class PublicDoenetMLCore {
  constructor() {
    throw new Error("cannot invoke `new` directly");
  }
  static __wrap(E) {
    const O = Object.create(PublicDoenetMLCore.prototype);
    return O.__wbg_ptr = E, PublicDoenetMLCoreFinalization.register(O, O.__wbg_ptr, O), O;
  }
  __destroy_into_raw() {
    const E = this.__wbg_ptr;
    return this.__wbg_ptr = 0, PublicDoenetMLCoreFinalization.unregister(this), E;
  }
  free() {
    const E = this.__destroy_into_raw();
    wasm.__wbg_publicdoenetmlcore_free(E, 0);
  }
  /**
   * @returns {string[]}
   */
  _get_tests() {
    if (this.__wbg_ptr == 0) throw new Error("Attempt to use a moved value");
    _assertNum(this.__wbg_ptr);
    const E = wasm.publicdoenetmlcore__get_tests(this.__wbg_ptr);
    var O = getArrayJsValueFromWasm0(E[0], E[1]).slice();
    return wasm.__wbindgen_free(E[0], E[1] * 4, 4), O;
  }
  /**
   * @param {string} test_name
   */
  _run_test(E) {
    if (this.__wbg_ptr == 0) throw new Error("Attempt to use a moved value");
    _assertNum(this.__wbg_ptr);
    const O = passStringToWasm0(E, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), F = WASM_VECTOR_LEN;
    wasm.publicdoenetmlcore__run_test(this.__wbg_ptr, O, F);
  }
  /**
   * @param {FlatFragment} flat_fragment
   * @param {IndexResolution} index_resolution
   */
  add_nodes_to_resolver(E, O) {
    if (this.__wbg_ptr == 0) throw new Error("Attempt to use a moved value");
    _assertNum(this.__wbg_ptr), wasm.publicdoenetmlcore_add_nodes_to_resolver(this.__wbg_ptr, E, O);
  }
  /**
   * @returns {RootNames}
   */
  calculate_root_names() {
    if (this.__wbg_ptr == 0) throw new Error("Attempt to use a moved value");
    return _assertNum(this.__wbg_ptr), wasm.publicdoenetmlcore_calculate_root_names(this.__wbg_ptr);
  }
  /**
   * @param {NodeList} node_list
   */
  delete_nodes_from_resolver(E) {
    if (this.__wbg_ptr == 0) throw new Error("Attempt to use a moved value");
    _assertNum(this.__wbg_ptr), wasm.publicdoenetmlcore_delete_nodes_from_resolver(this.__wbg_ptr, E);
  }
  /**
   * Send an action to DoenetMLCore. This is often in response to a user
   * interaction with a component (and requesting a change to that component, like
   * changing the value of a slider).
   *
   * Returns updates to the FlatDast.
   * @param {Action} action
   * @returns {ActionResponse}
   */
  dispatch_action(E) {
    if (this.__wbg_ptr == 0) throw new Error("Attempt to use a moved value");
    _assertNum(this.__wbg_ptr);
    const O = wasm.publicdoenetmlcore_dispatch_action(this.__wbg_ptr, E);
    if (O[2])
      throw takeFromExternrefTable0(O[1]);
    return takeFromExternrefTable0(O[0]);
  }
  /**
   * @returns {PublicDoenetMLCore}
   */
  static new() {
    const E = wasm.publicdoenetmlcore_new();
    return PublicDoenetMLCore.__wrap(E);
  }
  /**
   * Drop the data that is only needed while initializing a core
   * (currently the document's DAST, which for large documents holds
   * megabytes of WASM linear memory). Called by the worker once the
   * JavaScript core has consumed the normalized DAST; calling
   * `set_source` again repopulates the data.
   */
  release_initialization_data() {
    if (this.__wbg_ptr == 0) throw new Error("Attempt to use a moved value");
    _assertNum(this.__wbg_ptr), wasm.publicdoenetmlcore_release_initialization_data(this.__wbg_ptr);
  }
  /**
   * @param {ContentVector} components
   * @param {IndexResolution} index_resolution
   */
  replace_index_resolutions_in_resolver(E, O) {
    if (this.__wbg_ptr == 0) throw new Error("Attempt to use a moved value");
    _assertNum(this.__wbg_ptr), wasm.publicdoenetmlcore_replace_index_resolutions_in_resolver(this.__wbg_ptr, E, O);
  }
  /**
   * @param {PathToCheck} path
   * @param {number} origin
   * @param {boolean} skip_parent_search
   * @returns {RefResolution}
   */
  resolve_path(E, O, F) {
    if (this.__wbg_ptr == 0) throw new Error("Attempt to use a moved value");
    _assertNum(this.__wbg_ptr), _assertNum(O), _assertBoolean(F);
    const I = wasm.publicdoenetmlcore_resolve_path(this.__wbg_ptr, E, O, F);
    if (I[2])
      throw takeFromExternrefTable0(I[1]);
    return takeFromExternrefTable0(I[0]);
  }
  /**
   * @returns {FlatDastRoot}
   */
  return_dast() {
    if (this.__wbg_ptr == 0) throw new Error("Attempt to use a moved value");
    _assertNum(this.__wbg_ptr);
    const E = wasm.publicdoenetmlcore_return_dast(this.__wbg_ptr);
    if (E[2])
      throw takeFromExternrefTable0(E[1]);
    return takeFromExternrefTable0(E[0]);
  }
  /**
   * @returns {NormalizedRoot}
   */
  return_normalized_dast_root() {
    if (this.__wbg_ptr == 0) throw new Error("Attempt to use a moved value");
    _assertNum(this.__wbg_ptr);
    const E = wasm.publicdoenetmlcore_return_normalized_dast_root(this.__wbg_ptr);
    if (E[2])
      throw takeFromExternrefTable0(E[1]);
    return takeFromExternrefTable0(E[0]);
  }
  /**
   * @param {string} flags
   */
  set_flags(E) {
    if (this.__wbg_ptr == 0) throw new Error("Attempt to use a moved value");
    _assertNum(this.__wbg_ptr);
    const O = passStringToWasm0(E, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), F = WASM_VECTOR_LEN;
    wasm.publicdoenetmlcore_set_flags(this.__wbg_ptr, O, F);
  }
  /**
   * @param {DastRoot} dast
   * @param {string} _source
   */
  set_source(E, O) {
    if (this.__wbg_ptr == 0) throw new Error("Attempt to use a moved value");
    _assertNum(this.__wbg_ptr);
    const F = passStringToWasm0(O, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), I = WASM_VECTOR_LEN, z = wasm.publicdoenetmlcore_set_source(this.__wbg_ptr, E, F, I);
    if (z[1])
      throw takeFromExternrefTable0(z[0]);
  }
}
Symbol.dispose && (PublicDoenetMLCore.prototype[Symbol.dispose] = PublicDoenetMLCore.prototype.free);
class _TypeExports {
  constructor() {
    throw new Error("cannot invoke `new` directly");
  }
  __destroy_into_raw() {
    const E = this.__wbg_ptr;
    return this.__wbg_ptr = 0, _TypeExportsFinalization.unregister(this), E;
  }
  free() {
    const E = this.__destroy_into_raw();
    wasm.__wbg__typeexports_free(E, 0);
  }
  /**
   * @returns {_DummyForWasmBindgen}
   */
  get t1() {
    if (this.__wbg_ptr == 0) throw new Error("Attempt to use a moved value");
    return _assertNum(this.__wbg_ptr), wasm.__wbg_get__typeexports_t1(this.__wbg_ptr);
  }
  /**
   * @param {_DummyForWasmBindgen} arg0
   */
  set t1(E) {
    if (this.__wbg_ptr == 0) throw new Error("Attempt to use a moved value");
    _assertNum(this.__wbg_ptr), wasm.__wbg_set__typeexports_t1(this.__wbg_ptr, E);
  }
}
Symbol.dispose && (_TypeExports.prototype[Symbol.dispose] = _TypeExports.prototype.free);
function __wbg_get_imports() {
  return {
    __proto__: null,
    "./lib_doenetml_worker_bg.js": {
      __proto__: null,
      __wbg_Error_92b29b0548f8b746: function() {
        return logError(function(E, O) {
          return Error(getStringFromWasm0(E, O));
        }, arguments);
      },
      __wbg_Number_9a4e0ecb0fa16705: function() {
        return logError(function(E) {
          return Number(E);
        }, arguments);
      },
      __wbg___wbindgen_debug_string_c25d447a39f5578f: function(E, O) {
        const F = debugString(O), I = passStringToWasm0(F, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), z = WASM_VECTOR_LEN;
        getDataViewMemory0().setInt32(E + 4, z, !0), getDataViewMemory0().setInt32(E + 0, I, !0);
      },
      __wbg___wbindgen_is_string_ea5e6cc2e4141dfe: function(E) {
        const O = typeof E == "string";
        return _assertBoolean(O), O;
      },
      __wbg___wbindgen_number_get_394265ed1e1b84ee: function(E, O) {
        const F = O, I = typeof F == "number" ? F : void 0;
        isLikeNone(I) || _assertNum(I), getDataViewMemory0().setFloat64(E + 8, isLikeNone(I) ? 0 : I, !0), getDataViewMemory0().setInt32(E + 0, !isLikeNone(I), !0);
      },
      __wbg___wbindgen_string_get_b0ca35b86a603356: function(E, O) {
        const F = O, I = typeof F == "string" ? F : void 0;
        var z = isLikeNone(I) ? 0 : passStringToWasm0(I, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), R = WASM_VECTOR_LEN;
        getDataViewMemory0().setInt32(E + 4, R, !0), getDataViewMemory0().setInt32(E + 0, z, !0);
      },
      __wbg___wbindgen_throw_344f42d3211c4765: function(E, O) {
        throw new Error(getStringFromWasm0(E, O));
      },
      __wbg_error_a6fa202b58aa1cd3: function() {
        return logError(function(E, O) {
          let F, I;
          try {
            F = E, I = O, console.error(getStringFromWasm0(E, O));
          } finally {
            wasm.__wbindgen_free(F, I, 1);
          }
        }, arguments);
      },
      __wbg_evalWithMathExpressionsInScope_b8edd68a6b72e272: function() {
        return handleError(function(E) {
          return __forDoenetWorker.evalWithMathExpressionsInScope(E);
        }, arguments);
      },
      __wbg_evaluateToNumber_f4af150f71cd377f: function() {
        return handleError(function(E) {
          return __forDoenetWorker.evaluateToNumber(E);
        }, arguments);
      },
      __wbg_new_227d7c05414eb861: function() {
        return logError(function() {
          return new Error();
        }, arguments);
      },
      __wbg_new_32b398fb48b6d94a: function() {
        return logError(function() {
          return new Array();
        }, arguments);
      },
      __wbg_new_7796ffc7ed656783: function() {
        return logError(function() {
          return /* @__PURE__ */ new Map();
        }, arguments);
      },
      __wbg_new_da52cf8fe3429cb2: function() {
        return logError(function() {
          return new Object();
        }, arguments);
      },
      __wbg_normalizeMath_8b89e6d57aea962f: function() {
        return handleError(function(E, O, F, I, z) {
          return __forDoenetWorker.normalizeMath(E, O, F, I, z);
        }, arguments);
      },
      __wbg_parseLatexIntoMath_6ce160c6b4c0a969: function() {
        return handleError(function(E, O, F) {
          return __forDoenetWorker.parseLatexIntoMath(E, O, F);
        }, arguments);
      },
      __wbg_parseTextIntoMath_6f6715ea647d86d5: function() {
        return handleError(function(E, O, F) {
          return __forDoenetWorker.parseTextIntoMath(E, O, F);
        }, arguments);
      },
      __wbg_parseTextIntoNumber_c5c6bb56379f3cf7: function() {
        return handleError(function(E) {
          return __forDoenetWorker.parseTextIntoNumber(E);
        }, arguments);
      },
      __wbg_parse_9faf394ef4f6fe31: function() {
        return logError(function(E, O) {
          let F, I;
          try {
            return F = E, I = O, JSON.parse(getStringFromWasm0(E, O));
          } finally {
            wasm.__wbindgen_free(F, I, 1);
          }
        }, arguments);
      },
      __wbg_push_d2ae3af0c1217ae6: function() {
        return logError(function(E, O) {
          const F = E.push(O);
          return _assertNum(F), F;
        }, arguments);
      },
      __wbg_set_575dd786d51585f8: function() {
        return logError(function(E, O, F) {
          return E.set(O, F);
        }, arguments);
      },
      __wbg_set_6be42768c690e380: function() {
        return logError(function(E, O, F) {
          E[O] = F;
        }, arguments);
      },
      __wbg_stack_3b0d974bbf31e44f: function() {
        return logError(function(E, O) {
          const F = O.stack, I = passStringToWasm0(F, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), z = WASM_VECTOR_LEN;
          getDataViewMemory0().setInt32(E + 4, z, !0), getDataViewMemory0().setInt32(E + 0, I, !0);
        }, arguments);
      },
      __wbg_stringify_77725d3482b481f5: function() {
        return logError(function(E, O) {
          const F = JSON.stringify(O);
          var I = isLikeNone(F) ? 0 : passStringToWasm0(F, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), z = WASM_VECTOR_LEN;
          getDataViewMemory0().setInt32(E + 4, z, !0), getDataViewMemory0().setInt32(E + 0, I, !0);
        }, arguments);
      },
      __wbg_substituteIntoMath_81aeb49d7049aaeb: function() {
        return handleError(function(E, O) {
          return __forDoenetWorker.substituteIntoMath(E, O);
        }, arguments);
      },
      __wbg_toLatex_d4b775d4bc3fd2a2: function() {
        return handleError(function(E, O, F, I) {
          return __forDoenetWorker.toLatex(E, O, F, I);
        }, arguments);
      },
      __wbg_toText_83438010aa3573ac: function() {
        return handleError(function(E, O, F, I) {
          return __forDoenetWorker.toText(E, O, F, I);
        }, arguments);
      },
      __wbindgen_cast_0000000000000001: function() {
        return logError(function(E) {
          return E;
        }, arguments);
      },
      __wbindgen_cast_0000000000000002: function() {
        return logError(function(E) {
          return E;
        }, arguments);
      },
      __wbindgen_cast_0000000000000003: function() {
        return logError(function(E, O) {
          return getStringFromWasm0(E, O);
        }, arguments);
      },
      __wbindgen_init_externref_table: function() {
        const E = wasm.__wbindgen_externrefs, O = E.grow(4);
        E.set(0, void 0), E.set(O + 0, void 0), E.set(O + 1, null), E.set(O + 2, !0), E.set(O + 3, !1);
      }
    }
  };
}
const PublicDoenetMLCoreFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((D) => wasm.__wbg_publicdoenetmlcore_free(D, 1)), _TypeExportsFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((D) => wasm.__wbg__typeexports_free(D, 1));
function addToExternrefTable0(D) {
  const E = wasm.__externref_table_alloc();
  return wasm.__wbindgen_externrefs.set(E, D), E;
}
function _assertBoolean(D) {
  if (typeof D != "boolean")
    throw new Error(`expected a boolean argument, found ${typeof D}`);
}
function _assertNum(D) {
  if (typeof D != "number") throw new Error(`expected a number argument, found ${typeof D}`);
}
function debugString(D) {
  const E = typeof D;
  if (E == "number" || E == "boolean" || D == null)
    return `${D}`;
  if (E == "string")
    return `"${D}"`;
  if (E == "symbol") {
    const I = D.description;
    return I == null ? "Symbol" : `Symbol(${I})`;
  }
  if (E == "function") {
    const I = D.name;
    return typeof I == "string" && I.length > 0 ? `Function(${I})` : "Function";
  }
  if (Array.isArray(D)) {
    const I = D.length;
    let z = "[";
    I > 0 && (z += debugString(D[0]));
    for (let R = 1; R < I; R++)
      z += ", " + debugString(D[R]);
    return z += "]", z;
  }
  const O = /\[object ([^\]]+)\]/.exec(toString.call(D));
  let F;
  if (O && O.length > 1)
    F = O[1];
  else
    return toString.call(D);
  if (F == "Object")
    try {
      return "Object(" + JSON.stringify(D) + ")";
    } catch {
      return "Object";
    }
  return D instanceof Error ? `${D.name}: ${D.message}
${D.stack}` : F;
}
function getArrayJsValueFromWasm0(D, E) {
  D = D >>> 0;
  const O = getDataViewMemory0(), F = [];
  for (let I = D; I < D + 4 * E; I += 4)
    F.push(wasm.__wbindgen_externrefs.get(O.getUint32(I, !0)));
  return wasm.__externref_drop_slice(D, E), F;
}
let cachedDataViewMemory0 = null;
function getDataViewMemory0() {
  return (cachedDataViewMemory0 === null || cachedDataViewMemory0.buffer.detached === !0 || cachedDataViewMemory0.buffer.detached === void 0 && cachedDataViewMemory0.buffer !== wasm.memory.buffer) && (cachedDataViewMemory0 = new DataView(wasm.memory.buffer)), cachedDataViewMemory0;
}
function getStringFromWasm0(D, E) {
  return decodeText(D >>> 0, E);
}
let cachedUint8ArrayMemory0 = null;
function getUint8ArrayMemory0() {
  return (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) && (cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer)), cachedUint8ArrayMemory0;
}
function handleError(D, E) {
  try {
    return D.apply(this, E);
  } catch (O) {
    const F = addToExternrefTable0(O);
    wasm.__wbindgen_exn_store(F);
  }
}
function isLikeNone(D) {
  return D == null;
}
function logError(D, E) {
  try {
    return D.apply(this, E);
  } catch (O) {
    let F = (function() {
      try {
        return O instanceof Error ? `${O.message}

Stack:
${O.stack}` : O.toString();
      } catch {
        return "<failed to stringify thrown value>";
      }
    })();
    throw console.error("wasm-bindgen: imported JS function that was not marked as `catch` threw an error:", F), O;
  }
}
function passStringToWasm0(D, E, O) {
  if (typeof D != "string") throw new Error(`expected a string argument, found ${typeof D}`);
  if (O === void 0) {
    const L = cachedTextEncoder.encode(D), q = E(L.length, 1) >>> 0;
    return getUint8ArrayMemory0().subarray(q, q + L.length).set(L), WASM_VECTOR_LEN = L.length, q;
  }
  let F = D.length, I = E(F, 1) >>> 0;
  const z = getUint8ArrayMemory0();
  let R = 0;
  for (; R < F; R++) {
    const L = D.charCodeAt(R);
    if (L > 127) break;
    z[I + R] = L;
  }
  if (R !== F) {
    R !== 0 && (D = D.slice(R)), I = O(I, F, F = R + D.length * 3, 1) >>> 0;
    const L = getUint8ArrayMemory0().subarray(I + R, I + F), q = cachedTextEncoder.encodeInto(D, L);
    if (q.read !== D.length) throw new Error("failed to pass whole string");
    R += q.written, I = O(I, F, R, 1) >>> 0;
  }
  return WASM_VECTOR_LEN = R, I;
}
function takeFromExternrefTable0(D) {
  const E = wasm.__wbindgen_externrefs.get(D);
  return wasm.__externref_table_dealloc(D), E;
}
let cachedTextDecoder = new TextDecoder("utf-8", { ignoreBOM: !0, fatal: !0 });
cachedTextDecoder.decode();
const MAX_SAFARI_DECODE_BYTES = 2146435072;
let numBytesDecoded = 0;
function decodeText(D, E) {
  return numBytesDecoded += E, numBytesDecoded >= MAX_SAFARI_DECODE_BYTES && (cachedTextDecoder = new TextDecoder("utf-8", { ignoreBOM: !0, fatal: !0 }), cachedTextDecoder.decode(), numBytesDecoded = E), cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(D, D + E));
}
const cachedTextEncoder = new TextEncoder();
"encodeInto" in cachedTextEncoder || (cachedTextEncoder.encodeInto = function(D, E) {
  const O = cachedTextEncoder.encode(D);
  return E.set(O), {
    read: D.length,
    written: O.length
  };
});
let WASM_VECTOR_LEN = 0, wasm;
function __wbg_finalize_init(D, E) {
  return wasm = D.exports, cachedDataViewMemory0 = null, cachedUint8ArrayMemory0 = null, wasm.__wbindgen_start(), wasm;
}
async function __wbg_load(D, E) {
  if (typeof Response == "function" && D instanceof Response) {
    if (typeof WebAssembly.instantiateStreaming == "function")
      try {
        return await WebAssembly.instantiateStreaming(D, E);
      } catch (I) {
        if (D.ok && O(D.type) && D.headers.get("Content-Type") !== "application/wasm")
          console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve Wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", I);
        else
          throw I;
      }
    const F = await D.arrayBuffer();
    return await WebAssembly.instantiate(F, E);
  } else {
    const F = await WebAssembly.instantiate(D, E);
    return F instanceof WebAssembly.Instance ? { instance: F, module: D } : F;
  }
  function O(F) {
    switch (F) {
      case "basic":
      case "cors":
      case "default":
        return !0;
    }
    return !1;
  }
}
function initSync(D) {
  if (wasm !== void 0) return wasm;
  D !== void 0 && (Object.getPrototypeOf(D) === Object.prototype ? { module: D } = D : console.warn("using deprecated parameters for `initSync()`; pass a single object instead"));
  const E = __wbg_get_imports();
  D instanceof WebAssembly.Module || (D = new WebAssembly.Module(D));
  const O = new WebAssembly.Instance(D, E);
  return __wbg_finalize_init(O);
}
async function __wbg_init(D) {
  if (wasm !== void 0) return wasm;
  D !== void 0 && (Object.getPrototypeOf(D) === Object.prototype ? { module_or_path: D } = D : console.warn("using deprecated parameters for the initialization function; pass a single object instead"));
  const E = __wbg_get_imports();
  (typeof D == "string" || typeof Request == "function" && D instanceof Request || typeof URL == "function" && D instanceof URL) && (D = fetch(D));
  const { instance: O, module: F } = await __wbg_load(await D, E);
  return __wbg_finalize_init(O);
}
var __create = Object.create, __defProp = Object.defineProperty, __getOwnPropDesc = Object.getOwnPropertyDescriptor, __getOwnPropNames = Object.getOwnPropertyNames, __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty, __esmMin = (D, E) => () => (D && (E = D(D = 0)), E), __commonJSMin = (D, E) => () => (E || (D((E = { exports: {} }).exports, E), D = null), E.exports), __exportAll = (D, E) => {
  let O = {};
  for (var F in D) __defProp(O, F, { get: D[F], enumerable: !0 });
  return __defProp(O, Symbol.toStringTag, { value: "Module" }), O;
}, __copyProps = (D, E, O, F) => {
  if (E && typeof E == "object" || typeof E == "function") for (var I = __getOwnPropNames(E), z = 0, R = I.length, L; z < R; z++) L = I[z], !__hasOwnProp.call(D, L) && L !== O && __defProp(D, L, { get: ((q) => E[q]).bind(null, L), enumerable: !(F = __getOwnPropDesc(E, L)) || F.enumerable });
  return D;
}, __toESM = (D, E, O) => (O = D == null ? {} : __create(__getProtoOf(D)), __copyProps(__defProp(O, "default", { value: D, enumerable: !0 }), D)), __toCommonJS = (D) => __hasOwnProp.call(D, "module.exports") ? D["module.exports"] : __copyProps(__defProp({}, "__esModule", { value: !0 }), D), get_tree = function(D) {
  if (D != null) return D.tree === void 0 ? D : D.tree;
};
function* subsets(D, E) {
  var O = D.length;
  if (E === void 0 && (E = O), E !== 0) {
    for (let F = 0; F < O; F++) yield [D[F]];
    if (E !== 1) for (let F = 0; F < O; F++) {
      let I = subsets(D.slice(F + 1), E - 1);
      for (let z of I) yield [D[F]].concat(z);
    }
  }
}
var is_associative$1 = { "+": !0, "*": !0, and: !0, or: !0, union: !0, intersect: !0 };
function flatten$5(D) {
  var E = get_tree(D);
  if (!Array.isArray(E)) return E;
  var O = E[0], F = E.slice(1);
  if (F = F.map(function(R, L) {
    return flatten$5(R);
  }), is_associative$1[O]) {
    for (var I = [], z = 0; z < F.length; z++) Array.isArray(F[z]) && F[z][0] === O && F[z].length > 2 ? I = I.concat(F[z].slice(1)) : I.push(F[z]);
    F = I;
  }
  return [O].concat(F);
}
var unflattenRight = function(D) {
  var E = get_tree(D);
  if (!Array.isArray(E)) return E;
  var O = E[0], F = E.slice(1);
  if (F = F.map(function(L, q) {
    return unflattenRight(L);
  }), F.length > 2 && is_associative$1[O]) {
    for (var I = [O, F[0], void 0], z = I, R = 1; R < F.length - 1; R++) z[2] = [O, F[R], void 0], z = z[2];
    return z[2] = F[F.length - 1], I;
  }
  return [O].concat(F);
}, unflattenLeft = function(D) {
  var E = get_tree(D);
  if (!Array.isArray(E)) return E;
  var O = E[0], F = E.slice(1);
  if (F = F.map(function(L, q) {
    return unflattenLeft(L);
  }), F.length > 2 && is_associative$1[O]) {
    for (var I = [O, void 0, F[F.length - 1]], z = I, R = F.length - 2; R > 0; R--) z[1] = [O, void 0, F[R]], z = z[1];
    return z[1] = F[0], I;
  }
  return [O].concat(F);
}, allChildren = function(D) {
  if (!Array.isArray(D)) return [];
  var E = D[0], O = D.slice(1);
  return is_associative$1[E] ? O.reduce(function(F, I) {
    return Array.isArray(I) && I[0] === E ? F.concat(allChildren(I)) : F.concat([I]);
  }, []) : O;
};
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(D) {
    for (var E = 1; E < arguments.length; E++) {
      var O = arguments[E];
      for (var F in O) ({}).hasOwnProperty.call(O, F) && (D[F] = O[F]);
    }
    return D;
  }, _extends.apply(null, arguments);
}
var DEFAULT_CONFIG = { relTol: 1e-12, absTol: 1e-15, matrix: "Matrix", number: "number", numberFallback: "number", precision: 64, predictable: !1, randomSeed: null, legacySubset: !1 };
function getSafeProperty(D, E) {
  if (isSafeObjectProperty(D, E) || isSafeArrayProperty(D, E)) return D[E];
  throw isSafeMethod(D, E) ? Error(`Cannot access method "${E}" as a property`) : D == null ? TypeError(`Cannot access property "${E}": object is ${D}`) : Error('No access to property "' + E + '"');
}
function setSafeProperty(D, E, O) {
  if (isSafeObjectProperty(D, E) || isSafeArrayProperty(D, E)) return D[E] = O, O;
  throw Error(`No access to property "${E}"`);
}
function isSafeObjectProperty(D, E) {
  return isPlainObject(D) ? !(E in Object.prototype) : !1;
}
function isSafeArrayProperty(D, E) {
  return Array.isArray(D) ? typeof E == "number" || typeof E == "string" && isInteger$1(E) || E === "length" : !1;
}
function isInteger$1(D) {
  return /^\d+$/.test(D);
}
function getSafeMethod(D, E) {
  if (!isSafeMethod(D, E)) throw Error('No access to method "' + E + '"');
  return D[E];
}
function isSafeMethod(D, E) {
  return D == null || typeof D[E] != "function" || hasOwnProperty$1(D, E) && Object.getPrototypeOf && E in Object.getPrototypeOf(D) ? !1 : safeNativeMethods.has(E) ? !0 : !(E in Object.prototype || E in Function.prototype);
}
function isPlainObject(D) {
  return typeof D == "object" && D && D.constructor === Object;
}
var safeNativeMethods = /* @__PURE__ */ new Set(["toString", "valueOf", "toLocaleString"]), ObjectWrappingMap = class {
  constructor(D) {
    this.wrappedObject = D, this[Symbol.iterator] = this.entries;
  }
  keys() {
    return Object.keys(this.wrappedObject).filter((D) => this.has(D)).values();
  }
  get(D) {
    return getSafeProperty(this.wrappedObject, D);
  }
  set(D, E) {
    return setSafeProperty(this.wrappedObject, D, E), this;
  }
  has(D) {
    return isSafeObjectProperty(this.wrappedObject, D) && D in this.wrappedObject;
  }
  entries() {
    return mapIterator(this.keys(), (D) => [D, this.get(D)]);
  }
  forEach(D) {
    for (var E of this.keys()) D(this.get(E), E, this);
  }
  delete(D) {
    isSafeObjectProperty(this.wrappedObject, D) && delete this.wrappedObject[D];
  }
  clear() {
    for (var D of this.keys()) this.delete(D);
  }
  get size() {
    return Object.keys(this.wrappedObject).length;
  }
}, PartitionedMap = class {
  constructor(D, E, O) {
    this.a = D, this.b = E, this.bKeys = O, this[Symbol.iterator] = this.entries;
  }
  get(D) {
    return this.bKeys.has(D) ? this.b.get(D) : this.a.get(D);
  }
  set(D, E) {
    return this.bKeys.has(D) ? this.b.set(D, E) : this.a.set(D, E), this;
  }
  has(D) {
    return this.b.has(D) || this.a.has(D);
  }
  keys() {
    return (/* @__PURE__ */ new Set([...this.a.keys(), ...this.b.keys()]))[Symbol.iterator]();
  }
  entries() {
    return mapIterator(this.keys(), (D) => [D, this.get(D)]);
  }
  forEach(D) {
    for (var E of this.keys()) D(this.get(E), E, this);
  }
  delete(D) {
    return this.bKeys.has(D) ? this.b.delete(D) : this.a.delete(D);
  }
  clear() {
    this.a.clear(), this.b.clear();
  }
  get size() {
    return [...this.keys()].length;
  }
};
function mapIterator(D, E) {
  return { next: () => {
    var O = D.next();
    return O.done ? O : { value: E(O.value), done: !1 };
  } };
}
function createEmptyMap() {
  return /* @__PURE__ */ new Map();
}
function createMap$1(D) {
  if (!D) return createEmptyMap();
  if (isMap(D)) return D;
  if (isObject$1(D)) return new ObjectWrappingMap(D);
  throw Error("createMap can create maps from objects or Maps");
}
function toObject(D) {
  if (D instanceof ObjectWrappingMap) return D.wrappedObject;
  var E = {};
  for (var O of D.keys()) setSafeProperty(E, O, D.get(O));
  return E;
}
function isNumber(D) {
  return typeof D == "number";
}
function isBigNumber(D) {
  return !D || typeof D != "object" || typeof D.constructor != "function" ? !1 : D.isBigNumber === !0 && typeof D.constructor.prototype == "object" && D.constructor.prototype.isBigNumber === !0 || typeof D.constructor.isDecimal == "function" && D.constructor.isDecimal(D) === !0;
}
function isBigInt(D) {
  return typeof D == "bigint";
}
function isComplex(D) {
  return D && typeof D == "object" && Object.getPrototypeOf(D).isComplex === !0 || !1;
}
function isFraction(D) {
  return D && typeof D == "object" && Object.getPrototypeOf(D).isFraction === !0 || !1;
}
function isUnit(D) {
  return D && D.constructor.prototype.isUnit === !0 || !1;
}
function isString(D) {
  return typeof D == "string";
}
var isArray = Array.isArray;
function isMatrix(D) {
  return D && D.constructor.prototype.isMatrix === !0 || !1;
}
function isCollection(D) {
  return Array.isArray(D) || isMatrix(D);
}
function isDenseMatrix(D) {
  return D && D.isDenseMatrix && D.constructor.prototype.isMatrix === !0 || !1;
}
function isSparseMatrix(D) {
  return D && D.isSparseMatrix && D.constructor.prototype.isMatrix === !0 || !1;
}
function isRange(D) {
  return D && D.constructor.prototype.isRange === !0 || !1;
}
function isIndex(D) {
  return D && D.constructor.prototype.isIndex === !0 || !1;
}
function isBoolean$1(D) {
  return typeof D == "boolean";
}
function isResultSet(D) {
  return D && D.constructor.prototype.isResultSet === !0 || !1;
}
function isHelp(D) {
  return D && D.constructor.prototype.isHelp === !0 || !1;
}
function isFunction$1(D) {
  return typeof D == "function";
}
function isDate(D) {
  return D instanceof Date;
}
function isRegExp(D) {
  return D instanceof RegExp;
}
function isObject$1(D) {
  return !!(D && typeof D == "object" && D.constructor === Object && !isComplex(D) && !isFraction(D));
}
function isMap(D) {
  return D ? D instanceof Map || D instanceof ObjectWrappingMap || typeof D.set == "function" && typeof D.get == "function" && typeof D.keys == "function" && typeof D.has == "function" : !1;
}
function isPartitionedMap(D) {
  return isMap(D) && isMap(D.a) && isMap(D.b);
}
function isObjectWrappingMap(D) {
  return isMap(D) && isObject$1(D.wrappedObject);
}
function isNull$1(D) {
  return D === null;
}
function isUndefined$1(D) {
  return D === void 0;
}
function isAccessorNode(D) {
  return D && D.isAccessorNode === !0 && D.constructor.prototype.isNode === !0 || !1;
}
function isArrayNode(D) {
  return D && D.isArrayNode === !0 && D.constructor.prototype.isNode === !0 || !1;
}
function isAssignmentNode(D) {
  return D && D.isAssignmentNode === !0 && D.constructor.prototype.isNode === !0 || !1;
}
function isBlockNode(D) {
  return D && D.isBlockNode === !0 && D.constructor.prototype.isNode === !0 || !1;
}
function isConditionalNode(D) {
  return D && D.isConditionalNode === !0 && D.constructor.prototype.isNode === !0 || !1;
}
function isConstantNode(D) {
  return D && D.isConstantNode === !0 && D.constructor.prototype.isNode === !0 || !1;
}
function rule2Node(D) {
  return isConstantNode(D) || isOperatorNode(D) && D.args.length === 1 && isConstantNode(D.args[0]) && "-+~".includes(D.op);
}
function isFunctionAssignmentNode(D) {
  return D && D.isFunctionAssignmentNode === !0 && D.constructor.prototype.isNode === !0 || !1;
}
function isFunctionNode(D) {
  return D && D.isFunctionNode === !0 && D.constructor.prototype.isNode === !0 || !1;
}
function isIndexNode(D) {
  return D && D.isIndexNode === !0 && D.constructor.prototype.isNode === !0 || !1;
}
function isNode(D) {
  return D && D.isNode === !0 && D.constructor.prototype.isNode === !0 || !1;
}
function isObjectNode(D) {
  return D && D.isObjectNode === !0 && D.constructor.prototype.isNode === !0 || !1;
}
function isOperatorNode(D) {
  return D && D.isOperatorNode === !0 && D.constructor.prototype.isNode === !0 || !1;
}
function isParenthesisNode(D) {
  return D && D.isParenthesisNode === !0 && D.constructor.prototype.isNode === !0 || !1;
}
function isRangeNode(D) {
  return D && D.isRangeNode === !0 && D.constructor.prototype.isNode === !0 || !1;
}
function isRelationalNode(D) {
  return D && D.isRelationalNode === !0 && D.constructor.prototype.isNode === !0 || !1;
}
function isSymbolNode(D) {
  return D && D.isSymbolNode === !0 && D.constructor.prototype.isNode === !0 || !1;
}
function isChain(D) {
  return D && D.constructor.prototype.isChain === !0 || !1;
}
function typeOf(D) {
  var E = typeof D;
  return E === "object" ? D === null ? "null" : isBigNumber(D) ? "BigNumber" : D.constructor && D.constructor.name ? D.constructor.name : "Object" : E;
}
function clone$3(D) {
  var E = typeof D;
  if (E === "number" || E === "bigint" || E === "string" || E === "boolean" || D == null) return D;
  if (typeof D.clone == "function") return D.clone();
  if (Array.isArray(D)) return D.map(function(O) {
    return clone$3(O);
  });
  if (D instanceof Date) return new Date(D.valueOf());
  if (isBigNumber(D)) return D;
  if (isObject$1(D)) return mapObject$1(D, clone$3);
  if (E === "function") return D;
  throw TypeError(`Cannot clone: unknown type of value (value: ${D})`);
}
function mapObject$1(D, E) {
  var O = {};
  for (var F in D) hasOwnProperty$1(D, F) && (O[F] = E(D[F]));
  return O;
}
function extend$1(D, E) {
  for (var O in E) hasOwnProperty$1(E, O) && (D[O] = E[O]);
  return D;
}
function deepExtend(D, E) {
  if (Array.isArray(E)) throw TypeError("Arrays are not supported by deepExtend");
  for (var O in E) if (hasOwnProperty$1(E, O) && !(O in Object.prototype) && !(O in Function.prototype)) if (E[O] && E[O].constructor === Object) D[O] === void 0 && (D[O] = {}), D[O] && D[O].constructor === Object ? deepExtend(D[O], E[O]) : D[O] = E[O];
  else {
    if (Array.isArray(E[O])) throw TypeError("Arrays are not supported by deepExtend");
    D[O] = E[O];
  }
  return D;
}
function deepStrictEqual(D, E) {
  var O, F, I;
  if (Array.isArray(D)) {
    if (!Array.isArray(E) || D.length !== E.length) return !1;
    for (F = 0, I = D.length; F < I; F++) if (!deepStrictEqual(D[F], E[F])) return !1;
    return !0;
  } else {
    if (typeof D == "function") return D === E;
    if (D instanceof Object) {
      if (Array.isArray(E) || !(E instanceof Object)) return !1;
      for (O in D) if (!(O in E) || !deepStrictEqual(D[O], E[O])) return !1;
      for (O in E) if (!(O in D)) return !1;
      return !0;
    } else return D === E;
  }
}
function deepFlatten(D) {
  var E = {};
  return _deepFlatten(D, E), E;
}
function _deepFlatten(D, E) {
  for (var O in D) if (hasOwnProperty$1(D, O)) {
    var F = D[O];
    typeof F == "object" && F ? _deepFlatten(F, E) : E[O] = F;
  }
}
function lazy(D, E, O) {
  var F = !0, I;
  Object.defineProperty(D, E, { get: function() {
    return F &&= (I = O(), !1), I;
  }, set: function(z) {
    I = z, F = !1;
  }, configurable: !0, enumerable: !0 });
}
function hasOwnProperty$1(D, E) {
  return D && Object.hasOwnProperty.call(D, E);
}
function isLegacyFactory(D) {
  return D && typeof D.factory == "function";
}
function pickShallow(D, E) {
  for (var O = {}, F = 0; F < E.length; F++) {
    var I = E[F], z = D[I];
    z !== void 0 && (O[I] = z);
  }
  return O;
}
var MATRIX_OPTIONS = ["Matrix", "Array"], NUMBER_OPTIONS = ["number", "BigNumber", "bigint", "Fraction"];
function configFactory(D, E) {
  function O(F) {
    if (F) {
      if (F.epsilon !== void 0) {
        console.warn('Warning: The configuration option "epsilon" is deprecated. Use "relTol" and "absTol" instead.');
        var I = clone$3(F);
        return I.relTol = F.epsilon, I.absTol = F.epsilon * 1e-3, delete I.epsilon, O(I);
      }
      F.legacySubset === !0 && console.warn('Warning: The configuration option "legacySubset" is for compatibility only and might be deprecated in the future.');
      var z = clone$3(D);
      validateOption(F, "matrix", MATRIX_OPTIONS), validateOption(F, "number", NUMBER_OPTIONS), deepExtend(D, F);
      var R = clone$3(D);
      return E("config", R, z, clone$3(F)), R;
    } else return clone$3(D);
  }
  return O.MATRIX_OPTIONS = MATRIX_OPTIONS, O.NUMBER_OPTIONS = NUMBER_OPTIONS, Object.keys(DEFAULT_CONFIG).forEach((F) => {
    Object.defineProperty(O, F, { get: () => D[F], enumerable: !0, configurable: !0 });
  }), O;
}
function validateOption(D, E, O) {
  D[E] !== void 0 && !O.includes(D[E]) && console.warn('Warning: Unknown value "' + D[E] + '" for configuration option "' + E + '". Available options: ' + O.map((F) => JSON.stringify(F)).join(", ") + ".");
}
var require_typed_function = __commonJSMin(((D, E) => {
  (function(O, F) {
    typeof D == "object" && E !== void 0 ? E.exports = F() : typeof define == "function" && define.amd ? define(F) : (O = typeof globalThis < "u" ? globalThis : O || self, O["'typed'"] = F());
  })(D, (function() {
    function O() {
      return !0;
    }
    function F() {
      return !1;
    }
    function I() {
    }
    let z = "Argument is not a typed-function.";
    function R() {
      function L(Se) {
        return typeof Se == "object" && !!Se && Se.constructor === Object;
      }
      let q = [{ name: "number", test: function(Se) {
        return typeof Se == "number";
      } }, { name: "string", test: function(Se) {
        return typeof Se == "string";
      } }, { name: "boolean", test: function(Se) {
        return typeof Se == "boolean";
      } }, { name: "Function", test: function(Se) {
        return typeof Se == "function";
      } }, { name: "Array", test: Array.isArray }, { name: "Date", test: function(Se) {
        return Se instanceof Date;
      } }, { name: "RegExp", test: function(Se) {
        return Se instanceof RegExp;
      } }, { name: "Object", test: L }, { name: "null", test: function(Se) {
        return Se === null;
      } }, { name: "undefined", test: function(Se) {
        return Se === void 0;
      } }], U = { name: "any", test: O, isAny: !0 }, Z, V, G = 0, W = { createCount: 0 };
      function J(Se) {
        let Be = Z.get(Se);
        if (Be) return Be;
        let qe = 'Unknown type "' + Se + '"', Ze = Se.toLowerCase(), He;
        for (He of V) if (He.toLowerCase() === Ze) {
          qe += '. Did you mean "' + He + '" ?';
          break;
        }
        throw TypeError(qe);
      }
      function X(Se) {
        let Be = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "any", qe = Be ? J(Be).index : V.length, Ze = [];
        for (let Ge = 0; Ge < Se.length; ++Ge) {
          if (!Se[Ge] || typeof Se[Ge].name != "string" || typeof Se[Ge].test != "function") throw TypeError("Object with properties {name: string, test: function} expected");
          let Ye = Se[Ge].name;
          if (Z.has(Ye)) throw TypeError('Duplicate type name "' + Ye + '"');
          Ze.push(Ye), Z.set(Ye, { name: Ye, test: Se[Ge].test, isAny: Se[Ge].isAny, index: qe + Ge, conversionsTo: [] });
        }
        let He = V.slice(qe);
        V = V.slice(0, qe).concat(Ze).concat(He);
        for (let Ge = qe + Ze.length; Ge < V.length; ++Ge) Z.get(V[Ge]).index = Ge;
      }
      function Y() {
        Z = /* @__PURE__ */ new Map(), V = [], G = 0, X([U], !1);
      }
      Y(), X(q);
      function ee() {
        let Se;
        for (Se of V) Z.get(Se).conversionsTo = [];
        G = 0;
      }
      function K(Se) {
        let Be = V.filter((qe) => {
          let Ze = Z.get(qe);
          return !Ze.isAny && Ze.test(Se);
        });
        return Be.length ? Be : ["any"];
      }
      function te(Se) {
        return Se && typeof Se == "function" && "_typedFunctionData" in Se;
      }
      function ie(Se, Be, qe) {
        if (!te(Se)) throw TypeError(z);
        let Ze = qe && qe.exact, He = ce(Array.isArray(Be) ? Be.join(",") : Be), Ge = ue(He);
        if (!Ze || Ge in Se.signatures) {
          let Ee = Se._typedFunctionData.signatureMap.get(Ge);
          if (Ee) return Ee;
        }
        let Ye = He.length, Je;
        if (Ze) {
          Je = [];
          let Ee;
          for (Ee in Se.signatures) Je.push(Se._typedFunctionData.signatureMap.get(Ee));
        } else Je = Se._typedFunctionData.signatures;
        for (let Ee = 0; Ee < Ye; ++Ee) {
          let Le = He[Ee], Ve = [], tr;
          for (tr of Je) {
            let ar = _e(tr.params, Ee);
            if (!(!ar || Le.restParam && !ar.restParam)) {
              if (!ar.hasAny) {
                let cr = le(ar);
                if (Le.types.some((mr) => !cr.has(mr.name))) continue;
              }
              Ve.push(tr);
            }
          }
          if (Je = Ve, Je.length === 0) break;
        }
        let me;
        for (me of Je) if (me.params.length <= Ye) return me;
        throw TypeError("Signature not found (signature: " + (Se.name || "unnamed") + "(" + ue(He, ", ") + "))");
      }
      function ne(Se, Be, qe) {
        return ie(Se, Be, qe).implementation;
      }
      function ae(Se, Be) {
        let qe = J(Be);
        if (qe.test(Se)) return Se;
        let Ze = qe.conversionsTo;
        if (Ze.length === 0) throw Error("There are no conversions to " + Be + " defined.");
        for (let He = 0; He < Ze.length; He++) if (J(Ze[He].from).test(Se)) return Ze[He].convert(Se);
        throw Error("Cannot convert " + Se + " to " + Be);
      }
      function ue(Se) {
        let Be = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ",";
        return Se.map((qe) => qe.name).join(Be);
      }
      function oe(Se) {
        let Be = Se.indexOf("...") === 0, qe = (Be ? Se.length > 3 ? Se.slice(3) : "any" : Se).split("|").map((Ge) => J(Ge.trim())), Ze = !1, He = Be ? "..." : "";
        return { types: qe.map(function(Ge) {
          return Ze = Ge.isAny || Ze, He += Ge.name + "|", { name: Ge.name, typeIndex: Ge.index, test: Ge.test, isAny: Ge.isAny, conversion: null, conversionIndex: -1 };
        }), name: He.slice(0, -1), hasAny: Ze, hasConversion: !1, restParam: Be };
      }
      function se(Se) {
        let Be = ke(Se.types.map((Ge) => Ge.name)), qe = Se.hasAny, Ze = Se.name, He = Be.map(function(Ge) {
          let Ye = J(Ge.from);
          return qe = Ye.isAny || qe, Ze += "|" + Ge.from, { name: Ge.from, typeIndex: Ye.index, test: Ye.test, isAny: Ye.isAny, conversion: Ge, conversionIndex: Ge.index };
        });
        return { types: Se.types.concat(He), name: Ze, hasAny: qe, hasConversion: He.length > 0, restParam: Se.restParam };
      }
      function le(Se) {
        return Se.typeSet || (Se.typeSet = /* @__PURE__ */ new Set(), Se.types.forEach((Be) => Se.typeSet.add(Be.name))), Se.typeSet;
      }
      function ce(Se) {
        let Be = [];
        if (typeof Se != "string") throw TypeError("Signatures must be strings");
        let qe = Se.trim();
        if (qe === "") return Be;
        let Ze = qe.split(",");
        for (let He = 0; He < Ze.length; ++He) {
          let Ge = oe(Ze[He].trim());
          if (Ge.restParam && He !== Ze.length - 1) throw SyntaxError('Unexpected rest parameter "' + Ze[He] + '": only allowed for the last parameter');
          if (Ge.types.length === 0) return null;
          Be.push(Ge);
        }
        return Be;
      }
      function fe(Se) {
        let Be = Qe(Se);
        return Be ? Be.restParam : !1;
      }
      function pe(Se) {
        if (!Se || Se.types.length === 0) return O;
        if (Se.types.length === 1) return J(Se.types[0].name).test;
        if (Se.types.length === 2) {
          let Be = J(Se.types[0].name).test, qe = J(Se.types[1].name).test;
          return function(Ze) {
            return Be(Ze) || qe(Ze);
          };
        } else {
          let Be = Se.types.map(function(qe) {
            return J(qe.name).test;
          });
          return function(qe) {
            for (let Ze = 0; Ze < Be.length; Ze++) if (Be[Ze](qe)) return !0;
            return !1;
          };
        }
      }
      function ve(Se) {
        let Be, qe, Ze;
        if (fe(Se)) {
          Be = Ke(Se).map(pe);
          let He = Be.length, Ge = pe(Qe(Se)), Ye = function(Je) {
            for (let me = He; me < Je.length; me++) if (!Ge(Je[me])) return !1;
            return !0;
          };
          return function(Je) {
            for (let me = 0; me < Be.length; me++) if (!Be[me](Je[me])) return !1;
            return Ye(Je) && Je.length >= He + 1;
          };
        } else return Se.length === 0 ? function(He) {
          return He.length === 0;
        } : Se.length === 1 ? (qe = pe(Se[0]), function(He) {
          return qe(He[0]) && He.length === 1;
        }) : Se.length === 2 ? (qe = pe(Se[0]), Ze = pe(Se[1]), function(He) {
          return qe(He[0]) && Ze(He[1]) && He.length === 2;
        }) : (Be = Se.map(pe), function(He) {
          for (let Ge = 0; Ge < Be.length; Ge++) if (!Be[Ge](He[Ge])) return !1;
          return He.length === Be.length;
        });
      }
      function _e(Se, Be) {
        return Be < Se.length ? Se[Be] : fe(Se) ? Qe(Se) : null;
      }
      function de(Se, Be) {
        let qe = _e(Se, Be);
        return qe ? le(qe) : /* @__PURE__ */ new Set();
      }
      function ge(Se) {
        return Se.conversion === null || Se.conversion === void 0;
      }
      function ye(Se, Be) {
        let qe = /* @__PURE__ */ new Set();
        return Se.forEach((Ze) => {
          let He = de(Ze.params, Be), Ge;
          for (Ge of He) qe.add(Ge);
        }), qe.has("any") ? ["any"] : Array.from(qe);
      }
      function De(Se, Be, qe) {
        let Ze, He, Ge = Se || "unnamed", Ye = qe, Je;
        for (Je = 0; Je < Be.length; Je++) {
          let Ve = [];
          if (Ye.forEach((tr) => {
            let ar = pe(_e(tr.params, Je));
            (Je < tr.params.length || fe(tr.params)) && ar(Be[Je]) && Ve.push(tr);
          }), Ve.length === 0) {
            if (He = ye(Ye, Je), He.length > 0) {
              let tr = K(Be[Je]);
              return Ze = TypeError("Unexpected type of argument in function " + Ge + " (expected: " + He.join(" or ") + ", actual: " + tr.join(" | ") + ", index: " + Je + ")"), Ze.data = { category: "wrongType", fn: Ge, index: Je, actual: tr, expected: He }, Ze;
            }
          } else Ye = Ve;
        }
        let me = Ye.map(function(Ve) {
          return fe(Ve.params) ? 1 / 0 : Ve.params.length;
        });
        if (Be.length < Math.min.apply(null, me)) return He = ye(Ye, Je), Ze = TypeError("Too few arguments in function " + Ge + " (expected: " + He.join(" or ") + ", index: " + Be.length + ")"), Ze.data = { category: "tooFewArgs", fn: Ge, index: Be.length, expected: He }, Ze;
        let Ee = Math.max.apply(null, me);
        if (Be.length > Ee) return Ze = TypeError("Too many arguments in function " + Ge + " (expected: " + Ee + ", actual: " + Be.length + ")"), Ze.data = { category: "tooManyArgs", fn: Ge, index: Be.length, expectedLength: Ee }, Ze;
        let Le = [];
        for (let Ve = 0; Ve < Be.length; ++Ve) Le.push(K(Be[Ve]).join("|"));
        return Ze = TypeError('Arguments of type "' + Le.join(", ") + '" do not match any of the defined signatures of function ' + Ge + "."), Ze.data = { category: "mismatch", actual: Le }, Ze;
      }
      function Ce(Se) {
        let Be = V.length + 1;
        for (let qe = 0; qe < Se.types.length; qe++) ge(Se.types[qe]) && (Be = Math.min(Be, Se.types[qe].typeIndex));
        return Be;
      }
      function Ie(Se) {
        let Be = G + 1;
        for (let qe = 0; qe < Se.types.length; qe++) ge(Se.types[qe]) || (Be = Math.min(Be, Se.types[qe].conversionIndex));
        return Be;
      }
      function Ne(Se, Be) {
        if (Se.hasAny) {
          if (!Be.hasAny) return 1;
        } else if (Be.hasAny) return -1;
        if (Se.restParam) {
          if (!Be.restParam) return 1;
        } else if (Be.restParam) return -1;
        if (Se.hasConversion) {
          if (!Be.hasConversion) return 1;
        } else if (Be.hasConversion) return -1;
        let qe = Ce(Se) - Ce(Be);
        if (qe < 0) return -1;
        if (qe > 0) return 1;
        let Ze = Ie(Se) - Ie(Be);
        return Ze < 0 ? -1 : +(Ze > 0);
      }
      function he(Se, Be) {
        let qe = Se.params, Ze = Be.params, He = Qe(qe), Ge = Qe(Ze), Ye = fe(qe), Je = fe(Ze);
        if (Ye && He.hasAny) {
          if (!Je || !Ge.hasAny) return 1;
        } else if (Je && Ge.hasAny) return -1;
        let me = 0, Ee = 0, Le;
        for (Le of qe) Le.hasAny && ++me, Le.hasConversion && ++Ee;
        let Ve = 0, tr = 0;
        for (Le of Ze) Le.hasAny && ++Ve, Le.hasConversion && ++tr;
        if (me !== Ve) return me - Ve;
        if (Ye && He.hasConversion) {
          if (!Je || !Ge.hasConversion) return 1;
        } else if (Je && Ge.hasConversion) return -1;
        if (Ee !== tr) return Ee - tr;
        if (Ye) {
          if (!Je) return 1;
        } else if (Je) return -1;
        let ar = (qe.length - Ze.length) * (Ye ? -1 : 1);
        if (ar !== 0) return ar;
        let cr = [], mr = 0;
        for (let gr = 0; gr < qe.length; ++gr) {
          let _r = Ne(qe[gr], Ze[gr]);
          cr.push(_r), mr += _r;
        }
        if (mr !== 0) return mr;
        let pr;
        for (pr of cr) if (pr !== 0) return pr;
        return 0;
      }
      function ke(Se) {
        if (Se.length === 0) return [];
        let Be = Se.map(J);
        Se.length > 1 && Be.sort((He, Ge) => He.index - Ge.index);
        let qe = Be[0].conversionsTo;
        if (Se.length === 1) return qe;
        qe = qe.concat([]);
        let Ze = new Set(Se);
        for (let He = 1; He < Be.length; ++He) {
          let Ge;
          for (Ge of Be[He].conversionsTo) Ze.has(Ge.from) || (qe.push(Ge), Ze.add(Ge.from));
        }
        return qe;
      }
      function xe(Se, Be) {
        let qe = Be;
        if (Se.some((He) => He.hasConversion)) {
          let He = fe(Se), Ge = Se.map(Te);
          qe = function() {
            let Ye = [], Je = He ? arguments.length - 1 : arguments.length;
            for (let me = 0; me < Je; me++) Ye[me] = Ge[me](arguments[me]);
            return He && (Ye[Je] = arguments[Je].map(Ge[Je])), Be.apply(this, Ye);
          };
        }
        let Ze = qe;
        if (fe(Se)) {
          let He = Se.length - 1;
          Ze = function() {
            return qe.apply(this, We(arguments, 0, He).concat([We(arguments, He)]));
          };
        }
        return Ze;
      }
      function Te(Se) {
        let Be, qe, Ze, He, Ge = [], Ye = [];
        switch (Se.types.forEach(function(Je) {
          Je.conversion && (Ge.push(J(Je.conversion.from).test), Ye.push(Je.conversion.convert));
        }), Ye.length) {
          case 0:
            return function(Je) {
              return Je;
            };
          case 1:
            return Be = Ge[0], Ze = Ye[0], function(Je) {
              return Be(Je) ? Ze(Je) : Je;
            };
          case 2:
            return Be = Ge[0], qe = Ge[1], Ze = Ye[0], He = Ye[1], function(Je) {
              return Be(Je) ? Ze(Je) : qe(Je) ? He(Je) : Je;
            };
          default:
            return function(Je) {
              for (let me = 0; me < Ye.length; me++) if (Ge[me](Je)) return Ye[me](Je);
              return Je;
            };
        }
      }
      function Fe(Se) {
        function Be(qe, Ze, He) {
          if (Ze < qe.length) {
            let Ge = qe[Ze], Ye = [];
            if (Ge.restParam) {
              let Je = Ge.types.filter(ge);
              Je.length < Ge.types.length && Ye.push({ types: Je, name: "..." + Je.map((me) => me.name).join("|"), hasAny: Je.some((me) => me.isAny), hasConversion: !1, restParam: !0 }), Ye.push(Ge);
            } else Ye = Ge.types.map(function(Je) {
              return { types: [Je], name: Je.name, hasAny: Je.isAny, hasConversion: Je.conversion, restParam: !1 };
            });
            return nr(Ye, function(Je) {
              return Be(qe, Ze + 1, He.concat([Je]));
            });
          } else return [He];
        }
        return Be(Se, 0, []);
      }
      function be(Se, Be) {
        let qe = Math.max(Se.length, Be.length);
        for (let Je = 0; Je < qe; Je++) {
          let me = de(Se, Je), Ee = de(Be, Je), Le = !1, Ve;
          for (Ve of Ee) if (me.has(Ve)) {
            Le = !0;
            break;
          }
          if (!Le) return !1;
        }
        let Ze = Se.length, He = Be.length, Ge = fe(Se), Ye = fe(Be);
        return Ge ? Ye ? Ze === He : He >= Ze : Ye ? Ze >= He : Ze === He;
      }
      function Ae(Se) {
        return Se.map((Be) => er(Be) ? ze(Be.referToSelf.callback) : Ue(Be) ? Oe(Be.referTo.references, Be.referTo.callback) : Be);
      }
      function Me(Se, Be, qe) {
        let Ze = [], He;
        for (He of Se) {
          let Ge = qe[He];
          if (typeof Ge != "number") throw TypeError('No definition for referenced signature "' + He + '"');
          if (Ge = Be[Ge], typeof Ge != "function") return !1;
          Ze.push(Ge);
        }
        return Ze;
      }
      function $e(Se, Be, qe) {
        let Ze = Ae(Se), He = Array(Ze.length).fill(!1), Ge = !0;
        for (; Ge; ) {
          Ge = !1;
          let Ye = !0;
          for (let Je = 0; Je < Ze.length; ++Je) {
            if (He[Je]) continue;
            let me = Ze[Je];
            if (er(me)) Ze[Je] = me.referToSelf.callback(qe), Ze[Je].referToSelf = me.referToSelf, He[Je] = !0, Ye = !1;
            else if (Ue(me)) {
              let Ee = Me(me.referTo.references, Ze, Be);
              Ee ? (Ze[Je] = me.referTo.callback.apply(this, Ee), Ze[Je].referTo = me.referTo, He[Je] = !0, Ye = !1) : Ge = !0;
            }
          }
          if (Ye && Ge) throw SyntaxError("Circular reference detected in resolving typed.referTo");
        }
        return Ze;
      }
      function Re(Se) {
        let Be = /\bthis(\(|\.signatures\b)/;
        Object.keys(Se).forEach((qe) => {
          let Ze = Se[qe];
          if (Be.test(Ze.toString())) throw SyntaxError("Using `this` to self-reference a function is deprecated since typed-function@3. Use typed.referTo and typed.referToSelf instead.");
        });
      }
      function je(Se, Be) {
        if (W.createCount++, Object.keys(Be).length === 0) throw SyntaxError("No signatures provided");
        W.warnAgainstDeprecatedThis && Re(Be);
        let qe = [], Ze = [], He = {}, Ge = [], Ye;
        for (Ye in Be) {
          if (!Object.prototype.hasOwnProperty.call(Be, Ye)) continue;
          let ur = ce(Ye);
          if (!ur) continue;
          qe.forEach(function(vr) {
            if (be(vr, ur)) throw TypeError('Conflicting signatures "' + ue(vr) + '" and "' + ue(ur) + '".');
          }), qe.push(ur);
          let dr = Ze.length;
          Ze.push(Be[Ye]);
          let Jr = ur.map(se), xr;
          for (xr of Fe(Jr)) {
            let vr = ue(xr);
            Ge.push({ params: xr, name: vr, fn: dr }), xr.every((Xr) => !Xr.hasConversion) && (He[vr] = dr);
          }
        }
        Ge.sort(he);
        let Je = $e(Ze, He, yr), me;
        for (me in He) Object.prototype.hasOwnProperty.call(He, me) && (He[me] = Je[He[me]]);
        let Ee = [], Le = /* @__PURE__ */ new Map();
        for (me of Ge) Le.has(me.name) || (me.fn = Je[me.fn], Ee.push(me), Le.set(me.name, me));
        let Ve = Ee[0] && Ee[0].params.length <= 2 && !fe(Ee[0].params), tr = Ee[1] && Ee[1].params.length <= 2 && !fe(Ee[1].params), ar = Ee[2] && Ee[2].params.length <= 2 && !fe(Ee[2].params), cr = Ee[3] && Ee[3].params.length <= 2 && !fe(Ee[3].params), mr = Ee[4] && Ee[4].params.length <= 2 && !fe(Ee[4].params), pr = Ee[5] && Ee[5].params.length <= 2 && !fe(Ee[5].params), gr = Ve && tr && ar && cr && mr && pr;
        for (let ur = 0; ur < Ee.length; ++ur) Ee[ur].test = ve(Ee[ur].params);
        let _r = Ve ? pe(Ee[0].params[0]) : F, br = tr ? pe(Ee[1].params[0]) : F, Ar = ar ? pe(Ee[2].params[0]) : F, wr = cr ? pe(Ee[3].params[0]) : F, Nr = mr ? pe(Ee[4].params[0]) : F, Dr = pr ? pe(Ee[5].params[0]) : F, Er = Ve ? pe(Ee[0].params[1]) : F, Sr = tr ? pe(Ee[1].params[1]) : F, Mr = ar ? pe(Ee[2].params[1]) : F, $r = cr ? pe(Ee[3].params[1]) : F, Cr = mr ? pe(Ee[4].params[1]) : F, Tr = pr ? pe(Ee[5].params[1]) : F;
        for (let ur = 0; ur < Ee.length; ++ur) Ee[ur].implementation = xe(Ee[ur].params, Ee[ur].fn);
        let Or = Ve ? Ee[0].implementation : I, Fr = tr ? Ee[1].implementation : I, kr = ar ? Ee[2].implementation : I, Br = cr ? Ee[3].implementation : I, Ir = mr ? Ee[4].implementation : I, Pr = pr ? Ee[5].implementation : I, zr = Ve ? Ee[0].params.length : -1, Rr = tr ? Ee[1].params.length : -1, qr = ar ? Ee[2].params.length : -1, Lr = cr ? Ee[3].params.length : -1, jr = mr ? Ee[4].params.length : -1, Ur = pr ? Ee[5].params.length : -1, Zr = gr ? 6 : 0, Vr = Ee.length, Gr = Ee.map((ur) => ur.test), Hr = Ee.map((ur) => ur.implementation), Wr = function() {
          for (let ur = Zr; ur < Vr; ur++) if (Gr[ur](arguments)) return Hr[ur].apply(this, arguments);
          return W.onMismatch(Se, arguments, Ee);
        };
        function yr(ur, dr) {
          return arguments.length === zr && _r(ur) && Er(dr) ? Or.apply(this, arguments) : arguments.length === Rr && br(ur) && Sr(dr) ? Fr.apply(this, arguments) : arguments.length === qr && Ar(ur) && Mr(dr) ? kr.apply(this, arguments) : arguments.length === Lr && wr(ur) && $r(dr) ? Br.apply(this, arguments) : arguments.length === jr && Nr(ur) && Cr(dr) ? Ir.apply(this, arguments) : arguments.length === Ur && Dr(ur) && Tr(dr) ? Pr.apply(this, arguments) : Wr.apply(this, arguments);
        }
        try {
          Object.defineProperty(yr, "name", { value: Se });
        } catch {
        }
        return yr.signatures = He, yr._typedFunctionData = { signatures: Ee, signatureMap: Le }, yr;
      }
      function Pe(Se, Be, qe) {
        throw De(Se, Be, qe);
      }
      function Ke(Se) {
        return We(Se, 0, Se.length - 1);
      }
      function Qe(Se) {
        return Se[Se.length - 1];
      }
      function We(Se, Be, qe) {
        return Array.prototype.slice.call(Se, Be, qe);
      }
      function ir(Se, Be) {
        for (let qe = 0; qe < Se.length; qe++) if (Be(Se[qe])) return Se[qe];
      }
      function nr(Se, Be) {
        return Array.prototype.concat.apply([], Se.map(Be));
      }
      function we() {
        let Se = Ke(arguments).map((qe) => ue(ce(qe))), Be = Qe(arguments);
        if (typeof Be != "function") throw TypeError("Callback function expected as last argument");
        return Oe(Se, Be);
      }
      function Oe(Se, Be) {
        return { referTo: { references: Se, callback: Be } };
      }
      function ze(Se) {
        if (typeof Se != "function") throw TypeError("Callback function expected as first argument");
        return { referToSelf: { callback: Se } };
      }
      function Ue(Se) {
        return Se && typeof Se.referTo == "object" && Array.isArray(Se.referTo.references) && typeof Se.referTo.callback == "function";
      }
      function er(Se) {
        return Se && typeof Se.referToSelf == "object" && typeof Se.referToSelf.callback == "function";
      }
      function Xe(Se, Be) {
        if (!Se) return Be;
        if (Be && Be !== Se) {
          let qe = Error("Function names do not match (expected: " + Se + ", actual: " + Be + ")");
          throw qe.data = { actual: Be, expected: Se }, qe;
        }
        return Se;
      }
      function rr(Se) {
        let Be;
        for (let qe in Se) Object.prototype.hasOwnProperty.call(Se, qe) && (te(Se[qe]) || typeof Se[qe].signature == "string") && (Be = Xe(Be, Se[qe].name));
        return Be;
      }
      function or(Se, Be) {
        let qe;
        for (qe in Be) if (Object.prototype.hasOwnProperty.call(Be, qe)) {
          if (qe in Se && Be[qe] !== Se[qe]) {
            let Ze = Error('Signature "' + qe + '" is defined twice');
            throw Ze.data = { signature: qe, sourceFunction: Be[qe], destFunction: Se[qe] }, Ze;
          }
          Se[qe] = Be[qe];
        }
      }
      let lr = W;
      W = function(Se) {
        let Be = typeof Se == "string", qe = +!!Be, Ze = Be ? Se : "", He = {};
        for (let Ge = qe; Ge < arguments.length; ++Ge) {
          let Ye = arguments[Ge], Je = {}, me;
          if (typeof Ye == "function" ? (me = Ye.name, typeof Ye.signature == "string" ? Je[Ye.signature] = Ye : te(Ye) && (Je = Ye.signatures)) : L(Ye) && (Je = Ye, Be || (me = rr(Ye))), Object.keys(Je).length === 0) {
            let Ee = TypeError("Argument to 'typed' at index " + Ge + " is not a (typed) function, nor an object with signatures as keys and functions as values.");
            throw Ee.data = { index: Ge, argument: Ye }, Ee;
          }
          Be || (Ze = Xe(Ze, me)), or(He, Je);
        }
        return je(Ze || "", He);
      }, W.create = R, W.createCount = lr.createCount, W.onMismatch = Pe, W.throwMismatchError = Pe, W.createError = De, W.clear = Y, W.clearConversions = ee, W.addTypes = X, W._findType = J, W.referTo = we, W.referToSelf = ze, W.convert = ae, W.findSignature = ie, W.find = ne, W.isTypedFunction = te, W.warnAgainstDeprecatedThis = !0, W.addType = function(Se, Be) {
        let qe = "any";
        Be !== !1 && Z.has("Object") && (qe = "Object"), W.addTypes([Se], qe);
      };
      function sr(Se) {
        if (!Se || typeof Se.from != "string" || typeof Se.to != "string" || typeof Se.convert != "function") throw TypeError("Object with properties {from: string, to: string, convert: function} expected");
        if (Se.to === Se.from) throw SyntaxError('Illegal to define conversion from "' + Se.from + '" to itself.');
      }
      return W.addConversion = function(Se) {
        let Be = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : { override: !1 };
        sr(Se);
        let qe = J(Se.to), Ze = qe.conversionsTo.find((He) => He.from === Se.from);
        if (Ze) if (Be && Be.override) W.removeConversion({ from: Ze.from, to: Se.to, convert: Ze.convert });
        else throw Error('There is already a conversion from "' + Se.from + '" to "' + qe.name + '"');
        qe.conversionsTo.push({ from: Se.from, convert: Se.convert, index: G++ });
      }, W.addConversions = function(Se, Be) {
        Se.forEach((qe) => W.addConversion(qe, Be));
      }, W.removeConversion = function(Se) {
        sr(Se);
        let Be = J(Se.to), qe = ir(Be.conversionsTo, (He) => He.from === Se.from);
        if (!qe) throw Error("Attempt to remove nonexistent conversion from " + Se.from + " to " + Se.to);
        if (qe.convert !== Se.convert) throw Error("Conversion to remove does not match existing conversion");
        let Ze = Be.conversionsTo.indexOf(qe);
        Be.conversionsTo.splice(Ze, 1);
      }, W.resolve = function(Se, Be) {
        if (!te(Se)) throw TypeError(z);
        let qe = Se._typedFunctionData.signatures;
        for (let Ze = 0; Ze < qe.length; ++Ze) if (qe[Ze].test(Be)) return qe[Ze];
        return null;
      }, W;
    }
    return R();
  }));
}));
function factory(D, E, O, F) {
  function I(z) {
    var R = pickShallow(z, E.map(stripOptionalNotation));
    return assertDependencies(D, E, z), O(R);
  }
  return I.isFactory = !0, I.fn = D, I.dependencies = E.slice().sort(), F && (I.meta = F), I;
}
function isFactory(D) {
  return typeof D == "function" && typeof D.fn == "string" && Array.isArray(D.dependencies);
}
function assertDependencies(D, E, O) {
  if (!E.filter((I) => !isOptionalDependency(I)).every((I) => O[I] !== void 0)) {
    var F = E.filter((I) => O[I] === void 0);
    throw Error(`Cannot create function "${D}", some dependencies are missing: ${F.map((I) => `"${I}"`).join(", ")}.`);
  }
}
function isOptionalDependency(D) {
  return D && D[0] === "?";
}
function stripOptionalNotation(D) {
  return D && D[0] === "?" ? D.slice(1) : D;
}
function isInteger(D) {
  return typeof D == "boolean" ? !0 : Number.isFinite(D) ? D === Math.round(D) : !1;
}
function safeNumberType(D, E) {
  if (E.number === "bigint") try {
    BigInt(D);
  } catch {
    return E.numberFallback;
  }
  return E.number;
}
var sign$2 = Math.sign || function(D) {
  return D > 0 ? 1 : D < 0 ? -1 : 0;
}, log2$1 = Math.log2 || function(D) {
  return Math.log(D) / Math.LN2;
}, log10$2 = Math.log10 || function(D) {
  return Math.log(D) / Math.LN10;
}, log1p = Math.log1p || function(D) {
  return Math.log(D + 1);
}, cbrt$1 = Math.cbrt || function(D) {
  if (D === 0) return D;
  var E = D < 0, O;
  return E && (D = -D), Number.isFinite(D) ? (O = Math.exp(Math.log(D) / 3), O = (D / (O * O) + 2 * O) / 3) : O = D, E ? -O : O;
}, expm1 = Math.expm1 || function(D) {
  return D >= 2e-4 || D <= -2e-4 ? Math.exp(D) - 1 : D + D * D / 2 + D * D * D / 6;
};
function formatNumberToBase(D, E, O) {
  var F = { 2: "0b", 8: "0o", 16: "0x" }[E], I = "";
  if (O) {
    if (O < 1) throw Error("size must be in greater than 0");
    if (!isInteger(O)) throw Error("size must be an integer");
    if (D > 2 ** (O - 1) - 1 || D < -(2 ** (O - 1))) throw Error(`Value must be in range [-2^${O - 1}, 2^${O - 1}-1]`);
    if (!isInteger(D)) throw Error("Value must be an integer");
    D < 0 && (D += 2 ** O), I = `i${O}`;
  }
  var z = "";
  return D < 0 && (D = -D, z = "-"), `${z}${F}${D.toString(E)}${I}`;
}
function format$2(D, E) {
  if (typeof E == "function") return E(D);
  if (D === 1 / 0) return "Infinity";
  if (D === -1 / 0) return "-Infinity";
  if (isNaN(D)) return "NaN";
  var { notation: O, precision: F, wordSize: I } = normalizeFormatOptions(E);
  switch (O) {
    case "fixed":
      return toFixed$2(D, F);
    case "exponential":
      return toExponential$1(D, F);
    case "engineering":
      return toEngineering$1(D, F);
    case "bin":
      return formatNumberToBase(D, 2, I);
    case "oct":
      return formatNumberToBase(D, 8, I);
    case "hex":
      return formatNumberToBase(D, 16, I);
    case "auto":
      return toPrecision(D, F, E).replace(/((\.\d*?)(0+))($|e)/, function() {
        var z = arguments[2], R = arguments[4];
        return z === "." ? R : z + R;
      });
    default:
      throw Error('Unknown notation "' + O + '". Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.');
  }
}
function normalizeFormatOptions(D) {
  var E = "auto", O, F;
  if (D !== void 0) if (isNumber(D)) O = D;
  else if (isBigNumber(D)) O = D.toNumber();
  else if (isObject$1(D)) D.precision !== void 0 && (O = _toNumberOrThrow(D.precision, () => {
    throw Error('Option "precision" must be a number or BigNumber');
  })), D.wordSize !== void 0 && (F = _toNumberOrThrow(D.wordSize, () => {
    throw Error('Option "wordSize" must be a number or BigNumber');
  })), D.notation && (E = D.notation);
  else throw Error("Unsupported type of options, number, BigNumber, or object expected");
  return { notation: E, precision: O, wordSize: F };
}
function splitNumber(D) {
  var E = String(D).toLowerCase().match(/^(-?)(\d+\.?\d*)(e([+-]?\d+))?$/);
  if (!E) throw SyntaxError("Invalid number " + D);
  var O = E[1], F = E[2], I = parseFloat(E[4] || "0"), z = F.indexOf(".");
  I += z === -1 ? F.length - 1 : z - 1;
  var R = F.replace(".", "").replace(/^0*/, function(L) {
    return I -= L.length, "";
  }).replace(/0*$/, "").split("").map(function(L) {
    return parseInt(L);
  });
  return R.length === 0 && (R.push(0), I++), { sign: O, coefficients: R, exponent: I };
}
function toEngineering$1(D, E) {
  if (isNaN(D) || !Number.isFinite(D)) return String(D);
  var O = roundDigits(splitNumber(D), E), F = O.exponent, I = O.coefficients, z = F % 3 == 0 ? F : F < 0 ? F - 3 - F % 3 : F - F % 3;
  if (isNumber(E)) for (; E > I.length || F - z + 1 > I.length; ) I.push(0);
  else for (var R = Math.abs(F - z) - (I.length - 1), L = 0; L < R; L++) I.push(0);
  for (var q = Math.abs(F - z), U = 1; q > 0; ) U++, q--;
  var Z = I.slice(U).join(""), V = isNumber(E) && Z.length || Z.match(/[1-9]/) ? "." + Z : "", G = I.slice(0, U).join("") + V + "e" + (F >= 0 ? "+" : "") + z.toString();
  return O.sign + G;
}
function toFixed$2(D, E) {
  if (isNaN(D) || !Number.isFinite(D)) return String(D);
  var O = splitNumber(D), F = typeof E == "number" ? roundDigits(O, O.exponent + 1 + E) : O, I = F.coefficients, z = F.exponent + 1, R = z + (E || 0);
  return I.length < R && (I = I.concat(zeros(R - I.length))), z < 0 && (I = zeros(-z + 1).concat(I), z = 1), z < I.length && I.splice(z, 0, z === 0 ? "0." : "."), F.sign + I.join("");
}
function toExponential$1(D, E) {
  if (isNaN(D) || !Number.isFinite(Number(D))) return String(D);
  var O = splitNumber(D), F = E ? roundDigits(O, E) : O, I = F.coefficients, z = F.exponent;
  I.length < E && (I = I.concat(zeros(E - I.length)));
  var R = I.shift();
  return F.sign + R + (I.length > 0 ? "." + I.join("") : "") + "e" + (z >= 0 ? "+" : "") + z;
}
function toPrecision(D, E, O) {
  if (isNaN(D) || !Number.isFinite(D)) return String(D);
  var F = _toNumberOrDefault$1(O?.lowerExp, -3), I = _toNumberOrDefault$1(O?.upperExp, 5), z = splitNumber(D), R = E ? roundDigits(z, E) : z;
  if (R.exponent < F || R.exponent >= I) return toExponential$1(D, E);
  var L = R.coefficients, q = R.exponent;
  L.length < E && (L = L.concat(zeros(E - L.length))), L = L.concat(zeros(q - L.length + 1 + (L.length < E ? E - L.length : 0))), L = zeros(-q).concat(L);
  var U = q > 0 ? q : 0;
  return U < L.length - 1 && L.splice(U + 1, 0, "."), R.sign + L.join("");
}
function roundDigits(D, E) {
  for (var O = { sign: D.sign, coefficients: D.coefficients, exponent: D.exponent }, F = O.coefficients; E <= 0; ) F.unshift(0), O.exponent++, E++;
  if (F.length > E && F.splice(E, F.length - E)[0] >= 5) {
    var I = E - 1;
    for (F[I]++; F[I] === 10; ) F.pop(), I === 0 && (F.unshift(0), O.exponent++, I++), I--, F[I]++;
  }
  return O;
}
function zeros(D) {
  for (var E = [], O = 0; O < D; O++) E.push(0);
  return E;
}
function digits(D) {
  return D.toExponential().replace(/e.*$/, "").replace(/^0\.?0*|\./, "").length;
}
function nearlyEqual$1(D, E) {
  var O = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1e-8, F = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
  if (O <= 0) throw Error("Relative tolerance must be greater than 0");
  if (F < 0) throw Error("Absolute tolerance must be at least 0");
  return isNaN(D) || isNaN(E) ? !1 : !Number.isFinite(D) || !Number.isFinite(E) ? D === E : D === E ? !0 : Math.abs(D - E) <= Math.max(O * Math.max(Math.abs(D), Math.abs(E)), F);
}
var acosh$2 = Math.acosh || function(D) {
  return Math.log(Math.sqrt(D * D - 1) + D);
}, asinh$2 = Math.asinh || function(D) {
  return Math.log(Math.sqrt(D * D + 1) + D);
}, atanh$2 = Math.atanh || function(D) {
  return Math.log((1 + D) / (1 - D)) / 2;
}, cosh$3 = Math.cosh || function(D) {
  return (Math.exp(D) + Math.exp(-D)) / 2;
}, sinh$3 = Math.sinh || function(D) {
  return (Math.exp(D) - Math.exp(-D)) / 2;
}, tanh$2 = Math.tanh || function(D) {
  var E = Math.exp(2 * D);
  return (E - 1) / (E + 1);
};
function copysign(D, E) {
  return !0 ^ (E > 0 ? !0 : E < 0 ? !1 : 1 / E == 1 / 0) ? -D : D;
}
function _toNumberOrThrow(D, E) {
  if (isNumber(D)) return D;
  if (isBigNumber(D)) return D.toNumber();
  E();
}
function _toNumberOrDefault$1(D, E) {
  return isNumber(D) ? D : isBigNumber(D) ? D.toNumber() : E;
}
var import_typed_function = __toESM(require_typed_function()), _createTyped2 = function() {
  return _createTyped2 = import_typed_function.default.create, import_typed_function.default;
}, dependencies$322 = ["?BigNumber", "?Complex", "?DenseMatrix", "?Fraction"], createTyped = factory("typed", dependencies$322, function(D) {
  var { BigNumber: E, Complex: O, DenseMatrix: F, Fraction: I } = D, z = _createTyped2();
  return z.clear(), z.addTypes([{ name: "number", test: isNumber }, { name: "Complex", test: isComplex }, { name: "BigNumber", test: isBigNumber }, { name: "bigint", test: isBigInt }, { name: "Fraction", test: isFraction }, { name: "Unit", test: isUnit }, { name: "identifier", test: (R) => isString && /^(?:[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088F\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5C\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDC-\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C8A\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7DC\uA7F1-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDDC0-\uDDF3\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD40-\uDD59\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDD4A-\uDD65\uDD6F-\uDD85\uDE80-\uDEA9\uDEB0\uDEB1\uDEC2-\uDEC7\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61\uDF80-\uDF89\uDF8B\uDF8E\uDF90-\uDFB5\uDFB7\uDFD1\uDFD3]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8\uDFC0-\uDFE0]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDDB0-\uDDDB\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD80E\uD80F\uD81C-\uD822\uD840-\uD868\uD86A-\uD86D\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD88C][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46\uDC60-\uDFFF]|\uD810[\uDC00-\uDFFA]|\uD811[\uDC00-\uDE46]|\uD818[\uDD00-\uDD1D]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDD40-\uDD6C\uDE40-\uDE7F\uDEA0-\uDEB8\uDEBB-\uDED3\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3\uDFF2\uDFF3]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD1E\uDD80-\uDDF2]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDCD0-\uDCEB\uDDD0-\uDDED\uDDF0\uDEC0-\uDEDE\uDEE0-\uDEE2\uDEE4\uDEE5\uDEE7-\uDEED\uDEF0-\uDEF4\uDEFE\uDEFF\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEAD\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD88D[\uDC00-\uDC79])(?:[0-9A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088F\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5C\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDC-\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C8A\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7DC\uA7F1-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDDC0-\uDDF3\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD40-\uDD59\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDD4A-\uDD65\uDD6F-\uDD85\uDE80-\uDEA9\uDEB0\uDEB1\uDEC2-\uDEC7\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61\uDF80-\uDF89\uDF8B\uDF8E\uDF90-\uDFB5\uDFB7\uDFD1\uDFD3]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8\uDFC0-\uDFE0]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDDB0-\uDDDB\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD80E\uD80F\uD81C-\uD822\uD840-\uD868\uD86A-\uD86D\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD88C][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46\uDC60-\uDFFF]|\uD810[\uDC00-\uDFFA]|\uD811[\uDC00-\uDE46]|\uD818[\uDD00-\uDD1D]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDD40-\uDD6C\uDE40-\uDE7F\uDEA0-\uDEB8\uDEBB-\uDED3\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3\uDFF2\uDFF3]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD1E\uDD80-\uDDF2]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDCD0-\uDCEB\uDDD0-\uDDED\uDDF0\uDEC0-\uDEDE\uDEE0-\uDEE2\uDEE4\uDEE5\uDEE7-\uDEED\uDEF0-\uDEF4\uDEFE\uDEFF\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEAD\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD88D[\uDC00-\uDC79])*$/.test(R) }, { name: "string", test: isString }, { name: "Chain", test: isChain }, { name: "Array", test: isArray }, { name: "Matrix", test: isMatrix }, { name: "DenseMatrix", test: isDenseMatrix }, { name: "SparseMatrix", test: isSparseMatrix }, { name: "Range", test: isRange }, { name: "Index", test: isIndex }, { name: "boolean", test: isBoolean$1 }, { name: "ResultSet", test: isResultSet }, { name: "Help", test: isHelp }, { name: "function", test: isFunction$1 }, { name: "Date", test: isDate }, { name: "RegExp", test: isRegExp }, { name: "null", test: isNull$1 }, { name: "undefined", test: isUndefined$1 }, { name: "AccessorNode", test: isAccessorNode }, { name: "ArrayNode", test: isArrayNode }, { name: "AssignmentNode", test: isAssignmentNode }, { name: "BlockNode", test: isBlockNode }, { name: "ConditionalNode", test: isConditionalNode }, { name: "ConstantNode", test: isConstantNode }, { name: "FunctionNode", test: isFunctionNode }, { name: "FunctionAssignmentNode", test: isFunctionAssignmentNode }, { name: "IndexNode", test: isIndexNode }, { name: "Node", test: isNode }, { name: "ObjectNode", test: isObjectNode }, { name: "OperatorNode", test: isOperatorNode }, { name: "ParenthesisNode", test: isParenthesisNode }, { name: "RangeNode", test: isRangeNode }, { name: "RelationalNode", test: isRelationalNode }, { name: "SymbolNode", test: isSymbolNode }, { name: "Map", test: isMap }, { name: "Object", test: isObject$1 }]), z.addConversions([{ from: "number", to: "BigNumber", convert: function(R) {
    if (E || throwNoBignumber(R), digits(R) > 15) throw TypeError("Cannot implicitly convert a number with >15 significant digits to BigNumber (value: " + R + "). Use function bignumber(x) to convert to BigNumber.");
    return new E(R);
  } }, { from: "number", to: "Complex", convert: function(R) {
    return O || throwNoComplex(R), new O(R, 0);
  } }, { from: "BigNumber", to: "Complex", convert: function(R) {
    return O || throwNoComplex(R), new O(R.toNumber(), 0);
  } }, { from: "bigint", to: "number", convert: function(R) {
    if (R > 2 ** 53 - 1) throw TypeError("Cannot implicitly convert bigint to number: value exceeds the max safe integer value (value: " + R + ")");
    return Number(R);
  } }, { from: "bigint", to: "BigNumber", convert: function(R) {
    return E || throwNoBignumber(R), new E(R.toString());
  } }, { from: "bigint", to: "Fraction", convert: function(R) {
    return I || throwNoFraction(R), new I(R);
  } }, { from: "Fraction", to: "BigNumber", convert: function(R) {
    throw TypeError("Cannot implicitly convert a Fraction to BigNumber or vice versa. Use function bignumber(x) to convert to BigNumber or fraction(x) to convert to Fraction.");
  } }, { from: "Fraction", to: "Complex", convert: function(R) {
    return O || throwNoComplex(R), new O(R.valueOf(), 0);
  } }, { from: "number", to: "Fraction", convert: function(R) {
    I || throwNoFraction(R);
    var L = new I(R);
    if (L.valueOf() !== R) throw TypeError("Cannot implicitly convert a number to a Fraction when there will be a loss of precision (value: " + R + "). Use function fraction(x) to convert to Fraction.");
    return L;
  } }, { from: "string", to: "number", convert: function(R) {
    var L = Number(R);
    if (isNaN(L)) throw Error('Cannot convert "' + R + '" to a number');
    return L;
  } }, { from: "string", to: "BigNumber", convert: function(R) {
    E || throwNoBignumber(R);
    try {
      return new E(R);
    } catch {
      throw Error('Cannot convert "' + R + '" to BigNumber');
    }
  } }, { from: "string", to: "bigint", convert: function(R) {
    try {
      return BigInt(R);
    } catch {
      throw Error('Cannot convert "' + R + '" to BigInt');
    }
  } }, { from: "string", to: "Fraction", convert: function(R) {
    I || throwNoFraction(R);
    try {
      return new I(R);
    } catch {
      throw Error('Cannot convert "' + R + '" to Fraction');
    }
  } }, { from: "string", to: "Complex", convert: function(R) {
    O || throwNoComplex(R);
    try {
      return new O(R);
    } catch {
      throw Error('Cannot convert "' + R + '" to Complex');
    }
  } }, { from: "boolean", to: "number", convert: function(R) {
    return +R;
  } }, { from: "boolean", to: "BigNumber", convert: function(R) {
    return E || throwNoBignumber(R), new E(+R);
  } }, { from: "boolean", to: "bigint", convert: function(R) {
    return BigInt(+R);
  } }, { from: "boolean", to: "Fraction", convert: function(R) {
    return I || throwNoFraction(R), new I(+R);
  } }, { from: "boolean", to: "string", convert: function(R) {
    return String(R);
  } }, { from: "Array", to: "Matrix", convert: function(R) {
    return F || throwNoMatrix(), new F(R);
  } }, { from: "Matrix", to: "Array", convert: function(R) {
    return R.valueOf();
  } }]), z.onMismatch = (R, L, q) => {
    var U = z.createError(R, L, q);
    if (["wrongType", "mismatch"].includes(U.data.category) && L.length === 1 && isCollection(L[0]) && q.some((V) => !V.params.includes(","))) {
      var Z = TypeError(`Function '${R}' doesn't apply to matrices. To call it elementwise on a matrix 'M', try 'map(M, ${R})'.`);
      throw Z.data = U.data, Z;
    }
    throw U;
  }, z.onMismatch = (R, L, q) => {
    var U = z.createError(R, L, q);
    if (["wrongType", "mismatch"].includes(U.data.category) && L.length === 1 && isCollection(L[0]) && q.some((V) => !V.params.includes(","))) {
      var Z = TypeError(`Function '${R}' doesn't apply to matrices. To call it elementwise on a matrix 'M', try 'map(M, ${R})'.`);
      throw Z.data = U.data, Z;
    }
    throw U;
  }, z;
});
function throwNoBignumber(D) {
  throw Error(`Cannot convert value ${D} into a BigNumber: no class 'BigNumber' provided`);
}
function throwNoComplex(D) {
  throw Error(`Cannot convert value ${D} into a Complex number: no class 'Complex' provided`);
}
function throwNoMatrix() {
  throw Error("Cannot convert array into a Matrix: no class 'DenseMatrix' provided");
}
function throwNoFraction(D) {
  throw Error(`Cannot convert value ${D} into a Fraction, no class 'Fraction' provided.`);
}
var name$321 = "ResultSet", dependencies$321 = [], createResultSet = factory(name$321, dependencies$321, () => {
  function D(E) {
    if (!(this instanceof D)) throw SyntaxError("Constructor must be called with the new operator");
    this.entries = E || [];
  }
  return D.prototype.type = "ResultSet", D.prototype.isResultSet = !0, D.prototype.valueOf = function() {
    return this.entries;
  }, D.prototype.toString = function() {
    return "[" + this.entries.map(String).join(", ") + "]";
  }, D.prototype.toJSON = function() {
    return { mathjs: "ResultSet", entries: this.entries };
  }, D.fromJSON = function(E) {
    return new D(E.entries);
  }, D;
}, { isClass: !0 }), EXP_LIMIT = 9e15, MAX_DIGITS = 1e9, NUMERALS = "0123456789abcdef", LN10 = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", PI = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", DEFAULTS = { precision: 20, rounding: 4, modulo: 1, toExpNeg: -7, toExpPos: 21, minE: -EXP_LIMIT, maxE: EXP_LIMIT, crypto: !1 }, inexact, quadrant, external = !0, decimalError = "[DecimalError] ", invalidArgument = decimalError + "Invalid argument: ", precisionLimitExceeded = decimalError + "Precision limit exceeded", cryptoUnavailable = decimalError + "crypto unavailable", tag = "[object Decimal]", mathfloor = Math.floor, mathpow = Math.pow, isBinary = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, isHex = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, isOctal = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, LN10_PRECISION = LN10.length - 1, PI_PRECISION = PI.length - 1, P$3 = { toStringTag: tag };
P$3.absoluteValue = P$3.abs = function() {
  var D = new this.constructor(this);
  return D.s < 0 && (D.s = 1), finalise(D);
}, P$3.ceil = function() {
  return finalise(new this.constructor(this), this.e + 1, 2);
}, P$3.clampedTo = P$3.clamp = function(D, E) {
  var O, F = this, I = F.constructor;
  if (D = new I(D), E = new I(E), !D.s || !E.s) return new I(NaN);
  if (D.gt(E)) throw Error(invalidArgument + E);
  return O = F.cmp(D), O < 0 ? D : F.cmp(E) > 0 ? E : new I(F);
}, P$3.comparedTo = P$3.cmp = function(D) {
  var E, O, F, I, z = this, R = z.d, L = (D = new z.constructor(D)).d, q = z.s, U = D.s;
  if (!R || !L) return !q || !U ? NaN : q === U ? R === L ? 0 : !R ^ q < 0 ? 1 : -1 : q;
  if (!R[0] || !L[0]) return R[0] ? q : L[0] ? -U : 0;
  if (q !== U) return q;
  if (z.e !== D.e) return z.e > D.e ^ q < 0 ? 1 : -1;
  for (F = R.length, I = L.length, E = 0, O = F < I ? F : I; E < O; ++E) if (R[E] !== L[E]) return R[E] > L[E] ^ q < 0 ? 1 : -1;
  return F === I ? 0 : F > I ^ q < 0 ? 1 : -1;
}, P$3.cosine = P$3.cos = function() {
  var D, E, O = this, F = O.constructor;
  return O.d ? O.d[0] ? (D = F.precision, E = F.rounding, F.precision = D + Math.max(O.e, O.sd()) + LOG_BASE, F.rounding = 1, O = cosine(F, toLessThanHalfPi(F, O)), F.precision = D, F.rounding = E, finalise(quadrant == 2 || quadrant == 3 ? O.neg() : O, D, E, !0)) : new F(1) : new F(NaN);
}, P$3.cubeRoot = P$3.cbrt = function() {
  var D, E, O, F, I, z, R, L, q, U, Z = this, V = Z.constructor;
  if (!Z.isFinite() || Z.isZero()) return new V(Z);
  for (external = !1, z = Z.s * mathpow(Z.s * Z, 1 / 3), !z || Math.abs(z) == 1 / 0 ? (O = digitsToString(Z.d), D = Z.e, (z = (D - O.length + 1) % 3) && (O += z == 1 || z == -2 ? "0" : "00"), z = mathpow(O, 1 / 3), D = mathfloor((D + 1) / 3) - (D % 3 == (D < 0 ? -1 : 2)), z == 1 / 0 ? O = "5e" + D : (O = z.toExponential(), O = O.slice(0, O.indexOf("e") + 1) + D), F = new V(O), F.s = Z.s) : F = new V(z.toString()), R = (D = V.precision) + 3; ; ) if (L = F, q = L.times(L).times(L), U = q.plus(Z), F = divide$1(U.plus(Z).times(L), U.plus(q), R + 2, 1), digitsToString(L.d).slice(0, R) === (O = digitsToString(F.d)).slice(0, R)) if (O = O.slice(R - 3, R + 1), O == "9999" || !I && O == "4999") {
    if (!I && (finalise(L, D + 1, 0), L.times(L).times(L).eq(Z))) {
      F = L;
      break;
    }
    R += 4, I = 1;
  } else {
    (!+O || !+O.slice(1) && O.charAt(0) == "5") && (finalise(F, D + 1, 1), E = !F.times(F).times(F).eq(Z));
    break;
  }
  return external = !0, finalise(F, D, V.rounding, E);
}, P$3.decimalPlaces = P$3.dp = function() {
  var D, E = this.d, O = NaN;
  if (E) {
    if (D = E.length - 1, O = (D - mathfloor(this.e / LOG_BASE)) * LOG_BASE, D = E[D], D) for (; D % 10 == 0; D /= 10) O--;
    O < 0 && (O = 0);
  }
  return O;
}, P$3.dividedBy = P$3.div = function(D) {
  return divide$1(this, new this.constructor(D));
}, P$3.dividedToIntegerBy = P$3.divToInt = function(D) {
  var E = this, O = E.constructor;
  return finalise(divide$1(E, new O(D), 0, 1, 1), O.precision, O.rounding);
}, P$3.equals = P$3.eq = function(D) {
  return this.cmp(D) === 0;
}, P$3.floor = function() {
  return finalise(new this.constructor(this), this.e + 1, 3);
}, P$3.greaterThan = P$3.gt = function(D) {
  return this.cmp(D) > 0;
}, P$3.greaterThanOrEqualTo = P$3.gte = function(D) {
  var E = this.cmp(D);
  return E == 1 || E === 0;
}, P$3.hyperbolicCosine = P$3.cosh = function() {
  var D, E, O, F, I, z = this, R = z.constructor, L = new R(1);
  if (!z.isFinite()) return new R(z.s ? 1 / 0 : NaN);
  if (z.isZero()) return L;
  O = R.precision, F = R.rounding, R.precision = O + Math.max(z.e, z.sd()) + 4, R.rounding = 1, I = z.d.length, I < 32 ? (D = Math.ceil(I / 3), E = (1 / tinyPow(4, D)).toString()) : (D = 16, E = "2.3283064365386962890625e-10"), z = taylorSeries(R, 1, z.times(E), new R(1), !0);
  for (var q, U = D, Z = new R(8); U--; ) q = z.times(z), z = L.minus(q.times(Z.minus(q.times(Z))));
  return finalise(z, R.precision = O, R.rounding = F, !0);
}, P$3.hyperbolicSine = P$3.sinh = function() {
  var D, E, O, F, I = this, z = I.constructor;
  if (!I.isFinite() || I.isZero()) return new z(I);
  if (E = z.precision, O = z.rounding, z.precision = E + Math.max(I.e, I.sd()) + 4, z.rounding = 1, F = I.d.length, F < 3) I = taylorSeries(z, 2, I, I, !0);
  else {
    D = 1.4 * Math.sqrt(F), D = D > 16 ? 16 : D | 0, I = I.times(1 / tinyPow(5, D)), I = taylorSeries(z, 2, I, I, !0);
    for (var R, L = new z(5), q = new z(16), U = new z(20); D--; ) R = I.times(I), I = I.times(L.plus(R.times(q.times(R).plus(U))));
  }
  return z.precision = E, z.rounding = O, finalise(I, E, O, !0);
}, P$3.hyperbolicTangent = P$3.tanh = function() {
  var D, E, O = this, F = O.constructor;
  return O.isFinite() ? O.isZero() ? new F(O) : (D = F.precision, E = F.rounding, F.precision = D + 7, F.rounding = 1, divide$1(O.sinh(), O.cosh(), F.precision = D, F.rounding = E)) : new F(O.s);
}, P$3.inverseCosine = P$3.acos = function() {
  var D, E = this, O = E.constructor, F = E.abs().cmp(1), I = O.precision, z = O.rounding;
  return F === -1 ? E.isZero() ? getPi(O, I + 4, z).times(0.5) : (O.precision = I + 6, O.rounding = 1, E = E.asin(), D = getPi(O, I + 4, z).times(0.5), O.precision = I, O.rounding = z, D.minus(E)) : F === 0 ? E.isNeg() ? getPi(O, I, z) : new O(0) : new O(NaN);
}, P$3.inverseHyperbolicCosine = P$3.acosh = function() {
  var D, E, O = this, F = O.constructor;
  return O.lte(1) ? new F(O.eq(1) ? 0 : NaN) : O.isFinite() ? (D = F.precision, E = F.rounding, F.precision = D + Math.max(Math.abs(O.e), O.sd()) + 4, F.rounding = 1, external = !1, O = O.times(O).minus(1).sqrt().plus(O), external = !0, F.precision = D, F.rounding = E, O.ln()) : new F(O);
}, P$3.inverseHyperbolicSine = P$3.asinh = function() {
  var D, E, O = this, F = O.constructor;
  return !O.isFinite() || O.isZero() ? new F(O) : (D = F.precision, E = F.rounding, F.precision = D + 2 * Math.max(Math.abs(O.e), O.sd()) + 6, F.rounding = 1, external = !1, O = O.times(O).plus(1).sqrt().plus(O), external = !0, F.precision = D, F.rounding = E, O.ln());
}, P$3.inverseHyperbolicTangent = P$3.atanh = function() {
  var D, E, O, F, I = this, z = I.constructor;
  return I.isFinite() ? I.e >= 0 ? new z(I.abs().eq(1) ? I.s / 0 : I.isZero() ? I : NaN) : (D = z.precision, E = z.rounding, F = I.sd(), Math.max(F, D) < 2 * -I.e - 1 ? finalise(new z(I), D, E, !0) : (z.precision = O = F - I.e, I = divide$1(I.plus(1), new z(1).minus(I), O + D, 1), z.precision = D + 4, z.rounding = 1, I = I.ln(), z.precision = D, z.rounding = E, I.times(0.5))) : new z(NaN);
}, P$3.inverseSine = P$3.asin = function() {
  var D, E, O, F, I = this, z = I.constructor;
  return I.isZero() ? new z(I) : (E = I.abs().cmp(1), O = z.precision, F = z.rounding, E === -1 ? (z.precision = O + 6, z.rounding = 1, I = I.div(new z(1).minus(I.times(I)).sqrt().plus(1)).atan(), z.precision = O, z.rounding = F, I.times(2)) : E === 0 ? (D = getPi(z, O + 4, F).times(0.5), D.s = I.s, D) : new z(NaN));
}, P$3.inverseTangent = P$3.atan = function() {
  var D, E, O, F, I, z, R, L, q, U = this, Z = U.constructor, V = Z.precision, G = Z.rounding;
  if (U.isFinite()) {
    if (U.isZero()) return new Z(U);
    if (U.abs().eq(1) && V + 4 <= PI_PRECISION) return R = getPi(Z, V + 4, G).times(0.25), R.s = U.s, R;
  } else {
    if (!U.s) return new Z(NaN);
    if (V + 4 <= PI_PRECISION) return R = getPi(Z, V + 4, G).times(0.5), R.s = U.s, R;
  }
  for (Z.precision = L = V + 10, Z.rounding = 1, O = Math.min(28, L / LOG_BASE + 2 | 0), D = O; D; --D) U = U.div(U.times(U).plus(1).sqrt().plus(1));
  for (external = !1, E = Math.ceil(L / LOG_BASE), F = 1, q = U.times(U), R = new Z(U), I = U; D !== -1; ) if (I = I.times(q), z = R.minus(I.div(F += 2)), I = I.times(q), R = z.plus(I.div(F += 2)), R.d[E] !== void 0) for (D = E; R.d[D] === z.d[D] && D--; ) ;
  return O && (R = R.times(2 << O - 1)), external = !0, finalise(R, Z.precision = V, Z.rounding = G, !0);
}, P$3.isFinite = function() {
  return !!this.d;
}, P$3.isInteger = P$3.isInt = function() {
  return !!this.d && mathfloor(this.e / LOG_BASE) > this.d.length - 2;
}, P$3.isNaN = function() {
  return !this.s;
}, P$3.isNegative = P$3.isNeg = function() {
  return this.s < 0;
}, P$3.isPositive = P$3.isPos = function() {
  return this.s > 0;
}, P$3.isZero = function() {
  return !!this.d && this.d[0] === 0;
}, P$3.lessThan = P$3.lt = function(D) {
  return this.cmp(D) < 0;
}, P$3.lessThanOrEqualTo = P$3.lte = function(D) {
  return this.cmp(D) < 1;
}, P$3.logarithm = P$3.log = function(D) {
  var E, O, F, I, z, R, L, q, U = this, Z = U.constructor, V = Z.precision, G = Z.rounding, W = 5;
  if (D == null) D = new Z(10), E = !0;
  else {
    if (D = new Z(D), O = D.d, D.s < 0 || !O || !O[0] || D.eq(1)) return new Z(NaN);
    E = D.eq(10);
  }
  if (O = U.d, U.s < 0 || !O || !O[0] || U.eq(1)) return new Z(O && !O[0] ? -1 / 0 : U.s == 1 ? O ? 0 : 1 / 0 : NaN);
  if (E) if (O.length > 1) z = !0;
  else {
    for (I = O[0]; I % 10 == 0; ) I /= 10;
    z = I !== 1;
  }
  if (external = !1, L = V + W, R = naturalLogarithm(U, L), F = E ? getLn10(Z, L + 10) : naturalLogarithm(D, L), q = divide$1(R, F, L, 1), checkRoundingDigits(q.d, I = V, G)) do
    if (L += 10, R = naturalLogarithm(U, L), F = E ? getLn10(Z, L + 10) : naturalLogarithm(D, L), q = divide$1(R, F, L, 1), !z) {
      +digitsToString(q.d).slice(I + 1, I + 15) + 1 == 1e14 && (q = finalise(q, V + 1, 0));
      break;
    }
  while (checkRoundingDigits(q.d, I += 10, G));
  return external = !0, finalise(q, V, G);
}, P$3.minus = P$3.sub = function(D) {
  var E, O, F, I, z, R, L, q, U, Z, V, G, W = this, J = W.constructor;
  if (D = new J(D), !W.d || !D.d) return !W.s || !D.s ? D = new J(NaN) : W.d ? D.s = -D.s : D = new J(D.d || W.s !== D.s ? W : NaN), D;
  if (W.s != D.s) return D.s = -D.s, W.plus(D);
  if (U = W.d, G = D.d, L = J.precision, q = J.rounding, !U[0] || !G[0]) {
    if (G[0]) D.s = -D.s;
    else if (U[0]) D = new J(W);
    else return new J(q === 3 ? -0 : 0);
    return external ? finalise(D, L, q) : D;
  }
  if (O = mathfloor(D.e / LOG_BASE), Z = mathfloor(W.e / LOG_BASE), U = U.slice(), z = Z - O, z) {
    for (V = z < 0, V ? (E = U, z = -z, R = G.length) : (E = G, O = Z, R = U.length), F = Math.max(Math.ceil(L / LOG_BASE), R) + 2, z > F && (z = F, E.length = 1), E.reverse(), F = z; F--; ) E.push(0);
    E.reverse();
  } else {
    for (F = U.length, R = G.length, V = F < R, V && (R = F), F = 0; F < R; F++) if (U[F] != G[F]) {
      V = U[F] < G[F];
      break;
    }
    z = 0;
  }
  for (V && (E = U, U = G, G = E, D.s = -D.s), R = U.length, F = G.length - R; F > 0; --F) U[R++] = 0;
  for (F = G.length; F > z; ) {
    if (U[--F] < G[F]) {
      for (I = F; I && U[--I] === 0; ) U[I] = BASE - 1;
      --U[I], U[F] += BASE;
    }
    U[F] -= G[F];
  }
  for (; U[--R] === 0; ) U.pop();
  for (; U[0] === 0; U.shift()) --O;
  return U[0] ? (D.d = U, D.e = getBase10Exponent(U, O), external ? finalise(D, L, q) : D) : new J(q === 3 ? -0 : 0);
}, P$3.modulo = P$3.mod = function(D) {
  var E, O = this, F = O.constructor;
  return D = new F(D), !O.d || !D.s || D.d && !D.d[0] ? new F(NaN) : !D.d || O.d && !O.d[0] ? finalise(new F(O), F.precision, F.rounding) : (external = !1, F.modulo == 9 ? (E = divide$1(O, D.abs(), 0, 3, 1), E.s *= D.s) : E = divide$1(O, D, 0, F.modulo, 1), E = E.times(D), external = !0, O.minus(E));
}, P$3.naturalExponential = P$3.exp = function() {
  return naturalExponential(this);
}, P$3.naturalLogarithm = P$3.ln = function() {
  return naturalLogarithm(this);
}, P$3.negated = P$3.neg = function() {
  var D = new this.constructor(this);
  return D.s = -D.s, finalise(D);
}, P$3.plus = P$3.add = function(D) {
  var E, O, F, I, z, R, L, q, U, Z, V = this, G = V.constructor;
  if (D = new G(D), !V.d || !D.d) return !V.s || !D.s ? D = new G(NaN) : V.d || (D = new G(D.d || V.s === D.s ? V : NaN)), D;
  if (V.s != D.s) return D.s = -D.s, V.minus(D);
  if (U = V.d, Z = D.d, L = G.precision, q = G.rounding, !U[0] || !Z[0]) return Z[0] || (D = new G(V)), external ? finalise(D, L, q) : D;
  if (z = mathfloor(V.e / LOG_BASE), F = mathfloor(D.e / LOG_BASE), U = U.slice(), I = z - F, I) {
    for (I < 0 ? (O = U, I = -I, R = Z.length) : (O = Z, F = z, R = U.length), z = Math.ceil(L / LOG_BASE), R = z > R ? z + 1 : R + 1, I > R && (I = R, O.length = 1), O.reverse(); I--; ) O.push(0);
    O.reverse();
  }
  for (R = U.length, I = Z.length, R - I < 0 && (I = R, O = Z, Z = U, U = O), E = 0; I; ) E = (U[--I] = U[I] + Z[I] + E) / BASE | 0, U[I] %= BASE;
  for (E && (U.unshift(E), ++F), R = U.length; U[--R] == 0; ) U.pop();
  return D.d = U, D.e = getBase10Exponent(U, F), external ? finalise(D, L, q) : D;
}, P$3.precision = P$3.sd = function(D) {
  var E, O = this;
  if (D !== void 0 && D !== !!D && D !== 1 && D !== 0) throw Error(invalidArgument + D);
  return O.d ? (E = getPrecision(O.d), D && O.e + 1 > E && (E = O.e + 1)) : E = NaN, E;
}, P$3.round = function() {
  var D = this, E = D.constructor;
  return finalise(new E(D), D.e + 1, E.rounding);
}, P$3.sine = P$3.sin = function() {
  var D, E, O = this, F = O.constructor;
  return O.isFinite() ? O.isZero() ? new F(O) : (D = F.precision, E = F.rounding, F.precision = D + Math.max(O.e, O.sd()) + LOG_BASE, F.rounding = 1, O = sine(F, toLessThanHalfPi(F, O)), F.precision = D, F.rounding = E, finalise(quadrant > 2 ? O.neg() : O, D, E, !0)) : new F(NaN);
}, P$3.squareRoot = P$3.sqrt = function() {
  var D, E, O, F, I, z, R = this, L = R.d, q = R.e, U = R.s, Z = R.constructor;
  if (U !== 1 || !L || !L[0]) return new Z(!U || U < 0 && (!L || L[0]) ? NaN : L ? R : 1 / 0);
  for (external = !1, U = Math.sqrt(+R), U == 0 || U == 1 / 0 ? (E = digitsToString(L), (E.length + q) % 2 == 0 && (E += "0"), U = Math.sqrt(E), q = mathfloor((q + 1) / 2) - (q < 0 || q % 2), U == 1 / 0 ? E = "5e" + q : (E = U.toExponential(), E = E.slice(0, E.indexOf("e") + 1) + q), F = new Z(E)) : F = new Z(U.toString()), O = (q = Z.precision) + 3; ; ) if (z = F, F = z.plus(divide$1(R, z, O + 2, 1)).times(0.5), digitsToString(z.d).slice(0, O) === (E = digitsToString(F.d)).slice(0, O)) if (E = E.slice(O - 3, O + 1), E == "9999" || !I && E == "4999") {
    if (!I && (finalise(z, q + 1, 0), z.times(z).eq(R))) {
      F = z;
      break;
    }
    O += 4, I = 1;
  } else {
    (!+E || !+E.slice(1) && E.charAt(0) == "5") && (finalise(F, q + 1, 1), D = !F.times(F).eq(R));
    break;
  }
  return external = !0, finalise(F, q, Z.rounding, D);
}, P$3.tangent = P$3.tan = function() {
  var D, E, O = this, F = O.constructor;
  return O.isFinite() ? O.isZero() ? new F(O) : (D = F.precision, E = F.rounding, F.precision = D + 10, F.rounding = 1, O = O.sin(), O.s = 1, O = divide$1(O, new F(1).minus(O.times(O)).sqrt(), D + 10, 0), F.precision = D, F.rounding = E, finalise(quadrant == 2 || quadrant == 4 ? O.neg() : O, D, E, !0)) : new F(NaN);
}, P$3.times = P$3.mul = function(D) {
  var E, O, F, I, z, R, L, q, U, Z = this, V = Z.constructor, G = Z.d, W = (D = new V(D)).d;
  if (D.s *= Z.s, !G || !G[0] || !W || !W[0]) return new V(!D.s || G && !G[0] && !W || W && !W[0] && !G ? NaN : !G || !W ? D.s / 0 : D.s * 0);
  for (O = mathfloor(Z.e / LOG_BASE) + mathfloor(D.e / LOG_BASE), q = G.length, U = W.length, q < U && (z = G, G = W, W = z, R = q, q = U, U = R), z = [], R = q + U, F = R; F--; ) z.push(0);
  for (F = U; --F >= 0; ) {
    for (E = 0, I = q + F; I > F; ) L = z[I] + W[F] * G[I - F - 1] + E, z[I--] = L % BASE | 0, E = L / BASE | 0;
    z[I] = (z[I] + E) % BASE | 0;
  }
  for (; !z[--R]; ) z.pop();
  return E ? ++O : z.shift(), D.d = z, D.e = getBase10Exponent(z, O), external ? finalise(D, V.precision, V.rounding) : D;
}, P$3.toBinary = function(D, E) {
  return toStringBinary(this, 2, D, E);
}, P$3.toDecimalPlaces = P$3.toDP = function(D, E) {
  var O = this, F = O.constructor;
  return O = new F(O), D === void 0 ? O : (checkInt32(D, 0, MAX_DIGITS), E === void 0 ? E = F.rounding : checkInt32(E, 0, 8), finalise(O, D + O.e + 1, E));
}, P$3.toExponential = function(D, E) {
  var O, F = this, I = F.constructor;
  return D === void 0 ? O = finiteToString(F, !0) : (checkInt32(D, 0, MAX_DIGITS), E === void 0 ? E = I.rounding : checkInt32(E, 0, 8), F = finalise(new I(F), D + 1, E), O = finiteToString(F, !0, D + 1)), F.isNeg() && !F.isZero() ? "-" + O : O;
}, P$3.toFixed = function(D, E) {
  var O, F, I = this, z = I.constructor;
  return D === void 0 ? O = finiteToString(I) : (checkInt32(D, 0, MAX_DIGITS), E === void 0 ? E = z.rounding : checkInt32(E, 0, 8), F = finalise(new z(I), D + I.e + 1, E), O = finiteToString(F, !1, D + F.e + 1)), I.isNeg() && !I.isZero() ? "-" + O : O;
}, P$3.toFraction = function(D) {
  var E, O, F, I, z, R, L, q, U, Z, V, G, W = this, J = W.d, X = W.constructor;
  if (!J) return new X(W);
  if (U = O = new X(1), F = q = new X(0), E = new X(F), z = E.e = getPrecision(J) - W.e - 1, R = z % LOG_BASE, E.d[0] = mathpow(10, R < 0 ? LOG_BASE + R : R), D == null) D = z > 0 ? E : U;
  else {
    if (L = new X(D), !L.isInt() || L.lt(U)) throw Error(invalidArgument + L);
    D = L.gt(E) ? z > 0 ? E : U : L;
  }
  for (external = !1, L = new X(digitsToString(J)), Z = X.precision, X.precision = z = J.length * LOG_BASE * 2; V = divide$1(L, E, 0, 1, 1), I = O.plus(V.times(F)), I.cmp(D) != 1; ) O = F, F = I, I = U, U = q.plus(V.times(I)), q = I, I = E, E = L.minus(V.times(I)), L = I;
  return I = divide$1(D.minus(O), F, 0, 1, 1), q = q.plus(I.times(U)), O = O.plus(I.times(F)), q.s = U.s = W.s, G = divide$1(U, F, z, 1).minus(W).abs().cmp(divide$1(q, O, z, 1).minus(W).abs()) < 1 ? [U, F] : [q, O], X.precision = Z, external = !0, G;
}, P$3.toHexadecimal = P$3.toHex = function(D, E) {
  return toStringBinary(this, 16, D, E);
}, P$3.toNearest = function(D, E) {
  var O = this, F = O.constructor;
  if (O = new F(O), D == null) {
    if (!O.d) return O;
    D = new F(1), E = F.rounding;
  } else {
    if (D = new F(D), E === void 0 ? E = F.rounding : checkInt32(E, 0, 8), !O.d) return D.s ? O : D;
    if (!D.d) return D.s &&= O.s, D;
  }
  return D.d[0] ? (external = !1, O = divide$1(O, D, 0, E, 1).times(D), external = !0, finalise(O)) : (D.s = O.s, O = D), O;
}, P$3.toNumber = function() {
  return +this;
}, P$3.toOctal = function(D, E) {
  return toStringBinary(this, 8, D, E);
}, P$3.toPower = P$3.pow = function(D) {
  var E, O, F, I, z, R, L = this, q = L.constructor, U = +(D = new q(D));
  if (!L.d || !D.d || !L.d[0] || !D.d[0]) return new q(mathpow(+L, U));
  if (L = new q(L), L.eq(1)) return L;
  if (F = q.precision, z = q.rounding, D.eq(1)) return finalise(L, F, z);
  if (E = mathfloor(D.e / LOG_BASE), E >= D.d.length - 1 && (O = U < 0 ? -U : U) <= MAX_SAFE_INTEGER) return I = intPow(q, L, O, F), D.s < 0 ? new q(1).div(I) : finalise(I, F, z);
  if (R = L.s, R < 0) {
    if (E < D.d.length - 1) return new q(NaN);
    if (D.d[E] & 1 || (R = 1), L.e == 0 && L.d[0] == 1 && L.d.length == 1) return L.s = R, L;
  }
  return O = mathpow(+L, U), E = O == 0 || !isFinite(O) ? mathfloor(U * (Math.log("0." + digitsToString(L.d)) / Math.LN10 + L.e + 1)) : new q(O + "").e, E > q.maxE + 1 || E < q.minE - 1 ? new q(E > 0 ? R / 0 : 0) : (external = !1, q.rounding = L.s = 1, O = Math.min(12, (E + "").length), I = naturalExponential(D.times(naturalLogarithm(L, F + O)), F), I.d && (I = finalise(I, F + 5, 1), checkRoundingDigits(I.d, F, z) && (E = F + 10, I = finalise(naturalExponential(D.times(naturalLogarithm(L, E + O)), E), E + 5, 1), +digitsToString(I.d).slice(F + 1, F + 15) + 1 == 1e14 && (I = finalise(I, F + 1, 0)))), I.s = R, external = !0, q.rounding = z, finalise(I, F, z));
}, P$3.toPrecision = function(D, E) {
  var O, F = this, I = F.constructor;
  return D === void 0 ? O = finiteToString(F, F.e <= I.toExpNeg || F.e >= I.toExpPos) : (checkInt32(D, 1, MAX_DIGITS), E === void 0 ? E = I.rounding : checkInt32(E, 0, 8), F = finalise(new I(F), D, E), O = finiteToString(F, D <= F.e || F.e <= I.toExpNeg, D)), F.isNeg() && !F.isZero() ? "-" + O : O;
}, P$3.toSignificantDigits = P$3.toSD = function(D, E) {
  var O = this, F = O.constructor;
  return D === void 0 ? (D = F.precision, E = F.rounding) : (checkInt32(D, 1, MAX_DIGITS), E === void 0 ? E = F.rounding : checkInt32(E, 0, 8)), finalise(new F(O), D, E);
}, P$3.toString = function() {
  var D = this, E = D.constructor, O = finiteToString(D, D.e <= E.toExpNeg || D.e >= E.toExpPos);
  return D.isNeg() && !D.isZero() ? "-" + O : O;
}, P$3.truncated = P$3.trunc = function() {
  return finalise(new this.constructor(this), this.e + 1, 1);
}, P$3.valueOf = P$3.toJSON = function() {
  var D = this, E = D.constructor, O = finiteToString(D, D.e <= E.toExpNeg || D.e >= E.toExpPos);
  return D.isNeg() ? "-" + O : O;
};
function digitsToString(D) {
  var E, O, F, I = D.length - 1, z = "", R = D[0];
  if (I > 0) {
    for (z += R, E = 1; E < I; E++) F = D[E] + "", O = LOG_BASE - F.length, O && (z += getZeroString(O)), z += F;
    R = D[E], F = R + "", O = LOG_BASE - F.length, O && (z += getZeroString(O));
  } else if (R === 0) return "0";
  for (; R % 10 == 0; ) R /= 10;
  return z + R;
}
function checkInt32(D, E, O) {
  if (D !== ~~D || D < E || D > O) throw Error(invalidArgument + D);
}
function checkRoundingDigits(D, E, O, F) {
  var I, z, R, L;
  for (z = D[0]; z >= 10; z /= 10) --E;
  return --E < 0 ? (E += LOG_BASE, I = 0) : (I = Math.ceil((E + 1) / LOG_BASE), E %= LOG_BASE), z = mathpow(10, LOG_BASE - E), L = D[I] % z | 0, F == null ? E < 3 ? (E == 0 ? L = L / 100 | 0 : E == 1 && (L = L / 10 | 0), R = O < 4 && L == 99999 || O > 3 && L == 49999 || L == 5e4 || L == 0) : R = (O < 4 && L + 1 == z || O > 3 && L + 1 == z / 2) && (D[I + 1] / z / 100 | 0) == mathpow(10, E - 2) - 1 || (L == z / 2 || L == 0) && (D[I + 1] / z / 100 | 0) == 0 : E < 4 ? (E == 0 ? L = L / 1e3 | 0 : E == 1 ? L = L / 100 | 0 : E == 2 && (L = L / 10 | 0), R = (F || O < 4) && L == 9999 || !F && O > 3 && L == 4999) : R = ((F || O < 4) && L + 1 == z || !F && O > 3 && L + 1 == z / 2) && (D[I + 1] / z / 1e3 | 0) == mathpow(10, E - 3) - 1, R;
}
function convertBase(D, E, O) {
  for (var F, I = [0], z, R = 0, L = D.length; R < L; ) {
    for (z = I.length; z--; ) I[z] *= E;
    for (I[0] += NUMERALS.indexOf(D.charAt(R++)), F = 0; F < I.length; F++) I[F] > O - 1 && (I[F + 1] === void 0 && (I[F + 1] = 0), I[F + 1] += I[F] / O | 0, I[F] %= O);
  }
  return I.reverse();
}
function cosine(D, E) {
  var O, F, I;
  if (E.isZero()) return E;
  F = E.d.length, F < 32 ? (O = Math.ceil(F / 3), I = (1 / tinyPow(4, O)).toString()) : (O = 16, I = "2.3283064365386962890625e-10"), D.precision += O, E = taylorSeries(D, 1, E.times(I), new D(1));
  for (var z = O; z--; ) {
    var R = E.times(E);
    E = R.times(R).minus(R).times(8).plus(1);
  }
  return D.precision -= O, E;
}
var divide$1 = /* @__PURE__ */ (function() {
  function D(F, I, z) {
    var R, L = 0, q = F.length;
    for (F = F.slice(); q--; ) R = F[q] * I + L, F[q] = R % z | 0, L = R / z | 0;
    return L && F.unshift(L), F;
  }
  function E(F, I, z, R) {
    var L, q;
    if (z != R) q = z > R ? 1 : -1;
    else for (L = q = 0; L < z; L++) if (F[L] != I[L]) {
      q = F[L] > I[L] ? 1 : -1;
      break;
    }
    return q;
  }
  function O(F, I, z, R) {
    for (var L = 0; z--; ) F[z] -= L, L = +(F[z] < I[z]), F[z] = L * R + F[z] - I[z];
    for (; !F[0] && F.length > 1; ) F.shift();
  }
  return function(F, I, z, R, L, q) {
    var U, Z, V, G, W, J, X, Y, ee, K, te, ie, ne, ae, ue, oe, se, le, ce, fe, pe = F.constructor, ve = F.s == I.s ? 1 : -1, _e = F.d, de = I.d;
    if (!_e || !_e[0] || !de || !de[0]) return new pe(!F.s || !I.s || (_e ? de && _e[0] == de[0] : !de) ? NaN : _e && _e[0] == 0 || !de ? ve * 0 : ve / 0);
    for (q ? (W = 1, Z = F.e - I.e) : (q = BASE, W = LOG_BASE, Z = mathfloor(F.e / W) - mathfloor(I.e / W)), ce = de.length, se = _e.length, ee = new pe(ve), K = ee.d = [], V = 0; de[V] == (_e[V] || 0); V++) ;
    if (de[V] > (_e[V] || 0) && Z--, z == null ? (ae = z = pe.precision, R = pe.rounding) : ae = L ? z + (F.e - I.e) + 1 : z, ae < 0) K.push(1), J = !0;
    else {
      if (ae = ae / W + 2 | 0, V = 0, ce == 1) {
        for (G = 0, de = de[0], ae++; (V < se || G) && ae--; V++) ue = G * q + (_e[V] || 0), K[V] = ue / de | 0, G = ue % de | 0;
        J = G || V < se;
      } else {
        for (G = q / (de[0] + 1) | 0, G > 1 && (de = D(de, G, q), _e = D(_e, G, q), ce = de.length, se = _e.length), oe = ce, te = _e.slice(0, ce), ie = te.length; ie < ce; ) te[ie++] = 0;
        fe = de.slice(), fe.unshift(0), le = de[0], de[1] >= q / 2 && ++le;
        do
          G = 0, U = E(de, te, ce, ie), U < 0 ? (ne = te[0], ce != ie && (ne = ne * q + (te[1] || 0)), G = ne / le | 0, G > 1 ? (G >= q && (G = q - 1), X = D(de, G, q), Y = X.length, ie = te.length, U = E(X, te, Y, ie), U == 1 && (G--, O(X, ce < Y ? fe : de, Y, q))) : (G == 0 && (U = G = 1), X = de.slice()), Y = X.length, Y < ie && X.unshift(0), O(te, X, ie, q), U == -1 && (ie = te.length, U = E(de, te, ce, ie), U < 1 && (G++, O(te, ce < ie ? fe : de, ie, q))), ie = te.length) : U === 0 && (G++, te = [0]), K[V++] = G, U && te[0] ? te[ie++] = _e[oe] || 0 : (te = [_e[oe]], ie = 1);
        while ((oe++ < se || te[0] !== void 0) && ae--);
        J = te[0] !== void 0;
      }
      K[0] || K.shift();
    }
    if (W == 1) ee.e = Z, inexact = J;
    else {
      for (V = 1, G = K[0]; G >= 10; G /= 10) V++;
      ee.e = V + Z * W - 1, finalise(ee, L ? z + ee.e + 1 : z, R, J);
    }
    return ee;
  };
})();
function finalise(D, E, O, F) {
  var I, z, R, L, q, U, Z, V, G, W = D.constructor;
  e: if (E != null) {
    if (V = D.d, !V) return D;
    for (I = 1, L = V[0]; L >= 10; L /= 10) I++;
    if (z = E - I, z < 0) z += LOG_BASE, R = E, Z = V[G = 0], q = Z / mathpow(10, I - R - 1) % 10 | 0;
    else if (G = Math.ceil((z + 1) / LOG_BASE), L = V.length, G >= L) if (F) {
      for (; L++ <= G; ) V.push(0);
      Z = q = 0, I = 1, z %= LOG_BASE, R = z - LOG_BASE + 1;
    } else break e;
    else {
      for (Z = L = V[G], I = 1; L >= 10; L /= 10) I++;
      z %= LOG_BASE, R = z - LOG_BASE + I, q = R < 0 ? 0 : Z / mathpow(10, I - R - 1) % 10 | 0;
    }
    if (F = F || E < 0 || V[G + 1] !== void 0 || (R < 0 ? Z : Z % mathpow(10, I - R - 1)), U = O < 4 ? (q || F) && (O == 0 || O == (D.s < 0 ? 3 : 2)) : q > 5 || q == 5 && (O == 4 || F || O == 6 && (z > 0 ? R > 0 ? Z / mathpow(10, I - R) : 0 : V[G - 1]) % 10 & 1 || O == (D.s < 0 ? 8 : 7)), E < 1 || !V[0]) return V.length = 0, U ? (E -= D.e + 1, V[0] = mathpow(10, (LOG_BASE - E % LOG_BASE) % LOG_BASE), D.e = -E || 0) : V[0] = D.e = 0, D;
    if (z == 0 ? (V.length = G, L = 1, G--) : (V.length = G + 1, L = mathpow(10, LOG_BASE - z), V[G] = R > 0 ? (Z / mathpow(10, I - R) % mathpow(10, R) | 0) * L : 0), U) for (; ; ) if (G == 0) {
      for (z = 1, R = V[0]; R >= 10; R /= 10) z++;
      for (R = V[0] += L, L = 1; R >= 10; R /= 10) L++;
      z != L && (D.e++, V[0] == BASE && (V[0] = 1));
      break;
    } else {
      if (V[G] += L, V[G] != BASE) break;
      V[G--] = 0, L = 1;
    }
    for (z = V.length; V[--z] === 0; ) V.pop();
  }
  return external && (D.e > W.maxE ? (D.d = null, D.e = NaN) : D.e < W.minE && (D.e = 0, D.d = [0])), D;
}
function finiteToString(D, E, O) {
  if (!D.isFinite()) return nonFiniteToString(D);
  var F, I = D.e, z = digitsToString(D.d), R = z.length;
  return E ? (O && (F = O - R) > 0 ? z = z.charAt(0) + "." + z.slice(1) + getZeroString(F) : R > 1 && (z = z.charAt(0) + "." + z.slice(1)), z = z + (D.e < 0 ? "e" : "e+") + D.e) : I < 0 ? (z = "0." + getZeroString(-I - 1) + z, O && (F = O - R) > 0 && (z += getZeroString(F))) : I >= R ? (z += getZeroString(I + 1 - R), O && (F = O - I - 1) > 0 && (z = z + "." + getZeroString(F))) : ((F = I + 1) < R && (z = z.slice(0, F) + "." + z.slice(F)), O && (F = O - R) > 0 && (I + 1 === R && (z += "."), z += getZeroString(F))), z;
}
function getBase10Exponent(D, E) {
  var O = D[0];
  for (E *= LOG_BASE; O >= 10; O /= 10) E++;
  return E;
}
function getLn10(D, E, O) {
  if (E > LN10_PRECISION) throw external = !0, O && (D.precision = O), Error(precisionLimitExceeded);
  return finalise(new D(LN10), E, 1, !0);
}
function getPi(D, E, O) {
  if (E > PI_PRECISION) throw Error(precisionLimitExceeded);
  return finalise(new D(PI), E, O, !0);
}
function getPrecision(D) {
  var E = D.length - 1, O = E * LOG_BASE + 1;
  if (E = D[E], E) {
    for (; E % 10 == 0; E /= 10) O--;
    for (E = D[0]; E >= 10; E /= 10) O++;
  }
  return O;
}
function getZeroString(D) {
  for (var E = ""; D--; ) E += "0";
  return E;
}
function intPow(D, E, O, F) {
  var I, z = new D(1), R = Math.ceil(F / LOG_BASE + 4);
  for (external = !1; ; ) {
    if (O % 2 && (z = z.times(E), truncate(z.d, R) && (I = !0)), O = mathfloor(O / 2), O === 0) {
      O = z.d.length - 1, I && z.d[O] === 0 && ++z.d[O];
      break;
    }
    E = E.times(E), truncate(E.d, R);
  }
  return external = !0, z;
}
function isOdd(D) {
  return D.d[D.d.length - 1] & 1;
}
function maxOrMin(D, E, O) {
  for (var F, I = new D(E[0]), z = 0; ++z < E.length; ) if (F = new D(E[z]), F.s) I[O](F) && (I = F);
  else {
    I = F;
    break;
  }
  return I;
}
function naturalExponential(D, E) {
  var O, F, I, z, R, L, q, U = 0, Z = 0, V = 0, G = D.constructor, W = G.rounding, J = G.precision;
  if (!D.d || !D.d[0] || D.e > 17) return new G(D.d ? D.d[0] ? D.s < 0 ? 0 : 1 / 0 : 1 : D.s ? D.s < 0 ? 0 : D : NaN);
  for (E == null ? (external = !1, q = J) : q = E, L = new G(0.03125); D.e > -2; ) D = D.times(L), V += 5;
  for (F = Math.log(mathpow(2, V)) / Math.LN10 * 2 + 5 | 0, q += F, O = z = R = new G(1), G.precision = q; ; ) {
    if (z = finalise(z.times(D), q, 1), O = O.times(++Z), L = R.plus(divide$1(z, O, q, 1)), digitsToString(L.d).slice(0, q) === digitsToString(R.d).slice(0, q)) {
      for (I = V; I--; ) R = finalise(R.times(R), q, 1);
      if (E == null) if (U < 3 && checkRoundingDigits(R.d, q - F, W, U)) G.precision = q += 10, O = z = L = new G(1), Z = 0, U++;
      else return finalise(R, G.precision = J, W, external = !0);
      else return G.precision = J, R;
    }
    R = L;
  }
}
function naturalLogarithm(D, E) {
  var O, F, I, z, R, L, q, U, Z, V, G, W = 1, J = 10, X = D, Y = X.d, ee = X.constructor, K = ee.rounding, te = ee.precision;
  if (X.s < 0 || !Y || !Y[0] || !X.e && Y[0] == 1 && Y.length == 1) return new ee(Y && !Y[0] ? -1 / 0 : X.s == 1 ? Y ? 0 : X : NaN);
  if (E == null ? (external = !1, Z = te) : Z = E, ee.precision = Z += J, O = digitsToString(Y), F = O.charAt(0), Math.abs(z = X.e) < 15e14) {
    for (; F < 7 && F != 1 || F == 1 && O.charAt(1) > 3; ) X = X.times(D), O = digitsToString(X.d), F = O.charAt(0), W++;
    z = X.e, F > 1 ? (X = new ee("0." + O), z++) : X = new ee(F + "." + O.slice(1));
  } else return U = getLn10(ee, Z + 2, te).times(z + ""), X = naturalLogarithm(new ee(F + "." + O.slice(1)), Z - J).plus(U), ee.precision = te, E == null ? finalise(X, te, K, external = !0) : X;
  for (V = X, q = R = X = divide$1(X.minus(1), X.plus(1), Z, 1), G = finalise(X.times(X), Z, 1), I = 3; ; ) {
    if (R = finalise(R.times(G), Z, 1), U = q.plus(divide$1(R, new ee(I), Z, 1)), digitsToString(U.d).slice(0, Z) === digitsToString(q.d).slice(0, Z)) if (q = q.times(2), z !== 0 && (q = q.plus(getLn10(ee, Z + 2, te).times(z + ""))), q = divide$1(q, new ee(W), Z, 1), E == null) if (checkRoundingDigits(q.d, Z - J, K, L)) ee.precision = Z += J, U = R = X = divide$1(V.minus(1), V.plus(1), Z, 1), G = finalise(X.times(X), Z, 1), I = L = 1;
    else return finalise(q, ee.precision = te, K, external = !0);
    else return ee.precision = te, q;
    q = U, I += 2;
  }
}
function nonFiniteToString(D) {
  return String(D.s * D.s / 0);
}
function parseDecimal(D, E) {
  var O, F, I;
  for ((O = E.indexOf(".")) > -1 && (E = E.replace(".", "")), (F = E.search(/e/i)) > 0 ? (O < 0 && (O = F), O += +E.slice(F + 1), E = E.substring(0, F)) : O < 0 && (O = E.length), F = 0; E.charCodeAt(F) === 48; F++) ;
  for (I = E.length; E.charCodeAt(I - 1) === 48; --I) ;
  if (E = E.slice(F, I), E) {
    if (I -= F, D.e = O = O - F - 1, D.d = [], F = (O + 1) % LOG_BASE, O < 0 && (F += LOG_BASE), F < I) {
      for (F && D.d.push(+E.slice(0, F)), I -= LOG_BASE; F < I; ) D.d.push(+E.slice(F, F += LOG_BASE));
      E = E.slice(F), F = LOG_BASE - E.length;
    } else F -= I;
    for (; F--; ) E += "0";
    D.d.push(+E), external && (D.e > D.constructor.maxE ? (D.d = null, D.e = NaN) : D.e < D.constructor.minE && (D.e = 0, D.d = [0]));
  } else D.e = 0, D.d = [0];
  return D;
}
function parseOther(D, E) {
  var O, F, I, z, R, L, q, U, Z;
  if (E.indexOf("_") > -1) {
    if (E = E.replace(/(\d)_(?=\d)/g, "$1"), isDecimal.test(E)) return parseDecimal(D, E);
  } else if (E === "Infinity" || E === "NaN") return +E || (D.s = NaN), D.e = NaN, D.d = null, D;
  if (isHex.test(E)) O = 16, E = E.toLowerCase();
  else if (isBinary.test(E)) O = 2;
  else if (isOctal.test(E)) O = 8;
  else throw Error(invalidArgument + E);
  for (z = E.search(/p/i), z > 0 ? (q = +E.slice(z + 1), E = E.substring(2, z)) : E = E.slice(2), z = E.indexOf("."), R = z >= 0, F = D.constructor, R && (E = E.replace(".", ""), L = E.length, z = L - z, I = intPow(F, new F(O), z, z * 2)), U = convertBase(E, O, BASE), Z = U.length - 1, z = Z; U[z] === 0; --z) U.pop();
  return z < 0 ? new F(D.s * 0) : (D.e = getBase10Exponent(U, Z), D.d = U, external = !1, R && (D = divide$1(D, I, L * 4)), q && (D = D.times(Math.abs(q) < 54 ? mathpow(2, q) : Decimal.pow(2, q))), external = !0, D);
}
function sine(D, E) {
  var O, F = E.d.length;
  if (F < 3) return E.isZero() ? E : taylorSeries(D, 2, E, E);
  O = 1.4 * Math.sqrt(F), O = O > 16 ? 16 : O | 0, E = E.times(1 / tinyPow(5, O)), E = taylorSeries(D, 2, E, E);
  for (var I, z = new D(5), R = new D(16), L = new D(20); O--; ) I = E.times(E), E = E.times(z.plus(I.times(R.times(I).minus(L))));
  return E;
}
function taylorSeries(D, E, O, F, I) {
  var z, R, L, q, U = D.precision, Z = Math.ceil(U / LOG_BASE);
  for (external = !1, q = O.times(O), L = new D(F); ; ) {
    if (R = divide$1(L.times(q), new D(E++ * E++), U, 1), L = I ? F.plus(R) : F.minus(R), F = divide$1(R.times(q), new D(E++ * E++), U, 1), R = L.plus(F), R.d[Z] !== void 0) {
      for (z = Z; R.d[z] === L.d[z] && z--; ) ;
      if (z == -1) break;
    }
    z = L, L = F, F = R, R = z;
  }
  return external = !0, R.d.length = Z + 1, R;
}
function tinyPow(D, E) {
  for (var O = D; --E; ) O *= D;
  return O;
}
function toLessThanHalfPi(D, E) {
  var O, F = E.s < 0, I = getPi(D, D.precision, 1), z = I.times(0.5);
  if (E = E.abs(), E.lte(z)) return quadrant = F ? 4 : 1, E;
  if (O = E.divToInt(I), O.isZero()) quadrant = F ? 3 : 2;
  else {
    if (E = E.minus(O.times(I)), E.lte(z)) return quadrant = isOdd(O) ? F ? 2 : 3 : F ? 4 : 1, E;
    quadrant = isOdd(O) ? F ? 1 : 4 : F ? 3 : 2;
  }
  return E.minus(I).abs();
}
function toStringBinary(D, E, O, F) {
  var I, z, R, L, q, U, Z, V, G, W = D.constructor, J = O !== void 0;
  if (J ? (checkInt32(O, 1, MAX_DIGITS), F === void 0 ? F = W.rounding : checkInt32(F, 0, 8)) : (O = W.precision, F = W.rounding), !D.isFinite()) Z = nonFiniteToString(D);
  else {
    for (Z = finiteToString(D), R = Z.indexOf("."), J ? (I = 2, E == 16 ? O = O * 4 - 3 : E == 8 && (O = O * 3 - 2)) : I = E, R >= 0 && (Z = Z.replace(".", ""), G = new W(1), G.e = Z.length - R, G.d = convertBase(finiteToString(G), 10, I), G.e = G.d.length), V = convertBase(Z, 10, I), z = q = V.length; V[--q] == 0; ) V.pop();
    if (!V[0]) Z = J ? "0p+0" : "0";
    else {
      if (R < 0 ? z-- : (D = new W(D), D.d = V, D.e = z, D = divide$1(D, G, O, F, 0, I), V = D.d, z = D.e, U = inexact), R = V[O], L = I / 2, U ||= V[O + 1] !== void 0, U = F < 4 ? (R !== void 0 || U) && (F === 0 || F === (D.s < 0 ? 3 : 2)) : R > L || R === L && (F === 4 || U || F === 6 && V[O - 1] & 1 || F === (D.s < 0 ? 8 : 7)), V.length = O, U) for (; ++V[--O] > I - 1; ) V[O] = 0, O || (++z, V.unshift(1));
      for (q = V.length; !V[q - 1]; --q) ;
      for (R = 0, Z = ""; R < q; R++) Z += NUMERALS.charAt(V[R]);
      if (J) {
        if (q > 1) if (E == 16 || E == 8) {
          for (R = E == 16 ? 4 : 3, --q; q % R; q++) Z += "0";
          for (V = convertBase(Z, I, E), q = V.length; !V[q - 1]; --q) ;
          for (R = 1, Z = "1."; R < q; R++) Z += NUMERALS.charAt(V[R]);
        } else Z = Z.charAt(0) + "." + Z.slice(1);
        Z = Z + (z < 0 ? "p" : "p+") + z;
      } else if (z < 0) {
        for (; ++z; ) Z = "0" + Z;
        Z = "0." + Z;
      } else if (++z > q) for (z -= q; z--; ) Z += "0";
      else z < q && (Z = Z.slice(0, z) + "." + Z.slice(z));
    }
    Z = (E == 16 ? "0x" : E == 2 ? "0b" : E == 8 ? "0o" : "") + Z;
  }
  return D.s < 0 ? "-" + Z : Z;
}
function truncate(D, E) {
  if (D.length > E) return D.length = E, !0;
}
function abs$1(D) {
  return new this(D).abs();
}
function acos$1(D) {
  return new this(D).acos();
}
function acosh$1(D) {
  return new this(D).acosh();
}
function add$1(D, E) {
  return new this(D).plus(E);
}
function asin$1(D) {
  return new this(D).asin();
}
function asinh$1(D) {
  return new this(D).asinh();
}
function atan$1(D) {
  return new this(D).atan();
}
function atanh$1(D) {
  return new this(D).atanh();
}
function atan2$1(D, E) {
  D = new this(D), E = new this(E);
  var O, F = this.precision, I = this.rounding, z = F + 4;
  return !D.s || !E.s ? O = new this(NaN) : !D.d && !E.d ? (O = getPi(this, z, 1).times(E.s > 0 ? 0.25 : 0.75), O.s = D.s) : !E.d || D.isZero() ? (O = E.s < 0 ? getPi(this, F, I) : new this(0), O.s = D.s) : !D.d || E.isZero() ? (O = getPi(this, z, 1).times(0.5), O.s = D.s) : E.s < 0 ? (this.precision = z, this.rounding = 1, O = this.atan(divide$1(D, E, z, 1)), E = getPi(this, z, 1), this.precision = F, this.rounding = I, O = D.s < 0 ? O.minus(E) : O.plus(E)) : O = this.atan(divide$1(D, E, z, 1)), O;
}
function cbrt(D) {
  return new this(D).cbrt();
}
function ceil(D) {
  return finalise(D = new this(D), D.e + 1, 2);
}
function clamp(D, E, O) {
  return new this(D).clamp(E, O);
}
function config(D) {
  if (!D || typeof D != "object") throw Error(decimalError + "Object expected");
  var E, O, F, I = D.defaults === !0, z = ["precision", 1, MAX_DIGITS, "rounding", 0, 8, "toExpNeg", -EXP_LIMIT, 0, "toExpPos", 0, EXP_LIMIT, "maxE", 0, EXP_LIMIT, "minE", -EXP_LIMIT, 0, "modulo", 0, 9];
  for (E = 0; E < z.length; E += 3) if (O = z[E], I && (this[O] = DEFAULTS[O]), (F = D[O]) !== void 0) if (mathfloor(F) === F && F >= z[E + 1] && F <= z[E + 2]) this[O] = F;
  else throw Error(invalidArgument + O + ": " + F);
  if (O = "crypto", I && (this[O] = DEFAULTS[O]), (F = D[O]) !== void 0) if (F === !0 || F === !1 || F === 0 || F === 1) if (F) if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes)) this[O] = !0;
  else throw Error(cryptoUnavailable);
  else this[O] = !1;
  else throw Error(invalidArgument + O + ": " + F);
  return this;
}
function cos$1(D) {
  return new this(D).cos();
}
function cosh$2(D) {
  return new this(D).cosh();
}
function clone$2(D) {
  var E, O, F;
  function I(z) {
    var R, L, q, U = this;
    if (!(U instanceof I)) return new I(z);
    if (U.constructor = I, isDecimalInstance(z)) {
      U.s = z.s, external ? !z.d || z.e > I.maxE ? (U.e = NaN, U.d = null) : z.e < I.minE ? (U.e = 0, U.d = [0]) : (U.e = z.e, U.d = z.d.slice()) : (U.e = z.e, U.d = z.d ? z.d.slice() : z.d);
      return;
    }
    if (q = typeof z, q === "number") {
      if (z === 0) {
        U.s = 1 / z < 0 ? -1 : 1, U.e = 0, U.d = [0];
        return;
      }
      if (z < 0 ? (z = -z, U.s = -1) : U.s = 1, z === ~~z && z < 1e7) {
        for (R = 0, L = z; L >= 10; L /= 10) R++;
        external ? R > I.maxE ? (U.e = NaN, U.d = null) : R < I.minE ? (U.e = 0, U.d = [0]) : (U.e = R, U.d = [z]) : (U.e = R, U.d = [z]);
        return;
      } else if (z * 0 != 0) {
        z || (U.s = NaN), U.e = NaN, U.d = null;
        return;
      }
      return parseDecimal(U, z.toString());
    } else if (q !== "string") throw Error(invalidArgument + z);
    return (L = z.charCodeAt(0)) === 45 ? (z = z.slice(1), U.s = -1) : (L === 43 && (z = z.slice(1)), U.s = 1), isDecimal.test(z) ? parseDecimal(U, z) : parseOther(U, z);
  }
  if (I.prototype = P$3, I.ROUND_UP = 0, I.ROUND_DOWN = 1, I.ROUND_CEIL = 2, I.ROUND_FLOOR = 3, I.ROUND_HALF_UP = 4, I.ROUND_HALF_DOWN = 5, I.ROUND_HALF_EVEN = 6, I.ROUND_HALF_CEIL = 7, I.ROUND_HALF_FLOOR = 8, I.EUCLID = 9, I.config = I.set = config, I.clone = clone$2, I.isDecimal = isDecimalInstance, I.abs = abs$1, I.acos = acos$1, I.acosh = acosh$1, I.add = add$1, I.asin = asin$1, I.asinh = asinh$1, I.atan = atan$1, I.atanh = atanh$1, I.atan2 = atan2$1, I.cbrt = cbrt, I.ceil = ceil, I.clamp = clamp, I.cos = cos$1, I.cosh = cosh$2, I.div = div, I.exp = exp$1, I.floor = floor, I.hypot = hypot$1, I.ln = ln, I.log = log$1, I.log10 = log10$1, I.log2 = log2, I.max = max$1, I.min = min$1, I.mod = mod$1, I.mul = mul, I.pow = pow$1, I.random = random$1, I.round = round, I.sign = sign$1, I.sin = sin$1, I.sinh = sinh$2, I.sqrt = sqrt$1, I.sub = sub, I.sum = sum, I.tan = tan$1, I.tanh = tanh$1, I.trunc = trunc$1, D === void 0 && (D = {}), D && D.defaults !== !0) for (F = ["precision", "rounding", "toExpNeg", "toExpPos", "maxE", "minE", "modulo", "crypto"], E = 0; E < F.length; ) D.hasOwnProperty(O = F[E++]) || (D[O] = this[O]);
  return I.config(D), I;
}
function div(D, E) {
  return new this(D).div(E);
}
function exp$1(D) {
  return new this(D).exp();
}
function floor(D) {
  return finalise(D = new this(D), D.e + 1, 3);
}
function hypot$1() {
  var D, E, O = new this(0);
  for (external = !1, D = 0; D < arguments.length; ) if (E = new this(arguments[D++]), E.d) O.d && (O = O.plus(E.times(E)));
  else {
    if (E.s) return external = !0, new this(1 / 0);
    O = E;
  }
  return external = !0, O.sqrt();
}
function isDecimalInstance(D) {
  return D instanceof Decimal || D && D.toStringTag === tag || !1;
}
function ln(D) {
  return new this(D).ln();
}
function log$1(D, E) {
  return new this(D).log(E);
}
function log2(D) {
  return new this(D).log(2);
}
function log10$1(D) {
  return new this(D).log(10);
}
function max$1() {
  return maxOrMin(this, arguments, "lt");
}
function min$1() {
  return maxOrMin(this, arguments, "gt");
}
function mod$1(D, E) {
  return new this(D).mod(E);
}
function mul(D, E) {
  return new this(D).mul(E);
}
function pow$1(D, E) {
  return new this(D).pow(E);
}
function random$1(D) {
  var E, O, F, I, z = 0, R = new this(1), L = [];
  if (D === void 0 ? D = this.precision : checkInt32(D, 1, MAX_DIGITS), F = Math.ceil(D / LOG_BASE), !this.crypto) for (; z < F; ) L[z++] = Math.random() * 1e7 | 0;
  else if (crypto.getRandomValues) for (E = crypto.getRandomValues(new Uint32Array(F)); z < F; ) I = E[z], I >= 429e7 ? E[z] = crypto.getRandomValues(new Uint32Array(1))[0] : L[z++] = I % 1e7;
  else if (crypto.randomBytes) {
    for (E = crypto.randomBytes(F *= 4); z < F; ) I = E[z] + (E[z + 1] << 8) + (E[z + 2] << 16) + ((E[z + 3] & 127) << 24), I >= 214e7 ? crypto.randomBytes(4).copy(E, z) : (L.push(I % 1e7), z += 4);
    z = F / 4;
  } else throw Error(cryptoUnavailable);
  for (F = L[--z], D %= LOG_BASE, F && D && (I = mathpow(10, LOG_BASE - D), L[z] = (F / I | 0) * I); L[z] === 0; z--) L.pop();
  if (z < 0) O = 0, L = [0];
  else {
    for (O = -1; L[0] === 0; O -= LOG_BASE) L.shift();
    for (F = 1, I = L[0]; I >= 10; I /= 10) F++;
    F < LOG_BASE && (O -= LOG_BASE - F);
  }
  return R.e = O, R.d = L, R;
}
function round(D) {
  return finalise(D = new this(D), D.e + 1, this.rounding);
}
function sign$1(D) {
  return D = new this(D), D.d ? D.d[0] ? D.s : 0 * D.s : D.s || NaN;
}
function sin$1(D) {
  return new this(D).sin();
}
function sinh$2(D) {
  return new this(D).sinh();
}
function sqrt$1(D) {
  return new this(D).sqrt();
}
function sub(D, E) {
  return new this(D).sub(E);
}
function sum() {
  var D = 0, E = arguments, O = new this(E[D]);
  for (external = !1; O.s && ++D < E.length; ) O = O.plus(E[D]);
  return external = !0, finalise(O, this.precision, this.rounding);
}
function tan$1(D) {
  return new this(D).tan();
}
function tanh$1(D) {
  return new this(D).tanh();
}
function trunc$1(D) {
  return finalise(D = new this(D), D.e + 1, 1);
}
P$3[/* @__PURE__ */ Symbol.for("nodejs.util.inspect.custom")] = P$3.toString, P$3[Symbol.toStringTag] = "Decimal";
var Decimal = P$3.constructor = clone$2(DEFAULTS);
LN10 = new Decimal(LN10), PI = new Decimal(PI);
var name$320 = "BigNumber", dependencies$320 = ["?on", "config"], createBigNumberClass = factory(name$320, dependencies$320, (D) => {
  var { on: E, config: O } = D, F = Decimal.clone({ precision: O.precision, modulo: Decimal.EUCLID });
  return F.prototype = Object.create(F.prototype), F.prototype.type = "BigNumber", F.prototype.isBigNumber = !0, F.prototype.toJSON = function() {
    return { mathjs: "BigNumber", value: this.toString() };
  }, F.fromJSON = function(I) {
    return new F(I.value);
  }, E && E("config", function(I, z) {
    I.precision !== z.precision && F.config({ precision: I.precision });
  }), F;
}, { isClass: !0 }), cosh$1 = Math.cosh || function(D) {
  return Math.abs(D) < 1e-9 ? 1 - D : (Math.exp(D) + Math.exp(-D)) * 0.5;
}, sinh$1 = Math.sinh || function(D) {
  return Math.abs(D) < 1e-9 ? D : (Math.exp(D) - Math.exp(-D)) * 0.5;
}, cosm1 = function(D) {
  let E = Math.PI / 4;
  if (-E > D || D > E) return Math.cos(D) - 1;
  let O = D * D;
  return O * (O * (O * (O * (O * (O * (O * (O / 20922789888e3 - 1 / 87178291200) + 1 / 479001600) - 1 / 3628800) + 1 / 40320) - 1 / 720) + 1 / 24) - 1 / 2);
}, hypot = function(D, E) {
  return D = Math.abs(D), E = Math.abs(E), D < E && ([D, E] = [E, D]), D < 1e8 ? Math.sqrt(D * D + E * E) : (E /= D, D * Math.sqrt(1 + E * E));
}, parser_exit = function() {
  throw SyntaxError("Invalid Param");
};
function logHypot(D, E) {
  let O = Math.abs(D), F = Math.abs(E);
  return D === 0 ? Math.log(F) : E === 0 ? Math.log(O) : O < 3e3 && F < 3e3 ? Math.log(D * D + E * E) * 0.5 : (D *= 0.5, E *= 0.5, 0.5 * Math.log(D * D + E * E) + Math.LN2);
}
var P$2 = { re: 0, im: 0 }, parse$1 = function(D, E) {
  let O = P$2;
  if (D == null) O.re = O.im = 0;
  else if (E !== void 0) O.re = D, O.im = E;
  else switch (typeof D) {
    case "object":
      if ("im" in D && "re" in D) O.re = D.re, O.im = D.im;
      else if ("abs" in D && "arg" in D) {
        if (!isFinite(D.abs) && isFinite(D.arg)) return Complex.INFINITY;
        O.re = D.abs * Math.cos(D.arg), O.im = D.abs * Math.sin(D.arg);
      } else if ("r" in D && "phi" in D) {
        if (!isFinite(D.r) && isFinite(D.phi)) return Complex.INFINITY;
        O.re = D.r * Math.cos(D.phi), O.im = D.r * Math.sin(D.phi);
      } else D.length === 2 ? (O.re = D[0], O.im = D[1]) : parser_exit();
      break;
    case "string":
      O.im = O.re = 0;
      let F = D.replace(/_/g, "").match(/\d+\.?\d*e[+-]?\d+|\d+\.?\d*|\.\d+|./g), I = 1, z = 0;
      F === null && parser_exit();
      for (let R = 0; R < F.length; R++) {
        let L = F[R];
        L === " " || L === "	" || L === `
` || (L === "+" ? I++ : L === "-" ? z++ : L === "i" || L === "I" ? (I + z === 0 && parser_exit(), F[R + 1] !== " " && !isNaN(F[R + 1]) ? (O.im += parseFloat((z % 2 ? "-" : "") + F[R + 1]), R++) : O.im += parseFloat((z % 2 ? "-" : "") + "1"), I = z = 0) : ((I + z === 0 || isNaN(L)) && parser_exit(), F[R + 1] === "i" || F[R + 1] === "I" ? (O.im += parseFloat((z % 2 ? "-" : "") + L), R++) : O.re += parseFloat((z % 2 ? "-" : "") + L), I = z = 0));
      }
      I + z > 0 && parser_exit();
      break;
    case "number":
      O.im = 0, O.re = D;
      break;
    default:
      parser_exit();
  }
  return isNaN(O.re) || isNaN(O.im), O;
};
function Complex(D, E) {
  if (!(this instanceof Complex)) return new Complex(D, E);
  let O = parse$1(D, E);
  this.re = O.re, this.im = O.im;
}
Complex.prototype = { re: 0, im: 0, sign: function() {
  let D = hypot(this.re, this.im);
  return new Complex(this.re / D, this.im / D);
}, add: function(D, E) {
  let O = parse$1(D, E), F = this.isInfinite(), I = !(isFinite(O.re) && isFinite(O.im));
  return F || I ? F && I ? Complex.NAN : Complex.INFINITY : new Complex(this.re + O.re, this.im + O.im);
}, sub: function(D, E) {
  let O = parse$1(D, E), F = this.isInfinite(), I = !(isFinite(O.re) && isFinite(O.im));
  return F || I ? F && I ? Complex.NAN : Complex.INFINITY : new Complex(this.re - O.re, this.im - O.im);
}, mul: function(D, E) {
  let O = parse$1(D, E), F = this.isInfinite(), I = !(isFinite(O.re) && isFinite(O.im)), z = this.re === 0 && this.im === 0, R = O.re === 0 && O.im === 0;
  return F && R || I && z ? Complex.NAN : F || I ? Complex.INFINITY : O.im === 0 && this.im === 0 ? new Complex(this.re * O.re, 0) : new Complex(this.re * O.re - this.im * O.im, this.re * O.im + this.im * O.re);
}, div: function(D, E) {
  let O = parse$1(D, E), F = this.isInfinite(), I = !(isFinite(O.re) && isFinite(O.im)), z = this.re === 0 && this.im === 0, R = O.re === 0 && O.im === 0;
  if (z && R || F && I) return Complex.NAN;
  if (R || F) return Complex.INFINITY;
  if (z || I) return Complex.ZERO;
  if (O.im === 0) return new Complex(this.re / O.re, this.im / O.re);
  if (Math.abs(O.re) < Math.abs(O.im)) {
    let L = O.re / O.im, q = O.re * L + O.im;
    return new Complex((this.re * L + this.im) / q, (this.im * L - this.re) / q);
  } else {
    let L = O.im / O.re, q = O.im * L + O.re;
    return new Complex((this.re + this.im * L) / q, (this.im - this.re * L) / q);
  }
}, pow: function(D, E) {
  let O = parse$1(D, E), F = this.re === 0 && this.im === 0;
  if (O.re === 0 && O.im === 0) return Complex.ONE;
  if (O.im === 0) {
    if (this.im === 0 && this.re > 0) return new Complex(this.re ** +O.re, 0);
    if (this.re === 0) switch ((O.re % 4 + 4) % 4) {
      case 0:
        return new Complex(this.im ** +O.re, 0);
      case 1:
        return new Complex(0, this.im ** +O.re);
      case 2:
        return new Complex(-(this.im ** +O.re), 0);
      case 3:
        return new Complex(0, -(this.im ** +O.re));
    }
  }
  if (F && O.re > 0) return Complex.ZERO;
  let I = Math.atan2(this.im, this.re), z = logHypot(this.re, this.im), R = Math.exp(O.re * z - O.im * I), L = O.im * z + O.re * I;
  return new Complex(R * Math.cos(L), R * Math.sin(L));
}, sqrt: function() {
  let D = this.re, E = this.im;
  if (E === 0) return D >= 0 ? new Complex(Math.sqrt(D), 0) : new Complex(0, Math.sqrt(-D));
  let O = hypot(D, E), F = Math.sqrt(0.5 * (O + Math.abs(D))), I = Math.abs(E) / (2 * F);
  return D >= 0 ? new Complex(F, E < 0 ? -I : I) : new Complex(I, E < 0 ? -F : F);
}, exp: function() {
  let D = Math.exp(this.re);
  return this.im === 0 ? new Complex(D, 0) : new Complex(D * Math.cos(this.im), D * Math.sin(this.im));
}, expm1: function() {
  let D = this.re, E = this.im;
  return new Complex(Math.expm1(D) * Math.cos(E) + cosm1(E), Math.exp(D) * Math.sin(E));
}, log: function() {
  let D = this.re, E = this.im;
  return E === 0 && D > 0 ? new Complex(Math.log(D), 0) : new Complex(logHypot(D, E), Math.atan2(E, D));
}, abs: function() {
  return hypot(this.re, this.im);
}, arg: function() {
  return Math.atan2(this.im, this.re);
}, sin: function() {
  let D = this.re, E = this.im;
  return new Complex(Math.sin(D) * cosh$1(E), Math.cos(D) * sinh$1(E));
}, cos: function() {
  let D = this.re, E = this.im;
  return new Complex(Math.cos(D) * cosh$1(E), -Math.sin(D) * sinh$1(E));
}, tan: function() {
  let D = 2 * this.re, E = 2 * this.im, O = Math.cos(D) + cosh$1(E);
  return new Complex(Math.sin(D) / O, sinh$1(E) / O);
}, cot: function() {
  let D = 2 * this.re, E = 2 * this.im, O = Math.cos(D) - cosh$1(E);
  return new Complex(-Math.sin(D) / O, sinh$1(E) / O);
}, sec: function() {
  let D = this.re, E = this.im, O = 0.5 * cosh$1(2 * E) + 0.5 * Math.cos(2 * D);
  return new Complex(Math.cos(D) * cosh$1(E) / O, Math.sin(D) * sinh$1(E) / O);
}, csc: function() {
  let D = this.re, E = this.im, O = 0.5 * cosh$1(2 * E) - 0.5 * Math.cos(2 * D);
  return new Complex(Math.sin(D) * cosh$1(E) / O, -Math.cos(D) * sinh$1(E) / O);
}, asin: function() {
  let D = this.re, E = this.im, O = new Complex(E * E - D * D + 1, -2 * D * E).sqrt(), F = new Complex(O.re - E, O.im + D).log();
  return new Complex(F.im, -F.re);
}, acos: function() {
  let D = this.re, E = this.im, O = new Complex(E * E - D * D + 1, -2 * D * E).sqrt(), F = new Complex(O.re - E, O.im + D).log();
  return new Complex(Math.PI / 2 - F.im, F.re);
}, atan: function() {
  let D = this.re, E = this.im;
  if (D === 0) {
    if (E === 1) return new Complex(0, 1 / 0);
    if (E === -1) return new Complex(0, -1 / 0);
  }
  let O = D * D + (1 - E) * (1 - E), F = new Complex((1 - E * E - D * D) / O, -2 * D / O).log();
  return new Complex(-0.5 * F.im, 0.5 * F.re);
}, acot: function() {
  let D = this.re, E = this.im;
  if (E === 0) return new Complex(Math.atan2(1, D), 0);
  let O = D * D + E * E;
  return O === 0 ? new Complex(D === 0 ? 0 : D / 0, E === 0 ? 0 : -E / 0).atan() : new Complex(D / O, -E / O).atan();
}, asec: function() {
  let D = this.re, E = this.im;
  if (D === 0 && E === 0) return new Complex(0, 1 / 0);
  let O = D * D + E * E;
  return O === 0 ? new Complex(D === 0 ? 0 : D / 0, E === 0 ? 0 : -E / 0).acos() : new Complex(D / O, -E / O).acos();
}, acsc: function() {
  let D = this.re, E = this.im;
  if (D === 0 && E === 0) return new Complex(Math.PI / 2, 1 / 0);
  let O = D * D + E * E;
  return O === 0 ? new Complex(D === 0 ? 0 : D / 0, E === 0 ? 0 : -E / 0).asin() : new Complex(D / O, -E / O).asin();
}, sinh: function() {
  let D = this.re, E = this.im;
  return new Complex(sinh$1(D) * Math.cos(E), cosh$1(D) * Math.sin(E));
}, cosh: function() {
  let D = this.re, E = this.im;
  return new Complex(cosh$1(D) * Math.cos(E), sinh$1(D) * Math.sin(E));
}, tanh: function() {
  let D = 2 * this.re, E = 2 * this.im, O = cosh$1(D) + Math.cos(E);
  return new Complex(sinh$1(D) / O, Math.sin(E) / O);
}, coth: function() {
  let D = 2 * this.re, E = 2 * this.im, O = cosh$1(D) - Math.cos(E);
  return new Complex(sinh$1(D) / O, -Math.sin(E) / O);
}, csch: function() {
  let D = this.re, E = this.im, O = Math.cos(2 * E) - cosh$1(2 * D);
  return new Complex(-2 * sinh$1(D) * Math.cos(E) / O, 2 * cosh$1(D) * Math.sin(E) / O);
}, sech: function() {
  let D = this.re, E = this.im, O = Math.cos(2 * E) + cosh$1(2 * D);
  return new Complex(2 * cosh$1(D) * Math.cos(E) / O, -2 * sinh$1(D) * Math.sin(E) / O);
}, asinh: function() {
  let D = this.im;
  this.im = -this.re, this.re = D;
  let E = this.asin();
  return this.re = -this.im, this.im = D, D = E.re, E.re = -E.im, E.im = D, E;
}, acosh: function() {
  let D = this.acos();
  if (D.im <= 0) {
    let E = D.re;
    D.re = -D.im, D.im = E;
  } else {
    let E = D.im;
    D.im = -D.re, D.re = E;
  }
  return D;
}, atanh: function() {
  let D = this.re, E = this.im, O = D > 1 && E === 0, F = 1 - D, I = 1 + D, z = F * F + E * E, R = z === 0 ? new Complex(D === -1 ? 0 : D / 0, E === 0 ? 0 : E / 0) : new Complex((I * F - E * E) / z, (E * F + I * E) / z), L = R.re;
  return R.re = logHypot(R.re, R.im) / 2, R.im = Math.atan2(R.im, L) / 2, O && (R.im = -R.im), R;
}, acoth: function() {
  let D = this.re, E = this.im;
  if (D === 0 && E === 0) return new Complex(0, Math.PI / 2);
  let O = D * D + E * E;
  return O === 0 ? new Complex(D === 0 ? 0 : D / 0, E === 0 ? 0 : -E / 0).atanh() : new Complex(D / O, -E / O).atanh();
}, acsch: function() {
  let D = this.re, E = this.im;
  if (E === 0) return new Complex(D === 0 ? 1 / 0 : Math.log(D + Math.sqrt(D * D + 1)), 0);
  let O = D * D + E * E;
  return O === 0 ? new Complex(D === 0 ? 0 : D / 0, E === 0 ? 0 : -E / 0).asinh() : new Complex(D / O, -E / O).asinh();
}, asech: function() {
  let D = this.re, E = this.im;
  if (this.isZero()) return Complex.INFINITY;
  let O = D * D + E * E;
  return O === 0 ? new Complex(D === 0 ? 0 : D / 0, E === 0 ? 0 : -E / 0).acosh() : new Complex(D / O, -E / O).acosh();
}, inverse: function() {
  if (this.isZero()) return Complex.INFINITY;
  if (this.isInfinite()) return Complex.ZERO;
  let D = this.re, E = this.im, O = D * D + E * E;
  return new Complex(D / O, -E / O);
}, conjugate: function() {
  return new Complex(this.re, -this.im);
}, neg: function() {
  return new Complex(-this.re, -this.im);
}, ceil: function(D) {
  return D = 10 ** (D || 0), new Complex(Math.ceil(this.re * D) / D, Math.ceil(this.im * D) / D);
}, floor: function(D) {
  return D = 10 ** (D || 0), new Complex(Math.floor(this.re * D) / D, Math.floor(this.im * D) / D);
}, round: function(D) {
  return D = 10 ** (D || 0), new Complex(Math.round(this.re * D) / D, Math.round(this.im * D) / D);
}, equals: function(D, E) {
  let O = parse$1(D, E);
  return Math.abs(O.re - this.re) <= Complex.EPSILON && Math.abs(O.im - this.im) <= Complex.EPSILON;
}, clone: function() {
  return new Complex(this.re, this.im);
}, toString: function() {
  let D = this.re, E = this.im, O = "";
  return this.isNaN() ? "NaN" : this.isInfinite() ? "Infinity" : (Math.abs(D) < Complex.EPSILON && (D = 0), Math.abs(E) < Complex.EPSILON && (E = 0), E === 0 ? O + D : (D === 0 ? E < 0 && (E = -E, O += "-") : (O += D, O += " ", E < 0 ? (E = -E, O += "-") : O += "+", O += " "), E !== 1 && (O += E), O + "i"));
}, toVector: function() {
  return [this.re, this.im];
}, valueOf: function() {
  return this.im === 0 ? this.re : null;
}, isNaN: function() {
  return isNaN(this.re) || isNaN(this.im);
}, isZero: function() {
  return this.im === 0 && this.re === 0;
}, isFinite: function() {
  return isFinite(this.re) && isFinite(this.im);
}, isInfinite: function() {
  return !this.isFinite();
} }, Complex.ZERO = new Complex(0, 0), Complex.ONE = new Complex(1, 0), Complex.I = new Complex(0, 1), Complex.PI = new Complex(Math.PI, 0), Complex.E = new Complex(Math.E, 0), Complex.INFINITY = new Complex(1 / 0, 1 / 0), Complex.NAN = new Complex(NaN, NaN), Complex.EPSILON = 1e-15;
var name$319 = "Complex", dependencies$319 = [], createComplexClass = factory(name$319, dependencies$319, () => (Object.defineProperty(Complex, "name", { value: "Complex" }), Complex.prototype.constructor = Complex, Complex.prototype.type = "Complex", Complex.prototype.isComplex = !0, Complex.prototype.toJSON = function() {
  return { mathjs: "Complex", re: this.re, im: this.im };
}, Complex.prototype.toPolar = function() {
  return { r: this.abs(), phi: this.arg() };
}, Complex.prototype.format = function(D) {
  var E = "", O = this.im, F = this.re, I = format$2(this.re, D), z = format$2(this.im, D), R = isNumber(D) ? D : D ? D.precision : null;
  if (R !== null) {
    var L = 10 ** -R;
    Math.abs(F / O) < L && (F = 0), Math.abs(O / F) < L && (O = 0);
  }
  return E = O === 0 ? I : F === 0 ? O === 1 ? "i" : O === -1 ? "-i" : z + "i" : O < 0 ? O === -1 ? I + " - i" : I + " - " + z.substring(1) + "i" : O === 1 ? I + " + i" : I + " + " + z + "i", E;
}, Complex.fromPolar = function(D) {
  switch (arguments.length) {
    case 1:
      var E = arguments[0];
      if (typeof E == "object") return Complex(E);
      throw TypeError("Input has to be an object with r and phi keys.");
    case 2:
      var O = arguments[0], F = arguments[1];
      if (isNumber(O)) {
        if (isUnit(F) && F.hasBase("ANGLE") && (F = F.toNumber("rad")), isNumber(F)) return new Complex({ r: O, phi: F });
        throw TypeError("Phi is not a number nor an angle unit.");
      } else throw TypeError("Radius r is not a number.");
    default:
      throw SyntaxError("Wrong number of arguments in function fromPolar");
  }
}, Complex.prototype.valueOf = Complex.prototype.toString, Complex.fromJSON = function(D) {
  return new Complex(D);
}, Complex.compare = function(D, E) {
  return D.re > E.re ? 1 : D.re < E.re ? -1 : D.im > E.im ? 1 : D.im < E.im ? -1 : 0;
}, Complex), { isClass: !0 });
typeof BigInt > "u" && (BigInt = function(D) {
  if (isNaN(D)) throw Error("");
  return D;
});
var C_ZERO = BigInt(0), C_ONE = BigInt(1), C_TWO = BigInt(2), C_FIVE = BigInt(5), C_TEN = BigInt(10), MAX_CYCLE_LEN = 2e3, P$1 = { s: C_ONE, n: C_ZERO, d: C_ONE };
function assign(D, E) {
  try {
    D = BigInt(D);
  } catch {
    throw InvalidParameter();
  }
  return D * E;
}
function trunc(D) {
  return typeof D == "bigint" ? D : Math.floor(D);
}
function newFraction(D, E) {
  if (E === C_ZERO) throw DivisionByZero();
  let O = Object.create(Fraction.prototype);
  O.s = D < C_ZERO ? -C_ONE : C_ONE, D = D < C_ZERO ? -D : D;
  let F = gcd$1(D, E);
  return O.n = D / F, O.d = E / F, O;
}
function factorize(D) {
  let E = {}, O = D, F = C_TWO, I = C_FIVE - C_ONE;
  for (; I <= O; ) {
    for (; O % F === C_ZERO; ) O /= F, E[F] = (E[F] || C_ZERO) + C_ONE;
    I += C_ONE + C_TWO * F++;
  }
  return O === D ? E[D] = (E[D] || C_ZERO) + C_ONE : O > 1 && (E[O] = (E[O] || C_ZERO) + C_ONE), E;
}
var parse = function(D, E) {
  let O = C_ZERO, F = C_ONE, I = C_ONE;
  if (D != null) if (E !== void 0) {
    if (typeof D == "bigint") O = D;
    else {
      if (isNaN(D)) throw InvalidParameter();
      if (D % 1 != 0) throw NonIntegerParameter();
      O = BigInt(D);
    }
    if (typeof E == "bigint") F = E;
    else {
      if (isNaN(E)) throw InvalidParameter();
      if (E % 1 != 0) throw NonIntegerParameter();
      F = BigInt(E);
    }
    I = O * F;
  } else if (typeof D == "object") {
    if ("d" in D && "n" in D) O = BigInt(D.n), F = BigInt(D.d), "s" in D && (O *= BigInt(D.s));
    else if (0 in D) O = BigInt(D[0]), 1 in D && (F = BigInt(D[1]));
    else if (typeof D == "bigint") O = D;
    else throw InvalidParameter();
    I = O * F;
  } else if (typeof D == "number") {
    if (isNaN(D)) throw InvalidParameter();
    if (D < 0 && (I = -C_ONE, D = -D), D % 1 == 0) O = BigInt(D);
    else {
      let z = 1, R = 0, L = 1, q = 1, U = 1, Z = 1e7;
      for (D >= 1 && (z = 10 ** Math.floor(1 + Math.log10(D)), D /= z); L <= Z && U <= Z; ) {
        let V = (R + q) / (L + U);
        if (D === V) {
          L + U <= Z ? (O = R + q, F = L + U) : U > L ? (O = q, F = U) : (O = R, F = L);
          break;
        } else D > V ? (R += q, L += U) : (q += R, U += L), L > Z ? (O = q, F = U) : (O = R, F = L);
      }
      O = BigInt(O) * BigInt(z), F = BigInt(F);
    }
  } else if (typeof D == "string") {
    let z = 0, R = C_ZERO, L = C_ZERO, q = C_ZERO, U = C_ONE, Z = C_ONE, V = D.replace(/_/g, "").match(/\d+|./g);
    if (V === null) throw InvalidParameter();
    if (V[z] === "-" ? (I = -C_ONE, z++) : V[z] === "+" && z++, V.length === z + 1 ? L = assign(V[z++], I) : V[z + 1] === "." || V[z] === "." ? (V[z] !== "." && (R = assign(V[z++], I)), z++, (z + 1 === V.length || V[z + 1] === "(" && V[z + 3] === ")" || V[z + 1] === "'" && V[z + 3] === "'") && (L = assign(V[z], I), U = C_TEN ** BigInt(V[z].length), z++), (V[z] === "(" && V[z + 2] === ")" || V[z] === "'" && V[z + 2] === "'") && (q = assign(V[z + 1], I), Z = C_TEN ** BigInt(V[z + 1].length) - C_ONE, z += 3)) : V[z + 1] === "/" || V[z + 1] === ":" ? (L = assign(V[z], I), U = assign(V[z + 2], C_ONE), z += 3) : V[z + 3] === "/" && V[z + 1] === " " && (R = assign(V[z], I), L = assign(V[z + 2], I), U = assign(V[z + 4], C_ONE), z += 5), V.length <= z) F = U * Z, I = O = q + F * R + Z * L;
    else throw InvalidParameter();
  } else if (typeof D == "bigint") O = D, I = D, F = C_ONE;
  else throw InvalidParameter();
  if (F === C_ZERO) throw DivisionByZero();
  P$1.s = I < C_ZERO ? -C_ONE : C_ONE, P$1.n = O < C_ZERO ? -O : O, P$1.d = F < C_ZERO ? -F : F;
};
function modpow(D, E, O) {
  let F = C_ONE;
  for (; E > C_ZERO; D = D * D % O, E >>= C_ONE) E & C_ONE && (F = F * D % O);
  return F;
}
function cycleLen(D, E) {
  for (; E % C_TWO === C_ZERO; E /= C_TWO) ;
  for (; E % C_FIVE === C_ZERO; E /= C_FIVE) ;
  if (E === C_ONE) return C_ZERO;
  let O = C_TEN % E, F = 1;
  for (; O !== C_ONE; F++) if (O = O * C_TEN % E, F > MAX_CYCLE_LEN) return C_ZERO;
  return BigInt(F);
}
function cycleStart(D, E, O) {
  let F = C_ONE, I = modpow(C_TEN, O, E);
  for (let z = 0; z < 300; z++) {
    if (F === I) return BigInt(z);
    F = F * C_TEN % E, I = I * C_TEN % E;
  }
  return 0;
}
function gcd$1(D, E) {
  if (!D) return E;
  if (!E) return D;
  for (; ; ) {
    if (D %= E, !D) return E;
    if (E %= D, !E) return D;
  }
}
function Fraction(D, E) {
  if (parse(D, E), this instanceof Fraction) D = gcd$1(P$1.d, P$1.n), this.s = P$1.s, this.n = P$1.n / D, this.d = P$1.d / D;
  else return newFraction(P$1.s * P$1.n, P$1.d);
}
var DivisionByZero = function() {
  return Error("Division by Zero");
}, InvalidParameter = function() {
  return Error("Invalid argument");
}, NonIntegerParameter = function() {
  return Error("Parameters must be integer");
};
Fraction.prototype = { s: C_ONE, n: C_ZERO, d: C_ONE, abs: function() {
  return newFraction(this.n, this.d);
}, neg: function() {
  return newFraction(-this.s * this.n, this.d);
}, add: function(D, E) {
  return parse(D, E), newFraction(this.s * this.n * P$1.d + P$1.s * this.d * P$1.n, this.d * P$1.d);
}, sub: function(D, E) {
  return parse(D, E), newFraction(this.s * this.n * P$1.d - P$1.s * this.d * P$1.n, this.d * P$1.d);
}, mul: function(D, E) {
  return parse(D, E), newFraction(this.s * P$1.s * this.n * P$1.n, this.d * P$1.d);
}, div: function(D, E) {
  return parse(D, E), newFraction(this.s * P$1.s * this.n * P$1.d, this.d * P$1.n);
}, clone: function() {
  return newFraction(this.s * this.n, this.d);
}, mod: function(D, E) {
  if (D === void 0) return newFraction(this.s * this.n % this.d, C_ONE);
  if (parse(D, E), C_ZERO === P$1.n * this.d) throw DivisionByZero();
  return newFraction(this.s * (P$1.d * this.n) % (P$1.n * this.d), P$1.d * this.d);
}, gcd: function(D, E) {
  return parse(D, E), newFraction(gcd$1(P$1.n, this.n) * gcd$1(P$1.d, this.d), P$1.d * this.d);
}, lcm: function(D, E) {
  return parse(D, E), P$1.n === C_ZERO && this.n === C_ZERO ? newFraction(C_ZERO, C_ONE) : newFraction(P$1.n * this.n, gcd$1(P$1.n, this.n) * gcd$1(P$1.d, this.d));
}, inverse: function() {
  return newFraction(this.s * this.d, this.n);
}, pow: function(D, E) {
  if (parse(D, E), P$1.d === C_ONE) return P$1.s < C_ZERO ? newFraction((this.s * this.d) ** P$1.n, this.n ** P$1.n) : newFraction((this.s * this.n) ** P$1.n, this.d ** P$1.n);
  if (this.s < C_ZERO) return null;
  let O = factorize(this.n), F = factorize(this.d), I = C_ONE, z = C_ONE;
  for (let R in O) if (R !== "1") {
    if (R === "0") {
      I = C_ZERO;
      break;
    }
    if (O[R] *= P$1.n, O[R] % P$1.d === C_ZERO) O[R] /= P$1.d;
    else return null;
    I *= BigInt(R) ** O[R];
  }
  for (let R in F) if (R !== "1") {
    if (F[R] *= P$1.n, F[R] % P$1.d === C_ZERO) F[R] /= P$1.d;
    else return null;
    z *= BigInt(R) ** F[R];
  }
  return P$1.s < C_ZERO ? newFraction(z, I) : newFraction(I, z);
}, log: function(D, E) {
  if (parse(D, E), this.s <= C_ZERO || P$1.s <= C_ZERO) return null;
  let O = {}, F = factorize(P$1.n), I = factorize(P$1.d), z = factorize(this.n), R = factorize(this.d);
  for (let U in I) F[U] = (F[U] || C_ZERO) - I[U];
  for (let U in R) z[U] = (z[U] || C_ZERO) - R[U];
  for (let U in F) U !== "1" && (O[U] = !0);
  for (let U in z) U !== "1" && (O[U] = !0);
  let L = null, q = null;
  for (let U in O) {
    let Z = F[U] || C_ZERO, V = z[U] || C_ZERO;
    if (Z === C_ZERO) {
      if (V !== C_ZERO) return null;
      continue;
    }
    let G = V, W = Z, J = gcd$1(G, W);
    if (G /= J, W /= J, L === null && q === null) L = G, q = W;
    else if (G * q !== L * W) return null;
  }
  return L !== null && q !== null ? newFraction(L, q) : null;
}, equals: function(D, E) {
  return parse(D, E), this.s * this.n * P$1.d === P$1.s * P$1.n * this.d;
}, lt: function(D, E) {
  return parse(D, E), this.s * this.n * P$1.d < P$1.s * P$1.n * this.d;
}, lte: function(D, E) {
  return parse(D, E), this.s * this.n * P$1.d <= P$1.s * P$1.n * this.d;
}, gt: function(D, E) {
  return parse(D, E), this.s * this.n * P$1.d > P$1.s * P$1.n * this.d;
}, gte: function(D, E) {
  return parse(D, E), this.s * this.n * P$1.d >= P$1.s * P$1.n * this.d;
}, compare: function(D, E) {
  parse(D, E);
  let O = this.s * this.n * P$1.d - P$1.s * P$1.n * this.d;
  return (C_ZERO < O) - (O < C_ZERO);
}, ceil: function(D) {
  return D = C_TEN ** BigInt(D || 0), newFraction(trunc(this.s * D * this.n / this.d) + (D * this.n % this.d > C_ZERO && this.s >= C_ZERO ? C_ONE : C_ZERO), D);
}, floor: function(D) {
  return D = C_TEN ** BigInt(D || 0), newFraction(trunc(this.s * D * this.n / this.d) - (D * this.n % this.d > C_ZERO && this.s < C_ZERO ? C_ONE : C_ZERO), D);
}, round: function(D) {
  return D = C_TEN ** BigInt(D || 0), newFraction(trunc(this.s * D * this.n / this.d) + this.s * ((this.s >= C_ZERO ? C_ONE : C_ZERO) + C_TWO * (D * this.n % this.d) > this.d ? C_ONE : C_ZERO), D);
}, roundTo: function(D, E) {
  parse(D, E);
  let O = this.n * P$1.d, F = this.d * P$1.n, I = O % F, z = trunc(O / F);
  return I + I >= F && z++, newFraction(this.s * z * P$1.n, P$1.d);
}, divisible: function(D, E) {
  return parse(D, E), !(!(P$1.n * this.d) || this.n * P$1.d % (P$1.n * this.d));
}, valueOf: function() {
  return Number(this.s * this.n) / Number(this.d);
}, toString: function(D) {
  let E = this.n, O = this.d;
  D ||= 15;
  let F = cycleLen(E, O), I = cycleStart(E, O, F), z = this.s < C_ZERO ? "-" : "";
  if (z += trunc(E / O), E %= O, E *= C_TEN, E && (z += "."), F) {
    for (let R = I; R--; ) z += trunc(E / O), E %= O, E *= C_TEN;
    z += "(";
    for (let R = F; R--; ) z += trunc(E / O), E %= O, E *= C_TEN;
    z += ")";
  } else for (let R = D; E && R--; ) z += trunc(E / O), E %= O, E *= C_TEN;
  return z;
}, toFraction: function(D) {
  let E = this.n, O = this.d, F = this.s < C_ZERO ? "-" : "";
  if (O === C_ONE) F += E;
  else {
    let I = trunc(E / O);
    D && I > C_ZERO && (F += I, F += " ", E %= O), F += E, F += "/", F += O;
  }
  return F;
}, toLatex: function(D) {
  let E = this.n, O = this.d, F = this.s < C_ZERO ? "-" : "";
  if (O === C_ONE) F += E;
  else {
    let I = trunc(E / O);
    D && I > C_ZERO && (F += I, E %= O), F += "\\frac{", F += E, F += "}{", F += O, F += "}";
  }
  return F;
}, toContinued: function() {
  let D = this.n, E = this.d, O = [];
  do {
    O.push(trunc(D / E));
    let F = D % E;
    D = E, E = F;
  } while (D !== C_ONE);
  return O;
}, simplify: function(D) {
  let E = BigInt(1 / (D || 1e-3) | 0), O = this.abs(), F = O.toContinued();
  for (let I = 1; I < F.length; I++) {
    let z = newFraction(F[I - 1], C_ONE);
    for (let L = I - 2; L >= 0; L--) z = z.inverse().add(F[L]);
    let R = z.sub(O);
    if (R.n * E < R.d) return z.mul(this.s);
  }
  return this;
} };
var name$318 = "Fraction", dependencies$318 = [], createFractionClass = factory(name$318, dependencies$318, () => (Object.defineProperty(Fraction, "name", { value: "Fraction" }), Fraction.prototype.constructor = Fraction, Fraction.prototype.type = "Fraction", Fraction.prototype.isFraction = !0, Fraction.prototype.toJSON = function() {
  return { mathjs: "Fraction", n: String(this.s * this.n), d: String(this.d) };
}, Fraction.fromJSON = function(D) {
  return new Fraction(D);
}, Fraction), { isClass: !0 }), name$317 = "Range", dependencies$317 = [], createRangeClass = factory(name$317, dependencies$317, () => {
  function D(E, O, F) {
    if (!(this instanceof D)) throw SyntaxError("Constructor must be called with the new operator");
    var I = E != null, z = O != null, R = F != null;
    if (I) {
      if (isBigNumber(E)) E = E.toNumber();
      else if (typeof E != "number" && !isBigInt(E)) throw TypeError("Parameter start must be a number or bigint");
    }
    if (z) {
      if (isBigNumber(O)) O = O.toNumber();
      else if (typeof O != "number" && !isBigInt(O)) throw TypeError("Parameter end must be a number or bigint");
    }
    if (R) {
      if (isBigNumber(F)) F = F.toNumber();
      else if (typeof F != "number" && !isBigInt(F)) throw TypeError("Parameter step must be a number or bigint");
    }
    if (this.start = I ? parseFloat(E) : 0, this.end = z ? parseFloat(O) : 0, this.step = R ? parseFloat(F) : 1, R && nearlyEqual$1(this.step, 0)) throw Error("Step must not be zero");
  }
  return D.prototype.type = "Range", D.prototype.isRange = !0, D.parse = function(E) {
    if (typeof E != "string") return null;
    var O = E.split(":").map(function(F) {
      return parseFloat(F);
    });
    if (O.some(function(F) {
      return isNaN(F);
    })) return null;
    switch (O.length) {
      case 2:
        return new D(O[0], O[1]);
      case 3:
        return new D(O[0], O[2], O[1]);
      default:
        return null;
    }
  }, D.prototype.clone = function() {
    return new D(this.start, this.end, this.step);
  }, D.prototype.size = function() {
    var E = 0, O = this.start, F = this.step, I = this.end - O;
    return sign$2(F) === sign$2(I) ? E = Math.ceil(I / F) : I === 0 && (E = 0), isNaN(E) && (E = 0), [E];
  }, D.prototype.min = function() {
    var E = this.size()[0];
    if (E > 0) return this.step > 0 ? this.start : this.start + (E - 1) * this.step;
  }, D.prototype.max = function() {
    var E = this.size()[0];
    if (E > 0) return this.step > 0 ? this.start + (E - 1) * this.step : this.start;
  }, D.prototype.forEach = function(E) {
    var O = this.start, F = this.step, I = this.end, z = 0;
    if (F > 0) for (; O < I; ) E(O, [z], this), O += F, z++;
    else if (F < 0) for (; O > I; ) E(O, [z], this), O += F, z++;
  }, D.prototype.map = function(E) {
    var O = [];
    return this.forEach(function(F, I, z) {
      O[I[0]] = E(F, I, z);
    }), O;
  }, D.prototype.toArray = function() {
    var E = [];
    return this.forEach(function(O, F) {
      E[F[0]] = O;
    }), E;
  }, D.prototype.valueOf = function() {
    return this.toArray();
  }, D.prototype.format = function(E) {
    var O = format$2(this.start, E);
    return this.step !== 1 && (O += ":" + format$2(this.step, E)), O += ":" + format$2(this.end, E), O;
  }, D.prototype.toString = function() {
    return this.format();
  }, D.prototype.toJSON = function() {
    return { mathjs: "Range", start: this.start, end: this.end, step: this.step };
  }, D.fromJSON = function(E) {
    return new D(E.start, E.end, E.step);
  }, D;
}, { isClass: !0 }), name$316 = "Matrix", dependencies$316 = [], createMatrixClass = factory(name$316, dependencies$316, () => {
  function D() {
    if (!(this instanceof D)) throw SyntaxError("Constructor must be called with the new operator");
  }
  return D.prototype.type = "Matrix", D.prototype.isMatrix = !0, D.prototype.storage = function() {
    throw Error("Cannot invoke storage on a Matrix interface");
  }, D.prototype.datatype = function() {
    throw Error("Cannot invoke datatype on a Matrix interface");
  }, D.prototype.create = function(E, O) {
    throw Error("Cannot invoke create on a Matrix interface");
  }, D.prototype.subset = function(E, O, F) {
    throw Error("Cannot invoke subset on a Matrix interface");
  }, D.prototype.get = function(E) {
    throw Error("Cannot invoke get on a Matrix interface");
  }, D.prototype.set = function(E, O, F) {
    throw Error("Cannot invoke set on a Matrix interface");
  }, D.prototype.resize = function(E, O) {
    throw Error("Cannot invoke resize on a Matrix interface");
  }, D.prototype.reshape = function(E, O) {
    throw Error("Cannot invoke reshape on a Matrix interface");
  }, D.prototype.clone = function() {
    throw Error("Cannot invoke clone on a Matrix interface");
  }, D.prototype.size = function() {
    throw Error("Cannot invoke size on a Matrix interface");
  }, D.prototype.map = function(E, O) {
    throw Error("Cannot invoke map on a Matrix interface");
  }, D.prototype.forEach = function(E) {
    throw Error("Cannot invoke forEach on a Matrix interface");
  }, D.prototype[Symbol.iterator] = function() {
    throw Error("Cannot iterate a Matrix interface");
  }, D.prototype.toArray = function() {
    throw Error("Cannot invoke toArray on a Matrix interface");
  }, D.prototype.valueOf = function() {
    throw Error("Cannot invoke valueOf on a Matrix interface");
  }, D.prototype.format = function(E) {
    throw Error("Cannot invoke format on a Matrix interface");
  }, D.prototype.toString = function() {
    throw Error("Cannot invoke toString on a Matrix interface");
  }, D;
}, { isClass: !0 });
function formatBigNumberToBase(D, E, O) {
  var F = D.constructor, I = new F(2), z = "";
  if (O) {
    if (O < 1) throw Error("size must be in greater than 0");
    if (!isInteger(O)) throw Error("size must be an integer");
    if (D.greaterThan(I.pow(O - 1).sub(1)) || D.lessThan(I.pow(O - 1).mul(-1))) throw Error(`Value must be in range [-2^${O - 1}, 2^${O - 1}-1]`);
    if (!D.isInteger()) throw Error("Value must be an integer");
    D.lessThan(0) && (D = D.add(I.pow(O))), z = `i${O}`;
  }
  switch (E) {
    case 2:
      return `${D.toBinary()}${z}`;
    case 8:
      return `${D.toOctal()}${z}`;
    case 16:
      return `${D.toHexadecimal()}${z}`;
    default:
      throw Error(`Base ${E} not supported `);
  }
}
function format$1(D, E) {
  if (typeof E == "function") return E(D);
  if (!D.isFinite()) return D.isNaN() ? "NaN" : D.gt(0) ? "Infinity" : "-Infinity";
  var { notation: O, precision: F, wordSize: I } = normalizeFormatOptions(E);
  switch (O) {
    case "fixed":
      return toFixed$1(D, F);
    case "exponential":
      return toExponential(D, F);
    case "engineering":
      return toEngineering(D, F);
    case "bin":
      return formatBigNumberToBase(D, 2, I);
    case "oct":
      return formatBigNumberToBase(D, 8, I);
    case "hex":
      return formatBigNumberToBase(D, 16, I);
    case "auto":
      var z = _toNumberOrDefault(E?.lowerExp, -3), R = _toNumberOrDefault(E?.upperExp, 5);
      if (D.isZero()) return "0";
      var L, q = D.toSignificantDigits(F), U = q.e;
      return L = U >= z && U < R ? q.toFixed() : toExponential(D, F), L.replace(/((\.\d*?)(0+))($|e)/, function() {
        var Z = arguments[2], V = arguments[4];
        return Z === "." ? V : Z + V;
      });
    default:
      throw Error('Unknown notation "' + O + '". Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.');
  }
}
function toEngineering(D, E) {
  var O = D.e, F = O % 3 == 0 ? O : O < 0 ? O - 3 - O % 3 : O - O % 3, I = D.mul(10 ** -F).toPrecision(E);
  if (I.includes("e")) {
    var z = D.constructor;
    I = new z(I).toFixed();
  }
  return I + "e" + (O >= 0 ? "+" : "") + F.toString();
}
function toExponential(D, E) {
  return E === void 0 ? D.toExponential() : D.toExponential(E - 1);
}
function toFixed$1(D, E) {
  return D.toFixed(E);
}
function _toNumberOrDefault(D, E) {
  return isNumber(D) ? D : isBigNumber(D) ? D.toNumber() : E;
}
function endsWith(D, E) {
  var O = D.length - E.length, F = D.length;
  return D.substring(O, F) === E;
}
function format(D, E) {
  var O = _format(D, E);
  return E && typeof E == "object" && "truncate" in E && O.length > E.truncate ? O.substring(0, E.truncate - 3) + "..." : O;
}
function _format(D, E) {
  return typeof D == "number" ? format$2(D, E) : isBigNumber(D) ? format$1(D, E) : looksLikeFraction(D) ? !E || E.fraction !== "decimal" ? `${D.s * D.n}/${D.d}` : D.toString() : Array.isArray(D) ? formatArray(D, E) : isString(D) ? stringify(D) : typeof D == "function" ? D.syntax ? String(D.syntax) : "function" : D && typeof D == "object" ? typeof D.format == "function" ? D.format(E) : D && D.toString(E) !== {}.toString() ? D.toString(E) : "{" + Object.keys(D).map((O) => stringify(O) + ": " + format(D[O], E)).join(", ") + "}" : String(D);
}
function stringify(D) {
  for (var E = String(D), O = "", F = 0; F < E.length; ) {
    var I = E.charAt(F);
    O += I in controlCharacters ? controlCharacters[I] : I, F++;
  }
  return '"' + O + '"';
}
var controlCharacters = { '"': '\\"', "\\": "\\\\", "\b": "\\b", "\f": "\\f", "\n": "\\n", "\r": "\\r", "	": "\\t" };
function escape(D) {
  var E = String(D);
  return E = E.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), E;
}
function formatArray(D, E) {
  if (Array.isArray(D)) {
    for (var O = "[", F = D.length, I = 0; I < F; I++) I !== 0 && (O += ", "), O += formatArray(D[I], E);
    return O += "]", O;
  } else return format(D, E);
}
function looksLikeFraction(D) {
  return D && typeof D == "object" && typeof D.s == "bigint" && typeof D.n == "bigint" && typeof D.d == "bigint" || !1;
}
function compareText(D, E) {
  if (!isString(D)) throw TypeError("Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: " + typeOf(D) + ", index: 0)");
  if (!isString(E)) throw TypeError("Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: " + typeOf(E) + ", index: 1)");
  return D === E ? 0 : D > E ? 1 : -1;
}
function DimensionError(D, E, O) {
  if (!(this instanceof DimensionError)) throw SyntaxError("Constructor must be called with the new operator");
  this.actual = D, this.expected = E, this.relation = O, this.message = "Dimension mismatch (" + (Array.isArray(D) ? "[" + D.join(", ") + "]" : D) + " " + (this.relation || "!=") + " " + (Array.isArray(E) ? "[" + E.join(", ") + "]" : E) + ")", this.stack = Error().stack;
}
DimensionError.prototype = RangeError(), DimensionError.prototype.constructor = RangeError, DimensionError.prototype.name = "DimensionError", DimensionError.prototype.isDimensionError = !0;
function IndexError(D, E, O) {
  if (!(this instanceof IndexError)) throw SyntaxError("Constructor must be called with the new operator");
  this.index = D, arguments.length < 3 ? (this.min = 0, this.max = E) : (this.min = E, this.max = O), this.min !== void 0 && this.index < this.min ? this.message = "Index out of range (" + this.index + " < " + this.min + ")" : this.max !== void 0 && this.index >= this.max ? this.message = "Index out of range (" + this.index + " > " + (this.max - 1) + ")" : this.message = "Index out of range (" + this.index + ")", this.stack = Error().stack;
}
IndexError.prototype = RangeError(), IndexError.prototype.constructor = RangeError, IndexError.prototype.name = "IndexError", IndexError.prototype.isIndexError = !0;
function arraySize(D) {
  for (var E = []; Array.isArray(D); ) E.push(D.length), D = D[0];
  return E;
}
function _validate(D, E, O) {
  var F, I = D.length;
  if (I !== E[O]) throw new DimensionError(I, E[O]);
  if (O < E.length - 1) {
    var z = O + 1;
    for (F = 0; F < I; F++) {
      var R = D[F];
      if (!Array.isArray(R)) throw new DimensionError(E.length - 1, E.length, "<");
      _validate(D[F], E, z);
    }
  } else for (F = 0; F < I; F++) if (Array.isArray(D[F])) throw new DimensionError(E.length + 1, E.length, ">");
}
function validate(D, E) {
  if (E.length === 0) {
    if (Array.isArray(D)) throw new DimensionError(D.length, 0);
  } else _validate(D, E, 0);
}
function validateIndexSourceSize(D, E) {
  var O = D.isMatrix ? D._size : arraySize(D);
  E._sourceSize.forEach((F, I) => {
    if (F !== null && F !== O[I]) throw new DimensionError(F, O[I]);
  });
}
function validateIndex(D, E) {
  if (D !== void 0) {
    if (!isNumber(D) || !isInteger(D)) throw TypeError("Index must be an integer (value: " + D + ")");
    if (D < 0 || typeof E == "number" && D >= E) throw new IndexError(D, E);
  }
}
function isEmptyIndex(D) {
  for (var E = 0; E < D._dimensions.length; ++E) {
    var O = D._dimensions[E];
    if (O._data && isArray(O._data)) {
      if (O._size[0] === 0) return !0;
    } else if (O.isRange) {
      if (O.start === O.end) return !0;
    } else if (isString(O) && O.length === 0) return !0;
  }
  return !1;
}
function resize(D, E, O) {
  if (!Array.isArray(E)) throw TypeError("Array expected");
  if (E.length === 0) throw Error("Resizing to scalar is not supported");
  return E.forEach(function(F) {
    if (!isNumber(F) || !isInteger(F) || F < 0) throw TypeError("Invalid size, must contain positive integers (size: " + format(E) + ")");
  }), (isNumber(D) || isBigNumber(D)) && (D = [D]), _resize(D, E, 0, O === void 0 ? 0 : O), D;
}
function _resize(D, E, O, F) {
  var I, z, R = D.length, L = E[O], q = Math.min(R, L);
  if (D.length = L, O < E.length - 1) {
    var U = O + 1;
    for (I = 0; I < q; I++) z = D[I], Array.isArray(z) || (z = [z], D[I] = z), _resize(z, E, U, F);
    for (I = q; I < L; I++) z = [], D[I] = z, _resize(z, E, U, F);
  } else {
    for (I = 0; I < q; I++) for (; Array.isArray(D[I]); ) D[I] = D[I][0];
    for (I = q; I < L; I++) D[I] = F;
  }
}
function reshape(D, E) {
  var O = flatten$4(D, !0), F = O.length;
  if (!Array.isArray(D) || !Array.isArray(E)) throw TypeError("Array expected");
  if (E.length === 0) throw new DimensionError(0, F, "!=");
  E = processSizesWildcard(E, F);
  var I = product$1(E);
  if (F !== I) throw new DimensionError(I, F, "!=");
  try {
    return _reshape(O, E);
  } catch (z) {
    throw z instanceof DimensionError ? new DimensionError(I, F, "!=") : z;
  }
}
function processSizesWildcard(D, E) {
  var O = product$1(D), F = D.slice(), I = -1, z = D.indexOf(I);
  if (D.indexOf(I, z + 1) >= 0) throw Error("More than one wildcard in sizes");
  var R = z >= 0, L = E % O === 0;
  if (R) if (L) F[z] = -E / O;
  else throw Error("Could not replace wildcard, since " + E + " is no multiple of " + -O);
  return F;
}
function product$1(D) {
  return D.reduce((E, O) => E * O, 1);
}
function _reshape(D, E) {
  for (var O = D, F, I = E.length - 1; I > 0; I--) {
    var z = E[I];
    F = [];
    for (var R = O.length / z, L = 0; L < R; L++) F.push(O.slice(L * z, (L + 1) * z));
    O = F;
  }
  return O;
}
function squeeze(D, E) {
  for (var O = arraySize(D); Array.isArray(D) && D.length === 1; ) D = D[0], O.shift();
  for (var F = O.length; O[F - 1] === 1; ) F--;
  return F < O.length && (D = _squeeze(D, F, 0), O.length = F), D;
}
function _squeeze(D, E, O) {
  var F, I;
  if (O < E) {
    var z = O + 1;
    for (F = 0, I = D.length; F < I; F++) D[F] = _squeeze(D[F], E, z);
  } else for (; Array.isArray(D); ) D = D[0];
  return D;
}
function unsqueeze(D, E, O, F) {
  var I = F || arraySize(D);
  if (O) for (var z = 0; z < O; z++) D = [D], I.unshift(1);
  for (D = _unsqueeze(D, E, 0); I.length < E; ) I.push(1);
  return D;
}
function _unsqueeze(D, E, O) {
  var F, I;
  if (Array.isArray(D)) {
    var z = O + 1;
    for (F = 0, I = D.length; F < I; F++) D[F] = _unsqueeze(D[F], E, z);
  } else for (var R = O; R < E; R++) D = [D];
  return D;
}
function flatten$4(D) {
  var E = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  if (!Array.isArray(D)) return D;
  if (typeof E != "boolean") throw TypeError("Boolean expected for second argument of flatten");
  var O = [];
  return E ? I(D) : F(D), O;
  function F(z) {
    for (var R = 0; R < z.length; R++) {
      var L = z[R];
      Array.isArray(L) ? F(L) : O.push(L);
    }
  }
  function I(z) {
    if (Array.isArray(z[0])) for (var R = 0; R < z.length; R++) I(z[R]);
    else for (var L = 0; L < z.length; L++) O.push(z[L]);
  }
}
function map$1(D, E) {
  return Array.prototype.map.call(D, E);
}
function forEach(D, E) {
  Array.prototype.forEach.call(D, E);
}
function filter$1(D, E) {
  if (arraySize(D).length !== 1) throw Error("Only one dimensional matrices supported");
  return Array.prototype.filter.call(D, E);
}
function filterRegExp(D, E) {
  if (arraySize(D).length !== 1) throw Error("Only one dimensional matrices supported");
  return Array.prototype.filter.call(D, (O) => E.test(O));
}
function join(D, E) {
  return Array.prototype.join.call(D, E);
}
function identify(D) {
  if (!Array.isArray(D)) throw TypeError("Array input expected");
  if (D.length === 0) return D;
  var E = [], O = 0;
  E[0] = { value: D[0], identifier: 0 };
  for (var F = 1; F < D.length; F++) D[F] === D[F - 1] ? O++ : O = 0, E.push({ value: D[F], identifier: O });
  return E;
}
function generalize(D) {
  if (!Array.isArray(D)) throw TypeError("Array input expected");
  if (D.length === 0) return D;
  for (var E = [], O = 0; O < D.length; O++) E.push(D[O].value);
  return E;
}
function getArrayDataType(D, E) {
  for (var O, F = 0, I = 0; I < D.length; I++) {
    var z = D[I], R = Array.isArray(z);
    if (I === 0 && R && (F = z.length), R && z.length !== F) return;
    var L = R ? getArrayDataType(z, E) : E(z);
    if (O === void 0) O = L;
    else if (O !== L) return "mixed";
  }
  return O;
}
function concatRecursive(D, E, O, F) {
  if (F < O) {
    if (D.length !== E.length) throw new DimensionError(D.length, E.length);
    for (var I = [], z = 0; z < D.length; z++) I[z] = concatRecursive(D[z], E[z], O, F + 1);
    return I;
  } else return D.concat(E);
}
function concat() {
  var D = Array.prototype.slice.call(arguments, 0, -1), E = Array.prototype.slice.call(arguments, -1);
  if (D.length === 1) return D[0];
  if (D.length > 1) return D.slice(1).reduce(function(O, F) {
    return concatRecursive(O, F, E, 0);
  }, D[0]);
  throw Error("Wrong number of arguments in function concat");
}
function broadcastSizes() {
  for (var D = [...arguments], E = D.map((Z) => Z.length), O = Math.max(...E), F = Array(O).fill(null), I = 0; I < D.length; I++) for (var z = D[I], R = E[I], L = 0; L < R; L++) {
    var q = O - R + L;
    z[L] > F[q] && (F[q] = z[L]);
  }
  for (var U = 0; U < D.length; U++) checkBroadcastingRules(D[U], F);
  return F;
}
function checkBroadcastingRules(D, E) {
  for (var O = E.length, F = D.length, I = 0; I < F; I++) {
    var z = O - F + I;
    if (D[I] < E[z] && D[I] > 1 || D[I] > E[z]) throw Error(`shape mismatch: mismatch is found in arg with shape (${D}) not possible to broadcast dimension ${F} with size ${D[I]} to size ${E[z]}`);
  }
}
function broadcastTo(D, E) {
  var O = arraySize(D);
  if (deepStrictEqual(O, E)) return D;
  checkBroadcastingRules(O, E);
  var F = broadcastSizes(O, E), I = F.length, z = [...Array(I - O.length).fill(1), ...O], R = clone$1(D);
  O.length < I && (R = reshape(R, z), O = arraySize(R));
  for (var L = 0; L < I; L++) O[L] < F[L] && (R = stretch(R, F[L], L), O = arraySize(R));
  return R;
}
function stretch(D, E, O) {
  return concat(...Array(E).fill(D), O);
}
function get$1(D, E) {
  if (!Array.isArray(D)) throw Error("Array expected");
  if (!Array.isArray(E)) throw Error("Array expected for index");
  var O = arraySize(D);
  if (E.length !== O.length) throw new DimensionError(E.length, O.length);
  for (var F = 0; F < E.length; F++) validateIndex(E[F], O[F]);
  return E.reduce((I, z) => I[z], D);
}
function deepMap$1(D, E) {
  var O = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  if (D.length === 0) return [];
  if (O) return z(D);
  var F = [];
  return I(D, 0);
  function I(R, L) {
    if (Array.isArray(R)) {
      for (var q = R.length, U = Array(q), Z = 0; Z < q; Z++) F[L] = Z, U[Z] = I(R[Z], L + 1);
      return U;
    } else return E(R, F.slice(0, L), D);
  }
  function z(R) {
    if (Array.isArray(R)) {
      for (var L = R.length, q = Array(L), U = 0; U < L; U++) q[U] = z(R[U]);
      return q;
    } else return E(R);
  }
}
function deepForEach$1(D, E) {
  var O = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  if (D.length === 0) return;
  if (O) {
    z(D);
    return;
  }
  var F = [];
  I(D, 0);
  function I(R, L) {
    if (Array.isArray(R)) for (var q = R.length, U = 0; U < q; U++) F[L] = U, I(R[U], L + 1);
    else E(R, F.slice(0, L), D);
  }
  function z(R) {
    if (Array.isArray(R)) for (var L = R.length, q = 0; q < L; q++) z(R[q]);
    else E(R);
  }
}
function clone$1(D) {
  return _extends([], D);
}
function optimizeCallback(D, E, O, F) {
  if (import_typed_function.default.isTypedFunction(D)) {
    var I;
    if (F) I = 1;
    else {
      var z = E.isMatrix ? E.size() : arraySize(E);
      if (!z.length || z[z.length - 1] === 0) return { isUnary: F, fn: D };
      var R = z.map(() => 0);
      I = _findNumberOfArgumentsTyped(D, E.isMatrix ? E.get(R) : get$1(E, R), R, E);
    }
    var L;
    if (E.isMatrix && E.dataType !== "mixed" && E.dataType !== void 0) {
      var q = _findSingleSignatureWithArity(D, I);
      L = q === void 0 ? D : q;
    } else L = D;
    return I >= 1 && I <= 3 ? { isUnary: I === 1, fn: function() {
      return _tryFunctionWithArgs(L, [...arguments].slice(0, I), O, D.name);
    } } : { isUnary: !1, fn: function() {
      return _tryFunctionWithArgs(L, [...arguments], O, D.name);
    } };
  }
  return F === void 0 ? { isUnary: _findIfCallbackIsUnary(D), fn: D } : { isUnary: F, fn: D };
}
function _findSingleSignatureWithArity(D, E) {
  var O = [];
  if (Object.entries(D.signatures).forEach((F) => {
    var [I, z] = F;
    I.split(",").length === E && O.push(z);
  }), O.length === 1) return O[0];
}
function _findIfCallbackIsUnary(D) {
  if (D.length !== 1) return !1;
  var E = D.toString();
  if (/arguments/.test(E)) return !1;
  var O = E.match(/\(.*?\)/);
  return !/\.\.\./.test(O);
}
function _findNumberOfArgumentsTyped(D, E, O, F) {
  for (var I = [E, O, F], z = 3; z > 0; z--) {
    var R = I.slice(0, z);
    if (import_typed_function.default.resolve(D, R) !== null) return z;
  }
}
function _tryFunctionWithArgs(D, E, O, F) {
  try {
    return D(...E);
  } catch (I) {
    _createCallbackError(I, E, O, F);
  }
}
function _createCallbackError(D, E, O, F) {
  if (D instanceof TypeError && D.data?.category === "wrongType") {
    var I = [];
    throw I.push(`value: ${typeOf(E[0])}`), E.length >= 2 && I.push(`index: ${typeOf(E[1])}`), E.length >= 3 && I.push(`array: ${typeOf(E[2])}`), TypeError(`Function ${O} cannot apply callback arguments ${F}(${I.join(", ")}) at index ${JSON.stringify(E[1])}`);
  } else throw TypeError(`Function ${O} cannot apply callback arguments to function ${F}: ${D.message}`);
}
var name$315 = "DenseMatrix", dependencies$315 = ["Matrix", "config"], createDenseMatrixClass = factory(name$315, dependencies$315, (D) => {
  var { Matrix: E, config: O } = D;
  function F(V, G) {
    if (!(this instanceof F)) throw SyntaxError("Constructor must be called with the new operator");
    if (G && !isString(G)) throw Error("Invalid datatype: " + G);
    if (isMatrix(V)) V.type === "DenseMatrix" ? (this._data = clone$3(V._data), this._size = clone$3(V._size), this._datatype = G || V._datatype) : (this._data = V.toArray(), this._size = V.size(), this._datatype = G || V._datatype);
    else if (V && isArray(V.data) && isArray(V.size)) this._data = V.data, this._size = V.size, validate(this._data, this._size), this._datatype = G || V.datatype;
    else if (isArray(V)) this._data = Z(V), this._size = arraySize(this._data), validate(this._data, this._size), this._datatype = G;
    else {
      if (V) throw TypeError("Unsupported type of data (" + typeOf(V) + ")");
      this._data = [], this._size = [0], this._datatype = G;
    }
  }
  F.prototype = new E(), F.prototype.createDenseMatrix = function(V, G) {
    return new F(V, G);
  }, Object.defineProperty(F, "name", { value: "DenseMatrix" }), F.prototype.constructor = F, F.prototype.type = "DenseMatrix", F.prototype.isDenseMatrix = !0, F.prototype.getDataType = function() {
    return getArrayDataType(this._data, typeOf);
  }, F.prototype.storage = function() {
    return "dense";
  }, F.prototype.datatype = function() {
    return this._datatype;
  }, F.prototype.create = function(V, G) {
    return new F(V, G);
  }, F.prototype.subset = function(V, G, W) {
    switch (arguments.length) {
      case 1:
        return I(this, V);
      case 2:
      case 3:
        return R(this, V, G, W);
      default:
        throw SyntaxError("Wrong number of arguments");
    }
  }, F.prototype.get = function(V) {
    return get$1(this._data, V);
  }, F.prototype.set = function(V, G, W) {
    if (!isArray(V)) throw TypeError("Array expected");
    if (V.length < this._size.length) throw new DimensionError(V.length, this._size.length, "<");
    var J, X, Y, ee = V.map(function(te) {
      return te + 1;
    });
    U(this, ee, W);
    var K = this._data;
    for (J = 0, X = V.length - 1; J < X; J++) Y = V[J], validateIndex(Y, K.length), K = K[Y];
    return Y = V[V.length - 1], validateIndex(Y, K.length), K[Y] = G, this;
  };
  function I(V, G) {
    if (!isIndex(G)) throw TypeError("Invalid index");
    if (O.legacySubset ? G.size().every((ie) => ie === 1) : G.isScalar()) return V.get(G.min());
    var W = G.size();
    if (W.length !== V._size.length) throw new DimensionError(W.length, V._size.length);
    for (var J = G.min(), X = G.max(), Y = 0, ee = V._size.length; Y < ee; Y++) validateIndex(J[Y], V._size[Y]), validateIndex(X[Y], V._size[Y]);
    var K = new F(), te = z(V._data, G);
    return K._size = te.size, K._datatype = V._datatype, K._data = te.data, O.legacySubset ? K.reshape(G.size()) : K;
  }
  function z(V, G) {
    var W = G.size().length - 1, J = Array(W);
    return { data: X(V), size: J.filter((Y) => Y !== null) };
    function X(Y) {
      var ee = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, K = G.dimension(ee);
      function te(ie, ne) {
        return isNumber(ie) ? ne(ie) : ie.map(ne).valueOf();
      }
      return isNumber(K) ? J[ee] = null : J[ee] = K.size()[0], ee < W ? te(K, (ie) => (validateIndex(ie, Y.length), X(Y[ie], ee + 1))) : te(K, (ie) => (validateIndex(ie, Y.length), Y[ie]));
    }
  }
  function R(V, G, W, J) {
    if (!G || G.isIndex !== !0) throw TypeError("Invalid index");
    var X = G.size(), Y = G.isScalar(), ee;
    if (isMatrix(W) ? (ee = W.size(), W = W.valueOf()) : ee = arraySize(W), Y) {
      if (ee.length !== 0) throw TypeError("Scalar expected");
      V.set(G.min(), W, J);
    } else {
      if (!deepStrictEqual(ee, X)) {
        if (ee.length === 0) W = broadcastTo([W], X);
        else try {
          W = broadcastTo(W, X);
        } catch {
        }
        ee = arraySize(W);
      }
      if (X.length < V._size.length) throw new DimensionError(X.length, V._size.length, "<");
      if (ee.length < X.length) {
        for (var K = 0, te = 0; X[K] === 1 && ee[K] === 1; ) K++;
        for (; X[K] === 1; ) te++, K++;
        W = unsqueeze(W, X.length, te, ee);
      }
      if (!deepStrictEqual(X, ee)) throw new DimensionError(X, ee, ">");
      U(V, G.max().map(function(ie) {
        return ie + 1;
      }), J), L(V._data, G, W);
    }
    return V;
  }
  function L(V, G, W) {
    var J = G.size().length - 1;
    X(V, W);
    function X(Y, ee) {
      var K = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, te = G.dimension(K), ie = (ae, ue) => {
        validateIndex(ae, Y.length), X(Y[ae], ee[ue[0]], K + 1);
      }, ne = (ae, ue) => {
        validateIndex(ae, Y.length), Y[ae] = ee[ue[0]];
      };
      K < J ? isNumber(te) ? ie(te, [0]) : te.forEach(ie) : isNumber(te) ? ne(te, [0]) : te.forEach(ne);
    }
  }
  F.prototype.resize = function(V, G, W) {
    if (!isCollection(V)) throw TypeError("Array or Matrix expected");
    var J = V.valueOf().map((X) => Array.isArray(X) && X.length === 1 ? X[0] : X);
    return q(W ? this.clone() : this, J, G);
  };
  function q(V, G, W) {
    if (G.length === 0) {
      for (var J = V._data; isArray(J); ) J = J[0];
      return J;
    }
    return V._size = G.slice(0), V._data = resize(V._data, V._size, W), V;
  }
  F.prototype.reshape = function(V, G) {
    var W = G ? this.clone() : this;
    return W._data = reshape(W._data, V), W._size = processSizesWildcard(V, W._size.reduce((J, X) => J * X)), W;
  };
  function U(V, G, W) {
    for (var J = V._size.slice(0), X = !1; J.length < G.length; ) J.push(0), X = !0;
    for (var Y = 0, ee = G.length; Y < ee; Y++) G[Y] > J[Y] && (J[Y] = G[Y], X = !0);
    X && q(V, J, W);
  }
  F.prototype.clone = function() {
    return new F({ data: clone$3(this._data), size: clone$3(this._size), datatype: this._datatype });
  }, F.prototype.size = function() {
    return this._size.slice(0);
  }, F.prototype.map = function(V) {
    var G = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, W = this, J = W._size.length - 1;
    if (J < 0) return W.clone();
    var X = optimizeCallback(V, W, "map", G), Y = X.fn, ee = W.create(void 0, W._datatype);
    if (ee._size = W._size, G || X.isUnary) return ee._data = ue(W._data), ee;
    if (J === 0) {
      for (var K = W.valueOf(), te = Array(K.length), ie = 0; ie < K.length; ie++) te[ie] = Y(K[ie], [ie], W);
      return ee._data = te, ee;
    }
    var ne = [];
    return ee._data = ae(W._data), ee;
    function ae(oe) {
      var se = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, le = Array(oe.length);
      if (se < J) for (var ce = 0; ce < oe.length; ce++) ne[se] = ce, le[ce] = ae(oe[ce], se + 1);
      else for (var fe = 0; fe < oe.length; fe++) ne[se] = fe, le[fe] = Y(oe[fe], ne.slice(), W);
      return le;
    }
    function ue(oe) {
      var se = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, le = Array(oe.length);
      if (se < J) for (var ce = 0; ce < oe.length; ce++) le[ce] = ue(oe[ce], se + 1);
      else for (var fe = 0; fe < oe.length; fe++) le[fe] = Y(oe[fe]);
      return le;
    }
  }, F.prototype.forEach = function(V) {
    var G = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, W = this, J = W._size.length - 1;
    if (J < 0) return;
    var X = optimizeCallback(V, W, "map", G), Y = X.fn;
    if (G || X.isUnary) {
      ie(W._data);
      return;
    }
    if (J === 0) {
      for (var ee = 0; ee < W._data.length; ee++) Y(W._data[ee], [ee], W);
      return;
    }
    var K = [];
    te(W._data);
    function te(ne) {
      var ae = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      if (ae < J) for (var ue = 0; ue < ne.length; ue++) K[ae] = ue, te(ne[ue], ae + 1);
      else for (var oe = 0; oe < ne.length; oe++) K[ae] = oe, Y(ne[oe], K.slice(), W);
    }
    function ie(ne) {
      var ae = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      if (ae < J) for (var ue = 0; ue < ne.length; ue++) ie(ne[ue], ae + 1);
      else for (var oe = 0; oe < ne.length; oe++) Y(ne[oe]);
    }
  }, F.prototype[Symbol.iterator] = function* () {
    var V = this._size.length - 1;
    if (!(V < 0)) {
      if (V === 0) {
        for (var G = 0; G < this._data.length; G++) yield { value: this._data[G], index: [G] };
        return;
      }
      for (var W = Array(V + 1).fill(0), J = this._size.reduce((te, ie) => te * ie, 1), X = 0; X < J; X++) {
        for (var Y = this._data, ee = 0; ee < V; ee++) Y = Y[W[ee]];
        yield { value: Y[W[V]], index: W.slice() };
        for (var K = V; K >= 0 && (W[K]++, !(W[K] < this._size[K])); K--) W[K] = 0;
      }
    }
  }, F.prototype.rows = function() {
    var V = [];
    if (this.size().length !== 2) throw TypeError("Rows can only be returned for a 2D matrix.");
    for (var G of this._data) V.push(new F([G], this._datatype));
    return V;
  }, F.prototype.columns = function() {
    var V = this, G = [], W = this.size();
    if (W.length !== 2) throw TypeError("Rows can only be returned for a 2D matrix.");
    for (var J = this._data, X = function(ee) {
      var K = J.map((te) => [te[ee]]);
      G.push(new F(K, V._datatype));
    }, Y = 0; Y < W[1]; Y++) X(Y);
    return G;
  }, F.prototype.toArray = function() {
    return clone$3(this._data);
  }, F.prototype.valueOf = function() {
    return this._data;
  }, F.prototype.format = function(V) {
    return format(this._data, V);
  }, F.prototype.toString = function() {
    return format(this._data);
  }, F.prototype.toJSON = function() {
    return { mathjs: "DenseMatrix", data: this._data, size: this._size, datatype: this._datatype };
  }, F.prototype.diagonal = function(V) {
    if (V) {
      if (isBigNumber(V) && (V = V.toNumber()), !isNumber(V) || !isInteger(V)) throw TypeError("The parameter k must be an integer number");
    } else V = 0;
    for (var G = V > 0 ? V : 0, W = V < 0 ? -V : 0, J = this._size[0], X = this._size[1], Y = Math.min(J - W, X - G), ee = [], K = 0; K < Y; K++) ee[K] = this._data[K + W][K + G];
    return new F({ data: ee, size: [Y], datatype: this._datatype });
  }, F.diagonal = function(V, G, W, J) {
    if (!isArray(V)) throw TypeError("Array expected, size parameter");
    if (V.length !== 2) throw Error("Only two dimensions matrix are supported");
    if (V = V.map(function(oe) {
      if (isBigNumber(oe) && (oe = oe.toNumber()), !isNumber(oe) || !isInteger(oe) || oe < 1) throw Error("Size values must be positive integers");
      return oe;
    }), W) {
      if (isBigNumber(W) && (W = W.toNumber()), !isNumber(W) || !isInteger(W)) throw TypeError("The parameter k must be an integer number");
    } else W = 0;
    var X = W > 0 ? W : 0, Y = W < 0 ? -W : 0, ee = V[0], K = V[1], te = Math.min(ee - Y, K - X), ie;
    if (isArray(G)) {
      if (G.length !== te) throw Error("Invalid value array length");
      ie = function(oe) {
        return G[oe];
      };
    } else if (isMatrix(G)) {
      var ne = G.size();
      if (ne.length !== 1 || ne[0] !== te) throw Error("Invalid matrix length");
      ie = function(oe) {
        return G.get([oe]);
      };
    } else ie = function() {
      return G;
    };
    J ||= isBigNumber(ie(0)) ? ie(0).mul(0) : 0;
    var ae = [];
    if (V.length > 0) {
      ae = resize(ae, V, J);
      for (var ue = 0; ue < te; ue++) ae[ue + Y][ue + X] = ie(ue);
    }
    return new F({ data: ae, size: [ee, K] });
  }, F.fromJSON = function(V) {
    return new F(V);
  }, F.prototype.swapRows = function(V, G) {
    if (!isNumber(V) || !isInteger(V) || !isNumber(G) || !isInteger(G)) throw Error("Row index must be positive integers");
    if (this._size.length !== 2) throw Error("Only two dimensional matrix is supported");
    return validateIndex(V, this._size[0]), validateIndex(G, this._size[0]), F._swapRows(V, G, this._data), this;
  }, F._swapRows = function(V, G, W) {
    var J = W[V];
    W[V] = W[G], W[G] = J;
  };
  function Z(V) {
    return isMatrix(V) ? Z(V.valueOf()) : isArray(V) ? V.map(Z) : V;
  }
  return F;
}, { isClass: !0 }), name$314 = "clone", dependencies$314 = ["typed"], createClone = factory(name$314, dependencies$314, (D) => {
  var { typed: E } = D;
  return E(name$314, { any: clone$3 });
});
function _switch$1(D) {
  var E = D.length, O = D[0].length, F, I, z = [];
  for (I = 0; I < O; I++) {
    var R = [];
    for (F = 0; F < E; F++) R.push(D[F][I]);
    z.push(R);
  }
  return z;
}
function containsCollections(D) {
  for (var E = 0; E < D.length; E++) if (isCollection(D[E])) return !0;
  return !1;
}
function deepForEach(D, E) {
  isMatrix(D) ? D.forEach((O) => E(O), !1, !0) : deepForEach$1(D, E, !0);
}
function deepMap(D, E, O) {
  if (!O) return isMatrix(D) ? D.map((I) => E(I), !1, !0) : deepMap$1(D, E, !0);
  var F = (I) => I === 0 ? I : E(I);
  return isMatrix(D) ? D.map((I) => F(I), !1, !0) : deepMap$1(D, F, !0);
}
function reduce$1(D, E, O) {
  var F = Array.isArray(D) ? arraySize(D) : D.size();
  if (E < 0 || E >= F.length) throw new IndexError(E, F.length);
  return isMatrix(D) ? D.create(_reduce(D.valueOf(), E, O), D.datatype()) : _reduce(D, E, O);
}
function _reduce(D, E, O) {
  var F, I, z, R;
  if (E <= 0) if (Array.isArray(D[0])) {
    for (R = _switch$1(D), I = [], F = 0; F < R.length; F++) I[F] = _reduce(R[F], E - 1, O);
    return I;
  } else {
    for (z = D[0], F = 1; F < D.length; F++) z = O(z, D[F]);
    return z;
  }
  else {
    for (I = [], F = 0; F < D.length; F++) I[F] = _reduce(D[F], E - 1, O);
    return I;
  }
}
function scatter(D, E, O, F, I, z, R, L, q, U, Z) {
  var V = D._values, G = D._index, W = D._ptr, J, X, Y, ee;
  if (F) for (X = W[E], Y = W[E + 1], J = X; J < Y; J++) ee = G[J], O[ee] === z ? (F[ee] = L(F[ee], V[J]), I[ee] = z) : (O[ee] = z, R.push(ee), F[ee] = V[J]);
  else for (X = W[E], Y = W[E + 1], J = X; J < Y; J++) ee = G[J], O[ee] === z ? I[ee] = z : (O[ee] = z, R.push(ee));
}
var name$313 = "isInteger", dependencies$313 = ["typed", "equal"], createIsInteger = factory(name$313, dependencies$313, (D) => {
  var { typed: E, equal: O } = D;
  return E(name$313, { number: (F) => Number.isFinite(F) ? O(F, Math.round(F)) : !1, BigNumber: (F) => F.isFinite() ? O(F.round(), F) : !1, bigint: (F) => !0, Fraction: (F) => F.d === 1n, "Array | Matrix": E.referToSelf((F) => (I) => deepMap(I, F)) });
}), n1$4 = "number", n2$3 = "number, number";
function absNumber(D) {
  return Math.abs(D);
}
absNumber.signature = n1$4;
function addNumber(D, E) {
  return D + E;
}
addNumber.signature = n2$3;
function subtractNumber(D, E) {
  return D - E;
}
subtractNumber.signature = n2$3;
function multiplyNumber(D, E) {
  return D * E;
}
multiplyNumber.signature = n2$3;
function unaryMinusNumber(D) {
  return -D;
}
unaryMinusNumber.signature = n1$4;
function unaryPlusNumber(D) {
  return D;
}
unaryPlusNumber.signature = n1$4;
function cbrtNumber(D) {
  return cbrt$1(D);
}
cbrtNumber.signature = n1$4;
function cubeNumber(D) {
  return D * D * D;
}
cubeNumber.signature = n1$4;
function expNumber(D) {
  return Math.exp(D);
}
expNumber.signature = n1$4;
function expm1Number(D) {
  return expm1(D);
}
expm1Number.signature = n1$4;
function lcmNumber(D, E) {
  if (!isInteger(D) || !isInteger(E)) throw Error("Parameters in function lcm must be integer numbers");
  if (D === 0 || E === 0) return 0;
  for (var O, F = D * E; E !== 0; ) O = E, E = D % O, D = O;
  return Math.abs(F / D);
}
lcmNumber.signature = n2$3;
function logNumber(D, E) {
  return E ? Math.log(D) / Math.log(E) : Math.log(D);
}
function log10Number(D) {
  return log10$2(D);
}
log10Number.signature = n1$4;
function log2Number(D) {
  return log2$1(D);
}
log2Number.signature = n1$4;
function nthRootNumber(D) {
  var E = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, O = E < 0;
  if (O && (E = -E), E === 0) throw Error("Root must be non-zero");
  if (D < 0 && Math.abs(E) % 2 != 1) throw Error("Root must be odd when a is negative.");
  if (D === 0) return O ? 1 / 0 : 0;
  if (!isFinite(D)) return O ? 0 : D;
  var F = Math.abs(D) ** (1 / E);
  return F = D < 0 ? -F : F, O ? 1 / F : F;
}
function signNumber(D) {
  return sign$2(D);
}
signNumber.signature = n1$4;
function squareNumber(D) {
  return D * D;
}
squareNumber.signature = n1$4;
function xgcdNumber(D, E) {
  var O, F, I, z = 0, R = 1, L = 1, q = 0;
  if (!isInteger(D) || !isInteger(E)) throw Error("Parameters in function xgcd must be integer numbers");
  for (; E; ) F = Math.floor(D / E), I = D - F * E, O = z, z = R - F * z, R = O, O = L, L = q - F * L, q = O, D = E, E = I;
  return D < 0 ? [-D, -R, -q] : [D, D ? R : 0, q];
}
xgcdNumber.signature = n2$3;
function powNumber(D, E) {
  return D * D < 1 && E === 1 / 0 || D * D > 1 && E === -1 / 0 ? 0 : D ** +E;
}
powNumber.signature = n2$3;
function roundNumber(D) {
  var E = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  if (!isInteger(E) || E < 0 || E > 15) throw Error("Number of decimals in function round must be an integer from 0 to 15 inclusive");
  return parseFloat(toFixed$2(D, E));
}
var n1$3 = "number", n2$2 = "number, number";
function bitAndNumber(D, E) {
  if (!isInteger(D) || !isInteger(E)) throw Error("Integers expected in function bitAnd");
  return D & E;
}
bitAndNumber.signature = n2$2;
function bitNotNumber(D) {
  if (!isInteger(D)) throw Error("Integer expected in function bitNot");
  return ~D;
}
bitNotNumber.signature = n1$3;
function bitOrNumber(D, E) {
  if (!isInteger(D) || !isInteger(E)) throw Error("Integers expected in function bitOr");
  return D | E;
}
bitOrNumber.signature = n2$2;
function bitXorNumber(D, E) {
  if (!isInteger(D) || !isInteger(E)) throw Error("Integers expected in function bitXor");
  return D ^ E;
}
bitXorNumber.signature = n2$2;
function leftShiftNumber(D, E) {
  if (!isInteger(D) || !isInteger(E)) throw Error("Integers expected in function leftShift");
  return D << E;
}
leftShiftNumber.signature = n2$2;
function rightArithShiftNumber(D, E) {
  if (!isInteger(D) || !isInteger(E)) throw Error("Integers expected in function rightArithShift");
  return D >> E;
}
rightArithShiftNumber.signature = n2$2;
function rightLogShiftNumber(D, E) {
  if (!isInteger(D) || !isInteger(E)) throw Error("Integers expected in function rightLogShift");
  return D >>> E;
}
rightLogShiftNumber.signature = n2$2;
function product(D, E) {
  if (E < D) return 1;
  if (E === D) return E;
  var O = E + D >> 1;
  return product(D, O) * product(O + 1, E);
}
function combinationsNumber(D, E) {
  if (!isInteger(D) || D < 0 || !isInteger(E) || E < 0) throw TypeError("Positive integer value expected in function combinations");
  if (E > D) throw TypeError("k must be less than or equal to n");
  for (var O = D - E, F = 1, I = E < O ? O + 1 : E + 1, z = 2, R = E < O ? E : O, L = I; L <= D; ++L) for (F *= L; z <= R && F % z === 0; ) F /= z, ++z;
  return z <= R && (F /= product(z, R)), F;
}
combinationsNumber.signature = "number, number";
var pi = Math.PI, tau = 2 * Math.PI, e$1 = Math.E, phi = 1.618033988749895, n1$2 = "number", n2$1 = "number, number";
function notNumber(D) {
  return !D;
}
notNumber.signature = n1$2;
function orNumber(D, E) {
  return !!(D || E);
}
orNumber.signature = n2$1;
function xorNumber(D, E) {
  return !!D != !!E;
}
xorNumber.signature = n2$1;
function andNumber(D, E) {
  return !!(D && E);
}
andNumber.signature = n2$1;
function gammaNumber(D) {
  var E;
  if (isInteger(D)) return D <= 0 ? Number.isFinite(D) ? 1 / 0 : NaN : D > 171 ? 1 / 0 : product(1, D - 1);
  if (D < 0.5) return Math.PI / (Math.sin(Math.PI * D) * gammaNumber(1 - D));
  if (D >= 171.35) return 1 / 0;
  if (D > 85) {
    var O = D * D, F = O * D, I = F * D, z = I * D;
    return Math.sqrt(2 * Math.PI / D) * (D / Math.E) ** +D * (1 + 1 / (12 * D) + 1 / (288 * O) - 139 / (51840 * F) - 571 / (2488320 * I) + 163879 / (209018880 * z) + 5246819 / (75246796800 * z * D));
  }
  --D, E = gammaP[0];
  for (var R = 1; R < gammaP.length; ++R) E += gammaP[R] / (D + R);
  var L = D + gammaG + 0.5;
  return Math.sqrt(2 * Math.PI) * L ** +(D + 0.5) * Math.exp(-L) * E;
}
gammaNumber.signature = "number";
var gammaG = 4.7421875, gammaP = [0.9999999999999971, 57.15623566586292, -59.59796035547549, 14.136097974741746, -0.4919138160976202, 3399464998481189e-20, 4652362892704858e-20, -9837447530487956e-20, 1580887032249125e-19, -21026444172410488e-20, 21743961811521265e-20, -1643181065367639e-19, 8441822398385275e-20, -26190838401581408e-21, 36899182659531625e-22], lnSqrt2PI = 0.9189385332046728, lgammaSeries = [1.000000000190015, 76.18009172947146, -86.50532032941678, 24.01409824083091, -1.231739572450155, 0.001208650973866179, -5395239384953e-18];
function lgammaNumber(D) {
  if (D < 0) return NaN;
  if (D === 0) return 1 / 0;
  if (!Number.isFinite(D)) return D;
  if (D < 0.5) return Math.log(Math.PI / Math.sin(Math.PI * D)) - lgammaNumber(1 - D);
  --D;
  for (var E = D + 5 + 0.5, O = lgammaSeries[0], F = 6; F >= 1; F--) O += lgammaSeries[F] / (D + F);
  return lnSqrt2PI + (D + 0.5) * Math.log(E) - E + Math.log(O);
}
lgammaNumber.signature = "number";
var n1$1 = "number";
function acoshNumber(D) {
  return acosh$2(D);
}
acoshNumber.signature = n1$1;
function acotNumber(D) {
  return Math.atan(1 / D);
}
acotNumber.signature = n1$1;
function acothNumber(D) {
  return Number.isFinite(D) ? (Math.log((D + 1) / D) + Math.log(D / (D - 1))) / 2 : 0;
}
acothNumber.signature = n1$1;
function acscNumber(D) {
  return Math.asin(1 / D);
}
acscNumber.signature = n1$1;
function acschNumber(D) {
  var E = 1 / D;
  return Math.log(E + Math.sqrt(E * E + 1));
}
acschNumber.signature = n1$1;
function asecNumber(D) {
  return Math.acos(1 / D);
}
asecNumber.signature = n1$1;
function asechNumber(D) {
  var E = 1 / D, O = Math.sqrt(E * E - 1);
  return Math.log(O + E);
}
asechNumber.signature = n1$1;
function asinhNumber(D) {
  return asinh$2(D);
}
asinhNumber.signature = n1$1;
function atanhNumber(D) {
  return atanh$2(D);
}
atanhNumber.signature = n1$1;
function cotNumber(D) {
  return 1 / Math.tan(D);
}
cotNumber.signature = n1$1;
function cothNumber(D) {
  var E = Math.exp(2 * D);
  return (E + 1) / (E - 1);
}
cothNumber.signature = n1$1;
function cscNumber(D) {
  return 1 / Math.sin(D);
}
cscNumber.signature = n1$1;
function cschNumber(D) {
  return D === 0 ? 1 / 0 : Math.abs(2 / (Math.exp(D) - Math.exp(-D))) * sign$2(D);
}
cschNumber.signature = n1$1;
function secNumber(D) {
  return 1 / Math.cos(D);
}
secNumber.signature = n1$1;
function sechNumber(D) {
  return 2 / (Math.exp(D) + Math.exp(-D));
}
sechNumber.signature = n1$1;
function sinhNumber(D) {
  return sinh$3(D);
}
sinhNumber.signature = n1$1;
var n1 = "number";
function isNegativeNumber(D) {
  return D < 0;
}
isNegativeNumber.signature = n1;
function isPositiveNumber(D) {
  return D > 0;
}
isPositiveNumber.signature = n1;
function isNaNNumber(D) {
  return Number.isNaN(D);
}
isNaNNumber.signature = n1;
function nearlyEqual(D, E) {
  var O = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1e-9, F = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
  if (O <= 0) throw Error("Relative tolerance must be greater than 0");
  if (F < 0) throw Error("Absolute tolerance must be at least 0");
  return D.isNaN() || E.isNaN() ? !1 : !D.isFinite() || !E.isFinite() ? D.eq(E) : D.eq(E) ? !0 : D.minus(E).abs().lte(D.constructor.max(D.constructor.max(D.abs(), E.abs()).mul(O), F));
}
var name$312 = "isNegative", dependencies$312 = ["typed", "config"], createIsNegative = factory(name$312, dependencies$312, (D) => {
  var { typed: E, config: O } = D;
  return E(name$312, { number: (F) => nearlyEqual$1(F, 0, O.relTol, O.absTol) ? !1 : isNegativeNumber(F), BigNumber: (F) => nearlyEqual(F, new F.constructor(0), O.relTol, O.absTol) ? !1 : F.isNeg() && !F.isZero() && !F.isNaN(), bigint: (F) => F < 0n, Fraction: (F) => F.s < 0n, Unit: E.referToSelf((F) => (I) => E.find(F, I.valueType())(I.value)), "Array | Matrix": E.referToSelf((F) => (I) => deepMap(I, F)) });
}), name$311 = "isNumeric", dependencies$311 = ["typed"], createIsNumeric = factory(name$311, dependencies$311, (D) => {
  var { typed: E } = D;
  return E(name$311, { "number | BigNumber | bigint | Fraction | boolean": () => !0, "Complex | Unit | string | null | undefined | Node": () => !1, "Array | Matrix": E.referToSelf((O) => (F) => deepMap(F, O)) });
}), name$310 = "hasNumericValue", dependencies$310 = ["typed", "isNumeric"], createHasNumericValue = factory(name$310, dependencies$310, (D) => {
  var { typed: E, isNumeric: O } = D;
  return E(name$310, { boolean: () => !0, string: function(F) {
    return F.trim().length > 0 && !isNaN(Number(F));
  }, any: function(F) {
    return O(F);
  } });
}), name$309 = "isPositive", dependencies$309 = ["typed", "config"], createIsPositive = factory(name$309, dependencies$309, (D) => {
  var { typed: E, config: O } = D;
  return E(name$309, { number: (F) => nearlyEqual$1(F, 0, O.relTol, O.absTol) ? !1 : isPositiveNumber(F), BigNumber: (F) => nearlyEqual(F, new F.constructor(0), O.relTol, O.absTol) ? !1 : !F.isNeg() && !F.isZero() && !F.isNaN(), bigint: (F) => F > 0n, Fraction: (F) => F.s > 0n && F.n > 0n, Unit: E.referToSelf((F) => (I) => E.find(F, I.valueType())(I.value)), "Array | Matrix": E.referToSelf((F) => (I) => deepMap(I, F)) });
}), name$308 = "isZero", dependencies$308 = ["typed", "equalScalar"], createIsZero = factory(name$308, dependencies$308, (D) => {
  var { typed: E, equalScalar: O } = D;
  return E(name$308, { "number | BigNumber | Complex | Fraction": (F) => O(F, 0), bigint: (F) => F === 0n, Unit: E.referToSelf((F) => (I) => E.find(F, I.valueType())(I.value)), "Array | Matrix": E.referToSelf((F) => (I) => deepMap(I, F)) });
}), name$307 = "isNaN", dependencies$307 = ["typed"], createIsNaN = factory(name$307, dependencies$307, (D) => {
  var { typed: E } = D;
  return E(name$307, { number: isNaNNumber, BigNumber: function(O) {
    return O.isNaN();
  }, bigint: function(O) {
    return !1;
  }, Fraction: function(O) {
    return !1;
  }, Complex: function(O) {
    return O.isNaN();
  }, Unit: function(O) {
    return Number.isNaN(O.value);
  }, "Array | Matrix": E.referToSelf((O) => (F) => deepMap(F, O)) });
}), name$306 = "isBounded", dependencies$306 = ["typed"], createIsBounded = factory(name$306, dependencies$306, (D) => {
  var { typed: E } = D;
  return E(name$306, { number: (O) => Number.isFinite(O), "BigNumber | Complex": (O) => O.isFinite(), "bigint | Fraction": () => !0, "null | undefined": () => !1, Unit: E.referToSelf((O) => (F) => O(F.value)), "Array | Matrix": E.referToSelf((O) => (F) => (Array.isArray(F) || (F = F.valueOf()), F.every((I) => O(I)))) });
}), name$305 = "isFinite", dependencies$305 = ["typed", "isBounded", "map"], createIsFinite = factory(name$305, dependencies$305, (D) => {
  var { typed: E, isBounded: O, map: F } = D;
  return E(name$305, { "Array | Matrix": (I) => F(I, O), any: (I) => O(I) });
}), name$304 = "typeOf", dependencies$304 = ["typed"], createTypeOf = factory(name$304, dependencies$304, (D) => {
  var { typed: E } = D;
  return E(name$304, { any: typeOf });
});
function complexEquals(D, E, O, F) {
  return nearlyEqual$1(D.re, E.re, O, F) && nearlyEqual$1(D.im, E.im, O, F);
}
var createCompareUnits = factory("compareUnits", ["typed"], (D) => {
  var { typed: E } = D;
  return { "Unit, Unit": E.referToSelf((O) => (F, I) => {
    if (!F.equalBase(I)) throw Error("Cannot compare units with different base");
    return E.find(O, [F.valueType(), I.valueType()])(F.value, I.value);
  }) };
}), name$303 = "equalScalar", dependencies$303 = ["typed", "config"], createEqualScalar = factory(name$303, dependencies$303, (D) => {
  var { typed: E, config: O } = D;
  return E(name$303, { "boolean, boolean": function(F, I) {
    return F === I;
  }, "number, number": function(F, I) {
    return nearlyEqual$1(F, I, O.relTol, O.absTol);
  }, "BigNumber, BigNumber": function(F, I) {
    return F.eq(I) || nearlyEqual(F, I, O.relTol, O.absTol);
  }, "bigint, bigint": function(F, I) {
    return F === I;
  }, "Fraction, Fraction": function(F, I) {
    return F.equals(I);
  }, "Complex, Complex": function(F, I) {
    return complexEquals(F, I, O.relTol, O.absTol);
  } }, createCompareUnits({ typed: E }));
});
factory(name$303, ["typed", "config"], (D) => {
  var { typed: E, config: O } = D;
  return E(name$303, { "number, number": function(F, I) {
    return nearlyEqual$1(F, I, O.relTol, O.absTol);
  } });
});
var name$302 = "SparseMatrix", dependencies$302 = ["typed", "equalScalar", "Matrix"], createSparseMatrixClass = factory(name$302, dependencies$302, (D) => {
  var { typed: E, equalScalar: O, Matrix: F } = D;
  function I(X, Y) {
    if (!(this instanceof I)) throw SyntaxError("Constructor must be called with the new operator");
    if (Y && !isString(Y)) throw Error("Invalid datatype: " + Y);
    if (isMatrix(X)) z(this, X, Y);
    else if (X && isArray(X.index) && isArray(X.ptr) && isArray(X.size)) this._values = X.values, this._index = X.index, this._ptr = X.ptr, this._size = X.size, this._datatype = Y || X.datatype;
    else if (isArray(X)) R(this, X, Y);
    else {
      if (X) throw TypeError("Unsupported type of data (" + typeOf(X) + ")");
      this._values = [], this._index = [], this._ptr = [0], this._size = [0, 0], this._datatype = Y;
    }
  }
  function z(X, Y, ee) {
    Y.type === "SparseMatrix" ? (X._values = Y._values ? clone$3(Y._values) : void 0, X._index = clone$3(Y._index), X._ptr = clone$3(Y._ptr), X._size = clone$3(Y._size), X._datatype = ee || Y._datatype) : R(X, Y.valueOf(), ee || Y._datatype);
  }
  function R(X, Y, ee) {
    X._values = [], X._index = [], X._ptr = [], X._datatype = ee;
    var K = Y.length, te = 0, ie = O, ne = 0;
    if (isString(ee) && (ie = E.find(O, [ee, ee]) || O, ne = E.convert(0, ee)), K > 0) {
      var ae = 0;
      do {
        X._ptr.push(X._index.length);
        for (var ue = 0; ue < K; ue++) {
          var oe = Y[ue];
          if (isArray(oe)) {
            if (ae === 0 && te < oe.length && (te = oe.length), ae < oe.length) {
              var se = oe[ae];
              ie(se, ne) || (X._values.push(se), X._index.push(ue));
            }
          } else ae === 0 && te < 1 && (te = 1), ie(oe, ne) || (X._values.push(oe), X._index.push(ue));
        }
        ae++;
      } while (ae < te);
    }
    for (; X._ptr.length <= te; ) X._ptr.push(X._index.length);
    X._size = [K, te];
  }
  I.prototype = new F(), I.prototype.createSparseMatrix = function(X, Y) {
    return new I(X, Y);
  }, Object.defineProperty(I, "name", { value: "SparseMatrix" }), I.prototype.constructor = I, I.prototype.type = "SparseMatrix", I.prototype.isSparseMatrix = !0, I.prototype.getDataType = function() {
    return getArrayDataType(this._values, typeOf);
  }, I.prototype.storage = function() {
    return "sparse";
  }, I.prototype.datatype = function() {
    return this._datatype;
  }, I.prototype.create = function(X, Y) {
    return new I(X, Y);
  }, I.prototype.density = function() {
    var X = this._size[0], Y = this._size[1];
    return X !== 0 && Y !== 0 ? this._index.length / (X * Y) : 0;
  }, I.prototype.subset = function(X, Y, ee) {
    if (!this._values) throw Error("Cannot invoke subset on a Pattern only matrix");
    switch (arguments.length) {
      case 1:
        return L(this, X);
      case 2:
      case 3:
        return q(this, X, Y, ee);
      default:
        throw SyntaxError("Wrong number of arguments");
    }
  };
  function L(X, Y) {
    if (!isIndex(Y)) throw TypeError("Invalid index");
    if (Y.isScalar()) return X.get(Y.min());
    var ee = Y.size();
    if (ee.length !== X._size.length) throw new DimensionError(ee.length, X._size.length);
    var K, te, ie, ne, ae = Y.min(), ue = Y.max();
    for (K = 0, te = X._size.length; K < te; K++) validateIndex(ae[K], X._size[K]), validateIndex(ue[K], X._size[K]);
    var oe = X._values, se = X._index, le = X._ptr, ce = Y.dimension(0), fe = Y.dimension(1), pe = [], ve = [];
    function _e(Ce, Ie) {
      ve[Ce] = Ie[0], pe[Ce] = !0;
    }
    Number.isInteger(ce) ? _e(ce, [0]) : ce.forEach(_e);
    var de = oe ? [] : void 0, ge = [], ye = [];
    function De(Ce) {
      for (ye.push(ge.length), ie = le[Ce], ne = le[Ce + 1]; ie < ne; ie++) K = se[ie], pe[K] === !0 && (ge.push(ve[K]), de && de.push(oe[ie]));
    }
    return Number.isInteger(fe) ? De(fe) : fe.forEach(De), ye.push(ge.length), new I({ values: de, index: ge, ptr: ye, size: ee, datatype: X._datatype });
  }
  function q(X, Y, ee, K) {
    if (!Y || Y.isIndex !== !0) throw TypeError("Invalid index");
    var te = Y.size(), ie = Y.isScalar(), ne;
    if (isMatrix(ee) ? (ne = ee.size(), ee = ee.toArray()) : ne = arraySize(ee), ie) {
      if (ne.length !== 0) throw TypeError("Scalar expected");
      X.set(Y.min(), ee, K);
    } else {
      if (te.length !== 1 && te.length !== 2) throw new DimensionError(te.length, X._size.length, "<");
      if (ne.length < te.length) {
        for (var ae = 0, ue = 0; te[ae] === 1 && ne[ae] === 1; ) ae++;
        for (; te[ae] === 1; ) ue++, ae++;
        ee = unsqueeze(ee, te.length, ue, ne);
      }
      if (!deepStrictEqual(te, ne)) throw new DimensionError(te, ne, ">");
      if (te.length === 1) le(Y.dimension(0), (ce, fe) => {
        validateIndex(ce), X.set([ce, 0], ee[fe[0]], K);
      });
      else {
        var oe = Y.dimension(0), se = Y.dimension(1);
        le(oe, (ce, fe) => {
          validateIndex(ce), le(se, (pe, ve) => {
            validateIndex(pe), X.set([ce, pe], ee[fe[0]][ve[0]], K);
          });
        });
      }
    }
    return X;
    function le(ce, fe) {
      isNumber(ce) ? fe(ce, [0]) : ce.forEach(fe);
    }
  }
  I.prototype.get = function(X) {
    if (!isArray(X)) throw TypeError("Array expected");
    if (X.length !== this._size.length) throw new DimensionError(X.length, this._size.length);
    if (!this._values) throw Error("Cannot invoke get on a Pattern only matrix");
    var Y = X[0], ee = X[1];
    validateIndex(Y, this._size[0]), validateIndex(ee, this._size[1]);
    var K = U(Y, this._ptr[ee], this._ptr[ee + 1], this._index);
    return K < this._ptr[ee + 1] && this._index[K] === Y ? this._values[K] : 0;
  }, I.prototype.set = function(X, Y, ee) {
    if (!isArray(X)) throw TypeError("Array expected");
    if (X.length !== this._size.length) throw new DimensionError(X.length, this._size.length);
    if (!this._values) throw Error("Cannot invoke set on a Pattern only matrix");
    var K = X[0], te = X[1], ie = this._size[0], ne = this._size[1], ae = O, ue = 0;
    isString(this._datatype) && (ae = E.find(O, [this._datatype, this._datatype]) || O, ue = E.convert(0, this._datatype)), (K > ie - 1 || te > ne - 1) && (G(this, Math.max(K + 1, ie), Math.max(te + 1, ne), ee), ie = this._size[0], ne = this._size[1]), validateIndex(K, ie), validateIndex(te, ne);
    var oe = U(K, this._ptr[te], this._ptr[te + 1], this._index);
    return oe < this._ptr[te + 1] && this._index[oe] === K ? ae(Y, ue) ? Z(oe, te, this._values, this._index, this._ptr) : this._values[oe] = Y : ae(Y, ue) || V(oe, K, te, Y, this._values, this._index, this._ptr), this;
  };
  function U(X, Y, ee, K) {
    if (ee - Y === 0) return ee;
    for (var te = Y; te < ee; te++) if (K[te] === X) return te;
    return Y;
  }
  function Z(X, Y, ee, K, te) {
    ee.splice(X, 1), K.splice(X, 1);
    for (var ie = Y + 1; ie < te.length; ie++) te[ie]--;
  }
  function V(X, Y, ee, K, te, ie, ne) {
    te.splice(X, 0, K), ie.splice(X, 0, Y);
    for (var ae = ee + 1; ae < ne.length; ae++) ne[ae]++;
  }
  I.prototype.resize = function(X, Y, ee) {
    if (!isCollection(X)) throw TypeError("Array or Matrix expected");
    var K = X.valueOf().map((te) => Array.isArray(te) && te.length === 1 ? te[0] : te);
    if (K.length !== 2) throw Error("Only two dimensions matrix are supported");
    return K.forEach(function(te) {
      if (!isNumber(te) || !isInteger(te) || te < 0) throw TypeError("Invalid size, must contain positive integers (size: " + format(K) + ")");
    }), G(ee ? this.clone() : this, K[0], K[1], Y);
  };
  function G(X, Y, ee, K) {
    var te = K || 0, ie = O, ne = 0;
    isString(X._datatype) && (ie = E.find(O, [X._datatype, X._datatype]) || O, ne = E.convert(0, X._datatype), te = E.convert(te, X._datatype));
    var ae = !ie(te, ne), ue = X._size[0], oe = X._size[1], se, le, ce;
    if (ee > oe) {
      for (le = oe; le < ee; le++) if (X._ptr[le] = X._values.length, ae) for (se = 0; se < ue; se++) X._values.push(te), X._index.push(se);
      X._ptr[ee] = X._values.length;
    } else ee < oe && (X._ptr.splice(ee + 1, oe - ee), X._values.splice(X._ptr[ee], X._values.length), X._index.splice(X._ptr[ee], X._index.length));
    if (oe = ee, Y > ue) {
      if (ae) {
        var fe = 0;
        for (le = 0; le < oe; le++) {
          X._ptr[le] = X._ptr[le] + fe, ce = X._ptr[le + 1] + fe;
          var pe = 0;
          for (se = ue; se < Y; se++, pe++) X._values.splice(ce + pe, 0, te), X._index.splice(ce + pe, 0, se), fe++;
        }
        X._ptr[oe] = X._values.length;
      }
    } else if (Y < ue) {
      var ve = 0;
      for (le = 0; le < oe; le++) {
        X._ptr[le] = X._ptr[le] - ve;
        var _e = X._ptr[le], de = X._ptr[le + 1] - ve;
        for (ce = _e; ce < de; ce++) se = X._index[ce], se > Y - 1 && (X._values.splice(ce, 1), X._index.splice(ce, 1), ve++);
      }
      X._ptr[le] = X._values.length;
    }
    return X._size[0] = Y, X._size[1] = ee, X;
  }
  I.prototype.reshape = function(X, Y) {
    if (!isArray(X)) throw TypeError("Array expected");
    if (X.length !== 2) throw Error("Sparse matrices can only be reshaped in two dimensions");
    X.forEach(function(ge) {
      if (!isNumber(ge) || !isInteger(ge) || ge <= -2 || ge === 0) throw TypeError("Invalid size, must contain positive integers or -1 (size: " + format(X) + ")");
    });
    var ee = this._size[0] * this._size[1];
    if (X = processSizesWildcard(X, ee), ee !== X[0] * X[1]) throw Error("Reshaping sparse matrix will result in the wrong number of elements");
    var K = Y ? this.clone() : this;
    if (this._size[0] === X[0] && this._size[1] === X[1]) return K;
    for (var te = [], ie = 0; ie < K._ptr.length; ie++) for (var ne = 0; ne < K._ptr[ie + 1] - K._ptr[ie]; ne++) te.push(ie);
    for (var ae = K._values.slice(), ue = K._index.slice(), oe = 0; oe < K._index.length; oe++) {
      var se = ue[oe], le = te[oe], ce = se * K._size[1] + le;
      te[oe] = ce % X[1], ue[oe] = Math.floor(ce / X[1]);
    }
    K._values.length = 0, K._index.length = 0, K._ptr.length = X[1] + 1, K._size = X.slice();
    for (var fe = 0; fe < K._ptr.length; fe++) K._ptr[fe] = 0;
    for (var pe = 0; pe < ae.length; pe++) {
      var ve = ue[pe], _e = te[pe], de = ae[pe];
      V(U(ve, K._ptr[_e], K._ptr[_e + 1], K._index), ve, _e, de, K._values, K._index, K._ptr);
    }
    return K;
  }, I.prototype.clone = function() {
    return new I({ values: this._values ? clone$3(this._values) : void 0, index: clone$3(this._index), ptr: clone$3(this._ptr), size: clone$3(this._size), datatype: this._datatype });
  }, I.prototype.size = function() {
    return this._size.slice(0);
  }, I.prototype.map = function(X, Y) {
    if (!this._values) throw Error("Cannot invoke map on a Pattern only matrix");
    var ee = this, K = this._size[0], te = this._size[1], ie = optimizeCallback(X, ee, "map");
    return W(this, 0, K - 1, 0, te - 1, function(ne, ae, ue) {
      return ie.fn(ne, [ae, ue], ee);
    }, Y);
  };
  function W(X, Y, ee, K, te, ie, ne) {
    var ae = [], ue = [], oe = [], se = O, le = 0;
    isString(X._datatype) && (se = E.find(O, [X._datatype, X._datatype]) || O, le = E.convert(0, X._datatype));
    for (var ce = function(Ie, Ne, he) {
      var ke = ie(Ie, Ne, he);
      se(ke, le) || (ae.push(ke), ue.push(Ne));
    }, fe = K; fe <= te; fe++) {
      oe.push(ae.length);
      var pe = X._ptr[fe], ve = X._ptr[fe + 1];
      if (ne) for (var _e = pe; _e < ve; _e++) {
        var de = X._index[_e];
        de >= Y && de <= ee && ce(X._values[_e], de - Y, fe - K);
      }
      else {
        for (var ge = {}, ye = pe; ye < ve; ye++) {
          var De = X._index[ye];
          ge[De] = X._values[ye];
        }
        for (var Ce = Y; Ce <= ee; Ce++) ce(Ce in ge ? ge[Ce] : 0, Ce - Y, fe - K);
      }
    }
    return oe.push(ae.length), new I({ values: ae, index: ue, ptr: oe, size: [ee - Y + 1, te - K + 1] });
  }
  I.prototype.forEach = function(X, Y) {
    if (!this._values) throw Error("Cannot invoke forEach on a Pattern only matrix");
    for (var ee = this, K = this._size[0], te = this._size[1], ie = optimizeCallback(X, ee, "forEach"), ne = 0; ne < te; ne++) {
      var ae = this._ptr[ne], ue = this._ptr[ne + 1];
      if (Y) for (var oe = ae; oe < ue; oe++) {
        var se = this._index[oe];
        ie.fn(this._values[oe], [se, ne], ee);
      }
      else {
        for (var le = {}, ce = ae; ce < ue; ce++) {
          var fe = this._index[ce];
          le[fe] = this._values[ce];
        }
        for (var pe = 0; pe < K; pe++) {
          var ve = pe in le ? le[pe] : 0;
          ie.fn(ve, [pe, ne], ee);
        }
      }
    }
  }, I.prototype[Symbol.iterator] = function* () {
    if (!this._values) throw Error("Cannot iterate a Pattern only matrix");
    for (var X = this._size[1], Y = 0; Y < X; Y++) for (var ee = this._ptr[Y], K = this._ptr[Y + 1], te = ee; te < K; te++) {
      var ie = this._index[te];
      yield { value: this._values[te], index: [ie, Y] };
    }
  }, I.prototype.toArray = function() {
    return J(this._values, this._index, this._ptr, this._size, !0);
  }, I.prototype.valueOf = function() {
    return J(this._values, this._index, this._ptr, this._size, !1);
  };
  function J(X, Y, ee, K, te) {
    var ie = K[0], ne = K[1], ae = [], ue, oe;
    for (ue = 0; ue < ie; ue++) for (ae[ue] = [], oe = 0; oe < ne; oe++) ae[ue][oe] = 0;
    for (oe = 0; oe < ne; oe++) for (var se = ee[oe], le = ee[oe + 1], ce = se; ce < le; ce++) ue = Y[ce], ae[ue][oe] = X ? te ? clone$3(X[ce]) : X[ce] : 1;
    return ae;
  }
  return I.prototype.format = function(X) {
    for (var Y = this._size[0], ee = this._size[1], K = this.density(), te = "Sparse Matrix [" + format(Y, X) + " x " + format(ee, X) + "] density: " + format(K, X) + `
`, ie = 0; ie < ee; ie++) for (var ne = this._ptr[ie], ae = this._ptr[ie + 1], ue = ne; ue < ae; ue++) {
      var oe = this._index[ue];
      te += `
    (` + format(oe, X) + ", " + format(ie, X) + ") ==> " + (this._values ? format(this._values[ue], X) : "X");
    }
    return te;
  }, I.prototype.toString = function() {
    return format(this.toArray());
  }, I.prototype.toJSON = function() {
    return { mathjs: "SparseMatrix", values: this._values, index: this._index, ptr: this._ptr, size: this._size, datatype: this._datatype };
  }, I.prototype.diagonal = function(X) {
    if (X) {
      if (isBigNumber(X) && (X = X.toNumber()), !isNumber(X) || !isInteger(X)) throw TypeError("The parameter k must be an integer number");
    } else X = 0;
    var Y = X > 0 ? X : 0, ee = X < 0 ? -X : 0, K = this._size[0], te = this._size[1], ie = Math.min(K - ee, te - Y), ne = [], ae = [], ue = [];
    ue[0] = 0;
    for (var oe = Y; oe < te && ne.length < ie; oe++) for (var se = this._ptr[oe], le = this._ptr[oe + 1], ce = se; ce < le; ce++) {
      var fe = this._index[ce];
      if (fe === oe - Y + ee) {
        ne.push(this._values[ce]), ae[ne.length - 1] = fe - ee;
        break;
      }
    }
    return ue.push(ne.length), new I({ values: ne, index: ae, ptr: ue, size: [ie, 1] });
  }, I.fromJSON = function(X) {
    return new I(X);
  }, I.diagonal = function(X, Y, ee, K, te) {
    if (!isArray(X)) throw TypeError("Array expected, size parameter");
    if (X.length !== 2) throw Error("Only two dimensions matrix are supported");
    if (X = X.map(function(De) {
      if (isBigNumber(De) && (De = De.toNumber()), !isNumber(De) || !isInteger(De) || De < 1) throw Error("Size values must be positive integers");
      return De;
    }), ee) {
      if (isBigNumber(ee) && (ee = ee.toNumber()), !isNumber(ee) || !isInteger(ee)) throw TypeError("The parameter k must be an integer number");
    } else ee = 0;
    var ie = O, ne = 0;
    isString(te) && (ie = E.find(O, [te, te]) || O, ne = E.convert(0, te));
    var ae = ee > 0 ? ee : 0, ue = ee < 0 ? -ee : 0, oe = X[0], se = X[1], le = Math.min(oe - ue, se - ae), ce;
    if (isArray(Y)) {
      if (Y.length !== le) throw Error("Invalid value array length");
      ce = function(De) {
        return Y[De];
      };
    } else if (isMatrix(Y)) {
      var fe = Y.size();
      if (fe.length !== 1 || fe[0] !== le) throw Error("Invalid matrix length");
      ce = function(De) {
        return Y.get([De]);
      };
    } else ce = function() {
      return Y;
    };
    for (var pe = [], ve = [], _e = [], de = 0; de < se; de++) {
      _e.push(pe.length);
      var ge = de - ae;
      if (ge >= 0 && ge < le) {
        var ye = ce(ge);
        ie(ye, ne) || (ve.push(ge + ue), pe.push(ye));
      }
    }
    return _e.push(pe.length), new I({ values: pe, index: ve, ptr: _e, size: [oe, se] });
  }, I.prototype.swapRows = function(X, Y) {
    if (!isNumber(X) || !isInteger(X) || !isNumber(Y) || !isInteger(Y)) throw Error("Row index must be positive integers");
    if (this._size.length !== 2) throw Error("Only two dimensional matrix is supported");
    return validateIndex(X, this._size[0]), validateIndex(Y, this._size[0]), I._swapRows(X, Y, this._size[1], this._values, this._index, this._ptr), this;
  }, I._forEachRow = function(X, Y, ee, K, te) {
    for (var ie = K[X], ne = K[X + 1], ae = ie; ae < ne; ae++) te(ee[ae], Y[ae]);
  }, I._swapRows = function(X, Y, ee, K, te, ie) {
    for (var ne = 0; ne < ee; ne++) {
      var ae = ie[ne], ue = ie[ne + 1], oe = U(X, ae, ue, te), se = U(Y, ae, ue, te);
      if (oe < ue && se < ue && te[oe] === X && te[se] === Y) {
        if (K) {
          var le = K[oe];
          K[oe] = K[se], K[se] = le;
        }
        continue;
      }
      if (oe < ue && te[oe] === X && (se >= ue || te[se] !== Y)) {
        var ce = K ? K[oe] : void 0;
        te.splice(se, 0, Y), K && K.splice(se, 0, ce), te.splice(se <= oe ? oe + 1 : oe, 1), K && K.splice(se <= oe ? oe + 1 : oe, 1);
        continue;
      }
      if (se < ue && te[se] === Y && (oe >= ue || te[oe] !== X)) {
        var fe = K ? K[se] : void 0;
        te.splice(oe, 0, X), K && K.splice(oe, 0, fe), te.splice(oe <= se ? se + 1 : se, 1), K && K.splice(oe <= se ? se + 1 : se, 1);
      }
    }
  }, I;
}, { isClass: !0 }), name$301 = "number", dependencies$301 = ["typed"];
function getNonDecimalNumberParts(D) {
  var E = D.match(/(0[box])([0-9a-fA-F]*)\.([0-9a-fA-F]*)/);
  return E ? { input: D, radix: { "0b": 2, "0o": 8, "0x": 16 }[E[1]], integerPart: E[2], fractionalPart: E[3] } : null;
}
function makeNumberFromNonDecimalParts(D) {
  for (var E = parseInt(D.integerPart, D.radix), O = 0, F = 0; F < D.fractionalPart.length; F++) {
    var I = parseInt(D.fractionalPart[F], D.radix);
    O += I / D.radix ** +(F + 1);
  }
  var z = E + O;
  if (isNaN(z)) throw SyntaxError('String "' + D.input + '" is not a valid number');
  return z;
}
var createNumber = factory(name$301, dependencies$301, (D) => {
  var { typed: E } = D, O = E("number", { "": function() {
    return 0;
  }, number: function(F) {
    return F;
  }, string: function(F) {
    if (F === "NaN") return NaN;
    var I = getNonDecimalNumberParts(F);
    if (I) return makeNumberFromNonDecimalParts(I);
    var z = 0, R = F.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
    R && (z = Number(R[2]), F = R[1]);
    var L = Number(F);
    if (isNaN(L)) throw SyntaxError('String "' + F + '" is not a valid number');
    if (R) {
      if (L > 2 ** z - 1) throw SyntaxError(`String "${F}" is out of range`);
      L >= 2 ** (z - 1) && (L -= 2 ** z);
    }
    return L;
  }, BigNumber: function(F) {
    return F.toNumber();
  }, bigint: function(F) {
    return Number(F);
  }, Fraction: function(F) {
    return F.valueOf();
  }, Unit: E.referToSelf((F) => (I) => {
    var z = I.clone();
    return z.value = F(I.value), z;
  }), null: function(F) {
    return 0;
  }, "Unit, string | Unit": function(F, I) {
    return F.toNumber(I);
  }, "Array | Matrix": E.referToSelf((F) => (I) => deepMap(I, F)) });
  return O.fromJSON = function(F) {
    return parseFloat(F.value);
  }, O;
}), name$300 = "bigint", dependencies$300 = ["typed"], createBigint = factory(name$300, dependencies$300, (D) => {
  var { typed: E } = D, O = E("bigint", { "": function() {
    return 0n;
  }, bigint: function(F) {
    return F;
  }, number: function(F) {
    return BigInt(F.toFixed());
  }, BigNumber: function(F) {
    return BigInt(F.round().toString());
  }, Fraction: function(F) {
    return BigInt(F.valueOf().toFixed());
  }, "string | boolean": function(F) {
    return BigInt(F);
  }, null: function(F) {
    return 0n;
  }, "Array | Matrix": E.referToSelf((F) => (I) => deepMap(I, F)) });
  return O.fromJSON = function(F) {
    return BigInt(F.value);
  }, O;
}), name$299 = "string", dependencies$299 = ["typed"], createString = factory(name$299, dependencies$299, (D) => {
  var { typed: E } = D;
  return E(name$299, { "": function() {
    return "";
  }, number: format$2, null: function(O) {
    return "null";
  }, boolean: function(O) {
    return O + "";
  }, string: function(O) {
    return O;
  }, "Array | Matrix": E.referToSelf((O) => (F) => deepMap(F, O)), any: function(O) {
    return String(O);
  } });
}), name$298 = "boolean", dependencies$298 = ["typed"], createBoolean = factory(name$298, dependencies$298, (D) => {
  var { typed: E } = D;
  return E(name$298, { "": function() {
    return !1;
  }, boolean: function(O) {
    return O;
  }, number: function(O) {
    return !!O;
  }, null: function(O) {
    return !1;
  }, BigNumber: function(O) {
    return !O.isZero();
  }, string: function(O) {
    var F = O.toLowerCase();
    if (F === "true") return !0;
    if (F === "false") return !1;
    var I = Number(O);
    if (O !== "" && !isNaN(I)) return !!I;
    throw Error('Cannot convert "' + O + '" to a boolean');
  }, "Array | Matrix": E.referToSelf((O) => (F) => deepMap(F, O)) });
}), name$297 = "bignumber", dependencies$297 = ["typed", "BigNumber"], createBignumber = factory(name$297, dependencies$297, (D) => {
  var { typed: E, BigNumber: O } = D;
  return E("bignumber", { "": function() {
    return new O(0);
  }, number: function(F) {
    return new O(F + "");
  }, string: function(F) {
    var I = F.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
    if (I) {
      var z = I[2], R = O(I[1]), L = new O(2).pow(Number(z));
      if (R.gt(L.sub(1))) throw SyntaxError(`String "${F}" is out of range`);
      var q = new O(2).pow(Number(z) - 1);
      return R.gte(q) ? R.sub(L) : R;
    }
    return new O(F);
  }, BigNumber: function(F) {
    return F;
  }, bigint: function(F) {
    return new O(F.toString());
  }, Unit: E.referToSelf((F) => (I) => {
    var z = I.clone();
    return z.value = F(I.value), z;
  }), Fraction: function(F) {
    return new O(String(F.n)).div(String(F.d)).times(String(F.s));
  }, null: function(F) {
    return new O(0);
  }, "Array | Matrix": E.referToSelf((F) => (I) => deepMap(I, F)) });
}), name$296 = "complex", dependencies$296 = ["typed", "Complex"], createComplex = factory(name$296, dependencies$296, (D) => {
  var { typed: E, Complex: O } = D;
  return E("complex", { "": function() {
    return O.ZERO;
  }, number: function(F) {
    return new O(F, 0);
  }, "number, number": function(F, I) {
    return new O(F, I);
  }, "BigNumber, BigNumber": function(F, I) {
    return new O(F.toNumber(), I.toNumber());
  }, Fraction: function(F) {
    return new O(F.valueOf(), 0);
  }, Complex: function(F) {
    return F.clone();
  }, string: function(F) {
    return O(F);
  }, null: function(F) {
    return O(0);
  }, Object: function(F) {
    if ("re" in F && "im" in F) return new O(F.re, F.im);
    if ("r" in F && "phi" in F || "abs" in F && "arg" in F) return new O(F);
    throw Error("Expected object with properties (re and im) or (r and phi) or (abs and arg)");
  }, "Array | Matrix": E.referToSelf((F) => (I) => deepMap(I, F)) });
}), name$295 = "fraction", dependencies$295 = ["typed", "Fraction"], createFraction = factory(name$295, dependencies$295, (D) => {
  var { typed: E, Fraction: O } = D;
  return E("fraction", { number: function(F) {
    if (!Number.isFinite(F) || isNaN(F)) throw Error(F + " cannot be represented as a fraction");
    return new O(F);
  }, string: function(F) {
    return new O(F);
  }, "number, number": function(F, I) {
    return new O(F, I);
  }, "bigint, bigint": function(F, I) {
    return new O(F, I);
  }, null: function(F) {
    return new O(0);
  }, BigNumber: function(F) {
    return new O(F.toString());
  }, bigint: function(F) {
    return new O(F.toString());
  }, Fraction: function(F) {
    return F;
  }, Unit: E.referToSelf((F) => (I) => {
    var z = I.clone();
    return z.value = F(I.value), z;
  }), Object: function(F) {
    return new O(F);
  }, "Array | Matrix": E.referToSelf((F) => (I) => deepMap(I, F)) });
}), name$294 = "matrix", dependencies$294 = ["typed", "Matrix", "DenseMatrix", "SparseMatrix"], createMatrix = factory(name$294, dependencies$294, (D) => {
  var { typed: E, Matrix: O, DenseMatrix: F, SparseMatrix: I } = D;
  return E(name$294, { "": function() {
    return z([]);
  }, string: function(R) {
    return z([], R);
  }, "string, string": function(R, L) {
    return z([], R, L);
  }, Array: function(R) {
    return z(R);
  }, Matrix: function(R) {
    return z(R, R.storage());
  }, "Array | Matrix, string": z, "Array | Matrix, string, string": z });
  function z(R, L, q) {
    if (L === "dense" || L === "default" || L === void 0) return new F(R, q);
    if (L === "sparse") return new I(R, q);
    throw TypeError("Unknown matrix type " + JSON.stringify(L) + ".");
  }
}), name$293 = "matrixFromFunction", dependencies$293 = ["typed", "matrix", "isZero"], createMatrixFromFunction = factory(name$293, dependencies$293, (D) => {
  var { typed: E, matrix: O, isZero: F } = D;
  return E(name$293, { "Array | Matrix, function, string, string": function(z, R, L, q) {
    return I(z, R, L, q);
  }, "Array | Matrix, function, string": function(z, R, L) {
    return I(z, R, L);
  }, "Matrix, function": function(z, R) {
    return I(z, R, "dense");
  }, "Array, function": function(z, R) {
    return I(z, R, "dense").toArray();
  }, "Array | Matrix, string, function": function(z, R, L) {
    return I(z, L, R);
  }, "Array | Matrix, string, string, function": function(z, R, L, q) {
    return I(z, q, R, L);
  } });
  function I(z, R, L, q) {
    var U = q === void 0 ? O(L) : O(L, q);
    return U.resize(z), U.forEach(function(Z, V) {
      var G = R(V);
      F(G) || U.set(V, G);
    }), U;
  }
}), name$292 = "matrixFromRows", dependencies$292 = ["typed", "matrix", "flatten", "size"], createMatrixFromRows = factory(name$292, dependencies$292, (D) => {
  var { typed: E, matrix: O, flatten: F, size: I } = D;
  return E(name$292, { "...Array": function(L) {
    return z(L);
  }, "...Matrix": function(L) {
    return O(z(L.map((q) => q.toArray())));
  } });
  function z(L) {
    if (L.length === 0) throw TypeError("At least one row is needed to construct a matrix.");
    var q = R(L[0]), U = [];
    for (var Z of L) {
      var V = R(Z);
      if (V !== q) throw TypeError("The vectors had different length: " + (q | 0) + " ≠ " + (V | 0));
      U.push(F(Z));
    }
    return U;
  }
  function R(L) {
    var q = I(L);
    if (q.length === 1) return q[0];
    if (q.length === 2) {
      if (q[0] === 1) return q[1];
      if (q[1] === 1) return q[0];
      throw TypeError("At least one of the arguments is not a vector.");
    } else throw TypeError("Only one- or two-dimensional vectors are supported.");
  }
}), name$291 = "matrixFromColumns", dependencies$291 = ["typed", "matrix", "flatten", "size"], createMatrixFromColumns = factory(name$291, dependencies$291, (D) => {
  var { typed: E, matrix: O, flatten: F, size: I } = D;
  return E(name$291, { "...Array": function(L) {
    return z(L);
  }, "...Matrix": function(L) {
    return O(z(L.map((q) => q.toArray())));
  } });
  function z(L) {
    if (L.length === 0) throw TypeError("At least one column is needed to construct a matrix.");
    for (var q = R(L[0]), U = [], Z = 0; Z < q; Z++) U[Z] = [];
    for (var V of L) {
      var G = R(V);
      if (G !== q) throw TypeError("The vectors had different length: " + (q | 0) + " ≠ " + (G | 0));
      for (var W = F(V), J = 0; J < q; J++) U[J].push(W[J]);
    }
    return U;
  }
  function R(L) {
    var q = I(L);
    if (q.length === 1) return q[0];
    if (q.length === 2) {
      if (q[0] === 1) return q[1];
      if (q[1] === 1) return q[0];
      throw TypeError("At least one of the arguments is not a vector.");
    } else throw TypeError("Only one- or two-dimensional vectors are supported.");
  }
}), name$290 = "splitUnit", dependencies$290 = ["typed"], createSplitUnit = factory(name$290, dependencies$290, (D) => {
  var { typed: E } = D;
  return E(name$290, { "Unit, Array": function(O, F) {
    return O.splitUnit(F);
  } });
}), name$289 = "unaryMinus", dependencies$289 = ["typed"], createUnaryMinus = factory(name$289, dependencies$289, (D) => {
  var { typed: E } = D;
  return E(name$289, { number: unaryMinusNumber, "Complex | BigNumber | Fraction": (O) => O.neg(), bigint: (O) => -O, Unit: E.referToSelf((O) => (F) => {
    var I = F.clone();
    return I.value = E.find(O, I.valueType())(F.value), I;
  }), "Array | Matrix": E.referToSelf((O) => (F) => deepMap(F, O, !0)) });
}), name$288 = "unaryPlus", dependencies$288 = ["typed", "config", "numeric"], createUnaryPlus = factory(name$288, dependencies$288, (D) => {
  var { typed: E, config: O, numeric: F } = D;
  return E(name$288, { number: unaryPlusNumber, Complex: function(I) {
    return I;
  }, BigNumber: function(I) {
    return I;
  }, bigint: function(I) {
    return I;
  }, Fraction: function(I) {
    return I;
  }, Unit: function(I) {
    return I.clone();
  }, "Array | Matrix": E.referToSelf((I) => (z) => deepMap(z, I, !0)), boolean: function(I) {
    return F(+!!I, O.number);
  }, string: function(I) {
    return F(I, safeNumberType(I, O));
  } });
}), name$287 = "abs", dependencies$287 = ["typed"], createAbs = factory(name$287, dependencies$287, (D) => {
  var { typed: E } = D;
  return E(name$287, { number: absNumber, "Complex | BigNumber | Fraction | Unit": (O) => O.abs(), bigint: (O) => O < 0n ? -O : O, "Array | Matrix": E.referToSelf((O) => (F) => deepMap(F, O, !0)) });
}), name$286 = "mapSlices", dependencies$286 = ["typed", "isInteger"], createMapSlices = factory(name$286, dependencies$286, (D) => {
  var { typed: E, isInteger: O } = D;
  return E(name$286, { "Array | Matrix, number | BigNumber, function": function(F, I, z) {
    if (!O(I)) throw TypeError("Integer number expected for dimension");
    var R = Array.isArray(F) ? arraySize(F) : F.size();
    if (I < 0 || I >= R.length) throw new IndexError(I, R.length);
    return isMatrix(F) ? F.create(_mapSlices(F.valueOf(), I, z), F.datatype()) : _mapSlices(F, I, z);
  } });
}, { formerly: "apply" });
function _mapSlices(D, E, O) {
  var F, I, z;
  if (E <= 0) if (Array.isArray(D[0])) {
    for (z = _switch(D), I = [], F = 0; F < z.length; F++) I[F] = _mapSlices(z[F], E - 1, O);
    return I;
  } else return O(D);
  else {
    for (I = [], F = 0; F < D.length; F++) I[F] = _mapSlices(D[F], E - 1, O);
    return I;
  }
}
function _switch(D) {
  var E = D.length, O = D[0].length, F, I, z = [];
  for (I = 0; I < O; I++) {
    var R = [];
    for (F = 0; F < E; F++) R.push(D[F][I]);
    z.push(R);
  }
  return z;
}
var name$285 = "addScalar", dependencies$285 = ["typed"], createAddScalar = factory(name$285, dependencies$285, (D) => {
  var { typed: E } = D;
  return E(name$285, { "number, number": addNumber, "Complex, Complex": function(O, F) {
    return O.add(F);
  }, "BigNumber, BigNumber": function(O, F) {
    return O.plus(F);
  }, "bigint, bigint": function(O, F) {
    return O + F;
  }, "Fraction, Fraction": function(O, F) {
    return O.add(F);
  }, "Unit, Unit": E.referToSelf((O) => (F, I) => {
    if (F.value === null || F.value === void 0) throw Error("Parameter x contains a unit with undefined value");
    if (I.value === null || I.value === void 0) throw Error("Parameter y contains a unit with undefined value");
    if (!F.equalBase(I)) throw Error("Units do not match");
    var z = F.clone();
    return z.value = E.find(O, [z.valueType(), I.valueType()])(z.value, I.value), z.fixPrefix = !1, z;
  }) });
}), name$284 = "subtractScalar", dependencies$284 = ["typed"], createSubtractScalar = factory(name$284, dependencies$284, (D) => {
  var { typed: E } = D;
  return E(name$284, { "number, number": subtractNumber, "Complex, Complex": function(O, F) {
    return O.sub(F);
  }, "BigNumber, BigNumber": function(O, F) {
    return O.minus(F);
  }, "bigint, bigint": function(O, F) {
    return O - F;
  }, "Fraction, Fraction": function(O, F) {
    return O.sub(F);
  }, "Unit, Unit": E.referToSelf((O) => (F, I) => {
    if (F.value === null || F.value === void 0) throw Error("Parameter x contains a unit with undefined value");
    if (I.value === null || I.value === void 0) throw Error("Parameter y contains a unit with undefined value");
    if (!F.equalBase(I)) throw Error("Units do not match");
    var z = F.clone();
    return z.value = E.find(O, [z.valueType(), I.valueType()])(z.value, I.value), z.fixPrefix = !1, z;
  }) });
}), name$283 = "cbrt", dependencies$283 = ["config", "typed", "isNegative", "unaryMinus", "matrix", "Complex", "BigNumber", "Fraction"], createCbrt = factory(name$283, dependencies$283, (D) => {
  var { config: E, typed: O, isNegative: F, unaryMinus: I, matrix: z, Complex: R, BigNumber: L, Fraction: q } = D;
  return O(name$283, { number: cbrtNumber, Complex: U, "Complex, boolean": U, BigNumber: function(V) {
    return V.cbrt();
  }, Unit: Z });
  function U(V, G) {
    var W = V.arg() / 3, J = V.abs(), X = new R(cbrtNumber(J), 0).mul(new R(0, W).exp());
    if (G) {
      var Y = [X, new R(cbrtNumber(J), 0).mul(new R(0, W + Math.PI * 2 / 3).exp()), new R(cbrtNumber(J), 0).mul(new R(0, W - Math.PI * 2 / 3).exp())];
      return E.matrix === "Array" ? Y : z(Y);
    } else return X;
  }
  function Z(V) {
    if (V.value && isComplex(V.value)) {
      var G = V.clone();
      return G.value = 1, G = G.pow(1 / 3), G.value = U(V.value), G;
    } else {
      var W = F(V.value);
      W && (V.value = I(V.value));
      var J = isBigNumber(V.value) ? new L(1).div(3) : isFraction(V.value) ? new q(1, 3) : 1 / 3, X = V.pow(J);
      return W && (X.value = I(X.value)), X;
    }
  }
}), name$282 = "matAlgo11xS0s", dependencies$282 = ["typed", "equalScalar"], createMatAlgo11xS0s = factory(name$282, dependencies$282, (D) => {
  var { typed: E, equalScalar: O } = D;
  return function(F, I, z, R) {
    var L = F._values, q = F._index, U = F._ptr, Z = F._size, V = F._datatype;
    if (!L) throw Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
    var G = Z[0], W = Z[1], J, X = O, Y = 0, ee = z;
    typeof V == "string" && (J = V, X = E.find(O, [J, J]), Y = E.convert(0, J), I = E.convert(I, J), ee = E.find(z, [J, J]));
    for (var K = [], te = [], ie = [], ne = 0; ne < W; ne++) {
      ie[ne] = te.length;
      for (var ae = U[ne], ue = U[ne + 1], oe = ae; oe < ue; oe++) {
        var se = q[oe], le = R ? ee(I, L[oe]) : ee(L[oe], I);
        X(le, Y) || (te.push(se), K.push(le));
      }
    }
    return ie[W] = te.length, F.createSparseMatrix({ values: K, index: te, ptr: ie, size: [G, W], datatype: J });
  };
}), name$281 = "matAlgo12xSfs", dependencies$281 = ["typed", "DenseMatrix"], createMatAlgo12xSfs = factory(name$281, dependencies$281, (D) => {
  var { typed: E, DenseMatrix: O } = D;
  return function(F, I, z, R) {
    var L = F._values, q = F._index, U = F._ptr, Z = F._size, V = F._datatype;
    if (!L) throw Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
    var G = Z[0], W = Z[1], J, X = z;
    typeof V == "string" && (J = V, I = E.convert(I, J), X = E.find(z, [J, J]));
    for (var Y = [], ee = [], K = [], te = 0; te < W; te++) {
      for (var ie = te + 1, ne = U[te], ae = U[te + 1], ue = ne; ue < ae; ue++) {
        var oe = q[ue];
        ee[oe] = L[ue], K[oe] = ie;
      }
      for (var se = 0; se < G; se++) te === 0 && (Y[se] = []), K[se] === ie ? Y[se][te] = R ? X(I, ee[se]) : X(ee[se], I) : Y[se][te] = R ? X(I, 0) : X(0, I);
    }
    return new O({ data: Y, size: [G, W], datatype: J });
  };
}), name$280 = "matAlgo14xDs", dependencies$280 = ["typed"], createMatAlgo14xDs = factory(name$280, dependencies$280, (D) => {
  var { typed: E } = D;
  return function(F, I, z, R) {
    var L = F._data, q = F._size, U = F._datatype, Z, V = z;
    typeof U == "string" && (Z = U, I = E.convert(I, Z), V = E.find(z, [Z, Z]));
    var G = q.length > 0 ? O(V, 0, q, q[0], L, I, R) : [];
    return F.createDenseMatrix({ data: G, size: clone$3(q), datatype: Z });
  };
  function O(F, I, z, R, L, q, U) {
    var Z = [];
    if (I === z.length - 1) for (var V = 0; V < R; V++) Z[V] = U ? F(q, L[V]) : F(L[V], q);
    else for (var G = 0; G < R; G++) Z[G] = O(F, I + 1, z, z[I + 1], L[G], q, U);
    return Z;
  }
}), name$279 = "ceil", dependencies$279 = ["typed", "config", "round", "matrix", "equalScalar", "zeros", "DenseMatrix"], bigTen$1 = new Decimal(10), createCeilNumber = factory(name$279, ["typed", "config", "round"], (D) => {
  var { typed: E, config: O, round: F } = D;
  function I(z) {
    var R = Math.ceil(z), L = F(z);
    return R === L ? R : nearlyEqual$1(z, L, O.relTol, O.absTol) && !nearlyEqual$1(z, R, O.relTol, O.absTol) ? L : R;
  }
  return E(name$279, { number: I, "number, number": function(z, R) {
    if (!isInteger(R)) throw RangeError("number of decimals in function ceil must be an integer");
    if (R < 0 || R > 15) throw RangeError("number of decimals in ceil number must be in range 0-15");
    var L = 10 ** R;
    return I(z * L) / L;
  } });
}), createCeil = factory(name$279, dependencies$279, (D) => {
  var { typed: E, config: O, round: F, matrix: I, equalScalar: z, zeros: R, DenseMatrix: L } = D, q = createMatAlgo11xS0s({ typed: E, equalScalar: z }), U = createMatAlgo12xSfs({ typed: E, DenseMatrix: L }), Z = createMatAlgo14xDs({ typed: E }), V = createCeilNumber({ typed: E, config: O, round: F });
  function G(W) {
    var J = (ee, K) => nearlyEqual(ee, K, O.relTol, O.absTol), X = W.ceil(), Y = F(W);
    return X.eq(Y) ? X : J(W, Y) && !J(W, X) ? Y : X;
  }
  return E("ceil", { number: V.signatures.number, "number,number": V.signatures["number,number"], Complex: function(W) {
    return W.ceil();
  }, "Complex, number": function(W, J) {
    return W.ceil(J);
  }, "Complex, BigNumber": function(W, J) {
    return W.ceil(J.toNumber());
  }, BigNumber: G, "BigNumber, BigNumber": function(W, J) {
    var X = bigTen$1.pow(J);
    return G(W.mul(X)).div(X);
  }, bigint: (W) => W, "bigint, number": (W, J) => W, "bigint, BigNumber": (W, J) => W, Fraction: function(W) {
    return W.ceil();
  }, "Fraction, number": function(W, J) {
    return W.ceil(J);
  }, "Fraction, BigNumber": function(W, J) {
    return W.ceil(J.toNumber());
  }, "Unit, number, Unit": E.referToSelf((W) => function(J, X, Y) {
    var ee = J.toNumeric(Y);
    return Y.multiply(W(ee, X));
  }), "Unit, BigNumber, Unit": E.referToSelf((W) => (J, X, Y) => W(J, X.toNumber(), Y)), "Array | Matrix, number | BigNumber, Unit": E.referToSelf((W) => (J, X, Y) => deepMap(J, (ee) => W(ee, X, Y), !0)), "Array | Matrix | Unit, Unit": E.referToSelf((W) => (J, X) => W(J, 0, X)), "Array | Matrix": E.referToSelf((W) => (J) => deepMap(J, W, !0)), "Array, number | BigNumber": E.referToSelf((W) => (J, X) => deepMap(J, (Y) => W(Y, X), !0)), "SparseMatrix, number | BigNumber": E.referToSelf((W) => (J, X) => q(J, X, W, !1)), "DenseMatrix, number | BigNumber": E.referToSelf((W) => (J, X) => Z(J, X, W, !1)), "number | Complex | Fraction | BigNumber, Array": E.referToSelf((W) => (J, X) => Z(I(X), J, W, !0).valueOf()), "number | Complex | Fraction | BigNumber, Matrix": E.referToSelf((W) => (J, X) => z(J, 0) ? R(X.size(), X.storage()) : X.storage() === "dense" ? Z(X, J, W, !0) : U(X, J, W, !0)) });
}), name$278 = "cube", dependencies$278 = ["typed"], createCube = factory(name$278, dependencies$278, (D) => {
  var { typed: E } = D;
  return E(name$278, { number: cubeNumber, Complex: function(O) {
    return O.mul(O).mul(O);
  }, BigNumber: function(O) {
    return O.times(O).times(O);
  }, bigint: function(O) {
    return O * O * O;
  }, Fraction: function(O) {
    return O.pow(3);
  }, Unit: function(O) {
    return O.pow(3);
  } });
}), name$277 = "exp", dependencies$277 = ["typed"], createExp = factory(name$277, dependencies$277, (D) => {
  var { typed: E } = D;
  return E(name$277, { number: expNumber, Complex: function(O) {
    return O.exp();
  }, BigNumber: function(O) {
    return O.exp();
  } });
}), name$276 = "expm1", dependencies$276 = ["typed", "Complex"], createExpm1 = factory(name$276, dependencies$276, (D) => {
  var { typed: E, Complex: O } = D;
  return E(name$276, { number: expm1Number, Complex: function(F) {
    var I = Math.exp(F.re);
    return new O(I * Math.cos(F.im) - 1, I * Math.sin(F.im));
  }, BigNumber: function(F) {
    return F.exp().minus(1);
  } });
}), name$275 = "fix", dependencies$275 = ["typed", "Complex", "matrix", "ceil", "floor", "equalScalar", "zeros", "DenseMatrix"], createFixNumber = factory(name$275, ["typed", "ceil", "floor"], (D) => {
  var { typed: E, ceil: O, floor: F } = D;
  return E(name$275, { number: function(I) {
    return I > 0 ? F(I) : O(I);
  }, "number, number": function(I, z) {
    return I > 0 ? F(I, z) : O(I, z);
  } });
}), createFix = factory(name$275, dependencies$275, (D) => {
  var { typed: E, Complex: O, matrix: F, ceil: I, floor: z, equalScalar: R, zeros: L, DenseMatrix: q } = D, U = createMatAlgo12xSfs({ typed: E, DenseMatrix: q }), Z = createMatAlgo14xDs({ typed: E }), V = createFixNumber({ typed: E, ceil: I, floor: z });
  return E("fix", { number: V.signatures.number, "number, number | BigNumber": V.signatures["number,number"], Complex: function(G) {
    return new O(G.re > 0 ? Math.floor(G.re) : Math.ceil(G.re), G.im > 0 ? Math.floor(G.im) : Math.ceil(G.im));
  }, "Complex, number": function(G, W) {
    return new O(G.re > 0 ? z(G.re, W) : I(G.re, W), G.im > 0 ? z(G.im, W) : I(G.im, W));
  }, "Complex, BigNumber": function(G, W) {
    var J = W.toNumber();
    return new O(G.re > 0 ? z(G.re, J) : I(G.re, J), G.im > 0 ? z(G.im, J) : I(G.im, J));
  }, BigNumber: function(G) {
    return G.isNegative() ? I(G) : z(G);
  }, "BigNumber, number | BigNumber": function(G, W) {
    return G.isNegative() ? I(G, W) : z(G, W);
  }, bigint: (G) => G, "bigint, number": (G, W) => G, "bigint, BigNumber": (G, W) => G, Fraction: function(G) {
    return G.s < 0n ? G.ceil() : G.floor();
  }, "Fraction, number | BigNumber": function(G, W) {
    return G.s < 0n ? I(G, W) : z(G, W);
  }, "Unit, number, Unit": E.referToSelf((G) => function(W, J, X) {
    var Y = W.toNumeric(X);
    return X.multiply(G(Y, J));
  }), "Unit, BigNumber, Unit": E.referToSelf((G) => (W, J, X) => G(W, J.toNumber(), X)), "Array | Matrix, number | BigNumber, Unit": E.referToSelf((G) => (W, J, X) => deepMap(W, (Y) => G(Y, J, X), !0)), "Array | Matrix | Unit, Unit": E.referToSelf((G) => (W, J) => G(W, 0, J)), "Array | Matrix": E.referToSelf((G) => (W) => deepMap(W, G, !0)), "Array | Matrix, number | BigNumber": E.referToSelf((G) => (W, J) => deepMap(W, (X) => G(X, J), !0)), "number | Complex | Fraction | BigNumber, Array": E.referToSelf((G) => (W, J) => Z(F(J), W, G, !0).valueOf()), "number | Complex | Fraction | BigNumber, Matrix": E.referToSelf((G) => (W, J) => R(W, 0) ? L(J.size(), J.storage()) : J.storage() === "dense" ? Z(J, W, G, !0) : U(J, W, G, !0)) });
}), name$274 = "floor", dependencies$274 = ["typed", "config", "round", "matrix", "equalScalar", "zeros", "DenseMatrix"], bigTen = new Decimal(10), createFloorNumber = factory(name$274, ["typed", "config", "round"], (D) => {
  var { typed: E, config: O, round: F } = D;
  function I(z) {
    var R = Math.floor(z), L = F(z);
    return R === L ? R : nearlyEqual$1(z, L, O.relTol, O.absTol) && !nearlyEqual$1(z, R, O.relTol, O.absTol) ? L : R;
  }
  return E(name$274, { number: I, "number, number": function(z, R) {
    if (!isInteger(R)) throw RangeError("number of decimals in function floor must be an integer");
    if (R < 0 || R > 15) throw RangeError("number of decimals in floor number must be in range 0 - 15");
    var L = 10 ** R;
    return I(z * L) / L;
  } });
}), createFloor = factory(name$274, dependencies$274, (D) => {
  var { typed: E, config: O, round: F, matrix: I, equalScalar: z, zeros: R, DenseMatrix: L } = D, q = createMatAlgo11xS0s({ typed: E, equalScalar: z }), U = createMatAlgo12xSfs({ typed: E, DenseMatrix: L }), Z = createMatAlgo14xDs({ typed: E }), V = createFloorNumber({ typed: E, config: O, round: F });
  function G(W) {
    var J = (ee, K) => nearlyEqual(ee, K, O.relTol, O.absTol), X = W.floor(), Y = F(W);
    return X.eq(Y) ? X : J(W, Y) && !J(W, X) ? Y : X;
  }
  return E("floor", { number: V.signatures.number, "number,number": V.signatures["number,number"], Complex: function(W) {
    return W.floor();
  }, "Complex, number": function(W, J) {
    return W.floor(J);
  }, "Complex, BigNumber": function(W, J) {
    return W.floor(J.toNumber());
  }, BigNumber: G, "BigNumber, BigNumber": function(W, J) {
    var X = bigTen.pow(J);
    return G(W.mul(X)).div(X);
  }, bigint: (W) => W, "bigint, number": (W, J) => W, "bigint, BigNumber": (W, J) => W, Fraction: function(W) {
    return W.floor();
  }, "Fraction, number": function(W, J) {
    return W.floor(J);
  }, "Fraction, BigNumber": function(W, J) {
    return W.floor(J.toNumber());
  }, "Unit, number, Unit": E.referToSelf((W) => function(J, X, Y) {
    var ee = J.toNumeric(Y);
    return Y.multiply(W(ee, X));
  }), "Unit, BigNumber, Unit": E.referToSelf((W) => (J, X, Y) => W(J, X.toNumber(), Y)), "Array | Matrix, number | BigNumber, Unit": E.referToSelf((W) => (J, X, Y) => deepMap(J, (ee) => W(ee, X, Y), !0)), "Array | Matrix | Unit, Unit": E.referToSelf((W) => (J, X) => W(J, 0, X)), "Array | Matrix": E.referToSelf((W) => (J) => deepMap(J, W, !0)), "Array, number | BigNumber": E.referToSelf((W) => (J, X) => deepMap(J, (Y) => W(Y, X), !0)), "SparseMatrix, number | BigNumber": E.referToSelf((W) => (J, X) => q(J, X, W, !1)), "DenseMatrix, number | BigNumber": E.referToSelf((W) => (J, X) => Z(J, X, W, !1)), "number | Complex | Fraction | BigNumber, Array": E.referToSelf((W) => (J, X) => Z(I(X), J, W, !0).valueOf()), "number | Complex | Fraction | BigNumber, Matrix": E.referToSelf((W) => (J, X) => z(J, 0) ? R(X.size(), X.storage()) : X.storage() === "dense" ? Z(X, J, W, !0) : U(X, J, W, !0)) });
}), name$273 = "matAlgo02xDS0", dependencies$273 = ["typed", "equalScalar"], createMatAlgo02xDS0 = factory(name$273, dependencies$273, (D) => {
  var { typed: E, equalScalar: O } = D;
  return function(F, I, z, R) {
    var L = F._data, q = F._size, U = F._datatype || F.getDataType(), Z = I._values, V = I._index, G = I._ptr, W = I._size, J = I._datatype || I._data === void 0 ? I._datatype : I.getDataType();
    if (q.length !== W.length) throw new DimensionError(q.length, W.length);
    if (q[0] !== W[0] || q[1] !== W[1]) throw RangeError("Dimension mismatch. Matrix A (" + q + ") must match Matrix B (" + W + ")");
    if (!Z) throw Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
    var X = q[0], Y = q[1], ee, K = O, te = 0, ie = z;
    typeof U == "string" && U === J && U !== "mixed" && (ee = U, K = E.find(O, [ee, ee]), te = E.convert(0, ee), ie = E.find(z, [ee, ee]));
    for (var ne = [], ae = [], ue = [], oe = 0; oe < Y; oe++) {
      ue[oe] = ae.length;
      for (var se = G[oe], le = G[oe + 1], ce = se; ce < le; ce++) {
        var fe = V[ce], pe = R ? ie(Z[ce], L[fe][oe]) : ie(L[fe][oe], Z[ce]);
        K(pe, te) || (ae.push(fe), ne.push(pe));
      }
    }
    return ue[Y] = ae.length, I.createSparseMatrix({ values: ne, index: ae, ptr: ue, size: [X, Y], datatype: U === F._datatype && J === I._datatype ? ee : void 0 });
  };
}), name$272 = "matAlgo03xDSf", dependencies$272 = ["typed"], createMatAlgo03xDSf = factory(name$272, dependencies$272, (D) => {
  var { typed: E } = D;
  return function(O, F, I, z) {
    var R = O._data, L = O._size, q = O._datatype || O.getDataType(), U = F._values, Z = F._index, V = F._ptr, G = F._size, W = F._datatype || F._data === void 0 ? F._datatype : F.getDataType();
    if (L.length !== G.length) throw new DimensionError(L.length, G.length);
    if (L[0] !== G[0] || L[1] !== G[1]) throw RangeError("Dimension mismatch. Matrix A (" + L + ") must match Matrix B (" + G + ")");
    if (!U) throw Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
    var J = L[0], X = L[1], Y, ee = 0, K = I;
    typeof q == "string" && q === W && q !== "mixed" && (Y = q, ee = E.convert(0, Y), K = E.find(I, [Y, Y]));
    for (var te = [], ie = 0; ie < J; ie++) te[ie] = [];
    for (var ne = [], ae = [], ue = 0; ue < X; ue++) {
      for (var oe = ue + 1, se = V[ue], le = V[ue + 1], ce = se; ce < le; ce++) {
        var fe = Z[ce];
        ne[fe] = z ? K(U[ce], R[fe][ue]) : K(R[fe][ue], U[ce]), ae[fe] = oe;
      }
      for (var pe = 0; pe < J; pe++) ae[pe] === oe ? te[pe][ue] = ne[pe] : te[pe][ue] = z ? K(ee, R[pe][ue]) : K(R[pe][ue], ee);
    }
    return O.createDenseMatrix({ data: te, size: [J, X], datatype: q === O._datatype && W === F._datatype ? Y : void 0 });
  };
}), name$271 = "matAlgo05xSfSf", dependencies$271 = ["typed", "equalScalar"], createMatAlgo05xSfSf = factory(name$271, dependencies$271, (D) => {
  var { typed: E, equalScalar: O } = D;
  return function(F, I, z) {
    var R = F._values, L = F._index, q = F._ptr, U = F._size, Z = F._datatype || F._data === void 0 ? F._datatype : F.getDataType(), V = I._values, G = I._index, W = I._ptr, J = I._size, X = I._datatype || I._data === void 0 ? I._datatype : I.getDataType();
    if (U.length !== J.length) throw new DimensionError(U.length, J.length);
    if (U[0] !== J[0] || U[1] !== J[1]) throw RangeError("Dimension mismatch. Matrix A (" + U + ") must match Matrix B (" + J + ")");
    var Y = U[0], ee = U[1], K, te = O, ie = 0, ne = z;
    typeof Z == "string" && Z === X && Z !== "mixed" && (K = Z, te = E.find(O, [K, K]), ie = E.convert(0, K), ne = E.find(z, [K, K]));
    var ae = R && V ? [] : void 0, ue = [], oe = [], se = ae ? [] : void 0, le = ae ? [] : void 0, ce = [], fe = [], pe, ve, _e, de;
    for (ve = 0; ve < ee; ve++) {
      oe[ve] = ue.length;
      var ge = ve + 1;
      for (_e = q[ve], de = q[ve + 1]; _e < de; _e++) pe = L[_e], ue.push(pe), ce[pe] = ge, se && (se[pe] = R[_e]);
      for (_e = W[ve], de = W[ve + 1]; _e < de; _e++) pe = G[_e], ce[pe] !== ge && ue.push(pe), fe[pe] = ge, le && (le[pe] = V[_e]);
      if (ae) for (_e = oe[ve]; _e < ue.length; ) {
        pe = ue[_e];
        var ye = ce[pe], De = fe[pe];
        if (ye === ge || De === ge) {
          var Ce = ye === ge ? se[pe] : ie, Ie = De === ge ? le[pe] : ie, Ne = ne(Ce, Ie);
          te(Ne, ie) ? ue.splice(_e, 1) : (ae.push(Ne), _e++);
        }
      }
    }
    return oe[ee] = ue.length, F.createSparseMatrix({ values: ae, index: ue, ptr: oe, size: [Y, ee], datatype: Z === F._datatype && X === I._datatype ? K : void 0 });
  };
}), name$270 = "matAlgo13xDD", dependencies$270 = ["typed"], createMatAlgo13xDD = factory(name$270, dependencies$270, (D) => {
  var { typed: E } = D;
  return function(F, I, z) {
    var R = F._data, L = F._size, q = F._datatype, U = I._data, Z = I._size, V = I._datatype, G = [];
    if (L.length !== Z.length) throw new DimensionError(L.length, Z.length);
    for (var W = 0; W < L.length; W++) {
      if (L[W] !== Z[W]) throw RangeError("Dimension mismatch. Matrix A (" + L + ") must match Matrix B (" + Z + ")");
      G[W] = L[W];
    }
    var J, X = z;
    typeof q == "string" && q === V && (J = q, X = E.find(z, [J, J]));
    var Y = G.length > 0 ? O(X, 0, G, G[0], R, U) : [];
    return F.createDenseMatrix({ data: Y, size: G, datatype: J });
  };
  function O(F, I, z, R, L, q) {
    var U = [];
    if (I === z.length - 1) for (var Z = 0; Z < R; Z++) U[Z] = F(L[Z], q[Z]);
    else for (var V = 0; V < R; V++) U[V] = O(F, I + 1, z, z[I + 1], L[V], q[V]);
    return U;
  }
});
function broadcast(D, E) {
  if (deepStrictEqual(D.size(), E.size())) return [D, E];
  var O = broadcastSizes(D.size(), E.size());
  return [D, E].map((F) => _broadcastTo(F, O));
}
function _broadcastTo(D, E) {
  return deepStrictEqual(D.size(), E) ? D : D.create(broadcastTo(D.valueOf(), E), D.datatype());
}
var name$269 = "matrixAlgorithmSuite", dependencies$269 = ["typed", "matrix"], createMatrixAlgorithmSuite = factory(name$269, dependencies$269, (D) => {
  var { typed: E, matrix: O } = D, F = createMatAlgo13xDD({ typed: E }), I = createMatAlgo14xDs({ typed: E });
  return function(z) {
    var R = z.elop, L = z.SD || z.DS, q;
    R ? (q = { "DenseMatrix, DenseMatrix": (V, G) => F(...broadcast(V, G), R), "Array, Array": (V, G) => F(...broadcast(O(V), O(G)), R).valueOf(), "Array, DenseMatrix": (V, G) => F(...broadcast(O(V), G), R), "DenseMatrix, Array": (V, G) => F(...broadcast(V, O(G)), R) }, z.SS && (q["SparseMatrix, SparseMatrix"] = (V, G) => z.SS(...broadcast(V, G), R, !1)), z.DS && (q["DenseMatrix, SparseMatrix"] = (V, G) => z.DS(...broadcast(V, G), R, !1), q["Array, SparseMatrix"] = (V, G) => z.DS(...broadcast(O(V), G), R, !1)), L && (q["SparseMatrix, DenseMatrix"] = (V, G) => L(...broadcast(G, V), R, !0), q["SparseMatrix, Array"] = (V, G) => L(...broadcast(O(G), V), R, !0))) : (q = { "DenseMatrix, DenseMatrix": E.referToSelf((V) => (G, W) => F(...broadcast(G, W), V)), "Array, Array": E.referToSelf((V) => (G, W) => F(...broadcast(O(G), O(W)), V).valueOf()), "Array, DenseMatrix": E.referToSelf((V) => (G, W) => F(...broadcast(O(G), W), V)), "DenseMatrix, Array": E.referToSelf((V) => (G, W) => F(...broadcast(G, O(W)), V)) }, z.SS && (q["SparseMatrix, SparseMatrix"] = E.referToSelf((V) => (G, W) => z.SS(...broadcast(G, W), V, !1))), z.DS && (q["DenseMatrix, SparseMatrix"] = E.referToSelf((V) => (G, W) => z.DS(...broadcast(G, W), V, !1)), q["Array, SparseMatrix"] = E.referToSelf((V) => (G, W) => z.DS(...broadcast(O(G), W), V, !1))), L && (q["SparseMatrix, DenseMatrix"] = E.referToSelf((V) => (G, W) => L(...broadcast(W, G), V, !0)), q["SparseMatrix, Array"] = E.referToSelf((V) => (G, W) => L(...broadcast(O(W), G), V, !0))));
    var U = z.scalar || "any";
    (z.Ds || z.Ss) && (R ? (q["DenseMatrix," + U] = (V, G) => I(V, G, R, !1), q[U + ", DenseMatrix"] = (V, G) => I(G, V, R, !0), q["Array," + U] = (V, G) => I(O(V), G, R, !1).valueOf(), q[U + ", Array"] = (V, G) => I(O(G), V, R, !0).valueOf()) : (q["DenseMatrix," + U] = E.referToSelf((V) => (G, W) => I(G, W, V, !1)), q[U + ", DenseMatrix"] = E.referToSelf((V) => (G, W) => I(W, G, V, !0)), q["Array," + U] = E.referToSelf((V) => (G, W) => I(O(G), W, V, !1).valueOf()), q[U + ", Array"] = E.referToSelf((V) => (G, W) => I(O(W), G, V, !0).valueOf())));
    var Z = z.sS === void 0 ? z.Ss : z.sS;
    return R ? (z.Ss && (q["SparseMatrix," + U] = (V, G) => z.Ss(V, G, R, !1)), Z && (q[U + ", SparseMatrix"] = (V, G) => Z(G, V, R, !0))) : (z.Ss && (q["SparseMatrix," + U] = E.referToSelf((V) => (G, W) => z.Ss(G, W, V, !1))), Z && (q[U + ", SparseMatrix"] = E.referToSelf((V) => (G, W) => Z(W, G, V, !0)))), R && R.signatures && extend$1(q, R.signatures), q;
  };
}), name$268 = "mod", dependencies$268 = ["typed", "config", "round", "matrix", "equalScalar", "zeros", "DenseMatrix", "concat"], createMod = factory(name$268, dependencies$268, (D) => {
  var { typed: E, config: O, round: F, matrix: I, equalScalar: z, zeros: R, DenseMatrix: L, concat: q } = D, U = createFloor({ typed: E, config: O, round: F, matrix: I, equalScalar: z, zeros: R, DenseMatrix: L }), Z = createMatAlgo02xDS0({ typed: E, equalScalar: z }), V = createMatAlgo03xDSf({ typed: E }), G = createMatAlgo05xSfSf({ typed: E, equalScalar: z }), W = createMatAlgo11xS0s({ typed: E, equalScalar: z }), J = createMatAlgo12xSfs({ typed: E, DenseMatrix: L }), X = createMatrixAlgorithmSuite({ typed: E, matrix: I, concat: q });
  return E(name$268, { "number, number": Y, "BigNumber, BigNumber": function(ee, K) {
    return K.isZero() ? ee : ee.sub(K.mul(U(ee.div(K))));
  }, "bigint, bigint": function(ee, K) {
    if (K === 0n) return ee;
    if (ee < 0) {
      var te = ee % K;
      return te === 0n ? te : te + K;
    }
    return ee % K;
  }, "Fraction, Fraction": function(ee, K) {
    return K.equals(0) ? ee : ee.sub(K.mul(U(ee.div(K))));
  } }, X({ SS: G, DS: V, SD: Z, Ss: W, sS: J }));
  function Y(ee, K) {
    return K === 0 ? ee : ee - K * U(ee / K);
  }
}), name$267 = "matAlgo01xDSid", dependencies$267 = ["typed"], createMatAlgo01xDSid = factory(name$267, dependencies$267, (D) => {
  var { typed: E } = D;
  return function(O, F, I, z) {
    var R = O._data, L = O._size, q = O._datatype || O.getDataType(), U = F._values, Z = F._index, V = F._ptr, G = F._size, W = F._datatype || F._data === void 0 ? F._datatype : F.getDataType();
    if (L.length !== G.length) throw new DimensionError(L.length, G.length);
    if (L[0] !== G[0] || L[1] !== G[1]) throw RangeError("Dimension mismatch. Matrix A (" + L + ") must match Matrix B (" + G + ")");
    if (!U) throw Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
    var J = L[0], X = L[1], Y = typeof q == "string" && q !== "mixed" && q === W ? q : void 0, ee = Y ? E.find(I, [Y, Y]) : I, K, te, ie = [];
    for (K = 0; K < J; K++) ie[K] = [];
    var ne = [], ae = [];
    for (te = 0; te < X; te++) {
      for (var ue = te + 1, oe = V[te], se = V[te + 1], le = oe; le < se; le++) K = Z[le], ne[K] = z ? ee(U[le], R[K][te]) : ee(R[K][te], U[le]), ae[K] = ue;
      for (K = 0; K < J; K++) ae[K] === ue ? ie[K][te] = ne[K] : ie[K][te] = R[K][te];
    }
    return O.createDenseMatrix({ data: ie, size: [J, X], datatype: q === O._datatype && W === F._datatype ? Y : void 0 });
  };
}), name$266 = "matAlgo04xSidSid", dependencies$266 = ["typed", "equalScalar"], createMatAlgo04xSidSid = factory(name$266, dependencies$266, (D) => {
  var { typed: E, equalScalar: O } = D;
  return function(F, I, z) {
    var R = F._values, L = F._index, q = F._ptr, U = F._size, Z = F._datatype || F._data === void 0 ? F._datatype : F.getDataType(), V = I._values, G = I._index, W = I._ptr, J = I._size, X = I._datatype || I._data === void 0 ? I._datatype : I.getDataType();
    if (U.length !== J.length) throw new DimensionError(U.length, J.length);
    if (U[0] !== J[0] || U[1] !== J[1]) throw RangeError("Dimension mismatch. Matrix A (" + U + ") must match Matrix B (" + J + ")");
    var Y = U[0], ee = U[1], K, te = O, ie = 0, ne = z;
    typeof Z == "string" && Z === X && Z !== "mixed" && (K = Z, te = E.find(O, [K, K]), ie = E.convert(0, K), ne = E.find(z, [K, K]));
    var ae = R && V ? [] : void 0, ue = [], oe = [], se = R && V ? [] : void 0, le = R && V ? [] : void 0, ce = [], fe = [], pe, ve, _e, de, ge;
    for (ve = 0; ve < ee; ve++) {
      oe[ve] = ue.length;
      var ye = ve + 1;
      for (de = q[ve], ge = q[ve + 1], _e = de; _e < ge; _e++) pe = L[_e], ue.push(pe), ce[pe] = ye, se && (se[pe] = R[_e]);
      for (de = W[ve], ge = W[ve + 1], _e = de; _e < ge; _e++) if (pe = G[_e], ce[pe] === ye) {
        if (se) {
          var De = ne(se[pe], V[_e]);
          te(De, ie) ? ce[pe] = null : se[pe] = De;
        }
      } else ue.push(pe), fe[pe] = ye, le && (le[pe] = V[_e]);
      if (se && le) for (_e = oe[ve]; _e < ue.length; ) pe = ue[_e], ce[pe] === ye ? (ae[_e] = se[pe], _e++) : fe[pe] === ye ? (ae[_e] = le[pe], _e++) : ue.splice(_e, 1);
    }
    return oe[ee] = ue.length, F.createSparseMatrix({ values: ae, index: ue, ptr: oe, size: [Y, ee], datatype: Z === F._datatype && X === I._datatype ? K : void 0 });
  };
}), name$265 = "matAlgo10xSids", dependencies$265 = ["typed", "DenseMatrix"], createMatAlgo10xSids = factory(name$265, dependencies$265, (D) => {
  var { typed: E, DenseMatrix: O } = D;
  return function(F, I, z, R) {
    var L = F._values, q = F._index, U = F._ptr, Z = F._size, V = F._datatype;
    if (!L) throw Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
    var G = Z[0], W = Z[1], J, X = z;
    typeof V == "string" && (J = V, I = E.convert(I, J), X = E.find(z, [J, J]));
    for (var Y = [], ee = [], K = [], te = 0; te < W; te++) {
      for (var ie = te + 1, ne = U[te], ae = U[te + 1], ue = ne; ue < ae; ue++) {
        var oe = q[ue];
        ee[oe] = L[ue], K[oe] = ie;
      }
      for (var se = 0; se < G; se++) te === 0 && (Y[se] = []), K[se] === ie ? Y[se][te] = R ? X(I, ee[se]) : X(ee[se], I) : Y[se][te] = I;
    }
    return new O({ data: Y, size: [G, W], datatype: J });
  };
});
function ArgumentsError(D, E, O, F) {
  if (!(this instanceof ArgumentsError)) throw SyntaxError("Constructor must be called with the new operator");
  this.fn = D, this.count = E, this.min = O, this.max = F, this.message = "Wrong number of arguments in function " + D + " (" + E + " provided, " + O + (F == null ? "" : "-" + F) + " expected)", this.stack = Error().stack;
}
ArgumentsError.prototype = Error(), ArgumentsError.prototype.constructor = Error, ArgumentsError.prototype.name = "ArgumentsError", ArgumentsError.prototype.isArgumentsError = !0;
var name$264 = "gcd", dependencies$264 = ["typed", "config", "round", "matrix", "equalScalar", "zeros", "BigNumber", "DenseMatrix", "concat"], gcdTypes = "number | BigNumber | Fraction | Matrix | Array", gcdManyTypesSignature = `${gcdTypes}, ${gcdTypes}, ...${gcdTypes}`;
function is1d(D) {
  return !D.some((E) => Array.isArray(E));
}
var createGcd = factory(name$264, dependencies$264, (D) => {
  var { typed: E, matrix: O, config: F, round: I, equalScalar: z, zeros: R, BigNumber: L, DenseMatrix: q, concat: U } = D, Z = createMod({ typed: E, config: F, round: I, matrix: O, equalScalar: z, zeros: R, DenseMatrix: q, concat: U }), V = createMatAlgo01xDSid({ typed: E }), G = createMatAlgo04xSidSid({ typed: E, equalScalar: z }), W = createMatAlgo10xSids({ typed: E, DenseMatrix: q }), J = createMatrixAlgorithmSuite({ typed: E, matrix: O, concat: U });
  return E(name$264, { "number, number": X, "BigNumber, BigNumber": Y, "Fraction, Fraction": (ee, K) => ee.gcd(K) }, J({ SS: G, DS: V, Ss: W }), { [gcdManyTypesSignature]: E.referToSelf((ee) => (K, te, ie) => {
    for (var ne = ee(K, te), ae = 0; ae < ie.length; ae++) ne = ee(ne, ie[ae]);
    return ne;
  }), Array: E.referToSelf((ee) => (K) => {
    if (K.length === 1 && Array.isArray(K[0]) && is1d(K[0])) return ee(...K[0]);
    if (is1d(K)) return ee(...K);
    throw new ArgumentsError("gcd() supports only 1d matrices!");
  }), Matrix: E.referToSelf((ee) => (K) => ee(K.toArray())) });
  function X(ee, K) {
    if (!isInteger(ee) || !isInteger(K)) throw Error("Parameters in function gcd must be integer numbers");
    for (var te; K !== 0; ) te = Z(ee, K), ee = K, K = te;
    return ee < 0 ? -ee : ee;
  }
  function Y(ee, K) {
    if (!ee.isInt() || !K.isInt()) throw Error("Parameters in function gcd must be integer numbers");
    for (var te = new L(0); !K.isZero(); ) {
      var ie = Z(ee, K);
      ee = K, K = ie;
    }
    return ee.lt(te) ? ee.neg() : ee;
  }
}), name$263 = "matAlgo06xS0S0", dependencies$263 = ["typed", "equalScalar"], createMatAlgo06xS0S0 = factory(name$263, dependencies$263, (D) => {
  var { typed: E, equalScalar: O } = D;
  return function(F, I, z) {
    var R = F._values, L = F._size, q = F._datatype || F._data === void 0 ? F._datatype : F.getDataType(), U = I._values, Z = I._size, V = I._datatype || I._data === void 0 ? I._datatype : I.getDataType();
    if (L.length !== Z.length) throw new DimensionError(L.length, Z.length);
    if (L[0] !== Z[0] || L[1] !== Z[1]) throw RangeError("Dimension mismatch. Matrix A (" + L + ") must match Matrix B (" + Z + ")");
    var G = L[0], W = L[1], J, X = O, Y = 0, ee = z;
    typeof q == "string" && q === V && q !== "mixed" && (J = q, X = E.find(O, [J, J]), Y = E.convert(0, J), ee = E.find(z, [J, J]));
    for (var K = R && U ? [] : void 0, te = [], ie = [], ne = K ? [] : void 0, ae = [], ue = [], oe = 0; oe < W; oe++) {
      ie[oe] = te.length;
      var se = oe + 1;
      if (scatter(F, oe, ae, ne, ue, se, te, ee), scatter(I, oe, ae, ne, ue, se, te, ee), ne) for (var le = ie[oe]; le < te.length; ) {
        var ce = te[le];
        if (ue[ce] === se) {
          var fe = ne[ce];
          X(fe, Y) ? te.splice(le, 1) : (K.push(fe), le++);
        } else te.splice(le, 1);
      }
      else for (var pe = ie[oe]; pe < te.length; ) ue[te[pe]] === se ? pe++ : te.splice(pe, 1);
    }
    return ie[W] = te.length, F.createSparseMatrix({ values: K, index: te, ptr: ie, size: [G, W], datatype: q === F._datatype && V === I._datatype ? J : void 0 });
  };
}), name$262 = "lcm", dependencies$262 = ["typed", "matrix", "equalScalar", "concat"], createLcm = factory(name$262, dependencies$262, (D) => {
  var { typed: E, matrix: O, equalScalar: F, concat: I } = D, z = createMatAlgo02xDS0({ typed: E, equalScalar: F }), R = createMatAlgo06xS0S0({ typed: E, equalScalar: F }), L = createMatAlgo11xS0s({ typed: E, equalScalar: F }), q = createMatrixAlgorithmSuite({ typed: E, matrix: O, concat: I }), U = "number | BigNumber | Fraction | Matrix | Array", Z = {};
  return Z[`${U}, ${U}, ...${U}`] = E.referToSelf((G) => (W, J, X) => {
    for (var Y = G(W, J), ee = 0; ee < X.length; ee++) Y = G(Y, X[ee]);
    return Y;
  }), E(name$262, { "number, number": lcmNumber, "BigNumber, BigNumber": V, "Fraction, Fraction": (G, W) => G.lcm(W) }, q({ SS: R, DS: z, Ss: L }), Z);
  function V(G, W) {
    if (!G.isInt() || !W.isInt()) throw Error("Parameters in function lcm must be integer numbers");
    if (G.isZero()) return G;
    if (W.isZero()) return W;
    for (var J = G.times(W); !W.isZero(); ) {
      var X = W;
      W = G.mod(X), G = X;
    }
    return J.div(G).abs();
  }
});
function promoteLogarithm(D, E, O, F) {
  return function(I) {
    if (I > 0 || O.predictable) {
      if (I <= 0) return NaN;
      var z = I.toString(16), R = z.substring(0, 15);
      return D * (z.length - R.length) + E(+("0x" + R));
    }
    return F(I.toNumber());
  };
}
var name$261 = "log10", dependencies$261 = ["typed", "config", "Complex"], log16 = log10Number(16), createLog10 = factory(name$261, dependencies$261, (D) => {
  var { typed: E, config: O, Complex: F } = D;
  function I(R) {
    return R.log().div(Math.LN10);
  }
  function z(R) {
    return I(new F(R, 0));
  }
  return E(name$261, { number: function(R) {
    return R >= 0 || O.predictable ? log10Number(R) : z(R);
  }, bigint: promoteLogarithm(log16, log10Number, O, z), Complex: I, BigNumber: function(R) {
    return !R.isNegative() || O.predictable ? R.log() : z(R.toNumber());
  }, "Array | Matrix": E.referToSelf((R) => (L) => deepMap(L, R)) });
}), name$260 = "log2", dependencies$260 = ["typed", "config", "Complex"], createLog2 = factory(name$260, dependencies$260, (D) => {
  var { typed: E, config: O, Complex: F } = D;
  function I(R) {
    return z(new F(R, 0));
  }
  return E(name$260, { number: function(R) {
    return R >= 0 || O.predictable ? log2Number(R) : I(R);
  }, bigint: promoteLogarithm(4, log2Number, O, I), Complex: z, BigNumber: function(R) {
    return !R.isNegative() || O.predictable ? R.log(2) : I(R.toNumber());
  }, "Array | Matrix": E.referToSelf((R) => (L) => deepMap(L, R)) });
  function z(R) {
    var L = Math.sqrt(R.re * R.re + R.im * R.im);
    return new F(Math.log2 ? Math.log2(L) : Math.log(L) / Math.LN2, Math.atan2(R.im, R.re) / Math.LN2);
  }
}), name$259 = "multiplyScalar", dependencies$259 = ["typed"], createMultiplyScalar = factory(name$259, dependencies$259, (D) => {
  var { typed: E } = D;
  return E("multiplyScalar", { "number, number": multiplyNumber, "Complex, Complex": function(O, F) {
    return O.mul(F);
  }, "BigNumber, BigNumber": function(O, F) {
    return O.times(F);
  }, "bigint, bigint": function(O, F) {
    return O * F;
  }, "Fraction, Fraction": function(O, F) {
    return O.mul(F);
  }, "number | Fraction | BigNumber | Complex, Unit": (O, F) => F.multiply(O), "Unit, number | Fraction | BigNumber | Complex | Unit": (O, F) => O.multiply(F) });
}), name$258 = "multiply", dependencies$258 = ["typed", "matrix", "addScalar", "multiplyScalar", "equalScalar", "dot"], createMultiply = factory(name$258, dependencies$258, (D) => {
  var { typed: E, matrix: O, addScalar: F, multiplyScalar: I, equalScalar: z, dot: R } = D, L = createMatAlgo11xS0s({ typed: E, equalScalar: z }), q = createMatAlgo14xDs({ typed: E });
  function U(ne, ae) {
    switch (ne.length) {
      case 1:
        switch (ae.length) {
          case 1:
            if (ne[0] !== ae[0]) throw RangeError("Dimension mismatch in multiplication. Vectors must have the same length");
            break;
          case 2:
            if (ne[0] !== ae[0]) throw RangeError("Dimension mismatch in multiplication. Vector length (" + ne[0] + ") must match Matrix rows (" + ae[0] + ")");
            break;
          default:
            throw Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + ae.length + " dimensions)");
        }
        break;
      case 2:
        switch (ae.length) {
          case 1:
            if (ne[1] !== ae[0]) throw RangeError("Dimension mismatch in multiplication. Matrix columns (" + ne[1] + ") must match Vector length (" + ae[0] + ")");
            break;
          case 2:
            if (ne[1] !== ae[0]) throw RangeError("Dimension mismatch in multiplication. Matrix A columns (" + ne[1] + ") must match Matrix B rows (" + ae[0] + ")");
            break;
          default:
            throw Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + ae.length + " dimensions)");
        }
        break;
      default:
        throw Error("Can only multiply a 1 or 2 dimensional matrix (Matrix A has " + ne.length + " dimensions)");
    }
  }
  function Z(ne, ae, ue) {
    if (ue === 0) throw Error("Cannot multiply two empty vectors");
    return R(ne, ae);
  }
  function V(ne, ae) {
    if (ae.storage() !== "dense") throw Error("Support for SparseMatrix not implemented");
    return G(ne, ae);
  }
  function G(ne, ae) {
    var ue = ne._data, oe = ne._size, se = ne._datatype || ne.getDataType(), le = ae._data, ce = ae._size, fe = ae._datatype || ae.getDataType(), pe = oe[0], ve = ce[1], _e, de = F, ge = I;
    se && fe && se === fe && typeof se == "string" && se !== "mixed" && (_e = se, de = E.find(F, [_e, _e]), ge = E.find(I, [_e, _e]));
    for (var ye = [], De = 0; De < ve; De++) {
      for (var Ce = ge(ue[0], le[0][De]), Ie = 1; Ie < pe; Ie++) Ce = de(Ce, ge(ue[Ie], le[Ie][De]));
      ye[De] = Ce;
    }
    return ne.createDenseMatrix({ data: ye, size: [ve], datatype: se === ne._datatype && fe === ae._datatype ? _e : void 0 });
  }
  var W = E("_multiplyMatrixVector", { "DenseMatrix, any": X, "SparseMatrix, any": K }), J = E("_multiplyMatrixMatrix", { "DenseMatrix, DenseMatrix": Y, "DenseMatrix, SparseMatrix": ee, "SparseMatrix, DenseMatrix": te, "SparseMatrix, SparseMatrix": ie });
  function X(ne, ae) {
    var ue = ne._data, oe = ne._size, se = ne._datatype || ne.getDataType(), le = ae._data, ce = ae._datatype || ae.getDataType(), fe = oe[0], pe = oe[1], ve, _e = F, de = I;
    se && ce && se === ce && typeof se == "string" && se !== "mixed" && (ve = se, _e = E.find(F, [ve, ve]), de = E.find(I, [ve, ve]));
    for (var ge = [], ye = 0; ye < fe; ye++) {
      for (var De = ue[ye], Ce = de(De[0], le[0]), Ie = 1; Ie < pe; Ie++) Ce = _e(Ce, de(De[Ie], le[Ie]));
      ge[ye] = Ce;
    }
    return ne.createDenseMatrix({ data: ge, size: [fe], datatype: se === ne._datatype && ce === ae._datatype ? ve : void 0 });
  }
  function Y(ne, ae) {
    var ue = ne._data, oe = ne._size, se = ne._datatype || ne.getDataType(), le = ae._data, ce = ae._size, fe = ae._datatype || ae.getDataType(), pe = oe[0], ve = oe[1], _e = ce[1], de, ge = F, ye = I;
    se && fe && se === fe && typeof se == "string" && se !== "mixed" && se !== "mixed" && (de = se, ge = E.find(F, [de, de]), ye = E.find(I, [de, de]));
    for (var De = [], Ce = 0; Ce < pe; Ce++) {
      var Ie = ue[Ce];
      De[Ce] = [];
      for (var Ne = 0; Ne < _e; Ne++) {
        for (var he = ye(Ie[0], le[0][Ne]), ke = 1; ke < ve; ke++) he = ge(he, ye(Ie[ke], le[ke][Ne]));
        De[Ce][Ne] = he;
      }
    }
    return ne.createDenseMatrix({ data: De, size: [pe, _e], datatype: se === ne._datatype && fe === ae._datatype ? de : void 0 });
  }
  function ee(ne, ae) {
    var ue = ne._data, oe = ne._size, se = ne._datatype || ne.getDataType(), le = ae._values, ce = ae._index, fe = ae._ptr, pe = ae._size, ve = ae._datatype || ae._data === void 0 ? ae._datatype : ae.getDataType();
    if (!le) throw Error("Cannot multiply Dense Matrix times Pattern only Matrix");
    var _e = oe[0], de = pe[1], ge, ye = F, De = I, Ce = z, Ie = 0;
    se && ve && se === ve && typeof se == "string" && se !== "mixed" && (ge = se, ye = E.find(F, [ge, ge]), De = E.find(I, [ge, ge]), Ce = E.find(z, [ge, ge]), Ie = E.convert(0, ge));
    for (var Ne = [], he = [], ke = [], xe = ae.createSparseMatrix({ values: Ne, index: he, ptr: ke, size: [_e, de], datatype: se === ne._datatype && ve === ae._datatype ? ge : void 0 }), Te = 0; Te < de; Te++) {
      ke[Te] = he.length;
      var Fe = fe[Te], be = fe[Te + 1];
      if (be > Fe) for (var Ae = 0, Me = 0; Me < _e; Me++) {
        for (var $e = Me + 1, Re = void 0, je = Fe; je < be; je++) {
          var Pe = ce[je];
          Ae === $e ? Re = ye(Re, De(ue[Me][Pe], le[je])) : (Re = De(ue[Me][Pe], le[je]), Ae = $e);
        }
        Ae === $e && !Ce(Re, Ie) && (he.push(Me), Ne.push(Re));
      }
    }
    return ke[de] = he.length, xe;
  }
  function K(ne, ae) {
    var ue = ne._values, oe = ne._index, se = ne._ptr, le = ne._datatype || ne._data === void 0 ? ne._datatype : ne.getDataType();
    if (!ue) throw Error("Cannot multiply Pattern only Matrix times Dense Matrix");
    var ce = ae._data, fe = ae._datatype || ae.getDataType(), pe = ne._size[0], ve = ae._size[0], _e = [], de = [], ge = [], ye, De = F, Ce = I, Ie = z, Ne = 0;
    le && fe && le === fe && typeof le == "string" && le !== "mixed" && (ye = le, De = E.find(F, [ye, ye]), Ce = E.find(I, [ye, ye]), Ie = E.find(z, [ye, ye]), Ne = E.convert(0, ye));
    var he = [], ke = [];
    ge[0] = 0;
    for (var xe = 0; xe < ve; xe++) {
      var Te = ce[xe];
      if (!Ie(Te, Ne)) for (var Fe = se[xe], be = se[xe + 1], Ae = Fe; Ae < be; Ae++) {
        var Me = oe[Ae];
        ke[Me] ? he[Me] = De(he[Me], Ce(Te, ue[Ae])) : (ke[Me] = !0, de.push(Me), he[Me] = Ce(Te, ue[Ae]));
      }
    }
    for (var $e = de.length, Re = 0; Re < $e; Re++) _e[Re] = he[de[Re]];
    return ge[1] = de.length, ne.createSparseMatrix({ values: _e, index: de, ptr: ge, size: [pe, 1], datatype: le === ne._datatype && fe === ae._datatype ? ye : void 0 });
  }
  function te(ne, ae) {
    var ue = ne._values, oe = ne._index, se = ne._ptr, le = ne._datatype || ne._data === void 0 ? ne._datatype : ne.getDataType();
    if (!ue) throw Error("Cannot multiply Pattern only Matrix times Dense Matrix");
    var ce = ae._data, fe = ae._datatype || ae.getDataType(), pe = ne._size[0], ve = ae._size[0], _e = ae._size[1], de, ge = F, ye = I, De = z, Ce = 0;
    le && fe && le === fe && typeof le == "string" && le !== "mixed" && (de = le, ge = E.find(F, [de, de]), ye = E.find(I, [de, de]), De = E.find(z, [de, de]), Ce = E.convert(0, de));
    for (var Ie = [], Ne = [], he = [], ke = ne.createSparseMatrix({ values: Ie, index: Ne, ptr: he, size: [pe, _e], datatype: le === ne._datatype && fe === ae._datatype ? de : void 0 }), xe = [], Te = [], Fe = 0; Fe < _e; Fe++) {
      he[Fe] = Ne.length;
      for (var be = Fe + 1, Ae = 0; Ae < ve; Ae++) {
        var Me = ce[Ae][Fe];
        if (!De(Me, Ce)) for (var $e = se[Ae], Re = se[Ae + 1], je = $e; je < Re; je++) {
          var Pe = oe[je];
          Te[Pe] === be ? xe[Pe] = ge(xe[Pe], ye(Me, ue[je])) : (Te[Pe] = be, Ne.push(Pe), xe[Pe] = ye(Me, ue[je]));
        }
      }
      for (var Ke = he[Fe], Qe = Ne.length, We = Ke; We < Qe; We++) Ie[We] = xe[Ne[We]];
    }
    return he[_e] = Ne.length, ke;
  }
  function ie(ne, ae) {
    var ue = ne._values, oe = ne._index, se = ne._ptr, le = ne._datatype || ne._data === void 0 ? ne._datatype : ne.getDataType(), ce = ae._values, fe = ae._index, pe = ae._ptr, ve = ae._datatype || ae._data === void 0 ? ae._datatype : ae.getDataType(), _e = ne._size[0], de = ae._size[1], ge = ue && ce, ye, De = F, Ce = I;
    le && ve && le === ve && typeof le == "string" && le !== "mixed" && (ye = le, De = E.find(F, [ye, ye]), Ce = E.find(I, [ye, ye]));
    for (var Ie = ge ? [] : void 0, Ne = [], he = [], ke = ne.createSparseMatrix({ values: Ie, index: Ne, ptr: he, size: [_e, de], datatype: le === ne._datatype && ve === ae._datatype ? ye : void 0 }), xe = ge ? [] : void 0, Te = [], Fe, be, Ae, Me, $e, Re, je, Pe, Ke = 0; Ke < de; Ke++) {
      he[Ke] = Ne.length;
      var Qe = Ke + 1;
      for ($e = pe[Ke], Re = pe[Ke + 1], Me = $e; Me < Re; Me++) if (Pe = fe[Me], ge) for (be = se[Pe], Ae = se[Pe + 1], Fe = be; Fe < Ae; Fe++) je = oe[Fe], Te[je] === Qe ? xe[je] = De(xe[je], Ce(ce[Me], ue[Fe])) : (Te[je] = Qe, Ne.push(je), xe[je] = Ce(ce[Me], ue[Fe]));
      else for (be = se[Pe], Ae = se[Pe + 1], Fe = be; Fe < Ae; Fe++) je = oe[Fe], Te[je] !== Qe && (Te[je] = Qe, Ne.push(je));
      if (ge) for (var We = he[Ke], ir = Ne.length, nr = We; nr < ir; nr++) Ie[nr] = xe[Ne[nr]];
    }
    return he[de] = Ne.length, ke;
  }
  return E(name$258, I, { "Array, Array": E.referTo("Matrix, Matrix", (ne) => (ae, ue) => {
    U(arraySize(ae), arraySize(ue));
    var oe = ne(O(ae), O(ue));
    return isMatrix(oe) ? oe.valueOf() : oe;
  }), "Matrix, Matrix": function(ne, ae) {
    var ue = ne.size(), oe = ae.size();
    return U(ue, oe), ue.length === 1 ? oe.length === 1 ? Z(ne, ae, ue[0]) : V(ne, ae) : oe.length === 1 ? W(ne, ae) : J(ne, ae);
  }, "Matrix, Array": E.referTo("Matrix,Matrix", (ne) => (ae, ue) => ne(ae, O(ue))), "Array, Matrix": E.referToSelf((ne) => (ae, ue) => ne(O(ae, ue.storage()), ue)), "SparseMatrix, any": function(ne, ae) {
    return L(ne, ae, I, !1);
  }, "DenseMatrix, any": function(ne, ae) {
    return q(ne, ae, I, !1);
  }, "any, SparseMatrix": function(ne, ae) {
    return L(ae, ne, I, !0);
  }, "any, DenseMatrix": function(ne, ae) {
    return q(ae, ne, I, !0);
  }, "Array, any": function(ne, ae) {
    return q(O(ne), ae, I, !1).valueOf();
  }, "any, Array": function(ne, ae) {
    return q(O(ae), ne, I, !0).valueOf();
  }, "any, any": I, "any, any, ...any": E.referToSelf((ne) => (ae, ue, oe) => {
    for (var se = ne(ae, ue), le = 0; le < oe.length; le++) se = ne(se, oe[le]);
    return se;
  }) });
}), name$257 = "nthRoot", dependencies$257 = ["typed", "matrix", "equalScalar", "BigNumber", "concat"], createNthRoot = factory(name$257, dependencies$257, (D) => {
  var { typed: E, matrix: O, equalScalar: F, BigNumber: I, concat: z } = D, R = createMatAlgo01xDSid({ typed: E }), L = createMatAlgo02xDS0({ typed: E, equalScalar: F }), q = createMatAlgo06xS0S0({ typed: E, equalScalar: F }), U = createMatAlgo11xS0s({ typed: E, equalScalar: F }), Z = createMatrixAlgorithmSuite({ typed: E, matrix: O, concat: z });
  function V() {
    throw Error("Complex number not supported in function nthRoot. Use nthRoots instead.");
  }
  return E(name$257, { number: nthRootNumber, "number, number": nthRootNumber, BigNumber: (W) => G(W, new I(2)), "BigNumber, BigNumber": G, Complex: V, "Complex, number": V, Array: E.referTo("DenseMatrix,number", (W) => (J) => W(O(J), 2).valueOf()), DenseMatrix: E.referTo("DenseMatrix,number", (W) => (J) => W(J, 2)), SparseMatrix: E.referTo("SparseMatrix,number", (W) => (J) => W(J, 2)), "SparseMatrix, SparseMatrix": E.referToSelf((W) => (J, X) => {
    if (X.density() === 1) return q(J, X, W);
    throw Error("Root must be non-zero");
  }), "DenseMatrix, SparseMatrix": E.referToSelf((W) => (J, X) => {
    if (X.density() === 1) return R(J, X, W, !1);
    throw Error("Root must be non-zero");
  }), "Array, SparseMatrix": E.referTo("DenseMatrix,SparseMatrix", (W) => (J, X) => W(O(J), X)), "number | BigNumber, SparseMatrix": E.referToSelf((W) => (J, X) => {
    if (X.density() === 1) return U(X, J, W, !0);
    throw Error("Root must be non-zero");
  }) }, Z({ scalar: "number | BigNumber", SD: L, Ss: U, sS: !1 }));
  function G(W, J) {
    var X = I.precision, Y = I.clone({ precision: X + 2 }), ee = new I(0), K = new Y(1), te = J.isNegative();
    if (te && (J = J.neg()), J.isZero()) throw Error("Root must be non-zero");
    if (W.isNegative() && !J.abs().mod(2).equals(1)) throw Error("Root must be odd when a is negative.");
    if (W.isZero()) return te ? new Y(1 / 0) : 0;
    if (!W.isFinite()) return te ? ee : W;
    var ie = W.abs().pow(K.div(J));
    return ie = W.isNeg() ? ie.neg() : ie, new I((te ? K.div(ie) : ie).toPrecision(X));
  }
}), name$256 = "sign", dependencies$256 = ["typed", "BigNumber", "Fraction", "complex"], createSign = factory(name$256, dependencies$256, (D) => {
  var { typed: E, BigNumber: O, complex: F, Fraction: I } = D;
  return E(name$256, { number: signNumber, Complex: function(z) {
    return z.im === 0 ? F(signNumber(z.re)) : z.sign();
  }, BigNumber: function(z) {
    return new O(z.cmp(0));
  }, bigint: function(z) {
    return z > 0n ? 1n : z < 0n ? -1n : 0n;
  }, Fraction: function(z) {
    return z.n === 0n ? new I(0) : new I(z.s);
  }, "Array | Matrix": E.referToSelf((z) => (R) => deepMap(R, z, !0)), Unit: E.referToSelf((z) => (R) => {
    if (!R._isDerived() && R.units[0].unit.offset !== 0) throw TypeError("sign is ambiguous for units with offset");
    return E.find(z, R.valueType())(R.value);
  }) });
}), name$255 = "sqrt", dependencies$255 = ["config", "typed", "Complex"], createSqrt = factory(name$255, dependencies$255, (D) => {
  var { config: E, typed: O, Complex: F } = D;
  return O("sqrt", { number: I, Complex: function(z) {
    return z.sqrt();
  }, BigNumber: function(z) {
    return !z.isNegative() || E.predictable ? z.sqrt() : I(z.toNumber());
  }, Unit: function(z) {
    return z.pow(0.5);
  } });
  function I(z) {
    return isNaN(z) ? NaN : z >= 0 || E.predictable ? Math.sqrt(z) : new F(z, 0).sqrt();
  }
}), name$254 = "square", dependencies$254 = ["typed"], createSquare = factory(name$254, dependencies$254, (D) => {
  var { typed: E } = D;
  return E(name$254, { number: squareNumber, Complex: function(O) {
    return O.mul(O);
  }, BigNumber: function(O) {
    return O.times(O);
  }, bigint: function(O) {
    return O * O;
  }, Fraction: function(O) {
    return O.mul(O);
  }, Unit: function(O) {
    return O.pow(2);
  } });
}), name$253 = "subtract", dependencies$253 = ["typed", "matrix", "equalScalar", "subtractScalar", "unaryMinus", "DenseMatrix", "concat"], createSubtract = factory(name$253, dependencies$253, (D) => {
  var { typed: E, matrix: O, equalScalar: F, subtractScalar: I, unaryMinus: z, DenseMatrix: R, concat: L } = D, q = createMatAlgo01xDSid({ typed: E }), U = createMatAlgo03xDSf({ typed: E }), Z = createMatAlgo05xSfSf({ typed: E, equalScalar: F }), V = createMatAlgo10xSids({ typed: E, DenseMatrix: R }), G = createMatAlgo12xSfs({ typed: E, DenseMatrix: R }), W = createMatrixAlgorithmSuite({ typed: E, matrix: O, concat: L });
  return E(name$253, { "any, any": I }, W({ elop: I, SS: Z, DS: q, SD: U, Ss: G, sS: V }));
}), name$252 = "xgcd", dependencies$252 = ["typed", "config", "matrix", "BigNumber"], createXgcd = factory(name$252, dependencies$252, (D) => {
  var { typed: E, config: O, matrix: F, BigNumber: I } = D;
  return E(name$252, { "number, number": function(R, L) {
    var q = xgcdNumber(R, L);
    return O.matrix === "Array" ? q : F(q);
  }, "BigNumber, BigNumber": z });
  function z(R, L) {
    var q, U, Z, V = new I(0), G = new I(1), W = V, J = G, X = G, Y = V;
    if (!R.isInt() || !L.isInt()) throw Error("Parameters in function xgcd must be integer numbers");
    for (; !L.isZero(); ) U = R.div(L).floor(), Z = R.mod(L), q = W, W = J.minus(U.times(W)), J = q, q = X, X = Y.minus(U.times(X)), Y = q, R = L, L = Z;
    var ee = R.lt(V) ? [R.neg(), J.neg(), Y.neg()] : [R, R.isZero() ? 0 : J, Y];
    return O.matrix === "Array" ? ee : F(ee);
  }
}), name$251 = "invmod", dependencies$251 = ["typed", "config", "BigNumber", "xgcd", "equal", "smaller", "mod", "add", "isInteger"], createInvmod = factory(name$251, dependencies$251, (D) => {
  var { typed: E, config: O, BigNumber: F, xgcd: I, equal: z, smaller: R, mod: L, add: q, isInteger: U } = D;
  return E(name$251, { "number, number": Z, "BigNumber, BigNumber": Z });
  function Z(V, G) {
    if (!U(V) || !U(G)) throw Error("Parameters in function invmod must be integer numbers");
    if (V = L(V, G), z(G, 0)) throw Error("Divisor must be non zero");
    var W = I(V, G);
    W = W.valueOf();
    var [J, X] = W;
    return z(J, F(1)) ? (X = L(X, G), R(X, F(0)) && (X = q(X, G)), X) : NaN;
  }
}), name$250 = "matAlgo09xS0Sf", dependencies$250 = ["typed", "equalScalar"], createMatAlgo09xS0Sf = factory(name$250, dependencies$250, (D) => {
  var { typed: E, equalScalar: O } = D;
  return function(F, I, z) {
    var R = F._values, L = F._index, q = F._ptr, U = F._size, Z = F._datatype || F._data === void 0 ? F._datatype : F.getDataType(), V = I._values, G = I._index, W = I._ptr, J = I._size, X = I._datatype || I._data === void 0 ? I._datatype : I.getDataType();
    if (U.length !== J.length) throw new DimensionError(U.length, J.length);
    if (U[0] !== J[0] || U[1] !== J[1]) throw RangeError("Dimension mismatch. Matrix A (" + U + ") must match Matrix B (" + J + ")");
    var Y = U[0], ee = U[1], K, te = O, ie = 0, ne = z;
    typeof Z == "string" && Z === X && Z !== "mixed" && (K = Z, te = E.find(O, [K, K]), ie = E.convert(0, K), ne = E.find(z, [K, K]));
    var ae = R && V ? [] : void 0, ue = [], oe = [], se = ae ? [] : void 0, le = [], ce, fe, pe, ve, _e;
    for (fe = 0; fe < ee; fe++) {
      oe[fe] = ue.length;
      var de = fe + 1;
      if (se) for (ve = W[fe], _e = W[fe + 1], pe = ve; pe < _e; pe++) ce = G[pe], le[ce] = de, se[ce] = V[pe];
      for (ve = q[fe], _e = q[fe + 1], pe = ve; pe < _e; pe++) if (ce = L[pe], se) {
        var ge = le[ce] === de ? se[ce] : ie, ye = ne(R[pe], ge);
        te(ye, ie) || (ue.push(ce), ae.push(ye));
      } else ue.push(ce);
    }
    return oe[ee] = ue.length, F.createSparseMatrix({ values: ae, index: ue, ptr: oe, size: [Y, ee], datatype: Z === F._datatype && X === I._datatype ? K : void 0 });
  };
}), name$249 = "dotMultiply", dependencies$249 = ["typed", "matrix", "equalScalar", "multiplyScalar", "concat"], createDotMultiply = factory(name$249, dependencies$249, (D) => {
  var { typed: E, matrix: O, equalScalar: F, multiplyScalar: I, concat: z } = D, R = createMatAlgo02xDS0({ typed: E, equalScalar: F }), L = createMatAlgo09xS0Sf({ typed: E, equalScalar: F }), q = createMatAlgo11xS0s({ typed: E, equalScalar: F });
  return E(name$249, createMatrixAlgorithmSuite({ typed: E, matrix: O, concat: z })({ elop: I, SS: L, DS: R, Ss: q }));
});
function bitAndBigNumber(D, E) {
  if (D.isFinite() && !D.isInteger() || E.isFinite() && !E.isInteger()) throw Error("Integers expected in function bitAnd");
  var O = D.constructor;
  if (D.isNaN() || E.isNaN()) return new O(NaN);
  if (D.isZero() || E.eq(-1) || D.eq(E)) return D;
  if (E.isZero() || D.eq(-1)) return E;
  if (!D.isFinite() || !E.isFinite()) {
    if (!D.isFinite() && !E.isFinite()) return D.isNegative() === E.isNegative() ? D : new O(0);
    if (!D.isFinite()) return E.isNegative() ? D : D.isNegative() ? new O(0) : E;
    if (!E.isFinite()) return D.isNegative() ? E : E.isNegative() ? new O(0) : D;
  }
  return bitwise(D, E, function(F, I) {
    return F & I;
  });
}
function bitNotBigNumber(D) {
  if (D.isFinite() && !D.isInteger()) throw Error("Integer expected in function bitNot");
  var E = D.constructor, O = E.precision;
  E.config({ precision: 1e9 });
  var F = D.plus(new E(1));
  return F.s = -F.s || null, E.config({ precision: O }), F;
}
function bitOrBigNumber(D, E) {
  if (D.isFinite() && !D.isInteger() || E.isFinite() && !E.isInteger()) throw Error("Integers expected in function bitOr");
  var O = D.constructor;
  if (D.isNaN() || E.isNaN()) return new O(NaN);
  var F = new O(-1);
  return D.isZero() || E.eq(F) || D.eq(E) ? E : E.isZero() || D.eq(F) ? D : !D.isFinite() || !E.isFinite() ? !D.isFinite() && !D.isNegative() && E.isNegative() || D.isNegative() && !E.isNegative() && !E.isFinite() ? F : D.isNegative() && E.isNegative() ? D.isFinite() ? D : E : D.isFinite() ? E : D : bitwise(D, E, function(I, z) {
    return I | z;
  });
}
function bitwise(D, E, O) {
  var F = D.constructor, I, z, R = +(D.s < 0), L = +(E.s < 0);
  if (R) {
    I = decCoefficientToBinaryString(bitNotBigNumber(D));
    for (var q = 0; q < I.length; ++q) I[q] ^= 1;
  } else I = decCoefficientToBinaryString(D);
  if (L) {
    z = decCoefficientToBinaryString(bitNotBigNumber(E));
    for (var U = 0; U < z.length; ++U) z[U] ^= 1;
  } else z = decCoefficientToBinaryString(E);
  var Z, V, G;
  I.length <= z.length ? (Z = I, V = z, G = R) : (Z = z, V = I, G = L);
  var W = Z.length, J = V.length, X = O(R, L) ^ 1, Y = new F(X ^ 1), ee = new F(1), K = new F(2), te = F.precision;
  for (F.config({ precision: 1e9 }); W > 0; ) O(Z[--W], V[--J]) === X && (Y = Y.plus(ee)), ee = ee.times(K);
  for (; J > 0; ) O(G, V[--J]) === X && (Y = Y.plus(ee)), ee = ee.times(K);
  return F.config({ precision: te }), X === 0 && (Y.s = -Y.s), Y;
}
function decCoefficientToBinaryString(D) {
  for (var E = D.d, O = E[0] + "", F = 1; F < E.length; ++F) {
    for (var I = E[F] + "", z = 7 - I.length; z--; ) I = "0" + I;
    O += I;
  }
  for (var R = O.length; O.charAt(R) === "0"; ) R--;
  var L = D.e, q = O.slice(0, R + 1 || 1), U = q.length;
  if (L > 0) if (++L > U) for (L -= U; L--; ) q += "0";
  else L < U && (q = q.slice(0, L) + "." + q.slice(L));
  for (var Z = [0], V = 0; V < q.length; ) {
    for (var G = Z.length; G--; ) Z[G] *= 10;
    Z[0] += parseInt(q.charAt(V++));
    for (var W = 0; W < Z.length; ++W) Z[W] > 1 && ((Z[W + 1] === null || Z[W + 1] === void 0) && (Z[W + 1] = 0), Z[W + 1] += Z[W] >> 1, Z[W] &= 1);
  }
  return Z.reverse();
}
function bitXor(D, E) {
  if (D.isFinite() && !D.isInteger() || E.isFinite() && !E.isInteger()) throw Error("Integers expected in function bitXor");
  var O = D.constructor;
  if (D.isNaN() || E.isNaN()) return new O(NaN);
  if (D.isZero()) return E;
  if (E.isZero()) return D;
  if (D.eq(E)) return new O(0);
  var F = new O(-1);
  return D.eq(F) ? bitNotBigNumber(E) : E.eq(F) ? bitNotBigNumber(D) : !D.isFinite() || !E.isFinite() ? !D.isFinite() && !E.isFinite() ? F : new O(D.isNegative() === E.isNegative() ? 1 / 0 : -1 / 0) : bitwise(D, E, function(I, z) {
    return I ^ z;
  });
}
function leftShiftBigNumber(D, E) {
  if (D.isFinite() && !D.isInteger() || E.isFinite() && !E.isInteger()) throw Error("Integers expected in function leftShift");
  var O = D.constructor;
  return D.isNaN() || E.isNaN() || E.isNegative() && !E.isZero() ? new O(NaN) : D.isZero() || E.isZero() ? D : !D.isFinite() && !E.isFinite() ? new O(NaN) : E.lt(55) ? D.times(2 ** E.toNumber() + "") : D.times(new O(2).pow(E));
}
function rightArithShiftBigNumber(D, E) {
  if (D.isFinite() && !D.isInteger() || E.isFinite() && !E.isInteger()) throw Error("Integers expected in function rightArithShift");
  var O = D.constructor;
  return D.isNaN() || E.isNaN() || E.isNegative() && !E.isZero() ? new O(NaN) : D.isZero() || E.isZero() ? D : E.isFinite() ? E.lt(55) ? D.div(2 ** E.toNumber() + "").floor() : D.div(new O(2).pow(E)).floor() : D.isNegative() ? new O(-1) : D.isFinite() ? new O(0) : new O(NaN);
}
var name$248 = "bitAnd", dependencies$248 = ["typed", "matrix", "equalScalar", "concat"], createBitAnd = factory(name$248, dependencies$248, (D) => {
  var { typed: E, matrix: O, equalScalar: F, concat: I } = D, z = createMatAlgo02xDS0({ typed: E, equalScalar: F }), R = createMatAlgo06xS0S0({ typed: E, equalScalar: F }), L = createMatAlgo11xS0s({ typed: E, equalScalar: F }), q = createMatrixAlgorithmSuite({ typed: E, matrix: O, concat: I });
  return E(name$248, { "number, number": bitAndNumber, "BigNumber, BigNumber": bitAndBigNumber, "bigint, bigint": (U, Z) => U & Z }, q({ SS: R, DS: z, Ss: L }));
}), name$247 = "bitNot", dependencies$247 = ["typed"], createBitNot = factory(name$247, dependencies$247, (D) => {
  var { typed: E } = D;
  return E(name$247, { number: bitNotNumber, BigNumber: bitNotBigNumber, bigint: (O) => ~O, "Array | Matrix": E.referToSelf((O) => (F) => deepMap(F, O)) });
}), name$246 = "bitOr", dependencies$246 = ["typed", "matrix", "equalScalar", "DenseMatrix", "concat"], createBitOr = factory(name$246, dependencies$246, (D) => {
  var { typed: E, matrix: O, equalScalar: F, DenseMatrix: I, concat: z } = D, R = createMatAlgo01xDSid({ typed: E }), L = createMatAlgo04xSidSid({ typed: E, equalScalar: F }), q = createMatAlgo10xSids({ typed: E, DenseMatrix: I }), U = createMatrixAlgorithmSuite({ typed: E, matrix: O, concat: z });
  return E(name$246, { "number, number": bitOrNumber, "BigNumber, BigNumber": bitOrBigNumber, "bigint, bigint": (Z, V) => Z | V }, U({ SS: L, DS: R, Ss: q }));
}), name$245 = "matAlgo07xSSf", dependencies$245 = ["typed", "SparseMatrix"], createMatAlgo07xSSf = factory(name$245, dependencies$245, (D) => {
  var { typed: E, SparseMatrix: O } = D;
  return function(I, z, R) {
    var L = I._size, q = I._datatype || I._data === void 0 ? I._datatype : I.getDataType(), U = z._size, Z = z._datatype || z._data === void 0 ? z._datatype : z.getDataType();
    if (L.length !== U.length) throw new DimensionError(L.length, U.length);
    if (L[0] !== U[0] || L[1] !== U[1]) throw RangeError("Dimension mismatch. Matrix A (" + L + ") must match Matrix B (" + U + ")");
    var V = L[0], G = L[1], W, J = 0, X = R;
    typeof q == "string" && q === Z && q !== "mixed" && (W = q, J = E.convert(0, W), X = E.find(R, [W, W]));
    for (var Y = [], ee = [], K = Array(G + 1).fill(0), te = [], ie = [], ne = [], ae = [], ue = 0; ue < G; ue++) {
      var oe = ue + 1, se = 0;
      F(I, ue, ne, te, oe), F(z, ue, ae, ie, oe);
      for (var le = 0; le < V; le++) {
        var ce = ne[le] === oe ? te[le] : J, fe = ae[le] === oe ? ie[le] : J, pe = X(ce, fe);
        pe !== 0 && pe !== !1 && (ee.push(le), Y.push(pe), se++);
      }
      K[ue + 1] = K[ue] + se;
    }
    return new O({ values: Y, index: ee, ptr: K, size: [V, G], datatype: q === I._datatype && Z === z._datatype ? W : void 0 });
  };
  function F(I, z, R, L, q) {
    for (var U = I._values, Z = I._index, V = I._ptr, G = V[z], W = V[z + 1]; G < W; G++) {
      var J = Z[G];
      R[J] = q, L[J] = U[G];
    }
  }
}), name$244 = "bitXor", dependencies$244 = ["typed", "matrix", "DenseMatrix", "concat", "SparseMatrix"], createBitXor = factory(name$244, dependencies$244, (D) => {
  var { typed: E, matrix: O, DenseMatrix: F, concat: I, SparseMatrix: z } = D, R = createMatAlgo03xDSf({ typed: E }), L = createMatAlgo07xSSf({ typed: E, SparseMatrix: z }), q = createMatAlgo12xSfs({ typed: E, DenseMatrix: F }), U = createMatrixAlgorithmSuite({ typed: E, matrix: O, concat: I });
  return E(name$244, { "number, number": bitXorNumber, "BigNumber, BigNumber": bitXor, "bigint, bigint": (Z, V) => Z ^ V }, U({ SS: L, DS: R, Ss: q }));
}), name$243 = "arg", dependencies$243 = ["typed"], createArg = factory(name$243, dependencies$243, (D) => {
  var { typed: E } = D;
  return E(name$243, { number: function(O) {
    return Math.atan2(0, O);
  }, BigNumber: function(O) {
    return O.constructor.atan2(0, O);
  }, Complex: function(O) {
    return O.arg();
  }, "Array | Matrix": E.referToSelf((O) => (F) => deepMap(F, O)) });
}), name$242 = "conj", dependencies$242 = ["typed"], createConj = factory(name$242, dependencies$242, (D) => {
  var { typed: E } = D;
  return E(name$242, { "number | BigNumber | Fraction": (O) => O, Complex: (O) => O.conjugate(), Unit: E.referToSelf((O) => (F) => new F.constructor(O(F.toNumeric()), F.formatUnits())), "Array | Matrix": E.referToSelf((O) => (F) => deepMap(F, O)) });
}), name$241 = "im", dependencies$241 = ["typed"], createIm = factory(name$241, dependencies$241, (D) => {
  var { typed: E } = D;
  return E(name$241, { number: () => 0, "BigNumber | Fraction": (O) => O.mul(0), Complex: (O) => O.im, "Array | Matrix": E.referToSelf((O) => (F) => deepMap(F, O)) });
}), name$240 = "re", dependencies$240 = ["typed"], createRe = factory(name$240, dependencies$240, (D) => {
  var { typed: E } = D;
  return E(name$240, { "number | BigNumber | Fraction": (O) => O, Complex: (O) => O.re, "Array | Matrix": E.referToSelf((O) => (F) => deepMap(F, O)) });
}), name$239 = "not", dependencies$239 = ["typed"], createNot = factory(name$239, dependencies$239, (D) => {
  var { typed: E } = D;
  return E(name$239, { "null | undefined": () => !0, number: notNumber, Complex: function(O) {
    return O.re === 0 && O.im === 0;
  }, BigNumber: function(O) {
    return O.isZero() || O.isNaN();
  }, bigint: (O) => !O, Unit: E.referToSelf((O) => (F) => E.find(O, F.valueType())(F.value)), "Array | Matrix": E.referToSelf((O) => (F) => deepMap(F, O)) });
}), name$238 = "nullish", dependencies$238 = ["typed", "matrix", "size", "flatten", "deepEqual"], createNullish = factory(name$238, dependencies$238, (D) => {
  var { typed: E, matrix: O, size: F, flatten: I, deepEqual: z } = D, R = createMatAlgo03xDSf({ typed: E }), L = createMatAlgo14xDs({ typed: E }), q = createMatAlgo13xDD({ typed: E });
  return E(name$238, { "number|bigint|Complex|BigNumber|Fraction|Unit|string|boolean|SparseMatrix, any": (U, Z) => U, "null, any": (U, Z) => Z, "undefined, any": (U, Z) => Z, "SparseMatrix, Array | Matrix": (U, Z) => {
    var V = F(U), G = F(Z);
    if (z(V, G)) return U;
    throw new DimensionError(V, G);
  }, "DenseMatrix, DenseMatrix": E.referToSelf((U) => (Z, V) => q(Z, V, U)), "DenseMatrix, SparseMatrix": E.referToSelf((U) => (Z, V) => R(Z, V, U, !1)), "DenseMatrix, Array": E.referToSelf((U) => (Z, V) => q(Z, O(V), U)), "DenseMatrix, any": E.referToSelf((U) => (Z, V) => L(Z, V, U, !1)), "Array, Array": E.referToSelf((U) => (Z, V) => q(O(Z), O(V), U).valueOf()), "Array, DenseMatrix": E.referToSelf((U) => (Z, V) => q(O(Z), V, U)), "Array, SparseMatrix": E.referToSelf((U) => (Z, V) => R(O(Z), V, U, !1)), "Array, any": E.referToSelf((U) => (Z, V) => L(O(Z), V, U, !1).valueOf()) });
}), name$237 = "or", dependencies$237 = ["typed", "matrix", "equalScalar", "DenseMatrix", "concat"], createOr = factory(name$237, dependencies$237, (D) => {
  var { typed: E, matrix: O, equalScalar: F, DenseMatrix: I, concat: z } = D, R = createMatAlgo03xDSf({ typed: E }), L = createMatAlgo05xSfSf({ typed: E, equalScalar: F }), q = createMatAlgo12xSfs({ typed: E, DenseMatrix: I }), U = createMatrixAlgorithmSuite({ typed: E, matrix: O, concat: z });
  return E(name$237, { "number, number": orNumber, "Complex, Complex": function(Z, V) {
    return Z.re !== 0 || Z.im !== 0 || V.re !== 0 || V.im !== 0;
  }, "BigNumber, BigNumber": function(Z, V) {
    return !Z.isZero() && !Z.isNaN() || !V.isZero() && !V.isNaN();
  }, "bigint, bigint": orNumber, "Unit, Unit": E.referToSelf((Z) => (V, G) => Z(V.value || 0, G.value || 0)) }, U({ SS: L, DS: R, Ss: q }));
}), name$236 = "xor", dependencies$236 = ["typed", "matrix", "DenseMatrix", "concat", "SparseMatrix"], createXor = factory(name$236, dependencies$236, (D) => {
  var { typed: E, matrix: O, DenseMatrix: F, concat: I, SparseMatrix: z } = D, R = createMatAlgo03xDSf({ typed: E }), L = createMatAlgo07xSSf({ typed: E, SparseMatrix: z }), q = createMatAlgo12xSfs({ typed: E, DenseMatrix: F }), U = createMatrixAlgorithmSuite({ typed: E, matrix: O, concat: I });
  return E(name$236, { "number, number": xorNumber, "Complex, Complex": function(Z, V) {
    return (Z.re !== 0 || Z.im !== 0) != (V.re !== 0 || V.im !== 0);
  }, "bigint, bigint": xorNumber, "BigNumber, BigNumber": function(Z, V) {
    return (!Z.isZero() && !Z.isNaN()) != (!V.isZero() && !V.isNaN());
  }, "Unit, Unit": E.referToSelf((Z) => (V, G) => Z(V.value || 0, G.value || 0)) }, U({ SS: L, DS: R, Ss: q }));
}), name$235 = "concat", dependencies$235 = ["typed", "matrix", "isInteger"], createConcat = factory(name$235, dependencies$235, (D) => {
  var { typed: E, matrix: O, isInteger: F } = D;
  return E(name$235, { "...Array | Matrix | number | BigNumber": function(I) {
    var z, R = I.length, L = -1, q, U = !1, Z = [];
    for (z = 0; z < R; z++) {
      var V = I[z];
      if (isMatrix(V) && (U = !0), isNumber(V) || isBigNumber(V)) {
        if (z !== R - 1) throw Error("Dimension must be specified as last argument");
        if (q = L, L = V.valueOf(), !F(L)) throw TypeError("Integer number expected for dimension");
        if (L < 0 || z > 0 && L > q) throw new IndexError(L, q + 1);
      } else {
        var G = clone$3(V).valueOf(), W = arraySize(G);
        if (Z[z] = G, q = L, L = W.length - 1, z > 0 && L !== q) throw new DimensionError(q + 1, L + 1);
      }
    }
    if (Z.length === 0) throw SyntaxError("At least one matrix expected");
    for (var J = Z.shift(); Z.length; ) J = concat(J, Z.shift(), L);
    return U ? O(J) : J;
  }, "...string": function(I) {
    return I.join("");
  } });
}), name$234 = "column", dependencies$234 = ["typed", "Index", "matrix", "range"], createColumn = factory(name$234, dependencies$234, (D) => {
  var { typed: E, Index: O, matrix: F, range: I } = D;
  return E(name$234, { "Matrix, number": z, "Array, number": function(R, L) {
    return z(F(clone$3(R)), L).valueOf();
  } });
  function z(R, L) {
    if (R.size().length !== 2) throw Error("Only two dimensional matrix is supported");
    validateIndex(L, R.size()[1]);
    var q = new O(I(0, R.size()[0]), [L]), U = R.subset(q);
    return isMatrix(U) ? U : F([[U]]);
  }
}), name$233 = "count", dependencies$233 = ["typed", "size", "prod"], createCount = factory(name$233, dependencies$233, (D) => {
  var { typed: E, size: O, prod: F } = D;
  return E(name$233, { string: function(I) {
    return I.length;
  }, "Matrix | Array": function(I) {
    return F(O(I));
  } });
}), name$232 = "cross", dependencies$232 = ["typed", "matrix", "subtract", "multiply"], createCross = factory(name$232, dependencies$232, (D) => {
  var { typed: E, matrix: O, subtract: F, multiply: I } = D;
  return E(name$232, { "Matrix, Matrix": function(R, L) {
    return O(z(R.toArray(), L.toArray()));
  }, "Matrix, Array": function(R, L) {
    return O(z(R.toArray(), L));
  }, "Array, Matrix": function(R, L) {
    return O(z(R, L.toArray()));
  }, "Array, Array": z });
  function z(R, L) {
    var q = Math.max(arraySize(R).length, arraySize(L).length);
    R = squeeze(R), L = squeeze(L);
    var U = arraySize(R), Z = arraySize(L);
    if (U.length !== 1 || Z.length !== 1 || U[0] !== 3 || Z[0] !== 3) throw RangeError("Vectors with length 3 expected (Size A = [" + U.join(", ") + "], B = [" + Z.join(", ") + "])");
    var V = [F(I(R[1], L[2]), I(R[2], L[1])), F(I(R[2], L[0]), I(R[0], L[2])), F(I(R[0], L[1]), I(R[1], L[0]))];
    return q > 1 ? [V] : V;
  }
}), name$231 = "diag", dependencies$231 = ["typed", "matrix", "DenseMatrix", "SparseMatrix"], createDiag = factory(name$231, dependencies$231, (D) => {
  var { typed: E, matrix: O, DenseMatrix: F, SparseMatrix: I } = D;
  return E(name$231, { Array: function(q) {
    return z(q, 0, arraySize(q), null);
  }, "Array, number": function(q, U) {
    return z(q, U, arraySize(q), null);
  }, "Array, BigNumber": function(q, U) {
    return z(q, U.toNumber(), arraySize(q), null);
  }, "Array, string": function(q, U) {
    return z(q, 0, arraySize(q), U);
  }, "Array, number, string": function(q, U, Z) {
    return z(q, U, arraySize(q), Z);
  }, "Array, BigNumber, string": function(q, U, Z) {
    return z(q, U.toNumber(), arraySize(q), Z);
  }, Matrix: function(q) {
    return z(q, 0, q.size(), q.storage());
  }, "Matrix, number": function(q, U) {
    return z(q, U, q.size(), q.storage());
  }, "Matrix, BigNumber": function(q, U) {
    return z(q, U.toNumber(), q.size(), q.storage());
  }, "Matrix, string": function(q, U) {
    return z(q, 0, q.size(), U);
  }, "Matrix, number, string": function(q, U, Z) {
    return z(q, U, q.size(), Z);
  }, "Matrix, BigNumber, string": function(q, U, Z) {
    return z(q, U.toNumber(), q.size(), Z);
  } });
  function z(q, U, Z, V) {
    if (!isInteger(U)) throw TypeError("Second parameter in function diag must be an integer");
    var G = U > 0 ? U : 0, W = U < 0 ? -U : 0;
    switch (Z.length) {
      case 1:
        return R(q, U, V, Z[0], W, G);
      case 2:
        return L(q, U, V, Z, W, G);
    }
    throw RangeError("Matrix for function diag must be 2 dimensional");
  }
  function R(q, U, Z, V, G, W) {
    var J = [V + G, V + W];
    if (Z && Z !== "sparse" && Z !== "dense") throw TypeError(`Unknown matrix type ${Z}"`);
    var X = Z === "sparse" ? I.diagonal(J, q, U) : F.diagonal(J, q, U);
    return Z === null ? X.valueOf() : X;
  }
  function L(q, U, Z, V, G, W) {
    if (isMatrix(q)) {
      var J = q.diagonal(U);
      return Z === null ? J.valueOf() : Z === J.storage() ? J : O(J, Z);
    }
    for (var X = Math.min(V[0] - G, V[1] - W), Y = [], ee = 0; ee < X; ee++) Y[ee] = q[ee + G][ee + W];
    return Z === null ? Y : O(Y);
  }
}), name$230 = "filter", dependencies$230 = ["typed"], createFilter = factory(name$230, dependencies$230, (D) => {
  var { typed: E } = D;
  return E("filter", { "Array, function": _filterCallback, "Matrix, function": function(O, F) {
    return O.create(_filterCallback(O.valueOf(), F), O.datatype());
  }, "Array, RegExp": filterRegExp, "Matrix, RegExp": function(O, F) {
    return O.create(filterRegExp(O.valueOf(), F), O.datatype());
  } });
});
function _filterCallback(D, E) {
  var O = optimizeCallback(E, D, "filter");
  return O.isUnary ? filter$1(D, O.fn) : filter$1(D, function(F, I, z) {
    return O.fn(F, [I], z);
  });
}
var name$229 = "flatten", dependencies$229 = ["typed"], createFlatten = factory(name$229, dependencies$229, (D) => {
  var { typed: E } = D;
  return E(name$229, { Array: function(O) {
    return flatten$4(O);
  }, DenseMatrix: function(O) {
    return O.create(flatten$4(O.valueOf(), !0), O.datatype());
  }, SparseMatrix: function(O) {
    throw TypeError("SparseMatrix is not supported by function flatten because it does not support 1D vectors. Convert to a DenseMatrix or Array first. Example: flatten(x.toArray())");
  } });
}), name$228 = "forEach", dependencies$228 = ["typed"], createForEach = factory(name$228, dependencies$228, (D) => {
  var { typed: E } = D;
  return E(name$228, { "Array, function": _forEach, "Matrix, function": function(O, F) {
    O.forEach(F);
  } });
});
function _forEach(D, E) {
  var O = optimizeCallback(E, D, name$228);
  deepForEach$1(D, O.fn, O.isUnary);
}
var name$227 = "getMatrixDataType", dependencies$227 = ["typed"], createGetMatrixDataType = factory(name$227, dependencies$227, (D) => {
  var { typed: E } = D;
  return E(name$227, { Array: function(O) {
    return getArrayDataType(O, typeOf);
  }, Matrix: function(O) {
    return O.getDataType();
  } });
}), name$226 = "identity", dependencies$226 = ["typed", "config", "matrix", "BigNumber", "DenseMatrix", "SparseMatrix"], createIdentity = factory(name$226, dependencies$226, (D) => {
  var { typed: E, config: O, matrix: F, BigNumber: I, DenseMatrix: z, SparseMatrix: R } = D;
  return E(name$226, { "": function() {
    return O.matrix === "Matrix" ? F([]) : [];
  }, string: function(U) {
    return F(U);
  }, "number | BigNumber": function(U) {
    return q(U, U, O.matrix === "Matrix" ? "dense" : void 0);
  }, "number | BigNumber, string": function(U, Z) {
    return q(U, U, Z);
  }, "number | BigNumber, number | BigNumber": function(U, Z) {
    return q(U, Z, O.matrix === "Matrix" ? "dense" : void 0);
  }, "number | BigNumber, number | BigNumber, string": function(U, Z, V) {
    return q(U, Z, V);
  }, Array: function(U) {
    return L(U);
  }, "Array, string": function(U, Z) {
    return L(U, Z);
  }, Matrix: function(U) {
    return L(U.valueOf(), U.storage());
  }, "Matrix, string": function(U, Z) {
    return L(U.valueOf(), Z);
  } });
  function L(U, Z) {
    switch (U.length) {
      case 0:
        return Z ? F(Z) : [];
      case 1:
        return q(U[0], U[0], Z);
      case 2:
        return q(U[0], U[1], Z);
      default:
        throw Error("Vector containing two values expected");
    }
  }
  function q(U, Z, V) {
    var G = isBigNumber(U) || isBigNumber(Z) ? I : null;
    if (isBigNumber(U) && (U = U.toNumber()), isBigNumber(Z) && (Z = Z.toNumber()), !isInteger(U) || U < 1 || !isInteger(Z) || Z < 1) throw Error("Parameters in function identity must be positive integers");
    var W = G ? new I(1) : 1, J = G ? new G(0) : 0, X = [U, Z];
    if (V) {
      if (V === "sparse") return R.diagonal(X, W, 0, J);
      if (V === "dense") return z.diagonal(X, W, 0, J);
      throw TypeError(`Unknown matrix type "${V}"`);
    }
    for (var Y = resize([], X, J), ee = U < Z ? U : Z, K = 0; K < ee; K++) Y[K][K] = W;
    return Y;
  }
}), name$225 = "kron", dependencies$225 = ["typed", "matrix", "multiplyScalar"], createKron = factory(name$225, dependencies$225, (D) => {
  var { typed: E, matrix: O, multiplyScalar: F } = D;
  return E(name$225, { "Matrix, Matrix": function(R, L) {
    return O(z(R.toArray(), L.toArray()));
  }, "Matrix, Array": function(R, L) {
    return O(z(R.toArray(), L));
  }, "Array, Matrix": function(R, L) {
    return O(z(R, L.toArray()));
  }, "Array, Array": z });
  function I(R, L) {
    return R.flatMap((q) => L.map((U) => F(q, U)));
  }
  function z(R, L) {
    var q = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1;
    if (q < 0) {
      var U = arraySize(R).length, Z = arraySize(L).length;
      for (q = Math.max(U, Z); U++ < q; ) R = [R];
      for (; Z++ < q; ) L = [L];
    }
    return q === 1 ? I(R, L) : R.flatMap((V) => L.map((G) => z(V, G, q - 1)));
  }
}), name$224 = "map", dependencies$224 = ["typed"], createMap = factory(name$224, dependencies$224, (D) => {
  var { typed: E } = D;
  return E(name$224, { "Array, function": L, "Matrix, function": function(q, U) {
    return q.map(U);
  }, "Array|Matrix, Array|Matrix, ...Array|Matrix|function": (q, U, Z) => O([q, U, ...Z.slice(0, Z.length - 1)], Z[Z.length - 1]) });
  function O(q, U) {
    if (typeof U != "function") throw Error("Last argument must be a callback function");
    var Z = q[0].isMatrix, V = q.map((ie) => ie.isMatrix ? ie.size() : arraySize(ie)), G = broadcastSizes(...V), W = q.length, J = Z ? (ie, ne) => ie.get(ne) : get$1, X = q.map((ie, ne) => {
      var ae = V[ne].map(() => 0);
      return ie.isMatrix ? ie.get(ae) : get$1(ie, ae);
    }), Y = E.isTypedFunction(U) ? R(U, X, G.map(() => 0), q) : z(U, W);
    if (Y < 2) return F(q, I(Y, U, null));
    var ee = Z ? q.map((ie) => ie.isMatrix ? ie.create(broadcastTo(ie.toArray(), G), ie.datatype()) : q[0].create(broadcastTo(ie.valueOf(), G))) : q.map((ie) => ie.isMatrix ? broadcastTo(ie.toArray(), G) : broadcastTo(ie, G)), K = I(Y, U, ee), te = (ie, ne) => K([ie, ...ee.slice(1).map((ae) => J(ae, ne))], ne);
    return Z ? ee[0].map(te) : L(ee[0], te);
  }
  function F(q, U) {
    var Z = q[0], V = q.map((ie) => ie.isMatrix ? ie.valueOf() : ie), G = q.map((ie) => ie.isMatrix ? ie.size() : arraySize(ie)), W = broadcastSizes(...G), J = G.map((ie) => W.length - ie.length), X = W.length - 1, Y = U.length > 1 ? [] : null, ee = te(V, 0);
    if (Z.isMatrix) {
      var K = Z.create();
      return K._data = ee, K._size = W, K;
    } else return ee;
    function te(ie) {
      var ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, ae = W[ne], ue = Array(ae);
      if (ne < X) for (var oe = function(fe) {
        Y && (Y[ne] = fe), ue[fe] = te(ie.map((pe, ve) => J[ve] > ne ? pe : pe.length === 1 ? pe[0] : pe[fe]), ne + 1);
      }, se = 0; se < ae; se++) oe(se);
      else for (var le = function(fe) {
        Y && (Y[ne] = fe), ue[fe] = U(ie.map((pe) => pe.length === 1 ? pe[0] : pe[fe]), Y ? Y.slice() : void 0);
      }, ce = 0; ce < ae; ce++) le(ce);
      return ue;
    }
  }
  function I(q, U, Z) {
    switch (q) {
      case 0:
        return (V) => U(...V);
      case 1:
        return (V, G) => U(...V, G);
      case 2:
        return (V, G) => U(...V, G, ...Z);
    }
  }
  function z(q, U) {
    var Z = q.toString();
    if (/arguments/.test(Z)) return 2;
    var V = Z.match(/\(.*?\)/);
    return /\.\.\./.test(V) || q.length > U + 1 ? 2 : +(q.length === U + 1);
  }
  function R(q, U, Z, V) {
    return E.resolve(q, [...U, Z, ...V]) === null ? E.resolve(q, [...U, Z]) === null ? (E.resolve(q, U), 0) : 1 : 2;
  }
  function L(q, U) {
    var Z = optimizeCallback(U, q, name$224);
    return deepMap$1(q, Z.fn, Z.isUnary);
  }
}), name$223 = "diff", dependencies$223 = ["typed", "matrix", "subtract", "number"], createDiff = factory(name$223, dependencies$223, (D) => {
  var { typed: E, matrix: O, subtract: F, number: I } = D;
  return E(name$223, { "Array | Matrix": function(U) {
    return isMatrix(U) ? O(R(U.toArray())) : R(U);
  }, "Array | Matrix, number": function(U, Z) {
    if (!isInteger(Z)) throw RangeError("Dimension must be a whole number");
    return isMatrix(U) ? O(z(U.toArray(), Z)) : z(U, Z);
  }, "Array, BigNumber": E.referTo("Array,number", (U) => (Z, V) => U(Z, I(V))), "Matrix, BigNumber": E.referTo("Matrix,number", (U) => (Z, V) => U(Z, I(V))) });
  function z(U, Z) {
    if (isMatrix(U) && (U = U.toArray()), !Array.isArray(U)) throw RangeError("Array/Matrix does not have that many dimensions");
    if (Z > 0) {
      var V = [];
      return U.forEach((G) => {
        V.push(z(G, Z - 1));
      }), V;
    } else {
      if (Z === 0) return R(U);
      throw RangeError("Cannot have negative dimension");
    }
  }
  function R(U) {
    for (var Z = [], V = U.length, G = 1; G < V; G++) Z.push(L(U[G - 1], U[G]));
    return Z;
  }
  function L(U, Z) {
    isMatrix(U) && (U = U.toArray()), isMatrix(Z) && (Z = Z.toArray());
    var V = Array.isArray(U), G = Array.isArray(Z);
    if (V && G) return q(U, Z);
    if (!V && !G) return F(Z, U);
    throw TypeError("Cannot calculate difference between 1 array and 1 non-array");
  }
  function q(U, Z) {
    if (U.length !== Z.length) throw RangeError("Not all sub-arrays have the same length");
    for (var V = [], G = U.length, W = 0; W < G; W++) V.push(L(U[W], Z[W]));
    return V;
  }
}), name$222 = "ones", dependencies$222 = ["typed", "config", "matrix", "BigNumber"], createOnes = factory(name$222, dependencies$222, (D) => {
  var { typed: E, config: O, matrix: F, BigNumber: I } = D;
  return E("ones", { "": function() {
    return O.matrix === "Array" ? z([]) : z([], "default");
  }, "...number | BigNumber | string": function(q) {
    return typeof q[q.length - 1] == "string" ? z(q, q.pop()) : O.matrix === "Array" ? z(q) : z(q, "default");
  }, Array: z, Matrix: function(q) {
    var U = q.storage();
    return z(q.valueOf(), U);
  }, "Array | Matrix, string": function(q, U) {
    return z(q.valueOf(), U);
  } });
  function z(q, U) {
    var Z = R(q) ? new I(1) : 1;
    if (L(q), U) {
      var V = F(U);
      return q.length > 0 ? V.resize(q, Z) : V;
    } else {
      var G = [];
      return q.length > 0 ? resize(G, q, Z) : G;
    }
  }
  function R(q) {
    var U = !1;
    return q.forEach(function(Z, V, G) {
      isBigNumber(Z) && (U = !0, G[V] = Z.toNumber());
    }), U;
  }
  function L(q) {
    q.forEach(function(U) {
      if (typeof U != "number" || !isInteger(U) || U < 0) throw Error("Parameters in function ones must be positive integers");
    });
  }
});
function noBignumber() {
  throw Error('No "bignumber" implementation available');
}
function noFraction() {
  throw Error('No "fraction" implementation available');
}
function noMatrix() {
  throw Error('No "matrix" implementation available');
}
var name$221 = "range", dependencies$221 = ["typed", "config", "?matrix", "?bignumber", "equal", "smaller", "smallerEq", "larger", "largerEq", "add", "isZero", "isPositive"], createRange = factory(name$221, dependencies$221, (D) => {
  var { typed: E, config: O, matrix: F, bignumber: I, smaller: z, smallerEq: R, larger: L, largerEq: q, add: U, isZero: Z, isPositive: V } = D;
  return E(name$221, { string: W, "string, boolean": W, number: function(Y) {
    throw TypeError(`Too few arguments to function range(): ${Y}`);
  }, boolean: function(Y) {
    throw TypeError(`Unexpected type of argument 1 to function range(): ${Y}, number|bigint|BigNumber|Fraction`);
  }, "number, number": function(Y, ee) {
    return G(J(Y, ee, 1, !1));
  }, "number, number, number": function(Y, ee, K) {
    return G(J(Y, ee, K, !1));
  }, "number, number, boolean": function(Y, ee, K) {
    return G(J(Y, ee, 1, K));
  }, "number, number, number, boolean": function(Y, ee, K, te) {
    return G(J(Y, ee, K, te));
  }, "bigint, bigint|number": function(Y, ee) {
    return G(J(Y, ee, 1n, !1));
  }, "number, bigint": function(Y, ee) {
    return G(J(BigInt(Y), ee, 1n, !1));
  }, "bigint, bigint|number, bigint|number": function(Y, ee, K) {
    return G(J(Y, ee, BigInt(K), !1));
  }, "number, bigint, bigint|number": function(Y, ee, K) {
    return G(J(BigInt(Y), ee, BigInt(K), !1));
  }, "bigint, bigint|number, boolean": function(Y, ee, K) {
    return G(J(Y, ee, 1n, K));
  }, "number, bigint, boolean": function(Y, ee, K) {
    return G(J(BigInt(Y), ee, 1n, K));
  }, "bigint, bigint|number, bigint|number, boolean": function(Y, ee, K, te) {
    return G(J(Y, ee, BigInt(K), te));
  }, "number, bigint, bigint|number, boolean": function(Y, ee, K, te) {
    return G(J(BigInt(Y), ee, BigInt(K), te));
  }, "BigNumber, BigNumber": function(Y, ee) {
    var K = Y.constructor;
    return G(J(Y, ee, new K(1), !1));
  }, "BigNumber, BigNumber, BigNumber": function(Y, ee, K) {
    return G(J(Y, ee, K, !1));
  }, "BigNumber, BigNumber, boolean": function(Y, ee, K) {
    var te = Y.constructor;
    return G(J(Y, ee, new te(1), K));
  }, "BigNumber, BigNumber, BigNumber, boolean": function(Y, ee, K, te) {
    return G(J(Y, ee, K, te));
  }, "Fraction, Fraction": function(Y, ee) {
    return G(J(Y, ee, 1, !1));
  }, "Fraction, Fraction, Fraction": function(Y, ee, K) {
    return G(J(Y, ee, K, !1));
  }, "Fraction, Fraction, boolean": function(Y, ee, K) {
    return G(J(Y, ee, 1, K));
  }, "Fraction, Fraction, Fraction, boolean": function(Y, ee, K, te) {
    return G(J(Y, ee, K, te));
  }, "Unit, Unit, Unit": function(Y, ee, K) {
    return G(J(Y, ee, K, !1));
  }, "Unit, Unit, Unit, boolean": function(Y, ee, K, te) {
    return G(J(Y, ee, K, te));
  } });
  function G(Y) {
    return O.matrix === "Matrix" ? F ? F(Y) : noMatrix() : Y;
  }
  function W(Y, ee) {
    var K = X(Y);
    if (!K) throw SyntaxError('String "' + Y + '" is no valid range');
    return O.number === "BigNumber" ? (I === void 0 && noBignumber(), G(J(I(K.start), I(K.end), I(K.step)))) : G(J(K.start, K.end, K.step, ee));
  }
  function J(Y, ee, K, te) {
    var ie = [];
    if (Z(K)) throw Error("Step must be non-zero");
    for (var ne = V(K) ? te ? R : z : te ? q : L, ae = Y; ne(ae, ee); ) ie.push(ae), ae = U(ae, K);
    return ie;
  }
  function X(Y) {
    var ee = Y.split(":").map(function(K) {
      return Number(K);
    });
    if (ee.some(function(K) {
      return isNaN(K);
    })) return null;
    switch (ee.length) {
      case 2:
        return { start: ee[0], end: ee[1], step: 1 };
      case 3:
        return { start: ee[0], end: ee[2], step: ee[1] };
      default:
        return null;
    }
  }
}), name$220 = "reshape", dependencies$220 = ["typed", "isInteger", "matrix"], createReshape = factory(name$220, dependencies$220, (D) => {
  var { typed: E, isInteger: O } = D;
  return E(name$220, { "Matrix, Array": function(F, I) {
    return F.reshape(I, !0);
  }, "Array, Array": function(F, I) {
    return I.forEach(function(z) {
      if (!O(z)) throw TypeError("Invalid size for dimension: " + z);
    }), reshape(F, I);
  } });
}), name$219 = "resize", dependencies$219 = ["config", "matrix"], createResize = factory(name$219, dependencies$219, (D) => {
  var { config: E, matrix: O } = D;
  return function(I, z, R) {
    if (arguments.length !== 2 && arguments.length !== 3) throw new ArgumentsError("resize", arguments.length, 2, 3);
    if (isMatrix(z) && (z = z.valueOf()), isBigNumber(z[0]) && (z = z.map(function(U) {
      return isBigNumber(U) ? U.toNumber() : U;
    })), isMatrix(I)) return I.resize(z, R, !0);
    if (typeof I == "string") return F(I, z, R);
    var L = Array.isArray(I) ? !1 : E.matrix !== "Array";
    if (z.length === 0) {
      for (; Array.isArray(I); ) I = I[0];
      return clone$3(I);
    } else {
      Array.isArray(I) || (I = [I]), I = clone$3(I);
      var q = resize(I, z, R);
      return L ? O(q) : q;
    }
  };
  function F(I, z, R) {
    if (R !== void 0) {
      if (typeof R != "string" || R.length !== 1) throw TypeError("Single character expected as defaultValue");
    } else R = " ";
    if (z.length !== 1) throw new DimensionError(z.length, 1);
    var L = z[0];
    if (typeof L != "number" || !isInteger(L)) throw TypeError("Invalid size, must contain positive integers (size: " + format(z) + ")");
    if (I.length > L) return I.substring(0, L);
    if (I.length < L) {
      for (var q = I, U = 0, Z = L - I.length; U < Z; U++) q += R;
      return q;
    } else return I;
  }
}), name$218 = "rotate", dependencies$218 = ["typed", "multiply", "rotationMatrix"], createRotate = factory(name$218, dependencies$218, (D) => {
  var { typed: E, multiply: O, rotationMatrix: F } = D;
  return E(name$218, { "Array , number | BigNumber | Complex | Unit": function(z, R) {
    return I(z, 2), O(F(R), z).toArray();
  }, "Matrix , number | BigNumber | Complex | Unit": function(z, R) {
    return I(z, 2), O(F(R), z);
  }, "Array, number | BigNumber | Complex | Unit, Array | Matrix": function(z, R, L) {
    return I(z, 3), O(F(R, L), z);
  }, "Matrix, number | BigNumber | Complex | Unit, Array | Matrix": function(z, R, L) {
    return I(z, 3), O(F(R, L), z);
  } });
  function I(z, R) {
    var L = Array.isArray(z) ? arraySize(z) : z.size();
    if (L.length > 2 || L.length === 2 && L[1] !== 1 || L[0] !== R) throw RangeError(`Vector must be of dimensions 1x${R}`);
  }
}), name$217 = "rotationMatrix", dependencies$217 = ["typed", "config", "multiplyScalar", "addScalar", "unaryMinus", "norm", "matrix", "BigNumber", "DenseMatrix", "SparseMatrix", "cos", "sin"], createRotationMatrix = factory(name$217, dependencies$217, (D) => {
  var { typed: E, config: O, multiplyScalar: F, addScalar: I, unaryMinus: z, norm: R, BigNumber: L, matrix: q, DenseMatrix: U, SparseMatrix: Z, cos: V, sin: G } = D;
  return E(name$217, { "": function() {
    return O.matrix === "Matrix" ? q([]) : [];
  }, string: function(K) {
    return q(K);
  }, "number | BigNumber | Complex | Unit": function(K) {
    return W(K, O.matrix === "Matrix" ? "dense" : void 0);
  }, "number | BigNumber | Complex | Unit, string": function(K, te) {
    return W(K, te);
  }, "number | BigNumber | Complex | Unit, Array": function(K, te) {
    var ie = q(te);
    return J(ie), ee(K, ie, void 0);
  }, "number | BigNumber | Complex | Unit, Matrix": function(K, te) {
    return J(te), ee(K, te, te.storage() || (O.matrix === "Matrix" ? "dense" : void 0));
  }, "number | BigNumber | Complex | Unit, Array, string": function(K, te, ie) {
    var ne = q(te);
    return J(ne), ee(K, ne, ie);
  }, "number | BigNumber | Complex | Unit, Matrix, string": function(K, te, ie) {
    return J(te), ee(K, te, ie);
  } });
  function W(K, te) {
    var ie = isBigNumber(K) ? new L(-1) : -1, ne = V(K), ae = G(K);
    return Y([[ne, F(ie, ae)], [ae, ne]], te);
  }
  function J(K) {
    var te = K.size();
    if (te.length < 1 || te[0] !== 3) throw RangeError("Vector must be of dimensions 1x3");
  }
  function X(K) {
    return K.reduce((te, ie) => F(te, ie));
  }
  function Y(K, te) {
    if (te) {
      if (te === "sparse") return new Z(K);
      if (te === "dense") return new U(K);
      throw TypeError(`Unknown matrix type "${te}"`);
    }
    return K;
  }
  function ee(K, te, ie) {
    var ne = R(te);
    if (ne === 0) throw RangeError("Rotation around zero vector");
    var ae = isBigNumber(K) ? L : null, ue = ae ? new ae(1) : 1, oe = ae ? new ae(-1) : -1, se = ae ? new ae(te.get([0]) / ne) : te.get([0]) / ne, le = ae ? new ae(te.get([1]) / ne) : te.get([1]) / ne, ce = ae ? new ae(te.get([2]) / ne) : te.get([2]) / ne, fe = V(K), pe = I(ue, z(fe)), ve = G(K), _e = I(fe, X([se, se, pe])), de = I(X([se, le, pe]), X([oe, ce, ve])), ge = I(X([se, ce, pe]), X([le, ve])), ye = I(X([se, le, pe]), X([ce, ve])), De = I(fe, X([le, le, pe])), Ce = I(X([le, ce, pe]), X([oe, se, ve])), Ie = I(X([se, ce, pe]), X([oe, le, ve])), Ne = I(X([le, ce, pe]), X([se, ve])), he = I(fe, X([ce, ce, pe]));
    return Y([[_e, de, ge], [ye, De, Ce], [Ie, Ne, he]], ie);
  }
}), name$216 = "row", dependencies$216 = ["typed", "Index", "matrix", "range"], createRow = factory(name$216, dependencies$216, (D) => {
  var { typed: E, Index: O, matrix: F, range: I } = D;
  return E(name$216, { "Matrix, number": z, "Array, number": function(R, L) {
    return z(F(clone$3(R)), L).valueOf();
  } });
  function z(R, L) {
    if (R.size().length !== 2) throw Error("Only two dimensional matrix is supported");
    validateIndex(L, R.size()[0]);
    var q = I(0, R.size()[1]), U = new O([L], q), Z = R.subset(U);
    return isMatrix(Z) ? Z : F([[Z]]);
  }
}), name$215 = "size", dependencies$215 = ["typed"], createSize = factory(name$215, dependencies$215, (D) => {
  var { typed: E } = D;
  return E(name$215, { Matrix: (O) => O.size(), Array: arraySize, string: (O) => [O.length], "number | Complex | BigNumber | Unit | boolean | null": (O) => [] });
}), name$214 = "squeeze", dependencies$214 = ["typed"], createSqueeze = factory(name$214, dependencies$214, (D) => {
  var { typed: E } = D;
  return E(name$214, { Array: function(O) {
    return squeeze(clone$3(O));
  }, Matrix: function(O) {
    var F = squeeze(O.toArray());
    return Array.isArray(F) ? O.create(F, O.datatype()) : F;
  }, any: function(O) {
    return clone$3(O);
  } });
}), name$213 = "subset", dependencies$213 = ["typed", "matrix", "zeros", "add"], createSubset = factory(name$213, dependencies$213, (D) => {
  var { typed: E, matrix: O, zeros: F, add: I } = D;
  return E(name$213, { "Matrix, Index": function(R, L) {
    return isEmptyIndex(L) ? O() : (validateIndexSourceSize(R, L), R.subset(L));
  }, "Array, Index": E.referTo("Matrix, Index", function(R) {
    return function(L, q) {
      var U = R(O(L), q);
      return q.isScalar() ? U : U.valueOf();
    };
  }), "Object, Index": _getObjectProperty, "string, Index": _getSubstring, "Matrix, Index, any, any": function(R, L, q, U) {
    return isEmptyIndex(L) ? R : (validateIndexSourceSize(R, L), R.clone().subset(L, z(q, L), U));
  }, "Array, Index, any, any": E.referTo("Matrix, Index, any, any", function(R) {
    return function(L, q, U, Z) {
      var V = R(O(L), q, U, Z);
      return V.isMatrix ? V.valueOf() : V;
    };
  }), "Array, Index, any": E.referTo("Matrix, Index, any, any", function(R) {
    return function(L, q, U) {
      return R(O(L), q, U, void 0).valueOf();
    };
  }), "Matrix, Index, any": E.referTo("Matrix, Index, any, any", function(R) {
    return function(L, q, U) {
      return R(L, q, U, void 0);
    };
  }), "string, Index, string": _setSubstring, "string, Index, string, string": _setSubstring, "Object, Index, any": _setObjectProperty });
  function z(R, L) {
    if (typeof R == "string") throw Error("can't boradcast a string");
    if (L.isScalar()) return R;
    var q = L.size();
    if (q.every((U) => U > 0)) try {
      return I(R, F(q));
    } catch {
      return R;
    }
    else return R;
  }
});
function _getSubstring(D, E) {
  if (!isIndex(E)) throw TypeError("Index expected");
  if (isEmptyIndex(E)) return "";
  if (validateIndexSourceSize(Array.from(D), E), E.size().length !== 1) throw new DimensionError(E.size().length, 1);
  var O = D.length;
  validateIndex(E.min()[0], O), validateIndex(E.max()[0], O);
  var F = E.dimension(0), I = "";
  function z(R) {
    I += D.charAt(R);
  }
  return Number.isInteger(F) ? z(F) : F.forEach(z), I;
}
function _setSubstring(D, E, O, F) {
  if (!E || E.isIndex !== !0) throw TypeError("Index expected");
  if (isEmptyIndex(E)) return D;
  if (validateIndexSourceSize(Array.from(D), E), E.size().length !== 1) throw new DimensionError(E.size().length, 1);
  if (F !== void 0) {
    if (typeof F != "string" || F.length !== 1) throw TypeError("Single character expected as defaultValue");
  } else F = " ";
  var I = E.dimension(0);
  if ((Number.isInteger(I) ? 1 : I.size()[0]) !== O.length) throw new DimensionError(I.size()[0], O.length);
  var z = D.length;
  validateIndex(E.min()[0]), validateIndex(E.max()[0]);
  for (var R = [], L = 0; L < z; L++) R[L] = D.charAt(L);
  function q(V, G) {
    R[V] = O.charAt(G[0]);
  }
  if (Number.isInteger(I) ? q(I, [0]) : I.forEach(q), R.length > z) for (var U = z - 1, Z = R.length; U < Z; U++) R[U] || (R[U] = F);
  return R.join("");
}
function _getObjectProperty(D, E) {
  if (!isEmptyIndex(E)) {
    if (E.size().length !== 1) throw new DimensionError(E.size(), 1);
    var O = E.dimension(0);
    if (typeof O != "string") throw TypeError("String expected as index to retrieve an object property");
    return getSafeProperty(D, O);
  }
}
function _setObjectProperty(D, E, O) {
  if (isEmptyIndex(E)) return D;
  if (E.size().length !== 1) throw new DimensionError(E.size(), 1);
  var F = E.dimension(0);
  if (typeof F != "string") throw TypeError("String expected as index to retrieve an object property");
  var I = clone$3(D);
  return setSafeProperty(I, F, O), I;
}
var name$212 = "transpose", dependencies$212 = ["typed", "matrix"], createTranspose = factory(name$212, dependencies$212, (D) => {
  var { typed: E, matrix: O } = D;
  return E(name$212, { Array: (R) => F(O(R)).valueOf(), Matrix: F, any: clone$3 });
  function F(R) {
    var L = R.size(), q;
    switch (L.length) {
      case 1:
        q = R.clone();
        break;
      case 2:
        var U = L[0], Z = L[1];
        if (Z === 0) throw RangeError("Cannot transpose a 2D matrix with no columns (size: " + format(L) + ")");
        switch (R.storage()) {
          case "dense":
            q = I(R, U, Z);
            break;
          case "sparse":
            q = z(R, U, Z);
            break;
        }
        break;
      default:
        throw RangeError("Matrix must be a vector or two dimensional (size: " + format(L) + ")");
    }
    return q;
  }
  function I(R, L, q) {
    for (var U = R._data, Z = [], V, G = 0; G < q; G++) {
      V = Z[G] = [];
      for (var W = 0; W < L; W++) V[W] = clone$3(U[W][G]);
    }
    return R.createDenseMatrix({ data: Z, size: [q, L], datatype: R._datatype });
  }
  function z(R, L, q) {
    for (var U = R._values, Z = R._index, V = R._ptr, G = U ? [] : void 0, W = [], J = [], X = [], Y = 0; Y < L; Y++) X[Y] = 0;
    var ee, K, te;
    for (ee = 0, K = Z.length; ee < K; ee++) X[Z[ee]]++;
    for (var ie = 0, ne = 0; ne < L; ne++) J.push(ie), ie += X[ne], X[ne] = J[ne];
    for (J.push(ie), te = 0; te < q; te++) for (var ae = V[te], ue = V[te + 1], oe = ae; oe < ue; oe++) {
      var se = X[Z[oe]]++;
      W[se] = te, U && (G[se] = clone$3(U[oe]));
    }
    return R.createSparseMatrix({ values: G, index: W, ptr: J, size: [q, L], datatype: R._datatype });
  }
}), name$211 = "ctranspose", dependencies$211 = ["typed", "transpose", "conj"], createCtranspose = factory(name$211, dependencies$211, (D) => {
  var { typed: E, transpose: O, conj: F } = D;
  return E(name$211, { any: function(I) {
    return F(O(I));
  } });
}), name$210 = "zeros", dependencies$210 = ["typed", "config", "matrix", "BigNumber"], createZeros = factory(name$210, dependencies$210, (D) => {
  var { typed: E, config: O, matrix: F, BigNumber: I } = D;
  return E(name$210, { "": function() {
    return O.matrix === "Array" ? z([]) : z([], "default");
  }, "...number | BigNumber | string": function(q) {
    return typeof q[q.length - 1] == "string" ? z(q, q.pop()) : O.matrix === "Array" ? z(q) : z(q, "default");
  }, Array: z, Matrix: function(q) {
    var U = q.storage();
    return z(q.valueOf(), U);
  }, "Array | Matrix, string": function(q, U) {
    return z(q.valueOf(), U);
  } });
  function z(q, U) {
    var Z = R(q) ? new I(0) : 0;
    if (L(q), U) {
      var V = F(U);
      return q.length > 0 ? V.resize(q, Z) : V;
    } else {
      var G = [];
      return q.length > 0 ? resize(G, q, Z) : G;
    }
  }
  function R(q) {
    var U = !1;
    return q.forEach(function(Z, V, G) {
      isBigNumber(Z) && (U = !0, G[V] = Z.toNumber());
    }), U;
  }
  function L(q) {
    q.forEach(function(U) {
      if (typeof U != "number" || !isInteger(U) || U < 0) throw Error("Parameters in function zeros must be positive integers");
    });
  }
}), name$209 = "fft", dependencies$209 = ["typed", "matrix", "addScalar", "multiplyScalar", "divideScalar", "exp", "tau", "i", "dotDivide", "conj", "pow", "ceil", "log2"], createFft = factory(name$209, dependencies$209, (D) => {
  var { typed: E, matrix: O, addScalar: F, multiplyScalar: I, divideScalar: z, exp: R, tau: L, i: q, dotDivide: U, conj: Z, pow: V, ceil: G, log2: W } = D;
  return E(name$209, { Array: J, Matrix: function(K) {
    return K.create(J(K.valueOf()), K.datatype());
  } });
  function J(K) {
    var te = arraySize(K);
    return te.length === 1 ? ee(K, te[0]) : X(K.map((ie) => J(ie, te.slice(1))), 0);
  }
  function X(K, te) {
    var ie = arraySize(K);
    if (te !== 0) return Array(ie[0]).fill(0).map((ae, ue) => X(K[ue], te - 1));
    if (ie.length === 1) return ee(K);
    function ne(ae) {
      var ue = arraySize(ae);
      return Array(ue[1]).fill(0).map((oe, se) => Array(ue[0]).fill(0).map((le, ce) => ae[ce][se]));
    }
    return ne(X(ne(K), 1));
  }
  function Y(K) {
    for (var te = K.length, ie = R(z(I(-1, I(q, L)), te)), ne = [], ae = 1 - te; ae < te; ae++) ne.push(V(ie, z(V(ae, 2), 2)));
    for (var ue = V(2, G(W(te + te - 1))), oe = [...Array(te).fill(0).map((_e, de) => I(K[de], ne[te - 1 + de])), ...Array(ue - te).fill(0)], se = [...Array(te + te - 1).fill(0).map((_e, de) => z(1, ne[de])), ...Array(ue - (te + te - 1)).fill(0)], le = ee(oe), ce = ee(se), fe = U(Z(J(Z(Array(ue).fill(0).map((_e, de) => I(le[de], ce[de]))))), ue), pe = [], ve = te - 1; ve < te + te - 1; ve++) pe.push(I(fe[ve], ne[ve]));
    return pe;
  }
  function ee(K) {
    var te = K.length;
    if (te === 1) return [K[0]];
    if (te % 2 == 0) {
      for (var ie = [...ee(K.filter((oe, se) => se % 2 == 0)), ...ee(K.filter((oe, se) => se % 2 == 1))], ne = 0; ne < te / 2; ne++) {
        var ae = ie[ne], ue = I(ie[ne + te / 2], R(I(I(L, q), z(-ne, te))));
        ie[ne] = F(ae, ue), ie[ne + te / 2] = F(ae, I(-1, ue));
      }
      return ie;
    } else return Y(K);
  }
}), name$208 = "ifft", dependencies$208 = ["typed", "fft", "dotDivide", "conj"], createIfft = factory(name$208, dependencies$208, (D) => {
  var { typed: E, fft: O, dotDivide: F, conj: I } = D;
  return E(name$208, { "Array | Matrix": function(z) {
    var R = isMatrix(z) ? z.size() : arraySize(z);
    return F(I(O(I(z))), R.reduce((L, q) => L * q, 1));
  } });
});
function _typeof(D) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(E) {
    return typeof E;
  } : function(E) {
    return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
  }, _typeof(D);
}
function toPrimitive(D, E) {
  if (_typeof(D) != "object" || !D) return D;
  var O = D[Symbol.toPrimitive];
  if (O !== void 0) {
    var F = O.call(D, E);
    if (_typeof(F) != "object") return F;
    throw TypeError("@@toPrimitive must return a primitive value.");
  }
  return (E === "string" ? String : Number)(D);
}
function toPropertyKey(D) {
  var E = toPrimitive(D, "string");
  return _typeof(E) == "symbol" ? E : E + "";
}
function _defineProperty(D, E, O) {
  return (E = toPropertyKey(E)) in D ? Object.defineProperty(D, E, { value: O, enumerable: !0, configurable: !0, writable: !0 }) : D[E] = O, D;
}
function ownKeys$3(D, E) {
  var O = Object.keys(D);
  if (Object.getOwnPropertySymbols) {
    var F = Object.getOwnPropertySymbols(D);
    E && (F = F.filter(function(I) {
      return Object.getOwnPropertyDescriptor(D, I).enumerable;
    })), O.push.apply(O, F);
  }
  return O;
}
function _objectSpread$3(D) {
  for (var E = 1; E < arguments.length; E++) {
    var O = arguments[E] == null ? {} : arguments[E];
    E % 2 ? ownKeys$3(Object(O), !0).forEach(function(F) {
      _defineProperty(D, F, O[F]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(D, Object.getOwnPropertyDescriptors(O)) : ownKeys$3(Object(O)).forEach(function(F) {
      Object.defineProperty(D, F, Object.getOwnPropertyDescriptor(O, F));
    });
  }
  return D;
}
var name$207 = "solveODE", dependencies$207 = ["typed", "add", "subtract", "multiply", "divide", "max", "map", "abs", "isPositive", "isNegative", "larger", "smaller", "matrix", "bignumber", "unaryMinus"], createSolveODE = factory(name$207, dependencies$207, (D) => {
  var { typed: E, add: O, subtract: F, multiply: I, divide: z, max: R, map: L, abs: q, isPositive: U, isNegative: Z, larger: V, smaller: G, matrix: W, bignumber: J, unaryMinus: X } = D;
  function Y(oe) {
    return function(se, le, ce, fe) {
      if (!(le.length === 2 && (le.every(ae) || le.every(isUnit)))) throw Error('"tspan" must be an Array of two numeric values or two units [tStart, tEnd]');
      var pe = le[0], ve = le[1], _e = V(ve, pe), de = fe.firstStep;
      if (de !== void 0 && !U(de)) throw Error('"firstStep" must be positive');
      var ge = fe.maxStep;
      if (ge !== void 0 && !U(ge)) throw Error('"maxStep" must be positive');
      var ye = fe.minStep;
      if (ye && Z(ye)) throw Error('"minStep" must be positive or zero');
      var De = [pe, ve, de, ye, ge].filter((ze) => ze !== void 0);
      if (!(De.every(ae) || De.every(isUnit))) throw Error('Inconsistent type of "t" dependant variables');
      for (var Ce = 1, Ie = fe.tol ? fe.tol : 1e-4, Ne = fe.minDelta ? fe.minDelta : 0.2, he = fe.maxDelta ? fe.maxDelta : 5, ke = fe.maxIter ? fe.maxIter : 1e4, xe = [pe, ve, ...ce, ge, ye].some(isBigNumber), [Te, Fe, be, Ae] = xe ? [J(oe.a), J(oe.c), J(oe.b), J(oe.bp)] : [oe.a, oe.c, oe.b, oe.bp], Me = de ? _e ? de : X(de) : z(F(ve, pe), Ce), $e = [pe], Re = [ce], je = F(be, Ae), Pe = 0, Ke = 0, Qe = ie(_e), We = ne(_e); Qe($e[Pe], ve); ) {
        var ir = [];
        Me = We($e[Pe], ve, Me), ir.push(se($e[Pe], Re[Pe]));
        for (var nr = 1; nr < Fe.length; ++nr) ir.push(se(O($e[Pe], I(Fe[nr], Me)), O(Re[Pe], I(Me, Te[nr], ir))));
        var we = R(q(L(I(je, ir), (ze) => isUnit(ze) ? ze.value : ze)));
        we < Ie && Ie / we > 1 / 4 && ($e.push(O($e[Pe], Me)), Re.push(O(Re[Pe], I(Me, be, ir))), Pe++);
        var Oe = 0.84 * (Ie / we) ** (1 / 5);
        if (G(Oe, Ne) ? Oe = Ne : V(Oe, he) && (Oe = he), Oe = xe ? J(Oe) : Oe, Me = I(Me, Oe), ge && V(q(Me), ge) ? Me = _e ? ge : X(ge) : ye && G(q(Me), ye) && (Me = _e ? ye : X(ye)), Ke++, Ke > ke) throw Error("Maximum number of iterations reached, try changing options");
      }
      return { t: $e, y: Re };
    };
  }
  function ee(oe, se, le, ce) {
    return Y({ a: [[], [1 / 2], [0, 3 / 4], [2 / 9, 1 / 3, 4 / 9]], c: [null, 1 / 2, 3 / 4, 1], b: [2 / 9, 1 / 3, 4 / 9, 0], bp: [7 / 24, 1 / 4, 1 / 3, 1 / 8] })(oe, se, le, ce);
  }
  function K(oe, se, le, ce) {
    return Y({ a: [[], [1 / 5], [3 / 40, 9 / 40], [44 / 45, -56 / 15, 32 / 9], [19372 / 6561, -25360 / 2187, 64448 / 6561, -212 / 729], [9017 / 3168, -355 / 33, 46732 / 5247, 49 / 176, -5103 / 18656], [35 / 384, 0, 500 / 1113, 125 / 192, -2187 / 6784, 11 / 84]], c: [null, 1 / 5, 3 / 10, 4 / 5, 8 / 9, 1, 1], b: [35 / 384, 0, 500 / 1113, 125 / 192, -2187 / 6784, 11 / 84, 0], bp: [5179 / 57600, 0, 7571 / 16695, 393 / 640, -92097 / 339200, 187 / 2100, 1 / 40] })(oe, se, le, ce);
  }
  function te(oe, se, le, ce) {
    var fe = ce.method ? ce.method : "RK45", pe = { RK23: ee, RK45: K };
    if (fe.toUpperCase() in pe) {
      var ve = _objectSpread$3({}, ce);
      return delete ve.method, pe[fe.toUpperCase()](oe, se, le, ve);
    } else {
      var _e = Object.keys(pe).map((ge) => `"${ge}"`), de = `${_e.slice(0, -1).join(", ")} and ${_e.slice(-1)}`;
      throw Error(`Unavailable method "${fe}". Available methods are ${de}`);
    }
  }
  function ie(oe) {
    return oe ? G : V;
  }
  function ne(oe) {
    var se = oe ? V : G;
    return function(le, ce, fe) {
      return se(O(le, fe), ce) ? F(ce, le) : fe;
    };
  }
  function ae(oe) {
    return isBigNumber(oe) || isNumber(oe);
  }
  function ue(oe, se, le, ce) {
    var fe = te(oe, se.toArray(), le.toArray(), ce);
    return { t: W(fe.t), y: W(fe.y) };
  }
  return E("solveODE", { "function, Array, Array, Object": te, "function, Matrix, Matrix, Object": ue, "function, Array, Array": (oe, se, le) => te(oe, se, le, {}), "function, Matrix, Matrix": (oe, se, le) => ue(oe, se, le, {}), "function, Array, number | BigNumber | Unit": (oe, se, le) => {
    var ce = te(oe, se, [le], {});
    return { t: ce.t, y: ce.y.map((fe) => fe[0]) };
  }, "function, Matrix, number | BigNumber | Unit": (oe, se, le) => {
    var ce = te(oe, se.toArray(), [le], {});
    return { t: W(ce.t), y: W(ce.y.map((fe) => fe[0])) };
  }, "function, Array, number | BigNumber | Unit, Object": (oe, se, le, ce) => {
    var fe = te(oe, se, [le], ce);
    return { t: fe.t, y: fe.y.map((pe) => pe[0]) };
  }, "function, Matrix, number | BigNumber | Unit, Object": (oe, se, le, ce) => {
    var fe = te(oe, se.toArray(), [le], ce);
    return { t: W(fe.t), y: W(fe.y.map((pe) => pe[0])) };
  } });
}), name$206 = "erf", dependencies$206 = ["typed"], createErf = factory(name$206, dependencies$206, (D) => {
  var { typed: E } = D;
  return E("name", { number: function(z) {
    var R = Math.abs(z);
    return R >= MAX_NUM ? sign$2(z) : R <= THRESH ? sign$2(z) * O(R) : R <= 4 ? sign$2(z) * (1 - F(R)) : sign$2(z) * (1 - I(R));
  }, "Array | Matrix": E.referToSelf((z) => (R) => deepMap(R, z)) });
  function O(z) {
    var R = z * z, L = P[0][4] * R, q = R, U;
    for (U = 0; U < 3; U += 1) L = (L + P[0][U]) * R, q = (q + Q[0][U]) * R;
    return z * (L + P[0][3]) / (q + Q[0][3]);
  }
  function F(z) {
    var R = P[1][8] * z, L = z, q;
    for (q = 0; q < 7; q += 1) R = (R + P[1][q]) * z, L = (L + Q[1][q]) * z;
    var U = (R + P[1][7]) / (L + Q[1][7]), Z = parseInt(z * 16) / 16, V = (z - Z) * (z + Z);
    return Math.exp(-Z * Z) * Math.exp(-V) * U;
  }
  function I(z) {
    var R = 1 / (z * z), L = P[2][5] * R, q = R, U;
    for (U = 0; U < 4; U += 1) L = (L + P[2][U]) * R, q = (q + Q[2][U]) * R;
    var Z = R * (L + P[2][4]) / (q + Q[2][4]);
    Z = (SQRPI - Z) / z, R = parseInt(z * 16) / 16;
    var V = (z - R) * (z + R);
    return Math.exp(-R * R) * Math.exp(-V) * Z;
  }
}), THRESH = 0.46875, SQRPI = 0.5641895835477563, P = [[3.1611237438705655, 113.86415415105016, 377.485237685302, 3209.3775891384694, 0.18577770618460315], [0.5641884969886701, 8.883149794388377, 66.11919063714163, 298.6351381974001, 881.952221241769, 1712.0476126340707, 2051.0783778260716, 1230.3393547979972, 21531153547440383e-24], [0.30532663496123236, 0.36034489994980445, 0.12578172611122926, 0.016083785148742275, 6587491615298378e-19, 0.016315387137302097]], Q = [[23.601290952344122, 244.02463793444417, 1282.6165260773723, 2844.236833439171], [15.744926110709835, 117.6939508913125, 537.1811018620099, 1621.3895745666903, 3290.7992357334597, 4362.619090143247, 3439.3676741437216, 1230.3393548037495], [2.568520192289822, 1.8729528499234604, 0.5279051029514285, 0.06051834131244132, 0.0023352049762686918]], MAX_NUM = 2 ** 53, name$205 = "zeta", dependencies$205 = ["typed", "config", "multiply", "pow", "divide", "factorial", "equal", "smallerEq", "isBounded", "isNegative", "gamma", "sin", "subtract", "add", "?Complex", "?BigNumber", "pi"], createZeta = factory(name$205, dependencies$205, (D) => {
  var { typed: E, config: O, multiply: F, pow: I, divide: z, factorial: R, equal: L, smallerEq: q, isBounded: U, isNegative: Z, gamma: V, sin: G, subtract: W, add: J, Complex: X, BigNumber: Y, pi: ee } = D;
  return E(name$205, { number: (ue) => K(ue, (oe) => oe, () => 20), BigNumber: (ue) => K(ue, (oe) => new Y(oe), () => Math.abs(Math.log10(O.relTol))), Complex: te });
  function K(ue, oe, se) {
    return L(ue, 0) ? oe(-0.5) : L(ue, 1) ? oe(NaN) : U(ue) ? ie(ue, oe, se, (le) => le) : Z(ue) ? oe(NaN) : oe(1);
  }
  function te(ue) {
    return ue.re === 0 && ue.im === 0 ? new X(-0.5) : ue.re === 1 ? new X(NaN, NaN) : ue.re === 1 / 0 && ue.im === 0 ? new X(1) : ue.im === 1 / 0 || ue.re === -1 / 0 ? new X(NaN, NaN) : ie(ue, (oe) => oe, (oe) => Math.round(1.3 * 15 + 0.9 * Math.abs(oe.im)), (oe) => oe.re);
  }
  function ie(ue, oe, se, le) {
    var ce = se(ue);
    if (le(ue) > -(ce - 1) / 2) return ae(ue, oe(ce), oe);
    var fe = F(I(2, ue), I(oe(ee), W(ue, 1)));
    return fe = F(fe, G(F(z(oe(ee), 2), ue))), fe = F(fe, V(W(1, ue))), F(fe, ie(W(1, ue), oe, se, le));
  }
  function ne(ue, oe) {
    for (var se = ue, le = ue; q(le, oe); le = J(le, 1)) {
      var ce = z(F(R(J(oe, W(le, 1))), I(4, le)), F(R(W(oe, le)), R(F(2, le))));
      se = J(se, ce);
    }
    return F(oe, se);
  }
  function ae(ue, oe, se) {
    for (var le = z(1, F(ne(se(0), oe), W(1, I(2, W(1, ue))))), ce = se(0), fe = se(1); q(fe, oe); fe = J(fe, 1)) ce = J(ce, z(F((-1) ** (fe - 1), ne(fe, oe)), I(fe, ue)));
    return F(le, ce);
  }
}), name$204 = "mode", dependencies$204 = ["typed", "isNaN", "isNumeric"], createMode = factory(name$204, dependencies$204, (D) => {
  var { typed: E, isNaN: O, isNumeric: F } = D;
  return E(name$204, { "Array | Matrix": I, "...": function(z) {
    return I(z);
  } });
  function I(z) {
    if (z = flatten$4(z.valueOf()), z.length === 0) throw Error("Cannot calculate mode of an empty array");
    for (var R = {}, L = [], q = 0, U = 0; U < z.length; U++) {
      var Z = z[U];
      if (F(Z) && O(Z)) throw Error("Cannot calculate mode of an array containing NaN values");
      Z in R || (R[Z] = 0), R[Z]++, R[Z] === q ? L.push(Z) : R[Z] > q && (q = R[Z], L = [Z]);
    }
    return L;
  }
});
function improveErrorMessage(D, E, O) {
  var F;
  return String(D).includes("Unexpected type") ? (F = arguments.length > 2 ? " (type: " + typeOf(O) + ", value: " + JSON.stringify(O) + ")" : " (type: " + D.data.actual + ")", TypeError("Cannot calculate " + E + ", unexpected type of argument" + F)) : String(D).includes("complex numbers") ? (F = arguments.length > 2 ? " (type: " + typeOf(O) + ", value: " + JSON.stringify(O) + ")" : "", TypeError("Cannot calculate " + E + ", no ordering relation is defined for complex numbers" + F)) : D;
}
var name$203 = "prod", dependencies$203 = ["typed", "config", "multiplyScalar", "numeric"], createProd = factory(name$203, dependencies$203, (D) => {
  var { typed: E, config: O, multiplyScalar: F, numeric: I } = D;
  return E(name$203, { "Array | Matrix": z, "Array | Matrix, number | BigNumber": function(R, L) {
    throw Error("prod(A, dim) is not yet supported");
  }, "...": function(R) {
    return z(R);
  } });
  function z(R) {
    var L;
    if (deepForEach(R, function(q) {
      try {
        L = L === void 0 ? q : F(L, q);
      } catch (U) {
        throw improveErrorMessage(U, "prod", q);
      }
    }), typeof L == "string" && (L = I(L, safeNumberType(L, O))), L === void 0) throw Error("Cannot calculate prod of an empty array");
    return L;
  }
}), name$202 = "format", dependencies$202 = ["typed"], createFormat = factory(name$202, dependencies$202, (D) => {
  var { typed: E } = D;
  return E(name$202, { any: format, "any, Object | function | number | BigNumber": format });
}), name$201 = "bin", dependencies$201 = ["typed", "format"], createBin = factory(name$201, dependencies$201, (D) => {
  var { typed: E, format: O } = D;
  return E(name$201, { "number | BigNumber": function(F) {
    return O(F, { notation: "bin" });
  }, "number | BigNumber, number | BigNumber": function(F, I) {
    return O(F, { notation: "bin", wordSize: I });
  } });
}), name$200 = "oct", dependencies$200 = ["typed", "format"], createOct = factory(name$200, dependencies$200, (D) => {
  var { typed: E, format: O } = D;
  return E(name$200, { "number | BigNumber": function(F) {
    return O(F, { notation: "oct" });
  }, "number | BigNumber, number | BigNumber": function(F, I) {
    return O(F, { notation: "oct", wordSize: I });
  } });
}), name$199 = "hex", dependencies$199 = ["typed", "format"], createHex = factory(name$199, dependencies$199, (D) => {
  var { typed: E, format: O } = D;
  return E(name$199, { "number | BigNumber": function(F) {
    return O(F, { notation: "hex" });
  }, "number | BigNumber, number | BigNumber": function(F, I) {
    return O(F, { notation: "hex", wordSize: I });
  } });
}), printTemplate = /\$([\w.]+)/g, name$198 = "print", dependencies$198 = ["typed"], createPrint = factory(name$198, dependencies$198, (D) => {
  var { typed: E } = D;
  return E(name$198, { "string, Object | Array": _print, "string, Object | Array, number | Object": _print });
});
function _print(D, E, O) {
  return D.replace(printTemplate, function(F, I) {
    var z = I.split("."), R = E[z.shift()];
    for (R !== void 0 && R.isMatrix && (R = R.toArray()); z.length && R !== void 0; ) {
      var L = z.shift();
      R = L ? R[L] : R + ".";
    }
    return R === void 0 ? F : isString(R) ? R : format(R, O);
  });
}
var name$197 = "to", dependencies$197 = ["typed", "matrix", "concat"], createTo = factory(name$197, dependencies$197, (D) => {
  var { typed: E, matrix: O, concat: F } = D;
  return E(name$197, { "Unit, Unit | string": (I, z) => I.to(z) }, createMatrixAlgorithmSuite({ typed: E, matrix: O, concat: F })({ Ds: !0 }));
}), name$196 = "toBest", dependencies$196 = ["typed"], createToBest = factory(name$196, dependencies$196, (D) => {
  var { typed: E } = D;
  return E(name$196, { Unit: (O) => O.toBest(), "Unit, string": (O, F) => O.toBest(F.split(",")), "Unit, string, Object": (O, F, I) => O.toBest(F.split(","), I), "Unit, Array": (O, F) => O.toBest(F), "Unit, Array, Object": (O, F, I) => O.toBest(F, I) });
}), name$195 = "isPrime", dependencies$195 = ["typed"], createIsPrime = factory(name$195, dependencies$195, (D) => {
  var { typed: E } = D;
  return E(name$195, { number: function(O) {
    if (O <= 3) return O > 1;
    if (O % 2 == 0 || O % 3 == 0) return !1;
    for (var F = 5; F * F <= O; F += 6) if (O % F === 0 || O % (F + 2) === 0) return !1;
    return !0;
  }, bigint: function(O) {
    if (O <= 3n) return O > 1n;
    if (O % 2n == 0n || O % 3n == 0n) return !1;
    for (var F = 5n; F * F <= O; F += 6n) if (O % F === 0n || O % (F + 2n) === 0n) return !1;
    return !0;
  }, BigNumber: function(O) {
    if (O.lte(3)) return O.gt(1);
    if (O.mod(2).eq(0) || O.mod(3).eq(0)) return !1;
    if (O.lt(2 ** 32)) {
      for (var F = O.toNumber(), I = 5; I * I <= F; I += 6) if (F % I === 0 || F % (I + 2) === 0) return !1;
      return !0;
    }
    function z(Y, ee, K) {
      for (var te = 1; !ee.eq(0); ) ee.mod(2).eq(0) ? (ee = ee.div(2), Y = Y.mul(Y).mod(K)) : (ee = ee.sub(1), te = Y.mul(te).mod(K));
      return te;
    }
    O = new (O.constructor.clone({ precision: O.toFixed(0).length * 2 }))(O);
    for (var R = 0, L = O.sub(1); L.mod(2).eq(0); ) L = L.div(2), R += 1;
    var q = null;
    if (O.lt("3317044064679887385961981")) q = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41].filter((Y) => Y < O);
    else {
      var U = Math.min(O.toNumber() - 2, Math.floor(2 * (O.toFixed(0).length * Math.log(10)) ** 2));
      q = [];
      for (var Z = 2; Z <= U; Z += 1) q.push(U);
    }
    for (var V = 0; V < q.length; V += 1) {
      var G = q[V], W = z(O.sub(O).add(G), L, O);
      if (!W.eq(1)) {
        for (var J = 0, X = W; !X.eq(O.sub(1)); J += 1, X = X.mul(X).mod(O)) if (J === R - 1) return !1;
      }
    }
    return !0;
  }, "Array | Matrix": E.referToSelf((O) => (F) => deepMap(F, O)) });
}), name$194 = "numeric", dependencies$194 = ["number", "?bignumber", "?fraction"], createNumeric = factory(name$194, dependencies$194, (D) => {
  var { number: E, bignumber: O, fraction: F } = D, I = { string: !0, number: !0, BigNumber: !0, Fraction: !0 }, z = { number: (R) => E(R), BigNumber: O ? (R) => O(R) : noBignumber, bigint: (R) => BigInt(R), Fraction: F ? (R) => F(R) : noFraction };
  return function(R) {
    var L = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "number";
    if ((arguments.length > 2 ? arguments[2] : void 0) !== void 0) throw SyntaxError("numeric() takes one or two arguments");
    var q = typeOf(R);
    if (!(q in I)) throw TypeError("Cannot convert " + R + ' of type "' + q + '"; valid input types are ' + Object.keys(I).join(", "));
    if (!(L in z)) throw TypeError("Cannot convert " + R + ' to type "' + L + '"; valid output types are ' + Object.keys(z).join(", "));
    return L === q ? R : z[L](R);
  };
}), name$193 = "divideScalar", dependencies$193 = ["typed", "numeric"], createDivideScalar = factory(name$193, dependencies$193, (D) => {
  var { typed: E, numeric: O } = D;
  return E(name$193, { "number, number": function(F, I) {
    return F / I;
  }, "Complex, Complex": function(F, I) {
    return F.div(I);
  }, "BigNumber, BigNumber": function(F, I) {
    return F.div(I);
  }, "bigint, bigint": function(F, I) {
    return F / I;
  }, "Fraction, Fraction": function(F, I) {
    return F.div(I);
  }, "Unit, number | Complex | Fraction | BigNumber | Unit": (F, I) => F.divide(I), "number | Fraction | Complex | BigNumber, Unit": (F, I) => I.divideInto(F) });
}), name$192 = "pow", dependencies$192 = ["typed", "config", "identity", "multiply", "matrix", "inv", "fraction", "number", "Complex"], createPow = factory(name$192, dependencies$192, (D) => {
  var { typed: E, config: O, identity: F, multiply: I, matrix: z, inv: R, number: L, fraction: q, Complex: U } = D;
  return E(name$192, { "number, number": Z, "Complex, Complex": function(W, J) {
    return W.pow(J);
  }, "BigNumber, BigNumber": function(W, J) {
    return J.isInteger() || W >= 0 || O.predictable ? W.pow(J) : new U(W.toNumber(), 0).pow(J.toNumber(), 0);
  }, "bigint, bigint": (W, J) => W ** J, "Fraction, Fraction": function(W, J) {
    var X = W.pow(J);
    if (X != null) return X;
    if (O.predictable) throw Error("Result of pow is non-rational and cannot be expressed as a fraction");
    return Z(W.valueOf(), J.valueOf());
  }, "Array, number": V, "Array, BigNumber": function(W, J) {
    return V(W, J.toNumber());
  }, "Matrix, number": G, "Matrix, BigNumber": function(W, J) {
    return G(W, J.toNumber());
  }, "Unit, number | BigNumber": function(W, J) {
    return W.pow(J);
  } });
  function Z(W, J) {
    if (O.predictable && !isInteger(J) && W < 0) try {
      var X = q(J), Y = L(X);
      if ((J === Y || Math.abs((J - Y) / J) < 1e-14) && X.d % 2n == 1n) return (X.n % 2n == 0n ? 1 : -1) * (-W) ** +J;
    } catch {
    }
    return O.predictable && (W < -1 && J === 1 / 0 || W > -1 && W < 0 && J === -1 / 0) ? NaN : isInteger(J) || W >= 0 || O.predictable ? powNumber(W, J) : W * W < 1 && J === 1 / 0 || W * W > 1 && J === -1 / 0 ? 0 : new U(W, 0).pow(J, 0);
  }
  function V(W, J) {
    if (!isInteger(J)) throw TypeError("For A^b, b must be an integer (value is " + J + ")");
    var X = arraySize(W);
    if (X.length !== 2) throw Error("For A^b, A must be 2 dimensional (A has " + X.length + " dimensions)");
    if (X[0] !== X[1]) throw Error("For A^b, A must be square (size is " + X[0] + "x" + X[1] + ")");
    if (J < 0) try {
      return V(R(W), -J);
    } catch (K) {
      throw K.message === "Cannot calculate inverse, determinant is zero" ? TypeError("For A^b, when A is not invertible, b must be a positive integer (value is " + J + ")") : K;
    }
    for (var Y = F(X[0]).valueOf(), ee = W; J >= 1; ) (J & 1) == 1 && (Y = I(ee, Y)), J >>= 1, ee = I(ee, ee);
    return Y;
  }
  function G(W, J) {
    return z(V(W.valueOf(), J));
  }
}), NO_INT = "Number of decimals in function round must be an integer", name$191 = "round", dependencies$191 = ["typed", "config", "matrix", "equalScalar", "zeros", "BigNumber", "DenseMatrix"], createRound = factory(name$191, dependencies$191, (D) => {
  var { typed: E, config: O, matrix: F, equalScalar: I, zeros: z, BigNumber: R, DenseMatrix: L } = D, q = createMatAlgo11xS0s({ typed: E, equalScalar: I }), U = createMatAlgo12xSfs({ typed: E, DenseMatrix: L }), Z = createMatAlgo14xDs({ typed: E });
  function V(G) {
    return Math.abs(splitNumber(G).exponent);
  }
  return E(name$191, { number: function(G) {
    var W = roundNumber(G, V(O.relTol));
    return roundNumber(nearlyEqual$1(G, W, O.relTol, O.absTol) ? W : G);
  }, "number, number": function(G, W) {
    var J = V(O.relTol);
    if (W >= J) return roundNumber(G, W);
    var X = roundNumber(G, J);
    return roundNumber(nearlyEqual$1(G, X, O.relTol, O.absTol) ? X : G, W);
  }, "number, BigNumber": function(G, W) {
    if (!W.isInteger()) throw TypeError(NO_INT);
    return new R(G).toDecimalPlaces(W.toNumber());
  }, Complex: function(G) {
    return G.round();
  }, "Complex, number": function(G, W) {
    if (W % 1) throw TypeError(NO_INT);
    return G.round(W);
  }, "Complex, BigNumber": function(G, W) {
    if (!W.isInteger()) throw TypeError(NO_INT);
    var J = W.toNumber();
    return G.round(J);
  }, BigNumber: function(G) {
    var W = new R(G).toDecimalPlaces(V(O.relTol));
    return (nearlyEqual(G, W, O.relTol, O.absTol) ? W : G).toDecimalPlaces(0);
  }, "BigNumber, BigNumber": function(G, W) {
    if (!W.isInteger()) throw TypeError(NO_INT);
    var J = V(O.relTol);
    if (W >= J) return G.toDecimalPlaces(W.toNumber());
    var X = G.toDecimalPlaces(J);
    return (nearlyEqual(G, X, O.relTol, O.absTol) ? X : G).toDecimalPlaces(W.toNumber());
  }, bigint: (G) => G, "bigint, number": (G, W) => G, "bigint, BigNumber": (G, W) => G, Fraction: function(G) {
    return G.round();
  }, "Fraction, number": function(G, W) {
    if (W % 1) throw TypeError(NO_INT);
    return G.round(W);
  }, "Fraction, BigNumber": function(G, W) {
    if (!W.isInteger()) throw TypeError(NO_INT);
    return G.round(W.toNumber());
  }, "Unit, number, Unit": E.referToSelf((G) => function(W, J, X) {
    var Y = W.toNumeric(X);
    return X.multiply(G(Y, J));
  }), "Unit, BigNumber, Unit": E.referToSelf((G) => (W, J, X) => G(W, J.toNumber(), X)), "Array | Matrix, number | BigNumber, Unit": E.referToSelf((G) => (W, J, X) => deepMap(W, (Y) => G(Y, J, X), !0)), "Array | Matrix | Unit, Unit": E.referToSelf((G) => (W, J) => G(W, 0, J)), "Array | Matrix": E.referToSelf((G) => (W) => deepMap(W, G, !0)), "SparseMatrix, number | BigNumber": E.referToSelf((G) => (W, J) => q(W, J, G, !1)), "DenseMatrix, number | BigNumber": E.referToSelf((G) => (W, J) => Z(W, J, G, !1)), "Array, number | BigNumber": E.referToSelf((G) => (W, J) => Z(F(W), J, G, !1).valueOf()), "number | Complex | BigNumber | Fraction, SparseMatrix": E.referToSelf((G) => (W, J) => I(W, 0) ? z(J.size(), J.storage()) : U(J, W, G, !0)), "number | Complex | BigNumber | Fraction, DenseMatrix": E.referToSelf((G) => (W, J) => I(W, 0) ? z(J.size(), J.storage()) : Z(J, W, G, !0)), "number | Complex | BigNumber | Fraction, Array": E.referToSelf((G) => (W, J) => Z(F(J), W, G, !0).valueOf()) });
}), name$190 = "log", dependencies$190 = ["config", "typed", "typeOf", "divideScalar", "Complex"], nlg16 = Math.log(16), createLog = factory(name$190, dependencies$190, (D) => {
  var { typed: E, typeOf: O, config: F, divideScalar: I, Complex: z } = D;
  function R(q) {
    return q.log();
  }
  function L(q) {
    return R(new z(q, 0));
  }
  return E(name$190, { number: function(q) {
    return q >= 0 || F.predictable ? logNumber(q) : L(q);
  }, bigint: promoteLogarithm(nlg16, logNumber, F, L), Complex: R, BigNumber: function(q) {
    return !q.isNegative() || F.predictable ? q.ln() : L(q.toNumber());
  }, "any, any": E.referToSelf((q) => (U, Z) => {
    if (O(U) === "Fraction" && O(Z) === "Fraction") {
      var V = U.log(Z);
      if (V !== null) return V;
    }
    return I(q(U), q(Z));
  }) });
}), name$189 = "log1p", dependencies$189 = ["typed", "config", "divideScalar", "log", "Complex"], createLog1p = factory(name$189, dependencies$189, (D) => {
  var { typed: E, config: O, divideScalar: F, log: I, Complex: z } = D;
  return E(name$189, { number: function(L) {
    return L >= -1 || O.predictable ? log1p(L) : R(new z(L, 0));
  }, Complex: R, BigNumber: function(L) {
    var q = L.plus(1);
    return !q.isNegative() || O.predictable ? q.ln() : R(new z(L.toNumber(), 0));
  }, "Array | Matrix": E.referToSelf((L) => (q) => deepMap(q, L)), "any, any": E.referToSelf((L) => (q, U) => F(L(q), I(U))) });
  function R(L) {
    var q = L.re + 1;
    return new z(Math.log(Math.sqrt(q * q + L.im * L.im)), Math.atan2(L.im, q));
  }
}), name$188 = "nthRoots", dependencies$188 = ["config", "typed", "divideScalar", "Complex"], createNthRoots = factory(name$188, dependencies$188, (D) => {
  var { typed: E, config: O, divideScalar: F, Complex: I } = D, z = [function(L) {
    return new I(L, 0);
  }, function(L) {
    return new I(0, L);
  }, function(L) {
    return new I(-L, 0);
  }, function(L) {
    return new I(0, -L);
  }];
  function R(L, q) {
    if (q < 0) throw Error("Root must be greater than zero");
    if (q === 0) throw Error("Root must be non-zero");
    if (q % 1 != 0) throw Error("Root must be an integer");
    if (L === 0 || L.abs() === 0) return [new I(0, 0)];
    var U = typeof L == "number", Z;
    (U || L.re === 0 || L.im === 0) && (Z = U ? 2 * (L < 0) : L.im === 0 ? 2 * (L.re < 0) : 2 * (L.im < 0) + 1);
    for (var V = L.arg(), G = L.abs(), W = [], J = G ** (1 / q), X = 0; X < q; X++) {
      var Y = (Z + 4 * X) / q;
      if (Y === Math.round(Y)) {
        W.push(z[Y % 4](J));
        continue;
      }
      W.push(new I({ r: J, phi: (V + 2 * Math.PI * X) / q }));
    }
    return W;
  }
  return E(name$188, { Complex: function(L) {
    return R(L, 2);
  }, "Complex, number": R });
}), name$187 = "dotPow", dependencies$187 = ["typed", "equalScalar", "matrix", "pow", "DenseMatrix", "concat", "SparseMatrix"], createDotPow = factory(name$187, dependencies$187, (D) => {
  var { typed: E, equalScalar: O, matrix: F, pow: I, DenseMatrix: z, concat: R, SparseMatrix: L } = D, q = createMatAlgo03xDSf({ typed: E }), U = createMatAlgo07xSSf({ typed: E, SparseMatrix: L }), Z = createMatAlgo11xS0s({ typed: E, equalScalar: O }), V = createMatAlgo12xSfs({ typed: E, DenseMatrix: z }), G = createMatrixAlgorithmSuite({ typed: E, matrix: F, concat: R }), W = {};
  for (var J in I.signatures) Object.prototype.hasOwnProperty.call(I.signatures, J) && !J.includes("Matrix") && !J.includes("Array") && (W[J] = I.signatures[J]);
  return E(name$187, G({ elop: E(W), SS: U, DS: q, Ss: Z, sS: V }));
}), name$186 = "dotDivide", dependencies$186 = ["typed", "matrix", "equalScalar", "divideScalar", "DenseMatrix", "concat", "SparseMatrix"], createDotDivide = factory(name$186, dependencies$186, (D) => {
  var { typed: E, matrix: O, equalScalar: F, divideScalar: I, DenseMatrix: z, concat: R, SparseMatrix: L } = D, q = createMatAlgo02xDS0({ typed: E, equalScalar: F }), U = createMatAlgo03xDSf({ typed: E }), Z = createMatAlgo07xSSf({ typed: E, SparseMatrix: L }), V = createMatAlgo11xS0s({ typed: E, equalScalar: F }), G = createMatAlgo12xSfs({ typed: E, DenseMatrix: z });
  return E(name$186, createMatrixAlgorithmSuite({ typed: E, matrix: O, concat: R })({ elop: I, SS: Z, DS: U, SD: q, Ss: V, sS: G }));
});
function createSolveValidation(D) {
  var { DenseMatrix: E } = D;
  return function(O, F, I) {
    var z = O.size();
    if (z.length !== 2) throw RangeError("Matrix must be two dimensional (size: " + format(z) + ")");
    var R = z[0];
    if (R !== z[1]) throw RangeError("Matrix must be square (size: " + format(z) + ")");
    var L = [];
    if (isMatrix(F)) {
      var q = F.size(), U = F._data;
      if (q.length === 1) {
        if (q[0] !== R) throw RangeError("Dimension mismatch. Matrix columns must match vector length.");
        for (var Z = 0; Z < R; Z++) L[Z] = [U[Z]];
        return new E({ data: L, size: [R, 1], datatype: F._datatype });
      }
      if (q.length === 2) {
        if (q[0] !== R || q[1] !== 1) throw RangeError("Dimension mismatch. Matrix columns must match vector length.");
        if (isDenseMatrix(F)) {
          if (I) {
            L = [];
            for (var V = 0; V < R; V++) L[V] = [U[V][0]];
            return new E({ data: L, size: [R, 1], datatype: F._datatype });
          }
          return F;
        }
        if (isSparseMatrix(F)) {
          for (var G = 0; G < R; G++) L[G] = [0];
          for (var W = F._values, J = F._index, X = F._ptr, Y = X[1], ee = X[0]; ee < Y; ee++) {
            var K = J[ee];
            L[K][0] = W[ee];
          }
          return new E({ data: L, size: [R, 1], datatype: F._datatype });
        }
      }
      throw RangeError("Dimension mismatch. The right side has to be either 1- or 2-dimensional vector.");
    }
    if (isArray(F)) {
      var te = arraySize(F);
      if (te.length === 1) {
        if (te[0] !== R) throw RangeError("Dimension mismatch. Matrix columns must match vector length.");
        for (var ie = 0; ie < R; ie++) L[ie] = [F[ie]];
        return new E({ data: L, size: [R, 1] });
      }
      if (te.length === 2) {
        if (te[0] !== R || te[1] !== 1) throw RangeError("Dimension mismatch. Matrix columns must match vector length.");
        for (var ne = 0; ne < R; ne++) L[ne] = [F[ne][0]];
        return new E({ data: L, size: [R, 1] });
      }
      throw RangeError("Dimension mismatch. The right side has to be either 1- or 2-dimensional vector.");
    }
  };
}
var name$185 = "lsolve", dependencies$185 = ["typed", "matrix", "divideScalar", "multiplyScalar", "subtractScalar", "equalScalar", "DenseMatrix"], createLsolve = factory(name$185, dependencies$185, (D) => {
  var { typed: E, matrix: O, divideScalar: F, multiplyScalar: I, subtractScalar: z, equalScalar: R, DenseMatrix: L } = D, q = createSolveValidation({ DenseMatrix: L });
  return E(name$185, { "SparseMatrix, Array | Matrix": function(V, G) {
    return Z(V, G);
  }, "DenseMatrix, Array | Matrix": function(V, G) {
    return U(V, G);
  }, "Array, Array | Matrix": function(V, G) {
    return U(O(V), G).valueOf();
  } });
  function U(V, G) {
    G = q(V, G, !0);
    for (var W = G._data, J = V._size[0], X = V._size[1], Y = [], ee = V._data, K = 0; K < X; K++) {
      var te = W[K][0] || 0, ie = void 0;
      if (R(te, 0)) ie = 0;
      else {
        var ne = ee[K][K];
        if (R(ne, 0)) throw Error("Linear system cannot be solved since matrix is singular");
        ie = F(te, ne);
        for (var ae = K + 1; ae < J; ae++) W[ae] = [z(W[ae][0] || 0, I(ie, ee[ae][K]))];
      }
      Y[K] = [ie];
    }
    return new L({ data: Y, size: [J, 1] });
  }
  function Z(V, G) {
    G = q(V, G, !0);
    for (var W = G._data, J = V._size[0], X = V._size[1], Y = V._values, ee = V._index, K = V._ptr, te = [], ie = 0; ie < X; ie++) {
      var ne = W[ie][0] || 0;
      if (R(ne, 0)) te[ie] = [0];
      else {
        for (var ae = 0, ue = [], oe = [], se = K[ie], le = K[ie + 1], ce = se; ce < le; ce++) {
          var fe = ee[ce];
          fe === ie ? ae = Y[ce] : fe > ie && (ue.push(Y[ce]), oe.push(fe));
        }
        if (R(ae, 0)) throw Error("Linear system cannot be solved since matrix is singular");
        for (var pe = F(ne, ae), ve = 0, _e = oe.length; ve < _e; ve++) {
          var de = oe[ve];
          W[de] = [z(W[de][0] || 0, I(pe, ue[ve]))];
        }
        te[ie] = [pe];
      }
    }
    return new L({ data: te, size: [J, 1] });
  }
}), name$184 = "usolve", dependencies$184 = ["typed", "matrix", "divideScalar", "multiplyScalar", "subtractScalar", "equalScalar", "DenseMatrix"], createUsolve = factory(name$184, dependencies$184, (D) => {
  var { typed: E, matrix: O, divideScalar: F, multiplyScalar: I, subtractScalar: z, equalScalar: R, DenseMatrix: L } = D, q = createSolveValidation({ DenseMatrix: L });
  return E(name$184, { "SparseMatrix, Array | Matrix": function(V, G) {
    return Z(V, G);
  }, "DenseMatrix, Array | Matrix": function(V, G) {
    return U(V, G);
  }, "Array, Array | Matrix": function(V, G) {
    return U(O(V), G).valueOf();
  } });
  function U(V, G) {
    G = q(V, G, !0);
    for (var W = G._data, J = V._size[0], X = V._size[1], Y = [], ee = V._data, K = X - 1; K >= 0; K--) {
      var te = W[K][0] || 0, ie = void 0;
      if (R(te, 0)) ie = 0;
      else {
        var ne = ee[K][K];
        if (R(ne, 0)) throw Error("Linear system cannot be solved since matrix is singular");
        ie = F(te, ne);
        for (var ae = K - 1; ae >= 0; ae--) W[ae] = [z(W[ae][0] || 0, I(ie, ee[ae][K]))];
      }
      Y[K] = [ie];
    }
    return new L({ data: Y, size: [J, 1] });
  }
  function Z(V, G) {
    G = q(V, G, !0);
    for (var W = G._data, J = V._size[0], X = V._size[1], Y = V._values, ee = V._index, K = V._ptr, te = [], ie = X - 1; ie >= 0; ie--) {
      var ne = W[ie][0] || 0;
      if (R(ne, 0)) te[ie] = [0];
      else {
        for (var ae = 0, ue = [], oe = [], se = K[ie], le = K[ie + 1] - 1; le >= se; le--) {
          var ce = ee[le];
          ce === ie ? ae = Y[le] : ce < ie && (ue.push(Y[le]), oe.push(ce));
        }
        if (R(ae, 0)) throw Error("Linear system cannot be solved since matrix is singular");
        for (var fe = F(ne, ae), pe = 0, ve = oe.length; pe < ve; pe++) {
          var _e = oe[pe];
          W[_e] = [z(W[_e][0], I(fe, ue[pe]))];
        }
        te[ie] = [fe];
      }
    }
    return new L({ data: te, size: [J, 1] });
  }
}), name$183 = "lsolveAll", dependencies$183 = ["typed", "matrix", "divideScalar", "multiplyScalar", "subtractScalar", "equalScalar", "DenseMatrix"], createLsolveAll = factory(name$183, dependencies$183, (D) => {
  var { typed: E, matrix: O, divideScalar: F, multiplyScalar: I, subtractScalar: z, equalScalar: R, DenseMatrix: L } = D, q = createSolveValidation({ DenseMatrix: L });
  return E(name$183, { "SparseMatrix, Array | Matrix": function(V, G) {
    return Z(V, G);
  }, "DenseMatrix, Array | Matrix": function(V, G) {
    return U(V, G);
  }, "Array, Array | Matrix": function(V, G) {
    return U(O(V), G).map((W) => W.valueOf());
  } });
  function U(V, G) {
    for (var W = [q(V, G, !0)._data.map((oe) => oe[0])], J = V._data, X = V._size[0], Y = V._size[1], ee = 0; ee < Y; ee++) for (var K = W.length, te = 0; te < K; te++) {
      var ie = W[te];
      if (R(J[ee][ee], 0))
        if (R(ie[ee], 0)) {
          if (te === 0) {
            var ae = [...ie];
            ae[ee] = 1;
            for (var ue = ee + 1; ue < Y; ue++) ae[ue] = z(ae[ue], J[ue][ee]);
            W.push(ae);
          }
        } else {
          if (te === 0) return [];
          W.splice(te, 1), --te, --K;
        }
      else {
        ie[ee] = F(ie[ee], J[ee][ee]);
        for (var ne = ee + 1; ne < Y; ne++) ie[ne] = z(ie[ne], I(ie[ee], J[ne][ee]));
      }
    }
    return W.map((oe) => new L({ data: oe.map((se) => [se]), size: [X, 1] }));
  }
  function Z(V, G) {
    for (var W = [q(V, G, !0)._data.map((Ie) => Ie[0])], J = V._size[0], X = V._size[1], Y = V._values, ee = V._index, K = V._ptr, te = 0; te < X; te++) for (var ie = W.length, ne = 0; ne < ie; ne++) {
      for (var ae = W[ne], ue = [], oe = [], se = K[te], le = K[te + 1], ce = 0, fe = se; fe < le; fe++) {
        var pe = ee[fe];
        pe === te ? ce = Y[fe] : pe > te && (ue.push(Y[fe]), oe.push(pe));
      }
      if (R(ce, 0))
        if (R(ae[te], 0)) {
          if (ne === 0) {
            var ge = [...ae];
            ge[te] = 1;
            for (var ye = 0, De = oe.length; ye < De; ye++) {
              var Ce = oe[ye];
              ge[Ce] = z(ge[Ce], ue[ye]);
            }
            W.push(ge);
          }
        } else {
          if (ne === 0) return [];
          W.splice(ne, 1), --ne, --ie;
        }
      else {
        ae[te] = F(ae[te], ce);
        for (var ve = 0, _e = oe.length; ve < _e; ve++) {
          var de = oe[ve];
          ae[de] = z(ae[de], I(ae[te], ue[ve]));
        }
      }
    }
    return W.map((Ie) => new L({ data: Ie.map((Ne) => [Ne]), size: [J, 1] }));
  }
}), name$182 = "usolveAll", dependencies$182 = ["typed", "matrix", "divideScalar", "multiplyScalar", "subtractScalar", "equalScalar", "DenseMatrix"], createUsolveAll = factory(name$182, dependencies$182, (D) => {
  var { typed: E, matrix: O, divideScalar: F, multiplyScalar: I, subtractScalar: z, equalScalar: R, DenseMatrix: L } = D, q = createSolveValidation({ DenseMatrix: L });
  return E(name$182, { "SparseMatrix, Array | Matrix": function(V, G) {
    return Z(V, G);
  }, "DenseMatrix, Array | Matrix": function(V, G) {
    return U(V, G);
  }, "Array, Array | Matrix": function(V, G) {
    return U(O(V), G).map((W) => W.valueOf());
  } });
  function U(V, G) {
    for (var W = [q(V, G, !0)._data.map((ue) => ue[0])], J = V._data, X = V._size[0], Y = V._size[1] - 1; Y >= 0; Y--) for (var ee = W.length, K = 0; K < ee; K++) {
      var te = W[K];
      if (R(J[Y][Y], 0))
        if (R(te[Y], 0)) {
          if (K === 0) {
            var ne = [...te];
            ne[Y] = 1;
            for (var ae = Y - 1; ae >= 0; ae--) ne[ae] = z(ne[ae], J[ae][Y]);
            W.push(ne);
          }
        } else {
          if (K === 0) return [];
          W.splice(K, 1), --K, --ee;
        }
      else {
        te[Y] = F(te[Y], J[Y][Y]);
        for (var ie = Y - 1; ie >= 0; ie--) te[ie] = z(te[ie], I(te[Y], J[ie][Y]));
      }
    }
    return W.map((ue) => new L({ data: ue.map((oe) => [oe]), size: [X, 1] }));
  }
  function Z(V, G) {
    for (var W = [q(V, G, !0)._data.map((Ie) => Ie[0])], J = V._size[0], X = V._size[1], Y = V._values, ee = V._index, K = V._ptr, te = X - 1; te >= 0; te--) for (var ie = W.length, ne = 0; ne < ie; ne++) {
      for (var ae = W[ne], ue = [], oe = [], se = K[te], le = K[te + 1], ce = 0, fe = le - 1; fe >= se; fe--) {
        var pe = ee[fe];
        pe === te ? ce = Y[fe] : pe < te && (ue.push(Y[fe]), oe.push(pe));
      }
      if (R(ce, 0))
        if (R(ae[te], 0)) {
          if (ne === 0) {
            var ge = [...ae];
            ge[te] = 1;
            for (var ye = 0, De = oe.length; ye < De; ye++) {
              var Ce = oe[ye];
              ge[Ce] = z(ge[Ce], ue[ye]);
            }
            W.push(ge);
          }
        } else {
          if (ne === 0) return [];
          W.splice(ne, 1), --ne, --ie;
        }
      else {
        ae[te] = F(ae[te], ce);
        for (var ve = 0, _e = oe.length; ve < _e; ve++) {
          var de = oe[ve];
          ae[de] = z(ae[de], I(ae[te], ue[ve]));
        }
      }
    }
    return W.map((Ie) => new L({ data: Ie.map((Ne) => [Ne]), size: [J, 1] }));
  }
}), name$181 = "matAlgo08xS0Sid", dependencies$181 = ["typed", "equalScalar"], createMatAlgo08xS0Sid = factory(name$181, dependencies$181, (D) => {
  var { typed: E, equalScalar: O } = D;
  return function(F, I, z) {
    var R = F._values, L = F._index, q = F._ptr, U = F._size, Z = F._datatype || F._data === void 0 ? F._datatype : F.getDataType(), V = I._values, G = I._index, W = I._ptr, J = I._size, X = I._datatype || I._data === void 0 ? I._datatype : I.getDataType();
    if (U.length !== J.length) throw new DimensionError(U.length, J.length);
    if (U[0] !== J[0] || U[1] !== J[1]) throw RangeError("Dimension mismatch. Matrix A (" + U + ") must match Matrix B (" + J + ")");
    if (!R || !V) throw Error("Cannot perform operation on Pattern Sparse Matrices");
    var Y = U[0], ee = U[1], K, te = O, ie = 0, ne = z;
    typeof Z == "string" && Z === X && Z !== "mixed" && (K = Z, te = E.find(O, [K, K]), ie = E.convert(0, K), ne = E.find(z, [K, K]));
    for (var ae = [], ue = [], oe = [], se = [], le = [], ce, fe, pe, ve, _e = 0; _e < ee; _e++) {
      oe[_e] = ue.length;
      var de = _e + 1;
      for (fe = q[_e], pe = q[_e + 1], ce = fe; ce < pe; ce++) ve = L[ce], le[ve] = de, se[ve] = R[ce], ue.push(ve);
      for (fe = W[_e], pe = W[_e + 1], ce = fe; ce < pe; ce++) ve = G[ce], le[ve] === de && (se[ve] = ne(se[ve], V[ce]));
      for (ce = oe[_e]; ce < ue.length; ) {
        ve = ue[ce];
        var ge = se[ve];
        te(ge, ie) ? ue.splice(ce, 1) : (ae.push(ge), ce++);
      }
    }
    return oe[ee] = ue.length, F.createSparseMatrix({ values: ae, index: ue, ptr: oe, size: [Y, ee], datatype: Z === F._datatype && X === I._datatype ? K : void 0 });
  };
}), createUseMatrixForArrayScalar = factory("useMatrixForArrayScalar", ["typed", "matrix"], (D) => {
  var { typed: E, matrix: O } = D;
  return { "Array, number": E.referTo("DenseMatrix, number", (F) => (I, z) => F(O(I), z).valueOf()), "Array, BigNumber": E.referTo("DenseMatrix, BigNumber", (F) => (I, z) => F(O(I), z).valueOf()), "number, Array": E.referTo("number, DenseMatrix", (F) => (I, z) => F(I, O(z)).valueOf()), "BigNumber, Array": E.referTo("BigNumber, DenseMatrix", (F) => (I, z) => F(I, O(z)).valueOf()) };
}), name$180 = "leftShift", dependencies$180 = ["typed", "matrix", "equalScalar", "zeros", "DenseMatrix", "concat"], createLeftShift = factory(name$180, dependencies$180, (D) => {
  var { typed: E, matrix: O, equalScalar: F, zeros: I, DenseMatrix: z, concat: R } = D, L = createMatAlgo01xDSid({ typed: E }), q = createMatAlgo02xDS0({ typed: E, equalScalar: F }), U = createMatAlgo08xS0Sid({ typed: E, equalScalar: F }), Z = createMatAlgo10xSids({ typed: E, DenseMatrix: z }), V = createMatAlgo11xS0s({ typed: E, equalScalar: F }), G = createMatAlgo14xDs({ typed: E }), W = createMatrixAlgorithmSuite({ typed: E, matrix: O, concat: R }), J = createUseMatrixForArrayScalar({ typed: E, matrix: O });
  return E(name$180, { "number, number": leftShiftNumber, "BigNumber, BigNumber": leftShiftBigNumber, "bigint, bigint": (X, Y) => X << Y, "SparseMatrix, number | BigNumber": E.referToSelf((X) => (Y, ee) => F(ee, 0) ? Y.clone() : V(Y, ee, X, !1)), "DenseMatrix, number | BigNumber": E.referToSelf((X) => (Y, ee) => F(ee, 0) ? Y.clone() : G(Y, ee, X, !1)), "number | BigNumber, SparseMatrix": E.referToSelf((X) => (Y, ee) => F(Y, 0) ? I(ee.size(), ee.storage()) : Z(ee, Y, X, !0)), "number | BigNumber, DenseMatrix": E.referToSelf((X) => (Y, ee) => F(Y, 0) ? I(ee.size(), ee.storage()) : G(ee, Y, X, !0)) }, J, W({ SS: U, DS: L, SD: q }));
}), name$179 = "rightArithShift", dependencies$179 = ["typed", "matrix", "equalScalar", "zeros", "DenseMatrix", "concat"], createRightArithShift = factory(name$179, dependencies$179, (D) => {
  var { typed: E, matrix: O, equalScalar: F, zeros: I, DenseMatrix: z, concat: R } = D, L = createMatAlgo01xDSid({ typed: E }), q = createMatAlgo02xDS0({ typed: E, equalScalar: F }), U = createMatAlgo08xS0Sid({ typed: E, equalScalar: F }), Z = createMatAlgo10xSids({ typed: E, DenseMatrix: z }), V = createMatAlgo11xS0s({ typed: E, equalScalar: F }), G = createMatAlgo14xDs({ typed: E }), W = createMatrixAlgorithmSuite({ typed: E, matrix: O, concat: R }), J = createUseMatrixForArrayScalar({ typed: E, matrix: O });
  return E(name$179, { "number, number": rightArithShiftNumber, "BigNumber, BigNumber": rightArithShiftBigNumber, "bigint, bigint": (X, Y) => X >> Y, "SparseMatrix, number | BigNumber": E.referToSelf((X) => (Y, ee) => F(ee, 0) ? Y.clone() : V(Y, ee, X, !1)), "DenseMatrix, number | BigNumber": E.referToSelf((X) => (Y, ee) => F(ee, 0) ? Y.clone() : G(Y, ee, X, !1)), "number | BigNumber, SparseMatrix": E.referToSelf((X) => (Y, ee) => F(Y, 0) ? I(ee.size(), ee.storage()) : Z(ee, Y, X, !0)), "number | BigNumber, DenseMatrix": E.referToSelf((X) => (Y, ee) => F(Y, 0) ? I(ee.size(), ee.storage()) : G(ee, Y, X, !0)) }, J, W({ SS: U, DS: L, SD: q }));
}), name$178 = "rightLogShift", dependencies$178 = ["typed", "matrix", "equalScalar", "zeros", "DenseMatrix", "concat"], createRightLogShift = factory(name$178, dependencies$178, (D) => {
  var { typed: E, matrix: O, equalScalar: F, zeros: I, DenseMatrix: z, concat: R } = D, L = createMatAlgo01xDSid({ typed: E }), q = createMatAlgo02xDS0({ typed: E, equalScalar: F }), U = createMatAlgo08xS0Sid({ typed: E, equalScalar: F }), Z = createMatAlgo10xSids({ typed: E, DenseMatrix: z }), V = createMatAlgo11xS0s({ typed: E, equalScalar: F }), G = createMatAlgo14xDs({ typed: E }), W = createMatrixAlgorithmSuite({ typed: E, matrix: O, concat: R }), J = createUseMatrixForArrayScalar({ typed: E, matrix: O });
  return E(name$178, { "number, number": rightLogShiftNumber, "SparseMatrix, number | BigNumber": E.referToSelf((X) => (Y, ee) => F(ee, 0) ? Y.clone() : V(Y, ee, X, !1)), "DenseMatrix, number | BigNumber": E.referToSelf((X) => (Y, ee) => F(ee, 0) ? Y.clone() : G(Y, ee, X, !1)), "number | BigNumber, SparseMatrix": E.referToSelf((X) => (Y, ee) => F(Y, 0) ? I(ee.size(), ee.storage()) : Z(ee, Y, X, !0)), "number | BigNumber, DenseMatrix": E.referToSelf((X) => (Y, ee) => F(Y, 0) ? I(ee.size(), ee.storage()) : G(ee, Y, X, !0)) }, J, W({ SS: U, DS: L, SD: q }));
}), name$177 = "and", dependencies$177 = ["typed", "matrix", "equalScalar", "zeros", "not", "concat"], createAnd = factory(name$177, dependencies$177, (D) => {
  var { typed: E, matrix: O, equalScalar: F, zeros: I, not: z, concat: R } = D, L = createMatAlgo02xDS0({ typed: E, equalScalar: F }), q = createMatAlgo06xS0S0({ typed: E, equalScalar: F }), U = createMatAlgo11xS0s({ typed: E, equalScalar: F }), Z = createMatAlgo14xDs({ typed: E }), V = createMatrixAlgorithmSuite({ typed: E, matrix: O, concat: R });
  return E(name$177, { "number, number": andNumber, "Complex, Complex": function(G, W) {
    return (G.re !== 0 || G.im !== 0) && (W.re !== 0 || W.im !== 0);
  }, "BigNumber, BigNumber": function(G, W) {
    return !G.isZero() && !W.isZero() && !G.isNaN() && !W.isNaN();
  }, "bigint, bigint": andNumber, "Unit, Unit": E.referToSelf((G) => (W, J) => G(W.value || 0, J.value || 0)), "SparseMatrix, any": E.referToSelf((G) => (W, J) => z(J) ? I(W.size(), W.storage()) : U(W, J, G, !1)), "DenseMatrix, any": E.referToSelf((G) => (W, J) => z(J) ? I(W.size(), W.storage()) : Z(W, J, G, !1)), "any, SparseMatrix": E.referToSelf((G) => (W, J) => z(W) ? I(W.size(), W.storage()) : U(J, W, G, !0)), "any, DenseMatrix": E.referToSelf((G) => (W, J) => z(W) ? I(W.size(), W.storage()) : Z(J, W, G, !0)), "Array, any": E.referToSelf((G) => (W, J) => G(O(W), J).valueOf()), "any, Array": E.referToSelf((G) => (W, J) => G(W, O(J)).valueOf()) }, V({ SS: q, DS: L }));
}), name$176 = "compare", dependencies$176 = ["typed", "config", "matrix", "equalScalar", "BigNumber", "Fraction", "DenseMatrix", "concat"], createCompare = factory(name$176, dependencies$176, (D) => {
  var { typed: E, config: O, equalScalar: F, matrix: I, BigNumber: z, Fraction: R, DenseMatrix: L, concat: q } = D, U = createMatAlgo03xDSf({ typed: E }), Z = createMatAlgo05xSfSf({ typed: E, equalScalar: F }), V = createMatAlgo12xSfs({ typed: E, DenseMatrix: L }), G = createMatrixAlgorithmSuite({ typed: E, matrix: I, concat: q }), W = createCompareUnits({ typed: E });
  return E(name$176, createCompareNumber({ typed: E, config: O }), { "boolean, boolean": function(J, X) {
    return J === X ? 0 : J > X ? 1 : -1;
  }, "BigNumber, BigNumber": function(J, X) {
    return nearlyEqual(J, X, O.relTol, O.absTol) ? new z(0) : new z(J.cmp(X));
  }, "bigint, bigint": function(J, X) {
    return J === X ? 0n : J > X ? 1n : -1n;
  }, "Fraction, Fraction": function(J, X) {
    return new R(J.compare(X));
  }, "Complex, Complex": function() {
    throw TypeError("No ordering relation is defined for complex numbers");
  } }, W, G({ SS: Z, DS: U, Ss: V }));
}), createCompareNumber = factory(name$176, ["typed", "config"], (D) => {
  var { typed: E, config: O } = D;
  return E(name$176, { "number, number": function(F, I) {
    return nearlyEqual$1(F, I, O.relTol, O.absTol) ? 0 : F > I ? 1 : -1;
  } });
}), require_naturalSort = __commonJSMin(((D, E) => {
  E.exports = function O(F, I) {
    var z = /(^([+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi, R = /(^[ ]*|[ ]*$)/g, L = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/, q = /^0x[0-9a-f]+$/i, U = /^0/, Z = function(ne) {
      return O.insensitive && ("" + ne).toLowerCase() || "" + ne;
    }, V = Z(F).replace(R, "") || "", G = Z(I).replace(R, "") || "", W = V.replace(z, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"), J = G.replace(z, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"), X = parseInt(V.match(q), 16) || W.length !== 1 && V.match(L) && Date.parse(V), Y = parseInt(G.match(q), 16) || X && G.match(L) && Date.parse(G) || null, ee, K;
    if (Y) {
      if (X < Y) return -1;
      if (X > Y) return 1;
    }
    for (var te = 0, ie = Math.max(W.length, J.length); te < ie; te++) {
      if (ee = !(W[te] || "").match(U) && parseFloat(W[te]) || W[te] || 0, K = !(J[te] || "").match(U) && parseFloat(J[te]) || J[te] || 0, isNaN(ee) !== isNaN(K)) return isNaN(ee) ? 1 : -1;
      if (typeof ee != typeof K && (ee += "", K += ""), ee < K) return -1;
      if (ee > K) return 1;
    }
    return 0;
  };
})), import_naturalSort = __toESM(require_naturalSort()), name$175 = "compareNatural", dependencies$175 = ["typed", "compare"], createCompareNatural = factory(name$175, dependencies$175, (D) => {
  var { typed: E, compare: O } = D, F = O.signatures["boolean,boolean"];
  return E(name$175, { "any, any": I });
  function I(q, U) {
    var Z = typeOf(q), V = typeOf(U), G;
    if ((Z === "number" || Z === "BigNumber" || Z === "Fraction" || Z === "bigint") && (V === "number" || V === "BigNumber" || V === "Fraction" || V === "bigint")) return G = O(q, U), G.toString() === "0" ? (0, import_naturalSort.default)(Z, V) : G > 0 ? 1 : -1;
    var W = ["Array", "DenseMatrix", "SparseMatrix"];
    if (W.includes(Z) || W.includes(V)) return G = z(I, q, U), G === 0 ? (0, import_naturalSort.default)(Z, V) : G;
    if (Z !== V) return (0, import_naturalSort.default)(Z, V);
    if (Z === "Complex") return compareComplexNumbers(q, U);
    if (Z === "Unit") return q.equalBase(U) ? I(q.value, U.value) : R(I, q.formatUnits(), U.formatUnits());
    if (Z === "boolean") return F(q, U);
    if (Z === "string") return (0, import_naturalSort.default)(q, U);
    if (Z === "Object") return L(I, q, U);
    if (Z === "null" || Z === "undefined") return 0;
    throw TypeError('Unsupported type of value "' + Z + '"');
  }
  function z(q, U, Z) {
    return isSparseMatrix(U) && isSparseMatrix(Z) ? R(q, U.toJSON().values, Z.toJSON().values) : isSparseMatrix(U) ? z(q, U.toArray(), Z) : isSparseMatrix(Z) ? z(q, U, Z.toArray()) : isDenseMatrix(U) ? z(q, U.toJSON().data, Z) : isDenseMatrix(Z) ? z(q, U, Z.toJSON().data) : Array.isArray(U) ? Array.isArray(Z) ? R(q, U, Z) : z(q, U, [Z]) : z(q, [U], Z);
  }
  function R(q, U, Z) {
    for (var V = 0, G = Math.min(U.length, Z.length); V < G; V++) {
      var W = q(U[V], Z[V]);
      if (W !== 0) return W;
    }
    return U.length > Z.length ? 1 : U.length < Z.length ? -1 : 0;
  }
  function L(q, U, Z) {
    var V = Object.keys(U), G = Object.keys(Z);
    V.sort(import_naturalSort.default), G.sort(import_naturalSort.default);
    var W = R(q, V, G);
    if (W !== 0) return W;
    for (var J = 0; J < V.length; J++) {
      var X = q(U[V[J]], Z[G[J]]);
      if (X !== 0) return X;
    }
    return 0;
  }
});
function compareComplexNumbers(D, E) {
  return D.re > E.re ? 1 : D.re < E.re ? -1 : D.im > E.im ? 1 : D.im < E.im ? -1 : 0;
}
var name$174 = "compareText", dependencies$174 = ["typed", "matrix", "concat"];
compareText.signature = "any, any";
var createCompareText = factory(name$174, dependencies$174, (D) => {
  var { typed: E, matrix: O, concat: F } = D;
  return E(name$174, compareText, createMatrixAlgorithmSuite({ typed: E, matrix: O, concat: F })({ elop: compareText, Ds: !0 }));
}), name$173 = "equal", dependencies$173 = ["typed", "matrix", "equalScalar", "DenseMatrix", "SparseMatrix"], createEqual = factory(name$173, dependencies$173, (D) => {
  var { typed: E, matrix: O, equalScalar: F, DenseMatrix: I, concat: z, SparseMatrix: R } = D, L = createMatAlgo03xDSf({ typed: E }), q = createMatAlgo07xSSf({ typed: E, SparseMatrix: R }), U = createMatAlgo12xSfs({ typed: E, DenseMatrix: I }), Z = createMatrixAlgorithmSuite({ typed: E, matrix: O });
  return E(name$173, createEqualNumber({ typed: E, equalScalar: F }), Z({ elop: F, SS: q, DS: L, Ss: U }));
}), createEqualNumber = factory(name$173, ["typed", "equalScalar"], (D) => {
  var { typed: E, equalScalar: O } = D;
  return E(name$173, { "any, any": function(F, I) {
    return F === null ? I === null : I === null ? F === null : F === void 0 ? I === void 0 : I === void 0 ? F === void 0 : O(F, I);
  } });
}), name$172 = "equalText", dependencies$172 = ["typed", "compareText", "isZero"], createEqualText = factory(name$172, dependencies$172, (D) => {
  var { typed: E, compareText: O, isZero: F } = D;
  return E(name$172, { "any, any": function(I, z) {
    return F(O(I, z));
  } });
}), name$171 = "smaller", dependencies$171 = ["typed", "config", "bignumber", "matrix", "DenseMatrix", "concat", "SparseMatrix"], createSmaller = factory(name$171, dependencies$171, (D) => {
  var { typed: E, config: O, bignumber: F, matrix: I, DenseMatrix: z, concat: R, SparseMatrix: L } = D, q = createMatAlgo03xDSf({ typed: E }), U = createMatAlgo07xSSf({ typed: E, SparseMatrix: L }), Z = createMatAlgo12xSfs({ typed: E, DenseMatrix: z }), V = createMatrixAlgorithmSuite({ typed: E, matrix: I, concat: R }), G = createCompareUnits({ typed: E });
  function W(J, X) {
    return J.lt(X) && !nearlyEqual(J, X, O.relTol, O.absTol);
  }
  return E(name$171, createSmallerNumber({ typed: E, config: O }), { "boolean, boolean": (J, X) => J < X, "BigNumber, BigNumber": W, "bigint, bigint": (J, X) => J < X, "Fraction, Fraction": (J, X) => J.compare(X) === -1, "Fraction, BigNumber": function(J, X) {
    return W(F(J), X);
  }, "BigNumber, Fraction": function(J, X) {
    return W(J, F(X));
  }, "Complex, Complex": function(J, X) {
    throw TypeError("No ordering relation is defined for complex numbers");
  } }, G, V({ SS: U, DS: q, Ss: Z }));
}), createSmallerNumber = factory(name$171, ["typed", "config"], (D) => {
  var { typed: E, config: O } = D;
  return E(name$171, { "number, number": function(F, I) {
    return F < I && !nearlyEqual$1(F, I, O.relTol, O.absTol);
  } });
}), name$170 = "smallerEq", dependencies$170 = ["typed", "config", "matrix", "DenseMatrix", "concat", "SparseMatrix"], createSmallerEq = factory(name$170, dependencies$170, (D) => {
  var { typed: E, config: O, matrix: F, DenseMatrix: I, concat: z, SparseMatrix: R } = D, L = createMatAlgo03xDSf({ typed: E }), q = createMatAlgo07xSSf({ typed: E, SparseMatrix: R }), U = createMatAlgo12xSfs({ typed: E, DenseMatrix: I }), Z = createMatrixAlgorithmSuite({ typed: E, matrix: F, concat: z }), V = createCompareUnits({ typed: E });
  return E(name$170, createSmallerEqNumber({ typed: E, config: O }), { "boolean, boolean": (G, W) => G <= W, "BigNumber, BigNumber": function(G, W) {
    return G.lte(W) || nearlyEqual(G, W, O.relTol, O.absTol);
  }, "bigint, bigint": (G, W) => G <= W, "Fraction, Fraction": (G, W) => G.compare(W) !== 1, "Complex, Complex": function() {
    throw TypeError("No ordering relation is defined for complex numbers");
  } }, V, Z({ SS: q, DS: L, Ss: U }));
}), createSmallerEqNumber = factory(name$170, ["typed", "config"], (D) => {
  var { typed: E, config: O } = D;
  return E(name$170, { "number, number": function(F, I) {
    return F <= I || nearlyEqual$1(F, I, O.relTol, O.absTol);
  } });
}), name$169 = "larger", dependencies$169 = ["typed", "config", "bignumber", "matrix", "DenseMatrix", "concat", "SparseMatrix"], createLarger = factory(name$169, dependencies$169, (D) => {
  var { typed: E, config: O, bignumber: F, matrix: I, DenseMatrix: z, concat: R, SparseMatrix: L } = D, q = createMatAlgo03xDSf({ typed: E }), U = createMatAlgo07xSSf({ typed: E, SparseMatrix: L }), Z = createMatAlgo12xSfs({ typed: E, DenseMatrix: z }), V = createMatrixAlgorithmSuite({ typed: E, matrix: I, concat: R }), G = createCompareUnits({ typed: E });
  function W(J, X) {
    return J.gt(X) && !nearlyEqual(J, X, O.relTol, O.absTol);
  }
  return E(name$169, createLargerNumber({ typed: E, config: O }), { "boolean, boolean": (J, X) => J > X, "BigNumber, BigNumber": W, "bigint, bigint": (J, X) => J > X, "Fraction, Fraction": (J, X) => J.compare(X) === 1, "Fraction, BigNumber": function(J, X) {
    return W(F(J), X);
  }, "BigNumber, Fraction": function(J, X) {
    return W(J, F(X));
  }, "Complex, Complex": function() {
    throw TypeError("No ordering relation is defined for complex numbers");
  } }, G, V({ SS: U, DS: q, Ss: Z }));
}), createLargerNumber = factory(name$169, ["typed", "config"], (D) => {
  var { typed: E, config: O } = D;
  return E(name$169, { "number, number": function(F, I) {
    return F > I && !nearlyEqual$1(F, I, O.relTol, O.absTol);
  } });
}), name$168 = "largerEq", dependencies$168 = ["typed", "config", "matrix", "DenseMatrix", "concat", "SparseMatrix"], createLargerEq = factory(name$168, dependencies$168, (D) => {
  var { typed: E, config: O, matrix: F, DenseMatrix: I, concat: z, SparseMatrix: R } = D, L = createMatAlgo03xDSf({ typed: E }), q = createMatAlgo07xSSf({ typed: E, SparseMatrix: R }), U = createMatAlgo12xSfs({ typed: E, DenseMatrix: I }), Z = createMatrixAlgorithmSuite({ typed: E, matrix: F, concat: z }), V = createCompareUnits({ typed: E });
  return E(name$168, createLargerEqNumber({ typed: E, config: O }), { "boolean, boolean": (G, W) => G >= W, "BigNumber, BigNumber": function(G, W) {
    return G.gte(W) || nearlyEqual(G, W, O.relTol, O.absTol);
  }, "bigint, bigint": function(G, W) {
    return G >= W;
  }, "Fraction, Fraction": (G, W) => G.compare(W) !== -1, "Complex, Complex": function() {
    throw TypeError("No ordering relation is defined for complex numbers");
  } }, V, Z({ SS: q, DS: L, Ss: U }));
}), createLargerEqNumber = factory(name$168, ["typed", "config"], (D) => {
  var { typed: E, config: O } = D;
  return E(name$168, { "number, number": function(F, I) {
    return F >= I || nearlyEqual$1(F, I, O.relTol, O.absTol);
  } });
}), name$167 = "deepEqual", dependencies$167 = ["typed", "equal"], createDeepEqual = factory(name$167, dependencies$167, (D) => {
  var { typed: E, equal: O } = D;
  return E(name$167, { "any, any": function(I, z) {
    return F(I.valueOf(), z.valueOf());
  } });
  function F(I, z) {
    if (Array.isArray(I)) if (Array.isArray(z)) {
      var R = I.length;
      if (R !== z.length) return !1;
      for (var L = 0; L < R; L++) if (!F(I[L], z[L])) return !1;
      return !0;
    } else return !1;
    else return Array.isArray(z) ? !1 : O(I, z);
  }
}), name$166 = "unequal", dependencies$166 = ["typed", "config", "equalScalar", "matrix", "DenseMatrix", "concat", "SparseMatrix"], createUnequal = factory(name$166, dependencies$166, (D) => {
  var { typed: E, config: O, equalScalar: F, matrix: I, DenseMatrix: z, concat: R, SparseMatrix: L } = D, q = createMatAlgo03xDSf({ typed: E }), U = createMatAlgo07xSSf({ typed: E, SparseMatrix: L }), Z = createMatAlgo12xSfs({ typed: E, DenseMatrix: z }), V = createMatrixAlgorithmSuite({ typed: E, matrix: I, concat: R });
  return E(name$166, createUnequalNumber({ typed: E, equalScalar: F }), V({ elop: G, SS: U, DS: q, Ss: Z }));
  function G(W, J) {
    return !F(W, J);
  }
}), createUnequalNumber = factory(name$166, ["typed", "equalScalar"], (D) => {
  var { typed: E, equalScalar: O } = D;
  return E(name$166, { "any, any": function(F, I) {
    return F === null ? I !== null : I === null ? F !== null : F === void 0 ? I !== void 0 : I === void 0 ? F !== void 0 : !O(F, I);
  } });
}), name$165 = "partitionSelect", dependencies$165 = ["typed", "isNumeric", "isNaN", "compare"], createPartitionSelect = factory(name$165, dependencies$165, (D) => {
  var { typed: E, isNumeric: O, isNaN: F, compare: I } = D, z = I, R = (U, Z) => -I(U, Z);
  return E(name$165, { "Array | Matrix, number": function(U, Z) {
    return L(U, Z, z);
  }, "Array | Matrix, number, string": function(U, Z, V) {
    if (V === "asc") return L(U, Z, z);
    if (V === "desc") return L(U, Z, R);
    throw Error('Compare string must be "asc" or "desc"');
  }, "Array | Matrix, number, function": L });
  function L(U, Z, V) {
    if (!isInteger(Z) || Z < 0) throw Error("k must be a non-negative integer");
    if (isMatrix(U)) {
      if (U.size().length > 1) throw Error("Only one dimensional matrices supported");
      return q(U.valueOf(), Z, V);
    }
    if (Array.isArray(U)) return q(U, Z, V);
  }
  function q(U, Z, V) {
    if (Z >= U.length) throw Error("k out of bounds");
    for (var G = 0; G < U.length; G++) if (O(U[G]) && F(U[G])) return U[G];
    for (var W = 0, J = U.length - 1; W < J; ) {
      for (var X = W, Y = J, ee = U[Math.floor(Math.random() * (J - W + 1)) + W]; X < Y; ) if (V(U[X], ee) >= 0) {
        var K = U[Y];
        U[Y] = U[X], U[X] = K, --Y;
      } else ++X;
      V(U[X], ee) > 0 && --X, Z <= X ? J = X : W = X + 1;
    }
    return U[Z];
  }
}), name$164 = "sort", dependencies$164 = ["typed", "matrix", "compare", "compareNatural"], createSort = factory(name$164, dependencies$164, (D) => {
  var { typed: E, matrix: O, compare: F, compareNatural: I } = D, z = F, R = (Z, V) => -F(Z, V);
  return E(name$164, { Array: function(Z) {
    return q(Z), Z.sort(z);
  }, Matrix: function(Z) {
    return U(Z), O(Z.toArray().sort(z), Z.storage());
  }, "Array, function": function(Z, V) {
    return q(Z), Z.sort(V);
  }, "Matrix, function": function(Z, V) {
    return U(Z), O(Z.toArray().sort(V), Z.storage());
  }, "Array, string": function(Z, V) {
    return q(Z), Z.sort(L(V));
  }, "Matrix, string": function(Z, V) {
    return U(Z), O(Z.toArray().sort(L(V)), Z.storage());
  } });
  function L(Z) {
    if (Z === "asc") return z;
    if (Z === "desc") return R;
    if (Z === "natural") return I;
    throw Error('String "asc", "desc", or "natural" expected');
  }
  function q(Z) {
    if (arraySize(Z).length !== 1) throw Error("One dimensional array expected");
  }
  function U(Z) {
    if (Z.size().length !== 1) throw Error("One dimensional matrix expected");
  }
}), name$163 = "max", dependencies$163 = ["typed", "config", "numeric", "larger", "isNaN"], createMax = factory(name$163, dependencies$163, (D) => {
  var { typed: E, config: O, numeric: F, larger: I, isNaN: z } = D;
  return E(name$163, { "Array | Matrix": L, "Array | Matrix, number | BigNumber": function(q, U) {
    return reduce$1(q, U.valueOf(), R);
  }, "...": function(q) {
    if (containsCollections(q)) throw TypeError("Scalar values expected in function max");
    return L(q);
  } });
  function R(q, U) {
    try {
      return I(q, U) ? q : U;
    } catch (Z) {
      throw improveErrorMessage(Z, "max", U);
    }
  }
  function L(q) {
    var U;
    if (deepForEach(q, function(Z) {
      try {
        (z(Z) || U === void 0 || I(Z, U)) && (U = Z);
      } catch (V) {
        throw improveErrorMessage(V, "max", Z);
      }
    }), U === void 0) throw Error("Cannot calculate max of an empty array");
    return typeof U == "string" && (U = F(U, safeNumberType(U, O))), U;
  }
}), name$162 = "min", dependencies$162 = ["typed", "config", "numeric", "smaller", "isNaN"], createMin = factory(name$162, dependencies$162, (D) => {
  var { typed: E, config: O, numeric: F, smaller: I, isNaN: z } = D;
  return E(name$162, { "Array | Matrix": L, "Array | Matrix, number | BigNumber": function(q, U) {
    return reduce$1(q, U.valueOf(), R);
  }, "...": function(q) {
    if (containsCollections(q)) throw TypeError("Scalar values expected in function min");
    return L(q);
  } });
  function R(q, U) {
    try {
      return I(q, U) ? q : U;
    } catch (Z) {
      throw improveErrorMessage(Z, "min", U);
    }
  }
  function L(q) {
    var U;
    if (deepForEach(q, function(Z) {
      try {
        (z(Z) || U === void 0 || I(Z, U)) && (U = Z);
      } catch (V) {
        throw improveErrorMessage(V, "min", Z);
      }
    }), U === void 0) throw Error("Cannot calculate min of an empty array");
    return typeof U == "string" && (U = F(U, safeNumberType(U, O))), U;
  }
}), name$161 = "ImmutableDenseMatrix", dependencies$161 = ["smaller", "DenseMatrix"], createImmutableDenseMatrixClass = factory(name$161, dependencies$161, (D) => {
  var { smaller: E, DenseMatrix: O } = D;
  function F(I, z) {
    if (!(this instanceof F)) throw SyntaxError("Constructor must be called with the new operator");
    if (z && !isString(z)) throw Error("Invalid datatype: " + z);
    if (isMatrix(I) || isArray(I)) {
      var R = new O(I, z);
      this._data = R._data, this._size = R._size, this._datatype = R._datatype, this._min = null, this._max = null;
    } else if (I && isArray(I.data) && isArray(I.size)) this._data = I.data, this._size = I.size, this._datatype = I.datatype, this._min = I.min === void 0 ? null : I.min, this._max = I.max === void 0 ? null : I.max;
    else {
      if (I) throw TypeError("Unsupported type of data (" + typeOf(I) + ")");
      this._data = [], this._size = [0], this._datatype = z, this._min = null, this._max = null;
    }
  }
  return F.prototype = new O(), F.prototype.type = "ImmutableDenseMatrix", F.prototype.isImmutableDenseMatrix = !0, F.prototype.subset = function(I) {
    switch (arguments.length) {
      case 1:
        var z = O.prototype.subset.call(this, I);
        return isMatrix(z) ? new F({ data: z._data, size: z._size, datatype: z._datatype }) : z;
      case 2:
      case 3:
        throw Error("Cannot invoke set subset on an Immutable Matrix instance");
      default:
        throw SyntaxError("Wrong number of arguments");
    }
  }, F.prototype.set = function() {
    throw Error("Cannot invoke set on an Immutable Matrix instance");
  }, F.prototype.resize = function() {
    throw Error("Cannot invoke resize on an Immutable Matrix instance");
  }, F.prototype.reshape = function() {
    throw Error("Cannot invoke reshape on an Immutable Matrix instance");
  }, F.prototype.clone = function() {
    return new F({ data: clone$3(this._data), size: clone$3(this._size), datatype: this._datatype });
  }, F.prototype.toJSON = function() {
    return { mathjs: "ImmutableDenseMatrix", data: this._data, size: this._size, datatype: this._datatype };
  }, F.fromJSON = function(I) {
    return new F(I);
  }, F.prototype.swapRows = function() {
    throw Error("Cannot invoke swapRows on an Immutable Matrix instance");
  }, F.prototype.min = function() {
    if (this._min === null) {
      var I = null;
      this.forEach(function(z) {
        (I === null || E(z, I)) && (I = z);
      }), this._min = I === null ? void 0 : I;
    }
    return this._min;
  }, F.prototype.max = function() {
    if (this._max === null) {
      var I = null;
      this.forEach(function(z) {
        (I === null || E(I, z)) && (I = z);
      }), this._max = I === null ? void 0 : I;
    }
    return this._max;
  }, F;
}, { isClass: !0 }), name$160 = "Index", dependencies$160 = ["ImmutableDenseMatrix", "getMatrixDataType"], createIndexClass = factory(name$160, dependencies$160, (D) => {
  var { ImmutableDenseMatrix: E, getMatrixDataType: O } = D;
  function F() {
    if (!(this instanceof F)) throw SyntaxError("Constructor must be called with the new operator");
    this._dimensions = [], this._sourceSize = [], this._isScalar = !0;
    for (var z = 0, R = arguments.length; z < R; z++) {
      var L = z < 0 || arguments.length <= z ? void 0 : arguments[z], q = isArray(L), U = isMatrix(L), Z = typeof L, V = null;
      if (isRange(L)) this._dimensions.push(L), this._isScalar = !1;
      else if (q || U) {
        var G = void 0;
        this._isScalar = !1, O(L) === "boolean" ? (q && (G = I(_booleansArrayToNumbersForIndex(L).valueOf())), U && (G = I(_booleansArrayToNumbersForIndex(L._data).valueOf())), V = L.valueOf().length) : G = I(L.valueOf()), this._dimensions.push(G);
      } else if (Z === "number") this._dimensions.push(L);
      else if (Z === "bigint") this._dimensions.push(Number(L));
      else if (Z === "string") this._dimensions.push(L);
      else throw TypeError("Dimension must be an Array, Matrix, number, bigint, string, or Range");
      this._sourceSize.push(V);
    }
  }
  F.prototype.type = "Index", F.prototype.isIndex = !0;
  function I(z) {
    for (var R = 0, L = z.length; R < L; R++) if (!isNumber(z[R]) || !isInteger(z[R])) throw TypeError("Index parameters must be positive integer numbers");
    var q = new E();
    return q._data = z, q._size = [z.length], q;
  }
  return F.prototype.clone = function() {
    var z = new F();
    return z._dimensions = clone$3(this._dimensions), z._isScalar = this._isScalar, z._sourceSize = this._sourceSize, z;
  }, F.create = function(z) {
    var R = new F();
    return F.apply(R, z), R;
  }, F.prototype.size = function() {
    for (var z = [], R = 0, L = this._dimensions.length; R < L; R++) {
      var q = this._dimensions[R];
      z[R] = isString(q) || isNumber(q) ? 1 : q.size()[0];
    }
    return z;
  }, F.prototype.max = function() {
    for (var z = [], R = 0, L = this._dimensions.length; R < L; R++) {
      var q = this._dimensions[R];
      z[R] = isString(q) || isNumber(q) ? q : q.max();
    }
    return z;
  }, F.prototype.min = function() {
    for (var z = [], R = 0, L = this._dimensions.length; R < L; R++) {
      var q = this._dimensions[R];
      z[R] = isString(q) || isNumber(q) ? q : q.min();
    }
    return z;
  }, F.prototype.forEach = function(z) {
    for (var R = 0, L = this._dimensions.length; R < L; R++) z(this._dimensions[R], R, this);
  }, F.prototype.dimension = function(z) {
    return isNumber(z) ? this._dimensions[z] ?? null : null;
  }, F.prototype.isObjectProperty = function() {
    return this._dimensions.length === 1 && isString(this._dimensions[0]);
  }, F.prototype.getObjectProperty = function() {
    return this.isObjectProperty() ? this._dimensions[0] : null;
  }, F.prototype.isScalar = function() {
    return this._isScalar;
  }, F.prototype.toArray = function() {
    for (var z = [], R = 0, L = this._dimensions.length; R < L; R++) {
      var q = this._dimensions[R];
      z.push(isString(q) || isNumber(q) ? q : q.toArray());
    }
    return z;
  }, F.prototype.valueOf = F.prototype.toArray, F.prototype.toString = function() {
    for (var z = [], R = 0, L = this._dimensions.length; R < L; R++) {
      var q = this._dimensions[R];
      isString(q) ? z.push(JSON.stringify(q)) : z.push(q.toString());
    }
    return "[" + z.join(", ") + "]";
  }, F.prototype.toJSON = function() {
    return { mathjs: "Index", dimensions: this._dimensions };
  }, F.fromJSON = function(z) {
    return F.create(z.dimensions);
  }, F;
}, { isClass: !0 });
function _booleansArrayToNumbersForIndex(D) {
  var E = [];
  return D.forEach((O, F) => {
    O && E.push(F);
  }), E;
}
var name$159 = "FibonacciHeap", dependencies$159 = ["smaller", "larger"], createFibonacciHeapClass = factory(name$159, dependencies$159, (D) => {
  var { smaller: E, larger: O } = D, F = 1 / Math.log((1 + Math.sqrt(5)) / 2);
  function I() {
    if (!(this instanceof I)) throw SyntaxError("Constructor must be called with the new operator");
    this._minimum = null, this._size = 0;
  }
  I.prototype.type = "FibonacciHeap", I.prototype.isFibonacciHeap = !0, I.prototype.insert = function(Z, V) {
    var G = { key: Z, value: V, degree: 0 };
    if (this._minimum) {
      var W = this._minimum;
      G.left = W, G.right = W.right, W.right = G, G.right.left = G, E(Z, W.key) && (this._minimum = G);
    } else G.left = G, G.right = G, this._minimum = G;
    return this._size++, G;
  }, I.prototype.size = function() {
    return this._size;
  }, I.prototype.clear = function() {
    this._minimum = null, this._size = 0;
  }, I.prototype.isEmpty = function() {
    return this._size === 0;
  }, I.prototype.extractMinimum = function() {
    var Z = this._minimum;
    if (Z === null) return Z;
    for (var V = this._minimum, G = Z.degree, W = Z.child; G > 0; ) {
      var J = W.right;
      W.left.right = W.right, W.right.left = W.left, W.left = V, W.right = V.right, V.right = W, W.right.left = W, W.parent = null, W = J, G--;
    }
    return Z.left.right = Z.right, Z.right.left = Z.left, Z === Z.right ? V = null : (V = Z.right, V = U(V, this._size)), this._size--, this._minimum = V, Z;
  }, I.prototype.remove = function(Z) {
    this._minimum = z(this._minimum, Z, -1), this.extractMinimum();
  };
  function z(Z, V, G) {
    V.key = G;
    var W = V.parent;
    return W && E(V.key, W.key) && (R(Z, V, W), L(Z, W)), E(V.key, Z.key) && (Z = V), Z;
  }
  function R(Z, V, G) {
    V.left.right = V.right, V.right.left = V.left, G.degree--, G.child === V && (G.child = V.right), G.degree === 0 && (G.child = null), V.left = Z, V.right = Z.right, Z.right = V, V.right.left = V, V.parent = null, V.mark = !1;
  }
  function L(Z, V) {
    var G = V.parent;
    G && (V.mark ? (R(Z, V, G), L(G)) : V.mark = !0);
  }
  var q = function(Z, V) {
    Z.left.right = Z.right, Z.right.left = Z.left, Z.parent = V, V.child ? (Z.left = V.child, Z.right = V.child.right, V.child.right = Z, Z.right.left = Z) : (V.child = Z, Z.right = Z, Z.left = Z), V.degree++, Z.mark = !1;
  };
  function U(Z, V) {
    var G = Math.floor(Math.log(V) * F) + 1, W = Array(G), J = 0, X = Z;
    if (X) for (J++, X = X.right; X !== Z; ) J++, X = X.right;
    for (var Y; J > 0; ) {
      for (var ee = X.degree, K = X.right; Y = W[ee], Y; ) {
        if (O(X.key, Y.key)) {
          var te = Y;
          Y = X, X = te;
        }
        q(Y, X), W[ee] = null, ee++;
      }
      W[ee] = X, X = K, J--;
    }
    Z = null;
    for (var ie = 0; ie < G; ie++) Y = W[ie], Y && (Z ? (Y.left.right = Y.right, Y.right.left = Y.left, Y.left = Z, Y.right = Z.right, Z.right = Y, Y.right.left = Y, E(Y.key, Z.key) && (Z = Y)) : Z = Y);
    return Z;
  }
  return I;
}, { isClass: !0 }), name$158 = "Spa", dependencies$158 = ["addScalar", "equalScalar", "FibonacciHeap"], createSpaClass = factory(name$158, dependencies$158, (D) => {
  var { addScalar: E, equalScalar: O, FibonacciHeap: F } = D;
  function I() {
    if (!(this instanceof I)) throw SyntaxError("Constructor must be called with the new operator");
    this._values = [], this._heap = new F();
  }
  return I.prototype.type = "Spa", I.prototype.isSpa = !0, I.prototype.set = function(z, R) {
    if (this._values[z]) this._values[z].value = R;
    else {
      var L = this._heap.insert(z, R);
      this._values[z] = L;
    }
  }, I.prototype.get = function(z) {
    var R = this._values[z];
    return R ? R.value : 0;
  }, I.prototype.accumulate = function(z, R) {
    var L = this._values[z];
    L ? L.value = E(L.value, R) : (L = this._heap.insert(z, R), this._values[z] = L);
  }, I.prototype.forEach = function(z, R, L) {
    var q = this._heap, U = this._values, Z = [], V = q.extractMinimum();
    for (V && Z.push(V); V && V.key <= R; ) V.key >= z && (O(V.value, 0) || L(V.key, V.value, this)), V = q.extractMinimum(), V && Z.push(V);
    for (var G = 0; G < Z.length; G++) {
      var W = Z[G];
      V = q.insert(W.key, W.value), U[V.key] = V;
    }
  }, I.prototype.swap = function(z, R) {
    var L = this._values[z], q = this._values[R];
    if (!L && q) L = this._heap.insert(z, q.value), this._heap.remove(q), this._values[z] = L, this._values[R] = void 0;
    else if (L && !q) q = this._heap.insert(R, L.value), this._heap.remove(L), this._values[R] = q, this._values[z] = void 0;
    else if (L && q) {
      var U = L.value;
      L.value = q.value, q.value = U;
    }
  }, I;
}, { isClass: !0 });
function lruQueue(D) {
  var E = 0, O = 1, F = /* @__PURE__ */ Object.create(null), I = /* @__PURE__ */ Object.create(null), z = 0, R = function(L) {
    var q = I[L];
    if (q && (delete F[q], delete I[L], --E, O === q)) {
      if (!E) {
        z = 0, O = 1;
        return;
      }
      for (; !Object.prototype.hasOwnProperty.call(F, ++O); ) ;
    }
  };
  return D = Math.abs(D), { hit: function(L) {
    var q = I[L], U = ++z;
    if (F[U] = L, I[L] = U, !q) return ++E, E <= D ? void 0 : (L = F[O], R(L), L);
    if (delete F[q], O === q) for (; !Object.prototype.hasOwnProperty.call(F, ++O); ) ;
  }, delete: R, clear: function() {
    E = z = 0, O = 1, F = /* @__PURE__ */ Object.create(null), I = /* @__PURE__ */ Object.create(null);
  } };
}
function memoize$1(D) {
  var { hasher: E, limit: O } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return O ??= 1 / 0, E ??= JSON.stringify, function F() {
    typeof F.cache != "object" && (F.cache = { values: /* @__PURE__ */ new Map(), lru: lruQueue(O || 1 / 0) });
    var I = [...arguments], z = E(I);
    if (F.cache.values.has(z)) return F.cache.lru.hit(z), F.cache.values.get(z);
    var R = D.apply(D, I);
    return F.cache.values.set(z, R), F.cache.values.delete(F.cache.lru.hit(z)), R;
  };
}
var createBigNumberE = memoize$1(function(D) {
  return new D(1).exp();
}, { hasher }), createBigNumberPhi = memoize$1(function(D) {
  return new D(1).plus(new D(5).sqrt()).div(2);
}, { hasher }), createBigNumberPi = memoize$1(function(D) {
  return D.acos(-1);
}, { hasher }), createBigNumberTau = memoize$1(function(D) {
  return createBigNumberPi(D).times(2);
}, { hasher });
function hasher(D) {
  return D[0].precision;
}
function ownKeys$2(D, E) {
  var O = Object.keys(D);
  if (Object.getOwnPropertySymbols) {
    var F = Object.getOwnPropertySymbols(D);
    E && (F = F.filter(function(I) {
      return Object.getOwnPropertyDescriptor(D, I).enumerable;
    })), O.push.apply(O, F);
  }
  return O;
}
function _objectSpread$2(D) {
  for (var E = 1; E < arguments.length; E++) {
    var O = arguments[E] == null ? {} : arguments[E];
    E % 2 ? ownKeys$2(Object(O), !0).forEach(function(F) {
      _defineProperty(D, F, O[F]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(D, Object.getOwnPropertyDescriptors(O)) : ownKeys$2(Object(O)).forEach(function(F) {
      Object.defineProperty(D, F, Object.getOwnPropertyDescriptor(O, F));
    });
  }
  return D;
}
var name$157 = "Unit", dependencies$157 = ["?on", "config", "addScalar", "subtractScalar", "multiplyScalar", "divideScalar", "pow", "abs", "fix", "round", "equal", "isNumeric", "format", "number", "Complex", "BigNumber", "Fraction"], createUnitClass = factory(name$157, dependencies$157, (D) => {
  var { on: E, config: O, addScalar: F, subtractScalar: I, multiplyScalar: z, divideScalar: R, pow: L, abs: q, fix: U, round: Z, equal: V, isNumeric: G, format: W, number: J, Complex: X, BigNumber: Y, Fraction: ee } = D, K = J, te = !1, ie = !0;
  function ne(we, Oe) {
    if (!(this instanceof ne)) throw Error("Constructor must be called with the new operator");
    if (!(we == null || G(we) || isComplex(we))) throw TypeError("First parameter in Unit constructor must be number, BigNumber, Fraction, Complex, or undefined");
    if (this.fixPrefix = te, this.skipAutomaticSimplification = ie, Oe === void 0) this.units = [], this.dimensions = ke.map((Ue) => 0);
    else if (typeof Oe == "string") {
      var ze = ne.parse(Oe);
      this.units = ze.units, this.dimensions = ze.dimensions;
    } else if (isUnit(Oe) && Oe.value === null) this.fixPrefix = Oe.fixPrefix, this.skipAutomaticSimplification = Oe.skipAutomaticSimplification, this.dimensions = Oe.dimensions.slice(0), this.units = Oe.units.map((Ue) => _extends({}, Ue));
    else throw TypeError("Second parameter in Unit constructor must be a string or valueless Unit");
    this.value = this._normalize(we);
  }
  Object.defineProperty(ne, "name", { value: "Unit" }), ne.prototype.constructor = ne, ne.prototype.type = "Unit", ne.prototype.isUnit = !0;
  var ae, ue, oe;
  function se() {
    for (; oe === " " || oe === "	"; ) fe();
  }
  function le(we) {
    return we >= "0" && we <= "9" || we === ".";
  }
  function ce(we) {
    return we >= "0" && we <= "9";
  }
  function fe() {
    ue++, oe = ae.charAt(ue);
  }
  function pe(we) {
    ue = we, oe = ae.charAt(ue);
  }
  function ve() {
    var we = "", Oe = ue;
    if (oe === "+" ? fe() : oe === "-" && (we += oe, fe()), !le(oe)) return pe(Oe), null;
    if (oe === ".") {
      if (we += oe, fe(), !ce(oe)) return pe(Oe), null;
    } else {
      for (; ce(oe); ) we += oe, fe();
      oe === "." && (we += oe, fe());
    }
    for (; ce(oe); ) we += oe, fe();
    if (oe === "E" || oe === "e") {
      var ze = "", Ue = ue;
      if (ze += oe, fe(), (oe === "+" || oe === "-") && (ze += oe, fe()), !ce(oe)) return pe(Ue), we;
      for (we += ze; ce(oe); ) we += oe, fe();
    }
    return we;
  }
  function _e() {
    for (var we = ""; ce(oe) || ne.isValidAlpha(oe); ) we += oe, fe();
    var Oe = we.charAt(0);
    return ne.isValidAlpha(Oe) ? we : null;
  }
  function de(we) {
    return oe === we ? (fe(), we) : null;
  }
  ne.parse = function(we, Oe) {
    if (Oe ||= {}, ae = we, ue = -1, oe = "", typeof ae != "string") throw TypeError("Invalid argument in Unit.parse, string expected");
    var ze = new ne();
    ze.units = [];
    var Ue = 1, er = !1;
    fe(), se();
    var Xe = ve(), rr = null;
    if (Xe) {
      if (O.number === "BigNumber") rr = new Y(Xe);
      else if (O.number === "Fraction") try {
        rr = new ee(Xe);
      } catch {
        rr = parseFloat(Xe);
      }
      else rr = parseFloat(Xe);
      se(), de("*") ? (Ue = 1, er = !0) : de("/") && (Ue = -1, er = !0);
    }
    for (var or = [], lr = 1; ; ) {
      for (se(); oe === "("; ) or.push(Ue), lr *= Ue, Ue = 1, fe(), se();
      var sr = void 0;
      if (oe) {
        var Se = oe;
        if (sr = _e(), sr === null) throw SyntaxError('Unexpected "' + Se + '" in "' + ae + '" at index ' + ue.toString());
      } else break;
      var Be = ge(sr);
      if (Be === null) throw SyntaxError('Unit "' + sr + '" not found.');
      var qe = Ue * lr;
      if (se(), de("^")) {
        se();
        var Ze = ve();
        if (Ze === null) throw SyntaxError('In "' + we + '", "^" must be followed by a floating-point number');
        qe *= Ze;
      }
      ze.units.push({ unit: Be.unit, prefix: Be.prefix, power: qe });
      for (var He = 0; He < ke.length; He++) ze.dimensions[He] += (Be.unit.dimensions[He] || 0) * qe;
      for (se(); oe === ")"; ) {
        if (or.length === 0) throw SyntaxError('Unmatched ")" in "' + ae + '" at index ' + ue.toString());
        lr /= or.pop(), fe(), se();
      }
      if (er = !1, de("*") ? (Ue = 1, er = !0) : de("/") ? (Ue = -1, er = !0) : Ue = 1, Be.unit.base) {
        var Ge = Be.unit.base.key;
        $e.auto[Ge] = { unit: Be.unit, prefix: Be.prefix };
      }
    }
    if (se(), oe) throw SyntaxError('Could not parse: "' + we + '"');
    if (er) throw SyntaxError('Trailing characters: "' + we + '"');
    if (or.length !== 0) throw SyntaxError('Unmatched "(" in "' + ae + '"');
    if (ze.units.length === 0 && !Oe.allowNoUnits) throw SyntaxError('"' + we + '" contains no units');
    return ze.value = rr === void 0 ? null : ze._normalize(rr), ze;
  }, ne.prototype.clone = function() {
    var we = new ne();
    we.fixPrefix = this.fixPrefix, we.skipAutomaticSimplification = this.skipAutomaticSimplification, we.value = clone$3(this.value), we.dimensions = this.dimensions.slice(0), we.units = [];
    for (var Oe = 0; Oe < this.units.length; Oe++) for (var ze in we.units[Oe] = {}, this.units[Oe]) hasOwnProperty$1(this.units[Oe], ze) && (we.units[Oe][ze] = this.units[Oe][ze]);
    return we;
  }, ne.prototype.valueType = function() {
    return typeOf(this.value);
  }, ne.prototype._isDerived = function() {
    return this.units.length === 0 ? !1 : this.units.length > 1 || Math.abs(this.units[0].power - 1) > 1e-15;
  }, ne.prototype._normalize = function(we) {
    if (we == null || this.units.length === 0) return we;
    for (var Oe = we, ze = ne._getNumberConverter(typeOf(we)), Ue = 0; Ue < this.units.length; Ue++) {
      var er = ze(this.units[Ue].unit.value), Xe = ze(this.units[Ue].prefix.value), rr = ze(this.units[Ue].power);
      Oe = z(Oe, L(z(er, Xe), rr));
    }
    return Oe;
  }, ne.prototype._denormalize = function(we, Oe) {
    if (we == null || this.units.length === 0) return we;
    for (var ze = we, Ue = ne._getNumberConverter(typeOf(we)), er = 0; er < this.units.length; er++) {
      var Xe = Ue(this.units[er].unit.value), rr = Ue(this.units[er].prefix.value), or = Ue(this.units[er].power);
      ze = R(ze, L(z(Xe, rr), or));
    }
    return ze;
  };
  var ge = memoize$1((we) => {
    if (hasOwnProperty$1(be, we)) {
      var Oe = be[we];
      return { unit: Oe, prefix: Oe.prefixes[""] };
    }
    for (var ze in be) if (hasOwnProperty$1(be, ze) && endsWith(we, ze)) {
      var Ue = be[ze], er = we.length - ze.length, Xe = we.substring(0, er), rr = hasOwnProperty$1(Ue.prefixes, Xe) ? Ue.prefixes[Xe] : void 0;
      if (rr !== void 0) return { unit: Ue, prefix: rr };
    }
    return null;
  }, { hasher: (we) => we[0], limit: 100 });
  ne.isValuelessUnit = function(we) {
    return ge(we) !== null;
  }, ne.prototype.hasBase = function(we) {
    if (typeof we == "string" && (we = xe[we]), !we) return !1;
    for (var Oe = 0; Oe < ke.length; Oe++) if (Math.abs((this.dimensions[Oe] || 0) - (we.dimensions[Oe] || 0)) > 1e-12) return !1;
    return !0;
  }, ne.prototype.equalBase = function(we) {
    for (var Oe = 0; Oe < ke.length; Oe++) if (Math.abs((this.dimensions[Oe] || 0) - (we.dimensions[Oe] || 0)) > 1e-12) return !1;
    return !0;
  }, ne.prototype.equals = function(we) {
    return this.equalBase(we) && V(this.value, we.value);
  }, ne.prototype.multiply = function(we) {
    for (var Oe = this.clone(), ze = isUnit(we) ? we : new ne(we), Ue = 0; Ue < ke.length; Ue++) Oe.dimensions[Ue] = (this.dimensions[Ue] || 0) + (ze.dimensions[Ue] || 0);
    for (var er = 0; er < ze.units.length; er++) {
      var Xe = _objectSpread$2({}, ze.units[er]);
      Oe.units.push(Xe);
    }
    return this.value !== null || ze.value !== null ? Oe.value = z(this.value === null ? this._normalize(De(ze.value)) : this.value, ze.value === null ? ze._normalize(De(this.value)) : ze.value) : Oe.value = null, isUnit(we) && (Oe.skipAutomaticSimplification = !1), ye(Oe);
  }, ne.prototype.divideInto = function(we) {
    return new ne(we).divide(this);
  }, ne.prototype.divide = function(we) {
    for (var Oe = this.clone(), ze = isUnit(we) ? we : new ne(we), Ue = 0; Ue < ke.length; Ue++) Oe.dimensions[Ue] = (this.dimensions[Ue] || 0) - (ze.dimensions[Ue] || 0);
    for (var er = 0; er < ze.units.length; er++) {
      var Xe = _objectSpread$2(_objectSpread$2({}, ze.units[er]), {}, { power: -ze.units[er].power });
      Oe.units.push(Xe);
    }
    return this.value !== null || ze.value !== null ? Oe.value = R(this.value === null ? this._normalize(De(ze.value)) : this.value, ze.value === null ? ze._normalize(De(this.value)) : ze.value) : Oe.value = null, isUnit(we) && (Oe.skipAutomaticSimplification = !1), ye(Oe);
  }, ne.prototype.pow = function(we) {
    for (var Oe = this.clone(), ze = 0; ze < ke.length; ze++) Oe.dimensions[ze] = (this.dimensions[ze] || 0) * we;
    for (var Ue = 0; Ue < Oe.units.length; Ue++) Oe.units[Ue].power *= we;
    return Oe.value === null ? Oe.value = null : Oe.value = L(Oe.value, we), Oe.skipAutomaticSimplification = !1, ye(Oe);
  };
  function ye(we) {
    return we.equalBase(xe.NONE) && we.value !== null && !O.predictable ? we.value : we;
  }
  function De(we) {
    return ne._getNumberConverter(typeOf(we))(1);
  }
  ne.prototype.abs = function() {
    var we = this.clone();
    if (we.value !== null) if (we._isDerived() || we.units.length === 0 || we.units[0].unit.offset === 0) we.value = q(we.value);
    else {
      var Oe = we._numberConverter(), ze = z(Oe(we.units[0].unit.value), Oe(we.units[0].unit.offset));
      we.value = I(q(F(we.value, ze)), ze);
    }
    for (var Ue in we.units) (we.units[Ue].unit.name === "VA" || we.units[Ue].unit.name === "VAR") && (we.units[Ue].unit = be.W);
    return we;
  }, ne.prototype.to = function(we) {
    var Oe = this.value === null ? this._normalize(1) : this.value, ze;
    if (typeof we == "string") ze = ne.parse(we);
    else if (isUnit(we)) ze = we.clone();
    else throw Error("String or Unit expected as parameter");
    if (!this.equalBase(ze)) throw Error(`Units do not match ('${ze.toString()}' != '${this.toString()}')`);
    if (ze.value !== null) throw Error("Cannot convert to a unit with a value");
    if (this.value === null || this._isDerived() || this.units.length === 0 || ze.units.length === 0 || this.units[0].unit.offset === ze.units[0].unit.offset) ze.value = clone$3(Oe);
    else {
      var Ue = ne._getNumberConverter(typeOf(Oe)), er = this.units[0].unit.value, Xe = this.units[0].unit.offset, rr = z(er, Xe), or = ze.units[0].unit.value, lr = ze.units[0].unit.offset, sr = z(or, lr);
      ze.value = F(Oe, Ue(I(rr, sr)));
    }
    return ze.fixPrefix = !0, ze.skipAutomaticSimplification = !0, ze;
  }, ne.prototype.toNumber = function(we) {
    return K(this.toNumeric(we));
  }, ne.prototype.toNumeric = function(we) {
    var Oe = we ? this.to(we) : this.clone();
    return Oe._isDerived() || Oe.units.length === 0 ? Oe._denormalize(Oe.value) : Oe._denormalize(Oe.value, Oe.units[0].prefix.value);
  }, ne.prototype.toString = function() {
    return this.format();
  }, ne.prototype.toJSON = function() {
    return { mathjs: "Unit", value: this._denormalize(this.value), unit: this.units.length > 0 ? this.formatUnits() : null, fixPrefix: this.fixPrefix, skipSimp: this.skipAutomaticSimplification };
  }, ne.fromJSON = function(we) {
    var Oe = new ne(we.value, we.unit ?? void 0);
    return Oe.fixPrefix = we.fixPrefix ?? te, Oe.skipAutomaticSimplification = we.skipSimp ?? ie, Oe;
  }, ne.prototype.valueOf = ne.prototype.toString, ne.prototype.simplify = function() {
    var we = this.clone(), Oe = [], ze;
    for (var Ue in Re) if (hasOwnProperty$1(Re, Ue) && we.hasBase(xe[Ue])) {
      ze = Ue;
      break;
    }
    if (ze === "NONE") we.units = [];
    else {
      var er;
      if (ze && hasOwnProperty$1(Re, ze) && (er = Re[ze]), er) we.units = [{ unit: er.unit, prefix: er.prefix, power: 1 }];
      else {
        for (var Xe = !1, rr = 0; rr < ke.length; rr++) {
          var or = ke[rr];
          Math.abs(we.dimensions[rr] || 0) > 1e-12 && (hasOwnProperty$1(Re, or) ? Oe.push({ unit: Re[or].unit, prefix: Re[or].prefix, power: we.dimensions[rr] || 0 }) : Xe = !0);
        }
        Oe.length < we.units.length && !Xe && (we.units = Oe);
      }
    }
    return we;
  }, ne.prototype.toSI = function() {
    for (var we = this.clone(), Oe = [], ze = 0; ze < ke.length; ze++) {
      var Ue = ke[ze];
      if (Math.abs(we.dimensions[ze] || 0) > 1e-12) if (hasOwnProperty$1($e.si, Ue)) Oe.push({ unit: $e.si[Ue].unit, prefix: $e.si[Ue].prefix, power: we.dimensions[ze] || 0 });
      else throw Error("Cannot express custom unit " + Ue + " in SI units");
    }
    return we.units = Oe, we.fixPrefix = !0, we.skipAutomaticSimplification = !0, this.value === null ? we : (we.value = null, this.to(we));
  }, ne.prototype.formatUnits = function() {
    for (var we = "", Oe = "", ze = 0, Ue = 0, er = 0; er < this.units.length; er++) this.units[er].power > 0 ? (ze++, we += " " + this.units[er].prefix.name + this.units[er].unit.name, Math.abs(this.units[er].power - 1) > 1e-15 && (we += "^" + this.units[er].power)) : this.units[er].power < 0 && Ue++;
    if (Ue > 0) for (var Xe = 0; Xe < this.units.length; Xe++) this.units[Xe].power < 0 && (ze > 0 ? (Oe += " " + this.units[Xe].prefix.name + this.units[Xe].unit.name, Math.abs(this.units[Xe].power + 1) > 1e-15 && (Oe += "^" + -this.units[Xe].power)) : (Oe += " " + this.units[Xe].prefix.name + this.units[Xe].unit.name, Oe += "^" + this.units[Xe].power));
    we = we.substr(1), Oe = Oe.substr(1), ze > 1 && Ue > 0 && (we = "(" + we + ")"), Ue > 1 && ze > 0 && (Oe = "(" + Oe + ")");
    var rr = we;
    return ze > 0 && Ue > 0 && (rr += " / "), rr += Oe, rr;
  }, ne.prototype.toBest = function() {
    var we = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], Oe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (we && !Array.isArray(we)) throw Error("Invalid unit type. Expected string or Unit.");
    var ze = this.units[0].unit.prefixes;
    if (we && we.length > 0) {
      var Ue = we.map((Xe) => {
        var rr = null;
        if (typeof Xe == "string") {
          if (rr = ne.parse(Xe), !rr) throw Error("Invalid unit type. Expected compatible string or Unit.");
        } else if (!isUnit(Xe)) throw Error("Invalid unit type. Expected compatible string or Unit.");
        rr === null && (rr = Xe.clone());
        try {
          return this.to(rr.formatUnits()), rr;
        } catch {
          throw Error("Invalid unit type. Expected compatible string or Unit.");
        }
      }).map((Xe) => Xe.units[0].prefix);
      this.units[0].unit.prefixes = Ue.reduce((Xe, rr) => (Xe[rr.name] = rr, Xe), {}), this.units[0].prefix = Ue[0];
    }
    var er = Ce(this, Oe).simp;
    return this.units[0].unit.prefixes = ze, er.fixPrefix = !0, er;
  }, ne.prototype.format = function(we) {
    var { simp: Oe, valueStr: ze, unitStr: Ue } = Ce(this, we), er = ze;
    return Oe.value && isComplex(Oe.value) && (er = "(" + er + ")"), Ue.length > 0 && er.length > 0 && (er += " "), er += Ue, er;
  };
  function Ce(we) {
    var Oe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, ze = we.skipAutomaticSimplification || we.value === null ? we.clone() : we.simplify();
    Ie(ze), Ne(ze, Oe.offset);
    var Ue = ze._denormalize(ze.value);
    return { simp: ze, valueStr: ze.value === null ? "" : W(Ue, Oe || {}), unitStr: ze.formatUnits() };
  }
  function Ie(we) {
    var Oe = !1;
    for (var ze in we.value !== void 0 && we.value !== null && isComplex(we.value) && (Oe = Math.abs(we.value.re) < 1e-14), we.units) hasOwnProperty$1(we.units, ze) && we.units[ze].unit && (we.units[ze].unit.name === "VA" && Oe ? we.units[ze].unit = be.VAR : we.units[ze].unit.name === "VAR" && !Oe && (we.units[ze].unit = be.VA));
  }
  function Ne(we, Oe) {
    we.units.length === 1 && !we.fixPrefix && Math.abs(we.units[0].power - Math.round(we.units[0].power)) < 1e-14 && (we.units[0].prefix = we._bestPrefix(Oe));
  }
  ne.prototype._bestPrefix = function() {
    var we = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1.2;
    if (this.units.length !== 1 || Math.abs(this.units[0].power - Math.round(this.units[0].power)) >= 1e-14) throw Error("Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!");
    var Oe = this.value === null ? 0 : q(this.value), ze = q(this.units[0].unit.value), Ue = this.units[0].prefix;
    if (Oe === 0) return Ue;
    var er = this.units[0].power, Xe = Math.log(Oe / (Ue.value * ze) ** +er) / Math.LN10 - we;
    if (Xe > -2.200001 && Xe < 1.800001) return Ue;
    Xe = Math.abs(Xe);
    var rr = this.units[0].unit.prefixes;
    for (var or in rr) if (hasOwnProperty$1(rr, or)) {
      var lr = rr[or];
      if (lr.scientific) {
        var sr = Math.abs(Math.log(Oe / (lr.value * ze) ** +er) / Math.LN10 - we);
        (sr < Xe || sr === Xe && lr.name.length < Ue.name.length) && (Ue = lr, Xe = sr);
      }
    }
    return Ue;
  }, ne.prototype.splitUnit = function(we) {
    for (var Oe = this.clone(), ze = [], Ue = 0; Ue < we.length && (Oe = Oe.to(we[Ue]), Ue !== we.length - 1); Ue++) {
      var er = Oe.toNumeric(), Xe = Z(er), rr = void 0;
      rr = V(Xe, er) ? Xe : U(Oe.toNumeric());
      var or = new ne(rr, we[Ue].toString());
      ze.push(or), Oe = I(Oe, or);
    }
    for (var lr = 0, sr = 0; sr < ze.length; sr++) lr = F(lr, ze[sr].value);
    return V(lr, this.value) && (Oe.value = 0), ze.push(Oe), ze;
  };
  var he = { NONE: { "": { name: "", value: 1, scientific: !0 } }, SHORT: { "": { name: "", value: 1, scientific: !0 }, da: { name: "da", value: 10, scientific: !1 }, h: { name: "h", value: 100, scientific: !1 }, k: { name: "k", value: 1e3, scientific: !0 }, M: { name: "M", value: 1e6, scientific: !0 }, G: { name: "G", value: 1e9, scientific: !0 }, T: { name: "T", value: 1e12, scientific: !0 }, P: { name: "P", value: 1e15, scientific: !0 }, E: { name: "E", value: 1e18, scientific: !0 }, Z: { name: "Z", value: 1e21, scientific: !0 }, Y: { name: "Y", value: 1e24, scientific: !0 }, R: { name: "R", value: 1e27, scientific: !0 }, Q: { name: "Q", value: 1e30, scientific: !0 }, d: { name: "d", value: 0.1, scientific: !1 }, c: { name: "c", value: 0.01, scientific: !1 }, m: { name: "m", value: 1e-3, scientific: !0 }, u: { name: "u", value: 1e-6, scientific: !0 }, n: { name: "n", value: 1e-9, scientific: !0 }, p: { name: "p", value: 1e-12, scientific: !0 }, f: { name: "f", value: 1e-15, scientific: !0 }, a: { name: "a", value: 1e-18, scientific: !0 }, z: { name: "z", value: 1e-21, scientific: !0 }, y: { name: "y", value: 1e-24, scientific: !0 }, r: { name: "r", value: 1e-27, scientific: !0 }, q: { name: "q", value: 1e-30, scientific: !0 } }, LONG: { "": { name: "", value: 1, scientific: !0 }, deca: { name: "deca", value: 10, scientific: !1 }, hecto: { name: "hecto", value: 100, scientific: !1 }, kilo: { name: "kilo", value: 1e3, scientific: !0 }, mega: { name: "mega", value: 1e6, scientific: !0 }, giga: { name: "giga", value: 1e9, scientific: !0 }, tera: { name: "tera", value: 1e12, scientific: !0 }, peta: { name: "peta", value: 1e15, scientific: !0 }, exa: { name: "exa", value: 1e18, scientific: !0 }, zetta: { name: "zetta", value: 1e21, scientific: !0 }, yotta: { name: "yotta", value: 1e24, scientific: !0 }, ronna: { name: "ronna", value: 1e27, scientific: !0 }, quetta: { name: "quetta", value: 1e30, scientific: !0 }, deci: { name: "deci", value: 0.1, scientific: !1 }, centi: { name: "centi", value: 0.01, scientific: !1 }, milli: { name: "milli", value: 1e-3, scientific: !0 }, micro: { name: "micro", value: 1e-6, scientific: !0 }, nano: { name: "nano", value: 1e-9, scientific: !0 }, pico: { name: "pico", value: 1e-12, scientific: !0 }, femto: { name: "femto", value: 1e-15, scientific: !0 }, atto: { name: "atto", value: 1e-18, scientific: !0 }, zepto: { name: "zepto", value: 1e-21, scientific: !0 }, yocto: { name: "yocto", value: 1e-24, scientific: !0 }, ronto: { name: "ronto", value: 1e-27, scientific: !0 }, quecto: { name: "quecto", value: 1e-30, scientific: !0 } }, SQUARED: { "": { name: "", value: 1, scientific: !0 }, da: { name: "da", value: 100, scientific: !1 }, h: { name: "h", value: 1e4, scientific: !1 }, k: { name: "k", value: 1e6, scientific: !0 }, M: { name: "M", value: 1e12, scientific: !0 }, G: { name: "G", value: 1e18, scientific: !0 }, T: { name: "T", value: 1e24, scientific: !0 }, P: { name: "P", value: 1e30, scientific: !0 }, E: { name: "E", value: 1e36, scientific: !0 }, Z: { name: "Z", value: 1e42, scientific: !0 }, Y: { name: "Y", value: 1e48, scientific: !0 }, R: { name: "R", value: 1e54, scientific: !0 }, Q: { name: "Q", value: 1e60, scientific: !0 }, d: { name: "d", value: 0.01, scientific: !1 }, c: { name: "c", value: 1e-4, scientific: !1 }, m: { name: "m", value: 1e-6, scientific: !0 }, u: { name: "u", value: 1e-12, scientific: !0 }, n: { name: "n", value: 1e-18, scientific: !0 }, p: { name: "p", value: 1e-24, scientific: !0 }, f: { name: "f", value: 1e-30, scientific: !0 }, a: { name: "a", value: 1e-36, scientific: !0 }, z: { name: "z", value: 1e-42, scientific: !0 }, y: { name: "y", value: 1e-48, scientific: !0 }, r: { name: "r", value: 1e-54, scientific: !0 }, q: { name: "q", value: 1e-60, scientific: !0 } }, CUBIC: { "": { name: "", value: 1, scientific: !0 }, da: { name: "da", value: 1e3, scientific: !1 }, h: { name: "h", value: 1e6, scientific: !1 }, k: { name: "k", value: 1e9, scientific: !0 }, M: { name: "M", value: 1e18, scientific: !0 }, G: { name: "G", value: 1e27, scientific: !0 }, T: { name: "T", value: 1e36, scientific: !0 }, P: { name: "P", value: 1e45, scientific: !0 }, E: { name: "E", value: 1e54, scientific: !0 }, Z: { name: "Z", value: 1e63, scientific: !0 }, Y: { name: "Y", value: 1e72, scientific: !0 }, R: { name: "R", value: 1e81, scientific: !0 }, Q: { name: "Q", value: 1e90, scientific: !0 }, d: { name: "d", value: 1e-3, scientific: !1 }, c: { name: "c", value: 1e-6, scientific: !1 }, m: { name: "m", value: 1e-9, scientific: !0 }, u: { name: "u", value: 1e-18, scientific: !0 }, n: { name: "n", value: 1e-27, scientific: !0 }, p: { name: "p", value: 1e-36, scientific: !0 }, f: { name: "f", value: 1e-45, scientific: !0 }, a: { name: "a", value: 1e-54, scientific: !0 }, z: { name: "z", value: 1e-63, scientific: !0 }, y: { name: "y", value: 1e-72, scientific: !0 }, r: { name: "r", value: 1e-81, scientific: !0 }, q: { name: "q", value: 1e-90, scientific: !0 } }, BINARY_SHORT_SI: { "": { name: "", value: 1, scientific: !0 }, k: { name: "k", value: 1e3, scientific: !0 }, M: { name: "M", value: 1e6, scientific: !0 }, G: { name: "G", value: 1e9, scientific: !0 }, T: { name: "T", value: 1e12, scientific: !0 }, P: { name: "P", value: 1e15, scientific: !0 }, E: { name: "E", value: 1e18, scientific: !0 }, Z: { name: "Z", value: 1e21, scientific: !0 }, Y: { name: "Y", value: 1e24, scientific: !0 } }, BINARY_SHORT_IEC: { "": { name: "", value: 1, scientific: !0 }, Ki: { name: "Ki", value: 1024, scientific: !0 }, Mi: { name: "Mi", value: 1024 ** 2, scientific: !0 }, Gi: { name: "Gi", value: 1024 ** 3, scientific: !0 }, Ti: { name: "Ti", value: 1024 ** 4, scientific: !0 }, Pi: { name: "Pi", value: 1024 ** 5, scientific: !0 }, Ei: { name: "Ei", value: 1024 ** 6, scientific: !0 }, Zi: { name: "Zi", value: 1024 ** 7, scientific: !0 }, Yi: { name: "Yi", value: 1024 ** 8, scientific: !0 } }, BINARY_LONG_SI: { "": { name: "", value: 1, scientific: !0 }, kilo: { name: "kilo", value: 1e3, scientific: !0 }, mega: { name: "mega", value: 1e6, scientific: !0 }, giga: { name: "giga", value: 1e9, scientific: !0 }, tera: { name: "tera", value: 1e12, scientific: !0 }, peta: { name: "peta", value: 1e15, scientific: !0 }, exa: { name: "exa", value: 1e18, scientific: !0 }, zetta: { name: "zetta", value: 1e21, scientific: !0 }, yotta: { name: "yotta", value: 1e24, scientific: !0 } }, BINARY_LONG_IEC: { "": { name: "", value: 1, scientific: !0 }, kibi: { name: "kibi", value: 1024, scientific: !0 }, mebi: { name: "mebi", value: 1024 ** 2, scientific: !0 }, gibi: { name: "gibi", value: 1024 ** 3, scientific: !0 }, tebi: { name: "tebi", value: 1024 ** 4, scientific: !0 }, pebi: { name: "pebi", value: 1024 ** 5, scientific: !0 }, exi: { name: "exi", value: 1024 ** 6, scientific: !0 }, zebi: { name: "zebi", value: 1024 ** 7, scientific: !0 }, yobi: { name: "yobi", value: 1024 ** 8, scientific: !0 } }, BTU: { "": { name: "", value: 1, scientific: !0 }, MM: { name: "MM", value: 1e6, scientific: !0 } } };
  he.SHORTLONG = _extends({}, he.SHORT, he.LONG), he.BINARY_SHORT = _extends({}, he.BINARY_SHORT_SI, he.BINARY_SHORT_IEC), he.BINARY_LONG = _extends({}, he.BINARY_LONG_SI, he.BINARY_LONG_IEC);
  var ke = ["MASS", "LENGTH", "TIME", "CURRENT", "TEMPERATURE", "LUMINOUS_INTENSITY", "AMOUNT_OF_SUBSTANCE", "ANGLE", "BIT"], xe = { NONE: { dimensions: [0, 0, 0, 0, 0, 0, 0, 0, 0] }, MASS: { dimensions: [1, 0, 0, 0, 0, 0, 0, 0, 0] }, LENGTH: { dimensions: [0, 1, 0, 0, 0, 0, 0, 0, 0] }, TIME: { dimensions: [0, 0, 1, 0, 0, 0, 0, 0, 0] }, CURRENT: { dimensions: [0, 0, 0, 1, 0, 0, 0, 0, 0] }, TEMPERATURE: { dimensions: [0, 0, 0, 0, 1, 0, 0, 0, 0] }, LUMINOUS_INTENSITY: { dimensions: [0, 0, 0, 0, 0, 1, 0, 0, 0] }, AMOUNT_OF_SUBSTANCE: { dimensions: [0, 0, 0, 0, 0, 0, 1, 0, 0] }, FORCE: { dimensions: [1, 1, -2, 0, 0, 0, 0, 0, 0] }, SURFACE: { dimensions: [0, 2, 0, 0, 0, 0, 0, 0, 0] }, VOLUME: { dimensions: [0, 3, 0, 0, 0, 0, 0, 0, 0] }, ENERGY: { dimensions: [1, 2, -2, 0, 0, 0, 0, 0, 0] }, POWER: { dimensions: [1, 2, -3, 0, 0, 0, 0, 0, 0] }, PRESSURE: { dimensions: [1, -1, -2, 0, 0, 0, 0, 0, 0] }, ELECTRIC_CHARGE: { dimensions: [0, 0, 1, 1, 0, 0, 0, 0, 0] }, ELECTRIC_CAPACITANCE: { dimensions: [-1, -2, 4, 2, 0, 0, 0, 0, 0] }, ELECTRIC_POTENTIAL: { dimensions: [1, 2, -3, -1, 0, 0, 0, 0, 0] }, ELECTRIC_RESISTANCE: { dimensions: [1, 2, -3, -2, 0, 0, 0, 0, 0] }, ELECTRIC_INDUCTANCE: { dimensions: [1, 2, -2, -2, 0, 0, 0, 0, 0] }, ELECTRIC_CONDUCTANCE: { dimensions: [-1, -2, 3, 2, 0, 0, 0, 0, 0] }, MAGNETIC_FLUX: { dimensions: [1, 2, -2, -1, 0, 0, 0, 0, 0] }, MAGNETIC_FLUX_DENSITY: { dimensions: [1, 0, -2, -1, 0, 0, 0, 0, 0] }, FREQUENCY: { dimensions: [0, 0, -1, 0, 0, 0, 0, 0, 0] }, ANGLE: { dimensions: [0, 0, 0, 0, 0, 0, 0, 1, 0] }, BIT: { dimensions: [0, 0, 0, 0, 0, 0, 0, 0, 1] } };
  for (var Te in xe) hasOwnProperty$1(xe, Te) && (xe[Te].key = Te);
  var Fe = { name: "", base: {}, value: 1, offset: 0, dimensions: ke.map((we) => 0) }, be = { meter: { name: "meter", base: xe.LENGTH, prefixes: he.LONG, value: 1, offset: 0 }, inch: { name: "inch", base: xe.LENGTH, prefixes: he.NONE, value: 0.0254, offset: 0 }, foot: { name: "foot", base: xe.LENGTH, prefixes: he.NONE, value: 0.3048, offset: 0 }, yard: { name: "yard", base: xe.LENGTH, prefixes: he.NONE, value: 0.9144, offset: 0 }, mile: { name: "mile", base: xe.LENGTH, prefixes: he.NONE, value: 1609.344, offset: 0 }, link: { name: "link", base: xe.LENGTH, prefixes: he.NONE, value: 0.201168, offset: 0 }, rod: { name: "rod", base: xe.LENGTH, prefixes: he.NONE, value: 5.0292, offset: 0 }, chain: { name: "chain", base: xe.LENGTH, prefixes: he.NONE, value: 20.1168, offset: 0 }, angstrom: { name: "angstrom", base: xe.LENGTH, prefixes: he.NONE, value: 1e-10, offset: 0 }, m: { name: "m", base: xe.LENGTH, prefixes: he.SHORT, value: 1, offset: 0 }, in: { name: "in", base: xe.LENGTH, prefixes: he.NONE, value: 0.0254, offset: 0 }, ft: { name: "ft", base: xe.LENGTH, prefixes: he.NONE, value: 0.3048, offset: 0 }, yd: { name: "yd", base: xe.LENGTH, prefixes: he.NONE, value: 0.9144, offset: 0 }, mi: { name: "mi", base: xe.LENGTH, prefixes: he.NONE, value: 1609.344, offset: 0 }, li: { name: "li", base: xe.LENGTH, prefixes: he.NONE, value: 0.201168, offset: 0 }, rd: { name: "rd", base: xe.LENGTH, prefixes: he.NONE, value: 5.02921, offset: 0 }, ch: { name: "ch", base: xe.LENGTH, prefixes: he.NONE, value: 20.1168, offset: 0 }, mil: { name: "mil", base: xe.LENGTH, prefixes: he.NONE, value: 254e-7, offset: 0 }, m2: { name: "m2", base: xe.SURFACE, prefixes: he.SQUARED, value: 1, offset: 0 }, sqin: { name: "sqin", base: xe.SURFACE, prefixes: he.NONE, value: 64516e-8, offset: 0 }, sqft: { name: "sqft", base: xe.SURFACE, prefixes: he.NONE, value: 0.09290304, offset: 0 }, sqyd: { name: "sqyd", base: xe.SURFACE, prefixes: he.NONE, value: 0.83612736, offset: 0 }, sqmi: { name: "sqmi", base: xe.SURFACE, prefixes: he.NONE, value: 2589988110336e-6, offset: 0 }, sqrd: { name: "sqrd", base: xe.SURFACE, prefixes: he.NONE, value: 25.29295, offset: 0 }, sqch: { name: "sqch", base: xe.SURFACE, prefixes: he.NONE, value: 404.6873, offset: 0 }, sqmil: { name: "sqmil", base: xe.SURFACE, prefixes: he.NONE, value: 64516e-14, offset: 0 }, acre: { name: "acre", base: xe.SURFACE, prefixes: he.NONE, value: 4046.86, offset: 0 }, hectare: { name: "hectare", base: xe.SURFACE, prefixes: he.NONE, value: 1e4, offset: 0 }, m3: { name: "m3", base: xe.VOLUME, prefixes: he.CUBIC, value: 1, offset: 0 }, L: { name: "L", base: xe.VOLUME, prefixes: he.SHORT, value: 1e-3, offset: 0 }, l: { name: "l", base: xe.VOLUME, prefixes: he.SHORT, value: 1e-3, offset: 0 }, litre: { name: "litre", base: xe.VOLUME, prefixes: he.LONG, value: 1e-3, offset: 0 }, cuin: { name: "cuin", base: xe.VOLUME, prefixes: he.NONE, value: 16387064e-12, offset: 0 }, cuft: { name: "cuft", base: xe.VOLUME, prefixes: he.NONE, value: 0.028316846592, offset: 0 }, cuyd: { name: "cuyd", base: xe.VOLUME, prefixes: he.NONE, value: 0.764554857984, offset: 0 }, teaspoon: { name: "teaspoon", base: xe.VOLUME, prefixes: he.NONE, value: 5e-6, offset: 0 }, tablespoon: { name: "tablespoon", base: xe.VOLUME, prefixes: he.NONE, value: 15e-6, offset: 0 }, drop: { name: "drop", base: xe.VOLUME, prefixes: he.NONE, value: 5e-8, offset: 0 }, gtt: { name: "gtt", base: xe.VOLUME, prefixes: he.NONE, value: 5e-8, offset: 0 }, minim: { name: "minim", base: xe.VOLUME, prefixes: he.NONE, value: 61611519921875e-21, offset: 0 }, fluiddram: { name: "fluiddram", base: xe.VOLUME, prefixes: he.NONE, value: 36966911953125e-19, offset: 0 }, fluidounce: { name: "fluidounce", base: xe.VOLUME, prefixes: he.NONE, value: 295735295625e-16, offset: 0 }, gill: { name: "gill", base: xe.VOLUME, prefixes: he.NONE, value: 11829411825e-14, offset: 0 }, cc: { name: "cc", base: xe.VOLUME, prefixes: he.NONE, value: 1e-6, offset: 0 }, cup: { name: "cup", base: xe.VOLUME, prefixes: he.NONE, value: 2365882365e-13, offset: 0 }, pint: { name: "pint", base: xe.VOLUME, prefixes: he.NONE, value: 473176473e-12, offset: 0 }, quart: { name: "quart", base: xe.VOLUME, prefixes: he.NONE, value: 946352946e-12, offset: 0 }, gallon: { name: "gallon", base: xe.VOLUME, prefixes: he.NONE, value: 0.003785411784, offset: 0 }, beerbarrel: { name: "beerbarrel", base: xe.VOLUME, prefixes: he.NONE, value: 0.117347765304, offset: 0 }, oilbarrel: { name: "oilbarrel", base: xe.VOLUME, prefixes: he.NONE, value: 0.158987294928, offset: 0 }, hogshead: { name: "hogshead", base: xe.VOLUME, prefixes: he.NONE, value: 0.238480942392, offset: 0 }, g: { name: "g", base: xe.MASS, prefixes: he.SHORT, value: 1e-3, offset: 0 }, gram: { name: "gram", base: xe.MASS, prefixes: he.LONG, value: 1e-3, offset: 0 }, ton: { name: "ton", base: xe.MASS, prefixes: he.SHORT, value: 907.18474, offset: 0 }, t: { name: "t", base: xe.MASS, prefixes: he.SHORT, value: 1e3, offset: 0 }, tonne: { name: "tonne", base: xe.MASS, prefixes: he.LONG, value: 1e3, offset: 0 }, grain: { name: "grain", base: xe.MASS, prefixes: he.NONE, value: 6479891e-11, offset: 0 }, dram: { name: "dram", base: xe.MASS, prefixes: he.NONE, value: 0.0017718451953125, offset: 0 }, ounce: { name: "ounce", base: xe.MASS, prefixes: he.NONE, value: 0.028349523125, offset: 0 }, poundmass: { name: "poundmass", base: xe.MASS, prefixes: he.NONE, value: 0.45359237, offset: 0 }, hundredweight: { name: "hundredweight", base: xe.MASS, prefixes: he.NONE, value: 45.359237, offset: 0 }, stick: { name: "stick", base: xe.MASS, prefixes: he.NONE, value: 0.115, offset: 0 }, stone: { name: "stone", base: xe.MASS, prefixes: he.NONE, value: 6.35029318, offset: 0 }, gr: { name: "gr", base: xe.MASS, prefixes: he.NONE, value: 6479891e-11, offset: 0 }, dr: { name: "dr", base: xe.MASS, prefixes: he.NONE, value: 0.0017718451953125, offset: 0 }, oz: { name: "oz", base: xe.MASS, prefixes: he.NONE, value: 0.028349523125, offset: 0 }, lbm: { name: "lbm", base: xe.MASS, prefixes: he.NONE, value: 0.45359237, offset: 0 }, cwt: { name: "cwt", base: xe.MASS, prefixes: he.NONE, value: 45.359237, offset: 0 }, s: { name: "s", base: xe.TIME, prefixes: he.SHORT, value: 1, offset: 0 }, min: { name: "min", base: xe.TIME, prefixes: he.NONE, value: 60, offset: 0 }, h: { name: "h", base: xe.TIME, prefixes: he.NONE, value: 3600, offset: 0 }, second: { name: "second", base: xe.TIME, prefixes: he.LONG, value: 1, offset: 0 }, sec: { name: "sec", base: xe.TIME, prefixes: he.LONG, value: 1, offset: 0 }, minute: { name: "minute", base: xe.TIME, prefixes: he.NONE, value: 60, offset: 0 }, hour: { name: "hour", base: xe.TIME, prefixes: he.NONE, value: 3600, offset: 0 }, day: { name: "day", base: xe.TIME, prefixes: he.NONE, value: 86400, offset: 0 }, week: { name: "week", base: xe.TIME, prefixes: he.NONE, value: 7 * 86400, offset: 0 }, month: { name: "month", base: xe.TIME, prefixes: he.NONE, value: 2629800, offset: 0 }, year: { name: "year", base: xe.TIME, prefixes: he.NONE, value: 31557600, offset: 0 }, decade: { name: "decade", base: xe.TIME, prefixes: he.NONE, value: 315576e3, offset: 0 }, century: { name: "century", base: xe.TIME, prefixes: he.NONE, value: 315576e4, offset: 0 }, millennium: { name: "millennium", base: xe.TIME, prefixes: he.NONE, value: 315576e5, offset: 0 }, hertz: { name: "Hertz", base: xe.FREQUENCY, prefixes: he.LONG, value: 1, offset: 0, reciprocal: !0 }, Hz: { name: "Hz", base: xe.FREQUENCY, prefixes: he.SHORT, value: 1, offset: 0, reciprocal: !0 }, rad: { name: "rad", base: xe.ANGLE, prefixes: he.SHORT, value: 1, offset: 0 }, radian: { name: "radian", base: xe.ANGLE, prefixes: he.LONG, value: 1, offset: 0 }, deg: { name: "deg", base: xe.ANGLE, prefixes: he.SHORT, value: null, offset: 0 }, degree: { name: "degree", base: xe.ANGLE, prefixes: he.LONG, value: null, offset: 0 }, grad: { name: "grad", base: xe.ANGLE, prefixes: he.SHORT, value: null, offset: 0 }, gradian: { name: "gradian", base: xe.ANGLE, prefixes: he.LONG, value: null, offset: 0 }, cycle: { name: "cycle", base: xe.ANGLE, prefixes: he.NONE, value: null, offset: 0 }, arcsec: { name: "arcsec", base: xe.ANGLE, prefixes: he.NONE, value: null, offset: 0 }, arcmin: { name: "arcmin", base: xe.ANGLE, prefixes: he.NONE, value: null, offset: 0 }, A: { name: "A", base: xe.CURRENT, prefixes: he.SHORT, value: 1, offset: 0 }, ampere: { name: "ampere", base: xe.CURRENT, prefixes: he.LONG, value: 1, offset: 0 }, K: { name: "K", base: xe.TEMPERATURE, prefixes: he.SHORT, value: 1, offset: 0 }, degC: { name: "degC", base: xe.TEMPERATURE, prefixes: he.SHORT, value: 1, offset: 273.15 }, degF: { name: "degF", base: xe.TEMPERATURE, prefixes: he.SHORT, value: new ee(5, 9), offset: 459.67 }, degR: { name: "degR", base: xe.TEMPERATURE, prefixes: he.SHORT, value: new ee(5, 9), offset: 0 }, kelvin: { name: "kelvin", base: xe.TEMPERATURE, prefixes: he.LONG, value: 1, offset: 0 }, celsius: { name: "celsius", base: xe.TEMPERATURE, prefixes: he.LONG, value: 1, offset: 273.15 }, fahrenheit: { name: "fahrenheit", base: xe.TEMPERATURE, prefixes: he.LONG, value: new ee(5, 9), offset: 459.67 }, rankine: { name: "rankine", base: xe.TEMPERATURE, prefixes: he.LONG, value: new ee(5, 9), offset: 0 }, mol: { name: "mol", base: xe.AMOUNT_OF_SUBSTANCE, prefixes: he.SHORT, value: 1, offset: 0 }, mole: { name: "mole", base: xe.AMOUNT_OF_SUBSTANCE, prefixes: he.LONG, value: 1, offset: 0 }, cd: { name: "cd", base: xe.LUMINOUS_INTENSITY, prefixes: he.SHORT, value: 1, offset: 0 }, candela: { name: "candela", base: xe.LUMINOUS_INTENSITY, prefixes: he.LONG, value: 1, offset: 0 }, N: { name: "N", base: xe.FORCE, prefixes: he.SHORT, value: 1, offset: 0 }, newton: { name: "newton", base: xe.FORCE, prefixes: he.LONG, value: 1, offset: 0 }, dyn: { name: "dyn", base: xe.FORCE, prefixes: he.SHORT, value: 1e-5, offset: 0 }, dyne: { name: "dyne", base: xe.FORCE, prefixes: he.LONG, value: 1e-5, offset: 0 }, lbf: { name: "lbf", base: xe.FORCE, prefixes: he.NONE, value: 4.4482216152605, offset: 0 }, poundforce: { name: "poundforce", base: xe.FORCE, prefixes: he.NONE, value: 4.4482216152605, offset: 0 }, kip: { name: "kip", base: xe.FORCE, prefixes: he.LONG, value: 4448.2216, offset: 0 }, kilogramforce: { name: "kilogramforce", base: xe.FORCE, prefixes: he.NONE, value: 9.80665, offset: 0 }, J: { name: "J", base: xe.ENERGY, prefixes: he.SHORT, value: 1, offset: 0 }, joule: { name: "joule", base: xe.ENERGY, prefixes: he.LONG, value: 1, offset: 0 }, erg: { name: "erg", base: xe.ENERGY, prefixes: he.SHORTLONG, value: 1e-7, offset: 0 }, Wh: { name: "Wh", base: xe.ENERGY, prefixes: he.SHORT, value: 3600, offset: 0 }, BTU: { name: "BTU", base: xe.ENERGY, prefixes: he.BTU, value: 1055.05585262, offset: 0 }, eV: { name: "eV", base: xe.ENERGY, prefixes: he.SHORT, value: 1602176565e-28, offset: 0 }, electronvolt: { name: "electronvolt", base: xe.ENERGY, prefixes: he.LONG, value: 1602176565e-28, offset: 0 }, W: { name: "W", base: xe.POWER, prefixes: he.SHORT, value: 1, offset: 0 }, watt: { name: "watt", base: xe.POWER, prefixes: he.LONG, value: 1, offset: 0 }, hp: { name: "hp", base: xe.POWER, prefixes: he.NONE, value: 745.6998715386, offset: 0 }, VAR: { name: "VAR", base: xe.POWER, prefixes: he.SHORT, value: X.I, offset: 0 }, VA: { name: "VA", base: xe.POWER, prefixes: he.SHORT, value: 1, offset: 0 }, Pa: { name: "Pa", base: xe.PRESSURE, prefixes: he.SHORT, value: 1, offset: 0 }, psi: { name: "psi", base: xe.PRESSURE, prefixes: he.NONE, value: 6894.75729276459, offset: 0 }, atm: { name: "atm", base: xe.PRESSURE, prefixes: he.NONE, value: 101325, offset: 0 }, bar: { name: "bar", base: xe.PRESSURE, prefixes: he.SHORTLONG, value: 1e5, offset: 0 }, torr: { name: "torr", base: xe.PRESSURE, prefixes: he.NONE, value: 133.322, offset: 0 }, mmHg: { name: "mmHg", base: xe.PRESSURE, prefixes: he.NONE, value: 133.322, offset: 0 }, mmH2O: { name: "mmH2O", base: xe.PRESSURE, prefixes: he.NONE, value: 9.80665, offset: 0 }, cmH2O: { name: "cmH2O", base: xe.PRESSURE, prefixes: he.NONE, value: 98.0665, offset: 0 }, coulomb: { name: "coulomb", base: xe.ELECTRIC_CHARGE, prefixes: he.LONG, value: 1, offset: 0 }, C: { name: "C", base: xe.ELECTRIC_CHARGE, prefixes: he.SHORT, value: 1, offset: 0 }, Ah: { name: "Ah", base: xe.ELECTRIC_CHARGE, prefixes: he.SHORT, value: 3600, offset: 0 }, farad: { name: "farad", base: xe.ELECTRIC_CAPACITANCE, prefixes: he.LONG, value: 1, offset: 0 }, F: { name: "F", base: xe.ELECTRIC_CAPACITANCE, prefixes: he.SHORT, value: 1, offset: 0 }, volt: { name: "volt", base: xe.ELECTRIC_POTENTIAL, prefixes: he.LONG, value: 1, offset: 0 }, V: { name: "V", base: xe.ELECTRIC_POTENTIAL, prefixes: he.SHORT, value: 1, offset: 0 }, ohm: { name: "ohm", base: xe.ELECTRIC_RESISTANCE, prefixes: he.SHORTLONG, value: 1, offset: 0 }, henry: { name: "henry", base: xe.ELECTRIC_INDUCTANCE, prefixes: he.LONG, value: 1, offset: 0 }, H: { name: "H", base: xe.ELECTRIC_INDUCTANCE, prefixes: he.SHORT, value: 1, offset: 0 }, siemens: { name: "siemens", base: xe.ELECTRIC_CONDUCTANCE, prefixes: he.LONG, value: 1, offset: 0 }, S: { name: "S", base: xe.ELECTRIC_CONDUCTANCE, prefixes: he.SHORT, value: 1, offset: 0 }, weber: { name: "weber", base: xe.MAGNETIC_FLUX, prefixes: he.LONG, value: 1, offset: 0 }, Wb: { name: "Wb", base: xe.MAGNETIC_FLUX, prefixes: he.SHORT, value: 1, offset: 0 }, tesla: { name: "tesla", base: xe.MAGNETIC_FLUX_DENSITY, prefixes: he.LONG, value: 1, offset: 0 }, T: { name: "T", base: xe.MAGNETIC_FLUX_DENSITY, prefixes: he.SHORT, value: 1, offset: 0 }, b: { name: "b", base: xe.BIT, prefixes: he.BINARY_SHORT, value: 1, offset: 0 }, bits: { name: "bits", base: xe.BIT, prefixes: he.BINARY_LONG, value: 1, offset: 0 }, B: { name: "B", base: xe.BIT, prefixes: he.BINARY_SHORT, value: 8, offset: 0 }, bytes: { name: "bytes", base: xe.BIT, prefixes: he.BINARY_LONG, value: 8, offset: 0 } }, Ae = { meters: "meter", inches: "inch", feet: "foot", yards: "yard", miles: "mile", links: "link", rods: "rod", chains: "chain", angstroms: "angstrom", lt: "l", litres: "litre", liter: "litre", liters: "litre", teaspoons: "teaspoon", tablespoons: "tablespoon", minims: "minim", fldr: "fluiddram", fluiddrams: "fluiddram", floz: "fluidounce", fluidounces: "fluidounce", gi: "gill", gills: "gill", cp: "cup", cups: "cup", pt: "pint", pints: "pint", qt: "quart", quarts: "quart", gal: "gallon", gallons: "gallon", bbl: "beerbarrel", beerbarrels: "beerbarrel", obl: "oilbarrel", oilbarrels: "oilbarrel", hogsheads: "hogshead", gtts: "gtt", grams: "gram", tons: "ton", tonnes: "tonne", grains: "grain", drams: "dram", ounces: "ounce", poundmasses: "poundmass", hundredweights: "hundredweight", sticks: "stick", lb: "lbm", lbs: "lbm", kips: "kip", kgf: "kilogramforce", acres: "acre", hectares: "hectare", sqfeet: "sqft", sqyard: "sqyd", sqmile: "sqmi", sqmiles: "sqmi", mmhg: "mmHg", mmh2o: "mmH2O", cmh2o: "cmH2O", seconds: "second", secs: "second", minutes: "minute", mins: "minute", hours: "hour", hr: "hour", hrs: "hour", days: "day", weeks: "week", months: "month", years: "year", decades: "decade", centuries: "century", millennia: "millennium", hertz: "hertz", radians: "radian", degrees: "degree", gradians: "gradian", cycles: "cycle", arcsecond: "arcsec", arcseconds: "arcsec", arcminute: "arcmin", arcminutes: "arcmin", BTUs: "BTU", watts: "watt", joules: "joule", amperes: "ampere", amps: "ampere", amp: "ampere", coulombs: "coulomb", volts: "volt", ohms: "ohm", farads: "farad", webers: "weber", teslas: "tesla", electronvolts: "electronvolt", moles: "mole", bit: "bits", byte: "bytes" };
  function Me(we) {
    if (we.number === "BigNumber") {
      var Oe = createBigNumberPi(Y);
      be.rad.value = new Y(1), be.deg.value = Oe.div(180), be.grad.value = Oe.div(200), be.cycle.value = Oe.times(2), be.arcsec.value = Oe.div(648e3), be.arcmin.value = Oe.div(10800);
    } else be.rad.value = 1, be.deg.value = Math.PI / 180, be.grad.value = Math.PI / 200, be.cycle.value = Math.PI * 2, be.arcsec.value = Math.PI / 648e3, be.arcmin.value = Math.PI / 10800;
    be.radian.value = be.rad.value, be.degree.value = be.deg.value, be.gradian.value = be.grad.value;
  }
  Me(O), E && E("config", function(we, Oe) {
    we.number !== Oe.number && Me(we);
  });
  var $e = { si: { NONE: { unit: Fe, prefix: he.NONE[""] }, LENGTH: { unit: be.m, prefix: he.SHORT[""] }, MASS: { unit: be.g, prefix: he.SHORT.k }, TIME: { unit: be.s, prefix: he.SHORT[""] }, CURRENT: { unit: be.A, prefix: he.SHORT[""] }, TEMPERATURE: { unit: be.K, prefix: he.SHORT[""] }, LUMINOUS_INTENSITY: { unit: be.cd, prefix: he.SHORT[""] }, AMOUNT_OF_SUBSTANCE: { unit: be.mol, prefix: he.SHORT[""] }, ANGLE: { unit: be.rad, prefix: he.SHORT[""] }, BIT: { unit: be.bits, prefix: he.SHORT[""] }, FORCE: { unit: be.N, prefix: he.SHORT[""] }, ENERGY: { unit: be.J, prefix: he.SHORT[""] }, POWER: { unit: be.W, prefix: he.SHORT[""] }, PRESSURE: { unit: be.Pa, prefix: he.SHORT[""] }, ELECTRIC_CHARGE: { unit: be.C, prefix: he.SHORT[""] }, ELECTRIC_CAPACITANCE: { unit: be.F, prefix: he.SHORT[""] }, ELECTRIC_POTENTIAL: { unit: be.V, prefix: he.SHORT[""] }, ELECTRIC_RESISTANCE: { unit: be.ohm, prefix: he.SHORT[""] }, ELECTRIC_INDUCTANCE: { unit: be.H, prefix: he.SHORT[""] }, ELECTRIC_CONDUCTANCE: { unit: be.S, prefix: he.SHORT[""] }, MAGNETIC_FLUX: { unit: be.Wb, prefix: he.SHORT[""] }, MAGNETIC_FLUX_DENSITY: { unit: be.T, prefix: he.SHORT[""] }, FREQUENCY: { unit: be.Hz, prefix: he.SHORT[""] } } };
  $e.cgs = JSON.parse(JSON.stringify($e.si)), $e.cgs.LENGTH = { unit: be.m, prefix: he.SHORT.c }, $e.cgs.MASS = { unit: be.g, prefix: he.SHORT[""] }, $e.cgs.FORCE = { unit: be.dyn, prefix: he.SHORT[""] }, $e.cgs.ENERGY = { unit: be.erg, prefix: he.NONE[""] }, $e.us = JSON.parse(JSON.stringify($e.si)), $e.us.LENGTH = { unit: be.ft, prefix: he.NONE[""] }, $e.us.MASS = { unit: be.lbm, prefix: he.NONE[""] }, $e.us.TEMPERATURE = { unit: be.degF, prefix: he.NONE[""] }, $e.us.FORCE = { unit: be.lbf, prefix: he.NONE[""] }, $e.us.ENERGY = { unit: be.BTU, prefix: he.BTU[""] }, $e.us.POWER = { unit: be.hp, prefix: he.NONE[""] }, $e.us.PRESSURE = { unit: be.psi, prefix: he.NONE[""] }, $e.auto = JSON.parse(JSON.stringify($e.si));
  var Re = $e.auto;
  for (var je in ne.setUnitSystem = function(we) {
    if (hasOwnProperty$1($e, we)) Re = $e[we];
    else throw Error("Unit system " + we + " does not exist. Choices are: " + Object.keys($e).join(", "));
  }, ne.getUnitSystem = function() {
    for (var we in $e) if (hasOwnProperty$1($e, we) && $e[we] === Re) return we;
  }, ne.typeConverters = { BigNumber: function(we) {
    return we != null && we.isFraction ? new Y(String(we.n)).div(String(we.d)).times(String(we.s)) : new Y(we + "");
  }, Fraction: function(we) {
    return new ee(we);
  }, Complex: function(we) {
    return we;
  }, number: function(we) {
    return we != null && we.isFraction ? J(we) : we;
  } }, ne.prototype._numberConverter = function() {
    var we = ne.typeConverters[this.valueType()];
    if (we) return we;
    throw TypeError('Unsupported Unit value type "' + this.valueType() + '"');
  }, ne._getNumberConverter = function(we) {
    if (!ne.typeConverters[we]) throw TypeError('Unsupported type "' + we + '"');
    return ne.typeConverters[we];
  }, be) if (hasOwnProperty$1(be, je)) {
    var Pe = be[je];
    Pe.dimensions = Pe.base.dimensions;
  }
  for (var Ke in Ae) if (hasOwnProperty$1(Ae, Ke)) {
    var Qe = be[Ae[Ke]], We = {};
    for (var ir in Qe) hasOwnProperty$1(Qe, ir) && (We[ir] = Qe[ir]);
    We.name = Ke, be[Ke] = We;
  }
  ne.isValidAlpha = function(we) {
    return /^[a-zA-Z]$/.test(we);
  };
  function nr(we) {
    for (var Oe = 0; Oe < we.length; Oe++) {
      if (oe = we.charAt(Oe), Oe === 0 && !ne.isValidAlpha(oe)) throw Error('Invalid unit name (must begin with alpha character): "' + we + '"');
      if (Oe > 0 && !(ne.isValidAlpha(oe) || ce(oe))) throw Error('Invalid unit name (only alphanumeric characters are allowed): "' + we + '"');
    }
  }
  return ne.createUnit = function(we, Oe) {
    if (typeof we != "object") throw TypeError("createUnit expects first parameter to be of type 'Object'");
    if (Oe && Oe.override) {
      for (var ze in we) if (hasOwnProperty$1(we, ze) && ne.deleteUnit(ze), we[ze].aliases) for (var Ue = 0; Ue < we[ze].aliases.length; Ue++) ne.deleteUnit(we[ze].aliases[Ue]);
    }
    var er;
    for (var Xe in we) hasOwnProperty$1(we, Xe) && (er = ne.createUnitSingle(Xe, we[Xe]));
    return er;
  }, ne.createUnitSingle = function(we, Oe) {
    if (Oe ??= {}, typeof we != "string") throw TypeError("createUnitSingle expects first parameter to be of type 'string'");
    if (hasOwnProperty$1(be, we)) throw Error('Cannot create unit "' + we + '": a unit with that name already exists');
    nr(we);
    var ze = null, Ue = [], er = 0, Xe, rr, or;
    if (Oe && Oe.type === "Unit") ze = Oe.clone();
    else if (typeof Oe == "string") Oe !== "" && (Xe = Oe);
    else if (typeof Oe == "object") Xe = Oe.definition, rr = Oe.prefixes, er = Oe.offset, or = Oe.baseName, Oe.aliases && (Ue = Oe.aliases.valueOf());
    else throw TypeError('Cannot create unit "' + we + '" from "' + Oe.toString() + '": expecting "string" or "Unit" or "Object"');
    if (Ue) {
      for (var lr = 0; lr < Ue.length; lr++) if (hasOwnProperty$1(be, Ue[lr])) throw Error('Cannot create alias "' + Ue[lr] + '": a unit with that name already exists');
    }
    if (Xe && typeof Xe == "string" && !ze) try {
      ze = ne.parse(Xe, { allowNoUnits: !0 });
    } catch (tr) {
      throw tr.message = 'Could not create unit "' + we + '" from "' + Xe + '": ' + tr.message, tr;
    }
    else Xe && Xe.type === "Unit" && (ze = Xe.clone());
    Ue ||= [], er ||= 0, rr = rr && rr.toUpperCase && he[rr.toUpperCase()] || he.NONE;
    var sr = {};
    if (ze) {
      sr = { name: we, value: ze.value, dimensions: ze.dimensions.slice(0), prefixes: rr, offset: er };
      var Se = !1;
      for (var Be in xe) if (hasOwnProperty$1(xe, Be)) {
        for (var qe = !0, Ze = 0; Ze < ke.length; Ze++) if (Math.abs((sr.dimensions[Ze] || 0) - (xe[Be].dimensions[Ze] || 0)) > 1e-12) {
          qe = !1;
          break;
        }
        if (qe) {
          Se = !0, sr.base = xe[Be];
          break;
        }
      }
      if (!Se) {
        or ||= we + "_STUFF";
        var He = { dimensions: ze.dimensions.slice(0) };
        He.key = or, xe[or] = He, Re[or] = { unit: sr, prefix: he.NONE[""] }, sr.base = xe[or];
      }
    } else {
      if (or ||= we + "_STUFF", ke.indexOf(or) >= 0) throw Error('Cannot create new base unit "' + we + '": a base unit with that name already exists (and cannot be overridden)');
      for (var Ge in ke.push(or), xe) hasOwnProperty$1(xe, Ge) && (xe[Ge].dimensions[ke.length - 1] = 0);
      for (var Ye = { dimensions: [] }, Je = 0; Je < ke.length; Je++) Ye.dimensions[Je] = 0;
      Ye.dimensions[ke.length - 1] = 1, Ye.key = or, xe[or] = Ye, sr = { name: we, value: 1, dimensions: xe[or].dimensions.slice(0), prefixes: rr, offset: er, base: xe[or] }, Re[or] = { unit: sr, prefix: he.NONE[""] };
    }
    ne.UNITS[we] = sr;
    for (var me = 0; me < Ue.length; me++) {
      var Ee = Ue[me], Le = {};
      for (var Ve in sr) hasOwnProperty$1(sr, Ve) && (Le[Ve] = sr[Ve]);
      Le.name = Ee, ne.UNITS[Ee] = Le;
    }
    return delete ge.cache, new ne(null, we);
  }, ne.deleteUnit = function(we) {
    delete ne.UNITS[we], delete ge.cache;
  }, ne.PREFIXES = he, ne.BASE_DIMENSIONS = ke, ne.BASE_UNITS = xe, ne.UNIT_SYSTEMS = $e, ne.UNITS = be, ne;
}, { isClass: !0 }), name$156 = "unit", dependencies$156 = ["typed", "Unit"], createUnitFunction = factory(name$156, dependencies$156, (D) => {
  var { typed: E, Unit: O } = D;
  return E(name$156, { Unit: function(F) {
    return F.clone();
  }, string: function(F) {
    return O.isValuelessUnit(F) ? new O(null, F) : O.parse(F, { allowNoUnits: !0 });
  }, "number | BigNumber | Fraction | Complex, string | Unit": function(F, I) {
    return new O(F, I);
  }, "number | BigNumber | Fraction": function(F) {
    return new O(F);
  }, "Array | Matrix": E.referToSelf((F) => (I) => deepMap(I, F)) });
}), name$155 = "sparse", dependencies$155 = ["typed", "SparseMatrix"], createSparse = factory(name$155, dependencies$155, (D) => {
  var { typed: E, SparseMatrix: O } = D;
  return E(name$155, { "": function() {
    return new O([]);
  }, string: function(F) {
    return new O([], F);
  }, "Array | Matrix": function(F) {
    return new O(F);
  }, "Array | Matrix, string": function(F, I) {
    return new O(F, I);
  } });
}), name$154 = "createUnit", dependencies$154 = ["typed", "Unit"], createCreateUnit = factory(name$154, dependencies$154, (D) => {
  var { typed: E, Unit: O } = D;
  return E(name$154, { "Object, Object": function(F, I) {
    return O.createUnit(F, I);
  }, Object: function(F) {
    return O.createUnit(F, {});
  }, "string, Unit | string | Object, Object": function(F, I, z) {
    var R = {};
    return R[F] = I, O.createUnit(R, z);
  }, "string, Unit | string | Object": function(F, I) {
    var z = {};
    return z[F] = I, O.createUnit(z, {});
  }, string: function(F) {
    var I = {};
    return I[F] = {}, O.createUnit(I, {});
  } });
}), name$153 = "acos", dependencies$153 = ["typed", "config", "Complex"], createAcos = factory(name$153, dependencies$153, (D) => {
  var { typed: E, config: O, Complex: F } = D;
  return E(name$153, { number: function(I) {
    return I >= -1 && I <= 1 || O.predictable ? Math.acos(I) : new F(I, 0).acos();
  }, Complex: function(I) {
    return I.acos();
  }, BigNumber: function(I) {
    return I.acos();
  } });
}), name$152 = "acosh", dependencies$152 = ["typed", "config", "Complex"], createAcosh = factory(name$152, dependencies$152, (D) => {
  var { typed: E, config: O, Complex: F } = D;
  return E(name$152, { number: function(I) {
    return I >= 1 || O.predictable ? acoshNumber(I) : I <= -1 ? new F(Math.log(Math.sqrt(I * I - 1) - I), Math.PI) : new F(I, 0).acosh();
  }, Complex: function(I) {
    return I.acosh();
  }, BigNumber: function(I) {
    return I.acosh();
  } });
}), name$151 = "acot", dependencies$151 = ["typed", "BigNumber"], createAcot = factory(name$151, dependencies$151, (D) => {
  var { typed: E, BigNumber: O } = D;
  return E(name$151, { number: acotNumber, Complex: function(F) {
    return F.acot();
  }, BigNumber: function(F) {
    return new O(1).div(F).atan();
  } });
}), name$150 = "acoth", dependencies$150 = ["typed", "config", "Complex", "BigNumber"], createAcoth = factory(name$150, dependencies$150, (D) => {
  var { typed: E, config: O, Complex: F, BigNumber: I } = D;
  return E(name$150, { number: function(z) {
    return z >= 1 || z <= -1 || O.predictable ? acothNumber(z) : new F(z, 0).acoth();
  }, Complex: function(z) {
    return z.acoth();
  }, BigNumber: function(z) {
    return new I(1).div(z).atanh();
  } });
}), name$149 = "acsc", dependencies$149 = ["typed", "config", "Complex", "BigNumber"], createAcsc = factory(name$149, dependencies$149, (D) => {
  var { typed: E, config: O, Complex: F, BigNumber: I } = D;
  return E(name$149, { number: function(z) {
    return z <= -1 || z >= 1 || O.predictable ? acscNumber(z) : new F(z, 0).acsc();
  }, Complex: function(z) {
    return z.acsc();
  }, BigNumber: function(z) {
    return new I(1).div(z).asin();
  } });
}), name$148 = "acsch", dependencies$148 = ["typed", "BigNumber"], createAcsch = factory(name$148, dependencies$148, (D) => {
  var { typed: E, BigNumber: O } = D;
  return E(name$148, { number: acschNumber, Complex: function(F) {
    return F.acsch();
  }, BigNumber: function(F) {
    return new O(1).div(F).asinh();
  } });
}), name$147 = "asec", dependencies$147 = ["typed", "config", "Complex", "BigNumber"], createAsec = factory(name$147, dependencies$147, (D) => {
  var { typed: E, config: O, Complex: F, BigNumber: I } = D;
  return E(name$147, { number: function(z) {
    return z <= -1 || z >= 1 || O.predictable ? asecNumber(z) : new F(z, 0).asec();
  }, Complex: function(z) {
    return z.asec();
  }, BigNumber: function(z) {
    return new I(1).div(z).acos();
  } });
}), name$146 = "asech", dependencies$146 = ["typed", "config", "Complex", "BigNumber"], createAsech = factory(name$146, dependencies$146, (D) => {
  var { typed: E, config: O, Complex: F, BigNumber: I } = D;
  return E(name$146, { number: function(z) {
    if (z <= 1 && z >= -1 || O.predictable) {
      var R = 1 / z;
      if (R > 0 || O.predictable) return asechNumber(z);
      var L = Math.sqrt(R * R - 1);
      return new F(Math.log(L - R), Math.PI);
    }
    return new F(z, 0).asech();
  }, Complex: function(z) {
    return z.asech();
  }, BigNumber: function(z) {
    return new I(1).div(z).acosh();
  } });
}), name$145 = "asin", dependencies$145 = ["typed", "config", "Complex"], createAsin = factory(name$145, dependencies$145, (D) => {
  var { typed: E, config: O, Complex: F } = D;
  return E(name$145, { number: function(I) {
    return I >= -1 && I <= 1 || O.predictable ? Math.asin(I) : new F(I, 0).asin();
  }, Complex: function(I) {
    return I.asin();
  }, BigNumber: function(I) {
    return I.asin();
  } });
}), name$144 = "asinh", dependencies$144 = ["typed"], createAsinh = factory(name$144, dependencies$144, (D) => {
  var { typed: E } = D;
  return E("asinh", { number: asinhNumber, Complex: function(O) {
    return O.asinh();
  }, BigNumber: function(O) {
    return O.asinh();
  } });
}), name$143 = "atan", dependencies$143 = ["typed"], createAtan = factory(name$143, dependencies$143, (D) => {
  var { typed: E } = D;
  return E("atan", { number: function(O) {
    return Math.atan(O);
  }, Complex: function(O) {
    return O.atan();
  }, BigNumber: function(O) {
    return O.atan();
  } });
}), name$142 = "atan2", dependencies$142 = ["typed", "matrix", "equalScalar", "BigNumber", "DenseMatrix", "concat"], createAtan2 = factory(name$142, dependencies$142, (D) => {
  var { typed: E, matrix: O, equalScalar: F, BigNumber: I, DenseMatrix: z, concat: R } = D, L = createMatAlgo02xDS0({ typed: E, equalScalar: F }), q = createMatAlgo03xDSf({ typed: E }), U = createMatAlgo09xS0Sf({ typed: E, equalScalar: F }), Z = createMatAlgo11xS0s({ typed: E, equalScalar: F }), V = createMatAlgo12xSfs({ typed: E, DenseMatrix: z }), G = createMatrixAlgorithmSuite({ typed: E, matrix: O, concat: R });
  return E(name$142, { "number, number": Math.atan2, "BigNumber, BigNumber": (W, J) => I.atan2(W, J) }, G({ scalar: "number | BigNumber", SS: U, DS: q, SD: L, Ss: Z, sS: V }));
}), name$141 = "atanh", dependencies$141 = ["typed", "config", "Complex"], createAtanh = factory(name$141, dependencies$141, (D) => {
  var { typed: E, config: O, Complex: F } = D;
  return E(name$141, { number: function(I) {
    return I <= 1 && I >= -1 || O.predictable ? atanhNumber(I) : new F(I, 0).atanh();
  }, Complex: function(I) {
    return I.atanh();
  }, BigNumber: function(I) {
    return I.atanh();
  } });
}), createTrigUnit = factory("trigUnit", ["typed"], (D) => {
  var { typed: E } = D;
  return { Unit: E.referToSelf((O) => (F) => {
    if (!F.hasBase(F.constructor.BASE_UNITS.ANGLE)) throw TypeError("Unit in function cot is no angle");
    return E.find(O, F.valueType())(F.value);
  }) };
}), name$140 = "cos", dependencies$140 = ["typed"], createCos = factory(name$140, dependencies$140, (D) => {
  var { typed: E } = D, O = createTrigUnit({ typed: E });
  return E(name$140, { number: Math.cos, "Complex | BigNumber": (F) => F.cos() }, O);
}), name$139 = "cosh", dependencies$139 = ["typed"], createCosh = factory(name$139, dependencies$139, (D) => {
  var { typed: E } = D;
  return E(name$139, { number: cosh$3, "Complex | BigNumber": (O) => O.cosh() });
}), name$138 = "cot", dependencies$138 = ["typed", "BigNumber"], createCot = factory(name$138, dependencies$138, (D) => {
  var { typed: E, BigNumber: O } = D, F = createTrigUnit({ typed: E });
  return E(name$138, { number: cotNumber, Complex: (I) => I.cot(), BigNumber: (I) => new O(1).div(I.tan()) }, F);
}), name$137 = "coth", dependencies$137 = ["typed", "BigNumber"], createCoth = factory(name$137, dependencies$137, (D) => {
  var { typed: E, BigNumber: O } = D;
  return E(name$137, { number: cothNumber, Complex: (F) => F.coth(), BigNumber: (F) => new O(1).div(F.tanh()) });
}), name$136 = "csc", dependencies$136 = ["typed", "BigNumber"], createCsc = factory(name$136, dependencies$136, (D) => {
  var { typed: E, BigNumber: O } = D, F = createTrigUnit({ typed: E });
  return E(name$136, { number: cscNumber, Complex: (I) => I.csc(), BigNumber: (I) => new O(1).div(I.sin()) }, F);
}), name$135 = "csch", dependencies$135 = ["typed", "BigNumber"], createCsch = factory(name$135, dependencies$135, (D) => {
  var { typed: E, BigNumber: O } = D;
  return E(name$135, { number: cschNumber, Complex: (F) => F.csch(), BigNumber: (F) => new O(1).div(F.sinh()) });
}), name$134 = "sec", dependencies$134 = ["typed", "BigNumber"], createSec = factory(name$134, dependencies$134, (D) => {
  var { typed: E, BigNumber: O } = D, F = createTrigUnit({ typed: E });
  return E(name$134, { number: secNumber, Complex: (I) => I.sec(), BigNumber: (I) => new O(1).div(I.cos()) }, F);
}), name$133 = "sech", dependencies$133 = ["typed", "BigNumber"], createSech = factory(name$133, dependencies$133, (D) => {
  var { typed: E, BigNumber: O } = D;
  return E(name$133, { number: sechNumber, Complex: (F) => F.sech(), BigNumber: (F) => new O(1).div(F.cosh()) });
}), name$132 = "sin", dependencies$132 = ["typed"], createSin = factory(name$132, dependencies$132, (D) => {
  var { typed: E } = D, O = createTrigUnit({ typed: E });
  return E(name$132, { number: Math.sin, "Complex | BigNumber": (F) => F.sin() }, O);
}), name$131 = "sinh", dependencies$131 = ["typed"], createSinh = factory(name$131, dependencies$131, (D) => {
  var { typed: E } = D;
  return E(name$131, { number: sinhNumber, "Complex | BigNumber": (O) => O.sinh() });
}), name$130 = "tan", dependencies$130 = ["typed"], createTan = factory(name$130, dependencies$130, (D) => {
  var { typed: E } = D, O = createTrigUnit({ typed: E });
  return E(name$130, { number: Math.tan, "Complex | BigNumber": (F) => F.tan() }, O);
}), name$129 = "tanh", dependencies$129 = ["typed"], createTanh = factory(name$129, dependencies$129, (D) => {
  var { typed: E } = D;
  return E("tanh", { number: tanh$2, "Complex | BigNumber": (O) => O.tanh() });
}), name$128 = "setCartesian", dependencies$128 = ["typed", "size", "subset", "compareNatural", "Index", "DenseMatrix"], createSetCartesian = factory(name$128, dependencies$128, (D) => {
  var { typed: E, size: O, subset: F, compareNatural: I, Index: z, DenseMatrix: R } = D;
  return E(name$128, { "Array | Matrix, Array | Matrix": function(L, q) {
    var U = [];
    if (F(O(L), new z(0)) !== 0 && F(O(q), new z(0)) !== 0) {
      var Z = flatten$4(Array.isArray(L) ? L : L.toArray()).sort(I), V = flatten$4(Array.isArray(q) ? q : q.toArray()).sort(I);
      U = [];
      for (var G = 0; G < Z.length; G++) for (var W = 0; W < V.length; W++) U.push([Z[G], V[W]]);
    }
    return Array.isArray(L) && Array.isArray(q) ? U : new R(U);
  } });
}), name$127 = "setDifference", dependencies$127 = ["typed", "size", "subset", "compareNatural", "Index", "DenseMatrix"], createSetDifference = factory(name$127, dependencies$127, (D) => {
  var { typed: E, size: O, subset: F, compareNatural: I, Index: z, DenseMatrix: R } = D;
  return E(name$127, { "Array | Matrix, Array | Matrix": function(L, q) {
    var U;
    if (F(O(L), new z(0)) === 0) U = [];
    else {
      if (F(O(q), new z(0)) === 0) return flatten$4(L.toArray());
      var Z = identify(flatten$4(Array.isArray(L) ? L : L.toArray()).sort(I)), V = identify(flatten$4(Array.isArray(q) ? q : q.toArray()).sort(I));
      U = [];
      for (var G, W = 0; W < Z.length; W++) {
        G = !1;
        for (var J = 0; J < V.length; J++) if (I(Z[W].value, V[J].value) === 0 && Z[W].identifier === V[J].identifier) {
          G = !0;
          break;
        }
        G || U.push(Z[W]);
      }
    }
    return Array.isArray(L) && Array.isArray(q) ? generalize(U) : new R(generalize(U));
  } });
}), name$126 = "setDistinct", dependencies$126 = ["typed", "size", "subset", "compareNatural", "Index", "DenseMatrix"], createSetDistinct = factory(name$126, dependencies$126, (D) => {
  var { typed: E, size: O, subset: F, compareNatural: I, Index: z, DenseMatrix: R } = D;
  return E(name$126, { "Array | Matrix": function(L) {
    var q;
    if (F(O(L), new z(0)) === 0) q = [];
    else {
      var U = flatten$4(Array.isArray(L) ? L : L.toArray()).sort(I);
      q = [], q.push(U[0]);
      for (var Z = 1; Z < U.length; Z++) I(U[Z], U[Z - 1]) !== 0 && q.push(U[Z]);
    }
    return Array.isArray(L) ? q : new R(q);
  } });
}), name$125 = "setIntersect", dependencies$125 = ["typed", "size", "subset", "compareNatural", "Index", "DenseMatrix"], createSetIntersect = factory(name$125, dependencies$125, (D) => {
  var { typed: E, size: O, subset: F, compareNatural: I, Index: z, DenseMatrix: R } = D;
  return E(name$125, { "Array | Matrix, Array | Matrix": function(L, q) {
    var U;
    if (F(O(L), new z(0)) === 0 || F(O(q), new z(0)) === 0) U = [];
    else {
      var Z = identify(flatten$4(Array.isArray(L) ? L : L.toArray()).sort(I)), V = identify(flatten$4(Array.isArray(q) ? q : q.toArray()).sort(I));
      U = [];
      for (var G = 0; G < Z.length; G++) for (var W = 0; W < V.length; W++) if (I(Z[G].value, V[W].value) === 0 && Z[G].identifier === V[W].identifier) {
        U.push(Z[G]);
        break;
      }
    }
    return Array.isArray(L) && Array.isArray(q) ? generalize(U) : new R(generalize(U));
  } });
}), name$124 = "setIsSubset", dependencies$124 = ["typed", "size", "subset", "compareNatural", "Index"], createSetIsSubset = factory(name$124, dependencies$124, (D) => {
  var { typed: E, size: O, subset: F, compareNatural: I, Index: z } = D;
  return E(name$124, { "Array | Matrix, Array | Matrix": function(R, L) {
    if (F(O(R), new z(0)) === 0) return !0;
    if (F(O(L), new z(0)) === 0) return !1;
    for (var q = identify(flatten$4(Array.isArray(R) ? R : R.toArray()).sort(I)), U = identify(flatten$4(Array.isArray(L) ? L : L.toArray()).sort(I)), Z, V = 0; V < q.length; V++) {
      Z = !1;
      for (var G = 0; G < U.length; G++) if (I(q[V].value, U[G].value) === 0 && q[V].identifier === U[G].identifier) {
        Z = !0;
        break;
      }
      if (Z === !1) return !1;
    }
    return !0;
  } });
}), name$123 = "setMultiplicity", dependencies$123 = ["typed", "size", "subset", "compareNatural", "Index"], createSetMultiplicity = factory(name$123, dependencies$123, (D) => {
  var { typed: E, size: O, subset: F, compareNatural: I, Index: z } = D;
  return E(name$123, { "number | BigNumber | Fraction | Complex, Array | Matrix": function(R, L) {
    if (F(O(L), new z(0)) === 0) return 0;
    for (var q = flatten$4(Array.isArray(L) ? L : L.toArray()), U = 0, Z = 0; Z < q.length; Z++) I(q[Z], R) === 0 && U++;
    return U;
  } });
}), name$122 = "setPowerset", dependencies$122 = ["typed", "size", "subset", "compareNatural", "Index"], createSetPowerset = factory(name$122, dependencies$122, (D) => {
  var { typed: E, size: O, subset: F, compareNatural: I, Index: z } = D;
  return E(name$122, { "Array | Matrix": function(q) {
    if (F(O(q), new z(0)) === 0) return [];
    for (var U = flatten$4(Array.isArray(q) ? q : q.toArray()).sort(I), Z = [], V = 0; V.toString(2).length <= U.length; ) Z.push(R(U, V.toString(2).split("").reverse())), V++;
    return L(Z);
  } });
  function R(q, U) {
    for (var Z = [], V = 0; V < U.length; V++) U[V] === "1" && Z.push(q[V]);
    return Z;
  }
  function L(q) {
    for (var U = [], Z = q.length - 1; Z > 0; Z--) for (var V = 0; V < Z; V++) q[V].length > q[V + 1].length && (U = q[V], q[V] = q[V + 1], q[V + 1] = U);
    return q;
  }
}), name$121 = "setSize", dependencies$121 = ["typed", "compareNatural"], createSetSize = factory(name$121, dependencies$121, (D) => {
  var { typed: E, compareNatural: O } = D;
  return E(name$121, { "Array | Matrix": function(F) {
    return Array.isArray(F) ? flatten$4(F).length : flatten$4(F.toArray()).length;
  }, "Array | Matrix, boolean": function(F, I) {
    if (I === !1 || F.length === 0) return Array.isArray(F) ? flatten$4(F).length : flatten$4(F.toArray()).length;
    for (var z = flatten$4(Array.isArray(F) ? F : F.toArray()).sort(O), R = 1, L = 1; L < z.length; L++) O(z[L], z[L - 1]) !== 0 && R++;
    return R;
  } });
}), name$120 = "setSymDifference", dependencies$120 = ["typed", "size", "concat", "subset", "setDifference", "Index"], createSetSymDifference = factory(name$120, dependencies$120, (D) => {
  var { typed: E, size: O, concat: F, subset: I, setDifference: z, Index: R } = D;
  return E(name$120, { "Array | Matrix, Array | Matrix": function(L, q) {
    if (I(O(L), new R(0)) === 0) return flatten$4(q);
    if (I(O(q), new R(0)) === 0) return flatten$4(L);
    var U = flatten$4(L), Z = flatten$4(q);
    return F(z(U, Z), z(Z, U));
  } });
}), name$119 = "setUnion", dependencies$119 = ["typed", "size", "concat", "subset", "setIntersect", "setSymDifference", "Index"], createSetUnion = factory(name$119, dependencies$119, (D) => {
  var { typed: E, size: O, concat: F, subset: I, setIntersect: z, setSymDifference: R, Index: L } = D;
  return E(name$119, { "Array | Matrix, Array | Matrix": function(q, U) {
    if (I(O(q), new L(0)) === 0) return flatten$4(U);
    if (I(O(U), new L(0)) === 0) return flatten$4(q);
    var Z = flatten$4(q), V = flatten$4(U);
    return F(R(Z, V), z(Z, V));
  } });
}), name$118 = "add", dependencies$118 = ["typed", "matrix", "addScalar", "equalScalar", "DenseMatrix", "SparseMatrix", "concat"], createAdd = factory(name$118, dependencies$118, (D) => {
  var { typed: E, matrix: O, addScalar: F, equalScalar: I, DenseMatrix: z, SparseMatrix: R, concat: L } = D, q = createMatAlgo01xDSid({ typed: E }), U = createMatAlgo04xSidSid({ typed: E, equalScalar: I }), Z = createMatAlgo10xSids({ typed: E, DenseMatrix: z }), V = createMatrixAlgorithmSuite({ typed: E, matrix: O, concat: L });
  return E(name$118, { "any, any": F, "any, any, ...any": E.referToSelf((G) => (W, J, X) => {
    for (var Y = G(W, J), ee = 0; ee < X.length; ee++) Y = G(Y, X[ee]);
    return Y;
  }) }, V({ elop: F, DS: q, SS: U, Ss: Z }));
}), name$117 = "hypot", dependencies$117 = ["typed", "abs", "addScalar", "divideScalar", "multiplyScalar", "sqrt", "smaller", "isPositive"], createHypot = factory(name$117, dependencies$117, (D) => {
  var { typed: E, abs: O, addScalar: F, divideScalar: I, multiplyScalar: z, sqrt: R, smaller: L, isPositive: q } = D;
  return E(name$117, { "... number | BigNumber": U, Array: U, Matrix: (Z) => U(flatten$4(Z.toArray(), !0)) });
  function U(Z) {
    for (var V = 0, G = 0, W = 0; W < Z.length; W++) {
      if (isComplex(Z[W])) throw TypeError("Unexpected type of argument to hypot");
      var J = O(Z[W]);
      L(G, J) ? (V = z(V, z(I(G, J), I(G, J))), V = F(V, 1), G = J) : V = F(V, q(J) ? z(I(J, G), I(J, G)) : J);
    }
    return z(G, R(V));
  }
}), name$116 = "norm", dependencies$116 = ["typed", "abs", "add", "pow", "conj", "sqrt", "multiply", "equalScalar", "larger", "smaller", "matrix", "ctranspose", "eigs"], createNorm = factory(name$116, dependencies$116, (D) => {
  var { typed: E, abs: O, add: F, pow: I, conj: z, sqrt: R, multiply: L, equalScalar: q, larger: U, smaller: Z, matrix: V, ctranspose: G, eigs: W } = D;
  return E(name$116, { number: Math.abs, Complex: function(ue) {
    return ue.abs();
  }, BigNumber: function(ue) {
    return ue.abs();
  }, boolean: function(ue) {
    return Math.abs(ue);
  }, Array: function(ue) {
    return ae(V(ue), 2);
  }, Matrix: function(ue) {
    return ae(ue, 2);
  }, "Array, number | BigNumber | string": function(ue, oe) {
    return ae(V(ue), oe);
  }, "Matrix, number | BigNumber | string": function(ue, oe) {
    return ae(ue, oe);
  } });
  function J(ue) {
    var oe = 0;
    return ue.forEach(function(se) {
      var le = O(se);
      U(le, oe) && (oe = le);
    }, !0), oe;
  }
  function X(ue) {
    var oe;
    return ue.forEach(function(se) {
      var le = O(se);
      (!oe || Z(le, oe)) && (oe = le);
    }, !0), oe || 0;
  }
  function Y(ue, oe) {
    if (oe === 1 / 0 || oe === "inf") return J(ue);
    if (oe === -1 / 0 || oe === "-inf") return X(ue);
    if (oe === "fro") return ae(ue, 2);
    if (typeof oe == "number" && !isNaN(oe)) {
      if (!q(oe, 0)) {
        var se = 0;
        return ue.forEach(function(le) {
          se = F(I(O(le), oe), se);
        }, !0), I(se, 1 / oe);
      }
      return 1 / 0;
    }
    throw Error("Unsupported parameter value");
  }
  function ee(ue) {
    var oe = 0;
    return ue.forEach(function(se, le) {
      oe = F(oe, L(se, z(se)));
    }), O(R(oe));
  }
  function K(ue) {
    var oe = [], se = 0;
    return ue.forEach(function(le, ce) {
      var fe = ce[1], pe = F(oe[fe] || 0, O(le));
      U(pe, se) && (se = pe), oe[fe] = pe;
    }, !0), se;
  }
  function te(ue) {
    var oe = ue.size();
    if (oe[0] !== oe[1]) throw RangeError("Invalid matrix dimensions");
    var se = W(L(G(ue), ue)).values.toArray(), le = se[se.length - 1];
    return O(R(le));
  }
  function ie(ue) {
    var oe = [], se = 0;
    return ue.forEach(function(le, ce) {
      var fe = ce[0], pe = F(oe[fe] || 0, O(le));
      U(pe, se) && (se = pe), oe[fe] = pe;
    }, !0), se;
  }
  function ne(ue, oe) {
    if (oe === 1) return K(ue);
    if (oe === 1 / 0 || oe === "inf") return ie(ue);
    if (oe === "fro") return ee(ue);
    if (oe === 2) return te(ue);
    throw Error("Unsupported parameter value " + oe);
  }
  function ae(ue, oe) {
    var se = ue.size();
    if (se.length === 1) return Y(ue, oe);
    if (se.length === 2) {
      if (se[0] && se[1]) return ne(ue, oe);
      throw RangeError("Invalid matrix dimensions");
    }
  }
}), name$115 = "dot", dependencies$115 = ["typed", "addScalar", "multiplyScalar", "conj", "size"], createDot = factory(name$115, dependencies$115, (D) => {
  var { typed: E, addScalar: O, multiplyScalar: F, conj: I, size: z } = D;
  return E(name$115, { "Array | DenseMatrix, Array | DenseMatrix": L, "SparseMatrix, SparseMatrix": q });
  function R(U, Z) {
    var V = z(U), G = z(Z), W, J;
    if (V.length === 1) W = V[0];
    else if (V.length === 2 && V[1] === 1) W = V[0];
    else throw RangeError("Expected a column vector, instead got a matrix of size (" + V.join(", ") + ")");
    if (G.length === 1) J = G[0];
    else if (G.length === 2 && G[1] === 1) J = G[0];
    else throw RangeError("Expected a column vector, instead got a matrix of size (" + G.join(", ") + ")");
    if (W !== J) throw RangeError("Vectors must have equal length (" + W + " != " + J + ")");
    if (W === 0) throw RangeError("Cannot calculate the dot product of empty vectors");
    return W;
  }
  function L(U, Z) {
    var V = R(U, Z), G = isMatrix(U) ? U._data : U, W = isMatrix(U) ? U._datatype || U.getDataType() : void 0, J = isMatrix(Z) ? Z._data : Z, X = isMatrix(Z) ? Z._datatype || Z.getDataType() : void 0, Y = z(U).length === 2, ee = z(Z).length === 2, K = O, te = F;
    if (W && X && W === X && typeof W == "string" && W !== "mixed") {
      var ie = W;
      K = E.find(O, [ie, ie]), te = E.find(F, [ie, ie]);
    }
    if (!Y && !ee) {
      for (var ne = te(I(G[0]), J[0]), ae = 1; ae < V; ae++) ne = K(ne, te(I(G[ae]), J[ae]));
      return ne;
    }
    if (!Y && ee) {
      for (var ue = te(I(G[0]), J[0][0]), oe = 1; oe < V; oe++) ue = K(ue, te(I(G[oe]), J[oe][0]));
      return ue;
    }
    if (Y && !ee) {
      for (var se = te(I(G[0][0]), J[0]), le = 1; le < V; le++) se = K(se, te(I(G[le][0]), J[le]));
      return se;
    }
    if (Y && ee) {
      for (var ce = te(I(G[0][0]), J[0][0]), fe = 1; fe < V; fe++) ce = K(ce, te(I(G[fe][0]), J[fe][0]));
      return ce;
    }
  }
  function q(U, Z) {
    R(U, Z);
    for (var V = U._index, G = U._values, W = Z._index, J = Z._values, X = 0, Y = O, ee = F, K = 0, te = 0; K < V.length && te < W.length; ) {
      var ie = V[K], ne = W[te];
      if (ie < ne) {
        K++;
        continue;
      }
      if (ie > ne) {
        te++;
        continue;
      }
      ie === ne && (X = Y(X, ee(G[K], J[te])), K++, te++);
    }
    return X;
  }
}), name$114 = "trace", dependencies$114 = ["typed", "matrix", "add"], createTrace = factory(name$114, dependencies$114, (D) => {
  var { typed: E, matrix: O, add: F } = D;
  return E("trace", { Array: function(R) {
    return I(O(R));
  }, SparseMatrix: z, DenseMatrix: I, any: clone$3 });
  function I(R) {
    var L = R._size, q = R._data;
    switch (L.length) {
      case 1:
        if (L[0] === 1) return clone$3(q[0]);
        throw RangeError("Matrix must be square (size: " + format(L) + ")");
      case 2:
        var U = L[0];
        if (U === L[1]) {
          for (var Z = 0, V = 0; V < U; V++) Z = F(Z, q[V][V]);
          return Z;
        } else throw RangeError("Matrix must be square (size: " + format(L) + ")");
      default:
        throw RangeError("Matrix must be two dimensional (size: " + format(L) + ")");
    }
  }
  function z(R) {
    var L = R._values, q = R._index, U = R._ptr, Z = R._size, V = Z[0], G = Z[1];
    if (V === G) {
      var W = 0;
      if (L.length > 0) for (var J = 0; J < G; J++) for (var X = U[J], Y = U[J + 1], ee = X; ee < Y; ee++) {
        var K = q[ee];
        if (K === J) {
          W = F(W, L[ee]);
          break;
        }
        if (K > J) break;
      }
      return W;
    }
    throw RangeError("Matrix must be square (size: " + format(Z) + ")");
  }
}), name$113 = "index", dependencies$113 = ["typed", "Index"], createIndex = factory(name$113, dependencies$113, (D) => {
  var { typed: E, Index: O } = D;
  return E(name$113, { "...number | string | BigNumber | Range | Array | Matrix": function(F) {
    var I = F.map(function(R) {
      return isBigNumber(R) ? R.toNumber() : isArray(R) || isMatrix(R) ? R.map(function(L) {
        return isBigNumber(L) ? L.toNumber() : L;
      }) : R;
    }), z = new O();
    return O.apply(z, I), z;
  } });
}), keywords = /* @__PURE__ */ new Set(["end"]), name$112 = "Node", dependencies$112 = ["mathWithTransform"], createNode = factory(name$112, dependencies$112, (D) => {
  var { mathWithTransform: E } = D;
  function O(I) {
    for (var z of [...keywords]) if (I.has(z)) throw Error('Scope contains an illegal symbol, "' + z + '" is a reserved keyword');
  }
  class F {
    get type() {
      return "Node";
    }
    get isNode() {
      return !0;
    }
    evaluate(z) {
      return this.compile().evaluate(z);
    }
    compile() {
      var z = this._compile(E, {}), R = {}, L = null;
      function q(U) {
        var Z = createMap$1(U);
        return O(Z), z(Z, R, L);
      }
      return { evaluate: q };
    }
    _compile(z, R) {
      throw Error("Method _compile must be implemented by type " + this.type);
    }
    forEach(z) {
      throw Error("Cannot run forEach on a Node interface");
    }
    map(z) {
      throw Error("Cannot run map on a Node interface");
    }
    _ifNode(z) {
      if (!isNode(z)) throw TypeError("Callback function must return a Node");
      return z;
    }
    traverse(z) {
      z(this, null, null);
      function R(L, q) {
        L.forEach(function(U, Z, V) {
          q(U, Z, V), R(U, q);
        });
      }
      R(this, z);
    }
    transform(z) {
      function R(L, q, U) {
        var Z = z(L, q, U);
        return Z === L ? L.map(R) : Z;
      }
      return R(this, null, null);
    }
    filter(z) {
      var R = [];
      return this.traverse(function(L, q, U) {
        z(L, q, U) && R.push(L);
      }), R;
    }
    clone() {
      throw Error("Cannot clone a Node interface");
    }
    cloneDeep() {
      return this.map(function(z) {
        return z.cloneDeep();
      });
    }
    equals(z) {
      return z ? this.type === z.type && deepStrictEqual(this, z) : !1;
    }
    toString(z) {
      var R = this._getCustomString(z);
      return R === void 0 ? this._toString(z) : R;
    }
    _toString() {
      throw Error("_toString not implemented for " + this.type);
    }
    toJSON() {
      throw Error("Cannot serialize object: toJSON not implemented by " + this.type);
    }
    toHTML(z) {
      var R = this._getCustomString(z);
      return R === void 0 ? this._toHTML(z) : R;
    }
    _toHTML() {
      throw Error("_toHTML not implemented for " + this.type);
    }
    toTex(z) {
      var R = this._getCustomString(z);
      return R === void 0 ? this._toTex(z) : R;
    }
    _toTex(z) {
      throw Error("_toTex not implemented for " + this.type);
    }
    _getCustomString(z) {
      if (z && typeof z == "object") switch (typeof z.handler) {
        case "object":
        case "undefined":
          return;
        case "function":
          return z.handler(this, z);
        default:
          throw TypeError("Object or function expected as callback");
      }
    }
    getIdentifier() {
      return this.type;
    }
    getContent() {
      return this;
    }
  }
  return F;
}, { isClass: !0, isNode: !0 });
function errorTransform(D) {
  return D && D.isIndexError ? new IndexError(D.index + 1, D.min + 1, D.max === void 0 ? void 0 : D.max + 1) : D;
}
function accessFactory(D) {
  var { subset: E } = D;
  return function(O, F) {
    try {
      if (Array.isArray(O)) return E(O, F);
      if (O && typeof O.subset == "function") return O.subset(F);
      if (typeof O == "string") return E(O, F);
      if (typeof O == "object") {
        if (!F.isObjectProperty()) throw TypeError("Cannot apply a numeric index as object property");
        return getSafeProperty(O, F.getObjectProperty());
      } else throw TypeError("Cannot apply index: unsupported type of object");
    } catch (I) {
      throw errorTransform(I);
    }
  };
}
var name$111 = "AccessorNode", dependencies$111 = ["subset", "Node"], createAccessorNode = factory(name$111, dependencies$111, (D) => {
  var { subset: E, Node: O } = D, F = accessFactory({ subset: E });
  function I(R) {
    return !(isAccessorNode(R) || isArrayNode(R) || isConstantNode(R) || isFunctionNode(R) || isObjectNode(R) || isParenthesisNode(R) || isSymbolNode(R));
  }
  class z extends O {
    constructor(L, q) {
      var U = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
      if (super(), !isNode(L)) throw TypeError('Node expected for parameter "object"');
      if (!isIndexNode(q)) throw TypeError('IndexNode expected for parameter "index"');
      this.object = L, this.index = q, this.optionalChaining = U;
    }
    get name() {
      return this.index ? this.index.isObjectProperty() ? this.index.getObjectProperty() : "" : this.object.name || "";
    }
    get type() {
      return name$111;
    }
    get isAccessorNode() {
      return !0;
    }
    _compile(L, q) {
      var U = this.object._compile(L, q), Z = this.index._compile(L, q), V = this.optionalChaining, G = isAccessorNode(this.object) && this.object.optionalChaining;
      if (this.index.isObjectProperty()) {
        var W = this.index.getObjectProperty();
        return function(J, X, Y) {
          var ee = Y || {}, K = U(J, X, ee);
          if (V && K == null) {
            ee.optionalShortCircuit = !0;
            return;
          }
          if (!(G && ee != null && ee.optionalShortCircuit)) return getSafeProperty(K, W);
        };
      } else return function(J, X, Y) {
        var ee = Y || {}, K = U(J, X, ee);
        if (V && K == null) {
          ee.optionalShortCircuit = !0;
          return;
        }
        if (!(G && ee != null && ee.optionalShortCircuit)) return F(K, Z(J, X, K));
      };
    }
    forEach(L) {
      L(this.object, "object", this), L(this.index, "index", this);
    }
    map(L) {
      return new z(this._ifNode(L(this.object, "object", this)), this._ifNode(L(this.index, "index", this)), this.optionalChaining);
    }
    clone() {
      return new z(this.object, this.index, this.optionalChaining);
    }
    _toString(L) {
      var q = this.object.toString(L);
      I(this.object) && (q = "(" + q + ")");
      var U = this.optionalChaining ? this.index.dotNotation ? "?" : "?." : "";
      return q + U + this.index.toString(L);
    }
    _toHTML(L) {
      var q = this.object.toHTML(L);
      return I(this.object) && (q = '<span class="math-parenthesis math-round-parenthesis">(</span>' + q + '<span class="math-parenthesis math-round-parenthesis">)</span>'), q + this.index.toHTML(L);
    }
    _toTex(L) {
      var q = this.object.toTex(L);
      return I(this.object) && (q = "\\left(' + object + '\\right)"), q + this.index.toTex(L);
    }
    toJSON() {
      return { mathjs: name$111, object: this.object, index: this.index, optionalChaining: this.optionalChaining };
    }
    static fromJSON(L) {
      return new z(L.object, L.index, L.optionalChaining);
    }
  }
  return _defineProperty(z, "name", name$111), z;
}, { isClass: !0, isNode: !0 }), name$110 = "ArrayNode", dependencies$110 = ["Node"], createArrayNode = factory(name$110, dependencies$110, (D) => {
  var { Node: E } = D;
  class O extends E {
    constructor(I) {
      if (super(), this.items = I || [], !Array.isArray(this.items) || !this.items.every(isNode)) throw TypeError("Array containing Nodes expected");
    }
    get type() {
      return name$110;
    }
    get isArrayNode() {
      return !0;
    }
    _compile(I, z) {
      var R = map$1(this.items, function(q) {
        return q._compile(I, z);
      });
      if (I.config.matrix !== "Array") {
        var L = I.matrix;
        return function(q, U, Z) {
          return L(map$1(R, function(V) {
            return V(q, U, Z);
          }));
        };
      } else return function(q, U, Z) {
        return map$1(R, function(V) {
          return V(q, U, Z);
        });
      };
    }
    forEach(I) {
      for (var z = 0; z < this.items.length; z++) {
        var R = this.items[z];
        I(R, "items[" + z + "]", this);
      }
    }
    map(I) {
      for (var z = [], R = 0; R < this.items.length; R++) z[R] = this._ifNode(I(this.items[R], "items[" + R + "]", this));
      return new O(z);
    }
    clone() {
      return new O(this.items.slice(0));
    }
    _toString(I) {
      return "[" + this.items.map(function(z) {
        return z.toString(I);
      }).join(", ") + "]";
    }
    toJSON() {
      return { mathjs: name$110, items: this.items };
    }
    static fromJSON(I) {
      return new O(I.items);
    }
    _toHTML(I) {
      return '<span class="math-parenthesis math-square-parenthesis">[</span>' + this.items.map(function(z) {
        return z.toHTML(I);
      }).join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-square-parenthesis">]</span>';
    }
    _toTex(I) {
      function z(R, L) {
        var q = R.some(isArrayNode) && !R.every(isArrayNode), U = L || q, Z = U ? "&" : "\\\\", V = R.map(function(G) {
          return G.items ? z(G.items, !L) : G.toTex(I);
        }).join(Z);
        return q || !U || U && !L ? "\\begin{bmatrix}" + V + "\\end{bmatrix}" : V;
      }
      return z(this.items, !1);
    }
  }
  return _defineProperty(O, "name", name$110), O;
}, { isClass: !0, isNode: !0 });
function assignFactory(D) {
  var { subset: E, matrix: O } = D;
  return function(F, I, z) {
    try {
      if (Array.isArray(F)) return O(F).subset(I, z).valueOf().forEach((R, L) => {
        F[L] = R;
      }), F;
      if (F && typeof F.subset == "function") return F.subset(I, z);
      if (typeof F == "string") return E(F, I, z);
      if (typeof F == "object") {
        if (!I.isObjectProperty()) throw TypeError("Cannot apply a numeric index as object property");
        return setSafeProperty(F, I.getObjectProperty(), z), F;
      } else throw TypeError("Cannot apply index: unsupported type of object");
    } catch (R) {
      throw errorTransform(R);
    }
  };
}
var properties = [{ AssignmentNode: {}, FunctionAssignmentNode: {} }, { ConditionalNode: { latexLeftParens: !1, latexRightParens: !1, latexParens: !1 } }, { "OperatorNode:or": { op: "or", associativity: "left", associativeWith: [] } }, { "OperatorNode:xor": { op: "xor", associativity: "left", associativeWith: [] } }, { "OperatorNode:and": { op: "and", associativity: "left", associativeWith: [] } }, { "OperatorNode:bitOr": { op: "|", associativity: "left", associativeWith: [] } }, { "OperatorNode:bitXor": { op: "^|", associativity: "left", associativeWith: [] } }, { "OperatorNode:bitAnd": { op: "&", associativity: "left", associativeWith: [] } }, { "OperatorNode:equal": { op: "==", associativity: "left", associativeWith: [] }, "OperatorNode:unequal": { op: "!=", associativity: "left", associativeWith: [] }, "OperatorNode:smaller": { op: "<", associativity: "left", associativeWith: [] }, "OperatorNode:larger": { op: ">", associativity: "left", associativeWith: [] }, "OperatorNode:smallerEq": { op: "<=", associativity: "left", associativeWith: [] }, "OperatorNode:largerEq": { op: ">=", associativity: "left", associativeWith: [] }, RelationalNode: { associativity: "left", associativeWith: [] } }, { "OperatorNode:leftShift": { op: "<<", associativity: "left", associativeWith: [] }, "OperatorNode:rightArithShift": { op: ">>", associativity: "left", associativeWith: [] }, "OperatorNode:rightLogShift": { op: ">>>", associativity: "left", associativeWith: [] } }, { "OperatorNode:to": { op: "to", associativity: "left", associativeWith: [] } }, { RangeNode: {} }, { "OperatorNode:add": { op: "+", associativity: "left", associativeWith: ["OperatorNode:add", "OperatorNode:subtract"] }, "OperatorNode:subtract": { op: "-", associativity: "left", associativeWith: [] } }, { "OperatorNode:multiply": { op: "*", associativity: "left", associativeWith: ["OperatorNode:multiply", "OperatorNode:divide", "Operator:dotMultiply", "Operator:dotDivide"] }, "OperatorNode:divide": { op: "/", associativity: "left", associativeWith: [], latexLeftParens: !1, latexRightParens: !1, latexParens: !1 }, "OperatorNode:dotMultiply": { op: ".*", associativity: "left", associativeWith: ["OperatorNode:multiply", "OperatorNode:divide", "OperatorNode:dotMultiply", "OperatorNode:doDivide"] }, "OperatorNode:dotDivide": { op: "./", associativity: "left", associativeWith: [] }, "OperatorNode:mod": { op: "mod", associativity: "left", associativeWith: [] } }, { "OperatorNode:multiply": { associativity: "left", associativeWith: ["OperatorNode:multiply", "OperatorNode:divide", "Operator:dotMultiply", "Operator:dotDivide"] } }, { "OperatorNode:unaryPlus": { op: "+", associativity: "right" }, "OperatorNode:unaryMinus": { op: "-", associativity: "right" }, "OperatorNode:bitNot": { op: "~", associativity: "right" }, "OperatorNode:not": { op: "not", associativity: "right" } }, { "OperatorNode:pow": { op: "^", associativity: "right", associativeWith: [], latexRightParens: !1 }, "OperatorNode:dotPow": { op: ".^", associativity: "right", associativeWith: [] } }, { "OperatorNode:nullish": { op: "??", associativity: "left", associativeWith: [] } }, { "OperatorNode:factorial": { op: "!", associativity: "left" } }, { "OperatorNode:ctranspose": { op: "'", associativity: "left" } }];
function unwrapParen(D, E) {
  if (!E || E !== "auto") return D;
  for (var O = D; isParenthesisNode(O); ) O = O.content;
  return O;
}
function getPrecedence(D, E, O, F) {
  var I = D;
  E !== "keep" && (I = D.getContent());
  for (var z = I.getIdentifier(), R = null, L = 0; L < properties.length; L++) if (z in properties[L]) {
    R = L;
    break;
  }
  if (z === "OperatorNode:multiply" && I.implicit && O !== "show") {
    var q = unwrapParen(I.args[0], E);
    !(isConstantNode(q) && F && F.getIdentifier() === "OperatorNode:divide" && rule2Node(unwrapParen(F.args[0], E))) && !(q.getIdentifier() === "OperatorNode:divide" && rule2Node(unwrapParen(q.args[0], E)) && isConstantNode(unwrapParen(q.args[1]))) && (R += 1);
  }
  return R;
}
function getAssociativity(D, E) {
  var O = D;
  E !== "keep" && (O = D.getContent());
  var F = O.getIdentifier(), I = getPrecedence(O, E);
  if (I === null) return null;
  var z = properties[I][F];
  if (hasOwnProperty$1(z, "associativity")) {
    if (z.associativity === "left") return "left";
    if (z.associativity === "right") return "right";
    throw Error("'" + F + "' has the invalid associativity '" + z.associativity + "'.");
  }
  return null;
}
function isAssociativeWith(D, E, O) {
  var F = O === "keep" ? D : D.getContent(), I = O === "keep" ? E : D.getContent(), z = F.getIdentifier(), R = I.getIdentifier(), L = getPrecedence(F, O);
  if (L === null) return null;
  var q = properties[L][z];
  if (hasOwnProperty$1(q, "associativeWith") && q.associativeWith instanceof Array) {
    for (var U = 0; U < q.associativeWith.length; U++) if (q.associativeWith[U] === R) return !0;
    return !1;
  }
  return null;
}
function getOperator(D) {
  var E = "OperatorNode:" + D;
  for (var O of properties) if (E in O) return O[E].op;
  return null;
}
var name$109 = "AssignmentNode", dependencies$109 = ["subset", "?matrix", "Node"], createAssignmentNode = factory(name$109, dependencies$109, (D) => {
  var { subset: E, matrix: O, Node: F } = D, I = accessFactory({ subset: E }), z = assignFactory({ subset: E, matrix: O });
  function R(q, U, Z) {
    U ||= "keep";
    var V = getPrecedence(q, U, Z), G = getPrecedence(q.value, U, Z);
    return U === "all" || G !== null && G <= V;
  }
  class L extends F {
    constructor(U, Z, V) {
      if (super(), this.object = U, this.index = V ? Z : null, this.value = V || Z, !isSymbolNode(U) && !isAccessorNode(U)) throw TypeError('SymbolNode or AccessorNode expected as "object"');
      if (isSymbolNode(U) && U.name === "end") throw Error('Cannot assign to symbol "end"');
      if (this.index && !isIndexNode(this.index)) throw TypeError('IndexNode expected as "index"');
      if (!isNode(this.value)) throw TypeError('Node expected as "value"');
    }
    get name() {
      return this.index ? this.index.isObjectProperty() ? this.index.getObjectProperty() : "" : this.object.name || "";
    }
    get type() {
      return name$109;
    }
    get isAssignmentNode() {
      return !0;
    }
    _compile(U, Z) {
      var V = this.object._compile(U, Z), G = this.index ? this.index._compile(U, Z) : null, W = this.value._compile(U, Z), J = this.object.name;
      if (this.index)
        if (this.index.isObjectProperty()) {
          var X = this.index.getObjectProperty();
          return function(te, ie, ne) {
            var ae = V(te, ie, ne), ue = W(te, ie, ne);
            return setSafeProperty(ae, X, ue), ue;
          };
        } else {
          if (isSymbolNode(this.object)) return function(te, ie, ne) {
            var ae = V(te, ie, ne), ue = W(te, ie, ne), oe = G(te, ie, ae);
            return te.set(J, z(ae, oe, ue)), ue;
          };
          var Y = this.object.object._compile(U, Z);
          if (this.object.index.isObjectProperty()) {
            var ee = this.object.index.getObjectProperty();
            return function(te, ie, ne) {
              var ae = Y(te, ie, ne), ue = getSafeProperty(ae, ee), oe = G(te, ie, ue), se = W(te, ie, ne);
              return setSafeProperty(ae, ee, z(ue, oe, se)), se;
            };
          } else {
            var K = this.object.index._compile(U, Z);
            return function(te, ie, ne) {
              var ae = Y(te, ie, ne), ue = K(te, ie, ae), oe = I(ae, ue), se = G(te, ie, oe), le = W(te, ie, ne);
              return z(ae, ue, z(oe, se, le)), le;
            };
          }
        }
      else {
        if (!isSymbolNode(this.object)) throw TypeError("SymbolNode expected as object");
        return function(te, ie, ne) {
          var ae = W(te, ie, ne);
          return te.set(J, ae), ae;
        };
      }
    }
    forEach(U) {
      U(this.object, "object", this), this.index && U(this.index, "index", this), U(this.value, "value", this);
    }
    map(U) {
      return new L(this._ifNode(U(this.object, "object", this)), this.index ? this._ifNode(U(this.index, "index", this)) : null, this._ifNode(U(this.value, "value", this)));
    }
    clone() {
      return new L(this.object, this.index, this.value);
    }
    _toString(U) {
      var Z = this.object.toString(U), V = this.index ? this.index.toString(U) : "", G = this.value.toString(U);
      return R(this, U && U.parenthesis, U && U.implicit) && (G = "(" + G + ")"), Z + V + " = " + G;
    }
    toJSON() {
      return { mathjs: name$109, object: this.object, index: this.index, value: this.value };
    }
    static fromJSON(U) {
      return new L(U.object, U.index, U.value);
    }
    _toHTML(U) {
      var Z = this.object.toHTML(U), V = this.index ? this.index.toHTML(U) : "", G = this.value.toHTML(U);
      return R(this, U && U.parenthesis, U && U.implicit) && (G = '<span class="math-paranthesis math-round-parenthesis">(</span>' + G + '<span class="math-paranthesis math-round-parenthesis">)</span>'), Z + V + '<span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>' + G;
    }
    _toTex(U) {
      var Z = this.object.toTex(U), V = this.index ? this.index.toTex(U) : "", G = this.value.toTex(U);
      return R(this, U && U.parenthesis, U && U.implicit) && (G = `\\left(${G}\\right)`), Z + V + "=" + G;
    }
  }
  return _defineProperty(L, "name", name$109), L;
}, { isClass: !0, isNode: !0 }), name$108 = "BlockNode", dependencies$108 = ["ResultSet", "Node"], createBlockNode = factory(name$108, dependencies$108, (D) => {
  var { ResultSet: E, Node: O } = D;
  class F extends O {
    constructor(z) {
      if (super(), !Array.isArray(z)) throw Error("Array expected");
      this.blocks = z.map(function(R) {
        var L = R && R.node, q = R && R.visible !== void 0 ? R.visible : !0;
        if (!isNode(L)) throw TypeError('Property "node" must be a Node');
        if (typeof q != "boolean") throw TypeError('Property "visible" must be a boolean');
        return { node: L, visible: q };
      });
    }
    get type() {
      return name$108;
    }
    get isBlockNode() {
      return !0;
    }
    _compile(z, R) {
      var L = map$1(this.blocks, function(q) {
        return { evaluate: q.node._compile(z, R), visible: q.visible };
      });
      return function(q, U, Z) {
        var V = [];
        return forEach(L, function(G) {
          var W = G.evaluate(q, U, Z);
          G.visible && V.push(W);
        }), new E(V);
      };
    }
    forEach(z) {
      for (var R = 0; R < this.blocks.length; R++) z(this.blocks[R].node, "blocks[" + R + "].node", this);
    }
    map(z) {
      for (var R = [], L = 0; L < this.blocks.length; L++) {
        var q = this.blocks[L];
        R[L] = { node: this._ifNode(z(q.node, "blocks[" + L + "].node", this)), visible: q.visible };
      }
      return new F(R);
    }
    clone() {
      return new F(this.blocks.map(function(z) {
        return { node: z.node, visible: z.visible };
      }));
    }
    _toString(z) {
      return this.blocks.map(function(R) {
        return R.node.toString(z) + (R.visible ? "" : ";");
      }).join(`
`);
    }
    toJSON() {
      return { mathjs: name$108, blocks: this.blocks };
    }
    static fromJSON(z) {
      return new F(z.blocks);
    }
    _toHTML(z) {
      return this.blocks.map(function(R) {
        return R.node.toHTML(z) + (R.visible ? "" : '<span class="math-separator">;</span>');
      }).join('<span class="math-separator"><br /></span>');
    }
    _toTex(z) {
      return this.blocks.map(function(R) {
        return R.node.toTex(z) + (R.visible ? "" : ";");
      }).join(`\\;\\;
`);
    }
  }
  return _defineProperty(F, "name", name$108), F;
}, { isClass: !0, isNode: !0 }), name$107 = "ConditionalNode", dependencies$107 = ["Node"], createConditionalNode = factory(name$107, dependencies$107, (D) => {
  var { Node: E } = D;
  function O(I) {
    if (typeof I == "number" || typeof I == "boolean" || typeof I == "string") return !!I;
    if (I) {
      if (isBigNumber(I)) return !I.isZero();
      if (isComplex(I)) return !!(I.re || I.im);
      if (isUnit(I)) return !!I.value;
    }
    if (I == null) return !1;
    throw TypeError('Unsupported type of condition "' + typeOf(I) + '"');
  }
  class F extends E {
    constructor(z, R, L) {
      if (super(), !isNode(z)) throw TypeError("Parameter condition must be a Node");
      if (!isNode(R)) throw TypeError("Parameter trueExpr must be a Node");
      if (!isNode(L)) throw TypeError("Parameter falseExpr must be a Node");
      this.condition = z, this.trueExpr = R, this.falseExpr = L;
    }
    get type() {
      return name$107;
    }
    get isConditionalNode() {
      return !0;
    }
    _compile(z, R) {
      var L = this.condition._compile(z, R), q = this.trueExpr._compile(z, R), U = this.falseExpr._compile(z, R);
      return function(Z, V, G) {
        return O(L(Z, V, G)) ? q(Z, V, G) : U(Z, V, G);
      };
    }
    forEach(z) {
      z(this.condition, "condition", this), z(this.trueExpr, "trueExpr", this), z(this.falseExpr, "falseExpr", this);
    }
    map(z) {
      return new F(this._ifNode(z(this.condition, "condition", this)), this._ifNode(z(this.trueExpr, "trueExpr", this)), this._ifNode(z(this.falseExpr, "falseExpr", this)));
    }
    clone() {
      return new F(this.condition, this.trueExpr, this.falseExpr);
    }
    _toString(z) {
      var R = z && z.parenthesis ? z.parenthesis : "keep", L = getPrecedence(this, R, z && z.implicit), q = this.condition.toString(z), U = getPrecedence(this.condition, R, z && z.implicit);
      (R === "all" || this.condition.type === "OperatorNode" || U !== null && U <= L) && (q = "(" + q + ")");
      var Z = this.trueExpr.toString(z), V = getPrecedence(this.trueExpr, R, z && z.implicit);
      (R === "all" || this.trueExpr.type === "OperatorNode" || V !== null && V <= L) && (Z = "(" + Z + ")");
      var G = this.falseExpr.toString(z), W = getPrecedence(this.falseExpr, R, z && z.implicit);
      return (R === "all" || this.falseExpr.type === "OperatorNode" || W !== null && W <= L) && (G = "(" + G + ")"), q + " ? " + Z + " : " + G;
    }
    toJSON() {
      return { mathjs: name$107, condition: this.condition, trueExpr: this.trueExpr, falseExpr: this.falseExpr };
    }
    static fromJSON(z) {
      return new F(z.condition, z.trueExpr, z.falseExpr);
    }
    _toHTML(z) {
      var R = z && z.parenthesis ? z.parenthesis : "keep", L = getPrecedence(this, R, z && z.implicit), q = this.condition.toHTML(z), U = getPrecedence(this.condition, R, z && z.implicit);
      (R === "all" || this.condition.type === "OperatorNode" || U !== null && U <= L) && (q = '<span class="math-parenthesis math-round-parenthesis">(</span>' + q + '<span class="math-parenthesis math-round-parenthesis">)</span>');
      var Z = this.trueExpr.toHTML(z), V = getPrecedence(this.trueExpr, R, z && z.implicit);
      (R === "all" || this.trueExpr.type === "OperatorNode" || V !== null && V <= L) && (Z = '<span class="math-parenthesis math-round-parenthesis">(</span>' + Z + '<span class="math-parenthesis math-round-parenthesis">)</span>');
      var G = this.falseExpr.toHTML(z), W = getPrecedence(this.falseExpr, R, z && z.implicit);
      return (R === "all" || this.falseExpr.type === "OperatorNode" || W !== null && W <= L) && (G = '<span class="math-parenthesis math-round-parenthesis">(</span>' + G + '<span class="math-parenthesis math-round-parenthesis">)</span>'), q + '<span class="math-operator math-conditional-operator">?</span>' + Z + '<span class="math-operator math-conditional-operator">:</span>' + G;
    }
    _toTex(z) {
      return "\\begin{cases} {" + this.trueExpr.toTex(z) + "}, &\\quad{\\text{if }\\;" + this.condition.toTex(z) + "}\\\\{" + this.falseExpr.toTex(z) + "}, &\\quad{\\text{otherwise}}\\end{cases}";
    }
  }
  return _defineProperty(F, "name", name$107), F;
}, { isClass: !0, isNode: !0 }), require_dist = __commonJSMin(((D, E) => {
  var O = Object.assign || function(R) {
    for (var L = 1; L < arguments.length; L++) {
      var q = arguments[L];
      for (var U in q) Object.prototype.hasOwnProperty.call(q, U) && (R[U] = q[U]);
    }
    return R;
  }, F = { "{": "\\{", "}": "\\}", "\\": "\\textbackslash{}", "#": "\\#", $: "\\$", "%": "\\%", "&": "\\&", "^": "\\textasciicircum{}", _: "\\_", "~": "\\textasciitilde{}" }, I = { "–": "\\--", "—": "\\---", " ": "~", "	": "\\qquad{}", "\r\n": "\\newline{}", "\n": "\\newline{}" }, z = function(R, L) {
    return O({}, R, L);
  };
  E.exports = function(R) {
    for (var L = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, q = L.preserveFormatting, U = q === void 0 ? !1 : q, Z = L.escapeMapFn, V = Z === void 0 ? z : Z, G = String(R), W = "", J = V(O({}, F), U ? O({}, I) : {}), X = Object.keys(J), Y = function() {
      var ee = !1;
      X.forEach(function(K, te) {
        ee || G.length >= K.length && G.slice(0, K.length) === K && (W += J[X[te]], G = G.slice(K.length, G.length), ee = !0);
      }), ee || (W += G.slice(0, 1), G = G.slice(1, G.length));
    }; G; ) Y();
    return W;
  };
})), import_dist = __toESM(require_dist()), latexSymbols = { Alpha: "A", alpha: "\\alpha", Beta: "B", beta: "\\beta", Gamma: "\\Gamma", gamma: "\\gamma", Delta: "\\Delta", delta: "\\delta", Epsilon: "E", epsilon: "\\epsilon", varepsilon: "\\varepsilon", Zeta: "Z", zeta: "\\zeta", Eta: "H", eta: "\\eta", Theta: "\\Theta", theta: "\\theta", vartheta: "\\vartheta", Iota: "I", iota: "\\iota", Kappa: "K", kappa: "\\kappa", varkappa: "\\varkappa", Lambda: "\\Lambda", lambda: "\\lambda", Mu: "M", mu: "\\mu", Nu: "N", nu: "\\nu", Xi: "\\Xi", xi: "\\xi", Omicron: "O", omicron: "o", Pi: "\\Pi", pi: "\\pi", varpi: "\\varpi", Rho: "P", rho: "\\rho", varrho: "\\varrho", Sigma: "\\Sigma", sigma: "\\sigma", varsigma: "\\varsigma", Tau: "T", tau: "\\tau", Upsilon: "\\Upsilon", upsilon: "\\upsilon", Phi: "\\Phi", phi: "\\phi", varphi: "\\varphi", Chi: "X", chi: "\\chi", Psi: "\\Psi", psi: "\\psi", Omega: "\\Omega", omega: "\\omega", true: "\\mathrm{True}", false: "\\mathrm{False}", i: "i", inf: "\\infty", Inf: "\\infty", infinity: "\\infty", Infinity: "\\infty", oo: "\\infty", lim: "\\lim", undefined: "\\mathbf{?}" }, latexOperators = { transpose: "^\\top", ctranspose: "^H", factorial: "!", pow: "^", dotPow: ".^\\wedge", unaryPlus: "+", unaryMinus: "-", bitNot: "\\~", not: "\\neg", multiply: "\\cdot", divide: "\\frac", dotMultiply: ".\\cdot", dotDivide: ".:", mod: "\\mod", add: "+", subtract: "-", to: "\\rightarrow", leftShift: "<<", rightArithShift: ">>", rightLogShift: ">>>", equal: "=", unequal: "\\neq", smaller: "<", larger: ">", smallerEq: "\\leq", largerEq: "\\geq", bitAnd: "\\&", bitXor: "\\underline{|}", bitOr: "|", and: "\\wedge", xor: "\\veebar", or: "\\vee" }, latexFunctions = { abs: { 1: "\\left|${args[0]}\\right|" }, add: { 2: `\\left(\${args[0]}${latexOperators.add}\${args[1]}\\right)` }, cbrt: { 1: "\\sqrt[3]{${args[0]}}" }, ceil: { 1: "\\left\\lceil${args[0]}\\right\\rceil" }, cube: { 1: "\\left(${args[0]}\\right)^3" }, divide: { 2: "\\frac{${args[0]}}{${args[1]}}" }, dotDivide: { 2: `\\left(\${args[0]}${latexOperators.dotDivide}\${args[1]}\\right)` }, dotMultiply: { 2: `\\left(\${args[0]}${latexOperators.dotMultiply}\${args[1]}\\right)` }, dotPow: { 2: `\\left(\${args[0]}${latexOperators.dotPow}\${args[1]}\\right)` }, exp: { 1: "\\exp\\left(${args[0]}\\right)" }, expm1: `\\left(e${latexOperators.pow}{\${args[0]}}-1\\right)`, fix: { 1: "\\mathrm{${name}}\\left(${args[0]}\\right)" }, floor: { 1: "\\left\\lfloor${args[0]}\\right\\rfloor" }, fraction: { 2: "\\frac{${args[0]}}{${args[1]}}" }, gcd: "\\gcd\\left(${args}\\right)", hypot: "\\hypot\\left(${args}\\right)", log: { 1: "\\ln\\left(${args[0]}\\right)", 2: "\\log_{${args[1]}}\\left(${args[0]}\\right)" }, log10: { 1: "\\log_{10}\\left(${args[0]}\\right)" }, log1p: { 1: "\\ln\\left(${args[0]}+1\\right)", 2: "\\log_{${args[1]}}\\left(${args[0]}+1\\right)" }, log2: "\\log_{2}\\left(${args[0]}\\right)", mod: { 2: `\\left(\${args[0]}${latexOperators.mod}\${args[1]}\\right)` }, multiply: { 2: `\\left(\${args[0]}${latexOperators.multiply}\${args[1]}\\right)` }, norm: { 1: "\\left\\|${args[0]}\\right\\|", 2: void 0 }, nthRoot: { 2: "\\sqrt[${args[1]}]{${args[0]}}" }, nthRoots: { 2: "\\{y : y^${args[1]} = {${args[0]}}\\}" }, pow: { 2: `\\left(\${args[0]}\\right)${latexOperators.pow}{\${args[1]}}` }, round: { 1: "\\left\\lfloor${args[0]}\\right\\rceil", 2: void 0 }, sign: { 1: "\\mathrm{${name}}\\left(${args[0]}\\right)" }, sqrt: { 1: "\\sqrt{${args[0]}}" }, square: { 1: "\\left(${args[0]}\\right)^2" }, subtract: { 2: `\\left(\${args[0]}${latexOperators.subtract}\${args[1]}\\right)` }, unaryMinus: { 1: `${latexOperators.unaryMinus}\\left(\${args[0]}\\right)` }, unaryPlus: { 1: `${latexOperators.unaryPlus}\\left(\${args[0]}\\right)` }, bitAnd: { 2: `\\left(\${args[0]}${latexOperators.bitAnd}\${args[1]}\\right)` }, bitNot: { 1: latexOperators.bitNot + "\\left(${args[0]}\\right)" }, bitOr: { 2: `\\left(\${args[0]}${latexOperators.bitOr}\${args[1]}\\right)` }, bitXor: { 2: `\\left(\${args[0]}${latexOperators.bitXor}\${args[1]}\\right)` }, leftShift: { 2: `\\left(\${args[0]}${latexOperators.leftShift}\${args[1]}\\right)` }, rightArithShift: { 2: `\\left(\${args[0]}${latexOperators.rightArithShift}\${args[1]}\\right)` }, rightLogShift: { 2: `\\left(\${args[0]}${latexOperators.rightLogShift}\${args[1]}\\right)` }, bellNumbers: { 1: "\\mathrm{B}_{${args[0]}}" }, catalan: { 1: "\\mathrm{C}_{${args[0]}}" }, stirlingS2: { 2: "\\mathrm{S}\\left(${args}\\right)" }, arg: { 1: "\\arg\\left(${args[0]}\\right)" }, conj: { 1: "\\left(${args[0]}\\right)^*" }, im: { 1: "\\Im\\left\\lbrace${args[0]}\\right\\rbrace" }, re: { 1: "\\Re\\left\\lbrace${args[0]}\\right\\rbrace" }, and: { 2: `\\left(\${args[0]}${latexOperators.and}\${args[1]}\\right)` }, not: { 1: latexOperators.not + "\\left(${args[0]}\\right)" }, or: { 2: `\\left(\${args[0]}${latexOperators.or}\${args[1]}\\right)` }, xor: { 2: `\\left(\${args[0]}${latexOperators.xor}\${args[1]}\\right)` }, cross: { 2: "\\left(${args[0]}\\right)\\times\\left(${args[1]}\\right)" }, ctranspose: { 1: `\\left(\${args[0]}\\right)${latexOperators.ctranspose}` }, det: { 1: "\\det\\left(${args[0]}\\right)" }, dot: { 2: "\\left(${args[0]}\\cdot${args[1]}\\right)" }, expm: { 1: "\\exp\\left(${args[0]}\\right)" }, inv: { 1: "\\left(${args[0]}\\right)^{-1}" }, pinv: { 1: "\\left(${args[0]}\\right)^{+}" }, sqrtm: { 1: `{\${args[0]}}${latexOperators.pow}{\\frac{1}{2}}` }, trace: { 1: "\\mathrm{tr}\\left(${args[0]}\\right)" }, transpose: { 1: `\\left(\${args[0]}\\right)${latexOperators.transpose}` }, combinations: { 2: "\\binom{${args[0]}}{${args[1]}}" }, combinationsWithRep: { 2: "\\left(\\!\\!{\\binom{${args[0]}}{${args[1]}}}\\!\\!\\right)" }, factorial: { 1: `\\left(\${args[0]}\\right)${latexOperators.factorial}` }, gamma: { 1: "\\Gamma\\left(${args[0]}\\right)" }, lgamma: { 1: "\\ln\\Gamma\\left(${args[0]}\\right)" }, equal: { 2: `\\left(\${args[0]}${latexOperators.equal}\${args[1]}\\right)` }, larger: { 2: `\\left(\${args[0]}${latexOperators.larger}\${args[1]}\\right)` }, largerEq: { 2: `\\left(\${args[0]}${latexOperators.largerEq}\${args[1]}\\right)` }, smaller: { 2: `\\left(\${args[0]}${latexOperators.smaller}\${args[1]}\\right)` }, smallerEq: { 2: `\\left(\${args[0]}${latexOperators.smallerEq}\${args[1]}\\right)` }, unequal: { 2: `\\left(\${args[0]}${latexOperators.unequal}\${args[1]}\\right)` }, erf: { 1: "erf\\left(${args[0]}\\right)" }, max: "\\max\\left(${args}\\right)", min: "\\min\\left(${args}\\right)", variance: "\\mathrm{Var}\\left(${args}\\right)", acos: { 1: "\\cos^{-1}\\left(${args[0]}\\right)" }, acosh: { 1: "\\cosh^{-1}\\left(${args[0]}\\right)" }, acot: { 1: "\\cot^{-1}\\left(${args[0]}\\right)" }, acoth: { 1: "\\coth^{-1}\\left(${args[0]}\\right)" }, acsc: { 1: "\\csc^{-1}\\left(${args[0]}\\right)" }, acsch: { 1: "\\mathrm{csch}^{-1}\\left(${args[0]}\\right)" }, asec: { 1: "\\sec^{-1}\\left(${args[0]}\\right)" }, asech: { 1: "\\mathrm{sech}^{-1}\\left(${args[0]}\\right)" }, asin: { 1: "\\sin^{-1}\\left(${args[0]}\\right)" }, asinh: { 1: "\\sinh^{-1}\\left(${args[0]}\\right)" }, atan: { 1: "\\tan^{-1}\\left(${args[0]}\\right)" }, atan2: { 2: "\\mathrm{atan2}\\left(${args}\\right)" }, atanh: { 1: "\\tanh^{-1}\\left(${args[0]}\\right)" }, cos: { 1: "\\cos\\left(${args[0]}\\right)" }, cosh: { 1: "\\cosh\\left(${args[0]}\\right)" }, cot: { 1: "\\cot\\left(${args[0]}\\right)" }, coth: { 1: "\\coth\\left(${args[0]}\\right)" }, csc: { 1: "\\csc\\left(${args[0]}\\right)" }, csch: { 1: "\\mathrm{csch}\\left(${args[0]}\\right)" }, sec: { 1: "\\sec\\left(${args[0]}\\right)" }, sech: { 1: "\\mathrm{sech}\\left(${args[0]}\\right)" }, sin: { 1: "\\sin\\left(${args[0]}\\right)" }, sinh: { 1: "\\sinh\\left(${args[0]}\\right)" }, tan: { 1: "\\tan\\left(${args[0]}\\right)" }, tanh: { 1: "\\tanh\\left(${args[0]}\\right)" }, to: { 2: `\\left(\${args[0]}${latexOperators.to}\${args[1]}\\right)` }, numeric: function(D, E) {
  return D.args[0].toTex();
}, number: { 0: "0", 1: "\\left(${args[0]}\\right)", 2: "\\left(\\left(${args[0]}\\right)${args[1]}\\right)" }, string: { 0: '\\mathtt{""}', 1: "\\mathrm{string}\\left(${args[0]}\\right)" }, bignumber: { 0: "0", 1: "\\left(${args[0]}\\right)" }, bigint: { 0: "0", 1: "\\left(${args[0]}\\right)" }, complex: { 0: "0", 1: "\\left(${args[0]}\\right)", 2: `\\left(\\left(\${args[0]}\\right)+${latexSymbols.i}\\cdot\\left(\${args[1]}\\right)\\right)` }, matrix: { 0: "\\begin{bmatrix}\\end{bmatrix}", 1: "\\left(${args[0]}\\right)", 2: "\\left(${args[0]}\\right)" }, sparse: { 0: "\\begin{bsparse}\\end{bsparse}", 1: "\\left(${args[0]}\\right)" }, unit: { 1: "\\left(${args[0]}\\right)", 2: "\\left(\\left(${args[0]}\\right)${args[1]}\\right)" } }, defaultTemplate = "\\mathrm{${name}}\\left(${args}\\right)", latexUnits = { deg: "^\\circ" };
function escapeLatex(D) {
  return (0, import_dist.default)(D, { preserveFormatting: !0 });
}
function toSymbol(D, E) {
  return E = E === void 0 ? !1 : E, E ? hasOwnProperty$1(latexUnits, D) ? latexUnits[D] : "\\mathrm{" + escapeLatex(D) + "}" : hasOwnProperty$1(latexSymbols, D) ? latexSymbols[D] : escapeLatex(D);
}
var name$106 = "ConstantNode", dependencies$106 = ["Node", "isBounded"], createConstantNode = factory(name$106, dependencies$106, (D) => {
  var { Node: E, isBounded: O } = D;
  class F extends E {
    constructor(z) {
      super(), this.value = z;
    }
    get type() {
      return name$106;
    }
    get isConstantNode() {
      return !0;
    }
    _compile(z, R) {
      var L = this.value;
      return function() {
        return L;
      };
    }
    forEach(z) {
    }
    map(z) {
      return this.clone();
    }
    clone() {
      return new F(this.value);
    }
    _toString(z) {
      return format(this.value, z);
    }
    _toHTML(z) {
      var R = this._toString(z);
      switch (typeOf(this.value)) {
        case "number":
        case "bigint":
        case "BigNumber":
        case "Fraction":
          return '<span class="math-number">' + R + "</span>";
        case "string":
          return '<span class="math-string">' + R + "</span>";
        case "boolean":
          return '<span class="math-boolean">' + R + "</span>";
        case "null":
          return '<span class="math-null-symbol">' + R + "</span>";
        case "undefined":
          return '<span class="math-undefined">' + R + "</span>";
        default:
          return '<span class="math-symbol">' + R + "</span>";
      }
    }
    toJSON() {
      return { mathjs: name$106, value: this.value };
    }
    static fromJSON(z) {
      return new F(z.value);
    }
    _toTex(z) {
      var R = this._toString(z);
      switch (typeOf(this.value)) {
        case "string":
          return "\\mathtt{" + escapeLatex(R) + "}";
        case "number":
        case "BigNumber":
          if (!O(this.value)) return this.value.valueOf() < 0 ? "-\\infty" : "\\infty";
          var L = R.toLowerCase().indexOf("e");
          return L === -1 ? R : R.substring(0, L) + "\\cdot10^{" + R.substring(L + 1) + "}";
        case "bigint":
          return R.toString();
        case "Fraction":
          return this.value.toLatex();
        default:
          return R;
      }
    }
  }
  return _defineProperty(F, "name", name$106), F;
}, { isClass: !0, isNode: !0 }), name$105 = "FunctionAssignmentNode", dependencies$105 = ["typed", "Node"], createFunctionAssignmentNode = factory(name$105, dependencies$105, (D) => {
  var { typed: E, Node: O } = D;
  function F(z, R, L) {
    var q = getPrecedence(z, R, L), U = getPrecedence(z.expr, R, L);
    return R === "all" || U !== null && U <= q;
  }
  class I extends O {
    constructor(R, L, q) {
      if (super(), typeof R != "string") throw TypeError('String expected for parameter "name"');
      if (!Array.isArray(L)) throw TypeError('Array containing strings or objects expected for parameter "params"');
      if (!isNode(q)) throw TypeError('Node expected for parameter "expr"');
      if (keywords.has(R)) throw Error('Illegal function name, "' + R + '" is a reserved keyword');
      var U = /* @__PURE__ */ new Set();
      for (var Z of L) {
        var V = typeof Z == "string" ? Z : Z.name;
        if (U.has(V)) throw Error(`Duplicate parameter name "${V}"`);
        U.add(V);
      }
      this.name = R, this.params = L.map(function(G) {
        return G && G.name || G;
      }), this.types = L.map(function(G) {
        return G && G.type || "any";
      }), this.expr = q;
    }
    get type() {
      return name$105;
    }
    get isFunctionAssignmentNode() {
      return !0;
    }
    _compile(R, L) {
      var q = Object.create(L);
      forEach(this.params, function(X) {
        q[X] = !0;
      });
      var U = this.expr, Z = U._compile(R, q), V = this.name, G = this.params, W = join(this.types, ","), J = V + "(" + join(this.params, ", ") + ")";
      return function(X, Y, ee) {
        var K = {};
        K[W] = function() {
          for (var ie = Object.create(Y), ne = 0; ne < G.length; ne++) ie[G[ne]] = arguments[ne];
          return Z(X, ie, ee);
        };
        var te = E(V, K);
        return te.syntax = J, te.expr = U.toString(), X.set(V, te), te;
      };
    }
    forEach(R) {
      R(this.expr, "expr", this);
    }
    map(R) {
      var L = this._ifNode(R(this.expr, "expr", this));
      return new I(this.name, this.params.slice(0), L);
    }
    clone() {
      return new I(this.name, this.params.slice(0), this.expr);
    }
    _toString(R) {
      var L = R && R.parenthesis ? R.parenthesis : "keep", q = this.expr.toString(R);
      return F(this, L, R && R.implicit) && (q = "(" + q + ")"), this.name + "(" + this.params.join(", ") + ") = " + q;
    }
    toJSON() {
      var R = this.types;
      return { mathjs: name$105, name: this.name, params: this.params.map(function(L, q) {
        return { name: L, type: R[q] };
      }), expr: this.expr };
    }
    static fromJSON(R) {
      return new I(R.name, R.params, R.expr);
    }
    _toHTML(R) {
      for (var L = R && R.parenthesis ? R.parenthesis : "keep", q = [], U = 0; U < this.params.length; U++) q.push('<span class="math-symbol math-parameter">' + escape(this.params[U]) + "</span>");
      var Z = this.expr.toHTML(R);
      return F(this, L, R && R.implicit) && (Z = '<span class="math-parenthesis math-round-parenthesis">(</span>' + Z + '<span class="math-parenthesis math-round-parenthesis">)</span>'), '<span class="math-function">' + escape(this.name) + '</span><span class="math-parenthesis math-round-parenthesis">(</span>' + q.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-round-parenthesis">)</span><span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>' + Z;
    }
    _toTex(R) {
      var L = R && R.parenthesis ? R.parenthesis : "keep", q = this.expr.toTex(R);
      return F(this, L, R && R.implicit) && (q = `\\left(${q}\\right)`), "\\mathrm{" + this.name + "}\\left(" + this.params.map(toSymbol).join(",") + "\\right)=" + q;
    }
  }
  return _defineProperty(I, "name", name$105), I;
}, { isClass: !0, isNode: !0 }), name$104 = "IndexNode", dependencies$104 = ["Node", "size"], createIndexNode = factory(name$104, dependencies$104, (D) => {
  var { Node: E, size: O } = D;
  class F extends E {
    constructor(z, R) {
      if (super(), this.dimensions = z, this.dotNotation = R || !1, !Array.isArray(z) || !z.every(isNode)) throw TypeError('Array containing Nodes expected for parameter "dimensions"');
      if (this.dotNotation && !this.isObjectProperty()) throw Error("dotNotation only applicable for object properties");
    }
    get type() {
      return name$104;
    }
    get isIndexNode() {
      return !0;
    }
    _compile(z, R) {
      var L = map$1(this.dimensions, function(U, Z) {
        if (U.filter((W) => W.isSymbolNode && W.name === "end").length > 0) {
          var V = Object.create(R);
          V.end = !0;
          var G = U._compile(z, V);
          return function(W, J, X) {
            if (!isMatrix(X) && !isArray(X) && !isString(X)) throw TypeError('Cannot resolve "end": context must be a Matrix, Array, or string but is ' + typeOf(X));
            var Y = O(X), ee = Object.create(J);
            return ee.end = Y[Z], G(W, ee, X);
          };
        } else return U._compile(z, R);
      }), q = getSafeProperty(z, "index");
      return function(U, Z, V) {
        return q(...map$1(L, function(G) {
          return G(U, Z, V);
        }));
      };
    }
    forEach(z) {
      for (var R = 0; R < this.dimensions.length; R++) z(this.dimensions[R], "dimensions[" + R + "]", this);
    }
    map(z) {
      for (var R = [], L = 0; L < this.dimensions.length; L++) R[L] = this._ifNode(z(this.dimensions[L], "dimensions[" + L + "]", this));
      return new F(R, this.dotNotation);
    }
    clone() {
      return new F(this.dimensions.slice(0), this.dotNotation);
    }
    isObjectProperty() {
      return this.dimensions.length === 1 && isConstantNode(this.dimensions[0]) && typeof this.dimensions[0].value == "string";
    }
    getObjectProperty() {
      return this.isObjectProperty() ? this.dimensions[0].value : null;
    }
    _toString(z) {
      return this.dotNotation ? "." + this.getObjectProperty() : "[" + this.dimensions.join(", ") + "]";
    }
    toJSON() {
      return { mathjs: name$104, dimensions: this.dimensions, dotNotation: this.dotNotation };
    }
    static fromJSON(z) {
      return new F(z.dimensions, z.dotNotation);
    }
    _toHTML(z) {
      for (var R = [], L = 0; L < this.dimensions.length; L++) R[L] = this.dimensions[L].toHTML();
      return this.dotNotation ? '<span class="math-operator math-accessor-operator">.</span><span class="math-symbol math-property">' + escape(this.getObjectProperty()) + "</span>" : '<span class="math-parenthesis math-square-parenthesis">[</span>' + R.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-square-parenthesis">]</span>';
    }
    _toTex(z) {
      var R = this.dimensions.map(function(L) {
        return L.toTex(z);
      });
      return this.dotNotation ? "." + this.getObjectProperty() : "_{" + R.join(",") + "}";
    }
  }
  return _defineProperty(F, "name", name$104), F;
}, { isClass: !0, isNode: !0 }), name$103 = "ObjectNode", dependencies$103 = ["Node"], createObjectNode = factory(name$103, dependencies$103, (D) => {
  var { Node: E } = D;
  class O extends E {
    constructor(I) {
      if (super(), this.properties = I || {}, I && (typeof I != "object" || !Object.keys(I).every(function(z) {
        return isNode(I[z]);
      }))) throw TypeError("Object containing Nodes expected");
    }
    get type() {
      return name$103;
    }
    get isObjectNode() {
      return !0;
    }
    _compile(I, z) {
      var R = {};
      for (var L in this.properties) if (hasOwnProperty$1(this.properties, L)) {
        var q = stringify(L), U = JSON.parse(q);
        R[U] = getSafeProperty(this.properties, L)._compile(I, z);
      }
      return function(Z, V, G) {
        var W = {};
        for (var J in R) hasOwnProperty$1(R, J) && (W[J] = R[J](Z, V, G));
        return W;
      };
    }
    forEach(I) {
      for (var z in this.properties) hasOwnProperty$1(this.properties, z) && I(this.properties[z], "properties[" + stringify(z) + "]", this);
    }
    map(I) {
      var z = {};
      for (var R in this.properties) hasOwnProperty$1(this.properties, R) && (z[R] = this._ifNode(I(this.properties[R], "properties[" + stringify(R) + "]", this)));
      return new O(z);
    }
    clone() {
      var I = {};
      for (var z in this.properties) hasOwnProperty$1(this.properties, z) && (I[z] = this.properties[z]);
      return new O(I);
    }
    _toString(I) {
      var z = [];
      for (var R in this.properties) hasOwnProperty$1(this.properties, R) && z.push(stringify(R) + ": " + this.properties[R].toString(I));
      return "{" + z.join(", ") + "}";
    }
    toJSON() {
      return { mathjs: name$103, properties: this.properties };
    }
    static fromJSON(I) {
      return new O(I.properties);
    }
    _toHTML(I) {
      var z = [];
      for (var R in this.properties) hasOwnProperty$1(this.properties, R) && z.push('<span class="math-symbol math-property">' + escape(R) + '</span><span class="math-operator math-assignment-operator math-property-assignment-operator math-binary-operator">:</span>' + this.properties[R].toHTML(I));
      return '<span class="math-parenthesis math-curly-parenthesis">{</span>' + z.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-curly-parenthesis">}</span>';
    }
    _toTex(I) {
      var z = [];
      for (var R in this.properties) hasOwnProperty$1(this.properties, R) && z.push("\\mathbf{" + R + ":} & " + this.properties[R].toTex(I) + "\\\\");
      return "\\left\\{\\begin{array}{ll}" + z.join(`
`) + "\\end{array}\\right\\}";
    }
  }
  return _defineProperty(O, "name", name$103), O;
}, { isClass: !0, isNode: !0 });
function createSubScope(D, E) {
  return new PartitionedMap(D, new ObjectWrappingMap(E), new Set(Object.keys(E)));
}
var name$102 = "OperatorNode", dependencies$102 = ["Node"], createOperatorNode = factory(name$102, dependencies$102, (D) => {
  var { Node: E } = D;
  function O(z, R) {
    var L = z;
    if (R === "auto") for (; isParenthesisNode(L); ) L = L.content;
    return isConstantNode(L) ? !0 : isOperatorNode(L) ? O(L.args[0], R) : !1;
  }
  function F(z, R, L, q, U) {
    var Z = getPrecedence(z, R, L), V = getAssociativity(z, R);
    if (R === "all" || q.length > 2 && z.getIdentifier() !== "OperatorNode:add" && z.getIdentifier() !== "OperatorNode:multiply") return q.map(function(le) {
      switch (le.getContent().type) {
        case "ArrayNode":
        case "ConstantNode":
        case "SymbolNode":
        case "ParenthesisNode":
          return !1;
        default:
          return !0;
      }
    });
    var G;
    switch (q.length) {
      case 0:
        G = [];
        break;
      case 1:
        var W = getPrecedence(q[0], R, L, z);
        if (U && W !== null) {
          var J, X;
          if (R === "keep" ? (J = q[0].getIdentifier(), X = z.getIdentifier()) : (J = q[0].getContent().getIdentifier(), X = z.getContent().getIdentifier()), properties[Z][X].latexLeftParens === !1) {
            G = [!1];
            break;
          }
          if (properties[W][J].latexParens === !1) {
            G = [!1];
            break;
          }
        }
        if (W === null) {
          G = [!1];
          break;
        }
        if (W <= Z) {
          G = [!0];
          break;
        }
        G = [!1];
        break;
      case 2:
        var Y, ee = getPrecedence(q[0], R, L, z), K = isAssociativeWith(z, q[0], R);
        Y = ee === null ? !1 : ee === Z && V === "right" && !K ? !0 : ee < Z;
        var te, ie = getPrecedence(q[1], R, L, z), ne = isAssociativeWith(z, q[1], R);
        if (te = ie === null ? !1 : ie === Z && V === "left" && !ne ? !0 : ie < Z, U) {
          var ae, ue, oe;
          R === "keep" ? (ae = z.getIdentifier(), ue = z.args[0].getIdentifier(), oe = z.args[1].getIdentifier()) : (ae = z.getContent().getIdentifier(), ue = z.args[0].getContent().getIdentifier(), oe = z.args[1].getContent().getIdentifier()), ee !== null && (properties[Z][ae].latexLeftParens === !1 && (Y = !1), properties[ee][ue].latexParens === !1 && (Y = !1)), ie !== null && (properties[Z][ae].latexRightParens === !1 && (te = !1), properties[ie][oe].latexParens === !1 && (te = !1));
        }
        G = [Y, te];
        break;
      default:
        (z.getIdentifier() === "OperatorNode:add" || z.getIdentifier() === "OperatorNode:multiply") && (G = q.map(function(le) {
          var ce = getPrecedence(le, R, L, z), fe = isAssociativeWith(z, le, R), pe = getAssociativity(le, R);
          return ce === null ? !1 : Z === ce && V === pe && !fe ? !0 : ce < Z;
        }));
        break;
    }
    if (q.length >= 2 && z.getIdentifier() === "OperatorNode:multiply" && z.implicit && R !== "all" && L === "hide") for (var se = 1; se < G.length; ++se) O(q[se], R) && !G[se - 1] && (R !== "keep" || !isParenthesisNode(q[se - 1])) && (G[se] = !0);
    return G;
  }
  class I extends E {
    constructor(R, L, q, U, Z) {
      if (super(), typeof R != "string") throw TypeError('string expected for parameter "op"');
      if (typeof L != "string") throw TypeError('string expected for parameter "fn"');
      if (!Array.isArray(q) || !q.every(isNode)) throw TypeError('Array containing Nodes expected for parameter "args"');
      this.implicit = U === !0, this.isPercentage = Z === !0, this.op = R, this.fn = L, this.args = q || [];
    }
    get type() {
      return name$102;
    }
    get isOperatorNode() {
      return !0;
    }
    _compile(R, L) {
      if (typeof this.fn != "string" || !isSafeMethod(R, this.fn)) throw R[this.fn] ? Error('No access to function "' + this.fn + '"') : Error("Function " + this.fn + ' missing in provided namespace "math"');
      var q = getSafeProperty(R, this.fn), U = map$1(this.args, function(J) {
        return J._compile(R, L);
      });
      if (typeof q == "function" && q.rawArgs === !0) {
        var Z = this.args;
        return function(J, X, Y) {
          return q(Z, R, createSubScope(J, X));
        };
      } else if (U.length === 1) {
        var V = U[0];
        return function(J, X, Y) {
          return q(V(J, X, Y));
        };
      } else if (U.length === 2) {
        var G = U[0], W = U[1];
        return function(J, X, Y) {
          return q(G(J, X, Y), W(J, X, Y));
        };
      } else return function(J, X, Y) {
        return q.apply(null, map$1(U, function(ee) {
          return ee(J, X, Y);
        }));
      };
    }
    forEach(R) {
      for (var L = 0; L < this.args.length; L++) R(this.args[L], "args[" + L + "]", this);
    }
    map(R) {
      for (var L = [], q = 0; q < this.args.length; q++) L[q] = this._ifNode(R(this.args[q], "args[" + q + "]", this));
      return new I(this.op, this.fn, L, this.implicit, this.isPercentage);
    }
    clone() {
      return new I(this.op, this.fn, this.args.slice(0), this.implicit, this.isPercentage);
    }
    isUnary() {
      return this.args.length === 1;
    }
    isBinary() {
      return this.args.length === 2;
    }
    _toString(R) {
      var L = R && R.parenthesis ? R.parenthesis : "keep", q = R && R.implicit ? R.implicit : "hide", U = this.args, Z = F(this, L, q, U, !1);
      if (U.length === 1) {
        var V = getAssociativity(this, L), G = U[0].toString(R);
        Z[0] && (G = "(" + G + ")");
        var W = /[a-zA-Z]+/.test(this.op);
        return V === "right" ? this.op + (W ? " " : "") + G : V === "left" ? G + (W ? " " : "") + this.op : G + this.op;
      } else if (U.length === 2) {
        var J = U[0].toString(R), X = U[1].toString(R);
        return Z[0] && (J = "(" + J + ")"), Z[1] && (X = "(" + X + ")"), this.implicit && this.getIdentifier() === "OperatorNode:multiply" && q === "hide" ? J + " " + X : J + " " + this.op + " " + X;
      } else if (U.length > 2 && (this.getIdentifier() === "OperatorNode:add" || this.getIdentifier() === "OperatorNode:multiply")) {
        var Y = U.map(function(ee, K) {
          return ee = ee.toString(R), Z[K] && (ee = "(" + ee + ")"), ee;
        });
        return this.implicit && this.getIdentifier() === "OperatorNode:multiply" && q === "hide" ? Y.join(" ") : Y.join(" " + this.op + " ");
      } else return this.fn + "(" + this.args.join(", ") + ")";
    }
    toJSON() {
      return { mathjs: name$102, op: this.op, fn: this.fn, args: this.args, implicit: this.implicit, isPercentage: this.isPercentage };
    }
    static fromJSON(R) {
      return new I(R.op, R.fn, R.args, R.implicit, R.isPercentage);
    }
    _toHTML(R) {
      var L = R && R.parenthesis ? R.parenthesis : "keep", q = R && R.implicit ? R.implicit : "hide", U = this.args, Z = F(this, L, q, U, !1);
      if (U.length === 1) {
        var V = getAssociativity(this, L), G = U[0].toHTML(R);
        return Z[0] && (G = '<span class="math-parenthesis math-round-parenthesis">(</span>' + G + '<span class="math-parenthesis math-round-parenthesis">)</span>'), V === "right" ? '<span class="math-operator math-unary-operator math-lefthand-unary-operator">' + escape(this.op) + "</span>" + G : G + '<span class="math-operator math-unary-operator math-righthand-unary-operator">' + escape(this.op) + "</span>";
      } else if (U.length === 2) {
        var W = U[0].toHTML(R), J = U[1].toHTML(R);
        return Z[0] && (W = '<span class="math-parenthesis math-round-parenthesis">(</span>' + W + '<span class="math-parenthesis math-round-parenthesis">)</span>'), Z[1] && (J = '<span class="math-parenthesis math-round-parenthesis">(</span>' + J + '<span class="math-parenthesis math-round-parenthesis">)</span>'), this.implicit && this.getIdentifier() === "OperatorNode:multiply" && q === "hide" ? W + '<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>' + J : W + '<span class="math-operator math-binary-operator math-explicit-binary-operator">' + escape(this.op) + "</span>" + J;
      } else {
        var X = U.map(function(Y, ee) {
          return Y = Y.toHTML(R), Z[ee] && (Y = '<span class="math-parenthesis math-round-parenthesis">(</span>' + Y + '<span class="math-parenthesis math-round-parenthesis">)</span>'), Y;
        });
        return U.length > 2 && (this.getIdentifier() === "OperatorNode:add" || this.getIdentifier() === "OperatorNode:multiply") ? this.implicit && this.getIdentifier() === "OperatorNode:multiply" && q === "hide" ? X.join('<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>') : X.join('<span class="math-operator math-binary-operator math-explicit-binary-operator">' + escape(this.op) + "</span>") : '<span class="math-function">' + escape(this.fn) + '</span><span class="math-paranthesis math-round-parenthesis">(</span>' + X.join('<span class="math-separator">,</span>') + '<span class="math-paranthesis math-round-parenthesis">)</span>';
      }
    }
    _toTex(R) {
      var L = R && R.parenthesis ? R.parenthesis : "keep", q = R && R.implicit ? R.implicit : "hide", U = this.args, Z = F(this, L, q, U, !0), V = latexOperators[this.fn];
      if (V = V === void 0 ? this.op : V, U.length === 1) {
        var G = getAssociativity(this, L), W = U[0].toTex(R);
        return Z[0] && (W = `\\left(${W}\\right)`), G === "right" ? V + W : W + V;
      } else if (U.length === 2) {
        var J = U[0], X = J.toTex(R);
        Z[0] && (X = `\\left(${X}\\right)`);
        var Y = U[1].toTex(R);
        Z[1] && (Y = `\\left(${Y}\\right)`);
        var ee = L === "keep" ? J.getIdentifier() : J.getContent().getIdentifier();
        switch (this.getIdentifier()) {
          case "OperatorNode:divide":
            return V + "{" + X + "}{" + Y + "}";
          case "OperatorNode:pow":
            switch (X = "{" + X + "}", Y = "{" + Y + "}", ee) {
              case "ConditionalNode":
              case "OperatorNode:divide":
                X = `\\left(${X}\\right)`;
            }
            break;
          case "OperatorNode:multiply":
            if (this.implicit && q === "hide") return X + "~" + Y;
        }
        return X + V + Y;
      } else if (U.length > 2 && (this.getIdentifier() === "OperatorNode:add" || this.getIdentifier() === "OperatorNode:multiply")) {
        var K = U.map(function(te, ie) {
          return te = te.toTex(R), Z[ie] && (te = `\\left(${te}\\right)`), te;
        });
        return this.getIdentifier() === "OperatorNode:multiply" && this.implicit && q === "hide" ? K.join("~") : K.join(V);
      } else return "\\mathrm{" + this.fn + "}\\left(" + U.map(function(te) {
        return te.toTex(R);
      }).join(",") + "\\right)";
    }
    getIdentifier() {
      return this.type + ":" + this.fn;
    }
  }
  return _defineProperty(I, "name", name$102), I;
}, { isClass: !0, isNode: !0 }), name$101 = "ParenthesisNode", dependencies$101 = ["Node"], createParenthesisNode = factory(name$101, dependencies$101, (D) => {
  var { Node: E } = D;
  class O extends E {
    constructor(I) {
      if (super(), !isNode(I)) throw TypeError('Node expected for parameter "content"');
      this.content = I;
    }
    get type() {
      return name$101;
    }
    get isParenthesisNode() {
      return !0;
    }
    _compile(I, z) {
      return this.content._compile(I, z);
    }
    getContent() {
      return this.content.getContent();
    }
    forEach(I) {
      I(this.content, "content", this);
    }
    map(I) {
      return new O(I(this.content, "content", this));
    }
    clone() {
      return new O(this.content);
    }
    _toString(I) {
      return !I || I && !I.parenthesis || I && I.parenthesis === "keep" ? "(" + this.content.toString(I) + ")" : this.content.toString(I);
    }
    toJSON() {
      return { mathjs: name$101, content: this.content };
    }
    static fromJSON(I) {
      return new O(I.content);
    }
    _toHTML(I) {
      return !I || I && !I.parenthesis || I && I.parenthesis === "keep" ? '<span class="math-parenthesis math-round-parenthesis">(</span>' + this.content.toHTML(I) + '<span class="math-parenthesis math-round-parenthesis">)</span>' : this.content.toHTML(I);
    }
    _toTex(I) {
      return !I || I && !I.parenthesis || I && I.parenthesis === "keep" ? `\\left(${this.content.toTex(I)}\\right)` : this.content.toTex(I);
    }
  }
  return _defineProperty(O, "name", name$101), O;
}, { isClass: !0, isNode: !0 }), name$100 = "RangeNode", dependencies$100 = ["Node"], createRangeNode = factory(name$100, dependencies$100, (D) => {
  var { Node: E } = D;
  function O(I, z, R) {
    var L = getPrecedence(I, z, R), q = {}, U = getPrecedence(I.start, z, R);
    if (q.start = U !== null && U <= L || z === "all", I.step) {
      var Z = getPrecedence(I.step, z, R);
      q.step = Z !== null && Z <= L || z === "all";
    }
    var V = getPrecedence(I.end, z, R);
    return q.end = V !== null && V <= L || z === "all", q;
  }
  class F extends E {
    constructor(z, R, L) {
      if (super(), !isNode(z) || !isNode(R) || L && !isNode(L)) throw TypeError("Node expected");
      if (arguments.length > 3) throw Error("Too many arguments");
      this.start = z, this.end = R, this.step = L || null;
    }
    get type() {
      return name$100;
    }
    get isRangeNode() {
      return !0;
    }
    needsEnd() {
      return this.filter(function(z) {
        return isSymbolNode(z) && z.name === "end";
      }).length > 0;
    }
    _compile(z, R) {
      var L = z.range, q = this.start._compile(z, R), U = this.end._compile(z, R);
      if (this.step) {
        var Z = this.step._compile(z, R);
        return function(V, G, W) {
          return L(q(V, G, W), U(V, G, W), Z(V, G, W));
        };
      } else return function(V, G, W) {
        return L(q(V, G, W), U(V, G, W));
      };
    }
    forEach(z) {
      z(this.start, "start", this), z(this.end, "end", this), this.step && z(this.step, "step", this);
    }
    map(z) {
      return new F(this._ifNode(z(this.start, "start", this)), this._ifNode(z(this.end, "end", this)), this.step && this._ifNode(z(this.step, "step", this)));
    }
    clone() {
      return new F(this.start, this.end, this.step && this.step);
    }
    _toString(z) {
      var R = z && z.parenthesis ? z.parenthesis : "keep", L = O(this, R, z && z.implicit), q, U = this.start.toString(z);
      if (L.start && (U = "(" + U + ")"), q = U, this.step) {
        var Z = this.step.toString(z);
        L.step && (Z = "(" + Z + ")"), q += ":" + Z;
      }
      var V = this.end.toString(z);
      return L.end && (V = "(" + V + ")"), q += ":" + V, q;
    }
    toJSON() {
      return { mathjs: name$100, start: this.start, end: this.end, step: this.step };
    }
    static fromJSON(z) {
      return new F(z.start, z.end, z.step);
    }
    _toHTML(z) {
      var R = z && z.parenthesis ? z.parenthesis : "keep", L = O(this, R, z && z.implicit), q, U = this.start.toHTML(z);
      if (L.start && (U = '<span class="math-parenthesis math-round-parenthesis">(</span>' + U + '<span class="math-parenthesis math-round-parenthesis">)</span>'), q = U, this.step) {
        var Z = this.step.toHTML(z);
        L.step && (Z = '<span class="math-parenthesis math-round-parenthesis">(</span>' + Z + '<span class="math-parenthesis math-round-parenthesis">)</span>'), q += '<span class="math-operator math-range-operator">:</span>' + Z;
      }
      var V = this.end.toHTML(z);
      return L.end && (V = '<span class="math-parenthesis math-round-parenthesis">(</span>' + V + '<span class="math-parenthesis math-round-parenthesis">)</span>'), q += '<span class="math-operator math-range-operator">:</span>' + V, q;
    }
    _toTex(z) {
      var R = z && z.parenthesis ? z.parenthesis : "keep", L = O(this, R, z && z.implicit), q = this.start.toTex(z);
      if (L.start && (q = `\\left(${q}\\right)`), this.step) {
        var U = this.step.toTex(z);
        L.step && (U = `\\left(${U}\\right)`), q += ":" + U;
      }
      var Z = this.end.toTex(z);
      return L.end && (Z = `\\left(${Z}\\right)`), q += ":" + Z, q;
    }
  }
  return _defineProperty(F, "name", name$100), F;
}, { isClass: !0, isNode: !0 }), name$99 = "RelationalNode", dependencies$99 = ["Node"], createRelationalNode = factory(name$99, dependencies$99, (D) => {
  var { Node: E } = D, O = { equal: "==", unequal: "!=", smaller: "<", larger: ">", smallerEq: "<=", largerEq: ">=" };
  class F extends E {
    constructor(z, R) {
      if (super(), !Array.isArray(z)) throw TypeError("Parameter conditionals must be an array");
      if (!Array.isArray(R)) throw TypeError("Parameter params must be an array");
      if (z.length !== R.length - 1) throw TypeError("Parameter params must contain exactly one more element than parameter conditionals");
      this.conditionals = z, this.params = R;
    }
    get type() {
      return name$99;
    }
    get isRelationalNode() {
      return !0;
    }
    _compile(z, R) {
      var L = this, q = this.params.map((U) => U._compile(z, R));
      return function(U, Z, V) {
        for (var G, W = q[0](U, Z, V), J = 0; J < L.conditionals.length; J++) if (G = W, W = q[J + 1](U, Z, V), !getSafeProperty(z, L.conditionals[J])(G, W)) return !1;
        return !0;
      };
    }
    forEach(z) {
      this.params.forEach((R, L) => z(R, "params[" + L + "]", this), this);
    }
    map(z) {
      return new F(this.conditionals.slice(), this.params.map((R, L) => this._ifNode(z(R, "params[" + L + "]", this)), this));
    }
    clone() {
      return new F(this.conditionals, this.params);
    }
    _toString(z) {
      for (var R = z && z.parenthesis ? z.parenthesis : "keep", L = getPrecedence(this, R, z && z.implicit), q = this.params.map(function(V, G) {
        var W = getPrecedence(V, R, z && z.implicit);
        return R === "all" || W !== null && W <= L ? "(" + V.toString(z) + ")" : V.toString(z);
      }), U = q[0], Z = 0; Z < this.conditionals.length; Z++) U += " " + O[this.conditionals[Z]], U += " " + q[Z + 1];
      return U;
    }
    toJSON() {
      return { mathjs: name$99, conditionals: this.conditionals, params: this.params };
    }
    static fromJSON(z) {
      return new F(z.conditionals, z.params);
    }
    _toHTML(z) {
      for (var R = z && z.parenthesis ? z.parenthesis : "keep", L = getPrecedence(this, R, z && z.implicit), q = this.params.map(function(V, G) {
        var W = getPrecedence(V, R, z && z.implicit);
        return R === "all" || W !== null && W <= L ? '<span class="math-parenthesis math-round-parenthesis">(</span>' + V.toHTML(z) + '<span class="math-parenthesis math-round-parenthesis">)</span>' : V.toHTML(z);
      }), U = q[0], Z = 0; Z < this.conditionals.length; Z++) U += '<span class="math-operator math-binary-operator math-explicit-binary-operator">' + escape(O[this.conditionals[Z]]) + "</span>" + q[Z + 1];
      return U;
    }
    _toTex(z) {
      for (var R = z && z.parenthesis ? z.parenthesis : "keep", L = getPrecedence(this, R, z && z.implicit), q = this.params.map(function(V, G) {
        var W = getPrecedence(V, R, z && z.implicit);
        return R === "all" || W !== null && W <= L ? "\\left(" + V.toTex(z) + "\right)" : V.toTex(z);
      }), U = q[0], Z = 0; Z < this.conditionals.length; Z++) U += latexOperators[this.conditionals[Z]] + q[Z + 1];
      return U;
    }
  }
  return _defineProperty(F, "name", name$99), F;
}, { isClass: !0, isNode: !0 }), name$98 = "SymbolNode", dependencies$98 = ["math", "?Unit", "Node"], createSymbolNode = factory(name$98, dependencies$98, (D) => {
  var { math: E, Unit: O, Node: F } = D;
  function I(R) {
    return O ? O.isValuelessUnit(R) : !1;
  }
  class z extends F {
    constructor(L) {
      if (super(), typeof L != "string") throw TypeError('String expected for parameter "name"');
      this.name = L;
    }
    get type() {
      return "SymbolNode";
    }
    get isSymbolNode() {
      return !0;
    }
    _compile(L, q) {
      var U = this.name;
      if (q[U] === !0) return function(V, G, W) {
        return getSafeProperty(G, U);
      };
      if (U in L) return function(V, G, W) {
        return V.has(U) ? V.get(U) : getSafeProperty(L, U);
      };
      var Z = I(U);
      return function(V, G, W) {
        return V.has(U) ? V.get(U) : Z ? new O(null, U) : z.onUndefinedSymbol(U);
      };
    }
    forEach(L) {
    }
    map(L) {
      return this.clone();
    }
    static onUndefinedSymbol(L) {
      throw Error("Undefined symbol " + L);
    }
    clone() {
      return new z(this.name);
    }
    _toString(L) {
      return this.name;
    }
    _toHTML(L) {
      var q = escape(this.name);
      return q === "true" || q === "false" ? '<span class="math-symbol math-boolean">' + q + "</span>" : q === "i" ? '<span class="math-symbol math-imaginary-symbol">' + q + "</span>" : q === "Infinity" ? '<span class="math-symbol math-infinity-symbol">' + q + "</span>" : q === "NaN" ? '<span class="math-symbol math-nan-symbol">' + q + "</span>" : q === "null" ? '<span class="math-symbol math-null-symbol">' + q + "</span>" : q === "undefined" ? '<span class="math-symbol math-undefined-symbol">' + q + "</span>" : '<span class="math-symbol">' + q + "</span>";
    }
    toJSON() {
      return { mathjs: "SymbolNode", name: this.name };
    }
    static fromJSON(L) {
      return new z(L.name);
    }
    _toTex(L) {
      var q = !1;
      E[this.name] === void 0 && I(this.name) && (q = !0);
      var U = toSymbol(this.name, q);
      return U[0] === "\\" ? U : " " + U;
    }
  }
  return z;
}, { isClass: !0, isNode: !0 }), name$97 = "FunctionNode", dependencies$97 = ["math", "Node", "SymbolNode"], createFunctionNode = factory(name$97, dependencies$97, (D) => {
  var E, { math: O, Node: F, SymbolNode: I } = D, z = (q) => format(q, { truncate: 78 });
  function R(q, U, Z) {
    for (var V = "", G = /\$(?:\{([a-z_][a-z_0-9]*)(?:\[([0-9]+)\])?\}|\$)/gi, W = 0, J; (J = G.exec(q)) !== null; ) if (V += q.substring(W, J.index), W = J.index, J[0] === "$$") V += "$", W++;
    else {
      W += J[0].length;
      var X = U[J[1]];
      if (!X) throw ReferenceError("Template: Property " + J[1] + " does not exist.");
      if (J[2] === void 0) switch (typeof X) {
        case "string":
          V += X;
          break;
        case "object":
          if (isNode(X)) V += X.toTex(Z);
          else if (Array.isArray(X)) V += X.map(function(Y, ee) {
            if (isNode(Y)) return Y.toTex(Z);
            throw TypeError("Template: " + J[1] + "[" + ee + "] is not a Node.");
          }).join(",");
          else throw TypeError("Template: " + J[1] + " has to be a Node, String or array of Nodes");
          break;
        default:
          throw TypeError("Template: " + J[1] + " has to be a Node, String or array of Nodes");
      }
      else if (isNode(X[J[2]] && X[J[2]])) V += X[J[2]].toTex(Z);
      else throw TypeError("Template: " + J[1] + "[" + J[2] + "] is not a Node.");
    }
    return V += q.slice(W), V;
  }
  class L extends F {
    constructor(U, Z, V) {
      if (super(), typeof U == "string" && (U = new I(U)), !isNode(U)) throw TypeError('Node expected as parameter "fn"');
      if (!Array.isArray(Z) || !Z.every(isNode)) throw TypeError('Array containing Nodes expected for parameter "args"');
      var G = typeof V;
      if (!(G === "undefined" || G === "boolean")) throw TypeError("optional flag, if specified, must be boolean");
      this.fn = U, this.args = Z || [], this.optional = !!V;
    }
    get name() {
      return this.fn.name || "";
    }
    get type() {
      return name$97;
    }
    get isFunctionNode() {
      return !0;
    }
    _compile(U, Z) {
      var V = this.args.map((se) => se._compile(U, Z)), G = this.optional || isAccessorNode(this.fn) && this.fn.optionalChaining;
      if (isSymbolNode(this.fn)) {
        var W = this.fn.name;
        if (Z[W]) {
          var J = this.args;
          return function(se, le, ce) {
            var fe = getSafeProperty(le, W);
            if (!(G && fe === void 0)) {
              if (typeof fe != "function") throw TypeError(`Argument '${W}' was not a function; received: ${z(fe)}`);
              if (fe.rawArgs) return fe(J, U, createSubScope(se, le));
              var pe = V.map((ve) => ve(se, le, ce));
              return fe.apply(fe, pe);
            }
          };
        } else {
          var X = W in U ? getSafeProperty(U, W) : void 0, Y = typeof X == "function" && X.rawArgs === !0, ee = (se) => {
            var le;
            if (se.has(W)) le = se.get(W);
            else if (W in U) le = getSafeProperty(U, W);
            else if (G) le = void 0;
            else return L.onUndefinedFunction(W);
            if (typeof le == "function" || G && le === void 0) return le;
            throw TypeError(`'${W}' is not a function; its value is:
  ${z(le)}`);
          };
          if (Y) {
            var K = this.args;
            return function(se, le, ce) {
              var fe = ee(se);
              return fe.rawArgs === !0 ? fe(K, U, createSubScope(se, le)) : fe(...V.map((pe) => pe(se, le, ce)));
            };
          } else switch (V.length) {
            case 0:
              return function(se, le, ce) {
                var fe = ee(se);
                if (!(G && fe === void 0)) return fe();
              };
            case 1:
              return function(se, le, ce) {
                var fe = ee(se);
                if (!(G && fe === void 0)) {
                  var pe = V[0];
                  return fe(pe(se, le, ce));
                }
              };
            case 2:
              return function(se, le, ce) {
                var fe = ee(se);
                if (!(G && fe === void 0)) {
                  var pe = V[0], ve = V[1];
                  return fe(pe(se, le, ce), ve(se, le, ce));
                }
              };
            default:
              return function(se, le, ce) {
                var fe = ee(se);
                if (!(G && fe === void 0)) return fe(...V.map((pe) => pe(se, le, ce)));
              };
          }
        }
      } else if (isAccessorNode(this.fn) && isIndexNode(this.fn.index) && this.fn.index.isObjectProperty()) {
        var te = this.fn.object._compile(U, Z), ie = this.fn.index.getObjectProperty(), ne = this.args;
        return function(se, le, ce) {
          var fe = te(se, le, ce);
          if (!(G && (fe == null || fe[ie] === void 0))) {
            var pe = getSafeMethod(fe, ie);
            if (pe != null && pe.rawArgs) return pe(ne, U, createSubScope(se, le));
            var ve = V.map((_e) => _e(se, le, ce));
            return pe.apply(fe, ve);
          }
        };
      } else {
        var ae = this.fn.toString(), ue = this.fn._compile(U, Z), oe = this.args;
        return function(se, le, ce) {
          var fe = ue(se, le, ce);
          if (!(G && fe === void 0)) {
            if (typeof fe != "function") throw TypeError(`Expression '${ae}' did not evaluate to a function; value is:
  ${z(fe)}`);
            if (fe.rawArgs) return fe(oe, U, createSubScope(se, le));
            var pe = V.map((ve) => ve(se, le, ce));
            return fe.apply(fe, pe);
          }
        };
      }
    }
    forEach(U) {
      U(this.fn, "fn", this);
      for (var Z = 0; Z < this.args.length; Z++) U(this.args[Z], "args[" + Z + "]", this);
    }
    map(U) {
      for (var Z = this._ifNode(U(this.fn, "fn", this)), V = [], G = 0; G < this.args.length; G++) V[G] = this._ifNode(U(this.args[G], "args[" + G + "]", this));
      return new L(Z, V);
    }
    clone() {
      return new L(this.fn, this.args.slice(0));
    }
    toString(U) {
      var Z, V = this.fn.toString(U);
      return U && typeof U.handler == "object" && hasOwnProperty$1(U.handler, V) && (Z = U.handler[V](this, U)), Z === void 0 ? super.toString(U) : Z;
    }
    _toString(U) {
      var Z = this.args.map(function(V) {
        return V.toString(U);
      });
      return (isFunctionAssignmentNode(this.fn) ? "(" + this.fn.toString(U) + ")" : this.fn.toString(U)) + "(" + Z.join(", ") + ")";
    }
    toJSON() {
      return { mathjs: name$97, fn: this.fn, args: this.args };
    }
    _toHTML(U) {
      var Z = this.args.map(function(V) {
        return V.toHTML(U);
      });
      return '<span class="math-function">' + escape(this.fn) + '</span><span class="math-paranthesis math-round-parenthesis">(</span>' + Z.join('<span class="math-separator">,</span>') + '<span class="math-paranthesis math-round-parenthesis">)</span>';
    }
    toTex(U) {
      var Z;
      return U && typeof U.handler == "object" && hasOwnProperty$1(U.handler, this.name) && (Z = U.handler[this.name](this, U)), Z === void 0 ? super.toTex(U) : Z;
    }
    _toTex(U) {
      var Z = this.args.map(function(W) {
        return W.toTex(U);
      }), V;
      latexFunctions[this.name] && (V = latexFunctions[this.name]), O[this.name] && (typeof O[this.name].toTex == "function" || typeof O[this.name].toTex == "object" || typeof O[this.name].toTex == "string") && (V = O[this.name].toTex);
      var G;
      switch (typeof V) {
        case "function":
          G = V(this, U);
          break;
        case "string":
          G = R(V, this, U);
          break;
        case "object":
          switch (typeof V[Z.length]) {
            case "function":
              G = V[Z.length](this, U);
              break;
            case "string":
              G = R(V[Z.length], this, U);
              break;
          }
      }
      return G === void 0 ? R(defaultTemplate, this, U) : G;
    }
    getIdentifier() {
      return this.type + ":" + this.name;
    }
  }
  return E = L, _defineProperty(L, "name", name$97), _defineProperty(L, "onUndefinedFunction", function(q) {
    throw Error("Undefined function " + q);
  }), _defineProperty(L, "fromJSON", function(q) {
    return new E(q.fn, q.args);
  }), L;
}, { isClass: !0, isNode: !0 }), name$96 = "parse", dependencies$96 = ["typed", "numeric", "config", "AccessorNode", "ArrayNode", "AssignmentNode", "BlockNode", "ConditionalNode", "ConstantNode", "FunctionAssignmentNode", "FunctionNode", "IndexNode", "ObjectNode", "OperatorNode", "ParenthesisNode", "RangeNode", "RelationalNode", "SymbolNode"], createParse = factory(name$96, dependencies$96, (D) => {
  var { typed: E, numeric: O, config: F, AccessorNode: I, ArrayNode: z, AssignmentNode: R, BlockNode: L, ConditionalNode: q, ConstantNode: U, FunctionAssignmentNode: Z, FunctionNode: V, IndexNode: G, ObjectNode: W, OperatorNode: J, ParenthesisNode: X, RangeNode: Y, RelationalNode: ee, SymbolNode: K } = D, te = E(name$96, { string: function(me) {
    return Ie(me, {});
  }, "Array | Matrix": function(me) {
    return ie(me, {});
  }, "string, Object": function(me, Ee) {
    return Ie(me, Ee.nodes === void 0 ? {} : Ee.nodes);
  }, "Array | Matrix, Object": ie });
  function ie(me) {
    var Ee = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Le = Ee.nodes === void 0 ? {} : Ee.nodes;
    return deepMap(me, function(Ve) {
      if (typeof Ve != "string") throw TypeError("String expected");
      return Ie(Ve, Le);
    });
  }
  var ne = { NULL: 0, DELIMITER: 1, NUMBER: 2, SYMBOL: 3, UNKNOWN: 4 }, ae = { ",": !0, "(": !0, ")": !0, "[": !0, "]": !0, "{": !0, "}": !0, '"': !0, "'": !0, ";": !0, "+": !0, "-": !0, "*": !0, ".*": !0, "/": !0, "./": !0, "%": !0, "^": !0, ".^": !0, "~": !0, "!": !0, "&": !0, "|": !0, "^|": !0, "=": !0, ":": !0, "?": !0, "?.": !0, "??": !0, "==": !0, "!=": !0, "<": !0, ">": !0, "<=": !0, ">=": !0, "<<": !0, ">>": !0, ">>>": !0 }, ue = { mod: !0, to: !0, in: !0, and: !0, xor: !0, or: !0, not: !0 }, oe = { true: !0, false: !1, null: null, undefined: void 0 }, se = ["NaN", "Infinity"], le = { '"': '"', "'": "'", "\\": "\\", "/": "/", b: "\b", f: "\f", n: `
`, r: "\r", t: "	" };
  function ce() {
    return { extraNodes: {}, expression: "", comment: "", index: 0, token: "", tokenType: ne.NULL, nestingLevel: 0, conditionalLevel: null };
  }
  function fe(me, Ee) {
    return me.expression.substr(me.index, Ee);
  }
  function pe(me) {
    return fe(me, 1);
  }
  function ve(me) {
    me.index++;
  }
  function _e(me) {
    return me.expression.charAt(me.index - 1);
  }
  function de(me) {
    return me.expression.charAt(me.index + 1);
  }
  function ge(me) {
    for (me.tokenType = ne.NULL, me.token = "", me.comment = ""; ; ) {
      if (pe(me) === "#") for (; pe(me) !== `
` && pe(me) !== ""; ) me.comment += pe(me), ve(me);
      if (te.isWhitespace(pe(me), me.nestingLevel)) ve(me);
      else break;
    }
    if (pe(me) === "") {
      me.tokenType = ne.DELIMITER;
      return;
    }
    if (pe(me) === `
` && !me.nestingLevel) {
      me.tokenType = ne.DELIMITER, me.token = pe(me), ve(me);
      return;
    }
    var Ee = pe(me), Le = fe(me, 2), Ve = fe(me, 3);
    if (Ve.length === 3 && ae[Ve]) {
      me.tokenType = ne.DELIMITER, me.token = Ve, ve(me), ve(me), ve(me);
      return;
    }
    if (Le.length === 2 && ae[Le] && (Le !== "?." || !te.isDigit(me.expression.charAt(me.index + 2)))) {
      me.tokenType = ne.DELIMITER, me.token = Le, ve(me), ve(me);
      return;
    }
    if (ae[Ee]) {
      me.tokenType = ne.DELIMITER, me.token = Ee, ve(me);
      return;
    }
    if (te.isDigitDot(Ee)) {
      me.tokenType = ne.NUMBER;
      var tr = fe(me, 2);
      if (tr === "0b" || tr === "0o" || tr === "0x") {
        for (me.token += pe(me), ve(me), me.token += pe(me), ve(me); te.isAlpha(pe(me), _e(me), de(me)) || te.isDigit(pe(me)); ) me.token += pe(me), ve(me);
        if (pe(me) === ".") for (me.token += ".", ve(me); te.isAlpha(pe(me), _e(me), de(me)) || te.isDigit(pe(me)); ) me.token += pe(me), ve(me);
        else if (pe(me) === "i") for (me.token += "i", ve(me); te.isDigit(pe(me)); ) me.token += pe(me), ve(me);
        return;
      }
      if (pe(me) === ".") {
        if (me.token += pe(me), ve(me), !te.isDigit(pe(me))) {
          me.tokenType = ne.DELIMITER;
          return;
        }
      } else {
        for (; te.isDigit(pe(me)); ) me.token += pe(me), ve(me);
        te.isDecimalMark(pe(me), de(me)) && (me.token += pe(me), ve(me));
      }
      for (; te.isDigit(pe(me)); ) me.token += pe(me), ve(me);
      if (pe(me) === "E" || pe(me) === "e") {
        if (te.isDigit(de(me)) || de(me) === "-" || de(me) === "+") {
          if (me.token += pe(me), ve(me), (pe(me) === "+" || pe(me) === "-") && (me.token += pe(me), ve(me)), !te.isDigit(pe(me))) throw Ye(me, 'Digit expected, got "' + pe(me) + '"');
          for (; te.isDigit(pe(me)); ) me.token += pe(me), ve(me);
          if (te.isDecimalMark(pe(me), de(me))) throw Ye(me, 'Digit expected, got "' + pe(me) + '"');
        } else if (te.isDecimalMark(de(me), me.expression.charAt(me.index + 2))) throw ve(me), Ye(me, 'Digit expected, got "' + pe(me) + '"');
      }
      return;
    }
    if (te.isAlpha(pe(me), _e(me), de(me))) {
      for (; te.isAlpha(pe(me), _e(me), de(me)) || te.isDigit(pe(me)); ) me.token += pe(me), ve(me);
      hasOwnProperty$1(ue, me.token) ? me.tokenType = ne.DELIMITER : me.tokenType = ne.SYMBOL;
      return;
    }
    for (me.tokenType = ne.UNKNOWN; pe(me) !== ""; ) me.token += pe(me), ve(me);
    throw Ye(me, 'Syntax error in part "' + me.token + '"');
  }
  function ye(me) {
    do
      ge(me);
    while (me.token === `
`);
  }
  function De(me) {
    me.nestingLevel++;
  }
  function Ce(me) {
    me.nestingLevel--;
  }
  te.isAlpha = function(me, Ee, Le) {
    return te.isValidLatinOrGreek(me) || te.isValidMathSymbol(me, Le) || te.isValidMathSymbol(Ee, me);
  }, te.isValidLatinOrGreek = function(me) {
    return /^[a-zA-Z_$\u00C0-\u02AF\u0370-\u03FF\u2100-\u214F]$/.test(me);
  }, te.isValidMathSymbol = function(me, Ee) {
    return /^[\uD835]$/.test(me) && /^[\uDC00-\uDFFF]$/.test(Ee) && /^[^\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]$/.test(Ee);
  }, te.isWhitespace = function(me, Ee) {
    return me === " " || me === "	" || me === " " || me === `
` && Ee > 0;
  }, te.isDecimalMark = function(me, Ee) {
    return me === "." && Ee !== "/" && Ee !== "*" && Ee !== "^";
  }, te.isDigitDot = function(me) {
    return me >= "0" && me <= "9" || me === ".";
  }, te.isDigit = function(me) {
    return me >= "0" && me <= "9";
  };
  function Ie(me, Ee) {
    var Le = ce();
    _extends(Le, { expression: me, extraNodes: Ee }), ge(Le);
    var Ve = Ne(Le);
    if (Le.token !== "") throw Le.tokenType === ne.DELIMITER ? Je(Le, "Unexpected operator " + Le.token) : Ye(Le, 'Unexpected part "' + Le.token + '"');
    return Ve;
  }
  function Ne(me) {
    var Ee, Le = [], Ve;
    for (me.token !== "" && me.token !== `
` && me.token !== ";" && (Ee = he(me), me.comment && (Ee.comment = me.comment)); me.token === `
` || me.token === ";"; ) Le.length === 0 && Ee && (Ve = me.token !== ";", Le.push({ node: Ee, visible: Ve })), ge(me), me.token !== `
` && me.token !== ";" && me.token !== "" && (Ee = he(me), me.comment && (Ee.comment = me.comment), Ve = me.token !== ";", Le.push({ node: Ee, visible: Ve }));
    return Le.length > 0 ? new L(Le) : (Ee || (Ee = new U(void 0), me.comment && (Ee.comment = me.comment)), Ee);
  }
  function he(me) {
    var Ee, Le, Ve, tr, ar = ke(me);
    if (me.token === "=") {
      if (isSymbolNode(ar)) return Ee = ar.name, ye(me), Ve = he(me), new R(new K(Ee), Ve);
      if (isAccessorNode(ar)) {
        if (ar.optionalChaining) throw Ye(me, "Cannot assign to optional chain");
        return ye(me), Ve = he(me), new R(ar.object, ar.index, Ve);
      } else if (isFunctionNode(ar) && isSymbolNode(ar.fn) && (tr = !0, Le = [], Ee = ar.name, ar.args.forEach(function(cr, mr) {
        isSymbolNode(cr) ? Le[mr] = cr.name : tr = !1;
      }), tr)) return ye(me), Ve = he(me), new Z(Ee, Le, Ve);
      throw Ye(me, "Invalid left hand side of assignment operator =");
    }
    return ar;
  }
  function ke(me) {
    for (var Ee = xe(me); me.token === "?"; ) {
      var Le = me.conditionalLevel;
      me.conditionalLevel = me.nestingLevel, ye(me);
      var Ve = Ee, tr = he(me);
      if (me.token !== ":") throw Ye(me, "False part of conditional expression expected");
      me.conditionalLevel = null, ye(me), Ee = new q(Ve, tr, he(me)), me.conditionalLevel = Le;
    }
    return Ee;
  }
  function xe(me) {
    for (var Ee = Te(me); me.token === "or"; ) ye(me), Ee = new J("or", "or", [Ee, Te(me)]);
    return Ee;
  }
  function Te(me) {
    for (var Ee = Fe(me); me.token === "xor"; ) ye(me), Ee = new J("xor", "xor", [Ee, Fe(me)]);
    return Ee;
  }
  function Fe(me) {
    for (var Ee = be(me); me.token === "and"; ) ye(me), Ee = new J("and", "and", [Ee, be(me)]);
    return Ee;
  }
  function be(me) {
    for (var Ee = Ae(me); me.token === "|"; ) ye(me), Ee = new J("|", "bitOr", [Ee, Ae(me)]);
    return Ee;
  }
  function Ae(me) {
    for (var Ee = Me(me); me.token === "^|"; ) ye(me), Ee = new J("^|", "bitXor", [Ee, Me(me)]);
    return Ee;
  }
  function Me(me) {
    for (var Ee = $e(me); me.token === "&"; ) ye(me), Ee = new J("&", "bitAnd", [Ee, $e(me)]);
    return Ee;
  }
  function $e(me) {
    for (var Ee = [Re(me)], Le = [], Ve = { "==": "equal", "!=": "unequal", "<": "smaller", ">": "larger", "<=": "smallerEq", ">=": "largerEq" }; hasOwnProperty$1(Ve, me.token); ) {
      var tr = { name: me.token, fn: Ve[me.token] };
      Le.push(tr), ye(me), Ee.push(Re(me));
    }
    return Ee.length === 1 ? Ee[0] : Ee.length === 2 ? new J(Le[0].name, Le[0].fn, Ee) : new ee(Le.map((ar) => ar.fn), Ee);
  }
  function Re(me) {
    for (var Ee = je(me), Le, Ve, tr, ar = { "<<": "leftShift", ">>": "rightArithShift", ">>>": "rightLogShift" }; hasOwnProperty$1(ar, me.token); ) Le = me.token, Ve = ar[Le], ye(me), tr = [Ee, je(me)], Ee = new J(Le, Ve, tr);
    return Ee;
  }
  function je(me) {
    for (var Ee = Pe(me), Le, Ve, tr, ar = { to: "to", in: "to" }; hasOwnProperty$1(ar, me.token); ) Le = me.token, Ve = ar[Le], ye(me), Le === "in" && "])},;".includes(me.token) ? Ee = new J("*", "multiply", [Ee, new K("in")], !0) : (tr = [Ee, Pe(me)], Ee = new J(Le, Ve, tr));
    return Ee;
  }
  function Pe(me) {
    var Ee, Le = [];
    if (me.token === ":") {
      if (me.conditionalLevel === me.nestingLevel) throw Ye(me, "The true-expression of a conditional operator may not be empty");
      Ee = new U(1);
    } else Ee = Ke(me);
    if (me.token === ":" && me.conditionalLevel !== me.nestingLevel) {
      for (Le.push(Ee); me.token === ":" && Le.length < 3; ) ye(me), me.token === ")" || me.token === "]" || me.token === "," || me.token === "" ? Le.push(new K("end")) : Le.push(Ke(me));
      Ee = Le.length === 3 ? new Y(Le[0], Le[2], Le[1]) : new Y(Le[0], Le[1]);
    }
    return Ee;
  }
  function Ke(me) {
    for (var Ee = Qe(me), Le, Ve, tr, ar = { "+": "add", "-": "subtract" }; hasOwnProperty$1(ar, me.token); ) {
      Le = me.token, Ve = ar[Le], ye(me);
      var cr = Qe(me);
      tr = cr.isPercentage ? [Ee, new J("*", "multiply", [Ee, cr])] : [Ee, cr], Ee = new J(Le, Ve, tr);
    }
    return Ee;
  }
  function Qe(me) {
    for (var Ee = We(me), Le = Ee, Ve, tr, ar = { "*": "multiply", ".*": "dotMultiply", "/": "divide", "./": "dotDivide", "%": "mod", mod: "mod" }; hasOwnProperty$1(ar, me.token); ) Ve = me.token, tr = ar[Ve], ye(me), Le = We(me), Ee = new J(Ve, tr, [Ee, Le]);
    return Ee;
  }
  function We(me) {
    for (var Ee = ir(me), Le = Ee; me.tokenType === ne.SYMBOL || me.token === "in" && isConstantNode(Ee) || me.token === "in" && isOperatorNode(Ee) && Ee.fn === "unaryMinus" && isConstantNode(Ee.args[0]) || me.tokenType === ne.NUMBER && !isConstantNode(Le) && (!isOperatorNode(Le) || Le.op === "!") || me.token === "("; ) Le = ir(me), Ee = new J("*", "multiply", [Ee, Le], !0);
    return Ee;
  }
  function ir(me) {
    for (var Ee = nr(me), Le = Ee, Ve = []; me.token === "/" && rule2Node(Le); ) if (Ve.push(_extends({}, me)), ye(me), me.tokenType === ne.NUMBER) if (Ve.push(_extends({}, me)), ye(me), me.tokenType === ne.SYMBOL || me.token === "(" || me.token === "in") _extends(me, Ve.pop()), Ve.pop(), Le = nr(me), Ee = new J("/", "divide", [Ee, Le]);
    else {
      Ve.pop(), _extends(me, Ve.pop());
      break;
    }
    else {
      _extends(me, Ve.pop());
      break;
    }
    return Ee;
  }
  function nr(me) {
    var Ee = we(me);
    if (me.token === "%") {
      var Le = _extends({}, me);
      ye(me);
      try {
        we(me), _extends(me, Le);
      } catch {
        Ee = new J("/", "divide", [Ee, new U(100)], !1, !0);
      }
    }
    return Ee;
  }
  function we(me) {
    var Ee, Le, Ve, tr = { "-": "unaryMinus", "+": "unaryPlus", "~": "bitNot", not: "not" };
    return hasOwnProperty$1(tr, me.token) ? (Ve = tr[me.token], Ee = me.token, ye(me), Le = [we(me)], new J(Ee, Ve, Le)) : Oe(me);
  }
  function Oe(me) {
    var Ee = ze(me), Le, Ve, tr;
    return (me.token === "^" || me.token === ".^") && (Le = me.token, Ve = Le === "^" ? "pow" : "dotPow", ye(me), tr = [Ee, we(me)], Ee = new J(Le, Ve, tr)), Ee;
  }
  function ze(me) {
    for (var Ee = Ue(me); me.token === "??"; ) ye(me), Ee = new J("??", "nullish", [Ee, Ue(me)]);
    return Ee;
  }
  function Ue(me) {
    for (var Ee = er(me), Le, Ve, tr, ar = { "!": "factorial", "'": "ctranspose" }; hasOwnProperty$1(ar, me.token); ) Le = me.token, Ve = ar[Le], ge(me), tr = [Ee], Ee = new J(Le, Ve, tr), Ee = rr(me, Ee);
    return Ee;
  }
  function er(me) {
    var Ee = [];
    if (me.tokenType === ne.SYMBOL && hasOwnProperty$1(me.extraNodes, me.token)) {
      var Le = me.extraNodes[me.token];
      if (ge(me), me.token === "(") {
        if (Ee = [], De(me), ge(me), me.token !== ")") for (Ee.push(he(me)); me.token === ","; ) ge(me), Ee.push(he(me));
        if (me.token !== ")") throw Ye(me, "Parenthesis ) expected");
        Ce(me), ge(me);
      }
      return new Le(Ee);
    }
    return Xe(me);
  }
  function Xe(me) {
    var Ee, Le;
    return me.tokenType === ne.SYMBOL || me.tokenType === ne.DELIMITER && me.token in ue ? (Le = me.token, ge(me), Ee = hasOwnProperty$1(oe, Le) ? new U(oe[Le]) : se.includes(Le) ? new U(O(Le, "number")) : new K(Le), Ee = rr(me, Ee), Ee) : or(me);
  }
  function rr(me, Ee, Le) {
    for (var Ve; ; ) {
      var tr = !1;
      me.token === "?." && (tr = !0, ge(me));
      var ar = (me.token === "(" || me.token === "[" || me.token === ".") && !0;
      if (!(tr || ar)) break;
      if (Ve = [], me.token === "(") if (tr || isSymbolNode(Ee) || isAccessorNode(Ee)) {
        if (De(me), ge(me), me.token !== ")") for (Ve.push(he(me)); me.token === ","; ) ge(me), Ve.push(he(me));
        if (me.token !== ")") throw Ye(me, "Parenthesis ) expected");
        Ce(me), ge(me), Ee = new V(Ee, Ve, tr);
      } else return Ee;
      else if (me.token === "[") {
        if (De(me), ge(me), me.token !== "]") for (Ve.push(he(me)); me.token === ","; ) ge(me), Ve.push(he(me));
        if (me.token !== "]") throw Ye(me, "Parenthesis ] expected");
        Ce(me), ge(me), Ee = new I(Ee, new G(Ve), tr);
      } else {
        if (tr || ge(me), !(me.tokenType === ne.SYMBOL || me.tokenType === ne.DELIMITER && me.token in ue)) {
          var cr = "Property name expected after ";
          throw cr += tr ? "optional chain" : "dot", Ye(me, cr);
        }
        Ve.push(new U(me.token)), ge(me), Ee = new I(Ee, new G(Ve, !0), tr);
      }
    }
    return Ee;
  }
  function or(me) {
    var Ee, Le;
    return me.token === '"' || me.token === "'" ? (Le = lr(me, me.token), Ee = new U(Le), Ee = rr(me, Ee), Ee) : sr(me);
  }
  function lr(me, Ee) {
    for (var Le = ""; pe(me) !== "" && pe(me) !== Ee; ) if (pe(me) === "\\") {
      ve(me);
      var Ve = pe(me), tr = le[Ve];
      if (tr !== void 0) Le += tr, me.index += 1;
      else if (Ve === "u") {
        var ar = me.expression.slice(me.index + 1, me.index + 5);
        if (/^[0-9A-Fa-f]{4}$/.test(ar)) Le += String.fromCharCode(parseInt(ar, 16)), me.index += 5;
        else throw Ye(me, `Invalid unicode character \\u${ar}`);
      } else throw Ye(me, `Bad escape character \\${Ve}`);
    } else Le += pe(me), ve(me);
    if (ge(me), me.token !== Ee) throw Ye(me, `End of string ${Ee} expected`);
    return ge(me), Le;
  }
  function sr(me) {
    var Ee, Le, Ve, tr;
    if (me.token === "[") {
      if (De(me), ge(me), me.token !== "]") {
        var ar = Se(me);
        if (me.token === ";") {
          for (Ve = 1, Le = [ar]; me.token === ";"; ) ge(me), me.token !== "]" && (Le[Ve] = Se(me), Ve++);
          if (me.token !== "]") throw Ye(me, "End of matrix ] expected");
          Ce(me), ge(me), tr = Le[0].items.length;
          for (var cr = 1; cr < Ve; cr++) if (Le[cr].items.length !== tr) throw Je(me, "Column dimensions mismatch (" + Le[cr].items.length + " !== " + tr + ")");
          Ee = new z(Le);
        } else {
          if (me.token !== "]") throw Ye(me, "End of matrix ] expected");
          Ce(me), ge(me), Ee = ar;
        }
      } else Ce(me), ge(me), Ee = new z([]);
      return rr(me, Ee);
    }
    return Be(me);
  }
  function Se(me) {
    for (var Ee = [he(me)], Le = 1; me.token === ","; ) ge(me), me.token !== "]" && me.token !== ";" && (Ee[Le] = he(me), Le++);
    return new z(Ee);
  }
  function Be(me) {
    if (me.token === "{") {
      De(me);
      var Ee, Le = {};
      do
        if (ge(me), me.token !== "}") {
          if (me.token === '"' || me.token === "'") Ee = lr(me, me.token);
          else if (me.tokenType === ne.SYMBOL || me.tokenType === ne.DELIMITER && me.token in ue) Ee = me.token, ge(me);
          else throw Ye(me, "Symbol or string expected as object key");
          if (me.token !== ":") throw Ye(me, "Colon : expected after object key");
          ge(me), Le[Ee] = he(me);
        }
      while (me.token === ",");
      if (me.token !== "}") throw Ye(me, "Comma , or bracket } expected after object value");
      Ce(me), ge(me);
      var Ve = new W(Le);
      return Ve = rr(me, Ve), Ve;
    }
    return qe(me);
  }
  function qe(me) {
    var Ee;
    if (me.tokenType === ne.NUMBER) {
      Ee = me.token, ge(me);
      var Le = safeNumberType(Ee, F);
      return new U(O(Ee, Le));
    }
    return Ze(me);
  }
  function Ze(me) {
    var Ee;
    if (me.token === "(") {
      if (De(me), ge(me), Ee = he(me), me.token !== ")") throw Ye(me, "Parenthesis ) expected");
      return Ce(me), ge(me), Ee = new X(Ee), Ee = rr(me, Ee), Ee;
    }
    return He(me);
  }
  function He(me) {
    throw me.token === "" ? Ye(me, "Unexpected end of expression") : Ye(me, "Value expected");
  }
  function Ge(me) {
    return me.index - me.token.length + 1;
  }
  function Ye(me, Ee) {
    var Le = Ge(me), Ve = SyntaxError(Ee + " (char " + Le + ")");
    return Ve.char = Le, Ve;
  }
  function Je(me, Ee) {
    var Le = Ge(me), Ve = SyntaxError(Ee + " (char " + Le + ")");
    return Ve.char = Le, Ve;
  }
  return E.addConversion({ from: "string", to: "Node", convert: te }), te;
}), name$95 = "compile", dependencies$95 = ["typed", "parse"], createCompile = factory(name$95, dependencies$95, (D) => {
  var { typed: E, parse: O } = D;
  return E(name$95, { string: function(F) {
    return O(F).compile();
  }, "Array | Matrix": function(F) {
    return deepMap(F, function(I) {
      return O(I).compile();
    });
  } });
}), name$94 = "evaluate", dependencies$94 = ["typed", "parse"], createEvaluate = factory(name$94, dependencies$94, (D) => {
  var { typed: E, parse: O } = D;
  return E(name$94, { string: function(F) {
    var I = createEmptyMap();
    return O(F).compile().evaluate(I);
  }, "string, Map | Object": function(F, I) {
    return O(F).compile().evaluate(I);
  }, "Array | Matrix": function(F) {
    var I = createEmptyMap();
    return deepMap(F, function(z) {
      return O(z).compile().evaluate(I);
    });
  }, "Array | Matrix, Map | Object": function(F, I) {
    return deepMap(F, function(z) {
      return O(z).compile().evaluate(I);
    });
  } });
}), name$93 = "Parser", dependencies$93 = ["evaluate", "parse"], createParserClass = factory(name$93, dependencies$93, (D) => {
  var { evaluate: E, parse: O } = D;
  function F() {
    if (!(this instanceof F)) throw SyntaxError("Constructor must be called with the new operator");
    Object.defineProperty(this, "scope", { value: createEmptyMap(), writable: !1 });
  }
  F.prototype.type = "Parser", F.prototype.isParser = !0, F.prototype.evaluate = function(z) {
    return E(z, this.scope);
  }, F.prototype.get = function(z) {
    if (this.scope.has(z)) return this.scope.get(z);
  }, F.prototype.getAll = function() {
    return toObject(this.scope);
  }, F.prototype.getAllAsMap = function() {
    return this.scope;
  };
  function I(z) {
    if (z.length === 0) return !1;
    for (var R = 0; R < z.length; R++) {
      var L = z.charAt(R - 1), q = z.charAt(R), U = z.charAt(R + 1);
      if (!(O.isAlpha(q, L, U) || R > 0 && O.isDigit(q))) return !1;
    }
    return !0;
  }
  return F.prototype.set = function(z, R) {
    if (!I(z)) throw Error(`Invalid variable name: '${z}'. Variable names must follow the specified rules.`);
    return this.scope.set(z, R), R;
  }, F.prototype.remove = function(z) {
    this.scope.delete(z);
  }, F.prototype.clear = function() {
    this.scope.clear();
  }, F.prototype.toJSON = function() {
    var z = { mathjs: "Parser", variables: {}, functions: {} };
    for (var [R, L] of this.scope) if (isFunction$1(L)) {
      if (!isExpressionFunction(L)) throw Error(`Cannot serialize external function ${R}`);
      z.functions[R] = `${L.syntax} = ${L.expr}`;
    } else z.variables[R] = L;
    return z;
  }, F.fromJSON = function(z) {
    var R = new F();
    return Object.entries(z.variables).forEach((L) => {
      var [q, U] = L;
      return R.set(q, U);
    }), Object.entries(z.functions).forEach((L) => {
      var [q, U] = L;
      return R.evaluate(U);
    }), R;
  }, F;
}, { isClass: !0 });
function isExpressionFunction(D) {
  return typeof D == "function" && typeof D.syntax == "string" && typeof D.expr == "string";
}
var name$92 = "parser", dependencies$92 = ["typed", "Parser"], createParser = factory(name$92, dependencies$92, (D) => {
  var { typed: E, Parser: O } = D;
  return E(name$92, { "": function() {
    return new O();
  } });
}), name$91 = "lup", dependencies$91 = ["typed", "matrix", "abs", "addScalar", "divideScalar", "multiplyScalar", "subtractScalar", "larger", "equalScalar", "unaryMinus", "DenseMatrix", "SparseMatrix", "Spa"], createLup = factory(name$91, dependencies$91, (D) => {
  var { typed: E, matrix: O, abs: F, addScalar: I, divideScalar: z, multiplyScalar: R, subtractScalar: L, larger: q, equalScalar: U, unaryMinus: Z, DenseMatrix: V, SparseMatrix: G, Spa: W } = D;
  return E(name$91, { DenseMatrix: function(Y) {
    return J(Y);
  }, SparseMatrix: function(Y) {
    return X(Y);
  }, Array: function(Y) {
    var ee = J(O(Y));
    return { L: ee.L.valueOf(), U: ee.U.valueOf(), p: ee.p };
  } });
  function J(Y) {
    var ee = Y._size[0], K = Y._size[1], te = Math.min(ee, K), ie = clone$3(Y._data), ne = [], ae = [ee, te], ue = [], oe = [te, K], se, le, ce, fe = [];
    for (se = 0; se < ee; se++) fe[se] = se;
    for (le = 0; le < K; le++) {
      if (le > 0) for (se = 0; se < ee; se++) {
        var pe = Math.min(se, le), ve = 0;
        for (ce = 0; ce < pe; ce++) ve = I(ve, R(ie[se][ce], ie[ce][le]));
        ie[se][le] = L(ie[se][le], ve);
      }
      var _e = le, de = 0, ge = 0;
      for (se = le; se < ee; se++) {
        var ye = ie[se][le], De = F(ye);
        q(De, de) && (_e = se, de = De, ge = ye);
      }
      if (le !== _e && (fe[le] = [fe[_e], fe[_e] = fe[le]][0], V._swapRows(le, _e, ie)), le < ee) for (se = le + 1; se < ee; se++) {
        var Ce = ie[se][le];
        U(Ce, 0) || (ie[se][le] = z(ie[se][le], ge));
      }
    }
    for (le = 0; le < K; le++) for (se = 0; se < ee; se++) {
      if (le === 0 && (se < K && (ue[se] = []), ne[se] = []), se < le) {
        se < K && (ue[se][le] = ie[se][le]), le < ee && (ne[se][le] = 0);
        continue;
      }
      if (se === le) {
        se < K && (ue[se][le] = ie[se][le]), le < ee && (ne[se][le] = 1);
        continue;
      }
      se < K && (ue[se][le] = 0), le < ee && (ne[se][le] = ie[se][le]);
    }
    var Ie = new V({ data: ne, size: ae }), Ne = new V({ data: ue, size: oe }), he = [];
    for (se = 0, te = fe.length; se < te; se++) he[fe[se]] = se;
    return { L: Ie, U: Ne, p: he, toString: function() {
      return "L: " + this.L.toString() + `
U: ` + this.U.toString() + `
P: ` + this.p;
    } };
  }
  function X(Y) {
    var ee = Y._size[0], K = Y._size[1], te = Math.min(ee, K), ie = Y._values, ne = Y._index, ae = Y._ptr, ue = [], oe = [], se = [], le = [ee, te], ce = [], fe = [], pe = [], ve = [te, K], _e, de, ge, ye = [], De = [];
    for (_e = 0; _e < ee; _e++) ye[_e] = _e, De[_e] = _e;
    var Ce = function(Ne, he) {
      var ke = De[Ne], xe = De[he];
      ye[ke] = he, ye[xe] = Ne, De[Ne] = xe, De[he] = ke;
    }, Ie = function() {
      var Ne = new W();
      de < ee && (se.push(ue.length), ue.push(1), oe.push(de)), pe.push(ce.length);
      var he = ae[de], ke = ae[de + 1];
      for (ge = he; ge < ke; ge++) _e = ne[ge], Ne.set(ye[_e], ie[ge]);
      de > 0 && Ne.forEach(0, de - 1, function(be, Ae) {
        G._forEachRow(be, ue, oe, se, function(Me, $e) {
          Me > be && Ne.accumulate(Me, Z(R($e, Ae)));
        });
      });
      var xe = de, Te = Ne.get(de), Fe = F(Te);
      Ne.forEach(de + 1, ee - 1, function(be, Ae) {
        var Me = F(Ae);
        q(Me, Fe) && (xe = be, Fe = Me, Te = Ae);
      }), de !== xe && (G._swapRows(de, xe, le[1], ue, oe, se), G._swapRows(de, xe, ve[1], ce, fe, pe), Ne.swap(de, xe), Ce(de, xe)), Ne.forEach(0, ee - 1, function(be, Ae) {
        be <= de ? (ce.push(Ae), fe.push(be)) : (Ae = z(Ae, Te), U(Ae, 0) || (ue.push(Ae), oe.push(be)));
      });
    };
    for (de = 0; de < K; de++) Ie();
    return pe.push(ce.length), se.push(ue.length), { L: new G({ values: ue, index: oe, ptr: se, size: le }), U: new G({ values: ce, index: fe, ptr: pe, size: ve }), p: ye, toString: function() {
      return "L: " + this.L.toString() + `
U: ` + this.U.toString() + `
P: ` + this.p;
    } };
  }
}), name$90 = "qr", dependencies$90 = ["typed", "matrix", "zeros", "identity", "isZero", "equal", "sign", "sqrt", "conj", "unaryMinus", "addScalar", "divideScalar", "multiplyScalar", "subtractScalar", "complex"], createQr = factory(name$90, dependencies$90, (D) => {
  var { typed: E, matrix: O, zeros: F, identity: I, isZero: z, equal: R, sign: L, sqrt: q, conj: U, unaryMinus: Z, addScalar: V, divideScalar: G, multiplyScalar: W, subtractScalar: J, complex: X } = D;
  return _extends(E(name$90, { DenseMatrix: function(te) {
    return ee(te);
  }, SparseMatrix: function(te) {
    return K();
  }, Array: function(te) {
    var ie = ee(O(te));
    return { Q: ie.Q.valueOf(), R: ie.R.valueOf() };
  } }), { _denseQRimpl: Y });
  function Y(te) {
    var ie = te._size[0], ne = te._size[1], ae = I([ie], "dense"), ue = ae._data, oe = te.clone(), se = oe._data, le, ce, fe, pe = F([ie], "");
    for (fe = 0; fe < Math.min(ne, ie); ++fe) {
      var ve = se[fe][fe], _e = Z(R(ve, 0) ? 1 : L(ve)), de = U(_e), ge = 0;
      for (le = fe; le < ie; le++) ge = V(ge, W(se[le][fe], U(se[le][fe])));
      var ye = W(_e, q(ge));
      if (!z(ye)) {
        var De = J(ve, ye);
        for (pe[fe] = 1, le = fe + 1; le < ie; le++) pe[le] = G(se[le][fe], De);
        var Ce = Z(U(G(De, ye))), Ie = void 0;
        for (ce = fe; ce < ne; ce++) {
          for (Ie = 0, le = fe; le < ie; le++) Ie = V(Ie, W(U(pe[le]), se[le][ce]));
          for (Ie = W(Ie, Ce), le = fe; le < ie; le++) se[le][ce] = W(J(se[le][ce], W(pe[le], Ie)), de);
        }
        for (le = 0; le < ie; le++) {
          for (Ie = 0, ce = fe; ce < ie; ce++) Ie = V(Ie, W(ue[le][ce], pe[ce]));
          for (Ie = W(Ie, Ce), ce = fe; ce < ie; ++ce) ue[le][ce] = G(J(ue[le][ce], W(Ie, U(pe[ce]))), de);
        }
      }
    }
    return { Q: ae, R: oe, toString: function() {
      return "Q: " + this.Q.toString() + `
R: ` + this.R.toString();
    } };
  }
  function ee(te) {
    var ie = Y(te), ne = ie.R._data;
    if (te._data.length > 0) for (var ae = ne[0][0].type === "Complex" ? X(0) : 0, ue = 0; ue < ne.length; ++ue) for (var oe = 0; oe < ue && oe < (ne[0] || []).length; ++oe) ne[ue][oe] = ae;
    return ie;
  }
  function K(te) {
    throw Error("qr not implemented for sparse matrices yet");
  }
});
function csPermute(D, E, O, F) {
  for (var I = D._values, z = D._index, R = D._ptr, L = D._size, q = D._datatype, U = L[0], Z = L[1], V = null, G = [], W = [], J = 0, X = 0; X < Z; X++) {
    W[X] = J;
    for (var Y = O ? O[X] : X, ee = R[Y], K = R[Y + 1], te = ee; te < K; te++) G[J] = z[te], V && (V[J] = I[te]), J++;
  }
  return W[Z] = J, D.createSparseMatrix({ values: V, index: G, ptr: W, size: [U, Z], datatype: q });
}
function csTdfs(D, E, O, F, I, z, R) {
  var L = 0;
  for (O[R] = D; L >= 0; ) {
    var q = O[R + L], U = O[F + q];
    U === -1 ? (L--, z[E++] = q) : (O[F + q] = O[I + U], ++L, O[R + L] = U);
  }
  return E;
}
function csPost(D, E) {
  if (!D) return null;
  var O = 0, F, I = [], z = [], R = 0, L = E, q = 2 * E;
  for (F = 0; F < E; F++) z[R + F] = -1;
  for (F = E - 1; F >= 0; F--) D[F] !== -1 && (z[L + F] = z[R + D[F]], z[R + D[F]] = F);
  for (F = 0; F < E; F++) D[F] === -1 && (O = csTdfs(F, O, z, R, L, I, q));
  return I;
}
function csEtree(D, E) {
  if (!D) return null;
  var O = D._index, F = D._ptr, I = D._size, z = I[0], R = I[1], L = [], q = [], U = 0, Z = R, V, G;
  for (V = 0; V < z; V++) q[Z + V] = -1;
  for (var W = 0; W < R; W++) {
    L[W] = -1, q[U + W] = -1;
    for (var J = F[W], X = F[W + 1], Y = J; Y < X; Y++) {
      var ee = O[Y];
      for (V = q[Z + ee]; V !== -1 && V < W; V = G) G = q[U + V], q[U + V] = W, G === -1 && (L[V] = W);
      q[Z + ee] = W;
    }
  }
  return L;
}
function csFkeep(D, E, O) {
  for (var F = D._values, I = D._index, z = D._ptr, R = D._size[1], L = 0, q = 0; q < R; q++) {
    var U = z[q];
    for (z[q] = L; U < z[q + 1]; U++) E(I[U], q, F ? F[U] : 1, O) && (I[L] = I[U], F && (F[L] = F[U]), L++);
  }
  return z[R] = L, I.splice(L, I.length - L), F && F.splice(L, F.length - L), L;
}
function csFlip(D) {
  return -D - 2;
}
var name$89 = "csAmd", dependencies$89 = ["add", "multiply", "transpose"], createCsAmd = factory(name$89, dependencies$89, (D) => {
  var { add: E, multiply: O, transpose: F } = D;
  return function(U, Z) {
    if (!Z || U <= 0 || U > 3) return null;
    var V = Z._size, G = V[0], W = V[1], J = 0, X = Math.max(16, 10 * Math.sqrt(W));
    X = Math.min(W - 2, X);
    var Y = I(U, Z, G, W, X);
    csFkeep(Y, q, null);
    for (var ee = Y._index, K = Y._ptr, te = K[W], ie = [], ne = [], ae = 0, ue = W + 1, oe = 2 * (W + 1), se = 3 * (W + 1), le = 4 * (W + 1), ce = 5 * (W + 1), fe = 6 * (W + 1), pe = 7 * (W + 1), ve = ie, _e = z(W, K, ne, ae, se, ve, oe, pe, ue, fe, le, ce), de = R(W, K, ne, ce, le, fe, X, ue, se, ve, oe), ge = 0, ye, De, Ce, Ie, Ne, he, ke, xe, Te, Fe, be, Ae, Me, $e, Re, je; de < W; ) {
      for (Ce = -1; ge < W && (Ce = ne[se + ge]) === -1; ge++) ;
      ne[oe + Ce] !== -1 && (ve[ne[oe + Ce]] = -1), ne[se + ge] = ne[oe + Ce];
      var Pe = ne[le + Ce], Ke = ne[ue + Ce];
      de += Ke;
      var Qe = 0;
      ne[ue + Ce] = -Ke;
      var We = K[Ce], ir = Pe === 0 ? We : te, nr = ir;
      for (Ie = 1; Ie <= Pe + 1; Ie++) {
        for (Ie > Pe ? (he = Ce, ke = We, xe = ne[ae + Ce] - Pe) : (he = ee[We++], ke = K[he], xe = ne[ae + he]), Ne = 1; Ne <= xe; Ne++) ye = ee[ke++], !((Te = ne[ue + ye]) <= 0) && (Qe += Te, ne[ue + ye] = -Te, ee[nr++] = ye, ne[oe + ye] !== -1 && (ve[ne[oe + ye]] = ve[ye]), ve[ye] === -1 ? ne[se + ne[ce + ye]] = ne[oe + ye] : ne[oe + ve[ye]] = ne[oe + ye]);
        he !== Ce && (K[he] = csFlip(Ce), ne[fe + he] = 0);
      }
      for (Pe !== 0 && (te = nr), ne[ce + Ce] = Qe, K[Ce] = ir, ne[ae + Ce] = nr - ir, ne[le + Ce] = -2, _e = L(_e, J, ne, fe, W), Fe = ir; Fe < nr; Fe++) if (ye = ee[Fe], !((be = ne[le + ye]) <= 0)) {
        Te = -ne[ue + ye];
        var we = _e - Te;
        for (We = K[ye], Ae = K[ye] + be - 1; We <= Ae; We++) he = ee[We], ne[fe + he] >= _e ? ne[fe + he] -= Te : ne[fe + he] !== 0 && (ne[fe + he] = ne[ce + he] + we);
      }
      for (Fe = ir; Fe < nr; Fe++) {
        for (ye = ee[Fe], Ae = K[ye], Me = Ae + ne[le + ye] - 1, $e = Ae, Re = 0, je = 0, We = Ae; We <= Me; We++) if (he = ee[We], ne[fe + he] !== 0) {
          var Oe = ne[fe + he] - _e;
          Oe > 0 ? (je += Oe, ee[$e++] = he, Re += he) : (K[he] = csFlip(Ce), ne[fe + he] = 0);
        }
        ne[le + ye] = $e - Ae + 1;
        var ze = $e, Ue = Ae + ne[ae + ye];
        for (We = Me + 1; We < Ue; We++) {
          De = ee[We];
          var er = ne[ue + De];
          er <= 0 || (je += er, ee[$e++] = De, Re += De);
        }
        je === 0 ? (K[ye] = csFlip(Ce), Te = -ne[ue + ye], Qe -= Te, Ke += Te, de += Te, ne[ue + ye] = 0, ne[le + ye] = -1) : (ne[ce + ye] = Math.min(ne[ce + ye], je), ee[$e] = ee[ze], ee[ze] = ee[Ae], ee[Ae] = Ce, ne[ae + ye] = $e - Ae + 1, Re = (Re < 0 ? -Re : Re) % W, ne[oe + ye] = ne[pe + Re], ne[pe + Re] = ye, ve[ye] = Re);
      }
      for (ne[ce + Ce] = Qe, J = Math.max(J, Qe), _e = L(_e + J, J, ne, fe, W), Fe = ir; Fe < nr; Fe++) if (ye = ee[Fe], !(ne[ue + ye] >= 0)) for (Re = ve[ye], ye = ne[pe + Re], ne[pe + Re] = -1; ye !== -1 && ne[oe + ye] !== -1; ye = ne[oe + ye], _e++) {
        for (xe = ne[ae + ye], be = ne[le + ye], We = K[ye] + 1; We <= K[ye] + xe - 1; We++) ne[fe + ee[We]] = _e;
        var Xe = ye;
        for (De = ne[oe + ye]; De !== -1; ) {
          var rr = ne[ae + De] === xe && ne[le + De] === be;
          for (We = K[De] + 1; rr && We <= K[De] + xe - 1; We++) ne[fe + ee[We]] !== _e && (rr = 0);
          rr ? (K[De] = csFlip(ye), ne[ue + ye] += ne[ue + De], ne[ue + De] = 0, ne[le + De] = -1, De = ne[oe + De], ne[oe + Xe] = De) : (Xe = De, De = ne[oe + De]);
        }
      }
      for (We = ir, Fe = ir; Fe < nr; Fe++) ye = ee[Fe], !((Te = -ne[ue + ye]) <= 0) && (ne[ue + ye] = Te, je = ne[ce + ye] + Qe - Te, je = Math.min(je, W - de - Te), ne[se + je] !== -1 && (ve[ne[se + je]] = ye), ne[oe + ye] = ne[se + je], ve[ye] = -1, ne[se + je] = ye, ge = Math.min(ge, je), ne[ce + ye] = je, ee[We++] = ye);
      ne[ue + Ce] = Ke, (ne[ae + Ce] = We - ir) === 0 && (K[Ce] = -1, ne[fe + Ce] = 0), Pe !== 0 && (te = We);
    }
    for (ye = 0; ye < W; ye++) K[ye] = csFlip(K[ye]);
    for (De = 0; De <= W; De++) ne[se + De] = -1;
    for (De = W; De >= 0; De--) ne[ue + De] > 0 || (ne[oe + De] = ne[se + K[De]], ne[se + K[De]] = De);
    for (he = W; he >= 0; he--) ne[ue + he] <= 0 || K[he] !== -1 && (ne[oe + he] = ne[se + K[he]], ne[se + K[he]] = he);
    for (Ce = 0, ye = 0; ye <= W; ye++) K[ye] === -1 && (Ce = csTdfs(ye, Ce, ne, se, oe, ie, fe));
    return ie.splice(ie.length - 1, 1), ie;
  };
  function I(U, Z, V, G, W) {
    var J = F(Z);
    if (U === 1 && G === V) return E(Z, J);
    if (U === 2) {
      for (var X = J._index, Y = J._ptr, ee = 0, K = 0; K < V; K++) {
        var te = Y[K];
        if (Y[K] = ee, !(Y[K + 1] - te > W)) for (var ie = Y[K + 1]; te < ie; te++) X[ee++] = X[te];
      }
      return Y[V] = ee, Z = F(J), O(J, Z);
    }
    return O(J, Z);
  }
  function z(U, Z, V, G, W, J, X, Y, ee, K, te, ie) {
    for (var ne = 0; ne < U; ne++) V[G + ne] = Z[ne + 1] - Z[ne];
    V[G + U] = 0;
    for (var ae = 0; ae <= U; ae++) V[W + ae] = -1, J[ae] = -1, V[X + ae] = -1, V[Y + ae] = -1, V[ee + ae] = 1, V[K + ae] = 1, V[te + ae] = 0, V[ie + ae] = V[G + ae];
    var ue = L(0, 0, V, K, U);
    return V[te + U] = -2, Z[U] = -1, V[K + U] = 0, ue;
  }
  function R(U, Z, V, G, W, J, X, Y, ee, K, te) {
    for (var ie = 0, ne = 0; ne < U; ne++) {
      var ae = V[G + ne];
      if (ae === 0) V[W + ne] = -2, ie++, Z[ne] = -1, V[J + ne] = 0;
      else if (ae > X) V[Y + ne] = 0, V[W + ne] = -1, ie++, Z[ne] = csFlip(U), V[Y + U]++;
      else {
        var ue = V[ee + ae];
        ue !== -1 && (K[ue] = ne), V[te + ne] = V[ee + ae], V[ee + ae] = ne;
      }
    }
    return ie;
  }
  function L(U, Z, V, G, W) {
    if (U < 2 || U + Z < 0) {
      for (var J = 0; J < W; J++) V[G + J] !== 0 && (V[G + J] = 1);
      U = 2;
    }
    return U;
  }
  function q(U, Z) {
    return U !== Z;
  }
});
function csLeaf(D, E, O, F, I, z, R) {
  var L, q, U = 0, Z;
  if (D <= E || O[F + E] <= O[I + D]) return -1;
  O[I + D] = O[F + E];
  var V = O[z + D];
  if (O[z + D] = E, V === -1) U = 1, Z = D;
  else {
    for (U = 2, Z = V; Z !== O[R + Z]; Z = O[R + Z]) ;
    for (L = V; L !== Z; L = q) q = O[R + L], O[R + L] = Z;
  }
  return { jleaf: U, q: Z };
}
var name$88 = "csCounts", dependencies$88 = ["transpose"], createCsCounts = factory(name$88, dependencies$88, (D) => {
  var { transpose: E } = D;
  return function(O, F, I, z) {
    if (!O || !F || !I) return null;
    var R = O._size, L = R[0], q = R[1], U, Z, V, G, W, J, X, Y = 4 * q + (z ? q + L + 1 : 0), ee = [], K = 0, te = q, ie = 2 * q, ne = 3 * q, ae = 4 * q, ue = 5 * q + 1;
    for (V = 0; V < Y; V++) ee[V] = -1;
    var oe = [], se = E(O), le = se._index, ce = se._ptr;
    for (V = 0; V < q; V++) for (Z = I[V], oe[Z] = +(ee[ne + Z] === -1); Z !== -1 && ee[ne + Z] === -1; Z = F[Z]) ee[ne + Z] = V;
    if (z) {
      for (V = 0; V < q; V++) ee[I[V]] = V;
      for (U = 0; U < L; U++) {
        for (V = q, J = ce[U], X = ce[U + 1], W = J; W < X; W++) V = Math.min(V, ee[le[W]]);
        ee[ue + U] = ee[ae + V], ee[ae + V] = U;
      }
    }
    for (U = 0; U < q; U++) ee[K + U] = U;
    for (V = 0; V < q; V++) {
      for (Z = I[V], F[Z] !== -1 && oe[F[Z]]--, G = z ? ee[ae + V] : Z; G !== -1; G = z ? ee[ue + G] : -1) for (W = ce[G]; W < ce[G + 1]; W++) {
        U = le[W];
        var fe = csLeaf(U, Z, ee, ne, te, ie, K);
        fe.jleaf >= 1 && oe[Z]++, fe.jleaf === 2 && oe[fe.q]--;
      }
      F[Z] !== -1 && (ee[K + Z] = F[Z]);
    }
    for (Z = 0; Z < q; Z++) F[Z] !== -1 && (oe[F[Z]] += oe[Z]);
    return oe;
  };
}), name$87 = "csSqr", dependencies$87 = ["add", "multiply", "transpose"], createCsSqr = factory(name$87, dependencies$87, (D) => {
  var { add: E, multiply: O, transpose: F } = D, I = createCsAmd({ add: E, multiply: O, transpose: F }), z = createCsCounts({ transpose: F });
  return function(L, q, U) {
    var Z = q._ptr, V = q._size[1], G, W = {};
    if (W.q = I(L, q), L && !W.q) return null;
    if (U) {
      var J = L ? csPermute(q, null, W.q) : q;
      W.parent = csEtree(J);
      var X = csPost(W.parent, V);
      if (W.cp = z(J, W.parent, X, 1), J && W.parent && W.cp && R(J, W)) for (W.unz = 0, G = 0; G < V; G++) W.unz += W.cp[G];
    } else W.unz = 4 * Z[V] + V, W.lnz = W.unz;
    return W;
  };
  function R(L, q) {
    var U = L._ptr, Z = L._index, V = L._size, G = V[0], W = V[1];
    q.pinv = [], q.leftmost = [];
    var J = q.parent, X = q.pinv, Y = q.leftmost, ee = [], K = 0, te = G, ie = G + W, ne = G + 2 * W, ae, ue, oe, se, le;
    for (ue = 0; ue < W; ue++) ee[te + ue] = -1, ee[ie + ue] = -1, ee[ne + ue] = 0;
    for (ae = 0; ae < G; ae++) Y[ae] = -1;
    for (ue = W - 1; ue >= 0; ue--) for (se = U[ue], le = U[ue + 1], oe = se; oe < le; oe++) Y[Z[oe]] = ue;
    for (ae = G - 1; ae >= 0; ae--) X[ae] = -1, ue = Y[ae], ue !== -1 && (ee[ne + ue]++ === 0 && (ee[ie + ue] = ae), ee[K + ae] = ee[te + ue], ee[te + ue] = ae);
    for (q.lnz = 0, q.m2 = G, ue = 0; ue < W; ue++) if (ae = ee[te + ue], q.lnz++, ae < 0 && (ae = q.m2++), X[ae] = ue, !(--ne[ue] <= 0)) {
      q.lnz += ee[ne + ue];
      var ce = J[ue];
      ce !== -1 && (ee[ne + ce] === 0 && (ee[ie + ce] = ee[ie + ue]), ee[K + ee[ie + ue]] = ee[te + ce], ee[te + ce] = ee[K + ae], ee[ne + ce] += ee[ne + ue]);
    }
    for (ae = 0; ae < G; ae++) X[ae] < 0 && (X[ae] = ue++);
    return !0;
  }
});
function csMarked(D, E) {
  return D[E] < 0;
}
function csMark(D, E) {
  D[E] = csFlip(D[E]);
}
function csUnflip(D) {
  return D < 0 ? csFlip(D) : D;
}
function csDfs(D, E, O, F, I) {
  var z = E._index, R = E._ptr, L = E._size[1], q, U, Z, V = 0;
  for (F[0] = D; V >= 0; ) {
    D = F[V];
    var G = I ? I[D] : D;
    csMarked(R, D) || (csMark(R, D), F[L + V] = G < 0 ? 0 : csUnflip(R[G]));
    var W = 1;
    for (U = F[L + V], Z = G < 0 ? 0 : csUnflip(R[G + 1]); U < Z; U++) if (q = z[U], !csMarked(R, q)) {
      F[L + V] = U, F[++V] = q, W = 0;
      break;
    }
    W && (V--, F[--O] = D);
  }
  return O;
}
function csReach(D, E, O, F, I) {
  var z = D._ptr, R = D._size, L = E._index, q = E._ptr, U = R[1], Z, V, G, W = U;
  for (V = q[O], G = q[O + 1], Z = V; Z < G; Z++) {
    var J = L[Z];
    csMarked(z, J) || (W = csDfs(J, D, W, F, I));
  }
  for (Z = W; Z < U; Z++) csMark(z, F[Z]);
  return W;
}
var name$86 = "csSpsolve", dependencies$86 = ["divideScalar", "multiply", "subtract"], createCsSpsolve = factory(name$86, dependencies$86, (D) => {
  var { divideScalar: E, multiply: O, subtract: F } = D;
  return function(I, z, R, L, q, U, Z) {
    var V = I._values, G = I._index, W = I._ptr, J = I._size[1], X = z._values, Y = z._index, ee = z._ptr, K, te, ie, ne, ae = csReach(I, z, R, L, U);
    for (K = ae; K < J; K++) q[L[K]] = 0;
    for (te = ee[R], ie = ee[R + 1], K = te; K < ie; K++) q[Y[K]] = X[K];
    for (var ue = ae; ue < J; ue++) {
      var oe = L[ue], se = U ? U[oe] : oe;
      if (!(se < 0)) for (te = W[se], ie = W[se + 1], q[oe] = E(q[oe], V[Z ? te : ie - 1]), K = Z ? te + 1 : te, ne = Z ? ie : ie - 1; K < ne; K++) {
        var le = G[K];
        q[le] = F(q[le], O(V[K], q[oe]));
      }
    }
    return ae;
  };
}), name$85 = "csLu", dependencies$85 = ["abs", "divideScalar", "multiply", "subtract", "larger", "largerEq", "SparseMatrix"], createCsLu = factory(name$85, dependencies$85, (D) => {
  var { abs: E, divideScalar: O, multiply: F, subtract: I, larger: z, largerEq: R, SparseMatrix: L } = D, q = createCsSpsolve({ divideScalar: O, multiply: F, subtract: I });
  return function(U, Z, V) {
    if (!U) return null;
    var G = U._size[1], W, J = 100, X = 100;
    Z && (W = Z.q, J = Z.lnz || J, X = Z.unz || X);
    var Y = [], ee = [], K = [], te = new L({ values: Y, index: ee, ptr: K, size: [G, G] }), ie = [], ne = [], ae = [], ue = new L({ values: ie, index: ne, ptr: ae, size: [G, G] }), oe = [], se, le, ce = [], fe = [];
    for (se = 0; se < G; se++) ce[se] = 0, oe[se] = -1, K[se + 1] = 0;
    J = 0, X = 0;
    for (var pe = 0; pe < G; pe++) {
      K[pe] = J, ae[pe] = X;
      var ve = W ? W[pe] : pe, _e = q(te, U, ve, fe, ce, oe, 1), de = -1, ge = -1;
      for (le = _e; le < G; le++) if (se = fe[le], oe[se] < 0) {
        var ye = E(ce[se]);
        z(ye, ge) && (ge = ye, de = se);
      } else ne[X] = oe[se], ie[X++] = ce[se];
      if (de === -1 || ge <= 0) return null;
      oe[ve] < 0 && R(E(ce[ve]), F(ge, V)) && (de = ve);
      var De = ce[de];
      for (ne[X] = pe, ie[X++] = De, oe[de] = pe, ee[J] = de, Y[J++] = 1, le = _e; le < G; le++) se = fe[le], oe[se] < 0 && (ee[J] = se, Y[J++] = O(ce[se], De)), ce[se] = 0;
    }
    for (K[G] = J, ae[G] = X, le = 0; le < J; le++) ee[le] = oe[ee[le]];
    return Y.splice(J, Y.length - J), ee.splice(J, ee.length - J), ie.splice(X, ie.length - X), ne.splice(X, ne.length - X), { L: te, U: ue, pinv: oe };
  };
}), name$84 = "slu", dependencies$84 = ["typed", "abs", "add", "multiply", "transpose", "divideScalar", "subtract", "larger", "largerEq", "SparseMatrix"], createSlu = factory(name$84, dependencies$84, (D) => {
  var { typed: E, abs: O, add: F, multiply: I, transpose: z, divideScalar: R, subtract: L, larger: q, largerEq: U, SparseMatrix: Z } = D, V = createCsSqr({ add: F, multiply: I, transpose: z }), G = createCsLu({ abs: O, divideScalar: R, multiply: I, subtract: L, larger: q, largerEq: U, SparseMatrix: Z });
  return E(name$84, { "SparseMatrix, number, number": function(W, J, X) {
    if (!isInteger(J) || J < 0 || J > 3) throw Error("Symbolic Ordering and Analysis order must be an integer number in the interval [0, 3]");
    if (X < 0 || X > 1) throw Error("Partial pivoting threshold must be a number from 0 to 1");
    var Y = V(J, W, !1), ee = G(W, Y, X);
    return { L: ee.L, U: ee.U, p: ee.pinv, q: Y.q, toString: function() {
      return "L: " + this.L.toString() + `
U: ` + this.U.toString() + `
p: ` + this.p.toString() + (this.q ? `
q: ` + this.q.toString() : "") + `
`;
    } };
  } });
});
function csIpvec(D, E) {
  var O, F = E.length, I = [];
  if (D) for (O = 0; O < F; O++) I[D[O]] = E[O];
  else for (O = 0; O < F; O++) I[O] = E[O];
  return I;
}
var name$83 = "lusolve", dependencies$83 = ["typed", "matrix", "lup", "slu", "usolve", "lsolve", "DenseMatrix"], createLusolve = factory(name$83, dependencies$83, (D) => {
  var { typed: E, matrix: O, lup: F, slu: I, usolve: z, lsolve: R, DenseMatrix: L } = D, q = createSolveValidation({ DenseMatrix: L });
  return E(name$83, { "Array, Array | Matrix": function(V, G) {
    V = O(V);
    var W = F(V);
    return Z(W.L, W.U, W.p, null, G).valueOf();
  }, "DenseMatrix, Array | Matrix": function(V, G) {
    var W = F(V);
    return Z(W.L, W.U, W.p, null, G);
  }, "SparseMatrix, Array | Matrix": function(V, G) {
    var W = F(V);
    return Z(W.L, W.U, W.p, null, G);
  }, "SparseMatrix, Array | Matrix, number, number": function(V, G, W, J) {
    var X = I(V, W, J);
    return Z(X.L, X.U, X.p, X.q, G);
  }, "Object, Array | Matrix": function(V, G) {
    return Z(V.L, V.U, V.p, V.q, G);
  } });
  function U(V) {
    if (isMatrix(V)) return V;
    if (isArray(V)) return O(V);
    throw TypeError("Invalid Matrix LU decomposition");
  }
  function Z(V, G, W, J, X) {
    V = U(V), G = U(G), W && (X = q(V, X, !0), X._data = csIpvec(W, X._data));
    var Y = R(V, X), ee = z(G, Y);
    return J && (ee._data = csIpvec(J, ee._data)), ee;
  }
}), name$82 = "polynomialRoot", dependencies$82 = ["typed", "isZero", "equalScalar", "add", "subtract", "multiply", "divide", "sqrt", "unaryMinus", "cbrt", "typeOf", "im", "re"], createPolynomialRoot = factory(name$82, dependencies$82, (D) => {
  var { typed: E, isZero: O, equalScalar: F, add: I, subtract: z, multiply: R, divide: L, sqrt: q, unaryMinus: U, cbrt: Z, typeOf: V, im: G, re: W } = D;
  return E(name$82, { "number|Complex, ...number|Complex": (J, X) => {
    for (var Y = [J, ...X]; Y.length > 0 && O(Y[Y.length - 1]); ) Y.pop();
    if (Y.length < 2) throw RangeError(`Polynomial [${J}, ${X}] must have a non-zero non-constant coefficient`);
    switch (Y.length) {
      case 2:
        return [U(L(Y[0], Y[1]))];
      case 3:
        var [ee, K, te] = Y, ie = R(2, te), ne = R(K, K), ae = R(4, te, ee);
        if (F(ne, ae)) return [L(U(K), ie)];
        var ue = q(z(ne, ae));
        return [L(z(ue, K), ie), L(z(U(ue), K), ie)];
      case 4:
        var [oe, se, le, ce] = Y, fe = U(R(3, ce)), pe = R(le, le), ve = R(3, ce, se), _e = I(R(2, le, le, le), R(27, ce, ce, oe)), de = R(9, ce, le, se);
        if (F(pe, ve) && F(_e, de)) return [L(le, fe)];
        var ge = z(pe, ve), ye = z(_e, de);
        return F(I(R(18, ce, le, se, oe), R(le, le, se, se)), I(R(4, le, le, le, oe), R(4, ce, se, se, se), R(27, ce, ce, oe, oe))) ? [L(z(R(4, ce, le, se), I(R(9, ce, ce, oe), R(le, le, le))), R(ce, ge)), L(z(R(9, ce, oe), R(le, se)), R(2, ge))] : Z(F(pe, ve) ? ye : L(I(ye, q(z(R(ye, ye), R(4, ge, ge, ge)))), 2), !0).toArray().map((De) => L(I(le, De, L(ge, De)), fe)).map((De) => V(De) === "Complex" && F(W(De), W(De) + G(De)) ? W(De) : De);
      default:
        throw RangeError(`only implemented for cubic or lower-order polynomials, not ${Y}`);
    }
  } });
}), name$81 = "Help", dependencies$81 = ["evaluate"], createHelpClass = factory(name$81, dependencies$81, (D) => {
  var { evaluate: E } = D;
  function O(F) {
    if (!(this instanceof O)) throw SyntaxError("Constructor must be called with the new operator");
    if (!F) throw Error('Argument "doc" missing');
    this.doc = F;
  }
  return O.prototype.type = "Help", O.prototype.isHelp = !0, O.prototype.toString = function() {
    var F = this.doc || {}, I = `
`;
    if (F.name && (I += "Name: " + F.name + `

`), F.category && (I += "Category: " + F.category + `

`), F.description && (I += `Description:
    ` + F.description + `

`), F.syntax && (I += `Syntax:
    ` + F.syntax.join(`
    `) + `

`), F.examples) {
      I += `Examples:
`;
      for (var z = !1, R = E("config()"), L = { config: (V) => (z = !0, E("config(newConfig)", { newConfig: V })) }, q = 0; q < F.examples.length; q++) {
        var U = F.examples[q];
        I += "    " + U + `
`;
        var Z = void 0;
        try {
          Z = E(U, L);
        } catch (V) {
          Z = V;
        }
        Z !== void 0 && !isHelp(Z) && (I += "        " + format(Z, { precision: 14 }) + `
`);
      }
      I += `
`, z && E("config(originalConfig)", { originalConfig: R });
    }
    return F.mayThrow && F.mayThrow.length && (I += "Throws: " + F.mayThrow.join(", ") + `

`), F.seealso && F.seealso.length && (I += "See also: " + F.seealso.join(", ") + `
`), I;
  }, O.prototype.toJSON = function() {
    var F = clone$3(this.doc);
    return F.mathjs = "Help", F;
  }, O.fromJSON = function(F) {
    var I = {};
    return Object.keys(F).filter((z) => z !== "mathjs").forEach((z) => {
      I[z] = F[z];
    }), new O(I);
  }, O.prototype.valueOf = O.prototype.toString, O;
}, { isClass: !0 }), name$80 = "Chain", dependencies$80 = ["?on", "math", "typed"], createChainClass = factory(name$80, dependencies$80, (D) => {
  var { on: E, math: O, typed: F } = D;
  function I(U) {
    if (!(this instanceof I)) throw SyntaxError("Constructor must be called with the new operator");
    isChain(U) ? this.value = U.value : this.value = U;
  }
  I.prototype.type = "Chain", I.prototype.isChain = !0, I.prototype.done = function() {
    return this.value;
  }, I.prototype.valueOf = function() {
    return this.value;
  }, I.prototype.toString = function() {
    return format(this.value);
  }, I.prototype.toJSON = function() {
    return { mathjs: "Chain", value: this.value };
  }, I.fromJSON = function(U) {
    return new I(U.value);
  };
  function z(U, Z) {
    typeof Z == "function" && (I.prototype[U] = L(Z));
  }
  function R(U, Z) {
    lazy(I.prototype, U, function() {
      var V = Z();
      if (typeof V == "function") return L(V);
    });
  }
  function L(U) {
    return function() {
      if (arguments.length === 0) return new I(U(this.value));
      for (var Z = [this.value], V = 0; V < arguments.length; V++) Z[V + 1] = arguments[V];
      if (F.isTypedFunction(U)) {
        var G = F.resolve(U, Z);
        if (G.params.length === 1) throw Error("chain function " + U.name + " cannot match rest parameter between chain value and additional arguments.");
        return new I(G.implementation.apply(U, Z));
      }
      return new I(U.apply(U, Z));
    };
  }
  I.createProxy = function(U, Z) {
    if (typeof U == "string") z(U, Z);
    else {
      var V = function(W) {
        hasOwnProperty$1(U, W) && q[W] === void 0 && R(W, () => U[W]);
      };
      for (var G in U) V(G);
    }
  };
  var q = { expression: !0, docs: !0, type: !0, classes: !0, json: !0, error: !0, isChain: !0 };
  return I.createProxy(O), E && E("import", function(U, Z, V) {
    V || R(U, Z);
  }), I;
}, { isClass: !0 }), eDocs = { name: "e", category: "Constants", syntax: ["e"], description: "Euler's number, the base of the natural logarithm. Approximately equal to 2.71828", examples: ["e", "e ^ 2", "exp(2)", "log(e)"], seealso: ["exp"] }, falseDocs = { name: "false", category: "Constants", syntax: ["false"], description: "Boolean value false", examples: ["false"], seealso: ["true"] }, iDocs = { name: "i", category: "Constants", syntax: ["i"], description: "Imaginary unit, defined as i*i=-1. A complex number is described as a + b*i, where a is the real part, and b is the imaginary part.", examples: ["i", "i * i", "sqrt(-1)"], seealso: [] }, InfinityDocs = { name: "Infinity", category: "Constants", syntax: ["Infinity"], description: "Infinity, a number which is larger than the maximum number that can be handled by a floating point number.", examples: ["Infinity", "1 / 0"], seealso: [] }, LN10Docs = { name: "LN10", category: "Constants", syntax: ["LN10"], description: "Returns the natural logarithm of 10, approximately equal to 2.302", examples: ["LN10", "log(10)"], seealso: [] }, LN2Docs = { name: "LN2", category: "Constants", syntax: ["LN2"], description: "Returns the natural logarithm of 2, approximately equal to 0.693", examples: ["LN2", "log(2)"], seealso: [] }, LOG10EDocs = { name: "LOG10E", category: "Constants", syntax: ["LOG10E"], description: "Returns the base-10 logarithm of E, approximately equal to 0.434", examples: ["LOG10E", "log(e, 10)"], seealso: [] }, LOG2EDocs = { name: "LOG2E", category: "Constants", syntax: ["LOG2E"], description: "Returns the base-2 logarithm of E, approximately equal to 1.442", examples: ["LOG2E", "log(e, 2)"], seealso: [] }, NaNDocs = { name: "NaN", category: "Constants", syntax: ["NaN"], description: "Not a number", examples: ["NaN", "0 / 0"], seealso: [] }, nullDocs = { name: "null", category: "Constants", syntax: ["null"], description: "Value null", examples: ["null"], seealso: ["true", "false"] }, phiDocs = { name: "phi", category: "Constants", syntax: ["phi"], description: "Phi is the golden ratio. Two quantities are in the golden ratio if their ratio is the same as the ratio of their sum to the larger of the two quantities. Phi is defined as `(1 + sqrt(5)) / 2` and is approximately 1.618034...", examples: ["phi"], seealso: [] }, piDocs = { name: "pi", category: "Constants", syntax: ["pi"], description: "The number pi is a mathematical constant that is the ratio of a circle's circumference to its diameter, and is approximately equal to 3.14159", examples: ["pi", "sin(pi/2)"], seealso: ["tau"] }, SQRT12Docs = { name: "SQRT1_2", category: "Constants", syntax: ["SQRT1_2"], description: "Returns the square root of 1/2, approximately equal to 0.707", examples: ["SQRT1_2", "sqrt(1/2)"], seealso: [] }, SQRT2Docs = { name: "SQRT2", category: "Constants", syntax: ["SQRT2"], description: "Returns the square root of 2, approximately equal to 1.414", examples: ["SQRT2", "sqrt(2)"], seealso: [] }, tauDocs = { name: "tau", category: "Constants", syntax: ["tau"], description: "Tau is the ratio constant of a circle's circumference to radius, equal to 2 * pi, approximately 6.2832.", examples: ["tau", "2 * pi"], seealso: ["pi"] }, trueDocs = { name: "true", category: "Constants", syntax: ["true"], description: "Boolean value true", examples: ["true"], seealso: ["false"] }, versionDocs = { name: "version", category: "Constants", syntax: ["version"], description: "A string with the version number of math.js", examples: ["version"], seealso: [] }, bignumberDocs = { name: "bignumber", category: "Construction", syntax: ["bignumber(x)"], description: "Create a big number from a number or string.", examples: ["0.1 + 0.2", "bignumber(0.1) + bignumber(0.2)", 'bignumber("7.2")', 'bignumber("7.2e500")', "bignumber([0.1, 0.2, 0.3])"], seealso: ["boolean", "bigint", "complex", "fraction", "index", "matrix", "string", "unit"] }, bigintDocs = { name: "bigint", category: "Construction", syntax: ["bigint(x)"], description: "Create a bigint, an integer with an arbitrary number of digits, from a number or string.", examples: ["123123123123123123 # a large number will lose digits", 'bigint("123123123123123123")', 'bignumber(["1", "3", "5"])'], seealso: ["boolean", "bignumber", "number", "complex", "fraction", "index", "matrix", "string", "unit"] }, booleanDocs = { name: "boolean", category: "Construction", syntax: ["x", "boolean(x)"], description: "Convert a string or number into a boolean.", examples: ["boolean(0)", "boolean(1)", "boolean(3)", 'boolean("true")', 'boolean("false")', "boolean([1, 0, 1, 1])"], seealso: ["bignumber", "complex", "index", "matrix", "number", "string", "unit"] }, complexDocs = { name: "complex", category: "Construction", syntax: ["complex()", "complex(re, im)", "complex(string)"], description: "Create a complex number.", examples: ["complex()", "complex(2, 3)", 'complex("7 - 2i")'], seealso: ["bignumber", "boolean", "index", "matrix", "number", "string", "unit"] }, createUnitDocs = { name: "createUnit", category: "Construction", syntax: ["createUnit(definitions)", "createUnit(name, definition)"], description: "Create a user-defined unit and register it with the Unit type.", examples: ['createUnit("foo")', 'createUnit("knot", {definition: "0.514444444 m/s", aliases: ["knots", "kt", "kts"]})', 'createUnit("mph", "1 mile/hour")'], seealso: ["unit", "splitUnit"] }, fractionDocs = { name: "fraction", category: "Construction", syntax: ["fraction(num)", "fraction(matrix)", "fraction(num,den)", "fraction({n: num, d: den})"], description: "Create a fraction from a number or from integer numerator and denominator.", examples: ["fraction(0.125)", "fraction(1, 3) + fraction(2, 5)", "fraction({n: 333, d: 53})", "fraction([sqrt(9), sqrt(10), sqrt(11)])"], seealso: ["bignumber", "boolean", "complex", "index", "matrix", "string", "unit"] }, indexDocs = { name: "index", category: "Construction", syntax: ["[start]", "[start:end]", "[start:step:end]", "[start1, start 2, ...]", "[start1:end1, start2:end2, ...]", "[start1:step1:end1, start2:step2:end2, ...]"], description: "Create an index to get or replace a subset of a matrix", examples: ["A = [1, 2, 3; 4, 5, 6]", "A[1, :]", "A[1, 2] = 50", "A[1:2, 1:2] = 1", "B = [1, 2, 3]", "B[B>1 and B<3]"], seealso: ["bignumber", "boolean", "complex", "matrix", "number", "range", "string", "unit"] }, matrixDocs = { name: "matrix", category: "Construction", syntax: ["[]", "[a1, b1, ...; a2, b2, ...]", "matrix()", 'matrix("dense")', "matrix([...])"], description: "Create a matrix.", examples: ["[]", "[1, 2, 3]", "[1, 2, 3; 4, 5, 6]", "matrix()", "matrix([3, 4])", 'matrix([3, 4; 5, 6], "sparse")', 'matrix([3, 4; 5, 6], "sparse", "number")'], seealso: ["bignumber", "boolean", "complex", "index", "number", "string", "unit", "sparse"] }, numberDocs = { name: "number", category: "Construction", syntax: ["x", "number(x)", "number(unit, valuelessUnit)"], description: "Create a number or convert a string or boolean into a number.", examples: ["2", "2e3", "4.05", "number(2)", 'number("7.2")', "number(true)", "number([true, false, true, true])", 'number(unit("52cm"), "m")'], seealso: ["bignumber", "bigint", "boolean", "complex", "fraction", "index", "matrix", "string", "unit"] }, sparseDocs = { name: "sparse", category: "Construction", syntax: ["sparse()", "sparse([a1, b1, ...; a1, b2, ...])", 'sparse([a1, b1, ...; a1, b2, ...], "number")'], description: "Create a sparse matrix.", examples: ["sparse()", "sparse([3, 4; 5, 6])", 'sparse([3, 0; 5, 0], "number")'], seealso: ["bignumber", "boolean", "complex", "index", "number", "string", "unit", "matrix"] }, splitUnitDocs = { name: "splitUnit", category: "Construction", syntax: ["splitUnit(unit: Unit, parts: Unit[])"], description: "Split a unit in an array of units whose sum is equal to the original unit.", examples: ['splitUnit(1 m, ["feet", "inch"])'], seealso: ["unit", "createUnit"] }, stringDocs = { name: "string", category: "Construction", syntax: ['"text"', "string(x)"], description: "Create a string or convert a value to a string", examples: ['"Hello World!"', "string(4.2)", "string(3 + 2i)"], seealso: ["bignumber", "boolean", "complex", "index", "matrix", "number", "unit"] }, unitDocs = { name: "unit", category: "Construction", syntax: ["value unit", "unit(value, unit)", "unit(string)"], description: "Create a unit.", examples: ["5.5 mm", "3 inch", 'unit(7.1, "kilogram")', 'unit("23 deg")'], seealso: ["bignumber", "boolean", "complex", "index", "matrix", "number", "string"] }, configDocs = { name: "config", category: "Core", syntax: ["config()", "config(options)"], description: "Get configuration or change configuration.", examples: ["config()", "1/3 + 1/4", 'config({number: "Fraction"})', "1/3 + 1/4"], seealso: [] }, importDocs = { name: "import", category: "Core", syntax: ["import(functions)", "import(functions, options)"], description: "Import functions or constants from an object.", examples: ["import({myFn: f(x)=x^2, myConstant: 32 })", "myFn(2)", "myConstant"], seealso: [] }, typedDocs = { name: "typed", category: "Core", syntax: ["typed(signatures)", "typed(name, signatures)"], description: "Create a typed function.", examples: ['double = typed({ "number": f(x)=x+x, "string": f(x)=concat(x,x) })', "double(2)", 'double("hello")'], seealso: [] }, derivativeDocs = { name: "derivative", category: "Algebra", syntax: ["derivative(expr, variable)", "derivative(expr, variable, {simplify: boolean})"], description: "Takes the derivative of an expression expressed in parser Nodes. The derivative will be taken over the supplied variable in the second parameter. If there are multiple variables in the expression, it will return a partial derivative.", examples: ['derivative("2x^3", "x")', 'derivative("2x^3", "x", {simplify: false})', 'derivative("2x^2 + 3x + 4", "x")', 'derivative("sin(2x)", "x")', 'f = parse("x^2 + x")', 'x = parse("x")', "df = derivative(f, x)", "df.evaluate({x: 3})"], seealso: ["simplify", "parse", "evaluate"] }, leafCountDocs = { name: "leafCount", category: "Algebra", syntax: ["leafCount(expr)"], description: "Computes the number of leaves in the parse tree of the given expression", examples: ['leafCount("e^(i*pi)-1")', 'leafCount(parse("{a: 22/7, b: 10^(1/2)}"))'], seealso: ["simplify"] }, lsolveDocs = { name: "lsolve", category: "Algebra", syntax: ["x=lsolve(L, b)"], description: "Finds one solution of the linear system L * x = b where L is an [n x n] lower triangular matrix and b is a [n] column vector.", examples: ["a = [-2, 3; 2, 1]", "b = [11, 9]", "x = lsolve(a, b)"], seealso: ["lsolveAll", "lup", "lusolve", "usolve", "matrix", "sparse"] }, lsolveAllDocs = { name: "lsolveAll", category: "Algebra", syntax: ["x=lsolveAll(L, b)"], description: "Finds all solutions of the linear system L * x = b where L is an [n x n] lower triangular matrix and b is a [n] column vector.", examples: ["a = [-2, 3; 2, 1]", "b = [11, 9]", "x = lsolve(a, b)"], seealso: ["lsolve", "lup", "lusolve", "usolve", "matrix", "sparse"] }, lupDocs = { name: "lup", category: "Algebra", syntax: ["lup(m)"], description: "Calculate the Matrix LU decomposition with partial pivoting. Matrix A is decomposed in three matrices (L, U, P) where P * A = L * U", examples: ["lup([[2, 1], [1, 4]])", "lup(matrix([[2, 1], [1, 4]]))", "lup(sparse([[2, 1], [1, 4]]))"], seealso: ["lusolve", "lsolve", "usolve", "matrix", "sparse", "slu", "qr"] }, lusolveDocs = { name: "lusolve", category: "Algebra", syntax: ["x=lusolve(A, b)", "x=lusolve(lu, b)"], description: "Solves the linear system A * x = b where A is an [n x n] matrix and b is a [n] column vector.", examples: ["a = [-2, 3; 2, 1]", "b = [11, 9]", "x = lusolve(a, b)"], seealso: ["lup", "slu", "lsolve", "usolve", "matrix", "sparse"] }, polynomialRootDocs = { name: "polynomialRoot", category: "Algebra", syntax: ["x=polynomialRoot(-6, 3)", "x=polynomialRoot(4, -4, 1)", "x=polynomialRoot(-8, 12, -6, 1)"], description: "Finds the roots of a univariate polynomial given by its coefficients starting from constant, linear, and so on, increasing in degree.", examples: ["a = polynomialRoot(-6, 11, -6, 1)"], seealso: ["cbrt", "sqrt"] }, qrDocs = { name: "qr", category: "Algebra", syntax: ["qr(A)"], description: "Calculates the Matrix QR decomposition. Matrix `A` is decomposed in two matrices (`Q`, `R`) where `Q` is an orthogonal matrix and `R` is an upper triangular matrix.", examples: ["qr([[1, -1,  4], [1,  4, -2], [1,  4,  2], [1,  -1, 0]])"], seealso: ["lup", "slu", "matrix"] }, rationalizeDocs = { name: "rationalize", category: "Algebra", syntax: ["rationalize(expr)", "rationalize(expr, scope)", "rationalize(expr, scope, detailed)"], description: "Transform a rationalizable expression in a rational fraction. If rational fraction is one variable polynomial then converts the numerator and denominator in canonical form, with decreasing exponents, returning the coefficients of numerator.", examples: ['rationalize("2x/y - y/(x+1)")', 'rationalize("2x/y - y/(x+1)", true)'], seealso: ["simplify"] }, resolveDocs = { name: "resolve", category: "Algebra", syntax: ["resolve(node, scope)"], description: "Recursively substitute variables in an expression tree.", examples: ['resolve(parse("1 + x"), { x: 7 })', 'resolve(parse("size(text)"), { text: "Hello World" })', 'resolve(parse("x + y"), { x: parse("3z") })', 'resolve(parse("3x"), { x: parse("y+z"), z: parse("w^y") })'], seealso: ["simplify", "evaluate"], mayThrow: ["ReferenceError"] }, simplifyDocs = { name: "simplify", category: "Algebra", syntax: ["simplify(expr)", "simplify(expr, rules)"], description: "Simplify an expression tree.", examples: ['simplify("3 + 2 / 4")', 'simplify("2x + x")', 'f = parse("x * (x + 2 + x)")', "simplified = simplify(f)", "simplified.evaluate({x: 2})"], seealso: ["simplifyCore", "derivative", "evaluate", "parse", "rationalize", "resolve"] }, simplifyConstantDocs = { name: "simplifyConstant", category: "Algebra", syntax: ["simplifyConstant(expr)", "simplifyConstant(expr, options)"], description: "Replace constant subexpressions of node with their values.", examples: ['simplifyConstant("(3-3)*x")', 'simplifyConstant(parse("z-cos(tau/8)"))'], seealso: ["simplify", "simplifyCore", "evaluate"] }, simplifyCoreDocs = { name: "simplifyCore", category: "Algebra", syntax: ["simplifyCore(node)"], description: "Perform simple one-pass simplifications on an expression tree.", examples: ['simplifyCore(parse("0*x"))', 'simplifyCore(parse("(x+0)*2"))'], seealso: ["simplify", "simplifyConstant", "evaluate"] }, sluDocs = { name: "slu", category: "Algebra", syntax: ["slu(A, order, threshold)"], description: "Calculate the Matrix LU decomposition with full pivoting. Matrix A is decomposed in two matrices (L, U) and two permutation vectors (pinv, q) where P * A * Q = L * U", examples: ["slu(sparse([4.5, 0, 3.2, 0; 3.1, 2.9, 0, 0.9; 0, 1.7, 3, 0; 3.5, 0.4, 0, 1]), 1, 0.001)"], seealso: ["lusolve", "lsolve", "usolve", "matrix", "sparse", "lup", "qr"] }, symbolicEqualDocs = { name: "symbolicEqual", category: "Algebra", syntax: ["symbolicEqual(expr1, expr2)", "symbolicEqual(expr1, expr2, options)"], description: "Returns true if the difference of the expressions simplifies to 0", examples: ['symbolicEqual("x*y","y*x")', 'symbolicEqual("abs(x^2)", "x^2")', 'symbolicEqual("abs(x)", "x", {context: {abs: {trivial: true}}})'], seealso: ["simplify", "evaluate"] }, usolveDocs = { name: "usolve", category: "Algebra", syntax: ["x=usolve(U, b)"], description: "Finds one solution of the linear system U * x = b where U is an [n x n] upper triangular matrix and b is a [n] column vector.", examples: ["x=usolve(sparse([1, 1, 1, 1; 0, 1, 1, 1; 0, 0, 1, 1; 0, 0, 0, 1]), [1; 2; 3; 4])"], seealso: ["usolveAll", "lup", "lusolve", "lsolve", "matrix", "sparse"] }, usolveAllDocs = { name: "usolveAll", category: "Algebra", syntax: ["x=usolve(U, b)"], description: "Finds all solutions of the linear system U * x = b where U is an [n x n] upper triangular matrix and b is a [n] column vector.", examples: ["x=usolve(sparse([1, 1, 1, 1; 0, 1, 1, 1; 0, 0, 1, 1; 0, 0, 0, 1]), [1; 2; 3; 4])"], seealso: ["usolve", "lup", "lusolve", "lsolve", "matrix", "sparse"] }, absDocs = { name: "abs", category: "Arithmetic", syntax: ["abs(x)"], description: "Compute the absolute value.", examples: ["abs(3.5)", "abs(-4.2)"], seealso: ["sign"] }, addDocs = { name: "add", category: "Operators", syntax: ["x + y", "add(x, y)"], description: "Add two values.", examples: ["a = 2.1 + 3.6", "a - 3.6", "3 + 2i", "3 cm + 2 inch", '"2.3" + "4"'], seealso: ["subtract"] }, cbrtDocs = { name: "cbrt", category: "Arithmetic", syntax: ["cbrt(x)", "cbrt(x, allRoots)"], description: "Compute the cubic root value. If x = y * y * y, then y is the cubic root of x. When `x` is a number or complex number, an optional second argument `allRoots` can be provided to return all three cubic roots. If not provided, the principal root is returned", examples: ["cbrt(64)", "cube(4)", "cbrt(-8)", "cbrt(2 + 3i)", "cbrt(8i)", "cbrt(8i, true)", "cbrt(27 m^3)"], seealso: ["square", "sqrt", "cube", "multiply"] }, ceilDocs = { name: "ceil", category: "Arithmetic", syntax: ["ceil(x)", "ceil(x, n)", "ceil(unit, valuelessUnit)", "ceil(unit, n, valuelessUnit)"], description: "Round a value towards plus infinity. If x is complex, both real and imaginary part are rounded towards plus infinity.", examples: ["ceil(3.2)", "ceil(3.8)", "ceil(-4.2)", "ceil(3.241cm, cm)", "ceil(3.241cm, 2, cm)"], seealso: ["floor", "fix", "round"] }, cubeDocs = { name: "cube", category: "Arithmetic", syntax: ["cube(x)"], description: "Compute the cube of a value. The cube of x is x * x * x.", examples: ["cube(2)", "2^3", "2 * 2 * 2"], seealso: ["multiply", "square", "pow"] }, divideDocs = { name: "divide", category: "Operators", syntax: ["x / y", "divide(x, y)"], description: "Divide two values.", examples: ["a = 2 / 3", "a * 3", "4.5 / 2", "3 + 4 / 2", "(3 + 4) / 2", "18 km / 4.5"], seealso: ["multiply"] }, dotDivideDocs = { name: "dotDivide", category: "Operators", syntax: ["x ./ y", "dotDivide(x, y)"], description: "Divide two values element wise.", examples: ["a = [1, 2, 3; 4, 5, 6]", "b = [2, 1, 1; 3, 2, 5]", "a ./ b"], seealso: ["multiply", "dotMultiply", "divide"] }, dotMultiplyDocs = { name: "dotMultiply", category: "Operators", syntax: ["x .* y", "dotMultiply(x, y)"], description: "Multiply two values element wise.", examples: ["a = [1, 2, 3; 4, 5, 6]", "b = [2, 1, 1; 3, 2, 5]", "a .* b"], seealso: ["multiply", "divide", "dotDivide"] }, dotPowDocs = { name: "dotPow", category: "Operators", syntax: ["x .^ y", "dotPow(x, y)"], description: "Calculates the power of x to y element wise.", examples: ["a = [1, 2, 3; 4, 5, 6]", "a .^ 2"], seealso: ["pow"] }, expDocs = { name: "exp", category: "Arithmetic", syntax: ["exp(x)"], description: "Calculate the exponent of a value.", examples: ["exp(1.3)", "e ^ 1.3", "log(exp(1.3))", "x = 2.4", "(exp(i*x) == cos(x) + i*sin(x))   # Euler's formula"], seealso: ["expm", "expm1", "pow", "log"] }, expmDocs = { name: "expm", category: "Arithmetic", syntax: ["exp(x)"], description: "Compute the matrix exponential, expm(A) = e^A. The matrix must be square. Not to be confused with exp(a), which performs element-wise exponentiation.", examples: ["expm([[0,2],[0,0]])"], seealso: ["exp"] }, expm1Docs = { name: "expm1", category: "Arithmetic", syntax: ["expm1(x)"], description: "Calculate the value of subtracting 1 from the exponential value.", examples: ["expm1(2)", "pow(e, 2) - 1", "log(expm1(2) + 1)"], seealso: ["exp", "pow", "log"] }, fixDocs = { name: "fix", category: "Arithmetic", syntax: ["fix(x)", "fix(x, n)", "fix(unit, valuelessUnit)", "fix(unit, n, valuelessUnit)"], description: "Round a value towards zero. If x is complex, both real and imaginary part are rounded towards zero.", examples: ["fix(3.2)", "fix(3.8)", "fix(-4.2)", "fix(-4.8)", "fix(3.241cm, cm)", "fix(3.241cm, 2, cm)"], seealso: ["ceil", "floor", "round"] }, floorDocs = { name: "floor", category: "Arithmetic", syntax: ["floor(x)", "floor(x, n)", "floor(unit, valuelessUnit)", "floor(unit, n, valuelessUnit)"], description: "Round a value towards minus infinity.If x is complex, both real and imaginary part are rounded towards minus infinity.", examples: ["floor(3.2)", "floor(3.8)", "floor(-4.2)", "floor(3.241cm, cm)", "floor(3.241cm, 2, cm)"], seealso: ["ceil", "fix", "round"] }, gcdDocs = { name: "gcd", category: "Arithmetic", syntax: ["gcd(a, b)", "gcd(a, b, c, ...)"], description: "Compute the greatest common divisor.", examples: ["gcd(8, 12)", "gcd(-4, 6)", "gcd(25, 15, -10)"], seealso: ["lcm", "xgcd"] }, hypotDocs = { name: "hypot", category: "Arithmetic", syntax: ["hypot(a, b, c, ...)", "hypot([a, b, c, ...])"], description: "Calculate the hypotenuse of a list with values.", examples: ["hypot(3, 4)", "sqrt(3^2 + 4^2)", "hypot(-2)", "hypot([3, 4, 5])"], seealso: ["abs", "norm"] }, invmodDocs = { name: "invmod", category: "Arithmetic", syntax: ["invmod(a, b)"], description: "Calculate the (modular) multiplicative inverse of a modulo b. Solution to the equation ax ≣ 1 (mod b)", examples: ["invmod(8, 12)", "invmod(7, 13)", "invmod(15151, 15122)"], seealso: ["gcd", "xgcd"] }, lcmDocs = { name: "lcm", category: "Arithmetic", syntax: ["lcm(x, y)"], description: "Compute the least common multiple.", examples: ["lcm(4, 6)", "lcm(6, 21)", "lcm(6, 21, 5)"], seealso: ["gcd"] }, logDocs = { name: "log", category: "Arithmetic", syntax: ["log(x)", "log(x, base)"], description: "Compute the logarithm of a value. If no base is provided, the natural logarithm of x is calculated. If base if provided, the logarithm is calculated for the specified base. log(x, base) is defined as log(x) / log(base).", examples: ["log(3.5)", "a = log(2.4)", "exp(a)", "10 ^ 4", "log(10000, 10)", "log(10000) / log(10)", "b = log(1024, 2)", "2 ^ b"], seealso: ["exp", "log1p", "log2", "log10"] }, log10Docs = { name: "log10", category: "Arithmetic", syntax: ["log10(x)"], description: "Compute the 10-base logarithm of a value.", examples: ["log10(0.00001)", "log10(10000)", "10 ^ 4", "log(10000) / log(10)", "log(10000, 10)"], seealso: ["exp", "log"] }, log1pDocs = { name: "log1p", category: "Arithmetic", syntax: ["log1p(x)", "log1p(x, base)"], description: "Calculate the logarithm of a `value+1`", examples: ["log1p(2.5)", "exp(log1p(1.4))", "pow(10, 4)", "log1p(9999, 10)", "log1p(9999) / log(10)"], seealso: ["exp", "log", "log2", "log10"] }, log2Docs = { name: "log2", category: "Arithmetic", syntax: ["log2(x)"], description: "Calculate the 2-base of a value. This is the same as calculating `log(x, 2)`.", examples: ["log2(0.03125)", "log2(16)", "log2(16) / log2(2)", "pow(2, 4)"], seealso: ["exp", "log1p", "log", "log10"] }, modDocs = { name: "mod", category: "Operators", syntax: ["x % y", "x mod y", "mod(x, y)"], description: "Calculates the modulus, the remainder of an integer division.", examples: ["7 % 3", "11 % 2", "10 mod 4", "isOdd(x) = x % 2", "isOdd(2)", "isOdd(3)"], seealso: ["divide"] }, multiplyDocs = { name: "multiply", category: "Operators", syntax: ["x * y", "multiply(x, y)"], description: "multiply two values.", examples: ["a = 2.1 * 3.4", "a / 3.4", "2 * 3 + 4", "2 * (3 + 4)", "3 * 2.1 km"], seealso: ["divide"] }, normDocs = { name: "norm", category: "Arithmetic", syntax: ["norm(x)", "norm(x, p)"], description: "Calculate the norm of a number, vector or matrix.", examples: ["abs(-3.5)", "norm(-3.5)", "norm(3 - 4i)", "norm([1, 2, -3], Infinity)", "norm([1, 2, -3], -Infinity)", "norm([3, 4], 2)", "norm([[1, 2], [3, 4]], 1)", 'norm([[1, 2], [3, 4]], "inf")', 'norm([[1, 2], [3, 4]], "fro")'] }, nthRootDocs = { name: "nthRoot", category: "Arithmetic", syntax: ["nthRoot(a)", "nthRoot(a, root)"], description: 'Calculate the nth root of a value. The principal nth root of a positive real number A, is the positive real solution of the equation "x^root = A".', examples: ["4 ^ 3", "nthRoot(64, 3)", "nthRoot(9, 2)", "sqrt(9)"], seealso: ["nthRoots", "pow", "sqrt"] }, nthRootsDocs = { name: "nthRoots", category: "Arithmetic", syntax: ["nthRoots(A)", "nthRoots(A, root)"], description: 'Calculate the nth roots of a value. An nth root of a positive real number A, is a positive real solution of the equation "x^root = A". This function returns an array of complex values.', examples: ["nthRoots(1)", "nthRoots(1, 3)"], seealso: ["sqrt", "pow", "nthRoot"] }, powDocs = { name: "pow", category: "Operators", syntax: ["x ^ y", "pow(x, y)"], description: "Calculates the power of x to y, x^y.", examples: ["2^3", "2*2*2", "1 + e ^ (pi * i)", "pow([[1, 2], [4, 3]], 2)", "pow([[1, 2], [4, 3]], -1)"], seealso: ["multiply", "nthRoot", "nthRoots", "sqrt"] }, roundDocs = { name: "round", category: "Arithmetic", syntax: ["round(x)", "round(x, n)", "round(unit, valuelessUnit)", "round(unit, n, valuelessUnit)"], description: "round a value towards the nearest integer.If x is complex, both real and imaginary part are rounded towards the nearest integer. When n is specified, the value is rounded to n decimals.", examples: ["round(3.2)", "round(3.8)", "round(-4.2)", "round(-4.8)", "round(pi, 3)", "round(123.45678, 2)", "round(3.241cm, 2, cm)", "round([3.2, 3.8, -4.7])"], seealso: ["ceil", "floor", "fix"] }, signDocs = { name: "sign", category: "Arithmetic", syntax: ["sign(x)"], description: "Compute the sign of a value. The sign of a value x is 1 when x>0, -1 when x<0, and 0 when x=0.", examples: ["sign(3.5)", "sign(-4.2)", "sign(0)"], seealso: ["abs"] }, sqrtDocs = { name: "sqrt", category: "Arithmetic", syntax: ["sqrt(x)"], description: "Compute the square root value. If x = y * y, then y is the square root of x.", examples: ["sqrt(25)", "5 * 5", "sqrt(-1)"], seealso: ["square", "sqrtm", "multiply", "nthRoot", "nthRoots", "pow"] }, sqrtmDocs = { name: "sqrtm", category: "Arithmetic", syntax: ["sqrtm(x)"], description: "Calculate the principal square root of a square matrix. The principal square root matrix `X` of another matrix `A` is such that `X * X = A`.", examples: ["sqrtm([[33, 24], [48, 57]])"], seealso: ["sqrt", "abs", "square", "multiply"] }, sylvesterDocs = { name: "sylvester", category: "Algebra", syntax: ["sylvester(A,B,C)"], description: "Solves the real-valued Sylvester equation AX+XB=C for X", examples: ["sylvester([[-1, -2], [1, 1]], [[-2, 1], [-1, 2]], [[-3, 2], [3, 0]])", "A = [[-1, -2], [1, 1]]; B = [[2, -1], [1, -2]]; C = [[-3, 2], [3, 0]]", "sylvester(A, B, C)"], seealso: ["schur", "lyap"] }, schurDocs = { name: "schur", category: "Algebra", syntax: ["schur(A)"], description: "Performs a real Schur decomposition of the real matrix A = UTU'", examples: ["schur([[1, 0], [-4, 3]])", "A = [[1, 0], [-4, 3]]", "schur(A)"], seealso: ["lyap", "sylvester"] }, lyapDocs = { name: "lyap", category: "Algebra", syntax: ["lyap(A,Q)"], description: "Solves the Continuous-time Lyapunov equation AP+PA'+Q=0 for P", examples: ["lyap([[-2, 0], [1, -4]], [[3, 1], [1, 3]])", "A = [[-2, 0], [1, -4]]", "Q = [[3, 1], [1, 3]]", "lyap(A,Q)"], seealso: ["schur", "sylvester"] }, squareDocs = { name: "square", category: "Arithmetic", syntax: ["square(x)"], description: "Compute the square of a value. The square of x is x * x.", examples: ["square(3)", "sqrt(9)", "3^2", "3 * 3"], seealso: ["multiply", "pow", "sqrt", "cube"] }, subtractDocs = { name: "subtract", category: "Operators", syntax: ["x - y", "subtract(x, y)"], description: "subtract two values.", examples: ["a = 5.3 - 2", "a + 2", "2/3 - 1/6", "2 * 3 - 3", "2.1 km - 500m"], seealso: ["add"] }, unaryMinusDocs = { name: "unaryMinus", category: "Operators", syntax: ["-x", "unaryMinus(x)"], description: "Inverse the sign of a value. Converts booleans and strings to numbers.", examples: ["-4.5", "-(-5.6)", '-"22"'], seealso: ["add", "subtract", "unaryPlus"] }, unaryPlusDocs = { name: "unaryPlus", category: "Operators", syntax: ["+x", "unaryPlus(x)"], description: "Converts booleans and strings to numbers.", examples: ["+true", '+"2"'], seealso: ["add", "subtract", "unaryMinus"] }, xgcdDocs = { name: "xgcd", category: "Arithmetic", syntax: ["xgcd(a, b)"], description: "Calculate the extended greatest common divisor for two values. The result is an array [d, x, y] with 3 entries, where d is the greatest common divisor, and d = x * a + y * b.", examples: ["xgcd(8, 12)", "gcd(8, 12)", "xgcd(36163, 21199)"], seealso: ["gcd", "lcm"] }, numDocs = { name: "num", category: "Fraction", syntax: ["num(x)"], description: "Get the numerator of a fraction.", examples: ["num(fraction(2, 3))", "num(fraction(5, 8))"], seealso: ["den", "fraction"] }, denDocs = { name: "den", category: "Fraction", syntax: ["den(x)"], description: "Get the denominator of a fraction.", examples: ["den(fraction(2, 3))", "den(fraction(5, 8))"], seealso: ["num", "fraction"] }, bitAndDocs = { name: "bitAnd", category: "Bitwise", syntax: ["x & y", "bitAnd(x, y)"], description: "Bitwise AND operation. Performs the logical AND operation on each pair of the corresponding bits of the two given values by multiplying them. If both bits in the compared position are 1, the bit in the resulting binary representation is 1, otherwise, the result is 0", examples: ["5 & 3", "bitAnd(53, 131)", "[1, 12, 31] & 42"], seealso: ["bitNot", "bitOr", "bitXor", "leftShift", "rightArithShift", "rightLogShift"] }, bitNotDocs = { name: "bitNot", category: "Bitwise", syntax: ["~x", "bitNot(x)"], description: "Bitwise NOT operation. Performs a logical negation on each bit of the given value. Bits that are 0 become 1, and those that are 1 become 0.", examples: ["~1", "~2", "bitNot([2, -3, 4])"], seealso: ["bitAnd", "bitOr", "bitXor", "leftShift", "rightArithShift", "rightLogShift"] }, bitOrDocs = { name: "bitOr", category: "Bitwise", syntax: ["x | y", "bitOr(x, y)"], description: "Bitwise OR operation. Performs the logical inclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if the first bit is 1 or the second bit is 1 or both bits are 1, otherwise, the result is 0.", examples: ["5 | 3", "bitOr([1, 2, 3], 4)"], seealso: ["bitAnd", "bitNot", "bitXor", "leftShift", "rightArithShift", "rightLogShift"] }, bitXorDocs = { name: "bitXor", category: "Bitwise", syntax: ["bitXor(x, y)"], description: "Bitwise XOR operation, exclusive OR. Performs the logical exclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if only the first bit is 1 or only the second bit is 1, but will be 0 if both are 0 or both are 1.", examples: ["bitOr(1, 2)", "bitXor([2, 3, 4], 4)"], seealso: ["bitAnd", "bitNot", "bitOr", "leftShift", "rightArithShift", "rightLogShift"] }, leftShiftDocs = { name: "leftShift", category: "Bitwise", syntax: ["x << y", "leftShift(x, y)"], description: "Bitwise left logical shift of a value x by y number of bits.", examples: ["4 << 1", "8 >> 1"], seealso: ["bitAnd", "bitNot", "bitOr", "bitXor", "rightArithShift", "rightLogShift"] }, rightArithShiftDocs = { name: "rightArithShift", category: "Bitwise", syntax: ["x >> y", "rightArithShift(x, y)"], description: "Bitwise right arithmetic shift of a value x by y number of bits.", examples: ["8 >> 1", "4 << 1", "-12 >> 2"], seealso: ["bitAnd", "bitNot", "bitOr", "bitXor", "leftShift", "rightLogShift"] }, rightLogShiftDocs = { name: "rightLogShift", category: "Bitwise", syntax: ["x >>> y", "rightLogShift(x, y)"], description: "Bitwise right logical shift of a value x by y number of bits.", examples: ["8 >>> 1", "4 << 1", "-12 >>> 2"], seealso: ["bitAnd", "bitNot", "bitOr", "bitXor", "leftShift", "rightArithShift"] }, bellNumbersDocs = { name: "bellNumbers", category: "Combinatorics", syntax: ["bellNumbers(n)"], description: "The Bell Numbers count the number of partitions of a set. A partition is a pairwise disjoint subset of S whose union is S. `bellNumbers` only takes integer arguments. The following condition must be enforced: n >= 0.", examples: ["bellNumbers(3)", "bellNumbers(8)"], seealso: ["stirlingS2"] }, catalanDocs = { name: "catalan", category: "Combinatorics", syntax: ["catalan(n)"], description: "The Catalan Numbers enumerate combinatorial structures of many different types. catalan only takes integer arguments. The following condition must be enforced: n >= 0.", examples: ["catalan(3)", "catalan(8)"], seealso: ["bellNumbers"] }, compositionDocs = { name: "composition", category: "Combinatorics", syntax: ["composition(n, k)"], description: "The composition counts of n into k parts. composition only takes integer arguments. The following condition must be enforced: k <= n.", examples: ["composition(5, 3)"], seealso: ["combinations"] }, stirlingS2Docs = { name: "stirlingS2", category: "Combinatorics", syntax: ["stirlingS2(n, k)"], description: "The Stirling numbers of the second kind, counts the number of ways to partition a set of n labelled objects into k nonempty unlabelled subsets. `stirlingS2` only takes integer arguments. The following condition must be enforced: k <= n. If n = k or k = 1, then s(n,k) = 1.", examples: ["stirlingS2(5, 3)"], seealso: ["bellNumbers", "bernoulli"] }, argDocs = { name: "arg", category: "Complex", syntax: ["arg(x)"], description: "Compute the argument of a complex value. If x = a+bi, the argument is computed as atan2(b, a).", examples: ["arg(2 + 2i)", "atan2(3, 2)", "arg(2 + 3i)"], seealso: ["re", "im", "conj", "abs"] }, conjDocs = { name: "conj", category: "Complex", syntax: ["conj(x)"], description: "Compute the complex conjugate of a complex value. If x = a+bi, the complex conjugate is a-bi.", examples: ["conj(2 + 3i)", "conj(2 - 3i)", "conj(-5.2i)"], seealso: ["re", "im", "abs", "arg"] }, imDocs = { name: "im", category: "Complex", syntax: ["im(x)"], description: "Get the imaginary part of a complex number.", examples: ["im(2 + 3i)", "re(2 + 3i)", "im(-5.2i)", "im(2.4)"], seealso: ["re", "conj", "abs", "arg"] }, reDocs = { name: "re", category: "Complex", syntax: ["re(x)"], description: "Get the real part of a complex number.", examples: ["re(2 + 3i)", "im(2 + 3i)", "re(-5.2i)", "re(2.4)"], seealso: ["im", "conj", "abs", "arg"] }, evaluateDocs = { name: "evaluate", category: "Expression", syntax: ["evaluate(expression)", "evaluate(expression, scope)", "evaluate([expr1, expr2, expr3, ...])", "evaluate([expr1, expr2, expr3, ...], scope)"], description: "Evaluate an expression or an array with expressions.", examples: ['evaluate("2 + 3")', 'evaluate("sqrt(16)")', 'evaluate("2 inch to cm")', 'evaluate("sin(x * pi)", { "x": 1/2 })', 'evaluate(["width=2", "height=4","width*height"])'], seealso: ["parser", "parse", "compile"] }, parserDocs = { name: "parser", category: "Expression", syntax: ["parser()"], description: "Create a parser object that keeps a context of variables and their values, allowing the evaluation of expressions in that context.", examples: ["myParser = parser()", 'myParser.evaluate("sqrt(3^2 + 4^2)")', 'myParser.set("x", 3)', 'myParser.evaluate("y = x + 3")', 'myParser.evaluate(["y = x + 3", "y = y + 1"])', 'myParser.get("y")'], seealso: ["evaluate", "parse", "compile"] }, parseDocs = { name: "parse", category: "Expression", syntax: ["parse(expr)", "parse(expr, options)", "parse([expr1, expr2, expr3, ...])", "parse([expr1, expr2, expr3, ...], options)"], description: "Parse an expression. Returns a node tree, which can be evaluated by invoking node.evaluate() or transformed into a functional object via node.compile().", examples: ['node1 = parse("sqrt(3^2 + 4^2)")', "node1.evaluate()", "code1 = node1.compile()", "code1.evaluate()", "scope = {a: 3, b: 4}", 'node2 = parse("a * b")', "node2.evaluate(scope)", "code2 = node2.compile()", "code2.evaluate(scope)"], seealso: ["parser", "evaluate", "compile"] }, compileDocs = { name: "compile", category: "Expression", syntax: ["compile(expr) ", "compile([expr1, expr2, expr3, ...])"], description: "Parse and compile an expression. Returns a an object with a function evaluate([scope]) to evaluate the compiled expression.", examples: ['code1 = compile("sqrt(3^2 + 4^2)")', "code1.evaluate() ", 'code2 = compile("a * b")', "code2.evaluate({a: 3, b: 4})"], seealso: ["parser", "parse", "evaluate"] }, helpDocs = { name: "help", category: "Expression", syntax: ["help(object)", "help(string)"], description: "Display documentation on a function or data type.", examples: ["help(sqrt)", 'help("complex")'], seealso: [] }, distanceDocs = { name: "distance", category: "Geometry", syntax: ["distance([x1, y1], [x2, y2])", "distance([[x1, y1], [x2, y2]])"], description: "Calculates the Euclidean distance between two points.", examples: ["distance([0,0], [4,4])", "distance([[0,0], [4,4]])"], seealso: [] }, intersectDocs = { name: "intersect", category: "Geometry", syntax: ["intersect(expr1, expr2, expr3, expr4)", "intersect(expr1, expr2, expr3)"], description: "Computes the intersection point of lines and/or planes.", examples: ["intersect([0, 0], [10, 10], [10, 0], [0, 10])", "intersect([1, 0, 1],  [4, -2, 2], [1, 1, 1, 6])"], seealso: [] }, andDocs = { name: "and", category: "Logical", syntax: ["x and y", "and(x, y)"], description: "Logical and. Test whether two values are both defined with a nonzero/nonempty value.", examples: ["true and false", "true and true", "2 and 4"], seealso: ["not", "or", "xor"] }, notDocs = { name: "not", category: "Logical", syntax: ["not x", "not(x)"], description: "Logical not. Flips the boolean value of given argument.", examples: ["not true", "not false", "not 2", "not 0"], seealso: ["and", "or", "xor"] }, nullishDocs = { name: "nullish", category: "Logical", syntax: ["x ?? y", "nullish(x, y)"], description: "Nullish coalescing operator. Returns the right-hand operand when the left-hand operand is null or undefined, and otherwise returns the left-hand operand.", examples: ["null ?? 42", "undefined ?? 42", "0 ?? 42", "false ?? 42", "null ?? undefined ?? 42"], seealso: ["and", "or", "not"] }, orDocs = { name: "or", category: "Logical", syntax: ["x or y", "or(x, y)"], description: "Logical or. Test if at least one value is defined with a nonzero/nonempty value.", examples: ["true or false", "false or false", "0 or 4"], seealso: ["not", "and", "xor"] }, xorDocs = { name: "xor", category: "Logical", syntax: ["x xor y", "xor(x, y)"], description: "Logical exclusive or, xor. Test whether one and only one value is defined with a nonzero/nonempty value.", examples: ["true xor false", "false xor false", "true xor true", "0 xor 4"], seealso: ["not", "and", "or"] }, mapSlicesDocs = { name: "mapSlices", category: "Matrix", syntax: ["mapSlices(A, dim, callback)"], description: "Generate a matrix one dimension less than A by applying callback to each slice of A along dimension dim.", examples: ["A = [[1, 2], [3, 4]]", "mapSlices(A, 1, sum)", "mapSlices(A, 2, prod)"], seealso: ["map", "forEach"] }, columnDocs = { name: "column", category: "Matrix", syntax: ["column(x, index)"], description: "Return a column from a matrix or array.", examples: ["A = [[1, 2], [3, 4]]", "column(A, 1)", "column(A, 2)"], seealso: ["row", "matrixFromColumns"] }, concatDocs = { name: "concat", category: "Matrix", syntax: ["concat(A, B, C, ...)", "concat(A, B, C, ..., dim)"], description: "Concatenate matrices. By default, the matrices are concatenated by the last dimension. The dimension on which to concatenate can be provided as last argument.", examples: ["A = [1, 2; 5, 6]", "B = [3, 4; 7, 8]", "concat(A, B)", "concat(A, B, 1)", "concat(A, B, 2)"], seealso: ["det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"] }, countDocs = { name: "count", category: "Matrix", syntax: ["count(x)"], description: "Count the number of elements of a matrix, array or string.", examples: ["a = [1, 2; 3, 4; 5, 6]", "count(a)", "size(a)", 'count("hello world")'], seealso: ["size"] }, crossDocs = { name: "cross", category: "Matrix", syntax: ["cross(A, B)"], description: "Calculate the cross product for two vectors in three dimensional space.", examples: ["cross([1, 1, 0],  [0, 1, 1])", "cross([3, -3, 1], [4, 9, 2])", "cross([2, 3, 4],  [5, 6, 7])"], seealso: ["multiply", "dot"] }, ctransposeDocs = { name: "ctranspose", category: "Matrix", syntax: ["x'", "ctranspose(x)"], description: "Complex Conjugate and Transpose a matrix", examples: ["a = [1, 2, 3; 4, 5, 6]", "a'", "ctranspose(a)"], seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "zeros"] }, detDocs = { name: "det", category: "Matrix", syntax: ["det(x)"], description: "Calculate the determinant of a matrix", examples: ["det([1, 2; 3, 4])", "det([-2, 2, 3; -1, 1, 3; 2, 0, -1])"], seealso: ["concat", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"] }, diagDocs = { name: "diag", category: "Matrix", syntax: ["diag(x)", "diag(x, k)"], description: "Create a diagonal matrix or retrieve the diagonal of a matrix. When x is a vector, a matrix with the vector values on the diagonal will be returned. When x is a matrix, a vector with the diagonal values of the matrix is returned. When k is provided, the k-th diagonal will be filled in or retrieved, if k is positive, the values are placed on the super diagonal. When k is negative, the values are placed on the sub diagonal.", examples: ["diag(1:3)", "diag(1:3, 1)", "a = [1, 2, 3; 4, 5, 6; 7, 8, 9]", "diag(a)"], seealso: ["concat", "det", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"] }, diffDocs = { name: "diff", category: "Matrix", syntax: ["diff(arr)", "diff(arr, dim)"], description: ["Create a new matrix or array with the difference of the passed matrix or array.", "Dim parameter is optional and used to indicate the dimension of the array/matrix to apply the difference", "If no dimension parameter is passed it is assumed as dimension 0", "Dimension is zero-based in javascript and one-based in the parser", "Arrays must be 'rectangular' meaning arrays like [1, 2]", "If something is passed as a matrix it will be returned as a matrix but other than that all matrices are converted to arrays"], examples: ["A = [1, 2, 4, 7, 0]", "diff(A)", "diff(A, 1)", "B = [[1, 2], [3, 4]]", "diff(B)", "diff(B, 1)", "diff(B, 2)", "diff(B, bignumber(2))", "diff([[1, 2], matrix([3, 4])], 2)"], seealso: ["subtract", "partitionSelect"] }, dotDocs = { name: "dot", category: "Matrix", syntax: ["dot(A, B)", "A * B"], description: "Calculate the dot product of two vectors. The dot product of A = [a1, a2, a3, ..., an] and B = [b1, b2, b3, ..., bn] is defined as dot(A, B) = a1 * b1 + a2 * b2 + a3 * b3 + ... + an * bn", examples: ["dot([2, 4, 1], [2, 2, 3])", "[2, 4, 1] * [2, 2, 3]"], seealso: ["multiply", "cross"] }, eigsDocs = { name: "eigs", category: "Matrix", syntax: ["eigs(x)"], description: "Calculate the eigenvalues and optionally eigenvectors of a square matrix", examples: ["eigs([[5, 2.3], [2.3, 1]])", "eigs([[1, 2, 3], [4, 5, 6], [7, 8, 9]], { precision: 1e-6, eigenvectors: false })"], seealso: ["inv"] }, filterDocs = { name: "filter", category: "Matrix", syntax: ["filter(x, test)"], description: "Filter items in a matrix.", examples: ["isPositive(x) = x > 0", "filter([6, -2, -1, 4, 3], isPositive)", "filter([6, -2, 0, 1, 0], x != 0)"], seealso: ["sort", "map", "forEach"] }, flattenDocs = { name: "flatten", category: "Matrix", syntax: ["flatten(x)"], description: "Flatten a multi dimensional matrix into a single dimensional matrix.", examples: ["a = [1, 2, 3; 4, 5, 6]", "size(a)", "b = flatten(a)", "size(b)"], seealso: ["concat", "resize", "size", "squeeze"] }, forEachDocs = { name: "forEach", category: "Matrix", syntax: ["forEach(x, callback)"], description: "Iterates over all elements of a matrix/array, and executes the given callback function.", examples: ["numberOfPets = {}", "addPet(n) = numberOfPets[n] = (numberOfPets[n] ? numberOfPets[n]:0 ) + 1;", 'forEach(["Dog","Cat","Cat"], addPet)', "numberOfPets"], seealso: ["map", "sort", "filter"] }, getMatrixDataTypeDocs = { name: "getMatrixDataType", category: "Matrix", syntax: ["getMatrixDataType(x)"], description: 'Find the data type of all elements in a matrix or array, for example "number" if all items are a number and "Complex" if all values are complex numbers. If a matrix contains more than one data type, it will return "mixed".', examples: ["getMatrixDataType([1, 2, 3])", "getMatrixDataType([[5 cm], [2 inch]])", 'getMatrixDataType([1, "text"])', "getMatrixDataType([1, bignumber(4)])"], seealso: ["matrix", "sparse", "typeOf"] }, identityDocs = { name: "identity", category: "Matrix", syntax: ["identity(n)", "identity(m, n)", "identity([m, n])"], description: "Returns the identity matrix with size m-by-n. The matrix has ones on the diagonal and zeros elsewhere.", examples: ["identity(3)", "identity(3, 5)", "a = [1, 2, 3; 4, 5, 6]", "identity(size(a))"], seealso: ["concat", "det", "diag", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"] }, invDocs = { name: "inv", category: "Matrix", syntax: ["inv(x)"], description: "Calculate the inverse of a matrix", examples: ["inv([1, 2; 3, 4])", "inv(4)", "1 / 4"], seealso: ["concat", "det", "diag", "identity", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"] }, pinvDocs = { name: "pinv", category: "Matrix", syntax: ["pinv(x)"], description: "Calculate the Moore–Penrose inverse of a matrix", examples: ["pinv([1, 2; 3, 4])", "pinv([[1, 0], [0, 1], [0, 1]])", "pinv(4)"], seealso: ["inv"] }, kronDocs = { name: "kron", category: "Matrix", syntax: ["kron(x, y)"], description: "Calculates the Kronecker product of 2 matrices or vectors.", examples: ["kron([[1, 0], [0, 1]], [[1, 2], [3, 4]])", "kron([1,1], [2,3,4])"], seealso: ["multiply", "dot", "cross"] }, mapDocs = { name: "map", category: "Matrix", syntax: ["map(x, callback)", "map(x, y, ..., callback)"], description: "Create a new matrix or array with the results of the callback function executed on each entry of the matrix/array or the matrices/arrays.", examples: ["map([1, 2, 3], square)", "map([1, 2], [3, 4], f(a,b) = a + b)"], seealso: ["filter", "forEach"] }, matrixFromColumnsDocs = { name: "matrixFromColumns", category: "Matrix", syntax: ["matrixFromColumns(...arr)", "matrixFromColumns(row1, row2)", "matrixFromColumns(row1, row2, row3)"], description: "Create a dense matrix from vectors as individual columns.", examples: ["matrixFromColumns([1, 2, 3], [[4],[5],[6]])"], seealso: ["matrix", "matrixFromRows", "matrixFromFunction", "zeros"] }, matrixFromFunctionDocs = { name: "matrixFromFunction", category: "Matrix", syntax: ["matrixFromFunction(size, fn)", "matrixFromFunction(size, fn, format)", "matrixFromFunction(size, fn, format, datatype)", "matrixFromFunction(size, format, fn)", "matrixFromFunction(size, format, datatype, fn)"], description: "Create a matrix by evaluating a generating function at each index.", examples: ["f(I) = I[1] - I[2]", "matrixFromFunction([3,3], f)", "g(I) = I[1] - I[2] == 1 ? 4 : 0", 'matrixFromFunction([100, 100], "sparse", g)', "matrixFromFunction([5], random)"], seealso: ["matrix", "matrixFromRows", "matrixFromColumns", "zeros"] }, matrixFromRowsDocs = { name: "matrixFromRows", category: "Matrix", syntax: ["matrixFromRows(...arr)", "matrixFromRows(row1, row2)", "matrixFromRows(row1, row2, row3)"], description: "Create a dense matrix from vectors as individual rows.", examples: ["matrixFromRows([1, 2, 3], [[4],[5],[6]])"], seealso: ["matrix", "matrixFromColumns", "matrixFromFunction", "zeros"] }, onesDocs = { name: "ones", category: "Matrix", syntax: ["ones(m)", "ones(m, n)", "ones(m, n, p, ...)", "ones([m])", "ones([m, n])", "ones([m, n, p, ...])"], description: "Create a matrix containing ones.", examples: ["ones(3)", "ones(3, 5)", "ones([2,3]) * 4.5", "a = [1, 2, 3; 4, 5, 6]", "ones(size(a))"], seealso: ["concat", "det", "diag", "identity", "inv", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"] }, partitionSelectDocs = { name: "partitionSelect", category: "Matrix", syntax: ["partitionSelect(x, k)", "partitionSelect(x, k, compare)"], description: "Partition-based selection of an array or 1D matrix. Will find the kth smallest value, and mutates the input array. Uses Quickselect.", examples: ["partitionSelect([5, 10, 1], 2)", 'partitionSelect(["C", "B", "A", "D"], 1, compareText)', "arr = [5, 2, 1]", "partitionSelect(arr, 0) # returns 1, arr is now: [1, 2, 5]", "arr", "partitionSelect(arr, 1, 'desc') # returns 2, arr is now: [5, 2, 1]", "arr"], seealso: ["sort"] }, rangeDocs = { name: "range", category: "Type", syntax: ["start:end", "start:step:end", "range(start, end)", "range(start, end, step)", "range(string)"], description: "Create a range. Lower bound of the range is included, upper bound is excluded.", examples: ["1:5", "3:-1:-3", "range(3, 7)", "range(0, 12, 2)", 'range("4:10")', "range(1m, 1m, 3m)", "a = [1, 2, 3, 4; 5, 6, 7, 8]", "a[1:2, 1:2]"], seealso: ["concat", "det", "diag", "identity", "inv", "ones", "size", "squeeze", "subset", "trace", "transpose", "zeros"] }, reshapeDocs = { name: "reshape", category: "Matrix", syntax: ["reshape(x, sizes)"], description: "Reshape a multi dimensional array to fit the specified dimensions.", examples: ["reshape([1, 2, 3, 4, 5, 6], [2, 3])", "reshape([[1, 2], [3, 4]], [1, 4])", "reshape([[1, 2], [3, 4]], [4])", "reshape([1, 2, 3, 4], [-1, 2])"], seealso: ["size", "squeeze", "resize"] }, resizeDocs = { name: "resize", category: "Matrix", syntax: ["resize(x, size)", "resize(x, size, defaultValue)"], description: "Resize a matrix.", examples: ["resize([1,2,3,4,5], [3])", "resize([1,2,3], [5])", "resize([1,2,3], [5], -1)", "resize(2, [2, 3])", 'resize("hello", [8], "!")'], seealso: ["size", "subset", "squeeze", "reshape"] }, rotateDocs = { name: "rotate", category: "Matrix", syntax: ["rotate(w, theta)", "rotate(w, theta, v)"], description: "Returns a 2-D rotation matrix (2x2) for a given angle (in radians). Returns a 2-D rotation matrix (3x3) of a given angle (in radians) around given axis.", examples: ["rotate([1, 0], pi / 2)", 'rotate(matrix([1, 0]), unit("35deg"))', 'rotate([1, 0, 0], unit("90deg"), [0, 0, 1])', 'rotate(matrix([1, 0, 0]), unit("90deg"), matrix([0, 0, 1]))'], seealso: ["matrix", "rotationMatrix"] }, rotationMatrixDocs = { name: "rotationMatrix", category: "Matrix", syntax: ["rotationMatrix(theta)", "rotationMatrix(theta, v)", "rotationMatrix(theta, v, format)"], description: "Returns a 2-D rotation matrix (2x2) for a given angle (in radians). Returns a 2-D rotation matrix (3x3) of a given angle (in radians) around given axis.", examples: ["rotationMatrix(pi / 2)", 'rotationMatrix(unit("45deg"), [0, 0, 1])', 'rotationMatrix(1, matrix([0, 0, 1]), "sparse")'], seealso: ["cos", "sin"] }, rowDocs = { name: "row", category: "Matrix", syntax: ["row(x, index)"], description: "Return a row from a matrix or array.", examples: ["A = [[1, 2], [3, 4]]", "row(A, 1)", "row(A, 2)"], seealso: ["column", "matrixFromRows"] }, sizeDocs = { name: "size", category: "Matrix", syntax: ["size(x)"], description: "Calculate the size of a matrix.", examples: ["size(2.3)", 'size("hello world")', "a = [1, 2; 3, 4; 5, 6]", "size(a)", "size(1:6)"], seealso: ["concat", "count", "det", "diag", "identity", "inv", "ones", "range", "squeeze", "subset", "trace", "transpose", "zeros"] }, sortDocs = { name: "sort", category: "Matrix", syntax: ["sort(x)", "sort(x, compare)"], description: 'Sort the items in a matrix. Compare can be a string "asc", "desc", "natural", or a custom sort function.', examples: ["sort([5, 10, 1])", 'sort(["C", "B", "A", "D"], "natural")', "sortByLength(a, b) = size(a)[1] - size(b)[1]", 'sort(["Langdon", "Tom", "Sara"], sortByLength)', 'sort(["10", "1", "2"], "natural")'], seealso: ["map", "filter", "forEach"] }, squeezeDocs = { name: "squeeze", category: "Matrix", syntax: ["squeeze(x)"], description: "Remove inner and outer singleton dimensions from a matrix.", examples: ["a = zeros(3,2,1)", "size(squeeze(a))", "b = zeros(1,1,3)", "size(squeeze(b))"], seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "subset", "trace", "transpose", "zeros"] }, subsetDocs = { name: "subset", category: "Matrix", syntax: ["value(index)", "value(index) = replacement", "subset(value, [index])", "subset(value, [index], replacement)"], description: "Get or set a subset of the entries of a matrix or characters of a string. Indexes are one-based. There should be one index specification for each dimension of the target. Each specification can be a single index, a list of indices, or a range in colon notation `l:u`. In a range, both the lower bound l and upper bound u are included; and if a bound is omitted it defaults to the most extreme valid value. The cartesian product of the indices specified in each dimension determines the target of the operation.", examples: ["d = [1, 2; 3, 4]", "e = []", "e[1, 1:2] = [5, 6]", "e[2, :] = [7, 8]", "f = d * e", "f[2, 1]", "f[:, 1]", "f[[1,2], [1,3]] = [9, 10; 11, 12]", "f"], seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "trace", "transpose", "zeros"] }, traceDocs = { name: "trace", category: "Matrix", syntax: ["trace(A)"], description: "Calculate the trace of a matrix: the sum of the elements on the main diagonal of a square matrix.", examples: ["A = [1, 2, 3; -1, 2, 3; 2, 0, 3]", "trace(A)"], seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "transpose", "zeros"] }, transposeDocs = { name: "transpose", category: "Matrix", syntax: ["x'", "transpose(x)"], description: "Transpose a matrix", examples: ["a = [1, 2, 3; 4, 5, 6]", "a'", "transpose(a)"], seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "zeros"] }, zerosDocs = { name: "zeros", category: "Matrix", syntax: ["zeros(m)", "zeros(m, n)", "zeros(m, n, p, ...)", "zeros([m])", "zeros([m, n])", "zeros([m, n, p, ...])"], description: "Create a matrix containing zeros.", examples: ["zeros(3)", "zeros(3, 5)", "a = [1, 2, 3; 4, 5, 6]", "zeros(size(a))"], seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose"] }, fftDocs = { name: "fft", category: "Matrix", syntax: ["fft(x)"], description: "Calculate N-dimensional Fourier transform", examples: ["fft([[1, 0], [1, 0]])"], seealso: ["ifft"] }, ifftDocs = { name: "ifft", category: "Matrix", syntax: ["ifft(x)"], description: "Calculate N-dimensional inverse Fourier transform", examples: ["ifft([[2, 2], [0, 0]])"], seealso: ["fft"] }, bernoulliDocs = { name: "bernoulli", category: "Probability", syntax: ["bernoulli(n)"], description: "The nth Bernoulli number", examples: ["bernoulli(4)", "bernoulli(fraction(12))"], seealso: ["combinations", "gamma", "stirlingS2"] }, combinationsDocs = { name: "combinations", category: "Probability", syntax: ["combinations(n, k)"], description: "Compute the number of combinations of n items taken k at a time", examples: ["combinations(7, 5)"], seealso: ["combinationsWithRep", "permutations", "factorial"] }, combinationsWithRepDocs = { name: "combinationsWithRep", category: "Probability", syntax: ["combinationsWithRep(n, k)"], description: "Compute the number of combinations of n items taken k at a time with replacements.", examples: ["combinationsWithRep(7, 5)"], seealso: ["combinations", "permutations", "factorial"] }, factorialDocs = { name: "factorial", category: "Probability", syntax: ["n!", "factorial(n)"], description: "Compute the factorial of a value", examples: ["5!", "5 * 4 * 3 * 2 * 1", "3!"], seealso: ["combinations", "combinationsWithRep", "permutations", "gamma"] }, gammaDocs = { name: "gamma", category: "Probability", syntax: ["gamma(n)"], description: "Compute the gamma function. For small values, the Lanczos approximation is used, and for large values the extended Stirling approximation.", examples: ["gamma(4)", "3!", "gamma(1/2)", "sqrt(pi)"], seealso: ["factorial"] }, lgammaDocs = { name: "lgamma", category: "Probability", syntax: ["lgamma(n)"], description: "Logarithm of the gamma function for real, positive numbers and complex numbers, using Lanczos approximation for numbers and Stirling series for complex numbers.", examples: ["lgamma(4)", "lgamma(1/2)", "lgamma(i)", "lgamma(complex(1.1, 2))"], seealso: ["gamma"] }, kldivergenceDocs = { name: "kldivergence", category: "Probability", syntax: ["kldivergence(x, y)"], description: "Calculate the Kullback-Leibler (KL) divergence  between two distributions.", examples: ["kldivergence([0.7,0.5,0.4], [0.2,0.9,0.5])"], seealso: [] }, multinomialDocs = { name: "multinomial", category: "Probability", syntax: ["multinomial(A)"], description: "Multinomial Coefficients compute the number of ways of picking a1, a2, ..., ai unordered outcomes from `n` possibilities. multinomial takes one array of integers as an argument. The following condition must be enforced: every ai > 0.", examples: ["multinomial([1, 2, 1])"], seealso: ["combinations", "factorial"] }, permutationsDocs = { name: "permutations", category: "Probability", syntax: ["permutations(n)", "permutations(n, k)"], description: "Compute the number of permutations of n items taken k at a time", examples: ["permutations(5)", "permutations(5, 3)"], seealso: ["combinations", "combinationsWithRep", "factorial"] }, pickRandomDocs = { name: "pickRandom", category: "Probability", syntax: ["pickRandom(array)", "pickRandom(array, number)", "pickRandom(array, weights)", "pickRandom(array, number, weights)", "pickRandom(array, weights, number)"], description: "Pick a random entry from a given array.", examples: ["pickRandom(0:10)", "pickRandom([1, 3, 1, 6])", "pickRandom([1, 3, 1, 6], 2)", "pickRandom([1, 3, 1, 6], [2, 3, 2, 1])", "pickRandom([1, 3, 1, 6], 2, [2, 3, 2, 1])", "pickRandom([1, 3, 1, 6], [2, 3, 2, 1], 2)"], seealso: ["random", "randomInt"] }, randomDocs = { name: "random", category: "Probability", syntax: ["random()", "random(max)", "random(min, max)", "random(size)", "random(size, max)", "random(size, min, max)"], description: "Return a random number.", examples: ["random()", "random(10, 20)", "random([2, 3])"], seealso: ["pickRandom", "randomInt"] }, randomIntDocs = { name: "randomInt", category: "Probability", syntax: ["randomInt(max)", "randomInt(min, max)", "randomInt(size)", "randomInt(size, max)", "randomInt(size, min, max)"], description: "Return a random integer number", examples: ["randomInt(10, 20)", "randomInt([2, 3], 10)"], seealso: ["pickRandom", "random"] }, compareDocs = { name: "compare", category: "Relational", syntax: ["compare(x, y)"], description: "Compare two values. Returns 1 when x > y, -1 when x < y, and 0 when x == y.", examples: ["compare(2, 3)", "compare(3, 2)", "compare(2, 2)", "compare(5cm, 40mm)", "compare(2, [1, 2, 3])"], seealso: ["equal", "unequal", "smaller", "smallerEq", "largerEq", "compareNatural", "compareText"] }, compareNaturalDocs = { name: "compareNatural", category: "Relational", syntax: ["compareNatural(x, y)"], description: "Compare two values of any type in a deterministic, natural way. Returns 1 when x > y, -1 when x < y, and 0 when x == y.", examples: ["compareNatural(2, 3)", "compareNatural(3, 2)", "compareNatural(2, 2)", "compareNatural(5cm, 40mm)", 'compareNatural("2", "10")', "compareNatural(2 + 3i, 2 + 4i)", "compareNatural([1, 2, 4], [1, 2, 3])", "compareNatural([1, 5], [1, 2, 3])", "compareNatural([1, 2], [1, 2])", "compareNatural({a: 2}, {a: 4})"], seealso: ["equal", "unequal", "smaller", "smallerEq", "largerEq", "compare", "compareText"] }, compareTextDocs = { name: "compareText", category: "Relational", syntax: ["compareText(x, y)"], description: "Compare two strings lexically. Comparison is case sensitive. Returns 1 when x > y, -1 when x < y, and 0 when x == y.", examples: ['compareText("B", "A")', 'compareText("A", "B")', 'compareText("A", "A")', 'compareText("2", "10")', 'compare("2", "10")', "compare(2, 10)", 'compareNatural("2", "10")', 'compareText("B", ["A", "B", "C"])'], seealso: ["compare", "compareNatural"] }, deepEqualDocs = { name: "deepEqual", category: "Relational", syntax: ["deepEqual(x, y)"], description: "Check equality of two matrices element wise. Returns true if the size of both matrices is equal and when and each of the elements are equal.", examples: ["deepEqual([1,3,4], [1,3,4])", "deepEqual([1,3,4], [1,3])"], seealso: ["equal", "unequal", "smaller", "larger", "smallerEq", "largerEq", "compare"] }, equalDocs = { name: "equal", category: "Relational", syntax: ["x == y", "equal(x, y)"], description: "Check equality of two values. Returns true if the values are equal, and false if not.", examples: ["2+2 == 3", "2+2 == 4", "a = 3.2", "b = 6-2.8", "a == b", "50cm == 0.5m"], seealso: ["unequal", "smaller", "larger", "smallerEq", "largerEq", "compare", "deepEqual", "equalText"] }, equalTextDocs = { name: "equalText", category: "Relational", syntax: ["equalText(x, y)"], description: "Check equality of two strings. Comparison is case sensitive. Returns true if the values are equal, and false if not.", examples: ['equalText("Hello", "Hello")', 'equalText("a", "A")', 'equal("2e3", "2000")', 'equalText("2e3", "2000")', 'equalText("B", ["A", "B", "C"])'], seealso: ["compare", "compareNatural", "compareText", "equal"] }, largerDocs = { name: "larger", category: "Relational", syntax: ["x > y", "larger(x, y)"], description: "Check if value x is larger than y. Returns true if x is larger than y, and false if not. Comparing a value with NaN returns false.", examples: ["2 > 3", "5 > 2*2", "a = 3.3", "b = 6-2.8", "(a > b)", "(b < a)", "5 cm > 2 inch"], seealso: ["equal", "unequal", "smaller", "smallerEq", "largerEq", "compare"] }, largerEqDocs = { name: "largerEq", category: "Relational", syntax: ["x >= y", "largerEq(x, y)"], description: "Check if value x is larger or equal to y. Returns true if x is larger or equal to y, and false if not.", examples: ["2 >= 1+1", "2 > 1+1", "a = 3.2", "b = 6-2.8", "(a >= b)"], seealso: ["equal", "unequal", "smallerEq", "smaller", "compare"] }, smallerDocs = { name: "smaller", category: "Relational", syntax: ["x < y", "smaller(x, y)"], description: "Check if value x is smaller than value y. Returns true if x is smaller than y, and false if not. Comparing a value with NaN returns false.", examples: ["2 < 3", "5 < 2*2", "a = 3.3", "b = 6-2.8", "(a < b)", "5 cm < 2 inch"], seealso: ["equal", "unequal", "larger", "smallerEq", "largerEq", "compare"] }, smallerEqDocs = { name: "smallerEq", category: "Relational", syntax: ["x <= y", "smallerEq(x, y)"], description: "Check if value x is smaller or equal to value y. Returns true if x is smaller than y, and false if not.", examples: ["2 <= 1+1", "2 < 1+1", "a = 3.2", "b = 6-2.8", "(a <= b)"], seealso: ["equal", "unequal", "larger", "smaller", "largerEq", "compare"] }, unequalDocs = { name: "unequal", category: "Relational", syntax: ["x != y", "unequal(x, y)"], description: "Check unequality of two values. Returns true if the values are unequal, and false if they are equal.", examples: ["2+2 != 3", "2+2 != 4", "a = 3.2", "b = 6-2.8", "a != b", "50cm != 0.5m", "5 cm != 2 inch"], seealso: ["equal", "smaller", "larger", "smallerEq", "largerEq", "compare", "deepEqual"] }, setCartesianDocs = { name: "setCartesian", category: "Set", syntax: ["setCartesian(set1, set2)"], description: "Create the cartesian product of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays and the values will be sorted in ascending order before the operation.", examples: ["setCartesian([1, 2], [3, 4])"], seealso: ["setUnion", "setIntersect", "setDifference", "setPowerset"] }, setDifferenceDocs = { name: "setDifference", category: "Set", syntax: ["setDifference(set1, set2)"], description: "Create the difference of two (multi)sets: every element of set1, that is not the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.", examples: ["setDifference([1, 2, 3, 4], [3, 4, 5, 6])", "setDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])"], seealso: ["setUnion", "setIntersect", "setSymDifference"] }, setDistinctDocs = { name: "setDistinct", category: "Set", syntax: ["setDistinct(set)"], description: "Collect the distinct elements of a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.", examples: ["setDistinct([1, 1, 1, 2, 2, 3])"], seealso: ["setMultiplicity"] }, setIntersectDocs = { name: "setIntersect", category: "Set", syntax: ["setIntersect(set1, set2)"], description: "Create the intersection of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.", examples: ["setIntersect([1, 2, 3, 4], [3, 4, 5, 6])", "setIntersect([[1, 2], [3, 4]], [[3, 4], [5, 6]])"], seealso: ["setUnion", "setDifference"] }, setIsSubsetDocs = { name: "setIsSubset", category: "Set", syntax: ["setIsSubset(set1, set2)"], description: "Check whether a (multi)set is a subset of another (multi)set: every element of set1 is the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.", examples: ["setIsSubset([1, 2], [3, 4, 5, 6])", "setIsSubset([3, 4], [3, 4, 5, 6])"], seealso: ["setUnion", "setIntersect", "setDifference"] }, setMultiplicityDocs = { name: "setMultiplicity", category: "Set", syntax: ["setMultiplicity(element, set)"], description: "Count the multiplicity of an element in a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.", examples: ["setMultiplicity(1, [1, 2, 2, 4])", "setMultiplicity(2, [1, 2, 2, 4])"], seealso: ["setDistinct", "setSize"] }, setPowersetDocs = { name: "setPowerset", category: "Set", syntax: ["setPowerset(set)"], description: "Create the powerset of a (multi)set: the powerset contains very possible subsets of a (multi)set. A multi-dimension array will be converted to a single-dimension array before the operation.", examples: ["setPowerset([1, 2, 3])"], seealso: ["setCartesian"] }, setSizeDocs = { name: "setSize", category: "Set", syntax: ["setSize(set)", "setSize(set, unique)"], description: 'Count the number of elements of a (multi)set. When the second parameter "unique" is true, count only the unique values. A multi-dimension array will be converted to a single-dimension array before the operation.', examples: ["setSize([1, 2, 2, 4])", "setSize([1, 2, 2, 4], true)"], seealso: ["setUnion", "setIntersect", "setDifference"] }, setSymDifferenceDocs = { name: "setSymDifference", category: "Set", syntax: ["setSymDifference(set1, set2)"], description: "Create the symmetric difference of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.", examples: ["setSymDifference([1, 2, 3, 4], [3, 4, 5, 6])", "setSymDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])"], seealso: ["setUnion", "setIntersect", "setDifference"] }, setUnionDocs = { name: "setUnion", category: "Set", syntax: ["setUnion(set1, set2)"], description: "Create the union of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.", examples: ["setUnion([1, 2, 3, 4], [3, 4, 5, 6])", "setUnion([[1, 2], [3, 4]], [[3, 4], [5, 6]])"], seealso: ["setIntersect", "setDifference"] }, zpk2tfDocs = { name: "zpk2tf", category: "Signal", syntax: ["zpk2tf(z, p, k)"], description: "Compute the transfer function of a zero-pole-gain model.", examples: ["zpk2tf([1, 2], [-1, -2], 1)", "zpk2tf([1, 2], [-1, -2])", "zpk2tf([1 - 3i, 2 + 2i], [-1, -2])"], seealso: [] }, freqzDocs = { name: "freqz", category: "Signal", syntax: ["freqz(b, a)", "freqz(b, a, w)"], description: "Calculates the frequency response of a filter given its numerator and denominator coefficients.", examples: ["freqz([1, 2], [1, 2, 3])", "freqz([1, 2], [1, 2, 3], [0, 1])", "freqz([1, 2], [1, 2, 3], 512)"], seealso: [] }, erfDocs = { name: "erf", category: "Special", syntax: ["erf(x)"], description: "Compute the erf function of a value using a rational Chebyshev approximations for different intervals of x", examples: ["erf(0.2)", "erf(-0.5)", "erf(4)"], seealso: [] }, zetaDocs = { name: "zeta", category: "Special", syntax: ["zeta(s)"], description: "Compute the Riemann Zeta Function using an infinite series and Riemann's Functional Equation for the entire complex plane", examples: ["zeta(0.2)", "zeta(-0.5)", "zeta(4)"], seealso: [] }, madDocs = { name: "mad", category: "Statistics", syntax: ["mad(a, b, c, ...)", "mad(A)"], description: "Compute the median absolute deviation of a matrix or a list with values. The median absolute deviation is defined as the median of the absolute deviations from the median.", examples: ["mad(10, 20, 30)", "mad([1, 2, 3])"], seealso: ["mean", "median", "std", "abs"] }, maxDocs = { name: "max", category: "Statistics", syntax: ["max(a, b, c, ...)", "max(A)", "max(A, dimension)"], description: "Compute the maximum value of a list of values. If any NaN values are found, the function yields the last NaN in the input.", examples: ["max(2, 3, 4, 1)", "max([2, 3, 4, 1])", "max([2, 5; 4, 3])", "max([2, 5; 4, 3], 1)", "max([2, 5; 4, 3], 2)", "max(2.7, 7.1, -4.5, 2.0, 4.1)", "min(2.7, 7.1, -4.5, 2.0, 4.1)"], seealso: ["mean", "median", "min", "prod", "std", "sum", "variance"] }, meanDocs = { name: "mean", category: "Statistics", syntax: ["mean(a, b, c, ...)", "mean(A)", "mean(A, dimension)"], description: "Compute the arithmetic mean of a list of values.", examples: ["mean(2, 3, 4, 1)", "mean([2, 3, 4, 1])", "mean([2, 5; 4, 3])", "mean([2, 5; 4, 3], 1)", "mean([2, 5; 4, 3], 2)", "mean([1.0, 2.7, 3.2, 4.0])"], seealso: ["max", "median", "min", "prod", "std", "sum", "variance"] }, medianDocs = { name: "median", category: "Statistics", syntax: ["median(a, b, c, ...)", "median(A)"], description: "Compute the median of all values. The values are sorted and the middle value is returned. In case of an even number of values, the average of the two middle values is returned.", examples: ["median(5, 2, 7)", "median([3, -1, 5, 7])"], seealso: ["max", "mean", "min", "prod", "std", "sum", "variance", "quantileSeq"] }, minDocs = { name: "min", category: "Statistics", syntax: ["min(a, b, c, ...)", "min(A)", "min(A, dimension)"], description: "Compute the minimum value of a list of values. If any NaN values are found, the function yields the last NaN in the input.", examples: ["min(2, 3, 4, 1)", "min([2, 3, 4, 1])", "min([2, 5; 4, 3])", "min([2, 5; 4, 3], 1)", "min([2, 5; 4, 3], 2)", "min(2.7, 7.1, -4.5, 2.0, 4.1)", "max(2.7, 7.1, -4.5, 2.0, 4.1)"], seealso: ["max", "mean", "median", "prod", "std", "sum", "variance"] }, modeDocs = { name: "mode", category: "Statistics", syntax: ["mode(a, b, c, ...)", "mode(A)", "mode(A, a, b, B, c, ...)"], description: "Computes the mode of all values as an array. In case mode being more than one, multiple values are returned in an array.", examples: ["mode(2, 1, 4, 3, 1)", "mode([1, 2.7, 3.2, 4, 2.7])", "mode(1, 4, 6, 1, 6)"], seealso: ["max", "mean", "min", "median", "prod", "std", "sum", "variance"] }, prodDocs = { name: "prod", category: "Statistics", syntax: ["prod(a, b, c, ...)", "prod(A)"], description: "Compute the product of all values.", examples: ["prod(2, 3, 4)", "prod([2, 3, 4])", "prod([2, 5; 4, 3])"], seealso: ["max", "mean", "min", "median", "min", "std", "sum", "variance"] }, quantileSeqDocs = { name: "quantileSeq", category: "Statistics", syntax: ["quantileSeq(A, prob[, sorted])", "quantileSeq(A, [prob1, prob2, ...][, sorted])", "quantileSeq(A, N[, sorted])"], description: `Compute the prob order quantile of a matrix or a list with values. The sequence is sorted and the middle value is returned. Supported types of sequence values are: Number, BigNumber, Unit Supported types of probability are: Number, BigNumber. 

In case of a (multi dimensional) array or matrix, the prob order quantile of all elements will be calculated.`, examples: ["quantileSeq([3, -1, 5, 7], 0.5)", "quantileSeq([3, -1, 5, 7], [1/3, 2/3])", "quantileSeq([3, -1, 5, 7], 2)", "quantileSeq([-1, 3, 5, 7], 0.5, true)"], seealso: ["mean", "median", "min", "max", "prod", "std", "sum", "variance"] }, stdDocs = { name: "std", category: "Statistics", syntax: ["std(a, b, c, ...)", "std(A)", "std(A, dimension)", "std(A, normalization)", "std(A, dimension, normalization)"], description: 'Compute the standard deviation of all values, defined as std(A) = sqrt(variance(A)). Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".', examples: ["std(2, 4, 6)", "std([2, 4, 6, 8])", 'std([2, 4, 6, 8], "uncorrected")', 'std([2, 4, 6, 8], "biased")', "std([1, 2, 3; 4, 5, 6])"], seealso: ["max", "mean", "min", "median", "prod", "sum", "variance"] }, cumSumDocs = { name: "cumsum", category: "Statistics", syntax: ["cumsum(a, b, c, ...)", "cumsum(A)"], description: "Compute the cumulative sum of all values.", examples: ["cumsum(2, 3, 4, 1)", "cumsum([2, 3, 4, 1])", "cumsum([1, 2; 3, 4])", "cumsum([1, 2; 3, 4], 1)", "cumsum([1, 2; 3, 4], 2)"], seealso: ["max", "mean", "median", "min", "prod", "std", "sum", "variance"] }, sumDocs = { name: "sum", category: "Statistics", syntax: ["sum(a, b, c, ...)", "sum(A)", "sum(A, dimension)"], description: "Compute the sum of all values.", examples: ["sum(2, 3, 4, 1)", "sum([2, 3, 4, 1])", "sum([2, 5; 4, 3])"], seealso: ["max", "mean", "median", "min", "prod", "std", "variance"] }, varianceDocs = { name: "variance", category: "Statistics", syntax: ["variance(a, b, c, ...)", "variance(A)", "variance(A, dimension)", "variance(A, normalization)", "variance(A, dimension, normalization)"], description: 'Compute the variance of all values. Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".', examples: ["variance(2, 4, 6)", "variance([2, 4, 6, 8])", 'variance([2, 4, 6, 8], "uncorrected")', 'variance([2, 4, 6, 8], "biased")', "variance([1, 2, 3; 4, 5, 6])"], seealso: ["max", "mean", "min", "median", "min", "prod", "std", "sum"] }, corrDocs = { name: "corr", category: "Statistics", syntax: ["corr(A,B)"], description: "Compute the correlation coefficient of a two list with values, For matrices, the matrix correlation coefficient is calculated.", examples: ["corr([2, 4, 6, 8],[1, 2, 3, 6])", "corr(matrix([[1, 2.2, 3, 4.8, 5], [1, 2, 3, 4, 5]]), matrix([[4, 5.3, 6.6, 7, 8], [1, 2, 3, 4, 5]]))"], seealso: ["max", "mean", "min", "median", "min", "prod", "std", "sum"] }, acosDocs = { name: "acos", category: "Trigonometry", syntax: ["acos(x)"], description: "Compute the inverse cosine of a value in radians.", examples: ["acos(0.5)", "acos(cos(2.3))"], seealso: ["cos", "atan", "asin"] }, acoshDocs = { name: "acosh", category: "Trigonometry", syntax: ["acosh(x)"], description: "Calculate the hyperbolic arccos of a value, defined as `acosh(x) = ln(sqrt(x^2 - 1) + x)`.", examples: ["acosh(1.5)"], seealso: ["cosh", "asinh", "atanh"] }, acotDocs = { name: "acot", category: "Trigonometry", syntax: ["acot(x)"], description: "Calculate the inverse cotangent of a value.", examples: ["acot(0.5)", "acot(cot(0.5))", "acot(2)"], seealso: ["cot", "atan"] }, acothDocs = { name: "acoth", category: "Trigonometry", syntax: ["acoth(x)"], description: "Calculate the inverse hyperbolic tangent of a value, defined as `acoth(x) = (ln((x+1)/x) + ln(x/(x-1))) / 2`.", examples: ["acoth(2)", "acoth(0.5)"], seealso: ["acsch", "asech"] }, acscDocs = { name: "acsc", category: "Trigonometry", syntax: ["acsc(x)"], description: "Calculate the inverse cotangent of a value.", examples: ["acsc(2)", "acsc(csc(0.5))", "acsc(0.5)"], seealso: ["csc", "asin", "asec"] }, acschDocs = { name: "acsch", category: "Trigonometry", syntax: ["acsch(x)"], description: "Calculate the inverse hyperbolic cosecant of a value, defined as `acsch(x) = ln(1/x + sqrt(1/x^2 + 1))`.", examples: ["acsch(0.5)"], seealso: ["asech", "acoth"] }, asecDocs = { name: "asec", category: "Trigonometry", syntax: ["asec(x)"], description: "Calculate the inverse secant of a value.", examples: ["asec(0.5)", "asec(sec(0.5))", "asec(2)"], seealso: ["acos", "acot", "acsc"] }, asechDocs = { name: "asech", category: "Trigonometry", syntax: ["asech(x)"], description: "Calculate the inverse secant of a value.", examples: ["asech(0.5)"], seealso: ["acsch", "acoth"] }, asinDocs = { name: "asin", category: "Trigonometry", syntax: ["asin(x)"], description: "Compute the inverse sine of a value in radians.", examples: ["asin(0.5)", "asin(sin(0.5))"], seealso: ["sin", "acos", "atan"] }, asinhDocs = { name: "asinh", category: "Trigonometry", syntax: ["asinh(x)"], description: "Calculate the hyperbolic arcsine of a value, defined as `asinh(x) = ln(x + sqrt(x^2 + 1))`.", examples: ["asinh(0.5)"], seealso: ["acosh", "atanh"] }, atanDocs = { name: "atan", category: "Trigonometry", syntax: ["atan(x)"], description: "Compute the inverse tangent of a value in radians.", examples: ["atan(0.5)", "atan(tan(0.5))"], seealso: ["tan", "acos", "asin"] }, atan2Docs = { name: "atan2", category: "Trigonometry", syntax: ["atan2(y, x)"], description: "Computes the principal value of the arc tangent of y/x in radians.", examples: ["atan2(2, 2) / pi", "angle = 60 deg in rad", "x = cos(angle)", "y = sin(angle)", "atan2(y, x)"], seealso: ["sin", "cos", "tan"] }, atanhDocs = { name: "atanh", category: "Trigonometry", syntax: ["atanh(x)"], description: "Calculate the hyperbolic arctangent of a value, defined as `atanh(x) = ln((1 + x)/(1 - x)) / 2`.", examples: ["atanh(0.5)"], seealso: ["acosh", "asinh"] }, cosDocs = { name: "cos", category: "Trigonometry", syntax: ["cos(x)"], description: "Compute the cosine of x in radians.", examples: ["cos(2)", "cos(pi / 4) ^ 2", "cos(180 deg)", "cos(60 deg)", "sin(0.2)^2 + cos(0.2)^2"], seealso: ["acos", "sin", "tan"] }, coshDocs = { name: "cosh", category: "Trigonometry", syntax: ["cosh(x)"], description: "Compute the hyperbolic cosine of x in radians.", examples: ["cosh(0.5)"], seealso: ["sinh", "tanh", "coth"] }, cotDocs = { name: "cot", category: "Trigonometry", syntax: ["cot(x)"], description: "Compute the cotangent of x in radians. Defined as 1/tan(x)", examples: ["cot(2)", "1 / tan(2)"], seealso: ["sec", "csc", "tan"] }, cothDocs = { name: "coth", category: "Trigonometry", syntax: ["coth(x)"], description: "Compute the hyperbolic cotangent of x in radians.", examples: ["coth(2)", "1 / tanh(2)"], seealso: ["sech", "csch", "tanh"] }, cscDocs = { name: "csc", category: "Trigonometry", syntax: ["csc(x)"], description: "Compute the cosecant of x in radians. Defined as 1/sin(x)", examples: ["csc(2)", "1 / sin(2)"], seealso: ["sec", "cot", "sin"] }, cschDocs = { name: "csch", category: "Trigonometry", syntax: ["csch(x)"], description: "Compute the hyperbolic cosecant of x in radians. Defined as 1/sinh(x)", examples: ["csch(2)", "1 / sinh(2)"], seealso: ["sech", "coth", "sinh"] }, secDocs = { name: "sec", category: "Trigonometry", syntax: ["sec(x)"], description: "Compute the secant of x in radians. Defined as 1/cos(x)", examples: ["sec(2)", "1 / cos(2)"], seealso: ["cot", "csc", "cos"] }, sechDocs = { name: "sech", category: "Trigonometry", syntax: ["sech(x)"], description: "Compute the hyperbolic secant of x in radians. Defined as 1/cosh(x)", examples: ["sech(2)", "1 / cosh(2)"], seealso: ["coth", "csch", "cosh"] }, sinDocs = { name: "sin", category: "Trigonometry", syntax: ["sin(x)"], description: "Compute the sine of x in radians.", examples: ["sin(2)", "sin(pi / 4) ^ 2", "sin(90 deg)", "sin(30 deg)", "sin(0.2)^2 + cos(0.2)^2"], seealso: ["asin", "cos", "tan"] }, sinhDocs = { name: "sinh", category: "Trigonometry", syntax: ["sinh(x)"], description: "Compute the hyperbolic sine of x in radians.", examples: ["sinh(0.5)"], seealso: ["cosh", "tanh"] }, tanDocs = { name: "tan", category: "Trigonometry", syntax: ["tan(x)"], description: "Compute the tangent of x in radians.", examples: ["tan(0.5)", "sin(0.5) / cos(0.5)", "tan(pi / 4)", "tan(45 deg)"], seealso: ["atan", "sin", "cos"] }, tanhDocs = { name: "tanh", category: "Trigonometry", syntax: ["tanh(x)"], description: "Compute the hyperbolic tangent of x in radians.", examples: ["tanh(0.5)", "sinh(0.5) / cosh(0.5)"], seealso: ["sinh", "cosh"] }, toDocs = { name: "to", category: "Units", syntax: ["x to unit", "to(x, unit)"], description: "Change the unit of a value.", examples: ["5 inch to cm", "3.2kg to g", "16 bytes in bits"], seealso: [] }, toBestDocs = { name: "toBest", category: "Units", syntax: ["toBest(x)", "toBest(x, unitList)", "toBest(x, unitList, options)"], description: "Converts to the most appropriate display unit.", examples: ['toBest(unit(5000, "m"))', 'toBest(unit(3500000, "W"))', 'toBest(unit(0.000000123, "A"))', 'toBest(unit(10, "m"), "cm")', 'toBest(unit(10, "m"), "mm,km", {offset: 1.5})'], seealso: [] }, binDocs = { name: "bin", category: "Utils", syntax: ["bin(value)"], description: "Format a number as binary", examples: ["bin(2)"], seealso: ["oct", "hex"] }, cloneDocs = { name: "clone", category: "Utils", syntax: ["clone(x)"], description: "Clone a variable. Creates a copy of primitive variables, and a deep copy of matrices", examples: ["clone(3.5)", "clone(2 - 4i)", "clone(45 deg)", "clone([1, 2; 3, 4])", 'clone("hello world")'], seealso: [] }, formatDocs = { name: "format", category: "Utils", syntax: ["format(value)", "format(value, precision)"], description: "Format a value of any type as string.", examples: ["format(2.3)", "format(3 - 4i)", "format([])", "format(pi, 3)"], seealso: ["print"] }, hasNumericValueDocs = { name: "hasNumericValue", category: "Utils", syntax: ["hasNumericValue(x)"], description: "Test whether a value is an numeric value. In case of a string, true is returned if the string contains a numeric value.", examples: ["hasNumericValue(2)", 'hasNumericValue("2")', 'isNumeric("2")', "hasNumericValue(0)", "hasNumericValue(bignumber(500))", "hasNumericValue(fraction(0.125))", "hasNumericValue(2 + 3i)", 'hasNumericValue([2.3, "foo", false])'], seealso: ["isInteger", "isZero", "isNegative", "isPositive", "isNaN", "isNumeric"] }, hexDocs = { name: "hex", category: "Utils", syntax: ["hex(value)"], description: "Format a number as hexadecimal", examples: ["hex(240)"], seealso: ["bin", "oct"] }, isIntegerDocs = { name: "isInteger", category: "Utils", syntax: ["isInteger(x)"], description: "Test whether a value is an integer number.", examples: ["isInteger(2)", "isInteger(3.5)", "isInteger([3, 0.5, -2])"], seealso: ["isNegative", "isNumeric", "isPositive", "isZero"] }, isNaNDocs = { name: "isNaN", category: "Utils", syntax: ["isNaN(x)"], description: "Test whether a value is NaN (not a number)", examples: ["isNaN(2)", "isNaN(0 / 0)", "isNaN(NaN)", "isNaN(Infinity)"], seealso: ["isNegative", "isNumeric", "isPositive", "isZero", "isFinite", "isBounded"] }, isBoundedDocs = { name: "isBounded", category: "Utils", syntax: ["isBounded(x)"], description: "Test whether a value or its entries are bounded.", examples: ["isBounded(Infinity)", "isBounded(bigint(3))", "isBounded([3, -Infinity, -3])"], seealso: ["isFinite", "isNumeric", "isNaN", "isNegative", "isPositive"] }, isFiniteDocs = { name: "isFinite", category: "Utils", syntax: ["isFinite(x)"], description: "Test whether a value is finite, elementwise on collections.", examples: ["isFinite(Infinity)", "isFinite(bigint(3))", "isFinite([3, -Infinity, -3])"], seealso: ["isBounded", "isNumeric", "isNaN", "isNegative", "isPositive"] }, isNegativeDocs = { name: "isNegative", category: "Utils", syntax: ["isNegative(x)"], description: "Test whether a value is negative: smaller than zero.", examples: ["isNegative(2)", "isNegative(0)", "isNegative(-4)", "isNegative([3, 0.5, -2])"], seealso: ["isInteger", "isNumeric", "isPositive", "isZero"] }, isNumericDocs = { name: "isNumeric", category: "Utils", syntax: ["isNumeric(x)"], description: "Test whether a value is a numeric value. Returns true when the input is a number, BigNumber, Fraction, or boolean.", examples: ["isNumeric(2)", 'isNumeric("2")', 'hasNumericValue("2")', "isNumeric(0)", "isNumeric(bignumber(500))", "isNumeric(fraction(0.125))", "isNumeric(2 + 3i)", 'isNumeric([2.3, "foo", false])'], seealso: ["isInteger", "isZero", "isNegative", "isPositive", "isNaN", "hasNumericValue", "isFinite", "isBounded"] }, isPositiveDocs = { name: "isPositive", category: "Utils", syntax: ["isPositive(x)"], description: "Test whether a value is positive: larger than zero.", examples: ["isPositive(2)", "isPositive(0)", "isPositive(-4)", "isPositive([3, 0.5, -2])"], seealso: ["isInteger", "isNumeric", "isNegative", "isZero"] }, isPrimeDocs = { name: "isPrime", category: "Utils", syntax: ["isPrime(x)"], description: "Test whether a value is prime: has no divisors other than itself and one.", examples: ["isPrime(3)", "isPrime(-2)", "isPrime([2, 17, 100])"], seealso: ["isInteger", "isNumeric", "isNegative", "isZero"] }, isZeroDocs = { name: "isZero", category: "Utils", syntax: ["isZero(x)"], description: "Test whether a value is zero.", examples: ["isZero(2)", "isZero(0)", "isZero(-4)", "isZero([3, 0, -2, 0])"], seealso: ["isInteger", "isNumeric", "isNegative", "isPositive"] }, numericDocs = { name: "numeric", category: "Utils", syntax: ["numeric(x)"], description: "Convert a numeric input to a specific numeric type: number, BigNumber, bigint, or Fraction.", examples: ['numeric("4")', 'numeric("4", "number")', 'numeric("4", "bigint")', 'numeric("4", "BigNumber")', 'numeric("4", "Fraction")', 'numeric(4, "Fraction")', 'numeric(fraction(2, 5), "number")'], seealso: ["number", "bigint", "fraction", "bignumber", "string", "format"] }, octDocs = { name: "oct", category: "Utils", syntax: ["oct(value)"], description: "Format a number as octal", examples: ["oct(56)"], seealso: ["bin", "hex"] }, printDocs = { name: "print", category: "Utils", syntax: ["print(template, values)", "print(template, values, precision)"], description: "Interpolate values into a string template.", examples: ['print("Lucy is $age years old", {age: 5})', 'print("The value of pi is $pi", {pi: pi}, 3)', 'print("Hello, $user.name!", {user: {name: "John"}})', 'print("Values: $1, $2, $3", [6, 9, 4])'], seealso: ["format"] }, typeOfDocs = { name: "typeOf", category: "Utils", syntax: ["typeOf(x)"], description: "Get the type of a variable.", examples: ["typeOf(3.5)", "typeOf(2 - 4i)", "typeOf(45 deg)", 'typeOf("hello world")'], seealso: ["getMatrixDataType"] }, solveODEDocs = { name: "solveODE", category: "Numeric", syntax: ["solveODE(func, tspan, y0)", "solveODE(func, tspan, y0, options)"], description: "Numerical Integration of Ordinary Differential Equations.", examples: ["f(t,y) = y", "tspan = [0, 4]", "solveODE(f, tspan, 1)", "solveODE(f, tspan, [1, 2])", 'solveODE(f, tspan, 1, { method:"RK23", maxStep:0.1 })'], seealso: ["derivative", "simplifyCore"] }, embeddedDocs = { bignumber: bignumberDocs, bigint: bigintDocs, boolean: booleanDocs, complex: complexDocs, createUnit: createUnitDocs, fraction: fractionDocs, index: indexDocs, matrix: matrixDocs, number: numberDocs, sparse: sparseDocs, splitUnit: splitUnitDocs, string: stringDocs, unit: unitDocs, e: eDocs, E: eDocs, false: falseDocs, i: iDocs, Infinity: InfinityDocs, LN2: LN2Docs, LN10: LN10Docs, LOG2E: LOG2EDocs, LOG10E: LOG10EDocs, NaN: NaNDocs, null: nullDocs, pi: piDocs, PI: piDocs, phi: phiDocs, SQRT1_2: SQRT12Docs, SQRT2: SQRT2Docs, tau: tauDocs, true: trueDocs, version: versionDocs, speedOfLight: { description: "Speed of light in vacuum", examples: ["speedOfLight"] }, gravitationConstant: { description: "Newtonian constant of gravitation", examples: ["gravitationConstant"] }, planckConstant: { description: "Planck constant", examples: ["planckConstant"] }, reducedPlanckConstant: { description: "Reduced Planck constant", examples: ["reducedPlanckConstant"] }, magneticConstant: { description: "Magnetic constant (vacuum permeability)", examples: ["magneticConstant"] }, electricConstant: { description: "Electric constant (vacuum permeability)", examples: ["electricConstant"] }, vacuumImpedance: { description: "Characteristic impedance of vacuum", examples: ["vacuumImpedance"] }, coulomb: { description: "Coulomb's constant. Deprecated in favor of coulombConstant", examples: ["coulombConstant"] }, coulombConstant: { description: "Coulomb's constant", examples: ["coulombConstant"] }, elementaryCharge: { description: "Elementary charge", examples: ["elementaryCharge"] }, bohrMagneton: { description: "Bohr magneton", examples: ["bohrMagneton"] }, conductanceQuantum: { description: "Conductance quantum", examples: ["conductanceQuantum"] }, inverseConductanceQuantum: { description: "Inverse conductance quantum", examples: ["inverseConductanceQuantum"] }, magneticFluxQuantum: { description: "Magnetic flux quantum", examples: ["magneticFluxQuantum"] }, nuclearMagneton: { description: "Nuclear magneton", examples: ["nuclearMagneton"] }, klitzing: { description: "Von Klitzing constant", examples: ["klitzing"] }, bohrRadius: { description: "Bohr radius", examples: ["bohrRadius"] }, classicalElectronRadius: { description: "Classical electron radius", examples: ["classicalElectronRadius"] }, electronMass: { description: "Electron mass", examples: ["electronMass"] }, fermiCoupling: { description: "Fermi coupling constant", examples: ["fermiCoupling"] }, fineStructure: { description: "Fine-structure constant", examples: ["fineStructure"] }, hartreeEnergy: { description: "Hartree energy", examples: ["hartreeEnergy"] }, protonMass: { description: "Proton mass", examples: ["protonMass"] }, deuteronMass: { description: "Deuteron Mass", examples: ["deuteronMass"] }, neutronMass: { description: "Neutron mass", examples: ["neutronMass"] }, quantumOfCirculation: { description: "Quantum of circulation", examples: ["quantumOfCirculation"] }, rydberg: { description: "Rydberg constant", examples: ["rydberg"] }, thomsonCrossSection: { description: "Thomson cross section", examples: ["thomsonCrossSection"] }, weakMixingAngle: { description: "Weak mixing angle", examples: ["weakMixingAngle"] }, efimovFactor: { description: "Efimov factor", examples: ["efimovFactor"] }, atomicMass: { description: "Atomic mass constant", examples: ["atomicMass"] }, avogadro: { description: "Avogadro's number", examples: ["avogadro"] }, boltzmann: { description: "Boltzmann constant", examples: ["boltzmann"] }, faraday: { description: "Faraday constant", examples: ["faraday"] }, firstRadiation: { description: "First radiation constant", examples: ["firstRadiation"] }, loschmidt: { description: "Loschmidt constant at T=273.15 K and p=101.325 kPa", examples: ["loschmidt"] }, gasConstant: { description: "Gas constant", examples: ["gasConstant"] }, molarPlanckConstant: { description: "Molar Planck constant", examples: ["molarPlanckConstant"] }, molarVolume: { description: "Molar volume of an ideal gas at T=273.15 K and p=101.325 kPa", examples: ["molarVolume"] }, sackurTetrode: { description: "Sackur-Tetrode constant at T=1 K and p=101.325 kPa", examples: ["sackurTetrode"] }, secondRadiation: { description: "Second radiation constant", examples: ["secondRadiation"] }, stefanBoltzmann: { description: "Stefan-Boltzmann constant", examples: ["stefanBoltzmann"] }, wienDisplacement: { description: "Wien displacement law constant", examples: ["wienDisplacement"] }, molarMass: { description: "Molar mass constant", examples: ["molarMass"] }, molarMassC12: { description: "Molar mass constant of carbon-12", examples: ["molarMassC12"] }, gravity: { description: "Standard acceleration of gravity (standard acceleration of free-fall on Earth)", examples: ["gravity"] }, planckLength: { description: "Planck length", examples: ["planckLength"] }, planckMass: { description: "Planck mass", examples: ["planckMass"] }, planckTime: { description: "Planck time", examples: ["planckTime"] }, planckCharge: { description: "Planck charge", examples: ["planckCharge"] }, planckTemperature: { description: "Planck temperature", examples: ["planckTemperature"] }, derivative: derivativeDocs, lsolve: lsolveDocs, lsolveAll: lsolveAllDocs, lup: lupDocs, lusolve: lusolveDocs, leafCount: leafCountDocs, polynomialRoot: polynomialRootDocs, resolve: resolveDocs, simplify: simplifyDocs, simplifyConstant: simplifyConstantDocs, simplifyCore: simplifyCoreDocs, symbolicEqual: symbolicEqualDocs, rationalize: rationalizeDocs, slu: sluDocs, usolve: usolveDocs, usolveAll: usolveAllDocs, qr: qrDocs, abs: absDocs, add: addDocs, cbrt: cbrtDocs, ceil: ceilDocs, cube: cubeDocs, divide: divideDocs, dotDivide: dotDivideDocs, dotMultiply: dotMultiplyDocs, dotPow: dotPowDocs, exp: expDocs, expm: expmDocs, expm1: expm1Docs, fix: fixDocs, floor: floorDocs, gcd: gcdDocs, hypot: hypotDocs, lcm: lcmDocs, log: logDocs, log2: log2Docs, log1p: log1pDocs, log10: log10Docs, mod: modDocs, multiply: multiplyDocs, norm: normDocs, nthRoot: nthRootDocs, nthRoots: nthRootsDocs, pow: powDocs, round: roundDocs, sign: signDocs, sqrt: sqrtDocs, sqrtm: sqrtmDocs, square: squareDocs, subtract: subtractDocs, unaryMinus: unaryMinusDocs, unaryPlus: unaryPlusDocs, xgcd: xgcdDocs, invmod: invmodDocs, num: numDocs, den: denDocs, bitAnd: bitAndDocs, bitNot: bitNotDocs, bitOr: bitOrDocs, bitXor: bitXorDocs, leftShift: leftShiftDocs, rightArithShift: rightArithShiftDocs, rightLogShift: rightLogShiftDocs, bellNumbers: bellNumbersDocs, catalan: catalanDocs, composition: compositionDocs, stirlingS2: stirlingS2Docs, config: configDocs, import: importDocs, typed: typedDocs, arg: argDocs, conj: conjDocs, re: reDocs, im: imDocs, evaluate: evaluateDocs, help: helpDocs, parse: parseDocs, parser: parserDocs, compile: compileDocs, distance: distanceDocs, intersect: intersectDocs, and: andDocs, not: notDocs, nullish: nullishDocs, or: orDocs, xor: xorDocs, mapSlices: mapSlicesDocs, concat: concatDocs, count: countDocs, cross: crossDocs, column: columnDocs, ctranspose: ctransposeDocs, det: detDocs, diag: diagDocs, diff: diffDocs, dot: dotDocs, getMatrixDataType: getMatrixDataTypeDocs, identity: identityDocs, filter: filterDocs, flatten: flattenDocs, forEach: forEachDocs, inv: invDocs, pinv: pinvDocs, eigs: eigsDocs, kron: kronDocs, matrixFromFunction: matrixFromFunctionDocs, matrixFromRows: matrixFromRowsDocs, matrixFromColumns: matrixFromColumnsDocs, map: mapDocs, ones: onesDocs, partitionSelect: partitionSelectDocs, range: rangeDocs, resize: resizeDocs, reshape: reshapeDocs, rotate: rotateDocs, rotationMatrix: rotationMatrixDocs, row: rowDocs, size: sizeDocs, sort: sortDocs, squeeze: squeezeDocs, subset: subsetDocs, trace: traceDocs, transpose: transposeDocs, zeros: zerosDocs, fft: fftDocs, ifft: ifftDocs, sylvester: sylvesterDocs, schur: schurDocs, lyap: lyapDocs, solveODE: solveODEDocs, bernoulli: bernoulliDocs, combinations: combinationsDocs, combinationsWithRep: combinationsWithRepDocs, factorial: factorialDocs, gamma: gammaDocs, kldivergence: kldivergenceDocs, lgamma: lgammaDocs, multinomial: multinomialDocs, permutations: permutationsDocs, pickRandom: pickRandomDocs, random: randomDocs, randomInt: randomIntDocs, compare: compareDocs, compareNatural: compareNaturalDocs, compareText: compareTextDocs, deepEqual: deepEqualDocs, equal: equalDocs, equalText: equalTextDocs, larger: largerDocs, largerEq: largerEqDocs, smaller: smallerDocs, smallerEq: smallerEqDocs, unequal: unequalDocs, setCartesian: setCartesianDocs, setDifference: setDifferenceDocs, setDistinct: setDistinctDocs, setIntersect: setIntersectDocs, setIsSubset: setIsSubsetDocs, setMultiplicity: setMultiplicityDocs, setPowerset: setPowersetDocs, setSize: setSizeDocs, setSymDifference: setSymDifferenceDocs, setUnion: setUnionDocs, zpk2tf: zpk2tfDocs, freqz: freqzDocs, erf: erfDocs, zeta: zetaDocs, cumsum: cumSumDocs, mad: madDocs, max: maxDocs, mean: meanDocs, median: medianDocs, min: minDocs, mode: modeDocs, prod: prodDocs, quantileSeq: quantileSeqDocs, std: stdDocs, sum: sumDocs, variance: varianceDocs, corr: corrDocs, acos: acosDocs, acosh: acoshDocs, acot: acotDocs, acoth: acothDocs, acsc: acscDocs, acsch: acschDocs, asec: asecDocs, asech: asechDocs, asin: asinDocs, asinh: asinhDocs, atan: atanDocs, atanh: atanhDocs, atan2: atan2Docs, cos: cosDocs, cosh: coshDocs, cot: cotDocs, coth: cothDocs, csc: cscDocs, csch: cschDocs, sec: secDocs, sech: sechDocs, sin: sinDocs, sinh: sinhDocs, tan: tanDocs, tanh: tanhDocs, to: toDocs, toBest: toBestDocs, clone: cloneDocs, format: formatDocs, bin: binDocs, oct: octDocs, hex: hexDocs, isNaN: isNaNDocs, isBounded: isBoundedDocs, isFinite: isFiniteDocs, isInteger: isIntegerDocs, isNegative: isNegativeDocs, isNumeric: isNumericDocs, hasNumericValue: hasNumericValueDocs, isPositive: isPositiveDocs, isPrime: isPrimeDocs, isZero: isZeroDocs, print: printDocs, typeOf: typeOfDocs, numeric: numericDocs }, name$79 = "help", dependencies$79 = ["typed", "mathWithTransform", "Help"], createHelp = factory(name$79, dependencies$79, (D) => {
  var { typed: E, mathWithTransform: O, Help: F } = D;
  return E(name$79, { any: function(I) {
    var z, R = I;
    if (typeof I != "string") {
      for (z in O) if (hasOwnProperty$1(O, z) && I === O[z]) {
        R = z;
        break;
      }
    }
    var L = getSafeProperty(embeddedDocs, R);
    if (!L) {
      var q = typeof R == "function" ? R.name : R;
      throw Error('No documentation found on "' + q + '"');
    }
    return new F(L);
  } });
}), name$78 = "chain", dependencies$78 = ["typed", "Chain"], createChain = factory(name$78, dependencies$78, (D) => {
  var { typed: E, Chain: O } = D;
  return E(name$78, { "": function() {
    return new O();
  }, any: function(F) {
    return new O(F);
  } });
}), name$77 = "det", dependencies$77 = ["typed", "matrix", "subtractScalar", "multiply", "divideScalar", "isZero", "unaryMinus"], createDet = factory(name$77, dependencies$77, (D) => {
  var { typed: E, matrix: O, subtractScalar: F, multiply: I, divideScalar: z, isZero: R, unaryMinus: L } = D;
  return E(name$77, { any: function(U) {
    return clone$3(U);
  }, "Array | Matrix": function(U) {
    var Z;
    switch (isMatrix(U) ? Z = U.size() : Array.isArray(U) ? (U = O(U), Z = U.size()) : Z = [], Z.length) {
      case 0:
        return clone$3(U);
      case 1:
        if (Z[0] === 1) return clone$3(U.valueOf()[0]);
        if (Z[0] === 0) return 1;
        throw RangeError("Matrix must be square (size: " + format(Z) + ")");
      case 2:
        var V = Z[0], G = Z[1];
        if (V === G) return q(U.clone().valueOf(), V);
        if (G === 0) return 1;
        throw RangeError("Matrix must be square (size: " + format(Z) + ")");
      default:
        throw RangeError("Matrix must be two dimensional (size: " + format(Z) + ")");
    }
  } });
  function q(U, Z, V) {
    if (Z === 1) return clone$3(U[0][0]);
    if (Z === 2) return F(I(U[0][0], U[1][1]), I(U[1][0], U[0][1]));
    for (var G = !1, W = Array(Z).fill(0).map((ue, oe) => oe), J = 0; J < Z; J++) {
      var X = W[J];
      if (R(U[X][J])) {
        var Y = void 0;
        for (Y = J + 1; Y < Z; Y++) if (!R(U[W[Y]][J])) {
          X = W[Y], W[Y] = W[J], W[J] = X, G = !G;
          break;
        }
        if (Y === Z) return U[X][J];
      }
      for (var ee = U[X][J], K = J === 0 ? 1 : U[W[J - 1]][J - 1], te = J + 1; te < Z; te++) for (var ie = W[te], ne = J + 1; ne < Z; ne++) U[ie][ne] = z(F(I(U[ie][ne], ee), I(U[ie][J], U[X][ne])), K);
    }
    var ae = U[W[Z - 1]][Z - 1];
    return G ? L(ae) : ae;
  }
}), name$76 = "inv", dependencies$76 = ["typed", "matrix", "divideScalar", "addScalar", "multiply", "unaryMinus", "det", "identity", "abs"], createInv = factory(name$76, dependencies$76, (D) => {
  var { typed: E, matrix: O, divideScalar: F, addScalar: I, multiply: z, unaryMinus: R, det: L, identity: q, abs: U } = D;
  return E(name$76, { "Array | Matrix": function(V) {
    var G = isMatrix(V) ? V.size() : arraySize(V);
    switch (G.length) {
      case 1:
        if (G[0] === 1) return isMatrix(V) ? O([F(1, V.valueOf()[0])]) : [F(1, V[0])];
        throw RangeError("Matrix must be square (size: " + format(G) + ")");
      case 2:
        var W = G[0], J = G[1];
        if (W === J) return isMatrix(V) ? O(Z(V.valueOf(), W, J), V.storage()) : Z(V, W, J);
        throw RangeError("Matrix must be square (size: " + format(G) + ")");
      default:
        throw RangeError("Matrix must be two dimensional (size: " + format(G) + ")");
    }
  }, any: function(V) {
    return F(1, V);
  } });
  function Z(V, G, W) {
    var J, X, Y, ee, K;
    if (G === 1) {
      if (ee = V[0][0], ee === 0) throw Error("Cannot calculate inverse, determinant is zero");
      return [[F(1, ee)]];
    } else if (G === 2) {
      var te = L(V);
      if (te === 0) throw Error("Cannot calculate inverse, determinant is zero");
      return [[F(V[1][1], te), F(R(V[0][1]), te)], [F(R(V[1][0]), te), F(V[0][0], te)]];
    } else {
      var ie = V.concat();
      for (J = 0; J < G; J++) ie[J] = ie[J].concat();
      for (var ne = q(G).valueOf(), ae = 0; ae < W; ae++) {
        var ue = U(ie[ae][ae]), oe = ae;
        for (J = ae + 1; J < G; ) U(ie[J][ae]) > ue && (ue = U(ie[J][ae]), oe = J), J++;
        if (ue === 0) throw Error("Cannot calculate inverse, determinant is zero");
        J = oe, J !== ae && (K = ie[ae], ie[ae] = ie[J], ie[J] = K, K = ne[ae], ne[ae] = ne[J], ne[J] = K);
        var se = ie[ae], le = ne[ae];
        for (J = 0; J < G; J++) {
          var ce = ie[J], fe = ne[J];
          if (J !== ae) {
            if (ce[ae] !== 0) {
              for (Y = F(R(ce[ae]), se[ae]), X = ae; X < W; X++) ce[X] = I(ce[X], z(Y, se[X]));
              for (X = 0; X < W; X++) fe[X] = I(fe[X], z(Y, le[X]));
            }
          } else {
            for (Y = se[ae], X = ae; X < W; X++) ce[X] = F(ce[X], Y);
            for (X = 0; X < W; X++) fe[X] = F(fe[X], Y);
          }
        }
      }
      return ne;
    }
  }
}), name$75 = "pinv", dependencies$75 = ["typed", "matrix", "inv", "deepEqual", "equal", "dotDivide", "dot", "ctranspose", "divideScalar", "multiply", "add", "Complex"], createPinv = factory(name$75, dependencies$75, (D) => {
  var { typed: E, matrix: O, inv: F, deepEqual: I, equal: z, dotDivide: R, dot: L, ctranspose: q, divideScalar: U, multiply: Z, add: V, Complex: G } = D;
  return E(name$75, { "Array | Matrix": function(K) {
    var te = isMatrix(K) ? K.size() : arraySize(K);
    switch (te.length) {
      case 1:
        return ee(K) ? q(K) : te[0] === 1 ? F(K) : R(q(K), L(K, K));
      case 2:
        if (ee(K)) return q(K);
        var ie = te[0], ne = te[1];
        if (ie === ne) try {
          return F(K);
        } catch (ae) {
          if (!(ae instanceof Error && ae.message.match(/Cannot calculate inverse, determinant is zero/))) throw ae;
        }
        return isMatrix(K) ? O(W(K.valueOf(), ie, ne), K.storage()) : W(K, ie, ne);
      default:
        throw RangeError("Matrix must be two dimensional (size: " + format(te) + ")");
    }
  }, any: function(K) {
    return z(K, 0) ? clone$3(K) : U(1, K);
  } });
  function W(K, te, ie) {
    var { C: ne, F: ae } = X(K, te, ie), ue = Z(F(Z(q(ne), ne)), q(ne));
    return Z(Z(q(ae), F(Z(ae, q(ae)))), ue);
  }
  function J(K, te, ie) {
    for (var ne = clone$3(K), ae = 0, ue = 0; ue < te; ue++) {
      if (ie <= ae) return ne;
      for (var oe = ue; Y(ne[oe][ae]); ) if (oe++, te === oe && (oe = ue, ae++, ie === ae)) return ne;
      [ne[oe], ne[ue]] = [ne[ue], ne[oe]];
      for (var se = ne[ue][ae], le = 0; le < ie; le++) ne[ue][le] = R(ne[ue][le], se);
      for (var ce = 0; ce < te; ce++) if (ce !== ue) {
        se = ne[ce][ae];
        for (var fe = 0; fe < ie; fe++) ne[ce][fe] = V(ne[ce][fe], Z(-1, Z(se, ne[ue][fe])));
      }
      ae++;
    }
    return ne;
  }
  function X(K, te, ie) {
    var ne = J(K, te, ie);
    return { C: K.map((ae, ue) => ae.filter((oe, se) => se < te && !Y(L(ne[se], ne[se])))), F: ne.filter((ae, ue) => !Y(L(ne[ue], ne[ue]))) };
  }
  function Y(K) {
    return z(V(K, G(1, 1)), V(0, G(1, 1)));
  }
  function ee(K) {
    return I(V(K, G(1, 1)), V(Z(K, 0), G(1, 1)));
  }
});
function createComplexEigs(D) {
  var { addScalar: E, subtract: O, flatten: F, multiply: I, multiplyScalar: z, divideScalar: R, sqrt: L, abs: q, bignumber: U, diag: Z, size: V, reshape: G, inv: W, qr: J, usolve: X, usolveAll: Y, equal: ee, complex: K, larger: te, smaller: ie, matrixFromColumns: ne, dot: ae } = D;
  function ue(Ne, he, ke, xe) {
    var Te = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, Fe = oe(Ne, he, ke, xe, Te);
    se(Ne, he, ke, xe, Te, Fe);
    var { values: be, C: Ae } = le(Ne, he, ke, xe, Te);
    return Te ? { values: be, eigenvectors: ce(Ne, he, Ae, Fe, be, ke, xe) } : { values: be };
  }
  function oe(Ne, he, ke, xe, Te) {
    var Fe = xe === "BigNumber", be = xe === "Complex", Ae = Fe ? U(0) : 0, Me = Fe ? U(1) : be ? K(1) : 1, $e = Fe ? U(1) : 1, Re = Fe ? U(10) : 2, je = z(Re, Re), Pe;
    Te && (Pe = Array(he).fill(Me));
    for (var Ke = !1; !Ke; ) {
      Ke = !0;
      for (var Qe = 0; Qe < he; Qe++) {
        for (var We = Ae, ir = Ae, nr = 0; nr < he; nr++) Qe !== nr && (We = E(We, q(Ne[nr][Qe])), ir = E(ir, q(Ne[Qe][nr])));
        if (!ee(We, 0) && !ee(ir, 0)) {
          for (var we = $e, Oe = We, ze = R(ir, Re), Ue = z(ir, Re); ie(Oe, ze); ) Oe = z(Oe, je), we = z(we, Re);
          for (; te(Oe, Ue); ) Oe = R(Oe, je), we = R(we, Re);
          if (ie(R(E(Oe, ir), we), z(E(We, ir), 0.95))) {
            Ke = !1;
            for (var er = R(1, we), Xe = 0; Xe < he; Xe++) Qe !== Xe && (Ne[Qe][Xe] = z(Ne[Qe][Xe], er), Ne[Xe][Qe] = z(Ne[Xe][Qe], we));
            Te && (Pe[Qe] = z(Pe[Qe], er));
          }
        }
      }
    }
    return Te ? Z(Pe) : null;
  }
  function se(Ne, he, ke, xe, Te, Fe) {
    var be = xe === "BigNumber", Ae = be ? U(0) : xe === "Complex" ? K(0) : 0;
    be && (ke = U(ke));
    for (var Me = 0; Me < he - 2; Me++) {
      for (var $e = 0, Re = Ae, je = Me + 1; je < he; je++) {
        var Pe = Ne[je][Me];
        ie(q(Re), q(Pe)) && (Re = Pe, $e = je);
      }
      if (!ie(q(Re), ke)) {
        if ($e !== Me + 1) {
          var Ke = Ne[$e];
          Ne[$e] = Ne[Me + 1], Ne[Me + 1] = Ke;
          for (var Qe = 0; Qe < he; Qe++) {
            var We = Ne[Qe][$e];
            Ne[Qe][$e] = Ne[Qe][Me + 1], Ne[Qe][Me + 1] = We;
          }
          if (Te) {
            var ir = Fe[$e];
            Fe[$e] = Fe[Me + 1], Fe[Me + 1] = ir;
          }
        }
        for (var nr = Me + 2; nr < he; nr++) {
          var we = R(Ne[nr][Me], Re);
          if (we !== 0) {
            for (var Oe = 0; Oe < he; Oe++) Ne[nr][Oe] = O(Ne[nr][Oe], z(we, Ne[Me + 1][Oe]));
            for (var ze = 0; ze < he; ze++) Ne[ze][Me + 1] = E(Ne[ze][Me + 1], z(we, Ne[ze][nr]));
            if (Te) for (var Ue = 0; Ue < he; Ue++) Fe[nr][Ue] = O(Fe[nr][Ue], z(we, Fe[Me + 1][Ue]));
          }
        }
      }
    }
    return Fe;
  }
  function le(Ne, he, ke, xe, Te) {
    var Fe = xe === "BigNumber", be = Fe ? U(1) : xe === "Complex" ? K(1) : 1;
    Fe && (ke = U(ke));
    for (var Ae = clone$3(Ne), Me = [], $e = he, Re = [], je = Te ? Z(Array(he).fill(be)) : void 0, Pe = Te ? Z(Array($e).fill(be)) : void 0, Ke = 0; Ke <= 100; ) {
      Ke += 1;
      for (var Qe = Ae[$e - 1][$e - 1], We = 0; We < $e; We++) Ae[We][We] = O(Ae[We][We], Qe);
      var { Q: ir, R: nr } = J(Ae);
      Ae = I(nr, ir);
      for (var we = 0; we < $e; we++) Ae[we][we] = E(Ae[we][we], Qe);
      if (Te && (Pe = I(Pe, ir)), $e === 1 || ie(q(Ae[$e - 1][$e - 2]), ke)) {
        Ke = 0, Me.push(Ae[$e - 1][$e - 1]), Te && (Re.unshift([[1]]), ve(Pe, he), je = I(je, Pe), $e > 1 && (Pe = Z(Array($e - 1).fill(be)))), --$e, Ae.pop();
        for (var Oe = 0; Oe < $e; Oe++) Ae[Oe].pop();
      } else if ($e === 2 || ie(q(Ae[$e - 2][$e - 3]), ke)) {
        Ke = 0;
        var ze = fe(Ae[$e - 2][$e - 2], Ae[$e - 2][$e - 1], Ae[$e - 1][$e - 2], Ae[$e - 1][$e - 1]);
        Me.push(...ze), Te && (Re.unshift(pe(Ae[$e - 2][$e - 2], Ae[$e - 2][$e - 1], Ae[$e - 1][$e - 2], Ae[$e - 1][$e - 1], ze[0], ze[1], ke, xe)), ve(Pe, he), je = I(je, Pe), $e > 2 && (Pe = Z(Array($e - 2).fill(be)))), $e -= 2, Ae.pop(), Ae.pop();
        for (var Ue = 0; Ue < $e; Ue++) Ae[Ue].pop(), Ae[Ue].pop();
      }
      if ($e === 0) break;
    }
    if (Me.sort((Xe, rr) => +O(q(Xe), q(rr))), Ke > 100) {
      var er = Error("The eigenvalues failed to converge. Only found these eigenvalues: " + Me.join(", "));
      throw er.values = Me, er.vectors = [], er;
    }
    return { values: Me, C: Te ? I(je, _e(Re, he)) : void 0 };
  }
  function ce(Ne, he, ke, xe, Te, Fe, be) {
    var Ae = I(W(ke), Ne, ke), Me = be === "BigNumber", $e = be === "Complex", Re = Me ? U(0) : $e ? K(0) : 0, je = Me ? U(1) : $e ? K(1) : 1, Pe = [], Ke = [];
    for (var Qe of Te) {
      var We = de(Pe, Qe, ee);
      We === -1 ? (Pe.push(Qe), Ke.push(1)) : Ke[We] += 1;
    }
    for (var ir = [], nr = Pe.length, we = Array(he).fill(Re), Oe = Z(Array(he).fill(je)), ze = function() {
      var er = Pe[Ue], Xe = O(Ae, I(er, Oe)), rr = Y(Xe, we);
      for (rr.shift(); rr.length < Ke[Ue]; ) {
        var or = ge(Xe, he, rr, Fe, be);
        if (or === null) break;
        rr.push(or);
      }
      var lr = I(W(xe), ke);
      rr = rr.map((sr) => I(lr, sr)), ir.push(...rr.map((sr) => ({ value: er, vector: F(sr) })));
    }, Ue = 0; Ue < nr; Ue++) ze();
    return ir;
  }
  function fe(Ne, he, ke, xe) {
    var Te = E(Ne, xe), Fe = O(z(Ne, xe), z(he, ke)), be = z(Te, 0.5), Ae = z(L(O(z(Te, Te), z(4, Fe))), 0.5);
    return [E(be, Ae), O(be, Ae)];
  }
  function pe(Ne, he, ke, xe, Te, Fe, be, Ae) {
    var Me = Ae === "BigNumber", $e = Ae === "Complex", Re = Me ? U(0) : $e ? K(0) : 0, je = Me ? U(1) : $e ? K(1) : 1;
    if (ie(q(ke), be)) return [[je, Re], [Re, je]];
    if (te(q(O(Te, Fe)), be)) return [[O(Te, xe), O(Fe, xe)], [ke, ke]];
    var Pe = O(Ne, Te), Ke = O(xe, Te);
    return ie(q(he), be) && ie(q(Ke), be) ? [[Pe, je], [ke, Re]] : [[he, Re], [Ke, je]];
  }
  function ve(Ne, he) {
    for (var ke = 0; ke < Ne.length; ke++) Ne[ke].push(...Array(he - Ne[ke].length).fill(0));
    for (var xe = Ne.length; xe < he; xe++) Ne.push(Array(he).fill(0)), Ne[xe][xe] = 1;
    return Ne;
  }
  function _e(Ne, he) {
    for (var ke = [], xe = 0; xe < he; xe++) ke[xe] = Array(he).fill(0);
    var Te = 0;
    for (var Fe of Ne) {
      for (var be = Fe.length, Ae = 0; Ae < be; Ae++) for (var Me = 0; Me < be; Me++) ke[Te + Ae][Te + Me] = Fe[Ae][Me];
      Te += be;
    }
    return ke;
  }
  function de(Ne, he, ke) {
    for (var xe = 0; xe < Ne.length; xe++) if (ke(Ne[xe], he)) return xe;
    return -1;
  }
  function ge(Ne, he, ke, xe, Te) {
    for (var Fe = Te === "BigNumber" ? U(1e3) : 1e3, be, Ae = 0; Ae < 5; ++Ae) {
      be = ye(he, ke, Te);
      try {
        be = X(Ne, be);
      } catch {
        continue;
      }
      if (te(Ce(be), Fe)) break;
    }
    if (Ae >= 5) return null;
    for (Ae = 0; ; ) {
      var Me = X(Ne, be);
      if (ie(Ce(De(be, [Me])), xe)) break;
      if (++Ae >= 10) return null;
      be = Ie(Me);
    }
    return be;
  }
  function ye(Ne, he, ke) {
    var xe = ke === "BigNumber", Te = ke === "Complex", Fe = Array(Ne).fill(0).map((be) => 2 * Math.random() - 1);
    return xe && (Fe = Fe.map((be) => U(be))), Te && (Fe = Fe.map((be) => K(be))), Fe = De(Fe, he), Ie(Fe, ke);
  }
  function De(Ne, he) {
    var ke = V(Ne);
    for (var xe of he) xe = G(xe, ke), Ne = O(Ne, I(R(ae(xe, Ne), ae(xe, xe)), xe));
    return Ne;
  }
  function Ce(Ne) {
    return q(L(ae(Ne, Ne)));
  }
  function Ie(Ne, he) {
    return I(R(he === "BigNumber" ? U(1) : he === "Complex" ? K(1) : 1, Ce(Ne)), Ne);
  }
  return ue;
}
function createRealSymmetric(D) {
  var { config: E, addScalar: O, subtract: F, abs: I, atan: z, cos: R, sin: L, multiplyScalar: q, inv: U, bignumber: Z, multiply: V, add: G } = D;
  function W(se, le) {
    var ce = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : E.relTol, fe = arguments.length > 3 ? arguments[3] : void 0, pe = arguments.length > 4 ? arguments[4] : void 0;
    if (fe === "number") return J(se, ce, pe);
    if (fe === "BigNumber") return X(se, ce, pe);
    throw TypeError("Unsupported data type: " + fe);
  }
  function J(se, le, ce) {
    var fe = se.length, pe = Math.abs(le / fe), ve, _e;
    if (ce) {
      _e = Array(fe);
      for (var de = 0; de < fe; de++) _e[de] = Array(fe).fill(0), _e[de][de] = 1;
    }
    for (var ge = ae(se); Math.abs(ge[1]) >= Math.abs(pe); ) {
      var ye = ge[0][0], De = ge[0][1];
      ve = Y(se[ye][ye], se[De][De], se[ye][De]), se = ne(se, ve, ye, De), ce && (_e = K(_e, ve, ye, De)), ge = ae(se);
    }
    for (var Ce = Array(fe).fill(0), Ie = 0; Ie < fe; Ie++) Ce[Ie] = se[Ie][Ie];
    return oe(clone$3(Ce), _e, ce);
  }
  function X(se, le, ce) {
    var fe = se.length, pe = I(le / fe), ve, _e;
    if (ce) {
      _e = Array(fe);
      for (var de = 0; de < fe; de++) _e[de] = Array(fe).fill(0), _e[de][de] = 1;
    }
    for (var ge = ue(se); I(ge[1]) >= I(pe); ) {
      var ye = ge[0][0], De = ge[0][1];
      ve = ee(se[ye][ye], se[De][De], se[ye][De]), se = ie(se, ve, ye, De), ce && (_e = te(_e, ve, ye, De)), ge = ue(se);
    }
    for (var Ce = Array(fe).fill(0), Ie = 0; Ie < fe; Ie++) Ce[Ie] = se[Ie][Ie];
    return oe(clone$3(Ce), _e, ce);
  }
  function Y(se, le, ce) {
    var fe = le - se;
    return Math.abs(fe) <= E.relTol ? Math.PI / 4 : 0.5 * Math.atan(2 * ce / (le - se));
  }
  function ee(se, le, ce) {
    var fe = F(le, se);
    return I(fe) <= E.relTol ? Z(-1).acos().div(4) : q(0.5, z(V(2, ce, U(fe))));
  }
  function K(se, le, ce, fe) {
    for (var pe = se.length, ve = Math.cos(le), _e = Math.sin(le), de = Array(pe).fill(0), ge = Array(pe).fill(0), ye = 0; ye < pe; ye++) de[ye] = ve * se[ye][ce] - _e * se[ye][fe], ge[ye] = _e * se[ye][ce] + ve * se[ye][fe];
    for (var De = 0; De < pe; De++) se[De][ce] = de[De], se[De][fe] = ge[De];
    return se;
  }
  function te(se, le, ce, fe) {
    for (var pe = se.length, ve = R(le), _e = L(le), de = Array(pe).fill(Z(0)), ge = Array(pe).fill(Z(0)), ye = 0; ye < pe; ye++) de[ye] = F(q(ve, se[ye][ce]), q(_e, se[ye][fe])), ge[ye] = O(q(_e, se[ye][ce]), q(ve, se[ye][fe]));
    for (var De = 0; De < pe; De++) se[De][ce] = de[De], se[De][fe] = ge[De];
    return se;
  }
  function ie(se, le, ce, fe) {
    for (var pe = se.length, ve = Z(R(le)), _e = Z(L(le)), de = q(ve, ve), ge = q(_e, _e), ye = Array(pe).fill(Z(0)), De = Array(pe).fill(Z(0)), Ce = V(Z(2), ve, _e, se[ce][fe]), Ie = O(F(q(de, se[ce][ce]), Ce), q(ge, se[fe][fe])), Ne = G(q(ge, se[ce][ce]), Ce, q(de, se[fe][fe])), he = 0; he < pe; he++) ye[he] = F(q(ve, se[ce][he]), q(_e, se[fe][he])), De[he] = O(q(_e, se[ce][he]), q(ve, se[fe][he]));
    se[ce][ce] = Ie, se[fe][fe] = Ne, se[ce][fe] = Z(0), se[fe][ce] = Z(0);
    for (var ke = 0; ke < pe; ke++) ke !== ce && ke !== fe && (se[ce][ke] = ye[ke], se[ke][ce] = ye[ke], se[fe][ke] = De[ke], se[ke][fe] = De[ke]);
    return se;
  }
  function ne(se, le, ce, fe) {
    for (var pe = se.length, ve = Math.cos(le), _e = Math.sin(le), de = ve * ve, ge = _e * _e, ye = Array(pe).fill(0), De = Array(pe).fill(0), Ce = de * se[ce][ce] - 2 * ve * _e * se[ce][fe] + ge * se[fe][fe], Ie = ge * se[ce][ce] + 2 * ve * _e * se[ce][fe] + de * se[fe][fe], Ne = 0; Ne < pe; Ne++) ye[Ne] = ve * se[ce][Ne] - _e * se[fe][Ne], De[Ne] = _e * se[ce][Ne] + ve * se[fe][Ne];
    se[ce][ce] = Ce, se[fe][fe] = Ie, se[ce][fe] = 0, se[fe][ce] = 0;
    for (var he = 0; he < pe; he++) he !== ce && he !== fe && (se[ce][he] = ye[he], se[he][ce] = ye[he], se[fe][he] = De[he], se[he][fe] = De[he]);
    return se;
  }
  function ae(se) {
    for (var le = se.length, ce = 0, fe = [0, 1], pe = 0; pe < le; pe++) for (var ve = pe + 1; ve < le; ve++) Math.abs(ce) < Math.abs(se[pe][ve]) && (ce = Math.abs(se[pe][ve]), fe = [pe, ve]);
    return [fe, ce];
  }
  function ue(se) {
    for (var le = se.length, ce = 0, fe = [0, 1], pe = 0; pe < le; pe++) for (var ve = pe + 1; ve < le; ve++) I(ce) < I(se[pe][ve]) && (ce = I(se[pe][ve]), fe = [pe, ve]);
    return [fe, ce];
  }
  function oe(se, le, ce) {
    var fe = se.length, pe = Array(fe), ve;
    if (ce) {
      ve = Array(fe);
      for (var _e = 0; _e < fe; _e++) ve[_e] = Array(fe);
    }
    for (var de = 0; de < fe; de++) {
      for (var ge = 0, ye = se[0], De = 0; De < se.length; De++) I(se[De]) < I(ye) && (ge = De, ye = se[ge]);
      if (pe[de] = se.splice(ge, 1)[0], ce) for (var Ce = 0; Ce < fe; Ce++) ve[de][Ce] = le[Ce][ge], le[Ce].splice(ge, 1);
    }
    return ce ? { values: pe, eigenvectors: ve.map((Ie, Ne) => ({ value: pe[Ne], vector: Ie })) } : { values: pe };
  }
  return W;
}
var name$74 = "eigs", dependencies$74 = "config.typed.matrix.addScalar.equal.subtract.abs.atan.cos.sin.multiplyScalar.divideScalar.inv.bignumber.multiply.add.larger.column.flatten.number.complex.sqrt.diag.size.reshape.qr.usolve.usolveAll.im.re.smaller.matrixFromColumns.dot".split("."), createEigs = factory(name$74, dependencies$74, (D) => {
  var { config: E, typed: O, matrix: F, addScalar: I, subtract: z, equal: R, abs: L, atan: q, cos: U, sin: Z, multiplyScalar: V, divideScalar: G, inv: W, bignumber: J, multiply: X, add: Y, larger: ee, column: K, flatten: te, number: ie, complex: ne, sqrt: ae, diag: ue, size: oe, reshape: se, qr: le, usolve: ce, usolveAll: fe, im: pe, re: ve, smaller: _e, matrixFromColumns: de, dot: ge } = D, ye = createRealSymmetric({ config: E, addScalar: I, subtract: z, abs: L, atan: q, cos: U, sin: Z, multiplyScalar: V, inv: W, bignumber: J, multiply: X, add: Y }), De = createComplexEigs({ addScalar: I, subtract: z, multiply: X, multiplyScalar: V, flatten: te, divideScalar: G, sqrt: ae, abs: L, bignumber: J, diag: ue, size: oe, reshape: se, qr: le, inv: W, usolve: ce, usolveAll: fe, equal: R, complex: ne, larger: ee, smaller: _e, matrixFromColumns: de, dot: ge });
  return O("eigs", { Array: function(Te) {
    return Ce(F(Te));
  }, "Array, number|BigNumber": function(Te, Fe) {
    return Ce(F(Te), { precision: Fe });
  }, "Array, Object"(Te, Fe) {
    return Ce(F(Te), Fe);
  }, Matrix: function(Te) {
    return Ce(Te, { matricize: !0 });
  }, "Matrix, number|BigNumber": function(Te, Fe) {
    return Ce(Te, { precision: Fe, matricize: !0 });
  }, "Matrix, Object": function(Te, Fe) {
    var be = { matricize: !0 };
    return _extends(be, Fe), Ce(Te, be);
  } });
  function Ce(Te) {
    var Fe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, be = "eigenvectors" in Fe ? Fe.eigenvectors : !0, Ae = Ie(Te, Fe.precision ?? E.relTol, be);
    return Fe.matricize && (Ae.values = F(Ae.values), be && (Ae.eigenvectors = Ae.eigenvectors.map((Me) => {
      var { value: $e, vector: Re } = Me;
      return { value: $e, vector: F(Re) };
    }))), be && Object.defineProperty(Ae, "vectors", { enumerable: !1, get: () => {
      throw Error("eigs(M).vectors replaced with eigs(M).eigenvectors");
    } }), Ae;
  }
  function Ie(Te, Fe, be) {
    var Ae = Te.toArray(), Me = Te.size();
    if (Me.length !== 2 || Me[0] !== Me[1]) throw RangeError(`Matrix must be square (size: ${format(Me)})`);
    var $e = Me[0];
    return he(Ae, $e, Fe) && (ke(Ae, $e), Ne(Ae, $e, Fe)) ? ye(Ae, $e, Fe, xe(Te, Ae, $e), be) : De(Ae, $e, Fe, xe(Te, Ae, $e), be);
  }
  function Ne(Te, Fe, be) {
    for (var Ae = 0; Ae < Fe; Ae++) for (var Me = Ae; Me < Fe; Me++) if (ee(J(L(z(Te[Ae][Me], Te[Me][Ae]))), be)) return !1;
    return !0;
  }
  function he(Te, Fe, be) {
    for (var Ae = 0; Ae < Fe; Ae++) for (var Me = 0; Me < Fe; Me++) if (ee(J(L(pe(Te[Ae][Me]))), be)) return !1;
    return !0;
  }
  function ke(Te, Fe) {
    for (var be = 0; be < Fe; be++) for (var Ae = 0; Ae < Fe; Ae++) Te[be][Ae] = ve(Te[be][Ae]);
  }
  function xe(Te, Fe, be) {
    var Ae = Te.datatype();
    if (Ae === "number" || Ae === "BigNumber" || Ae === "Complex") return Ae;
    for (var Me = !1, $e = !1, Re = !1, je = 0; je < be; je++) for (var Pe = 0; Pe < be; Pe++) {
      var Ke = Fe[je][Pe];
      if (isNumber(Ke) || isFraction(Ke)) Me = !0;
      else if (isBigNumber(Ke)) $e = !0;
      else if (isComplex(Ke)) Re = !0;
      else throw TypeError("Unsupported type in Matrix: " + typeOf(Ke));
    }
    if ($e && Re && console.warn("Complex BigNumbers not supported, this operation will lose precission."), Re) {
      for (var Qe = 0; Qe < be; Qe++) for (var We = 0; We < be; We++) Fe[Qe][We] = ne(Fe[Qe][We]);
      return "Complex";
    }
    if ($e) {
      for (var ir = 0; ir < be; ir++) for (var nr = 0; nr < be; nr++) Fe[ir][nr] = J(Fe[ir][nr]);
      return "BigNumber";
    }
    if (Me) {
      for (var we = 0; we < be; we++) for (var Oe = 0; Oe < be; Oe++) Fe[we][Oe] = ie(Fe[we][Oe]);
      return "number";
    } else throw TypeError("Matrix contains unsupported types only.");
  }
}), name$73 = "expm", dependencies$73 = ["typed", "abs", "add", "identity", "inv", "multiply"], createExpm = factory(name$73, dependencies$73, (D) => {
  var { typed: E, abs: O, add: F, identity: I, inv: z, multiply: R } = D;
  return E(name$73, { Matrix: function(Z) {
    var V = Z.size();
    if (V.length !== 2 || V[0] !== V[1]) throw RangeError("Matrix must be square (size: " + format(V) + ")");
    for (var G = V[0], W = q(L(Z), 1e-15), J = W.q, X = W.j, Y = R(Z, 2 ** -X), ee = I(G), K = I(G), te = 1, ie = Y, ne = -1, ae = 1; ae <= J; ae++) ae > 1 && (ie = R(ie, Y), ne = -ne), te = te * (J - ae + 1) / ((2 * J - ae + 1) * ae), ee = F(ee, R(te, ie)), K = F(K, R(te * ne, ie));
    for (var ue = R(z(K), ee), oe = 0; oe < X; oe++) ue = R(ue, ue);
    return isSparseMatrix(Z) ? Z.createSparseMatrix(ue) : ue;
  } });
  function L(Z) {
    for (var V = Z.size()[0], G = 0, W = 0; W < V; W++) {
      for (var J = 0, X = 0; X < V; X++) J += O(Z.get([W, X]));
      G = Math.max(J, G);
    }
    return G;
  }
  function q(Z, V) {
    for (var G = 30, W = 0; W < G; W++) for (var J = 0; J <= W; J++) {
      var X = W - J;
      if (U(Z, J, X) < V) return { q: J, j: X };
    }
    throw Error("Could not find acceptable parameters to compute the matrix exponential (try increasing maxSearchSize in expm.js)");
  }
  function U(Z, V, G) {
    for (var W = 1, J = 2; J <= V; J++) W *= J;
    for (var X = W, Y = V + 1; Y <= 2 * V; Y++) X *= Y;
    var ee = X * (2 * V + 1);
    return 8 * (Z / 2 ** G) ** (2 * V) * W * W / (X * ee);
  }
}), name$72 = "sqrtm", dependencies$72 = ["typed", "abs", "add", "multiply", "map", "sqrt", "subtract", "inv", "size", "max", "identity"], createSqrtm = factory(name$72, dependencies$72, (D) => {
  var { typed: E, abs: O, add: F, multiply: I, map: z, sqrt: R, subtract: L, inv: q, size: U, max: Z, identity: V } = D, G = 1e3, W = 1e-6;
  function J(X) {
    var Y, ee = 0, K = X, te = V(U(X));
    do {
      var ie = K;
      if (K = I(0.5, F(ie, q(te))), te = I(0.5, F(te, q(ie))), Y = Z(O(L(K, ie))), Y > W && ++ee > G) throw Error("computing square root of matrix: iterative method could not converge");
    } while (Y > W);
    return K;
  }
  return E(name$72, { "Array | Matrix": function(X) {
    var Y = isMatrix(X) ? X.size() : arraySize(X);
    switch (Y.length) {
      case 1:
        if (Y[0] === 1) return z(X, R);
        throw RangeError("Matrix must be square (size: " + format(Y) + ")");
      case 2:
        if (Y[0] === Y[1]) return J(X);
        throw RangeError("Matrix must be square (size: " + format(Y) + ")");
      default:
        throw RangeError("Matrix must be at most two dimensional (size: " + format(Y) + ")");
    }
  } });
}), name$71 = "sylvester", dependencies$71 = ["typed", "schur", "matrixFromColumns", "matrix", "multiply", "range", "concat", "transpose", "index", "subset", "add", "subtract", "identity", "lusolve", "abs"], createSylvester = factory(name$71, dependencies$71, (D) => {
  var { typed: E, schur: O, matrixFromColumns: F, matrix: I, multiply: z, range: R, concat: L, transpose: q, index: U, subset: Z, add: V, subtract: G, identity: W, lusolve: J, abs: X, config: Y } = D;
  return E(name$71, { "Matrix, Matrix, Matrix": ee, "Array, Matrix, Matrix": function(K, te, ie) {
    return ee(I(K), te, ie);
  }, "Array, Array, Matrix": function(K, te, ie) {
    return ee(I(K), I(te), ie);
  }, "Array, Matrix, Array": function(K, te, ie) {
    return ee(I(K), te, I(ie));
  }, "Matrix, Array, Matrix": function(K, te, ie) {
    return ee(K, I(te), ie);
  }, "Matrix, Array, Array": function(K, te, ie) {
    return ee(K, I(te), I(ie));
  }, "Matrix, Matrix, Array": function(K, te, ie) {
    return ee(K, te, I(ie));
  }, "Array, Array, Array": function(K, te, ie) {
    return ee(I(K), I(te), I(ie)).toArray();
  } });
  function ee(K, te, ie) {
    for (var ne = te.size()[0], ae = K.size()[0], ue = O(K), oe = ue.T, se = ue.U, le = O(z(-1, te)), ce = le.T, fe = le.U, pe = z(z(q(se), ie), fe), ve = R(0, ae), _e = [], de = (be, Ae) => L(be, Ae, 1), ge = (be, Ae) => L(be, Ae, 0), ye = 0; ye < ne; ye++) if (ye < ne - 1 && X(Z(ce, U(ye + 1, ye))) > 1e-5) {
      for (var De = ge(Z(pe, U(ve, [ye])), Z(pe, U(ve, [ye + 1]))), Ce = 0; Ce < ye; Ce++) De = V(De, ge(z(_e[Ce], Z(ce, U(Ce, ye))), z(_e[Ce], Z(ce, U(Ce, ye + 1)))));
      var Ie = z(W(ae), z(-1, Z(ce, U(ye, ye)))), Ne = z(W(ae), z(-1, Z(ce, U(ye + 1, ye)))), he = z(W(ae), z(-1, Z(ce, U(ye, ye + 1)))), ke = z(W(ae), z(-1, Z(ce, U(ye + 1, ye + 1)))), xe = J(ge(de(V(oe, Ie), Ne), de(he, V(oe, ke))), De);
      _e[ye] = xe.subset(U(R(0, ae), [0])), _e[ye + 1] = xe.subset(U(R(ae, 2 * ae), [0])), ye++;
    } else {
      for (var Te = Z(pe, U(ve, [ye])), Fe = 0; Fe < ye; Fe++) Te = V(Te, z(_e[Fe], Z(ce, U(Fe, ye))));
      _e[ye] = J(G(oe, z(Z(ce, U(ye, ye)), W(ae))), Te);
    }
    return z(se, z(I(F(..._e)), q(fe)));
  }
}), name$70 = "schur", dependencies$70 = ["typed", "matrix", "identity", "multiply", "qr", "norm", "subtract"], createSchur = factory(name$70, dependencies$70, (D) => {
  var { typed: E, matrix: O, identity: F, multiply: I, qr: z, norm: R, subtract: L } = D;
  return E(name$70, { Array: function(U) {
    var Z = q(O(U));
    return { U: Z.U.valueOf(), T: Z.T.valueOf() };
  }, Matrix: function(U) {
    return q(U);
  } });
  function q(U) {
    var Z = U.size()[0], V = U, G = F(Z), W = 0, J;
    do {
      J = V;
      var X = z(V), Y = X.Q, ee = X.R;
      if (V = I(ee, Y), G = I(G, Y), W++ > 100) break;
    } while (R(L(V, J)) > 1e-4);
    return { U: G, T: V };
  }
}), name$69 = "lyap", dependencies$69 = ["typed", "matrix", "sylvester", "multiply", "transpose"], createLyap = factory(name$69, dependencies$69, (D) => {
  var { typed: E, matrix: O, sylvester: F, multiply: I, transpose: z } = D;
  return E(name$69, { "Matrix, Matrix": function(R, L) {
    return F(R, z(R), I(-1, L));
  }, "Array, Matrix": function(R, L) {
    return F(O(R), z(O(R)), I(-1, L));
  }, "Matrix, Array": function(R, L) {
    return F(R, z(O(R)), O(I(-1, L)));
  }, "Array, Array": function(R, L) {
    return F(O(R), z(O(R)), O(I(-1, L))).toArray();
  } });
}), name$68 = "divide", dependencies$68 = ["typed", "matrix", "multiply", "equalScalar", "divideScalar", "inv"], createDivide = factory(name$68, dependencies$68, (D) => {
  var { typed: E, matrix: O, multiply: F, equalScalar: I, divideScalar: z, inv: R } = D, L = createMatAlgo11xS0s({ typed: E, equalScalar: I }), q = createMatAlgo14xDs({ typed: E });
  return E("divide", extend$1({ "Array | Matrix, Array | Matrix": function(U, Z) {
    return F(U, R(Z));
  }, "DenseMatrix, any": function(U, Z) {
    return q(U, Z, z, !1);
  }, "SparseMatrix, any": function(U, Z) {
    return L(U, Z, z, !1);
  }, "Array, any": function(U, Z) {
    return q(O(U), Z, z, !1).valueOf();
  }, "any, Array | Matrix": function(U, Z) {
    return F(U, R(Z));
  } }, z.signatures));
}), name$67 = "distance", dependencies$67 = ["typed", "addScalar", "subtractScalar", "divideScalar", "multiplyScalar", "deepEqual", "sqrt", "abs"], createDistance = factory(name$67, dependencies$67, (D) => {
  var { typed: E, addScalar: O, subtractScalar: F, multiplyScalar: I, divideScalar: z, deepEqual: R, sqrt: L, abs: q } = D;
  return E(name$67, { "Array, Array, Array": function(ie, ne, ae) {
    if (ie.length === 2 && ne.length === 2 && ae.length === 2) {
      if (!Z(ie)) throw TypeError("Array with 2 numbers or BigNumbers expected for first argument");
      if (!Z(ne)) throw TypeError("Array with 2 numbers or BigNumbers expected for second argument");
      if (!Z(ae)) throw TypeError("Array with 2 numbers or BigNumbers expected for third argument");
      if (R(ne, ae)) throw TypeError("LinePoint1 should not be same with LinePoint2");
      var ue = F(ae[1], ne[1]), oe = F(ne[0], ae[0]), se = F(I(ae[0], ne[1]), I(ne[0], ae[1]));
      return Y(ie[0], ie[1], ue, oe, se);
    } else throw TypeError("Invalid Arguments: Try again");
  }, "Object, Object, Object": function(ie, ne, ae) {
    if (Object.keys(ie).length === 2 && Object.keys(ne).length === 2 && Object.keys(ae).length === 2) {
      if (!Z(ie)) throw TypeError("Values of pointX and pointY should be numbers or BigNumbers");
      if (!Z(ne)) throw TypeError("Values of lineOnePtX and lineOnePtY should be numbers or BigNumbers");
      if (!Z(ae)) throw TypeError("Values of lineTwoPtX and lineTwoPtY should be numbers or BigNumbers");
      if (R(J(ne), J(ae))) throw TypeError("LinePoint1 should not be same with LinePoint2");
      if ("pointX" in ie && "pointY" in ie && "lineOnePtX" in ne && "lineOnePtY" in ne && "lineTwoPtX" in ae && "lineTwoPtY" in ae) {
        var ue = F(ae.lineTwoPtY, ne.lineOnePtY), oe = F(ne.lineOnePtX, ae.lineTwoPtX), se = F(I(ae.lineTwoPtX, ne.lineOnePtY), I(ne.lineOnePtX, ae.lineTwoPtY));
        return Y(ie.pointX, ie.pointY, ue, oe, se);
      } else throw TypeError("Key names do not match");
    } else throw TypeError("Invalid Arguments: Try again");
  }, "Array, Array": function(ie, ne) {
    if (ie.length === 2 && ne.length === 3) {
      if (!Z(ie)) throw TypeError("Array with 2 numbers or BigNumbers expected for first argument");
      if (!V(ne)) throw TypeError("Array with 3 numbers or BigNumbers expected for second argument");
      return Y(ie[0], ie[1], ne[0], ne[1], ne[2]);
    } else if (ie.length === 3 && ne.length === 6) {
      if (!V(ie)) throw TypeError("Array with 3 numbers or BigNumbers expected for first argument");
      if (!W(ne)) throw TypeError("Array with 6 numbers or BigNumbers expected for second argument");
      return ee(ie[0], ie[1], ie[2], ne[0], ne[1], ne[2], ne[3], ne[4], ne[5]);
    } else if (ie.length === ne.length && ie.length > 0) {
      if (!G(ie) || !G(ne)) throw TypeError("All values of an array should be numbers or BigNumbers");
      return K(ie, ne);
    } else throw TypeError("Invalid Arguments: Try again");
  }, "Object, Object": function(ie, ne) {
    if (Object.keys(ie).length === 2 && Object.keys(ne).length === 3) {
      if (!Z(ie)) throw TypeError("Values of pointX and pointY should be numbers or BigNumbers");
      if (!V(ne)) throw TypeError("Values of xCoeffLine, yCoeffLine and constant should be numbers or BigNumbers");
      if ("pointX" in ie && "pointY" in ie && "xCoeffLine" in ne && "yCoeffLine" in ne && "constant" in ne) return Y(ie.pointX, ie.pointY, ne.xCoeffLine, ne.yCoeffLine, ne.constant);
      throw TypeError("Key names do not match");
    } else if (Object.keys(ie).length === 3 && Object.keys(ne).length === 6) {
      if (!V(ie)) throw TypeError("Values of pointX, pointY and pointZ should be numbers or BigNumbers");
      if (!W(ne)) throw TypeError("Values of x0, y0, z0, a, b and c should be numbers or BigNumbers");
      if ("pointX" in ie && "pointY" in ie && "x0" in ne && "y0" in ne && "z0" in ne && "a" in ne && "b" in ne && "c" in ne) return ee(ie.pointX, ie.pointY, ie.pointZ, ne.x0, ne.y0, ne.z0, ne.a, ne.b, ne.c);
      throw TypeError("Key names do not match");
    } else if (Object.keys(ie).length === 2 && Object.keys(ne).length === 2) {
      if (!Z(ie)) throw TypeError("Values of pointOneX and pointOneY should be numbers or BigNumbers");
      if (!Z(ne)) throw TypeError("Values of pointTwoX and pointTwoY should be numbers or BigNumbers");
      if ("pointOneX" in ie && "pointOneY" in ie && "pointTwoX" in ne && "pointTwoY" in ne) return K([ie.pointOneX, ie.pointOneY], [ne.pointTwoX, ne.pointTwoY]);
      throw TypeError("Key names do not match");
    } else if (Object.keys(ie).length === 3 && Object.keys(ne).length === 3) {
      if (!V(ie)) throw TypeError("Values of pointOneX, pointOneY and pointOneZ should be numbers or BigNumbers");
      if (!V(ne)) throw TypeError("Values of pointTwoX, pointTwoY and pointTwoZ should be numbers or BigNumbers");
      if ("pointOneX" in ie && "pointOneY" in ie && "pointOneZ" in ie && "pointTwoX" in ne && "pointTwoY" in ne && "pointTwoZ" in ne) return K([ie.pointOneX, ie.pointOneY, ie.pointOneZ], [ne.pointTwoX, ne.pointTwoY, ne.pointTwoZ]);
      throw TypeError("Key names do not match");
    } else throw TypeError("Invalid Arguments: Try again");
  }, Array: function(ie) {
    if (!X(ie)) throw TypeError("Incorrect array format entered for pairwise distance calculation");
    return te(ie);
  } });
  function U(ie) {
    return typeof ie == "number" || isBigNumber(ie);
  }
  function Z(ie) {
    return ie.constructor !== Array && (ie = J(ie)), U(ie[0]) && U(ie[1]);
  }
  function V(ie) {
    return ie.constructor !== Array && (ie = J(ie)), U(ie[0]) && U(ie[1]) && U(ie[2]);
  }
  function G(ie) {
    return Array.isArray(ie) || (ie = J(ie)), ie.every(U);
  }
  function W(ie) {
    return ie.constructor !== Array && (ie = J(ie)), U(ie[0]) && U(ie[1]) && U(ie[2]) && U(ie[3]) && U(ie[4]) && U(ie[5]);
  }
  function J(ie) {
    for (var ne = Object.keys(ie), ae = [], ue = 0; ue < ne.length; ue++) ae.push(ie[ne[ue]]);
    return ae;
  }
  function X(ie) {
    if (ie[0].length === 2 && U(ie[0][0]) && U(ie[0][1])) {
      if (ie.some((ne) => ne.length !== 2 || !U(ne[0]) || !U(ne[1]))) return !1;
    } else if (ie[0].length === 3 && U(ie[0][0]) && U(ie[0][1]) && U(ie[0][2])) {
      if (ie.some((ne) => ne.length !== 3 || !U(ne[0]) || !U(ne[1]) || !U(ne[2]))) return !1;
    } else return !1;
    return !0;
  }
  function Y(ie, ne, ae, ue, oe) {
    return z(q(O(O(I(ae, ie), I(ue, ne)), oe)), L(O(I(ae, ae), I(ue, ue))));
  }
  function ee(ie, ne, ae, ue, oe, se, le, ce, fe) {
    var pe = [F(I(F(oe, ne), fe), I(F(se, ae), ce)), F(I(F(se, ae), le), I(F(ue, ie), fe)), F(I(F(ue, ie), ce), I(F(oe, ne), le))];
    pe = L(O(O(I(pe[0], pe[0]), I(pe[1], pe[1])), I(pe[2], pe[2])));
    var ve = L(O(O(I(le, le), I(ce, ce)), I(fe, fe)));
    return z(pe, ve);
  }
  function K(ie, ne) {
    for (var ae = ie.length, ue = 0, oe = 0, se = 0; se < ae; se++) oe = F(ie[se], ne[se]), ue = O(I(oe, oe), ue);
    return L(ue);
  }
  function te(ie) {
    for (var ne = [], ae = [], ue = [], oe = 0; oe < ie.length - 1; oe++) for (var se = oe + 1; se < ie.length; se++) ie[0].length === 2 ? (ae = [ie[oe][0], ie[oe][1]], ue = [ie[se][0], ie[se][1]]) : ie[0].length === 3 && (ae = [ie[oe][0], ie[oe][1], ie[oe][2]], ue = [ie[se][0], ie[se][1], ie[se][2]]), ne.push(K(ae, ue));
    return ne;
  }
}), name$66 = "intersect", dependencies$66 = ["typed", "config", "abs", "add", "addScalar", "matrix", "multiply", "multiplyScalar", "divideScalar", "subtract", "smaller", "equalScalar", "flatten", "isZero", "isNumeric"], createIntersect = factory(name$66, dependencies$66, (D) => {
  var { typed: E, config: O, abs: F, add: I, addScalar: z, matrix: R, multiply: L, multiplyScalar: q, divideScalar: U, subtract: Z, smaller: V, equalScalar: G, flatten: W, isZero: J, isNumeric: X } = D;
  return E("intersect", { "Array, Array, Array": Y, "Array, Array, Array, Array": ee, "Matrix, Matrix, Matrix": function(le, ce, fe) {
    var pe = Y(le.valueOf(), ce.valueOf(), fe.valueOf());
    return pe === null ? null : R(pe);
  }, "Matrix, Matrix, Matrix, Matrix": function(le, ce, fe, pe) {
    var ve = ee(le.valueOf(), ce.valueOf(), fe.valueOf(), pe.valueOf());
    return ve === null ? null : R(ve);
  } });
  function Y(le, ce, fe) {
    if (le = K(le), ce = K(ce), fe = K(fe), !ie(le)) throw TypeError("Array with 3 numbers or BigNumbers expected for first argument");
    if (!ie(ce)) throw TypeError("Array with 3 numbers or BigNumbers expected for second argument");
    if (!ne(fe)) throw TypeError("Array with 4 numbers expected as third argument");
    return se(le[0], le[1], le[2], ce[0], ce[1], ce[2], fe[0], fe[1], fe[2], fe[3]);
  }
  function ee(le, ce, fe, pe) {
    if (le = K(le), ce = K(ce), fe = K(fe), pe = K(pe), le.length === 2) {
      if (!te(le)) throw TypeError("Array with 2 numbers or BigNumbers expected for first argument");
      if (!te(ce)) throw TypeError("Array with 2 numbers or BigNumbers expected for second argument");
      if (!te(fe)) throw TypeError("Array with 2 numbers or BigNumbers expected for third argument");
      if (!te(pe)) throw TypeError("Array with 2 numbers or BigNumbers expected for fourth argument");
      return ae(le, ce, fe, pe);
    } else if (le.length === 3) {
      if (!ie(le)) throw TypeError("Array with 3 numbers or BigNumbers expected for first argument");
      if (!ie(ce)) throw TypeError("Array with 3 numbers or BigNumbers expected for second argument");
      if (!ie(fe)) throw TypeError("Array with 3 numbers or BigNumbers expected for third argument");
      if (!ie(pe)) throw TypeError("Array with 3 numbers or BigNumbers expected for fourth argument");
      return oe(le[0], le[1], le[2], ce[0], ce[1], ce[2], fe[0], fe[1], fe[2], pe[0], pe[1], pe[2]);
    } else throw TypeError("Arrays with two or thee dimensional points expected");
  }
  function K(le) {
    return le.length === 1 ? le[0] : le.length > 1 && Array.isArray(le[0]) && le.every((ce) => Array.isArray(ce) && ce.length === 1) ? W(le) : le;
  }
  function te(le) {
    return le.length === 2 && X(le[0]) && X(le[1]);
  }
  function ie(le) {
    return le.length === 3 && X(le[0]) && X(le[1]) && X(le[2]);
  }
  function ne(le) {
    return le.length === 4 && X(le[0]) && X(le[1]) && X(le[2]) && X(le[3]);
  }
  function ae(le, ce, fe, pe) {
    var ve = le, _e = fe, de = Z(ve, ce), ge = Z(_e, pe), ye = Z(q(de[0], ge[1]), q(ge[0], de[1]));
    if (J(ye) || V(F(ye), O.relTol)) return null;
    var De = q(ge[0], ve[1]), Ce = q(ge[1], ve[0]), Ie = q(ge[0], _e[1]), Ne = q(ge[1], _e[0]);
    return I(L(de, U(z(Z(Z(De, Ce), Ie), Ne), ye)), ve);
  }
  function ue(le, ce, fe, pe, ve, _e, de, ge, ye, De, Ce, Ie) {
    var Ne = q(Z(le, ce), Z(fe, pe)), he = q(Z(ve, _e), Z(de, ge)), ke = q(Z(ye, De), Z(Ce, Ie));
    return z(z(Ne, he), ke);
  }
  function oe(le, ce, fe, pe, ve, _e, de, ge, ye, De, Ce, Ie) {
    var Ne = ue(le, de, De, de, ce, ge, Ce, ge, fe, ye, Ie, ye), he = ue(De, de, pe, le, Ce, ge, ve, ce, Ie, ye, _e, fe), ke = ue(le, de, pe, le, ce, ge, ve, ce, fe, ye, _e, fe), xe = ue(De, de, De, de, Ce, ge, Ce, ge, Ie, ye, Ie, ye), Te = ue(pe, le, pe, le, ve, ce, ve, ce, _e, fe, _e, fe), Fe = Z(q(Ne, he), q(ke, xe)), be = Z(q(Te, xe), q(he, he));
    if (J(be)) return null;
    var Ae = U(Fe, be), Me = U(z(Ne, q(Ae, he)), xe), $e = z(le, q(Ae, Z(pe, le))), Re = z(ce, q(Ae, Z(ve, ce))), je = z(fe, q(Ae, Z(_e, fe))), Pe = z(de, q(Me, Z(De, de))), Ke = z(ge, q(Me, Z(Ce, ge))), Qe = z(ye, q(Me, Z(Ie, ye)));
    return G($e, Pe) && G(Re, Ke) && G(je, Qe) ? [$e, Re, je] : null;
  }
  function se(le, ce, fe, pe, ve, _e, de, ge, ye, De) {
    var Ce = q(le, de), Ie = q(pe, de), Ne = q(ce, ge), he = q(ve, ge), ke = q(fe, ye), xe = q(_e, ye), Te = U(Z(Z(Z(De, Ce), Ne), ke), Z(Z(Z(z(z(Ie, he), xe), Ce), Ne), ke));
    return [z(le, q(Te, Z(pe, le))), z(ce, q(Te, Z(ve, ce))), z(fe, q(Te, Z(_e, fe)))];
  }
}), name$65 = "sum", dependencies$65 = ["typed", "config", "add", "numeric"], createSum = factory(name$65, dependencies$65, (D) => {
  var { typed: E, config: O, add: F, numeric: I } = D;
  return E(name$65, { "Array | Matrix": z, "Array | Matrix, number | BigNumber": R, "...": function(L) {
    if (containsCollections(L)) throw TypeError("Scalar values expected in function sum");
    return z(L);
  } });
  function z(L) {
    var q;
    return deepForEach(L, function(U) {
      try {
        q = q === void 0 ? U : F(q, U);
      } catch (Z) {
        throw improveErrorMessage(Z, "sum", U);
      }
    }), q === void 0 && (q = I(0, O.number)), typeof q == "string" && (q = I(q, safeNumberType(q, O))), q;
  }
  function R(L, q) {
    try {
      return reduce$1(L, q, F);
    } catch (U) {
      throw improveErrorMessage(U, "sum");
    }
  }
}), name$64 = "cumsum", dependencies$64 = ["typed", "add", "unaryPlus"], createCumSum = factory(name$64, dependencies$64, (D) => {
  var { typed: E, add: O, unaryPlus: F } = D;
  return E(name$64, { Array: I, Matrix: function(q) {
    return q.create(I(q.valueOf(), q.datatype()));
  }, "Array, number | BigNumber": R, "Matrix, number | BigNumber": function(q, U) {
    return q.create(R(q.valueOf(), U), q.datatype());
  }, "...": function(q) {
    if (containsCollections(q)) throw TypeError("All values expected to be scalar in function cumsum");
    return I(q);
  } });
  function I(q) {
    try {
      return z(q);
    } catch (U) {
      throw improveErrorMessage(U, name$64);
    }
  }
  function z(q) {
    if (q.length === 0) return [];
    for (var U = [F(q[0])], Z = 1; Z < q.length; ++Z) U.push(O(U[Z - 1], q[Z]));
    return U;
  }
  function R(q, U) {
    var Z = arraySize(q);
    if (U < 0 || U >= Z.length) throw new IndexError(U, Z.length);
    try {
      return L(q, U);
    } catch (V) {
      throw improveErrorMessage(V, name$64);
    }
  }
  function L(q, U) {
    var Z, V, G;
    if (U <= 0) {
      var W = q[0][0];
      if (Array.isArray(W)) {
        for (G = _switch$1(q), V = [], Z = 0; Z < G.length; Z++) V[Z] = L(G[Z], U - 1);
        return V;
      } else return z(q);
    } else {
      for (V = [], Z = 0; Z < q.length; Z++) V[Z] = L(q[Z], U - 1);
      return V;
    }
  }
}), name$63 = "mean", dependencies$63 = ["typed", "add", "divide"], createMean = factory(name$63, dependencies$63, (D) => {
  var { typed: E, add: O, divide: F } = D;
  return E(name$63, { "Array | Matrix": z, "Array | Matrix, number | BigNumber": I, "...": function(R) {
    if (containsCollections(R)) throw TypeError("Scalar values expected in function mean");
    return z(R);
  } });
  function I(R, L) {
    try {
      return F(reduce$1(R, L, O), (Array.isArray(R) ? arraySize(R) : R.size())[L]);
    } catch (q) {
      throw improveErrorMessage(q, "mean");
    }
  }
  function z(R) {
    var L, q = 0;
    if (deepForEach(R, function(U) {
      try {
        L = L === void 0 ? U : O(L, U), q++;
      } catch (Z) {
        throw improveErrorMessage(Z, "mean", U);
      }
    }), q === 0) throw Error("Cannot calculate the mean of an empty array");
    return F(L, q);
  }
}), name$62 = "median", dependencies$62 = ["typed", "add", "divide", "compare", "partitionSelect"], createMedian = factory(name$62, dependencies$62, (D) => {
  var { typed: E, add: O, divide: F, compare: I, partitionSelect: z } = D;
  function R(U) {
    try {
      U = flatten$4(U.valueOf());
      var Z = U.length;
      if (Z === 0) throw Error("Cannot calculate median of an empty array");
      if (Z % 2 == 0) {
        for (var V = Z / 2 - 1, G = z(U, V + 1), W = U[V], J = 0; J < V; ++J) I(U[J], W) > 0 && (W = U[J]);
        return q(W, G);
      } else return L(z(U, (Z - 1) / 2));
    } catch (X) {
      throw improveErrorMessage(X, "median");
    }
  }
  var L = E({ "number | BigNumber | Complex | Unit": function(U) {
    return U;
  } }), q = E({ "number | BigNumber | Complex | Unit, number | BigNumber | Complex | Unit": function(U, Z) {
    return F(O(U, Z), 2);
  } });
  return E(name$62, { "Array | Matrix": R, "Array | Matrix, number | BigNumber": function(U, Z) {
    throw Error("median(A, dim) is not yet supported");
  }, "...": function(U) {
    if (containsCollections(U)) throw TypeError("Scalar values expected in function median");
    return R(U);
  } });
}), name$61 = "mad", dependencies$61 = ["typed", "abs", "map", "median", "subtract"], createMad = factory(name$61, dependencies$61, (D) => {
  var { typed: E, abs: O, map: F, median: I, subtract: z } = D;
  return E(name$61, { "Array | Matrix": R, "...": function(L) {
    return R(L);
  } });
  function R(L) {
    if (L = flatten$4(L.valueOf()), L.length === 0) throw Error("Cannot calculate median absolute deviation (mad) of an empty array");
    try {
      var q = I(L);
      return I(F(L, function(U) {
        return O(z(U, q));
      }));
    } catch (U) {
      throw U instanceof TypeError && U.message.includes("median") ? TypeError(U.message.replace("median", "mad")) : improveErrorMessage(U, "mad");
    }
  }
}), DEFAULT_NORMALIZATION = "unbiased", name$60 = "variance", dependencies$60 = ["typed", "add", "subtract", "multiply", "divide", "mapSlices", "isNaN"], createVariance = factory(name$60, dependencies$60, (D) => {
  var { typed: E, add: O, subtract: F, multiply: I, divide: z, mapSlices: R, isNaN: L } = D;
  return E(name$60, { "Array | Matrix": function(Z) {
    return q(Z, DEFAULT_NORMALIZATION);
  }, "Array | Matrix, string": q, "Array | Matrix, number | BigNumber": function(Z, V) {
    return U(Z, V, DEFAULT_NORMALIZATION);
  }, "Array | Matrix, number | BigNumber, string": U, "...": function(Z) {
    return q(Z, DEFAULT_NORMALIZATION);
  } });
  function q(Z, V) {
    var G, W = 0;
    if (Z.length === 0) throw SyntaxError("Function variance requires one or more parameters (0 provided)");
    if (deepForEach(Z, function(Y) {
      try {
        G = G === void 0 ? Y : O(G, Y), W++;
      } catch (ee) {
        throw improveErrorMessage(ee, "variance", Y);
      }
    }), W === 0) throw Error("Cannot calculate variance of an empty array");
    var J = z(G, W);
    if (G = void 0, deepForEach(Z, function(Y) {
      var ee = F(Y, J);
      G = G === void 0 ? I(ee, ee) : O(G, I(ee, ee));
    }), L(G)) return G;
    switch (V) {
      case "uncorrected":
        return z(G, W);
      case "biased":
        return z(G, W + 1);
      case "unbiased":
        var X = isBigNumber(G) ? G.mul(0) : 0;
        return W === 1 ? X : z(G, W - 1);
      default:
        throw Error('Unknown normalization "' + V + '". Choose "unbiased" (default), "uncorrected", or "biased".');
    }
  }
  function U(Z, V, G) {
    try {
      if (Z.length === 0) throw SyntaxError("Function variance requires one or more parameters (0 provided)");
      return R(Z, V, (W) => q(W, G));
    } catch (W) {
      throw improveErrorMessage(W, "variance");
    }
  }
}), name$59 = "quantileSeq", dependencies$59 = ["typed", "?bignumber", "add", "subtract", "divide", "multiply", "partitionSelect", "compare", "isInteger", "smaller", "smallerEq", "larger", "mapSlices"], createQuantileSeq = factory(name$59, dependencies$59, (D) => {
  var { typed: E, bignumber: O, add: F, subtract: I, divide: z, multiply: R, partitionSelect: L, compare: q, isInteger: U, smaller: Z, smallerEq: V, larger: G, mapSlices: W } = D;
  return E(name$59, { "Array | Matrix, number | BigNumber": (K, te) => X(K, te, !1), "Array | Matrix, number | BigNumber, number": (K, te, ie) => J(K, te, !1, ie, X), "Array | Matrix, number | BigNumber, boolean": X, "Array | Matrix, number | BigNumber, boolean, number": (K, te, ie, ne) => J(K, te, ie, ne, X), "Array | Matrix, Array | Matrix": (K, te) => Y(K, te, !1), "Array | Matrix, Array | Matrix, number": (K, te, ie) => J(K, te, !1, ie, Y), "Array | Matrix, Array | Matrix, boolean": Y, "Array | Matrix, Array | Matrix, boolean, number": (K, te, ie, ne) => J(K, te, ie, ne, Y) });
  function J(K, te, ie, ne, ae) {
    return W(K, ne, (ue) => ae(ue, te, ie));
  }
  function X(K, te, ie) {
    var ne, ae = K.valueOf();
    if (Z(te, 0)) throw Error("N/prob must be non-negative");
    if (V(te, 1)) return isNumber(te) ? ee(ae, te, ie) : O(ee(ae, te, ie));
    if (G(te, 1)) {
      if (!U(te)) throw Error("N must be a positive integer");
      if (G(te, 4294967295)) throw Error("N must be less than or equal to 2^32-1, as that is the maximum length of an Array");
      var ue = F(te, 1);
      ne = [];
      for (var oe = 0; Z(oe, te); oe++) {
        var se = z(oe + 1, ue);
        ne.push(ee(ae, se, ie));
      }
      return isNumber(te) ? ne : O(ne);
    }
  }
  function Y(K, te, ie) {
    for (var ne = K.valueOf(), ae = te.valueOf(), ue = [], oe = 0; oe < ae.length; ++oe) ue.push(ee(ne, ae[oe], ie));
    return ue;
  }
  function ee(K, te, ie) {
    var ne = flatten$4(K), ae = ne.length;
    if (ae === 0) throw Error("Cannot calculate quantile of an empty sequence");
    var ue = isNumber(te) ? te * (ae - 1) : te.times(ae - 1), oe = isNumber(te) ? Math.floor(ue) : ue.floor().toNumber(), se = isNumber(te) ? ue % 1 : ue.minus(oe);
    if (U(ue)) return ie ? ne[ue] : L(ne, isNumber(te) ? ue : ue.valueOf());
    var le, ce;
    if (ie) le = ne[oe], ce = ne[oe + 1];
    else {
      ce = L(ne, oe + 1), le = ne[oe];
      for (var fe = 0; fe < oe; ++fe) q(ne[fe], le) > 0 && (le = ne[fe]);
    }
    return F(R(le, I(1, se)), R(ce, se));
  }
}), name$58 = "std", dependencies$58 = ["typed", "map", "sqrt", "variance"], createStd = factory(name$58, dependencies$58, (D) => {
  var { typed: E, map: O, sqrt: F, variance: I } = D;
  return E(name$58, { "Array | Matrix": z, "Array | Matrix, string": z, "Array | Matrix, number | BigNumber": z, "Array | Matrix, number | BigNumber, string": z, "...": function(R) {
    return z(R);
  } });
  function z(R, L) {
    if (R.length === 0) throw SyntaxError("Function std requires one or more parameters (0 provided)");
    try {
      var q = I.apply(null, arguments);
      return isCollection(q) ? O(q, F) : F(q);
    } catch (U) {
      throw U instanceof TypeError && U.message.includes(" variance") ? TypeError(U.message.replace(" variance", " std")) : U;
    }
  }
}), name$57 = "corr", dependencies$57 = ["typed", "matrix", "mean", "sqrt", "sum", "add", "subtract", "multiply", "pow", "divide"], createCorr = factory(name$57, dependencies$57, (D) => {
  var { typed: E, matrix: O, sqrt: F, sum: I, add: z, subtract: R, multiply: L, pow: q, divide: U } = D;
  return E(name$57, { "Array, Array": function(G, W) {
    return Z(G, W);
  }, "Matrix, Matrix": function(G, W) {
    var J = Z(G.toArray(), W.toArray());
    return Array.isArray(J) ? O(J) : J;
  } });
  function Z(G, W) {
    var J = [];
    if (Array.isArray(G[0]) && Array.isArray(W[0])) {
      if (G.length !== W.length) throw SyntaxError("Dimension mismatch. Array A and B must have the same length.");
      for (var X = 0; X < G.length; X++) {
        if (G[X].length !== W[X].length) throw SyntaxError("Dimension mismatch. Array A and B must have the same number of elements.");
        J.push(V(G[X], W[X]));
      }
      return J;
    } else {
      if (G.length !== W.length) throw SyntaxError("Dimension mismatch. Array A and B must have the same number of elements.");
      return V(G, W);
    }
  }
  function V(G, W) {
    var J = G.length, X = I(G), Y = I(W), ee = G.reduce((ie, ne, ae) => z(ie, L(ne, W[ae])), 0), K = I(G.map((ie) => q(ie, 2))), te = I(W.map((ie) => q(ie, 2)));
    return U(R(L(J, ee), L(X, Y)), F(L(R(L(J, K), q(X, 2)), R(L(J, te), q(Y, 2)))));
  }
}), name$56 = "bernoulli", dependencies$56 = ["typed", "config", "isInteger", "number", "?BigNumber", "?Fraction"], createBernoulli = factory(name$56, dependencies$56, (D) => {
  var { typed: E, config: O, number: F, BigNumber: I, Fraction: z } = D, R = [void 0], L = [void 0], q = [void 0], U = 50;
  return E(name$56, { number: (Z) => _bernoulli(Z, (V) => V, R, (V, G) => V + G, (V, G) => V * G, (V, G) => V / G), "bigint | Fraction": (Z) => _bernoulli(F(Z), (V) => new z(V), L, (V, G) => V.add(G), (V, G) => V.mul(G), (V, G) => V.div(G)), BigNumber: (Z) => (O.precision !== U && (q = [void 0], U = O.precision), _bernoulli(F(Z), (V) => new I(V), q, (V, G) => V.add(G), (V, G) => V.mul(G), (V, G) => V.div(G))) });
});
function _bernoulli(D, E, O, F, I, z) {
  if (D < 0 || !isInteger(D)) throw RangeError("Bernoulli index must be nonnegative integer");
  if (D === 0) return E(1);
  if (D === 1) return z(E(-1), E(2));
  if (D % 2 == 1) return E(0);
  var R = E(1);
  O.length === 1 && O.push([z(R, E(-3)), z(R, E(-2)), z(R, E(6))]);
  for (var L = D / 2, q = E(0), U = E(2); O.length <= L; ) {
    for (var Z = O.length, V = Math.floor((Z + 1) / 2), G = q, W = 1; W < V; ++W) G = F(G, I(O[W][0], O[Z - W][0]));
    G = I(G, U), Z % 2 == 0 && (G = F(G, I(O[V][0], O[V][0]))), G = z(G, E(-(2 * Z + 1)));
    var J = z(I(O[Z - 1][1], E(-Z * (2 * Z - 1))), U);
    O.push([G, J, I(J, G)]);
  }
  return O[L][2];
}
var name$55 = "combinations", dependencies$55 = ["typed"], createCombinations = factory(name$55, dependencies$55, (D) => {
  var { typed: E } = D;
  return E(name$55, { "number, number": combinationsNumber, "BigNumber, BigNumber": function(O, F) {
    var I = O.constructor, z, R, L = O.minus(F), q = new I(1);
    if (!isPositiveInteger$2(O) || !isPositiveInteger$2(F)) throw TypeError("Positive integer value expected in function combinations");
    if (F.gt(O)) throw TypeError("k must be less than n in function combinations");
    if (z = q, F.lt(L)) for (R = q; R.lte(L); R = R.plus(q)) z = z.times(F.plus(R)).dividedBy(R);
    else for (R = q; R.lte(F); R = R.plus(q)) z = z.times(L.plus(R)).dividedBy(R);
    return z;
  } });
});
function isPositiveInteger$2(D) {
  return D.isInteger() && D.gte(0);
}
var name$54 = "combinationsWithRep", dependencies$54 = ["typed"], createCombinationsWithRep = factory(name$54, dependencies$54, (D) => {
  var { typed: E } = D;
  return E(name$54, { "number, number": function(O, F) {
    if (!isInteger(O) || O < 0 || !isInteger(F) || F < 0) throw TypeError("Positive integer value expected in function combinationsWithRep");
    if (O < 1) throw TypeError("k must be less than or equal to n + k - 1");
    return F < O - 1 ? product(O, O + F - 1) / product(1, F) : product(F + 1, O + F - 1) / product(1, O - 1);
  }, "BigNumber, BigNumber": function(O, F) {
    var I = O.constructor, z, R, L = new I(1), q = O.minus(L);
    if (!isPositiveInteger$1(O) || !isPositiveInteger$1(F)) throw TypeError("Positive integer value expected in function combinationsWithRep");
    if (O.lt(L)) throw TypeError("k must be less than or equal to n + k - 1 in function combinationsWithRep");
    if (z = L, F.lt(q)) for (R = L; R.lte(q); R = R.plus(L)) z = z.times(F.plus(R)).dividedBy(R);
    else for (R = L; R.lte(F); R = R.plus(L)) z = z.times(q.plus(R)).dividedBy(R);
    return z;
  } });
});
function isPositiveInteger$1(D) {
  return D.isInteger() && D.gte(0);
}
var name$53 = "gamma", dependencies$53 = ["typed", "config", "multiplyScalar", "pow", "BigNumber", "Complex"], createGamma = factory(name$53, dependencies$53, (D) => {
  var { typed: E, config: O, multiplyScalar: F, pow: I, BigNumber: z, Complex: R } = D;
  function L(U) {
    if (U.im === 0) return gammaNumber(U.re);
    if (U.re < 0.5) {
      var Z = new R(1 - U.re, -U.im), V = new R(Math.PI * U.re, Math.PI * U.im);
      return new R(Math.PI).div(V.sin()).div(L(Z));
    }
    U = new R(U.re - 1, U.im);
    for (var G = new R(gammaP[0], 0), W = 1; W < gammaP.length; ++W) {
      var J = new R(gammaP[W], 0);
      G = G.add(J.div(U.add(W)));
    }
    var X = new R(U.re + gammaG + 0.5, U.im), Y = Math.sqrt(2 * Math.PI), ee = X.pow(U.add(0.5)), K = X.neg().exp();
    return G.mul(Y).mul(ee).mul(K);
  }
  return E(name$53, { number: gammaNumber, Complex: L, BigNumber: function(U) {
    if (U.isInteger()) return U.isNegative() || U.isZero() ? new z(1 / 0) : q(U.minus(1));
    if (!U.isFinite()) return new z(U.isNegative() ? NaN : 1 / 0);
    throw Error("Integer BigNumber expected");
  } });
  function q(U) {
    if (U < 8) return new z([1, 1, 2, 6, 24, 120, 720, 5040][U]);
    var Z = O.precision + (Math.log(U.toNumber()) | 0), V = z.clone({ precision: Z });
    if (U % 2 == 1) return U.times(q(new z(U - 1)));
    for (var G = U, W = new V(U), J = U.toNumber(); G > 2; ) G -= 2, J += G, W = W.times(J);
    return new z(W.toPrecision(z.precision));
  }
}), name$52 = "lgamma", dependencies$52 = ["Complex", "typed"], createLgamma = factory(name$52, dependencies$52, (D) => {
  var { Complex: E, typed: O } = D, F = 7, I = 7, z = [-0.029550653594771242, 0.00641025641025641, -0.0019175269175269176, 8417508417508417e-19, -5952380952380953e-19, 7936507936507937e-19, -0.002777777777777778, 0.08333333333333333];
  return O(name$52, { number: lgammaNumber, Complex: R, BigNumber: function() {
    throw Error("mathjs doesn't yet provide an implementation of the algorithm lgamma for BigNumber");
  } });
  function R(U) {
    var Z = 6.283185307179586, V = 1.1447298858494002, G = 0.1;
    if (U.isNaN()) return new E(NaN, NaN);
    if (U.im === 0) return new E(lgammaNumber(U.re), 0);
    if (U.re >= F || Math.abs(U.im) >= I) return L(U);
    if (U.re <= G) {
      var W = copysign(Z, U.im) * Math.floor(0.5 * U.re + 0.25), J = U.mul(Math.PI).sin().log(), X = R(new E(1 - U.re, -U.im));
      return new E(V, W).sub(J).sub(X);
    } else return U.im >= 0 ? q(U) : q(U.conjugate()).conjugate();
  }
  function L(U) {
    for (var Z = U.sub(0.5).mul(U.log()).sub(U).add(lnSqrt2PI), V = new E(1, 0).div(U), G = V.div(U), W = z[0], J = z[1], X = 2 * G.re, Y = G.re * G.re + G.im * G.im, ee = 2; ee < 8; ee++) {
      var K = J;
      J = -Y * W + z[ee], W = X * W + K;
    }
    var te = V.mul(G.mul(W).add(J));
    return Z.add(te);
  }
  function q(U) {
    var Z = 0, V = 0, G = U;
    for (U = U.add(1); U.re <= F; ) {
      G = G.mul(U);
      var W = +(G.im < 0);
      W !== 0 && V === 0 && Z++, V = W, U = U.add(1);
    }
    return L(U).sub(G.log()).sub(new E(0, Z * 2 * Math.PI * 1));
  }
}), name$51 = "factorial", dependencies$51 = ["typed", "gamma"], createFactorial = factory(name$51, dependencies$51, (D) => {
  var { typed: E, gamma: O } = D;
  return E(name$51, { number: function(F) {
    if (F < 0) throw Error("Value must be non-negative");
    return O(F + 1);
  }, BigNumber: function(F) {
    if (F.isNegative()) throw Error("Value must be non-negative");
    return O(F.plus(1));
  }, "Array | Matrix": E.referToSelf((F) => (I) => deepMap(I, F)) });
}), name$50 = "kldivergence", dependencies$50 = ["typed", "matrix", "divide", "sum", "multiply", "map", "dotDivide", "log", "isNumeric"], createKldivergence = factory(name$50, dependencies$50, (D) => {
  var { typed: E, matrix: O, divide: F, sum: I, multiply: z, map: R, dotDivide: L, log: q, isNumeric: U } = D;
  return E(name$50, { "Array, Array": function(V, G) {
    return Z(O(V), O(G));
  }, "Matrix, Array": function(V, G) {
    return Z(V, O(G));
  }, "Array, Matrix": function(V, G) {
    return Z(O(V), G);
  }, "Matrix, Matrix": function(V, G) {
    return Z(V, G);
  } });
  function Z(V, G) {
    var W = G.size().length, J = V.size().length;
    if (W > 1) throw Error("first object must be one dimensional");
    if (J > 1) throw Error("second object must be one dimensional");
    if (W !== J) throw Error("Length of two vectors must be equal");
    if (I(V) === 0) throw Error("Sum of elements in first object must be non zero");
    if (I(G) === 0) throw Error("Sum of elements in second object must be non zero");
    var X = F(V, I(V)), Y = I(z(X, R(L(X, F(G, I(G))), (ee) => q(ee))));
    return U(Y) ? Y : NaN;
  }
}), name$49 = "multinomial", dependencies$49 = ["typed", "add", "divide", "multiply", "factorial", "isInteger", "isPositive"], createMultinomial = factory(name$49, dependencies$49, (D) => {
  var { typed: E, add: O, divide: F, multiply: I, factorial: z, isInteger: R, isPositive: L } = D;
  return E(name$49, { "Array | Matrix": function(q) {
    var U = 0, Z = 1;
    return deepForEach(q, function(V) {
      if (!R(V) || !L(V)) throw TypeError("Positive integer value expected in function multinomial");
      U = O(U, V), Z = I(Z, z(V));
    }), F(z(U), Z);
  } });
}), name$48 = "permutations", dependencies$48 = ["typed", "factorial"], createPermutations = factory(name$48, dependencies$48, (D) => {
  var { typed: E, factorial: O } = D;
  return E(name$48, { "number | BigNumber": O, "number, number": function(F, I) {
    if (!isInteger(F) || F < 0 || !isInteger(I) || I < 0) throw TypeError("Positive integer value expected in function permutations");
    if (I > F) throw TypeError("second argument k must be less than or equal to first argument n");
    return product(F - I + 1, F);
  }, "BigNumber, BigNumber": function(F, I) {
    var z, R;
    if (!isPositiveInteger(F) || !isPositiveInteger(I)) throw TypeError("Positive integer value expected in function permutations");
    if (I.gt(F)) throw TypeError("second argument k must be less than or equal to first argument n");
    for (z = F.mul(0).add(1), R = F.minus(I).plus(1); R.lte(F); R = R.plus(1)) z = z.times(R);
    return z;
  } });
});
function isPositiveInteger(D) {
  return D.isInteger() && D.gte(0);
}
var require_alea = __commonJSMin(((D, E) => {
  (function(O, F, I) {
    function z(U) {
      var Z = this, V = q();
      Z.next = function() {
        var G = 2091639 * Z.s0 + Z.c * 23283064365386963e-26;
        return Z.s0 = Z.s1, Z.s1 = Z.s2, Z.s2 = G - (Z.c = G | 0);
      }, Z.c = 1, Z.s0 = V(" "), Z.s1 = V(" "), Z.s2 = V(" "), Z.s0 -= V(U), Z.s0 < 0 && (Z.s0 += 1), Z.s1 -= V(U), Z.s1 < 0 && (Z.s1 += 1), Z.s2 -= V(U), Z.s2 < 0 && (Z.s2 += 1), V = null;
    }
    function R(U, Z) {
      return Z.c = U.c, Z.s0 = U.s0, Z.s1 = U.s1, Z.s2 = U.s2, Z;
    }
    function L(U, Z) {
      var V = new z(U), G = Z && Z.state, W = V.next;
      return W.int32 = function() {
        return V.next() * 4294967296 | 0;
      }, W.double = function() {
        return W() + (W() * 2097152 | 0) * 11102230246251565e-32;
      }, W.quick = W, G && (typeof G == "object" && R(G, V), W.state = function() {
        return R(V, {});
      }), W;
    }
    function q() {
      var U = 4022871197;
      return function(Z) {
        Z = String(Z);
        for (var V = 0; V < Z.length; V++) {
          U += Z.charCodeAt(V);
          var G = 0.02519603282416938 * U;
          U = G >>> 0, G -= U, G *= U, U = G >>> 0, G -= U, U += G * 4294967296;
        }
        return (U >>> 0) * 23283064365386963e-26;
      };
    }
    F && F.exports ? F.exports = L : I && I.amd ? I(function() {
      return L;
    }) : this.alea = L;
  })(D, typeof E == "object" && E, typeof define == "function" && define);
})), require_xor128 = __commonJSMin(((D, E) => {
  (function(O, F, I) {
    function z(q) {
      var U = this, Z = "";
      U.x = 0, U.y = 0, U.z = 0, U.w = 0, U.next = function() {
        var G = U.x ^ U.x << 11;
        return U.x = U.y, U.y = U.z, U.z = U.w, U.w ^= U.w >>> 19 ^ G ^ G >>> 8;
      }, q === (q | 0) ? U.x = q : Z += q;
      for (var V = 0; V < Z.length + 64; V++) U.x ^= Z.charCodeAt(V) | 0, U.next();
    }
    function R(q, U) {
      return U.x = q.x, U.y = q.y, U.z = q.z, U.w = q.w, U;
    }
    function L(q, U) {
      var Z = new z(q), V = U && U.state, G = function() {
        return (Z.next() >>> 0) / 4294967296;
      };
      return G.double = function() {
        do
          var W = ((Z.next() >>> 11) + (Z.next() >>> 0) / 4294967296) / (1 << 21);
        while (W === 0);
        return W;
      }, G.int32 = Z.next, G.quick = G, V && (typeof V == "object" && R(V, Z), G.state = function() {
        return R(Z, {});
      }), G;
    }
    F && F.exports ? F.exports = L : I && I.amd ? I(function() {
      return L;
    }) : this.xor128 = L;
  })(D, typeof E == "object" && E, typeof define == "function" && define);
})), require_xorwow = __commonJSMin(((D, E) => {
  (function(O, F, I) {
    function z(q) {
      var U = this, Z = "";
      U.next = function() {
        var G = U.x ^ U.x >>> 2;
        return U.x = U.y, U.y = U.z, U.z = U.w, U.w = U.v, (U.d = U.d + 362437 | 0) + (U.v = U.v ^ U.v << 4 ^ (G ^ G << 1)) | 0;
      }, U.x = 0, U.y = 0, U.z = 0, U.w = 0, U.v = 0, q === (q | 0) ? U.x = q : Z += q;
      for (var V = 0; V < Z.length + 64; V++) U.x ^= Z.charCodeAt(V) | 0, V == Z.length && (U.d = U.x << 10 ^ U.x >>> 4), U.next();
    }
    function R(q, U) {
      return U.x = q.x, U.y = q.y, U.z = q.z, U.w = q.w, U.v = q.v, U.d = q.d, U;
    }
    function L(q, U) {
      var Z = new z(q), V = U && U.state, G = function() {
        return (Z.next() >>> 0) / 4294967296;
      };
      return G.double = function() {
        do
          var W = ((Z.next() >>> 11) + (Z.next() >>> 0) / 4294967296) / (1 << 21);
        while (W === 0);
        return W;
      }, G.int32 = Z.next, G.quick = G, V && (typeof V == "object" && R(V, Z), G.state = function() {
        return R(Z, {});
      }), G;
    }
    F && F.exports ? F.exports = L : I && I.amd ? I(function() {
      return L;
    }) : this.xorwow = L;
  })(D, typeof E == "object" && E, typeof define == "function" && define);
})), require_xorshift7 = __commonJSMin(((D, E) => {
  (function(O, F, I) {
    function z(q) {
      var U = this;
      U.next = function() {
        var V = U.x, G = U.i, W = V[G], J;
        return W ^= W >>> 7, J = W ^ W << 24, W = V[G + 1 & 7], J ^= W ^ W >>> 10, W = V[G + 3 & 7], J ^= W ^ W >>> 3, W = V[G + 4 & 7], J ^= W ^ W << 7, W = V[G + 7 & 7], W ^= W << 13, J ^= W ^ W << 9, V[G] = J, U.i = G + 1 & 7, J;
      };
      function Z(V, G) {
        var W, J = [];
        if (G === (G | 0)) J[0] = G;
        else for (G = "" + G, W = 0; W < G.length; ++W) J[W & 7] = J[W & 7] << 15 ^ G.charCodeAt(W) + J[W + 1 & 7] << 13;
        for (; J.length < 8; ) J.push(0);
        for (W = 0; W < 8 && J[W] === 0; ++W) ;
        for (W == 8 ? J[7] = -1 : J[W], V.x = J, V.i = 0, W = 256; W > 0; --W) V.next();
      }
      Z(U, q);
    }
    function R(q, U) {
      return U.x = q.x.slice(), U.i = q.i, U;
    }
    function L(q, U) {
      q ??= +/* @__PURE__ */ new Date();
      var Z = new z(q), V = U && U.state, G = function() {
        return (Z.next() >>> 0) / 4294967296;
      };
      return G.double = function() {
        do
          var W = ((Z.next() >>> 11) + (Z.next() >>> 0) / 4294967296) / (1 << 21);
        while (W === 0);
        return W;
      }, G.int32 = Z.next, G.quick = G, V && (V.x && R(V, Z), G.state = function() {
        return R(Z, {});
      }), G;
    }
    F && F.exports ? F.exports = L : I && I.amd ? I(function() {
      return L;
    }) : this.xorshift7 = L;
  })(D, typeof E == "object" && E, typeof define == "function" && define);
})), require_xor4096 = __commonJSMin(((D, E) => {
  (function(O, F, I) {
    function z(q) {
      var U = this;
      U.next = function() {
        var V = U.w, G = U.X, W = U.i, J, X;
        return U.w = V = V + 1640531527 | 0, X = G[W + 34 & 127], J = G[W = W + 1 & 127], X ^= X << 13, J ^= J << 17, X ^= X >>> 15, J ^= J >>> 12, X = G[W] = X ^ J, U.i = W, X + (V ^ V >>> 16) | 0;
      };
      function Z(V, G) {
        var W, J, X, Y, ee, K = [], te = 128;
        for (G === (G | 0) ? (J = G, G = null) : (G += "\0", J = 0, te = Math.max(te, G.length)), X = 0, Y = -32; Y < te; ++Y) G && (J ^= G.charCodeAt((Y + 32) % G.length)), Y === 0 && (ee = J), J ^= J << 10, J ^= J >>> 15, J ^= J << 4, J ^= J >>> 13, Y >= 0 && (ee = ee + 1640531527 | 0, W = K[Y & 127] ^= J + ee, X = W == 0 ? X + 1 : 0);
        for (X >= 128 && (K[(G && G.length || 0) & 127] = -1), X = 127, Y = 512; Y > 0; --Y) J = K[X + 34 & 127], W = K[X = X + 1 & 127], J ^= J << 13, W ^= W << 17, J ^= J >>> 15, W ^= W >>> 12, K[X] = J ^ W;
        V.w = ee, V.X = K, V.i = X;
      }
      Z(U, q);
    }
    function R(q, U) {
      return U.i = q.i, U.w = q.w, U.X = q.X.slice(), U;
    }
    function L(q, U) {
      q ??= +/* @__PURE__ */ new Date();
      var Z = new z(q), V = U && U.state, G = function() {
        return (Z.next() >>> 0) / 4294967296;
      };
      return G.double = function() {
        do
          var W = ((Z.next() >>> 11) + (Z.next() >>> 0) / 4294967296) / (1 << 21);
        while (W === 0);
        return W;
      }, G.int32 = Z.next, G.quick = G, V && (V.X && R(V, Z), G.state = function() {
        return R(Z, {});
      }), G;
    }
    F && F.exports ? F.exports = L : I && I.amd ? I(function() {
      return L;
    }) : this.xor4096 = L;
  })(D, typeof E == "object" && E, typeof define == "function" && define);
})), require_tychei = __commonJSMin(((D, E) => {
  (function(O, F, I) {
    function z(q) {
      var U = this, Z = "";
      U.next = function() {
        var G = U.b, W = U.c, J = U.d, X = U.a;
        return G = G << 25 ^ G >>> 7 ^ W, W = W - J | 0, J = J << 24 ^ J >>> 8 ^ X, X = X - G | 0, U.b = G = G << 20 ^ G >>> 12 ^ W, U.c = W = W - J | 0, U.d = J << 16 ^ W >>> 16 ^ X, U.a = X - G | 0;
      }, U.a = 0, U.b = 0, U.c = -1640531527, U.d = 1367130551, q === Math.floor(q) ? (U.a = q / 4294967296 | 0, U.b = q | 0) : Z += q;
      for (var V = 0; V < Z.length + 20; V++) U.b ^= Z.charCodeAt(V) | 0, U.next();
    }
    function R(q, U) {
      return U.a = q.a, U.b = q.b, U.c = q.c, U.d = q.d, U;
    }
    function L(q, U) {
      var Z = new z(q), V = U && U.state, G = function() {
        return (Z.next() >>> 0) / 4294967296;
      };
      return G.double = function() {
        do
          var W = ((Z.next() >>> 11) + (Z.next() >>> 0) / 4294967296) / (1 << 21);
        while (W === 0);
        return W;
      }, G.int32 = Z.next, G.quick = G, V && (typeof V == "object" && R(V, Z), G.state = function() {
        return R(Z, {});
      }), G;
    }
    F && F.exports ? F.exports = L : I && I.amd ? I(function() {
      return L;
    }) : this.tychei = L;
  })(D, typeof E == "object" && E, typeof define == "function" && define);
})), require___vite_browser_external = __commonJSMin(((D, E) => {
  E.exports = {};
})), require_seedrandom$1 = __commonJSMin(((D, E) => {
  (function(O, F, I) {
    var z = 256, R = 6, L = 52, q = "random", U = I.pow(z, R), Z = I.pow(2, L), V = Z * 2, G = z - 1, W;
    function J(ne, ae, ue) {
      var oe = [];
      ae = ae == 1 ? { entropy: !0 } : ae || {};
      var se = K(ee(ae.entropy ? [ne, ie(F)] : ne ?? te(), 3), oe), le = new X(oe), ce = function() {
        for (var fe = le.g(R), pe = U, ve = 0; fe < Z; ) fe = (fe + ve) * z, pe *= z, ve = le.g(1);
        for (; fe >= V; ) fe /= 2, pe /= 2, ve >>>= 1;
        return (fe + ve) / pe;
      };
      return ce.int32 = function() {
        return le.g(4) | 0;
      }, ce.quick = function() {
        return le.g(4) / 4294967296;
      }, ce.double = ce, K(ie(le.S), F), (ae.pass || ue || function(fe, pe, ve, _e) {
        return _e && (_e.S && Y(_e, le), fe.state = function() {
          return Y(le, {});
        }), ve ? (I[q] = fe, pe) : fe;
      })(ce, se, "global" in ae ? ae.global : this == I, ae.state);
    }
    function X(ne) {
      var ae, ue = ne.length, oe = this, se = 0, le = oe.i = oe.j = 0, ce = oe.S = [];
      for (ue || (ne = [ue++]); se < z; ) ce[se] = se++;
      for (se = 0; se < z; se++) ce[se] = ce[le = G & le + ne[se % ue] + (ae = ce[se])], ce[le] = ae;
      (oe.g = function(fe) {
        for (var pe, ve = 0, _e = oe.i, de = oe.j, ge = oe.S; fe--; ) pe = ge[_e = G & _e + 1], ve = ve * z + ge[G & (ge[_e] = ge[de = G & de + pe]) + (ge[de] = pe)];
        return oe.i = _e, oe.j = de, ve;
      })(z);
    }
    function Y(ne, ae) {
      return ae.i = ne.i, ae.j = ne.j, ae.S = ne.S.slice(), ae;
    }
    function ee(ne, ae) {
      var ue = [], oe = typeof ne, se;
      if (ae && oe == "object") for (se in ne) try {
        ue.push(ee(ne[se], ae - 1));
      } catch {
      }
      return ue.length ? ue : oe == "string" ? ne : ne + "\0";
    }
    function K(ne, ae) {
      for (var ue = ne + "", oe, se = 0; se < ue.length; ) ae[G & se] = G & (oe ^= ae[G & se] * 19) + ue.charCodeAt(se++);
      return ie(ae);
    }
    function te() {
      try {
        var ne;
        return W && (ne = W.randomBytes) ? ne = ne(z) : (ne = new Uint8Array(z), (O.crypto || O.msCrypto).getRandomValues(ne)), ie(ne);
      } catch {
        var ae = O.navigator, ue = ae && ae.plugins;
        return [+/* @__PURE__ */ new Date(), O, ue, O.screen, ie(F)];
      }
    }
    function ie(ne) {
      return String.fromCharCode.apply(0, ne);
    }
    if (K(I.random(), F), typeof E == "object" && E.exports) {
      E.exports = J;
      try {
        W = require___vite_browser_external();
      } catch {
      }
    } else typeof define == "function" && define.amd ? define(function() {
      return J;
    }) : I["seed" + q] = J;
  })(typeof self < "u" ? self : D, [], Math);
})), require_seedrandom = __commonJSMin(((D, E) => {
  var O = require_alea(), F = require_xor128(), I = require_xorwow(), z = require_xorshift7(), R = require_xor4096(), L = require_tychei(), q = require_seedrandom$1();
  q.alea = O, q.xor128 = F, q.xorwow = I, q.xorshift7 = z, q.xor4096 = R, q.tychei = L, E.exports = q;
})), import_seedrandom = __toESM(require_seedrandom()), singletonRandom = (0, import_seedrandom.default)(Date.now());
function createRng(D) {
  var E;
  function O(I) {
    E = I === null ? singletonRandom : (0, import_seedrandom.default)(String(I));
  }
  O(D);
  function F() {
    return E();
  }
  return F;
}
var name$47 = "pickRandom", dependencies$47 = ["typed", "config", "?on"], createPickRandom = factory(name$47, dependencies$47, (D) => {
  var { typed: E, config: O, on: F } = D, I = createRng(O.randomSeed);
  return F && F("config", function(R, L) {
    R.randomSeed !== L.randomSeed && (I = createRng(R.randomSeed));
  }), E(name$47, { "Array | Matrix": function(R) {
    return z(R, {});
  }, "Array | Matrix, Object": function(R, L) {
    return z(R, L);
  }, "Array | Matrix, number": function(R, L) {
    return z(R, { number: L });
  }, "Array | Matrix, Array | Matrix": function(R, L) {
    return z(R, { weights: L });
  }, "Array | Matrix, Array | Matrix, number": function(R, L, q) {
    return z(R, { number: q, weights: L });
  }, "Array | Matrix, number, Array | Matrix": function(R, L, q) {
    return z(R, { number: L, weights: q });
  } });
  function z(R, L) {
    var { number: q, weights: U, elementWise: Z = !0 } = L, V = q === void 0;
    V && (q = 1);
    var G = isMatrix(R) ? R.create : isMatrix(U) ? U.create : null;
    R = R.valueOf(), U &&= U.valueOf(), Z === !0 && (R = flatten$4(R), U = flatten$4(U));
    var W = 0;
    if (U !== void 0) {
      if (U.length !== R.length) throw Error("Weights must have the same length as possibles");
      for (var J = 0, X = U.length; J < X; J++) {
        if (!isNumber(U[J]) || U[J] < 0) throw Error("Weights must be an array of positive numbers");
        W += U[J];
      }
    }
    for (var Y = R.length, ee = [], K; ee.length < q; ) {
      if (U === void 0) K = R[Math.floor(I() * Y)];
      else for (var te = I() * W, ie = 0, ne = R.length; ie < ne; ie++) if (te -= U[ie], te < 0) {
        K = R[ie];
        break;
      }
      ee.push(K);
    }
    return V ? ee[0] : G ? G(ee) : ee;
  }
});
function randomMatrix(D, E) {
  var O = [];
  if (D = D.slice(0), D.length > 1) for (var F = 0, I = D.shift(); F < I; F++) O.push(randomMatrix(D, E));
  else for (var z = 0, R = D.shift(); z < R; z++) O.push(E());
  return O;
}
var name$46 = "random", dependencies$46 = ["typed", "config", "?on"], createRandom = factory(name$46, dependencies$46, (D) => {
  var { typed: E, config: O, on: F } = D, I = createRng(O.randomSeed);
  return F && F("config", function(L, q) {
    L.randomSeed !== q.randomSeed && (I = createRng(L.randomSeed));
  }), E(name$46, { "": () => R(0, 1), number: (L) => R(0, L), "number, number": (L, q) => R(L, q), "Array | Matrix": (L) => z(L, 0, 1), "Array | Matrix, number": (L, q) => z(L, 0, q), "Array | Matrix, number, number": (L, q, U) => z(L, q, U) });
  function z(L, q, U) {
    var Z = randomMatrix(L.valueOf(), () => R(q, U));
    return isMatrix(L) ? L.create(Z, "number") : Z;
  }
  function R(L, q) {
    return L + I() * (q - L);
  }
}), name$45 = "randomInt", dependencies$45 = ["typed", "config", "log2", "?on"], createRandomInt = factory(name$45, dependencies$45, (D) => {
  var { typed: E, config: O, log2: F, on: I } = D, z = createRng(O.randomSeed);
  return I && I("config", function(U, Z) {
    U.randomSeed !== Z.randomSeed && (z = createRng(U.randomSeed));
  }), E(name$45, { "": () => L(0, 2), number: (U) => L(0, U), "number, number": (U, Z) => L(U, Z), bigint: (U) => q(0n, U), "bigint, bigint": q, "Array | Matrix": (U) => R(U, 0, 1), "Array | Matrix, number": (U, Z) => R(U, 0, Z), "Array | Matrix, number, number": (U, Z, V) => R(U, Z, V) });
  function R(U, Z, V) {
    var G = randomMatrix(U.valueOf(), () => L(Z, V));
    return isMatrix(U) ? U.create(G, "number") : G;
  }
  function L(U, Z) {
    return Math.floor(U + z() * (Z - U));
  }
  function q(U, Z) {
    var V = 2n ** 30n, G = Z - U;
    if (G <= V) return U + BigInt(L(0, Number(G)));
    for (var W = F(G), J = G; J >= G; ) {
      J = 0n;
      for (var X = 0; X < W; ++X) J = 2n * J + (z() < 0.5 ? 0n : 1n);
    }
    return U + J;
  }
}), name$44 = "stirlingS2", dependencies$44 = ["typed", "addScalar", "subtractScalar", "multiplyScalar", "divideScalar", "pow", "factorial", "combinations", "isNegative", "isInteger", "number", "?bignumber", "larger"], createStirlingS2 = factory(name$44, dependencies$44, (D) => {
  var { typed: E, addScalar: O, subtractScalar: F, multiplyScalar: I, divideScalar: z, pow: R, factorial: L, combinations: q, isNegative: U, isInteger: Z, number: V, bignumber: G, larger: W } = D, J = [], X = [];
  return E(name$44, { "number | BigNumber, number | BigNumber": function(Y, ee) {
    if (!Z(Y) || U(Y) || !Z(ee) || U(ee)) throw TypeError("Non-negative integer value expected in function stirlingS2");
    if (W(ee, Y)) throw TypeError("k must be less than or equal to n in function stirlingS2");
    var K = !(isNumber(Y) && isNumber(ee)), te = K ? X : J, ie = K ? G : V, ne = V(Y), ae = V(ee);
    if (te[ne] && te[ne].length > ae) return te[ne][ae];
    for (var ue = 0; ue <= ne; ++ue) if (te[ue] || (te[ue] = [ie(+(ue === 0))]), ue !== 0) for (var oe = te[ue], se = te[ue - 1], le = oe.length; le <= ue && le <= ae; ++le) le === ue ? oe[le] = 1 : oe[le] = O(I(ie(le), se[le]), se[le - 1]);
    return te[ne][ae];
  } });
}), name$43 = "bellNumbers", dependencies$43 = ["typed", "addScalar", "isNegative", "isInteger", "stirlingS2"], createBellNumbers = factory(name$43, dependencies$43, (D) => {
  var { typed: E, addScalar: O, isNegative: F, isInteger: I, stirlingS2: z } = D;
  return E(name$43, { "number | BigNumber": function(R) {
    if (!I(R) || F(R)) throw TypeError("Non-negative integer value expected in function bellNumbers");
    for (var L = 0, q = 0; q <= R; q++) L = O(L, z(R, q));
    return L;
  } });
}), name$42 = "catalan", dependencies$42 = ["typed", "addScalar", "divideScalar", "multiplyScalar", "combinations", "isNegative", "isInteger"], createCatalan = factory(name$42, dependencies$42, (D) => {
  var { typed: E, addScalar: O, divideScalar: F, multiplyScalar: I, combinations: z, isNegative: R, isInteger: L } = D;
  return E(name$42, { "number | BigNumber": function(q) {
    if (!L(q) || R(q)) throw TypeError("Non-negative integer value expected in function catalan");
    return F(z(I(q, 2), q), O(q, 1));
  } });
}), name$41 = "composition", dependencies$41 = ["typed", "addScalar", "combinations", "isNegative", "isPositive", "isInteger", "larger"], createComposition = factory(name$41, dependencies$41, (D) => {
  var { typed: E, addScalar: O, combinations: F, isPositive: I, isNegative: z, isInteger: R, larger: L } = D;
  return E(name$41, { "number | BigNumber, number | BigNumber": function(q, U) {
    if (!R(q) || !I(q) || !R(U) || !I(U)) throw TypeError("Positive integer value expected in function composition");
    if (L(U, q)) throw TypeError("k must be less than or equal to n in function composition");
    return F(O(q, -1), O(U, -1));
  } });
}), name$40 = "leafCount", dependencies$40 = ["parse", "typed"], createLeafCount = factory(name$40, dependencies$40, (D) => {
  var { parse: E, typed: O } = D;
  function F(I) {
    var z = 0;
    return I.forEach((R) => {
      z += F(R);
    }), z || 1;
  }
  return O(name$40, { Node: function(I) {
    return F(I);
  } });
});
function isNumericNode(D) {
  return isConstantNode(D) || isOperatorNode(D) && D.isUnary() && isConstantNode(D.args[0]);
}
function isConstantExpression(D) {
  return !!(isConstantNode(D) || (isFunctionNode(D) || isOperatorNode(D)) && D.args.every(isConstantExpression) || isParenthesisNode(D) && isConstantExpression(D.content));
}
function ownKeys$1(D, E) {
  var O = Object.keys(D);
  if (Object.getOwnPropertySymbols) {
    var F = Object.getOwnPropertySymbols(D);
    E && (F = F.filter(function(I) {
      return Object.getOwnPropertyDescriptor(D, I).enumerable;
    })), O.push.apply(O, F);
  }
  return O;
}
function _objectSpread$1(D) {
  for (var E = 1; E < arguments.length; E++) {
    var O = arguments[E] == null ? {} : arguments[E];
    E % 2 ? ownKeys$1(Object(O), !0).forEach(function(F) {
      _defineProperty(D, F, O[F]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(D, Object.getOwnPropertyDescriptors(O)) : ownKeys$1(Object(O)).forEach(function(F) {
      Object.defineProperty(D, F, Object.getOwnPropertyDescriptor(O, F));
    });
  }
  return D;
}
var name$39 = "simplifyUtil", dependencies$39 = ["FunctionNode", "OperatorNode", "SymbolNode"], createUtil = factory(name$39, dependencies$39, (D) => {
  var { FunctionNode: E, OperatorNode: O, SymbolNode: F } = D, I = !0, z = !1, R = "defaultF", L = { add: { trivial: I, total: I, commutative: I, associative: I }, unaryPlus: { trivial: I, total: I, commutative: I, associative: I }, subtract: { trivial: z, total: I, commutative: z, associative: z }, multiply: { trivial: I, total: I, commutative: I, associative: I }, divide: { trivial: z, total: I, commutative: z, associative: z }, paren: { trivial: I, total: I, commutative: I, associative: z }, defaultF: { trivial: z, total: I, commutative: z, associative: z } }, q = { divide: { total: z }, log: { total: z } }, U = { subtract: { total: z }, abs: { trivial: I }, log: { total: I } };
  function Z(te, ie) {
    var ne = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : L, ae = R;
    if (typeof te == "string" ? ae = te : isOperatorNode(te) ? ae = te.fn.toString() : isFunctionNode(te) ? ae = te.name : isParenthesisNode(te) && (ae = "paren"), hasOwnProperty$1(ne, ae)) {
      var ue = ne[ae];
      if (hasOwnProperty$1(ue, ie)) return ue[ie];
      if (hasOwnProperty$1(L, ae)) return L[ae][ie];
    }
    if (hasOwnProperty$1(ne, R)) {
      var oe = ne[R];
      return hasOwnProperty$1(oe, ie) ? oe[ie] : L[R][ie];
    }
    if (hasOwnProperty$1(L, ae)) {
      var se = L[ae];
      if (hasOwnProperty$1(se, ie)) return se[ie];
    }
    return L[R][ie];
  }
  function V(te) {
    return Z(te, "commutative", arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : L);
  }
  function G(te) {
    return Z(te, "associative", arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : L);
  }
  function W(te, ie) {
    var ne = _objectSpread$1({}, te);
    for (var ae in ie) hasOwnProperty$1(te, ae) ? ne[ae] = _objectSpread$1(_objectSpread$1({}, ie[ae]), te[ae]) : ne[ae] = ie[ae];
    return ne;
  }
  function J(te, ie) {
    if (!te.args || te.args.length === 0) return te;
    te.args = X(te, ie);
    for (var ne = 0; ne < te.args.length; ne++) J(te.args[ne], ie);
  }
  function X(te, ie) {
    var ne, ae = [], ue = function(oe) {
      for (var se = 0; se < oe.args.length; se++) {
        var le = oe.args[se];
        isOperatorNode(le) && ne === le.op ? ue(le) : ae.push(le);
      }
    };
    return G(te, ie) ? (ne = te.op, ue(te), ae) : te.args;
  }
  function Y(te, ie) {
    if (!(!te.args || te.args.length === 0)) {
      for (var ne = K(te), ae = te.args.length, ue = 0; ue < ae; ue++) Y(te.args[ue], ie);
      if (ae > 2 && G(te, ie)) {
        for (var oe = te.args.pop(); te.args.length > 0; ) oe = ne([te.args.pop(), oe]);
        te.args = oe.args;
      }
    }
  }
  function ee(te, ie) {
    if (!(!te.args || te.args.length === 0)) {
      for (var ne = K(te), ae = te.args.length, ue = 0; ue < ae; ue++) ee(te.args[ue], ie);
      if (ae > 2 && G(te, ie)) {
        for (var oe = te.args.shift(); te.args.length > 0; ) oe = ne([oe, te.args.shift()]);
        te.args = oe.args;
      }
    }
  }
  function K(te) {
    return isOperatorNode(te) ? function(ie) {
      try {
        return new O(te.op, te.fn, ie, te.implicit);
      } catch (ne) {
        return console.error(ne), [];
      }
    } : function(ie) {
      return new E(new F(te.name), ie);
    };
  }
  return { createMakeNodeFunction: K, hasProperty: Z, isCommutative: V, isAssociative: G, mergeContext: W, flatten: J, allChildren: X, unflattenr: Y, unflattenl: ee, defaultContext: L, realContext: q, positiveContext: U };
}), name$38 = "simplify", dependencies$38 = ["typed", "parse", "equal", "resolve", "simplifyConstant", "simplifyCore", "AccessorNode", "ArrayNode", "ConstantNode", "FunctionNode", "IndexNode", "ObjectNode", "OperatorNode", "ParenthesisNode", "SymbolNode", "replacer"], createSimplify = factory(name$38, dependencies$38, (D) => {
  var { typed: E, parse: O, equal: F, resolve: I, simplifyConstant: z, simplifyCore: R, AccessorNode: L, ArrayNode: q, ConstantNode: U, FunctionNode: Z, IndexNode: V, ObjectNode: G, OperatorNode: W, ParenthesisNode: J, SymbolNode: X, replacer: Y } = D, { hasProperty: ee, isCommutative: K, isAssociative: te, mergeContext: ie, flatten: ne, unflattenr: ae, unflattenl: ue, createMakeNodeFunction: oe, defaultContext: se, realContext: le, positiveContext: ce } = createUtil({ FunctionNode: Z, OperatorNode: W, SymbolNode: X });
  E.addConversion({ from: "Object", to: "Map", convert: createMap$1 });
  var fe = E("simplify", { Node: De, "Node, Map": (be, Ae) => De(be, !1, Ae), "Node, Map, Object": (be, Ae, Me) => De(be, !1, Ae, Me), "Node, Array": De, "Node, Array, Map": De, "Node, Array, Map, Object": De });
  E.removeConversion({ from: "Object", to: "Map", convert: createMap$1 }), fe.defaultContext = se, fe.realContext = le, fe.positiveContext = ce;
  function pe(be) {
    return be.transform(function(Ae) {
      return isParenthesisNode(Ae) ? pe(Ae.content) : Ae;
    });
  }
  var ve = { true: !0, false: !0, e: !0, i: !0, Infinity: !0, LN2: !0, LN10: !0, LOG2E: !0, LOG10E: !0, NaN: !0, phi: !0, pi: !0, SQRT1_2: !0, SQRT2: !0, tau: !0 };
  fe.rules = [R, { l: "log(e)", r: "1" }, { s: "n-n1 -> n+-n1", assuming: { subtract: { total: !0 } } }, { s: "n-n -> 0", assuming: { subtract: { total: !1 } } }, { s: "-(cl*v) -> v * (-cl)", assuming: { multiply: { commutative: !0 }, subtract: { total: !0 } } }, { s: "-(cl*v) -> (-cl) * v", assuming: { multiply: { commutative: !1 }, subtract: { total: !0 } } }, { s: "-(v*cl) -> v * (-cl)", assuming: { multiply: { commutative: !1 }, subtract: { total: !0 } } }, { l: "-(n1/n2)", r: "-n1/n2" }, { l: "-v", r: "v * (-1)" }, { l: "(n1 + n2)*(-1)", r: "n1*(-1) + n2*(-1)", repeat: !0 }, { l: "n/n1^n2", r: "n*n1^-n2" }, { l: "n/n1", r: "n*n1^-1" }, { s: "(n1*n2)^n3 -> n1^n3 * n2^n3", assuming: { multiply: { commutative: !0 } } }, { s: "(n1*n2)^(-1) -> n2^(-1) * n1^(-1)", assuming: { multiply: { commutative: !1 } } }, { s: "(n ^ n1) ^ n2 -> n ^ (n1 * n2)", assuming: { divide: { total: !0 } } }, { l: " vd   * ( vd   * n1 + n2)", r: "vd^2       * n1 +  vd   * n2" }, { s: " vd   * (vd^n4 * n1 + n2)   ->  vd^(1+n4)  * n1 +  vd   * n2", assuming: { divide: { total: !0 } } }, { s: "vd^n3 * ( vd   * n1 + n2)   ->  vd^(n3+1)  * n1 + vd^n3 * n2", assuming: { divide: { total: !0 } } }, { s: "vd^n3 * (vd^n4 * n1 + n2)   ->  vd^(n3+n4) * n1 + vd^n3 * n2", assuming: { divide: { total: !0 } } }, { l: "n*n", r: "n^2" }, { s: "n * n^n1 -> n^(n1+1)", assuming: { divide: { total: !0 } } }, { s: "n^n1 * n^n2 -> n^(n1+n2)", assuming: { divide: { total: !0 } } }, z, { s: "n+n -> 2*n", assuming: { add: { total: !0 } } }, { l: "n+-n", r: "0" }, { l: "vd*n + vd", r: "vd*(n+1)" }, { l: "n3*n1 + n3*n2", r: "n3*(n1+n2)" }, { l: "n3^(-n4)*n1 +   n3  * n2", r: "n3^(-n4)*(n1 + n3^(n4+1) *n2)" }, { l: "n3^(-n4)*n1 + n3^n5 * n2", r: "n3^(-n4)*(n1 + n3^(n4+n5)*n2)" }, { s: "n*vd + vd -> (n+1)*vd", assuming: { multiply: { commutative: !1 } } }, { s: "vd + n*vd -> (1+n)*vd", assuming: { multiply: { commutative: !1 } } }, { s: "n1*n3 + n2*n3 -> (n1+n2)*n3", assuming: { multiply: { commutative: !1 } } }, { s: "n^n1 * n -> n^(n1+1)", assuming: { divide: { total: !0 }, multiply: { commutative: !1 } } }, { s: "n1*n3^(-n4) + n2 * n3    -> (n1 + n2*n3^(n4 +  1))*n3^(-n4)", assuming: { multiply: { commutative: !1 } } }, { s: "n1*n3^(-n4) + n2 * n3^n5 -> (n1 + n2*n3^(n4 + n5))*n3^(-n4)", assuming: { multiply: { commutative: !1 } } }, { l: "n*cd + cd", r: "(n+1)*cd" }, { s: "cd*n + cd -> cd*(n+1)", assuming: { multiply: { commutative: !1 } } }, { s: "cd + cd*n -> cd*(1+n)", assuming: { multiply: { commutative: !1 } } }, z, { s: "(-n)*n1 -> -(n*n1)", assuming: { subtract: { total: !0 } } }, { s: "n1*(-n) -> -(n1*n)", assuming: { subtract: { total: !0 }, multiply: { commutative: !1 } } }, { s: "ce+ve -> ve+ce", assuming: { add: { commutative: !0 } }, imposeContext: { add: { commutative: !1 } } }, { s: "vd*cd -> cd*vd", assuming: { multiply: { commutative: !0 } }, imposeContext: { multiply: { commutative: !1 } } }, { l: "n+-n1", r: "n-n1" }, { l: "n+-(n1)", r: "n-(n1)" }, { s: "n*(n1^-1) -> n/n1", assuming: { multiply: { commutative: !0 } } }, { s: "n*n1^-n2 -> n/n1^n2", assuming: { multiply: { commutative: !0 } } }, { s: "n^-1 -> 1/n", assuming: { multiply: { commutative: !0 } } }, { l: "n^1", r: "n" }, { s: "n*(n1/n2) -> (n*n1)/n2", assuming: { multiply: { associative: !0 } } }, { s: "n-(n1+n2) -> n-n1-n2", assuming: { addition: { associative: !0, commutative: !0 } } }, { l: "1*n", r: "n", imposeContext: { multiply: { commutative: !0 } } }, { s: "n1/(n2/n3) -> (n1*n3)/n2", assuming: { multiply: { associative: !0 } } }, { l: "n1/(-n2)", r: "-n1/n2" }];
  function _e(be, Ae) {
    var Me = {};
    if (be.s) {
      var $e = be.s.split("->");
      if ($e.length === 2) Me.l = $e[0], Me.r = $e[1];
      else throw SyntaxError("Could not parse rule: " + be.s);
    } else Me.l = be.l, Me.r = be.r;
    Me.l = pe(O(Me.l)), Me.r = pe(O(Me.r));
    for (var Re of ["imposeContext", "repeat", "assuming"]) Re in be && (Me[Re] = be[Re]);
    if (be.evaluate && (Me.evaluate = O(be.evaluate)), te(Me.l, Ae)) {
      var je = !K(Me.l, Ae), Pe;
      je && (Pe = ye());
      var Ke = oe(Me.l), Qe = ye();
      Me.expanded = {}, Me.expanded.l = Ke([Me.l, Qe]), ne(Me.expanded.l, Ae), ae(Me.expanded.l, Ae), Me.expanded.r = Ke([Me.r, Qe]), je && (Me.expandedNC1 = {}, Me.expandedNC1.l = Ke([Pe, Me.l]), Me.expandedNC1.r = Ke([Pe, Me.r]), Me.expandedNC2 = {}, Me.expandedNC2.l = Ke([Pe, Me.expanded.l]), Me.expandedNC2.r = Ke([Pe, Me.expanded.r]));
    }
    return Me;
  }
  function de(be, Ae) {
    for (var Me = [], $e = 0; $e < be.length; $e++) {
      var Re = be[$e], je = void 0, Pe = typeof Re;
      switch (Pe) {
        case "string":
          Re = { s: Re };
        case "object":
          je = _e(Re, Ae);
          break;
        case "function":
          je = Re;
          break;
        default:
          throw TypeError("Unsupported type of rule: " + Pe);
      }
      Me.push(je);
    }
    return Me;
  }
  var ge = 0;
  function ye() {
    return new X("_p" + ge++);
  }
  function De(be, Ae) {
    var Me = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : createEmptyMap(), $e = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, Re = $e.consoleDebug;
    Ae = de(Ae || fe.rules, $e.context);
    var je = I(be, Me);
    je = pe(je);
    for (var Pe = {}, Ke = je.toString({ parenthesis: "all" }); !Pe[Ke]; ) {
      Pe[Ke] = !0, ge = 0;
      var Qe = Ke;
      Re && console.log("Working on: ", Ke);
      for (var We = 0; We < Ae.length; We++) {
        var ir = "";
        if (typeof Ae[We] == "function" ? (je = Ae[We](je, $e), Re && (ir = Ae[We].name)) : (ne(je, $e.context), je = Ie(je, Ae[We], $e.context), Re && (ir = `${Ae[We].l.toString()} -> ${Ae[We].r.toString()}`)), Re) {
          var nr = je.toString({ parenthesis: "all" });
          nr !== Qe && (console.log("Applying", ir, "produced", nr), Qe = nr);
        }
        ue(je, $e.context);
      }
      Ke = je.toString({ parenthesis: "all" });
    }
    return je;
  }
  function Ce(be, Ae, Me) {
    var $e = be;
    if (be) for (var Re = 0; Re < be.length; ++Re) {
      var je = Ie(be[Re], Ae, Me);
      je !== be[Re] && ($e === be && ($e = be.slice()), $e[Re] = je);
    }
    return $e;
  }
  function Ie(be, Ae, Me) {
    if (Ae.assuming) {
      for (var $e in Ae.assuming) for (var Re in Ae.assuming[$e]) if (ee($e, Re, Me) !== Ae.assuming[$e][Re]) return be;
    }
    var je = ie(Ae.imposeContext, Me), Pe = be;
    if (Pe instanceof W || Pe instanceof Z) {
      var Ke = Ce(Pe.args, Ae, Me);
      Ke !== Pe.args && (Pe = Pe.clone(), Pe.args = Ke);
    } else if (Pe instanceof J) {
      if (Pe.content) {
        var Qe = Ie(Pe.content, Ae, Me);
        Qe !== Pe.content && (Pe = new J(Qe));
      }
    } else if (Pe instanceof q) {
      var We = Ce(Pe.items, Ae, Me);
      We !== Pe.items && (Pe = new q(We));
    } else if (Pe instanceof L) {
      var ir = Pe.object;
      Pe.object && (ir = Ie(Pe.object, Ae, Me));
      var nr = Pe.index;
      Pe.index && (nr = Ie(Pe.index, Ae, Me)), (ir !== Pe.object || nr !== Pe.index) && (Pe = new L(ir, nr));
    } else if (Pe instanceof V) {
      var we = Ce(Pe.dimensions, Ae, Me);
      we !== Pe.dimensions && (Pe = new V(we));
    } else if (Pe instanceof G) {
      var Oe = !1, ze = {};
      for (var Ue in Pe.properties) ze[Ue] = Ie(Pe.properties[Ue], Ae, Me), ze[Ue] !== Pe.properties[Ue] && (Oe = !0);
      Oe && (Pe = new G(ze));
    }
    var er = Ae.r, Xe = Te(Ae.l, Pe, je)[0];
    if (!Xe && Ae.expanded && (er = Ae.expanded.r, Xe = Te(Ae.expanded.l, Pe, je)[0]), !Xe && Ae.expandedNC1 && (er = Ae.expandedNC1.r, Xe = Te(Ae.expandedNC1.l, Pe, je)[0], Xe ||= (er = Ae.expandedNC2.r, Te(Ae.expandedNC2.l, Pe, je)[0])), Xe) {
      var rr = Pe.implicit;
      Pe = er.clone(), rr && "implicit" in er && (Pe.implicit = !0), Pe = Pe.transform(function(or) {
        return or.isSymbolNode && hasOwnProperty$1(Xe.placeholders, or.name) ? Xe.placeholders[or.name].clone() : or;
      });
    }
    return Ae.repeat && Pe !== be && (Pe = Ie(Pe, Ae, Me)), Pe;
  }
  function Ne(be, Ae) {
    var Me = [], $e, Re, je = oe(be);
    if (K(be, Ae)) for (var Pe = 0; Pe < be.args.length; Pe++) Re = be.args.slice(0), Re.splice(Pe, 1), $e = Re.length === 1 ? Re[0] : je(Re), Me.push(je([be.args[Pe], $e]));
    else for (var Ke = 1; Ke < be.args.length; Ke++) {
      var Qe = be.args[0];
      Ke > 1 && (Qe = je(be.args.slice(0, Ke))), Re = be.args.slice(Ke), $e = Re.length === 1 ? Re[0] : je(Re), Me.push(je([Qe, $e]));
    }
    return Me;
  }
  function he(be, Ae) {
    var Me = { placeholders: {} };
    if (!be.placeholders && !Ae.placeholders) return Me;
    if (!be.placeholders) return Ae;
    if (!Ae.placeholders) return be;
    for (var $e in be.placeholders) if (hasOwnProperty$1(be.placeholders, $e) && (Me.placeholders[$e] = be.placeholders[$e], hasOwnProperty$1(Ae.placeholders, $e) && !Fe(be.placeholders[$e], Ae.placeholders[$e]))) return null;
    for (var Re in Ae.placeholders) hasOwnProperty$1(Ae.placeholders, Re) && (Me.placeholders[Re] = Ae.placeholders[Re]);
    return Me;
  }
  function ke(be, Ae) {
    var Me = [];
    if (be.length === 0 || Ae.length === 0) return Me;
    for (var $e, Re = 0; Re < be.length; Re++) for (var je = 0; je < Ae.length; je++) $e = he(be[Re], Ae[je]), $e && Me.push($e);
    return Me;
  }
  function xe(be) {
    if (be.length === 0) return be;
    for (var Ae = be.reduce(ke), Me = [], $e = {}, Re = 0; Re < Ae.length; Re++) {
      var je = JSON.stringify(Ae[Re], Y);
      $e[je] || ($e[je] = !0, Me.push(Ae[Re]));
    }
    return Me;
  }
  function Te(be, Ae, Me, $e) {
    var Re = [{ placeholders: {} }];
    if (be instanceof W && Ae instanceof W || be instanceof Z && Ae instanceof Z) {
      if (be instanceof W) {
        if (be.op !== Ae.op || be.fn !== Ae.fn) return [];
      } else if (be instanceof Z && be.name !== Ae.name) return [];
      if (Ae.args.length === 1 && be.args.length === 1 || !te(Ae, Me) && Ae.args.length === be.args.length || $e) {
        for (var je = [], Pe = 0; Pe < be.args.length; Pe++) {
          var Ke = Te(be.args[Pe], Ae.args[Pe], Me);
          if (Ke.length === 0) break;
          je.push(Ke);
        }
        if (je.length !== be.args.length) {
          if (!K(Ae, Me) || be.args.length === 1) return [];
          if (be.args.length > 2) throw Error("permuting >2 commutative non-associative rule arguments not yet implemented");
          var Qe = Te(be.args[0], Ae.args[1], Me);
          if (Qe.length === 0) return [];
          var We = Te(be.args[1], Ae.args[0], Me);
          if (We.length === 0) return [];
          je = [Qe, We];
        }
        Re = xe(je);
      } else if (Ae.args.length >= 2 && be.args.length === 2) {
        for (var ir = Ne(Ae, Me), nr = [], we = 0; we < ir.length; we++) {
          var Oe = Te(be, ir[we], Me, !0);
          nr = nr.concat(Oe);
        }
        return nr;
      } else {
        if (be.args.length > 2) throw Error("Unexpected non-binary associative function: " + be.toString());
        return [];
      }
    } else if (be instanceof X) {
      if (be.name.length === 0) throw Error("Symbol in rule has 0 length...!?");
      if (ve[be.name]) {
        if (be.name !== Ae.name) return [];
      } else switch (be.name[1] >= "a" && be.name[1] <= "z" ? be.name.substring(0, 2) : be.name[0]) {
        case "n":
        case "_p":
          Re[0].placeholders[be.name] = Ae;
          break;
        case "c":
        case "cl":
          if (isConstantNode(Ae)) Re[0].placeholders[be.name] = Ae;
          else return [];
          break;
        case "v":
          if (!isConstantNode(Ae)) Re[0].placeholders[be.name] = Ae;
          else return [];
          break;
        case "vl":
          if (isSymbolNode(Ae)) Re[0].placeholders[be.name] = Ae;
          else return [];
          break;
        case "cd":
          if (isNumericNode(Ae)) Re[0].placeholders[be.name] = Ae;
          else return [];
          break;
        case "vd":
          if (!isNumericNode(Ae)) Re[0].placeholders[be.name] = Ae;
          else return [];
          break;
        case "ce":
          if (isConstantExpression(Ae)) Re[0].placeholders[be.name] = Ae;
          else return [];
          break;
        case "ve":
          if (!isConstantExpression(Ae)) Re[0].placeholders[be.name] = Ae;
          else return [];
          break;
        default:
          throw Error("Invalid symbol in rule: " + be.name);
      }
    } else if (be instanceof U) {
      if (!F(be.value, Ae.value)) return [];
    } else return [];
    return Re;
  }
  function Fe(be, Ae) {
    if (be instanceof U && Ae instanceof U) {
      if (!F(be.value, Ae.value)) return !1;
    } else if (be instanceof X && Ae instanceof X) {
      if (be.name !== Ae.name) return !1;
    } else if (be instanceof W && Ae instanceof W || be instanceof Z && Ae instanceof Z) {
      if (be instanceof W) {
        if (be.op !== Ae.op || be.fn !== Ae.fn) return !1;
      } else if (be instanceof Z && be.name !== Ae.name) return !1;
      if (be.args.length !== Ae.args.length) return !1;
      for (var Me = 0; Me < be.args.length; Me++) if (!Fe(be.args[Me], Ae.args[Me])) return !1;
    } else return !1;
    return !0;
  }
  return fe;
}), name$37 = "simplifyConstant", dependencies$37 = ["typed", "config", "mathWithTransform", "matrix", "isBounded", "?fraction", "?bignumber", "AccessorNode", "ArrayNode", "ConstantNode", "FunctionNode", "IndexNode", "ObjectNode", "OperatorNode", "SymbolNode"], createSimplifyConstant = factory(name$37, dependencies$37, (D) => {
  var { typed: E, config: O, mathWithTransform: F, matrix: I, isBounded: z, fraction: R, bignumber: L, AccessorNode: q, ArrayNode: U, ConstantNode: Z, FunctionNode: V, IndexNode: G, ObjectNode: W, OperatorNode: J, SymbolNode: X } = D, { isCommutative: Y, isAssociative: ee, allChildren: K, createMakeNodeFunction: te } = createUtil({ FunctionNode: V, OperatorNode: J, SymbolNode: X }), ie = E("simplifyConstant", { Node: (de) => oe(_e(de, {})), "Node, Object": function(de, ge) {
    return oe(_e(de, ge));
  } });
  function ne(de) {
    return isFraction(de) ? de.valueOf() : de instanceof Array ? de.map(ne) : isMatrix(de) ? I(ne(de.valueOf())) : de;
  }
  function ae(de, ge, ye) {
    try {
      return F[de].apply(null, ge);
    } catch {
      return ge = ge.map(ne), le(F[de].apply(null, ge), ye);
    }
  }
  var ue = E({ Fraction: fe, number: function(de) {
    return de < 0 ? ce(new Z(-de)) : new Z(de);
  }, BigNumber: function(de) {
    return de < 0 ? ce(new Z(-de)) : new Z(de);
  }, bigint: function(de) {
    return de < 0n ? ce(new Z(-de)) : new Z(de);
  }, Complex: function(de) {
    throw Error("Cannot convert Complex number to Node");
  }, string: function(de) {
    return new Z(de);
  }, Matrix: function(de) {
    return new U(de.valueOf().map((ge) => ue(ge)));
  } });
  function oe(de) {
    return isNode(de) ? de : ue(de);
  }
  function se(de, ge) {
    if (ge && ge.exactFractions !== !1 && z(de) && R) {
      var ye = R(de), De = ge && typeof ge.fractionsLimit == "number" ? ge.fractionsLimit : 1 / 0;
      if (ye.valueOf() === de && ye.n < De && ye.d < De) return ye;
    }
    return de;
  }
  var le = E({ "string, Object": function(de, ge) {
    var ye = safeNumberType(de, O);
    return ye === "BigNumber" ? (L === void 0 && noBignumber(), L(de)) : ye === "bigint" ? BigInt(de) : ye === "Fraction" ? (R === void 0 && noFraction(), R(de)) : se(parseFloat(de), ge);
  }, "Fraction, Object": function(de, ge) {
    return de;
  }, "BigNumber, Object": function(de, ge) {
    return de;
  }, "number, Object": function(de, ge) {
    return se(de, ge);
  }, "bigint, Object": function(de, ge) {
    return de;
  }, "Complex, Object": function(de, ge) {
    return de.im === 0 ? se(de.re, ge) : de;
  }, "Matrix, Object": function(de, ge) {
    return I(se(de.valueOf()));
  }, "Array, Object": function(de, ge) {
    return de.map(se);
  } });
  function ce(de) {
    return new J("-", "unaryMinus", [de]);
  }
  function fe(de) {
    var ge = (Ce) => O.number === "BigNumber" && L ? L(Ce) : Number(Ce), ye = de.s * de.n, De = ye < 0n ? new J("-", "unaryMinus", [new Z(-ge(ye))]) : new Z(ge(ye));
    return de.d === 1n ? De : new J("/", "divide", [De, new Z(ge(de.d))]);
  }
  function pe(de, ge, ye) {
    if (!isIndexNode(ge)) return new q(oe(de), oe(ge));
    if (isArrayNode(de) || isMatrix(de)) {
      for (var De = Array.from(ge.dimensions); De.length > 0; ) if (isConstantNode(De[0]) && typeof De[0].value != "string") {
        var Ce = le(De.shift().value, ye);
        isArrayNode(de) ? de = de.items[Ce - 1] : (de = de.valueOf()[Ce - 1], de instanceof Array && (de = I(de)));
      } else if (De.length > 1 && isConstantNode(De[1]) && typeof De[1].value != "string") {
        var Ie = le(De[1].value, ye), Ne = [], he = isArrayNode(de) ? de.items : de.valueOf();
        for (var ke of he) if (isArrayNode(ke)) Ne.push(ke.items[Ie - 1]);
        else if (isMatrix(de)) Ne.push(ke[Ie - 1]);
        else break;
        if (Ne.length === he.length) de = isArrayNode(de) ? new U(Ne) : I(Ne), De.splice(1, 1);
        else break;
      } else break;
      return De.length === ge.dimensions.length ? new q(oe(de), ge) : De.length > 0 ? (ge = new G(De), new q(oe(de), ge)) : de;
    }
    if (isObjectNode(de) && ge.dimensions.length === 1 && isConstantNode(ge.dimensions[0])) {
      var xe = ge.dimensions[0].value;
      return xe in de.properties ? de.properties[xe] : new Z();
    }
    return new q(oe(de), ge);
  }
  function ve(de, ge, ye, De) {
    var Ce = ge.shift(), Ie = ge.reduce((Ne, he) => {
      if (!isNode(he)) {
        var ke = Ne.pop();
        if (isNode(ke)) return [ke, he];
        try {
          return Ne.push(ae(de, [ke, he], De)), Ne;
        } catch {
          Ne.push(ke);
        }
      }
      return Ne.push(oe(Ne.pop())), [ye([Ne.length === 1 ? Ne[0] : ye(Ne), oe(he)])];
    }, [Ce]);
    return Ie.length === 1 ? Ie[0] : ye([Ie[0], ue(Ie[1])]);
  }
  function _e(de, ge) {
    switch (de.type) {
      case "SymbolNode":
        return de;
      case "ConstantNode":
        switch (typeof de.value) {
          case "number":
            return le(de.value, ge);
          case "bigint":
            return le(de.value, ge);
          case "string":
            return de.value;
          default:
            if (!isNaN(de.value)) return le(de.value, ge);
        }
        return de;
      case "FunctionNode":
        if (F[de.name] && F[de.name].rawArgs) return de;
        if (!["add", "multiply"].includes(de.name)) {
          var ye = de.args.map(($e) => _e($e, ge));
          if (!ye.some(isNode)) try {
            return ae(de.name, ye, ge);
          } catch {
          }
          if (de.name === "size" && ye.length === 1 && isArrayNode(ye[0])) {
            for (var De = [], Ce = ye[0]; isArrayNode(Ce); ) De.push(Ce.items.length), Ce = Ce.items[0];
            return I(De);
          }
          return new V(de.name, ye.map(oe));
        }
      case "OperatorNode":
        var Ie = de.fn.toString(), Ne, he, ke = te(de);
        if (isOperatorNode(de) && de.isUnary()) Ne = [_e(de.args[0], ge)], he = isNode(Ne[0]) ? ke(Ne) : ae(Ie, Ne, ge);
        else if (ee(de, ge.context)) if (Ne = K(de, ge.context), Ne = Ne.map(($e) => _e($e, ge)), Y(Ie, ge.context)) {
          for (var xe = [], Te = [], Fe = 0; Fe < Ne.length; Fe++) isNode(Ne[Fe]) ? Te.push(Ne[Fe]) : xe.push(Ne[Fe]);
          xe.length > 1 ? (he = ve(Ie, xe, ke, ge), Te.unshift(he), he = ve(Ie, Te, ke, ge)) : he = ve(Ie, Ne, ke, ge);
        } else he = ve(Ie, Ne, ke, ge);
        else Ne = de.args.map(($e) => _e($e, ge)), he = ve(Ie, Ne, ke, ge);
        return he;
      case "ParenthesisNode":
        return _e(de.content, ge);
      case "AccessorNode":
        return pe(_e(de.object, ge), _e(de.index, ge), ge);
      case "ArrayNode":
        var be = de.items.map(($e) => _e($e, ge));
        return be.some(isNode) ? new U(be.map(oe)) : I(be);
      case "IndexNode":
        return new G(de.dimensions.map(($e) => ie($e, ge)));
      case "ObjectNode":
        var Ae = {};
        for (var Me in de.properties) Ae[Me] = ie(de.properties[Me], ge);
        return new W(Ae);
      default:
        throw Error(`Unimplemented node type in simplifyConstant: ${de.type}`);
    }
  }
  return ie;
}), name$36 = "simplifyCore", dependencies$36 = ["typed", "parse", "equal", "isZero", "add", "subtract", "multiply", "divide", "pow", "AccessorNode", "ArrayNode", "ConstantNode", "FunctionNode", "IndexNode", "ObjectNode", "OperatorNode", "ParenthesisNode", "SymbolNode"], createSimplifyCore = factory(name$36, dependencies$36, (D) => {
  var { typed: E, parse: O, equal: F, isZero: I, add: z, subtract: R, multiply: L, divide: q, pow: U, AccessorNode: Z, ArrayNode: V, ConstantNode: G, FunctionNode: W, IndexNode: J, ObjectNode: X, OperatorNode: Y, ParenthesisNode: ee, SymbolNode: K } = D, te = new G(0), ie = new G(1), ne = new G(!0), ae = new G(!1);
  function ue(ce) {
    return isOperatorNode(ce) && ["and", "not", "or"].includes(ce.op);
  }
  var { hasProperty: oe, isCommutative: se } = createUtil({ FunctionNode: W, OperatorNode: Y, SymbolNode: K });
  function le(ce) {
    var fe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, pe = fe ? fe.context : void 0;
    if (oe(ce, "trivial", pe)) {
      if (isFunctionNode(ce) && ce.args.length === 1) return le(ce.args[0], fe);
      var ve = !1, _e = 0;
      if (ce.forEach((Te) => {
        ++_e, _e === 1 && (ve = le(Te, fe));
      }), _e === 1) return ve;
    }
    var de = ce;
    if (isFunctionNode(de)) {
      var ge = getOperator(de.name);
      if (ge) {
        if (de.args.length > 2 && oe(de, "associative", pe)) for (; de.args.length > 2; ) {
          var ye = de.args.pop(), De = de.args.pop();
          de.args.push(new Y(ge, de.name, [ye, De]));
        }
        de = new Y(ge, de.name, de.args);
      } else return new W(le(de.fn), de.args.map((Te) => le(Te, fe)));
    }
    if (isOperatorNode(de) && de.isUnary()) {
      var Ce = le(de.args[0], fe);
      if (de.op === "~" && isOperatorNode(Ce) && Ce.isUnary() && Ce.op === "~" || de.op === "not" && isOperatorNode(Ce) && Ce.isUnary() && Ce.op === "not" && ue(Ce.args[0])) return Ce.args[0];
      var Ie = !0;
      if (de.op === "-" && isOperatorNode(Ce) && (Ce.isBinary() && Ce.fn === "subtract" && (de = new Y("-", "subtract", [Ce.args[1], Ce.args[0]]), Ie = !1), Ce.isUnary() && Ce.op === "-")) return Ce.args[0];
      if (Ie) return new Y(de.op, de.fn, [Ce]);
    }
    if (isOperatorNode(de) && de.isBinary()) {
      var Ne = le(de.args[0], fe), he = le(de.args[1], fe);
      if (de.op === "+") {
        if (isConstantNode(Ne) && I(Ne.value)) return he;
        if (isConstantNode(he) && I(he.value)) return Ne;
        isOperatorNode(he) && he.isUnary() && he.op === "-" && (he = he.args[0], de = new Y("-", "subtract", [Ne, he]));
      }
      if (de.op === "-") return isOperatorNode(he) && he.isUnary() && he.op === "-" ? le(new Y("+", "add", [Ne, he.args[0]]), fe) : isConstantNode(Ne) && I(Ne.value) ? le(new Y("-", "unaryMinus", [he])) : isConstantNode(he) && I(he.value) ? Ne : new Y(de.op, de.fn, [Ne, he]);
      if (de.op === "*") {
        if (isConstantNode(Ne)) {
          if (I(Ne.value)) return te;
          if (F(Ne.value, 1)) return he;
        }
        if (isConstantNode(he)) {
          if (I(he.value)) return te;
          if (F(he.value, 1)) return Ne;
          if (se(de, pe)) return new Y(de.op, de.fn, [he, Ne], de.implicit);
        }
        return new Y(de.op, de.fn, [Ne, he], de.implicit);
      }
      if (de.op === "/") return isConstantNode(Ne) && I(Ne.value) ? te : isConstantNode(he) && F(he.value, 1) ? Ne : new Y(de.op, de.fn, [Ne, he]);
      if (de.op === "^" && isConstantNode(he)) {
        if (I(he.value)) return ie;
        if (F(he.value, 1)) return Ne;
      }
      if (de.op === "and") {
        if (isConstantNode(Ne)) if (Ne.value) {
          if (ue(he)) return he;
          if (isConstantNode(he)) return he.value ? ne : ae;
        } else return ae;
        if (isConstantNode(he)) if (he.value) {
          if (ue(Ne)) return Ne;
        } else return ae;
      }
      if (de.op === "or") {
        if (isConstantNode(Ne)) {
          if (Ne.value) return ne;
          if (ue(he)) return he;
        }
        if (isConstantNode(he)) {
          if (he.value) return ne;
          if (ue(Ne)) return Ne;
        }
      }
      return new Y(de.op, de.fn, [Ne, he]);
    }
    if (isOperatorNode(de)) return new Y(de.op, de.fn, de.args.map((Te) => le(Te, fe)));
    if (isArrayNode(de)) return new V(de.items.map((Te) => le(Te, fe)));
    if (isAccessorNode(de)) return new Z(le(de.object, fe), le(de.index, fe));
    if (isIndexNode(de)) return new J(de.dimensions.map((Te) => le(Te, fe)));
    if (isObjectNode(de)) {
      var ke = {};
      for (var xe in de.properties) ke[xe] = le(de.properties[xe], fe);
      return new X(ke);
    }
    return de;
  }
  return E(name$36, { Node: le, "Node,Object": le });
}), name$35 = "resolve", dependencies$35 = ["typed", "parse", "ConstantNode", "FunctionNode", "OperatorNode", "ParenthesisNode"], createResolve = factory(name$35, dependencies$35, (D) => {
  var { typed: E, parse: O, ConstantNode: F, FunctionNode: I, OperatorNode: z, ParenthesisNode: R } = D;
  function L(q, U) {
    var Z = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : /* @__PURE__ */ new Set();
    if (!U) return q;
    if (isSymbolNode(q)) {
      if (Z.has(q.name)) {
        var V = Array.from(Z).join(", ");
        throw ReferenceError(`recursive loop of variable definitions among {${V}}`);
      }
      var G = U.get(q.name);
      if (isNode(G)) {
        var W = new Set(Z);
        return W.add(q.name), L(G, U, W);
      } else return typeof G == "number" ? O(String(G)) : G !== void 0 ? new F(G) : q;
    } else if (isOperatorNode(q)) {
      var J = q.args.map(function(Y) {
        return L(Y, U, Z);
      });
      return new z(q.op, q.fn, J, q.implicit);
    } else {
      if (isParenthesisNode(q)) return new R(L(q.content, U, Z));
      if (isFunctionNode(q)) {
        var X = q.args.map(function(Y) {
          return L(Y, U, Z);
        });
        return new I(q.name, X);
      }
    }
    return q.map((Y) => L(Y, U, Z));
  }
  return E("resolve", { Node: L, "Node, Map | null | undefined": L, "Node, Object": (q, U) => L(q, createMap$1(U)), "Array | Matrix": E.referToSelf((q) => (U) => U.map((Z) => q(Z))), "Array | Matrix, null | undefined": E.referToSelf((q) => (U) => U.map((Z) => q(Z))), "Array, Object": E.referTo("Array,Map", (q) => (U, Z) => q(U, createMap$1(Z))), "Matrix, Object": E.referTo("Matrix,Map", (q) => (U, Z) => q(U, createMap$1(Z))), "Array | Matrix, Map": E.referToSelf((q) => (U, Z) => U.map((V) => q(V, Z))) });
}), name$34 = "symbolicEqual", dependencies$34 = ["parse", "simplify", "typed", "OperatorNode"], createSymbolicEqual = factory(name$34, dependencies$34, (D) => {
  var { parse: E, simplify: O, typed: F, OperatorNode: I } = D;
  function z(R, L) {
    var q = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, U = O(new I("-", "subtract", [R, L]), {}, q);
    return isConstantNode(U) && !U.value;
  }
  return F(name$34, { "Node, Node": z, "Node, Node, Object": z });
}), name$33 = "derivative", dependencies$33 = ["typed", "config", "parse", "simplify", "equal", "isZero", "numeric", "ConstantNode", "FunctionNode", "OperatorNode", "ParenthesisNode", "SymbolNode"], createDerivative = factory(name$33, dependencies$33, (D) => {
  var { typed: E, config: O, parse: F, simplify: I, equal: z, isZero: R, numeric: L, ConstantNode: q, FunctionNode: U, OperatorNode: Z, ParenthesisNode: V, SymbolNode: G } = D;
  function W(ie, ne) {
    var ae = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : { simplify: !0 }, ue = /* @__PURE__ */ new Map(), oe = ne.name;
    function se(ce) {
      var fe = ue.get(ce);
      if (fe !== void 0) return fe;
      var pe = ee(se, ce, oe);
      return ue.set(ce, pe), pe;
    }
    var le = K(ie, se);
    return ae.simplify ? I(le) : le;
  }
  function J(ie) {
    var ne = F(ie);
    if (!ne.isSymbolNode) throw TypeError(`Invalid variable. Cannot parse ${JSON.stringify(ie)} into a variable in function derivative`);
    return ne;
  }
  var X = E(name$33, { "Node, SymbolNode": W, "Node, SymbolNode, Object": W, "Node, string": (ie, ne) => W(ie, J(ne)), "Node, string, Object": (ie, ne, ae) => W(ie, J(ne), ae) });
  X._simplify = !0, X.toTex = function(ie) {
    return Y.apply(null, ie.args);
  };
  var Y = E("_derivTex", { "Node, SymbolNode": function(ie, ne) {
    return isConstantNode(ie) && typeOf(ie.value) === "string" ? Y(F(ie.value).toString(), ne.toString(), 1) : Y(ie.toTex(), ne.toString(), 1);
  }, "Node, ConstantNode": function(ie, ne) {
    if (typeOf(ne.value) === "string") return Y(ie, F(ne.value));
    throw Error("The second parameter to 'derivative' is a non-string constant");
  }, "Node, SymbolNode, ConstantNode": function(ie, ne, ae) {
    return Y(ie.toString(), ne.name, ae.value);
  }, "string, string, number": function(ie, ne, ae) {
    return (ae === 1 ? "{d\\over d" + ne + "}" : "{d^{" + ae + "}\\over d" + ne + "^{" + ae + "}}") + `\\left[${ie}\\right]`;
  } }), ee = E("_isConst", { "function, ConstantNode, string": function() {
    return !0;
  }, "function, SymbolNode, string": function(ie, ne, ae) {
    return ne.name !== ae;
  }, "function, ParenthesisNode, string": function(ie, ne, ae) {
    return ie(ne.content, ae);
  }, "function, FunctionAssignmentNode, string": function(ie, ne, ae) {
    return ne.params.includes(ae) ? ie(ne.expr, ae) : !0;
  }, "function, FunctionNode | OperatorNode, string": function(ie, ne, ae) {
    return ne.args.every((ue) => ie(ue, ae));
  } }), K = E("_derivative", { "ConstantNode, function": function() {
    return te(0);
  }, "SymbolNode, function": function(ie, ne) {
    return ne(ie) ? te(0) : te(1);
  }, "ParenthesisNode, function": function(ie, ne) {
    return new V(K(ie.content, ne));
  }, "FunctionAssignmentNode, function": function(ie, ne) {
    return ne(ie) ? te(0) : K(ie.expr, ne);
  }, "FunctionNode, function": function(ie, ne) {
    if (ne(ie)) return te(0);
    var ae = ie.args[0], ue, oe = !1, se = !1, le;
    switch (ie.name) {
      case "cbrt":
        oe = !0, le = new Z("*", "multiply", [te(3), new Z("^", "pow", [ae, new Z("/", "divide", [te(2), te(3)])])]);
        break;
      case "sqrt":
      case "nthRoot":
        if (ie.args.length === 1) oe = !0, le = new Z("*", "multiply", [te(2), new U("sqrt", [ae])]);
        else if (ie.args.length === 2) return ue = new Z("/", "divide", [te(1), ie.args[1]]), K(new Z("^", "pow", [ae, ue]), ne);
        break;
      case "log10":
        ue = te(10);
      case "log":
        if (!ue && ie.args.length === 1) le = ae.clone(), oe = !0;
        else if (ie.args.length === 1 && ue || ie.args.length === 2 && ne(ie.args[1])) le = new Z("*", "multiply", [ae.clone(), new U("log", [ue || ie.args[1]])]), oe = !0;
        else if (ie.args.length === 2) return K(new Z("/", "divide", [new U("log", [ae]), new U("log", [ie.args[1]])]), ne);
        break;
      case "pow":
        if (ie.args.length === 2) return K(new Z("^", "pow", [ae, ie.args[1]]), ne);
        break;
      case "exp":
        le = new U("exp", [ae.clone()]);
        break;
      case "sin":
        le = new U("cos", [ae.clone()]);
        break;
      case "cos":
        le = new Z("-", "unaryMinus", [new U("sin", [ae.clone()])]);
        break;
      case "tan":
        le = new Z("^", "pow", [new U("sec", [ae.clone()]), te(2)]);
        break;
      case "sec":
        le = new Z("*", "multiply", [ie, new U("tan", [ae.clone()])]);
        break;
      case "csc":
        se = !0, le = new Z("*", "multiply", [ie, new U("cot", [ae.clone()])]);
        break;
      case "cot":
        se = !0, le = new Z("^", "pow", [new U("csc", [ae.clone()]), te(2)]);
        break;
      case "asin":
        oe = !0, le = new U("sqrt", [new Z("-", "subtract", [te(1), new Z("^", "pow", [ae.clone(), te(2)])])]);
        break;
      case "acos":
        oe = !0, se = !0, le = new U("sqrt", [new Z("-", "subtract", [te(1), new Z("^", "pow", [ae.clone(), te(2)])])]);
        break;
      case "atan":
        oe = !0, le = new Z("+", "add", [new Z("^", "pow", [ae.clone(), te(2)]), te(1)]);
        break;
      case "asec":
        oe = !0, le = new Z("*", "multiply", [new U("abs", [ae.clone()]), new U("sqrt", [new Z("-", "subtract", [new Z("^", "pow", [ae.clone(), te(2)]), te(1)])])]);
        break;
      case "acsc":
        oe = !0, se = !0, le = new Z("*", "multiply", [new U("abs", [ae.clone()]), new U("sqrt", [new Z("-", "subtract", [new Z("^", "pow", [ae.clone(), te(2)]), te(1)])])]);
        break;
      case "acot":
        oe = !0, se = !0, le = new Z("+", "add", [new Z("^", "pow", [ae.clone(), te(2)]), te(1)]);
        break;
      case "sinh":
        le = new U("cosh", [ae.clone()]);
        break;
      case "cosh":
        le = new U("sinh", [ae.clone()]);
        break;
      case "tanh":
        le = new Z("^", "pow", [new U("sech", [ae.clone()]), te(2)]);
        break;
      case "sech":
        se = !0, le = new Z("*", "multiply", [ie, new U("tanh", [ae.clone()])]);
        break;
      case "csch":
        se = !0, le = new Z("*", "multiply", [ie, new U("coth", [ae.clone()])]);
        break;
      case "coth":
        se = !0, le = new Z("^", "pow", [new U("csch", [ae.clone()]), te(2)]);
        break;
      case "asinh":
        oe = !0, le = new U("sqrt", [new Z("+", "add", [new Z("^", "pow", [ae.clone(), te(2)]), te(1)])]);
        break;
      case "acosh":
        oe = !0, le = new U("sqrt", [new Z("-", "subtract", [new Z("^", "pow", [ae.clone(), te(2)]), te(1)])]);
        break;
      case "atanh":
        oe = !0, le = new Z("-", "subtract", [te(1), new Z("^", "pow", [ae.clone(), te(2)])]);
        break;
      case "asech":
        oe = !0, se = !0, le = new Z("*", "multiply", [ae.clone(), new U("sqrt", [new Z("-", "subtract", [te(1), new Z("^", "pow", [ae.clone(), te(2)])])])]);
        break;
      case "acsch":
        oe = !0, se = !0, le = new Z("*", "multiply", [new U("abs", [ae.clone()]), new U("sqrt", [new Z("+", "add", [new Z("^", "pow", [ae.clone(), te(2)]), te(1)])])]);
        break;
      case "acoth":
        oe = !0, se = !0, le = new Z("-", "subtract", [te(1), new Z("^", "pow", [ae.clone(), te(2)])]);
        break;
      case "abs":
        le = new Z("/", "divide", [new U(new G("abs"), [ae.clone()]), ae.clone()]);
        break;
      default:
        throw Error('Cannot process function "' + ie.name + '" in derivative: the function is not supported, undefined, or the number of arguments passed to it are not supported');
    }
    var ce, fe;
    oe ? (ce = "/", fe = "divide") : (ce = "*", fe = "multiply");
    var pe = K(ae, ne);
    return se && (pe = new Z("-", "unaryMinus", [pe])), new Z(ce, fe, [pe, le]);
  }, "OperatorNode, function": function(ie, ne) {
    if (ne(ie)) return te(0);
    if (ie.op === "+") return new Z(ie.op, ie.fn, ie.args.map(function(ve) {
      return K(ve, ne);
    }));
    if (ie.op === "-") {
      if (ie.isUnary()) return new Z(ie.op, ie.fn, [K(ie.args[0], ne)]);
      if (ie.isBinary()) return new Z(ie.op, ie.fn, [K(ie.args[0], ne), K(ie.args[1], ne)]);
    }
    if (ie.op === "*") {
      var ae = ie.args.filter(function(ve) {
        return ne(ve);
      });
      if (ae.length > 0) {
        var ue = ie.args.filter(function(ve) {
          return !ne(ve);
        }), oe = ue.length === 1 ? ue[0] : new Z("*", "multiply", ue);
        return new Z("*", "multiply", ae.concat(K(oe, ne)));
      }
      return new Z("+", "add", ie.args.map(function(ve) {
        return new Z("*", "multiply", ie.args.map(function(_e) {
          return _e === ve ? K(_e, ne) : _e.clone();
        }));
      }));
    }
    if (ie.op === "/" && ie.isBinary()) {
      var se = ie.args[0], le = ie.args[1];
      return ne(le) ? new Z("/", "divide", [K(se, ne), le]) : ne(se) ? new Z("*", "multiply", [new Z("-", "unaryMinus", [se]), new Z("/", "divide", [K(le, ne), new Z("^", "pow", [le.clone(), te(2)])])]) : new Z("/", "divide", [new Z("-", "subtract", [new Z("*", "multiply", [K(se, ne), le.clone()]), new Z("*", "multiply", [se.clone(), K(le, ne)])]), new Z("^", "pow", [le.clone(), te(2)])]);
    }
    if (ie.op === "^" && ie.isBinary()) {
      var ce = ie.args[0], fe = ie.args[1];
      if (ne(ce)) return isConstantNode(ce) && (R(ce.value) || z(ce.value, 1)) ? te(0) : new Z("*", "multiply", [ie, new Z("*", "multiply", [new U("log", [ce.clone()]), K(fe.clone(), ne)])]);
      if (ne(fe)) {
        if (isConstantNode(fe)) {
          if (R(fe.value)) return te(0);
          if (z(fe.value, 1)) return K(ce, ne);
        }
        var pe = new Z("^", "pow", [ce.clone(), new Z("-", "subtract", [fe, te(1)])]);
        return new Z("*", "multiply", [fe.clone(), new Z("*", "multiply", [K(ce, ne), pe])]);
      }
      return new Z("*", "multiply", [new Z("^", "pow", [ce.clone(), fe.clone()]), new Z("+", "add", [new Z("*", "multiply", [K(ce, ne), new Z("/", "divide", [fe.clone(), ce.clone()])]), new Z("*", "multiply", [K(fe, ne), new U("log", [ce.clone()])])])]);
    }
    throw Error('Cannot process operator "' + ie.op + '" in derivative: the operator is not supported, undefined, or the number of arguments passed to it are not supported');
  } });
  function te(ie, ne) {
    return new q(L(ie, safeNumberType(String(ie), O)));
  }
  return X;
}), name$32 = "rationalize", dependencies$32 = "config.typed.equal.isZero.add.subtract.multiply.divide.pow.parse.simplifyConstant.simplifyCore.simplify.?bignumber.?fraction.mathWithTransform.matrix.AccessorNode.ArrayNode.ConstantNode.FunctionNode.IndexNode.ObjectNode.OperatorNode.SymbolNode.ParenthesisNode".split("."), createRationalize = factory(name$32, dependencies$32, (D) => {
  var { config: E, typed: O, equal: F, isZero: I, add: z, subtract: R, multiply: L, divide: q, pow: U, parse: Z, simplifyConstant: V, simplifyCore: G, simplify: W, fraction: J, bignumber: X, mathWithTransform: Y, matrix: ee, AccessorNode: K, ArrayNode: te, ConstantNode: ie, FunctionNode: ne, IndexNode: ae, ObjectNode: ue, OperatorNode: oe, SymbolNode: se, ParenthesisNode: le } = D;
  function ce(de) {
    var ge = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, ye = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, De = pe(), Ce = fe(de, ge, !0, De.firstRules), Ie = Ce.variables.length, Ne = { exactFractions: !1 }, he = { exactFractions: !0 };
    if (de = Ce.expression, Ie >= 1) {
      de = ve(de);
      var ke, xe, Te = !0, Fe = !1;
      de = W(de, De.firstRules, {}, Ne);
      for (var be; xe = Te ? De.distrDivRules : De.sucDivRules, de = W(de, xe, {}, he), Te = !Te, be = de.toString(), be !== ke; ) Fe = !0, ke = be;
      Fe && (de = W(de, De.firstRulesAgain, {}, Ne)), de = W(de, De.finalRules, {}, Ne);
    }
    var Ae = [], Me = {};
    return de.type === "OperatorNode" && de.isBinary() && de.op === "/" ? (Ie === 1 && (de.args[0] = _e(de.args[0], Ae), de.args[1] = _e(de.args[1])), ye && (Me.numerator = de.args[0], Me.denominator = de.args[1])) : (Ie === 1 && (de = _e(de, Ae)), ye && (Me.numerator = de, Me.denominator = null)), ye ? (Me.coefficients = Ae, Me.variables = Ce.variables, Me.expression = de, Me) : de;
  }
  return O(name$32, { Node: ce, "Node, boolean": (de, ge) => ce(de, {}, ge), "Node, Object": ce, "Node, Object, boolean": ce });
  function fe(de, ge, ye, De) {
    var Ce = [], Ie = W(de, De, ge, { exactFractions: !1 });
    ye = !!ye;
    var Ne = "+-*" + (ye ? "/" : "");
    ke(Ie);
    var he = {};
    return he.expression = Ie, he.variables = Ce, he;
    function ke(xe) {
      var Te = xe.type;
      if (Te === "FunctionNode") throw Error("There is an unsolved function call");
      if (Te === "OperatorNode") if (xe.op === "^") {
        if (xe.args[1].type !== "ConstantNode" || !isInteger(parseFloat(xe.args[1].value))) throw Error("There is a non-integer exponent");
        ke(xe.args[0]);
      } else {
        if (!Ne.includes(xe.op)) throw Error("Operator " + xe.op + " invalid in polynomial expression");
        for (var Fe = 0; Fe < xe.args.length; Fe++) ke(xe.args[Fe]);
      }
      else if (Te === "SymbolNode") {
        var be = xe.name;
        Ce.indexOf(be) === -1 && Ce.push(be);
      } else if (Te === "ParenthesisNode") ke(xe.content);
      else if (Te !== "ConstantNode") throw Error("type " + Te + " is not allowed in polynomial expression");
    }
  }
  function pe() {
    var de = [G, { l: "n+n", r: "2*n" }, { l: "n+-n", r: "0" }, V, { l: "n*(n1^-1)", r: "n/n1" }, { l: "n*n1^-n2", r: "n/n1^n2" }, { l: "n1^-1", r: "1/n1" }, { l: "n*(n1/n2)", r: "(n*n1)/n2" }, { l: "1*n", r: "n" }], ge = [{ l: "(-n1)/(-n2)", r: "n1/n2" }, { l: "(-n1)*(-n2)", r: "n1*n2" }, { l: "n1--n2", r: "n1+n2" }, { l: "n1-n2", r: "n1+(-n2)" }, { l: "(n1+n2)*n3", r: "(n1*n3 + n2*n3)" }, { l: "n1*(n2+n3)", r: "(n1*n2+n1*n3)" }, { l: "c1*n + c2*n", r: "(c1+c2)*n" }, { l: "c1*n + n", r: "(c1+1)*n" }, { l: "c1*n - c2*n", r: "(c1-c2)*n" }, { l: "c1*n - n", r: "(c1-1)*n" }, { l: "v/c", r: "(1/c)*v" }, { l: "v/-c", r: "-(1/c)*v" }, { l: "-v*-c", r: "c*v" }, { l: "-v*c", r: "-c*v" }, { l: "v*-c", r: "-c*v" }, { l: "v*c", r: "c*v" }, { l: "-(-n1*n2)", r: "(n1*n2)" }, { l: "-(n1*n2)", r: "(-n1*n2)" }, { l: "-(-n1+n2)", r: "(n1-n2)" }, { l: "-(n1+n2)", r: "(-n1-n2)" }, { l: "(n1^n2)^n3", r: "(n1^(n2*n3))" }, { l: "-(-n1/n2)", r: "(n1/n2)" }, { l: "-(n1/n2)", r: "(-n1/n2)" }], ye = [{ l: "(n1/n2 + n3/n4)", r: "((n1*n4 + n3*n2)/(n2*n4))" }, { l: "(n1/n2 + n3)", r: "((n1 + n3*n2)/n2)" }, { l: "(n1 + n2/n3)", r: "((n1*n3 + n2)/n3)" }], De = [{ l: "(n1/(n2/n3))", r: "((n1*n3)/n2)" }, { l: "(n1/n2/n3)", r: "(n1/(n2*n3))" }], Ce = {};
    return Ce.firstRules = de.concat(ge, De), Ce.distrDivRules = ye, Ce.sucDivRules = De, Ce.firstRulesAgain = de.concat(ge), Ce.finalRules = [G, { l: "n*-n", r: "-n^2" }, { l: "n*n", r: "n^2" }, V, { l: "n*-n^n1", r: "-n^(n1+1)" }, { l: "n*n^n1", r: "n^(n1+1)" }, { l: "n^n1*-n^n2", r: "-n^(n1+n2)" }, { l: "n^n1*n^n2", r: "n^(n1+n2)" }, { l: "n^n1*-n", r: "-n^(n1+1)" }, { l: "n^n1*n", r: "n^(n1+1)" }, { l: "n^n1/-n", r: "-n^(n1-1)" }, { l: "n^n1/n", r: "n^(n1-1)" }, { l: "n/-n^n1", r: "-n^(1-n1)" }, { l: "n/n^n1", r: "n^(1-n1)" }, { l: "n^n1/-n^n2", r: "n^(n1-n2)" }, { l: "n^n1/n^n2", r: "n^(n1-n2)" }, { l: "n1+(-n2*n3)", r: "n1-n2*n3" }, { l: "v*(-c)", r: "-c*v" }, { l: "n1+-n2", r: "n1-n2" }, { l: "v*c", r: "c*v" }, { l: "(n1^n2)^n3", r: "(n1^(n2*n3))" }], Ce;
  }
  function ve(de, ge, ye) {
    var De = de.type, Ce = arguments.length > 1;
    if (De === "OperatorNode" && de.isBinary()) {
      var Ie = !1, Ne;
      if (de.op === "^" && (de.args[0].type === "ParenthesisNode" || de.args[0].type === "OperatorNode") && de.args[1].type === "ConstantNode" && (Ne = parseFloat(de.args[1].value), Ie = Ne >= 2 && isInteger(Ne)), Ie) {
        if (Ne > 2) {
          var he = de.args[0];
          de = new oe("*", "multiply", [he, new oe("^", "pow", [de.args[0].cloneDeep(), new ie(Ne - 1)])]);
        } else de = new oe("*", "multiply", [de.args[0], de.args[0].cloneDeep()]);
        Ce && (ye === "content" ? ge.content = de : ge.args[ye] = de);
      }
    }
    if (De === "ParenthesisNode") ve(de.content, de, "content");
    else if (De !== "ConstantNode" && De !== "SymbolNode") for (var ke = 0; ke < de.args.length; ke++) ve(de.args[ke], de, ke);
    if (!Ce) return de;
  }
  function _e(de, ge) {
    ge === void 0 && (ge = []), ge[0] = 0;
    var ye = {};
    ye.cte = 1, ye.oper = "+", ye.fire = "";
    var De = 0, Ce = "";
    be(de, null, ye), De = ge.length - 1;
    for (var Ie = !0, Ne, he = De; he >= 0; he--) if (ge[he] !== 0) {
      var ke = new ie(Ie ? ge[he] : Math.abs(ge[he])), xe = ge[he] < 0 ? "-" : "+";
      if (he > 0) {
        var Te = new se(Ce);
        if (he > 1) {
          var Fe = new ie(he);
          Te = new oe("^", "pow", [Te, Fe]);
        }
        ke = ge[he] === -1 && Ie ? new oe("-", "unaryMinus", [Te]) : Math.abs(ge[he]) === 1 ? Te : new oe("*", "multiply", [ke, Te]);
      }
      Ne = Ie ? ke : xe === "+" ? new oe("+", "add", [Ne, ke]) : new oe("-", "subtract", [Ne, ke]), Ie = !1;
    }
    if (Ie) return new ie(0);
    return Ne;
    function be(Ae, Me, $e) {
      var Re = Ae.type;
      if (Re === "FunctionNode") throw Error("There is an unsolved function call");
      if (Re === "OperatorNode") {
        if (!"+-*^".includes(Ae.op)) throw Error("Operator " + Ae.op + " invalid");
        if (Me !== null && ((Ae.fn === "unaryMinus" || Ae.fn === "pow") && Me.fn !== "add" && Me.fn !== "subtract" && Me.fn !== "multiply" || (Ae.fn === "subtract" || Ae.fn === "add" || Ae.fn === "multiply") && Me.fn !== "add" && Me.fn !== "subtract" || (Ae.fn === "subtract" || Ae.fn === "add" || Ae.fn === "unaryMinus") && $e.noFil !== 0)) throw Error("Invalid " + Ae.op + " placing");
        (Ae.op === "^" || Ae.op === "*") && ($e.fire = Ae.op);
        for (var je = 0; je < Ae.args.length; je++) Ae.fn === "unaryMinus" && ($e.oper = "-"), (Ae.op === "+" || Ae.fn === "subtract") && ($e.fire = "", $e.cte = 1, $e.oper = je === 0 ? "+" : Ae.op), $e.noFil = je, be(Ae.args[je], Ae, $e);
      } else if (Re === "SymbolNode") {
        if (Ae.name !== Ce && Ce !== "") throw Error("There is more than one variable");
        if (Ce = Ae.name, Me === null) {
          ge[1] = 1;
          return;
        }
        if (Me.op === "^" && $e.noFil !== 0) throw Error("In power the variable should be the first parameter");
        if (Me.op === "*" && $e.noFil !== 1) throw Error("In multiply the variable should be the second parameter");
        ($e.fire === "" || $e.fire === "*") && (De < 1 && (ge[1] = 0), ge[1] += $e.cte * ($e.oper === "+" ? 1 : -1), De = Math.max(1, De));
      } else if (Re === "ConstantNode") {
        var Pe = parseFloat(Ae.value);
        if (Me === null) {
          ge[0] = Pe;
          return;
        }
        if (Me.op === "^") {
          if ($e.noFil !== 1) throw Error("Constant cannot be powered");
          if (!isInteger(Pe) || Pe <= 0) throw Error("Non-integer exponent is not allowed");
          for (var Ke = De + 1; Ke < Pe; Ke++) ge[Ke] = 0;
          Pe > De && (ge[Pe] = 0), ge[Pe] += $e.cte * ($e.oper === "+" ? 1 : -1), De = Math.max(Pe, De);
          return;
        }
        $e.cte = Pe, $e.fire === "" && (ge[0] += $e.cte * ($e.oper === "+" ? 1 : -1));
      } else throw Error("Type " + Re + " is not allowed");
    }
  }
}), name$31 = "zpk2tf", dependencies$31 = ["typed", "add", "multiply", "Complex", "number"], createZpk2tf = factory(name$31, dependencies$31, (D) => {
  var { typed: E, add: O, multiply: F, Complex: I, number: z } = D;
  return E(name$31, { "Array,Array,number": function(q, U, Z) {
    return R(q, U, Z);
  }, "Array,Array": function(q, U) {
    return R(q, U, 1);
  }, "Matrix,Matrix,number": function(q, U, Z) {
    return R(q.valueOf(), U.valueOf(), Z);
  }, "Matrix,Matrix": function(q, U) {
    return R(q.valueOf(), U.valueOf(), 1);
  } });
  function R(q, U, Z) {
    q.some((K) => K.type === "BigNumber") && (q = q.map((K) => z(K))), U.some((K) => K.type === "BigNumber") && (U = U.map((K) => z(K)));
    for (var V = [I(1, 0)], G = [I(1, 0)], W = 0; W < q.length; W++) {
      var J = q[W];
      typeof J == "number" && (J = I(J, 0)), V = L(V, [I(1, 0), I(-J.re, -J.im)]);
    }
    for (var X = 0; X < U.length; X++) {
      var Y = U[X];
      typeof Y == "number" && (Y = I(Y, 0)), G = L(G, [I(1, 0), I(-Y.re, -Y.im)]);
    }
    for (var ee = 0; ee < V.length; ee++) V[ee] = F(V[ee], Z);
    return [V, G];
  }
  function L(q, U) {
    for (var Z = [], V = 0; V < q.length + U.length - 1; V++) {
      Z[V] = I(0, 0);
      for (var G = 0; G < q.length; G++) V - G >= 0 && V - G < U.length && (Z[V] = O(Z[V], F(q[G], U[V - G])));
    }
    return Z;
  }
}), name$30 = "freqz", dependencies$30 = ["typed", "add", "multiply", "Complex", "divide", "matrix"], createFreqz = factory(name$30, dependencies$30, (D) => {
  var { typed: E, add: O, multiply: F, Complex: I, divide: z, matrix: R } = D;
  return E(name$30, { "Array, Array": function(U, Z) {
    return L(U, Z, q(512));
  }, "Array, Array, Array": function(U, Z, V) {
    return L(U, Z, V);
  }, "Array, Array, number": function(U, Z, V) {
    if (V < 0) throw Error("w must be a positive number");
    return L(U, Z, q(V));
  }, "Matrix, Matrix": function(U, Z) {
    var V = q(512), { w: G, h: W } = L(U.valueOf(), Z.valueOf(), V);
    return { w: R(G), h: R(W) };
  }, "Matrix, Matrix, Matrix": function(U, Z, V) {
    var { h: G } = L(U.valueOf(), Z.valueOf(), V.valueOf());
    return { h: R(G), w: R(V) };
  }, "Matrix, Matrix, number": function(U, Z, V) {
    if (V < 0) throw Error("w must be a positive number");
    var G = q(V), { h: W } = L(U.valueOf(), Z.valueOf(), G);
    return { h: R(W), w: R(G) };
  } });
  function L(U, Z, V) {
    for (var G = [], W = [], J = 0; J < V.length; J++) {
      for (var X = I(0, 0), Y = I(0, 0), ee = 0; ee < U.length; ee++) X = O(X, F(U[ee], I(Math.cos(-ee * V[J]), Math.sin(-ee * V[J]))));
      for (var K = 0; K < Z.length; K++) Y = O(Y, F(Z[K], I(Math.cos(-K * V[J]), Math.sin(-K * V[J]))));
      G.push(X), W.push(Y);
    }
    for (var te = [], ie = 0; ie < G.length; ie++) te.push(z(G[ie], W[ie]));
    return { h: te, w: V };
  }
  function q(U) {
    for (var Z = [], V = 0; V < U; V++) Z.push(V / U * Math.PI);
    return Z;
  }
}), name$29 = "reviver", dependencies$29 = ["classes"], createReviver = factory(name$29, dependencies$29, (D) => {
  var { classes: E } = D;
  return function(O, F) {
    var I = E[F && F.mathjs];
    return I && typeof I.fromJSON == "function" ? I.fromJSON(F) : F;
  };
}), name$28 = "replacer", dependencies$28 = [], createReplacer = factory(name$28, dependencies$28, () => function(D, E) {
  return typeof E == "number" && (!Number.isFinite(E) || isNaN(E)) ? { mathjs: "number", value: String(E) } : typeof E == "bigint" ? { mathjs: "bigint", value: String(E) } : E;
}), version = "15.2.0", createTrue = factory("true", [], () => !0), createFalse = factory("false", [], () => !1), createNull = factory("null", [], () => null), createInfinity = recreateFactory("Infinity", ["config", "?BigNumber"], (D) => {
  var { config: E, BigNumber: O } = D;
  return E.number === "BigNumber" ? new O(1 / 0) : 1 / 0;
}), createNaN = recreateFactory("NaN", ["config", "?BigNumber"], (D) => {
  var { config: E, BigNumber: O } = D;
  return E.number === "BigNumber" ? new O(NaN) : NaN;
}), createPi = recreateFactory("pi", ["config", "?BigNumber"], (D) => {
  var { config: E, BigNumber: O } = D;
  return E.number === "BigNumber" ? createBigNumberPi(O) : pi;
}), createTau = recreateFactory("tau", ["config", "?BigNumber"], (D) => {
  var { config: E, BigNumber: O } = D;
  return E.number === "BigNumber" ? createBigNumberTau(O) : tau;
}), createE = recreateFactory("e", ["config", "?BigNumber"], (D) => {
  var { config: E, BigNumber: O } = D;
  return E.number === "BigNumber" ? createBigNumberE(O) : e$1;
}), createPhi = recreateFactory("phi", ["config", "?BigNumber"], (D) => {
  var { config: E, BigNumber: O } = D;
  return E.number === "BigNumber" ? createBigNumberPhi(O) : phi;
}), createLN2 = recreateFactory("LN2", ["config", "?BigNumber"], (D) => {
  var { config: E, BigNumber: O } = D;
  return E.number === "BigNumber" ? new O(2).ln() : Math.LN2;
}), createLN10 = recreateFactory("LN10", ["config", "?BigNumber"], (D) => {
  var { config: E, BigNumber: O } = D;
  return E.number === "BigNumber" ? new O(10).ln() : Math.LN10;
}), createLOG2E = recreateFactory("LOG2E", ["config", "?BigNumber"], (D) => {
  var { config: E, BigNumber: O } = D;
  return E.number === "BigNumber" ? new O(1).div(new O(2).ln()) : Math.LOG2E;
}), createLOG10E = recreateFactory("LOG10E", ["config", "?BigNumber"], (D) => {
  var { config: E, BigNumber: O } = D;
  return E.number === "BigNumber" ? new O(1).div(new O(10).ln()) : Math.LOG10E;
}), createSQRT1_2 = recreateFactory("SQRT1_2", ["config", "?BigNumber"], (D) => {
  var { config: E, BigNumber: O } = D;
  return E.number === "BigNumber" ? new O("0.5").sqrt() : Math.SQRT1_2;
}), createSQRT2 = recreateFactory("SQRT2", ["config", "?BigNumber"], (D) => {
  var { config: E, BigNumber: O } = D;
  return E.number === "BigNumber" ? new O(2).sqrt() : Math.SQRT2;
}), createI = recreateFactory("i", ["Complex"], (D) => {
  var { Complex: E } = D;
  return E.I;
}), createUppercasePi = factory("PI", ["pi"], (D) => {
  var { pi: E } = D;
  return E;
}), createUppercaseE = factory("E", ["e"], (D) => {
  var { e: E } = D;
  return E;
}), createVersion = factory("version", [], () => version);
function recreateFactory(D, E, O) {
  return factory(D, E, O, { recreateOnConfigChange: !0 });
}
var createSpeedOfLight = unitFactory("speedOfLight", "299792458", "m s^-1"), createGravitationConstant = unitFactory("gravitationConstant", "6.67430e-11", "m^3 kg^-1 s^-2"), createPlanckConstant = unitFactory("planckConstant", "6.62607015e-34", "J s"), createReducedPlanckConstant = unitFactory("reducedPlanckConstant", "1.0545718176461565e-34", "J s"), createMagneticConstant = unitFactory("magneticConstant", "1.25663706212e-6", "N A^-2"), createElectricConstant = unitFactory("electricConstant", "8.8541878128e-12", "F m^-1"), createVacuumImpedance = unitFactory("vacuumImpedance", "376.730313667", "ohm"), createCoulomb = unitFactory("coulomb", "8.987551792261171e9", "N m^2 C^-2"), createCoulombConstant = unitFactory("coulombConstant", "8.987551792261171e9", "N m^2 C^-2"), createElementaryCharge = unitFactory("elementaryCharge", "1.602176634e-19", "C"), createBohrMagneton = unitFactory("bohrMagneton", "9.2740100783e-24", "J T^-1"), createConductanceQuantum = unitFactory("conductanceQuantum", "7.748091729863649e-5", "S"), createInverseConductanceQuantum = unitFactory("inverseConductanceQuantum", "12906.403729652257", "ohm"), createMagneticFluxQuantum = unitFactory("magneticFluxQuantum", "2.0678338484619295e-15", "Wb"), createNuclearMagneton = unitFactory("nuclearMagneton", "5.0507837461e-27", "J T^-1"), createKlitzing = unitFactory("klitzing", "25812.807459304513", "ohm"), createBohrRadius = unitFactory("bohrRadius", "5.29177210903e-11", "m"), createClassicalElectronRadius = unitFactory("classicalElectronRadius", "2.8179403262e-15", "m"), createElectronMass = unitFactory("electronMass", "9.1093837015e-31", "kg"), createFermiCoupling = unitFactory("fermiCoupling", "1.1663787e-5", "GeV^-2"), createFineStructure = numberFactory("fineStructure", 0.0072973525693), createHartreeEnergy = unitFactory("hartreeEnergy", "4.3597447222071e-18", "J"), createProtonMass = unitFactory("protonMass", "1.67262192369e-27", "kg"), createDeuteronMass = unitFactory("deuteronMass", "3.3435830926e-27", "kg"), createNeutronMass = unitFactory("neutronMass", "1.6749271613e-27", "kg"), createQuantumOfCirculation = unitFactory("quantumOfCirculation", "3.6369475516e-4", "m^2 s^-1"), createRydberg = unitFactory("rydberg", "10973731.568160", "m^-1"), createThomsonCrossSection = unitFactory("thomsonCrossSection", "6.6524587321e-29", "m^2"), createWeakMixingAngle = numberFactory("weakMixingAngle", 0.2229), createEfimovFactor = numberFactory("efimovFactor", 22.7), createAtomicMass = unitFactory("atomicMass", "1.66053906660e-27", "kg"), createAvogadro = unitFactory("avogadro", "6.02214076e23", "mol^-1"), createBoltzmann = unitFactory("boltzmann", "1.380649e-23", "J K^-1"), createFaraday = unitFactory("faraday", "96485.33212331001", "C mol^-1"), createFirstRadiation = unitFactory("firstRadiation", "3.7417718521927573e-16", "W m^2"), createLoschmidt = unitFactory("loschmidt", "2.686780111798444e25", "m^-3"), createGasConstant = unitFactory("gasConstant", "8.31446261815324", "J K^-1 mol^-1"), createMolarPlanckConstant = unitFactory("molarPlanckConstant", "3.990312712893431e-10", "J s mol^-1"), createMolarVolume = unitFactory("molarVolume", "0.022413969545014137", "m^3 mol^-1"), createSackurTetrode = numberFactory("sackurTetrode", -1.16487052358), createSecondRadiation = unitFactory("secondRadiation", "0.014387768775039337", "m K"), createStefanBoltzmann = unitFactory("stefanBoltzmann", "5.67037441918443e-8", "W m^-2 K^-4"), createWienDisplacement = unitFactory("wienDisplacement", "2.897771955e-3", "m K"), createMolarMass = unitFactory("molarMass", "0.99999999965e-3", "kg mol^-1"), createMolarMassC12 = unitFactory("molarMassC12", "11.9999999958e-3", "kg mol^-1"), createGravity = unitFactory("gravity", "9.80665", "m s^-2"), createPlanckLength = unitFactory("planckLength", "1.616255e-35", "m"), createPlanckMass = unitFactory("planckMass", "2.176435e-8", "kg"), createPlanckTime = unitFactory("planckTime", "5.391245e-44", "s"), createPlanckCharge = unitFactory("planckCharge", "1.87554603778e-18", "C"), createPlanckTemperature = unitFactory("planckTemperature", "1.416785e+32", "K");
function unitFactory(D, E, O) {
  return factory(D, ["config", "Unit", "BigNumber"], (F) => {
    var { config: I, Unit: z, BigNumber: R } = F, L = new z(I.number === "BigNumber" ? new R(E) : parseFloat(E), O);
    return L.fixPrefix = !0, L;
  });
}
function numberFactory(D, E) {
  return factory(D, ["config", "BigNumber"], (O) => {
    var { config: F, BigNumber: I } = O;
    return F.number === "BigNumber" ? new I(E) : E;
  });
}
function ownKeys(D, E) {
  var O = Object.keys(D);
  if (Object.getOwnPropertySymbols) {
    var F = Object.getOwnPropertySymbols(D);
    E && (F = F.filter(function(I) {
      return Object.getOwnPropertyDescriptor(D, I).enumerable;
    })), O.push.apply(O, F);
  }
  return O;
}
function _objectSpread(D) {
  for (var E = 1; E < arguments.length; E++) {
    var O = arguments[E] == null ? {} : arguments[E];
    E % 2 ? ownKeys(Object(O), !0).forEach(function(F) {
      _defineProperty(D, F, O[F]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(D, Object.getOwnPropertyDescriptors(O)) : ownKeys(Object(O)).forEach(function(F) {
      Object.defineProperty(D, F, Object.getOwnPropertyDescriptor(O, F));
    });
  }
  return D;
}
var name$27 = "mapSlices", dependencies$27 = ["typed", "isInteger"], createMapSlicesTransform = factory(name$27, dependencies$27, (D) => {
  var { typed: E, isInteger: O } = D, F = createMapSlices({ typed: E, isInteger: O });
  return E("mapSlices", { "...any": function(I) {
    var z = I[1];
    isNumber(z) ? I[1] = z - 1 : isBigNumber(z) && (I[1] = z.minus(1));
    try {
      return F.apply(null, I);
    } catch (R) {
      throw errorTransform(R);
    }
  } });
}, _objectSpread({ isTransformFunction: !0 }, createMapSlices.meta)), name$26 = "column", dependencies$26 = ["typed", "Index", "matrix", "range"], createColumnTransform = factory(name$26, dependencies$26, (D) => {
  var { typed: E, Index: O, matrix: F, range: I } = D, z = createColumn({ typed: E, Index: O, matrix: F, range: I });
  return E("column", { "...any": function(R) {
    var L = R.length - 1, q = R[L];
    isNumber(q) && (R[L] = q - 1);
    try {
      return z.apply(null, R);
    } catch (U) {
      throw errorTransform(U);
    }
  } });
}, { isTransformFunction: !0 });
function compileInlineExpression(D, E, O) {
  var F = D.filter(function(q) {
    return isSymbolNode(q) && !(q.name in E) && !O.has(q.name);
  })[0];
  if (!F) throw Error('No undefined variable found in inline expression "' + D + '"');
  var I = F.name, z = /* @__PURE__ */ new Map(), R = new PartitionedMap(O, z, /* @__PURE__ */ new Set([I])), L = D.compile();
  return function(q) {
    return z.set(I, q), L.evaluate(R);
  };
}
var name$25 = "transformCallback", dependencies$25 = ["typed"], createTransformCallback = factory(name$25, dependencies$25, (D) => {
  var { typed: E } = D;
  return function(F, I) {
    return E.isTypedFunction(F) ? O(F, I) : _transformCallbackFunction(F, F.length, I);
  };
  function O(F, I) {
    var z = Object.fromEntries(Object.entries(F.signatures).map((R) => {
      var [L, q] = R, U = L.split(",").length;
      return E.isTypedFunction(q) ? [L, O(q, I)] : [L, _transformCallbackFunction(q, U, I)];
    }));
    return typeof F.name == "string" ? E(F.name, z) : E(z);
  }
});
function _transformCallbackFunction(D, E, O) {
  return E === O ? D : E === O + 1 ? function() {
    var F = [...arguments], I = F.slice(0, O), z = _transformDims(F[O]);
    return D(...I, z);
  } : E > O + 1 ? function() {
    var F = [...arguments], I = F.slice(0, O), z = _transformDims(F[O]), R = F.slice(O + 1);
    return D(...I, z, ...R);
  } : D;
}
function _transformDims(D) {
  return D.map((E) => E + 1);
}
var name$24 = "filter", dependencies$24 = ["typed"], createFilterTransform = factory(name$24, dependencies$24, (D) => {
  var { typed: E } = D;
  function O(I, z, R) {
    var L = createFilter({ typed: E }), q = createTransformCallback({ typed: E });
    if (I.length === 0) return L();
    var U = I[0];
    if (I.length === 1) return L(U);
    var Z = I.length - 1, V = I[Z];
    return U &&= F(U, R), V &&= isSymbolNode(V) || isFunctionAssignmentNode(V) ? F(V, R) : compileInlineExpression(V, z, R), L(U, q(V, Z));
  }
  O.rawArgs = !0;
  function F(I, z) {
    return I.compile().evaluate(z);
  }
  return O;
}, { isTransformFunction: !0 }), name$23 = "forEach", dependencies$23 = ["typed"], createForEachTransform = factory(name$23, dependencies$23, (D) => {
  var { typed: E } = D, O = createForEach({ typed: E }), F = createTransformCallback({ typed: E });
  function I(R, L, q) {
    if (R.length === 0) return O();
    var U = R[0];
    if (R.length === 1) return O(U);
    var Z = R.length - 1, V = R[Z];
    return U &&= z(U, q), V &&= isSymbolNode(V) || isFunctionAssignmentNode(V) ? z(V, q) : compileInlineExpression(V, L, q), O(U, F(V, Z));
  }
  I.rawArgs = !0;
  function z(R, L) {
    return R.compile().evaluate(L);
  }
  return I;
}, { isTransformFunction: !0 }), name$22 = "index", dependencies$22 = ["Index", "getMatrixDataType"], createIndexTransform = factory(name$22, dependencies$22, (D) => {
  var { Index: E, getMatrixDataType: O } = D;
  return function() {
    for (var F = [], I = 0, z = arguments.length; I < z; I++) {
      var R = arguments[I];
      if (isRange(R)) R.start--, R.end -= R.step > 0 ? 0 : 2;
      else if (R && R.isSet === !0) R = R.map(function(q) {
        return q - 1;
      });
      else if (isArray(R) || isMatrix(R)) O(R) !== "boolean" && (R = R.map(function(q) {
        return q - 1;
      }));
      else if (isNumber(R) || isBigInt(R)) R--;
      else if (isBigNumber(R)) R = R.toNumber() - 1;
      else if (typeof R != "string") throw TypeError("Dimension must be an Array, Matrix, number, bigint, string, or Range");
      F[I] = R;
    }
    var L = new E();
    return E.apply(L, F), L;
  };
}, { isTransformFunction: !0 }), name$21 = "map", dependencies$21 = ["typed"], createMapTransform = factory(name$21, dependencies$21, (D) => {
  var { typed: E } = D, O = createMap({ typed: E }), F = createTransformCallback({ typed: E });
  function I(z, R, L) {
    if (z.length === 0) return O();
    if (z.length === 1) return O(z[0]);
    var q = z.length - 1, U = z.slice(0, q), Z = z[q];
    return U = U.map((G) => V(G, L)), Z &&= isSymbolNode(Z) || isFunctionAssignmentNode(Z) ? V(Z, L) : compileInlineExpression(Z, R, L), O(...U, F(Z, q));
    function V(G, W) {
      return G.compile().evaluate(W);
    }
  }
  return I.rawArgs = !0, I;
}, { isTransformFunction: !0 });
function dimToZeroBase(D) {
  return isNumber(D) ? D - 1 : isBigNumber(D) ? D.minus(1) : D;
}
function isNumberOrBigNumber(D) {
  return isNumber(D) || isBigNumber(D);
}
function lastDimToZeroBase(D) {
  if (D.length === 2 && isCollection(D[0])) {
    D = D.slice();
    var E = D[1];
    isNumberOrBigNumber(E) && (D[1] = dimToZeroBase(E));
  }
  return D;
}
var name$20 = "max", dependencies$20 = ["typed", "config", "numeric", "larger", "isNaN"], createMaxTransform = factory(name$20, dependencies$20, (D) => {
  var { typed: E, config: O, numeric: F, larger: I, isNaN: z } = D, R = createMax({ typed: E, config: O, numeric: F, larger: I, isNaN: z });
  return E("max", { "...any": function(L) {
    L = lastDimToZeroBase(L);
    try {
      return R.apply(null, L);
    } catch (q) {
      throw errorTransform(q);
    }
  } });
}, { isTransformFunction: !0 }), name$19 = "mean", dependencies$19 = ["typed", "add", "divide"], createMeanTransform = factory(name$19, dependencies$19, (D) => {
  var { typed: E, add: O, divide: F } = D, I = createMean({ typed: E, add: O, divide: F });
  return E("mean", { "...any": function(z) {
    z = lastDimToZeroBase(z);
    try {
      return I.apply(null, z);
    } catch (R) {
      throw errorTransform(R);
    }
  } });
}, { isTransformFunction: !0 }), name$18 = "min", dependencies$18 = ["typed", "config", "numeric", "smaller", "isNaN"], createMinTransform = factory(name$18, dependencies$18, (D) => {
  var { typed: E, config: O, numeric: F, smaller: I, isNaN: z } = D, R = createMin({ typed: E, config: O, numeric: F, smaller: I, isNaN: z });
  return E("min", { "...any": function(L) {
    L = lastDimToZeroBase(L);
    try {
      return R.apply(null, L);
    } catch (q) {
      throw errorTransform(q);
    }
  } });
}, { isTransformFunction: !0 }), name$17 = "range", dependencies$17 = ["typed", "config", "?matrix", "?bignumber", "equal", "smaller", "smallerEq", "larger", "largerEq", "add", "isZero", "isPositive"], createRangeTransform = factory(name$17, dependencies$17, (D) => {
  var { typed: E, config: O, matrix: F, bignumber: I, equal: z, smaller: R, smallerEq: L, larger: q, largerEq: U, add: Z, isZero: V, isPositive: G } = D, W = createRange({ typed: E, config: O, matrix: F, bignumber: I, equal: z, smaller: R, smallerEq: L, larger: q, largerEq: U, add: Z, isZero: V, isPositive: G });
  return E("range", { "...any": function(J) {
    return typeof J[J.length - 1] != "boolean" && J.push(!0), W.apply(null, J);
  } });
}, { isTransformFunction: !0 }), name$16 = "row", dependencies$16 = ["typed", "Index", "matrix", "range"], createRowTransform = factory(name$16, dependencies$16, (D) => {
  var { typed: E, Index: O, matrix: F, range: I } = D, z = createRow({ typed: E, Index: O, matrix: F, range: I });
  return E("row", { "...any": function(R) {
    var L = R.length - 1, q = R[L];
    isNumber(q) && (R[L] = q - 1);
    try {
      return z.apply(null, R);
    } catch (U) {
      throw errorTransform(U);
    }
  } });
}, { isTransformFunction: !0 }), name$15 = "subset", dependencies$15 = ["typed", "matrix", "zeros", "add"], createSubsetTransform = factory(name$15, dependencies$15, (D) => {
  var { typed: E, matrix: O, zeros: F, add: I } = D, z = createSubset({ typed: E, matrix: O, zeros: F, add: I });
  return E("subset", { "...any": function(R) {
    try {
      return z.apply(null, R);
    } catch (L) {
      throw errorTransform(L);
    }
  } });
}, { isTransformFunction: !0 }), name$14 = "concat", dependencies$14 = ["typed", "matrix", "isInteger"], createConcatTransform = factory(name$14, dependencies$14, (D) => {
  var { typed: E, matrix: O, isInteger: F } = D, I = createConcat({ typed: E, matrix: O, isInteger: F });
  return E("concat", { "...any": function(z) {
    var R = z.length - 1, L = z[R];
    isNumber(L) ? z[R] = L - 1 : isBigNumber(L) && (z[R] = L.minus(1));
    try {
      return I.apply(null, z);
    } catch (q) {
      throw errorTransform(q);
    }
  } });
}, { isTransformFunction: !0 }), name$13 = "diff", dependencies$13 = ["typed", "matrix", "subtract", "number", "bignumber"], createDiffTransform = factory(name$13, dependencies$13, (D) => {
  var { typed: E, matrix: O, subtract: F, number: I, bignumber: z } = D, R = createDiff({ typed: E, matrix: O, subtract: F, number: I, bignumber: z });
  return E(name$13, { "...any": function(L) {
    L = lastDimToZeroBase(L);
    try {
      return R.apply(null, L);
    } catch (q) {
      throw errorTransform(q);
    }
  } });
}, { isTransformFunction: !0 }), name$12 = "std", dependencies$12 = ["typed", "map", "sqrt", "variance"], createStdTransform = factory(name$12, dependencies$12, (D) => {
  var { typed: E, map: O, sqrt: F, variance: I } = D, z = createStd({ typed: E, map: O, sqrt: F, variance: I });
  return E("std", { "...any": function(R) {
    R = lastDimToZeroBase(R);
    try {
      return z.apply(null, R);
    } catch (L) {
      throw errorTransform(L);
    }
  } });
}, { isTransformFunction: !0 }), name$11 = "sum", dependencies$11 = ["typed", "config", "add", "numeric"], createSumTransform = factory(name$11, dependencies$11, (D) => {
  var { typed: E, config: O, add: F, numeric: I } = D, z = createSum({ typed: E, config: O, add: F, numeric: I });
  return E(name$11, { "...any": function(R) {
    R = lastDimToZeroBase(R);
    try {
      return z.apply(null, R);
    } catch (L) {
      throw errorTransform(L);
    }
  } });
}, { isTransformFunction: !0 }), name$10 = "quantileSeq", dependencies$10 = ["typed", "bignumber", "add", "subtract", "divide", "multiply", "partitionSelect", "compare", "isInteger", "smaller", "smallerEq", "larger", "mapSlices"], createQuantileSeqTransform = factory(name$10, dependencies$10, (D) => {
  var { typed: E, bignumber: O, add: F, subtract: I, divide: z, multiply: R, partitionSelect: L, compare: q, isInteger: U, smaller: Z, smallerEq: V, larger: G, mapSlices: W } = D, J = createQuantileSeq({ typed: E, bignumber: O, add: F, subtract: I, divide: z, multiply: R, partitionSelect: L, compare: q, isInteger: U, smaller: Z, smallerEq: V, larger: G, mapSlices: W });
  return E("quantileSeq", { "Array | Matrix, number | BigNumber": J, "Array | Matrix, number | BigNumber, number": (Y, ee, K) => J(Y, ee, X(K)), "Array | Matrix, number | BigNumber, boolean": J, "Array | Matrix, number | BigNumber, boolean, number": (Y, ee, K, te) => J(Y, ee, K, X(te)), "Array | Matrix, Array | Matrix": J, "Array | Matrix, Array | Matrix, number": (Y, ee, K) => J(Y, ee, X(K)), "Array | Matrix, Array | Matrix, boolean": J, "Array | Matrix, Array | Matrix, boolean, number": (Y, ee, K, te) => J(Y, ee, K, X(te)) });
  function X(Y) {
    return lastDimToZeroBase([[], Y])[1];
  }
}, { isTransformFunction: !0 }), name$9 = "cumsum", dependencies$9 = ["typed", "add", "unaryPlus"], createCumSumTransform = factory(name$9, dependencies$9, (D) => {
  var { typed: E, add: O, unaryPlus: F } = D, I = createCumSum({ typed: E, add: O, unaryPlus: F });
  return E(name$9, { "...any": function(z) {
    if (z.length === 2 && isCollection(z[0])) {
      var R = z[1];
      isNumber(R) ? z[1] = R - 1 : isBigNumber(R) && (z[1] = R.minus(1));
    }
    try {
      return I.apply(null, z);
    } catch (L) {
      throw errorTransform(L);
    }
  } });
}, { isTransformFunction: !0 }), name$8 = "variance", dependencies$8 = ["typed", "add", "subtract", "multiply", "divide", "mapSlices", "isNaN"], createVarianceTransform = factory(name$8, dependencies$8, (D) => {
  var { typed: E, add: O, subtract: F, multiply: I, divide: z, mapSlices: R, isNaN: L } = D, q = createVariance({ typed: E, add: O, subtract: F, multiply: I, divide: z, mapSlices: R, isNaN: L });
  return E(name$8, { "...any": function(U) {
    U = lastDimToZeroBase(U);
    try {
      return q.apply(null, U);
    } catch (Z) {
      throw errorTransform(Z);
    }
  } });
}, { isTransformFunction: !0 }), name$7 = "print", dependencies$7 = ["typed", "matrix", "zeros", "add"], createPrintTransform = factory(name$7, dependencies$7, (D) => {
  var { typed: E, matrix: O, zeros: F, add: I } = D, z = createPrint({ typed: E, matrix: O, zeros: F, add: I });
  return E(name$7, { "string, Object | Array": function(L, q) {
    return z(R(L), q);
  }, "string, Object | Array, number | Object": function(L, q, U) {
    return z(R(L), q, U);
  } });
  function R(L) {
    return L.replace(printTemplate, (q) => "$" + q.slice(1).split(".").map(function(U) {
      return !isNaN(U) && U.length > 0 ? parseInt(U) - 1 : U;
    }).join("."));
  }
}, { isTransformFunction: !0 }), name$6 = "and", dependencies$6 = ["typed", "matrix", "zeros", "add", "equalScalar", "not", "concat"], createAndTransform = factory(name$6, dependencies$6, (D) => {
  var { typed: E, matrix: O, equalScalar: F, zeros: I, not: z, concat: R } = D, L = createAnd({ typed: E, matrix: O, equalScalar: F, zeros: I, not: z, concat: R });
  function q(U, Z, V) {
    var G = U[0].compile().evaluate(V);
    return !isCollection(G) && !L(G, !0) ? !1 : L(G, U[1].compile().evaluate(V));
  }
  return q.rawArgs = !0, q;
}, { isTransformFunction: !0 }), name$5 = "or", dependencies$5 = ["typed", "matrix", "equalScalar", "DenseMatrix", "concat"], createOrTransform = factory(name$5, dependencies$5, (D) => {
  var { typed: E, matrix: O, equalScalar: F, DenseMatrix: I, concat: z } = D, R = createOr({ typed: E, matrix: O, equalScalar: F, DenseMatrix: I, concat: z });
  function L(q, U, Z) {
    var V = q[0].compile().evaluate(Z);
    return !isCollection(V) && R(V, !1) ? !0 : R(V, q[1].compile().evaluate(Z));
  }
  return L.rawArgs = !0, L;
}, { isTransformFunction: !0 }), name$4 = "nullish", dependencies$4 = ["typed", "matrix", "size", "flatten", "deepEqual"], createNullishTransform = factory(name$4, dependencies$4, (D) => {
  var { typed: E, matrix: O, size: F, flatten: I, deepEqual: z } = D, R = createNullish({ typed: E, matrix: O, size: F, flatten: I, deepEqual: z });
  function L(q, U, Z) {
    var V = q[0].compile().evaluate(Z);
    return !isCollection(V) && V != null && V !== void 0 ? V : R(V, q[1].compile().evaluate(Z));
  }
  return L.rawArgs = !0, L;
}, { isTransformFunction: !0 }), name$3 = "bitAnd", dependencies$3 = ["typed", "matrix", "zeros", "add", "equalScalar", "not", "concat"], createBitAndTransform = factory(name$3, dependencies$3, (D) => {
  var { typed: E, matrix: O, equalScalar: F, zeros: I, not: z, concat: R } = D, L = createBitAnd({ typed: E, matrix: O, equalScalar: F, zeros: I, not: z, concat: R });
  function q(U, Z, V) {
    var G = U[0].compile().evaluate(V);
    if (!isCollection(G)) {
      if (isNaN(G)) return NaN;
      if (G === 0 || G === !1) return 0;
    }
    return L(G, U[1].compile().evaluate(V));
  }
  return q.rawArgs = !0, q;
}, { isTransformFunction: !0 }), name$2 = "bitOr", dependencies$2 = ["typed", "matrix", "equalScalar", "DenseMatrix", "concat"], createBitOrTransform = factory(name$2, dependencies$2, (D) => {
  var { typed: E, matrix: O, equalScalar: F, DenseMatrix: I, concat: z } = D, R = createBitOr({ typed: E, matrix: O, equalScalar: F, DenseMatrix: I, concat: z });
  function L(q, U, Z) {
    var V = q[0].compile().evaluate(Z);
    if (!isCollection(V)) {
      if (isNaN(V)) return NaN;
      if (V === -1) return -1;
      if (V === !0) return 1;
    }
    return R(V, q[1].compile().evaluate(Z));
  }
  return L.rawArgs = !0, L;
}, { isTransformFunction: !0 }), name$1 = "num", dependencies$1 = ["typed", "fraction"], createNum = factory(name$1, dependencies$1, (D) => {
  var { typed: E, fraction: O } = D;
  return E(name$1, { Fraction: (F) => F.s * F.n, BigNumber: (F) => {
    var I = O(F);
    return I.s * I.n;
  }, "Array | Matrix": E.referToSelf((F) => (I) => deepMap(I, F)) });
}), name = "den", dependencies = ["typed", "fraction"], createDen = factory(name, dependencies, (D) => {
  var { typed: E, fraction: O } = D;
  return E(name, { Fraction: (F) => F.d, BigNumber: (F) => O(F).d, "Array | Matrix": E.referToSelf((F) => (I) => deepMap(I, F)) });
}), factoriesAny_exports = __exportAll({ createAbs: () => createAbs, createAccessorNode: () => createAccessorNode, createAcos: () => createAcos, createAcosh: () => createAcosh, createAcot: () => createAcot, createAcoth: () => createAcoth, createAcsc: () => createAcsc, createAcsch: () => createAcsch, createAdd: () => createAdd, createAddScalar: () => createAddScalar, createAnd: () => createAnd, createAndTransform: () => createAndTransform, createArg: () => createArg, createArrayNode: () => createArrayNode, createAsec: () => createAsec, createAsech: () => createAsech, createAsin: () => createAsin, createAsinh: () => createAsinh, createAssignmentNode: () => createAssignmentNode, createAtan: () => createAtan, createAtan2: () => createAtan2, createAtanh: () => createAtanh, createAtomicMass: () => createAtomicMass, createAvogadro: () => createAvogadro, createBellNumbers: () => createBellNumbers, createBernoulli: () => createBernoulli, createBigNumberClass: () => createBigNumberClass, createBigint: () => createBigint, createBignumber: () => createBignumber, createBin: () => createBin, createBitAnd: () => createBitAnd, createBitAndTransform: () => createBitAndTransform, createBitNot: () => createBitNot, createBitOr: () => createBitOr, createBitOrTransform: () => createBitOrTransform, createBitXor: () => createBitXor, createBlockNode: () => createBlockNode, createBohrMagneton: () => createBohrMagneton, createBohrRadius: () => createBohrRadius, createBoltzmann: () => createBoltzmann, createBoolean: () => createBoolean, createCatalan: () => createCatalan, createCbrt: () => createCbrt, createCeil: () => createCeil, createChain: () => createChain, createChainClass: () => createChainClass, createClassicalElectronRadius: () => createClassicalElectronRadius, createClone: () => createClone, createColumn: () => createColumn, createColumnTransform: () => createColumnTransform, createCombinations: () => createCombinations, createCombinationsWithRep: () => createCombinationsWithRep, createCompare: () => createCompare, createCompareNatural: () => createCompareNatural, createCompareText: () => createCompareText, createCompile: () => createCompile, createComplex: () => createComplex, createComplexClass: () => createComplexClass, createComposition: () => createComposition, createConcat: () => createConcat, createConcatTransform: () => createConcatTransform, createConditionalNode: () => createConditionalNode, createConductanceQuantum: () => createConductanceQuantum, createConj: () => createConj, createConstantNode: () => createConstantNode, createCorr: () => createCorr, createCos: () => createCos, createCosh: () => createCosh, createCot: () => createCot, createCoth: () => createCoth, createCoulomb: () => createCoulomb, createCoulombConstant: () => createCoulombConstant, createCount: () => createCount, createCreateUnit: () => createCreateUnit, createCross: () => createCross, createCsc: () => createCsc, createCsch: () => createCsch, createCtranspose: () => createCtranspose, createCube: () => createCube, createCumSum: () => createCumSum, createCumSumTransform: () => createCumSumTransform, createDeepEqual: () => createDeepEqual, createDen: () => createDen, createDenseMatrixClass: () => createDenseMatrixClass, createDerivative: () => createDerivative, createDet: () => createDet, createDeuteronMass: () => createDeuteronMass, createDiag: () => createDiag, createDiff: () => createDiff, createDiffTransform: () => createDiffTransform, createDistance: () => createDistance, createDivide: () => createDivide, createDivideScalar: () => createDivideScalar, createDot: () => createDot, createDotDivide: () => createDotDivide, createDotMultiply: () => createDotMultiply, createDotPow: () => createDotPow, createE: () => createE, createEfimovFactor: () => createEfimovFactor, createEigs: () => createEigs, createElectricConstant: () => createElectricConstant, createElectronMass: () => createElectronMass, createElementaryCharge: () => createElementaryCharge, createEqual: () => createEqual, createEqualScalar: () => createEqualScalar, createEqualText: () => createEqualText, createErf: () => createErf, createEvaluate: () => createEvaluate, createExp: () => createExp, createExpm: () => createExpm, createExpm1: () => createExpm1, createFactorial: () => createFactorial, createFalse: () => createFalse, createFaraday: () => createFaraday, createFermiCoupling: () => createFermiCoupling, createFft: () => createFft, createFibonacciHeapClass: () => createFibonacciHeapClass, createFilter: () => createFilter, createFilterTransform: () => createFilterTransform, createFineStructure: () => createFineStructure, createFirstRadiation: () => createFirstRadiation, createFix: () => createFix, createFlatten: () => createFlatten, createFloor: () => createFloor, createForEach: () => createForEach, createForEachTransform: () => createForEachTransform, createFormat: () => createFormat, createFraction: () => createFraction, createFractionClass: () => createFractionClass, createFreqz: () => createFreqz, createFunctionAssignmentNode: () => createFunctionAssignmentNode, createFunctionNode: () => createFunctionNode, createGamma: () => createGamma, createGasConstant: () => createGasConstant, createGcd: () => createGcd, createGetMatrixDataType: () => createGetMatrixDataType, createGravitationConstant: () => createGravitationConstant, createGravity: () => createGravity, createHartreeEnergy: () => createHartreeEnergy, createHasNumericValue: () => createHasNumericValue, createHelp: () => createHelp, createHelpClass: () => createHelpClass, createHex: () => createHex, createHypot: () => createHypot, createI: () => createI, createIdentity: () => createIdentity, createIfft: () => createIfft, createIm: () => createIm, createImmutableDenseMatrixClass: () => createImmutableDenseMatrixClass, createIndex: () => createIndex, createIndexClass: () => createIndexClass, createIndexNode: () => createIndexNode, createIndexTransform: () => createIndexTransform, createInfinity: () => createInfinity, createIntersect: () => createIntersect, createInv: () => createInv, createInverseConductanceQuantum: () => createInverseConductanceQuantum, createInvmod: () => createInvmod, createIsBounded: () => createIsBounded, createIsFinite: () => createIsFinite, createIsInteger: () => createIsInteger, createIsNaN: () => createIsNaN, createIsNegative: () => createIsNegative, createIsNumeric: () => createIsNumeric, createIsPositive: () => createIsPositive, createIsPrime: () => createIsPrime, createIsZero: () => createIsZero, createKldivergence: () => createKldivergence, createKlitzing: () => createKlitzing, createKron: () => createKron, createLN10: () => createLN10, createLN2: () => createLN2, createLOG10E: () => createLOG10E, createLOG2E: () => createLOG2E, createLarger: () => createLarger, createLargerEq: () => createLargerEq, createLcm: () => createLcm, createLeafCount: () => createLeafCount, createLeftShift: () => createLeftShift, createLgamma: () => createLgamma, createLog: () => createLog, createLog10: () => createLog10, createLog1p: () => createLog1p, createLog2: () => createLog2, createLoschmidt: () => createLoschmidt, createLsolve: () => createLsolve, createLsolveAll: () => createLsolveAll, createLup: () => createLup, createLusolve: () => createLusolve, createLyap: () => createLyap, createMad: () => createMad, createMagneticConstant: () => createMagneticConstant, createMagneticFluxQuantum: () => createMagneticFluxQuantum, createMap: () => createMap, createMapSlices: () => createMapSlices, createMapSlicesTransform: () => createMapSlicesTransform, createMapTransform: () => createMapTransform, createMatrix: () => createMatrix, createMatrixClass: () => createMatrixClass, createMatrixFromColumns: () => createMatrixFromColumns, createMatrixFromFunction: () => createMatrixFromFunction, createMatrixFromRows: () => createMatrixFromRows, createMax: () => createMax, createMaxTransform: () => createMaxTransform, createMean: () => createMean, createMeanTransform: () => createMeanTransform, createMedian: () => createMedian, createMin: () => createMin, createMinTransform: () => createMinTransform, createMod: () => createMod, createMode: () => createMode, createMolarMass: () => createMolarMass, createMolarMassC12: () => createMolarMassC12, createMolarPlanckConstant: () => createMolarPlanckConstant, createMolarVolume: () => createMolarVolume, createMultinomial: () => createMultinomial, createMultiply: () => createMultiply, createMultiplyScalar: () => createMultiplyScalar, createNaN: () => createNaN, createNeutronMass: () => createNeutronMass, createNode: () => createNode, createNorm: () => createNorm, createNot: () => createNot, createNthRoot: () => createNthRoot, createNthRoots: () => createNthRoots, createNuclearMagneton: () => createNuclearMagneton, createNull: () => createNull, createNullish: () => createNullish, createNullishTransform: () => createNullishTransform, createNum: () => createNum, createNumber: () => createNumber, createNumeric: () => createNumeric, createObjectNode: () => createObjectNode, createOct: () => createOct, createOnes: () => createOnes, createOperatorNode: () => createOperatorNode, createOr: () => createOr, createOrTransform: () => createOrTransform, createParenthesisNode: () => createParenthesisNode, createParse: () => createParse, createParser: () => createParser, createParserClass: () => createParserClass, createPartitionSelect: () => createPartitionSelect, createPermutations: () => createPermutations, createPhi: () => createPhi, createPi: () => createPi, createPickRandom: () => createPickRandom, createPinv: () => createPinv, createPlanckCharge: () => createPlanckCharge, createPlanckConstant: () => createPlanckConstant, createPlanckLength: () => createPlanckLength, createPlanckMass: () => createPlanckMass, createPlanckTemperature: () => createPlanckTemperature, createPlanckTime: () => createPlanckTime, createPolynomialRoot: () => createPolynomialRoot, createPow: () => createPow, createPrint: () => createPrint, createPrintTransform: () => createPrintTransform, createProd: () => createProd, createProtonMass: () => createProtonMass, createQr: () => createQr, createQuantileSeq: () => createQuantileSeq, createQuantileSeqTransform: () => createQuantileSeqTransform, createQuantumOfCirculation: () => createQuantumOfCirculation, createRandom: () => createRandom, createRandomInt: () => createRandomInt, createRange: () => createRange, createRangeClass: () => createRangeClass, createRangeNode: () => createRangeNode, createRangeTransform: () => createRangeTransform, createRationalize: () => createRationalize, createRe: () => createRe, createReducedPlanckConstant: () => createReducedPlanckConstant, createRelationalNode: () => createRelationalNode, createReplacer: () => createReplacer, createReshape: () => createReshape, createResize: () => createResize, createResolve: () => createResolve, createResultSet: () => createResultSet, createReviver: () => createReviver, createRightArithShift: () => createRightArithShift, createRightLogShift: () => createRightLogShift, createRotate: () => createRotate, createRotationMatrix: () => createRotationMatrix, createRound: () => createRound, createRow: () => createRow, createRowTransform: () => createRowTransform, createRydberg: () => createRydberg, createSQRT1_2: () => createSQRT1_2, createSQRT2: () => createSQRT2, createSackurTetrode: () => createSackurTetrode, createSchur: () => createSchur, createSec: () => createSec, createSech: () => createSech, createSecondRadiation: () => createSecondRadiation, createSetCartesian: () => createSetCartesian, createSetDifference: () => createSetDifference, createSetDistinct: () => createSetDistinct, createSetIntersect: () => createSetIntersect, createSetIsSubset: () => createSetIsSubset, createSetMultiplicity: () => createSetMultiplicity, createSetPowerset: () => createSetPowerset, createSetSize: () => createSetSize, createSetSymDifference: () => createSetSymDifference, createSetUnion: () => createSetUnion, createSign: () => createSign, createSimplify: () => createSimplify, createSimplifyConstant: () => createSimplifyConstant, createSimplifyCore: () => createSimplifyCore, createSin: () => createSin, createSinh: () => createSinh, createSize: () => createSize, createSlu: () => createSlu, createSmaller: () => createSmaller, createSmallerEq: () => createSmallerEq, createSolveODE: () => createSolveODE, createSort: () => createSort, createSpaClass: () => createSpaClass, createSparse: () => createSparse, createSparseMatrixClass: () => createSparseMatrixClass, createSpeedOfLight: () => createSpeedOfLight, createSplitUnit: () => createSplitUnit, createSqrt: () => createSqrt, createSqrtm: () => createSqrtm, createSquare: () => createSquare, createSqueeze: () => createSqueeze, createStd: () => createStd, createStdTransform: () => createStdTransform, createStefanBoltzmann: () => createStefanBoltzmann, createStirlingS2: () => createStirlingS2, createString: () => createString, createSubset: () => createSubset, createSubsetTransform: () => createSubsetTransform, createSubtract: () => createSubtract, createSubtractScalar: () => createSubtractScalar, createSum: () => createSum, createSumTransform: () => createSumTransform, createSylvester: () => createSylvester, createSymbolNode: () => createSymbolNode, createSymbolicEqual: () => createSymbolicEqual, createTan: () => createTan, createTanh: () => createTanh, createTau: () => createTau, createThomsonCrossSection: () => createThomsonCrossSection, createTo: () => createTo, createToBest: () => createToBest, createTrace: () => createTrace, createTranspose: () => createTranspose, createTrue: () => createTrue, createTypeOf: () => createTypeOf, createTyped: () => createTyped, createUnaryMinus: () => createUnaryMinus, createUnaryPlus: () => createUnaryPlus, createUnequal: () => createUnequal, createUnitClass: () => createUnitClass, createUnitFunction: () => createUnitFunction, createUppercaseE: () => createUppercaseE, createUppercasePi: () => createUppercasePi, createUsolve: () => createUsolve, createUsolveAll: () => createUsolveAll, createVacuumImpedance: () => createVacuumImpedance, createVariance: () => createVariance, createVarianceTransform: () => createVarianceTransform, createVersion: () => createVersion, createWeakMixingAngle: () => createWeakMixingAngle, createWienDisplacement: () => createWienDisplacement, createXgcd: () => createXgcd, createXor: () => createXor, createZeros: () => createZeros, createZeta: () => createZeta, createZpk2tf: () => createZpk2tf }), all = factoriesAny_exports, require_tiny_emitter = __commonJSMin(((D, E) => {
  function O() {
  }
  O.prototype = { on: function(F, I, z) {
    var R = this.e ||= {};
    return (R[F] || (R[F] = [])).push({ fn: I, ctx: z }), this;
  }, once: function(F, I, z) {
    var R = this;
    function L() {
      R.off(F, L), I.apply(z, arguments);
    }
    return L._ = I, this.on(F, L, z);
  }, emit: function(F) {
    for (var I = [].slice.call(arguments, 1), z = ((this.e ||= {})[F] || []).slice(), R = 0, L = z.length; R < L; R++) z[R].fn.apply(z[R].ctx, I);
    return this;
  }, off: function(F, I) {
    var z = this.e ||= {}, R = z[F], L = [];
    if (R && I) for (var q = 0, U = R.length; q < U; q++) R[q].fn !== I && R[q].fn._ !== I && L.push(R[q]);
    return L.length ? z[F] = L : delete z[F], this;
  } }, E.exports = O, E.exports.TinyEmitter = O;
})), import_tiny_emitter = __toESM(require_tiny_emitter());
function mixin$1(D) {
  var E = new import_tiny_emitter.default();
  return D.on = E.on.bind(E), D.off = E.off.bind(E), D.once = E.once.bind(E), D.emit = E.emit.bind(E), D;
}
function importFactory(D, E, O, F) {
  function I(ee, K) {
    var te = arguments.length;
    if (te !== 1 && te !== 2) throw new ArgumentsError("import", te, 1, 2);
    K ||= {};
    function ie(oe, se, le) {
      if (Array.isArray(se)) se.forEach((pe) => ie(oe, pe));
      else if (isObject$1(se) || V(se)) for (var ce in se) hasOwnProperty$1(se, ce) && ie(oe, se[ce], ce);
      else if (isFactory(se) || le !== void 0) {
        var fe = isFactory(se) ? X(se) ? se.fn + ".transform" : se.fn : le;
        if (hasOwnProperty$1(oe, fe) && oe[fe] !== se && !K.silent) throw Error('Cannot import "' + fe + '" twice');
        oe[fe] = se;
      } else if (!K.silent) throw TypeError("Factory, Object, or Array expected");
    }
    var ne = {};
    for (var ae in ie(ne, ee), ne) if (hasOwnProperty$1(ne, ae)) {
      var ue = ne[ae];
      if (isFactory(ue)) U(ue, K);
      else if (Z(ue)) z(ae, ue, K);
      else if (!K.silent) throw TypeError("Factory, Object, or Array expected");
    }
  }
  function z(ee, K, te) {
    if (te.wrap && typeof K == "function" && (K = q(K)), G(K) && (K = D(ee, { [K.signature]: K })), D.isTypedFunction(O[ee]) && D.isTypedFunction(K)) {
      K = te.override ? D(ee, K.signatures) : D(O[ee], K), O[ee] = K, delete F[ee], R(ee, K), O.emit("import", ee, function() {
        return K;
      });
      return;
    }
    var ie = O[ee] !== void 0, ne = O.Unit?.isValuelessUnit(ee);
    if (!ie && !ne || te.override) {
      O[ee] = K, delete F[ee], R(ee, K), O.emit("import", ee, function() {
        return K;
      });
      return;
    }
    if (!te.silent) throw Error('Cannot import "' + ee + '": already exists');
  }
  function R(ee, K) {
    K && typeof K.transform == "function" ? (O.expression.transform[ee] = K.transform, W(ee) && (O.expression.mathWithTransform[ee] = K.transform)) : (delete O.expression.transform[ee], W(ee) && (O.expression.mathWithTransform[ee] = K));
  }
  function L(ee) {
    delete O.expression.transform[ee], W(ee) ? O.expression.mathWithTransform[ee] = O[ee] : delete O.expression.mathWithTransform[ee];
  }
  function q(ee) {
    var K = function() {
      for (var te = [], ie = 0, ne = arguments.length; ie < ne; ie++) {
        var ae = arguments[ie];
        te[ie] = ae && ae.valueOf();
      }
      return ee.apply(O, te);
    };
    return ee.transform && (K.transform = ee.transform), K;
  }
  function U(ee, K) {
    var te = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ee.fn;
    if (te.includes(".")) throw Error("Factory name should not contain a nested path. Name: " + JSON.stringify(te));
    var ie = X(ee) ? O.expression.transform : O, ne = te in O.expression.transform, ae = hasOwnProperty$1(ie, te) ? ie[te] : void 0, ue = function() {
      var ce = {};
      ee.dependencies.map(stripOptionalNotation).forEach((pe) => {
        if (pe.includes(".")) throw Error("Factory dependency should not contain a nested path. Name: " + JSON.stringify(pe));
        pe === "math" ? ce.math = O : pe === "mathWithTransform" ? ce.mathWithTransform = O.expression.mathWithTransform : pe === "classes" ? ce.classes = O : ce[pe] = O[pe];
      });
      var fe = ee(ce);
      if (fe && typeof fe.transform == "function") throw Error('Transforms cannot be attached to factory functions. Please create a separate function for it with export const path = "expression.transform"');
      if (ae === void 0 || K.override) return fe;
      if (D.isTypedFunction(ae) && D.isTypedFunction(fe)) return D(ae, fe);
      if (K.silent) return ae;
      throw Error('Cannot import "' + te + '": already exists');
    }, oe = ee.meta?.formerly ?? "", se = X(ee) || J(ee), le = O.expression.mathWithTransform;
    !ee.meta || ee.meta.lazy !== !1 ? (lazy(ie, te, ue), oe && lazy(ie, oe, ue), ae && ne ? (L(te), oe && L(oe)) : se && (lazy(le, te, () => ie[te]), oe && lazy(le, oe, () => ie[te]))) : (ie[te] = ue(), oe && (ie[oe] = ie[te]), ae && ne ? (L(te), oe && L(oe)) : se && (lazy(le, te, () => ie[te]), oe && lazy(le, oe, () => ie[te]))), F[te] = ee, O.emit("import", te, ue);
  }
  function Z(ee) {
    return typeof ee == "function" || typeof ee == "number" || typeof ee == "string" || typeof ee == "boolean" || ee === null || isUnit(ee) || isComplex(ee) || isBigNumber(ee) || isFraction(ee) || isMatrix(ee) || Array.isArray(ee);
  }
  function V(ee) {
    return typeof ee == "object" && ee[Symbol.toStringTag] === "Module";
  }
  function G(ee) {
    return typeof ee == "function" && typeof ee.signature == "string";
  }
  function W(ee) {
    return !hasOwnProperty$1(Y, ee);
  }
  function J(ee) {
    return !ee.fn.includes(".") && !hasOwnProperty$1(Y, ee.fn) && (!ee.meta || !ee.meta.isClass);
  }
  function X(ee) {
    return ee !== void 0 && ee.meta !== void 0 && ee.meta.isTransformFunction === !0 || !1;
  }
  var Y = { expression: !0, type: !0, docs: !0, error: !0, json: !0, chain: !0 };
  return I;
}
function create$1(D, E) {
  var O = _extends({}, DEFAULT_CONFIG, E);
  if (typeof Object.create != "function") throw Error("ES5 not supported by this JavaScript engine. Please load the es5-shim and es5-sham library for compatibility.");
  var F = mixin$1({ isNumber, isComplex, isBigNumber, isBigInt, isFraction, isUnit, isString, isArray, isMatrix, isCollection, isDenseMatrix, isSparseMatrix, isRange, isIndex, isBoolean: isBoolean$1, isResultSet, isHelp, isFunction: isFunction$1, isDate, isRegExp, isObject: isObject$1, isMap, isPartitionedMap, isObjectWrappingMap, isNull: isNull$1, isUndefined: isUndefined$1, isAccessorNode, isArrayNode, isAssignmentNode, isBlockNode, isConditionalNode, isConstantNode, isFunctionAssignmentNode, isFunctionNode, isIndexNode, isNode, isObjectNode, isOperatorNode, isParenthesisNode, isRangeNode, isRelationalNode, isSymbolNode, isChain });
  F.config = configFactory(O, F.emit), F.expression = { transform: {}, mathWithTransform: { config: F.config } };
  var I = [], z = [];
  function R(Z) {
    if (isFactory(Z)) return Z(F);
    var V = Z[Object.keys(Z)[0]];
    if (isFactory(V)) return V(F);
    if (!isLegacyFactory(Z)) throw console.warn("Factory object with properties `type`, `name`, and `factory` expected", Z), Error("Factory object with properties `type`, `name`, and `factory` expected");
    var G = I.indexOf(Z), W;
    return G === -1 ? (W = Z.math === !0 ? Z.factory(F.type, O, R, F.typed, F) : Z.factory(F.type, O, R, F.typed), I.push(Z), z.push(W)) : W = z[G], W;
  }
  var L = {};
  function q() {
    var Z = [...arguments];
    return F.typed.apply(F.typed, Z);
  }
  q.isTypedFunction = import_typed_function.default.isTypedFunction;
  var U = importFactory(q, R, F, L);
  return F.import = U, F.on("config", () => {
    Object.values(L).forEach((Z) => {
      Z && Z.meta && Z.meta.recreateOnConfigChange && U(Z, { override: !0 });
    });
  }), F.create = create$1.bind(null, D), F.factory = factory, F.import(Object.values(deepFlatten(D))), F.ArgumentsError = ArgumentsError, F.DimensionError = DimensionError, F.IndexError = IndexError, F;
}
var require_numeric_1_2_6 = __commonJSMin(((exports) => {
  var numeric = exports === void 0 ? (function() {
  }) : exports;
  typeof global < "u" && (global.numeric = numeric), numeric.version = "1.2.6", numeric.bench = function(D, E) {
    var O, F, I, z;
    for (E === void 0 && (E = 15), I = 0.5, O = /* @__PURE__ */ new Date(); ; ) {
      for (I *= 2, z = I; z > 3; z -= 4) D(), D(), D(), D();
      for (; z > 0; ) D(), z--;
      if (F = /* @__PURE__ */ new Date(), F - O > E) break;
    }
    for (z = I; z > 3; z -= 4) D(), D(), D(), D();
    for (; z > 0; ) D(), z--;
    return F = /* @__PURE__ */ new Date(), 1e3 * (3 * I - 1) / (F - O);
  }, numeric._myIndexOf = (function(D) {
    var E = this.length, O;
    for (O = 0; O < E; ++O) if (this[O] === D) return O;
    return -1;
  }), numeric.myIndexOf = Array.prototype.indexOf ? Array.prototype.indexOf : numeric._myIndexOf, numeric.Function = Function, numeric.precision = 4, numeric.largeArray = 50, numeric.prettyPrint = function(D) {
    function E(I) {
      if (I === 0) return "0";
      if (isNaN(I)) return "NaN";
      if (I < 0) return "-" + E(-I);
      if (isFinite(I)) {
        var z = Math.floor(Math.log(I) / Math.log(10)), R = I / 10 ** z, L = R.toPrecision(numeric.precision);
        return parseFloat(L) === 10 && (z++, R = 1, L = R.toPrecision(numeric.precision)), parseFloat(L).toString() + "e" + z.toString();
      }
      return "Infinity";
    }
    var O = [];
    function F(I) {
      var z;
      if (I === void 0) return O.push(Array(numeric.precision + 8).join(" ")), !1;
      if (typeof I == "string") return O.push('"' + I + '"'), !1;
      if (typeof I == "boolean") return O.push(I.toString()), !1;
      if (typeof I == "number") {
        var R = E(I), L = I.toPrecision(numeric.precision), q = parseFloat(I.toString()).toString(), U = [R, L, q, parseFloat(L).toString(), parseFloat(q).toString()];
        for (z = 1; z < U.length; z++) U[z].length < R.length && (R = U[z]);
        return O.push(Array(numeric.precision + 8 - R.length).join(" ") + R), !1;
      }
      if (I === null) return O.push("null"), !1;
      if (typeof I == "function") {
        O.push(I.toString());
        var Z = !1;
        for (z in I) I.hasOwnProperty(z) && (Z ? O.push(`,
`) : O.push(`
{`), Z = !0, O.push(z), O.push(`: 
`), F(I[z]));
        return Z && O.push(`}
`), !0;
      }
      if (I instanceof Array) {
        if (I.length > numeric.largeArray) return O.push("...Large Array..."), !0;
        var Z = !1;
        for (O.push("["), z = 0; z < I.length; z++) z > 0 && (O.push(","), Z && O.push(`
 `)), Z = F(I[z]);
        return O.push("]"), !0;
      }
      O.push("{");
      var Z = !1;
      for (z in I) I.hasOwnProperty(z) && (Z && O.push(`,
`), Z = !0, O.push(z), O.push(`: 
`), F(I[z]));
      return O.push("}"), !0;
    }
    return F(D), O.join("");
  }, numeric.parseDate = function(D) {
    function E(O) {
      if (typeof O == "string") return Date.parse(O.replace(/-/g, "/"));
      if (!(O instanceof Array)) throw Error("parseDate: parameter must be arrays of strings");
      var F = [], I;
      for (I = 0; I < O.length; I++) F[I] = E(O[I]);
      return F;
    }
    return E(D);
  }, numeric.parseFloat = function(D) {
    function E(O) {
      if (typeof O == "string") return parseFloat(O);
      if (!(O instanceof Array)) throw Error("parseFloat: parameter must be arrays of strings");
      var F = [], I;
      for (I = 0; I < O.length; I++) F[I] = E(O[I]);
      return F;
    }
    return E(D);
  }, numeric.parseCSV = function(D) {
    var E = D.split(`
`), O, F, I = [], z = /(([^'",]*)|('[^']*')|("[^"]*")),/g, R = /^\s*(([+-]?[0-9]+(\.[0-9]*)?(e[+-]?[0-9]+)?)|([+-]?[0-9]*(\.[0-9]+)?(e[+-]?[0-9]+)?))\s*$/, L = function(V) {
      return V.substr(0, V.length - 1);
    }, q = 0;
    for (F = 0; F < E.length; F++) {
      var U = (E[F] + ",").match(z), Z;
      if (U.length > 0) {
        for (I[q] = [], O = 0; O < U.length; O++) Z = L(U[O]), R.test(Z) ? I[q][O] = parseFloat(Z) : I[q][O] = Z;
        q++;
      }
    }
    return I;
  }, numeric.toCSV = function(D) {
    var E = numeric.dim(D), O, F, I = E[0], z, R;
    for (E[1], R = [], O = 0; O < I; O++) {
      for (z = [], F = 0; F < I; F++) z[F] = D[O][F].toString();
      R[O] = z.join(", ");
    }
    return R.join(`
`) + `
`;
  }, numeric.getURL = function(D) {
    var E = new XMLHttpRequest();
    return E.open("GET", D, !1), E.send(), E;
  }, numeric.imageURL = function(D) {
    function E(Y) {
      var ee = Y.length, K, te, ie, ne, ae, ue, oe, se, le = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", ce = "";
      for (K = 0; K < ee; K += 3) te = Y[K], ie = Y[K + 1], ne = Y[K + 2], ae = te >> 2, ue = ((te & 3) << 4) + (ie >> 4), oe = ((ie & 15) << 2) + (ne >> 6), se = ne & 63, K + 1 >= ee ? oe = se = 64 : K + 2 >= ee && (se = 64), ce += le.charAt(ae) + le.charAt(ue) + le.charAt(oe) + le.charAt(se);
      return ce;
    }
    function O(Y, ee, K) {
      ee === void 0 && (ee = 0), K === void 0 && (K = Y.length);
      var te = [0, 1996959894, 3993919788, 2567524794, 124634137, 1886057615, 3915621685, 2657392035, 249268274, 2044508324, 3772115230, 2547177864, 162941995, 2125561021, 3887607047, 2428444049, 498536548, 1789927666, 4089016648, 2227061214, 450548861, 1843258603, 4107580753, 2211677639, 325883990, 1684777152, 4251122042, 2321926636, 335633487, 1661365465, 4195302755, 2366115317, 997073096, 1281953886, 3579855332, 2724688242, 1006888145, 1258607687, 3524101629, 2768942443, 901097722, 1119000684, 3686517206, 2898065728, 853044451, 1172266101, 3705015759, 2882616665, 651767980, 1373503546, 3369554304, 3218104598, 565507253, 1454621731, 3485111705, 3099436303, 671266974, 1594198024, 3322730930, 2970347812, 795835527, 1483230225, 3244367275, 3060149565, 1994146192, 31158534, 2563907772, 4023717930, 1907459465, 112637215, 2680153253, 3904427059, 2013776290, 251722036, 2517215374, 3775830040, 2137656763, 141376813, 2439277719, 3865271297, 1802195444, 476864866, 2238001368, 4066508878, 1812370925, 453092731, 2181625025, 4111451223, 1706088902, 314042704, 2344532202, 4240017532, 1658658271, 366619977, 2362670323, 4224994405, 1303535960, 984961486, 2747007092, 3569037538, 1256170817, 1037604311, 2765210733, 3554079995, 1131014506, 879679996, 2909243462, 3663771856, 1141124467, 855842277, 2852801631, 3708648649, 1342533948, 654459306, 3188396048, 3373015174, 1466479909, 544179635, 3110523913, 3462522015, 1591671054, 702138776, 2966460450, 3352799412, 1504918807, 783551873, 3082640443, 3233442989, 3988292384, 2596254646, 62317068, 1957810842, 3939845945, 2647816111, 81470997, 1943803523, 3814918930, 2489596804, 225274430, 2053790376, 3826175755, 2466906013, 167816743, 2097651377, 4027552580, 2265490386, 503444072, 1762050814, 4150417245, 2154129355, 426522225, 1852507879, 4275313526, 2312317920, 282753626, 1742555852, 4189708143, 2394877945, 397917763, 1622183637, 3604390888, 2714866558, 953729732, 1340076626, 3518719985, 2797360999, 1068828381, 1219638859, 3624741850, 2936675148, 906185462, 1090812512, 3747672003, 2825379669, 829329135, 1181335161, 3412177804, 3160834842, 628085408, 1382605366, 3423369109, 3138078467, 570562233, 1426400815, 3317316542, 2998733608, 733239954, 1555261956, 3268935591, 3050360625, 752459403, 1541320221, 2607071920, 3965973030, 1969922972, 40735498, 2617837225, 3943577151, 1913087877, 83908371, 2512341634, 3803740692, 2075208622, 213261112, 2463272603, 3855990285, 2094854071, 198958881, 2262029012, 4057260610, 1759359992, 534414190, 2176718541, 4139329115, 1873836001, 414664567, 2282248934, 4279200368, 1711684554, 285281116, 2405801727, 4167216745, 1634467795, 376229701, 2685067896, 3608007406, 1308918612, 956543938, 2808555105, 3495958263, 1231636301, 1047427035, 2932959818, 3654703836, 1088359270, 936918e3, 2847714899, 3736837829, 1202900863, 817233897, 3183342108, 3401237130, 1404277552, 615818150, 3134207493, 3453421203, 1423857449, 601450431, 3009837614, 3294710456, 1567103746, 711928724, 3020668471, 3272380065, 1510334235, 755167117], ie = -1, ne = 0;
      Y.length;
      var ae;
      for (ae = ee; ae < K; ae++) ne = (ie ^ Y[ae]) & 255, ie = ie >>> 8 ^ te[ne];
      return ie ^ -1;
    }
    var F = D[0].length, I = D[0][0].length, z, R, L, q, U, Z, V, G, W, J, X = [137, 80, 78, 71, 13, 10, 26, 10, 0, 0, 0, 13, 73, 72, 68, 82, I >> 24 & 255, I >> 16 & 255, I >> 8 & 255, I & 255, F >> 24 & 255, F >> 16 & 255, F >> 8 & 255, F & 255, 8, 2, 0, 0, 0, -1, -2, -3, -4, -5, -6, -7, -8, 73, 68, 65, 84, 8, 29];
    for (J = O(X, 12, 29), X[29] = J >> 24 & 255, X[30] = J >> 16 & 255, X[31] = J >> 8 & 255, X[32] = J & 255, z = 1, R = 0, V = 0; V < F; V++) {
      for (V < F - 1 ? X.push(0) : X.push(1), U = 3 * I + 1 + (V === 0) & 255, Z = 3 * I + 1 + (V === 0) >> 8 & 255, X.push(U), X.push(Z), X.push(~U & 255), X.push(~Z & 255), V === 0 && X.push(0), G = 0; G < I; G++) for (L = 0; L < 3; L++) U = D[L][V][G], U = U > 255 ? 255 : U < 0 ? 0 : Math.round(U), z = (z + U) % 65521, R = (R + z) % 65521, X.push(U);
      X.push(0);
    }
    return W = (R << 16) + z, X.push(W >> 24 & 255), X.push(W >> 16 & 255), X.push(W >> 8 & 255), X.push(W & 255), q = X.length - 41, X[33] = q >> 24 & 255, X[34] = q >> 16 & 255, X[35] = q >> 8 & 255, X[36] = q & 255, J = O(X, 37), X.push(J >> 24 & 255), X.push(J >> 16 & 255), X.push(J >> 8 & 255), X.push(J & 255), X.push(0), X.push(0), X.push(0), X.push(0), X.push(73), X.push(69), X.push(78), X.push(68), X.push(174), X.push(66), X.push(96), X.push(130), "data:image/png;base64," + E(X);
  }, numeric._dim = function(D) {
    for (var E = []; typeof D == "object"; ) E.push(D.length), D = D[0];
    return E;
  }, numeric.dim = function(D) {
    var E, O;
    return typeof D == "object" ? (E = D[0], typeof E == "object" ? (O = E[0], typeof O == "object" ? numeric._dim(D) : [D.length, E.length]) : [D.length]) : [];
  }, numeric.mapreduce = function(D, E) {
    return Function("x", "accum", "_s", "_k", 'if(typeof accum === "undefined") accum = ' + E + `;
if(typeof x === "number") { var xi = x; ` + D + `; return accum; }
if(typeof _s === "undefined") _s = numeric.dim(x);
if(typeof _k === "undefined") _k = 0;
var _n = _s[_k];
var i,xi;
if(_k < _s.length-1) {
    for(i=_n-1;i>=0;i--) {
        accum = arguments.callee(x[i],accum,_s,_k+1);
    }    return accum;
}
for(i=_n-1;i>=1;i-=2) { 
    xi = x[i];
    ` + D + `;
    xi = x[i-1];
    ` + D + `;
}
if(i === 0) {
    xi = x[i];
    ` + D + `
}
return accum;`);
  }, numeric.mapreduce2 = function(D, E) {
    return Function("x", `var n = x.length;
var i,xi;
` + E + `;
for(i=n-1;i!==-1;--i) { 
    xi = x[i];
    ` + D + `;
}
return accum;`);
  }, numeric.same = function D(E, O) {
    var F, I;
    if (!(E instanceof Array) || !(O instanceof Array) || (I = E.length, I !== O.length)) return !1;
    for (F = 0; F < I; F++) if (E[F] !== O[F]) if (typeof E[F] == "object") {
      if (!D(E[F], O[F])) return !1;
    } else return !1;
    return !0;
  }, numeric.rep = function(D, E, O) {
    O === void 0 && (O = 0);
    var F = D[O], I = Array(F), z;
    if (O === D.length - 1) {
      for (z = F - 2; z >= 0; z -= 2) I[z + 1] = E, I[z] = E;
      return z === -1 && (I[0] = E), I;
    }
    for (z = F - 1; z >= 0; z--) I[z] = numeric.rep(D, E, O + 1);
    return I;
  }, numeric.dotMMsmall = function(D, E) {
    var O, F, I, z = D.length, R = E.length, L = E[0].length, q = Array(z), U, Z, V, G;
    for (O = z - 1; O >= 0; O--) {
      for (U = Array(L), Z = D[O], I = L - 1; I >= 0; I--) {
        for (V = Z[R - 1] * E[R - 1][I], F = R - 2; F >= 1; F -= 2) G = F - 1, V += Z[F] * E[F][I] + Z[G] * E[G][I];
        F === 0 && (V += Z[0] * E[0][I]), U[I] = V;
      }
      q[O] = U;
    }
    return q;
  }, numeric._getCol = function(D, E, O) {
    var F = D.length, I;
    for (I = F - 1; I > 0; --I) O[I] = D[I][E], --I, O[I] = D[I][E];
    I === 0 && (O[0] = D[0][E]);
  }, numeric.dotMMbig = function(D, E) {
    var O = numeric._getCol, F = E.length, I = Array(F), z = D.length, R = E[0].length, L = Array(z), q, U = numeric.dotVV, Z, V;
    for (--F, --z, Z = z; Z !== -1; --Z) L[Z] = Array(R);
    for (--R, Z = R; Z !== -1; --Z) for (O(E, Z, I), V = z; V !== -1; --V) q = D[V], L[V][Z] = U(q, I);
    return L;
  }, numeric.dotMV = function(D, E) {
    var O = D.length;
    E.length;
    var F, I = Array(O), z = numeric.dotVV;
    for (F = O - 1; F >= 0; F--) I[F] = z(D[F], E);
    return I;
  }, numeric.dotVM = function(D, E) {
    var O, F, I = D.length, z = E[0].length, R = Array(z), L, q;
    for (F = z - 1; F >= 0; F--) {
      for (L = D[I - 1] * E[I - 1][F], O = I - 2; O >= 1; O -= 2) q = O - 1, L += D[O] * E[O][F] + D[q] * E[q][F];
      O === 0 && (L += D[0] * E[0][F]), R[F] = L;
    }
    return R;
  }, numeric.dotVV = function(D, E) {
    var O, F = D.length, I, z = D[F - 1] * E[F - 1];
    for (O = F - 2; O >= 1; O -= 2) I = O - 1, z += D[O] * E[O] + D[I] * E[I];
    return O === 0 && (z += D[0] * E[0]), z;
  }, numeric.dot = function(D, E) {
    var O = numeric.dim;
    switch (O(D).length * 1e3 + O(E).length) {
      case 2002:
        return E.length < 10 ? numeric.dotMMsmall(D, E) : numeric.dotMMbig(D, E);
      case 2001:
        return numeric.dotMV(D, E);
      case 1002:
        return numeric.dotVM(D, E);
      case 1001:
        return numeric.dotVV(D, E);
      case 1e3:
        return numeric.mulVS(D, E);
      case 1:
        return numeric.mulSV(D, E);
      case 0:
        return D * E;
      default:
        throw Error("numeric.dot only works on vectors and matrices");
    }
  }, numeric.diag = function(D) {
    var E, O, F, I = D.length, z = Array(I), R;
    for (E = I - 1; E >= 0; E--) {
      for (R = Array(I), O = E + 2, F = I - 1; F >= O; F -= 2) R[F] = 0, R[F - 1] = 0;
      for (F > E && (R[F] = 0), R[E] = D[E], F = E - 1; F >= 1; F -= 2) R[F] = 0, R[F - 1] = 0;
      F === 0 && (R[0] = 0), z[E] = R;
    }
    return z;
  }, numeric.getDiag = function(D) {
    var E = Math.min(D.length, D[0].length), O, F = Array(E);
    for (O = E - 1; O >= 1; --O) F[O] = D[O][O], --O, F[O] = D[O][O];
    return O === 0 && (F[0] = D[0][0]), F;
  }, numeric.identity = function(D) {
    return numeric.diag(numeric.rep([D], 1));
  }, numeric.pointwise = function(D, E, O) {
    O === void 0 && (O = "");
    var F = [], I, z = /\[i\]$/, R, L = "", q = !1;
    for (I = 0; I < D.length; I++) z.test(D[I]) ? (R = D[I].substring(0, D[I].length - 3), L = R) : R = D[I], R === "ret" && (q = !0), F.push(R);
    return F[D.length] = "_s", F[D.length + 1] = "_k", F[D.length + 2] = 'if(typeof _s === "undefined") _s = numeric.dim(' + L + `);
if(typeof _k === "undefined") _k = 0;
var _n = _s[_k];
var i` + (q ? "" : ", ret = Array(_n)") + `;
if(_k < _s.length-1) {
    for(i=_n-1;i>=0;i--) ret[i] = arguments.callee(` + D.join(",") + `,_s,_k+1);
    return ret;
}
` + O + `
for(i=_n-1;i!==-1;--i) {
    ` + E + `
}
return ret;`, Function.apply(null, F);
  }, numeric.pointwise2 = function(D, E, O) {
    O === void 0 && (O = "");
    var F = [], I, z = /\[i\]$/, R, L = "", q = !1;
    for (I = 0; I < D.length; I++) z.test(D[I]) ? (R = D[I].substring(0, D[I].length - 3), L = R) : R = D[I], R === "ret" && (q = !0), F.push(R);
    return F[D.length] = "var _n = " + L + `.length;
var i` + (q ? "" : ", ret = Array(_n)") + `;
` + O + `
for(i=_n-1;i!==-1;--i) {
` + E + `
}
return ret;`, Function.apply(null, F);
  }, numeric._biforeach = (function D(E, O, F, I, z) {
    if (I === F.length - 1) {
      z(E, O);
      return;
    }
    var R;
    for (R = F[I] - 1; R >= 0; R--) D(typeof E == "object" ? E[R] : E, typeof O == "object" ? O[R] : O, F, I + 1, z);
  }), numeric._biforeach2 = (function D(E, O, F, I, z) {
    if (I === F.length - 1) return z(E, O);
    var R, L = F[I], q = Array(L);
    for (R = L - 1; R >= 0; --R) q[R] = D(typeof E == "object" ? E[R] : E, typeof O == "object" ? O[R] : O, F, I + 1, z);
    return q;
  }), numeric._foreach = (function D(E, O, F, I) {
    if (F === O.length - 1) {
      I(E);
      return;
    }
    var z;
    for (z = O[F] - 1; z >= 0; z--) D(E[z], O, F + 1, I);
  }), numeric._foreach2 = (function D(E, O, F, I) {
    if (F === O.length - 1) return I(E);
    var z, R = O[F], L = Array(R);
    for (z = R - 1; z >= 0; z--) L[z] = D(E[z], O, F + 1, I);
    return L;
  }), numeric.ops2 = { add: "+", sub: "-", mul: "*", div: "/", mod: "%", and: "&&", or: "||", eq: "===", neq: "!==", lt: "<", gt: ">", leq: "<=", geq: ">=", band: "&", bor: "|", bxor: "^", lshift: "<<", rshift: ">>", rrshift: ">>>" }, numeric.opseq = { addeq: "+=", subeq: "-=", muleq: "*=", diveq: "/=", modeq: "%=", lshifteq: "<<=", rshifteq: ">>=", rrshifteq: ">>>=", bandeq: "&=", boreq: "|=", bxoreq: "^=" }, numeric.mathfuns = ["abs", "acos", "asin", "atan", "ceil", "cos", "exp", "floor", "log", "round", "sin", "sqrt", "tan", "isNaN", "isFinite"], numeric.mathfuns2 = ["atan2", "pow", "max", "min"], numeric.ops1 = { neg: "-", not: "!", bnot: "~", clone: "" }, numeric.mapreducers = { any: ["if(xi) return true;", "var accum = false;"], all: ["if(!xi) return false;", "var accum = true;"], sum: ["accum += xi;", "var accum = 0;"], prod: ["accum *= xi;", "var accum = 1;"], norm2Squared: ["accum += xi*xi;", "var accum = 0;"], norminf: ["accum = max(accum,abs(xi));", "var accum = 0, max = Math.max, abs = Math.abs;"], norm1: ["accum += abs(xi)", "var accum = 0, abs = Math.abs;"], sup: ["accum = max(accum,xi);", "var accum = -Infinity, max = Math.max;"], inf: ["accum = min(accum,xi);", "var accum = Infinity, min = Math.min;"] }, (function() {
    var D, E;
    for (D = 0; D < numeric.mathfuns2.length; ++D) E = numeric.mathfuns2[D], numeric.ops2[E] = E;
    for (D in numeric.ops2) if (numeric.ops2.hasOwnProperty(D)) {
      E = numeric.ops2[D];
      var O, F, I = "";
      numeric.myIndexOf.call(numeric.mathfuns2, D) === -1 ? (O = function(z, R, L) {
        return z + " = " + R + " " + E + " " + L;
      }, F = numeric.opseq.hasOwnProperty(D + "eq") ? function(z, R) {
        return z + " " + E + "= " + R;
      } : function(z, R) {
        return z + " = " + z + " " + E + " " + R;
      }) : (I = "var " + E + " = Math." + E + `;
`, O = function(z, R, L) {
        return z + " = " + E + "(" + R + "," + L + ")";
      }, F = function(z, R) {
        return z + " = " + E + "(" + z + "," + R + ")";
      }), numeric[D + "VV"] = numeric.pointwise2(["x[i]", "y[i]"], O("ret[i]", "x[i]", "y[i]"), I), numeric[D + "SV"] = numeric.pointwise2(["x", "y[i]"], O("ret[i]", "x", "y[i]"), I), numeric[D + "VS"] = numeric.pointwise2(["x[i]", "y"], O("ret[i]", "x[i]", "y"), I), numeric[D] = Function(`var n = arguments.length, i, x = arguments[0], y;
var VV = numeric.` + D + "VV, VS = numeric." + D + "VS, SV = numeric." + D + `SV;
var dim = numeric.dim;
for(i=1;i!==n;++i) { 
  y = arguments[i];
  if(typeof x === "object") {
      if(typeof y === "object") x = numeric._biforeach2(x,y,dim(x),0,VV);
      else x = numeric._biforeach2(x,y,dim(x),0,VS);
  } else if(typeof y === "object") x = numeric._biforeach2(x,y,dim(y),0,SV);
  else ` + F("x", "y") + `
}
return x;
`), numeric[E] = numeric[D], numeric[D + "eqV"] = numeric.pointwise2(["ret[i]", "x[i]"], F("ret[i]", "x[i]"), I), numeric[D + "eqS"] = numeric.pointwise2(["ret[i]", "x"], F("ret[i]", "x"), I), numeric[D + "eq"] = Function(`var n = arguments.length, i, x = arguments[0], y;
var V = numeric.` + D + "eqV, S = numeric." + D + `eqS
var s = numeric.dim(x);
for(i=1;i!==n;++i) { 
  y = arguments[i];
  if(typeof y === "object") numeric._biforeach(x,y,s,0,V);
  else numeric._biforeach(x,y,s,0,S);
}
return x;
`);
    }
    for (D = 0; D < numeric.mathfuns2.length; ++D) E = numeric.mathfuns2[D], delete numeric.ops2[E];
    for (D = 0; D < numeric.mathfuns.length; ++D) E = numeric.mathfuns[D], numeric.ops1[E] = E;
    for (D in numeric.ops1) numeric.ops1.hasOwnProperty(D) && (I = "", E = numeric.ops1[D], numeric.myIndexOf.call(numeric.mathfuns, D) !== -1 && Math.hasOwnProperty(E) && (I = "var " + E + " = Math." + E + `;
`), numeric[D + "eqV"] = numeric.pointwise2(["ret[i]"], "ret[i] = " + E + "(ret[i]);", I), numeric[D + "eq"] = Function("x", 'if(typeof x !== "object") return ' + E + `x
var i;
var V = numeric.` + D + `eqV;
var s = numeric.dim(x);
numeric._foreach(x,s,0,V);
return x;
`), numeric[D + "V"] = numeric.pointwise2(["x[i]"], "ret[i] = " + E + "(x[i]);", I), numeric[D] = Function("x", 'if(typeof x !== "object") return ' + E + `(x)
var i;
var V = numeric.` + D + `V;
var s = numeric.dim(x);
return numeric._foreach2(x,s,0,V);
`));
    for (D = 0; D < numeric.mathfuns.length; ++D) E = numeric.mathfuns[D], delete numeric.ops1[E];
    for (D in numeric.mapreducers) numeric.mapreducers.hasOwnProperty(D) && (E = numeric.mapreducers[D], numeric[D + "V"] = numeric.mapreduce2(E[0], E[1]), numeric[D] = Function("x", "s", "k", E[1] + `if(typeof x !== "object") {    xi = x;
` + E[0] + `;
    return accum;
}if(typeof s === "undefined") s = numeric.dim(x);
if(typeof k === "undefined") k = 0;
if(k === s.length-1) return numeric.` + D + `V(x);
var xi;
var n = x.length, i;
for(i=n-1;i!==-1;--i) {
   xi = arguments.callee(x[i]);
` + E[0] + `;
}
return accum;
`));
  })(), numeric.truncVV = numeric.pointwise(["x[i]", "y[i]"], "ret[i] = round(x[i]/y[i])*y[i];", "var round = Math.round;"), numeric.truncVS = numeric.pointwise(["x[i]", "y"], "ret[i] = round(x[i]/y)*y;", "var round = Math.round;"), numeric.truncSV = numeric.pointwise(["x", "y[i]"], "ret[i] = round(x/y[i])*y[i];", "var round = Math.round;"), numeric.trunc = function(D, E) {
    return typeof D == "object" ? typeof E == "object" ? numeric.truncVV(D, E) : numeric.truncVS(D, E) : typeof E == "object" ? numeric.truncSV(D, E) : Math.round(D / E) * E;
  }, numeric.inv = function(J) {
    var E = numeric.dim(J), O = Math.abs, F = E[0], I = E[1], z = numeric.clone(J), R, L, q = numeric.identity(F), U, Z, V, G, W, J;
    for (G = 0; G < I; ++G) {
      var X = -1, Y = -1;
      for (V = G; V !== F; ++V) W = O(z[V][G]), W > Y && (X = V, Y = W);
      for (L = z[X], z[X] = z[G], z[G] = L, Z = q[X], q[X] = q[G], q[G] = Z, J = L[G], W = G; W !== I; ++W) L[W] /= J;
      for (W = I - 1; W !== -1; --W) Z[W] /= J;
      for (V = F - 1; V !== -1; --V) if (V !== G) {
        for (R = z[V], U = q[V], J = R[G], W = G + 1; W !== I; ++W) R[W] -= L[W] * J;
        for (W = I - 1; W > 0; --W) U[W] -= Z[W] * J, --W, U[W] -= Z[W] * J;
        W === 0 && (U[0] -= Z[0] * J);
      }
    }
    return q;
  }, numeric.det = function(D) {
    var E = numeric.dim(D);
    if (E.length !== 2 || E[0] !== E[1]) throw Error("numeric: det() only works on square matrices");
    var O = E[0], F = 1, I, z, R, L = numeric.clone(D), q, U, Z, V, G;
    for (z = 0; z < O - 1; z++) {
      for (R = z, I = z + 1; I < O; I++) Math.abs(L[I][z]) > Math.abs(L[R][z]) && (R = I);
      for (R !== z && (V = L[R], L[R] = L[z], L[z] = V, F *= -1), q = L[z], I = z + 1; I < O; I++) {
        for (U = L[I], Z = U[z] / q[z], R = z + 1; R < O - 1; R += 2) G = R + 1, U[R] -= q[R] * Z, U[G] -= q[G] * Z;
        R !== O && (U[R] -= q[R] * Z);
      }
      if (q[z] === 0) return 0;
      F *= q[z];
    }
    return F * L[z][z];
  }, numeric.transpose = function(D) {
    var E, O, F = D.length, I = D[0].length, z = Array(I), R, L, q;
    for (O = 0; O < I; O++) z[O] = Array(F);
    for (E = F - 1; E >= 1; E -= 2) {
      for (L = D[E], R = D[E - 1], O = I - 1; O >= 1; --O) q = z[O], q[E] = L[O], q[E - 1] = R[O], --O, q = z[O], q[E] = L[O], q[E - 1] = R[O];
      O === 0 && (q = z[0], q[E] = L[0], q[E - 1] = R[0]);
    }
    if (E === 0) {
      for (R = D[0], O = I - 1; O >= 1; --O) z[O][0] = R[O], --O, z[O][0] = R[O];
      O === 0 && (z[0][0] = R[0]);
    }
    return z;
  }, numeric.negtranspose = function(D) {
    var E, O, F = D.length, I = D[0].length, z = Array(I), R, L, q;
    for (O = 0; O < I; O++) z[O] = Array(F);
    for (E = F - 1; E >= 1; E -= 2) {
      for (L = D[E], R = D[E - 1], O = I - 1; O >= 1; --O) q = z[O], q[E] = -L[O], q[E - 1] = -R[O], --O, q = z[O], q[E] = -L[O], q[E - 1] = -R[O];
      O === 0 && (q = z[0], q[E] = -L[0], q[E - 1] = -R[0]);
    }
    if (E === 0) {
      for (R = D[0], O = I - 1; O >= 1; --O) z[O][0] = -R[O], --O, z[O][0] = -R[O];
      O === 0 && (z[0][0] = -R[0]);
    }
    return z;
  }, numeric._random = function D(E, O) {
    var F, I = E[O], z = Array(I), R;
    if (O === E.length - 1) {
      for (R = Math.random, F = I - 1; F >= 1; F -= 2) z[F] = R(), z[F - 1] = R();
      return F === 0 && (z[0] = R()), z;
    }
    for (F = I - 1; F >= 0; F--) z[F] = D(E, O + 1);
    return z;
  }, numeric.random = function(D) {
    return numeric._random(D, 0);
  }, numeric.norm2 = function(D) {
    return Math.sqrt(numeric.norm2Squared(D));
  }, numeric.linspace = function(D, E, O) {
    if (O === void 0 && (O = Math.max(Math.round(E - D) + 1, 1)), O < 2) return O === 1 ? [D] : [];
    var F, I = Array(O);
    for (O--, F = O; F >= 0; F--) I[F] = (F * E + (O - F) * D) / O;
    return I;
  }, numeric.getBlock = function(D, E, O) {
    var F = numeric.dim(D);
    function I(z, R) {
      var L, q = E[R], U = O[R] - q, Z = Array(U);
      if (R === F.length - 1) {
        for (L = U; L >= 0; L--) Z[L] = z[L + q];
        return Z;
      }
      for (L = U; L >= 0; L--) Z[L] = I(z[L + q], R + 1);
      return Z;
    }
    return I(D, 0);
  }, numeric.setBlock = function(D, E, O, F) {
    var I = numeric.dim(D);
    function z(R, L, q) {
      var U, Z = E[q], V = O[q] - Z;
      if (q === I.length - 1) for (U = V; U >= 0; U--) R[U + Z] = L[U];
      for (U = V; U >= 0; U--) z(R[U + Z], L[U], q + 1);
    }
    return z(D, F, 0), D;
  }, numeric.getRange = function(D, E, O) {
    var F = E.length, I = O.length, z, R, L = Array(F), q, U;
    for (z = F - 1; z !== -1; --z) for (L[z] = Array(I), q = L[z], U = D[E[z]], R = I - 1; R !== -1; --R) q[R] = U[O[R]];
    return L;
  }, numeric.blockMatrix = function(D) {
    var E = numeric.dim(D);
    if (E.length < 4) return numeric.blockMatrix([D]);
    var O = E[0], F = E[1], I = 0, z = 0, R, L, q;
    for (R = 0; R < O; ++R) I += D[R][0].length;
    for (L = 0; L < F; ++L) z += D[0][L][0].length;
    var U = Array(I);
    for (R = 0; R < I; ++R) U[R] = Array(z);
    var Z = 0, V, G, W, J, X;
    for (R = 0; R < O; ++R) {
      for (V = z, L = F - 1; L !== -1; --L) for (q = D[R][L], V -= q[0].length, W = q.length - 1; W !== -1; --W) for (X = q[W], G = U[Z + W], J = X.length - 1; J !== -1; --J) G[V + J] = X[J];
      Z += D[R][0].length;
    }
    return U;
  }, numeric.tensor = function(D, E) {
    if (typeof D == "number" || typeof E == "number") return numeric.mul(D, E);
    var O = numeric.dim(D), F = numeric.dim(E);
    if (O.length !== 1 || F.length !== 1) throw Error("numeric: tensor product is only defined for vectors");
    var I = O[0], z = F[0], R = Array(I), L, q, U, Z;
    for (q = I - 1; q >= 0; q--) {
      for (L = Array(z), Z = D[q], U = z - 1; U >= 3; --U) L[U] = Z * E[U], --U, L[U] = Z * E[U], --U, L[U] = Z * E[U], --U, L[U] = Z * E[U];
      for (; U >= 0; ) L[U] = Z * E[U], --U;
      R[q] = L;
    }
    return R;
  }, numeric.T = function(D, E) {
    this.x = D, this.y = E;
  }, numeric.t = function(D, E) {
    return new numeric.T(D, E);
  }, numeric.Tbinop = function(D, E, O, F, I) {
    if (numeric.indexOf, typeof I != "string") for (var z in I = "", numeric) numeric.hasOwnProperty(z) && (D.indexOf(z) >= 0 || E.indexOf(z) >= 0 || O.indexOf(z) >= 0 || F.indexOf(z) >= 0) && z.length > 1 && (I += "var " + z + " = numeric." + z + `;
`);
    return Function(["y"], `var x = this;
if(!(y instanceof numeric.T)) { y = new numeric.T(y); }
` + I + `
if(x.y) {  if(y.y) {    return new numeric.T(` + F + `);
  }
  return new numeric.T(` + O + `);
}
if(y.y) {
  return new numeric.T(` + E + `);
}
return new numeric.T(` + D + `);
`);
  }, numeric.T.prototype.add = numeric.Tbinop("add(x.x,y.x)", "add(x.x,y.x),y.y", "add(x.x,y.x),x.y", "add(x.x,y.x),add(x.y,y.y)"), numeric.T.prototype.sub = numeric.Tbinop("sub(x.x,y.x)", "sub(x.x,y.x),neg(y.y)", "sub(x.x,y.x),x.y", "sub(x.x,y.x),sub(x.y,y.y)"), numeric.T.prototype.mul = numeric.Tbinop("mul(x.x,y.x)", "mul(x.x,y.x),mul(x.x,y.y)", "mul(x.x,y.x),mul(x.y,y.x)", "sub(mul(x.x,y.x),mul(x.y,y.y)),add(mul(x.x,y.y),mul(x.y,y.x))"), numeric.T.prototype.reciprocal = function() {
    var D = numeric.mul, E = numeric.div;
    if (this.y) {
      var O = numeric.add(D(this.x, this.x), D(this.y, this.y));
      return new numeric.T(E(this.x, O), E(numeric.neg(this.y), O));
    }
    return new T(E(1, this.x));
  }, numeric.T.prototype.div = function(D) {
    if (D instanceof numeric.T || (D = new numeric.T(D)), D.y) return this.mul(D.reciprocal());
    var E = numeric.div;
    return this.y ? new numeric.T(E(this.x, D.x), E(this.y, D.x)) : new numeric.T(E(this.x, D.x));
  }, numeric.T.prototype.dot = numeric.Tbinop("dot(x.x,y.x)", "dot(x.x,y.x),dot(x.x,y.y)", "dot(x.x,y.x),dot(x.y,y.x)", "sub(dot(x.x,y.x),dot(x.y,y.y)),add(dot(x.x,y.y),dot(x.y,y.x))"), numeric.T.prototype.transpose = function() {
    var D = numeric.transpose, E = this.x, O = this.y;
    return O ? new numeric.T(D(E), D(O)) : new numeric.T(D(E));
  }, numeric.T.prototype.transjugate = function() {
    var D = numeric.transpose, E = this.x, O = this.y;
    return O ? new numeric.T(D(E), numeric.negtranspose(O)) : new numeric.T(D(E));
  }, numeric.Tunop = function(D, E, O) {
    return typeof O != "string" && (O = ""), Function(`var x = this;
` + O + `
if(x.y) {  ` + E + `;
}
` + D + `;
`);
  }, numeric.T.prototype.exp = numeric.Tunop("return new numeric.T(ex)", "return new numeric.T(mul(cos(x.y),ex),mul(sin(x.y),ex))", "var ex = numeric.exp(x.x), cos = numeric.cos, sin = numeric.sin, mul = numeric.mul;"), numeric.T.prototype.conj = numeric.Tunop("return new numeric.T(x.x);", "return new numeric.T(x.x,numeric.neg(x.y));"), numeric.T.prototype.neg = numeric.Tunop("return new numeric.T(neg(x.x));", "return new numeric.T(neg(x.x),neg(x.y));", "var neg = numeric.neg;"), numeric.T.prototype.sin = numeric.Tunop("return new numeric.T(numeric.sin(x.x))", "return x.exp().sub(x.neg().exp()).div(new numeric.T(0,2));"), numeric.T.prototype.cos = numeric.Tunop("return new numeric.T(numeric.cos(x.x))", "return x.exp().add(x.neg().exp()).div(2);"), numeric.T.prototype.abs = numeric.Tunop("return new numeric.T(numeric.abs(x.x));", "return new numeric.T(numeric.sqrt(numeric.add(mul(x.x,x.x),mul(x.y,x.y))));", "var mul = numeric.mul;"), numeric.T.prototype.log = numeric.Tunop("return new numeric.T(numeric.log(x.x));", `var theta = new numeric.T(numeric.atan2(x.y,x.x)), r = x.abs();
return new numeric.T(numeric.log(r.x),theta.x);`), numeric.T.prototype.norm2 = numeric.Tunop("return numeric.norm2(x.x);", `var f = numeric.norm2Squared;
return Math.sqrt(f(x.x)+f(x.y));`), numeric.T.prototype.inv = function() {
    var D = this;
    if (D.y === void 0) return new numeric.T(numeric.inv(D.x));
    var E = D.x.length, J, X, Y, O = numeric.identity(E), F = numeric.rep([E, E], 0), I = numeric.clone(D.x), z = numeric.clone(D.y), R, L, q, U, Z, V, G, W, J, X, Y, ee, K, te, ie, ne, ae, ue;
    for (J = 0; J < E; J++) {
      for (te = I[J][J], ie = z[J][J], ee = te * te + ie * ie, Y = J, X = J + 1; X < E; X++) te = I[X][J], ie = z[X][J], K = te * te + ie * ie, K > ee && (Y = X, ee = K);
      for (Y !== J && (ue = I[J], I[J] = I[Y], I[Y] = ue, ue = z[J], z[J] = z[Y], z[Y] = ue, ue = O[J], O[J] = O[Y], O[Y] = ue, ue = F[J], F[J] = F[Y], F[Y] = ue), R = I[J], L = z[J], Z = O[J], V = F[J], te = R[J], ie = L[J], X = J + 1; X < E; X++) ne = R[X], ae = L[X], R[X] = (ne * te + ae * ie) / ee, L[X] = (ae * te - ne * ie) / ee;
      for (X = 0; X < E; X++) ne = Z[X], ae = V[X], Z[X] = (ne * te + ae * ie) / ee, V[X] = (ae * te - ne * ie) / ee;
      for (X = J + 1; X < E; X++) {
        for (q = I[X], U = z[X], G = O[X], W = F[X], te = q[J], ie = U[J], Y = J + 1; Y < E; Y++) ne = R[Y], ae = L[Y], q[Y] -= ne * te - ae * ie, U[Y] -= ae * te + ne * ie;
        for (Y = 0; Y < E; Y++) ne = Z[Y], ae = V[Y], G[Y] -= ne * te - ae * ie, W[Y] -= ae * te + ne * ie;
      }
    }
    for (J = E - 1; J > 0; J--) for (Z = O[J], V = F[J], X = J - 1; X >= 0; X--) for (G = O[X], W = F[X], te = I[X][J], ie = z[X][J], Y = E - 1; Y >= 0; Y--) ne = Z[Y], ae = V[Y], G[Y] -= te * ne - ie * ae, W[Y] -= te * ae + ie * ne;
    return new numeric.T(O, F);
  }, numeric.T.prototype.get = function(D) {
    var E = this.x, O = this.y, F = 0, I, z = D.length;
    if (O) {
      for (; F < z; ) I = D[F], E = E[I], O = O[I], F++;
      return new numeric.T(E, O);
    }
    for (; F < z; ) I = D[F], E = E[I], F++;
    return new numeric.T(E);
  }, numeric.T.prototype.set = function(D, E) {
    var O = this.x, F = this.y, I = 0, z, R = D.length, L = E.x, q = E.y;
    if (R === 0) return q ? this.y = q : F && (this.y = void 0), this.x = O, this;
    if (q) {
      for (F || (F = numeric.rep(numeric.dim(O), 0), this.y = F); I < R - 1; ) z = D[I], O = O[z], F = F[z], I++;
      return z = D[I], O[z] = L, F[z] = q, this;
    }
    if (F) {
      for (; I < R - 1; ) z = D[I], O = O[z], F = F[z], I++;
      return z = D[I], O[z] = L, L instanceof Array ? F[z] = numeric.rep(numeric.dim(L), 0) : F[z] = 0, this;
    }
    for (; I < R - 1; ) z = D[I], O = O[z], I++;
    return z = D[I], O[z] = L, this;
  }, numeric.T.prototype.getRows = function(D, E) {
    var O = E - D + 1, F, I = Array(O), z, R = this.x, L = this.y;
    for (F = D; F <= E; F++) I[F - D] = R[F];
    if (L) {
      for (z = Array(O), F = D; F <= E; F++) z[F - D] = L[F];
      return new numeric.T(I, z);
    }
    return new numeric.T(I);
  }, numeric.T.prototype.setRows = function(D, E, O) {
    var F, I = this.x, z = this.y, R = O.x, L = O.y;
    for (F = D; F <= E; F++) I[F] = R[F - D];
    if (L) for (z || (z = numeric.rep(numeric.dim(I), 0), this.y = z), F = D; F <= E; F++) z[F] = L[F - D];
    else if (z) for (F = D; F <= E; F++) z[F] = numeric.rep([R[F - D].length], 0);
    return this;
  }, numeric.T.prototype.getRow = function(D) {
    var E = this.x, O = this.y;
    return O ? new numeric.T(E[D], O[D]) : new numeric.T(E[D]);
  }, numeric.T.prototype.setRow = function(D, E) {
    var O = this.x, F = this.y, I = E.x, z = E.y;
    return O[D] = I, z ? (F || (F = numeric.rep(numeric.dim(O), 0), this.y = F), F[D] = z) : F &&= numeric.rep([I.length], 0), this;
  }, numeric.T.prototype.getBlock = function(D, E) {
    var O = this.x, F = this.y, I = numeric.getBlock;
    return F ? new numeric.T(I(O, D, E), I(F, D, E)) : new numeric.T(I(O, D, E));
  }, numeric.T.prototype.setBlock = function(D, E, O) {
    O instanceof numeric.T || (O = new numeric.T(O));
    var F = this.x, I = this.y, z = numeric.setBlock, R = O.x, L = O.y;
    if (L) return I ||= (this.y = numeric.rep(numeric.dim(this), 0), this.y), z(F, D, E, R), z(I, D, E, L), this;
    z(F, D, E, R), I && z(I, D, E, numeric.rep(numeric.dim(R), 0));
  }, numeric.T.rep = function(D, E) {
    var O = numeric.T;
    E instanceof O || (E = new O(E));
    var F = E.x, I = E.y, z = numeric.rep;
    return I ? new O(z(D, F), z(D, I)) : new O(z(D, F));
  }, numeric.T.diag = function(D) {
    D instanceof numeric.T || (D = new numeric.T(D));
    var E = D.x, O = D.y, F = numeric.diag;
    return O ? new numeric.T(F(E), F(O)) : new numeric.T(F(E));
  }, numeric.T.eig = function() {
    if (this.y) throw Error("eig: not implemented for complex matrices.");
    return numeric.eig(this.x);
  }, numeric.T.identity = function(D) {
    return new numeric.T(numeric.identity(D));
  }, numeric.T.prototype.getDiag = function() {
    var D = numeric, E = this.x, O = this.y;
    return O ? new D.T(D.getDiag(E), D.getDiag(O)) : new D.T(D.getDiag(E));
  }, numeric.house = function(D) {
    var E = numeric.clone(D), O = (D[0] >= 0 ? 1 : -1) * numeric.norm2(D);
    E[0] += O;
    var F = numeric.norm2(E);
    if (F === 0) throw Error("eig: internal error");
    return numeric.div(E, F);
  }, numeric.toUpperHessenberg = function(D) {
    var E = numeric.dim(D);
    if (E.length !== 2 || E[0] !== E[1]) throw Error("numeric: toUpperHessenberg() only works on square matrices");
    var O = E[0], F, I, z, R, L, q = numeric.clone(D), U, Z, V, G, W = numeric.identity(O), J;
    for (I = 0; I < O - 2; I++) {
      for (R = Array(O - I - 1), F = I + 1; F < O; F++) R[F - I - 1] = q[F][I];
      if (numeric.norm2(R) > 0) {
        for (L = numeric.house(R), U = numeric.getBlock(q, [I + 1, I], [O - 1, O - 1]), Z = numeric.tensor(L, numeric.dot(L, U)), F = I + 1; F < O; F++) for (V = q[F], G = Z[F - I - 1], z = I; z < O; z++) V[z] -= 2 * G[z - I];
        for (U = numeric.getBlock(q, [0, I + 1], [O - 1, O - 1]), Z = numeric.tensor(numeric.dot(U, L), L), F = 0; F < O; F++) for (V = q[F], G = Z[F], z = I + 1; z < O; z++) V[z] -= 2 * G[z - I - 1];
        for (U = Array(O - I - 1), F = I + 1; F < O; F++) U[F - I - 1] = W[F];
        for (Z = numeric.tensor(L, numeric.dot(L, U)), F = I + 1; F < O; F++) for (J = W[F], G = Z[F - I - 1], z = 0; z < O; z++) J[z] -= 2 * G[z];
      }
    }
    return { H: q, Q: W };
  }, numeric.epsilon = 2220446049250313e-31, numeric.QRFrancis = function(D, E) {
    E === void 0 && (E = 1e4), D = numeric.clone(D), numeric.clone(D);
    var O = numeric.dim(D)[0], F, I, z, R, L, q, U, Z, V, G = numeric.identity(O), W, J, X, Y, ee, K, te, ie, ne;
    if (O < 3) return { Q: G, B: [[0, O - 1]] };
    var ae = numeric.epsilon;
    for (ne = 0; ne < E; ne++) {
      for (te = 0; te < O - 1; te++) if (Math.abs(D[te + 1][te]) < ae * (Math.abs(D[te][te]) + Math.abs(D[te + 1][te + 1]))) {
        var ue = numeric.QRFrancis(numeric.getBlock(D, [0, 0], [te, te]), E), oe = numeric.QRFrancis(numeric.getBlock(D, [te + 1, te + 1], [O - 1, O - 1]), E);
        for (X = Array(te + 1), K = 0; K <= te; K++) X[K] = G[K];
        for (Y = numeric.dot(ue.Q, X), K = 0; K <= te; K++) G[K] = Y[K];
        for (X = Array(O - te - 1), K = te + 1; K < O; K++) X[K - te - 1] = G[K];
        for (Y = numeric.dot(oe.Q, X), K = te + 1; K < O; K++) G[K] = Y[K - te - 1];
        return { Q: G, B: ue.B.concat(numeric.add(oe.B, te + 1)) };
      }
      if (z = D[O - 2][O - 2], R = D[O - 2][O - 1], L = D[O - 1][O - 2], q = D[O - 1][O - 1], Z = z + q, U = z * q - R * L, V = numeric.getBlock(D, [0, 0], [2, 2]), Z * Z >= 4 * U) {
        var se = 0.5 * (Z + Math.sqrt(Z * Z - 4 * U)), le = 0.5 * (Z - Math.sqrt(Z * Z - 4 * U));
        V = numeric.add(numeric.sub(numeric.dot(V, V), numeric.mul(V, se + le)), numeric.diag(numeric.rep([3], se * le)));
      } else V = numeric.add(numeric.sub(numeric.dot(V, V), numeric.mul(V, Z)), numeric.diag(numeric.rep([3], U)));
      for (F = [V[0][0], V[1][0], V[2][0]], I = numeric.house(F), X = [D[0], D[1], D[2]], Y = numeric.tensor(I, numeric.dot(I, X)), K = 0; K < 3; K++) for (J = D[K], ee = Y[K], ie = 0; ie < O; ie++) J[ie] -= 2 * ee[ie];
      for (X = numeric.getBlock(D, [0, 0], [O - 1, 2]), Y = numeric.tensor(numeric.dot(X, I), I), K = 0; K < O; K++) for (J = D[K], ee = Y[K], ie = 0; ie < 3; ie++) J[ie] -= 2 * ee[ie];
      for (X = [G[0], G[1], G[2]], Y = numeric.tensor(I, numeric.dot(I, X)), K = 0; K < 3; K++) for (W = G[K], ee = Y[K], ie = 0; ie < O; ie++) W[ie] -= 2 * ee[ie];
      var ce;
      for (te = 0; te < O - 2; te++) {
        for (ie = te; ie <= te + 1; ie++) if (Math.abs(D[ie + 1][ie]) < ae * (Math.abs(D[ie][ie]) + Math.abs(D[ie + 1][ie + 1]))) {
          var ue = numeric.QRFrancis(numeric.getBlock(D, [0, 0], [ie, ie]), E), oe = numeric.QRFrancis(numeric.getBlock(D, [ie + 1, ie + 1], [O - 1, O - 1]), E);
          for (X = Array(ie + 1), K = 0; K <= ie; K++) X[K] = G[K];
          for (Y = numeric.dot(ue.Q, X), K = 0; K <= ie; K++) G[K] = Y[K];
          for (X = Array(O - ie - 1), K = ie + 1; K < O; K++) X[K - ie - 1] = G[K];
          for (Y = numeric.dot(oe.Q, X), K = ie + 1; K < O; K++) G[K] = Y[K - ie - 1];
          return { Q: G, B: ue.B.concat(numeric.add(oe.B, ie + 1)) };
        }
        for (ce = Math.min(O - 1, te + 3), F = Array(ce - te), K = te + 1; K <= ce; K++) F[K - te - 1] = D[K][te];
        for (I = numeric.house(F), X = numeric.getBlock(D, [te + 1, te], [ce, O - 1]), Y = numeric.tensor(I, numeric.dot(I, X)), K = te + 1; K <= ce; K++) for (J = D[K], ee = Y[K - te - 1], ie = te; ie < O; ie++) J[ie] -= 2 * ee[ie - te];
        for (X = numeric.getBlock(D, [0, te + 1], [O - 1, ce]), Y = numeric.tensor(numeric.dot(X, I), I), K = 0; K < O; K++) for (J = D[K], ee = Y[K], ie = te + 1; ie <= ce; ie++) J[ie] -= 2 * ee[ie - te - 1];
        for (X = Array(ce - te), K = te + 1; K <= ce; K++) X[K - te - 1] = G[K];
        for (Y = numeric.tensor(I, numeric.dot(I, X)), K = te + 1; K <= ce; K++) for (W = G[K], ee = Y[K - te - 1], ie = 0; ie < O; ie++) W[ie] -= 2 * ee[ie];
      }
    }
    throw Error("numeric: eigenvalue iteration does not converge -- increase maxiter?");
  }, numeric.eig = function(D, E) {
    var O = numeric.toUpperHessenberg(D), F = numeric.QRFrancis(O.H, E), I = numeric.T, fe = D.length, z, R, L = F.B, q = numeric.dot(F.Q, numeric.dot(O.H, numeric.transpose(F.Q))), U = new I(numeric.dot(F.Q, O.Q)), Z, V = L.length, G, W, J, X, Y, ee, K, te, ie, ne, ae, ue, oe, se, le = Math.sqrt;
    for (R = 0; R < V; R++) if (z = L[R][0], z !== L[R][1]) {
      if (G = z + 1, W = q[z][z], J = q[z][G], X = q[G][z], Y = q[G][G], J === 0 && X === 0) continue;
      ee = -W - Y, K = W * Y - J * X, te = ee * ee - 4 * K, te >= 0 ? (ie = ee < 0 ? -0.5 * (ee - le(te)) : -0.5 * (ee + le(te)), oe = (W - ie) * (W - ie) + J * J, se = X * X + (Y - ie) * (Y - ie), oe > se ? (oe = le(oe), ae = (W - ie) / oe, ue = J / oe) : (se = le(se), ae = X / se, ue = (Y - ie) / se), Z = new I([[ue, -ae], [ae, ue]]), U.setRows(z, G, Z.dot(U.getRows(z, G)))) : (ie = -0.5 * ee, ne = 0.5 * le(-te), oe = (W - ie) * (W - ie) + J * J, se = X * X + (Y - ie) * (Y - ie), oe > se ? (oe = le(oe + ne * ne), ae = (W - ie) / oe, ue = J / oe, ie = 0, ne /= oe) : (se = le(se + ne * ne), ae = X / se, ue = (Y - ie) / se, ie = ne / se, ne = 0), Z = new I([[ue, -ae], [ae, ue]], [[ie, ne], [ne, -ie]]), U.setRows(z, G, Z.dot(U.getRows(z, G))));
    }
    var ce = U.dot(D).dot(U.transjugate()), fe = D.length, pe = numeric.T.identity(fe);
    for (G = 0; G < fe; G++) if (G > 0) for (R = G - 1; R >= 0; R--) {
      var ve = ce.get([R, R]), _e = ce.get([G, G]);
      if (numeric.neq(ve.x, _e.x) || numeric.neq(ve.y, _e.y)) ie = ce.getRow(R).getBlock([R], [G - 1]), ne = pe.getRow(G).getBlock([R], [G - 1]), pe.set([G, R], ce.get([R, G]).neg().sub(ie.dot(ne)).div(ve.sub(_e)));
      else {
        pe.setRow(G, pe.getRow(R));
        continue;
      }
    }
    for (G = 0; G < fe; G++) ie = pe.getRow(G), pe.setRow(G, ie.div(ie.norm2()));
    return pe = pe.transpose(), pe = U.transjugate().dot(pe), { lambda: ce.getDiag(), E: pe };
  }, numeric.ccsSparse = function(D) {
    var E = D.length, R, O, F, I, z = [];
    for (F = E - 1; F !== -1; --F) for (I in O = D[F], O) {
      for (I = parseInt(I); I >= z.length; ) z[z.length] = 0;
      O[I] !== 0 && z[I]++;
    }
    var R = z.length, L = Array(R + 1);
    for (L[0] = 0, F = 0; F < R; ++F) L[F + 1] = L[F] + z[F];
    var q = Array(L[R]), U = Array(L[R]);
    for (F = E - 1; F !== -1; --F) for (I in O = D[F], O) O[I] !== 0 && (z[I]--, q[L[I] + z[I]] = F, U[L[I] + z[I]] = O[I]);
    return [L, q, U];
  }, numeric.ccsFull = function(D) {
    var E = D[0], O = D[1], F = D[2], I = numeric.ccsDim(D), z = I[0], R = I[1], L, q, U, Z, V = numeric.rep([z, R], 0);
    for (L = 0; L < R; L++) for (U = E[L], Z = E[L + 1], q = U; q < Z; ++q) V[O[q]][L] = F[q];
    return V;
  }, numeric.ccsTSolve = function(D, E, O, F, I) {
    var z = D[0], R = D[1], L = D[2], q = z.length - 1, U = Math.max, Z = 0;
    F === void 0 && (O = numeric.rep([q], 0)), F === void 0 && (F = numeric.linspace(0, O.length - 1)), I === void 0 && (I = []);
    function V(te) {
      var ie;
      if (O[te] === 0) {
        for (O[te] = 1, ie = z[te]; ie < z[te + 1]; ++ie) V(R[ie]);
        I[Z] = te, ++Z;
      }
    }
    var G, W, J, X, Y, ee, K;
    for (G = F.length - 1; G !== -1; --G) V(F[G]);
    for (I.length = Z, G = I.length - 1; G !== -1; --G) O[I[G]] = 0;
    for (G = F.length - 1; G !== -1; --G) W = F[G], O[W] = E[W];
    for (G = I.length - 1; G !== -1; --G) {
      for (W = I[G], J = z[W], X = U(z[W + 1], J), Y = J; Y !== X; ++Y) if (R[Y] === W) {
        O[W] /= L[Y];
        break;
      }
      for (K = O[W], Y = J; Y !== X; ++Y) ee = R[Y], ee !== W && (O[ee] -= K * L[Y]);
    }
    return O;
  }, numeric.ccsDFS = function(D) {
    this.k = Array(D), this.k1 = Array(D), this.j = Array(D);
  }, numeric.ccsDFS.prototype.dfs = function(D, E, O, F, I, z) {
    var R = 0, L, q = I.length, U = this.k, Z = this.k1, V = this.j, G, W;
    if (F[D] === 0) for (F[D] = 1, V[0] = D, U[0] = G = E[D], Z[0] = W = E[D + 1]; ; ) if (G >= W) {
      if (I[q] = V[R], R === 0) return;
      ++q, --R, G = U[R], W = Z[R];
    } else L = z[O[G]], F[L] === 0 ? (F[L] = 1, U[R] = G, ++R, V[R] = L, G = E[L], Z[R] = W = E[L + 1]) : ++G;
  }, numeric.ccsLPSolve = function(D, E, O, F, I, z, R) {
    var L = D[0], q = D[1], U = D[2];
    L.length - 1;
    var Z = E[0], V = E[1], G = E[2], W, J = Z[I], X = Z[I + 1], Y, ee, K, te, ie, ne;
    for (F.length = 0, W = J; W < X; ++W) R.dfs(z[V[W]], L, q, O, F, z);
    for (W = F.length - 1; W !== -1; --W) O[F[W]] = 0;
    for (W = J; W !== X; ++W) Y = z[V[W]], O[Y] = G[W];
    for (W = F.length - 1; W !== -1; --W) {
      for (Y = F[W], ee = L[Y], K = L[Y + 1], te = ee; te < K; ++te) if (z[q[te]] === Y) {
        O[Y] /= U[te];
        break;
      }
      for (ne = O[Y], te = ee; te < K; ++te) ie = z[q[te]], ie !== Y && (O[ie] -= ne * U[te]);
    }
    return O;
  }, numeric.ccsLUP1 = function(D, E) {
    var O = D[0].length - 1, F = [numeric.rep([O + 1], 0), [], []], I = [numeric.rep([O + 1], 0), [], []], z = F[0], R = F[1], L = F[2], q = I[0], U = I[1], Z = I[2], V = numeric.rep([O], 0), G = numeric.rep([O], 0), W, J, X, Y, ee, K, te, ie = numeric.ccsLPSolve, ne = Math.abs, ae = numeric.linspace(0, O - 1), ue = numeric.linspace(0, O - 1), oe = new numeric.ccsDFS(O);
    for (E === void 0 && (E = 1), W = 0; W < O; ++W) {
      for (ie(F, D, V, G, W, ue, oe), Y = -1, ee = -1, J = G.length - 1; J !== -1; --J) X = G[J], !(X <= W) && (K = ne(V[X]), K > Y && (ee = X, Y = K));
      for (ne(V[W]) < E * Y && (J = ae[W], Y = ae[ee], ae[W] = Y, ue[Y] = W, ae[ee] = J, ue[J] = ee, Y = V[W], V[W] = V[ee], V[ee] = Y), Y = z[W], ee = q[W], te = V[W], R[Y] = ae[W], L[Y] = 1, ++Y, J = G.length - 1; J !== -1; --J) X = G[J], K = V[X], G[J] = 0, V[X] = 0, X <= W ? (U[ee] = X, Z[ee] = K, ++ee) : (R[Y] = ae[X], L[Y] = K / te, ++Y);
      z[W + 1] = Y, q[W + 1] = ee;
    }
    for (J = R.length - 1; J !== -1; --J) R[J] = ue[R[J]];
    return { L: F, U: I, P: ae, Pinv: ue };
  }, numeric.ccsDFS0 = function(D) {
    this.k = Array(D), this.k1 = Array(D), this.j = Array(D);
  }, numeric.ccsDFS0.prototype.dfs = function(D, E, O, F, I, z, R) {
    var L = 0, q, U = I.length, Z = this.k, V = this.k1, G = this.j, W, J;
    if (F[D] === 0) for (F[D] = 1, G[0] = D, Z[0] = W = E[z[D]], V[0] = J = E[z[D] + 1]; ; ) {
      if (isNaN(W)) throw Error("Ow!");
      if (W >= J) {
        if (I[U] = z[G[L]], L === 0) return;
        ++U, --L, W = Z[L], J = V[L];
      } else q = O[W], F[q] === 0 ? (F[q] = 1, Z[L] = W, ++L, G[L] = q, q = z[q], W = E[q], V[L] = J = E[q + 1]) : ++W;
    }
  }, numeric.ccsLPSolve0 = function(D, E, O, F, I, z, R, L) {
    var q = D[0], U = D[1], Z = D[2];
    q.length - 1;
    var V = E[0], G = E[1], W = E[2], J, X = V[I], Y = V[I + 1], ee, K, te, ie, ne, ae;
    for (F.length = 0, J = X; J < Y; ++J) L.dfs(G[J], q, U, O, F, z, R);
    for (J = F.length - 1; J !== -1; --J) ee = F[J], O[R[ee]] = 0;
    for (J = X; J !== Y; ++J) ee = G[J], O[ee] = W[J];
    for (J = F.length - 1; J !== -1; --J) {
      for (ee = F[J], ne = R[ee], K = q[ee], te = q[ee + 1], ie = K; ie < te; ++ie) if (U[ie] === ne) {
        O[ne] /= Z[ie];
        break;
      }
      for (ae = O[ne], ie = K; ie < te; ++ie) O[U[ie]] -= ae * Z[ie];
      O[ne] = ae;
    }
  }, numeric.ccsLUP0 = function(D, E) {
    var O = D[0].length - 1, F = [numeric.rep([O + 1], 0), [], []], I = [numeric.rep([O + 1], 0), [], []], z = F[0], R = F[1], L = F[2], q = I[0], U = I[1], Z = I[2], V = numeric.rep([O], 0), G = numeric.rep([O], 0), W, J, X, Y, ee, K, te, ie = numeric.ccsLPSolve0, ne = Math.abs, ae = numeric.linspace(0, O - 1), ue = numeric.linspace(0, O - 1), oe = new numeric.ccsDFS0(O);
    for (E === void 0 && (E = 1), W = 0; W < O; ++W) {
      for (ie(F, D, V, G, W, ue, ae, oe), Y = -1, ee = -1, J = G.length - 1; J !== -1; --J) X = G[J], !(X <= W) && (K = ne(V[ae[X]]), K > Y && (ee = X, Y = K));
      for (ne(V[ae[W]]) < E * Y && (J = ae[W], Y = ae[ee], ae[W] = Y, ue[Y] = W, ae[ee] = J, ue[J] = ee), Y = z[W], ee = q[W], te = V[ae[W]], R[Y] = ae[W], L[Y] = 1, ++Y, J = G.length - 1; J !== -1; --J) X = G[J], K = V[ae[X]], G[J] = 0, V[ae[X]] = 0, X <= W ? (U[ee] = X, Z[ee] = K, ++ee) : (R[Y] = ae[X], L[Y] = K / te, ++Y);
      z[W + 1] = Y, q[W + 1] = ee;
    }
    for (J = R.length - 1; J !== -1; --J) R[J] = ue[R[J]];
    return { L: F, U: I, P: ae, Pinv: ue };
  }, numeric.ccsLUP = numeric.ccsLUP0, numeric.ccsDim = function(D) {
    return [numeric.sup(D[1]) + 1, D[0].length - 1];
  }, numeric.ccsGetBlock = function(D, E, O) {
    var F = numeric.ccsDim(D), I = F[0], z = F[1];
    E === void 0 ? E = numeric.linspace(0, I - 1) : typeof E == "number" && (E = [E]), O === void 0 ? O = numeric.linspace(0, z - 1) : typeof O == "number" && (O = [O]);
    var R, L = E.length, q, U = O.length, Z, V, G, W = numeric.rep([z], 0), J = [], X = [], Y = [W, J, X], ee = D[0], K = D[1], te = D[2], ie = numeric.rep([I], 0), ne = 0, ae = numeric.rep([I], 0);
    for (q = 0; q < U; ++q) {
      V = O[q];
      var ue = ee[V], oe = ee[V + 1];
      for (R = ue; R < oe; ++R) Z = K[R], ae[Z] = 1, ie[Z] = te[R];
      for (R = 0; R < L; ++R) G = E[R], ae[G] && (J[ne] = R, X[ne] = ie[E[R]], ++ne);
      for (R = ue; R < oe; ++R) Z = K[R], ae[Z] = 0;
      W[q + 1] = ne;
    }
    return Y;
  }, numeric.ccsDot = function(D, E) {
    var O = D[0], F = D[1], I = D[2], z = E[0], R = E[1], L = E[2], q = numeric.ccsDim(D), U = numeric.ccsDim(E), Z = q[0];
    q[1];
    var V = U[1], G = numeric.rep([Z], 0), W = numeric.rep([Z], 0), J = Array(Z), X = numeric.rep([V], 0), Y = [], ee = [], K = [X, Y, ee], te, ie, ne, ae, ue, oe, se, le, ce, fe, pe;
    for (ne = 0; ne !== V; ++ne) {
      for (ae = z[ne], ue = z[ne + 1], ce = 0, ie = ae; ie < ue; ++ie) for (fe = R[ie], pe = L[ie], oe = O[fe], se = O[fe + 1], te = oe; te < se; ++te) le = F[te], W[le] === 0 && (J[ce] = le, W[le] = 1, ce += 1), G[le] = G[le] + I[te] * pe;
      for (ae = X[ne], ue = ae + ce, X[ne + 1] = ue, ie = ce - 1; ie !== -1; --ie) pe = ae + ie, te = J[ie], Y[pe] = te, ee[pe] = G[te], W[te] = 0, G[te] = 0;
      X[ne + 1] = X[ne] + ce;
    }
    return K;
  }, numeric.ccsLUPSolve = function(D, E) {
    var O = D.L, F = D.U;
    D.P;
    var I = E[0], z = !1;
    typeof I != "object" && (E = [[0, E.length], numeric.linspace(0, E.length - 1), E], I = E[0], z = !0);
    var R = E[1], L = E[2], q = O[0].length - 1, U = I.length - 1, Z = numeric.rep([q], 0), V = Array(q), G = numeric.rep([q], 0), W = Array(q), J = numeric.rep([U + 1], 0), X = [], Y = [], ee = numeric.ccsTSolve, K, te, ie, ne, ae, ue, oe = 0;
    for (K = 0; K < U; ++K) {
      for (ae = 0, ie = I[K], ne = I[K + 1], te = ie; te < ne; ++te) ue = D.Pinv[R[te]], W[ae] = ue, G[ue] = L[te], ++ae;
      for (W.length = ae, ee(O, G, Z, W, V), te = W.length - 1; te !== -1; --te) G[W[te]] = 0;
      if (ee(F, Z, G, V, W), z) return G;
      for (te = V.length - 1; te !== -1; --te) Z[V[te]] = 0;
      for (te = W.length - 1; te !== -1; --te) ue = W[te], X[oe] = ue, Y[oe] = G[ue], G[ue] = 0, ++oe;
      J[K + 1] = oe;
    }
    return [J, X, Y];
  }, numeric.ccsbinop = function(D, E) {
    return E === void 0 && (E = ""), Function("X", "Y", `var Xi = X[0], Xj = X[1], Xv = X[2];
var Yi = Y[0], Yj = Y[1], Yv = Y[2];
var n = Xi.length-1,m = Math.max(numeric.sup(Xj),numeric.sup(Yj))+1;
var Zi = numeric.rep([n+1],0), Zj = [], Zv = [];
var x = numeric.rep([m],0),y = numeric.rep([m],0);
var xk,yk,zk;
var i,j,j0,j1,k,p=0;
` + E + `for(i=0;i<n;++i) {
  j0 = Xi[i]; j1 = Xi[i+1];
  for(j=j0;j!==j1;++j) {
    k = Xj[j];
    x[k] = 1;
    Zj[p] = k;
    ++p;
  }
  j0 = Yi[i]; j1 = Yi[i+1];
  for(j=j0;j!==j1;++j) {
    k = Yj[j];
    y[k] = Yv[j];
    if(x[k] === 0) {
      Zj[p] = k;
      ++p;
    }
  }
  Zi[i+1] = p;
  j0 = Xi[i]; j1 = Xi[i+1];
  for(j=j0;j!==j1;++j) x[Xj[j]] = Xv[j];
  j0 = Zi[i]; j1 = Zi[i+1];
  for(j=j0;j!==j1;++j) {
    k = Zj[j];
    xk = x[k];
    yk = y[k];
` + D + `
    Zv[j] = zk;
  }
  j0 = Xi[i]; j1 = Xi[i+1];
  for(j=j0;j!==j1;++j) x[Xj[j]] = 0;
  j0 = Yi[i]; j1 = Yi[i+1];
  for(j=j0;j!==j1;++j) y[Yj[j]] = 0;
}
return [Zi,Zj,Zv];`);
  }, (function() {
    var k, A, B, C;
    for (k in numeric.ops2) A = isFinite(eval("1" + numeric.ops2[k] + "0")) ? "[Y[0],Y[1],numeric." + k + "(X,Y[2])]" : "NaN", B = isFinite(eval("0" + numeric.ops2[k] + "1")) ? "[X[0],X[1],numeric." + k + "(X[2],Y)]" : "NaN", C = isFinite(eval("1" + numeric.ops2[k] + "0")) && isFinite(eval("0" + numeric.ops2[k] + "1")) ? "numeric.ccs" + k + "MM(X,Y)" : "NaN", numeric["ccs" + k + "MM"] = numeric.ccsbinop("zk = xk " + numeric.ops2[k] + "yk;"), numeric["ccs" + k] = Function("X", "Y", 'if(typeof X === "number") return ' + A + `;
if(typeof Y === "number") return ` + B + `;
return ` + C + `;
`);
  })(), numeric.ccsScatter = function(D) {
    var E = D[0], O = D[1], F = D[2], I = numeric.sup(O) + 1, z = E.length, R = numeric.rep([I], 0), L = Array(z), q = Array(z), U = numeric.rep([I], 0), Z;
    for (Z = 0; Z < z; ++Z) U[O[Z]]++;
    for (Z = 0; Z < I; ++Z) R[Z + 1] = R[Z] + U[Z];
    var V = R.slice(0), G, W;
    for (Z = 0; Z < z; ++Z) W = O[Z], G = V[W], L[G] = E[Z], q[G] = F[Z], V[W] = V[W] + 1;
    return [R, L, q];
  }, numeric.ccsGather = function(D) {
    var E = D[0], O = D[1], F = D[2], I = E.length - 1, z = O.length, R = Array(z), L = Array(z), q = Array(z), U, Z, V, G, W = 0;
    for (U = 0; U < I; ++U) for (V = E[U], G = E[U + 1], Z = V; Z !== G; ++Z) L[W] = U, R[W] = O[Z], q[W] = F[Z], ++W;
    return [R, L, q];
  }, numeric.sdim = function D(E, O, F) {
    if (O === void 0 && (O = []), typeof E != "object") return O;
    for (var I in F === void 0 && (F = 0), F in O || (O[F] = 0), E.length > O[F] && (O[F] = E.length), E) E.hasOwnProperty(I) && D(E[I], O, F + 1);
    return O;
  }, numeric.sclone = function D(E, O, F) {
    O === void 0 && (O = 0), F === void 0 && (F = numeric.sdim(E).length);
    var I, z = Array(E.length);
    if (O === F - 1) {
      for (I in E) E.hasOwnProperty(I) && (z[I] = E[I]);
      return z;
    }
    for (I in E) E.hasOwnProperty(I) && (z[I] = D(E[I], O + 1, F));
    return z;
  }, numeric.sdiag = function(D) {
    var E = D.length, O, F = Array(E), I;
    for (O = E - 1; O >= 1; O -= 2) I = O - 1, F[O] = [], F[O][O] = D[O], F[I] = [], F[I][I] = D[I];
    return O === 0 && (F[0] = [], F[0][0] = D[O]), F;
  }, numeric.sidentity = function(D) {
    return numeric.sdiag(numeric.rep([D], 1));
  }, numeric.stranspose = function(D) {
    var E = [];
    D.length;
    var O, F, I;
    for (O in D) if (D.hasOwnProperty(O)) for (F in I = D[O], I) I.hasOwnProperty(F) && (typeof E[F] != "object" && (E[F] = []), E[F][O] = I[F]);
    return E;
  }, numeric.sLUP = function(D, E) {
    throw Error("The function numeric.sLUP had a bug in it and has been removed. Please use the new numeric.ccsLUP function instead.");
  }, numeric.sdotMM = function(D, E) {
    var O = D.length;
    E.length;
    var F = numeric.stranspose(E), I = F.length, z, R, L, q, U, Z, V = Array(O), G;
    for (L = O - 1; L >= 0; L--) {
      for (G = [], z = D[L], U = I - 1; U >= 0; U--) {
        for (q in Z = 0, R = F[U], z) z.hasOwnProperty(q) && q in R && (Z += z[q] * R[q]);
        Z && (G[U] = Z);
      }
      V[L] = G;
    }
    return V;
  }, numeric.sdotMV = function(D, E) {
    var O = D.length, F, I, z, R = Array(O), L;
    for (I = O - 1; I >= 0; I--) {
      for (z in F = D[I], L = 0, F) F.hasOwnProperty(z) && E[z] && (L += F[z] * E[z]);
      L && (R[I] = L);
    }
    return R;
  }, numeric.sdotVM = function(D, E) {
    var O, F, I, z, R = [];
    for (O in D) if (D.hasOwnProperty(O)) for (F in I = E[O], z = D[O], I) I.hasOwnProperty(F) && (R[F] || (R[F] = 0), R[F] += z * I[F]);
    return R;
  }, numeric.sdotVV = function(D, E) {
    var O, F = 0;
    for (O in D) D[O] && E[O] && (F += D[O] * E[O]);
    return F;
  }, numeric.sdot = function(D, E) {
    var O = numeric.sdim(D).length, F = numeric.sdim(E).length;
    switch (O * 1e3 + F) {
      case 0:
        return D * E;
      case 1001:
        return numeric.sdotVV(D, E);
      case 2001:
        return numeric.sdotMV(D, E);
      case 1002:
        return numeric.sdotVM(D, E);
      case 2002:
        return numeric.sdotMM(D, E);
      default:
        throw Error("numeric.sdot not implemented for tensors of order " + O + " and " + F);
    }
  }, numeric.sscatter = function(D) {
    var E = D[0].length, O, F, I, z = D.length, R = [], L;
    for (F = E - 1; F >= 0; --F) if (D[z - 1][F]) {
      for (L = R, I = 0; I < z - 2; I++) O = D[I][F], L[O] || (L[O] = []), L = L[O];
      L[D[I][F]] = D[I + 1][F];
    }
    return R;
  }, numeric.sgather = function D(E, O, F) {
    O === void 0 && (O = []), F === void 0 && (F = []);
    var I = F.length, z, R;
    for (z in E) if (E.hasOwnProperty(z)) if (F[I] = parseInt(z), R = E[z], typeof R == "number") {
      if (R) {
        if (O.length === 0) for (z = I + 1; z >= 0; --z) O[z] = [];
        for (z = I; z >= 0; --z) O[z].push(F[z]);
        O[I + 1].push(R);
      }
    } else D(R, O, F);
    return F.length > I && F.pop(), O;
  }, numeric.cLU = function(D) {
    var E = D[0], O = D[1], F = D[2], oe = E.length, I = 0, z, R, L, q, U, Z;
    for (z = 0; z < oe; z++) E[z] > I && (I = E[z]);
    I++;
    var V = Array(I), G = Array(I), W = numeric.rep([I], 1 / 0), J = numeric.rep([I], -1 / 0), K, te, X;
    for (L = 0; L < oe; L++) z = E[L], R = O[L], R < W[z] && (W[z] = R), R > J[z] && (J[z] = R);
    for (z = 0; z < I - 1; z++) J[z] > J[z + 1] && (J[z + 1] = J[z]);
    for (z = I - 1; z >= 1; z--) W[z] < W[z - 1] && (W[z - 1] = W[z]);
    var Y = 0, ee = 0;
    for (z = 0; z < I; z++) G[z] = numeric.rep([J[z] - W[z] + 1], 0), V[z] = numeric.rep([z - W[z]], 0), Y += z - W[z] + 1, ee += J[z] - z + 1;
    for (L = 0; L < oe; L++) z = E[L], G[z][O[L] - W[z]] = F[L];
    for (z = 0; z < I - 1; z++) for (q = z - W[z], K = G[z], R = z + 1; W[R] <= z && R < I; R++) if (U = z - W[R], Z = J[z] - z, te = G[R], X = te[U] / K[q], X) {
      for (L = 1; L <= Z; L++) te[L + U] -= X * K[L + q];
      V[R][z - W[R]] = X;
    }
    var K = [], te = [], ie = [], ne = [], ae = [], ue = [], oe = 0, se = 0, le;
    for (z = 0; z < I; z++) {
      for (q = W[z], U = J[z], le = G[z], R = z; R <= U; R++) le[R - q] && (K[oe] = z, te[oe] = R, ie[oe] = le[R - q], oe++);
      for (le = V[z], R = q; R < z; R++) le[R - q] && (ne[se] = z, ae[se] = R, ue[se] = le[R - q], se++);
      ne[se] = z, ae[se] = z, ue[se] = 1, se++;
    }
    return { U: [K, te, ie], L: [ne, ae, ue] };
  }, numeric.cLUsolve = function(D, E) {
    var O = D.L, F = D.U, I = numeric.clone(E), z = O[0], R = O[1], L = O[2], q = F[0], U = F[1], Z = F[2], V = q.length;
    z.length;
    var G = I.length, W, J = 0;
    for (W = 0; W < G; W++) {
      for (; R[J] < W; ) I[W] -= L[J] * I[R[J]], J++;
      J++;
    }
    for (J = V - 1, W = G - 1; W >= 0; W--) {
      for (; U[J] > W; ) I[W] -= Z[J] * I[U[J]], J--;
      I[W] /= Z[J], J--;
    }
    return I;
  }, numeric.cgrid = function(D, E) {
    typeof D == "number" && (D = [D, D]);
    var O = numeric.rep(D, -1), F, I, z;
    for (typeof E != "function" && (E === "L" ? E = function(R, L) {
      return R >= D[0] / 2 || L < D[1] / 2;
    } : E = function(R, L) {
      return !0;
    }), z = 0, F = 1; F < D[0] - 1; F++) for (I = 1; I < D[1] - 1; I++) E(F, I) && (O[F][I] = z, z++);
    return O;
  }, numeric.cdelsq = function(D) {
    var E = [[-1, 0], [0, -1], [0, 1], [1, 0]], O = numeric.dim(D), F = O[0], I = O[1], z, R, L, q, U, Z = [], V = [], G = [];
    for (z = 1; z < F - 1; z++) for (R = 1; R < I - 1; R++) if (!(D[z][R] < 0)) {
      for (L = 0; L < 4; L++) q = z + E[L][0], U = R + E[L][1], !(D[q][U] < 0) && (Z.push(D[z][R]), V.push(D[q][U]), G.push(-1));
      Z.push(D[z][R]), V.push(D[z][R]), G.push(4);
    }
    return [Z, V, G];
  }, numeric.cdotMV = function(D, E) {
    var O, F = D[0], I = D[1], z = D[2], R, L = F.length, q = 0;
    for (R = 0; R < L; R++) F[R] > q && (q = F[R]);
    for (q++, O = numeric.rep([q], 0), R = 0; R < L; R++) O[F[R]] += z[R] * E[I[R]];
    return O;
  }, numeric.Spline = function(D, E, O, F, I) {
    this.x = D, this.yl = E, this.yr = O, this.kl = F, this.kr = I;
  }, numeric.Spline.prototype._at = function(L, E) {
    var O = this.x, F = this.yl, I = this.yr, z = this.kl, R = this.kr, L, q, U, Z, V = numeric.add, G = numeric.sub, W = numeric.mul;
    q = G(W(z[E], O[E + 1] - O[E]), G(I[E + 1], F[E])), U = V(W(R[E + 1], O[E] - O[E + 1]), G(I[E + 1], F[E])), Z = (L - O[E]) / (O[E + 1] - O[E]);
    var J = Z * (1 - Z);
    return V(V(V(W(1 - Z, F[E]), W(Z, I[E + 1])), W(q, J * (1 - Z))), W(U, J * Z));
  }, numeric.Spline.prototype.at = function(D) {
    if (typeof D == "number") {
      var E = this.x, R = E.length, O, F, I, z = Math.floor;
      for (O = 0, F = R - 1; F - O > 1; ) I = z((O + F) / 2), E[I] <= D ? O = I : F = I;
      return this._at(D, O);
    }
    var R = D.length, L, q = Array(R);
    for (L = R - 1; L !== -1; --L) q[L] = this.at(D[L]);
    return q;
  }, numeric.Spline.prototype.diff = function() {
    var D = this.x, E = this.yl, O = this.yr, F = this.kl, I = this.kr, z = E.length, R, L, q, U = F, Z = I, V = Array(z), G = Array(z), W = numeric.add, J = numeric.mul, X = numeric.div, Y = numeric.sub;
    for (R = z - 1; R !== -1; --R) L = D[R + 1] - D[R], q = Y(O[R + 1], E[R]), V[R] = X(W(J(q, 6), J(F[R], -4 * L), J(I[R + 1], -2 * L)), L * L), G[R + 1] = X(W(J(q, -6), J(F[R], 2 * L), J(I[R + 1], 4 * L)), L * L);
    return new numeric.Spline(D, U, Z, V, G);
  }, numeric.Spline.prototype.roots = function() {
    function D(ye) {
      return ye * ye;
    }
    var X = [], E = this.x, O = this.yl, F = this.yr, I = this.kl, z = this.kr;
    typeof O[0] == "number" && (O = [O], F = [F], I = [I], z = [z]);
    var R = O.length, L = E.length - 1, q, U, Z, V, G, W, J, X = Array(R), Y, ee, K, te, ie, ne, ae, ue, oe, se, le, ce, fe, pe, ve, _e, de = Math.sqrt;
    for (q = 0; q !== R; ++q) {
      for (V = O[q], G = F[q], W = I[q], J = z[q], Y = [], U = 0; U !== L; U++) {
        for (U > 0 && G[U] * V[U] < 0 && Y.push(E[U]), oe = E[U + 1] - E[U], E[U], te = V[U], ie = G[U + 1], ee = W[U] / oe, K = J[U + 1] / oe, ue = D(ee - K + 3 * (te - ie)) + 12 * K * te, ne = K + 3 * te + 2 * ee - 3 * ie, ae = 3 * (K + ee + 2 * (te - ie)), ue <= 0 ? (le = ne / ae, se = le > E[U] && le < E[U + 1] ? [E[U], le, E[U + 1]] : [E[U], E[U + 1]]) : (le = (ne - de(ue)) / ae, ce = (ne + de(ue)) / ae, se = [E[U]], le > E[U] && le < E[U + 1] && se.push(le), ce > E[U] && ce < E[U + 1] && se.push(ce), se.push(E[U + 1])), pe = se[0], le = this._at(pe, U), Z = 0; Z < se.length - 1; Z++) {
          if (ve = se[Z + 1], ce = this._at(ve, U), le === 0) {
            Y.push(pe), pe = ve, le = ce;
            continue;
          }
          if (ce === 0 || le * ce > 0) {
            pe = ve, le = ce;
            continue;
          }
          for (var ge = 0; _e = (le * ve - ce * pe) / (le - ce), !(_e <= pe || _e >= ve); ) if (fe = this._at(_e, U), fe * ce > 0) ve = _e, ce = fe, ge === -1 && (le *= 0.5), ge = -1;
          else if (fe * le > 0) pe = _e, le = fe, ge === 1 && (ce *= 0.5), ge = 1;
          else break;
          Y.push(_e), pe = se[Z + 1], le = this._at(pe, U);
        }
        ce === 0 && Y.push(ve);
      }
      X[q] = Y;
    }
    return typeof this.yl[0] == "number" ? X[0] : X;
  }, numeric.spline = function(D, E, O, F) {
    var I = D.length, z = [], R = [], L = [], q, U = numeric.sub, Z = numeric.mul, V = numeric.add;
    for (q = I - 2; q >= 0; q--) R[q] = D[q + 1] - D[q], L[q] = U(E[q + 1], E[q]);
    (typeof O == "string" || typeof F == "string") && (O = F = "periodic");
    var G = [[], [], []];
    switch (typeof O) {
      case "undefined":
        z[0] = Z(3 / (R[0] * R[0]), L[0]), G[0].push(0, 0), G[1].push(0, 1), G[2].push(2 / R[0], 1 / R[0]);
        break;
      case "string":
        z[0] = V(Z(3 / (R[I - 2] * R[I - 2]), L[I - 2]), Z(3 / (R[0] * R[0]), L[0])), G[0].push(0, 0, 0), G[1].push(I - 2, 0, 1), G[2].push(1 / R[I - 2], 2 / R[I - 2] + 2 / R[0], 1 / R[0]);
        break;
      default:
        z[0] = O, G[0].push(0), G[1].push(0), G[2].push(1);
        break;
    }
    for (q = 1; q < I - 1; q++) z[q] = V(Z(3 / (R[q - 1] * R[q - 1]), L[q - 1]), Z(3 / (R[q] * R[q]), L[q])), G[0].push(q, q, q), G[1].push(q - 1, q, q + 1), G[2].push(1 / R[q - 1], 2 / R[q - 1] + 2 / R[q], 1 / R[q]);
    switch (typeof F) {
      case "undefined":
        z[I - 1] = Z(3 / (R[I - 2] * R[I - 2]), L[I - 2]), G[0].push(I - 1, I - 1), G[1].push(I - 2, I - 1), G[2].push(1 / R[I - 2], 2 / R[I - 2]);
        break;
      case "string":
        G[1][G[1].length - 1] = 0;
        break;
      default:
        z[I - 1] = F, G[0].push(I - 1), G[1].push(I - 1), G[2].push(1);
        break;
    }
    z = typeof z[0] == "number" ? [z] : numeric.transpose(z);
    var W = Array(z.length);
    if (typeof O == "string") for (q = W.length - 1; q !== -1; --q) W[q] = numeric.ccsLUPSolve(numeric.ccsLUP(numeric.ccsScatter(G)), z[q]), W[q][I - 1] = W[q][0];
    else for (q = W.length - 1; q !== -1; --q) W[q] = numeric.cLUsolve(numeric.cLU(G), z[q]);
    return W = typeof E[0] == "number" ? W[0] : numeric.transpose(W), new numeric.Spline(D, E, E, W, W);
  }, numeric.fftpow2 = function D(E, O) {
    var F = E.length;
    if (F !== 1) {
      var I = Math.cos, z = Math.sin, R, L, q = Array(F / 2), U = Array(F / 2), Z = Array(F / 2), V = Array(F / 2);
      for (L = F / 2, R = F - 1; R !== -1; --R) --L, Z[L] = E[R], V[L] = O[R], --R, q[L] = E[R], U[L] = O[R];
      D(q, U), D(Z, V), L = F / 2;
      var G, W = -6.283185307179586 / F, J, X;
      for (R = F - 1; R !== -1; --R) --L, L === -1 && (L = F / 2 - 1), G = W * R, J = I(G), X = z(G), E[R] = q[L] + J * Z[L] - X * V[L], O[R] = U[L] + J * V[L] + X * Z[L];
    }
  }, numeric._ifftpow2 = function D(E, O) {
    var F = E.length;
    if (F !== 1) {
      var I = Math.cos, z = Math.sin, R, L, q = Array(F / 2), U = Array(F / 2), Z = Array(F / 2), V = Array(F / 2);
      for (L = F / 2, R = F - 1; R !== -1; --R) --L, Z[L] = E[R], V[L] = O[R], --R, q[L] = E[R], U[L] = O[R];
      D(q, U), D(Z, V), L = F / 2;
      var G, W = 6.283185307179586 / F, J, X;
      for (R = F - 1; R !== -1; --R) --L, L === -1 && (L = F / 2 - 1), G = W * R, J = I(G), X = z(G), E[R] = q[L] + J * Z[L] - X * V[L], O[R] = U[L] + J * V[L] + X * Z[L];
    }
  }, numeric.ifftpow2 = function(D, E) {
    numeric._ifftpow2(D, E), numeric.diveq(D, D.length), numeric.diveq(E, E.length);
  }, numeric.convpow2 = function(D, E, O, F) {
    numeric.fftpow2(D, E), numeric.fftpow2(O, F);
    var I, z = D.length, R, L, q, U;
    for (I = z - 1; I !== -1; --I) R = D[I], q = E[I], L = O[I], U = F[I], D[I] = R * L - q * U, E[I] = R * U + q * L;
    numeric.ifftpow2(D, E);
  }, numeric.T.prototype.fft = function() {
    var D = this.x, E = this.y, O = D.length, F = Math.log, I = F(2), z = 2 ** Math.ceil(F(2 * O - 1) / I), R = numeric.rep([z], 0), L = numeric.rep([z], 0), q = Math.cos, U = Math.sin, Z, V = -3.141592653589793 / O, G, W = numeric.rep([z], 0), J = numeric.rep([z], 0);
    for (Z = 0; Z < O; Z++) W[Z] = D[Z];
    if (E !== void 0) for (Z = 0; Z < O; Z++) J[Z] = E[Z];
    for (R[0] = 1, Z = 1; Z <= z / 2; Z++) G = V * Z * Z, R[Z] = q(G), L[Z] = U(G), R[z - Z] = q(G), L[z - Z] = U(G);
    var X = new numeric.T(W, J), Y = new numeric.T(R, L);
    return X = X.mul(Y), numeric.convpow2(X.x, X.y, numeric.clone(Y.x), numeric.neg(Y.y)), X = X.mul(Y), X.x.length = O, X.y.length = O, X;
  }, numeric.T.prototype.ifft = function() {
    var D = this.x, E = this.y, O = D.length, F = Math.log, I = F(2), z = 2 ** Math.ceil(F(2 * O - 1) / I), R = numeric.rep([z], 0), L = numeric.rep([z], 0), q = Math.cos, U = Math.sin, Z, V = 3.141592653589793 / O, G, W = numeric.rep([z], 0), J = numeric.rep([z], 0);
    for (Z = 0; Z < O; Z++) W[Z] = D[Z];
    if (E !== void 0) for (Z = 0; Z < O; Z++) J[Z] = E[Z];
    for (R[0] = 1, Z = 1; Z <= z / 2; Z++) G = V * Z * Z, R[Z] = q(G), L[Z] = U(G), R[z - Z] = q(G), L[z - Z] = U(G);
    var X = new numeric.T(W, J), Y = new numeric.T(R, L);
    return X = X.mul(Y), numeric.convpow2(X.x, X.y, numeric.clone(Y.x), numeric.neg(Y.y)), X = X.mul(Y), X.x.length = O, X.y.length = O, X.div(O);
  }, numeric.gradient = function(D, E) {
    var O = E.length, F = D(E);
    if (isNaN(F)) throw Error("gradient: f(x) is a NaN!");
    var Z = Math.max, I, z = numeric.clone(E), R, L, q = Array(O);
    numeric.div, numeric.sub;
    var U, Z = Math.max, V = 1e-3, G = Math.abs, W = Math.min, J, X, Y, ee = 0, K, te, ie;
    for (I = 0; I < O; I++) for (var ne = Z(1e-6 * F, 1e-8); ; ) {
      if (++ee, ee > 20) throw Error("Numerical gradient fails");
      if (z[I] = E[I] + ne, R = D(z), z[I] = E[I] - ne, L = D(z), z[I] = E[I], isNaN(R) || isNaN(L)) {
        ne /= 16;
        continue;
      }
      if (q[I] = (R - L) / (2 * ne), J = E[I] - ne, X = E[I], Y = E[I] + ne, K = (R - F) / ne, te = (F - L) / ne, ie = Z(G(q[I]), G(F), G(R), G(L), G(J), G(X), G(Y), 1e-8), U = W(Z(G(K - q[I]), G(te - q[I]), G(K - te)) / ie, ne / ie), U > V) ne /= 16;
      else break;
    }
    return q;
  }, numeric.uncmin = function(D, E, O, F, I, z, R) {
    var L = numeric.gradient;
    R === void 0 && (R = {}), O === void 0 && (O = 1e-8), F === void 0 && (F = function(Ce) {
      return L(D, Ce);
    }), I === void 0 && (I = 1e3), E = numeric.clone(E);
    var q = E.length, U = D(E), Z, V;
    if (isNaN(U)) throw Error("uncmin: f(x0) is a NaN!");
    var G = Math.max, W = numeric.norm2;
    O = G(O, numeric.epsilon);
    var J, X, Y, ee = R.Hinv || numeric.identity(q), K = numeric.dot;
    numeric.inv;
    var te = numeric.sub, ie = numeric.add, ne = numeric.tensor, ae = numeric.div, ue = numeric.mul, oe = numeric.all, se = numeric.isFinite, le = numeric.neg, ce = 0, fe, pe, ve, _e, de, ge, ye, De = "";
    for (X = F(E); ce < I; ) {
      if (typeof z == "function" && z(ce, E, U, X, ee)) {
        De = "Callback returned true";
        break;
      }
      if (!oe(se(X))) {
        De = "Gradient has Infinity or NaN";
        break;
      }
      if (J = le(K(ee, X)), !oe(se(J))) {
        De = "Search direction has Infinity or NaN";
        break;
      }
      if (ye = W(J), ye < O) {
        De = "Newton step smaller than tol";
        break;
      }
      for (ge = 1, V = K(X, J), pe = E; ce < I && !(ge * ye < O); ) {
        if (fe = ue(J, ge), pe = ie(E, fe), Z = D(pe), Z - U >= 0.1 * ge * V || isNaN(Z)) {
          ge *= 0.5, ++ce;
          continue;
        }
        break;
      }
      if (ge * ye < O) {
        De = "Line search step size smaller than tol";
        break;
      }
      if (ce === I) {
        De = "maxit reached during line search";
        break;
      }
      Y = F(pe), ve = te(Y, X), de = K(ve, fe), _e = K(ee, ve), ee = te(ie(ee, ue((de + K(ve, _e)) / (de * de), ne(fe, fe))), ae(ie(ne(_e, fe), ne(fe, _e)), de)), E = pe, U = Z, X = Y, ++ce;
    }
    return { solution: E, f: U, gradient: X, invHessian: ee, iterations: ce, message: De };
  }, numeric.Dopri = function(D, E, O, F, I, z, R) {
    this.x = D, this.y = E, this.f = O, this.ymid = F, this.iterations = I, this.events = R, this.message = z;
  }, numeric.Dopri.prototype._at = function(J, E) {
    function O(ue) {
      return ue * ue;
    }
    var F = this, I = F.x, z = F.y, R = F.f, L = F.ymid;
    I.length;
    var q, U, Z, V, G, W, J, X, Y = 0.5, ee = numeric.add, K = numeric.mul, te = numeric.sub, ie, ne, ae;
    return q = I[E], U = I[E + 1], V = z[E], G = z[E + 1], X = U - q, Z = q + Y * X, W = L[E], ie = te(R[E], K(V, 1 / (q - Z) + 2 / (q - U))), ne = te(R[E + 1], K(G, 1 / (U - Z) + 2 / (U - q))), ae = [O(J - U) * (J - Z) / O(q - U) / (q - Z), O(J - q) * O(J - U) / O(q - Z) / O(U - Z), O(J - q) * (J - Z) / O(U - q) / (U - Z), (J - q) * O(J - U) * (J - Z) / O(q - U) / (q - Z), (J - U) * O(J - q) * (J - Z) / O(q - U) / (U - Z)], ee(ee(ee(ee(K(V, ae[0]), K(W, ae[1])), K(G, ae[2])), K(ie, ae[3])), K(ne, ae[4]));
  }, numeric.Dopri.prototype.at = function(D) {
    var E, O, F, I = Math.floor;
    if (typeof D != "number") {
      var z = D.length, R = Array(z);
      for (E = z - 1; E !== -1; --E) R[E] = this.at(D[E]);
      return R;
    }
    var L = this.x;
    for (E = 0, O = L.length - 1; O - E > 1; ) F = I(0.5 * (E + O)), L[F] <= D ? E = F : O = F;
    return this._at(D, E);
  }, numeric.dopri = function(D, E, O, F, I, z, R) {
    I === void 0 && (I = 1e-6), z === void 0 && (z = 1e3);
    var L = [D], q = [O], U = [F(D, O)], Z, V, G, W, J, X, Y = [], ee = 1 / 5, K = [3 / 40, 9 / 40], te = [44 / 45, -56 / 15, 32 / 9], ie = [19372 / 6561, -25360 / 2187, 64448 / 6561, -212 / 729], ne = [9017 / 3168, -355 / 33, 46732 / 5247, 49 / 176, -5103 / 18656], ae = [35 / 384, 0, 500 / 1113, 125 / 192, -2187 / 6784, 11 / 84], ue = [0.5 * 6025192743 / 30085553152, 0, 0.5 * 51252292925 / 65400821598, 0.5 * -2691868925 / 45128329728, 0.5 * 187940372067 / 1594534317056, 0.5 * -1776094331 / 19743644256, 0.5 * 11237099 / 235043384], oe = [1 / 5, 3 / 10, 4 / 5, 8 / 9, 1, 1], se = [-71 / 57600, 0, 71 / 16695, -71 / 1920, 17253 / 339200, -22 / 525, 1 / 40], le = 0, ce, fe, pe = (E - D) / 10, ve = 0, _e = numeric.add, de = numeric.mul, ge, ye, De = Math.min, Ce = Math.abs, Ie = numeric.norminf, Ne = Math.pow, he = numeric.any, ke = numeric.lt, xe = numeric.and;
    numeric.sub;
    var Te, Fe, be, Ae = new numeric.Dopri(L, q, U, Y, -1, "");
    for (typeof R == "function" && (Te = R(D, O)); D < E && ve < z; ) {
      if (++ve, D + pe > E && (pe = E - D), Z = F(D + oe[0] * pe, _e(O, de(ee * pe, U[le]))), V = F(D + oe[1] * pe, _e(_e(O, de(K[0] * pe, U[le])), de(K[1] * pe, Z))), G = F(D + oe[2] * pe, _e(_e(_e(O, de(te[0] * pe, U[le])), de(te[1] * pe, Z)), de(te[2] * pe, V))), W = F(D + oe[3] * pe, _e(_e(_e(_e(O, de(ie[0] * pe, U[le])), de(ie[1] * pe, Z)), de(ie[2] * pe, V)), de(ie[3] * pe, G))), J = F(D + oe[4] * pe, _e(_e(_e(_e(_e(O, de(ne[0] * pe, U[le])), de(ne[1] * pe, Z)), de(ne[2] * pe, V)), de(ne[3] * pe, G)), de(ne[4] * pe, W))), ge = _e(_e(_e(_e(_e(O, de(U[le], pe * ae[0])), de(V, pe * ae[2])), de(G, pe * ae[3])), de(W, pe * ae[4])), de(J, pe * ae[5])), X = F(D + pe, ge), ce = _e(_e(_e(_e(_e(de(U[le], pe * se[0]), de(V, pe * se[2])), de(G, pe * se[3])), de(W, pe * se[4])), de(J, pe * se[5])), de(X, pe * se[6])), ye = typeof ce == "number" ? Ce(ce) : Ie(ce), ye > I) {
        if (pe = 0.2 * pe * Ne(I / ye, 0.25), D + pe === D) {
          Ae.msg = "Step size became too small";
          break;
        }
        continue;
      }
      if (Y[le] = _e(_e(_e(_e(_e(_e(O, de(U[le], pe * ue[0])), de(V, pe * ue[2])), de(G, pe * ue[3])), de(W, pe * ue[4])), de(J, pe * ue[5])), de(X, pe * ue[6])), ++le, L[le] = D + pe, q[le] = ge, U[le] = X, typeof R == "function") {
        var Me, $e = D, Re = D + 0.5 * pe, je;
        if (Fe = R(Re, Y[le - 1]), be = xe(ke(Te, 0), ke(0, Fe)), he(be) || ($e = Re, Re = D + pe, Te = Fe, Fe = R(Re, ge), be = xe(ke(Te, 0), ke(0, Fe))), he(be)) {
          for (var Pe, Ke, Qe, We, ir = 0, nr = 1, we = 1; ; ) {
            if (typeof Te == "number") je = (we * Fe * $e - nr * Te * Re) / (we * Fe - nr * Te);
            else for (je = Re, fe = Te.length - 1; fe !== -1; --fe) Te[fe] < 0 && Fe[fe] > 0 && (je = De(je, (we * Fe[fe] * $e - nr * Te[fe] * Re) / (we * Fe[fe] - nr * Te[fe])));
            if (je <= $e || je >= Re) break;
            Me = Ae._at(je, le - 1), We = R(je, Me), Qe = xe(ke(Te, 0), ke(0, We)), he(Qe) ? (Re = je, Fe = We, be = Qe, we = 1, ir === -1 ? nr *= 0.5 : nr = 1, ir = -1) : ($e = je, Te = We, nr = 1, ir === 1 ? we *= 0.5 : we = 1, ir = 1);
          }
          return ge = Ae._at(0.5 * (D + je), le - 1), Ae.f[le] = F(je, Me), Ae.x[le] = je, Ae.y[le] = Me, Ae.ymid[le - 1] = ge, Ae.events = be, Ae.iterations = ve, Ae;
        }
      }
      D += pe, O = ge, Te = Fe, pe = De(0.8 * pe * Ne(I / ye, 0.25), 4 * pe);
    }
    return Ae.iterations = ve, Ae;
  }, numeric.LU = function(D, E) {
    E ||= !1;
    var O = Math.abs, F, I, z, R, L, q, U, Z, V, G = D.length, W = G - 1, J = Array(G);
    for (E || (D = numeric.clone(D)), z = 0; z < G; ++z) {
      for (U = z, q = D[z], V = O(q[z]), I = z + 1; I < G; ++I) R = O(D[I][z]), V < R && (V = R, U = I);
      for (J[z] = U, U != z && (D[z] = D[U], D[U] = q, q = D[z]), L = q[z], F = z + 1; F < G; ++F) D[F][z] /= L;
      for (F = z + 1; F < G; ++F) {
        for (Z = D[F], I = z + 1; I < W; ++I) Z[I] -= Z[z] * q[I], ++I, Z[I] -= Z[z] * q[I];
        I === W && (Z[I] -= Z[z] * q[I]);
      }
    }
    return { LU: D, P: J };
  }, numeric.LUsolve = function(D, E) {
    var O, F, I = D.LU, z = I.length, R = numeric.clone(E), L = D.P, q, U, Z;
    for (O = z - 1; O !== -1; --O) R[O] = E[O];
    for (O = 0; O < z; ++O) for (q = L[O], L[O] !== O && (Z = R[O], R[O] = R[q], R[q] = Z), U = I[O], F = 0; F < O; ++F) R[O] -= R[F] * U[F];
    for (O = z - 1; O >= 0; --O) {
      for (U = I[O], F = O + 1; F < z; ++F) R[O] -= R[F] * U[F];
      R[O] /= U[O];
    }
    return R;
  }, numeric.solve = function(D, E, O) {
    return numeric.LUsolve(numeric.LU(D, O), E);
  }, numeric.echelonize = function(D) {
    var E = numeric.dim(D), O = E[0], F = E[1], I = numeric.identity(O), z = Array(O), R, L, q, U, Z, V, G, W, J = Math.abs, X = numeric.diveq;
    for (D = numeric.clone(D), R = 0; R < O; ++R) {
      for (q = 0, Z = D[R], V = I[R], L = 1; L < F; ++L) J(Z[q]) < J(Z[L]) && (q = L);
      for (z[R] = q, X(V, Z[q]), X(Z, Z[q]), L = 0; L < O; ++L) if (L !== R) {
        for (G = D[L], W = G[q], U = F - 1; U !== -1; --U) G[U] -= Z[U] * W;
        for (G = I[L], U = O - 1; U !== -1; --U) G[U] -= V[U] * W;
      }
    }
    return { I, A: D, P: z };
  }, numeric.__solveLP = function(D, E, O, F, I, z, R) {
    var L = numeric.sum;
    numeric.log;
    var q = numeric.mul, U = numeric.sub, Z = numeric.dot, V = numeric.div, G = numeric.add, W = D.length, J = O.length, X, Y = !1, ee = 0, K = 1;
    numeric.transpose(E), numeric.svd;
    var te = numeric.transpose;
    numeric.leq;
    var ie = Math.sqrt, ne = Math.abs;
    numeric.muleq, numeric.norminf, numeric.any;
    var ae = Math.min, ue = numeric.all, oe = numeric.gt, se = Array(W), le = Array(J);
    numeric.rep([J], 1);
    var ce, fe = numeric.solve, pe = U(O, Z(E, z)), ve, _e = Z(D, D), de;
    for (ve = ee; ve < I; ++ve) {
      var ge, ye;
      for (ge = J - 1; ge !== -1; --ge) le[ge] = V(E[ge], pe[ge]);
      var De = te(le);
      for (ge = W - 1; ge !== -1; --ge) se[ge] = L(De[ge]);
      K = 0.25 * ne(_e / Z(D, se));
      var Ce = 100 * ie(_e / Z(se, se));
      for ((!isFinite(K) || K > Ce) && (K = Ce), de = G(D, q(K, se)), ce = Z(De, le), ge = W - 1; ge !== -1; --ge) ce[ge][ge] += 1;
      ye = fe(ce, V(de, K), !0);
      var Ie = V(pe, Z(E, ye)), Ne = 1;
      for (ge = J - 1; ge !== -1; --ge) Ie[ge] < 0 && (Ne = ae(Ne, -0.999 * Ie[ge]));
      if (X = U(z, q(ye, Ne)), pe = U(O, Z(E, X)), !ue(oe(pe, 0))) return { solution: z, message: "", iterations: ve };
      if (z = X, K < F) return { solution: X, message: "", iterations: ve };
      if (R) {
        var he = Z(D, de), ke = Z(E, de);
        for (Y = !0, ge = J - 1; ge !== -1; --ge) if (he * ke[ge] < 0) {
          Y = !1;
          break;
        }
      } else Y = !(z[W - 1] >= 0);
      if (Y) return { solution: X, message: "Unbounded", iterations: ve };
    }
    return { solution: z, message: "maximum iteration count exceeded", iterations: ve };
  }, numeric._solveLP = function(D, E, O, F, I) {
    var z = D.length, R = O.length, W;
    numeric.sum, numeric.log, numeric.mul;
    var L = numeric.sub, q = numeric.dot;
    numeric.div, numeric.add;
    var U = numeric.rep([z], 0).concat([1]), Z = numeric.rep([R, 1], -1), V = numeric.blockMatrix([[E, Z]]), G = O, W = numeric.rep([z], 0).concat(Math.max(0, numeric.sup(numeric.neg(O))) + 1), J = numeric.__solveLP(U, V, G, F, I, W, !1), X = numeric.clone(J.solution);
    if (X.length = z, numeric.inf(L(O, q(E, X))) < 0) return { solution: NaN, message: "Infeasible", iterations: J.iterations };
    var Y = numeric.__solveLP(D, E, O, F, I - J.iterations, X, !0);
    return Y.iterations += J.iterations, Y;
  }, numeric.solveLP = function(D, E, O, F, I, z, R) {
    if (R === void 0 && (R = 1e3), z === void 0 && (z = numeric.epsilon), F === void 0) return numeric._solveLP(D, E, O, z, R);
    var L = F.length, q = F[0].length, U = E.length, Z = numeric.echelonize(F), V = numeric.rep([q], 0), G = Z.P, W = [], J;
    for (J = G.length - 1; J !== -1; --J) V[G[J]] = 1;
    for (J = q - 1; J !== -1; --J) V[J] === 0 && W.push(J);
    var X = numeric.getRange, Y = numeric.linspace(0, L - 1), ee = numeric.linspace(0, U - 1), K = X(F, Y, W), te = X(E, ee, G), ie = X(E, ee, W), ne = numeric.dot, ae = numeric.sub, ue = ne(te, Z.I), oe = ae(ie, ne(ue, K)), se = ae(O, ne(ue, I)), le = Array(G.length), ce = Array(W.length);
    for (J = G.length - 1; J !== -1; --J) le[J] = D[G[J]];
    for (J = W.length - 1; J !== -1; --J) ce[J] = D[W[J]];
    var fe = ae(ce, ne(le, ne(Z.I, K))), pe = numeric._solveLP(fe, oe, se, z, R), ve = pe.solution;
    if (ve !== ve) return pe;
    var _e = ne(Z.I, ae(I, ne(K, ve))), de = Array(D.length);
    for (J = G.length - 1; J !== -1; --J) de[G[J]] = _e[J];
    for (J = W.length - 1; J !== -1; --J) de[W[J]] = ve[J];
    return { solution: de, message: pe.message, iterations: pe.iterations };
  }, numeric.MPStoLP = function(D) {
    D instanceof String && D.split(`
`);
    var E = 0, O = ["Initial state", "NAME", "ROWS", "COLUMNS", "RHS", "BOUNDS", "ENDATA"], F = D.length, I, z, R, L = 0, q = {}, U = [], Z = 0, V = {}, G = 0, W, J = [], X = [], Y = [];
    function ee(ae) {
      throw Error("MPStoLP: " + ae + `
Line ` + I + ": " + D[I] + `
Current state: ` + O[E] + `
`);
    }
    for (I = 0; I < F; ++I) {
      R = D[I];
      var K = R.match(/\S*/g), te = [];
      for (z = 0; z < K.length; ++z) K[z] !== "" && te.push(K[z]);
      if (te.length !== 0) {
        for (z = 0; z < O.length && R.substr(0, O[z].length) !== O[z]; ++z) ;
        if (z < O.length) {
          if (E = z, z === 1 && (W = te[1]), z === 6) return { name: W, c: J, A: numeric.transpose(X), b: Y, rows: q, vars: V };
          continue;
        }
        switch (E) {
          case 0:
          case 1:
            ee("Unexpected line");
          case 2:
            switch (te[0]) {
              case "N":
                L === 0 ? L = te[1] : ee("Two or more N rows");
                break;
              case "L":
                q[te[1]] = Z, U[Z] = 1, Y[Z] = 0, ++Z;
                break;
              case "G":
                q[te[1]] = Z, U[Z] = -1, Y[Z] = 0, ++Z;
                break;
              case "E":
                q[te[1]] = Z, U[Z] = 0, Y[Z] = 0, ++Z;
                break;
              default:
                ee("Parse error " + numeric.prettyPrint(te));
            }
            break;
          case 3:
            V.hasOwnProperty(te[0]) || (V[te[0]] = G, J[G] = 0, X[G] = numeric.rep([Z], 0), ++G);
            var ie = V[te[0]];
            for (z = 1; z < te.length; z += 2) {
              if (te[z] === L) {
                J[ie] = parseFloat(te[z + 1]);
                continue;
              }
              var ne = q[te[z]];
              X[ie][ne] = (U[ne] < 0 ? -1 : 1) * parseFloat(te[z + 1]);
            }
            break;
          case 4:
            for (z = 1; z < te.length; z += 2) Y[q[te[z]]] = (U[q[te[z]]] < 0 ? -1 : 1) * parseFloat(te[z + 1]);
            break;
          case 5:
            break;
          case 6:
            ee("Internal error");
        }
      }
    }
    ee("Reached end of file without ENDATA");
  }, numeric.seedrandom = { pow: Math.pow, random: Math.random }, (function(D, E, O, F, I, z, R) {
    E.seedrandom = function(V, G) {
      var W = [], J;
      return V = U(q(G ? [V, D] : arguments.length ? V : [(/* @__PURE__ */ new Date()).getTime(), D, window], 3), W), J = new L(W), U(J.S, D), E.random = function() {
        for (var X = J.g(F), Y = R, ee = 0; X < I; ) X = (X + ee) * O, Y *= O, ee = J.g(1);
        for (; X >= z; ) X /= 2, Y /= 2, ee >>>= 1;
        return (X + ee) / Y;
      }, V;
    };
    function L(V) {
      var G, W, J = this, X = V.length, Y = 0, ee = J.i = J.j = J.m = 0;
      for (J.S = [], J.c = [], X || (V = [X++]); Y < O; ) J.S[Y] = Y++;
      for (Y = 0; Y < O; Y++) G = J.S[Y], ee = Z(ee + G + V[Y % X]), W = J.S[ee], J.S[Y] = W, J.S[ee] = G;
      J.g = function(K) {
        var te = J.S, ie = Z(J.i + 1), ne = te[ie], ae = Z(J.j + ne), ue = te[ae];
        te[ie] = ue, te[ae] = ne;
        for (var oe = te[Z(ne + ue)]; --K; ) ie = Z(ie + 1), ne = te[ie], ae = Z(ae + ne), ue = te[ae], te[ie] = ue, te[ae] = ne, oe = oe * O + te[Z(ne + ue)];
        return J.i = ie, J.j = ae, oe;
      }, J.g(O);
    }
    function q(V, G, W, J, X) {
      if (W = [], X = typeof V, G && X == "object") {
        for (J in V) if (J.indexOf("S") < 5) try {
          W.push(q(V[J], G - 1));
        } catch {
        }
      }
      return W.length ? W : V + (X == "string" ? "" : "\0");
    }
    function U(V, G, W, J) {
      for (V += "", W = 0, J = 0; J < V.length; J++) G[Z(J)] = Z((W ^= G[Z(J)] * 19) + V.charCodeAt(J));
      for (J in V = "", G) V += String.fromCharCode(G[J]);
      return V;
    }
    function Z(V) {
      return V & O - 1;
    }
    R = E.pow(O, F), I = E.pow(2, I), z = I * 2, U(E.random(), D);
  })([], numeric.seedrandom, 256, 6, 52), (function(D) {
    function E(q) {
      if (typeof q != "object") return q;
      var U = [], Z, V = q.length;
      for (Z = 0; Z < V; Z++) U[Z + 1] = E(q[Z]);
      return U;
    }
    function O(q) {
      if (typeof q != "object") return q;
      var U = [], Z, V = q.length;
      for (Z = 1; Z < V; Z++) U[Z - 1] = O(q[Z]);
      return U;
    }
    function F(q, U, Z) {
      var V, G, W, J, X;
      for (W = 1; W <= Z; W += 1) {
        for (q[W][W] = 1 / q[W][W], X = -q[W][W], V = 1; V < W; V += 1) q[V][W] = X * q[V][W];
        if (J = W + 1, Z < J) break;
        for (G = J; G <= Z; G += 1) for (X = q[W][G], q[W][G] = 0, V = 1; V <= W; V += 1) q[V][G] = q[V][G] + X * q[V][W];
      }
    }
    function I(q, U, Z, V) {
      var G, W, J, X;
      for (W = 1; W <= Z; W += 1) {
        for (X = 0, G = 1; G < W; G += 1) X += q[G][W] * V[G];
        V[W] = (V[W] - X) / q[W][W];
      }
      for (J = 1; J <= Z; J += 1) for (W = Z + 1 - J, V[W] = V[W] / q[W][W], X = -V[W], G = 1; G < W; G += 1) V[G] = V[G] + X * q[G][W];
    }
    function z(q, U, Z, V) {
      var G, W, J, X, Y, ee;
      for (W = 1; W <= Z; W += 1) {
        if (V[1] = W, ee = 0, J = W - 1, J < 1) {
          if (ee = q[W][W] - ee, ee <= 0) break;
          q[W][W] = Math.sqrt(ee);
        } else {
          for (X = 1; X <= J; X += 1) {
            for (Y = q[X][W], G = 1; G < X; G += 1) Y -= q[G][W] * q[G][X];
            Y /= q[X][X], q[X][W] = Y, ee += Y * Y;
          }
          if (ee = q[W][W] - ee, ee <= 0) break;
          q[W][W] = Math.sqrt(ee);
        }
        V[1] = 0;
      }
    }
    function R(q, U, Z, V, G, W, J, X, Y, ee, K, te, ie, ne, ae, ue) {
      var oe, se, le, ce, fe, pe, ve, _e, de, ge, ye, De, Ce = Math.min(V, ee), Ie, Ne, he, ke, xe, Te, Fe, be, Ae, Me, $e, Re, je, Pe;
      le = 2 * V + Ce * (Ce + 5) / 2 + 2 * ee + 1, $e = 1e-60;
      do
        $e += $e, Re = 1 + 0.1 * $e, je = 1 + 0.2 * $e;
      while (Re <= 1 || je <= 1);
      for (oe = 1; oe <= V; oe += 1) ae[oe] = U[oe];
      for (oe = V + 1; oe <= le; oe += 1) ae[oe] = 0;
      for (oe = 1; oe <= ee; oe += 1) te[oe] = 0;
      if (fe = [], ue[1] === 0) {
        if (z(q, Z, V, fe), fe[1] !== 0) {
          ue[1] = 2;
          return;
        }
        I(q, Z, V, U), F(q, Z, V);
      } else {
        for (se = 1; se <= V; se += 1) for (G[se] = 0, oe = 1; oe <= se; oe += 1) G[se] = G[se] + q[oe][se] * U[oe];
        for (se = 1; se <= V; se += 1) for (U[se] = 0, oe = se; oe <= V; oe += 1) U[se] = U[se] + q[se][oe] * G[oe];
      }
      for (W[1] = 0, se = 1; se <= V; se += 1) for (G[se] = U[se], W[1] += ae[se] * G[se], ae[se] = 0, oe = se + 1; oe <= V; oe += 1) q[oe][se] = 0;
      for (W[1] = -W[1] / 2, ue[1] = 0, ve = V, _e = ve + V, ye = _e + Ce, de = ye + Ce + 1, ge = de + Ce * (Ce + 1) / 2, Ie = ge + ee, oe = 1; oe <= ee; oe += 1) {
        for (he = 0, se = 1; se <= V; se += 1) he += J[se][oe] * J[se][oe];
        ae[Ie + oe] = Math.sqrt(he);
      }
      ie = 0, ne[1] = 0, ne[2] = 0;
      function Ke() {
        for (ne[1] += 1, le = ge, oe = 1; oe <= ee; oe += 1) {
          for (le += 1, he = -X[oe], se = 1; se <= V; se += 1) he += J[se][oe] * G[se];
          if (Math.abs(he) < $e && (he = 0), oe > K) ae[le] = he;
          else if (ae[le] = -Math.abs(he), he > 0) {
            for (se = 1; se <= V; se += 1) J[se][oe] = -J[se][oe];
            X[oe] = -X[oe];
          }
        }
        for (oe = 1; oe <= ie; oe += 1) ae[ge + te[oe]] = 0;
        for (De = 0, Ne = 0, oe = 1; oe <= ee; oe += 1) ae[ge + oe] < Ne * ae[Ie + oe] && (De = oe, Ne = ae[ge + oe] / ae[Ie + oe]);
        return De === 0 ? 999 : 0;
      }
      function Qe() {
        for (oe = 1; oe <= V; oe += 1) {
          for (he = 0, se = 1; se <= V; se += 1) he += q[se][oe] * J[se][De];
          ae[oe] = he;
        }
        for (ce = ve, oe = 1; oe <= V; oe += 1) ae[ce + oe] = 0;
        for (se = ie + 1; se <= V; se += 1) for (oe = 1; oe <= V; oe += 1) ae[ce + oe] = ae[ce + oe] + q[oe][se] * ae[se];
        for (Ae = !0, oe = ie; oe >= 1; --oe) {
          for (he = ae[oe], le = de + oe * (oe + 3) / 2, ce = le - oe, se = oe + 1; se <= ie; se += 1) he -= ae[le] * ae[_e + se], le += se;
          if (he /= ae[ce], ae[_e + oe] = he, te[oe] < K || he < 0) break;
          Ae = !1, pe = oe;
        }
        if (!Ae) for (ke = ae[ye + pe] / ae[_e + pe], oe = 1; oe <= ie && !(te[oe] < K || ae[_e + oe] < 0); oe += 1) Ne = ae[ye + oe] / ae[_e + oe], Ne < ke && (ke = Ne, pe = oe);
        for (he = 0, oe = ve + 1; oe <= ve + V; oe += 1) he += ae[oe] * ae[oe];
        if (Math.abs(he) <= $e) {
          if (Ae) return ue[1] = 1, 999;
          for (oe = 1; oe <= ie; oe += 1) ae[ye + oe] = ae[ye + oe] - ke * ae[_e + oe];
          return ae[ye + ie + 1] = ae[ye + ie + 1] + ke, 700;
        } else {
          for (he = 0, oe = 1; oe <= V; oe += 1) he += ae[ve + oe] * J[oe][De];
          for (xe = -ae[ge + De] / he, Me = !0, Ae || ke < xe && (xe = ke, Me = !1), oe = 1; oe <= V; oe += 1) G[oe] = G[oe] + xe * ae[ve + oe], Math.abs(G[oe]) < $e && (G[oe] = 0);
          for (W[1] += xe * he * (xe / 2 + ae[ye + ie + 1]), oe = 1; oe <= ie; oe += 1) ae[ye + oe] = ae[ye + oe] - xe * ae[_e + oe];
          if (ae[ye + ie + 1] = ae[ye + ie + 1] + xe, Me) {
            for (ie += 1, te[ie] = De, le = de + (ie - 1) * ie / 2 + 1, oe = 1; oe <= ie - 1; oe += 1) ae[le] = ae[oe], le += 1;
            if (ie === V) ae[le] = ae[V];
            else {
              for (oe = V; oe >= ie + 1 && !(ae[oe] === 0 || (Te = Math.max(Math.abs(ae[oe - 1]), Math.abs(ae[oe])), Fe = Math.min(Math.abs(ae[oe - 1]), Math.abs(ae[oe])), Ne = ae[oe - 1] >= 0 ? Math.abs(Te * Math.sqrt(1 + Fe * Fe / (Te * Te))) : -Math.abs(Te * Math.sqrt(1 + Fe * Fe / (Te * Te))), Te = ae[oe - 1] / Ne, Fe = ae[oe] / Ne, Te === 1)); --oe) if (Te === 0) for (ae[oe - 1] = Fe * Ne, se = 1; se <= V; se += 1) Ne = q[se][oe - 1], q[se][oe - 1] = q[se][oe], q[se][oe] = Ne;
              else for (ae[oe - 1] = Ne, be = Fe / (1 + Te), se = 1; se <= V; se += 1) Ne = Te * q[se][oe - 1] + Fe * q[se][oe], q[se][oe] = be * (q[se][oe - 1] + Ne) - q[se][oe], q[se][oe - 1] = Ne;
              ae[le] = ae[ie];
            }
          } else {
            for (he = -X[De], se = 1; se <= V; se += 1) he += G[se] * J[se][De];
            if (De > K) ae[ge + De] = he;
            else if (ae[ge + De] = -Math.abs(he), he > 0) {
              for (se = 1; se <= V; se += 1) J[se][De] = -J[se][De];
              X[De] = -X[De];
            }
            return 700;
          }
        }
        return 0;
      }
      function We() {
        if (le = de + pe * (pe + 1) / 2 + 1, ce = le + pe, ae[ce] === 0 || (Te = Math.max(Math.abs(ae[ce - 1]), Math.abs(ae[ce])), Fe = Math.min(Math.abs(ae[ce - 1]), Math.abs(ae[ce])), Ne = ae[ce - 1] >= 0 ? Math.abs(Te * Math.sqrt(1 + Fe * Fe / (Te * Te))) : -Math.abs(Te * Math.sqrt(1 + Fe * Fe / (Te * Te))), Te = ae[ce - 1] / Ne, Fe = ae[ce] / Ne, Te === 1)) return 798;
        if (Te === 0) {
          for (oe = pe + 1; oe <= ie; oe += 1) Ne = ae[ce - 1], ae[ce - 1] = ae[ce], ae[ce] = Ne, ce += oe;
          for (oe = 1; oe <= V; oe += 1) Ne = q[oe][pe], q[oe][pe] = q[oe][pe + 1], q[oe][pe + 1] = Ne;
        } else {
          for (be = Fe / (1 + Te), oe = pe + 1; oe <= ie; oe += 1) Ne = Te * ae[ce - 1] + Fe * ae[ce], ae[ce] = be * (ae[ce - 1] + Ne) - ae[ce], ae[ce - 1] = Ne, ce += oe;
          for (oe = 1; oe <= V; oe += 1) Ne = Te * q[oe][pe] + Fe * q[oe][pe + 1], q[oe][pe + 1] = be * (q[oe][pe] + Ne) - q[oe][pe + 1], q[oe][pe] = Ne;
        }
        return 0;
      }
      function ir() {
        for (ce = le - pe, oe = 1; oe <= pe; oe += 1) ae[ce] = ae[le], le += 1, ce += 1;
        return ae[ye + pe] = ae[ye + pe + 1], te[pe] = te[pe + 1], pe += 1, pe < ie ? 797 : 0;
      }
      function nr() {
        return ae[ye + ie] = ae[ye + ie + 1], ae[ye + ie + 1] = 0, te[ie] = 0, --ie, ne[2] += 1, 0;
      }
      for (Pe = 0; ; ) {
        if (Pe = Ke(), Pe === 999) return;
        for (; Pe = Qe(), Pe !== 0; ) {
          if (Pe === 999) return;
          if (Pe === 700) if (pe === ie) nr();
          else {
            for (; We(), Pe = ir(), Pe === 797; ) ;
            nr();
          }
        }
      }
    }
    function L(q, U, Z, V, G, W) {
      q = E(q), U = E(U), Z = E(Z);
      var J, X, Y, ee, K, te = [], ie = [], ne = [], ae = [], ue = [], oe;
      if (G ||= 0, W = W ? E(W) : [void 0, 0], V = V ? E(V) : [], X = q.length - 1, Y = Z[1].length - 1, !V) for (J = 1; J <= Y; J += 1) V[J] = 0;
      for (J = 1; J <= Y; J += 1) ie[J] = 0;
      for (ee = 0, K = Math.min(X, Y), J = 1; J <= X; J += 1) ne[J] = 0;
      for (te[1] = 0, J = 1; J <= 2 * X + K * (K + 5) / 2 + 2 * Y + 1; J += 1) ae[J] = 0;
      for (J = 1; J <= 2; J += 1) ue[J] = 0;
      return R(q, U, X, X, ne, te, Z, V, X, Y, G, ie, ee, ue, ae, W), oe = "", W[1] === 1 && (oe = "constraints are inconsistent, no solution!"), W[1] === 2 && (oe = "matrix D in quadratic function is not positive definite!"), { solution: O(ne), value: O(te), unconstrained_solution: O(U), iterations: O(ue), iact: O(ie), message: oe };
    }
    D.solveQP = L;
  })(numeric), numeric.svd = function(D) {
    var E, O = numeric.epsilon, F = 1e-64 / O, I = 50, z = 0, R = 0, L = 0, q = 0, U = 0, Z = numeric.clone(D), V = Z.length, G = Z[0].length;
    if (V < G) throw "Need more rows than columns";
    var W = Array(G), J = Array(G);
    for (R = 0; R < G; R++) W[R] = J[R] = 0;
    var X = numeric.rep([G, G], 0);
    function Y(ce, fe) {
      return ce = Math.abs(ce), fe = Math.abs(fe), ce > fe ? ce * Math.sqrt(1 + fe * fe / ce / ce) : fe == 0 ? ce : fe * Math.sqrt(1 + ce * ce / fe / fe);
    }
    var ee = 0, K = 0, te = 0, ie = 0, ne = 0, ae = 0, ue = 0;
    for (R = 0; R < G; R++) {
      for (W[R] = K, ue = 0, U = R + 1, L = R; L < V; L++) ue += Z[L][R] * Z[L][R];
      if (ue <= F) K = 0;
      else for (ee = Z[R][R], K = Math.sqrt(ue), ee >= 0 && (K = -K), te = ee * K - ue, Z[R][R] = ee - K, L = U; L < G; L++) {
        for (ue = 0, q = R; q < V; q++) ue += Z[q][R] * Z[q][L];
        for (ee = ue / te, q = R; q < V; q++) Z[q][L] += ee * Z[q][R];
      }
      for (J[R] = K, ue = 0, L = U; L < G; L++) ue += Z[R][L] * Z[R][L];
      if (ue <= F) K = 0;
      else {
        for (ee = Z[R][R + 1], K = Math.sqrt(ue), ee >= 0 && (K = -K), te = ee * K - ue, Z[R][R + 1] = ee - K, L = U; L < G; L++) W[L] = Z[R][L] / te;
        for (L = U; L < V; L++) {
          for (ue = 0, q = U; q < G; q++) ue += Z[L][q] * Z[R][q];
          for (q = U; q < G; q++) Z[L][q] += ue * W[q];
        }
      }
      ne = Math.abs(J[R]) + Math.abs(W[R]), ne > ie && (ie = ne);
    }
    for (R = G - 1; R != -1; R += -1) {
      if (K != 0) {
        for (te = K * Z[R][R + 1], L = U; L < G; L++) X[L][R] = Z[R][L] / te;
        for (L = U; L < G; L++) {
          for (ue = 0, q = U; q < G; q++) ue += Z[R][q] * X[q][L];
          for (q = U; q < G; q++) X[q][L] += ue * X[q][R];
        }
      }
      for (L = U; L < G; L++) X[R][L] = 0, X[L][R] = 0;
      X[R][R] = 1, K = W[R], U = R;
    }
    for (R = G - 1; R != -1; R += -1) {
      for (U = R + 1, K = J[R], L = U; L < G; L++) Z[R][L] = 0;
      if (K != 0) {
        for (te = Z[R][R] * K, L = U; L < G; L++) {
          for (ue = 0, q = U; q < V; q++) ue += Z[q][R] * Z[q][L];
          for (ee = ue / te, q = R; q < V; q++) Z[q][L] += ee * Z[q][R];
        }
        for (L = R; L < V; L++) Z[L][R] = Z[L][R] / K;
      } else for (L = R; L < V; L++) Z[L][R] = 0;
      Z[R][R] += 1;
    }
    for (O *= ie, q = G - 1; q != -1; q += -1) for (var oe = 0; oe < I; oe++) {
      var se = !1;
      for (U = q; U != -1; U += -1) {
        if (Math.abs(W[U]) <= O) {
          se = !0;
          break;
        }
        if (Math.abs(J[U - 1]) <= O) break;
      }
      if (!se) {
        z = 0, ue = 1;
        var le = U - 1;
        for (R = U; R < q + 1 && (ee = ue * W[R], W[R] = z * W[R], !(Math.abs(ee) <= O)); R++) for (K = J[R], te = Y(ee, K), J[R] = te, z = K / te, ue = -ee / te, L = 0; L < V; L++) ne = Z[L][le], ae = Z[L][R], Z[L][le] = ne * z + ae * ue, Z[L][R] = -ne * ue + ae * z;
      }
      if (ae = J[q], U == q) {
        if (ae < 0) for (J[q] = -ae, L = 0; L < G; L++) X[L][q] = -X[L][q];
        break;
      }
      if (oe >= I - 1) throw "Error: no convergence.";
      for (ie = J[U], ne = J[q - 1], K = W[q - 1], te = W[q], ee = ((ne - ae) * (ne + ae) + (K - te) * (K + te)) / (2 * te * ne), K = Y(ee, 1), ee = ee < 0 ? ((ie - ae) * (ie + ae) + te * (ne / (ee - K) - te)) / ie : ((ie - ae) * (ie + ae) + te * (ne / (ee + K) - te)) / ie, z = 1, ue = 1, R = U + 1; R < q + 1; R++) {
        for (K = W[R], ne = J[R], te = ue * K, K = z * K, ae = Y(ee, te), W[R - 1] = ae, z = ee / ae, ue = te / ae, ee = ie * z + K * ue, K = -ie * ue + K * z, te = ne * ue, ne *= z, L = 0; L < G; L++) ie = X[L][R - 1], ae = X[L][R], X[L][R - 1] = ie * z + ae * ue, X[L][R] = -ie * ue + ae * z;
        for (ae = Y(ee, te), J[R - 1] = ae, z = ee / ae, ue = te / ae, ee = z * K + ue * ne, ie = -ue * K + z * ne, L = 0; L < V; L++) ne = Z[L][R - 1], ae = Z[L][R], Z[L][R - 1] = ne * z + ae * ue, Z[L][R] = -ne * ue + ae * z;
      }
      W[U] = 0, W[q] = ee, J[q] = ie;
    }
    for (R = 0; R < J.length; R++) J[R] < O && (J[R] = 0);
    for (R = 0; R < G; R++) for (L = R - 1; L >= 0; L--) if (J[L] < J[R]) {
      for (z = J[L], J[L] = J[R], J[R] = z, q = 0; q < Z.length; q++) E = Z[q][R], Z[q][R] = Z[q][L], Z[q][L] = E;
      for (q = 0; q < X.length; q++) E = X[q][R], X[q][R] = X[q][L], X[q][L] = E;
      R = L;
    }
    return { U: Z, S: J, V: X };
  };
})), import_numeric_1_2_6 = __toESM(require_numeric_1_2_6());
function createInstance({ define_e: D = !0, define_pi: E = !0, define_i: O = !0, pow_strict: F = !0 } = {}) {
  let I = { ...all };
  delete I.createTau, delete I.createPhi, D || delete I.createE, E || delete I.createPi, O || delete I.createI;
  let z = create$1(I);
  z.import(import_numeric_1_2_6.default, { wrap: !0, silent: !0 });
  var R = z.pow;
  function L(q, U) {
    return U === 0 && typeof q == "number" && (q === 0 || !Number.isFinite(q)) ? NaN : R(q, U);
  }
  return F ? z.import({ pow: L }, { override: !0 }) : z.import({ pow: R }, { override: !0 }), z.define_e = D, z.define_pi = E, z.define_i = O, z.pow_strict = F, z;
}
var mathjs_default = createInstance(), function_normalizations = { ln: "log", arccos: "acos", arccosh: "acosh", arcsin: "asin", arcsinh: "asinh", arctan: "atan", arctanh: "atanh", arcsec: "asec", arcsech: "asech", arccsc: "acsc", arccsch: "acsch", arccot: "acot", arccoth: "acoth", cosec: "csc" }, create_trig_inverses_for = ["cos", "cosh", "sin", "sinh", "tan", "tanh", "sec", "sech", "csc", "csch", "cot", "coth"], move_exponents_outside_for = ["cos", "cosh", "sin", "sinh", "tan", "tanh", "sec", "sech", "csc", "csch", "cot", "coth", "log", "ln"];
function normalize_function_names(D) {
  var E = get_tree(D);
  if (!Array.isArray(E)) return E;
  var O = E[0], F = E.slice(1);
  if (O === "apply") {
    if (F[0] === "sqrt") return ["^", normalize_function_names(F[1]), 0.5];
    if (F[0] === "cbrt") return ["^", normalize_function_names(F[1]), ["/", 1, 3]];
    if (F[0] === "nthroot") return F.length !== 2 || F[1][0] !== "tuple" || F[1].length !== 3 ? ["^", normalize_function_names(F[1]), 0.5] : ["^", normalize_function_names(F[1][1]), ["/", 1, normalize_function_names(F[1][2])]];
    var I = normalize_function_names_sub(F[0]);
    I = ["apply", I];
    var z = F.slice(1).map(function(R) {
      return normalize_function_names(R);
    });
    return z = z.length > 1 ? ["tuple"].concat(z) : z[0], I.push(z), I;
  }
  return O === "^" && F[0] === "e" && mathjs_default.define_e ? ["apply", "exp", normalize_function_names(F[1])] : O === "binom" ? ["apply", "nCr", ["tuple", normalize_function_names(F[0]), normalize_function_names(F[1])]] : [O].concat(F.map(function(R) {
    return normalize_function_names(R);
  }));
}
function normalize_function_names_sub(D) {
  if (typeof D == "string") return D in function_normalizations ? function_normalizations[D] : D;
  if (!Array.isArray(D)) return D;
  var E = D[0], O = D.slice(1);
  if (E === "^" && O.length === 2 && O[1] === -1) {
    let F = normalize_function_names_sub(O[0]);
    if (create_trig_inverses_for.includes(F)) return "a" + F;
  }
  return [E].concat(O.map(function(F) {
    return normalize_function_names_sub(F);
  }));
}
function normalize_applied_functions(D) {
  var E = get_tree(D);
  if (!Array.isArray(E)) return E;
  var O = E[0], F = E.slice(1);
  if (O === "apply") {
    let I = F[0];
    if (I[0] === "^") {
      let L = I[1], q = I[2];
      return q !== -1 && move_exponents_outside_for.includes(L) ? ["^", ["apply", L, normalize_applied_functions(F[1])], q] : ["apply", I, normalize_applied_functions(F[1])];
    }
    let z = 0;
    for (; I[0] === "prime"; ) z += 1, I = I[1];
    let R = ["apply", I, normalize_applied_functions(F[1])];
    for (let L = 0; L < z; L++) R = ["prime", R];
    return R;
  }
  return [O].concat(F.map(function(I, z) {
    return normalize_applied_functions(I);
  }));
}
function log_subscript_to_two_arg_log(D) {
  var E = get_tree(D);
  if (!Array.isArray(E)) return E;
  let O = E[0], F = E.slice(1);
  if (O === "apply" && F.length === 2) {
    let I = F[0];
    if (Array.isArray(I) && I.length === 3 && I[0] === "_" && I[1] === "log") return ["apply", "log", ["tuple", F[1], I[2]]];
  }
  return [O, ...F.map(log_subscript_to_two_arg_log)];
}
function substitute_abs(D) {
  var E = get_tree(D);
  if (!Array.isArray(E)) return E;
  var O = E[0], F = E.slice(1);
  return O === "apply" && F[0] === "abs" ? ["^", ["^", substitute_abs(F[1]), 2], 0.5] : [O].concat(F.map(function(I) {
    return substitute_abs(I);
  }));
}
function constants_to_floats(D) {
  var E = get_tree(D);
  if (!(mathjs_default.define_e || mathjs_default.define_pi)) return E;
  if (typeof E == "string") {
    if (E === "e") {
      if (mathjs_default.define_e) return mathjs_default.e;
    } else if (E === "pi" && mathjs_default.define_pi) return mathjs_default.pi;
    return E;
  }
  if (!Array.isArray(E)) return E;
  let O = E[0], F = E.slice(1);
  return O === "^" && F[0] === "e" ? ["^", "e", constants_to_floats(F[1])] : [O, ...F.map(constants_to_floats)];
}
function normalize_angle_linesegment_arg_order(D) {
  var E = get_tree(D);
  if (!Array.isArray(E)) return E;
  let O = E[0], F = E.slice(1);
  return O === "angle" && F.length === 3 && compare_function(F[0], F[2]) === 1 || O === "linesegment" && F.length === 2 && compare_function(F[0], F[1]) === 1 ? (F.reverse(), [O, ...F]) : [O, ...F.map(normalize_angle_linesegment_arg_order)];
}
function normalize_negative_numbers(D) {
  var E = get_tree(D);
  function O(z) {
    if (typeof z == "number" && z >= 0) return [-z, !0];
    if (!Array.isArray(z)) return [z, !1];
    if (z[0] === "*" && typeof z[1] == "number" && z[1] >= 0) return [["*", -z[1], ...z.slice(2).map(normalize_negative_numbers)], !0];
    if (z[0] === "/" && z.length === 3) {
      let [R, L] = O(z[1]);
      if (L) return [["/", R, normalize_negative_numbers(z[2])], !0];
    }
    return [z, !1];
  }
  if (!Array.isArray(E)) return E;
  let F = E[0], I = E.slice(1);
  if (F === "-" && I.length === 1) {
    if (typeof I[0] == "number" && I[0] >= 0) return -I[0];
    if (Array.isArray(I[0]) && I[0][0] === "*") {
      let [z, R] = O(I[0][1]);
      if (R) return ["*", z, ...I[0].slice(2).map(normalize_negative_numbers)];
    }
    if (Array.isArray(I[0]) && I[0][0] === "/" && I[0].length === 3) {
      let [z, R] = O(I[0][1]);
      if (R) return ["/", z, normalize_negative_numbers(I[0][2])];
    }
  }
  return [F, ...I.map(normalize_negative_numbers)];
}
function tuples_to_vectors(D) {
  var E = get_tree(D);
  if (!Array.isArray(E)) return E;
  var O = E[0], F = E.slice(1);
  if (O === "tuple") return ["vector"].concat(F.map(function(I, z) {
    return tuples_to_vectors(I);
  }));
  if (O === "apply") {
    if (F[1][0] === "tuple") {
      let I = tuples_to_vectors(F[0]), z = F[1].slice(1);
      return ["apply", I, ["tuple"].concat(z.map(function(R, L) {
        return tuples_to_vectors(R);
      }))];
    }
  } else if (O === "gts" || O === "lts" || O === "interval") {
    let I = F[0], z = F[1];
    if (I[0] !== "tuple" || z[0] !== "tuple") throw Error("Badly formed ast");
    return [O, ["tuple"].concat(I.slice(1).map(function(R, L) {
      return tuples_to_vectors(R);
    })), z];
  } else if (O === "matrix") {
    let I = F[0], z = F[1];
    return I = ["tuple"].concat(I.slice(1).map(tuples_to_vectors)), z = ["tuple"].concat(z.slice(1).map((R) => ["tuple"].concat(R.slice(1).map(tuples_to_vectors)))), ["matrix", I, z];
  }
  return [O].concat(F.map(function(I, z) {
    return tuples_to_vectors(I);
  }));
}
function to_intervals(D) {
  var E = get_tree(D);
  if (!Array.isArray(E)) return E;
  var O = E[0], F = E.slice(1);
  if (O === "tuple" && F.length === 2) {
    let I = ["tuple"].concat(F.map(function(z, R) {
      return to_intervals(z);
    }));
    return I = ["interval", I, ["tuple", !1, !1]], I;
  }
  if (O === "array" && F.length === 2) {
    let I = ["tuple"].concat(F.map(function(z, R) {
      return to_intervals(z);
    }));
    return I = ["interval", I, ["tuple", !0, !0]], I;
  }
  if (O === "apply") {
    if (F[1][0] === "tuple") {
      let I = to_intervals(F[0]), z = F[1].slice(1);
      return ["apply", I, ["tuple"].concat(z.map(function(R, L) {
        return to_intervals(R);
      }))];
    }
  } else if (O === "gts" || O === "lts" || O === "interval") {
    let I = F[0], z = F[1];
    if (I[0] !== "tuple" || z[0] !== "tuple") throw Error("Badly formed ast");
    return [O, ["tuple"].concat(I.slice(1).map(function(R, L) {
      return to_intervals(R);
    })), z];
  }
  return [O].concat(F.map(function(I, z) {
    return to_intervals(I);
  }));
}
function altvectors_to_vectors(D) {
  var E = get_tree(D);
  if (!Array.isArray(E)) return E;
  var O = E[0], F = E.slice(1);
  return O === "altvector" ? ["vector"].concat(F.map(function(I, z) {
    return altvectors_to_vectors(I);
  })) : [O].concat(F.map(function(I, z) {
    return altvectors_to_vectors(I);
  }));
}
function padNumberStringToDigits(D, E) {
  let O = Math.floor(E);
  if (O > 0) {
    if (D.includes(".")) {
      if (D[0] === "0" ? O += D.match(/^0\.0*/)[0].length : O++, D.length < O) {
        let F = O - D.length;
        D += "0".repeat(F);
      }
    } else if (D.length < O) {
      let F = O - D.length;
      D += "." + "0".repeat(F);
    }
  }
  return D;
}
function padNumberStringToDecimals(D, E) {
  let O = Math.floor(E);
  if (O > 0) if (D.includes(".")) {
    let F = D.match(/\.\d*$/)[0].length - 1;
    if (F < O) {
      let I = O - F;
      D += "0".repeat(I);
    }
  } else D += "." + "0".repeat(O);
  return D;
}
function padNumberStringToDigitsAndDecimals(D, E, O) {
  let F = Math.floor(E);
  if (!(F > 0)) return padNumberStringToDecimals(D, O);
  let I = Math.floor(O);
  if (!(I > 0)) return padNumberStringToDigits(D, E);
  if (D.includes(".")) {
    D[0] === "0" ? F += D.match(/^0\.0*/)[0].length : F++;
    let z = 0;
    D.length < F && (z = F - D.length);
    let R = D.match(/\.\d*$/)[0].length - 1;
    R < I && (z = Math.max(z, I - R)), z > 0 && (D += "0".repeat(z));
  } else {
    let z = 0;
    D.length < F && (z = F - D.length), z = Math.max(z, I), D += "." + "0".repeat(z);
  }
  return D;
}
function remove_leading_negative_factor(D) {
  if (typeof D == "number" && D < 0) return [-D, !0];
  if (!Array.isArray(D)) return [D, !1];
  if (D[0] === "-" && D.length === 2) return [D[1], !0];
  if (D[0] === "*" && D.length >= 2) {
    let E = D[1];
    if (typeof E == "number" && E < 0) return [["*", -E, ...D.slice(2)], !0];
    if (Array.isArray(E) && E[0] === "-" && E.length === 2) return [["*", E[1], ...D.slice(2)], !0];
  }
  return [D, !1];
}
function normalize_display_negative_fractions_sub(D, { inside_unary_minus: E = !1 } = {}) {
  if (!Array.isArray(D)) return D;
  let O = D[0], F = D.slice(1);
  if (O === "-" && F.length === 1) return ["-", normalize_display_negative_fractions_sub(F[0], { inside_unary_minus: !0 })];
  if (O === "+") return ["+", ...F.map((I) => normalize_display_negative_fractions_sub(I, { inside_unary_minus: !1 }))];
  if (O === "*") {
    if (F.length === 0) return D;
    let I = [normalize_display_negative_fractions_sub(F[0], { inside_unary_minus: !1 })];
    for (let z = 1; z < F.length; z += 1) I.push(normalize_display_negative_fractions_sub(F[z], { inside_unary_minus: !1 }));
    return ["*", ...I];
  }
  if (O === "/" && F.length === 2) {
    let I = F[0], z = F[1];
    if (!E) {
      let [R, L] = remove_leading_negative_factor(I);
      if (L) return ["-", ["/", normalize_display_negative_fractions_sub(R, { inside_unary_minus: !1 }), normalize_display_negative_fractions_sub(z, { inside_unary_minus: !1 })]];
    }
    return ["/", normalize_display_negative_fractions_sub(I, { inside_unary_minus: !1 }), normalize_display_negative_fractions_sub(z, { inside_unary_minus: !1 })];
  }
  return [O, ...F.map((I) => normalize_display_negative_fractions_sub(I, { inside_unary_minus: !1 }))];
}
function normalize_display_negative_fractions(D) {
  return normalize_display_negative_fractions_sub(D, { inside_unary_minus: !1 });
}
function expandScientificNotation(D) {
  let E = D.indexOf("e");
  if (E === -1) return D;
  let O = D.substring(0, E), F = Number(D.substring(E + 1)), I = "";
  (O[0] === "-" || O[0] === "+") && (I = O[0] === "-" ? "-" : "", O = O.substring(1));
  let z = O.indexOf(".");
  z === -1 && (z = O.length);
  let R = O.replace(".", ""), L = z + F;
  return L <= 0 ? I + "0." + "0".repeat(-L) + R : L >= R.length ? I + R + "0".repeat(L - R.length) : I + R.substring(0, L) + "." + R.substring(L);
}
var unicode_operators = { "+": function(D) {
  return D.join(" ");
}, "-": function(D) {
  return "-" + D[0];
}, pm: function(D) {
  return "± " + D[0];
}, "*": function(D) {
  return D.join(" ");
}, "/": function(D) {
  return D[0] + "/" + D[1];
}, _: function(D) {
  return D[0] + "_" + D[1];
}, "^": function(D) {
  return D[0] + "^" + D[1];
}, prime: function(D) {
  return D[0] + "'";
}, tuple: function(D) {
  return "( " + D.join(", ") + " )";
}, array: function(D) {
  return "[ " + D.join(", ") + " ]";
}, list: function(D) {
  return D.join(", ");
}, set: function(D) {
  return "{ " + D.join(", ") + " }";
}, vector: function(D) {
  return "( " + D.join(", ") + " )";
}, altvector: function(D) {
  return "⟨ " + D.join(", ") + " ⟩";
}, interval: function(D) {
  return "( " + D.join(", ") + " )";
}, matrix: function(D) {
  return "( " + D.join(", ") + " )";
}, and: function(D) {
  return D.join(" and ");
}, or: function(D) {
  return D.join(" or ");
}, not: function(D) {
  return "not " + D[0];
}, "=": function(D) {
  return D.join(" = ");
}, "<": function(D) {
  return D.join(" < ");
}, ">": function(D) {
  return D.join(" > ");
}, lts: function(D) {
  return D.join(" < ");
}, gts: function(D) {
  return D.join(" > ");
}, le: function(D) {
  return D.join(" ≤ ");
}, ge: function(D) {
  return D.join(" ≥ ");
}, ne: function(D) {
  return D.join(" ≠ ");
}, forall: function(D) {
  return "∀ " + D[0];
}, exists: function(D) {
  return "∃ " + D[0];
}, in: function(D) {
  return D[0] + " ∈ " + D[1];
}, notin: function(D) {
  return D[0] + " ∉ " + D[1];
}, ni: function(D) {
  return D[0] + " ∋ " + D[1];
}, notni: function(D) {
  return D[0] + " ∌ " + D[1];
}, subset: function(D) {
  return D[0] + " ⊂ " + D[1];
}, subseteq: function(D) {
  return D[0] + " ⊆ " + D[1];
}, notsubset: function(D) {
  return D[0] + " ⊄ " + D[1];
}, notsubseteq: function(D) {
  return D[0] + " ⊈ " + D[1];
}, superset: function(D) {
  return D[0] + " ⊃ " + D[1];
}, superseteq: function(D) {
  return D[0] + " ⊇ " + D[1];
}, notsuperset: function(D) {
  return D[0] + " ⊅ " + D[1];
}, notsuperseteq: function(D) {
  return D[0] + " ⊉ " + D[1];
}, union: function(D) {
  return D.join(" ∪ ");
}, intersect: function(D) {
  return D.join(" ∩ ");
}, rightarrow: function(D) {
  return D.join(" → ");
}, leftarrow: function(D) {
  return D.join(" ← ");
}, leftrightarrow: function(D) {
  return D.join(" ↔ ");
}, implies: function(D) {
  return D.join(" ⟹ ");
}, impliedby: function(D) {
  return D.join(" ⟸ ");
}, iff: function(D) {
  return D.join(" ⟺ ");
}, perp: function(D) {
  return D.join(" ⟂ ");
}, parallel: function(D) {
  return D.join(" ∥ ");
}, derivative_leibniz: function(D) {
  return "d" + D[0] + "/d" + D[1];
}, partial_derivative_leibniz: function(D) {
  return "∂" + D[0] + "/∂" + D[1];
}, "|": function(D) {
  return D[0] + " | " + D[1];
}, ":": function(D) {
  return D[0] + " : " + D[1];
}, binom: function(D) {
  return "binom( " + D[0] + ", " + D[1] + " )";
}, vec: function(D) {
  return "vec(" + D[0] + ")";
}, linesegment: function(D) {
  return "linesegment( " + D.join(", ") + " )";
}, angle: function(D, E) {
  return E ? "∠" + D.join("") : "∠( " + D.join(", ") + " )";
}, unit: function(D) {
  return D[0] + " " + D[1];
} }, nonunicode_operators = { "+": function(D) {
  return D.join(" ");
}, "-": function(D) {
  return "-" + D[0];
}, pm: function(D) {
  return "plusminus " + D[0];
}, "*": function(D) {
  return D.join(" ");
}, "/": function(D) {
  return D[0] + "/" + D[1];
}, _: function(D) {
  return D[0] + "_" + D[1];
}, "^": function(D) {
  return D[0] + "^" + D[1];
}, prime: function(D) {
  return D[0] + "'";
}, tuple: function(D) {
  return "( " + D.join(", ") + " )";
}, array: function(D) {
  return "[ " + D.join(", ") + " ]";
}, list: function(D) {
  return D.join(", ");
}, set: function(D) {
  return "{ " + D.join(", ") + " }";
}, vector: function(D) {
  return "( " + D.join(", ") + " )";
}, altvector: function(D) {
  return "( " + D.join(", ") + " )";
}, interval: function(D) {
  return "( " + D.join(", ") + " )";
}, matrix: function(D) {
  return "( " + D.join(", ") + " )";
}, and: function(D) {
  return D.join(" and ");
}, or: function(D) {
  return D.join(" or ");
}, not: function(D) {
  return "not " + D[0];
}, "=": function(D) {
  return D.join(" = ");
}, "<": function(D) {
  return D.join(" < ");
}, ">": function(D) {
  return D.join(" > ");
}, lts: function(D) {
  return D.join(" < ");
}, gts: function(D) {
  return D.join(" > ");
}, le: function(D) {
  return D.join(" <= ");
}, ge: function(D) {
  return D.join(" >= ");
}, ne: function(D) {
  return D.join(" ne ");
}, forall: function(D) {
  return "forall " + D[0];
}, exists: function(D) {
  return "exists " + D[0];
}, in: function(D) {
  return D[0] + " elementof " + D[1];
}, notin: function(D) {
  return D[0] + " notelementof " + D[1];
}, ni: function(D) {
  return D[0] + " containselement " + D[1];
}, notni: function(D) {
  return D[0] + " notcontainselement " + D[1];
}, subset: function(D) {
  return D[0] + " subset " + D[1];
}, subseteq: function(D) {
  return D[0] + " subseteq " + D[1];
}, notsubset: function(D) {
  return D[0] + " notsubset " + D[1];
}, notsubseteq: function(D) {
  return D[0] + " notsubseteq " + D[1];
}, superset: function(D) {
  return D[0] + " superset " + D[1];
}, superseteq: function(D) {
  return D[0] + " superseteq " + D[1];
}, notsuperset: function(D) {
  return D[0] + " notsuperset " + D[1];
}, notsuperseteq: function(D) {
  return D[0] + " notsuperseteq " + D[1];
}, union: function(D) {
  return D.join(" union ");
}, intersect: function(D) {
  return D.join(" intersect ");
}, rightarrow: function(D) {
  return D.join(" rightarrow ");
}, leftarrow: function(D) {
  return D.join(" leftarrow ");
}, leftrightarrow: function(D) {
  return D.join(" leftrightarrow ");
}, implies: function(D) {
  return D.join(" implies ");
}, impliedby: function(D) {
  return D.join(" impliedby ");
}, iff: function(D) {
  return D.join(" iff ");
}, perp: function(D) {
  return D.join(" perp ");
}, parallel: function(D) {
  return D.join(" parallel ");
}, derivative_leibniz: function(D) {
  return "d" + D[0] + "/d" + D[1];
}, partial_derivative_leibniz: function(D) {
  return "∂" + D[0] + "/∂" + D[1];
}, "|": function(D) {
  return D[0] + " | " + D[1];
}, ":": function(D) {
  return D[0] + " : " + D[1];
}, binom: function(D) {
  return "binom( " + D[0] + ", " + D[1] + " )";
}, vec: function(D) {
  return "vec(" + D[0] + ")";
}, linesegment: function(D) {
  return "linesegment( " + D.join(", ") + " )";
}, angle: function(D, E) {
  return E ? "angle " + D.join("") : "angle( " + D.join(", ") + " )";
}, unit: function(D) {
  return D[0] + " " + D[1];
} }, output_unicodeDefault = !0, astToText$2 = class {
  constructor({ output_unicode: D = output_unicodeDefault, padToDigits: E = null, padToDecimals: O = null, avoidScientificNotation: F = !1, showBlanks: I = !0, explicitMultiplicationSymbols: z = !1 } = {}) {
    this.output_unicode = D, this.operators = unicode_operators, D || (this.operators = nonunicode_operators), this.padToDigits = E, this.padToDecimals = O, this.avoidScientificNotation = F, this.showBlanks = I, this.explicitMultiplicationSymbols = z;
  }
  convert(D) {
    return this.statement(normalize_display_negative_fractions(D));
  }
  statement(D) {
    if (!Array.isArray(D)) return this.single_statement(D);
    let E = D[0], O = D.slice(1);
    if (E === "ldots") return "...";
    if (!(E in this.operators) && E !== "apply") throw Error("Badly formed ast: operator " + E + " not recognized.");
    return ["implies", "impliedby", "iff", "rightarrow", "leftarrow", "leftrightarrow"].includes(E) ? this.operators[E](O.map((F) => this.statement(F))) : E === "and" || E === "or" ? this.operators[E](O.map((function(F, I) {
      let z = this.single_statement(F);
      return z.match(/ /) && !z.match(/^\(.*\)$/) ? "(" + z + ")" : z;
    }).bind(this))) : this.single_statement(D);
  }
  single_statement(D) {
    if (!Array.isArray(D)) return this.expression(D);
    let E = D[0], O = D.slice(1);
    if (E === "not") return this.operators[E](O.map((function(F, I) {
      let z = this.single_statement(F);
      return z.match(/ /) && !z.match(/^\(.*\)$/) ? "(" + z + ")" : z;
    }).bind(this)));
    if (E === "exists" || E === "forall") return this.operators[E]([this.single_statement(O[0])]);
    if (E === "=" || E === "ne" || E === "<" || E === ">" || E === "le" || E === "ge" || E === "in" || E === "notin" || E === "ni" || E === "notni" || E === "subset" || E === "notsubset" || E === "subseteq" || E === "notsubseteq" || E === "superset" || E === "notsuperset" || E === "superseteq" || E === "notsuperseteq") return this.operators[E](O.map((function(F, I) {
      return this.expression(F);
    }).bind(this)));
    if (E === "lts" || E === "gts") {
      let F = O[0], I = O[1];
      if (F[0] !== "tuple" || I[0] !== "tuple") throw Error("Badly formed ast");
      let z = this.expression(F[1]);
      for (let R = 1; R < F.length - 1; R++) I[R] ? E === "lts" ? z += " < " : z += " > " : E === "lts" ? this.output_unicode ? z += " ≤ " : z += " <= " : this.output_unicode ? z += " ≥ " : z += " >= ", z += this.expression(F[R + 1]);
      return z;
    }
    return this.expression(D);
  }
  expression(D) {
    if (!Array.isArray(D)) return this.term(D);
    let E = D[0], O = D.slice(1);
    return E === "+" ? O.length === 1 ? "+" + this.term(O[0]) : this.operators[E](O.map((function(F, I) {
      return I > 0 ? this.termWithPlusIfNotNegated(F) : this.term(F);
    }).bind(this))) : ["union", "intersect", "perp", "parallel"].includes(E) ? this.operators[E](O.map((function(F, I) {
      return this.term(F);
    }).bind(this))) : this.term(D);
  }
  term(D) {
    if (!Array.isArray(D)) return this.factor(D);
    let E = D[0], O = D.slice(1);
    if (E === "-" || E === "pm") return this.operators[E](O.map((function(F, I) {
      return this.term(F);
    }).bind(this)));
    if (E === "*") {
      let F = O.map((function(I, z) {
        let R;
        return z > 0 ? (R = this.factorWithParenthesesIfNegatedOrExplicitPlus(I), !this.explicitMultiplicationSymbols && R.match(/^[0-9]/) ? "* " + R : I[0] === "angle" && O.length > 1 ? "( " + R + " )" : R) : (R = this.factor(I), I[0] === "angle" && O.length > 1 ? "( " + R + " )" : R);
      }).bind(this));
      return this.explicitMultiplicationSymbols ? F.join("*") : this.operators[E](F);
    }
    if (E === "/") {
      let F = this.factor(O[0]), I = this.factor(O[1]);
      return this.simple_factor_or_function_or_parens(O[0]) || (F = "(" + F + ")"), this.simple_factor_or_function_or_parens(O[1]) || (I = "(" + I + ")"), this.operators[E]([F, I]);
    }
    return E === "unit" ? this.operators[E](O.map((function(F, I) {
      return this.expression(F);
    }).bind(this))) : this.factor(D);
  }
  symbolConvert(D) {
    let E = { alpha: "α", beta: "β", Gamma: "Γ", gamma: "γ", Delta: "Δ", delta: "δ", epsilon: "ε", zeta: "ζ", eta: "η", Theta: "ϴ", theta: "θ", iota: "ι", kappa: "κ", Lambda: "Λ", lambda: "λ", mu: "μ", nu: "ν", Xi: "Ξ", xi: "ξ", Pi: "Π", pi: "π", rho: "ρ", Sigma: "Σ", sigma: "σ", tau: "τ", Upsilon: "Υ", upsilon: "υ", Phi: "Φ", phi: "ϕ", Psi: "Ψ", psi: "ψ", Omega: "Ω", omega: "ω", perp: "⟂", int: "∫", emptyset: "∅" };
    return this.output_unicode && D in E ? E[D] : !this.showBlanks && D === "＿" ? "" : D;
  }
  simple_factor_or_function_or_parens(D) {
    let E = this.factor(D);
    return E.length <= 1 || typeof D == "string" && D.match(/^\w+$/) || Array.isArray(D) && D[0] === "apply" || E.match(/^\(.*\)$/) || E.match(/^⟨.*⟩$/) ? !0 : typeof D == "number" ? !!(D >= 0 && (this.avoidScientificNotation || !D.toString().includes("e"))) : !1;
  }
  factor(D) {
    if (typeof D == "string") return this.symbolConvert(D);
    if (typeof D == "number") {
      if (D === 1 / 0) return this.output_unicode ? "∞" : "infinity";
      if (D === -1 / 0) return this.output_unicode ? "-∞" : "-infinity";
      if (Number.isNaN(D)) return "NaN";
      {
        let F = D.toString(), I = F.indexOf("e");
        if (I === -1 || this.avoidScientificNotation) return I !== -1 && this.avoidScientificNotation && (F = expandScientificNotation(F)), (this.padToDigits !== null || this.padToDecimals !== null) && (F = padNumberStringToDigitsAndDecimals(F, this.padToDigits, this.padToDecimals)), F;
        let z = F.substring(0, I), R = F.substring(I + 1);
        if (this.padToDigits !== null || this.padToDecimals !== null) {
          let L = Number(R);
          if (L > 0 && this.padToDecimals !== null) return F = D.toLocaleString("fullwide", { useGrouping: !1 }), padNumberStringToDigitsAndDecimals(F, this.padToDigits, this.padToDecimals);
          {
            let q = null;
            this.padToDecimals !== null && (q = this.padToDecimals + L), z = padNumberStringToDigitsAndDecimals(z, this.padToDigits, q);
          }
        }
        return R[0] === "+" ? z + " * 10^" + R.substring(1) : z + " * 10^(" + R + ")";
      }
    }
    if (!Array.isArray(D)) return "";
    let E = D[0], O = D.slice(1);
    if (E === "^") {
      if (Number.isInteger(O[0]) && Number.isInteger(O[1])) {
        let R;
        return R = O[0] < 0 ? "(" + O[0].toString() + ")" : O[0].toString(), O[1] < 0 ? R + "^(" + O[1].toString() + ")" : R + "^" + O[1].toString();
      }
      let F = this.factor(O[0]), I = O[0];
      for (; I[0] === "prime"; ) I = I[1];
      this.simple_factor_or_function_or_parens(I) || I[0] === "_" && typeof I[1] == "string" || (F = "(" + F.toString() + ")");
      let z = this.factor(O[1]);
      return this.simple_factor_or_function_or_parens(O[1]) || (z = "(" + z.toString() + ")"), F + "^" + z;
    } else {
      if (E === "_") return this.operators[E](O.map((function(F, I) {
        let z = this.factor(F);
        return this.simple_factor_or_function_or_parens(F) ? z : "(" + z + ")";
      }).bind(this)));
      if (E === "prime") {
        let F = O[0], I = 1;
        for (; F[0] === "prime"; ) I += 1, F = F[1];
        let z = this.factor(F);
        this.simple_factor_or_function_or_parens(F) || F[0] === "_" && typeof F[1] == "string" || (z = "(" + z + ")");
        for (let R = 0; R < I; R++) z += "'";
        return z;
      } else {
        if (E === "-") return this.operators[E](O.map((function(F, I) {
          return this.term(F);
        }).bind(this)));
        if (E === "tuple" || E === "array" || E === "list" || E === "set" || E === "vector" || E === "altvector" || E === "|" || E === ":" || E === "binom" || E === "vec" || E === "linesegment") return this.operators[E](O.map((function(F, I) {
          return this.statement(F);
        }).bind(this)));
        if (E === "interval") {
          let F = O[0], I = O[1];
          if (F[0] !== "tuple" || I[0] !== "tuple") throw Error("Badly formed ast");
          let z = this.statement(F[1]) + ", " + this.statement(F[2]);
          return z = I[1] ? "[ " + z : "( " + z, I[2] ? z += " ]" : z += " )", z;
        } else if (E === "matrix") {
          let F = O[0], I = O[1], z = "[ ";
          for (let R = 0; R < F[1]; R += 1) {
            z += "[ ";
            for (let L = 0; L < F[2]; L += 1) z += this.statement(I[R + 1][L + 1]), L < F[2] - 1 && (z += ","), z += " ";
            z += "]", R < F[1] - 1 && (z += ","), z += " ";
          }
          return z += "]", z;
        } else if (E === "derivative_leibniz" || E === "partial_derivative_leibniz") {
          let F = "d";
          E === "partial_derivative_leibniz" && (F = "∂");
          let I = O[0], z = O[1], R = 1, L = "";
          Array.isArray(I) ? (L = I[1], R = I[2]) : L = I;
          let q = F;
          R > 1 && (q = q + "^" + R), q = q + this.symbolConvert(L) + "/";
          let U = 1;
          Array.isArray(z) && (U = z.length - 1);
          for (let Z = 1; Z <= U; Z++) {
            let V = z[Z], G = 1, W = "";
            Array.isArray(V) ? (W = V[1], G = V[2]) : W = V, q = q + F + this.symbolConvert(W), G > 1 && (q = q + "^" + G);
          }
          return q;
        } else if (E === "apply") {
          if (O[0] === "abs") return "|" + this.statement(O[1]) + "|";
          if (O[0] === "factorial") {
            let R = this.factor(O[1]);
            return this.simple_factor_or_function_or_parens(O[1]) || O[1][0] === "_" && typeof O[1][1] == "string" ? R + "!" : "(" + R + ")!";
          }
          let F = O[0];
          if (F[0] === "^" && (F = F[1]), F[0] === "_" && (F = F[1]), F === "int") {
            let R = this.factor(O[0]), L = O[1], q;
            if (Array.isArray(L) && L[0] === "*") {
              let U = [], Z = ["*"];
              for (let V = 1; V < L.length; V++) {
                let G = L[V];
                Array.isArray(G) && G[0] === "d" ? U.push(G) : Z.push(G);
              }
              q = this.term(Z), U.length > 0 && (q += " " + U.map((V) => "d" + this.factor(V[1])).join(" "));
            }
            return q ||= this.term(O[1]), R + " " + q;
          }
          let I = this.factor(O[0]), z = this.statement(O[1]);
          return O[1][0] !== "tuple" && (z = "(" + z + ")"), I + z;
        } else if (E === "angle") {
          let F = O.every((I) => {
            if (typeof I == "string" && I.length === 1) return !0;
            if (!Array.isArray(I)) return !1;
            let z = I[0];
            return z === "_" || z === "^" || z === "prime";
          });
          return this.operators[E](O.map((function(I, z) {
            return this.statement(I);
          }).bind(this)), F);
        } else return E === "+" && D.length === 2 ? "+ " + this.factor(D[1]) : "(" + this.statement(D) + ")";
      }
    }
  }
  factorWithParenthesesIfNegatedOrExplicitPlus(D) {
    var E = this.factor(D);
    return E.match(/^-/) || E.match(/^\+/) ? "(" + E + ")" : E;
  }
  termWithPlusIfNotNegated(D) {
    let E = this.term(D);
    return E.match(/^± /) || E.match(/^plusminus /) ? E : E.match(/^-/) ? E.match(/^-[^ ]/) ? "- " + E.slice(1) : E : "+ " + E;
  }
}, astToText$1 = new astToText$2();
function subscripts_to_strings(D, E = !1) {
  var O = get_tree(D);
  if (!Array.isArray(O)) return O;
  let F = O[0], I = O.slice(1);
  return F === "_" && (E || I.every((z) => ["number", "string"].includes(typeof z))) ? astToText$1.convert(O) : [F].concat(I.map((z) => subscripts_to_strings(z, E)));
}
function strings_to_subscripts(D) {
  var E = get_tree(D);
  if (typeof E == "string") {
    let I = E.match(/^([0-9a-zA-Z]+)_([a-zA-Z]+|[0-9]+)$/);
    if (I) {
      let z = Number(I[1]);
      isNaN(z) && (z = I[1]);
      let R = Number(I[2]);
      return isNaN(R) && (R = I[2]), ["_", z, R];
    } else return E;
  }
  if (!Array.isArray(E)) return E;
  let O = E[0], F = E.slice(1);
  return [O].concat(F.map(strings_to_subscripts));
}
var normalization_exports = __exportAll({ altvectors_to_vectors: () => altvectors_to_vectors, constants_to_floats: () => constants_to_floats, default_order: () => default_order, log_subscript_to_two_arg_log: () => log_subscript_to_two_arg_log, normalize_angle_linesegment_arg_order: () => normalize_angle_linesegment_arg_order, normalize_applied_functions: () => normalize_applied_functions, normalize_function_names: () => normalize_function_names, normalize_negative_numbers: () => normalize_negative_numbers, strings_to_subscripts: () => strings_to_subscripts, subscripts_to_strings: () => subscripts_to_strings, substitute_abs: () => substitute_abs, to_intervals: () => to_intervals, tuples_to_vectors: () => tuples_to_vectors });
function get_all_units() {
  return { "%": { scale: (D) => ["/", D, 100], only_scales: !0 }, $: { prefix: !0, scale: (D) => D }, deg: { scale: (D) => ["/", ["*", D, "pi"], 180], only_scales: !0 } };
}
var all_units$1 = get_all_units();
function get_unit_of_tree(D) {
  if (D[0] === "unit") {
    for (let E in all_units$1) if (all_units$1[E].prefix) {
      if (D[1] === E) return E;
    } else if (D[2] === E) return E;
  }
  return null;
}
function get_unit_value_of_tree(D) {
  if (D[0] === "unit") {
    for (let E in all_units$1) if (all_units$1[E].prefix) {
      if (D[1] === E) return [E, D[2]];
    } else if (D[2] === E) return [E, D[1]];
  }
  return null;
}
function remove_duplicate_negatives(D) {
  if (!Array.isArray(D)) return D;
  var E = D[0], O = D.slice(1);
  return E === "-" && Array.isArray(O[0]) && O[0][0] === "-" ? remove_duplicate_negatives(O[0][1]) : E === "-" && typeof O[0] == "number" && O[0] < 0 ? -O[0] : (O = O.map(remove_duplicate_negatives), [E].concat(O));
}
function normalize_negatives_in_factors(D) {
  if (!Array.isArray(D)) return D;
  var E = D[0], O = D.slice(1);
  if (O = O.map(normalize_negatives_in_factors), E !== "*" && E !== "/") return [E].concat(O);
  for (var F = 1, I = [], z = 0; z < O.length; z++) Array.isArray(O[z]) && O[z][0] === "-" ? (F *= -1, I.push(O[z][1])) : typeof O[z] == "number" && O[z] < 0 ? (F *= -1, I.push(-O[z])) : I.push(O[z]);
  var R = [E].concat(I);
  return F === -1 && (R = ["-", R]), R;
}
function normalize_negatives(D) {
  var E = get_tree(D);
  return E = remove_duplicate_negatives(E), E = normalize_negatives_in_factors(E), E = remove_duplicate_negatives(E), E = normalize_negative_numbers(E), E;
}
function sort_key(D, E = {}) {
  if (typeof D == "number") return E.ignore_negatives ? [0, "number", Math.abs(D)] : [0, "number", D];
  if (typeof D == "string") return D === "-" || D === "+" ? [8, "plus_minus_string", D] : [1, "symbol", D];
  if (typeof D == "boolean") return [1, "boolean", D];
  if (!Array.isArray(D)) return [-1, "unknown", D];
  var O = D[0], F = D.slice(1);
  if (O === "^" && F.length === 2) return [...sort_key(F[0], E), "power", ...sort_key(F[1], E)];
  if (O === "apply") {
    var I = [2, "function", F[0]];
    (F[0] === "sqrt" || F[0] === "cbrt" || F[0] === "nthroot") && (I = [5, "root", F[0] === "sqrt" ? 2 : F[0] === "cbrt" ? 3 : F[1][2] ?? 2]);
    var z = F[1], R = 1, L = [];
    return Array.isArray(z) ? (z = z.slice(1), R = z.length, L = z.map((Z) => sort_key(Z, E))) : L = [sort_key(z, E)], I.push([R, L]), I;
  } else if (O === "unit") {
    let [Z, V] = get_unit_value_of_tree(D);
    if (Z) {
      let G = sort_key(V, E);
      return G[1] += "_" + Z, G;
    }
  }
  var q = F.length, U = F.map(sort_key, E);
  return O === "*" ? [4, "product", q, U] : O === "/" ? [4, "quotient", q, U] : O === "+" ? [5, "sum", q, U] : O === "-" ? E.ignore_negatives ? U[0] : [6, "minus", q, U] : O === "pm" ? E.ignore_negatives ? U[0] : [6, "pm", q, U] : ["tuple", "vector", "altvector"].includes(O) ? [7, q, U] : O === "interval" ? F[1][1] === !1 ? F[1][2] === !1 ? [7, ...U[0].slice(1)] : [8, q, U] : F[1][2] === !1 ? [8, q, U] : [9, ...U[0].slice(1)] : O === "array" ? [9, q, U] : [10, O, q, U];
}
function arrayCompare(D, E) {
  if (Array.isArray(D)) if (Array.isArray(E)) {
    let O = Math.min(D.length, E.length);
    for (let F = 0; F < O; F++) {
      let I = arrayCompare(D[F], E[F]);
      if (I !== 0) return I;
    }
    return D.length < E.length ? -1 : +(D.length > E.length);
  } else return 1;
  else return Array.isArray(E) || D < E ? -1 : +(D > E);
}
function compare_function(D, E, O = {}) {
  return arrayCompare(sort_key(D, O), sort_key(E, O));
}
function coeff_factors_from_term(D, E) {
  if (typeof D == "string") {
    let O = E.indexOf(D);
    O === -1 && (E.push(D), O = E.length - 1);
    let F = [];
    return F[O] = 1, { factor_contains: F, coeff: 1 };
  } else if (Array.isArray(D)) {
    let O = D[0], F = D.slice(1);
    if (O === "*") {
      let I = [], z = [];
      for (let R of F) {
        if (typeof R == "string") {
          let L = E.indexOf(R);
          L === -1 && (E.push(R), L = E.length - 1), z[L] === void 0 && (z[L] = 0), z[L]++;
          continue;
        } else if (Array.isArray(R) && (R[0] === "^" || R[0] === "-")) {
          let L = coeff_factors_from_term(R, E);
          for (let q in L.factor_contains) z[q] === void 0 && (z[q] = 0), z[q] += L.factor_contains[q];
          L.coeff !== 1 && I.push(L.coeff);
          continue;
        }
        I.push(R);
      }
      return I = I.length === 0 ? 1 : I.length === 1 ? I[0] : ["*", ...I], { factor_contains: z, coeff: I };
    } else if (O === "^") {
      let I = F[0], z = F[1], R = [];
      if (typeof I == "string" && Number.isFinite(z)) {
        let L = E.indexOf(I);
        return L === -1 && (E.push(I), L = E.length - 1), R[L] = z, { factor_contains: R, coeff: 1 };
      }
    } else if (O === "-") {
      let I = coeff_factors_from_term(F[0], E), z = -1;
      return typeof I.coeff == "number" ? z *= I.coeff : z = ["-", I.coeff], { factor_contains: I.factor_contains, coeff: z };
    } else if (O === "/") {
      let I = coeff_factors_from_term(F[0], E), z = ["/", I.coeff, F[1]];
      return { factor_contains: I.factor_contains, coeff: z };
    }
  }
  return { factor_contains: [], coeff: D };
}
function default_order(D, E) {
  E === void 0 && (E = {});
  var O = get_tree(D);
  O = flatten$5(O), O = normalize_negatives(O);
  function F(I) {
    if (!Array.isArray(I)) return I;
    var z = I[0], R = I.slice(1);
    if (R = R.map(F), z === "+") {
      let U = [], Z = [], V = [];
      for (let X of R) {
        let Y = coeff_factors_from_term(X, U);
        Z.push(Y.factor_contains), V.push(Y.coeff);
      }
      let G = [];
      for (let [X, Y] of U.entries()) {
        let ee = { varname: Y, exponents_in_term: [] };
        for (let K = 0; K < Z.length; K++) ee.exponents_in_term.push(Z[K][X] || 0);
        G.push(ee);
      }
      G.sort((X, Y) => X.varname < Y.varname ? -1 : 1);
      let W = [];
      for (let X = 0; X < V.length; X++) {
        let Y = G.reduce((ee, K) => [...ee, -K.exponents_in_term[X]], []);
        Y.push(sort_key(V[X], E)), W.push(Y);
      }
      let J = [];
      for (let [X, Y] of R.entries()) J.push({ term: Y, sort_key: W[X] });
      J.sort((X, Y) => arrayCompare(X.sort_key, Y.sort_key)), R = J.map((X) => X.term);
    } else if (z === "*") {
      let U = [], Z = [];
      for (let V of R) ["tuple", "list", "vector", "altvector", "interval", "set", "array", "matrix"].includes(V[0]) ? Z.push(V) : U.push(V);
      U.sort((V, G) => compare_function(V, G, E)), R = [...U, ...Z];
    } else if (z === "=" || z === "and" || z === "or" || z === "ne" || z === "union" || z === "intersect") R.sort((U, Z) => compare_function(U, Z, E));
    else if (z === ">" || z === "ge") R = R.reverse(), z = z === ">" ? "<" : "le";
    else if (z === "gts") {
      var L = R[0], q = R[1];
      if (L[0] !== "tuple" || q[0] !== "tuple") throw Error("Badly formed ast");
      L = ["tuple"].concat(L.slice(1).reverse()), q = ["tuple"].concat(q.slice(1).reverse()), z = "lts", R = [L, q];
    } else if (z === "ni" || z === "notni" || z === "superset" || z === "notsuperset" || z === "superseteq" || z === "notsuperseteq") R = R.reverse(), z === "ni" ? z = "in" : z === "notni" ? z = "notin" : z === "superset" ? z = "subset" : z === "notsuperset" ? z = "notsubset" : z === "superseteq" ? z = "subseteq" : z === "notsuperseteq" && (z = "notsubseteq");
    else if (z === "-" && R[0][0] === "*") return R[0][1] = ["-", R[0][1]], R[0];
    return [z].concat(R);
  }
  return normalize_negatives(F(O));
}
var variables_exports = __exportAll({ functions: () => functions$2, operators: () => operators$3, variables: () => variables });
function leaves(D, E) {
  if (!Array.isArray(D)) return [D];
  var O = D[0], F = D.slice(1);
  return E && O === "_" && typeof F[0] == "string" && (typeof F[1] == "string" || typeof F[1] == "number") ? [F[0] + "_" + F[1]] : (O === "apply" && (F = D.slice(2)), F.length === 0 ? [] : F.map(function(I, z) {
    return leaves(I, E);
  }).reduce(function(I, z) {
    return I.concat(z);
  }));
}
function variables(D, E = !1) {
  var O = leaves(get_tree(D), E);
  return O = O.filter(function(F, I) {
    return typeof F == "string" && (mathjs_default.define_e || F !== "e") && (mathjs_default.define_pi || F !== "pi") && (mathjs_default.define_i || F !== "i");
  }), O = O.filter(function(F, I, z) {
    return I === O.indexOf(F);
  }), O;
}
function operators_list(D) {
  if (!Array.isArray(D)) return [];
  var E = D[0], O = D.slice(1);
  return E === "apply" && (O = D.slice(2)), O.length === 0 ? [E] : [E].concat(O.map(function(F, I) {
    return operators_list(F);
  }).reduce(function(F, I) {
    return F.concat(I);
  }));
}
function operators$3(D) {
  var E = operators_list(get_tree(D));
  return E = E.filter(function(O, F) {
    return O !== "apply";
  }), E = E.filter(function(O, F, I) {
    return F === E.indexOf(O);
  }), E;
}
function functions_list(D) {
  if (!Array.isArray(D)) return [];
  var E = D[0], O = D.slice(1), F = [];
  return E === "apply" && (F = [O[0]], O = D.slice(2)), F.concat(O.map(function(I, z) {
    return functions_list(I);
  }).reduce(function(I, z) {
    return I.concat(z);
  }, []));
}
function functions$2(D) {
  var E = functions_list(get_tree(D));
  return E = E.filter(function(O, F, I) {
    return F === E.indexOf(O);
  }), E;
}
var VERSION, root, ArrayProto, ObjProto, SymbolProto, push, slice, toString$1, hasOwnProperty, supportsArrayBuffer, supportsDataView, nativeIsArray, nativeKeys, nativeCreate, nativeIsView, _isNaN, _isFinite, hasEnumBug, nonEnumerableProps, MAX_ARRAY_INDEX, init__setup = __esmMin((() => {
  VERSION = "1.13.6", root = typeof self == "object" && self.self === self && self || typeof global == "object" && global.global === global && global || Function("return this")() || {}, ArrayProto = Array.prototype, ObjProto = Object.prototype, SymbolProto = typeof Symbol < "u" ? Symbol.prototype : null, push = ArrayProto.push, slice = ArrayProto.slice, toString$1 = ObjProto.toString, hasOwnProperty = ObjProto.hasOwnProperty, supportsArrayBuffer = typeof ArrayBuffer < "u", supportsDataView = typeof DataView < "u", nativeIsArray = Array.isArray, nativeKeys = Object.keys, nativeCreate = Object.create, nativeIsView = supportsArrayBuffer && ArrayBuffer.isView, _isNaN = isNaN, _isFinite = isFinite, hasEnumBug = !{ toString: null }.propertyIsEnumerable("toString"), nonEnumerableProps = ["valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"], MAX_ARRAY_INDEX = 2 ** 53 - 1;
}));
function restArguments(D, E) {
  return E = E == null ? D.length - 1 : +E, function() {
    for (var O = Math.max(arguments.length - E, 0), F = Array(O), I = 0; I < O; I++) F[I] = arguments[I + E];
    switch (E) {
      case 0:
        return D.call(this, F);
      case 1:
        return D.call(this, arguments[0], F);
      case 2:
        return D.call(this, arguments[0], arguments[1], F);
    }
    var z = Array(E + 1);
    for (I = 0; I < E; I++) z[I] = arguments[I];
    return z[E] = F, D.apply(this, z);
  };
}
var init_restArguments = __esmMin((() => {
}));
function isObject(D) {
  var E = typeof D;
  return E === "function" || E === "object" && !!D;
}
var init_isObject = __esmMin((() => {
}));
function isNull(D) {
  return D === null;
}
var init_isNull = __esmMin((() => {
}));
function isUndefined(D) {
  return D === void 0;
}
var init_isUndefined = __esmMin((() => {
}));
function isBoolean(D) {
  return D === !0 || D === !1 || toString$1.call(D) === "[object Boolean]";
}
var init_isBoolean = __esmMin((() => {
  init__setup();
}));
function isElement(D) {
  return !!(D && D.nodeType === 1);
}
var init_isElement = __esmMin((() => {
}));
function tagTester(D) {
  var E = "[object " + D + "]";
  return function(O) {
    return toString$1.call(O) === E;
  };
}
var init__tagTester = __esmMin((() => {
  init__setup();
})), isString_default, init_isString = __esmMin((() => {
  init__tagTester(), isString_default = tagTester("String");
})), isNumber_default, init_isNumber = __esmMin((() => {
  init__tagTester(), isNumber_default = tagTester("Number");
})), isDate_default, init_isDate = __esmMin((() => {
  init__tagTester(), isDate_default = tagTester("Date");
})), isRegExp_default, init_isRegExp = __esmMin((() => {
  init__tagTester(), isRegExp_default = tagTester("RegExp");
})), isError_default, init_isError = __esmMin((() => {
  init__tagTester(), isError_default = tagTester("Error");
})), isSymbol_default, init_isSymbol = __esmMin((() => {
  init__tagTester(), isSymbol_default = tagTester("Symbol");
})), isArrayBuffer_default, init_isArrayBuffer = __esmMin((() => {
  init__tagTester(), isArrayBuffer_default = tagTester("ArrayBuffer");
})), isFunction, nodelist, isFunction_default, init_isFunction = __esmMin((() => {
  init__tagTester(), init__setup(), isFunction = tagTester("Function"), nodelist = root.document && root.document.childNodes, typeof /./ != "function" && typeof Int8Array != "object" && typeof nodelist != "function" && (isFunction = function(D) {
    return typeof D == "function" || !1;
  }), isFunction_default = isFunction;
})), _hasObjectTag_default, init__hasObjectTag = __esmMin((() => {
  init__tagTester(), _hasObjectTag_default = tagTester("Object");
})), hasStringTagBug, isIE11, init__stringTagBug = __esmMin((() => {
  init__setup(), init__hasObjectTag(), hasStringTagBug = supportsDataView && _hasObjectTag_default(new DataView(new ArrayBuffer(8))), isIE11 = typeof Map < "u" && _hasObjectTag_default(/* @__PURE__ */ new Map());
}));
function ie10IsDataView(D) {
  return D != null && isFunction_default(D.getInt8) && isArrayBuffer_default(D.buffer);
}
var isDataView, isDataView_default, init_isDataView = __esmMin((() => {
  init__tagTester(), init_isFunction(), init_isArrayBuffer(), init__stringTagBug(), isDataView = tagTester("DataView"), isDataView_default = hasStringTagBug ? ie10IsDataView : isDataView;
})), isArray_default, init_isArray = __esmMin((() => {
  init__setup(), init__tagTester(), isArray_default = nativeIsArray || tagTester("Array");
}));
function has$1(D, E) {
  return D != null && hasOwnProperty.call(D, E);
}
var init__has = __esmMin((() => {
  init__setup();
})), isArguments, isArguments_default, init_isArguments = __esmMin((() => {
  init__tagTester(), init__has(), isArguments = tagTester("Arguments"), (function() {
    isArguments(arguments) || (isArguments = function(D) {
      return has$1(D, "callee");
    });
  })(), isArguments_default = isArguments;
}));
function isFinite$1(D) {
  return !isSymbol_default(D) && _isFinite(D) && !isNaN(parseFloat(D));
}
var init_isFinite = __esmMin((() => {
  init__setup(), init_isSymbol();
}));
function isNaN$1(D) {
  return isNumber_default(D) && _isNaN(D);
}
var init_isNaN = __esmMin((() => {
  init__setup(), init_isNumber();
}));
function constant(D) {
  return function() {
    return D;
  };
}
var init_constant = __esmMin((() => {
}));
function createSizePropertyCheck(D) {
  return function(E) {
    var O = D(E);
    return typeof O == "number" && O >= 0 && O <= MAX_ARRAY_INDEX;
  };
}
var init__createSizePropertyCheck = __esmMin((() => {
  init__setup();
}));
function shallowProperty(D) {
  return function(E) {
    return E?.[D];
  };
}
var init__shallowProperty = __esmMin((() => {
})), _getByteLength_default, init__getByteLength = __esmMin((() => {
  init__shallowProperty(), _getByteLength_default = shallowProperty("byteLength");
})), _isBufferLike_default, init__isBufferLike = __esmMin((() => {
  init__createSizePropertyCheck(), init__getByteLength(), _isBufferLike_default = createSizePropertyCheck(_getByteLength_default);
}));
function isTypedArray(D) {
  return nativeIsView ? nativeIsView(D) && !isDataView_default(D) : _isBufferLike_default(D) && typedArrayPattern.test(toString$1.call(D));
}
var typedArrayPattern, isTypedArray_default, init_isTypedArray = __esmMin((() => {
  init__setup(), init_isDataView(), init_constant(), init__isBufferLike(), typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/, isTypedArray_default = supportsArrayBuffer ? isTypedArray : constant(!1);
})), _getLength_default, init__getLength = __esmMin((() => {
  init__shallowProperty(), _getLength_default = shallowProperty("length");
}));
function emulatedSet(D) {
  for (var E = {}, O = D.length, F = 0; F < O; ++F) E[D[F]] = !0;
  return { contains: function(I) {
    return E[I] === !0;
  }, push: function(I) {
    return E[I] = !0, D.push(I);
  } };
}
function collectNonEnumProps(D, E) {
  E = emulatedSet(E);
  var O = nonEnumerableProps.length, F = D.constructor, I = isFunction_default(F) && F.prototype || ObjProto, z = "constructor";
  for (has$1(D, z) && !E.contains(z) && E.push(z); O--; ) z = nonEnumerableProps[O], z in D && D[z] !== I[z] && !E.contains(z) && E.push(z);
}
var init__collectNonEnumProps = __esmMin((() => {
  init__setup(), init_isFunction(), init__has();
}));
function keys(D) {
  if (!isObject(D)) return [];
  if (nativeKeys) return nativeKeys(D);
  var E = [];
  for (var O in D) has$1(D, O) && E.push(O);
  return hasEnumBug && collectNonEnumProps(D, E), E;
}
var init_keys = __esmMin((() => {
  init_isObject(), init__setup(), init__has(), init__collectNonEnumProps();
}));
function isEmpty(D) {
  if (D == null) return !0;
  var E = _getLength_default(D);
  return typeof E == "number" && (isArray_default(D) || isString_default(D) || isArguments_default(D)) ? E === 0 : _getLength_default(keys(D)) === 0;
}
var init_isEmpty = __esmMin((() => {
  init__getLength(), init_isArray(), init_isString(), init_isArguments(), init_keys();
}));
function isMatch(D, E) {
  var O = keys(E), F = O.length;
  if (D == null) return !F;
  for (var I = Object(D), z = 0; z < F; z++) {
    var R = O[z];
    if (E[R] !== I[R] || !(R in I)) return !1;
  }
  return !0;
}
var init_isMatch = __esmMin((() => {
  init_keys();
}));
function _$1(D) {
  if (D instanceof _$1) return D;
  if (!(this instanceof _$1)) return new _$1(D);
  this._wrapped = D;
}
var init_underscore = __esmMin((() => {
  init__setup(), _$1.VERSION = VERSION, _$1.prototype.value = function() {
    return this._wrapped;
  }, _$1.prototype.valueOf = _$1.prototype.toJSON = _$1.prototype.value, _$1.prototype.toString = function() {
    return String(this._wrapped);
  };
}));
function toBufferView(D) {
  return new Uint8Array(D.buffer || D, D.byteOffset || 0, _getByteLength_default(D));
}
var init__toBufferView = __esmMin((() => {
  init__getByteLength();
}));
function eq(D, E, O, F) {
  if (D === E) return D !== 0 || 1 / D == 1 / E;
  if (D == null || E == null) return !1;
  if (D !== D) return E !== E;
  var I = typeof D;
  return I !== "function" && I !== "object" && typeof E != "object" ? !1 : deepEq(D, E, O, F);
}
function deepEq(D, E, O, F) {
  D instanceof _$1 && (D = D._wrapped), E instanceof _$1 && (E = E._wrapped);
  var I = toString$1.call(D);
  if (I !== toString$1.call(E)) return !1;
  if (hasStringTagBug && I == "[object Object]" && isDataView_default(D)) {
    if (!isDataView_default(E)) return !1;
    I = tagDataView;
  }
  switch (I) {
    case "[object RegExp]":
    case "[object String]":
      return "" + D == "" + E;
    case "[object Number]":
      return +D == +D ? +D == 0 ? 1 / D == 1 / E : +D == +E : +E != +E;
    case "[object Date]":
    case "[object Boolean]":
      return +D == +E;
    case "[object Symbol]":
      return SymbolProto.valueOf.call(D) === SymbolProto.valueOf.call(E);
    case "[object ArrayBuffer]":
    case tagDataView:
      return deepEq(toBufferView(D), toBufferView(E), O, F);
  }
  var z = I === "[object Array]";
  if (!z && isTypedArray_default(D)) {
    if (_getByteLength_default(D) !== _getByteLength_default(E)) return !1;
    if (D.buffer === E.buffer && D.byteOffset === E.byteOffset) return !0;
    z = !0;
  }
  if (!z) {
    if (typeof D != "object" || typeof E != "object") return !1;
    var R = D.constructor, L = E.constructor;
    if (R !== L && !(isFunction_default(R) && R instanceof R && isFunction_default(L) && L instanceof L) && "constructor" in D && "constructor" in E) return !1;
  }
  O ||= [], F ||= [];
  for (var q = O.length; q--; ) if (O[q] === D) return F[q] === E;
  if (O.push(D), F.push(E), z) {
    if (q = D.length, q !== E.length) return !1;
    for (; q--; ) if (!eq(D[q], E[q], O, F)) return !1;
  } else {
    var U = keys(D), Z;
    if (q = U.length, keys(E).length !== q) return !1;
    for (; q--; ) if (Z = U[q], !(has$1(E, Z) && eq(D[Z], E[Z], O, F))) return !1;
  }
  return O.pop(), F.pop(), !0;
}
function isEqual(D, E) {
  return eq(D, E);
}
var tagDataView, init_isEqual = __esmMin((() => {
  init_underscore(), init__setup(), init__getByteLength(), init_isTypedArray(), init_isFunction(), init__stringTagBug(), init_isDataView(), init_keys(), init__has(), init__toBufferView(), tagDataView = "[object DataView]";
}));
function allKeys(D) {
  if (!isObject(D)) return [];
  var E = [];
  for (var O in D) E.push(O);
  return hasEnumBug && collectNonEnumProps(D, E), E;
}
var init_allKeys = __esmMin((() => {
  init_isObject(), init__setup(), init__collectNonEnumProps();
}));
function ie11fingerprint(D) {
  var E = _getLength_default(D);
  return function(O) {
    if (O == null || _getLength_default(allKeys(O))) return !1;
    for (var F = 0; F < E; F++) if (!isFunction_default(O[D[F]])) return !1;
    return D !== weakMapMethods || !isFunction_default(O[forEachName]);
  };
}
var forEachName, hasName, commonInit, mapTail, mapMethods, weakMapMethods, setMethods, init__methodFingerprint = __esmMin((() => {
  init__getLength(), init_isFunction(), init_allKeys(), forEachName = "forEach", hasName = "has", commonInit = ["clear", "delete"], mapTail = ["get", hasName, "set"], mapMethods = commonInit.concat(forEachName, mapTail), weakMapMethods = commonInit.concat(mapTail), setMethods = ["add"].concat(commonInit, forEachName, hasName);
})), isMap_default, init_isMap = __esmMin((() => {
  init__tagTester(), init__stringTagBug(), init__methodFingerprint(), isMap_default = isIE11 ? ie11fingerprint(mapMethods) : tagTester("Map");
})), isWeakMap_default, init_isWeakMap = __esmMin((() => {
  init__tagTester(), init__stringTagBug(), init__methodFingerprint(), isWeakMap_default = isIE11 ? ie11fingerprint(weakMapMethods) : tagTester("WeakMap");
})), isSet_default, init_isSet = __esmMin((() => {
  init__tagTester(), init__stringTagBug(), init__methodFingerprint(), isSet_default = isIE11 ? ie11fingerprint(setMethods) : tagTester("Set");
})), isWeakSet_default, init_isWeakSet = __esmMin((() => {
  init__tagTester(), isWeakSet_default = tagTester("WeakSet");
}));
function values(D) {
  for (var E = keys(D), O = E.length, F = Array(O), I = 0; I < O; I++) F[I] = D[E[I]];
  return F;
}
var init_values = __esmMin((() => {
  init_keys();
}));
function pairs(D) {
  for (var E = keys(D), O = E.length, F = Array(O), I = 0; I < O; I++) F[I] = [E[I], D[E[I]]];
  return F;
}
var init_pairs = __esmMin((() => {
  init_keys();
}));
function invert(D) {
  for (var E = {}, O = keys(D), F = 0, I = O.length; F < I; F++) E[D[O[F]]] = O[F];
  return E;
}
var init_invert = __esmMin((() => {
  init_keys();
}));
function functions$1(D) {
  var E = [];
  for (var O in D) isFunction_default(D[O]) && E.push(O);
  return E.sort();
}
var init_functions = __esmMin((() => {
  init_isFunction();
}));
function createAssigner(D, E) {
  return function(O) {
    var F = arguments.length;
    if (E && (O = Object(O)), F < 2 || O == null) return O;
    for (var I = 1; I < F; I++) for (var z = arguments[I], R = D(z), L = R.length, q = 0; q < L; q++) {
      var U = R[q];
      (!E || O[U] === void 0) && (O[U] = z[U]);
    }
    return O;
  };
}
var init__createAssigner = __esmMin((() => {
})), extend_default, init_extend = __esmMin((() => {
  init__createAssigner(), init_allKeys(), extend_default = createAssigner(allKeys);
})), extendOwn_default, init_extendOwn = __esmMin((() => {
  init__createAssigner(), init_keys(), extendOwn_default = createAssigner(keys);
})), defaults_default, init_defaults = __esmMin((() => {
  init__createAssigner(), init_allKeys(), defaults_default = createAssigner(allKeys, !0);
}));
function ctor() {
  return function() {
  };
}
function baseCreate(D) {
  if (!isObject(D)) return {};
  if (nativeCreate) return nativeCreate(D);
  var E = ctor();
  E.prototype = D;
  var O = new E();
  return E.prototype = null, O;
}
var init__baseCreate = __esmMin((() => {
  init_isObject(), init__setup();
}));
function create(D, E) {
  var O = baseCreate(D);
  return E && extendOwn_default(O, E), O;
}
var init_create = __esmMin((() => {
  init__baseCreate(), init_extendOwn();
}));
function clone(D) {
  return isObject(D) ? isArray_default(D) ? D.slice() : extend_default({}, D) : D;
}
var init_clone = __esmMin((() => {
  init_isObject(), init_isArray(), init_extend();
}));
function tap(D, E) {
  return E(D), D;
}
var init_tap = __esmMin((() => {
}));
function toPath$1(D) {
  return isArray_default(D) ? D : [D];
}
var init_toPath = __esmMin((() => {
  init_underscore(), init_isArray(), _$1.toPath = toPath$1;
}));
function toPath(D) {
  return _$1.toPath(D);
}
var init__toPath = __esmMin((() => {
  init_underscore(), init_toPath();
}));
function deepGet(D, E) {
  for (var O = E.length, F = 0; F < O; F++) {
    if (D == null) return;
    D = D[E[F]];
  }
  return O ? D : void 0;
}
var init__deepGet = __esmMin((() => {
}));
function get(D, E, O) {
  var F = deepGet(D, toPath(E));
  return isUndefined(F) ? O : F;
}
var init_get = __esmMin((() => {
  init__toPath(), init__deepGet(), init_isUndefined();
}));
function has(D, E) {
  E = toPath(E);
  for (var O = E.length, F = 0; F < O; F++) {
    var I = E[F];
    if (!has$1(D, I)) return !1;
    D = D[I];
  }
  return !!O;
}
var init_has = __esmMin((() => {
  init__has(), init__toPath();
}));
function identity(D) {
  return D;
}
var init_identity = __esmMin((() => {
}));
function matcher(D) {
  return D = extendOwn_default({}, D), function(E) {
    return isMatch(E, D);
  };
}
var init_matcher = __esmMin((() => {
  init_extendOwn(), init_isMatch();
}));
function property(D) {
  return D = toPath(D), function(E) {
    return deepGet(E, D);
  };
}
var init_property = __esmMin((() => {
  init__deepGet(), init__toPath();
}));
function optimizeCb(D, E, O) {
  if (E === void 0) return D;
  switch (O ?? 3) {
    case 1:
      return function(F) {
        return D.call(E, F);
      };
    case 3:
      return function(F, I, z) {
        return D.call(E, F, I, z);
      };
    case 4:
      return function(F, I, z, R) {
        return D.call(E, F, I, z, R);
      };
  }
  return function() {
    return D.apply(E, arguments);
  };
}
var init__optimizeCb = __esmMin((() => {
}));
function baseIteratee(D, E, O) {
  return D == null ? identity : isFunction_default(D) ? optimizeCb(D, E, O) : isObject(D) && !isArray_default(D) ? matcher(D) : property(D);
}
var init__baseIteratee = __esmMin((() => {
  init_identity(), init_isFunction(), init_isObject(), init_isArray(), init_matcher(), init_property(), init__optimizeCb();
}));
function iteratee(D, E) {
  return baseIteratee(D, E, 1 / 0);
}
var init_iteratee = __esmMin((() => {
  init_underscore(), init__baseIteratee(), _$1.iteratee = iteratee;
}));
function cb(D, E, O) {
  return _$1.iteratee === iteratee ? baseIteratee(D, E, O) : _$1.iteratee(D, E);
}
var init__cb = __esmMin((() => {
  init_underscore(), init__baseIteratee(), init_iteratee();
}));
function mapObject(D, E, O) {
  E = cb(E, O);
  for (var F = keys(D), I = F.length, z = {}, R = 0; R < I; R++) {
    var L = F[R];
    z[L] = E(D[L], L, D);
  }
  return z;
}
var init_mapObject = __esmMin((() => {
  init__cb(), init_keys();
}));
function noop() {
}
var init_noop = __esmMin((() => {
}));
function propertyOf(D) {
  return D == null ? noop : function(E) {
    return get(D, E);
  };
}
var init_propertyOf = __esmMin((() => {
  init_noop(), init_get();
}));
function times(D, E, O) {
  var F = Array(Math.max(0, D));
  E = optimizeCb(E, O, 1);
  for (var I = 0; I < D; I++) F[I] = E(I);
  return F;
}
var init_times = __esmMin((() => {
  init__optimizeCb();
}));
function random(D, E) {
  return E ?? (E = D, D = 0), D + Math.floor(Math.random() * (E - D + 1));
}
var init_random = __esmMin((() => {
})), now_default, init_now = __esmMin((() => {
  now_default = Date.now || function() {
    return (/* @__PURE__ */ new Date()).getTime();
  };
}));
function createEscaper(D) {
  var E = function(z) {
    return D[z];
  }, O = "(?:" + keys(D).join("|") + ")", F = RegExp(O), I = RegExp(O, "g");
  return function(z) {
    return z = z == null ? "" : "" + z, F.test(z) ? z.replace(I, E) : z;
  };
}
var init__createEscaper = __esmMin((() => {
  init_keys();
})), _escapeMap_default, init__escapeMap = __esmMin((() => {
  _escapeMap_default = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#x27;", "`": "&#x60;" };
})), escape_default, init_escape = __esmMin((() => {
  init__createEscaper(), init__escapeMap(), escape_default = createEscaper(_escapeMap_default);
})), _unescapeMap_default, init__unescapeMap = __esmMin((() => {
  init_invert(), init__escapeMap(), _unescapeMap_default = invert(_escapeMap_default);
})), unescape_default, init_unescape = __esmMin((() => {
  init__createEscaper(), init__unescapeMap(), unescape_default = createEscaper(_unescapeMap_default);
})), templateSettings_default, init_templateSettings = __esmMin((() => {
  init_underscore(), templateSettings_default = _$1.templateSettings = { evaluate: /<%([\s\S]+?)%>/g, interpolate: /<%=([\s\S]+?)%>/g, escape: /<%-([\s\S]+?)%>/g };
}));
function escapeChar(D) {
  return "\\" + escapes[D];
}
function template(D, E, O) {
  !E && O && (E = O), E = defaults_default({}, E, _$1.templateSettings);
  var F = RegExp([(E.escape || noMatch).source, (E.interpolate || noMatch).source, (E.evaluate || noMatch).source].join("|") + "|$", "g"), I = 0, z = "__p+='";
  D.replace(F, function(U, Z, V, G, W) {
    return z += D.slice(I, W).replace(escapeRegExp, escapeChar), I = W + U.length, Z ? z += `'+
((__t=(` + Z + `))==null?'':_.escape(__t))+
'` : V ? z += `'+
((__t=(` + V + `))==null?'':__t)+
'` : G && (z += `';
` + G + `
__p+='`), U;
  }), z += `';
`;
  var R = E.variable;
  if (R) {
    if (!bareIdentifier.test(R)) throw Error("variable is not a bare identifier: " + R);
  } else z = `with(obj||{}){
` + z + `}
`, R = "obj";
  z = `var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
` + z + `return __p;
`;
  var L;
  try {
    L = Function(R, "_", z);
  } catch (U) {
    throw U.source = z, U;
  }
  var q = function(U) {
    return L.call(this, U, _$1);
  };
  return q.source = "function(" + R + `){
` + z + "}", q;
}
var noMatch, escapes, escapeRegExp, bareIdentifier, init_template = __esmMin((() => {
  init_defaults(), init_underscore(), init_templateSettings(), noMatch = /(.)^/, escapes = { "'": "'", "\\": "\\", "\r": "r", "\n": "n", "\u2028": "u2028", "\u2029": "u2029" }, escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g, bareIdentifier = /^\s*(\w|\$)+\s*$/;
}));
function result(D, E, O) {
  E = toPath(E);
  var F = E.length;
  if (!F) return isFunction_default(O) ? O.call(D) : O;
  for (var I = 0; I < F; I++) {
    var z = D?.[E[I]];
    z === void 0 && (z = O, I = F), D = isFunction_default(z) ? z.call(D) : z;
  }
  return D;
}
var init_result = __esmMin((() => {
  init_isFunction(), init__toPath();
}));
function uniqueId(D) {
  var E = ++idCounter + "";
  return D ? D + E : E;
}
var idCounter, init_uniqueId = __esmMin((() => {
  idCounter = 0;
}));
function chain(D) {
  var E = _$1(D);
  return E._chain = !0, E;
}
var init_chain = __esmMin((() => {
  init_underscore();
}));
function executeBound(D, E, O, F, I) {
  if (!(F instanceof E)) return D.apply(O, I);
  var z = baseCreate(D.prototype), R = D.apply(z, I);
  return isObject(R) ? R : z;
}
var init__executeBound = __esmMin((() => {
  init__baseCreate(), init_isObject();
})), partial, init_partial = __esmMin((() => {
  init_restArguments(), init__executeBound(), init_underscore(), partial = restArguments(function(D, E) {
    var O = partial.placeholder, F = function() {
      for (var I = 0, z = E.length, R = Array(z), L = 0; L < z; L++) R[L] = E[L] === O ? arguments[I++] : E[L];
      for (; I < arguments.length; ) R.push(arguments[I++]);
      return executeBound(D, F, this, this, R);
    };
    return F;
  }), partial.placeholder = _$1;
})), bind_default, init_bind = __esmMin((() => {
  init_restArguments(), init_isFunction(), init__executeBound(), bind_default = restArguments(function(D, E, O) {
    if (!isFunction_default(D)) throw TypeError("Bind must be called on a function");
    var F = restArguments(function(I) {
      return executeBound(D, F, E, this, O.concat(I));
    });
    return F;
  });
})), _isArrayLike_default, init__isArrayLike = __esmMin((() => {
  init__createSizePropertyCheck(), init__getLength(), _isArrayLike_default = createSizePropertyCheck(_getLength_default);
}));
function flatten$3(D, E, O, F) {
  if (F ||= [], !E && E !== 0) E = 1 / 0;
  else if (E <= 0) return F.concat(D);
  for (var I = F.length, z = 0, R = _getLength_default(D); z < R; z++) {
    var L = D[z];
    if (_isArrayLike_default(L) && (isArray_default(L) || isArguments_default(L))) if (E > 1) flatten$3(L, E - 1, O, F), I = F.length;
    else for (var q = 0, U = L.length; q < U; ) F[I++] = L[q++];
    else O || (F[I++] = L);
  }
  return F;
}
var init__flatten = __esmMin((() => {
  init__getLength(), init__isArrayLike(), init_isArray(), init_isArguments();
})), bindAll_default, init_bindAll = __esmMin((() => {
  init_restArguments(), init__flatten(), init_bind(), bindAll_default = restArguments(function(D, E) {
    E = flatten$3(E, !1, !1);
    var O = E.length;
    if (O < 1) throw Error("bindAll must be passed function names");
    for (; O--; ) {
      var F = E[O];
      D[F] = bind_default(D[F], D);
    }
    return D;
  });
}));
function memoize(D, E) {
  var O = function(F) {
    var I = O.cache, z = "" + (E ? E.apply(this, arguments) : F);
    return has$1(I, z) || (I[z] = D.apply(this, arguments)), I[z];
  };
  return O.cache = {}, O;
}
var init_memoize = __esmMin((() => {
  init__has();
})), delay_default, init_delay = __esmMin((() => {
  init_restArguments(), delay_default = restArguments(function(D, E, O) {
    return setTimeout(function() {
      return D.apply(null, O);
    }, E);
  });
})), defer_default, init_defer = __esmMin((() => {
  init_partial(), init_delay(), init_underscore(), defer_default = partial(delay_default, _$1, 1);
}));
function throttle(D, E, O) {
  var F, I, z, R, L = 0;
  O ||= {};
  var q = function() {
    L = O.leading === !1 ? 0 : now_default(), F = null, R = D.apply(I, z), F || (I = z = null);
  }, U = function() {
    var Z = now_default();
    !L && O.leading === !1 && (L = Z);
    var V = E - (Z - L);
    return I = this, z = arguments, V <= 0 || V > E ? (F &&= (clearTimeout(F), null), L = Z, R = D.apply(I, z), F || (I = z = null)) : !F && O.trailing !== !1 && (F = setTimeout(q, V)), R;
  };
  return U.cancel = function() {
    clearTimeout(F), L = 0, F = I = z = null;
  }, U;
}
var init_throttle = __esmMin((() => {
  init_now();
}));
function debounce(D, E, O) {
  var F, I, z, R, L, q = function() {
    var Z = now_default() - I;
    E > Z ? F = setTimeout(q, E - Z) : (F = null, O || (R = D.apply(L, z)), F || (z = L = null));
  }, U = restArguments(function(Z) {
    return L = this, z = Z, I = now_default(), F || (F = setTimeout(q, E), O && (R = D.apply(L, z))), R;
  });
  return U.cancel = function() {
    clearTimeout(F), F = z = L = null;
  }, U;
}
var init_debounce = __esmMin((() => {
  init_restArguments(), init_now();
}));
function wrap(D, E) {
  return partial(E, D);
}
var init_wrap = __esmMin((() => {
  init_partial();
}));
function negate(D) {
  return function() {
    return !D.apply(this, arguments);
  };
}
var init_negate = __esmMin((() => {
}));
function compose() {
  var D = arguments, E = D.length - 1;
  return function() {
    for (var O = E, F = D[E].apply(this, arguments); O--; ) F = D[O].call(this, F);
    return F;
  };
}
var init_compose = __esmMin((() => {
}));
function after(D, E) {
  return function() {
    if (--D < 1) return E.apply(this, arguments);
  };
}
var init_after = __esmMin((() => {
}));
function before(D, E) {
  var O;
  return function() {
    return --D > 0 && (O = E.apply(this, arguments)), D <= 1 && (E = null), O;
  };
}
var init_before = __esmMin((() => {
})), once_default, init_once = __esmMin((() => {
  init_partial(), init_before(), once_default = partial(before, 2);
}));
function findKey(D, E, O) {
  E = cb(E, O);
  for (var F = keys(D), I, z = 0, R = F.length; z < R; z++) if (I = F[z], E(D[I], I, D)) return I;
}
var init_findKey = __esmMin((() => {
  init__cb(), init_keys();
}));
function createPredicateIndexFinder(D) {
  return function(E, O, F) {
    O = cb(O, F);
    for (var I = _getLength_default(E), z = D > 0 ? 0 : I - 1; z >= 0 && z < I; z += D) if (O(E[z], z, E)) return z;
    return -1;
  };
}
var init__createPredicateIndexFinder = __esmMin((() => {
  init__cb(), init__getLength();
})), findIndex_default, init_findIndex = __esmMin((() => {
  init__createPredicateIndexFinder(), findIndex_default = createPredicateIndexFinder(1);
})), findLastIndex_default, init_findLastIndex = __esmMin((() => {
  init__createPredicateIndexFinder(), findLastIndex_default = createPredicateIndexFinder(-1);
}));
function sortedIndex(D, E, O, F) {
  O = cb(O, F, 1);
  for (var I = O(E), z = 0, R = _getLength_default(D); z < R; ) {
    var L = Math.floor((z + R) / 2);
    O(D[L]) < I ? z = L + 1 : R = L;
  }
  return z;
}
var init_sortedIndex = __esmMin((() => {
  init__cb(), init__getLength();
}));
function createIndexFinder(D, E, O) {
  return function(F, I, z) {
    var R = 0, L = _getLength_default(F);
    if (typeof z == "number") D > 0 ? R = z >= 0 ? z : Math.max(z + L, R) : L = z >= 0 ? Math.min(z + 1, L) : z + L + 1;
    else if (O && z && L) return z = O(F, I), F[z] === I ? z : -1;
    if (I !== I) return z = E(slice.call(F, R, L), isNaN$1), z >= 0 ? z + R : -1;
    for (z = D > 0 ? R : L - 1; z >= 0 && z < L; z += D) if (F[z] === I) return z;
    return -1;
  };
}
var init__createIndexFinder = __esmMin((() => {
  init__getLength(), init__setup(), init_isNaN();
})), indexOf_default, init_indexOf = __esmMin((() => {
  init_sortedIndex(), init_findIndex(), init__createIndexFinder(), indexOf_default = createIndexFinder(1, findIndex_default, sortedIndex);
})), lastIndexOf_default, init_lastIndexOf = __esmMin((() => {
  init_findLastIndex(), init__createIndexFinder(), lastIndexOf_default = createIndexFinder(-1, findLastIndex_default);
}));
function find(D, E, O) {
  var F = (_isArrayLike_default(D) ? findIndex_default : findKey)(D, E, O);
  if (F !== void 0 && F !== -1) return D[F];
}
var init_find = __esmMin((() => {
  init__isArrayLike(), init_findIndex(), init_findKey();
}));
function findWhere(D, E) {
  return find(D, matcher(E));
}
var init_findWhere = __esmMin((() => {
  init_find(), init_matcher();
}));
function each(D, E, O) {
  E = optimizeCb(E, O);
  var F, I;
  if (_isArrayLike_default(D)) for (F = 0, I = D.length; F < I; F++) E(D[F], F, D);
  else {
    var z = keys(D);
    for (F = 0, I = z.length; F < I; F++) E(D[z[F]], z[F], D);
  }
  return D;
}
var init_each = __esmMin((() => {
  init__optimizeCb(), init__isArrayLike(), init_keys();
}));
function map(D, E, O) {
  E = cb(E, O);
  for (var F = !_isArrayLike_default(D) && keys(D), I = (F || D).length, z = Array(I), R = 0; R < I; R++) {
    var L = F ? F[R] : R;
    z[R] = E(D[L], L, D);
  }
  return z;
}
var init_map = __esmMin((() => {
  init__cb(), init__isArrayLike(), init_keys();
}));
function createReduce(D) {
  var E = function(O, F, I, z) {
    var R = !_isArrayLike_default(O) && keys(O), L = (R || O).length, q = D > 0 ? 0 : L - 1;
    for (z || (I = O[R ? R[q] : q], q += D); q >= 0 && q < L; q += D) {
      var U = R ? R[q] : q;
      I = F(I, O[U], U, O);
    }
    return I;
  };
  return function(O, F, I, z) {
    var R = arguments.length >= 3;
    return E(O, optimizeCb(F, z, 4), I, R);
  };
}
var init__createReduce = __esmMin((() => {
  init__isArrayLike(), init_keys(), init__optimizeCb();
})), reduce_default, init_reduce = __esmMin((() => {
  init__createReduce(), reduce_default = createReduce(1);
})), reduceRight_default, init_reduceRight = __esmMin((() => {
  init__createReduce(), reduceRight_default = createReduce(-1);
}));
function filter(D, E, O) {
  var F = [];
  return E = cb(E, O), each(D, function(I, z, R) {
    E(I, z, R) && F.push(I);
  }), F;
}
var init_filter = __esmMin((() => {
  init__cb(), init_each();
}));
function reject(D, E, O) {
  return filter(D, negate(cb(E)), O);
}
var init_reject = __esmMin((() => {
  init_filter(), init_negate(), init__cb();
}));
function every(D, E, O) {
  E = cb(E, O);
  for (var F = !_isArrayLike_default(D) && keys(D), I = (F || D).length, z = 0; z < I; z++) {
    var R = F ? F[z] : z;
    if (!E(D[R], R, D)) return !1;
  }
  return !0;
}
var init_every = __esmMin((() => {
  init__cb(), init__isArrayLike(), init_keys();
}));
function some(D, E, O) {
  E = cb(E, O);
  for (var F = !_isArrayLike_default(D) && keys(D), I = (F || D).length, z = 0; z < I; z++) {
    var R = F ? F[z] : z;
    if (E(D[R], R, D)) return !0;
  }
  return !1;
}
var init_some = __esmMin((() => {
  init__cb(), init__isArrayLike(), init_keys();
}));
function contains(D, E, O, F) {
  return _isArrayLike_default(D) || (D = values(D)), (typeof O != "number" || F) && (O = 0), indexOf_default(D, E, O) >= 0;
}
var init_contains = __esmMin((() => {
  init__isArrayLike(), init_values(), init_indexOf();
})), invoke_default, init_invoke = __esmMin((() => {
  init_restArguments(), init_isFunction(), init_map(), init__deepGet(), init__toPath(), invoke_default = restArguments(function(D, E, O) {
    var F, I;
    return isFunction_default(E) ? I = E : (E = toPath(E), F = E.slice(0, -1), E = E[E.length - 1]), map(D, function(z) {
      var R = I;
      if (!R) {
        if (F && F.length && (z = deepGet(z, F)), z == null) return;
        R = z[E];
      }
      return R == null ? R : R.apply(z, O);
    });
  });
}));
function pluck(D, E) {
  return map(D, property(E));
}
var init_pluck = __esmMin((() => {
  init_map(), init_property();
}));
function where(D, E) {
  return filter(D, matcher(E));
}
var init_where = __esmMin((() => {
  init_filter(), init_matcher();
}));
function max(D, E, O) {
  var F = -1 / 0, I = -1 / 0, z, R;
  if (E == null || typeof E == "number" && typeof D[0] != "object" && D != null) {
    D = _isArrayLike_default(D) ? D : values(D);
    for (var L = 0, q = D.length; L < q; L++) z = D[L], z != null && z > F && (F = z);
  } else E = cb(E, O), each(D, function(U, Z, V) {
    R = E(U, Z, V), (R > I || R === -1 / 0 && F === -1 / 0) && (F = U, I = R);
  });
  return F;
}
var init_max = __esmMin((() => {
  init__isArrayLike(), init_values(), init__cb(), init_each();
}));
function min(D, E, O) {
  var F = 1 / 0, I = 1 / 0, z, R;
  if (E == null || typeof E == "number" && typeof D[0] != "object" && D != null) {
    D = _isArrayLike_default(D) ? D : values(D);
    for (var L = 0, q = D.length; L < q; L++) z = D[L], z != null && z < F && (F = z);
  } else E = cb(E, O), each(D, function(U, Z, V) {
    R = E(U, Z, V), (R < I || R === 1 / 0 && F === 1 / 0) && (F = U, I = R);
  });
  return F;
}
var init_min = __esmMin((() => {
  init__isArrayLike(), init_values(), init__cb(), init_each();
}));
function toArray(D) {
  return D ? isArray_default(D) ? slice.call(D) : isString_default(D) ? D.match(reStrSymbol) : _isArrayLike_default(D) ? map(D, identity) : values(D) : [];
}
var reStrSymbol, init_toArray = __esmMin((() => {
  init_isArray(), init__setup(), init_isString(), init__isArrayLike(), init_map(), init_identity(), init_values(), reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
}));
function sample(D, E, O) {
  if (E == null || O) return _isArrayLike_default(D) || (D = values(D)), D[random(D.length - 1)];
  var F = toArray(D), I = _getLength_default(F);
  E = Math.max(Math.min(E, I), 0);
  for (var z = I - 1, R = 0; R < E; R++) {
    var L = random(R, z), q = F[R];
    F[R] = F[L], F[L] = q;
  }
  return F.slice(0, E);
}
var init_sample = __esmMin((() => {
  init__isArrayLike(), init_values(), init__getLength(), init_random(), init_toArray();
}));
function shuffle(D) {
  return sample(D, 1 / 0);
}
var init_shuffle = __esmMin((() => {
  init_sample();
}));
function sortBy(D, E, O) {
  var F = 0;
  return E = cb(E, O), pluck(map(D, function(I, z, R) {
    return { value: I, index: F++, criteria: E(I, z, R) };
  }).sort(function(I, z) {
    var R = I.criteria, L = z.criteria;
    if (R !== L) {
      if (R > L || R === void 0) return 1;
      if (R < L || L === void 0) return -1;
    }
    return I.index - z.index;
  }), "value");
}
var init_sortBy = __esmMin((() => {
  init__cb(), init_pluck(), init_map();
}));
function group(D, E) {
  return function(O, F, I) {
    var z = E ? [[], []] : {};
    return F = cb(F, I), each(O, function(R, L) {
      D(z, R, F(R, L, O));
    }), z;
  };
}
var init__group = __esmMin((() => {
  init__cb(), init_each();
})), groupBy_default, init_groupBy = __esmMin((() => {
  init__group(), init__has(), groupBy_default = group(function(D, E, O) {
    has$1(D, O) ? D[O].push(E) : D[O] = [E];
  });
})), indexBy_default, init_indexBy = __esmMin((() => {
  init__group(), indexBy_default = group(function(D, E, O) {
    D[O] = E;
  });
})), countBy_default, init_countBy = __esmMin((() => {
  init__group(), init__has(), countBy_default = group(function(D, E, O) {
    has$1(D, O) ? D[O]++ : D[O] = 1;
  });
})), partition_default, init_partition = __esmMin((() => {
  init__group(), partition_default = group(function(D, E, O) {
    D[+!O].push(E);
  }, !0);
}));
function size(D) {
  return D == null ? 0 : _isArrayLike_default(D) ? D.length : keys(D).length;
}
var init_size = __esmMin((() => {
  init__isArrayLike(), init_keys();
}));
function keyInObj(D, E, O) {
  return E in O;
}
var init__keyInObj = __esmMin((() => {
})), pick_default, init_pick = __esmMin((() => {
  init_restArguments(), init_isFunction(), init__optimizeCb(), init_allKeys(), init__keyInObj(), init__flatten(), pick_default = restArguments(function(D, E) {
    var O = {}, F = E[0];
    if (D == null) return O;
    isFunction_default(F) ? (E.length > 1 && (F = optimizeCb(F, E[1])), E = allKeys(D)) : (F = keyInObj, E = flatten$3(E, !1, !1), D = Object(D));
    for (var I = 0, z = E.length; I < z; I++) {
      var R = E[I], L = D[R];
      F(L, R, D) && (O[R] = L);
    }
    return O;
  });
})), omit_default, init_omit = __esmMin((() => {
  init_restArguments(), init_isFunction(), init_negate(), init_map(), init__flatten(), init_contains(), init_pick(), omit_default = restArguments(function(D, E) {
    var O = E[0], F;
    return isFunction_default(O) ? (O = negate(O), E.length > 1 && (F = E[1])) : (E = map(flatten$3(E, !1, !1), String), O = function(I, z) {
      return !contains(E, z);
    }), pick_default(D, O, F);
  });
}));
function initial(D, E, O) {
  return slice.call(D, 0, Math.max(0, D.length - (E == null || O ? 1 : E)));
}
var init_initial = __esmMin((() => {
  init__setup();
}));
function first(D, E, O) {
  return D == null || D.length < 1 ? E == null || O ? void 0 : [] : E == null || O ? D[0] : initial(D, D.length - E);
}
var init_first = __esmMin((() => {
  init_initial();
}));
function rest(D, E, O) {
  return slice.call(D, E == null || O ? 1 : E);
}
var init_rest = __esmMin((() => {
  init__setup();
}));
function last(D, E, O) {
  return D == null || D.length < 1 ? E == null || O ? void 0 : [] : E == null || O ? D[D.length - 1] : rest(D, Math.max(0, D.length - E));
}
var init_last = __esmMin((() => {
  init_rest();
}));
function compact(D) {
  return filter(D, Boolean);
}
var init_compact = __esmMin((() => {
  init_filter();
}));
function flatten$2(D, E) {
  return flatten$3(D, E, !1);
}
var init_flatten = __esmMin((() => {
  init__flatten();
})), difference_default, init_difference = __esmMin((() => {
  init_restArguments(), init__flatten(), init_filter(), init_contains(), difference_default = restArguments(function(D, E) {
    return E = flatten$3(E, !0, !0), filter(D, function(O) {
      return !contains(E, O);
    });
  });
})), without_default, init_without = __esmMin((() => {
  init_restArguments(), init_difference(), without_default = restArguments(function(D, E) {
    return difference_default(D, E);
  });
}));
function uniq(D, E, O, F) {
  isBoolean(E) || (F = O, O = E, E = !1), O != null && (O = cb(O, F));
  for (var I = [], z = [], R = 0, L = _getLength_default(D); R < L; R++) {
    var q = D[R], U = O ? O(q, R, D) : q;
    E && !O ? ((!R || z !== U) && I.push(q), z = U) : O ? contains(z, U) || (z.push(U), I.push(q)) : contains(I, q) || I.push(q);
  }
  return I;
}
var init_uniq = __esmMin((() => {
  init_isBoolean(), init__cb(), init__getLength(), init_contains();
})), union_default, init_union = __esmMin((() => {
  init_restArguments(), init_uniq(), init__flatten(), union_default = restArguments(function(D) {
    return uniq(flatten$3(D, !0, !0));
  });
}));
function intersection(D) {
  for (var E = [], O = arguments.length, F = 0, I = _getLength_default(D); F < I; F++) {
    var z = D[F];
    if (!contains(E, z)) {
      var R;
      for (R = 1; R < O && contains(arguments[R], z); R++) ;
      R === O && E.push(z);
    }
  }
  return E;
}
var init_intersection = __esmMin((() => {
  init__getLength(), init_contains();
}));
function unzip(D) {
  for (var E = D && max(D, _getLength_default).length || 0, O = Array(E), F = 0; F < E; F++) O[F] = pluck(D, F);
  return O;
}
var init_unzip = __esmMin((() => {
  init_max(), init__getLength(), init_pluck();
})), zip_default, init_zip = __esmMin((() => {
  init_restArguments(), init_unzip(), zip_default = restArguments(unzip);
}));
function object(D, E) {
  for (var O = {}, F = 0, I = _getLength_default(D); F < I; F++) E ? O[D[F]] = E[F] : O[D[F][0]] = D[F][1];
  return O;
}
var init_object = __esmMin((() => {
  init__getLength();
}));
function range(D, E, O) {
  E ?? (E = D || 0, D = 0), O ||= E < D ? -1 : 1;
  for (var F = Math.max(Math.ceil((E - D) / O), 0), I = Array(F), z = 0; z < F; z++, D += O) I[z] = D;
  return I;
}
var init_range = __esmMin((() => {
}));
function chunk(D, E) {
  if (E == null || E < 1) return [];
  for (var O = [], F = 0, I = D.length; F < I; ) O.push(slice.call(D, F, F += E));
  return O;
}
var init_chunk = __esmMin((() => {
  init__setup();
}));
function chainResult(D, E) {
  return D._chain ? _$1(E).chain() : E;
}
var init__chainResult = __esmMin((() => {
  init_underscore();
}));
function mixin(D) {
  return each(functions$1(D), function(E) {
    var O = _$1[E] = D[E];
    _$1.prototype[E] = function() {
      var F = [this._wrapped];
      return push.apply(F, arguments), chainResult(this, O.apply(_$1, F));
    };
  }), _$1;
}
var init_mixin = __esmMin((() => {
  init_underscore(), init_each(), init_functions(), init__setup(), init__chainResult();
})), underscore_array_methods_default, init_underscore_array_methods = __esmMin((() => {
  init_underscore(), init_each(), init__setup(), init__chainResult(), each(["pop", "push", "reverse", "shift", "sort", "splice", "unshift"], function(D) {
    var E = ArrayProto[D];
    _$1.prototype[D] = function() {
      var O = this._wrapped;
      return O != null && (E.apply(O, arguments), (D === "shift" || D === "splice") && O.length === 0 && delete O[0]), chainResult(this, O);
    };
  }), each(["concat", "join", "slice"], function(D) {
    var E = ArrayProto[D];
    _$1.prototype[D] = function() {
      var O = this._wrapped;
      return O != null && (O = E.apply(O, arguments)), chainResult(this, O);
    };
  }), underscore_array_methods_default = _$1;
})), modules_exports = __exportAll({ VERSION: () => VERSION, after: () => after, all: () => every, allKeys: () => allKeys, any: () => some, assign: () => extendOwn_default, before: () => before, bind: () => bind_default, bindAll: () => bindAll_default, chain: () => chain, chunk: () => chunk, clone: () => clone, collect: () => map, compact: () => compact, compose: () => compose, constant: () => constant, contains: () => contains, countBy: () => countBy_default, create: () => create, debounce: () => debounce, default: () => underscore_array_methods_default, defaults: () => defaults_default, defer: () => defer_default, delay: () => delay_default, detect: () => find, difference: () => difference_default, drop: () => rest, each: () => each, escape: () => escape_default, every: () => every, extend: () => extend_default, extendOwn: () => extendOwn_default, filter: () => filter, find: () => find, findIndex: () => findIndex_default, findKey: () => findKey, findLastIndex: () => findLastIndex_default, findWhere: () => findWhere, first: () => first, flatten: () => flatten$2, foldl: () => reduce_default, foldr: () => reduceRight_default, forEach: () => each, functions: () => functions$1, get: () => get, groupBy: () => groupBy_default, has: () => has, head: () => first, identity: () => identity, include: () => contains, includes: () => contains, indexBy: () => indexBy_default, indexOf: () => indexOf_default, initial: () => initial, inject: () => reduce_default, intersection: () => intersection, invert: () => invert, invoke: () => invoke_default, isArguments: () => isArguments_default, isArray: () => isArray_default, isArrayBuffer: () => isArrayBuffer_default, isBoolean: () => isBoolean, isDataView: () => isDataView_default, isDate: () => isDate_default, isElement: () => isElement, isEmpty: () => isEmpty, isEqual: () => isEqual, isError: () => isError_default, isFinite: () => isFinite$1, isFunction: () => isFunction_default, isMap: () => isMap_default, isMatch: () => isMatch, isNaN: () => isNaN$1, isNull: () => isNull, isNumber: () => isNumber_default, isObject: () => isObject, isRegExp: () => isRegExp_default, isSet: () => isSet_default, isString: () => isString_default, isSymbol: () => isSymbol_default, isTypedArray: () => isTypedArray_default, isUndefined: () => isUndefined, isWeakMap: () => isWeakMap_default, isWeakSet: () => isWeakSet_default, iteratee: () => iteratee, keys: () => keys, last: () => last, lastIndexOf: () => lastIndexOf_default, map: () => map, mapObject: () => mapObject, matcher: () => matcher, matches: () => matcher, max: () => max, memoize: () => memoize, methods: () => functions$1, min: () => min, mixin: () => mixin, negate: () => negate, noop: () => noop, now: () => now_default, object: () => object, omit: () => omit_default, once: () => once_default, pairs: () => pairs, partial: () => partial, partition: () => partition_default, pick: () => pick_default, pluck: () => pluck, property: () => property, propertyOf: () => propertyOf, random: () => random, range: () => range, reduce: () => reduce_default, reduceRight: () => reduceRight_default, reject: () => reject, rest: () => rest, restArguments: () => restArguments, result: () => result, sample: () => sample, select: () => filter, shuffle: () => shuffle, size: () => size, some: () => some, sortBy: () => sortBy, sortedIndex: () => sortedIndex, tail: () => rest, take: () => first, tap: () => tap, template: () => template, templateSettings: () => templateSettings_default, throttle: () => throttle, times: () => times, toArray: () => toArray, toPath: () => toPath$1, transpose: () => unzip, unescape: () => unescape_default, union: () => union_default, uniq: () => uniq, unique: () => uniq, uniqueId: () => uniqueId, unzip: () => unzip, values: () => values, where: () => where, without: () => without_default, wrap: () => wrap, zip: () => zip_default }), init_modules = __esmMin((() => {
  init__setup(), init_restArguments(), init_isObject(), init_isNull(), init_isUndefined(), init_isBoolean(), init_isElement(), init_isString(), init_isNumber(), init_isDate(), init_isRegExp(), init_isError(), init_isSymbol(), init_isArrayBuffer(), init_isDataView(), init_isArray(), init_isFunction(), init_isArguments(), init_isFinite(), init_isNaN(), init_isTypedArray(), init_isEmpty(), init_isMatch(), init_isEqual(), init_isMap(), init_isWeakMap(), init_isSet(), init_isWeakSet(), init_keys(), init_allKeys(), init_values(), init_pairs(), init_invert(), init_functions(), init_extend(), init_extendOwn(), init_defaults(), init_create(), init_clone(), init_tap(), init_get(), init_has(), init_mapObject(), init_identity(), init_constant(), init_noop(), init_toPath(), init_property(), init_propertyOf(), init_matcher(), init_times(), init_random(), init_now(), init_escape(), init_unescape(), init_templateSettings(), init_template(), init_result(), init_uniqueId(), init_chain(), init_iteratee(), init_partial(), init_bind(), init_bindAll(), init_memoize(), init_delay(), init_defer(), init_throttle(), init_debounce(), init_wrap(), init_negate(), init_compose(), init_after(), init_before(), init_once(), init_findKey(), init_findIndex(), init_findLastIndex(), init_sortedIndex(), init_indexOf(), init_lastIndexOf(), init_find(), init_findWhere(), init_each(), init_map(), init_reduce(), init_reduceRight(), init_filter(), init_reject(), init_every(), init_some(), init_contains(), init_invoke(), init_pluck(), init_where(), init_max(), init_min(), init_shuffle(), init_sample(), init_sortBy(), init_groupBy(), init_indexBy(), init_countBy(), init_partition(), init_toArray(), init_size(), init_pick(), init_omit(), init_first(), init_initial(), init_last(), init_rest(), init_compact(), init_flatten(), init_without(), init_uniq(), init_union(), init_intersection(), init_difference(), init_unzip(), init_zip(), init_object(), init_range(), init_chunk(), init_mixin(), init_underscore_array_methods();
})), _, init_index_default = __esmMin((() => {
  init_modules(), _ = mixin(modules_exports), _._ = _;
})), index_all_exports = __exportAll({ VERSION: () => VERSION, after: () => after, all: () => every, allKeys: () => allKeys, any: () => some, assign: () => extendOwn_default, before: () => before, bind: () => bind_default, bindAll: () => bindAll_default, chain: () => chain, chunk: () => chunk, clone: () => clone, collect: () => map, compact: () => compact, compose: () => compose, constant: () => constant, contains: () => contains, countBy: () => countBy_default, create: () => create, debounce: () => debounce, default: () => _, defaults: () => defaults_default, defer: () => defer_default, delay: () => delay_default, detect: () => find, difference: () => difference_default, drop: () => rest, each: () => each, escape: () => escape_default, every: () => every, extend: () => extend_default, extendOwn: () => extendOwn_default, filter: () => filter, find: () => find, findIndex: () => findIndex_default, findKey: () => findKey, findLastIndex: () => findLastIndex_default, findWhere: () => findWhere, first: () => first, flatten: () => flatten$2, foldl: () => reduce_default, foldr: () => reduceRight_default, forEach: () => each, functions: () => functions$1, get: () => get, groupBy: () => groupBy_default, has: () => has, head: () => first, identity: () => identity, include: () => contains, includes: () => contains, indexBy: () => indexBy_default, indexOf: () => indexOf_default, initial: () => initial, inject: () => reduce_default, intersection: () => intersection, invert: () => invert, invoke: () => invoke_default, isArguments: () => isArguments_default, isArray: () => isArray_default, isArrayBuffer: () => isArrayBuffer_default, isBoolean: () => isBoolean, isDataView: () => isDataView_default, isDate: () => isDate_default, isElement: () => isElement, isEmpty: () => isEmpty, isEqual: () => isEqual, isError: () => isError_default, isFinite: () => isFinite$1, isFunction: () => isFunction_default, isMap: () => isMap_default, isMatch: () => isMatch, isNaN: () => isNaN$1, isNull: () => isNull, isNumber: () => isNumber_default, isObject: () => isObject, isRegExp: () => isRegExp_default, isSet: () => isSet_default, isString: () => isString_default, isSymbol: () => isSymbol_default, isTypedArray: () => isTypedArray_default, isUndefined: () => isUndefined, isWeakMap: () => isWeakMap_default, isWeakSet: () => isWeakSet_default, iteratee: () => iteratee, keys: () => keys, last: () => last, lastIndexOf: () => lastIndexOf_default, map: () => map, mapObject: () => mapObject, matcher: () => matcher, matches: () => matcher, max: () => max, memoize: () => memoize, methods: () => functions$1, min: () => min, mixin: () => mixin, negate: () => negate, noop: () => noop, now: () => now_default, object: () => object, omit: () => omit_default, once: () => once_default, pairs: () => pairs, partial: () => partial, partition: () => partition_default, pick: () => pick_default, pluck: () => pluck, property: () => property, propertyOf: () => propertyOf, random: () => random, range: () => range, reduce: () => reduce_default, reduceRight: () => reduceRight_default, reject: () => reject, rest: () => rest, restArguments: () => restArguments, result: () => result, sample: () => sample, select: () => filter, shuffle: () => shuffle, size: () => size, some: () => some, sortBy: () => sortBy, sortedIndex: () => sortedIndex, tail: () => rest, take: () => first, tap: () => tap, template: () => template, templateSettings: () => templateSettings_default, throttle: () => throttle, times: () => times, toArray: () => toArray, toPath: () => toPath$1, transpose: () => unzip, unescape: () => unescape_default, union: () => union_default, uniq: () => uniq, unique: () => uniq, uniqueId: () => uniqueId, unzip: () => unzip, values: () => values, where: () => where, without: () => without_default, wrap: () => wrap, zip: () => zip_default }), init_index_all = __esmMin((() => {
  init_index_default(), init_modules();
}));
init_index_all();
var nonTupleVectorOperators = ["vector", "altvector"];
function coerce_tuple_array_vectors({ operator1: D, operator2: E, operands1: O, operands2: F, coerce_tuples_arrays: I, coerce_vectors: z }) {
  let R = D === E;
  if (!R) {
    if (I) {
      if (D === "tuple") {
        if (nonTupleVectorOperators.includes(E)) D = E, R = !0;
        else if (E === "interval" && O.length === 2) {
          let L = F[1];
          L[1] || L[2] || (R = !0, D = "interval", O = [["tuple", ...O], ["tuple", !1, !1]]);
        }
      } else if (E === "tuple") {
        if (nonTupleVectorOperators.includes(D)) E = D, R = !0;
        else if (D === "interval" && F.length === 2) {
          let L = O[1];
          L[1] || L[2] || (R = !0, E = "interval", F = [["tuple", ...F], ["tuple", !1, !1]]);
        }
      }
      if (!R) {
        if (D === "array" && O.length === 2) {
          if (E === "interval") {
            let L = F[1];
            L[1] && L[2] && (R = !0, D = "interval", O = [["tuple", ...O], ["tuple", !0, !0]]);
          }
        } else if (E === "array" && F.length === 2 && D === "interval") {
          let L = O[1];
          L[1] && L[2] && (R = !0, E = "interval", F = [["tuple", ...F], ["tuple", !0, !0]]);
        }
      }
    }
    !R && z && nonTupleVectorOperators.includes(D) && nonTupleVectorOperators.includes(E) && (R = !0, D = E = "vector");
  }
  return { operator1: D, operator2: E, operands1: O, operands2: F };
}
function handleNaNInfinityStringify(D, E) {
  return E === E ? E === 1 / 0 ? "1/0" : E === -1 / 0 ? "-1/0" : E : "0/0";
}
function handleNaNInfinityParse(D, E) {
  return E === "0/0" ? NaN : E === "1/0" ? 1 / 0 : E === "-1/0" ? -1 / 0 : E;
}
function deepClone(D) {
  return JSON.parse(JSON.stringify(D, handleNaNInfinityStringify), handleNaNInfinityParse);
}
var equal = function(D, E, { allowed_error_in_numbers: O = 0, include_error_in_number_exponents: F = !1, allowed_error_is_absolute: I = !1, coerce_tuples_arrays: z = !0, coerce_vectors: R = !0 } = {}) {
  if (!(Array.isArray(D) && Array.isArray(E))) {
    if (typeof D != typeof E) return !1;
    if (typeof D == "number" && Number.isFinite(D)) {
      let V = 1e-14, G = Math.min(Math.abs(D), Math.abs(E));
      return I ? (V *= G, O > V && (V = O)) : (O > V && (V = O), V *= G), Math.abs(D - E) <= V;
    }
    return D === E;
  }
  var L = D[0], q = D.slice(1), U = E[0], Z = E.slice(1);
  return L !== U && ({ operator1: L, operator2: U, operands1: q, operands2: Z } = coerce_tuple_array_vectors({ operator1: L, operator2: U, operands1: q, operands2: Z, coerce_tuples_arrays: z, coerce_vectors: R })), L !== U || q.length !== Z.length ? !1 : O > 0 && !F && L === "^" ? equal(q[0], Z[0], { allowed_error_in_numbers: O, include_error_in_number_exponents: F, allowed_error_is_absolute: I, coerce_tuples_arrays: z, coerce_vectors: R }) ? equal(q[1], Z[1], { coerce_tuples_arrays: z, coerce_vectors: R }) : !1 : _.every(_.zip(q, Z), function(V) {
    return equal(V[0], V[1], { allowed_error_in_numbers: O, include_error_in_number_exponents: F, allowed_error_is_absolute: I, coerce_tuples_arrays: z, coerce_vectors: R });
  });
}, match$1 = function(D, E, O) {
  var F = !1;
  O === void 0 ? O = {} : O.allow_extended_match && (F = !0, O = Object.assign({}, O), delete O.allow_extended_match);
  var I = O.variables;
  if (I === void 0) {
    I = {};
    let q = variables(E);
    for (let U = 0; U < q.length; U++) I[q[U]] = !0;
    O = Object.assign({}, O), O.variables = I;
  }
  if (E in I) {
    let q = I[E];
    if (q !== !0) if (q instanceof RegExp) {
      if (typeof D == "string") {
        if (!D.match(q)) return !1;
      } else if (!JSON.stringify(D).match(q)) return !1;
    } else if (typeof I[E] == "function") {
      if (!I[E](D)) return !1;
    } else return !1;
    let U = {};
    return U[E] = D, U;
  }
  if (O.allow_permutations && (D = default_order(D), E = default_order(E)), !Array.isArray(E)) return D === E ? {} : !1;
  var z = allChildren(D), R = E[0], L = E.slice(1);
  if (!Array.isArray(D) || D[0] !== R || z.length < L.length) {
    if (Array.isArray(O.allow_implicit_identities)) {
      let q = matchImplicitIdentity(D, E, O);
      if (q) return q;
    }
    if (R === "*" && Array.isArray(D) && D[0] === "-" && Array.isArray(D[1]) && D[1][0] === "*") z = allChildren(D[1]), z[0] = ["-", z[0]];
    else return !1;
  }
  return matchOperands(R, z, L, O, F) || (Array.isArray(O.allow_implicit_identities) ? matchImplicitIdentity([R].concat(z), E, O) : !1);
};
function matchOperands(D, E, O, F, I) {
  var z = O.map((V) => ({})), R = O.length, L = !1;
  F.allow_permutations && (D === "*" ? L = ![...E, ...O].some((V) => ["tuple", "list", "vector", "altvector", "interval", "set", "array", "matrix"].includes(V[0])) : (D === "+" || D === "=" || D === "and" || D === "or" || D === "ne" || D === "union" || D === "intersect") && (L = !0));
  function q(V, G, W) {
    let J = 1, X = 1;
    (is_associative$1[D] || ["tuple", "vector", "altvector"].includes(D)) && (J = V.length - (R - G - 1), X = V.length), F.max_group !== void 0 && (J = F.max_group < J ? F.max_group : J), F.max_last_group !== void 0 && (X = F.max_last_group < X ? F.max_last_group : X);
    let Y;
    if (!I && G === R - 1) if (V.length <= X) Y = [V];
    else return !1;
    else if (L) Y = subsets(V, J);
    else {
      Y = [];
      for (let ee = 1; ee <= J; ee++) Y.push(V.slice(0, ee));
    }
    for (let ee of Y) {
      let K = z[G][ee];
      if (K === void 0) {
        let ae = ee.reduce(function(ue, oe) {
          return ue.concat([E[oe]]);
        }, []);
        ae = ae.length > 1 ? [D].concat(ae) : ae[0], K = match$1(ae, O[G], F), z[G][ee] = K;
      }
      if (!K || !_.every(_.intersection(Object.keys(W), Object.keys(K)), function(ae) {
        return equal(W[ae], K[ae]);
      })) continue;
      let te = Object.assign({}, K);
      Object.assign(te, W);
      let ie = V.filter((ae) => !ee.includes(ae));
      if (G === R - 1) return { matches: te, skipped: ie.reduce(function(ae, ue) {
        return ae.concat([E[ue]]);
      }, []) };
      let ne = q(ie, G + 1, te);
      if (ne) return ne;
    }
    return !1;
  }
  var U = {}, Z = [...Array(E.length).keys()];
  if (L) {
    let V = q(Z, 0, {});
    return V ? (U = V.matches, V.skipped.length > 0 && (U._skipped = V.skipped), U) : !1;
  } else {
    let V = I ? E.length - R : 0, G = [], W;
    for (let J = 0; J <= V && (W = q(Z, 0, {}), !W); J++) Z = Z.slice(1), G.push(E[J]);
    return W ? (U = W.matches, W.skipped.length > 0 && (U._skipped = W.skipped), G.length > 0 && (U._skipped_before = G), U) : !1;
  }
}
function matchImplicitIdentity(D, E, O) {
  var F = E[0], I = E.slice(1);
  if (!(F === "+" || F === "*" || F === "^")) return !1;
  var z = [];
  for (let R = 0; R < I.length; R++) {
    let L = I[R];
    typeof L == "string" && O.allow_implicit_identities.includes(L) && z.push(L);
  }
  if (z.length === 0) return !1;
  for (let R of z) {
    let L = match_one_implicit_identity(D, E, O, R);
    if (L) return L;
  }
  return !1;
}
function match_one_implicit_identity(D, E, O, F) {
  var I = E[0], z = E.slice(1), R = {};
  I === "+" ? R[F] = 0 : R[F] = 1, I === "*" && z.includes(F) && Array.isArray(D) && D[0] === "-" && (R[F] = -1, D = D[1]);
  var L = z.indexOf(F);
  if (z.splice(L, 1), I === "^" && L === 0) return !1;
  E = z.length === 1 ? z[0] : [I].concat(z);
  var q = match$1(D, E, O);
  if (q) {
    if (F in q && !equal(q[F], R[F])) return !1;
    Object.assign(R, q);
  } else return !1;
  return R;
}
var substitute$1 = function(D, E) {
  return typeof D == "number" || typeof D == "boolean" ? D : typeof D == "string" ? E[D] === void 0 ? D : deepClone(E[D]) : Array.isArray(D) ? [D[0]].concat(D.slice(1).map(function(O) {
    return substitute$1(O, E);
  })) : [];
}, transform = function(D, E) {
  if (Array.isArray(D)) {
    let O = [D[0]];
    for (let F = 1; F < D.length; F++) O.push(transform(D[F], E));
    return E(O);
  }
  return E(D);
}, applyAllTransformations = function(D, E, O) {
  O === void 0 && (O = 5);
  for (var F = D, I; O > 0; O--) {
    I = F;
    for (let z = 0; z < E.length; z++) {
      let R = E[z][0], L = E[z][1], q = E[z][2];
      q === void 0 && (q = {}), F = transform(F, function(U) {
        let Z = match$1(U, R, q);
        if (Z) {
          let V = substitute$1(L, Z), G = q.assumptions ? substitute$1(q.assumptions, Z) : void 0;
          q.evaluate_numbers && (V = evaluate_numbers(V, { max_digits: q.max_digits, evaluate_functions: q.evaluate_functions, assumptions: G }));
          let W = [], J = [];
          return Z._skipped && (W = Z._skipped), Z._skipped_before && (J = Z._skipped_before), (J.length > 0 || W.length > 0) && (Array.isArray(V) && (V = V[0] === R[0] ? V.slice(1) : [V]), V = [R[0]].concat(J, V, W)), q.evaluate_numbers && (V = evaluate_numbers(V, { max_digits: q.max_digits, evaluate_functions: q.evaluate_functions, assumptions: G })), V;
        } else return U;
      });
    }
    if (equal(I, F)) return F;
  }
  return F;
}, math = mathjs_default, operators$2 = { "+": function(D) {
  return D.length === 1 ? D[0] : new math.OperatorNode("+", "add", D);
}, "*": function(D) {
  return new math.OperatorNode("*", "multiply", D);
}, "/": function(D) {
  return new math.OperatorNode("/", "divide", D);
}, "-": function(D) {
  return new math.OperatorNode("-", "unaryMinus", [D[0]]);
}, "^": function(D) {
  return new math.OperatorNode("^", "pow", D);
}, vector: function(D) {
  return new math.ArrayNode(D);
}, altvector: function(D) {
  return new math.ArrayNode(D);
}, and: function(D) {
  return new math.OperatorNode("and", "and", D);
}, or: function(D) {
  return new math.OperatorNode("or", "or", D);
}, not: function(D) {
  return new math.OperatorNode("not", "not", [D[0]]);
}, "<": function(D) {
  return new math.OperatorNode("<", "smaller", D);
}, ">": function(D) {
  return new math.OperatorNode(">", "larger", D);
}, le: function(D) {
  return new math.OperatorNode("<=", "smallerEq", D);
}, ge: function(D) {
  return new math.OperatorNode(">=", "largerEq", D);
}, ne: function(D) {
  return new math.OperatorNode("!=", "unequal", D);
}, binom: function(D) {
  let E = new math.SymbolNode("combinations");
  return new math.FunctionNode(E, D);
} }, functionConversions = { nCr: "combinations", nPr: "permutations", binom: "combinations" }, astToMathjs$2 = class {
  constructor({ mathjs: D = null } = {}) {
    D && (math = D);
  }
  convert(D) {
    if (typeof D == "number") return Number.isFinite(D) ? new math.ConstantNode(D) : Number.isNaN(D) ? new math.SymbolNode("NaN") : D < 0 ? operators$2["-"]([new math.SymbolNode("Infinity")]) : new math.SymbolNode("Infinity");
    if (typeof D == "string") return new math.SymbolNode(D);
    if (typeof D == "boolean") throw Error("no support for boolean");
    if (!Array.isArray(D)) throw Error("Invalid ast");
    let E = D[0], O = D.slice(1);
    if (E === "apply") {
      if (typeof O[0] != "string") throw Error("Non string functions not implemented for conversion to mathjs");
      if (O[0] === "factorial") return new math.OperatorNode("!", "factorial", [this.convert(O[1])]);
      let F = functionConversions[O[0]];
      F ||= O[0];
      let I = new math.SymbolNode(F), z = O[1], R;
      return R = z[0] === "tuple" ? z.slice(1).map((function(L, q) {
        return this.convert(L);
      }).bind(this)) : [this.convert(z)], O[0] === "count" && (R.length > 2 || !(R[0] instanceof math.ArrayNode)) && (R = [new math.ArrayNode(R)]), new math.FunctionNode(I, R);
    }
    if (E === "lts" || E === "gts") {
      let F = O[0], I = O[1];
      if (F[0] !== "tuple" || I[0] !== "tuple") throw Error("Badly formed ast");
      let z = F.slice(1).map((function(q, U) {
        return this.convert(q);
      }).bind(this)), R = [];
      for (let q = 1; q < F.length - 1; q++) I[q] ? E === "lts" ? R.push(new math.OperatorNode("<", "smaller", z.slice(q - 1, q + 1))) : R.push(new math.OperatorNode(">", "larger", z.slice(q - 1, q + 1))) : E === "lts" ? R.push(new math.OperatorNode("<=", "smallerEq", z.slice(q - 1, q + 1))) : R.push(new math.OperatorNode(">=", "largerEq", z.slice(q - 1, q + 1)));
      let L = new math.OperatorNode("and", "and", R.slice(0, 2));
      for (let q = 2; q < R.length; q++) L = new math.OperatorNode("and", "and", [L, R[q]]);
      return L;
    }
    if (E === "=") {
      let F = O.map((function(R, L) {
        return this.convert(R);
      }).bind(this)), I = [];
      for (let R = 1; R < F.length; R++) I.push(new math.OperatorNode("==", "equal", F.slice(R - 1, R + 1)));
      if (I.length === 1) return I[0];
      let z = new math.OperatorNode("and", "and", I.slice(0, 2));
      for (let R = 2; R < I.length; R++) z = new math.OperatorNode("and", "and", [z, I[R]]);
      return z;
    }
    if (E === "in" || E === "notin" || E === "ni" || E === "notni") {
      let F, I;
      if (E === "in" || E === "notin" ? (F = O[0], I = O[1]) : (F = O[1], I = O[0]), typeof F != "number" && typeof F != "string") throw Error("Set membership non-string variables not implemented for conversion to mathjs");
      if (F = this.convert(F), I[0] !== "interval") throw Error("Set membership in non-intervals not implemented for conversion to mathjs");
      let z = I[1], R = I[2];
      if (z[0] !== "tuple" || R[0] !== "tuple") throw Error("Badly formed ast");
      let L = this.convert(z[1]), q = this.convert(z[2]), U = [];
      R[1] ? U.push(new math.OperatorNode(">=", "largerEq", [F, L])) : U.push(new math.OperatorNode(">", "larger", [F, L])), R[2] ? U.push(new math.OperatorNode("<=", "smallerEq", [F, q])) : U.push(new math.OperatorNode("<", "smaller", [F, q]));
      let Z = new math.OperatorNode("and", "and", U);
      return (E === "notin" || E === "notni") && (Z = new math.OperatorNode("not", "not", [Z])), Z;
    }
    if (E === "subset" || E === "notsubset" || E === "superset" || E === "notsuperset") {
      let F, I;
      if (E === "subset" || E === "notsubset" ? (I = O[0], F = O[1]) : (I = O[1], F = O[0]), I[0] !== "interval" || F[0] !== "interval") throw Error("Set containment of non-intervals not implemented for conversion to mathjs");
      let z = I[1], R = I[2], L = F[1], q = F[2];
      if (z[0] !== "tuple" || R[0] !== "tuple" || L[0] !== "tuple" || q[0] !== "tuple") throw Error("Badly formed ast");
      let U = this.convert(z[1]), Z = this.convert(z[2]), V = this.convert(L[1]), G = this.convert(L[2]), W = [];
      R[1] && !q[1] ? W.push(new math.OperatorNode(">", "larger", [U, V])) : W.push(new math.OperatorNode(">=", "largerEq", [U, V])), R[2] && !q[2] ? W.push(new math.OperatorNode("<", "smaller", [Z, G])) : W.push(new math.OperatorNode("<=", "smallerEq", [Z, G]));
      let J = new math.OperatorNode("and", "and", W);
      return (E === "notsubset" || E === "notsuperset") && (J = new math.OperatorNode("not", "not", [J])), J;
    }
    if (E === "matrix") {
      let F = O[0], I = F[1], z = F[2], R = O[1];
      if (!Number.isInteger(I) || !Number.isInteger(z)) throw Error("Matrix must have integer dimensions");
      let L = [];
      for (let q = 1; q <= I; q++) {
        let U = [];
        for (let Z = 1; Z <= z; Z++) U.push(this.convert(R[q][Z]));
        L.push(new math.ArrayNode(U));
      }
      return new math.ArrayNode(L);
    }
    if (E === "array") {
      let F = O.map((I) => this.convert(I));
      return new math.ArrayNode(F);
    }
    if (E in operators$2) return operators$2[E](O.map((function(F, I) {
      return this.convert(F);
    }).bind(this)));
    throw Error("Operator " + E + " not implemented for conversion to mathjs");
  }
}, require_sieve = __commonJSMin(((D, E) => {
  E.exports = function(O) {
    for (var F = Array(O), I = 0; I < O; I++) F[I] = !0;
    for (var I = 2; I < Math.sqrt(O); I++) for (var z = I * I; z < O; z += I) F[z] = !1;
    for (var R = [], I = 2; I < O; I++) F[I] && R.push(I);
    return R;
  };
})), require_factor = __commonJSMin(((D, E) => {
  var O = require_sieve(), F = O(1e5);
  E.exports = function(I) {
    (!F || F[F.length - 1] < I) && (F = O(I));
    for (var z = [], R = 0; R < F.length && I > 1; R++) {
      var L = F[R];
      if (I % L === 0) {
        for (var q = { prime: L, power: 0 }; I % L === 0; ) q.power++, I /= L;
        z.push(q);
      }
    }
    return I > 1 && z.push({ prime: I, power: 1 }), z;
  };
})), require_inc_mixed = __commonJSMin(((D, E) => {
  E.exports = function(O, F) {
    var I = O.map(function(R) {
      return R;
    });
    I[0]++;
    for (var z = 0; z < O.length && !(I[z] <= F[z]); z++) z === O.length - 1 ? I[z] = 0 : (I[z] = 0, I[z + 1]++);
    return I;
  };
})), require_divisors = __commonJSMin(((D, E) => {
  var O = require_factor(), F = require_inc_mixed();
  E.exports = function(I) {
    for (var z = O(I), R = z.map(function(Z) {
      return 0;
    }), L = z.map(function(Z) {
      return Z.power;
    }), q = [1]; ; ) {
      R = F(R, L);
      var U = R.map(function(Z, V) {
        return z[V].prime ** +Z;
      }).reduce(function(Z, V) {
        return Z * V;
      }, 1);
      if (U === 1) break;
      q.push(U);
    }
    return q.sort(function(Z, V) {
      return parseInt(Z) - parseInt(V);
    }), q;
  };
})), require_prime_factors = __commonJSMin(((D, E) => {
  var O = require_factor();
  E.exports = function(F) {
    return O(F).map(function(I) {
      return I.prime;
    });
  };
})), require_euler_phi = __commonJSMin(((D, E) => {
  var O = require_prime_factors();
  E.exports = function(F) {
    var I = function(q) {
      return q.reduce(function(U, Z) {
        return U * Z;
      }, 1);
    }, z = O(F), R = I(z.map(function(q) {
      return q - 1;
    })), L = I(z);
    return F * R / L;
  };
})), require_gcd = __commonJSMin(((D, E) => {
  E.exports = function(O, F) {
    for (O < 0 && (O = -O), F < 0 && (F = -F); ; ) {
      if (F === 0) return O;
      if (O %= F, O === 0) return F;
      F %= O;
    }
  };
})), require_find_divisor = __commonJSMin(((D, E) => {
  var O = require_gcd();
  E.exports = function(F) {
    for (var I = 2 * Math.floor(Math.sqrt(Math.sqrt(F))), z = 2, R = z, L, q = 1; q < I; q++) if (z = (z * z + 1) % F, R = (R * R + 1) % F, R = (R * R + 1) % F, L = O(R - z, F), L != 1) return L;
    return 1;
  };
})), require_inverse_mod = __commonJSMin(((D, E) => {
  E.exports = function(O, F) {
    O < 0 && (O = O % F + F);
    for (var I = 0, z = 1, R = F, L = O; L !== 0; ) {
      var q = Math.floor(R / L), U = I;
      I = z, z = U - q * z;
      var Z = R;
      R = L, L = Z - q * L;
    }
    return R > 1 ? NaN : I > 0 ? I : I + F;
  };
})), require_is_abundant = __commonJSMin(((D, E) => {
  var O = require_divisors();
  E.exports = function(F) {
    if (F === 1) return !1;
    var I = O(F);
    return I.pop(), F < I.reduce(function(z, R) {
      return z + R;
    });
  };
})), require_is_deficient = __commonJSMin(((D, E) => {
  var O = require_divisors();
  E.exports = function(F) {
    if (F === 1) return !0;
    var I = O(F);
    return I.pop(), F > I.reduce(function(z, R) {
      return z + R;
    });
  };
})), require_is_heptagonal = __commonJSMin(((D, E) => {
  E.exports = function(O) {
    return (Math.sqrt(40 * O + 9) + 3) / 10 % 1 == 0;
  };
})), require_is_hexagonal = __commonJSMin(((D, E) => {
  E.exports = function(O) {
    return (Math.sqrt(8 * O + 1) + 1) / 4 % 1 == 0;
  };
})), require_is_octagonal = __commonJSMin(((D, E) => {
  E.exports = function(O) {
    return (Math.sqrt(3 * O + 1) + 1) / 3 % 1 == 0;
  };
})), require_is_pentagonal = __commonJSMin(((D, E) => {
  E.exports = function(O) {
    return (Math.sqrt(24 * O + 1) + 1) / 6 % 1 == 0;
  };
})), require_is_perfect = __commonJSMin(((D, E) => {
  var O = require_divisors();
  E.exports = function(F) {
    if (F === 1) return !1;
    var I = O(F);
    return I.pop(), F === I.reduce(function(z, R) {
      return z + R;
    });
  };
})), require_is_prime = __commonJSMin(((D, E) => {
  var O = require_factor();
  E.exports = function(F) {
    var I = O(F);
    return I.length == 1 ? I[0].power === 1 : !1;
  };
})), require_multiply_mod = __commonJSMin(((D, E) => {
  E.exports = function(O, F, I) {
    if (O < 94906265 && F < 94906265) return O * F % I;
    var z = 0, R = I / 2;
    O >= I && (O %= I), F >= I && (F %= I);
    for (var L = 0; L < 53; L++) z = z >= R ? 2 * z - I : 2 * z, O >= 4503599627370496 && (z += F, O -= 4503599627370495), z > I && (z -= I), O *= 2;
    return z;
  };
})), require_power_mod = __commonJSMin(((D, E) => {
  var O = require_multiply_mod(), F = require_inverse_mod();
  E.exports = function I(z, R, L) {
    if (R < 0) return F(I(z, -R, L), L);
    var q = 1;
    for (z %= L; R > 0; ) R % 2 == 1 && (q = O(q, z, L), --R), R /= 2, z = O(z, z, L);
    return q;
  };
})), require_miller = __commonJSMin(((D, E) => {
  var O = require_multiply_mod(), F = require_power_mod();
  E.exports = function(I) {
    if (I < 2) return !1;
    if (I == 2 || I == 3) return !0;
    if (!(I & 1) || I % 3 == 0) return !1;
    for (var z = I - 1, R = 0; z % 2 == 0; ) z /= 2, R += 1;
    for (var L = I < 1373653 ? [2, 3] : I < 9080191 ? [31, 73] : I < 4759123141 ? [2, 7, 61] : I < 1122004669633 ? [2, 13, 23, 1662803] : I < 2152302898747 ? [2, 3, 5, 7, 11] : I < 3474749660383 ? [2, 3, 5, 7, 11, 13] : [2, 3, 5, 7, 11, 13, 17], q = 0; q < L.length; q++) {
      for (var U = L[q], Z = F(U, z, I), V = 0, G = R; G > 0; ) {
        if (V = O(Z, Z, I), V === 1 && Z !== 1 && Z !== I - 1) return !1;
        Z = V, --G;
      }
      if (V !== 1) return !1;
    }
    return !0;
  };
})), require_is_square = __commonJSMin(((D, E) => {
  E.exports = function(O) {
    return Math.sqrt(O) % 1 == 0;
  };
})), require_is_triangular = __commonJSMin(((D, E) => {
  E.exports = function(O) {
    return Math.sqrt(8 * O + 1) % 1 == 0;
  };
})), require_jacobi_symbol = __commonJSMin(((D, E) => {
  E.exports = function(O, F) {
    if (F % 2 == 0 || F < 0) return NaN;
    O < 0 && (O = O % F + F);
    for (var I = 0; ; ) {
      if (O %= F, O === 0) return 0;
      for (; O % 2 == 0; ) I ^= (F % 8 * (F % 8) - 1) / 8, O /= 2;
      if (O == 1) return I & 1 ? -1 : 1;
      I ^= (O % 4 - 1) * (F % 4 - 1) / 4;
      var z = O;
      O = F, F = z;
    }
    return NaN;
  };
})), require_log_mod = __commonJSMin(((D, E) => {
  var O = require_power_mod(), F = require_multiply_mod(), I = {};
  E.exports = function(z, R, L) {
    z = (z % L + L) % L;
    var q = Math.ceil(Math.sqrt(L)), U = {};
    if (I[L] === void 0 && (I[L] = {}), I[L][R] === void 0) {
      I[L][R] = {}, U = I[L][R];
      for (var Z = 0; Z < q; Z++) U[O(R, Z, L)] = Z;
    } else U = I[L][R];
    for (var V = O(R, -q, L), G = z, W = 0; W < q; W++) {
      if (U[G] !== void 0) return (F(W, q, L) + U[G]) % L;
      G = F(G, V, L);
    }
    return NaN;
  };
})), require_primitive_root = __commonJSMin(((D, E) => {
  var O = (init_index_all(), __toCommonJS(index_all_exports)), F = require_euler_phi(), I = require_prime_factors(), z = require_power_mod();
  E.exports = function(R) {
    for (var L = F(R), q = I(L), U = 2; U < R; U++) if (O.every(q, function(Z) {
      return z(U, L / Z, R) != 1;
    })) return U;
    return NaN;
  };
})), require_quadratic_nonresidue = __commonJSMin(((D, E) => {
  var O = require_jacobi_symbol();
  E.exports = function(F) {
    for (var I = 2; I < F; I++) if (O(I, F) == -1) return I;
    return NaN;
  };
})), require_random_primitive_root = __commonJSMin(((D, E) => {
  var O = require_primitive_root(), F = require_euler_phi(), I = require_gcd(), z = require_power_mod();
  E.exports = function(R) {
    for (var L = O(R), q = F(R), U = 0; U < 100; U++) {
      var Z = Math.floor(Math.random() * q);
      if (I(Z, q) == 1) return z(L, Z, R);
    }
    return L;
  };
})), require_square_root_mod_prime = __commonJSMin(((D, E) => {
  var O = require_jacobi_symbol(), F = require_power_mod(), I = require_quadratic_nonresidue();
  E.exports = function(z, R) {
    if (O(z, R) != 1) return NaN;
    for (var L = R - 1, q = 0; L % 2 == 0; ) L /= 2, q++;
    if (R % 4 == 3) return F(z, (R + 1) / 4, R);
    for (var U = F(I(R), L, R), Z = F(z, (L + 1) / 2, R), V = F(z, L, R), G = q; ; ) {
      if (V % R == 1) return Z;
      for (var W = V, J = 1; J < G && (W = W * W % R, W != 1); J++) ;
      var X = J;
      J++;
      for (var Y = U; J < G; ) Y = Y * Y % R, J++;
      G = X, Z = Z * Y % R, V = V * Y * Y % R, U = Y * Y % R;
    }
    return NaN;
  };
})), require_square_root_mod = __commonJSMin(((D, E) => {
  var O = (init_index_all(), __toCommonJS(index_all_exports)), F = require_factor(), I = require_square_root_mod_prime(), z = require_jacobi_symbol(), R = require_inverse_mod(), L = require_multiply_mod();
  E.exports = function(q, U) {
    var Z = 1, V = [0];
    return F(U).forEach(function(G) {
      var W = G.prime, J = G.power, X = I(q, W), Y = [];
      if (z(q, W) != 1) return [];
      V.forEach(function(te) {
        Y.unshift(te * W * R(W, Z) + X * Z * R(Z, W)), Y.unshift(te * W * R(W, Z) - X * Z * R(Z, W));
      }), Y.sort(), V = O.unique(Y), Z *= W;
      var ee = 1;
      for (J--; J > 0; ) {
        var K = W ** +Math.min(ee, J);
        J -= Math.min(ee, J), V = V.map(function(te) {
          var ie = -((te * te - q) / Z), ne = R(2 * te, K);
          return te + Z * L(ie, ne, K);
        }), Z *= K;
      }
    }), V.map(function(G) {
      return (G % U + U) % U;
    });
  };
})), require_number_theory = __commonJSMin(((D, E) => {
  E.exports = { divisors: require_divisors(), eulerPhi: require_euler_phi(), factor: require_factor(), findDivisor: require_find_divisor(), gcd: require_gcd(), incMixed: require_inc_mixed(), inverseMod: require_inverse_mod(), isAbundant: require_is_abundant(), isDeficient: require_is_deficient(), isHeptagonal: require_is_heptagonal(), isHexagonal: require_is_hexagonal(), isOctagonal: require_is_octagonal(), isPentagonal: require_is_pentagonal(), isPerfect: require_is_perfect(), isPrime: require_is_prime(), isProbablyPrime: require_miller(), isSquare: require_is_square(), isTriangular: require_is_triangular(), jacobiSymbol: require_jacobi_symbol(), logMod: require_log_mod(), miller: require_miller(), multiplyMod: require_multiply_mod(), powerMod: require_power_mod(), primeFactors: require_prime_factors(), primitiveRoot: require_primitive_root(), quadraticNonresidue: require_quadratic_nonresidue(), randomPrimitiveRoot: require_random_primitive_root(), sieve: require_sieve(), squareRootMod: require_square_root_mod(), squareRootModPrime: require_square_root_mod_prime(), totient: require_euler_phi() };
})), import_number_theory = __toESM(require_number_theory());
function gcd$2(D, E) {
  return Number.isNaN(D) || Number.isNaN(E) ? NaN : import_number_theory.default.gcd(D, E);
}
function flatten$1(D) {
  return D.reduce(function(E, O) {
    return E.concat(O);
  }, []);
}
function positiveModulo(D, E) {
  return (D % E + E) % E;
}
var ZmodN = class hr {
  constructor(E, O, F = !1) {
    this.values = E.map(function(I) {
      return positiveModulo(I, O);
    }), this.modulus = O, this.approximate = F;
  }
  apply(E, O, F) {
    if (F == null || Number.isNaN(F)) {
      if (Number.isNaN(this.modulus) || Number.isNaN(E.modulus)) return new hr([NaN], NaN, this.approximate || E.approximate);
      F = gcd$2(this.modulus, E.modulus);
    }
    return new hr(flatten$1(this.values.map(function(I) {
      return E.values.map(function(z) {
        return Number.isNaN(I) || Number.isNaN(z) ? NaN : (F + O(I, z)) % F;
      });
    })), F, this.approximate || E.approximate);
  }
  add(E) {
    return this.apply(E, function(O, F) {
      return O + F;
    });
  }
  power(E) {
    var O = this.modulus;
    return E.modulus == import_number_theory.default.eulerPhi(O) ? this.apply(E, function(F, I) {
      return import_number_theory.default.powerMod(F, I, O);
    }, O) : new hr([NaN], NaN, this.approximate || E.approximate);
  }
  isNaN() {
    for (var E of this.values) if (isNaN(E)) return !0;
    return !1;
  }
  subtract(E) {
    return this.apply(E, function(O, F) {
      return O - F;
    });
  }
  multiply(E) {
    var O = gcd$2(this.modulus, E.modulus);
    return this.apply(E, function(F, I) {
      return import_number_theory.default.multiplyMod(F, I, O);
    });
  }
  inverse() {
    var E = this.modulus;
    return new hr(this.values.map(function(O) {
      return import_number_theory.default.inverseMod(O, E);
    }), this.modulus, this.approximate);
  }
  negate() {
    var E = this.modulus;
    return new hr(this.values.map(function(O) {
      return E - O;
    }), this.modulus, this.approximate);
  }
  divide(E) {
    var O = gcd$2(this.modulus, E.modulus);
    return new hr(flatten$1(flatten$1(this.values.map(function(F) {
      return E.values.map(function(I) {
        if (F % I == 0) return [F / I];
        var z = gcd$2(I, O);
        if (F % z != 0) return [];
        var R = I / z, L = F / z, q = import_number_theory.default.multiplyMod(L, import_number_theory.default.inverseMod(R, O), O), U = [], Z;
        for (Z = 0; Z < z; Z++) U.unshift(q + import_number_theory.default.multiplyMod(Z, O / z, O));
        return U;
      });
    }))), O, this.approximate || E.approximate);
  }
  sqrt() {
    var E = this.modulus;
    return new hr(flatten$1(this.values.map(function(O) {
      return import_number_theory.default.squareRootMod(O, E);
    })), this.modulus, this.approximate);
  }
  toString = function() {
    return "{" + this.values.sort().toString() + "}/" + this.modulus.toString();
  };
  equals(E) {
    return this.toString() == E.toString();
  }
}, PRIME = 10739999, levelFunctions = { "+": function(D) {
  return D.reduce(function(E, O) {
    return E.add(O);
  });
}, "*": function(D) {
  return D.reduce(function(E, O) {
    return E.multiply(O);
  });
}, "/": function(D) {
  return D.reduce(function(E, O) {
    return E.divide(O);
  });
}, "-": function(D) {
  return D[0].negate();
}, "~": function(D) {
  return D.reduce(function(E, O) {
    return E.subtract(O);
  }, new ZmodN([0], D[0].modulus));
}, factorial: function(D) {
  return ZmodN([NaN], 1);
}, gamma: function(D) {
  return ZmodN([NaN], 1);
} };
function rationalApproximation(D, E = 1e15) {
  let O = [[1, 0], [0, 1]], F;
  for (; O[1][0] * (F = Math.floor(D)) + O[1][1] <= E; ) {
    let z;
    if (z = O[0][0] * F + O[0][1], O[0][1] = O[0][0], O[0][0] = z, z = O[1][0] * F + O[1][1], O[1][1] = O[1][0], O[1][0] = z, D == F || (D = 1 / (D - F), D > 2147483647)) break;
  }
  let I = O[1][0] * F + O[1][1] > E;
  return { numerator: O[0][0], denominator: O[1][0], approximate: I };
}
function finite_field_evaluate_ast(D, E, O, F) {
  if (typeof D == "string") return D === "e" ? new ZmodN([import_number_theory.default.primitiveRoot(O)], O) : D === "pi" ? O % 2 == 0 ? new ZmodN([O / 2], O) : new ZmodN([NaN], O) : D === "i" ? new ZmodN([0], 1) : D in E ? new ZmodN([E[D]], O) : D;
  if (typeof D == "number") {
    if (Number.isInteger(D)) return new ZmodN([D], O);
    {
      let W = rationalApproximation(D), J = new ZmodN([W.numerator], O, W.approximate), X = new ZmodN([W.denominator], O, W.approximate);
      return J.divide(X);
    }
  }
  var I = D[0], z = D.slice(1);
  if (I === "apply") {
    if (typeof z[0] != "string") throw Error("Non string functions not implemented for finite fields");
    if (z[0] === "exp") {
      var R = finite_field_evaluate_ast("e", {}, O), L = finite_field_evaluate_ast(z[1], E, import_number_theory.default.eulerPhi(O));
      return R.power(L);
    }
    if (z[0] === "sec") return finite_field_evaluate_ast(["/", 1, ["apply", "cos", z[1]]], E, O);
    if (z[0] === "csc") return finite_field_evaluate_ast(["/", 1, ["apply", "sin", z[1]]], E, O);
    if (z[0] === "cot") return finite_field_evaluate_ast(["/", 1, ["apply", "tan", z[1]]], E, O);
    if (z[0] === "tan") {
      var q = import_number_theory.default.eulerPhi(O);
      return finite_field_evaluate_ast(["/", ["apply", "sin", z[1]], ["apply", "cos", z[1]]], E, O);
    }
    if (z[0] === "sin") {
      var U = import_number_theory.default.primitiveRoot(O), Z = new ZmodN([U], O), q = import_number_theory.default.eulerPhi(O);
      if (q % 4 != 0) return new ZmodN([NaN], O);
      var V = new ZmodN([import_number_theory.default.powerMod(U, q / 4, O)], O), G = finite_field_evaluate_ast(z[1], E, q);
      return Z.power(G).subtract(Z.power(G.negate())).divide(V.add(V));
    }
    if (z[0] === "cos") {
      var Z = new ZmodN([import_number_theory.default.primitiveRoot(O)], O), G = finite_field_evaluate_ast(z[1], E, import_number_theory.default.eulerPhi(O));
      return Z.power(G).add(Z.power(G.negate())).divide(new ZmodN([2], O));
    }
    if (z[0] === "log") return new ZmodN([NaN], NaN);
    if (z[0] === "sqrt") return finite_field_evaluate_ast(z[1], E, O).sqrt();
    if (z[0] === "abs") {
      let W = finite_field_evaluate_ast(z[1], E, O);
      return W.multiply(W).sqrt();
    }
  }
  if (I == "^") {
    var R = finite_field_evaluate_ast(z[0], E, O), L = finite_field_evaluate_ast(z[1], E, import_number_theory.default.eulerPhi(O));
    return R.power(L);
  }
  return I in levelFunctions ? levelFunctions[I](z.map(function(W, J) {
    return finite_field_evaluate_ast(W, E, O);
  })) : new ZmodN([NaN], O);
}
var astToFiniteField$1 = class {
  constructor() {
  }
  convert(D, E, O = PRIME) {
    return finite_field_evaluate_ast(D, E, O);
  }
}, evaluation_exports = __exportAll({ evaluate: () => evaluate, evaluate_to_constant: () => evaluate_to_constant, f: () => f$1, finite_field_evaluate: () => finite_field_evaluate }), astToMathjs$1 = new astToMathjs$2({ mathjs: mathjs_default }), astToFiniteField = new astToFiniteField$1(), f$1 = function(D) {
  var E = get_tree(D), O = factorial_to_gamma_function(astToMathjs$1.convert(log_subscript_to_two_arg_log(normalize_function_names(normalize_applied_functions(E)))));
  return O.evaluate.bind(O);
}, evaluate = function(D, E) {
  return f$1(D)(E);
}, finite_field_evaluate = function(D, E, O) {
  return astToFiniteField.convert(D.tree, E, O);
}, evaluate_to_constant = function(D, { remove_units_first: E = !0, scale_based_on_unit: O = !0, nan_for_non_numeric: F = !0 } = {}) {
  var I = get_tree(D);
  if (E && (I = remove_units(I, O)), typeof I == "number") return I;
  if (typeof I == "string") return I === "pi" && mathjs_default.define_pi ? Math.PI : I === "e" && mathjs_default.define_e ? Math.E : I === "i" && mathjs_default.define_i ? { re: 0, im: 1 } : F ? NaN : null;
  if (!Array.isArray(I)) return F ? NaN : null;
  var z = [];
  z.push([["^", "x", ["/", "m", "n"]], ["^", ["apply", "nthRoot", ["tuple", "x", "n"]], "m"], { variables: { x: (q) => q < 0, n: (q) => Number.isInteger(q) && Number.isInteger((q - 1) / 2), m: (q) => Number.isInteger(q) } }]), z.push([["^", "x", ["-", ["/", "m", "n"]]], ["^", ["apply", "nthRoot", ["tuple", "x", "n"]], ["-", "m"]], { variables: { x: (q) => q < 0, n: (q) => Number.isInteger(q) && Number.isInteger((q - 1) / 2), m: (q) => Number.isInteger(q) } }]), I = applyAllTransformations(I, z, 40);
  var R = F ? NaN : null;
  try {
    var L = f$1(I);
    R = L();
  } catch {
  }
  if (!Number.isNaN(R) && (typeof R == "number" || typeof R?.re == "number" && typeof R?.im == "number")) {
    if (R.re === 1 / 0 || R.re === -1 / 0 || R.im === 1 / 0 || R.im === -1 / 0) {
      let q;
      if (typeof R?.re == "number" && typeof R?.im == "number") if (R.im === 0) q = R.re;
      else {
        let U;
        U = R.im === 1 ? "i" : R.im === -1 ? ["-", "i"] : ["*", R.im, "i"], q = R.re === 0 ? U : ["+", R.re, U];
      }
      else q = R;
      R = F ? NaN : null;
      try {
        var L = f$1(q);
        R = L();
      } catch {
      }
    } else R.im === 0 && (R = R.re);
    return R;
  }
  return typeof R == "object" && (R = F ? NaN : null), R;
};
function factorial_to_gamma_function(D) {
  return D.transform(function(E, O, F) {
    if (E.isOperatorNode && E.op === "!" && E.fn === "factorial") {
      var I = [new mathjs_default.OperatorNode("+", "add", [E.args[0], new mathjs_default.ConstantNode(1)])];
      return new mathjs_default.FunctionNode(new mathjs_default.SymbolNode("gamma"), I);
    } else return E;
  });
}
var functions = { C: {}, R: {}, nonzeroC: {}, nonneg: {}, pos: {} };
functions.C.nonneg = ["abs"], functions.C.nonzero = ["exp"], functions.C.R = ["abs", "arg"], functions.C.C = ["abs", "arg", "exp", "sign", "cos", "cosh", "sin", "sinh", "erf", "sqrt", "log", "ln", "log10"], functions.R.pos = ["exp"], functions.R.nonneg = ["abs", "exp", "arg"], functions.R.R = ["abs", "arg", "exp", "sign", "cos", "cosh", "sin", "sinh", "erf"], functions.R.Z = ["sign"], functions.nonzeroC.pos = ["abs"], functions.nonneg.nonneg = ["abs", "exp", "arg", "sqrt", "erf"], functions.nonzeroC.nonzero = ["abs"], functions.nonneg.R = [...new Set(functions.R.R.concat(functions.nonneg.nonneg))], functions.pos.pos = ["abs", "exp", "sqrt", "erf"], functions.pos.nonneg = functions.pos.pos, functions.pos.nonzero = ["abs", "exp", "sqrt", "erf"], functions.pos.R = functions.nonneg.R.concat(["log", "ln", "log10"]);
function negate_adjust(D, E) {
  if (D) return !E;
  if (D === !1) return E;
}
function narrow_assumptions(D, E) {
  if (!Array.isArray(E)) return [];
  var O = E[0], F = E.slice(1);
  if (O !== "and") return [];
  for (var I = [], z = 0; z < F.length; z++) equal(F[z], D) || I.push(F[z]);
  return I.length === 0 ? [] : I.legnth === 1 ? I[0] : [O].concat(I);
}
function simple_assumption_combination(D, E, O) {
  return D === "and" ? E === void 0 ? O : O === void 0 ? E : E || O : E === void 0 || O === void 0 || E !== O ? void 0 : E;
}
function is_integer_ast(D, E, O) {
  if (typeof E != "object" && (E = []), O === void 0 && (O = E), typeof D == "number") return Number.isInteger(D);
  var F = evaluate_to_constant(D, { remove_units_first: !1, nan_for_non_numeric: !1 });
  if (F !== null) return Number.isInteger(F);
  if (typeof D == "string") {
    let I;
    if (I = Array.isArray(E) ? E : E.get_assumptions(D), !Array.isArray(I)) return;
    let z = I, R = I[0], L = I.slice(1), q = !1;
    for (; R === "not"; ) {
      if (q = !q, I = L[0], !Array.isArray(I)) return;
      R = I[0], L = I.slice(1);
    }
    if (R === "in" && L[0] === D && L[1] === "Z") return negate_adjust(!0, q);
    if (R === "notin" && L[0] === D && L[1] === "Z") return negate_adjust(!1, q);
    if (q === !1) {
      if (R === "notin" && (L[0] === D && L[1] === "R" || L[0] === D && L[1] === "C")) return !1;
    } else if (R === "in" && (L[0] === D && L[1] === "R" || L[0] === D && L[1] === "Z")) return !1;
    if (R === "=" && !q || R === "ne" && q) {
      let V = narrow_assumptions(z, O);
      if (L[0] === D) return is_integer_ast(L[1], V);
      if (L[1] === D) return is_integer_ast(L[0], V);
    }
    if (R !== "and" && R !== "or" || q) return;
    L.length > 2 && (I = unflattenRight(I), L = I.slice(1));
    let U = is_integer_ast(D, L[0], O), Z = is_integer_ast(D, L[1], O);
    return simple_assumption_combination(R, U, Z);
  }
  if (Array.isArray(D)) {
    let I;
    I = Array.isArray(E) ? E : E.get_assumptions([variables(D)]);
    let z = D[0], R = D.slice(1);
    if (z === "-") return is_integer_ast(R[0], I, O);
    if (z === "*") return R.every(function(L) {
      return is_integer_ast(L, I, O);
    }) ? !0 : void 0;
    if (z === "^") {
      let L = is_nonzero_ast(R[0], I, O);
      if (L) {
        if (is_nonzero_ast(R[1], I, O) === !1) return !(R[0] === 1 / 0 || R[0] === -1 / 0);
      } else {
        if (Number.isNaN(R[0])) return !1;
        if (is_positive_ast(R[1], I, !0, O)) {
          if (L === !1) return !0;
        } else return;
      }
      let q = is_integer_ast(R[0], I, O), U = is_integer_ast(R[1], I, O);
      return q && (U && is_positive_ast(R[1], I, !1, O) ? !0 : void 0);
    }
    if (z === "+") {
      let L = 0;
      for (let q = 0; q < R.length; q++) {
        let U = is_integer_ast(R[q], I, O);
        if (U === !1) {
          if (L > 0) return;
          L += 1;
        }
        if (U === void 0) return;
      }
      return L === 0;
    }
    return z === "apply" ? functions.C.Z && functions.C.Z.includes(R[0]) && is_complex_ast(R[1], I, O) || functions.R.Z && functions.R.Z.includes(R[0]) && is_real_ast(R[1], I, O) || functions.nonzeroC.Z && functions.nonzeroC.Z.includes(R[0]) && is_nonzero_ast(R[1], I, O) && is_complex_ast(R[1], I, O) || functions.nonneg.Z && functions.nonneg.Z.includes(R[0]) && is_positive_ast(R[1], I, !1, O) || functions.pos.Z && functions.pos.Z.includes(R[0]) && is_positive_ast(R[1], I, !0, O) ? !0 : void 0 : z === "/" || z === "prime" ? void 0 : !1;
  }
  return !1;
}
function is_real_ast(D, E, O) {
  if (typeof E != "object" && (E = []), O === void 0 && (O = E), typeof D == "number") return Number.isFinite(D);
  var F = evaluate_to_constant(D, { remove_units_first: !1, nan_for_non_numeric: !1 });
  if (F !== null) return typeof F == "number" ? Number.isFinite(F) : !1;
  if (typeof D == "string") {
    let I;
    if (I = Array.isArray(E) ? E : E.get_assumptions(D), !Array.isArray(I)) return;
    let z = I, R = I[0], L = I.slice(1), q = !1;
    for (; R === "not"; ) {
      if (q = !q, I = L[0], !Array.isArray(I)) return;
      R = I[0], L = I.slice(1);
    }
    if (R === "in" && L[0] === D && L[1] === "R") return negate_adjust(!0, q);
    if (R === "notin" && L[0] === D && L[1] === "R") return negate_adjust(!1, q);
    if (q === !1) {
      if (R === "in" && L[0] === D && L[1] === "Z") return !0;
    } else if (R === "notin" && L[0] === D && L[1] === "Z") return !0;
    if (R === "<" || R === "le") {
      let V = variables(I), G = functions$2(I);
      if (V.indexOf(D) !== -1 && G.length === 0) return !0;
    }
    if (R === "=" && !q || R === "ne" && q) {
      let V = narrow_assumptions(z, O);
      if (L[0] === D) return is_real_ast(L[1], V);
      if (L[1] === D) return is_real_ast(L[0], V);
    }
    if (R !== "and" && R !== "or" || q) return;
    L.length > 2 && (I = unflattenRight(I), L = I.slice(1));
    let U = is_real_ast(D, L[0], O), Z = is_real_ast(D, L[1], O);
    return simple_assumption_combination(R, U, Z);
  }
  if (Array.isArray(D)) {
    let I;
    I = Array.isArray(E) ? E : E.get_assumptions([variables(D)]);
    let z = D[0], R = D.slice(1);
    if (z === "-") return is_real_ast(R[0], I, O);
    if (z === "*" || z === "+") {
      if (R.length > 2 && (D = unflattenRight(D), R = D.slice(1)), z === "*" && (is_nonzero_ast(R[0], I, O) === !1 || is_nonzero_ast(R[1], I, O) === !1)) return !0;
      let L = is_real_ast(R[0], I, O), q = is_real_ast(R[1], I, O);
      return L && q ? !0 : L && q === !1 || q && L === !1 ? !1 : void 0;
    }
    if (z === "^") {
      let L = is_nonzero_ast(R[0], I, O), q = is_positive_ast(R[1], I, !0, O);
      if (L) {
        if (is_nonzero_ast(R[1], I, O) === !1) return !(R[0] === 1 / 0 || R[0] === -1 / 0);
      } else {
        if (Number.isNaN(R[0])) return !1;
        if (q) {
          if (L === !1) return !0;
        } else return;
      }
      let U = is_real_ast(R[0], I, O), Z = is_real_ast(R[1], I, O);
      return U && Z ? is_positive_ast(R[0], I, !1, O) ? is_positive_ast(R[0], I, !0, O) || q ? !0 : void 0 : is_integer_ast(R[1], I, O) ? !0 : void 0 : void 0;
    }
    return z === "/" ? is_nonzero_ast(R[1], I, O) && (is_nonzero_ast(R[0], I, O) === !1 || is_real_ast(R[0], I, O) && is_real_ast(R[1], I, O)) ? !0 : void 0 : z === "apply" ? functions.C.R && functions.C.R.includes(R[0]) && is_complex_ast(R[1], I, O) || functions.R.R && functions.R.R.includes(R[0]) && is_real_ast(R[1], I, O) || functions.nonzeroC.R && functions.nonzeroC.R.includes(R[0]) && is_nonzero_ast(R[1], I, O) && is_complex_ast(R[1], I, O) || functions.nonneg.R && functions.nonneg.R.includes(R[0]) && is_positive_ast(R[1], I, !1, O) || functions.pos.R && functions.pos.R.includes(R[0]) && is_positive_ast(R[1], I, !0, O) ? !0 : void 0 : z === "prime" ? void 0 : !1;
  }
  return !1;
}
function is_complex_ast(D, E, O) {
  if (typeof E != "object" && (E = []), O === void 0 && (O = E), typeof D == "number") return Number.isFinite(D);
  var F = evaluate_to_constant(D, { remove_units_first: !1, nan_for_non_numeric: !1 });
  if (F !== null) return typeof F == "number" ? Number.isFinite(F) : !!(F.re !== void 0 && Number.isFinite(F.re) && F.im !== void 0 && Number.isFinite(F.im));
  if (typeof D == "string") {
    let I;
    if (I = Array.isArray(E) ? E : E.get_assumptions(D), !Array.isArray(I)) return;
    let z = I, R = I[0], L = I.slice(1), q = !1;
    for (; R === "not"; ) {
      if (q = !q, I = L[0], !Array.isArray(I)) return;
      R = I[0], L = I.slice(1);
    }
    if (R === "in" && L[0] === D && L[1] === "C") return negate_adjust(!0, q);
    if (R === "notin" && L[0] === D && L[1] === "C") return negate_adjust(!1, q);
    if (q === !1) {
      if (R === "in" && (L[0] === D && L[1] === "Z" || L[0] === D && L[1] === "R")) return !0;
    } else if (R === "notin" && (L[0] === D && L[1] === "Z" || L[0] === D && L[1] === "R")) return !0;
    if (R === "<" || R === "le") {
      let V = variables(I), G = functions$2(I);
      if (V.indexOf(D) !== -1 && G.length === 0) return !0;
    }
    if (R === "=" && !q || R === "ne" && q) {
      let V = narrow_assumptions(z, O);
      if (L[0] === D) return is_complex_ast(L[1], V);
      if (L[1] === D) return is_complex_ast(L[0], V);
    }
    if (R !== "and" && R !== "or" || q) return;
    L.length > 2 && (I = unflattenRight(I), L = I.slice(1));
    let U = is_complex_ast(D, L[0], O), Z = is_complex_ast(D, L[1], O);
    return simple_assumption_combination(R, U, Z);
  }
  if (Array.isArray(D)) {
    let I;
    I = Array.isArray(E) ? E : E.get_assumptions([variables(D)]);
    let z = D[0], R = D.slice(1);
    if (z === "-") return is_complex_ast(R[0], I, O);
    if (z === "*" || z === "+") return z === "*" && !R.every((L) => is_nonzero_ast(L, I, O) !== !1) || R.every((L) => is_complex_ast(L, I, O)) ? !0 : void 0;
    if (z === "^") {
      let L = is_nonzero_ast(R[0], I, O), q = is_positive_ast(R[1], I, !0, O);
      if (L) {
        if (is_nonzero_ast(R[1], I, O) === !1) return !(R[0] === 1 / 0 || R[0] === -1 / 0);
      } else {
        if (Number.isNaN(R[0])) return !1;
        if (q) {
          if (L === !1) return !0;
        } else return;
      }
      let U = is_complex_ast(R[0], I, O), Z = is_complex_ast(R[1], I, O);
      return U && Z ? !0 : void 0;
    }
    return z === "/" ? is_nonzero_ast(R[1], I, O) && (is_nonzero_ast(R[0], I, O) === !1 || is_complex_ast(R[0], I, O) && is_complex_ast(R[1], I, O)) ? !0 : void 0 : z === "apply" ? functions.C.C && functions.C.C.includes(R[0]) && is_complex_ast(R[1], I, O) || functions.R.C && functions.R.C.includes(R[0]) && is_real_ast(R[1], I, O) || functions.nonzeroC.C && functions.nonzeroC.C.includes(R[0]) && is_nonzero_ast(R[1], I, O) && is_complex_ast(R[1], I, O) || functions.nonneg.C && functions.nonneg.C.includes(R[0]) && is_positive_ast(R[1], I, !1, O) || functions.pos.C && functions.pos.C.includes(R[0]) && is_positive_ast(R[1], I, !0, O) ? !0 : void 0 : z === "prime" ? void 0 : !1;
  }
  return !1;
}
function is_nonzero_ast(D, E, O) {
  if (typeof E != "object" && (E = []), O === void 0 && (O = E), typeof D == "number") return Number.isFinite(D) ? D !== 0 : Number.isNaN(D) ? void 0 : !0;
  var F = evaluate_to_constant(D, { remove_units_first: !1, nan_for_non_numeric: !1 });
  if (F !== null) return typeof F == "number" ? Number.isFinite(F) ? F !== 0 : Number.isNaN(F) ? void 0 : !0 : F.re !== void 0 && F.im !== void 0 && (F.re !== 0 || F.im !== 0) ? !0 : void 0;
  if (typeof D == "string") {
    let I;
    if (I = Array.isArray(E) ? E : E.get_assumptions(D), !Array.isArray(I)) return;
    let z = I, R = I[0], L = I.slice(1), q = !1;
    for (; R === "not"; ) {
      if (q = !q, I = L[0], !Array.isArray(I)) return;
      R = I[0], L = I.slice(1);
    }
    let U = narrow_assumptions(z, O);
    if (R === "=" && !q || R === "ne" && q) {
      if (L[0] === D) return is_nonzero_ast(L[1], U);
      if (L[1] === D) return is_nonzero_ast(L[0], U);
    }
    if ((R === "ne" && !q || R === "=" && q) && (L[0] === D && is_nonzero_ast(L[1], U) === !1 || L[1] === D && is_nonzero_ast(L[0], U) === !1)) return !0;
    if (R === "<") {
      if (q) {
        if (L[0] === D && is_positive_ast(L[1], U, !0) || L[1] === D && is_negative_ast(L[0], U, !0)) return !0;
      } else if (L[0] === D && is_negative_ast(L[1], U, !1) || L[1] === D && is_positive_ast(L[0], U, !1)) return !0;
    }
    if (R === "le") {
      if (q) {
        if (L[0] === D && is_positive_ast(L[1], U, !1) || L[1] === D && is_negative_ast(L[0], U, !1)) return !0;
      } else if (L[0] === D && is_negative_ast(L[1], U, !0) || L[1] === D && is_positive_ast(L[0], U, !0)) return !0;
    }
    if (R !== "and" && R !== "or" || q) return;
    L.length > 2 && (I = unflattenRight(I), L = I.slice(1));
    let Z = is_nonzero_ast(D, L[0], O), V = is_nonzero_ast(D, L[1], O);
    return simple_assumption_combination(R, Z, V);
  }
  if (Array.isArray(D)) {
    let I;
    I = Array.isArray(E) ? E : E.get_assumptions([variables(D)]);
    let z = D[0], R = D.slice(1);
    if (z === "-") return is_nonzero_ast(R[0], I, O);
    if (z === "+") {
      if (R.length > 2 && (D = unflattenRight(D), R = D.slice(1)), equal(R[0], simplify(["-", R[1]], O))) return !1;
      let L = is_nonzero_ast(R[0], I, O), q = is_nonzero_ast(R[1], I, O);
      if (L === !1) return q;
      if (q === !1) return L;
      let U = is_real_ast(R[0], I, O), Z = is_real_ast(R[1], I, O);
      if (!U || !Z) return U === !0 ? Z === !1 ? !0 : void 0 : Z === !0 && U === !1 ? !0 : void 0;
      let V = is_positive_ast(R[0], I, !1, O), G = is_positive_ast(R[1], I, !1, O), W = is_positive_ast(R[0], I, !0, O), J = is_positive_ast(R[1], I, !0, O);
      return V && J || W && G || V === !1 && J === !1 || W === !1 && G === !1 ? !0 : void 0;
    }
    if (z === "*") {
      let L = !0;
      for (let q = 0; q < R.length; q++) {
        let U = is_nonzero_ast(R[q], I, O);
        if (U === !1) return !1;
        U === void 0 && (L = !1);
      }
      return L ? !0 : void 0;
    }
    if (z === "/") {
      let L = is_nonzero_ast(R[0], I, O);
      return is_nonzero_ast(R[1], I, O) ? L : void 0;
    }
    if (z === "^") {
      let L = is_nonzero_ast(R[0], I, O);
      return L ? (R[0] === 1 / 0 || R[0] === -1 / 0) && is_nonzero_ast(R[1], I, O) === !1 ? void 0 : !0 : is_positive_ast(R[1], I, !0, O) && L === !1 ? !1 : void 0;
    }
    return z === "apply" ? functions.C.nonzero && functions.C.nonzero.includes(R[0]) && is_complex_ast(R[1], I, O) || functions.R.nonzero && functions.R.nonzero.includes(R[0]) && is_real_ast(R[1], I, O) || functions.nonzeroC.nonzero && functions.nonzeroC.nonzero.includes(R[0]) && is_nonzero_ast(R[1], I, O) || functions.nonneg.nonzero && functions.nonneg.nonzero.includes(R[0]) && is_positive_ast(R[1], I, !1, O) || functions.pos.nonzero && functions.pos.nonzero.includes(R[0]) && is_positive_ast(R[1], I, !0, O) ? !0 : void 0 : z === "prime" ? void 0 : !1;
  }
  return !1;
}
function is_positive_ast(D, E, O, F) {
  if (typeof E != "object" && (E = []), F === void 0 && (F = E), O === void 0 && (O = !0), typeof D == "number") return Number.isFinite(D) ? O ? D > 0 : D >= 0 : !1;
  var I = is_real_ast(D, E, F);
  if (!I) return I;
  var z = evaluate_to_constant(D, { remove_units_first: !1, nan_for_non_numeric: !1 });
  if (z !== null) return typeof z == "number" && Number.isFinite(z) ? O ? z > 0 : z >= 0 : !1;
  if (typeof D == "string") {
    let R;
    if (R = Array.isArray(E) ? E : E.get_assumptions(D), !Array.isArray(R)) return;
    let L = R, q = R[0], U = R.slice(1), Z = !1;
    for (; q === "not"; ) {
      if (Z = !Z, R = U[0], !Array.isArray(R)) return;
      q = R[0], U = R.slice(1);
    }
    let V = narrow_assumptions(L, F);
    if (q === "=" && !Z || q === "ne" && Z) {
      if (U[0] === D) return is_positive_ast(U[1], V, O);
      if (U[1] === D) return is_positive_ast(U[0], V, O);
    }
    if (q === "<") if (Z) {
      if (U[0] === D && is_positive_ast(U[1], V, O)) return !0;
      if (U[1] === D && is_negative_ast(U[0], V, !O)) return !1;
    } else {
      if (U[0] === D && is_negative_ast(U[1], V, !1)) return !1;
      if (U[1] === D && is_positive_ast(U[0], V, !1)) return !0;
    }
    if (q === "le") if (Z) {
      if (U[0] === D && is_positive_ast(U[1], V, !1)) return !0;
      if (U[1] === D && is_negative_ast(U[0], V, !1)) return !1;
    } else {
      if (U[0] === D && is_negative_ast(U[1], V, !O)) return !1;
      if (U[1] === D && is_positive_ast(U[0], V, O)) return !0;
    }
    if (q !== "and" && q !== "or" || Z) return;
    U.length > 2 && (R = unflattenRight(R), U = R.slice(1));
    let G = is_positive_ast(D, U[0], O, F), W = is_positive_ast(D, U[1], O, F);
    return simple_assumption_combination(q, G, W);
  }
  if (Array.isArray(D)) {
    let R;
    R = Array.isArray(E) ? E : E.get_assumptions([variables(D)]);
    let L = D[0], q = D.slice(1);
    if (L === "-") return is_negative_ast(q[0], R, O, F);
    if (L === "+") {
      q.length > 2 && (D = unflattenRight(D), q = D.slice(1));
      let U = is_positive_ast(q[0], R, !1, F), Z = is_positive_ast(q[1], R, !1, F), V = is_positive_ast(q[0], R, !0, F), G = is_positive_ast(q[1], R, !0, F);
      if (O) {
        if (U && G || V && Z) return !0;
      } else if (U && Z) return !0;
      if (O) {
        if (V === !1 && G === !1) return !1;
      } else if (U === !1 && G === !1 || V === !1 && Z === !1) return !1;
      return;
    }
    if (L === "*") {
      if (!q.every((X) => is_nonzero_ast(X, R, F) !== !1)) return !O;
      q.length > 2 && (D = unflattenRight(D), q = D.slice(1));
      let U = is_real_ast(q[0], R, F), Z = is_real_ast(q[1], R, F);
      if (U === void 0 || Z === void 0) return;
      if (U === !1) return Z === !1 ? void 0 : !1;
      if (Z === !1) return !1;
      let V = is_positive_ast(q[0], R, !1, F), G = is_positive_ast(q[1], R, !1, F), W = is_positive_ast(q[0], R, !0, F), J = is_positive_ast(q[1], R, !0, F);
      if (O) {
        if (W && J || V === !1 && G === !1) return !0;
        if (W === !1 && G || V && J === !1) return !1;
      } else {
        if (V && G || W === !1 && J === !1) return !0;
        if (W && G === !1 || V === !1 && J) return !1;
      }
      return;
    }
    if (L === "/") {
      if (!is_nonzero_ast(q[1], R, F)) return;
      if (is_nonzero_ast(q[0], R, F) === !1) return !O;
      let U = is_positive_ast(q[1], R, !0, F);
      if (U === void 0) return;
      let Z = U ? O : !O, V = is_positive_ast(q[0], R, Z, F);
      return V === void 0 ? void 0 : V === !0 ? U === !0 : U !== !0;
    }
    if (L === "^") {
      let U = is_nonzero_ast(q[0], R, F);
      if (U) {
        if (is_nonzero_ast(q[1], R, F) === !1) return q[0] === 1 / 0 || q[0] === -1 / 0 ? void 0 : !0;
      } else if (is_positive_ast(q[1], R, !0, F)) {
        if (U === !1) return !O;
        if (O) return;
      } else return;
      return is_real_ast(q[0], R, F) === !0 ? is_positive_ast(q[0], R, O, F) ? is_real_ast(q[1], R, F) ? !0 : void 0 : is_integer_ast(simplify(["/", q[1], 2], F), R, F) ? !0 : void 0 : void 0;
    }
    return L === "apply" && !O ? functions.C.nonneg && functions.C.nonneg.includes(q[0]) && is_complex_ast(q[1], R, F) || functions.R.nonneg && functions.R.nonneg.includes(q[0]) && is_real_ast(q[1], R, F) || functions.nonzeroC.nonneg && functions.nonzeroC.nonneg.includes(q[0]) && is_nonzero_ast(q[1], R, F) && is_complex_ast(q[1], R, F) || functions.nonneg.nonneg && functions.nonneg.nonneg.includes(q[0]) && is_positive_ast(q[1], R, !1, F) || functions.pos.nonneg && functions.pos.nonneg.includes(q[0]) && is_positive_ast(q[1], R, !0, F) ? !0 : void 0 : L === "apply" && O ? functions.C.pos && functions.C.pos.includes(q[0]) && is_complex_ast(q[1], R, F) || functions.R.pos && functions.R.pos.includes(q[0]) && is_real_ast(q[1], R, F) || functions.nonzeroC.pos && functions.nonzeroC.pos.includes(q[0]) && is_nonzero_ast(q[1], R, F) && is_complex_ast(q[1], R, F) || functions.nonneg.pos && functions.nonneg.pos.includes(q[0]) && is_positive_ast(q[1], R, !1, F) || functions.pos.pos && functions.pos.pos.includes(q[0]) && is_positive_ast(q[1], R, !0, F) ? !0 : void 0 : L === "prime" ? void 0 : !1;
  }
  return !1;
}
function is_negative_ast(D, E, O, F) {
  O === void 0 && (O = !0);
  var I = is_real_ast(D, E, F);
  if (I === !0) {
    let z = is_positive_ast(D, E, !O, F);
    return z === !1 ? !0 : z === !0 ? !1 : void 0;
  }
  return I;
}
function ParseError(D, E) {
  this.name = "ParseError", this.message = D || "Error parsing input", this.stack = Error().stack, this.location = E;
}
ParseError.prototype = Object.create(Error.prototype), ParseError.prototype.constructor = ParseError;
var lexer = class {
  constructor(D, E = "\\s") {
    this.input = "", this.location = 0, this.token_rules = [], this.initial_whitespace = RegExp("^(" + E + ")+");
    for (let O of D) this.token_rules.push([RegExp("^" + O[0])].concat(O.slice(1)));
  }
  set_input(D) {
    if (typeof D != "string") throw Error("Input must be a string");
    this.input = D, this.location = 0;
  }
  return_state() {
    return { input: this.input, location: this.location };
  }
  set_state({ input: D = null, location: E = 0 } = {}) {
    D !== null && (this.input = D, this.location = E);
  }
  advance({ remove_initial_space: D = !0 } = {}) {
    let E = this.initial_whitespace.exec(this.input);
    if (E) {
      let F = E[0].length;
      if (this.input = this.input.slice(F), this.location += F, !D) return { token_type: "SPACE", token_text: E[0], original_text: E[0] };
    }
    if (this.input.length === 0) return { token_type: "EOF", token_text: "", original_text: "" };
    E = null;
    for (var O of this.token_rules) if (E = O[0].exec(this.input), E) {
      let F = E[0].length;
      this.input = this.input.slice(F), this.location += F;
      break;
    }
    return E === null ? { token_type: "INVALID", token_text: this.input[0], original_text: this.input[0] } : O.length > 2 ? { token_type: O[1], token_text: O[2], original_text: E[0] } : { token_type: O[1], token_text: E[0], original_text: E[0] };
  }
  unput(D) {
    if (typeof D != "string") throw Error("Input must be a string");
    this.location -= D.length, this.input = D + this.input;
  }
}, is_associative = { "+": !0, "*": !0, and: !0, or: !0, union: !0, intersect: !0 };
function flatten(D) {
  if (!Array.isArray(D)) return D;
  var E = D[0], O = D.slice(1);
  if (O = O.map(function(z, R) {
    return flatten(z);
  }), is_associative[E]) {
    for (var F = [], I = 0; I < O.length; I++) Array.isArray(O[I]) && O[I][0] === E && O[I].length > 2 ? F = F.concat(O[I].slice(1)) : F.push(O[I]);
    O = F;
  }
  return [E].concat(O);
}
var number_rules_sci$1 = [["[0-9]+(\\.[0-9]*)?(E[+\\-]?[0-9]+\\s*($|(?=\\,|\\||\\)|\\}|\\])))?", "NUMBER"], ["\\.[0-9]+(E[+\\-]?[0-9]+\\s*($|(?=\\,|\\||\\)|\\}|\\])))?", "NUMBER"]], number_rules_non_sci$1 = [["[0-9]+(\\.[0-9]*)?", "NUMBER"], ["\\.[0-9]+", "NUMBER"]], base_text_rules = [["\\*\\*", "^"], ["\\*", "*"], ["\\xB7", "*"], ["·", "*"], ["•", "*"], ["⋅", "*"], ["×", "*"], ["/", "/"], ["-", "-"], ["֊", "-"], ["־", "-"], ["᠆", "-"], ["‐", "-"], ["‑", "-"], ["‒", "-"], ["–", "-"], ["—", "-"], ["―", "-"], ["⁻", "-"], ["₋", "-"], ["−", "-"], ["⸺", "-"], ["⸻", "-"], ["﹘", "-"], ["﹣", "-"], ["－", "-"], ["\\+", "+"], ["plusminus(?![a-zA-Z0-9])", "PM"], ["±", "PM"], ["\\^", "^"], ["‸", "^"], ["ʌ", "^"], ["′", "'"], ["\\|", "|"], ["\\(", "("], ["\\)", ")"], ["\\[", "["], ["\\]", "]"], ["\\{", "{"], ["\\}", "}"], ["⟨", "LANGLE"], ["⟩", "RANGLE"], ["〈", "LANGLE"], ["〉", "RANGLE"], [",", ","], [":", ":"], ["α", "VARMULTICHAR", "alpha"], ["β", "VARMULTICHAR", "beta"], ["ϐ", "VARMULTICHAR", "beta"], ["Γ", "VARMULTICHAR", "Gamma"], ["γ", "VARMULTICHAR", "gamma"], ["Δ", "VARMULTICHAR", "Delta"], ["δ", "VARMULTICHAR", "delta"], ["ε", "VARMULTICHAR", "epsilon"], ["ϵ", "VARMULTICHAR", "epsilon"], ["ζ", "VARMULTICHAR", "zeta"], ["η", "VARMULTICHAR", "eta"], ["Θ", "VARMULTICHAR", "Theta"], ["ϴ", "VARMULTICHAR", "Theta"], ["θ", "VARMULTICHAR", "theta"], ["ᶿ", "VARMULTICHAR", "theta"], ["ϑ", "VARMULTICHAR", "theta"], ["ι", "VARMULTICHAR", "iota"], ["κ", "VARMULTICHAR", "kappa"], ["Λ", "VARMULTICHAR", "Lambda"], ["λ", "VARMULTICHAR", "lambda"], ["μ", "VARMULTICHAR", "mu"], ["µ", "VARMULTICHAR", "mu"], ["ν", "VARMULTICHAR", "nu"], ["Ξ", "VARMULTICHAR", "Xi"], ["ξ", "VARMULTICHAR", "xi"], ["Π", "VARMULTICHAR", "Pi"], ["π", "VARMULTICHAR", "pi"], ["ϖ", "VARMULTICHAR", "pi"], ["ρ", "VARMULTICHAR", "rho"], ["ϱ", "VARMULTICHAR", "rho"], ["Σ", "VARMULTICHAR", "Sigma"], ["σ", "VARMULTICHAR", "sigma"], ["ς", "VARMULTICHAR", "sigma"], ["τ", "VARMULTICHAR", "tau"], ["Υ", "VARMULTICHAR", "Upsilon"], ["υ", "VARMULTICHAR", "upsilon"], ["Φ", "VARMULTICHAR", "Phi"], ["φ", "VARMULTICHAR", "phi"], ["ϕ", "VARMULTICHAR", "phi"], ["Ψ", "VARMULTICHAR", "Psi"], ["ψ", "VARMULTICHAR", "psi"], ["Ω", "VARMULTICHAR", "Omega"], ["ω", "VARMULTICHAR", "omega"], ["∅", "VARMULTICHAR", "emptyset"], ["oo(?![a-zA-Z0-9])", "INFINITY"], ["OO(?![a-zA-Z0-9])", "INFINITY"], ["infty(?![a-zA-Z0-9])", "INFINITY"], ["infinity(?![a-zA-Z0-9])", "INFINITY"], ["Infinity(?![a-zA-Z0-9])", "INFINITY"], ["∞", "INFINITY"], ["ℯ", "VAR", "e"], ["♠", "VARMULTICHAR", "spade"], ["♡", "VARMULTICHAR", "heart"], ["♢", "VARMULTICHAR", "diamond"], ["♣", "VARMULTICHAR", "club"], ["★", "VARMULTICHAR", "bigstar"], ["◯", "VARMULTICHAR", "bigcirc"], ["◊", "VARMULTICHAR", "lozenge"], ["△", "VARMULTICHAR", "bigtriangleup"], ["▽", "VARMULTICHAR", "bigtriangledown"], ["⧫", "VARMULTICHAR", "blacklozenge"], ["■", "VARMULTICHAR", "blacksquare"], ["▲", "VARMULTICHAR", "blacktriangle"], ["▼", "VARMULTICHAR", "blacktriangledown"], ["◀", "VARMULTICHAR", "blacktriangleleft"], ["▶", "VARMULTICHAR", "blacktriangleright"], ["□", "VARMULTICHAR", "Box"], ["∘", "VARMULTICHAR", "circ"], ["⋆", "VARMULTICHAR", "star"], ["and(?![a-zA-Z0-9])", "AND"], ["\\&\\&?", "AND"], ["∧", "AND"], ["or(?![a-zA-Z0-9])", "OR"], ["∨", "OR"], ["not(?![a-zA-Z0-9])", "NOT"], ["¬", "NOT"], ["=", "="], ["᐀", "="], ["゠", "="], ["!=", "NE"], ["≠", "NE"], ["<=", "LE"], ["≤", "LE"], [">=", "GE"], ["≥", "GE"], ["<", "<"], [">", ">"], ["forall(?![a-zA-Z0-9])", "FORALL"], ["∀", "FORALL"], ["exists(?![a-zA-Z0-9])", "EXISTS"], ["∃", "EXISTS"], ["elementof(?![a-zA-Z0-9])", "IN"], ["∈", "IN"], ["notelementof(?![a-zA-Z0-9])", "NOTIN"], ["∉", "NOTIN"], ["containselement(?![a-zA-Z0-9])", "NI"], ["∋", "NI"], ["notcontainselement(?![a-zA-Z0-9])", "NOTNI"], ["∌", "NOTNI"], ["subset(?![a-zA-Z0-9])", "SUBSET"], ["⊂", "SUBSET"], ["subseteq(?![a-zA-Z0-9])", "SUBSETEQ"], ["⊆", "SUBSETEQ"], ["notsubset(?![a-zA-Z0-9])", "NOTSUBSET"], ["⊄", "NOTSUBSET"], ["notsubseteq(?![a-zA-Z0-9])", "NOTSUBSETEQ"], ["⊈", "NOTSUBSETEQ"], ["superset(?![a-zA-Z0-9])", "SUPERSET"], ["⊃", "SUPERSET"], ["superseteq(?![a-zA-Z0-9])", "SUPERSETEQ"], ["⊇", "SUPERSETEQ"], ["notsuperset(?![a-zA-Z0-9])", "NOTSUPERSET"], ["⊅", "NOTSUPERSET"], ["notsuperseteq(?![a-zA-Z0-9])", "NOTSUPERSETEQ"], ["⊉", "NOTSUPERSETEQ"], ["union(?![a-zA-Z0-9])", "UNION"], ["∪", "UNION"], ["intersect(?![a-zA-Z0-9])", "INTERSECT"], ["∩", "INTERSECT"], ["rightarrow(?![a-zA-Z0-9])", "RIGHTARROW"], ["→", "RIGHTARROW"], ["⟶", "RIGHTARROW"], ["leftarrow(?![a-zA-Z0-9])", "LEFTARROW"], ["←", "LEFTARROW"], ["⟵", "LEFTARROW"], ["leftrightarrow(?![a-zA-Z0-9])", "LEFTRIGHTARROW"], ["↔", "LEFTRIGHTARROW"], ["⟷", "LEFTRIGHTARROW"], ["implies(?![a-zA-Z0-9])", "IMPLIES"], ["⇒", "IMPLIES"], ["⟹", "IMPLIES"], ["impliedby(?![a-zA-Z0-9])", "IMPLIEDBY"], ["⇐", "IMPLIEDBY"], ["⟸", "IMPLIEDBY"], ["iff(?![a-zA-Z0-9])", "IFF"], ["⇔", "IFF"], ["⟺", "IFF"], ["perp(?![a-zA-Z0-9])", "PERP"], ["⟂", "PERP"], ["parallel(?![a-zA-Z0-9])", "PARALLEL"], ["∥", "PARALLEL"], ["angle(?![a-zA-Z0-9])", "ANGLE"], ["∠", "ANGLE"], ["int(?![a-zA-Z0-9])", "INT"], ["∫", "INT"], ["!", "!"], ["'", "'"], ["_", "_"], ["\\.\\.\\.", "LDOTS"], ["[a-zA-Z∂][a-zA-Z∂0-9]*", "VAR"], ["[＿$%]", "VAR"]], allowSimplifiedFunctionApplicationDefault$1 = !0, splitSymbolsDefault = !0, unsplitSymbolsDefault = "alpha.beta.gamma.Gamma.delta.Delta.epsilon.zeta.eta.theta.Theta.iota.kappa.lambda.Lambda.mu.nu.xi.Xi.pi.Pi.rho.sigma.Sigma.tau.Tau.upsilon.Upsilon.phi.Phi.chi.psi.Psi.omega.Omega.angle.deg.emptyset".split("."), appliedFunctionSymbolsDefault$1 = "abs.exp.log.ln.log10.sign.sqrt.cbrt.nthroot.mod.erf.cos.cosh.acos.acosh.arccos.arccosh.cot.coth.acot.acoth.arccot.arccoth.csc.csch.acsc.acsch.arccsc.arccsch.sec.sech.asec.asech.arcsec.arcsech.sin.sinh.asin.asinh.arcsin.arcsinh.tan.tanh.atan.atan2.atanh.arctan.arctanh.arg.conj.re.im.det.trace.nPr.nCr.floor.ceil.round".split("."), functionSymbolsDefault$1 = ["f", "g"], operatorSymbolsDefault$1 = ["binom", "vec", "linesegment"], unitsDefault$1 = get_all_units(), parseLeibnizNotationDefault$1 = !0, textToAst$4 = class {
  constructor({ allowSimplifiedFunctionApplication: D = allowSimplifiedFunctionApplicationDefault$1, splitSymbols: E = splitSymbolsDefault, unsplitSymbols: O = unsplitSymbolsDefault, appliedFunctionSymbols: F = appliedFunctionSymbolsDefault$1, functionSymbols: I = functionSymbolsDefault$1, operatorSymbols: z = operatorSymbolsDefault$1, units: R = unitsDefault$1, parseLeibnizNotation: L = parseLeibnizNotationDefault$1, parseScientificNotation: q = !0 } = {}) {
    this.allowSimplifiedFunctionApplication = D, this.splitSymbols = E, this.unsplitSymbols = O, this.appliedFunctionSymbols = F, this.functionSymbols = I, this.operatorSymbols = z, this.units = R, this.parseLeibnizNotation = L;
    let U = base_text_rules;
    U = q ? [...number_rules_sci$1, ...U] : [...number_rules_non_sci$1, ...U], this.lexer = new lexer(U);
  }
  advance(D) {
    if (this.token = this.lexer.advance(D), this.token.token_type === "INVALID") throw new ParseError("Invalid symbol '" + this.token.original_text + "'", this.lexer.location);
  }
  return_state() {
    return { lexer_state: this.lexer.return_state(), token: Object.assign({}, this.token) };
  }
  set_state(D) {
    this.lexer.set_state(D.lexer_state), this.token = Object.assign({}, D.token);
  }
  convert(D) {
    this.lexer.set_input(D), this.advance();
    var E = this.statement_list();
    if (this.token.token_type !== "EOF") throw new ParseError("Invalid location of '" + this.token.original_text + "'", this.lexer.location);
    return flatten(E);
  }
  statement_list() {
    for (var D = [this.statement()]; this.token.token_type === ","; ) this.advance(), D.push(this.statement());
    return D = D.length > 1 ? ["list"].concat(D) : D[0], D;
  }
  statement({ inside_absolute_value: D = 0 } = {}) {
    if (this.token.token_type === "LDOTS") return this.advance(), ["ldots"];
    var E;
    try {
      E = this.return_state();
      let O = this.statement_a({ inside_absolute_value: D });
      return this.token.token_type === ":" ? (this.advance(), [":", O, this.statement_a()]) : O;
    } catch (O) {
      try {
        this.set_state(E);
        let F = this.statement_a({ parse_absolute_value: !1 });
        if (this.token.token_type !== "|") throw O;
        return this.advance(), ["|", F, this.statement_a({ parse_absolute_value: !1 })];
      } catch {
        throw O;
      }
    }
  }
  statement_a({ inside_absolute_value: D = 0, parse_absolute_value: E = !0 } = {}) {
    for (var O = this.statement_b({ inside_absolute_value: D, parse_absolute_value: E }); ["IMPLIES", "IMPLIEDBY", "IFF", "LEFTARROW", "RIGHTARROW", "LEFTRIGHTARROW"].includes(this.token.token_type); ) {
      let F = this.token.token_type.toLowerCase();
      this.advance();
      let I = this.statement_b({ inside_absolute_value: D, parse_absolute_value: E });
      O = [F, O, I];
    }
    return O;
  }
  statement_b({ inside_absolute_value: D = 0, parse_absolute_value: E = !0 } = {}) {
    for (var O = this.statement_c({ inside_absolute_value: D, parse_absolute_value: E }); this.token.token_type === "OR"; ) {
      let F = this.token.token_type.toLowerCase();
      this.advance();
      let I = this.statement_c({ inside_absolute_value: D, parse_absolute_value: E });
      O = [F, O, I];
    }
    return O;
  }
  statement_c(D) {
    for (var E = this.relation(D); this.token.token_type === "AND"; ) {
      let O = this.token.token_type.toLowerCase();
      this.advance();
      let F = this.relation(D);
      E = [O, E, F];
    }
    return E;
  }
  relation(D) {
    if (this.token.token_type === "NOT" || this.token.token_type === "!") return this.advance(), ["not", this.relation(D)];
    if (this.token.token_type === "FORALL" || this.token.token_type === "EXISTS") {
      let O = this.token.token_type.toLowerCase();
      return this.advance(), [O, this.relation(D)];
    }
    for (var E = this.expression(D); this.token.token_type === "=" || this.token.token_type === "NE" || this.token.token_type === "<" || this.token.token_type === ">" || this.token.token_type === "LE" || this.token.token_type === "GE" || this.token.token_type === "IN" || this.token.token_type === "NOTIN" || this.token.token_type === "NI" || this.token.token_type === "NOTNI" || this.token.token_type === "SUBSET" || this.token.token_type === "NOTSUBSET" || this.token.token_type === "SUBSETEQ" || this.token.token_type === "NOTSUBSETEQ" || this.token.token_type === "SUPERSET" || this.token.token_type === "NOTSUPERSET" || this.token.token_type === "SUPERSETEQ" || this.token.token_type === "NOTSUPERSETEQ"; ) {
      let O = this.token.token_type.toLowerCase(), F = 0;
      this.token.token_type === "<" || this.token.token_type === "LE" ? F = -1 : (this.token.token_type === ">" || this.token.token_type === "GE") && (F = 1), this.advance();
      let I = this.expression(D);
      if (F === -1) if (this.token.token_type === "<" || this.token.token_type === "LE") {
        let z = ["tuple"];
        O === "<" ? z.push(!0) : z.push(!1);
        let R = ["tuple", E, I];
        for (; this.token.token_type === "<" || this.token.token_type === "LE"; ) this.token.token_type === "<" ? z.push(!0) : z.push(!1), this.advance(), R.push(this.expression(D));
        E = ["lts", R, z];
      } else E = [O, E, I];
      else if (F === 1) if (this.token.token_type === ">" || this.token.token_type === "GE") {
        let z = ["tuple"];
        O === ">" ? z.push(!0) : z.push(!1);
        let R = ["tuple", E, I];
        for (; this.token.token_type === ">" || this.token.token_type === "GE"; ) this.token.token_type === ">" ? z.push(!0) : z.push(!1), this.advance(), R.push(this.expression(D));
        E = ["gts", R, z];
      } else E = [O, E, I];
      else if (O === "=") for (E = ["=", E, I]; this.token.token_type === "="; ) this.advance(), E.push(this.expression(D));
      else E = [O, E, I];
    }
    return E;
  }
  expression(D) {
    if (this.token.token_type === "NOT" || this.token.token_type === "!") return this.advance(), ["not", this.expression(D)];
    let E = !1;
    this.token.token_type === "+" && (E = !0, this.advance());
    let O = !1;
    this.token.token_type === "-" && (O = !0, this.advance());
    let F = !1;
    this.token.token_type === "PM" && (F = !0, this.advance());
    var I = this.term(D);
    if (O || E) {
      if (I === !1) return (E ? "+" : "") + (O ? "-" : "");
      if (typeof I == "string" && [...I].every((z) => ["+", "-"].includes(z))) return (E ? "+" : "") + (O ? "-" : "") + I;
    }
    for (I === !1 && (I = "＿"), O && (I = I > 0 ? -I : ["-", I]), F && (I = ["pm", I]), E && (I = ["+", I]); ["+", "-", "PM", "UNION", "INTERSECT", "PERP", "PARALLEL"].includes(this.token.token_type); ) {
      let z = this.token.token_type.toLowerCase(), R = !1, L = !1, q = !1;
      this.token.token_type === "-" ? (z = "+", R = !0, this.advance()) : this.token.token_type === "PM" ? (z = "+", L = !0, this.advance()) : (this.advance(), z === "+" && (this.token.token_type === "-" ? (R = !0, q = !0, this.advance()) : this.token.token_type === "PM" && (L = !0, this.advance())));
      let U = this.term(D);
      if (z === "+") {
        if (U === !1 && (typeof I == "number" || typeof I == "string")) {
          if (q) return I + "+-";
          if (R) return I + "-";
          if (!L) return I + "+";
        } else if (typeof U == "string" && [...U].every((Z) => ["+", "-"].includes(Z)) && (typeof I == "number" || typeof I == "string")) {
          if (q) return I + "+-" + U;
          if (R) return I + "-" + U;
          if (!L) return I + "+" + U;
        }
      }
      U === !1 && (U = "＿"), R && (U = U > 0 ? -U : ["-", U]), L && (U = ["pm", U]), I = [z, I, U];
    }
    return I;
  }
  term(D) {
    var E = this.factor(D), O = !1;
    do
      if (O = !1, this.token.token_type === "*") {
        this.advance(), E === !1 && (E = "＿");
        let F = this.factor(D);
        F === !1 && (F = "＿"), E = ["*", E, F], O = !0;
      } else if (this.token.token_type === "/") {
        this.advance(), E === !1 && (E = "＿");
        let F = this.factor(D);
        F === !1 && (F = "＿"), E = ["/", E, F], O = !0;
      } else {
        let F = Object.assign({}, D);
        F.allow_absolute_value_closing = !0;
        let I = this.nonMinusFactor(F);
        I !== !1 && (E === !1 && (E = "＿"), E = ["*", E, I], O = !0);
      }
    while (O);
    return this.convert_units_in_term(flatten(E));
  }
  convert_units_in_term(D) {
    if (!Array.isArray(D)) return D;
    let E = D[0], O = D.slice(1);
    if (E === "*") {
      let F = O.length;
      for (let [I, z] of O.entries()) {
        let R = this.units[z];
        if (R) {
          if (R.prefix && I < F - 1) {
            let L;
            L = I === F - 2 ? O[F - 1] : this.convert_units_in_term(["*", ...O.slice(I + 1)]);
            let q = z;
            R.substitute && (q = R.substitute);
            let U = ["unit", q, L];
            return I === 0 ? U : ["*", ...O.slice(0, I), U];
          } else if (!R.prefix && I > 0) {
            let L = z;
            R.substitute && (L = R.substitute);
            let q;
            return q = I === 1 ? ["unit", O[0], L] : ["unit", ["*", ...O.slice(0, I)], L], I === F - 1 ? q : this.convert_units_in_term(["*", q, ...O.slice(I + 1)]);
          }
        }
      }
      return D;
    } else if (E === "/") return ["/", this.convert_units_in_term(O[0]), this.convert_units_in_term(O[1])];
    return D;
  }
  factor(D) {
    if (this.token.token_text === "+") {
      this.advance();
      let O = this.factor(D);
      return O === !1 ? "+" : typeof O == "string" && [...O].every((F) => ["+", "-"].includes(F)) ? "+" + O : ["+", O];
    }
    if (this.token.token_type === "-") {
      this.advance();
      let O = this.factor(D);
      return O > 0 ? -O : O === !1 ? "-" : typeof O == "string" && [...O].every((F) => ["+", "-"].includes(F)) ? "-" + O : ["-", O];
    }
    let E = this.nonMinusFactor(D);
    return E === !1 && this.token.token_type === "PERP" && (E = "perp", this.advance()), E;
  }
  nonMinusFactor(D) {
    for (var E = this.baseFactor(D); this.token.token_type === "^" || this.token.token_type === "!" || this.token.token_type === "'"; ) if (E === !1 && (E = "＿"), this.token.token_type === "^") {
      this.advance();
      let O = this.get_subsuperscript(D);
      E = ["^", E, O];
    } else this.token.token_type === "!" ? (E = ["apply", "factorial", E], this.advance()) : (E = ["prime", E], this.advance());
    return E;
  }
  get_subsuperscript({ parse_absolute_value: D }) {
    if (["+", "-", "PERP"].includes(this.token.token_type)) {
      let E = this.token.token_type.toLowerCase();
      return this.advance(), E;
    } else {
      let E = this.baseFactor({ parse_absolute_value: D, in_subsuperscript_with_no_delimiters: !0 });
      return E === !1 && (E = "＿"), E;
    }
  }
  baseFactor({ inside_absolute_value: D = 0, parse_absolute_value: E = !0, allow_absolute_value_closing: O = !1, in_subsuperscript_with_no_delimiters: F = !1 } = {}) {
    var I = !1;
    if (this.token.token_type === "NUMBER") I = parseFloat(this.token.token_text), this.advance();
    else if (this.token.token_type === "INFINITY") I = 1 / 0, this.advance();
    else if (this.token.token_type === "VAR" || this.token.token_type === "VARMULTICHAR") if (I = this.token.token_text, this.appliedFunctionSymbols.includes(I) || this.functionSymbols.includes(I)) {
      let z = !1;
      if (this.appliedFunctionSymbols.includes(I) && (z = !0), this.advance(), this.token.token_type === "_") {
        this.advance();
        let R = this.get_subsuperscript({ parse_absolute_value: E });
        I = I === "log" && R === 10 ? "log10" : ["_", I, R];
      }
      if (F) z && (I = ["apply", I, "＿"]);
      else {
        for (; this.token.token_type === "'"; ) I = ["prime", I], this.advance();
        for (; this.token.token_type === "^"; ) {
          this.advance();
          let R = this.get_subsuperscript({ parse_absolute_value: E });
          I = ["^", I, R];
        }
        if (this.token.token_type === "(") {
          this.advance();
          let R = this.statement_list();
          if (this.token.token_type !== ")") throw new ParseError("Expecting )", this.lexer.location);
          this.advance(), R[0] === "list" && (R[0] = "tuple"), I = ["apply", I, R];
        } else if (z) {
          if (!this.allowSimplifiedFunctionApplication) throw new ParseError("Expecting ( after function", this.lexer.location);
          let R = this.factor({ parse_absolute_value: E });
          R === !1 && (R = "＿"), I = ["apply", I, R];
        }
      }
      return I;
    } else if (this.operatorSymbols.includes(I)) if (this.advance(), this.token.token_type === "(") {
      this.advance();
      let z = this.statement_list();
      if (this.token.token_type !== ")") throw new ParseError("Expecting )", this.lexer.location);
      this.advance(), I = z[0] === "list" ? [I, ...z.slice(1)] : [I, z];
    } else {
      let z = this.factor({ parse_absolute_value: E });
      z === !1 && (z = "＿"), I = [I, z];
    }
    else {
      if (this.parseLeibnizNotation) {
        let R = this.return_state(), L = this.leibniz_notation();
        if (L) return L;
        this.set_state(R);
      }
      let z = this.splitSymbols;
      if (z && (this.token.token_type === "VARMULTICHAR" || this.unsplitSymbols.includes(I) || I.length === 1 || I.match(/[\d]/g)) && (z = !1), z) {
        for (let R = I.length - 1; R >= 0; R--) this.lexer.unput(" "), this.lexer.unput(I[R]);
        return this.advance(), this.baseFactor({ inside_absolute_value: D, parse_absolute_value: E, allow_absolute_value_closing: O });
      } else this.advance();
    }
    else if (this.token.token_type === "(" || this.token.token_type === "[" || this.token.token_type === "{" || this.token.token_type === "LANGLE") {
      let z = this.token.token_type, R, L;
      this.token.token_type === "(" ? (R = ")", L = "]") : this.token.token_type === "[" ? (R = "]", L = ")") : this.token.token_type === "{" ? (R = "}", L = null) : (R = "RANGLE", L = null), this.advance(), I = this.statement_list();
      let q = 1;
      if (I[0] === "list" && (q = I.length - 1), this.token.token_type !== R) {
        if (q !== 2 || L === null) throw new ParseError("Expecting " + R, this.lexer.location);
        if (this.token.token_type !== L) throw new ParseError("Expecting ) or ]", this.lexer.location);
        I[0] = "tuple", I = ["interval", I];
        let U;
        U = z === "(" ? ["tuple", !1, !0] : ["tuple", !0, !1], I.push(U);
      } else q >= 2 ? z === "(" ? I[0] = "tuple" : z === "[" ? I[0] = "array" : z === "{" ? I[0] = "set" : I[0] = "altvector" : z === "{" && (I = (I[0] === "|" || I[0], ["set", I]));
      this.advance();
    } else if (this.token.token_type === "|" && E && (D === 0 || !O)) {
      if (D += 1, this.advance(), I = this.statement({ inside_absolute_value: D }), I = ["apply", "abs", I], this.token.token_type !== "|") throw new ParseError("Expecting |", this.lexer.location);
      this.advance();
    } else if (this.token.token_type === "ANGLE") if (this.advance(), this.token.token_type === "(") {
      this.advance();
      let z = this.statement_list();
      if (this.token.token_type !== ")") throw new ParseError("Expecting )", this.lexer.location);
      this.advance(), z[0] === "list" ? I = ["angle", ...z.slice(1)] : z[0] === "*" && (I = ["angle", z]);
    } else {
      let z = [], R = this.nonMinusFactor({ parse_absolute_value: E });
      for (; R !== !1; ) z.push(R), R = this.nonMinusFactor({ parse_absolute_value: E });
      I = z.length === 0 ? "angle" : ["angle", ...z];
    }
    else if (this.token.token_type === "INT") {
      this.advance();
      let z = "int";
      if (this.token.token_type === "_") {
        this.advance();
        let L = this.get_subsuperscript({ parse_absolute_value: E });
        z = ["_", z, L];
      }
      if (this.token.token_type === "^") {
        this.advance();
        let L = this.get_subsuperscript({ parse_absolute_value: E });
        z = ["^", z, L];
      }
      let R = flatten(this.term({ parse_absolute_value: E }));
      if (Array.isArray(R) && R[0] === "*") {
        let L = [];
        for (let q = 0; q < R.length - 1; q++) if (R[q] === "d") {
          let U = R[q + 1];
          R.splice(q, 2), L.push(["d", U]), q--;
        }
        R.push(...L);
      }
      return ["apply", z, R];
    }
    if (this.token.token_type === "_") {
      I === !1 && (I = "＿"), this.advance();
      let z = this.get_subsuperscript({ parse_absolute_value: E });
      I = ["_", I, z];
    }
    return I;
  }
  leibniz_notation() {
    var D = this.token.token_text;
    if (!(this.token.token_type === "VAR" && (D[0] === "d" || D[0] === "∂") && (D.length === 1 || D.length === 2 && /[a-zA-Z]/.exec(D[1])))) return !1;
    let E = D[0], O = 1, F = "", I = [], z = [];
    if (D.length === 2) F = D[1];
    else if (this.advance(), this.token.token_type === "VARMULTICHAR" || this.token.token_type === "VAR" && !this.token.token_text.includes("∂")) F = this.token.token_text;
    else {
      if (this.token.token_type !== "^" || (this.advance(), this.token.token_type !== "NUMBER") || (O = parseFloat(this.token.token_text), !Number.isInteger(O))) return !1;
      if (this.advance(), this.token.token_type === "VAR" && !this.token.token_text.includes("∂") || this.token.token_type === "VARMULTICHAR") F = this.token.token_text;
      else return !1;
    }
    if (this.advance(), this.token.token_type !== "/") return !1;
    let R = 0;
    for (this.advance(); ; ) {
      if (this.token.token_type !== "VAR" || this.token.token_text[0] !== E) return !1;
      this.token.token_text.length > 2 && (this.lexer.unput(this.token.token_text.slice(2)), this.token.token_text = this.token.token_text.slice(0, 2));
      let L = this.token.token_text;
      if (L.length === 2) if (/[a-zA-Z]/.exec(L[1])) I.push(L[1]);
      else return !1;
      else {
        if (this.advance(), !(this.token.token_type === "VAR" && !this.token.token_text.includes("∂") || this.token.token_type === "VARMULTICHAR")) return !1;
        I.push(this.token.token_text);
      }
      let q = 1, U = !1;
      if (this.advance({ remove_initial_space: !1 }), this.token.token_type === "SPACE" && (U = !0, this.advance()), this.token.token_type === "^") {
        if (this.advance(), this.token.token_type !== "NUMBER" || (q = parseFloat(this.token.token_text), !Number.isInteger(q))) return !1;
        U = !1, this.advance({ remove_initial_space: !1 }), this.token.token_type === "SPACE" && (U = !0, this.advance());
      }
      if (z.push(q), R += q, R > O) return !1;
      if (R === O) {
        if (!U && (this.token.token_type === "VAR" || this.token.token_type === "VARMULTICHAR")) return !1;
        this.token.token_type === "SPACE" && this.advance();
        let Z = "derivative_leibniz";
        E === "∂" && (Z = "partial_" + Z), D = [Z], O === 1 ? D.push(F) : D.push(["tuple", F, O]);
        let V = [];
        for (let G = 0; G < I.length; G += 1) z[G] === 1 ? V.push(I[G]) : V.push(["tuple", I[G], z[G]]);
        return V = ["tuple"].concat(V), D.push(V), D;
      }
    }
  }
}, MAX_PM_COUNT = 10, MAX_PM_EXPANSIONS = 1 << MAX_PM_COUNT;
function contains_pm(D) {
  if (!Array.isArray(D)) return !1;
  if (D[0] === "pm") return !0;
  for (let E = 1; E < D.length; E++) if (contains_pm(D[E])) return !0;
  return !1;
}
function count_pm(D) {
  if (!Array.isArray(D)) return 0;
  let E = +(D[0] === "pm");
  for (let O = 1; O < D.length; O++) E += count_pm(D[O]);
  return E;
}
function expand_pm_signs(D) {
  let E = count_pm(D);
  if (E === 0) return [D];
  if (E > MAX_PM_COUNT) throw Error(`pm: cannot expand ${E} plus-minus operators (limit is ${MAX_PM_COUNT} → ${MAX_PM_EXPANSIONS} combinations)`);
  let O = 1 << E, F = [];
  for (let I = 0; I < O; I++) F.push(replace_pm(D, I, { idx: 0 }));
  return F;
}
function replace_pm(D, E, O) {
  if (!Array.isArray(D)) return D;
  if (D[0] === "pm") {
    let I = E >> O.idx & 1;
    O.idx += 1;
    let z = replace_pm(D[1], E, O);
    return I === 0 ? z : ["-", z];
  }
  let F = [D[0]];
  for (let I = 1; I < D.length; I++) F.push(replace_pm(D[I], E, O));
  return F;
}
var transformation_exports = __exportAll({ expand: () => expand, expand_relations: () => expand_relations, get_component: () => get_component, perform_matrix_multiplications: () => perform_matrix_multiplications, perform_matrix_scalar_multiplications: () => perform_matrix_scalar_multiplications, perform_vector_scalar_multiplications: () => perform_vector_scalar_multiplications, substitute: () => substitute, substitute_component: () => substitute_component }), textToAst$3 = new textToAst$4();
function expand(D, E) {
  var O = get_tree(D);
  O = perform_matrix_multiplications(O), O = perform_vector_matrix_additions_scalar_multiplications(O);
  let F = (L) => !Array.isArray(L) || !["d", "*"].includes(L[0]) || L[0] === "*" && L.slice(1).every((q) => !Array.isArray(q) || q[0] !== "d"), I = (L) => F(L) && !contains_pm(L), z = (L) => !contains_pm(L);
  var R = [];
  return R.push([textToAst$3.convert("a*(b+c)"), textToAst$3.convert("a*b+a*c"), { variables: { a: I, b: !0, c: !0 }, allow_extended_match: !0 }]), R.push([textToAst$3.convert("(a+b)*c"), textToAst$3.convert("a*c+b*c"), { variables: { a: !0, b: !0, c: I }, allow_extended_match: !0 }]), E || R.push([textToAst$3.convert("(a+b)/c"), textToAst$3.convert("a/c+b/c"), { variables: { a: !0, b: !0, c: z } }]), R.push([textToAst$3.convert("-(a+b)"), textToAst$3.convert("-a-b")]), R.push([textToAst$3.convert("a(-b)"), textToAst$3.convert("-ab")]), R.push([textToAst$3.convert("(a+b)^2"), textToAst$3.convert("a^2+2ab+b^2"), { variables: { a: z, b: z } }]), R.push([textToAst$3.convert("(a+b)^3"), textToAst$3.convert("a^3+3a^2b+3ab^2+b^3"), { variables: { a: z, b: z } }]), R.push([textToAst$3.convert("(a+b)^4"), textToAst$3.convert("a^4+4a^3b+6a^2b^2+4ab^3+b^4"), { variables: { a: z, b: z } }]), R.push([textToAst$3.convert("a*(b+c)*d"), textToAst$3.convert("(a*b+a*c)*d"), { variables: { a: z, b: !0, c: !0, d: !0 } }]), O = applyAllTransformations(O, R, 20), O = flatten$5(O), O = evaluate_numbers(O), O = collect_like_terms_factors(O), O = normalize_negatives(O), O;
}
function perform_matrix_multiplications(D, E = !0, O = !0) {
  var F = get_tree(D);
  function I(Z, V) {
    let G = Z[1][1], W = Z[1][2], J = V[1][2];
    if (V[1][1] !== W) return { success: !1 };
    let X = Z[2], Y = V[2], ee = ["tuple"];
    for (let K = 0; K < G; K++) {
      let te = X[K + 1].slice(1), ie = ["tuple"];
      for (let ne = 0; ne < J; ne++) {
        let ae = Y.slice(1).map((oe) => oe[ne + 1]);
        if (te.length !== W || ae.length !== W) return subtree;
        let ue = ["+", ...te.map((oe, se) => ["*", oe, ae[se]])];
        ie.push(ue);
      }
      ee.push(ie);
    }
    return { success: !0, newMatrix: ["matrix", ["tuple", G, J], ee] };
  }
  function z(Z, V) {
    if (!Number.isInteger(V) || V < 1) return { success: !1 };
    if (V === 1) return { success: !0, newMatrix: Z };
    let G = Z[1][1];
    if (Z[1][2] !== G) return { success: !1 };
    let W = Z[2], J = JSON.parse(JSON.stringify(W));
    for (let X = 1; X < V; X++) {
      let Y = J;
      J = ["tuple"];
      for (let ee = 0; ee < G; ee++) {
        let K = Y[ee + 1].slice(1), te = ["tuple"];
        for (let ie = 0; ie < G; ie++) {
          let ne = W.slice(1).map((ue) => ue[ie + 1]);
          if (K.length !== G || ne.length !== G) return subtree;
          let ae = ["+", ...K.map((ue, oe) => ["*", ue, ne[oe]])];
          te.push(ae);
        }
        J.push(te);
      }
    }
    return { success: !0, newMatrix: ["matrix", ["tuple", G, G], J] };
  }
  function R(Z, V) {
    let G = Z[1][1], W = Z[1][2], J = Z[2], X = ["tuple"];
    for (let Y = 0; Y < G; Y++) {
      let ee = ["tuple"], K = J[Y + 1];
      for (let te = 0; te < W; te++) ee.push(["*", V, K[te + 1]]);
      X.push(ee);
    }
    return ["matrix", ["tuple", G, W], X];
  }
  function L() {
    let Z = ["^", ["matrix", "size", "matrixData"], "p"], V = { variables: { p: (G) => Number.isInteger(G) && G > 0, size: !0, matrixData: !0 } };
    F = transform(F, function(G) {
      let W = match$1(G, Z, V);
      if (W) {
        let J = z(["matrix", W.size, W.matrixData], W.p);
        return J.success ? J.newMatrix : G;
      } else return G;
    });
  }
  function q() {
    let Z = ["*", "a", ["matrix", "size", "matrixData"], "b"], V = { variables: { a: !0, b: !0, size: !0, matrixData: !0 }, allow_implicit_identities: ["a", "b"] };
    F = transform(F, function(G) {
      let W = match$1(G, Z, V);
      if (W) {
        let J = ["matrix", W.size, W.matrixData], X = [], Y = [];
        Array.isArray(W.a) && W.a[0] === "*" ? X.push(...W.a.slice(1)) : X.push(W.a), Array.isArray(W.b) && W.b[0] === "*" ? Y.push(...W.b.slice(1)) : Y.push(W.b);
        let ee = X.length;
        for (let K = ee - 1; K >= 0; K--) {
          let te = X[K][0];
          if (te === "matrix") {
            let ie = I(X[K], J);
            if (ie.success) J = ie.newMatrix, X.pop();
            else break;
          } else {
            if (["tuple", "list", "vector", "altvector", "interval", "set", "array"].includes(te)) break;
            X[K] !== 1 && (J = R(J, X[K])), X.pop();
          }
        }
        for (; Y.length > 0; ) {
          let K = Y[0][0];
          if (K === "matrix") {
            let te = I(J, Y[0]);
            if (te.success) J = te.newMatrix, Y.splice(0, 1);
            else break;
          } else {
            if (["tuple", "list", "vector", "altvector", "interval", "set", "array"].includes(K)) break;
            Y[0] !== 1 && (J = R(J, Y[0])), Y.splice(0, 1);
          }
        }
        return X.length > 0 || Y.length > 0 ? ["*", ...X, J, ...Y] : J;
      } else return G;
    });
  }
  function U() {
    let Z = ["*", ["matrix", ["tuple", "m", "n"], "matrixData"], "b"], V = { variables: { n: Number.isInteger, m: Number.isInteger, matrixData: !0, b: !0 } };
    F = transform(F, function(G) {
      let W = match$1(G, Z, V);
      if (W) {
        let J = W.m, X = W.n, Y = W.b, ee = W.matrixData, K = [];
        E && (K.push("vector"), K.push("altvector")), O && K.push("tuple");
        let te, ie = [];
        if (K.includes(Y[0])) te = Y;
        else if (Array.isArray(Y) && Y[0] === "*" && K.includes(Y[1][0])) te = Y[1], ie = Y.slice(2);
        else return G;
        let ne = te.slice(1);
        if (ne.length !== X) return G;
        let ae = [te[0]];
        for (let ue = 0; ue < J; ue++) {
          let oe = ["+", ...ee[ue + 1].slice(1).map((se, le) => ["*", se, ne[le]])];
          ae.push(oe);
        }
        return ie.length > 0 ? ["*", ae, ...ie] : ae;
      } else return G;
    });
  }
  return L(), q(), (E || O) && U(), F;
}
function perform_vector_scalar_multiplications(D, E = !0) {
  var O = get_tree(D);
  let F = function(I, z) {
    let R = ["*", "a", [z, "vectorData"], "b"], L = { allow_implicit_identities: ["a", "b"] };
    return I = transform(I, function(q) {
      let U = match$1(q, R, L);
      if (U) {
        if (U.a === 1 && U.b === 1) return q;
        let Z = U.vectorData;
        Z = Array.isArray(Z) && Z[0] === z ? Z.slice(1) : [Z];
        let V = [], G = [];
        Array.isArray(U.a) && U.a[0] === "*" ? V.push(...U.a.slice(1)) : V.push(U.a), Array.isArray(U.b) && U.b[0] === "*" ? G.push(...U.b.slice(1)) : G.push(U.b);
        let W = V.length;
        for (let X = W - 1; X >= 0; X--) {
          let Y = V[X][0];
          if (["tuple", "list", "vector", "altvector", "interval", "set", "array", "matrix"].includes(Y)) break;
          V[X] !== 1 && (Z = Z.map((ee) => ["*", ee, V[X]])), V.pop();
        }
        for (; G.length > 0; ) {
          let X = G[0][0];
          if (["tuple", "list", "vector", "altvector", "interval", "set", "array", "matrix"].includes(X)) break;
          G[0] !== 1 && (Z = Z.map((Y) => ["*", Y, G[0]])), G.splice(0, 1);
        }
        let J = [z, ...Z];
        return V.length > 0 || G.length > 0 ? ["*", ...V, J, ...G] : J;
      } else return q;
    }), I;
  };
  return O = F(O, "vector"), O = F(O, "altvector"), E && (O = F(O, "tuple")), O;
}
function perform_matrix_scalar_multiplications(D) {
  var E = get_tree(D);
  let O = ["*", "a", ["matrix", "size", "matrixData"], "b"], F = { allow_implicit_identities: ["a", "b"] };
  return E = transform(E, function(I) {
    let z = match$1(I, O, F);
    if (z) {
      if (z.a === 1 && z.b === 1) return I;
      let R = z.matrixData, L = [], q = [];
      Array.isArray(z.a) && z.a[0] === "*" ? L.push(...z.a.slice(1)) : L.push(z.a), Array.isArray(z.b) && z.b[0] === "*" ? q.push(...z.b.slice(1)) : q.push(z.b);
      let U = L.length;
      for (let V = U - 1; V >= 0; V--) {
        let G = L[V][0];
        if (["tuple", "list", "vector", "altvector", "interval", "set", "array", "matrix"].includes(G)) break;
        L[V] !== 1 && (R = R.map((W) => W === "tuple" ? W : W.map((J) => J === "tuple" ? J : ["*", J, L[V]]))), L.pop();
      }
      for (; q.length > 0; ) {
        let V = q[0][0];
        if (["tuple", "list", "vector", "altvector", "interval", "set", "array", "matrix"].includes(V)) break;
        q[0] !== 1 && (R = R.map((G) => G === "tuple" ? G : G.map((W) => W === "tuple" ? W : ["*", W, q[0]]))), q.splice(0, 1);
      }
      let Z = ["matrix", z.size, R];
      return L.length > 0 || q.length > 0 ? ["*", ...L, Z, ...q] : Z;
    } else return I;
  }), E;
}
function expand_relations(D) {
  return transform(get_tree(D), expand_relations_transform);
}
function expand_relations_transform(D) {
  if (!Array.isArray(D)) return D;
  var E = D[0], O = D.slice(1);
  if (E === "=") {
    if (O.length <= 2) return D;
    let F = ["and"];
    for (let I = 0; I < O.length - 1; I++) F.push(["=", O[I], O[I + 1]]);
    return F;
  }
  if (E === "gts" || E === "lts") {
    let F = O[0], I = O[1];
    if (F[0] !== "tuple" || I[0] !== "tuple") throw Error("Badly formed ast");
    let z = [];
    for (let L = 1; L < F.length - 1; L++) {
      let q;
      q = I[L] ? E === "lts" ? "<" : ">" : E === "lts" ? "le" : "ge", z.push([q, F[L], F[L + 1]]);
    }
    let R = ["and", z[0], z[1]];
    for (let L = 2; L < z.length; L++) R = ["and", R, z[L]];
    return R;
  }
  if (E === "in" || E === "notin" || E === "ni" || E === "notni") {
    let F = !1;
    (E === "notin" || E === "notni") && (F = !0);
    let I, z;
    if (E === "in" || E === "notin" ? (I = O[0], z = O[1]) : (I = O[1], z = O[0]), z = to_intervals(z), z[0] !== "interval") return D;
    let R = z[1], L = z[2];
    if (R[0] !== "tuple" || L[0] !== "tuple") throw Error("Badly formed ast");
    let q = R[1], U = R[2], Z = [];
    L[1] ? F ? Z.push(["<", I, q]) : Z.push(["ge", I, q]) : F ? Z.push(["le", I, q]) : Z.push([">", I, q]), L[2] ? F ? Z.push([">", I, U]) : Z.push(["le", I, U]) : F ? Z.push(["ge", I, U]) : Z.push(["<", I, U]);
    let V;
    return V = F ? ["or"].concat(Z) : ["and"].concat(Z), V;
  }
  if (E === "subset" || E === "notsubset" || E === "superset" || E === "notsuperset") {
    let F = !1;
    (E === "notsubset" || E === "notsuperset") && (F = !0);
    let I, z;
    if (E === "subset" || E === "notsubset" ? (I = O[0], z = O[1]) : (I = O[1], z = O[0]), I = to_intervals(I), z = to_intervals(z), I[0] !== "interval" || z[0] !== "interval") return D;
    let R = I[1], L = I[2], q = z[1], U = z[2];
    if (R[0] !== "tuple" || L[0] !== "tuple" || q[0] !== "tuple" || U[0] !== "tuple") throw Error("Badly formed ast");
    let Z = R[1], V = R[2], G = q[1], W = q[2], J = [];
    L[1] && !U[1] ? F ? J.push(["le", Z, G]) : J.push([">", Z, G]) : F ? J.push(["<", Z, G]) : J.push(["ge", Z, G]), L[2] && !U[2] ? F ? J.push(["ge", V, W]) : J.push(["<", V, W]) : F ? J.push([">", V, W]) : J.push(["le", V, W]);
    let X;
    return X = F ? ["or"].concat(J) : ["and"].concat(J), X;
  }
  return D;
}
function substitute(D, E) {
  var O = get_tree(D), F = {};
  for (let I in E) F[I] = get_tree(E[I]);
  return substitute$1(O, F);
}
function substitute_component(D, E, O) {
  let F = get_tree(D);
  if (get_tree(O), typeof E == "number") E = [E];
  else if (!Array.isArray(E)) throw Error("Invalid substitute_component: " + E);
  let I = ["list", "tuple", "vector", "altvector", "array"];
  return z(F, E);
  function z(R, L, q) {
    if (L.length === 0) return O;
    if (!Array.isArray(R)) throw Error("Invalid substitute_component: expected list, tuple, vector, or array");
    let U = R[0], Z = R.slice(1);
    if (!I.includes(U)) throw Error("Invalid substitute_component: expected list, tuple, vector, or array");
    let V = L[0];
    if (V < 0 || V > Z.length - 1) throw Error("Invalid substitute_component: component out of range");
    let G = L.slice(1), W = z(Z[V], G);
    return [U, ...Z.slice(0, V), W, ...Z.slice(V + 1)];
  }
}
function get_component(D, E) {
  let O = get_tree(D);
  if (typeof E == "number") E = [E];
  else if (!Array.isArray(E)) throw Error("Invalid get_component: " + E);
  let F = ["list", "tuple", "vector", "altvector", "array"];
  return I(O, E);
  function I(z, R) {
    if (R.length === 0) return z;
    if (!Array.isArray(z)) throw Error("Invalid get_component: expected list, tuple, vector, or array");
    let L = z[0], q = z.slice(1);
    if (!F.includes(L)) throw Error("Invalid get_component: expected list, tuple, vector, or array");
    let U = R[0];
    if (U < 0 || U > q.length - 1) throw Error("Invalid get_component: component out of range");
    let Z = R.slice(1);
    return I(q[U], Z);
  }
}
function apply_root(D, E) {
  return E === 2 ? ["apply", "sqrt", D] : E === 3 ? ["apply", "cbrt", D] : ["apply", "nthroot", ["tuple", D, E]];
}
function pull_number_outside_root(D, E = 2) {
  let O = D, F = 1, I = 2, z = mathjs_default.pow(I, E);
  for (; z <= Math.abs(O); ) O % z === 0 ? (O /= z, F *= I) : (I++, z = mathjs_default.pow(I, E));
  return { n_outside: F, n_inside: O };
}
function make_power(D, E) {
  return E === 0 ? 1 : E === 1 ? D : ["^", D, E];
}
function collect_radicand_factors(D, E) {
  let O = 1, F = (I) => {
    if (Array.isArray(I) && I[0] === "*") for (let z of I.slice(1)) F(z);
    else Array.isArray(I) && I[0] === "-" ? (O = -O, F(I[1])) : typeof I == "number" && I < 0 ? (O = -O, E.push(-I)) : E.push(I);
  };
  return F(D), O;
}
function combine_factors(D, E) {
  let O = 1, F = /* @__PURE__ */ new Map(), I = /* @__PURE__ */ new Map(), z = [], R = [];
  for (let L of D) {
    if (typeof L == "number") {
      O *= L;
      continue;
    }
    let q, U;
    if (typeof L == "string") q = L, U = 1;
    else if (Array.isArray(L) && L[0] === "^" && typeof L[1] == "string" && Number.isInteger(L[2])) q = L[1], U = L[2];
    else {
      R.push(L);
      continue;
    }
    if (I.has(q) || I.set(q, is_nonzero_ast(q, E) === !0), U < 1 && !I.get(q)) {
      R.push(L);
      continue;
    }
    F.has(q) ? F.set(q, F.get(q) + U) : (z.push(q), F.set(q, U));
  }
  return { numberFactor: O, expByVar: F, varOrder: z, others: R };
}
function pull_factor_into_root(D, E, O, F, I, z) {
  let R = E >= 1 ? Math.floor(E / O) : 0;
  if (R === 0) {
    z.push(make_power(D, E));
    return;
  }
  let L;
  if (is_positive_ast(D, F, !1)) L = D;
  else if (O % 2 == 1 && is_real_ast(D, F)) L = D;
  else if (O % 2 == 0 && is_real_ast(D, F)) L = R % 2 == 0 ? D : ["apply", "abs", D];
  else {
    z.push(make_power(D, E));
    return;
  }
  I.push(make_power(L, R)), z.push(make_power(D, E % O));
}
function simplify_powers_in_roots(D, E) {
  if (!Array.isArray(D)) return D;
  var O = D[0], F = D.slice(1);
  if (O === "*") {
    let I = [];
    for (let Z of F) {
      let V = simplify_powers_in_roots(Z, E);
      Array.isArray(V) && V[0] === "*" ? I.push(...V.slice(1)) : I.push(V);
    }
    let { numberFactor: z, expByVar: R, varOrder: L, others: q } = combine_factors(I, E), U = [];
    z !== 1 && U.push(z);
    for (let Z of L) {
      let V = make_power(Z, R.get(Z));
      V !== 1 && U.push(V);
    }
    return U.push(...q), U.length === 0 ? 1 : U.length === 1 ? U[0] : ["*", ...U];
  }
  if (O === "apply" && ["sqrt", "cbrt", "nthroot"].includes(F[0])) {
    let I = F[0], z = 2, R = F[1];
    if (I === "cbrt") z = 3;
    else if (I === "nthroot") if (Array.isArray(F[1]) && F[1][0] === "tuple") if (Number.isInteger(F[1][2]) && F[1][2] > 0) z = F[1][2], R = F[1][1];
    else return ["apply", "nthroot", ...F.slice(1).map((K) => simplify_powers_in_roots(K, E))];
    else z = 2;
    R = simplify_powers_in_roots(R, E);
    let L = [], q = collect_radicand_factors(R, L), { numberFactor: U, expByVar: Z, varOrder: V, others: G } = combine_factors(L, E);
    if (U === 0) return 0;
    let W = [], J = [];
    if (Number.isInteger(U)) {
      let { n_outside: K, n_inside: te } = pull_number_outside_root(U, z);
      K !== 1 && W.push(K), te !== 1 && J.push(te);
    } else U !== 1 && J.push(U);
    for (let K of V) pull_factor_into_root(K, Z.get(K), z, E, W, J);
    for (let K of G) Array.isArray(K) && K[0] === "^" && Number.isInteger(K[2]) ? pull_factor_into_root(K[1], K[2], z, E, W, J) : J.push(K);
    let X = J.filter((K) => K !== 1), Y;
    if (X.length === 0) Y = q < 0 ? -1 : 1;
    else {
      let K = X.length === 1 ? X[0] : ["*", ...X];
      Y = q < 0 ? ["-", K] : K;
    }
    let ee = W.filter((K) => K !== 1);
    return Y !== 1 && ee.push(apply_root(Y, z)), ee.length === 0 ? 1 : ee.length === 1 ? ee[0] : ["*", ...ee];
  }
  return [O, ...F.map((I) => simplify_powers_in_roots(I, E))];
}
var simplify_exports = __exportAll({ add_unit: () => add_unit, clean: () => clean, collapse_unary_minus: () => collapse_unary_minus, collect_like_terms_factors: () => collect_like_terms_factors, default_order: () => default_order, evaluate_numbers: () => evaluate_numbers, perform_vector_matrix_additions_scalar_multiplications: () => perform_vector_matrix_additions_scalar_multiplications, remove_scaling_units: () => remove_scaling_units, remove_units: () => remove_units, set_small_zero: () => set_small_zero, simplify: () => simplify, simplify_logical: () => simplify_logical, simplify_ratios: () => simplify_ratios });
function clean(D) {
  return flatten$5(get_tree(D));
}
function evalf(D, E) {
  return parseFloat(mathjs_default.format(D, { notation: "exponential", precision: E }));
}
function collapse_unary_minus(D) {
  var E = get_tree(D);
  if (!Array.isArray(E)) return E;
  var O = E[0], F = E.slice(1);
  if (F = F.map((I) => collapse_unary_minus(I)), O === "-") {
    if (typeof F[0] == "number") return -F[0];
    if (Array.isArray(F[0]) && F[0][0] === "*" && typeof F[0][1] == "number") return ["*", -F[0][1]].concat(F[0].slice(2));
    if (Array.isArray(F[0]) && F[0][0] === "/") {
      if (typeof F[0][1] == "number") return ["/", -F[0][1], F[0][2]];
      if (Array.isArray(F[0][1]) && F[0][1][0] === "*" && typeof F[0][1][1] == "number") return ["/", ["*", -F[0][1][1]].concat(F[0][1].slice(2)), F[0][2]];
    }
  }
  return [O].concat(F);
}
function simplify(D, E, O) {
  var F = get_tree(D);
  return contains_blank(F) || (E === void 0 && D.context !== void 0 && D.context.get_assumptions !== void 0 && (E = D.context.get_assumptions([D.variables()])), F = evaluate_numbers(F, { assumptions: E, max_digits: O, evaluate_functions: !0 }), !Array.isArray(F)) || (F = simplify_logical(F, E), F = perform_vector_matrix_additions_scalar_multiplications(F), F = simplify_integers_in_roots(F), F = collect_like_terms_factors(F, E, O)), F;
}
function simplify_logical(D, E) {
  var O = get_tree(D);
  if (contains_blank(O)) return O;
  E === void 0 && D.context !== void 0 && D.context.get_assumptions !== void 0 && (E = D.context.get_assumptions([D.variables()])), O = evaluate_numbers(O, { assumptions: E }), O = unflattenRight(O);
  var F = [];
  return F.push([["not", ["not", "a"]], "a"]), F.push([["not", ["and", "a", "b"]], ["or", ["not", "a"], ["not", "b"]]]), F.push([["not", ["or", "a", "b"]], ["and", ["not", "a"], ["not", "b"]]]), F.push([["not", ["=", "a", "b"]], ["ne", "a", "b"]]), F.push([["not", ["ne", "a", "b"]], ["=", "a", "b"]]), F.push([["not", ["<", "a", "b"]], ["le", "b", "a"]]), F.push([["not", ["le", "a", "b"]], ["not", ["le", "a", "b"]]]), F.push([["not", ["in", "a", "b"]], ["notin", "a", "b"]]), F.push([["not", ["subset", "a", "b"]], ["notsubset", "a", "b"]]), O = applyAllTransformations(O, F, 20), O = flatten$5(O), O;
}
function simplify_integers_in_roots(D) {
  if (!Array.isArray(D)) return D;
  var E = D[0], O = D.slice(1);
  if (E === "*") {
    let F = 1, I = [];
    for (let z of O) if (typeof z == "number") F *= z;
    else {
      let R = simplify_integers_in_roots(z);
      Array.isArray(R) && R[0] === "*" ? typeof R[1] == "number" ? (F *= R[1], I.push(...R.slice(2))) : I.push(...R.slice(1)) : I.push(R);
    }
    return F !== 1 && I.unshift(F), ["*", ...I];
  }
  if (E === "apply" && ["sqrt", "cbrt", "nthroot"].includes(O[0])) {
    let F = O[0], I = 2, z = O[1];
    if (F === "cbrt") I = 3;
    else if (F === "nthroot") if (Array.isArray(O[1]) && O[1][0] === "tuple") if (Number.isInteger(O[1][2]) && O[1][2] > 0) I = O[1][2], z = O[1][1];
    else return ["apply", "nthroot", ...O.slice(1).map(simplify_integers_in_roots)];
    else I = 2;
    if (z = simplify_integers_in_roots(z), Number.isInteger(z)) {
      let { n_outside: R, n_inside: L } = pull_number_outside_root(z, I);
      if (R !== 1) return ["*", R, apply_root(L, I)];
    } else if (Array.isArray(z) && z[0] === "*" && typeof z[1] == "number") {
      let { n_outside: R, n_inside: L } = pull_number_outside_root(z[1], I);
      if (R !== 1) return ["*", R, apply_root(["*", L, ...z.slice(2)], I)];
    }
    return apply_root(z, I);
  }
  return [E, ...O.map(simplify_integers_in_roots)];
}
function perform_vector_matrix_additions_scalar_multiplications(D, E = !0) {
  var O = get_tree(D);
  O = perform_matrix_scalar_multiplications(O), O = perform_vector_scalar_multiplications(O, E);
  let F = ["+", "a", "b"];
  return O = transform(O, function(I) {
    let z = match$1(I, F, { allow_permutations: !0 });
    if (z) {
      let R = ["vector", "altvector"];
      E && R.push("tuple");
      let L = {}, q = {}, U = [];
      if (R.includes(z.a[0])) {
        let V = z.a.length - 1;
        L[V] || (L[V] = []), L[V].push(z.a);
      } else if (z.a[0] === "matrix") {
        let V = z.a[1].slice(1).toString();
        q[V] || (q[V] = []), q[V].push(z.a);
      } else U.push(z.a);
      if (R.includes(z.b[0])) {
        let V = z.b.length - 1;
        L[V] || (L[V] = []), L[V].push(z.b);
      } else if (z.b[0] === "matrix") {
        let V = z.b[1].slice(1).toString();
        q[V] || (q[V] = []), q[V].push(z.b);
      } else if (z.b[0] === "+") for (let V of z.b.slice(1)) if (R.includes(V[0])) {
        let G = V.length - 1;
        L[G] || (L[G] = []), L[G].push(V);
      } else if (V[0] === "matrix") {
        let G = V[1].slice(1).toString();
        q[G] || (q[G] = []), q[G].push(V);
      } else U.push(V);
      else U.push(z.b);
      if (Object.values(L).every((V) => V.length < 2) && Object.values(q).every((V) => V.length < 2)) return I;
      let Z = U;
      for (let V in L) if (L[V].length < 2) Z.push(...L[V]);
      else {
        let G = L[V].some((Y) => Y[0] === "vector"), W = L[V].some((Y) => Y[0] === "tuple"), J = L[V].some((Y) => Y[0] === "altvector"), X;
        X = G || W && J ? ["vector"] : J ? ["altvector"] : ["tuple"];
        for (let Y = 0; Y < V; Y++) X.push(["+", ...L[V].map((ee) => ee[Y + 1])]);
        Z.push(X);
      }
      for (let V in q) if (q[V].length < 2) Z.push(...q[V]);
      else {
        let [G, W] = V.split(",").map(Number), J = ["tuple"];
        for (let Y = 0; Y < G; Y++) {
          let ee = ["tuple"];
          for (let K = 0; K < W; K++) ee.push(["+", ...q[V].map((te) => te[2][Y + 1][K + 1])]);
          J.push(ee);
        }
        let X = ["matrix", ["tuple", G, W], J];
        Z.push(X);
      }
      return Z.length === 1 ? Z[0] : ["+", ...Z];
    } else return I;
  }), O;
}
function contains_decimal_number(D) {
  return typeof D == "string" ? !1 : typeof D == "number" ? !!(Number.isFinite(D) && !Number.isInteger(D)) : Array.isArray(D) ? D.slice(1).some((E) => contains_decimal_number(E)) : !1;
}
function contains_only_numbers(D, { include_number_symbols: E = !1, evaluate_functions: O = !1 } = {}) {
  return typeof D == "string" ? !!(E && (D === "e" && mathjs_default.define_e || D === "pi" && mathjs_default.define_pi) || D === "i" && mathjs_default.define_i) : typeof D == "number" ? !0 : Array.isArray(D) ? O && D[0] === "apply" ? D.slice(2).every((F) => contains_only_numbers(F, { include_number_symbols: E })) : D.slice(1).every((F) => contains_only_numbers(F, { include_number_symbols: E })) : !1;
}
function try_evaluate_sum_of_numbers(D, E, O) {
  if (typeof D == "number") {
    if (D === 0) return E;
    if (typeof E == "number") return D + E;
    if (Array.isArray(E) && E[0] === "+" && typeof E[1] == "number") return ["+", D + E[1], E[2]];
    if (!O && Array.isArray(E) && E[0] === "+" && typeof E[2] == "number") return ["+", D + E[2], E[1]];
  }
  return typeof E == "number" && E === 0 ? D : null;
}
function try_evaluate_negate_number(D) {
  if (typeof D == "number") return -D;
  if (Array.isArray(D) && D[0] === "*" && typeof D[1] == "number") return ["*", -D[1]].concat(D.slice(2));
  if (Array.isArray(D) && D[0] === "/") {
    if (typeof D[1] == "number") return ["/", -D[1], D[2]];
    if (Array.isArray(D[1]) && D[1][0] === "*" && typeof D[1][1] == "number") return ["/", ["*", -D[1][1]].concat(D[1].slice(2)), D[2]];
  }
  return null;
}
function try_evaluate_product_of_numbers(D, E) {
  if (typeof D == "number") {
    if (isNaN(D)) return NaN;
    if (typeof E == "number") return D * E;
    if (!isFinite(D)) return D === 1 / 0 && is_negative_ast(E) || D === -1 / 0 && is_positive_ast(E) ? -1 / 0 : is_nonzero_ast(E) === !1 ? NaN : 1 / 0;
    if (D === 0) return 0;
    if (D === 1) return E;
    if (D === -1) return ["-", E];
    if (Array.isArray(E) && E[0] === "*" && typeof E[1] == "number") return D *= E[1], E = E[2], D === 1 ? E : D === -1 ? ["-", E] : ["*", D, E];
  }
  if (typeof E == "number") {
    if (isNaN(E)) return NaN;
    if (!isFinite(E)) return E === 1 / 0 && is_negative_ast(D) || E === -1 / 0 && is_positive_ast(D) ? -1 / 0 : is_nonzero_ast(D) === !1 ? NaN : 1 / 0;
    if (E === 0) return 0;
    if (E === 1) return D;
    if (E === -1) return ["-", D];
    if (Array.isArray(D) && D[0] === "*" && typeof D[1] == "number") return E *= D[1], D = D[2], E === 1 ? D : E === -1 ? ["-", D] : ["*", D, E];
  }
  if (mathjs_default.define_i && D === "i") {
    if (E === "i") return -1;
    if (Array.isArray(E) && E[0] === "*" && E[1] === "i") return ["-", E[2]];
  } else if (mathjs_default.define_i && E === "i" && Array.isArray(D) && D[0] === "*" && D[1] === "i") return ["-", D[2]];
  return null;
}
function try_evaluate_quotient_of_numbers(D, E, O, F) {
  if (typeof D == "number") {
    if (D === 0) {
      let I = is_nonzero_ast(E, O);
      if (I) return 0;
      if (I === !1) return NaN;
    }
    if (typeof E == "number") {
      let I = D / E;
      if (F === 1 / 0 || mathjs_default.round(I, F) === I) return I;
      if (E < 0) return ["/", -D, -E];
    }
    if (Array.isArray(E) && E[0] === "*" && typeof E[1] == "number") {
      let I = D / E[1];
      if (F === 1 / 0 || mathjs_default.round(I, F) === I) return ["/", I, E[2]];
    }
  } else if (typeof E == "number") {
    if (Array.isArray(D) && D[0] === "*" && typeof D[1] == "number") {
      let z = D[1] / E;
      if (F === 1 / 0 || mathjs_default.round(z, F) === z) return z === 1 ? D[2] : ["*", z, D[2]];
      if (E < 0) return ["/", ["*", -D[1], D[2]], -E];
    }
    let I = 1 / E;
    if (F === 1 / 0 || mathjs_default.round(I, F) === I) return ["*", I, D];
    if (E < 0) return Array.isArray(D) && D[0] === "-" ? ["/", D[1], -E] : ["-", ["/", D, -E]];
  }
  return null;
}
function set_small_zero(D, E = 1e-14) {
  var O = get_tree(D);
  return typeof O == "number" ? mathjs_default.abs(O) < E ? 0 : O : Array.isArray(O) ? [O[0], ...O.slice(1).map((F) => set_small_zero(F, E))] : O;
}
function evaluate_numbers_sub(D, E, O, F, I, z) {
  if (D === void 0) return D;
  if (typeof D == "number") return z > 0 && mathjs_default.abs(D) < z ? 0 : D;
  if (contains_only_numbers(D, { include_number_symbols: !0, evaluate_functions: I })) {
    let U = function(Z) {
      if (z > 0 && mathjs_default.abs(Z) < z) return 0;
      if (O === 1 / 0 || Number.isInteger(Z)) return Z;
      let V = evalf(Z, 14), G = evalf(Z, O);
      if (O === 0 && (G = mathjs_default.round(Z)), G === V || contains_decimal_number(D) && contains_only_numbers(D, { include_number_symbols: !0, evaluate_functions: I })) return Z;
      let W = mathjs_default.fraction(Z), J = { n: mathjs_default.number(W.n), d: mathjs_default.number(W.d), s: mathjs_default.number(W.s) }, X = evalf(J.d, 3);
      return (J.n < 1e4 || X === J.d) && evalf(J.s * J.n / J.d, 14) === V ? J.d === 1 ? J.s * J.n : ["/", J.s * J.n, J.d] : null;
    };
    var R = evaluate_to_constant(D, { remove_units_first: !1 });
    if (!Number.isNaN(R)) {
      if (typeof R == "number") {
        if (Number.isFinite(R)) {
          let Z = U(R);
          if (Z !== null) return Z;
        }
      } else if (R && Number.isFinite(R.re) && Number.isFinite(R.im)) {
        let Z = U(R.re), V = U(R.im);
        if (Z !== null && V !== null) {
          if (V === 0) return Z;
          {
            let G;
            return G = V === 1 ? "i" : V === -1 ? ["-", "i"] : ["*", V, "i"], Z === 0 ? G : ["+", Z, G];
          }
        }
      }
    }
  }
  if (!Array.isArray(D)) return D;
  var L = D[0], q = D.slice(1).map((U) => evaluate_numbers_sub(U, E, O, F, I, z));
  if (L === "+") {
    let U = q[0], Z = q[1];
    if (Z === void 0) return U;
    let V = try_evaluate_sum_of_numbers(U, Z, F);
    if (V !== null) return V;
    if (U[0] === "unit" && Z[0] === "unit") {
      let G = get_unit_of_tree(U), W = get_unit_of_tree(Z);
      if (G && G === W) {
        let J = try_evaluate_sum_of_numbers(remove_units(U, !1), remove_units(Z, !1), F);
        if (J !== null) return add_unit(J, G);
      }
    }
    return [L].concat(q);
  }
  if (L === "-") {
    let U = try_evaluate_negate_number(q[0]);
    if (U !== null) return U;
    if (q[0][0] === "unit") {
      let Z = get_unit_of_tree(q[0]);
      if (Z) {
        let V = try_evaluate_negate_number(remove_units(q[0], !1));
        if (V !== null) return add_unit(V, Z);
      }
    }
    return [L].concat(q);
  }
  if (L === "*") {
    let U = q[0], Z = q[1];
    if (Z === void 0) return U;
    let V = try_evaluate_product_of_numbers(U, Z);
    if (V !== null) return V;
    if (U[0] === "unit" && Z[0] !== "unit") {
      let G = get_unit_of_tree(U);
      if (G) {
        let W = try_evaluate_product_of_numbers(remove_units(U, !1), Z);
        if (W !== null) return add_unit(W, G);
      }
    }
    if (U[0] !== "unit" && Z[0] === "unit") {
      let G = get_unit_of_tree(Z);
      if (G) {
        let W = try_evaluate_product_of_numbers(U, remove_units(Z, !1));
        if (W !== null) return add_unit(W, G);
      }
    }
    return [L].concat(q);
  }
  if (L === "/") {
    let U = q[0], Z = q[1], V = try_evaluate_quotient_of_numbers(U, Z, E, O);
    if (V !== null) return V;
    if (U[0] === "unit" && Z[0] !== "unit") {
      let G = get_unit_of_tree(U);
      if (G) {
        let W = try_evaluate_quotient_of_numbers(remove_units(U, !1), Z, E, O);
        if (W !== null) return add_unit(W, G);
      }
    }
    return [L].concat(q);
  }
  if (L === "^") {
    let U = q[0], Z = q[1];
    if (typeof Z == "number")
      if (Z === 0) {
        if (!mathjs_default.pow_strict) return 1;
        let V = is_nonzero_ast(U, E);
        if (V && U !== 1 / 0 && U !== -1 / 0) return 1;
        if (V === !1) return NaN;
      } else {
        if (Z === 1) return U;
        if (typeof U == "number") {
          let V = mathjs_default.pow(U, Z);
          if (O === 1 / 0 || mathjs_default.round(V, O) === V) return V;
        }
      }
    else if (U === 1) return 1;
    return [L].concat(q);
  }
  return [L].concat(q);
}
function evaluate_numbers(D, { assumptions: E, max_digits: O, skip_ordering: F = !1, evaluate_functions: I = !1, set_small_zero: z = 0 } = {}) {
  (O === void 0 || !(Number.isInteger(O) || O === 1 / 0)) && (O = 0), z === !0 && (z = 1e-14);
  var R = get_tree(D);
  if (contains_blank(R)) return R;
  E === void 0 && D.context !== void 0 && D.context.get_assumptions !== void 0 && (E = D.context.get_assumptions([D.variables()]));
  var L;
  return F ? (R = unflattenRight(flatten$5(R)), L = evaluate_numbers_sub(R, E, O, F, I, z)) : (R = move_units_outside_products(R), R = unflattenRight(default_order(flatten$5(R))), L = default_order(evaluate_numbers_sub(R, E, O, F, I, z)), L = default_order(evaluate_numbers_sub(unflattenRight(L), E, O, F, I, z))), L = set_negative_zeros_to_zero(L), flatten$5(L);
}
function set_negative_zeros_to_zero(D) {
  return D === 0 ? 0 : Array.isArray(D) ? [D[0], ...D.slice(1).map(set_negative_zeros_to_zero)] : D;
}
function collect_like_terms_factors(D, E, O) {
  function F(U) {
    return !!(typeof U == "number" || Array.isArray(U) && U[0] === "-" && typeof U[1] == "number");
  }
  function I(U) {
    return !!(typeof U == "number" && U < 0 || Array.isArray(U) && U[0] === "-" && typeof U[1] == "number" && U > 0);
  }
  function z(U) {
    if (typeof U == "number" || Array.isArray(U) && U[0] === "-" && typeof U[1] == "number") return !0;
    var Z = evaluate_to_constant(U, { remove_units_first: !1 });
    return !!Number.isFinite(Z);
  }
  let R = (U) => !contains_pm(U);
  var L = get_tree(D);
  if (contains_blank(L)) return L;
  E === void 0 && D.context !== void 0 && D.context.get_assumptions !== void 0 && (E = D.context.get_assumptions([D.variables()])), L = evaluate_numbers(L, { assumptions: E, max_digits: O, evaluate_functions: !0 });
  var q = [];
  q.push([["/", "x", ["^", "y", "a"]], ["*", "x", ["^", "y", ["-", "a"]]], { evaluate_numbers: !0, max_digits: O }]), q.push([["/", "x", ["apply", "exp", "a"]], ["*", "x", ["apply", "exp", ["-", "a"]]], { evaluate_numbers: !0, max_digits: O, variables: { x: !0, a: !0 } }]), q.push([["/", "x", "y"], ["*", "x", ["^", "y", ["-", 1]]], { evaluate_numbers: !0, max_digits: O }]), L = applyAllTransformations(L, q, 40), q = [];
  for (let U in all_units) all_units[U].prefix ? (q.push([["+", ["unit", U, "x"], ["unit", U, "y"]], ["unit", U, ["+", "x", "y"]], { variables: { x: !0, y: !0 }, evaluate_numbers: !0, max_digits: O, allow_extended_match: !0, allow_permutations: !0, max_group: 1 }]), q.push([["+", ["unit", U, "x"], ["-", ["unit", U, "y"]]], ["unit", U, ["+", "x", ["-", "y"]]], { variables: { x: !0, y: !0 }, evaluate_numbers: !0, max_digits: O, allow_extended_match: !0, allow_permutations: !0, max_group: 1 }])) : (q.push([["+", ["unit", "x", U], ["unit", "y", U]], ["unit", ["+", "x", "y"], U], { variables: { x: !0, y: !0 }, evaluate_numbers: !0, max_digits: O, allow_extended_match: !0, allow_permutations: !0, max_group: 1 }]), q.push([["+", ["unit", "x", U], ["-", ["unit", "y", U]]], ["unit", ["+", "x", ["-", "y"]], U], { variables: { x: !0, y: !0 }, evaluate_numbers: !0, max_digits: O, allow_extended_match: !0, allow_permutations: !0, max_group: 1 }]));
  return q.push([["*", ["^", "x", "n"], ["^", "x", "m"]], ["^", "x", ["+", "n", "m"]], { variables: { x: (U) => is_nonzero_ast(U, E) && R(U), n: F, m: F }, evaluate_numbers: !0, max_digits: O, allow_implicit_identities: ["m", "n"], allow_extended_match: !0, allow_permutations: !0, max_group: 1 }]), q.push([["*", ["^", "x", "n"], ["^", "x", "m"]], ["^", "x", ["+", "n", "m"]], { variables: { x: R, n: (U) => F(U) && is_positive_ast(U, E), m: (U) => F(U) && is_positive_ast(U, E) }, evaluate_numbers: !0, max_digits: O, allow_implicit_identities: ["m", "n"], allow_extended_match: !0, allow_permutations: !0, max_group: 1 }]), q.push([["^", ["-", "x"], "n"], ["^", "x", "n"], { variables: { x: !0, n: (U) => Number.isInteger(U) && Number.isInteger(U / 2) }, evaluate_numbers: !0, max_digits: O, allow_extended_match: !0, max_group: 1 }]), q.push([["^", ["-", "x"], "n"], ["-", ["^", "x", "n"]], { variables: { x: !0, n: (U) => Number.isInteger(U) && !Number.isInteger(U / 2) }, evaluate_numbers: !0, max_digits: O, allow_extended_match: !0, max_group: 1 }]), q.push([["*", ["^", "x", "n"], ["^", "x", "m"]], ["^", "x", ["+", "n", "m"]], { variables: { x: R, n: (U) => F(U) && is_negative_ast(U, E), m: (U) => F(U) && is_negative_ast(U, E) }, evaluate_numbers: !0, max_digits: O, allow_extended_match: !0, allow_permutations: !0, max_group: 1 }]), q.push([["*", ["apply", "exp", "n"], ["apply", "exp", "m"]], ["apply", "exp", ["+", "n", "m"]], { variables: { n: F, m: F }, evaluate_numbers: !0, max_digits: O, allow_implicit_identities: ["m", "n"], allow_extended_match: !0, allow_permutations: !0, max_group: 1 }]), q.push([["+", ["*", "n", "x"], ["*", "m", "x"]], ["*", ["+", "n", "m"], "x"], { variables: { x: R, n: F, m: F }, evaluate_numbers: !0, max_digits: O, allow_implicit_identities: ["m", "n"], allow_extended_match: !0, allow_permutations: !0, max_group: 1 }]), q.push([["+", ["*", "n1", "x"], ["*", ["/", "n2", "m2"], "x"]], ["*", ["+", "n1", ["/", "n2", "m2"]], "x"], { variables: { x: R, n1: F, n2: F, m2: F }, evaluate_numbers: !0, max_digits: O, allow_implicit_identities: ["m2", "n1", "n2"], allow_extended_match: !0, allow_permutations: !0, max_group: 1 }]), q.push([["+", ["*", "n1", "x"], ["*", ["-", ["/", "n2", "m2"]], "x"]], ["*", ["+", "n1", ["-", ["/", "n2", "m2"]]], "x"], { variables: { x: R, n1: F, n2: F, m2: F }, evaluate_numbers: !0, max_digits: O, allow_implicit_identities: ["m2", "n1", "n2"], allow_extended_match: !0, allow_permutations: !0, max_group: 1 }]), q.push([["+", ["*", ["/", "n1", "m1"], "x"], ["*", ["/", "n2", "m2"], "x"]], ["*", ["+", ["/", "n1", "m1"], ["/", "n2", "m2"]], "x"], { variables: { x: R, n1: F, m1: F, n2: F, m2: F }, evaluate_numbers: !0, max_digits: O, allow_implicit_identities: ["m1", "m2", "n1", "n2"], allow_extended_match: !0, allow_permutations: !0, max_group: 1 }]), q.push([["+", ["*", ["/", "n1", "m1"], "x"], ["*", ["-", ["/", "n2", "m2"]], "x"]], ["*", ["+", ["/", "n1", "m1"], ["-", ["/", "n2", "m2"]]], "x"], { variables: { x: R, n1: F, m1: F, n2: F, m2: F }, evaluate_numbers: !0, max_digits: O, allow_implicit_identities: ["m1", "m2", "n1", "n2"], allow_extended_match: !0, allow_permutations: !0, max_group: 1 }]), q.push([["+", ["*", "n", "x"], ["-", ["*", "m", "x"]]], ["*", ["+", "n", ["-", "m"]], "x"], { variables: { x: R, n: F, m: F }, evaluate_numbers: !0, max_digits: O, allow_implicit_identities: ["m", "n"], allow_extended_match: !0, allow_permutations: !0, max_group: 1 }]), q.push([["-", ["pm", "x"]], ["pm", "x"], { variables: { x: !0 } }]), q.push([["*", "c", ["pm", "x"]], ["pm", ["*", "c", "x"]], { variables: { c: (U) => !contains_pm(U), x: !0 }, allow_extended_match: !0, allow_permutations: !0, max_group: 1 }]), q.push([["^", ["*", "x", "y"], "a"], ["*", ["^", "x", "a"], ["^", "y", "a"]], { allow_permutations: !0 }]), q.push([["^", ["^", "x", "n"], "m"], ["^", "x", ["*", "n", "m"]], { variables: { x: !0, n: F, m: F }, evaluate_numbers: !0, max_digits: O, allow_permutations: !0 }]), q.push([["-", ["+", "a", "b"]], ["+", ["-", "a"], ["-", "b"]]]), q.push([["apply", "cbrt", ["*", "a", "x"]], ["-", ["apply", "cbrt", ["-", ["*", "a", "x"]]]], { variables: { a: (U) => is_negative_ast(U, E), x: !0 }, evaluate_numbers: !0, max_digits: O, allow_implicit_identities: ["x"] }]), q.push([["apply", "cbrt", ["-", "x"]], ["-", ["apply", "cbrt", "x"]], { variables: { x: !0 }, evaluate_numbers: !0, max_digits: O, allow_implicit_identities: ["x"] }]), q.push([["apply", "nthroot", ["tuple", ["*", "a", "x"], "n"]], ["-", ["apply", "nthroot", ["tuple", ["-", ["*", "a", "x"]], "n"]]], { variables: { a: (U) => is_negative_ast(U, E), x: !0, n: (U) => Number.isInteger(U) && !Number.isInteger(U / 2) && U > 1 }, evaluate_numbers: !0, max_digits: O, allow_implicit_identities: ["x"] }]), q.push([["apply", "nthroot", ["tuple", ["-", "x"], "n"]], ["-", ["apply", "nthroot", ["tuple", "x", "n"]]], { variables: { x: !0, n: (U) => Number.isInteger(U) && !Number.isInteger(U / 2) && U > 1 }, evaluate_numbers: !0, max_digits: O, allow_implicit_identities: ["x"] }]), q.push([["^", ["apply", "abs", "x"], "n"], ["^", "x", "n"], { variables: { x: !0, n: (U) => Number.isInteger(U) && Number.isInteger(U / 2) }, evaluate_numbers: !0, max_digits: O }]), q.push([["*", "x", "y"], ["*", "x", "y"], { variables: { x: z, y: z }, evaluate_numbers: !0, max_digits: O, allow_extended_match: !0, allow_permutations: !0, max_group: 1 }]), L = applyAllTransformations(L, q, 40), L = simplify_powers_in_roots(L, E), q = [], q.push([["*", "x", ["^", "y", ["-", "a"]]], ["/", "x", ["^", "y", "a"]], { allow_extended_match: !0, allow_permutations: !0, evaluate_numbers: !0, max_digits: O, max_group: 1 }]), q.push([["*", "x", ["apply", "exp", ["-", "a"]]], ["/", "x", ["apply", "exp", "a"]], { allow_extended_match: !0, allow_permutations: !0, evaluate_numbers: !0, max_digits: O, max_group: 1, variables: { x: !0, a: !0 } }]), q.push([["*", "x", ["^", "y", "n"]], ["/", "x", ["^", "y", ["-", "n"]]], { variables: { x: !0, y: !0, n: I }, evaluate_numbers: !0, max_digits: O, allow_extended_match: !0, allow_permutations: !0, max_group: 1 }]), q.push([["*", "x", ["apply", "exp", "n"]], ["/", "x", ["apply", "exp", ["-", "n"]]], { variables: { x: !0, n: I }, evaluate_numbers: !0, max_digits: O, allow_extended_match: !0, allow_permutations: !0, max_group: 1 }]), L = applyAllTransformations(L, q, 40), q = [], q.push([["^", "y", "n"], ["/", 1, ["^", "y", ["-", "n"]]], { variables: { y: !0, n: I }, evaluate_numbers: !0, max_digits: O }]), q.push([["apply", "exp", "n"], ["/", 1, ["apply", "exp", ["-", "n"]]], { variables: { n: I }, evaluate_numbers: !0, max_digits: O }]), L = applyAllTransformations(L, q, 40), q = [], q.push([["/", ["/", "x", "y"], "z"], ["/", "x", ["*", "y", "z"]], { allow_extended_match: !0, allow_permutations: !0 }]), q.push([["/", "x", ["/", "y", "z"]], ["/", ["*", "x", "z"], "y"], { allow_extended_match: !0, allow_permutations: !0 }]), L = applyAllTransformations(L, q, 40), q = [], q.push([["*", "x", ["/", "y", "z"]], ["/", ["*", "x", "y"], "z"], { allow_extended_match: !0, allow_permutations: !0, max_group: 1 }]), q.push([["/", ["/", "x", "y"], "z"], ["/", "x", ["*", "y", "z"]], { allow_extended_match: !0, allow_permutations: !0 }]), q.push([["/", "x", ["/", "y", "z"]], ["/", ["*", "x", "z"], "y"], { allow_extended_match: !0, allow_permutations: !0 }]), L = applyAllTransformations(L, q, 40), L = evaluate_numbers(L, { assumptions: E, max_digits: O, evaluate_functions: !0 }), L;
}
function simplify_ratios(D, E) {
  function O(z) {
    var R = 1;
    return z = z.map(function(L) {
      if (typeof L == "number") return L < 0 ? (R *= -1, -L) : L;
      if (!Array.isArray(L)) return L;
      if (L[0] === "-") return R *= -1, L[1];
      if (L[0] !== "+") return L;
      var q = !1;
      if ((typeof L[1] == "number" && L[1] < 0 || Array.isArray(L[1]) && L[1][0] === "-" || Array.isArray(L[1]) && L[1][0] === "*" && Number(L[1][1]) < 0) && (q = !0), q) {
        R *= -1;
        var U = L.slice(1).map((Z) => ["-", Z]);
        return evaluate_numbers(["+"].concat(U));
      } else return L;
    }), { factors: z, sign_change: R };
  }
  function F(z, R) {
    if (!Array.isArray(z)) return R ? ["-", z] : z;
    var L = z[0];
    if (L === "-") return F(z[1], R = !0);
    var q = z.slice(1).map((X) => F(X));
    if (L !== "/") return R ? ["-", [L, ...q]] : [L, ...q];
    var U = q[0], Z = q[1];
    U = default_order(U, { ignore_negatives: !0 });
    var V = Array.isArray(U) && U[0] === "*" ? U.slice(1) : [U], G = O(V);
    V = G.factors, R && (G.sign_change *= -1), Z = default_order(Z, { ignore_negatives: !0 });
    var W = Array.isArray(Z) && Z[0] === "*" ? Z.slice(1) : [Z], J = O(W);
    return W = J.factors, G.sign_change * J.sign_change < 0 && (V[0] = ["-", V[0]]), U = V.length === 1 ? V[0] : ["*"].concat(V), Z = W.length === 1 ? W[0] : ["*"].concat(W), ["/", U, Z];
  }
  var I = get_tree(D);
  return contains_blank(I) ? I : (E === void 0 && D.context !== void 0 && D.context.get_assumptions !== void 0 && (E = D.context.get_assumptions([D.variables()])), F(I));
}
function contains_blank(D) {
  return D === "＿" ? !0 : Array.isArray(D) ? D.some(contains_blank) : !1;
}
var all_units = get_all_units();
function remove_units(D, E = !0) {
  var O = get_tree(D);
  if (!Array.isArray(O)) return O;
  let F = O[0], I = O.slice(1);
  if (F === "unit") {
    let z = all_units[get_unit_of_tree(O)];
    if (!z) return O;
    let R = remove_units(z.prefix ? I[1] : I[0], E);
    return E ? z.scale(R) : R;
  } else return [F, ...I.map((z) => remove_units(z, E))];
}
function remove_scaling_units(D) {
  var E = get_tree(D);
  if (!Array.isArray(E)) return E;
  let O = E[0], F = E.slice(1);
  if (O === "unit") {
    let I = all_units[get_unit_of_tree(E)];
    if (!(I && I.only_scales)) return E;
    let z = remove_scaling_units(I.prefix ? F[1] : F[0]);
    return I.scale(z);
  } else return [O, ...F.map((I) => remove_scaling_units(I))];
}
function add_unit(D, E) {
  var O = get_tree(D);
  let F = all_units[E];
  return F ? F.prefix ? ["unit", E, O] : ["unit", O, E] : O;
}
function move_units_outside_products(D) {
  if (!Array.isArray(D)) return D;
  let E = D[0], O = D.slice(1);
  if (E === "*") {
    let F = [], I = [];
    for (let R of O) {
      let L = get_unit_value_of_tree(R);
      L ? (F.push(L[0]), I.push(L[1])) : I.push(R);
    }
    let z = ["*", ...I];
    for (let R of F) z = add_unit(z, R);
    return z;
  } else return [E, ...O.map(move_units_outside_products)];
}
var solve_exports = __exportAll({ solve_linear: () => solve_linear });
function solve_linear(D, E, O) {
  if (typeof E == "string") {
    O === void 0 && D.context !== void 0 && D.context.get_assumptions !== void 0 && (O = D.context.get_assumptions([D.variables()]));
    var F = simplify(get_tree(D), O);
    if (Array.isArray(F)) {
      var I = F[0], z = F.slice(1);
      if (I === "=" || I === "ne" || I === "<" || I === "le" || I === ">" || I === "ge") {
        var R = simplify(["+", z[0], ["-", z[1]]], O), L = (G) => !variables(G).includes(E);
        if (R = simplify(applyAllTransformations(R, [[["+", ["*", "_a", E], ["*", "_b", E]], ["*", ["+", "_a", "_b"], E], { variables: { _a: L, _b: L }, allow_permutations: !0, allow_extended_match: !0, allow_implicit_identities: ["_a", "_b"], evaluate_numbers: !0 }]], 20)), variables(R).includes(E)) {
          var q = match$1(R, ["+", ["*", "_a", E], "_b"], { variables: { _a: L, _b: L }, allow_permutations: !0, allow_implicit_identities: ["_a", "_b"] });
          if (q) {
            var U = simplify(q._a), Z = simplify(q._b);
            if (is_nonzero_ast(U, O)) {
              if (I === "=" || I === "ne" || is_positive_ast(U, O)) {
                let G = simplify(["/", ["-", Z], U]);
                return [I, E, G];
              }
              if (is_negative_ast(U, O)) {
                var V = simplify(["/", ["-", Z], U]);
                return I = I === "<" ? ">" : I === "le" ? "ge" : I === ">" ? "<" : "le", [I, E, V];
              }
            }
          }
        }
      }
    }
  }
}
function clean_assumptions(D, E) {
  if (!Array.isArray(D) || D.length === 0) return D;
  D = flatten$5(default_order(simplify_logical(expand_relations(D))));
  var O = D[0], F = D.slice(1);
  if (O === "and" || O === "or") {
    if (F = F.reduce(function(I, z) {
      return I.every(function(R) {
        return !equal(R, z);
      }) && I.push(z), I;
    }, []), O === "and" && E && Array.isArray(E)) {
      let I;
      I = E[0] === "and" ? E.slice(1) : [E], F = F.filter((z) => I.every((R) => !equal(R, z)));
    }
    D = F.length === 1 ? F[0] : [O].concat(F);
  }
  if (O !== "and" && E && Array.isArray(E)) {
    let I;
    if (I = E[0] === "and" ? E.slice(1) : [E], !I.every((z) => !equal(z, D))) return;
  }
  return D;
}
function calculate_derived_assumptions(D, E) {
  if (E === void 0) {
    E = [];
    for (let q in D.byvar) {
      let U = D.byvar[q];
      U.length > 0 && E.push(U);
    }
    if (E.length === 0) return {};
    E = E.length === 1 ? E[0] : ["and"].concat(E), E = clean_assumptions(E);
  }
  if (!Array.isArray(E) || E.length === 0) return {};
  var O = E[0], F = E.slice(1);
  if (O === "and" || O === "or") {
    let q = F.map(function(V) {
      return calculate_derived_assumptions(D, V);
    }), U = [...new Set(q.reduce((V, G) => [...V, ...Object.keys(G)], []))], Z = {};
    for (let V of U) {
      let G = q.reduce(function(W, J) {
        return J[V] !== void 0 && W.push(J[V]), W;
      }, []);
      if (O === "and" || G.length === q.length) {
        let W = Z[V];
        W = W === void 0 ? G.length > 1 ? [O].concat(G) : G[0] : G.length > 1 ? ["and", W, [O].concat(G)] : ["and", W, G[0]], Z[V] = clean_assumptions(W, get_assumptions(D, V, { omit_derived: !0 }));
      }
    }
    return Z;
  }
  let I = {};
  if (O === "=" || O === "ne" || O === "<" || O === "le" || O === "in" || O === "subset" || O === "notin" || O === "notsubset") {
    var z = !1;
    for (let q = 0; q < 2; q++) {
      let U = F[q], Z = F[1 - q], V = variables(Z);
      if (typeof U != "string" || V.length === 0 || V.includes(U)) continue;
      z = !0;
      var R = O;
      q === 1 && (O === "<" ? R = ">" : O === "le" ? R = "ge" : O === "in" ? R = "ni" : O === "subset" ? R = "superset" : O === "notin" ? R = "notni" : O === "notsubset" && (R = "notsuperset"));
      let G = get_assumptions_for_expr(D, Z, [U]);
      if (G = combine_assumptions(U, R, Z, G), G !== void 0) {
        let W = I[U];
        W = W === void 0 ? G : ["and", W, G], I[U] = clean_assumptions(W, get_assumptions(D, U, { omit_derived: !0 }));
      }
    }
    if (z) return I;
  }
  let L = [];
  for (let q of F) {
    let U = get_assumptions_for_expr(D, q, []);
    U !== void 0 && L.push(U);
  }
  if (L.length === 0) return {};
  L = L.length === 1 ? L[0] : ["and"].concat(L);
  for (let q of variables(E)) I[q] = clean_assumptions(L, get_assumptions(D, q, { omit_derived: !0 }));
  return I;
}
function get_assumptions_for_expr(D, E, O) {
  let F = variables(E);
  if (F = F.filter((W) => !O.includes(W)), F.length === 0) return;
  function I(W) {
    return !!(typeof W == "number" || Array.isArray(W) && W[0] === "-" && typeof W[1] == "number");
  }
  var z = ["_b"], R = ["_b"], L = { _b: I }, q = {};
  for (let W = 0; W < F.length; W++) {
    let J = "_a" + W;
    q[F[W]] = J, z.push(["*", J, F[W]]), R.push(J), L[J] = I;
  }
  z = ["+"].concat(z);
  var U = match$1(E, z, { variables: L, allow_permutations: !0, allow_extended_match: !1, allow_implicit_identities: R, max_group: 1 });
  if (!U) {
    let W = [];
    for (let J of variables(E)) {
      let X = get_assumptions_for_expr(D, J, O);
      X !== void 0 && W.push(X);
    }
    return W.length === 0 ? void 0 : W.length === 1 ? W[0] : ["and"].concat(W);
  }
  for (let W of F) q[W] = U[q[W]];
  let Z = !1;
  U._b === 0 && U._a0 === 1 && F.length === 1 && (Z = !0);
  var V = get_assumptions(D, [F], { exclude_variables: O });
  if (V === void 0) return;
  return clean_assumptions(G(V));
  function G(W) {
    if (!Array.isArray(W)) return;
    var J = W[0], X = W.slice(1);
    if (J === "and" || J === "or") {
      let ae = X.map(G).filter((ue) => ue !== void 0);
      return ae.length === 0 ? void 0 : J === "or" ? ae.length === X.length ? ["or"].concat(ae) : void 0 : ae.length === 1 ? ae[0] : ["and"].concat(ae);
    }
    if (!(["=", "ne", "<", "le"].includes(J) || ["in", "notin", "subset", "notsubset"].includes(J) && Z)) {
      let ae = O.concat(variables(E)), ue = [];
      for (let oe of variables(W)) {
        if (ae.includes(oe)) continue;
        let se = get_assumptions_for_expr(D, oe, ae);
        se !== void 0 && ue.push(se);
      }
      return ue.length === 0 ? W : ue.length === 1 ? ["and", W, ue[0]] : ["and", W].concat(ue);
    }
    let Y = [];
    for (let ae = 0; ae <= 1; ae++) {
      let ue = X[ae], oe = X[1 - ae];
      if (typeof ue == "string" && F.includes(ue)) {
        var ee = {};
        ee[ue] = oe;
        var K = simplify(substitute$1(E, ee)), te = !1, ie = J;
        (ae === 1 && q[ue] > 0 || ae === 0 && q[ue] < 0) && (J === "<" ? (te = !0, ie = ">") : J === "le" ? (te = !0, ie = "ge") : J === "in" ? (te = !0, ie = "ni") : J === "subset" ? (te = !0, ie = "superset") : J === "notin" ? (te = !0, ie = "notni") : J === "notsubset" && (te = !0, ie = "notsuperset")), te ? Y.push([J, K, E]) : Y.push([J, E, K]);
        let se = get_assumptions_for_expr(D, K, O.concat([ue]));
        se = combine_assumptions(E, ie, K, se), se !== void 0 && Y.push(se);
      }
    }
    if (Y.length === 1) return Y[0];
    if (Y.length > 1) return ["and"].concat(Y);
    let ne = O.concat(variables(E));
    Y = [];
    for (let ae of variables(W)) {
      if (ne.includes(ae)) continue;
      let ue = get_assumptions_for_expr(D, ae, ne);
      ue !== void 0 && Y.push(ue);
    }
    return Y.length === 0 ? W : Y.length === 1 ? ["and", W, Y[0]] : ["and", W].concat(Y);
  }
}
function combine_assumptions(D, E, O, F) {
  if (!["=", "ne", "<", "le", ">", "ge", "in", "notin", "ni", "notni", "subset", "notsubset", "superset", "notsuperset"].includes(E)) return F;
  if (Array.isArray(F)) {
    var I = F[0], z = F.slice(1);
    if (I === "and" || I === "or") {
      let U = z.map((Z) => combine_assumptions(D, E, O, Z)).filter((Z) => Z !== void 0);
      return U.length === 0 ? void 0 : I === "or" ? U.length === z.length ? [["or"].concat(U)] : void 0 : U.length === 1 ? U[0] : ["and"].concat(U);
    }
    if (!["=", "ne", "<", "le", "in", "notin", "subset", "notsubset"].includes(I)) return F;
    var R = I, L;
    if (equal(z[0], O)) L = z[1];
    else if (equal(z[1], O)) L = z[0], I === "<" ? R = ">" : I === "le" ? R = "ge" : I === "in" ? R = "ni" : I === "notin" ? R = "notni" : I === "subset" ? R = "superset" : I === "notsubset" && (R = "notsuperset");
    else return F;
    var q;
    if (E === "=") q = R;
    else if (R === "=") q = E;
    else if (E === "<") if (R === "<" || R === "le") q = "<";
    else return R === "in" || R === "notin" ? F : void 0;
    else if (E === "le") if (R === "<") q = "<";
    else if (R === "le") q = "le";
    else return R === "in" || R === "notin" ? F : void 0;
    else if (E === ">") if (R === ">" || R === "ge") q = ">";
    else return R === "in" || R === "notin" ? F : void 0;
    else if (E === "ge") if (R === ">") q = ">";
    else if (R === "ge") q = "ge";
    else return R === "in" || R === "notin" ? F : void 0;
    else if (E === "in") if (R === "subset") q = "in";
    else return;
    else if (E === "notin") if (R === "superset") q = "notin";
    else return;
    else if (E === "ni") if (R === "notin") q = "notsubset";
    else return;
    else if (E === "notni") if (R === "in") q = "notsuperset";
    else return;
    else if (E === "subset") if (R === "subset") q = "subset";
    else if (R === "notni") q = "notni";
    else if (R === "notsuperset") q = "notsuperset";
    else return;
    else if (E === "notsubset") if (R === "superset") q = "notsubset";
    else return;
    else if (E === "superset") if (R === "superset") q = "superset";
    else if (R === "ni") q = "ni";
    else if (R === "notsubset") q = "notsubset";
    else return;
    else if (E === "notsuperset") if (R === "subset") q = "notsuperset";
    else return;
    else return;
    return q === ">" ? ["<", L, D] : q === "ge" ? ["le", L, D] : q === "ni" ? ["in", L, D] : q === "notni" ? ["notin", L, D] : q === "superset" ? ["subset", L, D] : q === "notsuperset" ? ["notsubset", L, D] : [q, D, L];
  }
}
function filter_assumptions_from_tree(D, E) {
  if (!(!Array.isArray(D) || D.length === 0)) {
    Array.isArray(E) || (E = [E]);
    var O = D[0], F = D.slice(1);
    if (O === "and") {
      var I = F.map(function(R) {
        return filter_assumptions_from_tree(R, E);
      });
      return I = I.filter((R) => R !== void 0), I.length === 0 ? void 0 : I.length === 1 ? I[0] : ["and"].concat(I);
    }
    var z = variables(D);
    if (!(E.filter((R) => z.includes(R)).length > 0)) return D;
  }
}
function get_assumptions_sub(D, E, O, F) {
  Array.isArray(E) || (E = [E]);
  var I = [];
  if (E.forEach(function(z) {
    if (D.byvar[z] || D.derived[z]) {
      if (D.byvar[z] && D.byvar[z].length > 0) {
        var R = filter_assumptions_from_tree(D.byvar[z], O);
        R !== void 0 && I.push(R);
      }
      if (D.derived[z] && D.derived[z].length > 0 && !F) {
        var L = filter_assumptions_from_tree(D.derived[z], O);
        L !== void 0 && I.push(L);
      }
    } else D.generic.length > 0 && (z === "x" || !variables(D.generic).includes(z)) && I.push(substitute$1(D.generic, { x: z }));
  }), I.length === 1 ? I = I[0] : I.length > 1 && (I = ["and"].concat(I)), I.length > 0) return clean_assumptions(I);
}
function get_assumptions(D, E, O) {
  O === void 0 && (O = {});
  var F = O.exclude_variables;
  F === void 0 ? F = [] : Array.isArray(F) || (F = [F]);
  var I, z = get_tree(E);
  if (typeof z == "string") I = [z];
  else if (Array.isArray(z)) Array.isArray(z[0]) && (I = z[0]);
  else return;
  return I ? get_assumptions_sub(D, I, F, O.omit_derived) : get_assumptions_for_expr(D, z, F);
}
function add_assumption(D, E, O) {
  var F = get_tree(E);
  if (!Array.isArray(F)) return 0;
  F = clean_assumptions(simplify(F, D));
  var I = add_assumption_sub(D, F, O);
  return I && (D.derived = calculate_derived_assumptions(D)), I;
}
function add_assumption_sub(D, E, O) {
  if (E[0] === "and") return E.slice(1).map((z) => add_assumption_sub(D, z, O)).reduce(function(z, R) {
    return z + R;
  });
  var F = variables(E);
  if (F.length === 0) return 0;
  let I = 0;
  !O && D.generic.length > 0 && F.forEach(function(z) {
    D.byvar[z] === void 0 && (z === "x" || !variables(D.generic).includes(z)) && (add_assumption_sub(D, substitute$1(D.generic, { x: z }), !0), I += 1);
  });
  for (let z of F) {
    let R = solve_linear(E, z, D), L = E;
    R && (L = R);
    let q = D.byvar[z];
    q !== void 0 && q.length !== 0 && (L = ["and", q, L]), L = clean_assumptions(L), equal(L, q) || (D.byvar[z] = L, I += 1);
  }
  return I;
}
function add_generic_assumption(D, E) {
  var O = get_tree(E);
  if (!Array.isArray(O)) return 0;
  O = clean_assumptions(simplify(O, D));
  var F = add_generic_assumption_sub(D, O);
  return F && (D.derived = calculate_derived_assumptions(D)), F;
}
function add_generic_assumption_sub(D, E) {
  if (E[0] === "and") return E.slice(1).map((z) => add_generic_assumption_sub(D, z)).reduce(function(z, R) {
    return z + R;
  });
  if (!variables(E).includes("x")) return 0;
  let O = solve_linear(E, "x", D), F = E;
  O && (F = O);
  let I = D.generic;
  return I.length !== 0 && (F = ["and", I, F]), F = clean_assumptions(F), equal(F, I) ? 0 : (D.generic = F, 1);
}
function remove_assumption(D, E) {
  var O = get_tree(E);
  if (!Array.isArray(O)) return 0;
  O = clean_assumptions(simplify(O, D));
  var F = remove_assumption_sub(D, O);
  return F && (D.derived = calculate_derived_assumptions(D)), F;
}
function remove_assumption_sub(D, E) {
  if (E[0] === "and") return E.slice(1).map((I) => remove_assumption_sub(D, I)).reduce(function(I, z) {
    return I + z;
  });
  var O = variables(E);
  if (O.length === 0) return 0;
  var F = 0;
  for (let I of O) {
    let z = solve_linear(E, I, D), R = D.byvar[I];
    if (!R || R.length === 0) continue;
    let L = R[0], q = R.slice(1), U = q.length, Z;
    if (L === "and") if (q = q.filter((V) => !(equal(V, E) || equal(V, z))), q.length === 0) Z = [];
    else if (q.length === 1) Z = q[0];
    else if (q.length < U) Z = [L].concat(q);
    else continue;
    else if (equal(R, E) || equal(R, z)) Z = [];
    else continue;
    F += 1, D.byvar[I] = Z;
  }
  return F;
}
function remove_generic_assumption(D, E) {
  var O = get_tree(E);
  if (!Array.isArray(O)) return 0;
  O = clean_assumptions(simplify(O, D));
  var F = remove_generic_assumption_sub(D, O);
  return F && (D.derived = calculate_derived_assumptions(D)), F;
}
function remove_generic_assumption_sub(D, E) {
  if (E[0] === "and") return E.slice(1).map((q) => remove_generic_assumption_sub(D, q)).reduce(function(q, U) {
    return q + U;
  });
  if (!variables(E).includes("x")) return 0;
  var O = D.generic;
  if (O.length === 0) return 0;
  let F = solve_linear(E, "x", D);
  var I = O[0], z = O.slice(1), R = z.length, L;
  if (I === "and") if (z = z.filter((q) => !(equal(q, E) || equal(q, F))), z.length === 0) L = [];
  else if (z.length === 1) L = z[0];
  else if (z.length < R) L = [I].concat(z);
  else return 0;
  else if (equal(O, E) || equal(O, F)) L = [];
  else return 0;
  return D.generic = L, 1;
}
function initialize_assumptions() {
  var D = {};
  return D.byvar = {}, D.derived = {}, D.generic = [], D.not_commutative = [], D.get_assumptions = function(E, O) {
    return get_assumptions(D, E, O);
  }, D.add_assumption = function(E, O) {
    return add_assumption(D, E, O);
  }, D.add_generic_assumption = function(E) {
    return add_generic_assumption(D, E);
  }, D.remove_assumption = function(E) {
    return remove_assumption(D, E);
  }, D.remove_generic_assumption = function(E) {
    return remove_generic_assumption(D, E);
  }, D;
}
var operators$1 = { "+": function(D) {
  return D.join(" ");
}, "-": function(D) {
  return "-" + D[0];
}, pm: function(D) {
  return "\\pm " + D[0];
}, "*": function(D) {
  return D.join(" ");
}, "/": function(D) {
  return "\\frac{" + D[0] + "}{" + D[1] + "}";
}, _: function(D) {
  return D[0] + "_{" + D[1] + "}";
}, "^": function(D) {
  return D[0] + "^{" + D[1] + "}";
}, prime: function(D) {
  return D[0] + "'";
}, tuple: function(D) {
  return "\\left( " + D.join(", ") + " \\right)";
}, array: function(D) {
  return "\\left[ " + D.join(", ") + " \\right]";
}, list: function(D) {
  return D.join(", ");
}, set: function(D) {
  return "\\left\\{ " + D.join(", ") + " \\right\\}";
}, vector: function(D) {
  return "\\left( " + D.join(", ") + " \\right)";
}, altvector: function(D) {
  return "\\left\\langle " + D.join(", ") + " \\right\\rangle";
}, interval: function(D) {
  return "\\left( " + D.join(", ") + " \\right)";
}, matrix: function(D) {
  return "\\left( " + D.join(", ") + " \\right)";
}, and: function(D) {
  return D.join(" \\land ");
}, or: function(D) {
  return D.join(" \\lor ");
}, not: function(D) {
  return "\\lnot " + D[0];
}, "=": function(D) {
  return D.join(" = ");
}, "<": function(D) {
  return D.join(" < ");
}, ">": function(D) {
  return D.join(" > ");
}, lts: function(D) {
  return D.join(" < ");
}, gts: function(D) {
  return D.join(" > ");
}, le: function(D) {
  return D.join(" \\le ");
}, ge: function(D) {
  return D.join(" \\ge ");
}, ne: function(D) {
  return D.join(" \\ne ");
}, forall: function(D) {
  return "\\forall " + D[0];
}, exists: function(D) {
  return "\\exists " + D[0];
}, in: function(D) {
  return D[0] + " \\in " + D[1];
}, notin: function(D) {
  return D[0] + " \\notin " + D[1];
}, ni: function(D) {
  return D[0] + " \\ni " + D[1];
}, notni: function(D) {
  return D[0] + " \\not\\ni " + D[1];
}, subset: function(D) {
  return D[0] + " \\subset " + D[1];
}, subseteq: function(D) {
  return D[0] + " \\subseteq " + D[1];
}, notsubset: function(D) {
  return D[0] + " \\not\\subset " + D[1];
}, notsubseteq: function(D) {
  return D[0] + " \\not\\subseteq " + D[1];
}, superset: function(D) {
  return D[0] + " \\supset " + D[1];
}, superseteq: function(D) {
  return D[0] + " \\supseteq " + D[1];
}, notsuperset: function(D) {
  return D[0] + " \\not\\supset " + D[1];
}, notsuperseteq: function(D) {
  return D[0] + " \\not\\supseteq " + D[1];
}, union: function(D) {
  return D.join(" \\cup ");
}, intersect: function(D) {
  return D.join(" \\cap ");
}, implies: function(D) {
  return D.join(" \\implies ");
}, impliedby: function(D) {
  return D.join(" \\impliedby ");
}, iff: function(D) {
  return D.join(" \\iff ");
}, leftarrow: function(D) {
  return D.join(" \\leftarrow ");
}, rightarrow: function(D) {
  return D.join(" \\rightarrow ");
}, leftrightarrow: function(D) {
  return D.join(" \\leftrightarrow ");
}, perp: function(D) {
  return D.join(" \\perp ");
}, parallel: function(D) {
  return D.join(" \\parallel ");
}, derivative_leibniz: function(D) {
  return "\\frac{d" + D[0] + "}{d" + D[1] + "}";
}, partial_derivative_leibniz: function(D) {
  return "\\frac{d" + D[0] + "}{d" + D[1] + "}";
}, "|": function(D) {
  return D[0] + " \\mid " + D[1];
}, ":": function(D) {
  return D[0] + " : " + D[1];
}, binom: function(D) {
  return "\\binom{" + D[0] + "}{" + D[1] + "}";
}, vec: function(D) {
  return "\\vec{" + D[0] + "}";
}, linesegment: function(D) {
  return "\\overline{" + D.join(" ") + "}";
}, angle: function(D, E) {
  return E ? "\\angle " + D.join("") : "\\angle\\left( " + D.join(", ") + " \\right)";
}, unit: function(D) {
  return D[1] === "\\circ" ? D[0] + "^{\\circ}" : D[0] + " " + D[1];
} }, allowedLatexSymbolsDefault$1 = "alpha.beta.gamma.Gamma.delta.Delta.epsilon.zeta.eta.theta.Theta.iota.kappa.lambda.Lambda.mu.nu.xi.Xi.pi.Pi.rho.sigma.Sigma.tau.Tau.upsilon.Upsilon.phi.Phi.chi.psi.Psi.omega.Omega.partial.abs.exp.log.ln.log10.sign.sqrt.erf.cos.cosh.cot.coth.csc.csch.sec.sech.sin.sinh.tan.tanh.arcsin.arccos.arctan.arccsc.arcsec.arccot.arg.Re.Im.det.angle.perp.circ.%.$.int.varnothing".split("."), convertLatexSymbolsDefault = { acos: "arccos", acosh: "arccosh", acot: "arccot", acoth: "arccoth", acsc: "arccsc", acsch: "arccsch", asec: "arcsec", asech: "arcsech", asin: "arcsin", asinh: "arcsinh", atan: "arctan", atanh: "arctanh", deg: "circ", emptyset: "varnothing" }, matrixEnvironmentDefault = "bmatrix", astToLatex$1 = class {
  constructor({ allowedLatexSymbols: D = allowedLatexSymbolsDefault$1, convertLatexSymbols: E = convertLatexSymbolsDefault, matrixEnvironment: O = matrixEnvironmentDefault, padToDigits: F = null, padToDecimals: I = null, avoidScientificNotation: z = !1, showBlanks: R = !0 } = {}) {
    this.allowedLatexSymbols = D, this.convertLatexSymbols = E, this.matrixEnvironment = O, this.padToDigits = F, this.padToDecimals = I, this.avoidScientificNotation = z, this.showBlanks = R;
  }
  convert(D) {
    return this.statement(normalize_display_negative_fractions(D));
  }
  statement(D) {
    if (!Array.isArray(D)) return this.single_statement(D);
    var E = D[0], O = D.slice(1);
    if (E === "ldots") return "\\ldots";
    if (!(E in operators$1) && E !== "apply") throw Error("Badly formed ast: operator " + E + " not recognized.");
    return ["implies", "impliedby", "iff", "rightarrow", "leftarrow", "leftrightarrow"].includes(E) ? operators$1[E](O.map((F) => this.statement(F))) : E === "and" || E === "or" ? operators$1[E](O.map((function(F, I) {
      let z = this.single_statement(F);
      return z.match(/ /) && !z.match(/^\\left\(.*\\right\)$/) ? "\\left(" + z + "\\right)" : z;
    }).bind(this))) : this.single_statement(D);
  }
  single_statement(D) {
    if (!Array.isArray(D)) return this.expression(D);
    var E = D[0], O = D.slice(1);
    if (E === "not") return operators$1[E](O.map((function(F, I) {
      let z = this.single_statement(F);
      return z.match(/ /) && !z.match(/^\\left\(.*\\right\)$/) ? "\\left(" + z + "\\right)" : z;
    }).bind(this)));
    if (E === "exists" || E === "forall") return operators$1[E]([this.single_statement(O[0])]);
    if (E === "=" || E === "ne" || E === "<" || E === ">" || E === "le" || E === "ge" || E === "in" || E === "notin" || E === "ni" || E === "notni" || E === "subset" || E === "notsubset" || E === "subseteq" || E === "notsubseteq" || E === "superset" || E === "notsuperset" || E === "superseteq" || E === "notsuperseteq") return operators$1[E](O.map((function(F, I) {
      return this.expression(F);
    }).bind(this)));
    if (E === "lts" || E === "gts") {
      let F = O[0], I = O[1];
      if (F[0] !== "tuple" || I[0] !== "tuple") throw Error("Badly formed ast");
      let z = this.expression(F[1]);
      for (let R = 1; R < F.length - 1; R++) I[R] ? E === "lts" ? z += " < " : z += " > " : E === "lts" ? z += " \\le " : z += " \\ge ", z += this.expression(F[R + 1]);
      return z;
    }
    return this.expression(D);
  }
  expression(D) {
    if (!Array.isArray(D)) return this.term(D);
    var E = D[0], O = D.slice(1);
    return E === "+" ? O.length === 1 ? "+" + this.term(O[0]) : operators$1[E](O.map((function(F, I) {
      return I > 0 ? this.termWithPlusIfNotNegated(F) : this.term(F);
    }).bind(this))) : ["union", "intersect", "perp", "parallel"].includes(E) ? operators$1[E](O.map((function(F, I) {
      return this.term(F);
    }).bind(this))) : this.term(D);
  }
  term(D) {
    if (!Array.isArray(D)) return this.factor(D);
    var E = D[0], O = D.slice(1);
    return E === "-" || E === "pm" ? operators$1[E](O.map((function(F, I) {
      return this.term(F);
    }).bind(this))) : E === "*" ? operators$1[E](O.map((function(F, I) {
      let z;
      return I > 0 ? (z = this.factorWithParenthesesIfNegatedExplicitPlusOrFraction(F), z.match(/^[0-9]/) ? "\\cdot " + z : F[0] === "angle" && O.length > 1 ? "\\left( " + z + " \\right)" : z) : (z = this.factor(F), F[0] === "angle" && O.length > 1 ? "\\left( " + z + " \\right)" : z);
    }).bind(this))) : E === "/" || E === "unit" ? operators$1[E](O.map((function(F, I) {
      return this.expression(F);
    }).bind(this))) : this.factor(D);
  }
  simple_factor_or_function_or_parens(D) {
    var E = this.factor(D);
    return E.length <= 1 || typeof D == "string" && D.match(/^\w+$/) || Array.isArray(D) && D[0] === "apply" && !["sqrt", "cbrt", "nthroot"].includes(D[1]) || E.match(/^\\left\(.*\\right\)$/) || E.match(/^\\left\\langle.*\\right\\rangle$/) ? !0 : typeof D == "number" ? !!(D >= 0 && (this.avoidScientificNotation || !D.toString().includes("e"))) : !1;
  }
  stringConvert(D) {
    return D.length > 1 ? (this.convertLatexSymbols[D] && (D = this.convertLatexSymbols[D]), this.allowedLatexSymbols.includes(D) ? "\\" + D : "\\operatorname{" + D + "}") : this.allowedLatexSymbols.includes(D) ? "\\" + D : D === "＿" && !this.showBlanks ? "" : D;
  }
  factor(D) {
    if (typeof D == "string") return this.stringConvert(D);
    if (typeof D == "number") {
      if (D === 1 / 0) return "\\infty";
      if (D === -1 / 0) return "-\\infty";
      if (Number.isNaN(D)) return "NaN";
      {
        let F = D.toString(), I = F.indexOf("e");
        if (I === -1 || this.avoidScientificNotation) return I !== -1 && this.avoidScientificNotation && (F = expandScientificNotation(F)), (this.padToDigits !== null || this.padToDecimals !== null) && (F = padNumberStringToDigitsAndDecimals(F, this.padToDigits, this.padToDecimals)), F;
        let z = F.substring(0, I), R = F.substring(I + 1);
        if (R[0] === "+" && (R = R.slice(1)), this.padToDigits !== null || this.padToDecimals !== null) {
          let L = Number(R);
          if (L > 0 && this.padToDecimals !== null) return F = D.toLocaleString("fullwide", { useGrouping: !1 }), padNumberStringToDigitsAndDecimals(F, this.padToDigits, this.padToDecimals);
          {
            let q = null;
            this.padToDecimals !== null && (q = this.padToDecimals + L), z = padNumberStringToDigitsAndDecimals(z, this.padToDigits, q);
          }
        }
        return z + " \\cdot 10^{" + R + "}";
      }
    }
    if (!Array.isArray(D)) return "";
    var E = D[0], O = D.slice(1);
    if (E === "^") {
      if (Number.isInteger(O[0]) && Number.isInteger(O[1])) return O[0] < 0 ? "\\left(" + O[0].toString() + "\\right)^{" + O[1].toString() + "}" : O[0].toString() + "^{" + O[1].toString() + "}";
      let F = this.factor(O[0]), I = O[0];
      for (; I[0] === "prime"; ) I = I[1];
      return this.simple_factor_or_function_or_parens(I) || I[0] === "_" && typeof I[1] == "string" || (F = "\\left(" + F.toString() + "\\right)"), F + "^{" + this.statement(O[1]) + "}";
    } else if (E === "_") {
      let F = this.factor(O[0]);
      return this.simple_factor_or_function_or_parens(O[0]) || (F = "\\left(" + F.toString() + "\\right)"), F + "_{" + this.statement(O[1]) + "}";
    } else if (E === "prime") {
      let F = O[0], I = 1;
      for (; F[0] === "prime"; ) I += 1, F = F[1];
      let z = this.factor(F);
      this.simple_factor_or_function_or_parens(F) || F[0] === "_" && typeof F[1] == "string" || (z = "\\left(" + z + "\\right)");
      for (let R = 0; R < I; R++) z += "'";
      return z;
    } else {
      if (E === "/") return this.term(D);
      if (E === "-") return operators$1[E](O.map((function(F, I) {
        return this.factor(F);
      }).bind(this)));
      if (E === "tuple" || E === "array" || E === "list" || E === "set" || E === "vector" || E === "altvector" || E === "|" || E === ":" || E === "binom" || E === "vec" || E === "linesegment") return operators$1[E](O.map((function(F, I) {
        return this.statement(F);
      }).bind(this)));
      if (E === "interval") {
        let F = O[0], I = O[1];
        if (F[0] !== "tuple" || I[0] !== "tuple") throw Error("Badly formed ast");
        let z = this.statement(F[1]) + ", " + this.statement(F[2]);
        return z = I[1] ? "\\left[ " + z : "\\left( " + z, I[2] ? z += " \\right]" : z += " \\right)", z;
      } else if (E === "matrix") {
        let F = O[0], I = O[1], z = "\\begin{" + this.matrixEnvironment + "} ";
        for (let R = 0; R < F[1]; R += 1) {
          for (let L = 0; L < F[2]; L += 1) z += this.statement(I[R + 1][L + 1]), L < F[2] - 1 && (z += " & ");
          R < F[1] - 1 && (z += " \\\\ ");
        }
        return z = z + " \\end{" + this.matrixEnvironment + "}", z;
      } else if (E === "derivative_leibniz" || E === "partial_derivative_leibniz") {
        let F = "d";
        E === "partial_derivative_leibniz" && (F = "\\partial ");
        let I = O[0], z = O[1], R = 1, L = "";
        Array.isArray(I) ? (L = I[1], R = I[2]) : L = I;
        let q = F;
        R > 1 ? q = q.trimRight() + "^{" + R + "}" + this.stringConvert(L) : q += this.stringConvert(L), q = "\\frac{ " + q + " }{ ";
        let U = 1;
        Array.isArray(z) && (U = z.length - 1);
        for (let Z = 1; Z <= U; Z++) {
          let V = z[Z], G = 1, W = "";
          Array.isArray(V) ? (W = V[1], G = V[2]) : W = V, q = q + F + this.stringConvert(W), G > 1 && (q = q + "^{" + G + "}"), q += " ";
        }
        return q += "}", q;
      } else if (E === "apply") {
        if (O[0] === "abs") return "\\left|" + this.statement(O[1]) + "\\right|";
        if (O[0] === "floor") return "\\left\\lfloor " + this.statement(O[1]) + " \\right\\rfloor";
        if (O[0] === "ceil") return "\\left\\lceil " + this.statement(O[1]) + " \\right\\rceil";
        if (O[0] === "factorial") {
          let R = this.factor(O[1]);
          return this.simple_factor_or_function_or_parens(O[1]) || O[1][0] === "_" && typeof O[1][1] == "string" ? R + "!" : "\\left(" + R + "\\right)!";
        } else {
          if (O[0] === "sqrt") return "\\sqrt{" + this.statement(O[1]) + "}";
          if (O[0] === "cbrt") return "\\sqrt[3]{" + this.statement(O[1]) + "}";
          if (O[0] === "nthroot") return Array.isArray(O[1]) && O[1][0] === "tuple" && O[1].length === 3 ? "\\sqrt[" + this.statement(O[1][2]) + "]{" + this.statement(O[1][1]) + "}" : "\\sqrt{" + this.statement(O[1]) + "}";
        }
        let F = O[0];
        if (F[0] === "^" && (F = F[1]), F[0] === "_" && (F = F[1]), F === "int") {
          let R = this.factor(O[0]), L = O[1], q;
          if (Array.isArray(L) && L[0] === "*") {
            let U = [], Z = ["*"];
            for (let V = 1; V < L.length; V++) {
              let G = L[V];
              Array.isArray(G) && G[0] === "d" ? U.push(G) : Z.push(G);
            }
            q = this.term(Z), U.length > 0 && (q[q.length - 1].match(/[a-zA-Z]/) && (q += "\\,"), q += U.map((V) => "d" + this.factor(V[1])).join("\\,"));
          }
          return q ||= this.term(O[1]), R + " " + q;
        }
        let I;
        I = O[0] === "log10" ? "\\log_{10}" : O[0] === "re" ? "\\Re" : O[0] === "im" ? "\\Im" : this.factor(O[0]);
        let z = this.statement(O[1]);
        return O[1][0] !== "tuple" && (z = "\\left(" + z + "\\right)"), I + z;
      } else if (E === "angle") {
        let F = O.every((I) => {
          if (typeof I == "string" && I.length === 1) return !0;
          if (!Array.isArray(I)) return !1;
          let z = I[0];
          return z === "_" || z === "^" || z === "prime";
        });
        return operators$1[E](O.map((function(I, z) {
          return this.statement(I);
        }).bind(this)), F);
      } else return E === "+" && D.length === 2 ? "+ " + this.factor(D[1]) : "\\left(" + this.statement(D) + "\\right)";
    }
  }
  factorWithParenthesesIfNegatedExplicitPlusOrFraction(D) {
    var E = this.factor(D);
    return E.match(/^-/) || E.match(/^\+/) || D[0] === "/" ? "\\left(" + E + "\\right)" : E;
  }
  termWithPlusIfNotNegated(D) {
    var E = this.term(D);
    return E.match(/^\\pm /) ? E : E.match(/^-/) ? E.match(/^-[^ ]/) ? "- " + E.slice(1) : E : "+ " + E;
  }
}, operators = { "+,add": function(D) {
  return ["+"].concat(D);
}, "*,multiply": function(D) {
  return ["*"].concat(D);
}, "/,divide": function(D) {
  return ["/", D[0], D[1]];
}, "-,unaryMinus": function(D) {
  return ["-", D[0]];
}, "-,subtract": function(D) {
  return ["+", D[0], ["-", D[1]]];
}, "^,pow": function(D) {
  return ["^", D[0], D[1]];
}, "and,and": function(D) {
  return ["and"].concat(D);
}, "or,or": function(D) {
  return ["or"].concat(D);
}, "not,not": function(D) {
  return ["not", D[0]];
}, "==,equal": function(D) {
  return ["="].concat(D);
}, "<,smaller": function(D) {
  return ["<", D[0], D[1]];
}, ">,larger": function(D) {
  return [">", D[0], D[1]];
}, "<=,smallerEq": function(D) {
  return ["le", D[0], D[1]];
}, ">=,largerEq": function(D) {
  return ["ge", D[0], D[1]];
}, "!=,unequal": function(D) {
  return ["ne", D[0], D[1]];
}, "!,factorial": function(D) {
  return ["apply", "factorial", D[0]];
} }, mathjsToAst$1 = class {
  convert(D) {
    if (D.isConstantNode) return D.value;
    if (D.isSymbolNode) return D.name;
    if (D.isOperatorNode) {
      var E = [D.op, D.fn].join(",");
      if (E in operators) return operators[E](D.args.map((function(I, z) {
        return this.convert(I);
      }).bind(this)));
      throw Error("Unsupported operator: " + D.op + ", " + D.fn);
    }
    if (D.isFunctionNode) {
      var O = D.args.map((function(I, z) {
        return this.convert(I);
      }).bind(this));
      O = O.length > 1 ? ["tuple"].concat(O) : O[0];
      var F = ["apply", D.name];
      return F.push(O), F;
    }
    if (D.isArrayNode) return ["vector"].concat(D.args.map((function(I, z) {
      return this.convert(I);
    }).bind(this)));
    if (D.isParenthesisNode) return this.convert(D.content);
    throw Error("Unsupported node type: " + D.type);
  }
}, differentiation_exports = __exportAll({ derivative: () => derivative, derivativeStory: () => derivativeStory, derivative_story: () => derivative_story, derivative_with_story: () => derivative_with_story }), astToMathjs = new astToMathjs$2({ mathjs: mathjs_default }), mathjsToAst = new mathjsToAst$1(), textToAst$2 = new textToAst$4(), astToLatex = new astToLatex$1(), derivatives = { sin: textToAst$2.convert("cos x"), cos: textToAst$2.convert("-(sin x)"), tan: textToAst$2.convert("(sec x)^2"), cot: textToAst$2.convert("-((csc x)^2)"), sec: textToAst$2.convert("(sec x)*(tan x)"), csc: textToAst$2.convert("-(csc x)*(cot x)"), sqrt: textToAst$2.convert("1/(2*sqrt(x))"), cbrt: textToAst$2.convert("1/(3*x^(2/3))"), log: textToAst$2.convert("1/x"), ln: textToAst$2.convert("1/x"), exp: textToAst$2.convert("exp(x)"), arcsin: textToAst$2.convert("1/sqrt(1 - x^2)"), arccos: textToAst$2.convert("-1/sqrt(1 - x^2)"), arctan: textToAst$2.convert("1/(1 + x^2)"), arccsc: textToAst$2.convert("-1/(sqrt(-1/x^2 + 1)*x^2)"), arcsec: textToAst$2.convert("1/(sqrt(-1/x^2 + 1)*x^2)"), arccot: textToAst$2.convert("-1/(1 + x^2)"), asin: textToAst$2.convert("1/sqrt(1 - x^2)"), acos: textToAst$2.convert("-1/sqrt(1 - x^2)"), atan: textToAst$2.convert("1/(1 + x^2)"), acsc: textToAst$2.convert("-1/(sqrt(-1/x^2 + 1)*x^2)"), asec: textToAst$2.convert("1/(sqrt(-1/x^2 + 1)*x^2)"), acot: textToAst$2.convert("-1/(1 + x^2)"), abs: textToAst$2.convert("abs(x)/x") };
function derivative_with_story(D, E, O = []) {
  var F = get_tree(D), I = "\\frac{d}{d" + E + "} ";
  if (typeof F == "number" || variables(F).indexOf(E) < 0) return O.push("The derivative of a constant is zero, that is, \\(" + I + astToLatex.convert(F) + " = 0\\)."), 0;
  if (typeof F == "string") return E === F ? (O.push("We know the derivative of the identity function is one, that is, \\(" + I + astToLatex.convert(F) + " = 1\\)."), 1) : (O.push("As far as \\(" + astToLatex.convert(E) + "\\) is concerned, \\(" + astToLatex.convert(F) + "\\) is constant, so " + I + astToLatex.convert(F) + " = 0\\)."), 0);
  if (!Array.isArray(F)) return null;
  var z = F[0], R = F.slice(1);
  if (z === "apply" && R[0] === "nthroot") if (R[1].length !== 3 || R[1][0] !== "tuple") R[0] = "sqrt";
  else {
    let L = R[1][2];
    z = "^", R = [R[1][1], ["/", 1, L]];
  }
  if (z === "+" || z === "-" || z === "~") {
    O.push("Using the sum rule, \\(" + I + astToLatex.convert(F) + " = " + R.map(function(q, U) {
      return I + astToLatex.convert(q);
    }).join(" + ") + "\\).");
    let L = [z].concat(R.map(function(q, U) {
      return derivative_with_story(q, E, O);
    }));
    return L = simplify(L), O.push("So using the sum rule, \\(" + I + astToLatex.convert(F) + " = " + astToLatex.convert(L) + "\\)."), L;
  }
  if (z === "*") {
    let L = [], q = [];
    for (let V = 0; V < R.length; V++) typeof R[V] == "number" || variables(R[V]).indexOf(E) < 0 ? q.push(R[V]) : L.push(R[V]);
    if (q.length > 0) {
      if (L.length === 0) return O.push("Since the derivative of a constant is zero, \\(" + I + astToLatex.convert(F) + " = 0.\\)"), 0;
      let V = ["*"].concat(L);
      if (L.length === 1 && (V = L[0]), V === E) {
        O.push("By the constant multiple rule, \\(" + I + astToLatex.convert(F) + " = " + q.map(function(X, Y) {
          return astToLatex.convert(X);
        }).join(" \\cdot ") + "\\).");
        let J = ["*"].concat(q);
        return J = simplify(J), J;
      }
      O.push("By the constant multiple rule, \\(" + I + astToLatex.convert(F) + " = " + q.map(function(J, X) {
        return astToLatex.convert(J);
      }).join(" \\cdot ") + " \\cdot " + I + "\\left(" + astToLatex.convert(V) + "\\right)\\).");
      let G = derivative_with_story(V, E, O), W = ["*"].concat(q.concat([G]));
      return W = simplify(W), O.push("And so \\(" + I + astToLatex.convert(F) + " = " + astToLatex.convert(W) + "\\)."), W;
    }
    O.push("Using the product rule, \\(" + I + astToLatex.convert(F) + " = " + R.map(function(V, G) {
      return R.map(function(W, J) {
        return G === J ? I + "\\left(" + astToLatex.convert(V) + "\\right)" : astToLatex.convert(W);
      }).join(" \\cdot ");
    }).join(" + ") + "\\).");
    let U = R.slice(), Z = ["+"].concat(R.map(function(V, G) {
      return ["*"].concat(U.map(function(W, J) {
        if (G === J) {
          let X = derivative_with_story(W, E, O);
          return X === 1 ? null : X;
        } else return W;
      }).filter(function(W) {
        return W != null;
      }));
    }));
    return Z = simplify(Z), O.push("So using the product rule, \\(" + I + astToLatex.convert(F) + " = " + astToLatex.convert(Z) + "\\)."), Z;
  }
  if (z === "/") {
    let L = R[0], q = R[1];
    if (variables(q).indexOf(E) < 0) {
      O.push("By the constant multiple rule, \\(" + I + astToLatex.convert(F) + " = " + astToLatex.convert(["/", 1, q]) + " \\cdot " + I + "\\left(" + astToLatex.convert(L) + "\\right)\\).");
      let G = derivative_with_story(L, E, O), W = substitute$1(textToAst$2.convert("(1/g)*d"), { d: G, g: q });
      return W = simplify(W), O.push("So \\(" + I + astToLatex.convert(F) + " = " + astToLatex.convert(W) + "\\)."), W;
    }
    if (variables(L).indexOf(E) < 0) {
      L !== 1 && O.push("By the constant multiple rule, \\(" + I + astToLatex.convert(F) + " = " + astToLatex.convert(L) + " \\cdot " + I + "\\left(" + astToLatex.convert(["/", 1, q]) + "\\right)\\)."), O.push("Since \\(\\frac{d}{du} \\frac{1}{u}\\) is \\(\\frac{-1}{u^2}\\), the chain rule gives \\(" + I + astToLatex.convert(F) + " = " + astToLatex.convert(L) + "\\cdot \\frac{-1}{ " + astToLatex.convert(q) + "^2} \\cdot " + I + astToLatex.convert(q) + "\\).");
      let G = derivative_with_story(q, E, O), W = substitute$1(textToAst$2.convert("f * (-a/(g^2))"), { f: L, a: G, g: q });
      return W = simplify(W), O.push("So since \\(\\frac{d}{du} \\frac{1}{u}\\) is \\(\\frac{-1}{u^2}\\), the chain rule gives \\(" + I + astToLatex.convert(F) + " = " + astToLatex.convert(W) + "\\)."), W;
    }
    O.push("Using the quotient rule, \\(" + I + astToLatex.convert(F) + " = \\frac{" + I + "\\left(" + astToLatex.convert(L) + "\\right) \\cdot " + astToLatex.convert(q) + " - " + astToLatex.convert(L) + "\\cdot " + I + "\\left(" + astToLatex.convert(q) + "\\right)}{ \\left( " + astToLatex.convert(q) + " \\right)^2} \\).");
    let U = derivative_with_story(L, E, O), Z = derivative_with_story(q, E, O), V = substitute$1(textToAst$2.convert("(a * g - f * b)/(g^2)"), { a: U, b: Z, f: L, g: q });
    return V = simplify(V), O.push("So using the quotient rule, \\(" + I + astToLatex.convert(F) + " = " + astToLatex.convert(V) + "\\)."), V;
  }
  if (z === "^") {
    let L = R[0], q = R[1];
    if (variables(q).indexOf(E) < 0) {
      if (typeof L == "string" && L === "x") {
        if (typeof q == "number") {
          let ee = substitute$1(textToAst$2.convert("n * (f^m)"), { n: q, m: q - 1, f: L });
          return ee = simplify(ee), O.push("By the power rule, \\(" + I + astToLatex.convert(F) + " = " + astToLatex.convert(q) + " \\cdot \\left(" + astToLatex.convert(L) + "\\right)^{" + astToLatex.convert(["-", q, 1]) + "}\\)."), ee;
        }
        let Y = substitute$1(textToAst$2.convert("n * (f^(n-1))"), { n: q, f: L });
        return Y = simplify(Y), O.push("By the power rule, \\(" + I + astToLatex.convert(F) + " = " + astToLatex.convert(q) + " \\cdot \\left(" + astToLatex.convert(L) + "\\right)^{" + astToLatex.convert(["-", q, 1]) + "}\\)."), Y;
      }
      q !== 1 && O.push("By the power rule and the chain rule, \\(" + I + astToLatex.convert(F) + " = " + astToLatex.convert(q) + " \\cdot \\left(" + astToLatex.convert(L) + "\\right)^{" + astToLatex.convert(["-", q, 1]) + "} \\cdot " + I + astToLatex.convert(L) + "\\).");
      let J = derivative_with_story(L, E, O);
      if (q === 1) return J;
      if (typeof q == "number") {
        let Y = substitute$1(textToAst$2.convert("n * (f^m) * a"), { n: q, m: q - 1, f: L, a: J });
        return Y = simplify(Y), O.push("So by the power rule and the chain rule, \\(" + I + astToLatex.convert(F) + " = " + astToLatex.convert(Y) + "\\)."), Y;
      }
      let X = substitute$1(textToAst$2.convert("n * (f^(n-1)) * a"), { n: q, f: L, a: J });
      return X = simplify(X), O.push("So by the power rule and the chain rule, \\(" + I + astToLatex.convert(F) + " = " + astToLatex.convert(X) + "\\)."), X;
    }
    if (L === "e" && mathjs_default.define_e) {
      if (typeof q == "string" && q === E) {
        let X = substitute$1(textToAst$2.convert("e^(f)"), { f: q });
        return X = simplify(X), O.push("The derivative of \\(e^" + astToLatex.convert(E) + "\\) is itself, that is, \\(" + I + astToLatex.convert(F) + " = " + astToLatex.convert(F) + "\\)."), X;
      }
      O.push("Using the rule for \\(e^x\\) and the chain rule, we know \\(" + I + astToLatex.convert(F) + " = " + astToLatex.convert(F) + " \\cdot " + I + astToLatex.convert(q) + "\\).");
      let J = substitute$1(textToAst$2.convert("e^(f)*d"), { f: q, d: derivative_with_story(q, E, O) });
      return J = simplify(J), O.push("So using the rule for \\(e^x\\) and the chain rule, \\(" + I + astToLatex.convert(F) + " = " + astToLatex.convert(J) + "\\)."), J;
    }
    if (typeof L == "number") {
      if (typeof q == "string" && q === E) {
        let Y = substitute$1(textToAst$2.convert("a^(f) * log(a)"), { a: L, f: q });
        return Y = simplify(Y), O.push("The derivative of \\(a^" + astToLatex.convert(E) + "\\) is \\(a^{" + astToLatex.convert(E) + "} \\, \\log a\\), that is, \\(" + I + astToLatex.convert(F) + " = " + astToLatex.convert(Y) + "\\)."), Y;
      }
      let J = substitute$1(textToAst$2.convert("a^(f) * log(a)"), { a: L, f: q });
      O.push("Using the rule for \\(a^x\\) and the chain rule, we know \\(" + I + astToLatex.convert(F) + " = " + astToLatex.convert(J) + " \\cdot " + I + astToLatex.convert(q) + "\\).");
      let X = substitute$1(textToAst$2.convert("a^(b)*log(a)*d"), { a: L, b: q, d: derivative_with_story(q, E, O) });
      return X = simplify(X), O.push("So using the rule for \\(a^x\\) and the chain rule, \\(" + I + astToLatex.convert(F) + " = " + astToLatex.convert(X) + "\\)."), X;
    }
    let U = L, Z = q;
    O.push("Recall the general rule for exponents, namely that \\(\\frac{d}{dx} u(x)^{v(x)} = u(x)^{v(x)} \\cdot \\left( v'(x) \\cdot \\log u(x) + \\frac{v(x) \\cdot u'(x)}{u(x)} \\right)\\).  In this case, \\(u(x) = " + astToLatex.convert(U) + "\\) and \\(v(x) = " + astToLatex.convert(Z) + "\\).");
    let V = derivative_with_story(U, E, O), G = derivative_with_story(Z, E, O), W = substitute$1(textToAst$2.convert("(f^g)*(b * log(f) + (g * a)/f)"), { a: V, b: G, f: U, g: Z });
    return W = simplify(W), O.push("So by the general rule for exponents, \\(" + I + astToLatex.convert(F) + " = " + astToLatex.convert(W) + "\\)."), W;
  }
  if (z === "apply" && !(R[0] in derivatives)) {
    let L = R[1];
    O.push("By the chain rule, \\(" + I + astToLatex.convert(F) + " = " + astToLatex.convert(substitute$1(["apply", R[0] + "'", "x"], { x: L })) + " \\cdot " + I + astToLatex.convert(L) + "\\).");
    let q = ["*", substitute$1(["apply", R[0] + "'", "x"], { x: L }), derivative_with_story(L, E, O)];
    return q = simplify(q), O.push("So by the chain rule, \\(" + I + astToLatex.convert(F) + " = " + astToLatex.convert(q) + "\\)."), q;
  }
  if (z === "apply" && R[0] in derivatives || z in derivatives) {
    let L = !1;
    z === "apply" && (z = R[0], R = R.slice(1), L = !0);
    let q = R[0];
    if (typeof q == "number")
      return O.push("The derivative of a constant is zero so \\(" + I + astToLatex.convert(F) + " = " + astToLatex.convert(0) + "\\)."), 0;
    if (typeof q == "string" && q === E) {
      let U = ["*", substitute$1(derivatives[z], { x: q })];
      return U = simplify(U), O.push("It is the case that \\(" + I + astToLatex.convert(F) + " = " + astToLatex.convert(U) + "\\)."), U;
    } else {
      if (typeof q == "string" && q !== E)
        return O.push("Since the derivative of a constant is zero, \\(" + I + astToLatex.convert(F) + " = " + astToLatex.convert(0) + "\\)."), 0;
      {
        let U = [z, "u"];
        L && (U = ["apply"].concat(U)), O.push("Recall \\(\\frac{d}{du}" + astToLatex.convert(U) + " = " + astToLatex.convert(derivative_with_story(U, "u", [])) + "\\)."), O.push("By the chain rule, \\(" + I + astToLatex.convert(F) + " = " + astToLatex.convert(substitute$1(derivatives[z], { x: q })) + " \\cdot " + I + astToLatex.convert(q) + "\\).");
        let Z = ["*", substitute$1(derivatives[z], { x: q }), derivative_with_story(q, E, O)];
        return Z = simplify(Z), O.push("So by the chain rule, \\(" + I + astToLatex.convert(F) + " = " + astToLatex.convert(Z) + "\\)."), Z;
      }
    }
  }
  return 0;
}
function lowercaseFirstLetter(D) {
  return D.charAt(0).toLowerCase() + D.slice(1);
}
function simplify_story(D) {
  for (let E = D.length - 1; E >= 1; E--) D[E] === D[E - 1] && D.splice(E, 1);
  for (let E = 0; E < D.length; E++) for (let O = E + 1; O < D.length; O++) D[E] === D[O] && (D[O] = "Again, " + lowercaseFirstLetter(D[O]));
  return D;
}
function derivative_story(D, E) {
  var O = [];
  return derivative_with_story(D, E, O), O = simplify_story(O), O;
}
var derivativeStory = derivative_story;
function derivative(D, E) {
  var O = get_tree(D);
  let F = astToMathjs.convert(log_subscript_to_two_arg_log(normalize_function_names(normalize_applied_functions(O)))), I = mathjs_default.derivative(F, E);
  return mathjsToAst.convert(I);
}
function pm_equals_numerical({ expr: D, other: E, randomBindings: O, expr_context: F, other_context: I, relative_tolerance: z, absolute_tolerance: R, tolerance_for_zero: L, allowed_error_in_numbers: q = 0, include_error_in_number_exponents: U = !1, allowed_error_is_absolute: Z = !1, rng: V }) {
  let G, W, J, X, Y;
  try {
    ({ variables: G, integer_variables: W, functions: J, expr: X, other: Y } = prepare_exprs_numerical_eval(D, E, F, I));
  } catch {
    return !1;
  }
  let ee, K;
  try {
    ee = expand_pm_signs(X.tree), K = expand_pm_signs(Y.tree);
  } catch {
    return !1;
  }
  let te, ie;
  try {
    te = ee.map((le) => F.fromAst(le).f()), ie = K.map((le) => I.fromAst(le).f());
  } catch {
    return !1;
  }
  let ne, ae;
  if (q > 0 && ee.length > 0) try {
    let le = replace_numbers_with_parameters({ expr: X, variables: G, include_exponents: U });
    ne = le.parameters;
    let ce = Object.keys(ne);
    if (ce.length > 0) {
      let fe;
      try {
        fe = expand_pm_signs(le.expr_with_params);
      } catch {
        fe = null;
      }
      fe && fe.length === ee.length && (ae = fe.map((pe) => {
        try {
          let ve = F.fromAst(pe), _e = ve.derivative(ce[0]);
          Z || (_e = _e.multiply(ne[ce[0]]));
          for (let de of ce.slice(1)) {
            let ge = ve.derivative(de);
            Z || (ge = ge.multiply(ne[de])), _e = _e.add(ge);
          }
          return _e.multiply(q).f();
        } catch {
          return;
        }
      }));
    }
  } catch {
  }
  let ue = Number.MAX_VALUE * 1e-20, oe = [10, 1, 100, 0.1, 1e3, 0.01], se = 0;
  for (let le = 0; le < 1e3; le++) {
    let ce = oe[Math.floor(le / 20) % oe.length], fe;
    try {
      fe = O(V, G, ce);
    } catch {
      continue;
    }
    for (let de = 0; de < W.length; de++) fe[W[de]] = generate_random_integer(-10, 10, V);
    for (let de = 0; de < J.length; de++) fe[J[de]] = random_cubic(V);
    let pe;
    if (ae) {
      let de = Object.assign({}, fe, ne);
      pe = Array(ae.length).fill(0);
      let ge = !1;
      for (let ye = 0; ye < ae.length; ye++) {
        let De = ae[ye];
        if (!De) continue;
        let Ce;
        try {
          Ce = mathjs_default.abs(De(de));
        } catch {
          ge = !0;
          break;
        }
        if (!Number.isFinite(Ce)) {
          ge = !0;
          break;
        }
        pe[ye] = Ce;
      }
      if (ge) continue;
    }
    let ve, _e;
    try {
      ve = te.map((de) => de(fe)), _e = ie.map((de) => de(fe));
    } catch {
      continue;
    }
    if (!(!ve.every((de) => typeof de != "boolean" && Number.isFinite(mathjs_default.abs(de)) && mathjs_default.abs(de) < ue) || !_e.every((de) => typeof de != "boolean" && Number.isFinite(mathjs_default.abs(de)) && mathjs_default.abs(de) < ue))) {
      if (!value_multisets_match(ve, _e, z, R, L, pe)) return !1;
      if (se += 1, se >= 10) return !0;
    }
  }
  return !1;
}
function value_multisets_match(D, E, O, F, I, z) {
  let R = (V) => z && z[V] !== void 0 ? z[V] : 0, L = (V, G) => values_close(D[V], E[G], O, F, I, R(V));
  if (D.length !== E.length) return D.every((V, G) => E.some((W, J) => L(G, J))) && E.every((V, G) => D.some((W, J) => L(J, G)));
  let q = D.length, U = Array(q).fill(-1), Z = (V, G) => {
    for (let W = 0; W < q; W++) if (!(G[W] || !L(V, W)) && (G[W] = !0, U[W] === -1 || Z(U[W], G))) return U[W] = V, !0;
    return !1;
  };
  for (let V = 0; V < q; V++) if (!Z(V, Array(q).fill(!1))) return !1;
  return !0;
}
function values_close(D, E, O, F, I, z = 0) {
  let R = mathjs_default.abs(D), L = mathjs_default.abs(E), q = Math.min(R, L), U = Math.max(R, L), Z = z;
  return Z += q * O, Z = Math.min(Z, 0.1 * q), Z === 0 && (D === 0 || E === 0) ? Z += I : Z += F, U === 0 || mathjs_default.abs(mathjs_default.subtract(D, E)) < Z;
}
var astToText = new astToText$2();
function generate_random_integer(D, E, O) {
  return D = mathjs_default.ceil(D), E = mathjs_default.floor(E), mathjs_default.floor(O() * (E - D + 1)) + D;
}
function random_cubic(D) {
  let E = (D() - 0.5) * 1, O = (D() - 0.5) * 2, F = (D() - 0.5) * 6, I = (D() - 0.5) * 24;
  return function(z) {
    return mathjs_default.add(mathjs_default.multiply(mathjs_default.add(mathjs_default.multiply(mathjs_default.add(mathjs_default.multiply(E, z), O), z), F), z), I);
  };
}
var equals$6 = function({ expr: D, other: E, randomBindings: O, expr_context: F, other_context: I, relative_tolerance: z = 1e-12, absolute_tolerance: R = 0, tolerance_for_zero: L = 1e-15, allowed_error_in_numbers: q = 0, include_error_in_number_exponents: U = !1, allowed_error_is_absolute: Z = !1, coerce_tuples_arrays: V = !0, coerce_vectors: G = !0, rng: W }) {
  if (F ||= D.context, I ||= E.context, Array.isArray(D.tree) && Array.isArray(E.tree)) {
    let J = D.tree[0], X = D.tree.slice(1), Y = E.tree[0], ee = E.tree.slice(1);
    if (J === "tuple" || J === "vector" || J === "altvector" || J === "list" || J === "array" || J === "matrix" || J === "interval") {
      if (Y !== J && ({ operator1: J, operator2: Y, operands1: X, operands2: ee } = coerce_tuple_array_vectors({ operator1: J, operator2: Y, operands1: X, operands2: ee, coerce_tuples_arrays: V, coerce_vectors: G })), Y !== J || ee.length !== X.length) return !1;
      for (let K = 0; K < X.length; K++) if (!equals$6({ expr: F.fromAst(X[K]), other: I.fromAst(ee[K]), randomBindings: O, expr_context: F, other_context: I, relative_tolerance: z, absolute_tolerance: R, tolerance_for_zero: L, allowed_error_in_numbers: q, include_error_in_number_exponents: U, allowed_error_is_absolute: Z, coerce_tuples_arrays: V, coerce_vectors: G, rng: W })) return !1;
      return !0;
    }
    if (X.length === 2 && ["=", ">", "<", "ge", "le"].includes(J)) {
      if (ee.length !== 2 || (J === ">" ? (J = "<", X = [X[1], X[0]]) : J === "ge" && (J = "le", X = [X[1], X[0]]), Y === ">" ? (Y = "<", ee = [ee[1], ee[0]]) : Y === "ge" && (Y = "le", ee = [ee[1], ee[0]]), J !== Y)) return !1;
      let K = ["+", X[0], ["-", X[1]]], te = ["+", ee[0], ["-", ee[1]]], ie = J !== "=";
      if (contains_pm(K) || contains_pm(te)) {
        if (J === "=") {
          let ne = (oe, se) => {
            let le = expand_pm_signs(oe), ce = [];
            for (let fe of le) {
              let pe = se.fromAst(fe).simplify().tree;
              ce.some((ve) => equal(ve, pe)) || ce.push(pe);
            }
            return ce.length === 1 ? ce[0] : ["*", ...ce];
          }, ae, ue;
          try {
            ae = ne(K, F), ue = ne(te, I);
          } catch {
            return !1;
          }
          return component_equals$1({ expr: F.fromAst(ae), other: I.fromAst(ue), randomBindings: O, expr_context: F, other_context: I, allow_proportional: !0, require_positive_proportion: !1, relative_tolerance: z, absolute_tolerance: R, tolerance_for_zero: L, allowed_error_in_numbers: q, include_error_in_number_exponents: U, allowed_error_is_absolute: Z, coerce_tuples_arrays: V, coerce_vectors: G, rng: W });
        }
        return pm_equals_numerical({ expr: F.fromAst(K), other: I.fromAst(te), randomBindings: O, expr_context: F, other_context: I, relative_tolerance: z, absolute_tolerance: R, tolerance_for_zero: L, allowed_error_in_numbers: q, include_error_in_number_exponents: U, allowed_error_is_absolute: Z, rng: W });
      }
      return component_equals$1({ expr: F.fromAst(K), other: I.fromAst(te), randomBindings: O, expr_context: F, other_context: I, allow_proportional: !0, require_positive_proportion: ie, relative_tolerance: z, absolute_tolerance: R, tolerance_for_zero: L, allowed_error_in_numbers: q, include_error_in_number_exponents: U, allowed_error_is_absolute: Z, coerce_tuples_arrays: V, coerce_vectors: G, rng: W });
    }
  }
  return contains_pm(D.tree) || contains_pm(E.tree) ? pm_equals_numerical({ expr: D, other: E, randomBindings: O, expr_context: F, other_context: I, relative_tolerance: z, absolute_tolerance: R, tolerance_for_zero: L, allowed_error_in_numbers: q, include_error_in_number_exponents: U, allowed_error_is_absolute: Z, rng: W }) : component_equals$1({ expr: D, other: E, randomBindings: O, expr_context: F, other_context: I, relative_tolerance: z, absolute_tolerance: R, tolerance_for_zero: L, allowed_error_in_numbers: q, include_error_in_number_exponents: U, allowed_error_is_absolute: Z, coerce_tuples_arrays: V, coerce_vectors: G, rng: W });
}, component_equals$1 = function({ expr: D, other: E, randomBindings: O, expr_context: F, other_context: I, allow_proportional: z = !1, require_positive_proportion: R = !1, relative_tolerance: L, absolute_tolerance: q, tolerance_for_zero: U, allowed_error_in_numbers: Z, include_error_in_number_exponents: V, allowed_error_is_absolute: G, coerce_tuples_arrays: W, coerce_vectors: J, rng: X }) {
  var Y = Number.MAX_VALUE * 1e-20, ee = 0, K = 10, te = 100, ie, ne, ae;
  ({ variables: ie, integer_variables: ne, functions: ae, expr: D, other: E } = prepare_exprs_numerical_eval(D, E, F, I));
  try {
    var ue = D.f(), oe = E.f();
  } catch {
    if (D.equalsViaSyntax(E, { allow_blanks: !0, allowed_error_in_numbers: Z, include_error_in_number_exponents: V, allowed_error_is_absolute: G, coerce_tuples_arrays: W, coerce_vectors: J })) return !0;
    if (!(Array.isArray(D.tree) && Array.isArray(E.tree)) || D.tree[0] !== E.tree[0]) return !1;
    let Ce = D.tree.slice(1), Ie = E.tree.slice(1);
    for (let Ne = 0; Ne < Ce.length; Ne++) if (!equals$6({ expr: F.fromAst(Ce[Ne]), other: I.fromAst(Ie[Ne]), randomBindings: O, expr_context: F, other_context: I, relative_tolerance: L, absolute_tolerance: q, tolerance_for_zero: U, allowed_error_in_numbers: Z, include_error_in_number_exponents: V, allowed_error_is_absolute: G, coerce_tuples_arrays: W, coerce_vectors: J, rng: X })) return !1;
    return !0;
  }
  let se, le, ce;
  if (Z > 0) {
    let Ce = replace_numbers_with_parameters({ expr: D, variables: ie, include_exponents: V });
    se = F.fromAst(Ce.expr_with_params), le = Ce.parameters;
    let Ie = Object.keys(le);
    if (Ie.length > 0) {
      let Ne = se.derivative(Ie[0]);
      if (G || (Ne = Ne.multiply(le[Ie[0]])), Ie.length > 1) for (let ke of Ie.slice(1)) {
        let xe = se.derivative(ke);
        G || (xe = xe.multiply(le[ke])), Ne = Ne.add(xe);
      }
      let he = Ne.multiply(Z);
      try {
        ce = he.f();
      } catch {
      }
    }
  }
  var fe = 1, pe = [10, 1, 100, 0.1, 1e3, 0.01], ve = 0;
  let _e = 0, de = !0, ge = 0;
  for (let Ce = 0; Ce < 10 * te; Ce++) {
    try {
      var ye = De(pe[ve], X);
    } catch {
      continue;
    }
    if (ye.always_zero === !1 && (de = !1), !ye.equal && !ye.out_of_bounds && !ye.always_zero && ye.sufficient_finite_values !== !1 && (ge++, ge > te)) return !1;
    if (ye.equal) if (ye.always_zero) {
      if (!de) continue;
      if (_e += 1, _e > 5 && (ve += 1, _e = 0), ve >= pe.length) return !0;
      continue;
    } else return !0;
  }
  return !1;
  function De(Ce, Ie) {
    var Ne = O(Ie, ie, Ce);
    for (let Qe = 0; Qe < ne.length; Qe++) Ne[ne[Qe]] = generate_random_integer(-10, 10, Ie);
    for (let Qe = 0; Qe < ae.length; Qe++) Ne[ae[Qe]] = random_cubic(Ie);
    var he;
    ce && (he = Object.assign({}, Ne, le));
    var ke = ue(Ne), xe = oe(Ne);
    if (typeof ke == "boolean" || typeof xe == "boolean") return { out_of_bounds: !0, always_zero: !1 };
    var Te = mathjs_default.abs(ke), Fe = mathjs_default.abs(xe);
    if (!(Te < Y && Fe < Y) || !((Te === 0 || Te > ee) && (Fe === 0 || Fe > ee))) return { out_of_bounds: !0, always_zero: !1 };
    var be = Math.min(Te, Fe), Ae = Math.max(Te, Fe), Me = 1;
    let $e = 0;
    if (ce) {
      try {
        $e = mathjs_default.abs(ce(he));
      } catch {
        return { equal_at_start: !1, always_zero: !1 };
      }
      if (!Number.isFinite($e)) return { equal_at_start: !1, always_zero: !1 };
    }
    if ($e += be * L, $e = Math.min($e, 0.1 * be), $e === 0 && (ke === 0 || xe === 0) ? $e += U : $e += q, !(Ae === 0 || mathjs_default.abs(mathjs_default.subtract(ke, xe)) < $e) && (!z || Te === 0 || Fe === 0 || (Me = mathjs_default.divide(ke, xe), R && !(Me > 0)))) return { equal_at_start: !1, always_zero: !1 };
    var Re = Ae === 0, je = 0;
    for (let Qe = 0; Qe < 100; Qe++) {
      var Pe = O(Ie, ie, fe / 100, Ne);
      for (let We = 0; We < ne.length; We++) Pe[ne[We]] = generate_random_integer(-10, 10, Ie);
      for (let We = 0; We < ae.length; We++) Pe[ae[We]] = random_cubic(Ie);
      var Ke;
      ce && (Ke = Object.assign({}, Pe, le));
      try {
        ke = ue(Pe), xe = mathjs_default.multiply(oe(Pe), Me);
      } catch {
        continue;
      }
      if (Te = mathjs_default.abs(ke), Fe = mathjs_default.abs(xe), Te < Y && Fe < Y) {
        be = Math.min(Te, Fe), Ae = Math.max(Te, Fe), je++;
        let We = 0;
        if (ce) {
          try {
            We = mathjs_default.abs(ce(Ke));
          } catch {
            continue;
          }
          if (!Number.isFinite(We)) continue;
        }
        if (We += be * L, We = Math.min(We, 0.1 * be), We === 0 && (ke === 0 || xe === 0) ? We += U : We += q, !(Ae === 0 || mathjs_default.abs(mathjs_default.subtract(ke, xe)) < We)) return { equality_in_middle: !1, always_zero: !1 };
        if (Re &&= Ae === 0, je >= K) return { equal: !0, always_zero: Re };
      }
    }
    return { sufficient_finite_values: !1, always_zero: Re };
  }
};
function prepare_exprs_numerical_eval(D, E, O, F) {
  O ||= D.context, F ||= E.context, { expr: D, other: E } = normalize_for_equality_checking(D, E, O, F);
  var I = [.../* @__PURE__ */ new Set([...D.variables(), ...E.variables()])];
  mathjs_default.define_pi && (I = I.filter(function(q) {
    return q !== "pi";
  })), mathjs_default.define_i && (I = I.filter(function(q) {
    return q !== "i";
  })), mathjs_default.define_e && (I = I.filter(function(q) {
    return q !== "e";
  }));
  var z = [];
  for (let q = 0; q < I.length; q++) (is_integer_ast(I[q], O.assumptions) || is_integer_ast(I[q], F.assumptions)) && z.push(I[q]);
  var R = [.../* @__PURE__ */ new Set([...D.functions(), ...E.functions()])].filter((q) => q.length === 1 || q.includes("_") || q.includes("^")), L = R.filter((q) => I.includes(q));
  if (R = R.filter((q) => !I.includes(q)), L.length > 0) {
    let q = D.tree, U = E.tree, Z = "x1";
    for (; [...R, ...I].includes(Z); ) Z += "x1";
    let V = "x2";
    for (; [...R, ...I].includes(V); ) V += "x2";
    for (let G of L) {
      let W = G + G;
      for (; [...R, ...I].includes(W); ) W += G;
      let J = [[["apply", G, Z], ["apply", W, Z], { variables: { [Z]: !0 } }]];
      q = applyAllTransformations(q, J), U = applyAllTransformations(U, J), R.push(W);
    }
    D = O.fromAst(q), E = F.fromAst(U);
  }
  return { variables: I, integer_variables: z, functions: R, expr: D, other: E };
}
function normalize_for_equality_checking(D, E, O, F) {
  O ||= D.context, F ||= E.context, D = D.normalize_function_names(), E = E.normalize_function_names(), D = D.log_subscript_to_two_arg_log(), E = E.log_subscript_to_two_arg_log(), D = D.subscripts_to_strings(), E = E.subscripts_to_strings(), D = D.normalize_applied_functions(), E = E.normalize_applied_functions();
  let I = rename_functions_with_exponents(D.tree), z = rename_functions_with_exponents(E.tree);
  return D = O.fromAst(rename_vecs(I)), E = F.fromAst(rename_vecs(z)), { expr: D, other: E };
}
function replace_numbers_with_parameters({ expr: D, variables: E, include_exponents: O = !1 }) {
  let F = {}, I = 0;
  function z() {
    I++;
    let L = "par" + I;
    for (; E.includes(L); ) I++, L = "par" + I;
    return L;
  }
  function R(L) {
    if (typeof L == "number") {
      if (L === 0) return L;
      {
        let Z = z();
        return F[Z] = L, Z;
      }
    }
    if (typeof L == "string") {
      if (L === "pi") {
        if (mathjs_default.define_pi) {
          let Z = z();
          return F[Z] = mathjs_default.PI, Z;
        }
      } else if (L === "e" && mathjs_default.define_e) {
        let Z = z();
        return F[Z] = mathjs_default.e, Z;
      }
      return L;
    }
    if (!Array.isArray(L)) return L;
    let q = L[0], U = L.slice(1);
    return q === "^" && !O ? [q, R(U[0]), U[1]] : [q, ...U.map(R)];
  }
  return D = D.evaluate_numbers({ max_digits: 1 / 0 }), { expr_with_params: R(D.tree), parameters: F };
}
function rename_functions_with_exponents(D) {
  if (!Array.isArray(D)) return D;
  let E = D[0], O = D.slice(1);
  if (E === "apply") {
    let F = O[0];
    return Array.isArray(F) && F[0] === "^" && F.slice(1).every((I) => ["number", "string"].includes(typeof I)) && (F = astToText.convert(F)), ["apply", F, O[1]];
  }
  return [E, ...O.map(rename_functions_with_exponents)];
}
function rename_vecs(D) {
  if (!Array.isArray(D)) return D;
  let E = D[0], O = D.slice(1);
  return E === "vec" && O.length === 1 ? "__vec_" + astToText.convert(O[0]) : [E, ...O.map(rename_vecs)];
}
function randomComplexBindings(D, E, O, F) {
  var I = {};
  return F === void 0 ? E.forEach(function(z) {
    I[z] = mathjs_default.complex(D() * 2 * O - O, D() * 2 * O - O);
  }) : E.forEach(function(z) {
    I[z] = mathjs_default.complex(F[z].re + D() * 2 * O - O, F[z].im + D() * 2 * O - O);
  }), I;
}
var equals$5 = function(D, E, { relative_tolerance: O = 1e-12, absolute_tolerance: F = 0, tolerance_for_zero: I = 1e-15, allowed_error_in_numbers: z = 0, include_error_in_number_exponents: R = !1, allowed_error_is_absolute: L = !1, allow_blanks: q = !1, coerce_tuples_arrays: U = !0, coerce_vectors: Z = !0 } = {}) {
  if (!q && (D.variables().includes("＿") || E.variables().includes("＿"))) return !1;
  let V = (0, import_seedrandom.default)("complex_seed");
  return D = D.remove_scaling_units(), E = E.remove_scaling_units(), equals$6({ expr: D, other: E, randomBindings: randomComplexBindings, expr_context: D.context, other_context: E.context, relative_tolerance: O, absolute_tolerance: F, tolerance_for_zero: I, allowed_error_in_numbers: z, include_error_in_number_exponents: R, allowed_error_is_absolute: L, coerce_tuples_arrays: U, coerce_vectors: Z, rng: V });
};
function randomRealBindings(D, E, O, F) {
  var I = {};
  return F === void 0 ? E.forEach(function(z) {
    I[z] = D() * 2 * O - O;
  }) : E.forEach(function(z) {
    I[z] = F[z] + D() * 2 * O - O;
  }), I;
}
var equals$4 = function(D, E, { relative_tolerance: O = 1e-12, absolute_tolerance: F = 0, tolerance_for_zero: I = 1e-15, allowed_error_in_numbers: z = 0, include_error_in_number_exponents: R = !1, allowed_error_is_absolute: L = !1 } = {}) {
  if (!D.isAnalytic() || !E.isAnalytic()) return !1;
  let q = seedrandom("real_seed");
  return equals$6({ expr: D, other: E, randomBindings: randomRealBindings, expr_context: D.context, other_content: E.context, relative_tolerance: O, absolute_tolerance: F, tolerance_for_zero: I, allowed_error_in_numbers: z, include_error_in_number_exponents: R, allowed_error_is_absolute: L, rng: q });
}, equals$3 = function(D, E, { allowed_error_in_numbers: O = 0, include_error_in_number_exponents: F = !1, allowed_error_is_absolute: I = !1, allow_blanks: z = !1, coerce_tuples_arrays: R = !0, coerce_vectors: L = !0 } = {}) {
  if (!z && (D.variables().includes("＿") || E.variables().includes("＿"))) return !1;
  let q = D.normalize_function_names().normalize_applied_functions().normalize_negative_numbers().normalize_angle_linesegment_arg_order(), U = E.normalize_function_names().normalize_applied_functions().normalize_negative_numbers().normalize_angle_linesegment_arg_order();
  return equal(q.tree, U.tree, { allowed_error_in_numbers: O, include_error_in_number_exponents: F, allowed_error_is_absolute: I, coerce_tuples_arrays: R, coerce_vectors: L });
};
function randomFiniteFieldBindings(D, E, O) {
  var F = {};
  return E.forEach(function(I) {
    F[I] = Math.floor(D() * O);
  }), F;
}
var equals$2 = function(D, E, { allow_blanks: O = !1, coerce_tuples_arrays: F = !0, coerce_vectors: I = !0 } = {}) {
  if (!O && (D.variables().includes("＿") || E.variables().includes("＿"))) return !1;
  let z = (0, import_seedrandom.default)("finite_field_seed");
  if (Array.isArray(D.tree) && Array.isArray(E.tree)) {
    let V = D.tree[0], G = D.tree.slice(1), W = E.tree[0], J = E.tree.slice(1);
    if (V === "tuple" || V === "vector" || V === "altvector" || V === "list" || V === "array" || V === "matrix" || V === "interval") {
      if (W !== V && ({ operator1: V, operator2: W, operands1: G, operands2: J } = coerce_tuple_array_vectors({ operator1: V, operator2: W, operands1: G, operands2: J, coerce_tuples_arrays: F, coerce_vectors: I })), W !== V || J.length !== G.length) return !1;
      for (let X = 0; X < G.length; X++) if (equals$2(D.context.fromAst(G[X]), E.context.fromAst(J[X]), z) === !1) return !1;
      return;
    }
    if (G.length === 2 && ["=", ">", "<", "ge", "le"].includes(V)) {
      if (J.length !== 2 || (V === ">" ? (V = "<", G = [G[1], G[0]]) : V === "ge" && (V = "le", G = [G[1], G[0]]), W === ">" ? (W = "<", J = [J[1], J[0]]) : W === "ge" && (W = "le", J = [J[1], J[0]]), V !== W)) return !1;
      let X = ["+", G[0], ["-", G[1]]], Y = ["+", J[0], ["-", J[1]]], ee = V !== "=", K = D.context.fromAst(X), te = E.context.fromAst(Y);
      try {
        let ie = prepare_exprs_numerical_eval(K, te);
        if (ie.functions.length === 0) {
          var R = ie.expr.f(), L = ie.other.f();
          let ne = Number.MAX_VALUE * 1e-20;
          for (let ae = 0; ae < 10; ae++) {
            var q = {};
            ie.variables.forEach(function(le) {
              q[le] = z() * 2 - 1;
            });
            for (let le = 0; le < ie.integer_variables.length; le++) q[ie.integer_variables[le]] = mathjs_default.floor(z() * 21) - 10;
            let ue = R(q), oe = L(q);
            var U = mathjs_default.abs(ue), Z = mathjs_default.abs(oe);
            if (!(U < ne && Z < ne) || U == 0 || Z === 0) continue;
            let se = mathjs_default.divide(ue, oe);
            if (ee && !(se > 0)) return !1;
            if (se !== 1) {
              let le = rationalApproximation(se);
              te = E.context.fromAst(["*", ["/", le.numerator, le.denominator], Y]);
            }
            break;
          }
        }
      } catch {
        return;
      }
      return component_equals(K, te, z);
    }
  }
  return component_equals(D, E, z);
}, component_equals = function(D, E, O) {
  ({ expr: D, other: E } = normalize_for_equality_checking(D, E));
  let F = [1181, 1187, 1193, 1201, 1213, 1217, 1223, 1229, 1231];
  var I = [.../* @__PURE__ */ new Set([...D.variables(), ...E.variables()])];
  for (let z of F) {
    let R = randomFiniteFieldBindings(O, I, z);
    try {
      let L = D.finite_field_evaluate(R, z), q = E.finite_field_evaluate(R, z);
      if (!L.approximate && !q.approximate && !L.isNaN() && !q.isNaN() && L.values.length > 0 && q.values.length > 0 && !L.equals(q)) return !1;
    } catch {
      return;
    }
  }
}, equals$1 = function(D, E, { min_elements_match: O = 3, match_partial: F = !1 } = {}) {
  if (!is_discrete_infinite_set(D)) return !1;
  if (is_discrete_infinite_set(E)) {
    var I = [];
    let z = D.context.get_assumptions(D);
    if (z !== void 0 && I.push(z), z = E.context.get_assumptions(E), z !== void 0 && I.push(z), I = I.length === 0 ? void 0 : I.length === 1 ? I[0] : clean_assumptions(["and"].concat(I)), F) {
      let R = contained_in(D.tree, E.tree, I, F);
      if (R === !1) return 0;
      let L = contained_in(E.tree, D.tree, I, F);
      return L === !1 ? 0 : R === !0 ? L === !0 ? 1 : L : L === !0 ? R : Math.min(R, L);
    } else return contained_in(D.tree, E.tree, I, F) && contained_in(E.tree, D.tree, I, F);
  } else {
    let z = E.tree;
    if (z[0] !== "list") return !1;
    let R = z.length - 2;
    if (z[R + 1][0] !== "ldots" || R < O) return !1;
    let L = z.slice(0, R + 1), q = sequence_from_discrete_infinite(D, R);
    return q ? (q = ["list"].concat(q), equals(D.context.from(q), E.context.from(L))) : !1;
  }
};
function is_discrete_infinite_set(D) {
  var E = D.tree;
  if (!Array.isArray(E) || E[0] !== "discrete_infinite_set") return !1;
  for (var O of E.slice(1)) if (!Array.isArray(O) || O[0] !== "tuple" || O.length !== 5) return !1;
  return !0;
}
function contained_in(D, E, O, F) {
  if (D[0] === "discrete_infinite_set") if (F) {
    let G = 0;
    for (let J of D.slice(1)) {
      let X = contained_in(J, E, O, F);
      X === !0 ? G++ : X !== !1 && (G += X);
    }
    let W = D.length - 1;
    return G === W ? !0 : G === 0 ? !1 : G / W;
  } else return D.slice(1).every((G) => contained_in(G, E, O));
  var I = D[1], z = D[2], R = evaluate_numbers(D[3], O), L = D[4];
  if (R !== -1 / 0 || L !== 1 / 0) return !1;
  I = simplify(["/", I, z], O, 1 / 0);
  var q = E.slice(1), U = [];
  for (let G = 0; G < q.length; G++) {
    let W = evaluate_numbers(q[G][3]), J = q[G][4];
    if (W !== -1 / 0 || J !== 1 / 0) return !1;
    let X = simplify(["/", q[G][1], z], O, 1 / 0), Y = simplify(["/", q[G][2], z], O, 1 / 0);
    if (typeof Y != "number") return !1;
    let ee = mathjs_default.fraction(Y), K = mathjs_default.number(ee.n), te = mathjs_default.number(ee.d);
    U.push([K, te, X, Y]);
  }
  for (U.sort(); U[0][0] === 1; ) {
    let G = U[0][2], W = U[0][3], J = simplify(expand(["+", G, ["-", I]]), O, 1 / 0);
    if (Number.isFinite(J) && Number.isFinite(W) && (J = mathjs_default.mod(J, W), mathjs_default.min(J, W - J) < 1e-10 * W)) return !0;
    if (U.splice(0, 1), U.length === 0) return !1;
  }
  var Z = [...new Set(U.map((G) => G[0]))];
  let V = 0;
  for (let G of Z) {
    let W = U.map(function(X, Y) {
      if (mathjs_default.mod(G, X[0]) === 0) {
        let ee = G / X[0];
        return [X[0], ee, Y];
      } else return;
    }).filter((X) => X), J = [];
    for (let X of W) {
      let Y = X[0], ee = X[1], K = X[2], te = U[K][2], ie = U[K][3];
      for (let ne = 0; ne < Y; ne++) {
        let ae = simplify(expand(["+", te, ["-", ["+", I, ne]]]), O, 1 / 0);
        if (Number.isFinite(ae) && Number.isFinite(ie) && (ae = mathjs_default.mod(ae, ie), mathjs_default.min(ae, ie - ae) < 1e-10 * ie)) {
          for (let oe = 0; oe < ee; oe++) J[ne + oe * Y] = !0;
          let ue = !0;
          for (let oe = 0; oe < G; oe++) if (!J[oe]) {
            ue = !1;
            break;
          }
          if (ue) return !0;
          break;
        }
      }
    }
    if (F) {
      let X = 0;
      for (let Y = 0; Y < G; Y++) J[Y] && X++;
      X /= G, X > V && (V = X);
    }
  }
  return F && V > 0 ? V : !1;
}
function sequence_from_discrete_infinite(D, E) {
  var O = D.tree.slice(1);
  if (O.length > 1) return;
  let F = O[0][1], I = O[0][2], z = evaluate_numbers(O[0][3]), R = O[0][4];
  if (!Number.isInteger(z) || R !== 1 / 0) return;
  let L = [];
  for (let q = 0; q < E; q++) L.push(evaluate_numbers(["+", ["*", I, z + q], F]));
  return L;
}
var equality_exports = __exportAll({ equals: () => equals, equalsDiscreteInfinite: () => equals$1, equalsViaComplex: () => equals$5, equalsViaFiniteField: () => equals$2, equalsViaReal: () => equals$4, equalsViaSyntax: () => equals$3 }), equals = function(D, E, { relative_tolerance: O = 1e-12, absolute_tolerance: F = 0, tolerance_for_zero: I = 1e-15, allowed_error_in_numbers: z = 0, include_error_in_number_exponents: R = !1, allowed_error_is_absolute: L = !1, allow_blanks: q = !1, coerce_tuples_arrays: U = !0, coerce_vectors: Z = !0 } = {}) {
  if (!q && (D.variables().includes("＿") || E.variables().includes("＿"))) return !1;
  let V = D.evaluate_numbers({ max_digits: 1 / 0 }).normalize_function_names().normalize_applied_functions().normalize_negative_numbers().normalize_angle_linesegment_arg_order().remove_scaling_units().simplify(), G = E.evaluate_numbers({ max_digits: 1 / 0 }).normalize_function_names().normalize_applied_functions().normalize_negative_numbers().normalize_angle_linesegment_arg_order().remove_scaling_units().simplify();
  return V.equalsViaSyntax(G, { allowed_error_in_numbers: z, include_error_in_number_exponents: R, allowed_error_is_absolute: L, allow_blanks: !0, coerce_tuples_arrays: U, coerce_vectors: Z }) ? !0 : z === 0 && D.equalsViaFiniteField(E, { allow_blanks: !0, coerce_tuples_arrays: U, coerce_vectors: Z }) == 0 ? !1 : D.equalsViaComplex(E, { relative_tolerance: O, absolute_tolerance: F, tolerance_for_zero: I, allowed_error_in_numbers: z, include_error_in_number_exponents: R, allowed_error_is_absolute: L, allow_blanks: !0, coerce_tuples_arrays: U, coerce_vectors: Z }) ? !0 : !!equals$1(D, E);
}, sign_error_exports = __exportAll({ equalSpecifiedSignErrors: () => equalSpecifiedSignErrors, equalWithSignErrors: () => equalWithSignErrors }), equalWithSignErrors = function(D, E, { equalityFunction: O = equals, max_sign_errors: F = 1 } = {}) {
  if (O(D, E)) return { matched: !0, n_sign_errors: 0 };
  for (let I = 1; I <= F; I++) if (equalSpecifiedSignErrors(D, E, { equalityFunction: O, n_sign_errors: I })) return { matched: !0, n_sign_errors: I };
  return { matched: !1 };
}, equalSpecifiedSignErrors = function(D, E, { equalityFunction: O = equals, n_sign_errors: F = 1 } = {}) {
  if (F === 0) return O(D, E);
  if (!(Number.isInteger(F) && F > 0)) throw Error(`Have not implemented equality check with ${F} sign errors.`);
  if (F > 1) {
    let Z = O;
    O = function(V, G) {
      return equalSpecifiedSignErrors(V, G, { equalityFunction: Z, n_sign_errors: F - 1 });
    };
  }
  var I = D.tree, z = [[I]], R = 0, L, q;
  D.tree = ["-", I];
  var U = O(D, E);
  if (D.tree = I, U) return !0;
  for (; L = z[R++]; ) if (L = L[0], Array.isArray(L)) {
    for (q = 1; q < L.length; q++) if (z.push([L[q]]), L[q] = ["-", L[q]], U = O(D, E), L[q] = L[q][1], U) return !0;
  }
  return !1;
}, arithmetic_exports = __exportAll({ add: () => add, copy: () => copy, divide: () => divide, mod: () => mod$2, multiply: () => multiply, pow: () => pow, subtract: () => subtract });
function add(D, E) {
  return clean(["+", get_tree(D), get_tree(E)]);
}
function subtract(D, E) {
  return clean(["+", get_tree(D), ["-", get_tree(E)]]);
}
function multiply(D, E) {
  return clean(["*", get_tree(D), get_tree(E)]);
}
function divide(D, E) {
  return clean(["/", get_tree(D), get_tree(E)]);
}
function pow(D, E) {
  return clean(["^", get_tree(D), get_tree(E)]);
}
function mod$2(D, E) {
  return clean(["apply", "mod", ["tuple", get_tree(D), get_tree(E)]]);
}
function copy(D) {
  return get_tree(D);
}
var analytic_exports = __exportAll({ isAnalytic: () => isAnalytic }), analytic_operators = ["+", "-", "*", "/", "^", "tuple", "vector", "altvector", "list", "array", "matrix", "interval", "vec"], non_analytic_functions = ["abs", "sign", "arg"], relation_operators = ["=", "le", "ge", "<", ">"];
function isAnalytic(D, { allow_abs: E = !1, allow_arg: O = !1, allow_relation: F = !1 } = {}) {
  var I = normalize_applied_functions(normalize_function_names(D));
  I = subscripts_to_strings(I);
  var z = operators$3(I);
  for (let L = 0; L < z.length; L++) {
    let q = z[L];
    if (analytic_operators.indexOf(q) === -1) if (F) {
      if (relation_operators.indexOf(q) === -1) return !1;
    } else return !1;
  }
  var R = functions$2(I);
  for (let L = 0; L < R.length; L++) {
    let q = R[L];
    if (non_analytic_functions.includes(q) && !(E && q == "abs" || O && q == "arg")) return !1;
  }
  return !0;
}
var sets_exports = __exportAll({ create_discrete_infinite_set: () => create_discrete_infinite_set });
function create_discrete_infinite_set({ offsets: D, periods: E, min_index: O = ["-", 1 / 0], max_index: F = 1 / 0 } = {}) {
  if (D = get_tree(D), E = get_tree(E), O = get_tree(O), F = get_tree(F), D === void 0 || E === void 0) return;
  let I = [];
  if (D[0] === "list") if (E[0] === "list") {
    if (D.length !== E.length || D.length === 1) return;
    for (let z = 1; z < D.length; z++) I.push(["tuple", D[z], E[z], O, F]);
  } else for (let z = 1; z < D.length; z++) I.push(["tuple", D[z], E, O, F]);
  else I.push(["tuple", D, E, O, F]);
  return ["discrete_infinite_set"].concat(I);
}
var matrix_exports = __exportAll({ cross_prod: () => cross_prod, dot_prod: () => dot_prod, matrix: () => matrix, scalar_mul: () => scalar_mul, vector_add: () => vector_add, vector_sub: () => vector_sub });
function tuple(D) {
  var E = [];
  E.push("tuple");
  var O = D.length;
  for (let F = 0; F < O; F++) E.push(D[F]);
  return E;
}
function matrix(D) {
  var E = [];
  E.push("matrix");
  var O = D.length, F = D[0].length;
  for (let z = 1; z < O; z++) if (D[z].length !== F) throw Error("Matrix dimensions mismatch");
  E.push(tuple([O, F]));
  let I = [];
  for (let z = 0; z < O; z++) I.push(tuple(D[z].map(function(R) {
    return R.tree;
  })));
  return E.push(tuple(I)), E;
}
function vector_add(D, E) {
  if (D = get_tree(D), E = get_tree(E), D.length !== E.length || D[0] !== "tuple" && D[0] !== "vector" && D[0] !== "altvector" || E[0] !== "tuple" && E[0] !== "vector" && E[0] !== "altvector") throw Error("Can't add. Those aren't vectors, or the dimensions don't match");
  var O = D[0] === "altvector" && E[0] === "altvector" ? ["altvector"] : ["vector"], F = D.length;
  for (let I = 1; I < F; I += 1) O.push(["+", D[I], E[I]]);
  return simplify(O);
}
function scalar_mul(D, E) {
  if (E = get_tree(E), E[0] !== "tuple" && E[0] !== "vector" && E[0] !== "altvector") throw Error("Can't scalar multiply. Isn't a vector");
  var O = E[0] === "altvector" ? ["altvector"] : ["vector"], F = E.length;
  for (let I = 1; I < F; I += 1) O.push(["*", E[I], D]);
  return simplify(O);
}
function vector_sub(D, E) {
  return vector_add(D, scalar_mul(-1, E));
}
function dot_prod(D, E) {
  if (D = get_tree(D), E = get_tree(E), D.length !== E.length || D[0] !== "tuple" && D[0] !== "vector" && D[0] !== "altvector" || E[0] !== "tuple" && E[0] !== "vector" && E[0] !== "altvector") throw Error("Can't take dot product. Those aren't vectors, or the dimensions don't match");
  var O = 0, F = 0, I = D.length;
  for (let z = 1; z < I; z += 1) F = ["*", D[z], E[z]], O = ["+", O, F];
  return simplify(O);
}
function cross_prod(D, E) {
  if (D = get_tree(D), E = get_tree(E), D[0] !== "tuple" && D[0] !== "vector" && D[0] !== "altvector" || E[0] !== "tuple" && E[0] !== "vector" && E[0] !== "altvector") throw Error("Can't take cross product. Those aren't vectors");
  if (D.length === 3 && E.length === 3) return simplify(["+", ["*", D[1], E[2]], ["-", ["*", D[2], E[1]]]]);
  if (D.length === 4 && E.length === 4) {
    var O = ["+", ["*", D[2], E[3]], ["-", ["*", D[3], E[2]]]], F = ["+", ["*", D[3], E[1]], ["-", ["*", D[1], E[3]]]], I = ["+", ["*", D[1], E[2]], ["-", ["*", D[2], E[1]]]];
    return simplify([D[0] === "altvector" && E[0] === "altvector" ? "altvector" : "vector", O, F, I]);
  }
  throw Error("Can't take cross product. The dimensions aren't both 2 or 3.");
}
var astToGuppy$1 = class fr {
  constructor() {
    this.operators = { "+": function(E) {
      return E.join("<e>+</e>");
    }, "-": function(E) {
      return "<e>-" + E.join("-") + "</e>";
    }, "*": function(E) {
      return E.join('<f type="*" group="operations" c="yes"><b p="latex">\\cdot</b><b p="text">*</b></f>');
    }, "/": function(E) {
      return fr.dfrac(E[0], E[1]);
    }, "^": function(E) {
      return fr.power(E[0], E[1]);
    }, sin: function(E) {
      return fr.trig("sin", E[0]);
    }, cos: function(E) {
      return fr.trig("cos", E[0]);
    }, tan: function(E) {
      return fr.trig("tan", E[0]);
    }, arcsin: function(E) {
      return fr.trig("arcsin", E[0]);
    }, arccos: function(E) {
      return fr.trig("arccos", E[0]);
    }, arctan: function(E) {
      return fr.trig("arctan", E[0]);
    }, arccsc: function(E) {
      return fr.trig("arccsc", E[0]);
    }, arcsec: function(E) {
      return fr.trig("arcsec", E[0]);
    }, arccot: function(E) {
      return fr.trig("arccot", E[0]);
    }, csc: function(E) {
      return fr.trig("csc", E[0]);
    }, sec: function(E) {
      return fr.trig("sec", E[0]);
    }, cot: function(E) {
      return fr.trig("cot", E[0]);
    }, log: function(E) {
      return fr.trig("log", E[0]);
    }, exp: function(E) {
      return fr.trig("exp", E[0]);
    }, ln: function(E) {
      return fr.trig("ln", E[0]);
    }, sqrt: function(E) {
      return fr.sqrt(E[0]);
    }, abs: function(E) {
      return fr.abs(E[0]);
    } };
  }
  static dfrac(E, O) {
    return '<f type="fraction" group="functions"><b p="latex">\\dfrac{<r ref="1"/>}{<r ref="2"/>}</b><b p="small_latex">\\frac{<r ref="1"/>}{<r ref="2"/>}</b><b p="text">(<r ref="1"/>)/(<r ref="2"/>)</b><c up="1" down="2" name="numerator"><e></e>' + E + '<e></e></c><c up="1" down="2" name="denominator"><e></e>' + O + "<e></e></c></f>";
  }
  static trig(E, O) {
    return '<f type="' + E + '" group="functions"><b p="latex">\\' + E + '\\left(<r ref="1"/>\\right)</b><b p="text"> ' + E + '(<r ref="1"/>)</b><c delete="1"><e></e>' + O + "<e></e></c></f>";
  }
  static sqrt(E) {
    return '<f type="square_root" group="functions"><b p="latex">\\sqrt{<r ref="1"/>}</b><b p="text">sqrt(<r ref="1"/>)</b><c delete="1"><e></e>' + E + "<e></e></c></f>";
  }
  static power(E, O) {
    return '<f type="exponential" group="functions"><b p="latex">{<r ref="1"/>}^{<r ref="2"/>}</b><b p="text">(<r ref="1"/>)^(<r ref="2"/>)</b><c up="2" bracket="yes" delete="1" name="base"><e></e>' + E + '<e></e></c><c down="1" delete="1" name="exponent" small="yes"><e></e>' + O + "<e></e></c></f>";
  }
  static abs(E) {
    return '<f type="absolute_value" group="functions"><b p="latex">\\left|<r ref="1"/>\\right|</b><b p="text">abs(<r ref="1"/>)</b><c delete="1"><e></e>' + E + "<e></e></c></f>";
  }
  static paren(E) {
    return '<f type="bracket" group="functions"><b p="latex">\\left(<r ref="1"/>\\right)</b><b p="text">(<r ref="1"/>)</b><c delete="1" is_bracket="yes"><e></e>' + E + "<e></e></c></f>";
  }
  static isFunctionSymbol(E) {
    return ["sin", "cos", "tan", "csc", "sec", "cot", "arcsin", "arccos", "arctan", "arccsc", "arcsec", "arccot", "log", "ln", "exp", "sqrt", "abs", "this.factorial"].indexOf(E) !== -1;
  }
  static isGreekLetterSymbol(E) {
    return "pi.theta.theta.Theta.alpha.nu.beta.xi.Xi.gamma.Gamma.delta.Delta.pi.Pi.epsilon.epsilon.rho.rho.zeta.sigma.Sigma.eta.tau.upsilon.Upsilon.iota.phi.phi.Phi.kappa.chi.lambda.Lambda.psi.Psi.omega.Omega".split(".").indexOf(E) !== -1;
  }
  factorWithParenthesesIfNegated(E) {
    var O = this.factor(E);
    return O.toString().match(/^<e>-/) ? fr.paren(O.toString()) : O;
  }
  factor(E) {
    if (typeof E == "string") return fr.isGreekLetterSymbol(E) ? '<f type="' + E + '" group="greek" c="yes"><b p="latex">\\' + E + '</b><b p="text"> $' + E + "</b></f>" : "<e>" + E + "</e>";
    if (typeof E == "number") return "<e>" + E + "</e>";
    if (!Array.isArray(E)) return "<e></e>";
    var O = E[0], F = E.slice(1);
    return O === "apply" && (O = E[1], F = E.slice(2)), O === "abs" ? this.operators[O](F.map((function(I, z) {
      return this.expression(I);
    }).bind(this))) : fr.isFunctionSymbol(O) ? O === "this.factorial" && (F[0].toString().length === 1 || F[0].toString().match(/^[0-9]*$/)) ? this.operators[O](F) : this.operators[O](F.map((function(I, z) {
      return this.factor(I);
    }).bind(this))) : O === "^" || O === "~" ? this.operators[O](F.map((function(I, z) {
      return this.factor(I);
    }).bind(this))) : fr.paren(this.expression(E));
  }
  term(E) {
    if (!Array.isArray(E)) return this.factor(E);
    var O = E[0], F = E.slice(1);
    return O === "*" ? this.operators[O](F.map((function(I, z) {
      var R = this.factorWithParenthesesIfNegated(I);
      return R.toString().match(/^[0-9]/) && z > 0 ? " * " + R : R;
    }).bind(this))) : O === "/" ? this.operators[O](F.map((function(I, z) {
      return this.factor(I);
    }).bind(this))) : this.factor(E);
  }
  expression(E) {
    if (!Array.isArray(E)) return this.term(E);
    var O = E[0], F = E.slice(1);
    return O === "+" || O === "-" ? this.operators[O](F.map((function(I, z) {
      return this.factorWithParenthesesIfNegated(I);
    }).bind(this))) : this.term(E);
  }
  convert(E) {
    return ("<m><e></e>" + this.expression(E) + "<e></e></m>").replace(/<\/e><e>/g, "");
  }
}, glslOperators = { "+": function(D) {
  var E = D[0];
  return D.slice(1).forEach(function(O) {
    E = E + "+" + O;
  }), E;
}, "-": function(D) {
  var E = "-" + D[0];
  return D.slice(1).forEach(function(O) {
    E = E + "-" + O;
  }), E;
}, "~": function(D) {
  var E = "vec2(0.0,0.0)";
  return D.forEach(function(O) {
    E = E + "-" + O;
  }), E;
}, "*": function(D) {
  var E = D[0];
  return D.slice(1).forEach(function(O) {
    E = "cmul(" + E + "," + O + ")";
  }), E;
}, "/": function(D) {
  var E = D[0];
  return D.slice(1).forEach(function(O) {
    E = "cdiv(" + E + "," + O + ")";
  }), E;
}, sin: function(D) {
  return "csin(" + D[0] + ")";
}, cos: function(D) {
  return "ccos(" + D[0] + ")";
}, tan: function(D) {
  return "ctan(" + D[0] + ")";
}, sinh: function(D) {
  return "csinh(" + D[0] + ")";
}, cosh: function(D) {
  return "ccosh(" + D[0] + ")";
}, arcsin: function(D) {
  return "carcsin(" + D[0] + ")";
}, arccos: function(D) {
  return "carccos(" + D[0] + ")";
}, arctan: function(D) {
  return "carctan(" + D[0] + ")";
}, arccsc: function(D) {
  return "carcsin(cdiv(vec2(1.0,0)," + D[0] + "))";
}, arcsec: function(D) {
  return "carccos(cdiv(vec2(1.0,0)," + D[0] + "))";
}, arccot: function(D) {
  return "carctan(cdiv(vec2(1.0,0)," + D[0] + "))";
}, csc: function(D) {
  return "ccsc(" + D[0] + ")";
}, sec: function(D) {
  return "csec(" + D[0] + ")";
}, cot: function(D) {
  return "ccot(" + D[0] + ")";
}, exp: function(D) {
  return "cexp(" + D[0] + ")";
}, conj: function(D) {
  return "conjugate(" + D[0] + ")";
}, sqrt: function(D) {
  return "cpower(" + D[0] + ",vec2(0.5,0.0))";
}, log: function(D) {
  return "clog(" + D[0] + ")";
}, ln: function(D) {
  return "clog(" + D[0] + ")";
}, "^": function(D) {
  return "cpower(" + D[0] + "," + D[1] + ")";
}, abs: function(D) {
  return "cabs(" + D[0] + ")";
}, apply: function(D) {
  return "vec2(NaN,NaN)";
} }, astToGLSL$1 = class {
  constructor() {
  }
  convert(D) {
    if (typeof D == "boolean") throw Error("no support for boolean");
    if (typeof D == "string") return D === "e" ? "vec2(2.71828182845905,0.0)" : D === "pi" ? "vec2(3.14159265358979,0.0)" : D === "i" ? "vec2(0.0,1.0)" : String(D);
    if (typeof D == "number") return "vec2(" + String(D) + ",0.0)";
    if ("real" in D && "imaginary" in D) return D;
    if (!Array.isArray(D)) throw Error("Invalid ast");
    var E = D[0], O = D.slice(1);
    if (E === "apply") {
      if (typeof O[0] != "string") throw Error("Non string functions not implemented for conversion to GLSL");
      var E = O[0], O = O.slice(1);
      return glslOperators[E](O.map((function(z, R) {
        return this.convert(z);
      }).bind(this)));
    }
    if (E in glslOperators) return glslOperators[E](O.map((function(F, I) {
      return this.convert(F);
    }).bind(this)));
    throw Error("Operator " + E + " not implemented for conversion to mathjs");
  }
}, printing_exports = __exportAll({ tex: () => tex, toGLSL: () => toGLSL, toLatex: () => toLatex$1, toString: () => toString$2, toXML: () => toXML }), astToGuppy = new astToGuppy$1(), astToGLSL = new astToGLSL$1(), tex = function(D, E) {
  return new astToLatex$1(E).convert(D.tree);
}, toLatex$1 = tex, toString$2 = function(D, E) {
  return new astToText$2(E).convert(D.tree);
}, toGLSL = function(D) {
  return astToGLSL.convert(D.tree);
}, toXML = function(D) {
  return astToGuppy.convert(D.tree);
}, integration_exports = __exportAll({ integrateNumerically: () => integrateNumerically }), integrateNumerically = function(D, E, O, F) {
  for (var I = 100, z = 0, R = {}, L = 0; L < I; L++) R[E] = O + (F - O) * (L + 0.5) / I, z += D.evaluate(R);
  return z * (F - O) / I;
};
init_index_all(), init_index_all();
function expression_to_polynomial(D) {
  var E = get_tree(D);
  if (typeof E == "string") return E === "pi" && mathjs_default.define_pi || E === "i" && mathjs_default.define_i || E === "e" && mathjs_default.define_e ? E : ["polynomial", E, [[1, 1]]];
  if (typeof E == "number") return E;
  var O = evaluate_to_constant(E, { remove_units_first: !1 });
  if (Number.isFinite(O)) return simplify(E);
  if (!Array.isArray(E) || !operators$3(E).every((q) => ["+", "-", "*", "^", "/", "_", "prime"].includes(q))) return !1;
  var F = E[0], I = E.slice(1);
  if (F === "+") {
    let q = I.map(expression_to_polynomial);
    return q.every((U) => U !== !1) ? q.reduce((U, Z) => polynomial_add(U, Z)) : !1;
  } else if (F === "-") {
    let q = expression_to_polynomial(I[0]);
    return q ? polynomial_neg(q) : !1;
  } else if (F === "*") {
    let q = I.map(expression_to_polynomial);
    return q.every((U) => U !== !1) ? q.reduce((U, Z) => polynomial_mul(U, Z)) : !1;
  } else if (F === "^") {
    let q = I[0], U = expression_to_polynomial(q);
    if (U === !1) return !1;
    let Z = simplify(I[1]);
    if (typeof Z != "number" || Z < 0 || !Number.isInteger(Z)) {
      let V = evaluate_to_constant(Z, { remove_units_first: !1 });
      if (Number.isFinite(V)) {
        let G = mathjs_default.fraction(V), W = { n: mathjs_default.number(G.n), d: mathjs_default.number(G.d), s: mathjs_default.number(G.s) };
        if (W.d <= 100) {
          q = W.s < 0 ? ["^", q, ["/", -1, W.d]] : ["^", q, ["/", 1, W.d]];
          var z = ["polynomial", simplify(q), []];
          return z[2].push([W.n, 1]), z;
        }
      }
      return ["polynomial", E, [[1, 1]]];
    }
    return Z === 0 ? 1 : Z === 1 ? U : polynomial_pow(U, Z);
  } else if (F === "/") {
    var R = I[1], L = evaluate_to_constant(R, { remove_units_first: !1 });
    return Number.isFinite(L) ? polynomial_mul(expression_to_polynomial(I[0]), ["/", 1, L]) : ["polynomial", E, [[1, 1]]];
  } else return ["polynomial", E, [[1, 1]]];
}
function polynomials_in_same_leading_variable(D, E) {
  return D[1] !== E[1] && (compare_function(D[1], E[1]) < 0 ? E = ["polynomial", D[1], [[0, E]]] : D = ["polynomial", E[1], [[0, D]]]), [D, E];
}
function polynomial_add(D, E) {
  if (D[0] !== "polynomial") {
    if (E[0] !== "polynomial") return simplify(["+", D, E]);
    D = ["polynomial", E[1], [[0, D]]];
  } else if (E[0] !== "polynomial") E = ["polynomial", D[1], [[0, E]]];
  else {
    let Z = polynomials_in_same_leading_variable(D, E);
    D = Z[0], E = Z[1];
  }
  let O = ["polynomial", D[1], []], F = D[2], I = E[2], z = O[2], R = F.length, L = I.length, q = 0, U = 0;
  for (; q < R || U < L; ) if (q === R) I[U][1] && z.push(I[U]), U += 1;
  else if (U === L) F[q][1] && z.push(F[q]), q += 1;
  else if (F[q][0] === I[U][0]) {
    let Z = polynomial_add(F[q][1], I[U][1]);
    Z && z.push([F[q][0], Z]), q += 1, U += 1;
  } else F[q][0] < I[U][0] ? (F[q][1] && z.push(F[q]), q += 1) : (I[U][1] && z.push(I[U]), U += 1);
  return z.length === 0 ? 0 : z.length === 1 && z[0][0] === 0 ? z[0][1] : O;
}
function polynomial_neg(D) {
  if (D[0] !== "polynomial") return simplify(["-", D]);
  let E = ["polynomial", D[1], []], O = D[2], F = E[2], I = O.length;
  for (var z = 0; z < I; z += 1) F.push([O[z][0], polynomial_neg(O[z][1])]);
  return E;
}
function polynomial_sub(D, E) {
  return polynomial_add(D, polynomial_neg(E));
}
function polynomial_mul(D, E) {
  if (D[0] !== "polynomial") {
    if (E[0] !== "polynomial") return simplify(["*", D, E]);
    if (D) {
      let Z = ["polynomial", E[1], []], V = E[2], G = Z[2];
      for (let W of V) W[1] && G.push([W[0], polynomial_mul(D, W[1])]);
      return Z;
    }
  } else if (E && E[0] !== "polynomial") {
    let Z = ["polynomial", D[1], []], V = D[2], G = Z[2];
    for (let W of V) W[1] && G.push([W[0], polynomial_mul(W[1], E)]);
    return Z;
  }
  let O = polynomials_in_same_leading_variable(D, E);
  D = O[0], E = O[1];
  let F = D[2], I = E[2], z = ["polynomial", D[1], []], R = z[2], L = F.length, q = I.length, U = [];
  for (let Z of F) for (let V of I) {
    let G = !1, W = Z[0] + V[0];
    for (let J of U) if (W === J) {
      G = !0;
      break;
    }
    G || U.push(W);
  }
  U.sort(function(Z, V) {
    return Z - V;
  });
  for (let Z of U) {
    let V = 0, G = 0;
    for (; G < L && F[G][0] <= Z; ) {
      let W = 0;
      for (; W < q && I[W][0] <= Z; ) {
        if (F[G][0] + I[W][0] === Z) {
          V = polynomial_add(V, polynomial_mul(F[G][1], I[W][1]));
          break;
        }
        W += 1;
      }
      G += 1;
    }
    V && R.push([Z, V]);
  }
  return z;
}
function polynomial_pow(D, E) {
  if (isNaN(E) || E < 0 || !Number.isInteger(E)) return;
  let O = 1;
  for (; E > 0; ) E & 1 && (O = polynomial_mul(O, D)), D = polynomial_mul(D, D), E >>= 1;
  return O;
}
function polynomial_to_expression(D) {
  if (!Array.isArray(D) || D[0] !== "polynomial") return D;
  let E = D[1], O = D[2], F = [], I = O.length;
  for (var z = 0; z < I; z += 1) O[z][1] && (O[z][0] === 0 ? F.push(polynomial_to_expression(O[z][1])) : O[z][0] === 1 ? F.push(["*", polynomial_to_expression(O[z][1]), E]) : F.push(["*", polynomial_to_expression(O[z][1]), ["^", E, O[z][0]]]));
  return F.length === 0 ? 0 : (F.length === 1 ? F = F[0] : F.unshift("+"), simplify(F));
}
function initial_term(D) {
  if (!Array.isArray(D) || D[0] !== "polynomial") return D;
  let E = [];
  for (; Array.isArray(D) && D[0] === "polynomial"; ) {
    let O = D[1], F = D[2], I = F[F.length - 1][0];
    D = F[F.length - 1][1], E.push([O, I]);
  }
  return ["monomial", D, E];
}
function mono_less_than(D, E) {
  if (!Array.isArray(E) || E[0] !== "monomial") return !1;
  if (!Array.isArray(D) || D[0] !== "monomial") return !0;
  let O = D[2], F = E[2], I = O.length, z = F.length;
  for (var R = I < z ? I : z, L = 0; L < R; L++) {
    if (O[L][0] !== F[L][0]) return !(compare_function(O[L][0], F[L][0]) < 0);
    if (O[L][1] < F[L][1]) return !0;
    if (O[L][1] > F[L][1]) return !1;
  }
  return !(I === z || R === z);
}
function mono_gcd(D, E) {
  if (!Array.isArray(D) || !Array.isArray(E) || D[0] !== "monomial" || E[0] !== "monomial") return 1;
  let O = D[2], F = E[2], I = [], z = O.length, R = F.length, L = 0, q = 0;
  for (; L < z && q < R; ) O[L][0] === F[q][0] ? (O[L][1] < F[q][1] ? I.push(O[L]) : I.push(F[q]), L += 1, q += 1) : compare_function(O[L][0], F[q][0]) < 0 ? L += 1 : compare_function(F[q][0], O[L][0]) < 0 && (q += 1);
  return I.length === 0 ? 1 : ["monomial", 1, I];
}
function mono_div(D, E) {
  if (!Array.isArray(E) || E[0] !== "monomial") return E === 1 ? D : !Array.isArray(D) || D[0] !== "monomial" ? evaluate_numbers(["/", D, E]) : [D[0], evaluate_numbers(["/", D[1], E]), D[2]];
  if (!Array.isArray(D) || D[0] !== "monomial") return;
  let O = D[2], F = E[2], I = [], z = O.length, R = F.length, L = 0, q = 0;
  for (; L < z && q < R; ) if (O[L][0] === F[q][0]) {
    if (O[L][1] < F[q][1]) return;
    {
      let U = O[L][1] - F[q][1];
      U !== 0 && I.push([O[L][0], U]);
    }
    L += 1, q += 1;
  } else if (compare_function(O[L][0], F[q][0]) < 0) I.push(O[L]), L += 1;
  else if (compare_function(F[q][0], O[L][0]) < 0) return;
  if (!(q < R)) {
    for (; L < z; ) I.push(O[L]), L += 1;
    return I.length === 0 ? E[1] === 1 ? D[1] : evaluate_numbers(["/", D[1], E[1]]) : E[1] === 1 ? ["monomial", D[1], I] : ["monomial", evaluate_numbers(["/", D[1], E[1]]), I];
  }
}
function mono_is_div(D, E) {
  if (E === 0) return !1;
  if (!Array.isArray(E) || E[0] !== "monomial") return !0;
  if (!Array.isArray(D) || D[0] !== "monomial") return !1;
  let O = D[2], F = E[2], I = [], z = O.length, R = F.length, L = 0, q = 0;
  for (; L < z && q < R; ) if (O[L][0] === F[q][0]) {
    if (O[L][1] < F[q][1]) return !1;
    {
      let U = O[L][1] - F[q][1];
      U !== 0 && I.push([O[L][0], U]);
    }
    L += 1, q += 1;
  } else if (compare_function(O[L][0], F[q][0]) < 0) I.push(O[L]), L += 1;
  else if (compare_function(F[q][0], O[L][0]) < 0) return !1;
  return !(q < R);
}
function mono_to_poly(D) {
  if (!Array.isArray(D) || D[0] !== "monomial") return D;
  let E = D[2].length - 1, O = D[1];
  for (; E >= 0; ) {
    var F = [];
    F.push([D[2][E][1], O]), O = ["polynomial", D[2][E][0], F], --E;
  }
  return O;
}
function max_div_init(D, E) {
  if (D === 0) return 0;
  let O = D, F = [];
  for (; Array.isArray(O) && O[0] === "polynomial"; ) {
    let L = O[1], q = O[2], U = q[q.length - 1][0];
    O = q[q.length - 1][1], F.push([L, U]);
  }
  let I = ["monomial", O, F], z = E.length;
  for (var R = 0; R < z; R += 1) if (mono_is_div(I, E[R])) return [I, R];
  return max_div_init(polynomial_sub(D, mono_to_poly(I)), E);
}
function poly_div(D, E) {
  let O = [], F = [], I = [], z = [], R = D;
  for (var L of E) O.push(initial_term(L));
  let q = max_div_init(R, O);
  for (; q !== 0; ) I = q[1], z = mono_div(q[0], O[I]), F.push([I, z]), R = polynomial_sub(R, polynomial_mul(mono_to_poly(z), E[I])), q = max_div_init(R, O);
  return [F, R];
}
function prereduce(D) {
  let E = D.length, O = [];
  for (var F = 0; F < E; F++) {
    if (D[F] !== 0 && (!Array.isArray(D[F]) || D[F][0] !== "polynomial")) return [1];
    D[F] !== 0 && O.push(D[F]);
  }
  return O.length === 0 ? [0] : O;
}
function reduce_ith(D, E) {
  let O = [], F = [], I = [], z = E[D], R = E.length;
  for (var L = 0; L < R; L += 1) L === D ? O.push(0) : O.push(initial_term(E[L]));
  let q = max_div_init(z, O);
  for (; q !== 0; ) F = q[1], I = mono_div(q[0], O[F]), z = polynomial_sub(z, polynomial_mul(mono_to_poly(I), E[F])), q = max_div_init(z, O);
  return z;
}
function reduce(D) {
  let E = 0, O = [], F = prereduce(D), I = F.length;
  if (I === 1) return F;
  let z = !0;
  for (; z; ) for (z = !1, F = prereduce(F), I = F.length, E = 0; E < I; ) O = reduce_ith(E, F), _.isEqual(O, F[E]) || (F[E] = O, z = !0), E += 1;
  E = 0;
  let R = [], L = 0;
  for (; E < I; ) R = initial_term(F[E]), !Array.isArray(R) || R[0] !== "monomial" ? F[E] = 1 : (L = R[1], L !== 1 && (F[E] = polynomial_mul(F[E], ["/", 1, L]))), E += 1;
  return F;
}
function hij(D, E, O) {
  let F = initial_term(O[D]), I = initial_term(O[E]), z = mono_gcd(F, I), R = mono_to_poly(mono_div(F, z));
  return poly_div(polynomial_sub(polynomial_mul(mono_to_poly(mono_div(I, z)), O[D]), polynomial_mul(R, O[E])), O)[1];
}
function build_hij_table(D, E) {
  let O = E.length, F = 0, I = 1, z = [];
  for (; I < O; ) {
    for (; F < I; ) D[[F, I]] = hij(F, I, E), D[[F, I]] !== 0 && z.push(D[[F, I]]), F += 1;
    F = 0, I += 1;
  }
  return z.length > 0 ? choice_lowest_degree(z) : 0;
}
function update_hij_table(D, E, O) {
  let F = E.length;
  E.push(O);
  let I = 0, z = 1, R = [];
  for (; z < F; ) {
    for (; I < z; ) D[[I, z]] !== 0 && (D[[I, z]] = hij(I, z, E), D[[I, z]] !== 0 && R.push(D[[I, z]])), I += 1;
    I = 0, z += 1;
  }
  for (; I < F; ) D[[I, F]] = hij(I, F, E), D[[I, F]] !== 0 && R.push(D[[I, F]]), I += 1;
  return R.length > 0 ? choice_lowest_degree(R) : 0;
}
function choice_lowest_degree(D) {
  let E = [], O = D.length;
  for (I = 0; I < O; I += 1) E.push(initial_term(D[I]));
  let F = 0;
  for (var I = 1; I < O; I += 1) {
    if (E[I] === 1) return 1;
    mono_less_than(E[I], E[F]) && (F = I);
  }
  return D[F];
}
function reduced_grobner(D) {
  let E = reduce(D), O = {}, F = build_hij_table(O, E);
  for (; F !== 0; ) F = update_hij_table(O, E, F);
  return E = reduce(E), E;
}
function poly_lcm(D, E) {
  let O = reduced_grobner([polynomial_mul(["polynomial", "_t", [[1, 1]]], D), polynomial_mul(["polynomial", "_t", [[0, 1], [1, -1]]], E)]), F = O.length;
  for (var I = 0; I < F; I += 1) {
    if (!Array.isArray(O[I]) || O[I][0] !== "polynomial") return 1;
    if (O[I][1] !== "_t") return O[I];
  }
}
function poly_gcd(D, E) {
  let O = poly_lcm(D, E), F = poly_div(polynomial_mul(D, E), [O]), I = 0, z = F[0].length;
  for (var R = 0; R < z; R += 1) I = polynomial_add(I, mono_to_poly(F[0][R][1]));
  let L = initial_term(I);
  if (!Array.isArray(L) || L[0] !== "monomial") I = 1;
  else {
    let q = L[1];
    q !== 1 && (I = polynomial_mul(I, ["/", 1, q]));
  }
  return I;
}
function poly_by_divisor(D, E) {
  let O = poly_div(D, [E]), F = 0, I = O[0].length;
  for (var z = 0; z < I; z += 1) F = polynomial_add(F, mono_to_poly(O[0][z][1]));
  return F;
}
function reduce_rational_expression(D, E) {
  let O = stringify_vars(D), F = stringify_vars(E);
  D = O[0], E = F[0];
  let I = poly_gcd(D, E), z = initial_term(E)[1], R = polynomial_mul(I, z), L = poly_by_divisor(D, R), q = poly_by_divisor(E, R);
  return [destringify_vars(destringify_vars(L, O[1]), F[1]), destringify_vars(destringify_vars(q, O[1]), F[1])];
}
function stringify_vars(D) {
  if (!Array.isArray(D) || D[0] !== "polynomial") return [D, {}];
  let E = {}, O = "z" + JSON.stringify(D[1]);
  E[O] = D[1], D[1] = O;
  let F = D[2], I = [];
  for (let z of F) {
    I = stringify_vars(z[1]), z[1] = I[0];
    for (let R in I[1]) E[R] = I[1][R];
  }
  return [D, E];
}
function destringify_vars(D, E) {
  if (!Array.isArray(D) || D[0] !== "polynomial") return D;
  E[D[1]] && (D[1] = E[D[1]]);
  let O = D[2];
  for (let F of O) F[1] = destringify_vars(F[1], E);
  return D;
}
var rational_exports = __exportAll({ common_denominator: () => common_denominator, reduce_rational: () => reduce_rational }), textToAst$1 = new textToAst$4();
function common_denominator(D, E) {
  D = simplify(D, E);
  var O = [];
  return O.push([textToAst$1.convert("a/c+b/c"), textToAst$1.convert("(a+b)/c"), { evaluate_numbers: !0, allow_extended_match: !0, allow_permutations: !0, max_group: 1 }]), O.push([textToAst$1.convert("a/c-b/c"), textToAst$1.convert("(a-b)/c"), { evaluate_numbers: !0, allow_extended_match: !0, allow_permutations: !0, max_group: 1 }]), O.push([textToAst$1.convert("a+b/c"), textToAst$1.convert("(ac+b)/c"), { evaluate_numbers: !0, allow_extended_match: !0, allow_permutations: !0, max_group: 1 }]), O.push([textToAst$1.convert("a-b/c"), textToAst$1.convert("(ac-b)/c"), { evaluate_numbers: !0, allow_extended_match: !0, allow_permutations: !0, max_group: 1 }]), O.push([textToAst$1.convert("a/d+b/c"), textToAst$1.convert("(ac+bd)/(cd)"), { evaluate_numbers: !0, allow_extended_match: !0, allow_permutations: !0, max_group: 1 }]), O.push([textToAst$1.convert("a/d-b/c"), textToAst$1.convert("(ac-bd)/(cd)"), { evaluate_numbers: !0, allow_extended_match: !0, allow_permutations: !0, max_group: 1 }]), O.push([textToAst$1.convert("x*(y/z)"), textToAst$1.convert("(x*y)/z"), { allow_extended_match: !0, allow_permutations: !0, max_group: 1 }]), O.push([textToAst$1.convert("(x/y)/z"), textToAst$1.convert("x/(y*z)"), { allow_extended_match: !0, allow_permutations: !0 }]), O.push([textToAst$1.convert("x/(y/z)"), textToAst$1.convert("xz/y"), { allow_extended_match: !0, allow_permutations: !0 }]), D = applyAllTransformations(D, O, 40), D = expand(D, !0), D;
}
function as_num_denom(D) {
  var E = get_tree(D);
  return E = common_denominator(E), E[0] === "/" ? [E[1], E[2]] : [E, 1];
}
function reduce_rational(D) {
  var E = get_tree(D), O = as_num_denom(E);
  if (O[1] === 1) return E;
  var F = reduce_rational_expression(expression_to_polynomial(O[0]), expression_to_polynomial(O[1])), I = polynomial_to_expression(F[0]), z = polynomial_to_expression(F[1]);
  return z === 1 ? I : ["/", I, z];
}
var round_exports = __exportAll({ round_numbers_to_decimals: () => round_numbers_to_decimals, round_numbers_to_precision: () => round_numbers_to_precision, round_numbers_to_precision_plus_decimals: () => round_numbers_to_precision_plus_decimals });
function toFixed(D, E) {
  return mathjs_default.format(D, { notation: "fixed", precision: E });
}
function round_numbers_to_precision(D, E = 14) {
  var O = get_tree(D);
  if (E < 1) throw Error("For round_numbers_to_precision, digits must be positive");
  if (!Number.isFinite(E)) throw Error("For round_numbers_to_precision, digits must be a number");
  return E > 15 ? O : (E = Math.round(E), round_numbers_to_precision_sub(O, E));
}
var round_numbers_to_precision_sub = function(D, E = 14) {
  if (typeof D == "number" && Number.isFinite(D) && D !== 0) {
    let O = E - mathjs_default.floor(mathjs_default.log10(mathjs_default.abs(D))) - 1;
    return parseFloat(O < 0 ? toFixed(D, O) + "0".repeat(mathjs_default.abs(O)) : toFixed(D, O));
  }
  return Array.isArray(D) ? [D[0], ...D.slice(1).map((O) => round_numbers_to_precision_sub(O, E))] : D;
};
function round_numbers_to_decimals(D, E = 14) {
  var O = get_tree(D);
  if (!Number.isFinite(E)) throw Error("For round_numbers_to_decimals, ndecimals must be a number");
  return E = Math.round(E), E = Math.max(-330, Math.min(330, E)), round_numbers_to_decimals_sub(O, E);
}
var round_numbers_to_decimals_sub = function(D, E = 0) {
  return typeof D == "number" ? parseFloat(E < 0 ? toFixed(D, E) + "0".repeat(mathjs_default.abs(E)) : toFixed(D, E)) : Array.isArray(D) ? [D[0], ...D.slice(1).map((O) => round_numbers_to_decimals_sub(O, E))] : D;
};
function round_numbers_to_precision_plus_decimals(D, E = 4, O = 2) {
  var F = get_tree(D);
  let I = !0, z = !0;
  if (E >= 1) {
    if (E = Math.round(E), E > 15) return F;
  } else I = !1;
  return Number.isFinite(O) ? (O = Math.round(O), O = Math.max(-330, Math.min(330, O))) : z = !1, I ? z ? round_numbers_to_precision_plus_decimals_sub(F, E, O) : round_numbers_to_precision_sub(F, E) : z ? round_numbers_to_decimals_sub(F, O) : F;
}
var round_numbers_to_precision_plus_decimals_sub = function(D, E = 4, O = 2) {
  if (typeof D == "number" && Number.isFinite(D) && D !== 0) {
    let F = mathjs_default.floor(mathjs_default.log10(mathjs_default.abs(D))), I = Math.max(E - F - 1, O);
    return parseFloat(I < 0 ? toFixed(D, I) + "0".repeat(mathjs_default.abs(I)) : toFixed(D, I));
  }
  return Array.isArray(D) ? [D[0], ...D.slice(1).map((F) => round_numbers_to_precision_plus_decimals_sub(F, E, O))] : D;
}, match_exports = __exportAll({ match: () => match }), match = function(D, E, O) {
  return match$1(get_tree(D), get_tree(E), O);
}, expression_to_tree$1 = [simplify_exports, differentiation_exports, normalization_exports, arithmetic_exports, transformation_exports, solve_exports, sets_exports, matrix_exports, rational_exports, round_exports], expression_to_other = [variables_exports, printing_exports, equality_exports, integration_exports, evaluation_exports, analytic_exports, sign_error_exports, match_exports], standard_exports = __exportAll({ abs: () => abs, acos: () => acos, acosh: () => acosh, acot: () => acot, acoth: () => acoth, acsc: () => acsc, acsch: () => acsch, asec: () => asec, asech: () => asech, asin: () => asin, asinh: () => asinh, atan: () => atan, atan2: () => atan2, atanh: () => atanh, conj: () => conj, cos: () => cos, cosh: () => cosh, cot: () => cot, coth: () => coth, csc: () => csc, csch: () => csch, erf: () => erf, exp: () => exp, factorial: () => factorial, gamma: () => gamma, im: () => im, log: () => log, log10: () => log10, re: () => re, sec: () => sec, sech: () => sech, sign: () => sign, sin: () => sin, sinh: () => sinh, sqrt: () => sqrt, tan: () => tan, tanh: () => tanh });
function abs(D) {
  return ["apply", "abs", get_tree(D)];
}
function exp(D) {
  return ["apply", "exp", get_tree(D)];
}
function log(D) {
  return ["apply", "log", get_tree(D)];
}
function log10(D) {
  return ["apply", "log10", get_tree(D)];
}
function sign(D) {
  return ["apply", "sign", get_tree(D)];
}
function sqrt(D) {
  return ["apply", "sqrt", get_tree(D)];
}
function conj(D) {
  return ["apply", "conj", get_tree(D)];
}
function im(D) {
  return ["apply", "im", get_tree(D)];
}
function re(D) {
  return ["apply", "re", get_tree(D)];
}
function factorial(D) {
  return ["apply", "factorial", get_tree(D)];
}
function gamma(D) {
  return ["apply", "gamma", get_tree(D)];
}
function erf(D) {
  return ["apply", "erf", get_tree(D)];
}
function acos(D) {
  return ["apply", "acos", get_tree(D)];
}
function acosh(D) {
  return ["apply", "acosh", get_tree(D)];
}
function acot(D) {
  return ["apply", "acot", get_tree(D)];
}
function acoth(D) {
  return ["apply", "acoth", get_tree(D)];
}
function acsc(D) {
  return ["apply", "acsc", get_tree(D)];
}
function acsch(D) {
  return ["apply", "acsch", get_tree(D)];
}
function asec(D) {
  return ["apply", "asec", get_tree(D)];
}
function asech(D) {
  return ["apply", "asech", get_tree(D)];
}
function asin(D) {
  return ["apply", "asin", get_tree(D)];
}
function asinh(D) {
  return ["apply", "asinh", get_tree(D)];
}
function atan(D) {
  return ["apply", "atan", get_tree(D)];
}
function atanh(D) {
  return ["apply", "atanh", get_tree(D)];
}
function cos(D) {
  return ["apply", "cos", get_tree(D)];
}
function cosh(D) {
  return ["apply", "cosh", get_tree(D)];
}
function cot(D) {
  return ["apply", "cot", get_tree(D)];
}
function coth(D) {
  return ["apply", "coth", get_tree(D)];
}
function csc(D) {
  return ["apply", "csc", get_tree(D)];
}
function csch(D) {
  return ["apply", "csch", get_tree(D)];
}
function sec(D) {
  return ["apply", "sec", get_tree(D)];
}
function sech(D) {
  return ["apply", "sech", get_tree(D)];
}
function sin(D) {
  return ["apply", "sin", get_tree(D)];
}
function sinh(D) {
  return ["apply", "sinh", get_tree(D)];
}
function tan(D) {
  return ["apply", "tan", get_tree(D)];
}
function tanh(D) {
  return ["apply", "tanh", get_tree(D)];
}
function atan2(D, E) {
  return ["apply", "atan2", ["tuple", get_tree(D), get_tree(E)]];
}
var expression_to_tree = [standard_exports], whitespace_rule = "\\s|\\\\,|\\\\!|\\\\ |\\\\>|\\\\;|\\\\:|\\\\quad\\b|\\\\qquad\\b", number_rules_sci = [["[0-9]+(\\.[0-9]*)?(E[+\\-]?[0-9]+\\s*($|(?=\\,|&|\\||\\\\\\||\\)|\\}|\\\\}|\\]|\\\\\\\\|\\\\end)))?", "NUMBER"], ["\\.[0-9]+(E[+\\-]?[0-9]+\\s*($|(?=\\,|&|\\||\\\\\\||\\)|\\}|\\\\}|\\]|\\\\\\\\|\\\\end)))?", "NUMBER"]], number_rules_non_sci = [["[0-9]+(\\.[0-9]*)?", "NUMBER"], ["\\.[0-9]+", "NUMBER"]], base_latex_rules = [["\\*", "*"], ["\\/", "/"], ["-", "-"], ["\\+", "+"], ["\\\\pm(?![a-zA-Z])", "PM"], ["\\^", "^"], ["\\(", "("], ["\\\\left\\s*\\(", "("], ["\\\\bigl\\s*\\(", "("], ["\\\\Bigl\\s*\\(", "("], ["\\\\biggl\\s*\\(", "("], ["\\\\Biggl\\s*\\(", "("], ["\\)", ")"], ["\\\\right\\s*\\)", ")"], ["\\\\bigr\\s*\\)", ")"], ["\\\\Bigr\\s*\\)", ")"], ["\\\\biggr\\s*\\)", ")"], ["\\\\Biggr\\s*\\)", ")"], ["\\[", "["], ["\\\\left\\s*\\[", "["], ["\\\\bigl\\s*\\[", "["], ["\\\\Bigl\\s*\\[", "["], ["\\\\biggl\\s*\\[", "["], ["\\\\Biggl\\s*\\[", "["], ["\\]", "]"], ["\\\\right\\s*\\]", "]"], ["\\\\bigr\\s*\\]", "]"], ["\\\\Bigr\\s*\\]", "]"], ["\\\\biggr\\s*\\]", "]"], ["\\\\Biggr\\s*\\]", "]"], ["\\|", "|"], ["\\\\left\\s*\\|", "|L"], ["\\\\bigl\\s*\\|", "|L"], ["\\\\Bigl\\s*\\|", "|L"], ["\\\\biggl\\s*\\|", "|L"], ["\\\\Biggl\\s*\\|", "|L"], ["\\\\right\\s*\\|", "|"], ["\\\\bigr\\s*\\|", "|"], ["\\\\Bigr\\s*\\|", "|"], ["\\\\biggr\\s*\\|", "|"], ["\\\\Biggr\\s*\\|", "|"], ["\\\\big\\s*\\|", "|"], ["\\\\Big\\s*\\|", "|"], ["\\\\bigg\\s*\\|", "|"], ["\\\\Bigg\\s*\\|", "|"], ["{", "{"], ["}", "}"], ["\\\\{", "LBRACE"], ["\\\\left\\s*\\\\{", "LBRACE"], ["\\\\bigl\\s*\\\\{", "LBRACE"], ["\\\\Bigl\\s*\\\\{", "LBRACE"], ["\\\\biggl\\s*\\\\{", "LBRACE"], ["\\\\Biggl\\s*\\\\{", "LBRACE"], ["\\\\}", "RBRACE"], ["\\\\right\\s*\\\\}", "RBRACE"], ["\\\\bigr\\s*\\\\}", "RBRACE"], ["\\\\Bigr\\s*\\\\}", "RBRACE"], ["\\\\biggr\\s*\\\\}", "RBRACE"], ["\\\\Biggr\\s*\\\\}", "RBRACE"], ["\\\\lfloor(?![a-zA-Z])", "LFLOOR"], ["\\\\left\\s*\\\\lfloor(?![a-zA-Z])", "LFLOOR"], ["\\\\bigl\\s*\\\\lfloor(?![a-zA-Z])", "LFLOOR"], ["\\\\Bigl\\s*\\\\lfloor(?![a-zA-Z])", "LFLOOR"], ["\\\\biggl\\s*\\\\lfloor(?![a-zA-Z])", "LFLOOR"], ["\\\\Biggl\\s*\\\\lfloor(?![a-zA-Z])", "LFLOOR"], ["\\\\rfloor(?![a-zA-Z])", "RFLOOR"], ["\\\\right\\s*\\\\rfloor(?![a-zA-Z])", "RFLOOR"], ["\\\\bigr\\s*\\\\rfloor(?![a-zA-Z])", "RFLOOR"], ["\\\\Bigr\\s*\\\\rfloor(?![a-zA-Z])", "RFLOOR"], ["\\\\biggr\\s*\\\\rfloor(?![a-zA-Z])", "RFLOOR"], ["\\\\Biggr\\s*\\\\rfloor(?![a-zA-Z])", "RFLOOR"], ["\\\\lceil(?![a-zA-Z])", "LCEIL"], ["\\\\left\\s*\\\\lceil(?![a-zA-Z])", "LCEIL"], ["\\\\bigl\\s*\\\\lceil(?![a-zA-Z])", "LCEIL"], ["\\\\Bigl\\s*\\\\lceil(?![a-zA-Z])", "LCEIL"], ["\\\\biggl\\s*\\\\lceil(?![a-zA-Z])", "LCEIL"], ["\\\\Biggl\\s*\\\\lceil(?![a-zA-Z])", "LCEIL"], ["\\\\rceil(?![a-zA-Z])", "RCEIL"], ["\\\\right\\s*\\\\rceil(?![a-zA-Z])", "RCEIL"], ["\\\\bigr\\s*\\\\rceil(?![a-zA-Z])", "RCEIL"], ["\\\\Bigr\\s*\\\\rceil(?![a-zA-Z])", "RCEIL"], ["\\\\biggr\\s*\\\\rceil(?![a-zA-Z])", "RCEIL"], ["\\\\Biggr\\s*\\\\rceil(?![a-zA-Z])", "RCEIL"], ["\\\\langle(?![a-zA-Z])", "LANGLE"], ["\\\\left\\s*\\\\langle(?![a-zA-Z])", "LANGLE"], ["\\\\bigl\\s*\\\\langle(?![a-zA-Z])", "LANGLE"], ["\\\\Bigl\\s*\\\\langle(?![a-zA-Z])", "LANGLE"], ["\\\\biggl\\s*\\\\langle(?![a-zA-Z])", "LANGLE"], ["\\\\Biggl\\s*\\\\langle(?![a-zA-Z])", "LANGLE"], ["\\\\rangle(?![a-zA-Z])", "RANGLE"], ["\\\\right\\s*\\\\rangle(?![a-zA-Z])", "RANGLE"], ["\\\\bigr\\s*\\\\rangle(?![a-zA-Z])", "RANGLE"], ["\\\\Bigr\\s*\\\\rangle(?![a-zA-Z])", "RANGLE"], ["\\\\biggr\\s*\\\\rangle(?![a-zA-Z])", "RANGLE"], ["\\\\Biggr\\s*\\\\rangle(?![a-zA-Z])", "RANGLE"], ["\\\\cdot(?![a-zA-Z])", "*"], ["\\\\div(?![a-zA-Z])", "/"], ["\\\\times(?![a-zA-Z])", "*"], [",", ","], [":", ":"], ["\\\\mid(?![a-zA-Z])", "MID"], ["\\\\varnothing(?![a-zA-Z])", "LATEXCOMMAND", "\\emptyset"], ["\\\\vartheta(?![a-zA-Z])", "LATEXCOMMAND", "\\theta"], ["\\\\varepsilon(?![a-zA-Z])", "LATEXCOMMAND", "\\epsilon"], ["\\\\varrho(?![a-zA-Z])", "LATEXCOMMAND", "\\rho"], ["\\\\varphi(?![a-zA-Z])", "LATEXCOMMAND", "\\phi"], ["\\\\infty(?![a-zA-Z])", "INFINITY"], ["\\\\asin(?![a-zA-Z])", "LATEXCOMMAND", "\\arcsin"], ["\\\\acos(?![a-zA-Z])", "LATEXCOMMAND", "\\arccos"], ["\\\\atan(?![a-zA-Z])", "LATEXCOMMAND", "\\arctan"], ["\\\\sqrt(?![a-zA-Z])", "SQRT"], ["\\\\land(?![a-zA-Z])", "AND"], ["\\\\wedge(?![a-zA-Z])", "AND"], ["\\\\lor(?![a-zA-Z])", "OR"], ["\\\\vee(?![a-zA-Z])", "OR"], ["\\\\lnot(?![a-zA-Z])", "NOT"], ["\\\\neg(?![a-zA-Z])", "NOT"], ["=", "="], ["\\\\neq(?![a-zA-Z])", "NE"], ["\\\\ne(?![a-zA-Z])", "NE"], ["\\\\not\\s*=", "NE"], ["\\\\leq(?![a-zA-Z])", "LE"], ["\\\\le(?![a-zA-Z])", "LE"], ["\\\\geq(?![a-zA-Z])", "GE"], ["\\\\ge(?![a-zA-Z])", "GE"], ["<", "<"], ["\\\\lt(?![a-zA-Z])", "<"], [">", ">"], ["\\\\gt(?![a-zA-Z])", ">"], ["\\\\forall(?![a-zA-Z])", "FORALL"], ["\\\\exists(?![a-zA-Z])", "EXISTS"], ["\\\\in(?![a-zA-Z])", "IN"], ["\\\\notin(?![a-zA-Z])", "NOTIN"], ["\\\\not\\s*\\\\in(?![a-zA-Z])", "NOTIN"], ["\\\\ni(?![a-zA-Z])", "NI"], ["\\\\not\\s*\\\\ni(?![a-zA-Z])", "NOTNI"], ["\\\\subset(?![a-zA-Z])", "SUBSET"], ["\\\\subseteq(?![a-zA-Z])", "SUBSETEQ"], ["\\\\not\\s*\\\\subset(?![a-zA-Z])", "NOTSUBSET"], ["\\\\not\\s*\\\\subseteq(?![a-zA-Z])", "NOTSUBSETEQ"], ["\\\\supset(?![a-zA-Z])", "SUPERSET"], ["\\\\supseteq(?![a-zA-Z])", "SUPERSETEQ"], ["\\\\not\\s*\\\\supset(?![a-zA-Z])", "NOTSUPERSET"], ["\\\\not\\s*\\\\supseteq(?![a-zA-Z])", "NOTSUPERSETEQ"], ["\\\\cup(?![a-zA-Z])", "UNION"], ["\\\\cap(?![a-zA-Z])", "INTERSECT"], ["\\\\to(?![a-zA-Z])", "RIGHTARROW"], ["\\\\rightarrow(?![a-zA-Z])", "RIGHTARROW"], ["\\\\longrightarrow(?![a-zA-Z])", "RIGHTARROW"], ["\\\\gets(?![a-zA-Z])", "LEFTARROW"], ["\\\\leftarrow(?![a-zA-Z])", "LEFTARROW"], ["\\\\longleftarrow(?![a-zA-Z])", "LEFTARROW"], ["\\\\leftrightarrow(?![a-zA-Z])", "LEFTRIGHTARROW"], ["\\\\longleftrightarrow(?![a-zA-Z])", "LEFTRIGHTARROW"], ["\\\\implies(?![a-zA-Z])", "IMPLIES"], ["\\\\Longrightarrow(?![a-zA-Z])", "IMPLIES"], ["\\\\Rightarrow(?![a-zA-Z])", "IMPLIES"], ["\\\\impliedby(?![a-zA-Z])", "IMPLIEDBY"], ["\\\\Longleftarrow(?![a-zA-Z])", "IMPLIEDBY"], ["\\\\Leftarrow(?![a-zA-Z])", "IMPLIEDBY"], ["\\\\iff(?![a-zA-Z])", "IFF"], ["\\\\Longleftrightarrow(?![a-zA-Z])", "IFF"], ["\\\\Leftrightarrow(?![a-zA-Z])", "IFF"], ["\\\\perp(?![a-zA-Z])", "PERP"], ["\\\\bot(?![a-zA-Z])", "PERP"], ["\\\\parallel(?![a-zA-Z])", "PARALLEL"], ["\\\\\\|", "PARALLEL"], ["\\\\angle(?![a-zA-Z])", "ANGLE"], ["\\\\int(?![a-zA-Z])", "INT"], ["!", "!"], ["'", "'"], ["_", "_"], ["&", "&"], ["\\\\ldots(?![a-zA-Z])", "LDOTS"], ["\\\\\\\\", "LINEBREAK"], ["\\\\begin\\s*{\\s*[a-zA-Z0-9]+\\s*}", "BEGINENVIRONMENT"], ["\\\\end\\s*{\\s*[a-zA-Z0-9]+\\s*}", "ENDENVIRONMENT"], ["\\\\operatorname\\s*{\\s*[a-zA-Z0-9\\+\\-]+\\s*}", "VARMULTICHAR"], ["\\\\[a-zA-Z]+(?![a-zA-Z])", "LATEXCOMMAND"], ["\\\\[$%]", "LATEXCOMMAND"], ["[a-zA-Z＿$%]", "VAR"]], allowSimplifiedFunctionApplicationDefault = !0, allowedLatexSymbolsDefault = "alpha.beta.gamma.Gamma.delta.Delta.epsilon.zeta.eta.theta.Theta.iota.kappa.lambda.Lambda.mu.nu.xi.Xi.pi.Pi.rho.sigma.Sigma.tau.Tau.upsilon.Upsilon.phi.Phi.chi.psi.Psi.omega.Omega.partial.angle.circ.%.$.emptyset".split("."), appliedFunctionSymbolsDefault$2 = "abs.exp.log.ln.log10.sign.sqrt.erf.cos.cosh.acos.acosh.arccos.arccosh.cot.coth.acot.acoth.arccot.arccoth.csc.csch.acsc.acsch.arccsc.arccsch.sec.sech.asec.asech.arcsec.arcsech.sin.sinh.asin.asinh.arcsin.arcsinh.tan.tanh.atan.atan2.atanh.arctan.arctanh.arg.conj.Re.Im.det.trace.nPr.nCr.floor.ceil.round".split("."), functionSymbolsDefault = ["f", "g"], operatorSymbolsDefault = { frac: { nargs: 2, substitute: "/" }, binom: { nargs: 2 }, vec: { nargs: 1 }, overline: { nargs: 1, substitute: "linesegment", remove_products: !0 } }, unitsDefault = get_all_units();
unitsDefault.circ = unitsDefault.deg, unitsDefault.circ.substitute = "deg", unitsDefault.circ.isExponent = !0, delete unitsDefault.deg;
var parseLeibnizNotationDefault = !0, latexToAst$1 = class {
  constructor({ allowSimplifiedFunctionApplication: D = allowSimplifiedFunctionApplicationDefault, allowedLatexSymbols: E = allowedLatexSymbolsDefault, appliedFunctionSymbols: O = appliedFunctionSymbolsDefault$2, functionSymbols: F = functionSymbolsDefault, operatorSymbols: I = operatorSymbolsDefault, units: z = unitsDefault, parseLeibnizNotation: R = parseLeibnizNotationDefault, parseScientificNotation: L = !0 } = {}) {
    this.allowSimplifiedFunctionApplication = D, this.allowedLatexSymbols = E, this.appliedFunctionSymbols = O, this.functionSymbols = F, this.operatorSymbols = I, this.units = z, this.parseLeibnizNotation = R;
    let q = base_latex_rules;
    q = L ? [...number_rules_sci, ...q] : [...number_rules_non_sci, ...q], this.lexer = new lexer(q, whitespace_rule);
  }
  advance(D) {
    if (this.token = this.lexer.advance(D), this.token.token_type === "INVALID") throw new ParseError("Invalid symbol '" + this.token.original_text + "'", this.lexer.location);
  }
  return_state() {
    return { lexer_state: this.lexer.return_state(), token: Object.assign({}, this.token) };
  }
  set_state(D) {
    this.lexer.set_state(D.lexer_state), this.token = Object.assign({}, D.token);
  }
  convert(D) {
    this.lexer.set_input(D), this.advance();
    var E = this.statement_list();
    if (this.token.token_type !== "EOF") throw new ParseError("Invalid location of '" + this.token.original_text + "'", this.lexer.location);
    return flatten(E);
  }
  statement_list() {
    for (var D = [this.statement()]; this.token.token_type === ","; ) this.advance(), D.push(this.statement());
    return D = D.length > 1 ? ["list"].concat(D) : D[0], D;
  }
  statement({ inside_absolute_value: D = 0 } = {}) {
    if (this.token.token_type === "LDOTS") return this.advance(), ["ldots"];
    var E;
    try {
      E = this.return_state();
      let O = this.statement_a({ inside_absolute_value: D });
      if (this.token.token_type !== ":" && this.token.token_type !== "MID") return O;
      let F = this.token.token_type === ":" ? ":" : "|";
      return this.advance(), [F, O, this.statement_a()];
    } catch (O) {
      try {
        this.set_state(E);
        let F = this.statement_a({ parse_absolute_value: !1 });
        if (this.token.token_type[0] !== "|") throw O;
        return this.advance(), ["|", F, this.statement_a({ parse_absolute_value: !1 })];
      } catch {
        throw O;
      }
    }
  }
  statement_a({ inside_absolute_value: D = 0, parse_absolute_value: E = !0 } = {}) {
    for (var O = this.statement_b({ inside_absolute_value: D, parse_absolute_value: E }); ["IMPLIES", "IMPLIEDBY", "IFF", "LEFTARROW", "RIGHTARROW", "LEFTRIGHTARROW"].includes(this.token.token_type); ) {
      let F = this.token.token_type.toLowerCase();
      this.advance();
      let I = this.statement_b({ inside_absolute_value: D, parse_absolute_value: E });
      O = [F, O, I];
    }
    return O;
  }
  statement_b({ inside_absolute_value: D = 0, parse_absolute_value: E = !0 } = {}) {
    for (var O = this.statement_c({ inside_absolute_value: D, parse_absolute_value: E }); this.token.token_type === "OR"; ) {
      let F = this.token.token_type.toLowerCase();
      this.advance();
      let I = this.statement_c({ inside_absolute_value: D, parse_absolute_value: E });
      O = [F, O, I];
    }
    return O;
  }
  statement_c(D) {
    for (var E = this.relation(D); this.token.token_type === "AND"; ) {
      let O = this.token.token_type.toLowerCase();
      this.advance();
      let F = this.relation(D);
      E = [O, E, F];
    }
    return E;
  }
  relation(D) {
    if (this.token.token_type === "NOT" || this.token.token_type === "!") return this.advance(), ["not", this.relation(D)];
    if (this.token.token_type === "FORALL" || this.token.token_type === "EXISTS") {
      let O = this.token.token_type.toLowerCase();
      return this.advance(), [O, this.relation(D)];
    }
    for (var E = this.expression(D); this.token.token_type === "=" || this.token.token_type === "NE" || this.token.token_type === "<" || this.token.token_type === ">" || this.token.token_type === "LE" || this.token.token_type === "GE" || this.token.token_type === "IN" || this.token.token_type === "NOTIN" || this.token.token_type === "NI" || this.token.token_type === "NOTNI" || this.token.token_type === "SUBSET" || this.token.token_type === "NOTSUBSET" || this.token.token_type === "SUBSETEQ" || this.token.token_type === "NOTSUBSETEQ" || this.token.token_type === "SUPERSET" || this.token.token_type === "NOTSUPERSET" || this.token.token_type === "SUPERSETEQ" || this.token.token_type === "NOTSUPERSETEQ"; ) {
      let O = this.token.token_type.toLowerCase(), F = 0;
      this.token.token_type === "<" || this.token.token_type === "LE" ? F = -1 : (this.token.token_type === ">" || this.token.token_type === "GE") && (F = 1), this.advance();
      let I = this.expression(D);
      if (F === -1) if (this.token.token_type === "<" || this.token.token_type === "LE") {
        let z = ["tuple"];
        O === "<" ? z.push(!0) : z.push(!1);
        let R = ["tuple", E, I];
        for (; this.token.token_type === "<" || this.token.token_type === "LE"; ) this.token.token_type === "<" ? z.push(!0) : z.push(!1), this.advance(), R.push(this.expression(D));
        E = ["lts", R, z];
      } else E = [O, E, I];
      else if (F === 1) if (this.token.token_type === ">" || this.token.token_type === "GE") {
        let z = ["tuple"];
        O === ">" ? z.push(!0) : z.push(!1);
        let R = ["tuple", E, I];
        for (; this.token.token_type === ">" || this.token.token_type === "GE"; ) this.token.token_type === ">" ? z.push(!0) : z.push(!1), this.advance(), R.push(this.expression(D));
        E = ["gts", R, z];
      } else E = [O, E, I];
      else if (O === "=") for (E = ["=", E, I]; this.token.token_type === "="; ) this.advance(), E.push(this.expression(D));
      else E = [O, E, I];
    }
    return E;
  }
  expression(D) {
    if (this.token.token_type === "NOT" || this.token.token_type === "!") return this.advance(), ["not", this.expression(D)];
    let E = !1;
    this.token.token_type === "+" && (E = !0, this.advance());
    let O = !1;
    this.token.token_type === "-" && (O = !0, this.advance());
    let F = !1;
    this.token.token_type === "PM" && (F = !0, this.advance());
    var I = this.term(D);
    if (O || E) {
      if (I === !1) return (E ? "+" : "") + (O ? "-" : "");
      if (typeof I == "string" && [...I].every((z) => ["+", "-"].includes(z))) return (E ? "+" : "") + (O ? "-" : "") + I;
    }
    for (I === !1 && (I = "＿"), O && (I = I > 0 ? -I : ["-", I]), F && (I = ["pm", I]), E && (I = ["+", I]); ["+", "-", "PM", "UNION", "INTERSECT", "PERP", "PARALLEL"].includes(this.token.token_type); ) {
      let z = this.token.token_type.toLowerCase(), R = !1, L = !1, q = !1;
      this.token.token_type === "-" ? (z = "+", R = !0, this.advance()) : this.token.token_type === "PM" ? (z = "+", L = !0, this.advance()) : (this.advance(), z === "+" && (this.token.token_type === "-" ? (R = !0, q = !0, this.advance()) : this.token.token_type === "PM" && (L = !0, this.advance())));
      let U = this.term(D);
      if (z === "+") {
        if (U === !1 && (typeof I == "number" || typeof I == "string")) {
          if (q) return I + "+-";
          if (R) return I + "-";
          if (!L) return I + "+";
        } else if (typeof U == "string" && [...U].every((Z) => ["+", "-"].includes(Z)) && (typeof I == "number" || typeof I == "string")) {
          if (q) return I + "+-" + U;
          if (R) return I + "-" + U;
          if (!L) return I + "+" + U;
        }
      }
      U === !1 && (U = "＿"), R && (U = U > 0 ? -U : ["-", U]), L && (U = ["pm", U]), I = [z, I, U];
    }
    return I;
  }
  term(D) {
    var E = this.factor(D), O = !1;
    do
      if (O = !1, this.token.token_type === "*") {
        this.advance(), E === !1 && (E = "＿");
        let F = this.factor(D);
        F === !1 && (F = "＿"), E = ["*", E, F], O = !0;
      } else if (this.token.token_type === "/") {
        this.advance(), E === !1 && (E = "＿");
        let F = this.factor(D);
        F === !1 && (F = "＿"), E = ["/", E, F], O = !0;
      } else {
        let F = Object.assign({}, D);
        F.allow_absolute_value_closing = !0;
        let I = this.nonMinusFactor(F);
        I !== !1 && (E === !1 && (E = "＿"), E = ["*", E, I], O = !0);
      }
    while (O);
    return this.convert_units_in_term(flatten(E));
  }
  convert_units_in_term(D) {
    if (!Array.isArray(D)) return D;
    let E = D[0], O = D.slice(1);
    if (E === "*") {
      let F = O.length;
      for (let [I, z] of O.entries()) {
        let R = this.units[z];
        if (R) {
          if (R.prefix && I < F - 1) {
            let L;
            L = I === F - 2 ? O[F - 1] : this.convert_units_in_term(["*", ...O.slice(I + 1)]);
            let q = z;
            R.substitute && (q = R.substitute);
            let U = ["unit", q, L];
            return I === 0 ? U : ["*", ...O.slice(0, I).map(this.convert_units_in_term.bind(this)), U];
          } else if (!R.prefix && I > 0) {
            let L = z;
            R.substitute && (L = R.substitute);
            let q;
            return q = I === 1 ? ["unit", O[0], L] : ["unit", ["*", ...O.slice(0, I).map(this.convert_units_in_term.bind(this))], L], I === F - 1 ? q : this.convert_units_in_term(["*", q, ...O.slice(I + 1)]);
          }
        }
      }
      return [E, ...O.map(this.convert_units_in_term.bind(this))];
    } else {
      if (E === "/") return ["/", this.convert_units_in_term(O[0]), this.convert_units_in_term(O[1])];
      if (E === "^") {
        let F = this.units[O[1]];
        if (F && F.isExponent) {
          let I = O[1];
          return F.substitute && (I = F.substitute), ["unit", O[0], I];
        }
        return [E, ...O.map(this.convert_units_in_term.bind(this))];
      }
    }
    return [E, ...O.map(this.convert_units_in_term.bind(this))];
  }
  factor(D) {
    if (this.token.token_text === "+") {
      this.advance();
      let O = this.factor(D);
      return O === !1 ? "+" : typeof O == "string" && [...O].every((F) => ["+", "-"].includes(F)) ? "+" + O : ["+", O];
    }
    if (this.token.token_type === "-") {
      this.advance();
      let O = this.factor(D);
      return O > 0 ? -O : O === !1 ? "-" : typeof O == "string" && [...O].every((F) => ["+", "-"].includes(F)) ? "-" + O : ["-", O];
    }
    let E = this.nonMinusFactor(D);
    return E === !1 && this.token.token_type === "PERP" && (E = "perp", this.advance()), E;
  }
  nonMinusFactor(D) {
    for (var E = this.baseFactor(D); this.token.token_type === "^" || this.token.token_type === "!" || this.token.token_type === "'"; ) if (E === !1 && (E = "＿"), this.token.token_type === "^") {
      this.advance();
      let O = this.get_subsuperscript(D);
      E = ["^", E, O];
    } else this.token.token_type === "!" ? (E = ["apply", "factorial", E], this.advance()) : (E = ["prime", E], this.advance());
    return E;
  }
  get_single_digit_as_number() {
    if (this.token.token_type === "NUMBER" && this.token.token_text[0] !== ".") {
      let D = Number(this.token.token_text[0]);
      return this.token.token_text.length > 1 && this.lexer.unput(this.token.token_text.slice(1)), this.advance(), D;
    }
    return null;
  }
  get_subsuperscript({ parse_absolute_value: D }) {
    let E = this.get_single_digit_as_number();
    if (E !== null) return E;
    if (["+", "-", "PERP"].includes(this.token.token_type)) {
      let O = this.token.token_type.toLowerCase();
      return this.advance(), O;
    } else {
      let O = this.baseFactor({ parse_absolute_value: D, in_subsuperscript_with_no_delimiters: !0 });
      return O === !1 && (O = "＿"), O;
    }
  }
  baseFactor({ inside_absolute_value: D = 0, parse_absolute_value: E = !0, allow_absolute_value_closing: O = !1, in_subsuperscript_with_no_delimiters: F = !1 } = {}) {
    var I = !1;
    if (this.token.token_type === "BEGINENVIRONMENT") {
      let z = /\\begin\s*{\s*([a-zA-Z0-9]+)\s*}/.exec(this.token.token_text)[1];
      if (["matrix", "pmatrix", "bmatrix"].includes(z)) {
        let R = 0, L = 0, q = [], U = [], Z = 0, V = this.token.token_type;
        for (this.advance(); this.token.token_type !== "ENDENVIRONMENT"; ) this.token.token_type === "&" ? ((V === "&" || V === "LINEBREAK") && (U.push(0), Z += 1), V = this.token.token_type, this.advance()) : this.token.token_type === "LINEBREAK" ? ((V === "&" || V === "LINEBREAK") && (U.push(0), Z += 1), q.push(U), Z > L && (L = Z), R += 1, Z = 0, U = [], V = this.token.token_type, this.advance()) : (U.push(this.statement({ parse_absolute_value: E })), Z += 1, V = " ");
        if (/\\end\s*{\s*([a-zA-Z0-9]+)\s*}/.exec(this.token.token_text)[1] !== z) throw new ParseError("Expecting \\end{" + z + "}", this.lexer.location);
        V === "&" && (U.push(0), Z += 1), q.push(U), Z > L && (L = Z), R += 1, this.advance(), I = ["matrix", ["tuple", R, L]];
        let G = ["tuple"];
        for (let W of q) {
          let J = ["tuple"].concat(W);
          for (let X = W.length; X < L; X += 1) J.push(0);
          G.push(J);
        }
        return I.push(G), I;
      } else throw new ParseError("Unrecognized environment " + z, this.lexer.location);
    }
    if (this.token.token_type === "NUMBER") I = parseFloat(this.token.token_text), this.advance();
    else if (this.token.token_type === "INFINITY") I = 1 / 0, this.advance();
    else if (this.token.token_type === "SQRT") {
      this.advance();
      let z = 2;
      if (this.token.token_type === "[") {
        this.advance();
        let L = this.statement({ parse_absolute_value: E });
        if (this.token.token_type !== "]") throw new ParseError("Expecting ]", this.lexer.location);
        this.advance(), z = L;
      }
      if (this.token.token_type !== "{") throw new ParseError("Expecting {", this.lexer.location);
      this.advance();
      let R = this.statement({ parse_absolute_value: E });
      if (this.token.token_type !== "}") throw new ParseError("Expecting }", this.lexer.location);
      this.advance(), I = z === 2 ? ["apply", "sqrt", R] : z === 3 ? ["apply", "cbrt", R] : ["apply", "nthroot", ["tuple", R, z]];
    } else if (this.token.token_type === "VAR" || this.token.token_type === "LATEXCOMMAND" || this.token.token_type === "VARMULTICHAR") {
      if (I = this.token.token_text, this.token.token_type === "LATEXCOMMAND") {
        if (I = I.slice(1), !(this.appliedFunctionSymbols.includes(I) || this.functionSymbols.includes(I) || this.allowedLatexSymbols.includes(I) || I in this.operatorSymbols)) throw new ParseError("Unrecognized latex command " + this.token.original_text, this.lexer.location);
      } else this.token.token_type === "VARMULTICHAR" && (I = /\\operatorname\s*\{\s*([a-zA-Z0-9\+\-]+)\s*\}/.exec(I)[1]);
      if (this.appliedFunctionSymbols.includes(I) || this.functionSymbols.includes(I)) {
        let z = !1;
        if (this.appliedFunctionSymbols.includes(I) && (z = !0), ["Re", "Im"].includes(I) && (I = I.toLowerCase()), this.advance(), this.token.token_type === "_") {
          this.advance();
          let R = this.get_subsuperscript({ parse_absolute_value: E });
          I = I === "log" && R === 10 ? "log10" : ["_", I, R];
        }
        if (F) z && (I = ["apply", I, "＿"]);
        else {
          for (; this.token.token_type === "'"; ) I = ["prime", I], this.advance();
          for (; this.token.token_type === "^"; ) {
            this.advance();
            let R = this.get_subsuperscript({ parse_absolute_value: E });
            I = ["^", I, R];
          }
          if (this.token.token_type === "{" || this.token.token_type === "(") {
            let R;
            R = this.token.token_type === "{" ? "}" : ")", this.advance();
            let L = this.statement_list();
            if (this.token.token_type !== R) throw new ParseError("Expecting " + R, this.lexer.location);
            this.advance(), L[0] === "list" && (L[0] = "tuple"), I = ["apply", I, L];
          } else if (z) {
            if (!this.allowSimplifiedFunctionApplication) throw new ParseError("Expecting ( after function", this.lexer.location);
            let R = this.factor({ parse_absolute_value: E });
            R === !1 && (R = "＿"), I = ["apply", I, R];
          }
        }
        return I;
      } else if (I in this.operatorSymbols) {
        if (this.advance(), I === "frac" && this.parseLeibnizNotation) {
          let U = this.return_state(), Z = this.leibniz_notation();
          if (Z) return Z;
          this.set_state(U);
        }
        let z = I;
        this.operatorSymbols[I].substitute && (z = this.operatorSymbols[I].substitute);
        let R = this.operatorSymbols[I].nargs, L = this.operatorSymbols[I].remove_products, q = [];
        for (let U = 0; U < R; U++) if (this.token.token_type === "{") {
          this.advance();
          let Z = this.statement({ parse_absolute_value: E });
          if (L && Array.isArray(Z) && Z[0] === "*" ? q.push(...Z.slice(1)) : q.push(Z), this.token.token_type !== "}") throw new ParseError("Expecting }", this.lexer.location);
          this.advance();
        } else {
          let Z = this.get_single_digit_as_number();
          if (Z === null) if (this.token.token_type === "VAR") Z = this.token.token_text, this.advance();
          else throw new ParseError("Expecting {", this.lexer.location);
          q.push(Z);
        }
        I = [z, ...q];
      } else this.advance();
    } else if (this.token.token_type === "(" || this.token.token_type === "[" || this.token.token_type === "{" || this.token.token_type === "LBRACE" || this.token.token_type === "LANGLE") {
      let z = this.token.token_type, R, L;
      this.token.token_type === "(" ? (R = ")", L = "]") : this.token.token_type === "[" ? (R = "]", L = ")") : this.token.token_type === "{" ? (R = "}", L = null) : this.token.token_type === "LBRACE" ? (R = "RBRACE", L = null) : (R = "RANGLE", L = null), this.advance(), I = this.statement_list();
      let q = 1;
      if (I[0] === "list" && (q = I.length - 1), this.token.token_type !== R) {
        if (q !== 2 || L === null) throw new ParseError("Expecting " + R, this.lexer.location);
        if (this.token.token_type !== L) throw new ParseError("Expecting ) or ]", this.lexer.location);
        I[0] = "tuple", I = ["interval", I];
        let U;
        U = z === "(" ? ["tuple", !1, !0] : ["tuple", !0, !1], I.push(U);
      } else q >= 2 ? z === "(" || z === "{" ? I[0] = "tuple" : z === "[" ? I[0] = "array" : z === "LBRACE" ? I[0] = "set" : I[0] = "altvector" : z === "LBRACE" && (I = (I[0] === "|" || I[0], ["set", I]));
      this.advance();
    } else if (this.token.token_type[0] === "|" && E && (D === 0 || !O || this.token.token_type[1] === "L")) {
      if (D += 1, this.advance(), I = this.statement({ inside_absolute_value: D }), I = ["apply", "abs", I], this.token.token_type !== "|") throw new ParseError("Expecting |", this.lexer.location);
      this.advance();
    } else if (this.token.token_type === "LFLOOR" || this.token.token_type === "LCEIL") {
      let z, R;
      if (this.token.token_type === "LFLOOR" ? (z = "RFLOOR", R = "floor") : this.token.token_type === "LCEIL" && (z = "RCEIL", R = "ceil"), this.advance(), I = this.statement(), I = ["apply", R, I], this.token.token_type !== z) throw new ParseError("Expecting " + z, this.lexer.location);
      this.advance();
    } else if (this.token.token_type === "ANGLE") if (this.advance(), this.token.token_type === "{" || this.token.token_type === "(") {
      let z;
      z = this.token.token_type === "{" ? "}" : ")", this.advance();
      let R = this.statement_list();
      if (this.token.token_type !== z) throw new ParseError("Expecting " + z, this.lexer.location);
      this.advance(), R[0] === "list" ? I = ["angle", ...R.slice(1)] : R[0] === "*" && (I = ["angle", R]);
    } else {
      let z = [], R = this.nonMinusFactor({ parse_absolute_value: E });
      for (; R !== !1; ) z.push(R), R = this.nonMinusFactor({ parse_absolute_value: E });
      I = z.length === 0 ? "angle" : ["angle", ...z];
    }
    else if (this.token.token_type === "INT") {
      this.advance();
      let z = "int";
      if (this.token.token_type === "_") {
        this.advance();
        let L = this.get_subsuperscript({ parse_absolute_value: E });
        z = ["_", z, L];
      }
      if (this.token.token_type === "^") {
        this.advance();
        let L = this.get_subsuperscript({ parse_absolute_value: E });
        z = ["^", z, L];
      }
      let R = flatten(this.term({ parse_absolute_value: E }));
      if (Array.isArray(R) && R[0] === "*") {
        let L = [];
        for (let q = 0; q < R.length - 1; q++) if (R[q] === "d") {
          let U = R[q + 1];
          R.splice(q, 2), L.push(["d", U]), q--;
        }
        R.push(...L);
      }
      return ["apply", z, R];
    }
    if (this.token.token_type === "_") {
      I === !1 && (I = "＿"), this.advance();
      let z = this.get_subsuperscript({ parse_absolute_value: E });
      I = ["_", I, z];
    }
    return I;
  }
  leibniz_notation() {
    if (this.token.token_type !== "{") return !1;
    this.advance();
    var D = this.token.token_text;
    let E = "", O = 1, F = "", I = [], z = [];
    if (this.token.token_type === "LATEXCOMMAND" && D.slice(1) === "partial") E = "∂";
    else if (this.token.token_type === "VAR" && D === "d") E = "d";
    else return !1;
    if (this.advance(), this.token.token_type === "^") {
      this.advance();
      let L = !1;
      if (this.token.token_type === "{" && (L = !0, this.advance()), this.token.token_type !== "NUMBER" || (O = parseFloat(this.token.token_text), !Number.isInteger(O)) || L && (this.advance(), this.token.token_type !== "}")) return !1;
      this.advance();
    }
    if (this.token.token_type === "VAR") F = this.token.token_text;
    else if (this.token.token_type === "VARMULTICHAR") F = /\\operatorname\s*\{\s*([a-zA-Z0-9\+\-]+)\s*\}/.exec(this.token.token_text)[1];
    else if (this.token.token_type === "LATEXCOMMAND") if (D = this.token.token_text.slice(1), this.allowedLatexSymbols.includes(D)) F = D;
    else return !1;
    if (this.advance(), this.token.token_type !== "}" || (this.advance(), this.token.token_type !== "{")) return !1;
    this.advance();
    let R = 0;
    for (; ; ) {
      if (!(E === "d" && this.token.token_type === "VAR" && this.token.token_text === "d" || E === "∂" && this.token.token_type === "LATEXCOMMAND" && this.token.token_text.slice(1) === "partial")) return !1;
      if (this.advance(), this.token.token_type === "VAR") I.push(this.token.token_text);
      else if (this.token.token_type === "VARMULTICHAR") I.push(/\\operatorname\s*\{\s*([a-zA-Z0-9\+\-]+)\s*\}/.exec(this.token.token_text)[1]);
      else if (this.token.token_type === "LATEXCOMMAND") {
        let q = this.token.token_text.slice(1);
        if (this.allowedLatexSymbols.includes(q)) I.push(q);
        else return !1;
      } else return !1;
      let L = 1;
      if (this.advance(), this.token.token_type === "^") {
        this.advance();
        let q = !1;
        if (this.token.token_type === "{" && (q = !0, this.advance()), this.token.token_type !== "NUMBER" || (L = parseFloat(this.token.token_text), !Number.isInteger(L)) || q && (this.advance(), this.token.token_type !== "}")) return !1;
        this.advance();
      }
      if (z.push(L), R += L, R > O) return !1;
      if (R === O) {
        if (this.token.token_type !== "}") return !1;
        this.advance();
        let q = "derivative_leibniz";
        E === "∂" && (q = "partial_" + q), D = [q], O === 1 ? D.push(F) : D.push(["tuple", F, O]);
        let U = [];
        for (let Z = 0; Z < I.length; Z += 1) z[Z] === 1 ? U.push(I[Z]) : U.push(["tuple", I[Z], z[Z]]);
        return U = ["tuple"].concat(U), D.push(U), D;
      }
    }
  }
}, latexToGuppy = class {
  constructor() {
    this.latexToAst = new latexToAst$1(), this.astToGuppy = new astToGuppy$1();
  }
  convert(D) {
    return this.astToGuppy.convert(this.latexToAst.convert(D));
  }
}, latexToMathjs = class {
  constructor() {
    this.latexToAst = new latexToAst$1(), this.astToMathjs = new astToMathjs$2();
  }
  convert(D) {
    return this.astToMathjs.convert(this.latexToAst.convert(D));
  }
}, latexToText = class {
  constructor() {
    this.latexToAst = new latexToAst$1(), this.astToText = new astToText$2();
  }
  convert(D) {
    return this.astToText.convert(this.latexToAst.convert(D));
  }
}, mathjsToGuppy = class {
  constructor() {
    this.mathjsToAst = new mathjsToAst$1(), this.astToGuppy = new astToGuppy$1();
  }
  convert(D) {
    return this.astToGuppy.convert(this.mathjsToAst.convert(D));
  }
}, mathjsToLatex = class {
  constructor() {
    this.mathjsToAst = new mathjsToAst$1(), this.astToLatex = new astToLatex$1();
  }
  convert(D) {
    return this.astToLatex.convert(this.mathjsToAst.convert(D));
  }
}, mathjsToText = class {
  constructor() {
    this.mathjsToAst = new mathjsToAst$1(), this.astToText = new astToText$2();
  }
  convert(D) {
    return this.astToText.convert(this.mathjsToAst.convert(D));
  }
}, require_ms = __commonJSMin(((D, E) => {
  var O = 1e3, F = O * 60, I = F * 60, z = I * 24, R = z * 365.25;
  E.exports = function(V, G) {
    G ||= {};
    var W = typeof V;
    if (W === "string" && V.length > 0) return L(V);
    if (W === "number" && isNaN(V) === !1) return G.long ? U(V) : q(V);
    throw Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(V));
  };
  function L(V) {
    if (V = String(V), !(V.length > 100)) {
      var G = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(V);
      if (G) {
        var W = parseFloat(G[1]);
        switch ((G[2] || "ms").toLowerCase()) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return W * R;
          case "days":
          case "day":
          case "d":
            return W * z;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return W * I;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return W * F;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return W * O;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return W;
          default:
            return;
        }
      }
    }
  }
  function q(V) {
    return V >= z ? Math.round(V / z) + "d" : V >= I ? Math.round(V / I) + "h" : V >= F ? Math.round(V / F) + "m" : V >= O ? Math.round(V / O) + "s" : V + "ms";
  }
  function U(V) {
    return Z(V, z, "day") || Z(V, I, "hour") || Z(V, F, "minute") || Z(V, O, "second") || V + " ms";
  }
  function Z(V, G, W) {
    if (!(V < G)) return V < G * 1.5 ? Math.floor(V / G) + " " + W : Math.ceil(V / G) + " " + W + "s";
  }
})), require_debug = __commonJSMin(((D, E) => {
  D = E.exports = I.debug = I.default = I, D.coerce = q, D.disable = R, D.enable = z, D.enabled = L, D.humanize = require_ms(), D.names = [], D.skips = [], D.formatters = {};
  var O;
  function F(U) {
    var Z = 0, V;
    for (V in U) Z = (Z << 5) - Z + U.charCodeAt(V), Z |= 0;
    return D.colors[Math.abs(Z) % D.colors.length];
  }
  function I(U) {
    function Z() {
      if (Z.enabled) {
        var V = Z, G = +/* @__PURE__ */ new Date();
        V.diff = G - (O || G), V.prev = O, V.curr = G, O = G;
        for (var W = Array(arguments.length), J = 0; J < W.length; J++) W[J] = arguments[J];
        W[0] = D.coerce(W[0]), typeof W[0] != "string" && W.unshift("%O");
        var X = 0;
        W[0] = W[0].replace(/%([a-zA-Z%])/g, function(Y, ee) {
          if (Y === "%%") return Y;
          X++;
          var K = D.formatters[ee];
          if (typeof K == "function") {
            var te = W[X];
            Y = K.call(V, te), W.splice(X, 1), X--;
          }
          return Y;
        }), D.formatArgs.call(V, W), (Z.log || D.log || console.log.bind(console)).apply(V, W);
      }
    }
    return Z.namespace = U, Z.enabled = D.enabled(U), Z.useColors = D.useColors(), Z.color = F(U), typeof D.init == "function" && D.init(Z), Z;
  }
  function z(U) {
    D.save(U), D.names = [], D.skips = [];
    for (var Z = (typeof U == "string" ? U : "").split(/[\s,]+/), V = Z.length, G = 0; G < V; G++) Z[G] && (U = Z[G].replace(/\*/g, ".*?"), U[0] === "-" ? D.skips.push(RegExp("^" + U.substr(1) + "$")) : D.names.push(RegExp("^" + U + "$")));
  }
  function R() {
    D.enable("");
  }
  function L(U) {
    var Z, V;
    for (Z = 0, V = D.skips.length; Z < V; Z++) if (D.skips[Z].test(U)) return !1;
    for (Z = 0, V = D.names.length; Z < V; Z++) if (D.names[Z].test(U)) return !0;
    return !1;
  }
  function q(U) {
    return U instanceof Error ? U.stack || U.message : U;
  }
})), require_browser = __commonJSMin(((D, E) => {
  D = E.exports = require_debug(), D.log = I, D.formatArgs = F, D.save = z, D.load = R, D.useColors = O, D.storage = typeof chrome < "u" && chrome.storage !== void 0 ? chrome.storage.local : L(), D.colors = ["lightseagreen", "forestgreen", "goldenrod", "dodgerblue", "darkorchid", "crimson"];
  function O() {
    return typeof window < "u" && window.process && window.process.type === "renderer" ? !0 : typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
  }
  D.formatters.j = function(q) {
    try {
      return JSON.stringify(q);
    } catch (U) {
      return "[UnexpectedJSONParseError]: " + U.message;
    }
  };
  function F(q) {
    var U = this.useColors;
    if (q[0] = (U ? "%c" : "") + this.namespace + (U ? " %c" : " ") + q[0] + (U ? "%c " : " ") + "+" + D.humanize(this.diff), U) {
      var Z = "color: " + this.color;
      q.splice(1, 0, Z, "color: inherit");
      var V = 0, G = 0;
      q[0].replace(/%[a-zA-Z%]/g, function(W) {
        W !== "%%" && (V++, W === "%c" && (G = V));
      }), q.splice(G, 0, Z);
    }
  }
  function I() {
    return typeof console == "object" && console.log && Function.prototype.apply.call(console.log, console, arguments);
  }
  function z(q) {
    try {
      q == null ? D.storage.removeItem("debug") : D.storage.debug = q;
    } catch {
    }
  }
  function R() {
    var q;
    try {
      q = D.storage.debug;
    } catch {
    }
    return !q && typeof process < "u" && "env" in process && (q = process.env.DEBUG), q;
  }
  D.enable(R());
  function L() {
    try {
      return window.localStorage;
    } catch {
    }
  }
})), require_xml_parser = __commonJSMin(((D, E) => {
  var O = require_browser()("xml-parser");
  E.exports = F;
  function F(I) {
    return I = I.trim(), I = I.replace(/<!--[\s\S]*?-->/g, ""), z();
    function z() {
      return { declaration: R(), root: L() };
    }
    function R() {
      if (V(/^<\?xml\s*/)) {
        for (var J = { attributes: {} }; !(G() || W("?>")); ) {
          var X = U();
          if (!X) return J;
          J.attributes[X.name] = X.value;
        }
        return V(/\?>\s*/), J;
      }
    }
    function L() {
      O("tag %j", I);
      var J = V(/^<([\w-:.]+)\s*/);
      if (J) {
        for (var X = { name: J[1], attributes: {}, children: [] }; !(G() || W(">") || W("?>") || W("/>")); ) {
          var Y = U();
          if (!Y) return X;
          X.attributes[Y.name] = Y.value;
        }
        if (V(/^\s*\/>\s*/)) return X;
        V(/\??>\s*/), X.content = q();
        for (var ee; ee = L(); ) X.children.push(ee);
        return V(/^<\/[\w-:.]+>\s*/), X;
      }
    }
    function q() {
      O("content %j", I);
      var J = V(/^([^<]*)/);
      return J ? J[1] : "";
    }
    function U() {
      O("attribute %j", I);
      var J = V(/([\w:-]+)\s*=\s*("[^"]*"|'[^']*'|\w+)\s*/);
      if (J) return { name: J[1], value: Z(J[2]) };
    }
    function Z(J) {
      return J.replace(/^['"]|['"]$/g, "");
    }
    function V(J) {
      var X = I.match(J);
      if (X) return I = I.slice(X[0].length), X;
    }
    function G() {
      return I.length == 0;
    }
    function W(J) {
      return I.indexOf(J) == 0;
    }
  }
})), import_xml_parser = __toESM(require_xml_parser()), entities = { "&#913;": "\\Alpha", "&Alpha;": "\\Alpha", "&#x0391;": "\\Alpha", "\\u0391;": "\\Alpha", "&#914;": "\\Beta", "&Beta;": "\\Beta", "&#x0392;": "\\Beta", "\\u0392;": "\\Beta", "&#915;": "\\Gamma", "&Gamma;": "\\Gamma", "&#x0393;": "\\Gamma", "\\u0393;": "\\Gamma", "&#916;": "\\Delta", "&Delta;": "\\Delta", "&#x0394;": "\\Delta", "\\u0394;": "\\Delta", "&#917;": "\\Epsilon", "&Epsilon;": "\\Epsilon", "&#x0395;": "\\Epsilon", "\\u0395;": "\\Epsilon", "&#918;": "\\Zeta", "&Zeta;": "\\Zeta", "&#x0396;": "\\Zeta", "\\u0396;": "\\Zeta", "&#919;": "\\Eta", "&Eta;": "\\Eta", "&#x0397;": "\\Eta", "\\u0397;": "\\Eta", "&#920;": "\\Theta", "&Theta;": "\\Theta", "&#x0398;": "\\Theta", "\\u0398;": "\\Theta", "&#921;": "\\Iota", "&Iota;": "\\Iota", "&#x0399;": "\\Iota", "\\u0399;": "\\Iota", "&#922;": "\\Kappa", "&Kappa;": "\\Kappa", "&#x039A;": "\\Kappa", "\\u039A;": "\\Kappa", "&#923;": "\\Lambda", "&Lambda;": "\\Lambda", "&#x039B;": "\\Lambda", "\\u039B;": "\\Lambda", "&#924;": "\\Mu", "&Mu;": "\\Mu", "&#x039C;": "\\Mu", "\\u039C;": "\\Mu", "&#925;": "\\Nu", "&Nu;": "\\Nu", "&#x039D;": "\\Nu", "\\u039D;": "\\Nu", "&#926;": "\\Xi", "&Xi;": "\\Xi", "&#x039E;": "\\Xi", "\\u039E;": "\\Xi", "&#927;": "\\Omicron", "&Omicron;": "\\Omicron", "&#x039F;": "\\Omicron", "\\u039F;": "\\Omicron", "&#928;": "\\Pi", "&Pi;": "\\Pi", "&#x03A0;": "\\Pi", "\\u03A0;": "\\Pi", "&#929;": "\\Rho", "&Rho;": "\\Rho", "&#x03A1;": "\\Rho", "\\u03A1;": "\\Rho", "&#931;": "\\Sigma", "&Sigma;": "\\Sigma", "&#x03A3;": "\\Sigma", "\\u03A3;": "\\Sigma", "&#932;": "\\Tau", "&Tau;": "\\Tau", "&#x03A4;": "\\Tau", "\\u03A4;": "\\Tau", "&#933;": "\\Upsilon", "&Upsilon;": "\\Upsilon", "&#x03A5;": "\\Upsilon", "\\u03A5;": "\\Upsilon", "&#934;": "\\Phi", "&Phi;": "\\Phi", "&#x03A6;": "\\Phi", "\\u03A6;": "\\Phi", "&#935;": "\\Chi", "&Chi;": "\\Chi", "&#x03A7;": "\\Chi", "\\u03A7;": "\\Chi", "&#936;": "\\Psi", "&Psi;": "\\Psi", "&#x03A8;": "\\Psi", "\\u03A8;": "\\Psi", "&#937;": "\\Omega", "&Omega;": "\\Omega", "&#x03A9;": "\\Omega", "\\u03A9;": "\\Omega", "&#945;": "\\alpha", "&alpha;": "\\alpha", "&#x03B1;": "\\alpha", "\\u03B1;": "\\alpha", "&#946;": "\\beta", "&beta;": "\\beta", "&#x03B2;": "\\beta", "\\u03B2;": "\\beta", "&#947;": "\\gamma", "&gamma;": "\\gamma", "&#x03B3;": "\\gamma", "\\u03B3;": "\\gamma", "&#948;": "\\delta", "&delta;": "\\delta", "&#x03B4;": "\\delta", "\\u03B4;": "\\delta", "&#949;": "\\epsilon", "&epsilon;": "\\epsilon", "&#x03B5;": "\\epsilon", "\\u03B5;": "\\epsilon", "&#950;": "\\zeta", "&zeta;": "\\zeta", "&#x03B6;": "\\zeta", "\\u03B6;": "\\zeta", "&#951;": "\\eta", "&eta;": "\\eta", "&#x03B7;": "\\eta", "\\u03B7;": "\\eta", "&#952;": "\\theta", "&theta;": "\\theta", "&#x03B8;": "\\theta", "\\u03B8;": "\\theta", "&#953;": "\\iota", "&iota;": "\\iota", "&#x03B9;": "\\iota", "\\u03B9;": "\\iota", "&#954;": "\\kappa", "&kappa;": "\\kappa", "&#x03BA;": "\\kappa", "\\u03BA;": "\\kappa", "&#955;": "\\lambda", "&lambda;": "\\lambda", "&#x03BB;": "\\lambda", "\\u03BB;": "\\lambda", "&#956;": "\\mu", "&mu;": "\\mu", "&#x03BC;": "\\mu", "\\u03BC;": "\\mu", "&#957;": "\\nu", "&nu;": "\\nu", "&#x03BD;": "\\nu", "\\u03BD;": "\\nu", "&#958;": "\\xi", "&xi;": "\\xi", "&#x03BE;": "\\xi", "\\u03BE;": "\\xi", "&#959;": "\\omicron", "&omicron;": "\\omicron", "&#x03BF;": "\\omicron", "\\u03BF;": "\\omicron", "&#960;": "\\pi", "&pi;": "\\pi", "&#x03C0;": "\\pi", "\\u03C0;": "\\pi", "&#961;": "\\rho", "&rho;": "\\rho", "&#x03C1;": "\\rho", "\\u03C1;": "\\rho", "&#962;": "\\sigma", ";": "\\sigma", "&#x03C2;": "\\sigma", "\\u03C2;": "\\sigma", "&#963;": "\\sigma", "&sigma;": "\\sigma", "&#x03C3;": "\\sigma", "\\u03C3;": "\\sigma", "&#964;": "\\tau", "&tau;": "\\tau", "&#x03C4;": "\\tau", "\\u03C4;": "\\tau", "&#965;": "\\upsilon", "&upsilon;": "\\upsilon", "&#x03C5;": "\\upsilon", "\\u03C5;": "\\upsilon", "&#966;": "\\phi", "&phi;": "\\phi", "&#x03C6;": "\\phi", "\\u03C6;": "\\phi", "&#967;": "\\chi", "&chi;": "\\chi", "&#x03C7;": "\\chi", "\\u03C7;": "\\chi", "&#968;": "\\psi", "&psi;": "\\psi", "&#x03C8;": "\\psi", "\\u03C8;": "\\psi", "&#969;": "\\omega", "&omega;": "\\omega", "&#x03C9;": "\\omega", "\\u03C9;": "\\omega", "&#x2212;": "-", "&minus;": "-", "&#x221E;": "\\infty", "&#8734;": "\\infty", "&infin;": "\\infty", "&sdot;": "\\cdot", "&#x22C5;": "\\cdot", "&#8901;": "\\cdot", "&times;": "\\times", "&#x00D7;": "\\times", "&#215;": "\\times" }, mmlToLatex = class {
  parse(D) {
    if (D.name === "mi") return entities[D.content] ? entities[D.content] : D.content.length > 1 ? "\\" + D.content : D.content;
    if (D.name === "mn") return D.content;
    if (D.name === "msup") return this.parse(D.children[0]) + "^{" + this.parse(D.children[1]) + "}";
    if (D.name === "mroot") return "\\sqrt[" + this.parse(D.children[1]) + "]{" + this.parse(D.children[1]) + "}";
    if (D.name === "mfrac") return "\\frac{" + this.parse(D.children[0]) + "}{" + this.parse(D.children[1]) + "}";
    if (D.name === "msqrt") return "\\sqrt{" + D.children.map((function(E, O) {
      return this.parse(E);
    }).bind(this)).join(" ") + "}";
    if (D.name === "mo") return entities[D.content] ? entities[D.content] : D.content === "&#x2061;" ? " " : D.content;
    if (D.name === "mrow" && D.attributes.class === "MJX-TeXAtom-ORD") return D.children.map((function(E, O) {
      return this.parse(E);
    }).bind(this)).join(" ");
    if (D.name === "math" || D.name === "mrow") return "(" + D.children.map((function(E, O) {
      return this.parse(E);
    }).bind(this)).join(" ") + ")";
  }
  convert(D) {
    return this.parse((0, import_xml_parser.default)(D).root);
  }
}, mmlToAst$1 = class {
  constructor() {
    this.mmlToLatex = new mmlToLatex(), this.latexToAst = new latexToAst$1();
  }
  convert(D) {
    return this.latexToAst.convert(this.mmlToLatex.convert(D));
  }
}, mmlToGuppy = class {
  constructor() {
    this.mmlToLatex = new mmlToLatex(), this.latexToAst = new latexToAst$1(), this.astToGuppy = new astToGuppy$1();
  }
  convert(D) {
    return this.astToGuppy.convert(this.latexToAst.convert(this.mmlToLatex.convert(D)));
  }
}, mmlToMathjs = class {
  constructor() {
    this.mmlToLatex = new mmlToLatex(), this.latexToAst = new latexToAst$1(), this.astToMathjs = new astToMathjs$2();
  }
  convert(D) {
    return this.astToMathjs.convert(this.latexToAst.convert(this.mmlToLatex.convert(D)));
  }
}, mmlToText = class {
  constructor() {
    this.mmlToLatex = new mmlToLatex(), this.latexToAst = new latexToAst$1(), this.astToText = new astToText$2();
  }
  convert(D) {
    return this.astToText.convert(this.latexToAst.convert(this.mmlToLatex.convert(D)));
  }
}, textToGuppy = class {
  constructor() {
    this.textToAst = new textToAst$4(), this.astToGuppy = new astToGuppy$1();
  }
  convert(D) {
    return this.astToGuppy.convert(this.textToAst.convert(D));
  }
}, textToLatex = class {
  constructor() {
    this.textToAst = new textToAst$4(), this.astToLatex = new astToLatex$1();
  }
  convert(D) {
    return this.astToLatex.convert(this.textToAst.convert(D));
  }
}, textToMathjs = class {
  constructor() {
    this.textToAst = new textToAst$4(), this.astToMathjs = new astToMathjs$2();
  }
  convert(D) {
    return this.astToMathjs.convert(this.textToAst.convert(D));
  }
}, converters_exports = __exportAll({ astToFiniteFieldObj: () => astToFiniteField$1, astToGLSL: () => astToGLSL$1, astToGuppyObj: () => astToGuppy$1, astToLatexObj: () => astToLatex$1, astToMathjsObj: () => astToMathjs$2, astToTextObj: () => astToText$2, latexToAstObj: () => latexToAst$1, latexToGuppyObj: () => latexToGuppy, latexToMathjsObj: () => latexToMathjs, latexToTextObj: () => latexToText, mathjsToAstObj: () => mathjsToAst$1, mathjsToGuppyObj: () => mathjsToGuppy, mathjsToLatexObj: () => mathjsToLatex, mathjsToTextObj: () => mathjsToText, mmlToAstObj: () => mmlToAst$1, mmlToGuppyObj: () => mmlToGuppy, mmlToLatexObj: () => mmlToLatex, mmlToMathjsObj: () => mmlToMathjs, mmlToTextObj: () => mmlToText, textToAstObj: () => textToAst$4, textToGuppyObj: () => textToGuppy, textToLatexObj: () => textToLatex, textToMathjsObj: () => textToMathjs }), textToAst = new textToAst$4(), latexToAst = new latexToAst$1(), mmlToAst = new mmlToAst$1(), utils = { match: match$1, flatten: flatten$5, unflattenLeft, unflattenRight };
function Expression(D, E) {
  this.tree = flatten$5(D), this.context = E, this.toJSON = function() {
    let O = { objectType: "math-expression", tree: this.tree }, F = {};
    for (let I in this.context.assumptions) Object.keys(this.context.assumptions[I]).length > 0 && (F[I] = this.context.assumptions[I]);
    return Object.keys(F).length > 0 && (O.assumptions = F), O;
  };
}
function extend(D, E) {
  return flatten_array(Array.prototype.slice.call(arguments, 2)).forEach(function(O) {
    if (O) for (var F in O) E ? (function() {
      var I = F;
      D[I] = function() {
        return this.fromAst(O[I].apply(null, arguments));
      };
    })() : D[F] = O[F];
  }), D;
}
function extend_prototype(D, E) {
  return flatten_array(Array.prototype.slice.call(arguments, 2)).forEach(function(O) {
    if (O) for (var F in O) (function() {
      var I = F;
      D[I] = function() {
        var z = [this].concat(Array.prototype.slice.call(arguments));
        return E ? this.context.fromAst(O[I].apply(null, z)) : O[I].apply(null, z);
      };
    })();
  }), D;
}
function create_from_multiple(D, E) {
  if (Array.isArray(D) || typeof D == "number") return new Expression(D, Context);
  if (typeof D == "string") try {
    return new Expression(textToAst.convert(D), Context);
  } catch (O) {
    try {
      return new Expression(latexToAst.convert(D), Context);
    } catch (F) {
      try {
        return new Expression(mmlToAst.convert(D), Context);
      } catch (I) {
        throw D.indexOf("\\") === -1 ? D.indexOf("</") === -1 ? O : I : F;
      }
    }
  }
}
function parseText(D, E) {
  return new Expression(textToAst.convert(D), Context);
}
function parseLatex(D, E) {
  return new Expression(latexToAst.convert(D), Context);
}
function parseMml(D, E) {
  return new Expression(mmlToAst.convert(D), Context);
}
var Context = { ZmodN, assumptions: initialize_assumptions(), parser_parameters: {}, from: create_from_multiple, fromText: parseText, parse: parseText, fromLaTeX: parseLatex, fromLatex: parseLatex, fromTeX: parseLatex, fromTex: parseLatex, fromMml: parseMml, parse_tex: parseLatex, converters: converters_exports, utils, fromAst: function(D) {
  return new Expression(D, this);
}, set_to_default: function() {
  this.assumptions = initialize_assumptions();
}, get_assumptions: function(D, E) {
  return get_assumptions(this.assumptions, D, E);
}, add_assumption: function(D, E) {
  return add_assumption(this.assumptions, D, E);
}, add_generic_assumption: function(D) {
  return add_generic_assumption(this.assumptions, D);
}, remove_assumption: function(D) {
  return remove_assumption(this.assumptions, D);
}, remove_generic_assumption: function(D) {
  return remove_generic_assumption(this.assumptions, D);
}, clear_assumptions: function() {
  this.assumptions = initialize_assumptions();
}, math: mathjs_default, reviver: function(D, E) {
  if (E && E.objectType === "math-expression" && E.tree !== void 0) {
    let O = Context.fromAst(E.tree);
    return E.assumptions !== void 0 && (O.assumptions = E.assumptions), O;
  }
  return E;
}, class: Expression };
Context.set_to_default(), extend(Context, !0, expression_to_tree$1, expression_to_tree), extend(Context, !1, expression_to_other), extend_prototype(Expression.prototype, !0, expression_to_tree$1), extend_prototype(Expression.prototype, !1, expression_to_other);
function flatten_array(D, E) {
  E = E === void 0 ? [] : E;
  for (var O = 0; O < D.length; O++) Array.isArray(D[O]) ? flatten_array(D[O], E) : E.push(D[O]);
  return E;
}
function ensureGlobalThis() {
  typeof globalThis != "object" && (Object.defineProperty(Object.prototype, "__magic__", {
    get: function() {
      return this;
    },
    configurable: !0
    // This makes it possible to `delete` the getter later.
  }), __magic__.globalThis = __magic__, delete Object.prototype.__magic__);
}
ensureGlobalThis();
const _globalThis = globalThis;
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(D) {
  return D && D.__esModule && Object.prototype.hasOwnProperty.call(D, "default") ? D.default : D;
}
var colorName$1, hasRequiredColorName;
function requireColorName() {
  return hasRequiredColorName || (hasRequiredColorName = 1, colorName$1 = {
    aliceblue: [240, 248, 255],
    antiquewhite: [250, 235, 215],
    aqua: [0, 255, 255],
    aquamarine: [127, 255, 212],
    azure: [240, 255, 255],
    beige: [245, 245, 220],
    bisque: [255, 228, 196],
    black: [0, 0, 0],
    blanchedalmond: [255, 235, 205],
    blue: [0, 0, 255],
    blueviolet: [138, 43, 226],
    brown: [165, 42, 42],
    burlywood: [222, 184, 135],
    cadetblue: [95, 158, 160],
    chartreuse: [127, 255, 0],
    chocolate: [210, 105, 30],
    coral: [255, 127, 80],
    cornflowerblue: [100, 149, 237],
    cornsilk: [255, 248, 220],
    crimson: [220, 20, 60],
    cyan: [0, 255, 255],
    darkblue: [0, 0, 139],
    darkcyan: [0, 139, 139],
    darkgoldenrod: [184, 134, 11],
    darkgray: [169, 169, 169],
    darkgreen: [0, 100, 0],
    darkgrey: [169, 169, 169],
    darkkhaki: [189, 183, 107],
    darkmagenta: [139, 0, 139],
    darkolivegreen: [85, 107, 47],
    darkorange: [255, 140, 0],
    darkorchid: [153, 50, 204],
    darkred: [139, 0, 0],
    darksalmon: [233, 150, 122],
    darkseagreen: [143, 188, 143],
    darkslateblue: [72, 61, 139],
    darkslategray: [47, 79, 79],
    darkslategrey: [47, 79, 79],
    darkturquoise: [0, 206, 209],
    darkviolet: [148, 0, 211],
    deeppink: [255, 20, 147],
    deepskyblue: [0, 191, 255],
    dimgray: [105, 105, 105],
    dimgrey: [105, 105, 105],
    dodgerblue: [30, 144, 255],
    firebrick: [178, 34, 34],
    floralwhite: [255, 250, 240],
    forestgreen: [34, 139, 34],
    fuchsia: [255, 0, 255],
    gainsboro: [220, 220, 220],
    ghostwhite: [248, 248, 255],
    gold: [255, 215, 0],
    goldenrod: [218, 165, 32],
    gray: [128, 128, 128],
    green: [0, 128, 0],
    greenyellow: [173, 255, 47],
    grey: [128, 128, 128],
    honeydew: [240, 255, 240],
    hotpink: [255, 105, 180],
    indianred: [205, 92, 92],
    indigo: [75, 0, 130],
    ivory: [255, 255, 240],
    khaki: [240, 230, 140],
    lavender: [230, 230, 250],
    lavenderblush: [255, 240, 245],
    lawngreen: [124, 252, 0],
    lemonchiffon: [255, 250, 205],
    lightblue: [173, 216, 230],
    lightcoral: [240, 128, 128],
    lightcyan: [224, 255, 255],
    lightgoldenrodyellow: [250, 250, 210],
    lightgray: [211, 211, 211],
    lightgreen: [144, 238, 144],
    lightgrey: [211, 211, 211],
    lightpink: [255, 182, 193],
    lightsalmon: [255, 160, 122],
    lightseagreen: [32, 178, 170],
    lightskyblue: [135, 206, 250],
    lightslategray: [119, 136, 153],
    lightslategrey: [119, 136, 153],
    lightsteelblue: [176, 196, 222],
    lightyellow: [255, 255, 224],
    lime: [0, 255, 0],
    limegreen: [50, 205, 50],
    linen: [250, 240, 230],
    magenta: [255, 0, 255],
    maroon: [128, 0, 0],
    mediumaquamarine: [102, 205, 170],
    mediumblue: [0, 0, 205],
    mediumorchid: [186, 85, 211],
    mediumpurple: [147, 112, 219],
    mediumseagreen: [60, 179, 113],
    mediumslateblue: [123, 104, 238],
    mediumspringgreen: [0, 250, 154],
    mediumturquoise: [72, 209, 204],
    mediumvioletred: [199, 21, 133],
    midnightblue: [25, 25, 112],
    mintcream: [245, 255, 250],
    mistyrose: [255, 228, 225],
    moccasin: [255, 228, 181],
    navajowhite: [255, 222, 173],
    navy: [0, 0, 128],
    oldlace: [253, 245, 230],
    olive: [128, 128, 0],
    olivedrab: [107, 142, 35],
    orange: [255, 165, 0],
    orangered: [255, 69, 0],
    orchid: [218, 112, 214],
    palegoldenrod: [238, 232, 170],
    palegreen: [152, 251, 152],
    paleturquoise: [175, 238, 238],
    palevioletred: [219, 112, 147],
    papayawhip: [255, 239, 213],
    peachpuff: [255, 218, 185],
    peru: [205, 133, 63],
    pink: [255, 192, 203],
    plum: [221, 160, 221],
    powderblue: [176, 224, 230],
    purple: [128, 0, 128],
    rebeccapurple: [102, 51, 153],
    red: [255, 0, 0],
    rosybrown: [188, 143, 143],
    royalblue: [65, 105, 225],
    saddlebrown: [139, 69, 19],
    salmon: [250, 128, 114],
    sandybrown: [244, 164, 96],
    seagreen: [46, 139, 87],
    seashell: [255, 245, 238],
    sienna: [160, 82, 45],
    silver: [192, 192, 192],
    skyblue: [135, 206, 235],
    slateblue: [106, 90, 205],
    slategray: [112, 128, 144],
    slategrey: [112, 128, 144],
    snow: [255, 250, 250],
    springgreen: [0, 255, 127],
    steelblue: [70, 130, 180],
    tan: [210, 180, 140],
    teal: [0, 128, 128],
    thistle: [216, 191, 216],
    tomato: [255, 99, 71],
    turquoise: [64, 224, 208],
    violet: [238, 130, 238],
    wheat: [245, 222, 179],
    white: [255, 255, 255],
    whitesmoke: [245, 245, 245],
    yellow: [255, 255, 0],
    yellowgreen: [154, 205, 50]
  }), colorName$1;
}
var colorNameExports = requireColorName();
const colorName = /* @__PURE__ */ getDefaultExportFromCjs(colorNameExports);
var nearestColor$2 = { exports: {} }, nearestColor$1 = nearestColor$2.exports, hasRequiredNearestColor;
function requireNearestColor() {
  return hasRequiredNearestColor || (hasRequiredNearestColor = 1, (function(D) {
    (function(E) {
      function O(U, Z) {
        if (U = I(U), !U)
          return null;
        var V, G = 1 / 0, W, J;
        Z || (Z = O.DEFAULT_COLORS);
        for (var X = 0; X < Z.length; ++X)
          W = Z[X].rgb, V = Math.pow(U.r - W.r, 2) + Math.pow(U.g - W.g, 2) + Math.pow(U.b - W.b, 2), V < G && (G = V, J = Z[X]);
        return J.name ? {
          name: J.name,
          value: J.source,
          rgb: J.rgb,
          distance: Math.sqrt(G)
        } : J.source;
      }
      O.from = function U(Z) {
        var V = F(Z), G = O, W = function(X) {
          return G(X, V);
        };
        return W.from = U, W.or = function(X) {
          var Y = V.concat(F(X));
          return O.from(Y);
        }, W;
      };
      function F(U) {
        return U instanceof Array ? U.map(function(Z) {
          return z(Z);
        }) : Object.keys(U).map(function(Z) {
          return z(U[Z], Z);
        });
      }
      function I(U) {
        var Z, V, G;
        if (typeof U == "object")
          return U;
        if (U in O.STANDARD_COLORS)
          return I(O.STANDARD_COLORS[U]);
        var W = U.match(/^#?((?:[0-9a-f]{3}){1,2})$/i);
        if (W)
          return W = W[1], W.length === 3 ? W = [
            W.charAt(0) + W.charAt(0),
            W.charAt(1) + W.charAt(1),
            W.charAt(2) + W.charAt(2)
          ] : W = [
            W.substring(0, 2),
            W.substring(2, 4),
            W.substring(4, 6)
          ], Z = parseInt(W[0], 16), V = parseInt(W[1], 16), G = parseInt(W[2], 16), { r: Z, g: V, b: G };
        var J = U.match(/^rgb\(\s*(\d{1,3}%?),\s*(\d{1,3}%?),\s*(\d{1,3}%?)\s*\)$/i);
        if (J)
          return Z = R(J[1]), V = R(J[2]), G = R(J[3]), { r: Z, g: V, b: G };
        throw Error('"' + U + '" is not a valid color');
      }
      function z(U, Z) {
        var V = {};
        if (Z && (V.name = Z), typeof U == "string")
          V.source = U, V.rgb = I(U);
        else if (typeof U == "object") {
          if (U.source)
            return z(U.source, U.name);
          V.rgb = U, V.source = L(U);
        }
        return V;
      }
      function R(U) {
        return U.charAt(U.length - 1) === "%" ? Math.round(parseInt(U, 10) * 255 / 100) : Number(U);
      }
      function L(U) {
        return "#" + q(U.r.toString(16)) + q(U.g.toString(16)) + q(U.b.toString(16));
      }
      function q(U) {
        return U.length === 1 && (U = "0" + U), U;
      }
      O.STANDARD_COLORS = {
        aqua: "#0ff",
        black: "#000",
        blue: "#00f",
        fuchsia: "#f0f",
        gray: "#808080",
        green: "#008000",
        lime: "#0f0",
        maroon: "#800000",
        navy: "#000080",
        olive: "#808000",
        orange: "#ffa500",
        purple: "#800080",
        red: "#f00",
        silver: "#c0c0c0",
        teal: "#008080",
        white: "#fff",
        yellow: "#ff0"
      }, O.DEFAULT_COLORS = F([
        "#f00",
        // r
        "#f80",
        // o
        "#ff0",
        // y
        "#0f0",
        // g
        "#00f",
        // b
        "#008",
        // i
        "#808"
        // v
      ]), O.VERSION = "0.4.4", D && D.exports ? D.exports = O : E.nearestColor = O;
    })(nearestColor$1);
  })(nearestColor$2)), nearestColor$2.exports;
}
var nearestColorExports = requireNearestColor();
const nearestColor = /* @__PURE__ */ getDefaultExportFromCjs(nearestColorExports), canonicalColorHexByKey = {
  black: "#000000",
  white: "#ffffff",
  gray: "#808080",
  red: "#ff0000",
  orange: "#ffa500",
  yellow: "#ffff00",
  green: "#008000",
  cyan: "#00ffff",
  blue: "#0000ff",
  purple: "#800080",
  pink: "#ffc0cb",
  brown: "#a52a2a"
}, canonicalAnchorDefinitions = Object.fromEntries(
  Object.entries(canonicalColorHexByKey).map(([D, E]) => [
    D,
    { hex: E, canonical: D }
  ])
), extraAnchorDefinitions = {
  silver: { hex: "#c0c0c0", canonical: "gray" },
  grayDark: { hex: "#4d4d4d", canonical: "gray" },
  grayCustom: { hex: "#757575", canonical: "gray" },
  grayLight: { hex: "#c8c8c8", canonical: "gray" },
  grayLighter: { hex: "#dcdcdc", canonical: "gray" },
  maroon: { hex: "#800000", canonical: "red" },
  redLight: { hex: "#f08080", canonical: "red" },
  redCustom: { hex: "#D4042D", canonical: "red" },
  redDark: { hex: "#8b0000", canonical: "red" },
  orangeLight: { hex: "#ffa07a", canonical: "orange" },
  orangeCustom: { hex: "#F19143", canonical: "orange" },
  orangePresetAccessible: { hex: "#a6510c", canonical: "orange" },
  orangeDark: { hex: "#ff8c00", canonical: "orange" },
  yellowLight: { hex: "#ffffe0", canonical: "yellow" },
  yellowDark: { hex: "#bdb76b", canonical: "yellow" },
  yellowgreen: { hex: "#9acd32", canonical: "green" },
  olive: { hex: "#808000", canonical: "green" },
  lime: { hex: "#00ff00", canonical: "green" },
  greenLight: { hex: "#90ee90", canonical: "green" },
  greenCustom: { hex: "#2ca02c", canonical: "green" },
  greenDark: { hex: "#006400", canonical: "green" },
  teal: { hex: "#008080", canonical: "green" },
  aqua: { hex: "#00ffff", canonical: "cyan" },
  cyanLight: { hex: "#e0ffff", canonical: "cyan" },
  cyanDark: { hex: "#008b8b", canonical: "cyan" },
  navy: { hex: "#000080", canonical: "blue" },
  blueCustom: { hex: "#648FFF", canonical: "blue" },
  bluePresetAccessible: { hex: "#1f5dff", canonical: "blue" },
  blueLight: { hex: "#add8e6", canonical: "blue" },
  blueDark: { hex: "#00008b", canonical: "blue" },
  fuchsia: { hex: "#ff00ff", canonical: "purple" },
  purpleCustom: { hex: "#644CD6", canonical: "purple" },
  purpleLight: { hex: "#dda0dd", canonical: "purple" },
  purpleDark: { hex: "#8b008b", canonical: "purple" },
  hotpink: { hex: "#ff69b4", canonical: "pink" },
  pinkDark: { hex: "#ff1493", canonical: "pink" },
  brownLight: { hex: "#deb887", canonical: "brown" },
  brownDark: { hex: "#8b4513", canonical: "brown" }
}, anchorDefinitions = {
  ...canonicalAnchorDefinitions,
  ...extraAnchorDefinitions
}, matchColorHexByName = Object.fromEntries(
  Object.entries(anchorDefinitions).map(([D, E]) => [
    D,
    E.hex
  ])
);
Object.fromEntries(
  Object.entries(anchorDefinitions).map(([D, E]) => [
    D,
    E.canonical
  ])
);
nearestColor.from(matchColorHexByName);
[
  ...Object.keys(colorName)
];
var r = { grad: 0.9, turn: 360, rad: 360 / (2 * Math.PI) }, t$1 = function(D) {
  return typeof D == "string" ? D.length > 0 : typeof D == "number";
}, n = function(D, E, O) {
  return E === void 0 && (E = 0), O === void 0 && (O = Math.pow(10, E)), Math.round(O * D) / O + 0;
}, e = function(D, E, O) {
  return E === void 0 && (E = 0), O === void 0 && (O = 1), D > O ? O : D > E ? D : E;
}, u = function(D) {
  return (D = isFinite(D) ? D % 360 : 0) > 0 ? D : D + 360;
}, a = function(D) {
  return { r: e(D.r, 0, 255), g: e(D.g, 0, 255), b: e(D.b, 0, 255), a: e(D.a) };
}, o$1 = function(D) {
  return { r: n(D.r), g: n(D.g), b: n(D.b), a: n(D.a, 3) };
}, i = /^#([0-9a-f]{3,8})$/i, s = function(D) {
  var E = D.toString(16);
  return E.length < 2 ? "0" + E : E;
}, h = function(D) {
  var E = D.r, O = D.g, F = D.b, I = D.a, z = Math.max(E, O, F), R = z - Math.min(E, O, F), L = R ? z === E ? (O - F) / R : z === O ? 2 + (F - E) / R : 4 + (E - O) / R : 0;
  return { h: 60 * (L < 0 ? L + 6 : L), s: z ? R / z * 100 : 0, v: z / 255 * 100, a: I };
}, b = function(D) {
  var E = D.h, O = D.s, F = D.v, I = D.a;
  E = E / 360 * 6, O /= 100, F /= 100;
  var z = Math.floor(E), R = F * (1 - O), L = F * (1 - (E - z) * O), q = F * (1 - (1 - E + z) * O), U = z % 6;
  return { r: 255 * [F, L, R, R, q, F][U], g: 255 * [q, F, F, L, R, R][U], b: 255 * [R, R, q, F, F, L][U], a: I };
}, g = function(D) {
  return { h: u(D.h), s: e(D.s, 0, 100), l: e(D.l, 0, 100), a: e(D.a) };
}, d = function(D) {
  return { h: n(D.h), s: n(D.s), l: n(D.l), a: n(D.a, 3) };
}, f = function(D) {
  return b((O = (E = D).s, { h: E.h, s: (O *= ((F = E.l) < 50 ? F : 100 - F) / 100) > 0 ? 2 * O / (F + O) * 100 : 0, v: F + O, a: E.a }));
  var E, O, F;
}, c = function(D) {
  return { h: (E = h(D)).h, s: (I = (200 - (O = E.s)) * (F = E.v) / 100) > 0 && I < 200 ? O * F / 100 / (I <= 100 ? I : 200 - I) * 100 : 0, l: I / 2, a: E.a };
  var E, O, F, I;
}, l = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, p = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, v = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, m = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, y = { string: [[function(D) {
  var E = i.exec(D);
  return E ? (D = E[1]).length <= 4 ? { r: parseInt(D[0] + D[0], 16), g: parseInt(D[1] + D[1], 16), b: parseInt(D[2] + D[2], 16), a: D.length === 4 ? n(parseInt(D[3] + D[3], 16) / 255, 2) : 1 } : D.length === 6 || D.length === 8 ? { r: parseInt(D.substr(0, 2), 16), g: parseInt(D.substr(2, 2), 16), b: parseInt(D.substr(4, 2), 16), a: D.length === 8 ? n(parseInt(D.substr(6, 2), 16) / 255, 2) : 1 } : null : null;
}, "hex"], [function(D) {
  var E = v.exec(D) || m.exec(D);
  return E ? E[2] !== E[4] || E[4] !== E[6] ? null : a({ r: Number(E[1]) / (E[2] ? 100 / 255 : 1), g: Number(E[3]) / (E[4] ? 100 / 255 : 1), b: Number(E[5]) / (E[6] ? 100 / 255 : 1), a: E[7] === void 0 ? 1 : Number(E[7]) / (E[8] ? 100 : 1) }) : null;
}, "rgb"], [function(D) {
  var E = l.exec(D) || p.exec(D);
  if (!E) return null;
  var O, F, I = g({ h: (O = E[1], F = E[2], F === void 0 && (F = "deg"), Number(O) * (r[F] || 1)), s: Number(E[3]), l: Number(E[4]), a: E[5] === void 0 ? 1 : Number(E[5]) / (E[6] ? 100 : 1) });
  return f(I);
}, "hsl"]], object: [[function(D) {
  var E = D.r, O = D.g, F = D.b, I = D.a, z = I === void 0 ? 1 : I;
  return t$1(E) && t$1(O) && t$1(F) ? a({ r: Number(E), g: Number(O), b: Number(F), a: Number(z) }) : null;
}, "rgb"], [function(D) {
  var E = D.h, O = D.s, F = D.l, I = D.a, z = I === void 0 ? 1 : I;
  if (!t$1(E) || !t$1(O) || !t$1(F)) return null;
  var R = g({ h: Number(E), s: Number(O), l: Number(F), a: Number(z) });
  return f(R);
}, "hsl"], [function(D) {
  var E = D.h, O = D.s, F = D.v, I = D.a, z = I === void 0 ? 1 : I;
  if (!t$1(E) || !t$1(O) || !t$1(F)) return null;
  var R = (function(L) {
    return { h: u(L.h), s: e(L.s, 0, 100), v: e(L.v, 0, 100), a: e(L.a) };
  })({ h: Number(E), s: Number(O), v: Number(F), a: Number(z) });
  return b(R);
}, "hsv"]] }, N = function(D, E) {
  for (var O = 0; O < E.length; O++) {
    var F = E[O][0](D);
    if (F) return [F, E[O][1]];
  }
  return [null, void 0];
}, x = function(D) {
  return typeof D == "string" ? N(D.trim(), y.string) : typeof D == "object" && D !== null ? N(D, y.object) : [null, void 0];
}, M = function(D, E) {
  var O = c(D);
  return { h: O.h, s: e(O.s + 100 * E, 0, 100), l: O.l, a: O.a };
}, H = function(D) {
  return (299 * D.r + 587 * D.g + 114 * D.b) / 1e3 / 255;
}, $ = function(D, E) {
  var O = c(D);
  return { h: O.h, s: O.s, l: e(O.l + 100 * E, 0, 100), a: O.a };
}, j = (function() {
  function D(E) {
    this.parsed = x(E)[0], this.rgba = this.parsed || { r: 0, g: 0, b: 0, a: 1 };
  }
  return D.prototype.isValid = function() {
    return this.parsed !== null;
  }, D.prototype.brightness = function() {
    return n(H(this.rgba), 2);
  }, D.prototype.isDark = function() {
    return H(this.rgba) < 0.5;
  }, D.prototype.isLight = function() {
    return H(this.rgba) >= 0.5;
  }, D.prototype.toHex = function() {
    return E = o$1(this.rgba), O = E.r, F = E.g, I = E.b, R = (z = E.a) < 1 ? s(n(255 * z)) : "", "#" + s(O) + s(F) + s(I) + R;
    var E, O, F, I, z, R;
  }, D.prototype.toRgb = function() {
    return o$1(this.rgba);
  }, D.prototype.toRgbString = function() {
    return E = o$1(this.rgba), O = E.r, F = E.g, I = E.b, (z = E.a) < 1 ? "rgba(" + O + ", " + F + ", " + I + ", " + z + ")" : "rgb(" + O + ", " + F + ", " + I + ")";
    var E, O, F, I, z;
  }, D.prototype.toHsl = function() {
    return d(c(this.rgba));
  }, D.prototype.toHslString = function() {
    return E = d(c(this.rgba)), O = E.h, F = E.s, I = E.l, (z = E.a) < 1 ? "hsla(" + O + ", " + F + "%, " + I + "%, " + z + ")" : "hsl(" + O + ", " + F + "%, " + I + "%)";
    var E, O, F, I, z;
  }, D.prototype.toHsv = function() {
    return E = h(this.rgba), { h: n(E.h), s: n(E.s), v: n(E.v), a: n(E.a, 3) };
    var E;
  }, D.prototype.invert = function() {
    return w({ r: 255 - (E = this.rgba).r, g: 255 - E.g, b: 255 - E.b, a: E.a });
    var E;
  }, D.prototype.saturate = function(E) {
    return E === void 0 && (E = 0.1), w(M(this.rgba, E));
  }, D.prototype.desaturate = function(E) {
    return E === void 0 && (E = 0.1), w(M(this.rgba, -E));
  }, D.prototype.grayscale = function() {
    return w(M(this.rgba, -1));
  }, D.prototype.lighten = function(E) {
    return E === void 0 && (E = 0.1), w($(this.rgba, E));
  }, D.prototype.darken = function(E) {
    return E === void 0 && (E = 0.1), w($(this.rgba, -E));
  }, D.prototype.rotate = function(E) {
    return E === void 0 && (E = 15), this.hue(this.hue() + E);
  }, D.prototype.alpha = function(E) {
    return typeof E == "number" ? w({ r: (O = this.rgba).r, g: O.g, b: O.b, a: E }) : n(this.rgba.a, 3);
    var O;
  }, D.prototype.hue = function(E) {
    var O = c(this.rgba);
    return typeof E == "number" ? w({ h: E, s: O.s, l: O.l, a: O.a }) : n(O.h);
  }, D.prototype.isEqual = function(E) {
    return this.toHex() === w(E).toHex();
  }, D;
})(), w = function(D) {
  return D instanceof j ? D : new j(D);
}, S = [], k = function(D) {
  D.forEach(function(E) {
    S.indexOf(E) < 0 && (E(j, y), S.push(E));
  });
}, o = function(D) {
  var E = D / 255;
  return E < 0.04045 ? E / 12.92 : Math.pow((E + 0.055) / 1.055, 2.4);
}, t = function(D) {
  return 0.2126 * o(D.r) + 0.7152 * o(D.g) + 0.0722 * o(D.b);
};
function a11yPlugin(D) {
  D.prototype.luminance = function() {
    return E = t(this.rgba), (O = 2) === void 0 && (O = 0), F === void 0 && (F = Math.pow(10, O)), Math.round(F * E) / F + 0;
    var E, O, F;
  }, D.prototype.contrast = function(E) {
    E === void 0 && (E = "#FFF");
    var O, F, I, z, R, L, q, U = E instanceof D ? E : new D(E);
    return z = this.rgba, R = U.toRgb(), L = t(z), q = t(R), O = L > q ? (L + 0.05) / (q + 0.05) : (q + 0.05) / (L + 0.05), (F = 2) === void 0 && (F = 0), I === void 0 && (I = Math.pow(10, F)), Math.floor(I * O) / I + 0;
  }, D.prototype.isReadable = function(E, O) {
    return E === void 0 && (E = "#FFF"), O === void 0 && (O = {}), this.contrast(E) >= (L = (R = (F = O).size) === void 0 ? "normal" : R, (z = (I = F.level) === void 0 ? "AA" : I) === "AAA" && L === "normal" ? 7 : z === "AA" && L === "large" ? 3 : 4.5);
    var F, I, z, R, L;
  };
}
function namesPlugin(D, E) {
  var O = { white: "#ffffff", bisque: "#ffe4c4", blue: "#0000ff", cadetblue: "#5f9ea0", chartreuse: "#7fff00", chocolate: "#d2691e", coral: "#ff7f50", antiquewhite: "#faebd7", aqua: "#00ffff", azure: "#f0ffff", whitesmoke: "#f5f5f5", papayawhip: "#ffefd5", plum: "#dda0dd", blanchedalmond: "#ffebcd", black: "#000000", gold: "#ffd700", goldenrod: "#daa520", gainsboro: "#dcdcdc", cornsilk: "#fff8dc", cornflowerblue: "#6495ed", burlywood: "#deb887", aquamarine: "#7fffd4", beige: "#f5f5dc", crimson: "#dc143c", cyan: "#00ffff", darkblue: "#00008b", darkcyan: "#008b8b", darkgoldenrod: "#b8860b", darkkhaki: "#bdb76b", darkgray: "#a9a9a9", darkgreen: "#006400", darkgrey: "#a9a9a9", peachpuff: "#ffdab9", darkmagenta: "#8b008b", darkred: "#8b0000", darkorchid: "#9932cc", darkorange: "#ff8c00", darkslateblue: "#483d8b", gray: "#808080", darkslategray: "#2f4f4f", darkslategrey: "#2f4f4f", deeppink: "#ff1493", deepskyblue: "#00bfff", wheat: "#f5deb3", firebrick: "#b22222", floralwhite: "#fffaf0", ghostwhite: "#f8f8ff", darkviolet: "#9400d3", magenta: "#ff00ff", green: "#008000", dodgerblue: "#1e90ff", grey: "#808080", honeydew: "#f0fff0", hotpink: "#ff69b4", blueviolet: "#8a2be2", forestgreen: "#228b22", lawngreen: "#7cfc00", indianred: "#cd5c5c", indigo: "#4b0082", fuchsia: "#ff00ff", brown: "#a52a2a", maroon: "#800000", mediumblue: "#0000cd", lightcoral: "#f08080", darkturquoise: "#00ced1", lightcyan: "#e0ffff", ivory: "#fffff0", lightyellow: "#ffffe0", lightsalmon: "#ffa07a", lightseagreen: "#20b2aa", linen: "#faf0e6", mediumaquamarine: "#66cdaa", lemonchiffon: "#fffacd", lime: "#00ff00", khaki: "#f0e68c", mediumseagreen: "#3cb371", limegreen: "#32cd32", mediumspringgreen: "#00fa9a", lightskyblue: "#87cefa", lightblue: "#add8e6", midnightblue: "#191970", lightpink: "#ffb6c1", mistyrose: "#ffe4e1", moccasin: "#ffe4b5", mintcream: "#f5fffa", lightslategray: "#778899", lightslategrey: "#778899", navajowhite: "#ffdead", navy: "#000080", mediumvioletred: "#c71585", powderblue: "#b0e0e6", palegoldenrod: "#eee8aa", oldlace: "#fdf5e6", paleturquoise: "#afeeee", mediumturquoise: "#48d1cc", mediumorchid: "#ba55d3", rebeccapurple: "#663399", lightsteelblue: "#b0c4de", mediumslateblue: "#7b68ee", thistle: "#d8bfd8", tan: "#d2b48c", orchid: "#da70d6", mediumpurple: "#9370db", purple: "#800080", pink: "#ffc0cb", skyblue: "#87ceeb", springgreen: "#00ff7f", palegreen: "#98fb98", red: "#ff0000", yellow: "#ffff00", slateblue: "#6a5acd", lavenderblush: "#fff0f5", peru: "#cd853f", palevioletred: "#db7093", violet: "#ee82ee", teal: "#008080", slategray: "#708090", slategrey: "#708090", aliceblue: "#f0f8ff", darkseagreen: "#8fbc8f", darkolivegreen: "#556b2f", greenyellow: "#adff2f", seagreen: "#2e8b57", seashell: "#fff5ee", tomato: "#ff6347", silver: "#c0c0c0", sienna: "#a0522d", lavender: "#e6e6fa", lightgreen: "#90ee90", orange: "#ffa500", orangered: "#ff4500", steelblue: "#4682b4", royalblue: "#4169e1", turquoise: "#40e0d0", yellowgreen: "#9acd32", salmon: "#fa8072", saddlebrown: "#8b4513", sandybrown: "#f4a460", rosybrown: "#bc8f8f", darksalmon: "#e9967a", lightgoldenrodyellow: "#fafad2", snow: "#fffafa", lightgrey: "#d3d3d3", lightgray: "#d3d3d3", dimgray: "#696969", dimgrey: "#696969", olivedrab: "#6b8e23", olive: "#808000" }, F = {};
  for (var I in O) F[O[I]] = I;
  var z = {};
  D.prototype.toName = function(R) {
    if (!(this.rgba.a || this.rgba.r || this.rgba.g || this.rgba.b)) return "transparent";
    var L, q, U = F[this.toHex()];
    if (U) return U;
    if (R?.closest) {
      var Z = this.toRgb(), V = 1 / 0, G = "black";
      if (!z.length) for (var W in O) z[W] = new D(O[W]).toRgb();
      for (var J in O) {
        var X = (L = Z, q = z[J], Math.pow(L.r - q.r, 2) + Math.pow(L.g - q.g, 2) + Math.pow(L.b - q.b, 2));
        X < V && (V = X, G = J);
      }
      return G;
    }
  }, E.string.push([function(R) {
    var L = R.toLowerCase(), q = L === "transparent" ? "#0000" : O[L];
    return q ? new D(q).toRgb() : null;
  }, "name"]);
}
k([a11yPlugin, namesPlugin]);
let styleAttributes = {
  lineColor: {
    componentType: "text",
    description: "Color used for line strokes (light mode)."
  },
  lineColorWord: {
    componentType: "text",
    description: "Human-readable name of the line color (light mode)."
  },
  lineColorDarkMode: {
    componentType: "text",
    description: "Color used for line strokes (dark mode)."
  },
  lineColorWordDarkMode: {
    componentType: "text",
    description: "Human-readable name of the line color (dark mode)."
  },
  lineOpacity: {
    componentType: "number",
    description: "Opacity of line strokes, 0 to 1."
  },
  lineWidth: {
    componentType: "number",
    description: "Stroke width for lines, in pixels."
  },
  lineWidthWord: {
    componentType: "text",
    description: "Human-readable name of the line width."
  },
  lineStyle: {
    componentType: "text",
    description: "Stroke style for lines.",
    toLowerCase: !0,
    validValues: [
      { value: "solid", description: "Continuous, unbroken stroke." },
      {
        value: "dashed",
        description: "Stroke composed of evenly-spaced dashes."
      },
      {
        value: "dotted",
        description: "Stroke composed of evenly-spaced dots."
      }
    ]
  },
  lineStyleWord: {
    componentType: "text",
    description: "Human-readable name of the line style."
  },
  markerColor: {
    componentType: "text",
    description: "Color used for markers/points (light mode)."
  },
  markerColorWord: {
    componentType: "text",
    description: "Human-readable name of the marker color (light mode)."
  },
  markerColorDarkMode: {
    componentType: "text",
    description: "Color used for markers/points (dark mode)."
  },
  markerColorWordDarkMode: {
    componentType: "text",
    description: "Human-readable name of the marker color (dark mode)."
  },
  markerOpacity: {
    componentType: "number",
    description: "Opacity of markers/points, 0 to 1."
  },
  markerStyle: {
    componentType: "text",
    description: "Marker shape.",
    toLowerCase: !0,
    validValues: [
      { value: "circle", description: "Circular marker." },
      { value: "square", description: "Square marker." },
      {
        value: "triangle",
        description: 'Triangular marker pointing up (alias for "triangleUp").'
      },
      {
        value: "triangleUp",
        description: "Triangular marker pointing up."
      },
      {
        value: "triangleDown",
        description: "Triangular marker pointing down."
      },
      {
        value: "triangleLeft",
        description: "Triangular marker pointing left."
      },
      {
        value: "triangleRight",
        description: "Triangular marker pointing right."
      },
      { value: "diamond", description: "Diamond-shaped marker." },
      { value: "cross", description: "Cross-shaped marker (×)." },
      { value: "plus", description: "Plus-shaped marker (+)." }
    ]
  },
  markerStyleWord: {
    componentType: "text",
    description: "Human-readable name of the marker style."
  },
  markerSize: {
    componentType: "number",
    description: "Marker size in pixels."
  },
  markerFilled: {
    componentType: "boolean",
    description: "Whether the marker is rendered filled (true) or open (false). Has no effect when markerStyle is cross or plus, which have no interior."
  },
  fillColor: {
    componentType: "text",
    description: "Fill color used inside closed shapes (light mode)."
  },
  fillColorWord: {
    componentType: "text",
    description: "Human-readable name of the fill color (light mode)."
  },
  fillColorDarkMode: {
    componentType: "text",
    description: "Fill color used inside closed shapes (dark mode)."
  },
  fillColorWordDarkMode: {
    componentType: "text",
    description: "Human-readable name of the fill color (dark mode)."
  },
  fillOpacity: {
    componentType: "number",
    description: "Opacity of solid fills, 0 to 1."
  },
  fillPatternOpacity: {
    componentType: "number",
    description: "Opacity of pattern fills (non-solid fillStyle), 0 to 1."
  },
  fillStyle: {
    componentType: "text",
    description: "Fill pattern used inside closed shapes.",
    toLowerCase: !0,
    validValues: [
      { value: "solid", description: "Solid fill." },
      {
        value: "horizontal",
        description: "Horizontal line pattern."
      },
      {
        value: "vertical",
        description: "Vertical line pattern."
      },
      {
        value: "diagonal",
        description: "Diagonal line pattern (/)."
      },
      {
        value: "backDiagonal",
        description: "Back-diagonal line pattern (\\)."
      },
      {
        value: "dots",
        description: "Dots pattern."
      },
      {
        value: "diamonds",
        description: "Filled diamonds pattern."
      }
    ]
  },
  fillStyleWord: {
    componentType: "text",
    description: "Human-readable name of the fill style."
  },
  textColor: {
    componentType: "text",
    description: "Text color (light mode)."
  },
  textColorWord: {
    componentType: "text",
    description: "Human-readable name of the text color (light mode)."
  },
  textColorDarkMode: {
    componentType: "text",
    description: "Text color (dark mode)."
  },
  textColorWordDarkMode: {
    componentType: "text",
    description: "Human-readable name of the text color (dark mode)."
  },
  highContrastColor: {
    componentType: "text",
    description: "High-contrast accent color (light mode)."
  },
  highContrastColorWord: {
    componentType: "text",
    description: "Human-readable name of the high-contrast accent color (light mode)."
  },
  highContrastColorDarkMode: {
    componentType: "text",
    description: "High-contrast accent color (dark mode)."
  },
  highContrastColorWordDarkMode: {
    componentType: "text",
    description: "Human-readable name of the high-contrast accent color (dark mode)."
  },
  backgroundColor: {
    componentType: "text",
    description: "Background color (light mode)."
  },
  backgroundColorWord: {
    componentType: "text",
    description: "Human-readable name of the background color (light mode)."
  },
  backgroundColorDarkMode: {
    componentType: "text",
    description: "Background color (dark mode)."
  },
  backgroundColorWordDarkMode: {
    componentType: "text",
    description: "Human-readable name of the background color (dark mode)."
  }
};
styleAttributes.markerStyle.validValues.filter(
  (D) => D.value !== "cross" && D.value !== "plus"
);
const MARKER_OVERRIDE_KEYS = [
  "markerStyle",
  "markerSize",
  "markerFilled"
], LINE_OVERRIDE_KEYS = [
  "lineStyle",
  "lineWidth"
], FILL_OVERRIDE_KEYS = [
  "fillOpacity",
  "fillPatternOpacity",
  "fillStyle"
], markerOverrideAttributes = Object.fromEntries(
  MARKER_OVERRIDE_KEYS.map((D) => [D, styleAttributes[D]])
), lineOverrideAttributes = Object.fromEntries(
  LINE_OVERRIDE_KEYS.map((D) => [D, styleAttributes[D]])
), fillOverrideAttributes = Object.fromEntries(
  FILL_OVERRIDE_KEYS.map((D) => [D, styleAttributes[D]])
);
({
  ...markerOverrideAttributes,
  ...lineOverrideAttributes,
  ...fillOverrideAttributes
});
const STYLE_OVERRIDE_CATEGORIES = {
  marker: markerOverrideAttributes,
  line: lineOverrideAttributes,
  fill: fillOverrideAttributes
};
for (const [D, E] of Object.entries(STYLE_OVERRIDE_CATEGORIES))
  for (const [O, F] of Object.entries(E)) {
    if (O.toLowerCase().includes("color"))
      throw new Error(
        `Style override category "${D}" contains color-related key "${O}"; colors stay <styleDefinition>-only so per-styleNumber WCAG contrast diagnostics remain authoritative. If this is intentional, also reconcile the lowercase asymmetry in returnSelectedStyleStateVariableDefinition.`
      );
    if (O.endsWith("Opacity") && O !== "fillOpacity" && O !== "fillPatternOpacity")
      throw new Error(
        `Style override category "${D}" contains contrast-feeding opacity key "${O}"; lineOpacity and markerOpacity feed the WCAG contrast diagnostic as an opacityMultiplier on the foreground alpha, so they stay <styleDefinition>-only alongside colors. Only fillOpacity and fillPatternOpacity are contrast-irrelevant and overridable.`
      );
    if (F.componentType === "text" && !F.toLowerCase)
      throw new Error(
        `Style override key "${O}" in category "${D}" is text-typed but missing toLowerCase: true. Add toLowerCase: true to its styleAttributes entry, or move it out of the override surface.`
      );
  }
var base32$1 = { exports: {} }, hasRequiredBase32;
function requireBase32() {
  return hasRequiredBase32 || (hasRequiredBase32 = 1, (function(D) {
    (function() {
      var E = typeof window == "object" ? window : {}, O = !E.HI_BASE32_NO_NODE_JS && typeof process == "object" && process.versions && process.versions.node;
      O && (E = commonjsGlobal);
      var F = !E.HI_BASE32_NO_COMMON_JS && !0 && D.exports, I = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567".split(""), z = {
        A: 0,
        B: 1,
        C: 2,
        D: 3,
        E: 4,
        F: 5,
        G: 6,
        H: 7,
        I: 8,
        J: 9,
        K: 10,
        L: 11,
        M: 12,
        N: 13,
        O: 14,
        P: 15,
        Q: 16,
        R: 17,
        S: 18,
        T: 19,
        U: 20,
        V: 21,
        W: 22,
        X: 23,
        Y: 24,
        Z: 25,
        2: 26,
        3: 27,
        4: 28,
        5: 29,
        6: 30,
        7: 31
      }, R = [0, 0, 0, 0, 0, 0, 0, 0], L = function(Y, ee) {
        ee.length > 10 && (ee = "..." + ee.substr(-10));
        var K = new Error("Decoded data is not valid UTF-8. Maybe try base32.decode.asBytes()? Partial data after reading " + Y + " bytes: " + ee + " <-");
        throw K.position = Y, K;
      }, q = function(Y) {
        for (var ee = "", K = Y.length, te = 0, ie = 0, ne, ae; te < K; ) {
          if (ne = Y[te++], ne <= 127) {
            ee += String.fromCharCode(ne);
            continue;
          } else ne > 191 && ne <= 223 ? (ae = ne & 31, ie = 1) : ne <= 239 ? (ae = ne & 15, ie = 2) : ne <= 247 ? (ae = ne & 7, ie = 3) : L(te, ee);
          for (var ue = 0; ue < ie; ++ue)
            ne = Y[te++], (ne < 128 || ne > 191) && L(te, ee), ae <<= 6, ae += ne & 63;
          ae >= 55296 && ae <= 57343 && L(te, ee), ae > 1114111 && L(te, ee), ae <= 65535 ? ee += String.fromCharCode(ae) : (ae -= 65536, ee += String.fromCharCode((ae >> 10) + 55296), ee += String.fromCharCode((ae & 1023) + 56320));
        }
        return ee;
      }, U = function(Y) {
        if (Y === "")
          return [];
        if (!/^[A-Z2-7=]+$/.test(Y))
          throw new Error("Invalid base32 characters");
        Y = Y.replace(/=/g, "");
        for (var ee, K, te, ie, ne, ae, ue, oe, se = [], le = 0, ce = Y.length, fe = 0, pe = ce >> 3 << 3; fe < pe; )
          ee = z[Y.charAt(fe++)], K = z[Y.charAt(fe++)], te = z[Y.charAt(fe++)], ie = z[Y.charAt(fe++)], ne = z[Y.charAt(fe++)], ae = z[Y.charAt(fe++)], ue = z[Y.charAt(fe++)], oe = z[Y.charAt(fe++)], se[le++] = (ee << 3 | K >>> 2) & 255, se[le++] = (K << 6 | te << 1 | ie >>> 4) & 255, se[le++] = (ie << 4 | ne >>> 1) & 255, se[le++] = (ne << 7 | ae << 2 | ue >>> 3) & 255, se[le++] = (ue << 5 | oe) & 255;
        var ve = ce - pe;
        return ve === 2 ? (ee = z[Y.charAt(fe++)], K = z[Y.charAt(fe++)], se[le++] = (ee << 3 | K >>> 2) & 255) : ve === 4 ? (ee = z[Y.charAt(fe++)], K = z[Y.charAt(fe++)], te = z[Y.charAt(fe++)], ie = z[Y.charAt(fe++)], se[le++] = (ee << 3 | K >>> 2) & 255, se[le++] = (K << 6 | te << 1 | ie >>> 4) & 255) : ve === 5 ? (ee = z[Y.charAt(fe++)], K = z[Y.charAt(fe++)], te = z[Y.charAt(fe++)], ie = z[Y.charAt(fe++)], ne = z[Y.charAt(fe++)], se[le++] = (ee << 3 | K >>> 2) & 255, se[le++] = (K << 6 | te << 1 | ie >>> 4) & 255, se[le++] = (ie << 4 | ne >>> 1) & 255) : ve === 7 && (ee = z[Y.charAt(fe++)], K = z[Y.charAt(fe++)], te = z[Y.charAt(fe++)], ie = z[Y.charAt(fe++)], ne = z[Y.charAt(fe++)], ae = z[Y.charAt(fe++)], ue = z[Y.charAt(fe++)], se[le++] = (ee << 3 | K >>> 2) & 255, se[le++] = (K << 6 | te << 1 | ie >>> 4) & 255, se[le++] = (ie << 4 | ne >>> 1) & 255, se[le++] = (ne << 7 | ae << 2 | ue >>> 3) & 255), se;
      }, Z = function(Y) {
        for (var ee, K, te, ie, ne, ae = "", ue = Y.length, oe = 0, se = parseInt(ue / 5) * 5; oe < se; )
          ee = Y.charCodeAt(oe++), K = Y.charCodeAt(oe++), te = Y.charCodeAt(oe++), ie = Y.charCodeAt(oe++), ne = Y.charCodeAt(oe++), ae += I[ee >>> 3] + I[(ee << 2 | K >>> 6) & 31] + I[K >>> 1 & 31] + I[(K << 4 | te >>> 4) & 31] + I[(te << 1 | ie >>> 7) & 31] + I[ie >>> 2 & 31] + I[(ie << 3 | ne >>> 5) & 31] + I[ne & 31];
        var le = ue - se;
        return le === 1 ? (ee = Y.charCodeAt(oe), ae += I[ee >>> 3] + I[ee << 2 & 31] + "======") : le === 2 ? (ee = Y.charCodeAt(oe++), K = Y.charCodeAt(oe), ae += I[ee >>> 3] + I[(ee << 2 | K >>> 6) & 31] + I[K >>> 1 & 31] + I[K << 4 & 31] + "====") : le === 3 ? (ee = Y.charCodeAt(oe++), K = Y.charCodeAt(oe++), te = Y.charCodeAt(oe), ae += I[ee >>> 3] + I[(ee << 2 | K >>> 6) & 31] + I[K >>> 1 & 31] + I[(K << 4 | te >>> 4) & 31] + I[te << 1 & 31] + "===") : le === 4 && (ee = Y.charCodeAt(oe++), K = Y.charCodeAt(oe++), te = Y.charCodeAt(oe++), ie = Y.charCodeAt(oe), ae += I[ee >>> 3] + I[(ee << 2 | K >>> 6) & 31] + I[K >>> 1 & 31] + I[(K << 4 | te >>> 4) & 31] + I[(te << 1 | ie >>> 7) & 31] + I[ie >>> 2 & 31] + I[ie << 3 & 31] + "="), ae;
      }, V = function(Y) {
        var ee, K, te, ie, ne, ae, ue = !1, oe = "", se = 0, le, ce = 0, fe = Y.length;
        if (Y === "")
          return oe;
        do {
          for (R[0] = R[5], R[1] = R[6], R[2] = R[7], le = ce; se < fe && le < 5; ++se)
            ae = Y.charCodeAt(se), ae < 128 ? R[le++] = ae : ae < 2048 ? (R[le++] = 192 | ae >> 6, R[le++] = 128 | ae & 63) : ae < 55296 || ae >= 57344 ? (R[le++] = 224 | ae >> 12, R[le++] = 128 | ae >> 6 & 63, R[le++] = 128 | ae & 63) : (ae = 65536 + ((ae & 1023) << 10 | Y.charCodeAt(++se) & 1023), R[le++] = 240 | ae >> 18, R[le++] = 128 | ae >> 12 & 63, R[le++] = 128 | ae >> 6 & 63, R[le++] = 128 | ae & 63);
          ce = le - 5, se === fe && ++se, se > fe && le < 6 && (ue = !0), ee = R[0], le > 4 ? (K = R[1], te = R[2], ie = R[3], ne = R[4], oe += I[ee >>> 3] + I[(ee << 2 | K >>> 6) & 31] + I[K >>> 1 & 31] + I[(K << 4 | te >>> 4) & 31] + I[(te << 1 | ie >>> 7) & 31] + I[ie >>> 2 & 31] + I[(ie << 3 | ne >>> 5) & 31] + I[ne & 31]) : le === 1 ? oe += I[ee >>> 3] + I[ee << 2 & 31] + "======" : le === 2 ? (K = R[1], oe += I[ee >>> 3] + I[(ee << 2 | K >>> 6) & 31] + I[K >>> 1 & 31] + I[K << 4 & 31] + "====") : le === 3 ? (K = R[1], te = R[2], oe += I[ee >>> 3] + I[(ee << 2 | K >>> 6) & 31] + I[K >>> 1 & 31] + I[(K << 4 | te >>> 4) & 31] + I[te << 1 & 31] + "===") : (K = R[1], te = R[2], ie = R[3], oe += I[ee >>> 3] + I[(ee << 2 | K >>> 6) & 31] + I[K >>> 1 & 31] + I[(K << 4 | te >>> 4) & 31] + I[(te << 1 | ie >>> 7) & 31] + I[ie >>> 2 & 31] + I[ie << 3 & 31] + "=");
        } while (!ue);
        return oe;
      }, G = function(Y) {
        for (var ee, K, te, ie, ne, ae = "", ue = Y.length, oe = 0, se = parseInt(ue / 5) * 5; oe < se; )
          ee = Y[oe++], K = Y[oe++], te = Y[oe++], ie = Y[oe++], ne = Y[oe++], ae += I[ee >>> 3] + I[(ee << 2 | K >>> 6) & 31] + I[K >>> 1 & 31] + I[(K << 4 | te >>> 4) & 31] + I[(te << 1 | ie >>> 7) & 31] + I[ie >>> 2 & 31] + I[(ie << 3 | ne >>> 5) & 31] + I[ne & 31];
        var le = ue - se;
        return le === 1 ? (ee = Y[oe], ae += I[ee >>> 3] + I[ee << 2 & 31] + "======") : le === 2 ? (ee = Y[oe++], K = Y[oe], ae += I[ee >>> 3] + I[(ee << 2 | K >>> 6) & 31] + I[K >>> 1 & 31] + I[K << 4 & 31] + "====") : le === 3 ? (ee = Y[oe++], K = Y[oe++], te = Y[oe], ae += I[ee >>> 3] + I[(ee << 2 | K >>> 6) & 31] + I[K >>> 1 & 31] + I[(K << 4 | te >>> 4) & 31] + I[te << 1 & 31] + "===") : le === 4 && (ee = Y[oe++], K = Y[oe++], te = Y[oe++], ie = Y[oe], ae += I[ee >>> 3] + I[(ee << 2 | K >>> 6) & 31] + I[K >>> 1 & 31] + I[(K << 4 | te >>> 4) & 31] + I[(te << 1 | ie >>> 7) & 31] + I[ie >>> 2 & 31] + I[ie << 3 & 31] + "="), ae;
      }, W = function(Y, ee) {
        var K = typeof Y != "string";
        return K && Y.constructor === ArrayBuffer && (Y = new Uint8Array(Y)), K ? G(Y) : ee ? Z(Y) : V(Y);
      }, J = function(Y, ee) {
        if (!ee)
          return q(U(Y));
        if (Y === "")
          return "";
        if (!/^[A-Z2-7=]+$/.test(Y))
          throw new Error("Invalid base32 characters");
        var K, te, ie, ne, ae, ue, oe, se, le = "", ce = Y.indexOf("=");
        ce === -1 && (ce = Y.length);
        for (var fe = 0, pe = ce >> 3 << 3; fe < pe; )
          K = z[Y.charAt(fe++)], te = z[Y.charAt(fe++)], ie = z[Y.charAt(fe++)], ne = z[Y.charAt(fe++)], ae = z[Y.charAt(fe++)], ue = z[Y.charAt(fe++)], oe = z[Y.charAt(fe++)], se = z[Y.charAt(fe++)], le += String.fromCharCode((K << 3 | te >>> 2) & 255) + String.fromCharCode((te << 6 | ie << 1 | ne >>> 4) & 255) + String.fromCharCode((ne << 4 | ae >>> 1) & 255) + String.fromCharCode((ae << 7 | ue << 2 | oe >>> 3) & 255) + String.fromCharCode((oe << 5 | se) & 255);
        var ve = ce - pe;
        return ve === 2 ? (K = z[Y.charAt(fe++)], te = z[Y.charAt(fe++)], le += String.fromCharCode((K << 3 | te >>> 2) & 255)) : ve === 4 ? (K = z[Y.charAt(fe++)], te = z[Y.charAt(fe++)], ie = z[Y.charAt(fe++)], ne = z[Y.charAt(fe++)], le += String.fromCharCode((K << 3 | te >>> 2) & 255) + String.fromCharCode((te << 6 | ie << 1 | ne >>> 4) & 255)) : ve === 5 ? (K = z[Y.charAt(fe++)], te = z[Y.charAt(fe++)], ie = z[Y.charAt(fe++)], ne = z[Y.charAt(fe++)], ae = z[Y.charAt(fe++)], le += String.fromCharCode((K << 3 | te >>> 2) & 255) + String.fromCharCode((te << 6 | ie << 1 | ne >>> 4) & 255) + String.fromCharCode((ne << 4 | ae >>> 1) & 255)) : ve === 7 && (K = z[Y.charAt(fe++)], te = z[Y.charAt(fe++)], ie = z[Y.charAt(fe++)], ne = z[Y.charAt(fe++)], ae = z[Y.charAt(fe++)], ue = z[Y.charAt(fe++)], oe = z[Y.charAt(fe++)], le += String.fromCharCode((K << 3 | te >>> 2) & 255) + String.fromCharCode((te << 6 | ie << 1 | ne >>> 4) & 255) + String.fromCharCode((ne << 4 | ae >>> 1) & 255) + String.fromCharCode((ae << 7 | ue << 2 | oe >>> 3) & 255)), le;
      }, X = {
        encode: W,
        decode: J
      };
      J.asBytes = U, F ? D.exports = X : E.base32 = X;
    })();
  })(base32$1)), base32$1.exports;
}
requireBase32();
const genericMethods = {
  union: function(D, E) {
    return D.complement().intersect(E.complement()).complement();
  },
  intersectWithOpenInterval: function(D, E) {
    return D.intersect(E);
  },
  setMinus: function(D, E) {
    return D.intersect(E.complement());
  },
  symmetricDifference: function(D, E) {
    return D.setMinus(E).union(E.setMinus(D));
  },
  containsSubset: function(D, E) {
    return D.intersect(E).equals(E);
  },
  isSubsetOf: function(D, E) {
    return genericMethods.containsSubset(E, D);
  },
  equals: function(D, E) {
    return D.symmetricDifference(E).isEmpty();
  }
};
function subsetReviver(D, E) {
  if (typeof E == "object" && E !== null && "objectType" in E && E.objectType === "subset" && "data" in E && typeof E.data == "object" && E.data !== null && "type" in E.data && E.data.type !== void 0) {
    if (E.data.type === "empty")
      return EmptySet();
    if (E.data.type === "realLine")
      return RealLine();
    if (E.data.type === "singleton") {
      if ("element" in E.data && typeof E.data.element == "number")
        return Singleton(E.data.element);
    } else if (E.data.type === "union") {
      if ("subsets" in E.data && Array.isArray(E.data.subsets) && E.data.subsets.every(
        (O) => O instanceof Constructors.Singleton || O instanceof Constructors.OpenInterval
      ))
        return Union(E.data.subsets);
    } else if (E.data.type === "openInterval" && "left" in E.data && typeof E.data.left == "number" && "right" in E.data && typeof E.data.right == "number")
      return OpenInterval(E.data.left, E.data.right);
  }
  return E;
}
const Constructors = {
  EmptySet: class {
    constructor() {
      this.type = "empty";
    }
    union(D) {
      return D;
    }
    intersectWithOpenInterval(D) {
      return genericMethods.intersectWithOpenInterval(this, D);
    }
    setMinus(D) {
      return genericMethods.setMinus(this, D);
    }
    symmetricDifference(D) {
      return genericMethods.symmetricDifference(this, D);
    }
    containsSubset(D) {
      return genericMethods.containsSubset(this, D);
    }
    isSubsetOf(D) {
      return genericMethods.isSubsetOf(this, D);
    }
    equals(D) {
      return genericMethods.equals(this, D);
    }
    intersect() {
      return EmptySet();
    }
    containsElement() {
      return !1;
    }
    isEmpty() {
      return !0;
    }
    complement() {
      return RealLine();
    }
    isValid() {
      return !0;
    }
    toString() {
      return "∅";
    }
    toMathExpression() {
      return Context.fromAst("emptyset");
    }
    toJSON() {
      return {
        objectType: "subset",
        data: { type: "empty" }
      };
    }
    copy() {
      return subsetReviver(null, this.toJSON());
    }
  },
  InvalidSet: class {
    constructor() {
      this.type = "invalid";
    }
    intersectWithOpenInterval(D) {
      return genericMethods.intersectWithOpenInterval(this, D);
    }
    setMinus(D) {
      return genericMethods.setMinus(this, D);
    }
    symmetricDifference(D) {
      return genericMethods.symmetricDifference(this, D);
    }
    containsSubset(D) {
      return genericMethods.containsSubset(this, D);
    }
    isSubsetOf(D) {
      return genericMethods.isSubsetOf(this, D);
    }
    equals(D) {
      return genericMethods.equals(this, D);
    }
    union() {
      return InvalidSet();
    }
    intersect() {
      return InvalidSet();
    }
    containsElement() {
      return !1;
    }
    isEmpty() {
      return !0;
    }
    complement() {
      return InvalidSet();
    }
    isValid() {
      return !1;
    }
    toString() {
      return "＿";
    }
    toMathExpression() {
      return Context.fromAst("＿");
    }
    toJSON() {
      return {
        objectType: "subset",
        data: { type: "invalid" }
      };
    }
    copy() {
      return subsetReviver(null, this.toJSON());
    }
  },
  RealLine: class {
    constructor() {
      this.type = "realLine";
    }
    intersectWithOpenInterval(D) {
      return genericMethods.intersectWithOpenInterval(this, D);
    }
    setMinus(D) {
      return genericMethods.setMinus(this, D);
    }
    symmetricDifference(D) {
      return genericMethods.symmetricDifference(this, D);
    }
    containsSubset(D) {
      return genericMethods.containsSubset(this, D);
    }
    isSubsetOf(D) {
      return genericMethods.isSubsetOf(this, D);
    }
    equals(D) {
      return genericMethods.equals(this, D);
    }
    isValid() {
      return !0;
    }
    union() {
      return RealLine();
    }
    intersect(D) {
      return D;
    }
    containsElement() {
      return !0;
    }
    complement() {
      return EmptySet();
    }
    isEmpty() {
      return !1;
    }
    toString() {
      return "ℝ";
    }
    toMathExpression() {
      return Context.fromAst("R");
    }
    toJSON() {
      return {
        objectType: "subset",
        data: { type: "realLine" }
      };
    }
    copy() {
      return subsetReviver(null, this.toJSON());
    }
  },
  Singleton: class {
    constructor(D) {
      this.type = "singleton", this.element = D;
    }
    intersectWithOpenInterval(D) {
      return genericMethods.intersectWithOpenInterval(this, D);
    }
    setMinus(D) {
      return genericMethods.setMinus(this, D);
    }
    symmetricDifference(D) {
      return genericMethods.symmetricDifference(this, D);
    }
    containsSubset(D) {
      return genericMethods.containsSubset(this, D);
    }
    isSubsetOf(D) {
      return genericMethods.isSubsetOf(this, D);
    }
    equals(D) {
      return genericMethods.equals(this, D);
    }
    isValid() {
      return !0;
    }
    union(D) {
      return D.containsElement(this.element) ? D : Union([D, this]);
    }
    intersect(D) {
      return D.containsElement(this.element) ? Singleton(this.element) : EmptySet();
    }
    isEmpty() {
      return !1;
    }
    containsElement(D) {
      return D === this.element;
    }
    complement() {
      return Union([
        OpenInterval(-1 / 0, this.element),
        OpenInterval(this.element, 1 / 0)
      ]);
    }
    toString() {
      return `{${this.element}}`;
    }
    toMathExpression() {
      return Context.fromAst(["set", this.element]);
    }
    toJSON() {
      return {
        objectType: "subset",
        data: { type: "singleton", element: this.element }
      };
    }
    copy() {
      return subsetReviver(null, this.toJSON());
    }
  },
  OpenInterval: class {
    constructor(D, E) {
      this.type = "openInterval", this.left = D, this.right = E;
    }
    union(D) {
      return genericMethods.union(this, D);
    }
    setMinus(D) {
      return genericMethods.setMinus(this, D);
    }
    symmetricDifference(D) {
      return genericMethods.symmetricDifference(this, D);
    }
    containsSubset(D) {
      return genericMethods.containsSubset(this, D);
    }
    isSubsetOf(D) {
      return genericMethods.isSubsetOf(this, D);
    }
    equals(D) {
      return genericMethods.equals(this, D);
    }
    isValid() {
      return !0;
    }
    intersect(D) {
      return D.intersectWithOpenInterval(this);
    }
    intersectWithOpenInterval(D) {
      return OpenInterval(
        Math.max(this.left, D.left),
        Math.min(this.right, D.right)
      );
    }
    complement() {
      return Union([
        OpenClosedInterval(-1 / 0, this.left),
        ClosedOpenInterval(this.right, 1 / 0)
      ]);
    }
    isEmpty() {
      return this.left >= this.right;
    }
    containsElement(D) {
      return D > this.left && D < this.right;
    }
    toString() {
      return `(${this.left.toString()},${this.right.toString()})`;
    }
    toMathExpression() {
      return Context.fromAst([
        "interval",
        ["tuple", this.left, this.right],
        ["tuple", !1, !1]
      ]);
    }
    toJSON() {
      return {
        objectType: "subset",
        data: {
          type: "openInterval",
          left: this.left,
          right: this.right
        }
      };
    }
    copy() {
      return subsetReviver(null, this.toJSON());
    }
  },
  Union: class {
    constructor(D) {
      this.type = "union", this.subsets = D;
    }
    union(D) {
      return genericMethods.union(this, D);
    }
    setMinus(D) {
      return genericMethods.setMinus(this, D);
    }
    symmetricDifference(D) {
      return genericMethods.symmetricDifference(this, D);
    }
    containsSubset(D) {
      return genericMethods.containsSubset(this, D);
    }
    isSubsetOf(D) {
      return genericMethods.isSubsetOf(this, D);
    }
    equals(D) {
      return genericMethods.equals(this, D);
    }
    isValid() {
      return !0;
    }
    intersectWithOpenInterval(D) {
      return this.intersect(D);
    }
    containsElement(D) {
      return this.subsets.some((E) => E.containsElement(D));
    }
    isEmpty() {
      return this.subsets.every((D) => D.isEmpty());
    }
    complement() {
      return this.subsets.map((D) => D.complement()).reduce((D, E) => D.intersect(E));
    }
    intersect(D) {
      return Union(this.subsets.map((E) => D.intersect(E)));
    }
    toString() {
      return this.subsets.map((D) => D.toString()).join(" U ");
    }
    toMathExpression() {
      return Context.fromAst([
        "union",
        ...this.subsets.map((D) => D.toMathExpression().tree)
      ]);
    }
    toJSON() {
      return {
        objectType: "subset",
        data: {
          type: "union",
          subsets: this.subsets.map((D) => D.toJSON())
        }
      };
    }
    copy() {
      return subsetReviver(null, this.toJSON());
    }
  }
};
function EmptySet() {
  return new Constructors.EmptySet();
}
function InvalidSet() {
  return new Constructors.InvalidSet();
}
function RealLine() {
  return new Constructors.RealLine();
}
function Singleton(D) {
  return Number.isFinite(D) ? new Constructors.Singleton(D) : new Constructors.EmptySet();
}
function OpenInterval(D, E) {
  return D < E ? D === -1 / 0 && E === 1 / 0 ? new Constructors.RealLine() : new Constructors.OpenInterval(D, E) : new Constructors.EmptySet();
}
function Union(D) {
  if (D.some((I) => I.type === "invalid"))
    return new Constructors.InvalidSet();
  const E = D.reduce(
    (I, z) => z.type === "union" ? [...I, ...z.subsets] : [...I, z],
    []
  ), O = [];
  for (const I of E) {
    if (I.type === "realLine")
      return new Constructors.RealLine();
    I.type !== "empty" && !I.isEmpty() && O.push(I);
  }
  if (O.length === 0)
    return new Constructors.EmptySet();
  const F = [];
  for (let I = 0; I < O.length; I++) {
    let z = O[I], R = !0;
    if (z.type === "openInterval") {
      let L = z.left, q = z.right;
      for (let U = I + 1; U < O.length; U++) {
        let Z = O[U];
        if (Z.type === "openInterval") {
          if (L < Z.right && Z.left < q) {
            L = Math.min(L, Z.left), q = Math.max(q, Z.right), O.splice(U, 1), U--, R = !1, I--;
            break;
          } else if (L === Z.right || q === Z.left) {
            let V = L === Z.right ? L : q, G = !1;
            for (let W = 0; W < F.length; W++) {
              let J = F[W];
              if (J.type === "singleton" && J.element === V) {
                F.splice(W, 1), G = !0;
                break;
              }
            }
            if (!G)
              for (let W = I + 1; W < O.length; W++) {
                let J = O[W];
                if (J.type === "singleton" && J.element === V) {
                  O.splice(W, 1), G = !0, W < U && U--;
                  break;
                }
              }
            if (G) {
              L = Math.min(L, Z.left), q = Math.max(q, Z.right), O.splice(U, 1), U--, R = !1, I--;
              break;
            }
          }
        } else
          Z.element > L && Z.element < q && (O.splice(U, 1), U--);
      }
      if (z.left = L, z.right = q, z.left === -1 / 0 && z.right === 1 / 0)
        return new Constructors.RealLine();
    } else {
      let L = z.element;
      for (let q = I + 1; q < O.length; q++) {
        let U = O[q];
        if (U.type === "openInterval") {
          if (L > U.left && L < U.right) {
            O.splice(I, 1), I--, R = !1;
            break;
          }
        } else U.element === L && (O.splice(q, 1), q--);
      }
    }
    R && F.push(z);
  }
  return F.length === 1 ? F[0] : new Constructors.Union(F);
}
function OpenClosedInterval(D, E) {
  if (D < E) {
    if (D === -1 / 0 && E === 1 / 0)
      return new Constructors.RealLine();
    {
      const O = [
        new Constructors.OpenInterval(D, E)
      ];
      return Number.isFinite(E) && O.push(new Constructors.Singleton(E)), Union(O);
    }
  } else return new Constructors.EmptySet();
}
function ClosedOpenInterval(D, E) {
  if (D < E) {
    if (D === -1 / 0 && E === 1 / 0)
      return new Constructors.RealLine();
    {
      const O = [
        new Constructors.OpenInterval(D, E)
      ];
      return Number.isFinite(D) && O.push(new Constructors.Singleton(D)), Union(O);
    }
  } else return new Constructors.EmptySet();
}
function serializedComponentsReplacer(D, E) {
  return E !== E ? { objectType: "special-numeric", stringValue: "NaN" } : E === 1 / 0 ? { objectType: "special-numeric", stringValue: "Infinity" } : E === -1 / 0 ? { objectType: "special-numeric", stringValue: "-Infinity" } : E;
}
function nanInfinityReviver(D, E) {
  if (E && E.objectType === "special-numeric") {
    if (E.stringValue === "NaN")
      return NaN;
    if (E.stringValue === "Infinity")
      return 1 / 0;
    if (E.stringValue === "-Infinity")
      return -1 / 0;
  }
  return E;
}
function serializedComponentsReviver(D, E) {
  return Context.reviver(D, subsetReviver(D, nanInfinityReviver(D, E)));
}
const { gcd, lcm } = Context.math;
function normalizeMathExpression({
  value: D,
  simplify: E,
  expand: O = !1,
  createVectors: F = !1,
  createIntervals: I = !1,
  assumptions: z = null
}) {
  if (z && z.tree !== "＿") {
    const R = [];
    if (Array.isArray(z.tree) && z.tree[0] === "list")
      for (let L = 1; L < z.tree.length; L++)
        R.push(Context.fromAst(z.tree[L]));
    else
      R.push(z);
    for (const L of R)
      Context.add_assumption(L);
  }
  return F && (D = D.tuples_to_vectors()), I && (D = D.to_intervals()), O && (D = D.expand()), E === "full" ? D = D.simplify() : E === "numbers" ? D = D.evaluate_numbers() : E === "numberspreserveorder" ? D = D.evaluate_numbers({ skip_ordering: !0 }) : E === "normalizeorder" && (D = D.default_order()), Context.clear_assumptions(), D;
}
const { mod } = Context.math, { dopri } = Context.math, defaultCreativeCommonsVersion = "4.0";
function creativeCommonsLicense(D, E, O, F) {
  return {
    code: D,
    name: `Creative Commons ${E}`,
    description: F,
    kind: "creative-commons",
    url: (I = defaultCreativeCommonsVersion) => `https://creativecommons.org/licenses/${O}/${I}/`
  };
}
function fixedUrlLicense(D, E, O, F, I) {
  return {
    code: D,
    name: E,
    description: F,
    kind: I,
    url: () => O
  };
}
const mediaLicenses = [
  creativeCommonsLicense(
    "CC-BY",
    "Attribution",
    "by",
    "Creative Commons Attribution: reuse with credit, including commercially."
  ),
  creativeCommonsLicense(
    "CC-BY-SA",
    "Attribution-ShareAlike",
    "by-sa",
    "Creative Commons Attribution-ShareAlike: reuse with credit; adaptations keep the same license."
  ),
  creativeCommonsLicense(
    "CC-BY-ND",
    "Attribution-NoDerivatives",
    "by-nd",
    "Creative Commons Attribution-NoDerivatives: reuse unchanged, with credit."
  ),
  creativeCommonsLicense(
    "CC-BY-NC",
    "Attribution-NonCommercial",
    "by-nc",
    "Creative Commons Attribution-NonCommercial: reuse with credit for noncommercial purposes."
  ),
  creativeCommonsLicense(
    "CC-BY-NC-SA",
    "Attribution-NonCommercial-ShareAlike",
    "by-nc-sa",
    "Creative Commons Attribution-NonCommercial-ShareAlike: noncommercial reuse with credit; adaptations keep the same license."
  ),
  creativeCommonsLicense(
    "CC-BY-NC-ND",
    "Attribution-NonCommercial-NoDerivatives",
    "by-nc-nd",
    "Creative Commons Attribution-NonCommercial-NoDerivatives: reuse unchanged for noncommercial purposes, with credit."
  ),
  fixedUrlLicense(
    "CC0",
    "CC0 1.0 Public Domain Dedication",
    "https://creativecommons.org/publicdomain/zero/1.0/",
    "Creative Commons Zero: the creator has dedicated the work to the public domain.",
    "public-domain"
  ),
  fixedUrlLicense(
    "PDM",
    "Public Domain Mark 1.0",
    "https://creativecommons.org/publicdomain/mark/1.0/",
    "Public Domain Mark: the work is free of known copyright restrictions.",
    "public-domain"
  ),
  fixedUrlLicense(
    "GFDL",
    "GNU Free Documentation License",
    "https://www.gnu.org/licenses/fdl-1.3.html",
    "GNU Free Documentation License: copyleft license common on Wikimedia.",
    "license"
  ),
  fixedUrlLicense(
    "FAL",
    "Free Art License 1.3",
    "https://artlibre.org/licence/lal/en/",
    "Free Art License: copyleft license for artistic works.",
    "license"
  ),
  fixedUrlLicense(
    "OGL",
    "Open Government Licence v3.0 (UK)",
    "https://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/",
    "UK Open Government Licence: reuse government material with attribution.",
    "license"
  ),
  fixedUrlLicense(
    "MIT",
    "MIT License",
    "https://opensource.org/license/mit",
    "MIT License: permissive license common for icon and illustration sets.",
    "license"
  ),
  fixedUrlLicense(
    "APACHE-2.0",
    "Apache License 2.0",
    "https://www.apache.org/licenses/LICENSE-2.0",
    "Apache License 2.0: permissive license common for icon and illustration sets.",
    "license"
  )
];
Object.fromEntries(
  mediaLicenses.map((D) => [D.code.toLowerCase(), D])
);
var cssesc_1, hasRequiredCssesc;
function requireCssesc() {
  if (hasRequiredCssesc) return cssesc_1;
  hasRequiredCssesc = 1;
  var D = {}, E = D.hasOwnProperty, O = function(q, U) {
    if (!q)
      return U;
    var Z = {};
    for (var V in U)
      Z[V] = E.call(q, V) ? q[V] : U[V];
    return Z;
  }, F = /[ -,\.\/:-@\[-\^`\{-~]/, I = /[ -,\.\/:-@\[\]\^`\{-~]/, z = /(^|\\+)?(\\[A-F0-9]{1,6})\x20(?![a-fA-F0-9\x20])/g, R = function L(q, U) {
    U = O(U, L.options), U.quotes != "single" && U.quotes != "double" && (U.quotes = "single");
    for (var Z = U.quotes == "double" ? '"' : "'", V = U.isIdentifier, G = q.charAt(0), W = "", J = 0, X = q.length; J < X; ) {
      var Y = q.charAt(J++), ee = Y.charCodeAt(), K = void 0;
      if (ee < 32 || ee > 126) {
        if (ee >= 55296 && ee <= 56319 && J < X) {
          var te = q.charCodeAt(J++);
          (te & 64512) == 56320 ? ee = ((ee & 1023) << 10) + (te & 1023) + 65536 : J--;
        }
        K = "\\" + ee.toString(16).toUpperCase() + " ";
      } else
        U.escapeEverything ? F.test(Y) ? K = "\\" + Y : K = "\\" + ee.toString(16).toUpperCase() + " " : /[\t\n\f\r\x0B]/.test(Y) ? K = "\\" + ee.toString(16).toUpperCase() + " " : Y == "\\" || !V && (Y == '"' && Z == Y || Y == "'" && Z == Y) || V && I.test(Y) ? K = "\\" + Y : K = Y;
      W += K;
    }
    return V && (/^-[-\d]/.test(W) ? W = "\\-" + W.slice(1) : /\d/.test(G) && (W = "\\3" + G + " " + W.slice(1))), W = W.replace(z, function(ie, ne, ae) {
      return ne && ne.length % 2 ? ie : (ne || "") + ae;
    }), !V && U.wrap ? Z + W + Z : W;
  };
  return R.options = {
    escapeEverything: !1,
    isIdentifier: !1,
    quotes: "single",
    wrap: !1
  }, R.version = "3.0.0", cssesc_1 = R, cssesc_1;
}
requireCssesc();
const mathAssets = { appliedFunctionSymbolsDefault: ["abs", "exp", "log", "ln", "log10", "sign", "sqrt", "erf", "cos", "cosh", "acos", "acosh", "arccos", "arccosh", "cot", "coth", "acot", "acoth", "arccot", "arccoth", "csc", "csch", "acsc", "acsch", "arccsc", "arccsch", "sec", "sech", "asec", "asech", "arcsec", "arcsech", "sin", "sinh", "asin", "asinh", "arcsin", "arcsinh", "tan", "tanh", "atan", "atan2", "atanh", "arctan", "arctanh", "arg", "min", "max", "mean", "median", "floor", "ceil", "round", "sum", "prod", "variance", "std", "count", "mod", "re", "im", "det", "trace", "nPr", "nCr"], appliedFunctionSymbolsDefaultLatex: ["abs", "exp", "log", "ln", "log10", "sign", "sqrt", "erf", "cos", "cosh", "acos", "acosh", "arccos", "arccosh", "cot", "coth", "acot", "acoth", "arccot", "arccoth", "csc", "csch", "acsc", "acsch", "arccsc", "arccsch", "sec", "sech", "asec", "asech", "arcsec", "arcsech", "sin", "sinh", "asin", "asinh", "arcsin", "arcsinh", "tan", "tanh", "atan", "atan2", "atanh", "arctan", "arctanh", "arg", "min", "max", "mean", "median", "floor", "ceil", "round", "sum", "prod", "variance", "std", "count", "mod", "Re", "Im", "det", "trace", "nPr", "nCr"], allowedLatexSymbols: ["alpha", "beta", "gamma", "Gamma", "delta", "Delta", "epsilon", "zeta", "eta", "theta", "Theta", "iota", "kappa", "lambda", "Lambda", "mu", "nu", "xi", "Xi", "pi", "Pi", "rho", "sigma", "Sigma", "tau", "Tau", "upsilon", "Upsilon", "phi", "Phi", "chi", "psi", "Psi", "omega", "Omega", "partial", "varnothing", "emptyset", "angle", "circ", "$", "%"] };
var appliedFunctionSymbolsDefault = mathAssets.appliedFunctionSymbolsDefault, appliedFunctionSymbolsDefaultLatex = mathAssets.appliedFunctionSymbolsDefaultLatex;
let allowedLatexSymbols = mathAssets.allowedLatexSymbols;
new Context.converters.textToAstObj({
  appliedFunctionSymbols: appliedFunctionSymbolsDefault
});
function textToMathFactory({
  functionSymbols: D,
  appliedFunctionSymbols: E = appliedFunctionSymbolsDefault,
  splitSymbols: O = !0,
  parseScientificNotation: F = !1
} = {}) {
  return (I) => Context.fromAst(
    new Context.converters.textToAstObj({
      appliedFunctionSymbols: E,
      functionSymbols: D,
      splitSymbols: O,
      parseScientificNotation: F
    }).convert(I)
  );
}
new Context.converters.latexToAstObj({
  appliedFunctionSymbols: appliedFunctionSymbolsDefaultLatex,
  allowedLatexSymbols
});
function latexToMathFactory({
  functionSymbols: D,
  appliedFunctionSymbols: E = appliedFunctionSymbolsDefaultLatex,
  splitSymbols: O = !0,
  parseScientificNotation: F = !1
} = {}) {
  let I = O ? wrapWordIncludingNumberWithOperatorName : wrapWordWithOperatorName;
  return (z) => Context.fromAst(
    new Context.converters.latexToAstObj({
      appliedFunctionSymbols: E,
      functionSymbols: D,
      allowedLatexSymbols,
      parseScientificNotation: F
    }).convert(I(z, F))
  );
}
function wrapWordWithOperatorName(D, E) {
  let O = "", F = /\\operatorname\s*{[^{}]*}/, I = D.match(F);
  for (; I && I.index !== void 0; ) {
    let z = I.index, R = z + I[0].length;
    O += wrapWordWithOperatorNameSub(
      D.substring(0, z),
      E
    ), O += D.substring(z, R), D = D.substring(R), I = D.match(F);
  }
  return O += wrapWordWithOperatorNameSub(D, E), O;
}
function wrapWordWithOperatorNameSub(D, E) {
  let O = "";
  const F = /([^a-zA-Z0-9]?)([a-zA-Z][a-zA-Z0-9]+)([^a-zA-Z0-9]?)/;
  let I;
  if (E) {
    const R = "(E[+\\-]?[0-9]+\\s*($|(?=\\,|&|\\||\\\\\\||\\)|\\}|\\\\}|\\]|\\\\\\\\|\\\\end)))";
    I = new RegExp(
      "([0-9]+(\\.[0-9]*)?" + R + ")|(\\.[0-9]+" + R + ")"
    );
  }
  let z = D.match(F);
  for (; z && z.index !== void 0; ) {
    let R = z.index, L = R + z[0].length - z[3].length;
    if (I) {
      let q = D.match(I);
      if (q && q.index !== void 0 && q.index < L && q.index + q[0].length > R) {
        O += D.substring(0, L), D = D.substring(L), z = D.match(F);
        continue;
      }
    }
    if (z[1] === "\\")
      O += D.substring(0, L), D = D.substring(L);
    else {
      let q = R + z[1].length;
      O += D.substring(0, q), O += `\\operatorname{${z[2]}}`, D = D.substring(L);
    }
    z = D.match(F);
  }
  return O += D, O;
}
function wrapWordIncludingNumberWithOperatorName(D, E) {
  let O = "", F = /\\operatorname\s*{[^{}]*}/, I = D.match(F);
  for (; I && I.index !== void 0; ) {
    let z = I.index, R = z + I[0].length;
    O += wrapWordIncludingNumberWithOperatorNameSub(
      D.substring(0, z),
      E
    ), O += D.substring(z, R), D = D.substring(R), I = D.match(F);
  }
  return O += wrapWordIncludingNumberWithOperatorNameSub(
    D,
    E
  ), O;
}
function wrapWordIncludingNumberWithOperatorNameSub(D, E) {
  let O = "";
  const F = /([^a-zA-Z0-9\s]?\s*)([a-zA-Z][a-zA-Z0-9]*[0-9][a-zA-Z0-9]*)([^a-zA-Z0-9]?)/;
  let I;
  if (E) {
    const R = "(E[+\\-]?[0-9]+\\s*($|(?=\\,|&|\\||\\\\\\||\\)|\\}|\\\\}|\\]|\\\\\\\\|\\\\end)))";
    I = new RegExp(
      "([0-9]+(\\.[0-9]*)?" + R + ")|(\\.[0-9]+" + R + ")"
    );
  }
  let z = D.match(F);
  for (; z && z.index !== void 0; ) {
    let R = z.index, L = R + z[0].length - z[3].length;
    if (I) {
      let q = D.match(I);
      if (q && q.index !== void 0 && q.index < L && q.index + q[0].length > R) {
        O += D.substring(0, L), D = D.substring(L), z = D.match(F);
        continue;
      }
    }
    if (z[1] === "\\" || z[1][0] === "^" || z[1][0] === "_")
      O += D.substring(0, L), D = D.substring(L);
    else {
      let q = R + z[1].length;
      O += D.substring(0, q), O += `\\operatorname{${z[2]}}`, D = D.substring(L);
    }
    z = D.match(F);
  }
  return O += D, O;
}
function evalWithMathExpressionsInScope(source) {
  function _eval(MathExpressions, window) {
    return Math.random() < -1 && console.log(
      "Running with MathExpressions in scope",
      MathExpressions,
      window,
      serializedComponentsReviver
    ), JSON.stringify(eval(source).tree, serializedComponentsReplacer);
  }
  return _eval(Context, _globalThis);
}
function parseTextIntoMath(D, E, O, F) {
  let I = textToMathFactory({
    splitSymbols: E,
    parseScientificNotation: F,
    functionSymbols: O
  }), z;
  try {
    z = I(D);
  } catch {
    z = Context.fromAst("＿"), console.warn("Invalid value for a math of text format: `" + D + "`");
  }
  return JSON.stringify(z.tree, serializedComponentsReplacer);
}
function toText(D, E, O, F) {
  return Context.fromAst(
    JSON.parse(D, serializedComponentsReviver)
  ).toString({
    padToDecimals: E,
    padToDigits: O,
    showBlanks: F
  });
}
function parseLatexIntoMath(D, E, O, F) {
  let I = latexToMathFactory({
    splitSymbols: E,
    parseScientificNotation: F,
    functionSymbols: O
  }), z;
  try {
    z = I(D);
  } catch {
    z = Context.fromAst("＿"), console.warn(
      "Invalid value for a math of latex format: `" + D + "`"
    );
  }
  return JSON.stringify(z.tree, serializedComponentsReplacer);
}
function toLatex(D, E, O, F) {
  return Context.fromAst(
    JSON.parse(D, serializedComponentsReviver)
  ).toLatex({
    padToDecimals: E,
    padToDigits: O,
    showBlanks: F
  });
}
function substituteIntoMath(D, E) {
  let O = Context.fromAst(
    JSON.parse(D, serializedComponentsReviver)
  ), F = {};
  for (const [z, R] of E.entries())
    F[z] = Context.fromAst(
      JSON.parse(R, serializedComponentsReviver)
    );
  let I = O.substitute(F);
  return JSON.stringify(I.tree, serializedComponentsReplacer);
}
function normalizeMath(D, E, O, F, I) {
  let z = Context.fromAst(
    JSON.parse(D, serializedComponentsReviver)
  ), R = normalizeMathExpression({
    value: z,
    simplify: E,
    expand: O,
    createVectors: F,
    createIntervals: I
  });
  return JSON.stringify(R.tree, serializedComponentsReplacer);
}
function evaluateToNumber(D) {
  return Context.fromAst(
    JSON.parse(D, serializedComponentsReviver)
  ).evaluate_to_constant();
}
function parseTextIntoNumber(D) {
  let E = textToMathFactory({
    splitSymbols: !0,
    functionSymbols: []
  }), O;
  try {
    O = E(D);
  } catch {
    return console.warn("Invalid value for a math of text format: `" + D + "`"), NaN;
  }
  return O.evaluate_to_constant() ?? NaN;
}
_globalThis.__forDoenetWorker = _globalThis._forDoenetWorker || {};
Object.assign(_globalThis.__forDoenetWorker, {
  evalWithMathExpressionsInScope,
  parseTextIntoMath,
  parseLatexIntoMath,
  toLatex,
  toText,
  substituteIntoMath,
  normalizeMath,
  evaluateToNumber,
  parseTextIntoNumber
});
export {
  PublicDoenetMLCore,
  _TypeExports,
  wasm as __wasm,
  __wbg_init as default,
  initSync
};
//# sourceMappingURL=index.js.map
